export const data = [
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/9Abiz59OQ1nRhVDtd9yLCk3gyTd.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 28, name: 'Phim Hành Động' },
      { id: 12, name: 'Phim Phiêu Lưu' },
      { id: 35, name: 'Phim Hài' },
    ],
    homepage: '',
    id: 37702,
    imdb_id: 'tt0116014',
    original_language: 'cn',
    original_title: '大內密探零零發',
    overview:
      'Phim Đại Nội Mật Thám là bộ phim hài của Châu Tình Trì. Nội dung phim xoay quanh Cung, Hỷ, Phát, Tài là bốn cao thủ hoàng cung chuyên bảo vệ Hoàng Thượng. Trong đó Phát là người tuy không biết võ công nhưng đầu óc lanh lợi, phát minh ra được những món đồ kỳ lạ. Nhưng cuối cùng không được vua trọng dụng bị đưa về làm một người thường dân. Lúc này nước Kim dựa vào thi thể của một người ngoài hành tinh đề lừa gạt nhà vua và hãm hại ông. Ba vị cao thủ kia đều hy sinh chỉ còn Phát nhờ phát minh của mình cứu được nhà vua. Nước Kim đành cho người trà trộn tìm cách quyến rũ Phát, Phát cùng vợ mình tương kế tựu kế tìm cách bắt kẻ gian.',
    popularity: 5.792,
    poster_path:
      'https://image.tmdb.org/t/p/w342/i8WoSMRqbl3TZFioq3TjhselxFf.jpg',
    production_companies: [
      {
        id: 44642,
        logo_path: null,
        name: "Win's Movie Production Limited",
        origin_country: '',
      },
      {
        id: 35439,
        logo_path: null,
        name: 'Samico Films Production Co., Ltd.',
        origin_country: '',
      },
    ],
    production_countries: [{ iso_3166_1: 'HK', name: 'Hồng Kông' }],
    release_date: '1996-02-16',
    revenue: 0,
    runtime: 89,
    spoken_languages: [
      { english_name: 'Cantonese', iso_639_1: 'cn', name: '广州话 / 廣州話' },
      { english_name: 'Mandarin', iso_639_1: 'zh', name: '普通话' },
    ],
    status: 'Đã phát hành',
    tagline: 'Đại Nội Mật Thám - Forbidden City Cop',
    title: 'Đại Nội Mật Thám',
    video: false,
    vote_average: 6.8,
    vote_count: 56,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Forbidden City Cop (1996) // Bande-annonce HD (VO)',
          key: 'UBNymeViWFo',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: false,
          published_at: '2011-09-22T21:06:57.000Z',
          id: '5f11d59099259c0035f5f19e',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 57607,
          known_for_department: 'Diễn viên',
          name: 'Stephen Chow',
          original_name: 'Stephen Chow',
          popularity: 9.156,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rO1e30Yq7KzgZFAXZDosyAShhhM.jpg',
          cast_id: 1,
          character: 'Ling Ling Faat (Double 0 Fat)',
          credit_id: '52fe46659251416c910531c1',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 12672,
          known_for_department: 'Diễn viên',
          name: 'Carina Lau',
          original_name: 'Carina Lau',
          popularity: 5.126,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5Va4jk69gkdAcABtkTtcUz85RLA.jpg',
          cast_id: 36,
          character: "Ling Kar Ting / Faat's wife",
          credit_id: '5ae6d7bc0e0a261079008c2c',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 110845,
          known_for_department: 'Diễn viên',
          name: 'Carman Lee',
          original_name: 'Carman Lee',
          popularity: 2.594,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pWPP7WKLLpXmPmcaZv51afrHnmt.jpg',
          cast_id: 15,
          character: 'Gum Tso / Kam Cho',
          credit_id: '52fe46659251416c910531fb',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 87944,
          known_for_department: 'Diễn viên',
          name: 'Law Kar-Ying',
          original_name: 'Law Kar-Ying',
          popularity: 2.565,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ly8lSEpKrjciOucpSLQjcj3JcnI.jpg',
          cast_id: 14,
          character: 'Fat Yan',
          credit_id: '52fe46659251416c910531f7',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 118350,
          known_for_department: 'Diễn viên',
          name: 'Cheung Tat-Ming',
          original_name: 'Cheung Tat-Ming',
          popularity: 2.634,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zq3vkchDeeQXkGWx4ywf7GLQ6BO.jpg',
          cast_id: 4,
          character: 'Emperor',
          credit_id: '52fe46659251416c910531c9',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 118355,
          known_for_department: 'Diễn viên',
          name: 'Lee Lik-Chi',
          original_name: 'Lee Lik-Chi',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vrSBx0NyJ2SqJ9sZPasM3MjwyXK.jpg',
          cast_id: 19,
          character: 'Court Official',
          credit_id: '573788909251417dd8000559',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 118352,
          known_for_department: 'Diễn viên',
          name: 'Tats Lau Yi-Tat',
          original_name: 'Tats Lau Yi-Tat',
          popularity: 1.038,
          profile_path:
            'https://image.tmdb.org/t/p/w185/h5aDgNb0ljfdRLJcafOjxP1hJSk.jpg',
          cast_id: 6,
          character: 'Forbidden City Cop',
          credit_id: '52fe46659251416c910531cd',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 65975,
          known_for_department: 'Diễn viên',
          name: 'Charlie Yuen Cheung-Yan',
          original_name: 'Charlie Yuen Cheung-Yan',
          popularity: 2.877,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oI1Q07u74Yod4t8K06aSvfEJIbH.jpg',
          cast_id: 7,
          character: 'Evil mother',
          credit_id: '52fe46659251416c910531d1',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 65976,
          known_for_department: 'Diễn viên',
          name: 'Sunny Yuen Shun-Yi',
          original_name: 'Sunny Yuen Shun-Yi',
          popularity: 1.432,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3DLtcPAMGnexk0GifXo1UVRmatX.jpg',
          cast_id: 8,
          character: 'Evil son',
          credit_id: '52fe46659251416c910531d5',
          order: 8,
        },
        {
          adult: false,
          gender: 1,
          id: 94076,
          known_for_department: 'Diễn viên',
          name: 'Kingdom Yuen',
          original_name: 'Kingdom Yuen',
          popularity: 3.229,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cuFctctF42GLEO6gdggVU24xkMs.jpg',
          cast_id: 20,
          character: 'Brothel procuress',
          credit_id: '573788a69251417b5e003de7',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 29692,
          known_for_department: 'Camera',
          name: 'Poon Hang-Sang',
          original_name: 'Poon Hang-Sang',
          popularity: 1.214,
          profile_path: null,
          cast_id: 21,
          character: "Faat's father-in-law",
          credit_id: '573788b1c3a3686f3b0007ad',
          order: 10,
        },
        {
          adult: false,
          gender: 1,
          id: 1135781,
          known_for_department: 'Diễn viên',
          name: 'Mimi Chu',
          original_name: 'Mimi Chu',
          popularity: 1.544,
          profile_path:
            'https://image.tmdb.org/t/p/w185/A1rpCGLmQysVqzqcGhiYtF35Nws.jpg',
          cast_id: 22,
          character: "Faat's mother-in-law",
          credit_id: '573788bbc3a36805ab0012cd',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 1160576,
          known_for_department: 'Diễn viên',
          name: 'Noel Chik King-Man',
          original_name: 'Noel Chik King-Man',
          popularity: 2.826,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jSrDLjCuoXch3BhWmXCimppczIR.jpg',
          cast_id: 23,
          character: "Faat's horny patient",
          credit_id: '573788c79251417dd8000564',
          order: 12,
        },
        {
          adult: false,
          gender: 1,
          id: 240927,
          known_for_department: 'Diễn viên',
          name: 'Alvina Kong Yai-Yin',
          original_name: 'Alvina Kong Yai-Yin',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/96pcgW1IxSCXyHwmghrdow6SVbn.jpg',
          cast_id: 24,
          character: "Faat's doctor patient",
          credit_id: '573788d29251417b3a003cd5',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 1415225,
          known_for_department: 'Diễn viên',
          name: 'Wong Chi-Keung',
          original_name: 'Wong Chi-Keung',
          popularity: 0.6,
          profile_path: null,
          cast_id: 25,
          character: 'Sai Mun Tsui Suet',
          credit_id: '573788e4925141155f0011e3',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 956575,
          known_for_department: 'Diễn viên',
          name: 'Wong Yat-fei',
          original_name: 'Wong Yat-fei',
          popularity: 1.637,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eMpNYfWMxmIPWvDd1npajeDweI7.jpg',
          cast_id: 26,
          character: 'Yip Koo Shing',
          credit_id: '573788ef9251417b3a003cdc',
          order: 15,
        },
        {
          adult: false,
          gender: 0,
          id: 21902,
          known_for_department: 'Biên kịch',
          name: 'Manfred Wong',
          original_name: 'Manfred Wong',
          popularity: 1.064,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ZW0X62PWUkVG4UTrMDqmdt1NmA.jpg',
          cast_id: 27,
          character: 'Luk Siu Fung',
          credit_id: '573788fa9251417dd800056f',
          order: 16,
        },
        {
          adult: false,
          gender: 0,
          id: 1619922,
          known_for_department: 'Diễn viên',
          name: 'Chan Kim-Wan',
          original_name: 'Chan Kim-Wan',
          popularity: 0.6,
          profile_path: null,
          cast_id: 28,
          character: 'Fa Moon Lau',
          credit_id: '5737890a925141132200022e',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 1619923,
          known_for_department: 'Diễn viên',
          name: 'Charles Shen',
          original_name: 'Charles Shen',
          popularity: 0.6,
          profile_path: null,
          cast_id: 29,
          character: 'Ling Ling Kung',
          credit_id: '57378915c3a3686f0400084c',
          order: 18,
        },
        {
          adult: false,
          gender: 2,
          id: 1398251,
          known_for_department: 'Diễn viên',
          name: 'Jackson Ng Yuk-Sue',
          original_name: 'Jackson Ng Yuk-Sue',
          popularity: 0.6,
          profile_path: null,
          cast_id: 30,
          character: 'Ling Ling Hei',
          credit_id: '57378b44925141136e004b87',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 1616889,
          known_for_department: 'Diễn viên',
          name: 'Wong Kwan-Hong',
          original_name: 'Wong Kwan-Hong',
          popularity: 0.6,
          profile_path: null,
          cast_id: 31,
          character: 'Ling Ling Choi',
          credit_id: '57378b50c3a3686f3b000825',
          order: 20,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 21906,
          known_for_department: 'Art',
          name: 'Cyrus Ho Kim-Hung',
          original_name: 'Cyrus Ho Kim-Hung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1643e10e0a2612e3003807',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 57607,
          known_for_department: 'Diễn viên',
          name: 'Stephen Chow',
          original_name: 'Stephen Chow',
          popularity: 9.156,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rO1e30Yq7KzgZFAXZDosyAShhhM.jpg',
          credit_id: '52fe46659251416c910531db',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 57607,
          known_for_department: 'Diễn viên',
          name: 'Stephen Chow',
          original_name: 'Stephen Chow',
          popularity: 9.156,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rO1e30Yq7KzgZFAXZDosyAShhhM.jpg',
          credit_id: '52fe46659251416c910531e7',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 64490,
          known_for_department: 'Editing',
          name: 'Chi-Leung Kwong',
          original_name: 'Chi-Leung Kwong',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16448592514153a3003b9f',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 65934,
          known_for_department: 'Diễn viên',
          name: 'Vincent Kok',
          original_name: 'Vincent Kok',
          popularity: 1.546,
          profile_path:
            'https://image.tmdb.org/t/p/w185/foYVecYCYkAuwyPXNy3jSJYaVub.jpg',
          credit_id: '52fe46659251416c910531e1',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 65934,
          known_for_department: 'Diễn viên',
          name: 'Vincent Kok',
          original_name: 'Vincent Kok',
          popularity: 1.546,
          profile_path:
            'https://image.tmdb.org/t/p/w185/foYVecYCYkAuwyPXNy3jSJYaVub.jpg',
          credit_id: '52fe46659251416c910531ed',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 118352,
          known_for_department: 'Diễn viên',
          name: 'Tats Lau Yi-Tat',
          original_name: 'Tats Lau Yi-Tat',
          popularity: 1.038,
          profile_path:
            'https://image.tmdb.org/t/p/w185/h5aDgNb0ljfdRLJcafOjxP1hJSk.jpg',
          credit_id: '5a16448f0e0a2612e30038a6',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 0,
          id: 1298436,
          known_for_department: 'Biên kịch',
          name: 'Edmond Liu',
          original_name: 'Edmond Liu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '53156e9692514158aa000082',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 1311735,
          known_for_department: 'Camera',
          name: 'Lee Kin-keung',
          original_name: 'Lee Kin-keung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16440c92514153a60037f7',
          department: 'Camera',
          job: 'Director of Photography',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path: null,
    belongs_to_collection: null,
    budget: 0,
    genres: [{ id: 28, name: 'Phim Hành Động' }],
    homepage: '',
    id: 711582,
    imdb_id: null,
    original_language: 'zh',
    original_title: '兵王传奇',
    overview:
      'mô tả trải nghiệm trưởng thành của một nhóm tân binh từ tự do đến thế hệ "Bing Wang". Đây là quá trình chuyển hóa từ tư tưởng, tinh thần sang thể lực và nhận thức. Thông qua sự giải thích sinh động của hình ảnh, chúng ta cho chúng ta thấy quân đội của những người lính Trung Quốc. Linh hồn. Nam diễn viên trẻ Jiang Yisheng vào vai "quân vương" có tính cách tốt, dám làm, hiếu thắng. Trong vở kịch, Jiang Yisheng thể hiện vai một vị vua kỳ cựu, tạo hình sinh động cho hình tượng người anh hùng quân đội, thể hiện phong cách quân tử đối với nhân dân, đồng thời khơi gợi lòng kính trọng của toàn xã hội đối với anh hùng và sự kính trọng đối với quân nhân.',
    popularity: 0.6,
    poster_path:
      'https://image.tmdb.org/t/p/w342/yuZhKaBqGHq7oGvtreiHZeBYUG0.jpg',
    production_companies: [],
    production_countries: [{ iso_3166_1: 'CN', name: 'Trung Quốc' }],
    release_date: '2020-06-01',
    revenue: 0,
    runtime: 92,
    spoken_languages: [
      { english_name: 'Mandarin', iso_639_1: 'zh', name: '普通话' },
    ],
    status: 'Đã phát hành',
    tagline: 'HUYỀN THOẠI NGƯỜI LÍNH',
    title: 'HUYỀN THOẠI NGƯỜI LÍNH',
    video: false,
    vote_average: 0.0,
    vote_count: 0,
    videos: { results: [] },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 1671010,
          known_for_department: 'Diễn viên',
          name: 'He Lanpeng',
          original_name: 'He Lanpeng',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hKtAPdR6bunWNTcwQ9QjNiGmQTJ.jpg',
          cast_id: 1,
          character: '',
          credit_id: '5ed5dd2847c9fb00206be4e9',
          order: 1,
        },
        {
          adult: false,
          gender: 0,
          id: 2663032,
          known_for_department: 'Diễn viên',
          name: 'Chen Weixun',
          original_name: 'Chen Weixun',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7K1Y0t1KFW12Q4eLw4i8um6Xxk4.jpg',
          cast_id: 2,
          character: '',
          credit_id: '5ed5dd300398ab0021cf92dd',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 1801146,
          known_for_department: 'Diễn viên',
          name: 'Yang Zitong',
          original_name: 'Yang Zitong',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/laOC25gixekkg4Jxtkt0Kzki0qZ.jpg',
          cast_id: 3,
          character: '',
          credit_id: '5ed5dd37fea0d7001e8c3ef4',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 2631743,
          known_for_department: 'Diễn viên',
          name: 'Di Zhang',
          original_name: 'Di Zhang',
          popularity: 0.6,
          profile_path: null,
          cast_id: 4,
          character: '',
          credit_id: '5ed5dd4347c9fb001e6cc808',
          order: 4,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 0,
          id: 2663035,
          known_for_department: 'Directing',
          name: 'Hanqiu Yu',
          original_name: 'Hanqiu Yu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ed5dd5c8ddc340020d85e97',
          department: 'Directing',
          job: 'Director',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/iITCYIZHzCNd6mrCBF9nRMtHqgM.jpg',
    belongs_to_collection: {
      id: 773903,
      name: '爵迹（系列）',
      poster_path: '/oyVorSteLn2rNBb2Gn9Z9vMMGaE.jpg',
      backdrop_path: null,
    },
    budget: 0,
    genres: [
      { id: 28, name: 'Phim Hành Động' },
      { id: 12, name: 'Phim Phiêu Lưu' },
      { id: 10752, name: 'Phim Chiến Tranh' },
      { id: 16, name: 'Phim Hoạt Hình' },
    ],
    homepage: 'https://www.lordthemovie.com',
    id: 630044,
    imdb_id: 'tt10701926',
    original_language: 'zh',
    original_title: '冷血狂宴',
    overview:
      'Vì hoàn thành di nguyện Vương tước cấp 6 Tây Lưu Nhĩ, Ngân Trần Kỳ Linh, Thiên Thúc U Hoa quyết định cùng nhau đi giải cứu Vương tước Cát Nhĩ Già Mĩ Thập. Khi vượt qua trở ngại trùng trùng đến được nơi giam cầm, không may gặp phải đội hình sát thủ mạnh nhất của Bạch Ngân Tế Ti: U Minh, Đặc Lôi Á, Tất Lạp, một trận giao đấu chính diện không thể tránh khỏi, bí mật đen tối của đế quốc Ashland cũng dần dần hiện ra.',
    popularity: 4.63,
    poster_path:
      'https://image.tmdb.org/t/p/w342/43MlbzxB5OohgvPHmPIvRi4MCVn.jpg',
    production_companies: [],
    production_countries: [{ iso_3166_1: 'CN', name: 'Trung Quốc' }],
    release_date: '2020-12-02',
    revenue: 0,
    runtime: 129,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
      { english_name: 'Mandarin', iso_639_1: 'zh', name: '普通话' },
    ],
    status: 'Đã phát hành',
    tagline: 'Tước Tích 2: Lãnh Huyết Cuồng Yến',
    title: 'Tước Tích 2: Lãnh Huyết Cuồng Yến',
    video: false,
    vote_average: 2.8,
    vote_count: 5,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'L.O.R.D 2 Legend of Ravaging Dynasties [TRAILER 2 - ENG SUB] Trung Quốc 2020 - Kris Wu - Animation - 冷血狂宴',
          key: 'im2lbGYW7kg',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: false,
          published_at: '2021-01-11T22:01:10.000Z',
          id: '5ffccb57773941003f7f8db0',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 1390948,
          known_for_department: 'Diễn viên',
          name: 'Kris Wu',
          original_name: 'Kris Wu',
          popularity: 4.332,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ht8RrzYbOEB3K2vheg51X33zmxt.jpg',
          cast_id: 1,
          character: 'Yin Chen',
          credit_id: '5fcad62211386c003fcea5e4',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 1193310,
          known_for_department: 'Diễn viên',
          name: 'Chen Xuedong',
          original_name: 'Chen Xuedong',
          popularity: 1.219,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pgzMLCxvpsh3CUto5Ag7vcx99PD.jpg',
          cast_id: 2,
          character: 'Qi Ling',
          credit_id: '5fcad632a5743d003f049fa7',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 127268,
          known_for_department: 'Diễn viên',
          name: 'William Chan Wai-Ting',
          original_name: 'William Chan Wai-Ting',
          popularity: 2.678,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ovPTGfoN7EJei92CSAqs0sPvuoS.jpg',
          cast_id: 3,
          character: 'You Ming',
          credit_id: '5fcad6b943999b003c17bfca',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 126716,
          known_for_department: 'Diễn viên',
          name: 'Amber Kuo',
          original_name: 'Amber Kuo',
          popularity: 1.508,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fepx2AfAdWcQ53VcjEZuAOYiIdd.jpg',
          cast_id: 5,
          character: 'Thalia',
          credit_id: '5fcad6d80b7316004206b577',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 1574909,
          known_for_department: 'Diễn viên',
          name: 'Lin Yun',
          original_name: 'Lin Yun',
          popularity: 2.722,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qba2QatqQQjAX1oQbfQkF2z27uZ.jpg',
          cast_id: 6,
          character: 'Tianshu You Hua',
          credit_id: '5fcad6f1680be8003e19b875',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 2291035,
          known_for_department: 'Diễn viên',
          name: 'Roy Wang',
          original_name: 'Roy Wang',
          popularity: 2.135,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sUS4VNImUs9YCTbLxLlNDmC89qc.jpg',
          cast_id: 7,
          character: 'Silver Priest',
          credit_id: '5fcad7000b7316003f067943',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 1785744,
          known_for_department: 'Diễn viên',
          name: 'Karry Wang',
          original_name: 'Karry Wang',
          popularity: 3.048,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gl1ibG6gEDy0XKAkSDbzEieDZq0.jpg',
          cast_id: 8,
          character: 'Frost',
          credit_id: '5fcad70ca5743d004004e7d6',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 2223265,
          known_for_department: 'Diễn viên',
          name: 'Jackson Yee',
          original_name: 'Jackson Yee',
          popularity: 2.537,
          profile_path:
            'https://image.tmdb.org/t/p/w185/c3U8naq100zys7snPAPNbM7KS4v.jpg',
          cast_id: 9,
          character: '源一度王爵',
          credit_id: '5fcad7227314a10040ca83da',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 1892422,
          known_for_department: 'Diễn viên',
          name: 'Wang Duo',
          original_name: 'Wang Duo',
          popularity: 1.38,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3rLEUFwn8ZGnT5WmCLckc3pJ9Ag.jpg',
          cast_id: 10,
          character: 'Qi La',
          credit_id: '5fcad72f0b7316004006a8ef',
          order: 10,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 554289,
          known_for_department: 'Biên kịch',
          name: 'Guo Jingming',
          original_name: 'Guo Jingming',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/byGiKT70jfVqRHIZncKDRXhZuOX.jpg',
          credit_id: '5fcad77843999b003c17c0d7',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 554289,
          known_for_department: 'Biên kịch',
          name: 'Guo Jingming',
          original_name: 'Guo Jingming',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/byGiKT70jfVqRHIZncKDRXhZuOX.jpg',
          credit_id: '5fcad75de32943003d3d1eb4',
          department: 'Biên kịch',
          job: 'Writer',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/3VUKpgrssr9iQYFAZiAbN5lbw7g.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [{ id: 18, name: 'Phim Chính Kịch' }],
    homepage: 'http://www.nbcfilm.com/ahlat/ahlat.php',
    id: 418472,
    imdb_id: 'tt6628102',
    original_language: 'tr',
    original_title: 'Ahlat Ağacı',
    overview:
      'Một nhà văn trở về quê hương sau khi tốt nghiệp, nơi anh ta tìm kiếm các nhà tài trợ để xuất bản cuốn sách của mình trong khi đối phó với sự buông thả của cha mình vào cờ bạc.',
    popularity: 9.418,
    poster_path:
      'https://image.tmdb.org/t/p/w342/zOf30Go9wz5u0guZjmq8PY7lqNp.jpg',
    production_companies: [
      { id: 27100, logo_path: null, name: 'Zeynofilm', origin_country: 'TR' },
      {
        id: 5162,
        logo_path: '/ePS4wgTIC1hjOnnmxYJmYNEzAR.png',
        name: 'Memento Films Production',
        origin_country: 'FR',
      },
      {
        id: 48663,
        logo_path: '/6JAGPbWGuRWAREs0XKhyHa17EZD.png',
        name: 'Detailfilm',
        origin_country: 'DE',
      },
      {
        id: 2801,
        logo_path: '/bswb1PLLsKDUXMLgy42bZtCtIde.png',
        name: 'Film i Väst',
        origin_country: 'SE',
      },
      {
        id: 88593,
        logo_path: '/bX3uLMaFzSKJ8I14OAWgKIlcLHY.png',
        name: 'Nulook Production',
        origin_country: 'TR',
      },
      {
        id: 29021,
        logo_path: null,
        name: 'RFF International',
        origin_country: '',
      },
      {
        id: 53362,
        logo_path: null,
        name: 'Sisters and Brother Mitevski',
        origin_country: 'MK',
      },
      { id: 75209, logo_path: null, name: 'TRT', origin_country: 'TR' },
      {
        id: 85580,
        logo_path: null,
        name: 'Turkish Radio & Television (TRT)',
        origin_country: '',
      },
    ],
    production_countries: [
      { iso_3166_1: 'DE', name: 'Germany' },
      { iso_3166_1: 'BA', name: 'Bosnia and Herzegovina' },
      { iso_3166_1: 'BG', name: 'Bulgaria' },
      { iso_3166_1: 'FR', name: 'France' },
      { iso_3166_1: 'SE', name: 'Sweden' },
      { iso_3166_1: 'MK', name: 'Macedonia' },
      { iso_3166_1: 'TR', name: 'Turkey' },
    ],
    release_date: '2018-08-08',
    revenue: 0,
    runtime: 188,
    spoken_languages: [
      { english_name: 'Turkish', iso_639_1: 'tr', name: 'Türkçe' },
    ],
    status: 'Đã phát hành',
    tagline: 'What a father keeps hidden is revealed in the son.',
    title: 'Cây Lê Dại',
    video: false,
    vote_average: 7.6,
    vote_count: 170,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Wild Pear Tree (official trailer)',
          key: 'po0vls18Koc',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          published_at: '2018-12-17T18:52:23.000Z',
          official: false,
          id: '5c5a93bc0e0a261de1636ad5',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 1962695,
          known_for_department: 'Diễn viên',
          name: 'Aydın Doğu Demirkol',
          original_name: 'Aydın Doğu Demirkol',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xPW7rEPja4Z2WWVjghTuYbxNZdT.jpg',
          cast_id: 23,
          character: 'Sinan',
          credit_id: '5adcbd0d9251410acd0213af',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 40023,
          known_for_department: 'Diễn viên',
          name: 'Murat Cemcir',
          original_name: 'Murat Cemcir',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gEhhn50hHMwKew4Ax1TJo4PP5iI.jpg',
          cast_id: 4,
          character: 'İdris',
          credit_id: '5a8ea6230e0a263e7a0125d4',
          order: 1,
        },
        {
          adult: false,
          gender: 0,
          id: 145507,
          known_for_department: 'Diễn viên',
          name: 'Bennu Yıldırımlar',
          original_name: 'Bennu Yıldırımlar',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/por6K7uArZfzn9EmGKGEpunKczJ.jpg',
          cast_id: 13,
          character: 'Asuman',
          credit_id: '5ad9d2f2c3a3683c7100a85f',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 1086261,
          known_for_department: 'Diễn viên',
          name: 'Hazar Ergüçlü',
          original_name: 'Hazar Ergüçlü',
          popularity: 1.102,
          profile_path:
            'https://image.tmdb.org/t/p/w185/syHxSQ0FezqShEvzwGo7KEdvTVr.jpg',
          cast_id: 24,
          character: 'Hatice',
          credit_id: '5f841c4f1065d30036df4057',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 72154,
          known_for_department: 'Diễn viên',
          name: 'Serkan Keskin',
          original_name: 'Serkan Keskin',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oXQJIB5XU0k4R257mHE3HZnqfqa.jpg',
          cast_id: 14,
          character: 'Süleyman',
          credit_id: '5ad9d301c3a3683c9a00bbd9',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 1083415,
          known_for_department: 'Diễn viên',
          name: 'Tamer Levent',
          original_name: 'Tamer Levent',
          popularity: 3.863,
          profile_path:
            'https://image.tmdb.org/t/p/w185/a7UQ5UItqUMut6MdF5ehad5wAP0.jpg',
          cast_id: 15,
          character: 'Recep',
          credit_id: '5ad9d30a0e0a2661fd00ca5d',
          order: 5,
        },
        {
          adult: false,
          gender: 0,
          id: 2026487,
          known_for_department: 'Diễn viên',
          name: 'Akın Aksu',
          original_name: 'Akın Aksu',
          popularity: 0.6,
          profile_path: null,
          cast_id: 16,
          character: 'İmam Veysel',
          credit_id: '5ad9d313925141590100a7f9',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 1291746,
          known_for_department: 'Diễn viên',
          name: 'Ahmet Rıfat Şungar',
          original_name: 'Ahmet Rıfat Şungar',
          popularity: 2.131,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wGtgnO60Qs35QB2Py7q6NgYn5IZ.jpg',
          cast_id: 3,
          character: 'Ali Riza',
          credit_id: '5a8ea61a9251416c7e0116e8',
          order: 7,
        },
        {
          adult: false,
          gender: 0,
          id: 1001782,
          known_for_department: 'Diễn viên',
          name: 'Kubilay Tunçer',
          original_name: 'Kubilay Tunçer',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wouduNXAqLmBeXGxqbIhWAQtRpX.jpg',
          cast_id: 17,
          character: 'İlhami',
          credit_id: '5ad9d328c3a3683c7c00b900',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 150279,
          known_for_department: 'Diễn viên',
          name: 'Öner Erkan',
          original_name: 'Öner Erkan',
          popularity: 0.932,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xqrlTZen9EbXxZCcAa2DStcLffK.jpg',
          cast_id: 18,
          character: 'İmam Nazmi',
          credit_id: '5ad9d3340e0a2661f700ba70',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 1052246,
          known_for_department: 'Diễn viên',
          name: 'Özay Fecht',
          original_name: 'Özay Fecht',
          popularity: 1.129,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gorWb1X2s5Yzvsj7Vj7m0KFTRU7.jpg',
          cast_id: 19,
          character: 'Hayriye',
          credit_id: '5ad9d33fc3a3683c6d00be5b',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 1685797,
          known_for_department: 'Diễn viên',
          name: 'Ercüment Balakoğlu',
          original_name: 'Ercüment Balakoğlu',
          popularity: 0.6,
          profile_path: null,
          cast_id: 5,
          character: 'Ramazan',
          credit_id: '5a8ea62bc3a368266a01011f',
          order: 12,
        },
        {
          adult: false,
          gender: 0,
          id: 1607125,
          known_for_department: 'Diễn viên',
          name: 'Sencar Sağdıç',
          original_name: 'Sencar Sağdıç',
          popularity: 0.6,
          profile_path: null,
          cast_id: 21,
          character: 'Nevzat',
          credit_id: '5ad9d3610e0a26620a00b74f',
          order: 13,
        },
        {
          adult: false,
          gender: 0,
          id: 1620392,
          known_for_department: 'Diễn viên',
          name: 'Asena Keskinci',
          original_name: 'Asena Keskinci',
          popularity: 0.6,
          profile_path: null,
          cast_id: 22,
          character: 'Yasemin',
          credit_id: '5ad9d3690e0a2661f700bad3',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 1603809,
          known_for_department: 'Diễn viên',
          name: 'Kadir Çermik',
          original_name: 'Kadir Çermik',
          popularity: 2.304,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bMJgxSoYQRRWJQLerIyv8Xc84O9.jpg',
          cast_id: 25,
          character: 'Adnan',
          credit_id: '601bf29cfb3f61003eccd643',
          order: 15,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 56214,
          known_for_department: 'Directing',
          name: 'Nuri Bilge Ceylan',
          original_name: 'Nuri Bilge Ceylan',
          popularity: 0.852,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5jH5pWhdE0Xe0renmFjCBdJV9aQ.jpg',
          credit_id: '57ebe2e8c3a36839fe005ac0',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 56214,
          known_for_department: 'Directing',
          name: 'Nuri Bilge Ceylan',
          original_name: 'Nuri Bilge Ceylan',
          popularity: 0.852,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5jH5pWhdE0Xe0renmFjCBdJV9aQ.jpg',
          credit_id: '57ebe2de9251411853000139',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 1,
          id: 301260,
          known_for_department: 'Production',
          name: 'Zeynep Ozbatur Atakan',
          original_name: 'Zeynep Ozbatur Atakan',
          popularity: 0.648,
          profile_path: null,
          credit_id: '5a8ea63bc3a368268f00fea7',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 307141,
          known_for_department: 'Biên kịch',
          name: 'Ebru Ceylan',
          original_name: 'Ebru Ceylan',
          popularity: 1.421,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kDzT1ZxXJ7BT6NeqU1eGEHlkfDz.jpg',
          credit_id: '5ad9d25d925141590500a687',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 456963,
          known_for_department: 'Camera',
          name: 'Gökhan Tiryaki',
          original_name: 'Gökhan Tiryaki',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gQjvYKmJThmCMekno7zkI68xpvK.jpg',
          credit_id: '5a8ea6479251416c81011720',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 1585853,
          known_for_department: 'Sound',
          name: 'Andreas Mücke-Niesytka',
          original_name: 'Andreas Mücke-Niesytka',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5a8ea6549251416c8101172b',
          department: 'Sound',
          job: 'Sound Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1597004,
          known_for_department: 'Sound',
          name: 'Ivaylo Natzev',
          original_name: 'Ivaylo Natzev',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a8ea66f0e0a263e8001102f',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1982842,
          known_for_department: 'Sound',
          name: 'Henrik Sunnåker',
          original_name: 'Henrik Sunnåker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a8ea6619251416c84010840',
          department: 'Sound',
          job: 'Foley Editor',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/sdylVXKmMZb5nCRJiMUwfDzVDQJ.jpg',
    belongs_to_collection: {
      id: 721111,
      name: 'Marshal Samuel Gerard Collection',
      poster_path: '/79iebaljoCowMLzEvu0ZPg18x8U.jpg',
      backdrop_path: '/ihZ2xvlTwsHW5yjZ5QYu0QSJRR1.jpg',
    },
    budget: 44000000,
    genres: [
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 28, name: 'Phim Hành Động' },
      { id: 53, name: 'Phim Gây Cấn' },
    ],
    homepage: '',
    id: 5503,
    imdb_id: 'tt0106977',
    original_language: 'en',
    original_title: 'The Fugitive',
    overview:
      'Richard Kimble đã bị hãm hại và buộc tội giết vợ. Và anh không có một bằng chứng nào bác bỏ giả thuyết này. Trường hợp này chắc chắn đến nỗi tưởng như định mệnh đã an bài, cuộc sống chối bỏ anh. Anh rơi vào cảnh ngộ không lối thoát. Nhưng một cơ hội tìm lại công bằng tự hé mở khi Kimble trốn thoát khỏi chiếc xe chở tù nhân. Ngay lúc đó anh cần tìm gặp kẻ đã giết vợ mình. Nhưng anh đã không còn mối liên hệ gì với thế giới này và không thể tin ai được nữa. Nếu điều đó không đủ cho anh đứng vững trên đôi chân của chính mình thì Samuel Gerard nóng nảy xuất hiện. Cuộc săn đuổi kẻ chạy trốn bắt đầu.',
    popularity: 22.924,
    poster_path:
      'https://image.tmdb.org/t/p/w342/eOFjZMYYx9T8JuV0gm2ezEw0rdl.jpg',
    production_companies: [
      {
        id: 174,
        logo_path: '/IuAlhI9eVC9Z8UQWOIDdWRKSEJ.png',
        name: 'Warner Bros. Pictures',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '1993-08-06',
    revenue: 368875760,
    runtime: 131,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline:
      'A murdered wife. A one-armed man. An obsessed detective. The chase begins.',
    title: 'Kẻ Đào Tẩu',
    video: false,
    vote_average: 7.4,
    vote_count: 3203,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Fugitive ≣ 1993 ≣ Trailer',
          key: 'P3nQP9IZ_pA',
          published_at: '2017-06-22T19:42:16.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: false,
          id: '594c1e02925141311101615d',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Fugitive 20th Anniversary - Bus Train Crash',
          key: '4LF4I1S9rOo',
          published_at: '2013-09-03T18:17:35.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: true,
          id: '5791fb64c3a3685961000c84',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Fugitive 20th Anniversary - L Train',
          key: 'eBqEpGk_HGY',
          published_at: '2013-09-03T18:15:52.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: true,
          id: '5791f9a19251411ff80009e6',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Fugitive 20th Anniversary - Dive',
          key: '4sjEAX4iymo',
          published_at: '2013-09-03T18:14:34.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: true,
          id: '5791f88ec3a36858df00091a',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Fugitive Trailer HD (1993)',
          key: '63hdx4iYs7k',
          published_at: '2010-11-05T15:58:58.000Z',
          site: 'YouTube',
          size: 720,
          type: 'Trailer',
          official: false,
          id: '5617357e9251412aec001434',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 3,
          known_for_department: 'Diễn viên',
          name: 'Harrison Ford',
          original_name: 'Harrison Ford',
          popularity: 9.173,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5M7oN3sznp99hWYQ9sX0xheswWX.jpg',
          cast_id: 2,
          character: 'Dr. Richard Kimble',
          credit_id: '52fe440ac3a36847f807eb29',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 2176,
          known_for_department: 'Diễn viên',
          name: 'Tommy Lee Jones',
          original_name: 'Tommy Lee Jones',
          popularity: 18.249,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zixpaPmOonRh1I3TWgxDkeGxkrv.jpg',
          cast_id: 3,
          character: 'Deputy Marshal Samuel Gerard',
          credit_id: '52fe440ac3a36847f807eb2d',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 532,
          known_for_department: 'Diễn viên',
          name: 'Joe Pantoliano',
          original_name: 'Joe Pantoliano',
          popularity: 6.764,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3OHUI3nX4SYGGItDk3xqeIvWtIf.jpg',
          cast_id: 7,
          character: 'Deputy Marashal Cosmo Renfro',
          credit_id: '52fe440ac3a36847f807eb3d',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 43774,
          known_for_department: 'Diễn viên',
          name: 'Daniel Roebuck',
          original_name: 'Daniel Roebuck',
          popularity: 2.551,
          profile_path:
            'https://image.tmdb.org/t/p/w185/y40aX3SdvUZwE7feNq77UMg3zge.jpg',
          cast_id: 10,
          character: 'Deputy Marshal Biggs',
          credit_id: '52fe440ac3a36847f807eb49',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 1924,
          known_for_department: 'Diễn viên',
          name: 'Jeroen Krabbé',
          original_name: 'Jeroen Krabbé',
          popularity: 3.385,
          profile_path:
            'https://image.tmdb.org/t/p/w185/r26lZKUeLIaUt8DMotm4mdc4EaY.jpg',
          cast_id: 9,
          character: 'Dr. Charles Nichols',
          credit_id: '52fe440ac3a36847f807eb45',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 29051,
          known_for_department: 'Diễn viên',
          name: 'L. Scott Caldwell',
          original_name: 'L. Scott Caldwell',
          popularity: 2.829,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8Iux9eUO9cBclLSFDO4DRbafLSy.jpg',
          cast_id: 11,
          character: 'Deputy Marshal Poole',
          credit_id: '52fe440ac3a36847f807eb4d',
          order: 5,
        },
        {
          adult: false,
          gender: 0,
          id: 43772,
          known_for_department: 'Diễn viên',
          name: 'Tom Wood',
          original_name: 'Tom Wood',
          popularity: 1.62,
          profile_path: null,
          cast_id: 6,
          character: 'Deputy Marshal Newman',
          credit_id: '52fe440ac3a36847f807eb39',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 57597,
          known_for_department: 'Diễn viên',
          name: 'Ron Dean',
          original_name: 'Ron Dean',
          popularity: 1.672,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mgqdr4VFrTVZatkki2suNLYxeDG.jpg',
          cast_id: 24,
          character: 'CPD Detective Kelly',
          credit_id: '56a182b8c3a36858cb00ec32',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 86576,
          known_for_department: 'Diễn viên',
          name: 'Joseph F. Kosala',
          original_name: 'Joseph F. Kosala',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/a6ioHr863U5wNiRCGimEyHOs4tg.jpg',
          cast_id: 25,
          character: 'CPD Detective Rosetti',
          credit_id: '56a182f5c3a36858c60110b7',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 43773,
          known_for_department: 'Diễn viên',
          name: 'Andreas Katsulas',
          original_name: 'Andreas Katsulas',
          popularity: 2.398,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nUWW0rW02JEVxIvu8y0Y4W0oK41.jpg',
          cast_id: 8,
          character: 'Frederick Sykes',
          credit_id: '52fe440ac3a36847f807eb41',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 6068,
          known_for_department: 'Diễn viên',
          name: 'Sela Ward',
          original_name: 'Sela Ward',
          popularity: 8.603,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pzQuH9vm182Ar2vpUsakKzxPNV7.jpg',
          cast_id: 4,
          character: 'Helen Kimble',
          credit_id: '52fe440ac3a36847f807eb31',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 86573,
          known_for_department: 'Diễn viên',
          name: 'Eddie Bo Smith Jr.',
          original_name: 'Eddie Bo Smith Jr.',
          popularity: 1.512,
          profile_path: null,
          cast_id: 40,
          character: 'Copeland - Escaped Convict',
          credit_id: '56a187d39251415e6700fec2',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 18262,
          known_for_department: 'Diễn viên',
          name: 'Richard Riehle',
          original_name: 'Richard Riehle',
          popularity: 4.211,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wgjBsgpzRvardVXZhNGixSw63g2.jpg',
          cast_id: 37,
          character: 'Senior Guard on Bus',
          credit_id: '56a18766c3a36858c800fbfd',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 62150,
          known_for_department: 'Diễn viên',
          name: 'Pancho Demmings',
          original_name: 'Pancho Demmings',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mvAaZccfae6mOAX7VYtNOdYzIMe.jpg',
          cast_id: 42,
          character: 'Younger Guard on Bus',
          credit_id: '56a188abc3a36858e5011319',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 12538,
          known_for_department: 'Diễn viên',
          name: 'Nick Searcy',
          original_name: 'Nick Searcy',
          popularity: 4.23,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nyeIw9bLarqoZ4mDVkkzRUPRiGK.jpg',
          cast_id: 45,
          character: 'Sheriff Rawlins',
          credit_id: '56a189dd9251412ec7008ac6',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 16477,
          known_for_department: 'Diễn viên',
          name: 'Danny Goldring',
          original_name: 'Danny Goldring',
          popularity: 1.107,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3F74afIgWwEVCrump1Wup0Rf9zx.jpg',
          cast_id: 44,
          character: 'Head Illinois State Trooper',
          credit_id: '56a189b7c3a36858e501136a',
          order: 15,
        },
        {
          adult: false,
          gender: 0,
          id: 171631,
          known_for_department: 'Diễn viên',
          name: 'Johnny Lee Davenport',
          original_name: 'Johnny Lee Davenport',
          popularity: 0.828,
          profile_path: null,
          cast_id: 50,
          character: 'Marshal Henry',
          credit_id: '56a18c81c3a36858c800fd50',
          order: 16,
        },
        {
          adult: false,
          gender: 2,
          id: 933416,
          known_for_department: 'Diễn viên',
          name: 'Dick Cusack',
          original_name: 'Dick Cusack',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tDWY3Km0jTn9ka2GmZOfadgAEDb.jpg',
          cast_id: 32,
          character: 'Walter Gutherie, lawyer',
          credit_id: '56a18632c3a36858dc00ff51',
          order: 17,
        },
        {
          adult: false,
          gender: 1,
          id: 1231,
          known_for_department: 'Diễn viên',
          name: 'Julianne Moore',
          original_name: 'Julianne Moore',
          popularity: 13.047,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3YF19rWusxWfEI59ZM33dFhasRq.jpg',
          cast_id: 5,
          character: 'Dr. Anne Eastman',
          credit_id: '52fe440ac3a36847f807eb35',
          order: 18,
        },
        {
          adult: false,
          gender: 1,
          id: 43775,
          known_for_department: 'Diễn viên',
          name: 'Jane Lynch',
          original_name: 'Jane Lynch',
          popularity: 5.278,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nye6D17ZfCHQzr9faYZYyz1CPsZ.jpg',
          cast_id: 12,
          character: 'Dr. Kathy Wahlund',
          credit_id: '52fe440ac3a36847f807eb51',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 35022,
          known_for_department: 'Diễn viên',
          name: 'David Darlow',
          original_name: 'David Darlow',
          popularity: 1.106,
          profile_path: null,
          cast_id: 28,
          character: 'Dr. Lentz',
          credit_id: '56a18520c3a36858c800fb70',
          order: 20,
        },
        {
          adult: false,
          gender: 2,
          id: 32289,
          known_for_department: 'Diễn viên',
          name: 'Andy Romano',
          original_name: 'Andy Romano',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/maQYk63vsymyolmJBHEsBmv3KxR.jpg',
          cast_id: 36,
          character: 'Judge Bennett',
          credit_id: '56a18739c3a36858e50112c4',
          order: 21,
        },
        {
          adult: false,
          gender: 2,
          id: 59399,
          known_for_department: 'Diễn viên',
          name: 'Miguel Nino',
          original_name: 'Miguel Nino',
          popularity: 0.6,
          profile_path: null,
          cast_id: 26,
          character: 'Chicago Cop #1',
          credit_id: '56a1835b92514137d60082ac',
          order: 22,
        },
        {
          adult: false,
          gender: 0,
          id: 1522099,
          known_for_department: 'Diễn viên',
          name: 'John Drummond',
          original_name: 'John Drummond',
          popularity: 0.6,
          profile_path: null,
          cast_id: 27,
          character: 'Newscaster',
          credit_id: '56a183ac9251415e5e00fbca',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 43776,
          known_for_department: 'Diễn viên',
          name: 'Neil Flynn',
          original_name: 'Neil Flynn',
          popularity: 3.841,
          profile_path:
            'https://image.tmdb.org/t/p/w185/17td6SExyUuOf2HYuYvnUnc4Ivy.jpg',
          cast_id: 13,
          character: 'Polizist',
          credit_id: '52fe440ac3a36847f807eb55',
          order: 24,
        },
        {
          adult: false,
          gender: 2,
          id: 1213105,
          known_for_department: 'Diễn viên',
          name: 'Kevin Crowley',
          original_name: 'Kevin Crowley',
          popularity: 1.53,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uRVsf1zx3EUA8nTpoEWkWNDyuKX.jpg',
          cast_id: 23,
          character: 'State Trooper',
          credit_id: '567436a89251412daf0030e4',
          order: 25,
        },
        {
          adult: false,
          gender: 2,
          id: 167567,
          known_for_department: 'Diễn viên',
          name: 'Mark D. Espinoza',
          original_name: 'Mark D. Espinoza',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xOgpNm7F37H4o5UV9HYJvgVW3yl.jpg',
          cast_id: 29,
          character: 'Resident',
          credit_id: '56a1856b9251415e5e00fc4d',
          order: 26,
        },
        {
          adult: false,
          gender: 0,
          id: 992588,
          known_for_department: 'Diễn viên',
          name: 'Gene Barge',
          original_name: 'Gene Barge',
          popularity: 0.6,
          profile_path: null,
          cast_id: 30,
          character: '11th District Cop',
          credit_id: '56a185ac92514168b1004cf4',
          order: 27,
        },
        {
          adult: false,
          gender: 2,
          id: 146307,
          known_for_department: 'Diễn viên',
          name: 'Joe Guzaldo',
          original_name: 'Joe Guzaldo',
          popularity: 0.991,
          profile_path: null,
          cast_id: 31,
          character: 'Prosecutor',
          credit_id: '56a185f492514149bc008624',
          order: 28,
        },
        {
          adult: false,
          gender: 2,
          id: 1522103,
          known_for_department: 'Diễn viên',
          name: 'Nicholas Kusenko',
          original_name: 'Nicholas Kusenko',
          popularity: 1.41,
          profile_path: null,
          cast_id: 33,
          character: 'Assistant Defense Attorney',
          credit_id: '56a186a292514138490084a2',
          order: 29,
        },
        {
          adult: false,
          gender: 0,
          id: 1522072,
          known_for_department: 'Diễn viên',
          name: 'Joan Kohn',
          original_name: 'Joan Kohn',
          popularity: 0.6,
          profile_path: null,
          cast_id: 34,
          character: 'Asst. Prosecuting Attorney',
          credit_id: '56a186c89251415e6700fe91',
          order: 30,
        },
        {
          adult: false,
          gender: 0,
          id: 1265395,
          known_for_department: 'Diễn viên',
          name: 'Joe Guastaferro',
          original_name: 'Joe Guastaferro',
          popularity: 0.98,
          profile_path: null,
          cast_id: 35,
          character: 'Coroner',
          credit_id: '56a1870792514149bc008673',
          order: 31,
        },
        {
          adult: false,
          gender: 0,
          id: 1357661,
          known_for_department: 'Diễn viên',
          name: 'Thom Vernon',
          original_name: 'Thom Vernon',
          popularity: 0.6,
          profile_path: null,
          cast_id: 38,
          character: 'Carlson',
          credit_id: '56a1878a92514137d60083c4',
          order: 32,
        },
        {
          adult: false,
          gender: 2,
          id: 201389,
          known_for_department: 'Diễn viên',
          name: 'Ken Moreno',
          original_name: 'Ken Moreno',
          popularity: 0.6,
          profile_path: null,
          cast_id: 39,
          character: 'Partida',
          credit_id: '56a187a89251415e5e00fcd1',
          order: 33,
        },
        {
          adult: false,
          gender: 2,
          id: 29745,
          known_for_department: 'Biên kịch',
          name: 'Frank Ray Perilli',
          original_name: 'Frank Ray Perilli',
          popularity: 1.052,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zBnDFSkEZYXGpnWIq8okQciMOdh.jpg',
          cast_id: 82,
          character: 'Jail Officer',
          credit_id: '56a6a774c3a36819cb0009b5',
          order: 34,
        },
        {
          adult: false,
          gender: 2,
          id: 1025090,
          known_for_department: 'Crew',
          name: 'Jim Wilkey',
          original_name: 'Jim Wilkey',
          popularity: 0.62,
          profile_path: null,
          cast_id: 43,
          character: 'Bus Driver',
          credit_id: '56a188cdc3a36858c800fc51',
          order: 35,
        },
        {
          adult: false,
          gender: 0,
          id: 1455934,
          known_for_department: 'Diễn viên',
          name: 'Michael James',
          original_name: 'Michael James',
          popularity: 0.6,
          profile_path: null,
          cast_id: 46,
          character: 'Head Welder',
          credit_id: '56a18b26c3a36858c800fcf7',
          order: 36,
        },
        {
          adult: false,
          gender: 0,
          id: 182372,
          known_for_department: 'Diễn viên',
          name: 'Michael Skewes',
          original_name: 'Michael Skewes',
          popularity: 0.6,
          profile_path: null,
          cast_id: 47,
          character: 'Highway Patrolman',
          credit_id: '56a18bd89251415e6700ffad',
          order: 37,
        },
        {
          adult: false,
          gender: 2,
          id: 1317080,
          known_for_department: 'Diễn viên',
          name: 'Cody Glenn',
          original_name: 'Cody Glenn',
          popularity: 0.6,
          profile_path: null,
          cast_id: 48,
          character: 'Paramedic',
          credit_id: '56a18c3092514168b1004e45',
          order: 38,
        },
        {
          adult: false,
          gender: 1,
          id: 1178319,
          known_for_department: 'Diễn viên',
          name: 'Cynthia Baker',
          original_name: 'Cynthia Baker',
          popularity: 0.6,
          profile_path: null,
          cast_id: 49,
          character: 'Woman in Car',
          credit_id: '56a18c5892514137d60084f2',
          order: 39,
        },
        {
          adult: false,
          gender: 2,
          id: 141417,
          known_for_department: 'Diễn viên',
          name: 'Mike Bacarella',
          original_name: 'Mike Bacarella',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iMvu8lPSr5nG2youh11S1RgrvTW.jpg',
          cast_id: 51,
          character: 'Marshal Stevens',
          credit_id: '56a18ca8c3a36858c301011c',
          order: 40,
        },
        {
          adult: false,
          gender: 2,
          id: 7143,
          known_for_department: 'Diễn viên',
          name: 'Bill Cusack',
          original_name: 'Bill Cusack',
          popularity: 5.901,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gzFrSaKHWiNw3QnoJe1Amv2mcpH.jpg',
          cast_id: 52,
          character: 'Tracing Technician',
          credit_id: '56a26a4d925141721400012d',
          order: 41,
        },
        {
          adult: false,
          gender: 0,
          id: 1434607,
          known_for_department: 'Crew',
          name: 'Tighe Barry',
          original_name: 'Tighe Barry',
          popularity: 0.6,
          profile_path: null,
          cast_id: 53,
          character: 'Windshield Washer',
          credit_id: '56a26acbc3a368389000018c',
          order: 42,
        },
        {
          adult: false,
          gender: 0,
          id: 1522106,
          known_for_department: 'Diễn viên',
          name: 'Afram Bill Williams',
          original_name: 'Afram Bill Williams',
          popularity: 0.98,
          profile_path: null,
          cast_id: 54,
          character: 'Salesman',
          credit_id: '56a26b32925141720b00015f',
          order: 43,
        },
        {
          adult: false,
          gender: 0,
          id: 1522083,
          known_for_department: 'Diễn viên',
          name: 'Noelle Bou-Sliman',
          original_name: 'Noelle Bou-Sliman',
          popularity: 0.98,
          profile_path: null,
          cast_id: 55,
          character: 'Myoelectric Technician',
          credit_id: '56a26b78925141720700017b',
          order: 44,
        },
        {
          adult: false,
          gender: 0,
          id: 74246,
          known_for_department: 'Diễn viên',
          name: 'Greg Hollimon',
          original_name: 'Greg Hollimon',
          popularity: 0.6,
          profile_path: null,
          cast_id: 56,
          character: 'Skating Orderly',
          credit_id: '56a26beac3a368389000019e',
          order: 45,
        },
        {
          adult: false,
          gender: 1,
          id: 23355,
          known_for_department: 'Diễn viên',
          name: 'Cheryl Lynn Bruce',
          original_name: 'Cheryl Lynn Bruce',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/u3Na9OzrjiJpqQ4Hpp7S1hT0oTF.jpg',
          cast_id: 57,
          character: 'O.R. Doctor',
          credit_id: '56a26c34c3a36838900001a6',
          order: 46,
        },
        {
          adult: false,
          gender: 1,
          id: 1005538,
          known_for_department: 'Diễn viên',
          name: 'Ann Whitney',
          original_name: 'Ann Whitney',
          popularity: 1.021,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gaoHTM46dilnFiyXdYzG7Dwk8FH.jpg',
          cast_id: 58,
          character: 'Myoelectric Director',
          credit_id: '56a26c7b925141720b00017b',
          order: 47,
        },
        {
          adult: false,
          gender: 2,
          id: 135717,
          known_for_department: 'Diễn viên',
          name: 'Turk Muller',
          original_name: 'Turk Muller',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1s6fvgupEpTBbDHR4eamvvTCNdf.jpg',
          cast_id: 59,
          character: 'Clearing Officer',
          credit_id: '56a26cb1925141720700019c',
          order: 48,
        },
        {
          adult: false,
          gender: 2,
          id: 1428209,
          known_for_department: 'Lighting',
          name: 'Eugene F. Crededio',
          original_name: 'Eugene F. Crededio',
          popularity: 0.6,
          profile_path: null,
          cast_id: 60,
          character: 'Visitation Guard',
          credit_id: '56a26d12c3a36838a3000174',
          order: 49,
        },
        {
          adult: false,
          gender: 0,
          id: 1522097,
          known_for_department: 'Diễn viên',
          name: 'Pam Zekman',
          original_name: 'Pam Zekman',
          popularity: 0.6,
          profile_path: null,
          cast_id: 61,
          character: 'Newscaster',
          credit_id: '56a26d49c3a368389e00015d',
          order: 50,
        },
        {
          adult: false,
          gender: 2,
          id: 74487,
          known_for_department: 'Diễn viên',
          name: 'David Pasquesi',
          original_name: 'David Pasquesi',
          popularity: 1.433,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vlXVxJSH6ja8RPf1Bv6UTnFdyhq.jpg',
          cast_id: 62,
          character: 'Newscaster',
          credit_id: '56a26d6ec3a368389b0001b2',
          order: 51,
        },
        {
          adult: false,
          gender: 1,
          id: 1480633,
          known_for_department: 'Directing',
          name: 'Dru Anne Carlson',
          original_name: 'Dru Anne Carlson',
          popularity: 1.176,
          profile_path: null,
          cast_id: 63,
          character: "Gerard's Secretary",
          credit_id: '56a26df8c3a36838900001e0',
          order: 52,
        },
        {
          adult: false,
          gender: 1,
          id: 1219500,
          known_for_department: 'Diễn viên',
          name: 'Kirsten Nelson',
          original_name: 'Kirsten Nelson',
          popularity: 2.118,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7TfweasXJLw5cKNAiV1xYzIJYcT.jpg',
          cast_id: 64,
          character: 'Betty',
          credit_id: '56a26e92c3a368388b0001b8',
          order: 53,
        },
        {
          adult: false,
          gender: 0,
          id: 148306,
          known_for_department: 'Diễn viên',
          name: 'Juan Ramírez',
          original_name: 'Juan Ramírez',
          popularity: 1.566,
          profile_path: null,
          cast_id: 65,
          character: "Man on 'El'",
          credit_id: '56a26ed292514172140001a5',
          order: 54,
        },
        {
          adult: false,
          gender: 2,
          id: 554391,
          known_for_department: 'Diễn viên',
          name: 'Allen Hamilton',
          original_name: 'Allen Hamilton',
          popularity: 0.98,
          profile_path: null,
          cast_id: 66,
          character: 'Host',
          credit_id: '56a26efcc3a3683890000203',
          order: 55,
        },
        {
          adult: false,
          gender: 2,
          id: 945907,
          known_for_department: 'Diễn viên',
          name: 'Lester Holt',
          original_name: 'Lester Holt',
          popularity: 0.756,
          profile_path:
            'https://image.tmdb.org/t/p/w185/x8uipNVcxFKqJdKPuxJKH0ByknB.jpg',
          cast_id: 67,
          character: 'Newscaster',
          credit_id: '56a26fad92514172020001fe',
          order: 56,
        },
        {
          adult: false,
          gender: 1,
          id: 568601,
          known_for_department: 'Diễn viên',
          name: 'Suzy Brack',
          original_name: 'Suzy Brack',
          popularity: 0.6,
          profile_path: null,
          cast_id: 83,
          character: 'City Hall Employee (uncredited)',
          credit_id: '56f53c5f9251412eb4000948',
          order: 57,
        },
        {
          adult: false,
          gender: 0,
          id: 1566977,
          known_for_department: 'Diễn viên',
          name: 'Darren W. Conrad',
          original_name: 'Darren W. Conrad',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iaunt7VS0YIZ5eyDT25kN5BmfvF.jpg',
          cast_id: 69,
          character: 'Deputy at Train Wreck (uncredited)',
          credit_id: '56a271bbc3a3683890000257',
          order: 58,
        },
        {
          adult: false,
          gender: 2,
          id: 976444,
          known_for_department: 'Diễn viên',
          name: 'Kevin Mukherji',
          original_name: 'Kevin Mukherji',
          popularity: 0.6,
          profile_path: null,
          cast_id: 70,
          character: 'Doctor (uncredited)',
          credit_id: '56a272bb92514171ff00022a',
          order: 59,
        },
        {
          adult: false,
          gender: 0,
          id: 1237372,
          known_for_department: 'Diễn viên',
          name: 'Sal Richards',
          original_name: 'Sal Richards',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gZSiZOtBVv1U4hqjlKkPr2p5rCP.jpg',
          cast_id: 71,
          character: 'Warrant Captain (uncredited)',
          credit_id: '56a2732192514171ff000234',
          order: 60,
        },
        {
          adult: false,
          gender: 2,
          id: 91901,
          known_for_department: 'Crew',
          name: 'John-Clay Scott',
          original_name: 'John-Clay Scott',
          popularity: 1.094,
          profile_path: null,
          cast_id: 72,
          character: 'Mad Motorist at Tunnel (uncredited)',
          credit_id: '56a2739b9251417207000273',
          order: 61,
        },
        {
          adult: false,
          gender: 0,
          id: 2481377,
          known_for_department: 'Diễn viên',
          name: 'B.J. Jones',
          original_name: 'B.J. Jones',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1QvOvJ7STey4LjGoO7JhclLYNbE.jpg',
          cast_id: 132,
          character: 'Doctor at Bar',
          credit_id: '5df2f364d1a89300127250b3',
          order: 62,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 3119,
          known_for_department: 'Sound',
          name: 'Lance Brown',
          original_name: 'Lance Brown',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5ad77779c3a36847de00f70a',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1044,
          known_for_department: 'Camera',
          name: 'Michael Chapman',
          original_name: 'Michael Chapman',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vFFWHlwwIgWoi2NPoVq3uzikCnM.jpg',
          credit_id: '52fe440ac3a36847f807eb7f',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 1056,
          known_for_department: 'Sound',
          name: 'Sam Gemette',
          original_name: 'Sam Gemette',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad777370e0a2674d5012897',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1213,
          known_for_department: 'Sound',
          name: 'James Newton Howard',
          original_name: 'James Newton Howard',
          popularity: 1.078,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qB4JgzCXCjr7NwW7UNrgBrWZDlo.jpg',
          credit_id: '52fe440ac3a36847f807eb79',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 7671,
          known_for_department: 'Biên kịch',
          name: 'Jeb Stuart',
          original_name: 'Jeb Stuart',
          popularity: 1.385,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jIDFAtot30xEHhEqi9T6ljb1Laj.jpg',
          credit_id: '52fe440ac3a36847f807eb5b',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 1,
          id: 2031,
          known_for_department: 'Production',
          name: 'Amanda Mackey',
          original_name: 'Amanda Mackey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe440ac3a36847f807eb85',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 1,
          id: 2532,
          known_for_department: 'Production',
          name: 'Cathy Sandrich Gelfond',
          original_name: 'Cathy Sandrich Gelfond',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe440ac3a36847f807eb8b',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 5580,
          known_for_department: 'Production',
          name: 'Peter Macgregor-Scott',
          original_name: 'Peter Macgregor-Scott',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56a2c0d6925141720e000adc',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 5584,
          known_for_department: 'Editing',
          name: 'Dennis Virkler',
          original_name: 'Dennis Virkler',
          popularity: 0.631,
          profile_path: null,
          credit_id: '5791f152c3a36857800005e7',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 8428,
          known_for_department: 'Costume & Make-Up',
          name: 'Aggie Guerard Rodgers',
          original_name: 'Aggie Guerard Rodgers',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56a2c1d7925141720b000ada',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 2,
          id: 11475,
          known_for_department: 'Art',
          name: 'Maher Ahmad',
          original_name: 'Maher Ahmad',
          popularity: 1.052,
          profile_path: null,
          credit_id: '56a2c189c3a3683890000d41',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 10764,
          known_for_department: 'Production',
          name: 'Arnold Kopelson',
          original_name: 'Arnold Kopelson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe440ac3a36847f807eb67',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 12989,
          known_for_department: 'Directing',
          name: 'Andrew Davis',
          original_name: 'Andrew Davis',
          popularity: 1.757,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wZIDAQwxXs1bkbQ4lUOPWdu4R8m.jpg',
          credit_id: '52fe440ac3a36847f807eb25',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 15842,
          known_for_department: 'Editing',
          name: 'Dov Hoenig',
          original_name: 'Dov Hoenig',
          popularity: 0.838,
          profile_path: null,
          credit_id: '5791f1909251411e670005fb',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 16601,
          known_for_department: 'Visual Effects',
          name: 'William Mesa',
          original_name: 'William Mesa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '575225469251414c5700062f',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 16614,
          known_for_department: 'Art',
          name: 'J. Dennis Washington',
          original_name: 'J. Dennis Washington',
          popularity: 0.694,
          profile_path: null,
          credit_id: '56a2c144c3a3683896000ac4',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 2,
          id: 16737,
          known_for_department: 'Sound',
          name: 'Jim Weidman',
          original_name: 'Jim Weidman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad779490e0a2674d5012ac6',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 16655,
          known_for_department: 'Sound',
          name: 'Stu Bernstein',
          original_name: 'Stu Bernstein',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad775e80e0a2674be0105cf',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 18387,
          known_for_department: 'Editing',
          name: 'David Finfer',
          original_name: 'David Finfer',
          popularity: 0.695,
          profile_path:
            'https://image.tmdb.org/t/p/w185/twn5dujvw7F93FaZTcwKDJzbuuU.jpg',
          credit_id: '5791f1d2c3a368577d00067b',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 21725,
          known_for_department: 'Production',
          name: 'Keith Barish',
          original_name: 'Keith Barish',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe440ac3a36847f807eb6d',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 28239,
          known_for_department: 'Biên kịch',
          name: 'David Twohy',
          original_name: 'David Twohy',
          popularity: 2.198,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jqcc7WqmAWD7TBOxu2dXK8M9L6d.jpg',
          credit_id: '52fe440ac3a36847f807eb61',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 28239,
          known_for_department: 'Biên kịch',
          name: 'David Twohy',
          original_name: 'David Twohy',
          popularity: 2.198,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jqcc7WqmAWD7TBOxu2dXK8M9L6d.jpg',
          credit_id: '5791ed39c3a3685925000343',
          department: 'Biên kịch',
          job: 'Story',
        },
        {
          adult: false,
          gender: 0,
          id: 36038,
          known_for_department: 'Production',
          name: 'James A. Dennett',
          original_name: 'James A. Dennett',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56a2c1fec3a368388b000c3a',
          department: 'Production',
          job: 'Unit Production Manager',
        },
        {
          adult: false,
          gender: 2,
          id: 43777,
          known_for_department: 'Biên kịch',
          name: 'Roy Huggins',
          original_name: 'Roy Huggins',
          popularity: 0.694,
          profile_path: null,
          credit_id: '52fe440ac3a36847f807eb73',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 43777,
          known_for_department: 'Biên kịch',
          name: 'Roy Huggins',
          original_name: 'Roy Huggins',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5791ed049251411f0d0003db',
          department: 'Biên kịch',
          job: 'Characters',
        },
        {
          adult: false,
          gender: 2,
          id: 53291,
          known_for_department: 'Editing',
          name: 'Richard Nord',
          original_name: 'Richard Nord',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5791f17b9251411ff80005ab',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 57076,
          known_for_department: 'Production',
          name: 'Stephen Joel Brown',
          original_name: 'Stephen Joel Brown',
          popularity: 0.84,
          profile_path: null,
          credit_id: '56a2c07a9251417211000ae0',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 58208,
          known_for_department: 'Editing',
          name: 'Don Brochu',
          original_name: 'Don Brochu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5791f1e9c3a36859610006d4',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 69895,
          known_for_department: 'Production',
          name: 'Nana Greenwald',
          original_name: 'Nana Greenwald',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56a2c0a992514171ff000a6e',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 80824,
          known_for_department: 'Sound',
          name: 'Jay Nierenberg',
          original_name: 'Jay Nierenberg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad777b20e0a2674c100fd93',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 83088,
          known_for_department: 'Sound',
          name: 'Kimberly Ellen Lowe',
          original_name: 'Kimberly Ellen Lowe',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5ad77518c3a36847de00f51b',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 106253,
          known_for_department: 'Editing',
          name: 'James Beshears',
          original_name: 'James Beshears',
          popularity: 0.996,
          profile_path: null,
          credit_id: '5ad775dc0e0a2674d5012783',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 228439,
          known_for_department: 'Sound',
          name: 'Gaston Biraben',
          original_name: 'Gaston Biraben',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad775c30e0a2674cb01111e',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 958460,
          known_for_department: 'Art',
          name: 'Rick Gentz',
          original_name: 'Rick Gentz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56a2c1aec3a368388e000b88',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 1115736,
          known_for_department: 'Sound',
          name: 'Bruce Stambler',
          original_name: 'Bruce Stambler',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad776bf9251413b28011e1a',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1338673,
          known_for_department: 'Crew',
          name: 'Douglas E. Madison',
          original_name: 'Douglas E. Madison',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad774c90e0a2674c401161b',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 2,
          id: 1344255,
          known_for_department: 'Sound',
          name: 'Anthony Milch',
          original_name: 'Anthony Milch',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad777a70e0a2674d20113a0',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1376901,
          known_for_department: 'Sound',
          name: 'Marshall Winn',
          original_name: 'Marshall Winn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad7788d9251413b2b012432',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1378170,
          known_for_department: 'Sound',
          name: 'Donald O. Mitchell',
          original_name: 'Donald O. Mitchell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad776fc0e0a2674c4011835',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1378226,
          known_for_department: 'Sound',
          name: 'Michael Herbick',
          original_name: 'Michael Herbick',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad777070e0a2674c100fce1',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1390525,
          known_for_department: 'Sound',
          name: 'Gary Mundheim',
          original_name: 'Gary Mundheim',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad774fa0e0a2674cb01105c',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1392242,
          known_for_department: 'Sound',
          name: 'Donald L. Warner Jr.',
          original_name: 'Donald L. Warner Jr.',
          popularity: 1.614,
          profile_path: null,
          credit_id: '5ad77883c3a36847de00f81a',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1393262,
          known_for_department: 'Sound',
          name: 'Steve Schwalbe',
          original_name: 'Steve Schwalbe',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad778609251413b28011fa9',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1394130,
          known_for_department: 'Sound',
          name: 'Frank A. Montaño',
          original_name: 'Frank A. Montaño',
          popularity: 1.008,
          profile_path: null,
          credit_id: '5ad776ef0e0a2674d501285d',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1404841,
          known_for_department: 'Sound',
          name: 'Zack Davis',
          original_name: 'Zack Davis',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5ad7762e0e0a2674d201125d',
          department: 'Sound',
          job: 'ADR Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1404903,
          known_for_department: 'Sound',
          name: 'Becky Sullivan',
          original_name: 'Becky Sullivan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad77506c3a368480b011745',
          department: 'Sound',
          job: 'Supervising Dialogue Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1405717,
          known_for_department: 'Sound',
          name: 'Howell Gibbens',
          original_name: 'Howell Gibbens',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad775919251413b37011a6c',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1406826,
          known_for_department: 'Sound',
          name: 'Hector C. Gika',
          original_name: 'Hector C. Gika',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1yJ3xp1jj4Az44n6fdIw4F6lCz6.jpg',
          credit_id: '5ad778c10e0a2674d201150f',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1412227,
          known_for_department: 'Sound',
          name: 'Glenn Hoskinson',
          original_name: 'Glenn Hoskinson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad777489251413b250113fa',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1412250,
          known_for_department: 'Visual Effects',
          name: 'John P. Mesa',
          original_name: 'John P. Mesa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '575224c29251414c570005e7',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 1413451,
          known_for_department: 'Sound',
          name: 'John Leveque',
          original_name: 'John Leveque',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5ad776d29251413b25011399',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1428852,
          known_for_department: 'Sound',
          name: 'Patrick Bietz',
          original_name: 'Patrick Bietz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad7771b0e0a2674be0106b0',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1431629,
          known_for_department: 'Sound',
          name: 'Barbara J. Boguski',
          original_name: 'Barbara J. Boguski',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad775fbc3a36847e801201d',
          department: 'Sound',
          job: 'ADR Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1439872,
          known_for_department: 'Sound',
          name: 'Lee Lemont',
          original_name: 'Lee Lemont',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad7763dc3a36848020105af',
          department: 'Sound',
          job: 'ADR Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1446545,
          known_for_department: 'Sound',
          name: 'Karen G. Wilson',
          original_name: 'Karen G. Wilson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad775ac0e0a2674c70115a6',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1480633,
          known_for_department: 'Directing',
          name: 'Dru Anne Carlson',
          original_name: 'Dru Anne Carlson',
          popularity: 1.176,
          profile_path: null,
          credit_id: '5ad7792ac3a36847de00f8b4',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1551523,
          known_for_department: 'Sound',
          name: 'Robert Ulrich',
          original_name: 'Robert Ulrich',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad774db9251413b2d011849',
          department: 'Sound',
          job: 'ADR Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1551853,
          known_for_department: 'Sound',
          name: 'Scott D. Smith',
          original_name: 'Scott D. Smith',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5ad776b19251413b310119c6',
          department: 'Sound',
          job: 'Production Sound Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1567079,
          known_for_department: 'Production',
          name: 'Robert Grand',
          original_name: 'Robert Grand',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56a2c240925141720b000ae4',
          department: 'Production',
          job: 'Unit Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1610265,
          known_for_department: 'Sound',
          name: 'Shawn Sykora',
          original_name: 'Shawn Sykora',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad778769251413b2d011b47',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1628600,
          known_for_department: 'Costume & Make-Up',
          name: 'Linda Henrikson',
          original_name: 'Linda Henrikson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '574c69df92514124150001c9',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1630675,
          known_for_department: 'Editing',
          name: 'Bob Putynkowski',
          original_name: 'Bob Putynkowski',
          popularity: 0.652,
          profile_path: null,
          credit_id: '575306e6c3a3686f69000274',
          department: 'Editing',
          job: 'Color Timer',
        },
        {
          adult: false,
          gender: 2,
          id: 1654393,
          known_for_department: 'Editing',
          name: 'Dean Goodhill',
          original_name: 'Dean Goodhill',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5791f1ab9251411ff80005c4',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1775575,
          known_for_department: 'Sound',
          name: 'Greg Stacy',
          original_name: 'Greg Stacy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad778999251413b28011fea',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 2013249,
          known_for_department: 'Sound',
          name: 'Michael C. Mason',
          original_name: 'Michael C. Mason',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ac149400e0a264a4e051275',
          department: 'Sound',
          job: 'Music Score Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2025271,
          known_for_department: 'Sound',
          name: 'Holly Huckins',
          original_name: 'Holly Huckins',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad77614c3a36847e801203c',
          department: 'Sound',
          job: 'ADR Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2025275,
          known_for_department: 'Sound',
          name: 'Frank Kniest',
          original_name: 'Frank Kniest',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad77784c3a36847f50111c3',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 2612131,
          known_for_department: 'Sound',
          name: 'Roy Hawkins',
          original_name: 'Roy Hawkins',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jAImQCksayIzSnRedm0IYmpBWYp.jpg',
          credit_id: '5ea15fb138e5100020da9041',
          department: 'Sound',
          job: 'Music',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'Wuchak',
          author_details: {
            name: '',
            username: 'Wuchak',
            avatar_path: '/4KVM1VkqmXLOuwj1jjaSdxbvBDk.jpg',
            rating: 8.0,
          },
          content:
            '***Top-of-the-line crime thriller with Harrison Ford and Tommy Lee Jones***\r\n\r\nĐã phát hành in 1993 and based on the TV show from 30 years earlier, “The Fugitive” stars Harrison Ford as Dr. Richard Kimble, an innocent fugitive framed for murder. As he pursues the one-armed killer & those who pulled his strings, a determined U.S. Marshal (Tommy Lee Jones) hunts Kimble down from wilderness regions to the streets of Chicago.\r\n\r\nThe first 40 minutes contain the most action, hooking the viewer with an exhilarating bus wreck/train wreck followed by a phenomenal dam sequence. The rest of the movie is an intelligent and suspenseful cat-and-mouse chase with Kimble zeroing-in on those who framed him and why.\r\n\r\n“The Fugitive” was a deserved box office hit, costing $40 million and raking in $369 million with $184 of that domestically. To realize just how well-done it is, check out the sequel, “U.S. Marshals” (1998), which features the same basic plot, but without most of the magic.\r\n\r\nThe film runs 2 hours, 10 minutes and was shot in Illinois and North Carolina; the dam sequence, for instance, was filmed at Cheoah Dam, Tapoco, North Carolina.\r\n\r\nGRADE: A-',
          created_at: '2018-12-10T21:06:16.552Z',
          id: '5c0ed548c3a368252d0d1070',
          updated_at: '2021-06-23T15:58:15.020Z',
          url: 'https://www.themoviedb.org/review/5c0ed548c3a368252d0d1070',
        },
      ],
      total_pages: 1,
      total_results: 1,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/8NLs4rogROu2eNPxdTUqExiLak2.jpg',
    belongs_to_collection: {
      id: 683139,
      name: 'Mojin Collection',
      poster_path: '/aZriVC7OH1sslZq6ASuY6K3Qcvq.jpg',
      backdrop_path: '/sArJxRzqvF3FVbJBN4ZK2kITaJ.jpg',
    },
    budget: 0,
    genres: [
      { id: 28, name: 'Phim Hành Động' },
      { id: 14, name: 'Phim Giả Tượng' },
      { id: 12, name: 'Phim Phiêu Lưu' },
    ],
    homepage: '',
    id: 571446,
    imdb_id: 'tt9490414',
    original_language: 'zh',
    original_title: '云南虫谷',
    overview:
      'Để tự cứu mình khỏi lời nguyền của Động Quỷ Tinh Tuyệt, Hồ Bát Nhất cùng Tuyền béo và Shirley Dương lên đường đến Trùng cốc, Vân Nam để tìm Mộc Trần Châu ẩn trong mộ Hiến Vương, vị vua bí hiểm, đầy phép phù thủy của nước Điền cổ hai ngàn năm trước.  Đến vùng núi Già Long gần Trùng cốc, trước mắt ba Mô kim Hiệu úy, một loạt chuyện kỳ quái đã xảy ra: những nô lệ bị thành xác khô bởi tà thuật cả ngàn năm trước, bọn cá ăn thịt người hung hãn, con sâu khổng lồ bất tử trong bộ giáp vảy rồng... Và chuyến đi lần này, họ không chỉ gặp những cạm bẫy âm hiểm hay đám cương thi trong mộ cổ, mà còn có thứ đáng sợ hơn gấp bội phần ...',
    popularity: 5.452,
    poster_path:
      'https://image.tmdb.org/t/p/w342/cVlBbBNdURmuy677dQksl5zf4AB.jpg',
    production_companies: [],
    production_countries: [{ iso_3166_1: 'CN', name: 'Trung Quốc' }],
    release_date: '2018-12-29',
    revenue: 0,
    runtime: 110,
    spoken_languages: [
      { english_name: 'Mandarin', iso_639_1: 'zh', name: '普通话' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Ma Thổi Đèn: Trùng Cốc Vân Nam',
    video: false,
    vote_average: 6.6,
    vote_count: 28,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'MOJIN: THE WORM VALLEY (2019) Official Trailer',
          key: 'Rgmj92dAyoQ',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2018-12-10T20:47:40.000Z',
          id: '5c86cec80e0a2618885dff8c',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 2263547,
          known_for_department: 'Diễn viên',
          name: 'Cai Heng',
          original_name: 'Cai Heng',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uiP8rXT4LwPEsYWM2hHaq7zgGFm.jpg',
          cast_id: 2,
          character: 'Hu Bayi',
          credit_id: '5c870d990e0a2627fd5afc62',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 1838723,
          known_for_department: 'Diễn viên',
          name: 'Gu Xuan',
          original_name: 'Gu Xuan',
          popularity: 2.08,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rFqfGScc5Lw5kEgX7Vr2SDKN06X.jpg',
          cast_id: 8,
          character: 'Shirley Yang',
          credit_id: '5d4205e4b87aec160a396239',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 2263548,
          known_for_department: 'Diễn viên',
          name: 'Yu Heng',
          original_name: 'Yu Heng',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hXCrsiGg9OqsidWCPP3TLuvOS5f.jpg',
          cast_id: 3,
          character: 'Wang Kaixuan',
          credit_id: '5c870e74c3a36813c2d44968',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 2484799,
          known_for_department: 'Diễn viên',
          name: 'Zhang Luyao',
          original_name: 'Zhang Luyao',
          popularity: 0.6,
          profile_path: null,
          cast_id: 12,
          character: 'Empress Jing Jue',
          credit_id: '5e88f58cd207f300169743d0',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 72483,
          known_for_department: 'Diễn viên',
          name: 'Cheng Taishen',
          original_name: 'Cheng Taishen',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nZultdTTH9d59smMlle3mqMkSih.jpg',
          cast_id: 9,
          character: 'Professor Sun',
          credit_id: '5d42060395acf00012b2086c',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 2263549,
          known_for_department: 'Diễn viên',
          name: 'Yusi Chen',
          original_name: 'Yusi Chen',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aw4m3hxi6O06Z4xGv2sdJfdyKVh.jpg',
          cast_id: 4,
          character: 'Zhou Linglong',
          credit_id: '5c870edfc3a3682853d28c04',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 586420,
          known_for_department: 'Diễn viên',
          name: 'Tong Chih-Wei',
          original_name: 'Tong Chih-Wei',
          popularity: 0.648,
          profile_path: null,
          cast_id: 5,
          character: 'Zhou Jiuye',
          credit_id: '5c870f3c9251410d361785c9',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 1366128,
          known_for_department: 'Diễn viên',
          name: 'Tou Chung-Hua',
          original_name: 'Tou Chung-Hua',
          popularity: 1.214,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sa3yzL4XYvyjKORErYh6Lpl1VgP.jpg',
          cast_id: 6,
          character: 'Chen Yukou',
          credit_id: '5c870fa20e0a26430a68e734',
          order: 7,
        },
        {
          adult: false,
          gender: 1,
          id: 2131400,
          known_for_department: 'Diễn viên',
          name: 'Xu Lu',
          original_name: 'Xu Lu',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uUbeOUcSGwsCYzpgh6jt2DTCo3U.jpg',
          cast_id: 7,
          character: 'Cai Yun',
          credit_id: '5c870fecc3a3684e8fe0a934',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 1985687,
          known_for_department: 'Diễn viên',
          name: 'Marc Ma',
          original_name: 'Marc Ma',
          popularity: 0.6,
          profile_path: null,
          cast_id: 11,
          character: '',
          credit_id: '5e88f4886dc6c000158246f4',
          order: 9,
        },
        {
          adult: false,
          gender: 0,
          id: 2589726,
          known_for_department: 'Diễn viên',
          name: "Zhu Yun'er",
          original_name: "Zhu Yun'er",
          popularity: 0.6,
          profile_path: null,
          cast_id: 13,
          character: '',
          credit_id: '5e88f66a6dc6c00017828c39',
          order: 10,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 64430,
          known_for_department: 'Camera',
          name: 'Chi Ying Chan',
          original_name: 'Chi Ying Chan',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yDChYg2NSVBYAmGdoyTDznaIfSv.jpg',
          credit_id: '614a51e6609750002a48c07f',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 1044872,
          known_for_department: 'Directing',
          name: 'Xing Fei',
          original_name: 'Xing Fei',
          popularity: 0.608,
          profile_path:
            'https://image.tmdb.org/t/p/w185/36farOwRxLtQ9Ekqi2x0WnZIboP.jpg',
          credit_id: '5c276e76c3a3683a70d2346a',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1044872,
          known_for_department: 'Directing',
          name: 'Xing Fei',
          original_name: 'Xing Fei',
          popularity: 0.608,
          profile_path:
            'https://image.tmdb.org/t/p/w185/36farOwRxLtQ9Ekqi2x0WnZIboP.jpg',
          credit_id: '5f92f59fb0cd200036825a20',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 2970968,
          known_for_department: 'Biên kịch',
          name: 'Zhang Muye',
          original_name: 'Zhang Muye',
          popularity: 1.22,
          profile_path: null,
          credit_id: '60c02278992fe600402e6371',
          department: 'Biên kịch',
          job: 'Novel',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/rQ5IqaZ1MAJiVnrGttqEoaZTMth.jpg',
    belongs_to_collection: {
      id: 24761,
      name: 'Tạp Chí Thiên Niên Kỷ',
      poster_path: '/sLeE5pwX9cle1v1TpBylT9MeYJ2.jpg',
      backdrop_path: '/9wLsZPhI7ZafO4fh1MhwCjvkclN.jpg',
    },
    budget: 4422952,
    genres: [
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 28, name: 'Phim Hành Động' },
      { id: 53, name: 'Phim Gây Cấn' },
      { id: 80, name: 'Phim Hình Sự' },
      { id: 9648, name: 'Phim Bí Ẩn' },
    ],
    homepage:
      'http://dragontattoofilm.com/about-5/the-girl-who-played-with-fire/',
    id: 24253,
    imdb_id: 'tt1216487',
    original_language: 'sv',
    original_title: 'Flickan som lekte med elden',
    overview:
      'Salander bị buộc tội giết 3 người và để chứng minh được mình vô tội, cô phải nhờ đến sự giúp đỡ của người yêu Mikael Blomkvist (Michael Nyqvist) - một nhà báo cánh tả hoàn toàn tin tưởng ở cô. Sử dụng những phương pháp khác biệt, Mikael đã nói chuyện với những nghi phạm, còn Lisbeth hack mạng máy tính lấy những thông tin cần thiết. Từ đó hai người đã tìm được những mối liên hệ bí mật giữa nhiều điệp viên, quan chức chính phủ, và những tay buôn bán phụ nữ quốc tế.',
    popularity: 10.363,
    poster_path:
      'https://image.tmdb.org/t/p/w342/qRawsllFDrNlzUpcvuVxiy4w9AT.jpg',
    production_companies: [
      {
        id: 235,
        logo_path: '/obOynoztBEhDNfHsDXBqOuQLAZk.png',
        name: 'Nordisk Film',
        origin_country: 'DK',
      },
      {
        id: 4606,
        logo_path: '/otZHbf1HmzLRQsZFSqJXkf8EHz7.png',
        name: 'ZDF',
        origin_country: 'DE',
      },
      {
        id: 33821,
        logo_path: '/fygjYD07KphyW2zrcpFxk1J2SzE.png',
        name: 'Film Capital Stockholm',
        origin_country: 'SE',
      },
      {
        id: 33822,
        logo_path: null,
        name: 'Spiltan Underhållning',
        origin_country: 'SE',
      },
      {
        id: 2302,
        logo_path: '/rPXEdpqwFycAY9ZgrAJXv13qcWW.png',
        name: 'Svenska Filminstitutet',
        origin_country: 'SE',
      },
      {
        id: 2999,
        logo_path: '/zGSqFee9aDgDuLD6vcs2mcJUem4.png',
        name: 'SVT',
        origin_country: 'SE',
      },
      {
        id: 2801,
        logo_path: '/bswb1PLLsKDUXMLgy42bZtCtIde.png',
        name: 'Film i Väst',
        origin_country: 'SE',
      },
    ],
    production_countries: [
      { iso_3166_1: 'DK', name: 'Denmark' },
      { iso_3166_1: 'DE', name: 'Germany' },
      { iso_3166_1: 'SE', name: 'Sweden' },
    ],
    release_date: '2009-09-18',
    revenue: 67126795,
    runtime: 130,
    spoken_languages: [
      { english_name: 'Swedish', iso_639_1: 'sv', name: 'svenska' },
      { english_name: 'Italian', iso_639_1: 'it', name: 'Italiano' },
      { english_name: 'French', iso_639_1: 'fr', name: 'Français' },
    ],
    status: 'Đã phát hành',
    tagline: 'Fight Fire with Fire',
    title: 'Cô Gái Đùa Với Lửa',
    video: false,
    vote_average: 7.0,
    vote_count: 1305,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Girl Who Played With Fire - US TRAILER',
          key: 'oSsodK7KFXQ',
          published_at: '2010-06-18T20:48:47.000Z',
          site: 'YouTube',
          size: 720,
          type: 'Trailer',
          official: true,
          id: '5605a2a592514167ee000491',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 6283,
          known_for_department: 'Diễn viên',
          name: 'Michael Nyqvist',
          original_name: 'Michael Nyqvist',
          popularity: 3.625,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ycMhmLinY7v3DABqYy0CL92BG27.jpg',
          cast_id: 2,
          character: 'Mikael Blomkvist',
          credit_id: '52fe448cc3a368484e029195',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 87722,
          known_for_department: 'Diễn viên',
          name: 'Noomi Rapace',
          original_name: 'Noomi Rapace',
          popularity: 10.077,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vdlUULsiwxEgxTwxn3vVQqmolcx.jpg',
          cast_id: 1,
          character: 'Lisbeth Salander',
          credit_id: '52fe448cc3a368484e029191',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 79196,
          known_for_department: 'Diễn viên',
          name: 'Lena Endre',
          original_name: 'Lena Endre',
          popularity: 3.102,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hWrqTNGRnXNhAIuVkOyxIhyCW1I.jpg',
          cast_id: 3,
          character: 'Erika Berger',
          credit_id: '52fe448cc3a368484e029199',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 21193,
          known_for_department: 'Diễn viên',
          name: 'Peter Andersson',
          original_name: 'Peter Andersson',
          popularity: 2.116,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5VDByR9Px3uiLcDknCdYVhjQVOb.jpg',
          cast_id: 5,
          character: 'Nils Bjurman',
          credit_id: '52fe448cc3a368484e0291a1',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 79270,
          known_for_department: 'Diễn viên',
          name: 'Annika Hallin',
          original_name: 'Annika Hallin',
          popularity: 2.28,
          profile_path:
            'https://image.tmdb.org/t/p/w185/w0xkKmLS2AeXKB6HqrUqeq5LzRC.jpg',
          cast_id: 6,
          character: 'Annika Giannini',
          credit_id: '52fe448cc3a368484e0291a5',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 3855,
          known_for_department: 'Diễn viên',
          name: 'Per Oscarsson',
          original_name: 'Per Oscarsson',
          popularity: 1.805,
          profile_path:
            'https://image.tmdb.org/t/p/w185/i4FaiiFHlJoYg0HzmQKEqazOdQX.jpg',
          cast_id: 8,
          character: 'Holger Palmgren',
          credit_id: '52fe448cc3a368484e0291ad',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 83899,
          known_for_department: 'Diễn viên',
          name: 'Sofia Ledarp',
          original_name: 'Sofia Ledarp',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rvUygwmSbc2K8Gv4x6PnCaJWUE0.jpg',
          cast_id: 4,
          character: 'Malin Erikson',
          credit_id: '52fe448cc3a368484e02919d',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 92644,
          known_for_department: 'Diễn viên',
          name: 'Micke Spreitz',
          original_name: 'Micke Spreitz',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vasKc6dnUcZo7JLHEH7g7CEvtzC.jpg',
          cast_id: 7,
          character: 'Ronald Niedermann',
          credit_id: '52fe448cc3a368484e0291a9',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 92645,
          known_for_department: 'Diễn viên',
          name: 'Georgi Staykov',
          original_name: 'Georgi Staykov',
          popularity: 1.702,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yfuP7Xfa0W0GxwZ9H9dlWHjF2c1.jpg',
          cast_id: 9,
          character: 'Alexander Zalachenko',
          credit_id: '52fe448cc3a368484e0291b1',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 929148,
          known_for_department: 'Diễn viên',
          name: 'Paolo Roberto',
          original_name: 'Paolo Roberto',
          popularity: 0.656,
          profile_path: null,
          cast_id: 18,
          character: 'Himself',
          credit_id: '53d4e67d0e0a262844003c38',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 234908,
          known_for_department: 'Diễn viên',
          name: 'Yasmine Garbi',
          original_name: 'Yasmine Garbi',
          popularity: 1.116,
          profile_path:
            'https://image.tmdb.org/t/p/w185/c0ulgB8hp2AvGEkpborqm9zLF2g.jpg',
          cast_id: 19,
          character: "Miriam 'Mimmi' Wu",
          credit_id: '53d4e6b80e0a262838003cac',
          order: 10,
        },
        {
          adult: false,
          gender: 1,
          id: 106659,
          known_for_department: 'Diễn viên',
          name: 'Tanja Lorentzon',
          original_name: 'Tanja Lorentzon',
          popularity: 0.813,
          profile_path:
            'https://image.tmdb.org/t/p/w185/v7uJtpsGfm8xXq4BAVcXDeyWMEK.jpg',
          cast_id: 21,
          character: 'Sonja Modig',
          credit_id: '53d4e875c3a3686b85003792',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 143391,
          known_for_department: 'Diễn viên',
          name: 'Magnus Krepper',
          original_name: 'Magnus Krepper',
          popularity: 1.328,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cqU3AACOth0ZdW3eIFyg4k6AWik.jpg',
          cast_id: 22,
          character: 'Hans Faste',
          credit_id: '53d4e89dc3a3686b910038f8',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 114580,
          known_for_department: 'Diễn viên',
          name: 'Ralph Carlsson',
          original_name: 'Ralph Carlsson',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dOrCf2eP4Na05klroiCmPhZk5l3.jpg',
          cast_id: 23,
          character: 'Gunnar Björk',
          credit_id: '53d4e8cbc3a3686b940036d8',
          order: 14,
        },
        {
          adult: false,
          gender: 0,
          id: 1042033,
          known_for_department: 'Diễn viên',
          name: 'Hans-Christian Thulin',
          original_name: 'Hans-Christian Thulin',
          popularity: 0.6,
          profile_path: null,
          cast_id: 24,
          character: 'Dag Svensson',
          credit_id: '53d4e921c3a3686b91003909',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 92897,
          known_for_department: 'Diễn viên',
          name: 'Michalis Koutsogiannakis',
          original_name: 'Michalis Koutsogiannakis',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/i0SPzpHpQRi4gfqDk8tGYQ6t289.jpg',
          cast_id: 25,
          character: 'Dragan Armanskij',
          credit_id: '53d4e954c3a3686b850037ab',
          order: 16,
        },
        {
          adult: false,
          gender: 0,
          id: 1040615,
          known_for_department: 'Diễn viên',
          name: 'Sunil Munshi',
          original_name: 'Sunil Munshi',
          popularity: 0.6,
          profile_path: null,
          cast_id: 51,
          character: 'Dr. Sivarnandan',
          credit_id: '57767e99925141038800085f',
          order: 17,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 0,
          id: 19352,
          known_for_department: 'Sound',
          name: 'Jacob Groth',
          original_name: 'Jacob Groth',
          popularity: 0.6,
          profile_path: null,
          credit_id: '533544bfc3a3682abb0044bf',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 2,
          id: 55889,
          known_for_department: 'Editing',
          name: 'Mattias Morheden',
          original_name: 'Mattias Morheden',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5530da33c3a3684121001888',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 68572,
          known_for_department: 'Camera',
          name: 'Peter Mokrosinski',
          original_name: 'Peter Mokrosinski',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5530da19c3a368411200196e',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 73799,
          known_for_department: 'Biên kịch',
          name: 'Stieg Larsson',
          original_name: 'Stieg Larsson',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8jp75MOmmNBlluQJciu9VIS29kY.jpg',
          credit_id: '52fe448cc3a368484e0291c3',
          department: 'Biên kịch',
          job: 'Novel',
        },
        {
          adult: false,
          gender: 2,
          id: 76325,
          known_for_department: 'Directing',
          name: 'Daniel Alfredson',
          original_name: 'Daniel Alfredson',
          popularity: 0.972,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bqHaJq7pqDIgOAptCfJEsiaAIlN.jpg',
          credit_id: '52fe448cc3a368484e0291b7',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 92646,
          known_for_department: 'Biên kịch',
          name: 'Jonas Frykberg',
          original_name: 'Jonas Frykberg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe448cc3a368484e0291bd',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 557759,
          known_for_department: 'Diễn viên',
          name: 'Kimmo Rajala',
          original_name: 'Kimmo Rajala',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jkAWBWKOFQfdAMRqxTxGs7jmjJ7.jpg',
          credit_id: '5530dca2c3a3684125001a53',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 563330,
          known_for_department: 'Sound',
          name: 'Niels Arild Nielsen',
          original_name: 'Niels Arild Nielsen',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5530dc1d92514150ab00194b',
          department: 'Sound',
          job: 'Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 577400,
          known_for_department: 'Production',
          name: 'Søren Stærmose',
          original_name: 'Søren Stærmose',
          popularity: 1.382,
          profile_path: null,
          credit_id: '5335445dc3a3682aac004440',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 927979,
          known_for_department: 'Visual Effects',
          name: 'Martin Madsen',
          original_name: 'Martin Madsen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5530dc4a92514150b80017ca',
          department: 'Visual Effects',
          job: 'Visual Effects',
        },
        {
          adult: false,
          gender: 2,
          id: 1003008,
          known_for_department: 'Production',
          name: 'Mikael Wallen',
          original_name: 'Mikael Wallen',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wfiXcJqrSjaWgEXSdc9rc0IJYrd.jpg',
          credit_id: '6180ebd10d5d857647eb8cfe',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1033481,
          known_for_department: 'Costume & Make-Up',
          name: 'Cilla Rörby',
          original_name: 'Cilla Rörby',
          popularity: 0.6,
          profile_path: null,
          credit_id: '533544d7c3a3682a940045a4',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1102110,
          known_for_department: 'Art',
          name: 'Jan Olof Ågren',
          original_name: 'Jan Olof Ågren',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5530da72c3a3684112001983',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1305251,
          known_for_department: 'Production',
          name: 'Tusse Lande',
          original_name: 'Tusse Lande',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5335447ec3a3682abb0044af',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 1316933,
          known_for_department: 'Sound',
          name: 'Andreas Kongsgaard',
          original_name: 'Andreas Kongsgaard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5530dbd2c3a3680a94001658',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1392614,
          known_for_department: 'Sound',
          name: 'James Shannon',
          original_name: 'James Shannon',
          popularity: 1.62,
          profile_path: null,
          credit_id: '5530db6d92514150a30018dd',
          department: 'Sound',
          job: 'Dolby Consultant',
        },
        {
          adult: false,
          gender: 0,
          id: 1395761,
          known_for_department: 'Visual Effects',
          name: 'Sean Wheelan',
          original_name: 'Sean Wheelan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5530dc73c3a36841210018f4',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1398918,
          known_for_department: 'Sound',
          name: 'Andrea King',
          original_name: 'Andrea King',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5530dba0c3a36841120019bc',
          department: 'Sound',
          job: 'Foley',
        },
        {
          adult: false,
          gender: 0,
          id: 1455301,
          known_for_department: 'Art',
          name: 'Maria Håård',
          original_name: 'Maria Håård',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5530da5c92514150ae001938',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 1455302,
          known_for_department: 'Crew',
          name: 'Love Larson',
          original_name: 'Love Larson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5530daafc3a36841250019fd',
          department: 'Crew',
          job: 'Makeup Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1455303,
          known_for_department: 'Crew',
          name: 'Doreen Möllerström',
          original_name: 'Doreen Möllerström',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5530dad1c3a3680a94001625',
          department: 'Crew',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 2,
          id: 1455304,
          known_for_department: 'Sound',
          name: 'Per Nyström',
          original_name: 'Per Nyström',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5530db3292514150ae001963',
          department: 'Editing',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1455305,
          known_for_department: 'Sound',
          name: 'Nalle Hansen',
          original_name: 'Nalle Hansen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5530dc0592514150a90018f7',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1455309,
          known_for_department: 'Camera',
          name: 'Knut K. Pedersen',
          original_name: 'Knut K. Pedersen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5530dcbd92514150ae0019b7',
          department: 'Camera',
          job: 'Steadicam Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1455310,
          known_for_department: 'Camera',
          name: 'Knut Koivisto',
          original_name: 'Knut Koivisto',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5530dcd292514150ab00196c',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 1,
          id: 1455311,
          known_for_department: 'Directing',
          name: 'Lotta Westberg',
          original_name: 'Lotta Westberg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5530dd20c3a368412100190e',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1455312,
          known_for_department: 'Production',
          name: 'Maria Billberg',
          original_name: 'Maria Billberg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5530dd3792514150b10018d0',
          department: 'Production',
          job: 'Location Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1455313,
          known_for_department: 'Production',
          name: 'Martin Strömberg',
          original_name: 'Martin Strömberg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5530dd5692514150b10018d7',
          department: 'Production',
          job: 'Publicist',
        },
        {
          adult: false,
          gender: 0,
          id: 1455316,
          known_for_department: 'Costume & Make-Up',
          name: 'Jenny Fred',
          original_name: 'Jenny Fred',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5530da99c3a368411e00180c',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 1,
          id: 1455317,
          known_for_department: 'Sound',
          name: 'Camilla Mauritzson Skjaerbaek',
          original_name: 'Camilla Mauritzson Skjaerbaek',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5530db4a92514150b100186d',
          department: 'Editing',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1455318,
          known_for_department: 'Sound',
          name: 'Torben Greve',
          original_name: 'Torben Greve',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5530db8792514150b80017a3',
          department: 'Sound',
          job: 'Foley',
        },
        {
          adult: false,
          gender: 0,
          id: 1455320,
          known_for_department: 'Visual Effects',
          name: 'Ruslan Ogorodnik',
          original_name: 'Ruslan Ogorodnik',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5530dc8792514150ae0019a7',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1455321,
          known_for_department: 'Lighting',
          name: 'Björn Becker',
          original_name: 'Björn Becker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5530dce7c3a3680f42000f09',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 1,
          id: 3186890,
          known_for_department: 'Production',
          name: 'Anna Hedenmo',
          original_name: 'Anna Hedenmo',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2OJwSYh8IKM6yE1hxtwMuhGWY4K.jpg',
          credit_id: '61acfa1815dea00064bb3a80',
          department: 'Crew',
          job: 'Thanks',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/3ZORgdbK8wglKL8Vb4KTl465BfJ.jpg',
    belongs_to_collection: null,
    budget: 11000000,
    genres: [{ id: 35, name: 'Phim Hài' }],
    homepage: 'https://www.fightingwithmyfamily.movie/home',
    id: 445629,
    imdb_id: 'tt6513120',
    original_language: 'en',
    original_title: 'Fighting with My Family',
    overview:
      'Fighting with My Family kể về cuộc đời và sự nghiệp của Saraya “Paige” Bevis - một cô gái sinh ra, lớn lên trong gia đình có truyền thống đô vật, sau đó trở nên vượt trội hơn cả cha mẹ và anh trai mình. Để rồi sau này, cô trở thành một trong những nữ đô vật lừng lẫy nhất của lịch sử WWE.',
    popularity: 22.904,
    poster_path:
      'https://image.tmdb.org/t/p/w342/fU4UrY5tTAYAXIzFs7oR9BK5Cqx.jpg',
    production_companies: [
      {
        id: 10339,
        logo_path: '/oiIi36MaWXwvvHWX5eojoE2Fiyv.png',
        name: 'WWE Studios',
        origin_country: 'US',
      },
      {
        id: 11581,
        logo_path: '/6K0xgnlb35PU31T2IH3deVGvTlX.png',
        name: 'Misher Films',
        origin_country: 'US',
      },
      {
        id: 73669,
        logo_path: '/7tmSGstK3KwgcDIuBYLTAayjit9.png',
        name: 'Seven Bucks Productions',
        origin_country: 'US',
      },
      {
        id: 6705,
        logo_path: '/e8EXNSfwr5E9d3TR8dHKbQnQK4W.png',
        name: 'Film4 Productions',
        origin_country: 'GB',
      },
      {
        id: 28275,
        logo_path: '/b6VatRipyJYN52xLAV7TtzJtuXv.png',
        name: 'The Ink Factory',
        origin_country: 'GB',
      },
      {
        id: 21,
        logo_path: '/aOWKh4gkNrfFZ3Ep7n0ckPhoGb5.png',
        name: 'Metro-Goldwyn-Mayer',
        origin_country: 'US',
      },
    ],
    production_countries: [
      { iso_3166_1: 'GB', name: 'United Kingdom' },
      { iso_3166_1: 'US', name: 'Hoa Kì' },
    ],
    release_date: '2019-02-14',
    revenue: 39055536,
    runtime: 108,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'A comedy about a family that fights a little differently.',
    title: 'Gia Đình Đại Chiến',
    video: false,
    vote_average: 6.8,
    vote_count: 1243,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'FIGHTING WITH MY FAMILY | Final Trailer | MGM',
          key: 'G-gx3y4d4Rw',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2019-02-18T05:44:51.000Z',
          id: '5cc94c3cc3a36820b5898321',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'FIGHTING WITH MY FAMILY | Official Trailer | MGM',
          key: 'WqF3VTv0cqU',
          published_at: '2018-11-14T14:15:22.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '5beedaed0e0a262666019352',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Rock gives Florence Pugh & Jack Lowden some tips in Fighting With My Family | Film4 Clip',
          key: 'Mh4zSZHhEeo',
          published_at: '2018-04-11T09:43:33.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: true,
          id: '5ace422ac3a3687e4804eb45',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 1373737,
          known_for_department: 'Diễn viên',
          name: 'Florence Pugh',
          original_name: 'Florence Pugh',
          popularity: 24.385,
          profile_path:
            'https://image.tmdb.org/t/p/w185/75PvULemW8BvheSKtPMoBBsvPLh.jpg',
          cast_id: 3,
          character: "Saraya 'Paige' Knight",
          credit_id: '58befee4c3a368668f0587a5',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 4937,
          known_for_department: 'Diễn viên',
          name: 'Vince Vaughn',
          original_name: 'Vince Vaughn',
          popularity: 5.741,
          profile_path:
            'https://image.tmdb.org/t/p/w185/A9fJ88dfXZGpgFTnQIK0bOtjMrj.jpg',
          cast_id: 4,
          character: 'Hutch Morgan',
          credit_id: '58befef1c3a368668f0587af',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 11109,
          known_for_department: 'Diễn viên',
          name: 'Nick Frost',
          original_name: 'Nick Frost',
          popularity: 3.776,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2CHS4t6miNGLgMQAjhFqb4fFuKS.jpg',
          cast_id: 1,
          character: "Patrick 'Rowdy Ricky' Knight",
          credit_id: '58befece925141340701a6af',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 17286,
          known_for_department: 'Diễn viên',
          name: 'Lena Headey',
          original_name: 'Lena Headey',
          popularity: 12.264,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xR2IBnBlUdyBe5hecaVdtRuQqUE.jpg',
          cast_id: 0,
          character: "Julia 'Sweet Saraya' Knight",
          credit_id: '58befec392514160840689df',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 1334638,
          known_for_department: 'Diễn viên',
          name: 'Jack Lowden',
          original_name: 'Jack Lowden',
          popularity: 4.199,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5bW2477C2Rc4tCpCjyKFITMXOAt.jpg',
          cast_id: 2,
          character: "Zak 'Zodiac' Knight",
          credit_id: '58befed9c3a3680df801967f',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 18918,
          known_for_department: 'Diễn viên',
          name: 'Dwayne Johnson',
          original_name: 'Dwayne Johnson',
          popularity: 23.478,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kuqFzlYMc2IrsOyPznMd1FroeGq.jpg',
          cast_id: 6,
          character: "Dwayne 'The Rock' Johnson",
          credit_id: '58beff059251416084068a2b',
          order: 5,
        },
        {
          adult: false,
          gender: 0,
          id: 1300637,
          known_for_department: 'Diễn viên',
          name: 'Aqueela Zoll',
          original_name: 'Aqueela Zoll',
          popularity: 1.704,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cvN1Bg4uEoBzCA03jjyHPtbzkNg.jpg',
          cast_id: 8,
          character: 'Kirsten',
          credit_id: '58beff0fc3a3680db1019af1',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 39189,
          known_for_department: 'Diễn viên',
          name: 'Stephen Merchant',
          original_name: 'Stephen Merchant',
          popularity: 8.634,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6WM2rK6390Nwk398syJbGcPvRct.jpg',
          cast_id: 31,
          character: 'Hugh',
          credit_id: '5c63afa99251417df4fa2aa8',
          order: 7,
        },
        {
          adult: false,
          gender: 0,
          id: 85068,
          known_for_department: 'Diễn viên',
          name: 'James Burrows',
          original_name: 'James Burrows',
          popularity: 0.756,
          profile_path:
            'https://image.tmdb.org/t/p/w185/khRHAVO5gfd8Q2QIbU0DQqBCaMC.jpg',
          cast_id: 47,
          character: 'Roy Knight',
          credit_id: '5cc9825d9251416e1ef36172',
          order: 8,
        },
        {
          adult: false,
          gender: 1,
          id: 1766862,
          known_for_department: 'Diễn viên',
          name: 'Hannah Rae',
          original_name: 'Hannah Rae',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/A9JWPpfEld7LhgSkTu1Ux7Rogrz.jpg',
          cast_id: 28,
          character: 'Courtney',
          credit_id: '58d1d918c3a36838c9013cc0',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 1040469,
          known_for_department: 'Diễn viên',
          name: 'Kim Matula',
          original_name: 'Kim Matula',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2lO9zABJNFx1C50D8zVhdAX9Ho2.jpg',
          cast_id: 12,
          character: 'Jeri-Lynn',
          credit_id: '58beff75c3a368668f058833',
          order: 10,
        },
        {
          adult: false,
          gender: 1,
          id: 1836,
          known_for_department: 'Diễn viên',
          name: 'Julia Davis',
          original_name: 'Julia Davis',
          popularity: 2.517,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wsUNCSKoNQTgSdlr9FIeIR6hRAd.jpg',
          cast_id: 34,
          character: 'Daphne',
          credit_id: '5c6b2b849251412a74ff5339',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 1531459,
          known_for_department: 'Diễn viên',
          name: 'Thea Trinidad',
          original_name: 'Thea Trinidad',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uMNtGBn4UtVqz8Ds4DMCd7qy9GR.jpg',
          cast_id: 79,
          character: 'AJ Lee',
          credit_id: '5ff514feb5bc21003d25c1ca',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 151042,
          known_for_department: 'Diễn viên',
          name: 'Paul Wight',
          original_name: 'Paul Wight',
          popularity: 4.306,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yIAgFD1jNJeSbarAEisGvRVaE5E.jpg',
          cast_id: 32,
          character: 'Big Show',
          credit_id: '5c63afcf0e0a262fa195800f',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 237746,
          known_for_department: 'Diễn viên',
          name: 'Stephen Farrelly',
          original_name: 'Stephen Farrelly',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3QEksVcpGbmBruNb3K1zO4FK0S4.jpg',
          cast_id: 35,
          character: 'Sheamus',
          credit_id: '5c6b2c4e0e0a261e069bd5f3',
          order: 14,
        },
        {
          adult: false,
          gender: 1,
          id: 2301521,
          known_for_department: 'Diễn viên',
          name: 'Tori Ellen Ross',
          original_name: 'Tori Ellen Ross',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mMgXzHI2s0m3auv80BwmzzL11ph.jpg',
          cast_id: 38,
          character: 'Young Paige',
          credit_id: '5cc94fc49251412ba1011365',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 2301519,
          known_for_department: 'Diễn viên',
          name: 'Thomas Whilley',
          original_name: 'Thomas Whilley',
          popularity: 0.707,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uJZetbFwQVERWYh6r5BZVsOm8od.jpg',
          cast_id: 37,
          character: 'Young Zak',
          credit_id: '5cc94f919251416e1ef317d0',
          order: 16,
        },
        {
          adult: false,
          gender: 2,
          id: 237740,
          known_for_department: 'Diễn viên',
          name: 'Mike Mizanin',
          original_name: 'Mike Mizanin',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yNjNFZsJjxQd4OpSphniIQZPcYI.jpg',
          cast_id: 78,
          character: 'The Miz',
          credit_id: '5f65427d5a78840033b1ee12',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 238321,
          known_for_department: 'Diễn viên',
          name: 'Jerry Lawler',
          original_name: 'Jerry Lawler',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/Auyl90q3zrakIgaTWQd0GPyW58i.jpg',
          cast_id: 54,
          character: 'Jerry Lawler',
          credit_id: '5d351d6dcaab6d1640aed25b',
          order: 18,
        },
        {
          adult: false,
          gender: 2,
          id: 1104687,
          known_for_department: 'Diễn viên',
          name: 'Michael Coulthard',
          original_name: 'Michael Coulthard',
          popularity: 1.176,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3qjpTtY7RqsbYIHN3XMkN8JGtmS.jpg',
          cast_id: 53,
          character: 'Michael Coulthard',
          credit_id: '5d351d612f8d095259e0838a',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 1170013,
          known_for_department: 'Diễn viên',
          name: 'John Layfield',
          original_name: 'John Layfield',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6gvi8L7xdMdE8J61oHHib69Iq1u.jpg',
          cast_id: 55,
          character: 'JBL',
          credit_id: '5d351d77caab6d1640aed26e',
          order: 20,
        },
        {
          adult: false,
          gender: 1,
          id: 1428998,
          known_for_department: 'Diễn viên',
          name: 'Julia Hamer-Bevis',
          original_name: 'Julia Hamer-Bevis',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4O7J3G2XPC89frjJdekjtCzD81k.jpg',
          cast_id: 58,
          character: 'Self (archive)',
          credit_id: '5d351dc3140bad0011922f58',
          order: 21,
        },
        {
          adult: false,
          gender: 0,
          id: 2368096,
          known_for_department: 'Diễn viên',
          name: 'Patrick Bevis',
          original_name: 'Patrick Bevis',
          popularity: 0.6,
          profile_path: null,
          cast_id: 57,
          character: 'Self (archive)',
          credit_id: '5d351dad2f8d097bccd5376f',
          order: 22,
        },
        {
          adult: false,
          gender: 0,
          id: 2368098,
          known_for_department: 'Diễn viên',
          name: 'Zak Bevis',
          original_name: 'Zak Bevis',
          popularity: 0.98,
          profile_path: null,
          cast_id: 59,
          character: 'Self (archive)',
          credit_id: '5d351de1befb090011b83a85',
          order: 23,
        },
        {
          adult: false,
          gender: 0,
          id: 1704853,
          known_for_department: 'Diễn viên',
          name: 'Olivia Bernstone',
          original_name: 'Olivia Bernstone',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7rQGrzEHEZ7iBIrlVzbBDIIhnvP.jpg',
          cast_id: 39,
          character: 'Ellie',
          credit_id: '5cc97d380e0a267f78f2d86a',
          order: 24,
        },
        {
          adult: false,
          gender: 1,
          id: 1765346,
          known_for_department: 'Diễn viên',
          name: 'Leah Harvey',
          original_name: 'Leah Harvey',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/j5bEw0gtE9RGTq2y4WoQ6HUa9di.jpg',
          cast_id: 10,
          character: 'Hannah',
          credit_id: '58beff63c3a3680df8019705',
          order: 25,
        },
        {
          adult: false,
          gender: 0,
          id: 2301680,
          known_for_department: 'Diễn viên',
          name: 'Mohammad Amiri',
          original_name: 'Mohammad Amiri',
          popularity: 0.6,
          profile_path: null,
          cast_id: 40,
          character: 'Ez',
          credit_id: '5cc97fbd92514151ca0b25ac',
          order: 26,
        },
        {
          adult: false,
          gender: 1,
          id: 1636470,
          known_for_department: 'Diễn viên',
          name: 'Christine Ozanne',
          original_name: 'Christine Ozanne',
          popularity: 0.6,
          profile_path: null,
          cast_id: 41,
          character: 'Old Lady',
          credit_id: '5cc980099251417ea6f2e91b',
          order: 27,
        },
        {
          adult: false,
          gender: 1,
          id: 2301681,
          known_for_department: 'Diễn viên',
          name: 'Grace Link',
          original_name: 'Grace Link',
          popularity: 0.6,
          profile_path: null,
          cast_id: 42,
          character: 'Townie #1',
          credit_id: '5cc980250e0a266f04ec8a7d',
          order: 28,
        },
        {
          adult: false,
          gender: 1,
          id: 2301682,
          known_for_department: 'Diễn viên',
          name: 'Hannah Dodd',
          original_name: 'Hannah Dodd',
          popularity: 1.094,
          profile_path:
            'https://image.tmdb.org/t/p/w185/55KfjaxQJClbl6pEcPMKHDle4Jj.jpg',
          cast_id: 43,
          character: 'Townie #2',
          credit_id: '5cc980469251410855f2f7a4',
          order: 29,
        },
        {
          adult: false,
          gender: 2,
          id: 2301683,
          known_for_department: 'Diễn viên',
          name: 'Jack Gouldbourne',
          original_name: 'Jack Gouldbourne',
          popularity: 0.6,
          profile_path: null,
          cast_id: 44,
          character: 'Calum',
          credit_id: '5cc980630e0a2678a0f407ed',
          order: 30,
        },
        {
          adult: false,
          gender: 0,
          id: 2301685,
          known_for_department: 'Diễn viên',
          name: 'Elroy Powell',
          original_name: 'Elroy Powell',
          popularity: 1.01,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zU9SQPENMJVBaqNnMJImXvveDw5.jpg',
          cast_id: 45,
          character: 'Union Jack',
          credit_id: '5cc980a29251417ea6f2e97f',
          order: 31,
        },
        {
          adult: false,
          gender: 0,
          id: 1771684,
          known_for_department: 'Diễn viên',
          name: 'Ellie Gonsalves',
          original_name: 'Ellie Gonsalves',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/g7MFtBgdHohaZao9wpM4DNBt94o.jpg',
          cast_id: 9,
          character: 'Madison',
          credit_id: '58beff21c3a368663006016d',
          order: 32,
        },
        {
          adult: false,
          gender: 0,
          id: 1429000,
          known_for_department: 'Diễn viên',
          name: 'Roy Bevis',
          original_name: 'Roy Bevis',
          popularity: 1.4,
          profile_path: null,
          cast_id: 46,
          character: 'Cage Match Wrestler',
          credit_id: '5cc9814092514151ca0b27ab',
          order: 33,
        },
        {
          adult: false,
          gender: 2,
          id: 108310,
          known_for_department: 'Diễn viên',
          name: 'Brendon Burns',
          original_name: 'Brendon Burns',
          popularity: 1.214,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ylbtyxqalZWkbnJsrlTKYxoHdTi.jpg',
          cast_id: 48,
          character: 'MC',
          credit_id: '5cc982d19251415cd2ff2480',
          order: 34,
        },
        {
          adult: false,
          gender: 0,
          id: 1869587,
          known_for_department: 'Diễn viên',
          name: 'Ciaran Dowd',
          original_name: 'Ciaran Dowd',
          popularity: 0.6,
          profile_path: null,
          cast_id: 49,
          character: 'Heckler',
          credit_id: '5cc982f90e0a266f04ec8f34',
          order: 35,
        },
        {
          adult: false,
          gender: 0,
          id: 1109987,
          known_for_department: 'Diễn viên',
          name: 'Josh Myers',
          original_name: 'Josh Myers',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5BD8lkmIJuZ4TOc5k34GgOzNr1j.jpg',
          cast_id: 50,
          character: 'Bruiser',
          credit_id: '5cc9834092514119e5f94d06',
          order: 36,
        },
        {
          adult: false,
          gender: 0,
          id: 1429003,
          known_for_department: 'Diễn viên',
          name: 'Zak Knight',
          original_name: 'Zak Knight',
          popularity: 0.6,
          profile_path: null,
          cast_id: 51,
          character: 'Gang Lieutenant',
          credit_id: '5cc983700e0a267f78f2e8b5',
          order: 37,
        },
        {
          adult: false,
          gender: 0,
          id: 2267724,
          known_for_department: 'Diễn viên',
          name: 'Rod Zapata',
          original_name: 'Rod Zapata',
          popularity: 0.6,
          profile_path: null,
          cast_id: 52,
          character: 'Referee',
          credit_id: '5cc983cc0e0a263743f300da',
          order: 38,
        },
        {
          adult: false,
          gender: 1,
          id: 995457,
          known_for_department: 'Diễn viên',
          name: 'Chloe Csengery',
          original_name: 'Chloe Csengery',
          popularity: 2.744,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jEXZlunoXQv1SVXVmCnRwZj4auv.jpg',
          cast_id: 29,
          character: 'Ally - Goth Teen (uncredited)',
          credit_id: '58d1d92ac3a36838f9013492',
          order: 39,
        },
        {
          adult: false,
          gender: 0,
          id: 1771687,
          known_for_department: 'Diễn viên',
          name: 'Chris Albright',
          original_name: 'Chris Albright',
          popularity: 0.98,
          profile_path: null,
          cast_id: 11,
          character: 'WWE RAW Fan (uncredited)',
          credit_id: '58beff6b925141609b066141',
          order: 40,
        },
        {
          adult: false,
          gender: 1,
          id: 1326321,
          known_for_department: 'Diễn viên',
          name: 'Saraya-Jade Bevis',
          original_name: 'Saraya-Jade Bevis',
          popularity: 2.744,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ohU0nlR5PHvih4nfDK8P4s7iQGH.jpg',
          cast_id: 56,
          character: 'Paige (archive)',
          credit_id: '5d351d9c2f8d097db9d36921',
          order: 41,
        },
        {
          adult: false,
          gender: 2,
          id: 56446,
          known_for_department: 'Diễn viên',
          name: 'John Cena',
          original_name: 'John Cena',
          popularity: 7.932,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rgB2eIOt7WyQjdgJCOuESdDlrjg.jpg',
          cast_id: 36,
          character: 'John Cena (archive)',
          credit_id: '5c6b2c90c3a3684fabe716fd',
          order: 42,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 1251,
          known_for_department: 'Camera',
          name: 'Remi Adefarasin',
          original_name: 'Remi Adefarasin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d4351d57719d70014646f2c',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 1,
          id: 2635,
          known_for_department: 'Production',
          name: 'Shaheen Baig',
          original_name: 'Shaheen Baig',
          popularity: 0.778,
          profile_path: null,
          credit_id: '58bf0034925141606b069184',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 11351,
          known_for_department: 'Sound',
          name: 'James Mather',
          original_name: 'James Mather',
          popularity: 0.6,
          profile_path: null,
          credit_id: '613119bafbe36f002ac06ed1',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 40769,
          known_for_department: 'Sound',
          name: 'David Mackie',
          original_name: 'David Mackie',
          popularity: 0.98,
          profile_path: null,
          credit_id: '61311a43ab68490042c07c22',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 40827,
          known_for_department: 'Sound',
          name: 'Peter Clarke',
          original_name: 'Peter Clarke',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qY6xd5homtmeeUlFZaTj6jrAzej.jpg',
          credit_id: '61311a66f056d5009036e7a2',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 18918,
          known_for_department: 'Diễn viên',
          name: 'Dwayne Johnson',
          original_name: 'Dwayne Johnson',
          popularity: 23.478,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kuqFzlYMc2IrsOyPznMd1FroeGq.jpg',
          credit_id: '5d43524095c0af0015da4783',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 39189,
          known_for_department: 'Diễn viên',
          name: 'Stephen Merchant',
          original_name: 'Stephen Merchant',
          popularity: 8.634,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6WM2rK6390Nwk398syJbGcPvRct.jpg',
          credit_id: '58beff96925141606b0690e4',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 39189,
          known_for_department: 'Diễn viên',
          name: 'Stephen Merchant',
          original_name: 'Stephen Merchant',
          popularity: 8.634,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6WM2rK6390Nwk398syJbGcPvRct.jpg',
          credit_id: '5d43522795c0af0016da3c61',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 39189,
          known_for_department: 'Diễn viên',
          name: 'Stephen Merchant',
          original_name: 'Stephen Merchant',
          popularity: 8.634,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6WM2rK6390Nwk398syJbGcPvRct.jpg',
          credit_id: '58beffa292514132a201aaae',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 57343,
          known_for_department: 'Production',
          name: 'Kevin Misher',
          original_name: 'Kevin Misher',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pZI2kJyR1aIGLJUb2Oeoi5QgA5t.jpg',
          credit_id: '58beffbcc3a3680db1019b8b',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 67846,
          known_for_department: 'Editing',
          name: 'Nancy Richardson',
          original_name: 'Nancy Richardson',
          popularity: 0.636,
          profile_path: null,
          credit_id: '5d4352cf7719d700136474a8',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 66572,
          known_for_department: 'Costume & Make-Up',
          name: 'Matthew Price',
          original_name: 'Matthew Price',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d4353107719d74809622059',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 2,
          id: 166278,
          known_for_department: 'Diễn viên',
          name: 'Andy Berman',
          original_name: 'Andy Berman',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9n7h50lDhZCXwiYqbviLit9uLP5.jpg',
          credit_id: '5994479492514151b1001f14',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 223762,
          known_for_department: 'Directing',
          name: 'Ralph E. Portillo',
          original_name: 'Ralph E. Portillo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d43520995c0af0015da4743',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 564964,
          known_for_department: 'Production',
          name: 'Jamie Elliott',
          original_name: 'Jamie Elliott',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d4351eb676ce20016a1a747',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1013112,
          known_for_department: 'Production',
          name: 'Sarada McDermott',
          original_name: 'Sarada McDermott',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58befffa925141126a04acee',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1039217,
          known_for_department: 'Production',
          name: 'Dany Garcia',
          original_name: 'Dany Garcia',
          popularity: 5.613,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nZnQuskqDYmm9BDfsgRjDyVakCR.jpg',
          credit_id: '5d435233676ce20017a1aad4',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1153021,
          known_for_department: 'Art',
          name: 'Christina Eunji Kim',
          original_name: 'Christina Eunji Kim',
          popularity: 1.009,
          profile_path: null,
          credit_id: '5d4352e5676ce20014a1ac21',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1335562,
          known_for_department: 'Sound',
          name: 'Jed Loughran',
          original_name: 'Jed Loughran',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61311a29ab6849005f7fa194',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1337412,
          known_for_department: 'Sound',
          name: 'Jason Swanscott',
          original_name: 'Jason Swanscott',
          popularity: 1.4,
          profile_path: null,
          credit_id: '61311b2584591c0029845df5',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 1355962,
          known_for_department: 'Sound',
          name: 'Tim Hands',
          original_name: 'Tim Hands',
          popularity: 0.6,
          profile_path: null,
          credit_id: '613119d4d207f3008f49a9a7',
          department: 'Sound',
          job: 'ADR Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1355962,
          known_for_department: 'Sound',
          name: 'Tim Hands',
          original_name: 'Tim Hands',
          popularity: 0.6,
          profile_path: null,
          credit_id: '613119e11fb94f006489aaa8',
          department: 'Sound',
          job: 'Supervising Dialogue Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1357600,
          known_for_department: 'Directing',
          name: 'Julia Chiavetta',
          original_name: 'Julia Chiavetta',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6131147033ad8f006540ee59',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1373711,
          known_for_department: 'Sound',
          name: 'Ben Meechan',
          original_name: 'Ben Meechan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5eee363fb344090031ba26a2',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1377410,
          known_for_department: 'Production',
          name: 'Michael J. Luisi',
          original_name: 'Michael J. Luisi',
          popularity: 0.728,
          profile_path: null,
          credit_id: '58beffb2c3a368668f058877',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1391526,
          known_for_department: 'Sound',
          name: 'Michael Wabro',
          original_name: 'Michael Wabro',
          popularity: 0.6,
          profile_path: null,
          credit_id: '613119f6fbe36f0065c51891',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1395024,
          known_for_department: 'Sound',
          name: 'Mike Prestwood Smith',
          original_name: 'Mike Prestwood Smith',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61311990fbe36f0065c5177d',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1405686,
          known_for_department: 'Art',
          name: 'Ellie Pash',
          original_name: 'Ellie Pash',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d435301676ce20014a1ac5d',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 1411668,
          known_for_department: 'Sound',
          name: 'Arran Mahoney',
          original_name: 'Arran Mahoney',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61311acee25860002cca445a',
          department: 'Sound',
          job: 'Foley Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1419731,
          known_for_department: 'Sound',
          name: 'Jay Duerr',
          original_name: 'Jay Duerr',
          popularity: 0.98,
          profile_path: null,
          credit_id: '61311a7c7f6c8d008a745f73',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1428555,
          known_for_department: 'Art',
          name: 'Roy Chapman',
          original_name: 'Roy Chapman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '613117b5e1faed002ab4fc1b',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 1430188,
          known_for_department: 'Camera',
          name: 'Simon Finney',
          original_name: 'Simon Finney',
          popularity: 1.186,
          profile_path: null,
          credit_id: '61311bf0c1ffbd002b9b9137',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1451721,
          known_for_department: 'Costume & Make-Up',
          name: 'Lillie Zohdy',
          original_name: 'Lillie Zohdy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '613118ca39549a004341a8a3',
          department: 'Costume & Make-Up',
          job: 'Makeup & Hair',
        },
        {
          adult: false,
          gender: 0,
          id: 1466097,
          known_for_department: 'Production',
          name: 'Hiram Garcia',
          original_name: 'Hiram Garcia',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58beffe2c3a3680d6801814c',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1477593,
          known_for_department: 'Costume & Make-Up',
          name: 'Mimi Milburn-Foster',
          original_name: 'Mimi Milburn-Foster',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6131183cfbe36f009225409e',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1482854,
          known_for_department: 'Sound',
          name: 'Vik Sharma',
          original_name: 'Vik Sharma',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d4352bd95c0af0016da3d70',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 0,
          id: 1492088,
          known_for_department: 'Production',
          name: 'David Kosse',
          original_name: 'David Kosse',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d43529e7719d74809621f1f',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1526984,
          known_for_department: 'Costume & Make-Up',
          name: 'Mary Cooke',
          original_name: 'Mary Cooke',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61311c57d207f300649da99f',
          department: 'Costume & Make-Up',
          job: 'Makeup & Hair',
        },
        {
          adult: false,
          gender: 0,
          id: 1535968,
          known_for_department: 'Art',
          name: 'Gareth Cousins',
          original_name: 'Gareth Cousins',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d4352f295c0af0016da3db8',
          department: 'Art',
          job: 'Supervising Art Director',
        },
        {
          adult: false,
          gender: 1,
          id: 1564100,
          known_for_department: 'Costume & Make-Up',
          name: 'Jutta Russell',
          original_name: 'Jutta Russell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61311c80ab68490042c080b5',
          department: 'Costume & Make-Up',
          job: 'Makeup & Hair',
        },
        {
          adult: false,
          gender: 0,
          id: 1603863,
          known_for_department: 'Biên kịch',
          name: 'Nick Palmer',
          original_name: 'Nick Palmer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58bf003d925141343501a0cb',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1635163,
          known_for_department: 'Crew',
          name: 'Miranda Jones',
          original_name: 'Miranda Jones',
          popularity: 0.6,
          profile_path: null,
          credit_id: '613113ef7f6c8d0043f4aa30',
          department: 'Crew',
          job: 'Post Production Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1746704,
          known_for_department: 'Sound',
          name: 'Sarah Bridge',
          original_name: 'Sarah Bridge',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6131141c357c000043e95e33',
          department: 'Sound',
          job: 'Music Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1763566,
          known_for_department: 'Camera',
          name: 'Robert Viglasky',
          original_name: 'Robert Viglasky',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61311b981fb94f002ba46f5e',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 0,
          id: 1771688,
          known_for_department: 'Production',
          name: 'David Pelech',
          original_name: 'David Pelech',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58bf001a9251416077068a72',
          department: 'Production',
          job: 'Associate Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1772295,
          known_for_department: 'Camera',
          name: 'Josh Close',
          original_name: 'Josh Close',
          popularity: 0.6,
          profile_path: null,
          credit_id: '613116f7fbe36f0092253ecd',
          department: 'Camera',
          job: 'Key Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1824254,
          known_for_department: 'Camera',
          name: 'Rene Adefarasin',
          original_name: 'Rene Adefarasin',
          popularity: 0.828,
          profile_path: null,
          credit_id: '6131165d1fb94f004470e028',
          department: 'Camera',
          job: 'First Assistant "A" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1824255,
          known_for_department: 'Camera',
          name: 'Ben Adefarasin',
          original_name: 'Ben Adefarasin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6131166deb0932008db1e14b',
          department: 'Camera',
          job: 'First Assistant "B" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1853859,
          known_for_department: 'Camera',
          name: 'Stéphane Renard',
          original_name: 'Stéphane Renard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6198bbf763536a006194cd23',
          department: 'Camera',
          job: 'First Assistant "A" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1942725,
          known_for_department: 'Editing',
          name: 'Pablo Prietto',
          original_name: 'Pablo Prietto',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61311956e258600042b55d80',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1950514,
          known_for_department: 'Production',
          name: 'Daniel Battsek',
          original_name: 'Daniel Battsek',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d43527ad8cc4a0e8c33b67a',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1955502,
          known_for_department: 'Lighting',
          name: 'Ian Barwick',
          original_name: 'Ian Barwick',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61311723f794ad00617e48c1',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 1,
          id: 1980587,
          known_for_department: 'Costume & Make-Up',
          name: 'Raqueli Dahan',
          original_name: 'Raqueli Dahan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6115a11aa76ac5005c9fd4b7',
          department: 'Costume & Make-Up',
          job: 'Makeup Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 2030154,
          known_for_department: 'Directing',
          name: 'Maria Aguilar',
          original_name: 'Maria Aguilar',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61311536f0647c002af1ff20',
          department: 'Crew',
          job: 'Floor Runner',
        },
        {
          adult: false,
          gender: 0,
          id: 2088310,
          known_for_department: 'Camera',
          name: 'Tom Carpenter',
          original_name: 'Tom Carpenter',
          popularity: 0.6,
          profile_path: null,
          credit_id: '613116ddf0647c0088eab1bd',
          department: 'Camera',
          job: 'Camera Trainee',
        },
        {
          adult: false,
          gender: 0,
          id: 2094864,
          known_for_department: 'Sound',
          name: 'Martin Beresford',
          original_name: 'Martin Beresford',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6131190f33ad8f00431b93ff',
          department: 'Sound',
          job: 'Production Sound Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 2107191,
          known_for_department: 'Camera',
          name: 'Kriss Dallimore',
          original_name: 'Kriss Dallimore',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61311681c1ffbd008b5e7e51',
          department: 'Camera',
          job: 'Second Assistant "A" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2137686,
          known_for_department: 'Diễn viên',
          name: 'Rhodri Thomas',
          original_name: 'Rhodri Thomas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d4352ac676ce20018a1aa2c',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2146235,
          known_for_department: 'Production',
          name: 'Nancy Bray',
          original_name: 'Nancy Bray',
          popularity: 0.6,
          profile_path: null,
          credit_id: '613113991fb94f008e4a9c3c',
          department: 'Production',
          job: 'Unit Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 2151549,
          known_for_department: 'Art',
          name: 'Dan Marsden',
          original_name: 'Dan Marsden',
          popularity: 0.6,
          profile_path: null,
          credit_id: '613117ea357c000091193075',
          department: 'Art',
          job: 'Construction Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 2160767,
          known_for_department: 'Camera',
          name: 'Tim Battersby',
          original_name: 'Tim Battersby',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6131162dfac502004270c039',
          department: 'Camera',
          job: 'Steadicam Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 2160770,
          known_for_department: 'Camera',
          name: 'Neil McConville',
          original_name: 'Neil McConville',
          popularity: 0.6,
          profile_path: null,
          credit_id: '613116aef0647c002af202a0',
          department: 'Camera',
          job: 'Second Assistant "B" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2342323,
          known_for_department: 'Production',
          name: 'Sarah Carswell',
          original_name: 'Sarah Carswell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '613115b1d207f300441653b0',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2370501,
          known_for_department: 'Art',
          name: 'Sophie Powell',
          original_name: 'Sophie Powell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6131178e33ad8f00431b9179',
          department: 'Art',
          job: 'Graphic Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2376509,
          known_for_department: 'Production',
          name: 'Tracey Josephs',
          original_name: 'Tracey Josephs',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d435292d8cc4a0013360f42',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2414778,
          known_for_department: 'Costume & Make-Up',
          name: 'Laura Blount',
          original_name: 'Laura Blount',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61311c436a3448002c197563',
          department: 'Costume & Make-Up',
          job: 'Makeup & Hair',
        },
        {
          adult: false,
          gender: 0,
          id: 2424363,
          known_for_department: 'Production',
          name: 'Michelle Giovanni',
          original_name: 'Michelle Giovanni',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61311b52e38bd800436c60f3',
          department: 'Production',
          job: 'Casting Associate',
        },
        {
          adult: false,
          gender: 0,
          id: 2880148,
          known_for_department: 'Costume & Make-Up',
          name: 'Rosie Stoward',
          original_name: 'Rosie Stoward',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6131180ff056d50029811663',
          department: 'Costume & Make-Up',
          job: 'Assistant Costume Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3170409,
          known_for_department: 'Directing',
          name: 'Sam Dawking',
          original_name: 'Sam Dawking',
          popularity: 0.6,
          profile_path: null,
          credit_id: '613113cae1faed0042ef69f4',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 3220367,
          known_for_department: 'Production',
          name: 'Emma Niamh Mitchell',
          original_name: 'Emma Niamh Mitchell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '613115841fb94f002ba462d6',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 3220368,
          known_for_department: 'Production',
          name: 'Jordan Lees',
          original_name: 'Jordan Lees',
          popularity: 0.6,
          profile_path: null,
          credit_id: '613115dee2586000629d1220',
          department: 'Production',
          job: 'Production Runner',
        },
        {
          adult: false,
          gender: 0,
          id: 3220369,
          known_for_department: 'Production',
          name: 'Emma Jane Richards',
          original_name: 'Emma Jane Richards',
          popularity: 0.6,
          profile_path: null,
          credit_id: '613116027f6c8d0043f4aeb3',
          department: 'Production',
          job: 'Location Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 3220373,
          known_for_department: 'Art',
          name: 'Meg Witts',
          original_name: 'Meg Witts',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61311768e25860002cca3dbb',
          department: 'Art',
          job: 'Assistant Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 3220389,
          known_for_department: 'Costume & Make-Up',
          name: 'Suzanne David',
          original_name: 'Suzanne David',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61311889c1ffbd008b5e82f1',
          department: 'Costume & Make-Up',
          job: 'Hair Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 3220389,
          known_for_department: 'Costume & Make-Up',
          name: 'Suzanne David',
          original_name: 'Suzanne David',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6131187eab68490087083496',
          department: 'Costume & Make-Up',
          job: 'Makeup Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 3220390,
          known_for_department: 'Costume & Make-Up',
          name: 'Alice Schneidau',
          original_name: 'Alice Schneidau',
          popularity: 0.6,
          profile_path: null,
          credit_id: '613118e839549a00611d5ff0',
          department: 'Costume & Make-Up',
          job: 'Makeup & Hair',
        },
        {
          adult: false,
          gender: 0,
          id: 3220401,
          known_for_department: 'Sound',
          name: 'Clare Mahoney',
          original_name: 'Clare Mahoney',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61311af484591c0087d622c9',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 3220402,
          known_for_department: 'Camera',
          name: 'Fabio Affuso',
          original_name: 'Fabio Affuso',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61311b7df056d500633ea7d8',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 0,
          id: 3220403,
          known_for_department: 'Camera',
          name: 'Ray Burmiston',
          original_name: 'Ray Burmiston',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61311bac39549a00844ef6fb',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 0,
          id: 3220407,
          known_for_department: 'Costume & Make-Up',
          name: 'Fiona Chaffey',
          original_name: 'Fiona Chaffey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61311c667f6c8d008a746455',
          department: 'Costume & Make-Up',
          job: 'Makeup & Hair',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'Gimly',
          author_details: {
            name: 'Gimly',
            username: 'Ruuz',
            avatar_path: '/xUObnJSvHrFPsIpoDmb1jiQZLq7.jpg',
            rating: 6.0,
          },
          content:
            "Not really a Wrestling movie so much as it is a character study that may or may not be remotely accurate. I don't feel like I walked away from _Fighting with My Family_ with a greater appreciation for the sport, but I did feel like I understood how the core cast felt about it.\r\n\r\n_Final rating:★★★ - I liked it. Would personally recommend you give it a _",
          created_at: '2019-06-10T10:29:33.539Z',
          id: '5cfe310dc3a368445b1e7b36',
          updated_at: '2021-06-23T15:58:23.115Z',
          url: 'https://www.themoviedb.org/review/5cfe310dc3a368445b1e7b36',
        },
      ],
      total_pages: 1,
      total_results: 1,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/qfB3KR6AuRI3Sqz8jWAOpRaGC0H.jpg',
    belongs_to_collection: null,
    budget: 250300,
    genres: [
      { id: 35, name: 'Phim Hài' },
      { id: 18, name: 'Phim Chính Kịch' },
    ],
    homepage: 'https://a24films.com/films/the-farewell',
    id: 565310,
    imdb_id: 'tt8637428',
    original_language: 'en',
    original_title: 'The Farewell',
    overview:
      'Lời từ biệt (The Farewell) kể câu chuyện “cười ra nước mắt” theo đúng nghĩa đen về một đại gia đình đông đúc. Cả gia đình của Bili từ New York quay trở về Trung Quốc để tham dự một đám cưới giả - cái cớ để cho cả đại gia đình được đoàn tụ khi biết tin người bà của mình chỉ còn vài tuần để sống. Trong khi đó, bà lại là người duy nhất hoàn toàn không biết đến căn ác bệnh của mình.',
    popularity: 11.545,
    poster_path:
      'https://image.tmdb.org/t/p/w342/7ht2IMGynDSVQGvAXhAb83DLET8.jpg',
    production_companies: [
      {
        id: 188,
        logo_path: '/4ZJKsMZ049ElLEtz8QZKGATXNAq.png',
        name: 'Big Beach',
        origin_country: 'US',
      },
      {
        id: 1473,
        logo_path: null,
        name: 'Depth of Field',
        origin_country: 'US',
      },
      {
        id: 118246,
        logo_path: '/d8vi9AHv2rB9DbYGvVHzljbgKos.png',
        name: 'Kindred Spirit',
        origin_country: 'US',
      },
      {
        id: 146336,
        logo_path: null,
        name: 'Seesaw Productions',
        origin_country: 'CN',
      },
    ],
    production_countries: [
      { iso_3166_1: 'CN', name: 'Trung Quốc' },
      { iso_3166_1: 'US', name: 'Hoa Kì' },
    ],
    release_date: '2019-07-12',
    revenue: 22110994,
    runtime: 100,
    spoken_languages: [
      { english_name: 'Mandarin', iso_639_1: 'zh', name: '普通话' },
      { english_name: 'Nhật Bảnese', iso_639_1: 'ja', name: '日本語' },
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'Based on an actual lie.',
    title: 'Lời Từ Biệt',
    video: false,
    vote_average: 7.5,
    vote_count: 1031,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'THE FAREWELL | Official Trailer HD | A24',
          key: 'RofpAjqwMa8',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2019-05-07T13:00:00.000Z',
          id: '5cd187d19251417be128de5f',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 1625558,
          known_for_department: 'Diễn viên',
          name: 'Awkwafina',
          original_name: 'Awkwafina',
          popularity: 21.01,
          profile_path:
            'https://image.tmdb.org/t/p/w185/l5AKkg3H1QhMuXmTTmq1EyjyiRb.jpg',
          cast_id: 0,
          character: 'Billi',
          credit_id: '5bff4cad9251417e2e00097b',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 21629,
          known_for_department: 'Diễn viên',
          name: 'Tzi Ma',
          original_name: 'Tzi Ma',
          popularity: 3.348,
          profile_path:
            'https://image.tmdb.org/t/p/w185/x4fz0LCIiBNGdil3nBYO22W7QJ0.jpg',
          cast_id: 3,
          character: 'Haiyan',
          credit_id: '5c0fc0d9c3a36825280e0dc7',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 2309752,
          known_for_department: 'Diễn viên',
          name: 'Diana Lin',
          original_name: 'Diana Lin',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yus3vnVL3y1Pvw3jGpb5vM2IXVl.jpg',
          cast_id: 27,
          character: 'Jian',
          credit_id: '5cd607aa0e0a262e03cabd2c',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 2309757,
          known_for_department: 'Diễn viên',
          name: 'Zhao Shuzhen',
          original_name: 'Zhao Shuzhen',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5TZ2HxavUaQCjUiZiQot5oNF74C.jpg',
          cast_id: 31,
          character: 'Nai Nai',
          credit_id: '5cd6096b92514106f8cd824a',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 2309910,
          known_for_department: 'Diễn viên',
          name: 'Jiang Yongbo',
          original_name: 'Jiang Yongbo',
          popularity: 0.6,
          profile_path: null,
          cast_id: 35,
          character: 'Haibin',
          credit_id: '5cd695af92514111dece1696',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 2193208,
          known_for_department: 'Diễn viên',
          name: 'Gil Perez-Abraham',
          original_name: 'Gil Perez-Abraham',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/obJ2pGNaRJ8mtIEPshw3ocIfcIj.jpg',
          cast_id: 15,
          character: 'Tony (uncredited)',
          credit_id: '5c0fc7fbc3a36825230d89b3',
          order: 6,
        },
        {
          adult: false,
          gender: 0,
          id: 1491421,
          known_for_department: 'Diễn viên',
          name: 'Ines Laimins',
          original_name: 'Ines Laimins',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2Ehk5fLLxxwf4jhoaWjoSgUWTMT.jpg',
          cast_id: 28,
          character: 'Kathy',
          credit_id: '5cd607ee92514106eecd8131',
          order: 7,
        },
        {
          adult: false,
          gender: 0,
          id: 2309754,
          known_for_department: 'Diễn viên',
          name: 'Jim Liu',
          original_name: 'Jim Liu',
          popularity: 0.6,
          profile_path: null,
          cast_id: 29,
          character: 'Doctor Song',
          credit_id: '5cd6083ac3a36817c0c01f00',
          order: 8,
        },
        {
          adult: false,
          gender: 0,
          id: 2267887,
          known_for_department: 'Diễn viên',
          name: 'X Mayo',
          original_name: 'X Mayo',
          popularity: 0.6,
          profile_path: null,
          cast_id: 30,
          character: 'Suz',
          credit_id: '5cd60869c3a36817cec01c66',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 2309759,
          known_for_department: 'Diễn viên',
          name: 'Aoi Mizuhara',
          original_name: 'Aoi Mizuhara',
          popularity: 0.6,
          profile_path: null,
          cast_id: 32,
          character: 'Aiko',
          credit_id: '5cd6099cc3a36817cec01d6b',
          order: 10,
        },
        {
          adult: false,
          gender: 0,
          id: 2309762,
          known_for_department: 'Diễn viên',
          name: 'Han Chen',
          original_name: 'Han Chen',
          popularity: 0.6,
          profile_path: null,
          cast_id: 33,
          character: 'Haohao',
          credit_id: '5cd609ff0e0a262defcac7e4',
          order: 11,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 3288,
          known_for_department: 'Production',
          name: 'Chris Weitz',
          original_name: 'Chris Weitz',
          popularity: 1.341,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4HONbwCefKNKBXafRRjXZN00wJE.jpg',
          credit_id: '5d44f00e0f2fbd766bed1ee3',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 4855,
          known_for_department: 'Production',
          name: 'Peter Saraf',
          original_name: 'Peter Saraf',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cd605f9c3a36817cec01970',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 4857,
          known_for_department: 'Production',
          name: 'Marc Turtletaub',
          original_name: 'Marc Turtletaub',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cd605d70e0a262df5cac1a4',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 45584,
          known_for_department: 'Production',
          name: 'Andrew Miano',
          original_name: 'Andrew Miano',
          popularity: 0.84,
          profile_path: null,
          credit_id: '5d44eff82d1e401ecbbe0e81',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 57176,
          known_for_department: 'Editing',
          name: 'Matthew Friedman',
          original_name: 'Matthew Friedman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cd606a592514106eecd7fc7',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 148740,
          known_for_department: 'Sound',
          name: 'Gene Park',
          original_name: 'Gene Park',
          popularity: 0.6,
          profile_path: null,
          credit_id: '609fe5f7ed2ac200419a302c',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 232158,
          known_for_department: 'Sound',
          name: 'Susan Jacobs',
          original_name: 'Susan Jacobs',
          popularity: 0.605,
          profile_path: null,
          credit_id: '609fe5bde635710059758ec0',
          department: 'Sound',
          job: 'Music Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 569737,
          known_for_department: 'Editing',
          name: 'Michael Taylor',
          original_name: 'Michael Taylor',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7jV1hc1x22f1XtZmJPthTUhNkqu.jpg',
          credit_id: '5cd6068792514106eecd7fbc',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1085600,
          known_for_department: 'Production',
          name: 'Leslie Woo',
          original_name: 'Leslie Woo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d44f05da0be280015a14ea0',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 1361591,
          known_for_department: 'Production',
          name: 'Eddie Rubin',
          original_name: 'Eddie Rubin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d44f0012d1e403b45bdf093',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1371324,
          known_for_department: 'Directing',
          name: 'Lulu Wang',
          original_name: 'Lulu Wang',
          popularity: 0.676,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ufhvyvzLhKuAEZdfbPxS97Ti1WZ.jpg',
          credit_id: '5cd605a8c3a36817c6c0241d',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 1,
          id: 1371324,
          known_for_department: 'Directing',
          name: 'Lulu Wang',
          original_name: 'Lulu Wang',
          popularity: 0.676,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ufhvyvzLhKuAEZdfbPxS97Ti1WZ.jpg',
          credit_id: '5c70201c9251411c66c1a8c2',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 1,
          id: 1371324,
          known_for_department: 'Directing',
          name: 'Lulu Wang',
          original_name: 'Lulu Wang',
          popularity: 0.676,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ufhvyvzLhKuAEZdfbPxS97Ti1WZ.jpg',
          credit_id: '5cd605ba0e0a262df9cac4c9',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1404274,
          known_for_department: 'Costume & Make-Up',
          name: 'Jackie Zbuska',
          original_name: 'Jackie Zbuska',
          popularity: 0.6,
          profile_path: null,
          credit_id: '617c2aad5aba32002950ece7',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1497843,
          known_for_department: 'Production',
          name: 'Daniele Tate Melia',
          original_name: 'Daniele Tate Melia',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d44efeea0be280018a154a1',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1539990,
          known_for_department: 'Sound',
          name: 'Ric Schnupp',
          original_name: 'Ric Schnupp',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/AjJjCuP1sHIkYch92muQ7le4fzy.jpg',
          credit_id: '617c2ad2a097dc00427f3ffe',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1555322,
          known_for_department: 'Visual Effects',
          name: 'Vico Sharabani',
          original_name: 'Vico Sharabani',
          popularity: 1.214,
          profile_path: null,
          credit_id: '5d44f0a4a0be280018a1563f',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1601638,
          known_for_department: 'Art',
          name: 'Lee Yong-ok',
          original_name: 'Lee Yong-ok',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/amsHaGAGtiiMyqL3CsRqS9bd8WW.jpg',
          credit_id: '5cd606dbc3a36817d2c01a39',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1851278,
          known_for_department: 'Production',
          name: 'Jane Zheng',
          original_name: 'Jane Zheng',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d44f01c0f2fbd7674ed2d85',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1881033,
          known_for_department: 'Production',
          name: 'Dan Balgoyen',
          original_name: 'Dan Balgoyen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d44efcfa0be280016a14899',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1973280,
          known_for_department: 'Visual Effects',
          name: 'John J. Budion',
          original_name: 'John J. Budion',
          popularity: 0.6,
          profile_path: null,
          credit_id: '617c2b01d388ae0043ec3e96',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 2023244,
          known_for_department: 'Visual Effects',
          name: 'Asaf Yeger',
          original_name: 'Asaf Yeger',
          popularity: 0.6,
          profile_path: null,
          credit_id: '617c2af0cb6db5008d4492fa',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 2023244,
          known_for_department: 'Visual Effects',
          name: 'Asaf Yeger',
          original_name: 'Asaf Yeger',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d44f0ae2d1e40349abde9cf',
          department: 'Visual Effects',
          job: 'Special Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2078508,
          known_for_department: 'Production',
          name: 'Anita Gou',
          original_name: 'Anita Gou',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d44efe32d1e403b44bde72a',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2084138,
          known_for_department: 'Production',
          name: 'Joshua M. Cohen',
          original_name: 'Joshua M. Cohen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d44efd90f2fbd7674ed2d11',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2138112,
          known_for_department: 'Sound',
          name: 'Alex Weston',
          original_name: 'Alex Weston',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cd60657c3a36817d2c01991',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 0,
          id: 2193206,
          known_for_department: 'Camera',
          name: 'Anna Franquesa Solano',
          original_name: 'Anna Franquesa Solano',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cd6063292514106facd7996',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 2247793,
          known_for_department: 'Sound',
          name: 'Dylan Neely',
          original_name: 'Dylan Neely',
          popularity: 0.6,
          profile_path: null,
          credit_id: '609fe5cce18e3f0058dd7d9e',
          department: 'Sound',
          job: 'Music Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 2247794,
          known_for_department: 'Costume & Make-Up',
          name: 'Athena Wang',
          original_name: 'Athena Wang',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cd606fbc3a36817d7c018ec',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 0,
          id: 2377443,
          known_for_department: 'Art',
          name: 'W. Haley Ho',
          original_name: 'W. Haley Ho',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d44f0732d1e401ecbbe0f69',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 2377444,
          known_for_department: 'Art',
          name: 'Joseph Sorelle',
          original_name: 'Joseph Sorelle',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d44f0852d1e403b44bde833',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 2377445,
          known_for_department: 'Visual Effects',
          name: 'Joseph Grundfast',
          original_name: 'Joseph Grundfast',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d44f0baa0be280015a14f6a',
          department: 'Visual Effects',
          job: '3D Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 2826845,
          known_for_department: 'Art',
          name: 'Hanrui Wang',
          original_name: 'Hanrui Wang',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f9691586c0b3600330b3669',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 3091372,
          known_for_department: 'Production',
          name: 'Anne Kang',
          original_name: 'Anne Kang',
          popularity: 0.6,
          profile_path: null,
          credit_id: '609fe63f839018003fcde279',
          department: 'Production',
          job: 'Casting',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'Sheldon Nylander',
          author_details: {
            name: 'Sheldon Nylander',
            username: 'dalboz',
            avatar_path: '/d9fi8H0uBIhn9B9WY8Avo5L1vzm.jpg',
            rating: 8.0,
          },
          content:
            'When a Chinese family finds out that the family’s matriarch is dying of lung cancer, complications arise. In Chinese culture, there is a saying that when you get cancer, you die. This actually boils down to the belief that it’s not the cancer that leads to the person’s death, but rather the fear of dying. As such, the family orchestrates an elaborate ruse to get everyone together for a wedding, but in reality the gathering is for everyone to be able to say goodbye to the grandmother without actually letting her know the truth.\r\n\r\nIt’s a fascinating premise and based on a true story (or based on an actual lie, as the film puts it). Showing aspects of Chinese culture we rarely get to see, the film takes us on a journey to Trung Quốc as we see modern life and urban development. How accurate it really is, I can’t attest to, and there are times that it feels like there should be more or that something is more complex and we’re being given the fortune cookie version, so to speak. The film does steer clear of politics, so that is not a factor here.\r\n\r\nThis is a beautiful film not just through visual aesthetics but also on a character level. We see how each character faces the impending death of the grandmother differently, such as the daughter-in-law being very matter of fact about it while her husband (the grandmother’s son) is being torn up inside, all while the wise and experienced grandmother continues to dispense advice, oblivious to her diagnosis. It details the variety of relationships we can develop in our life as no two relationships are the same, but they all still love each other despite some distance between certain relatives. There’s something that, despite the comedic premise (it’s sort of a comedy that’s not particularly funny), is very grounded and very real. I couldn’t help but see some of my own relationships reflected on the screen.\r\n\r\nBeautiful, heartbreaking, and at the same time somewhat hopeful, “The Farewell” comes highly recommended.',
          created_at: '2019-11-13T09:39:50.305Z',
          id: '5dcbcf66cc277c0017dfe3c9',
          updated_at: '2021-06-23T15:58:28.989Z',
          url: 'https://www.themoviedb.org/review/5dcbcf66cc277c0017dfe3c9',
        },
        {
          author: 'msbreviews',
          author_details: {
            name: '',
            username: 'msbreviews',
            avatar_path:
              '/https://secure.gravatar.com/avatar/992eef352126a53d7e141bf9e8707576.jpg',
            rating: 8.0,
          },
          content:
            'If you enjoy reading my Spoiler-Free reviews, please follow my blog @\r\nhttps://www.msbreviews.com\r\n\r\nLulu Wang shares an emotional part of her personal life by delivering a beautiful, heartfelt story about her grandmother. Even though The Farewell sticks the landing perfectly, not all of the second act’s storylines captivated me, especially the whole wedding narrative. However, Awkwafina offers a fantastic performance, as well as the rest of the cast. Alex Weston’s score elevates a lot of moments, and the drama-comedy balance is on-point.\r\n\r\nRating: B+',
          created_at: '2020-02-05T11:52:58.318Z',
          id: '5e3aac9a0c2710001375954d',
          updated_at: '2021-06-23T15:58:33.774Z',
          url: 'https://www.themoviedb.org/review/5e3aac9a0c2710001375954d',
        },
        {
          author: 'Peter McGinn',
          author_details: {
            name: 'Peter McGinn',
            username: 'narrator56',
            avatar_path: '/tVbrLJzA2RwRlE7dJLJG54UsAkq.jpg',
            rating: 8.0,
          },
          content:
            'This movie is described as a comedy-drama and it is. But I didn’t have many laugh out loud moments. The humor is situational mainly: the writers work up to those moments that make you smile, either because you remember a similar moment in your life, or else because you can’t imagine a similar moment.\r\n\r\nAs happens so often, the story is based on real events. I saw where one review title said it is heartbreaking, but I didn’t see that at all. The movie is fairly uplifting in that it shows the strengths of a family that values all of its members, particularly the very old, whose wisdom and experience aren’t as well received in many American families.\r\n\r\nWhen I think about it, nothing definitive seems to happen in the film: no crisis, no climax of action, but this lack of great drama didn’t detract from enjoying the movie. It is all about the journey, not the destination. Enjoy the trip.',
          created_at: '2021-05-12T04:47:36.170Z',
          id: '609b5de88dbc33002997a56a',
          updated_at: '2021-06-23T15:58:55.780Z',
          url: 'https://www.themoviedb.org/review/609b5de88dbc33002997a56a',
        },
      ],
      total_pages: 1,
      total_results: 3,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/pJS6cZBDKkjh9zPno74EmPErdaw.jpg',
    belongs_to_collection: {
      id: 334996,
      name: 'Son of Batman Collection',
      poster_path: '/ze3Wnhbom7T37orabHMIiEGtoYF.jpg',
      backdrop_path: '/sVvEkTNx6SjwOb80iyURe5KHtcD.jpg',
    },
    budget: 0,
    genres: [
      { id: 878, name: 'Phim Khoa Học Viễn Tưởng' },
      { id: 80, name: 'Phim Hình Sự' },
      { id: 16, name: 'Phim Hoạt Hình' },
      { id: 9648, name: 'Phim Bí Ẩn' },
      { id: 28, name: 'Phim Hành Động' },
    ],
    homepage: 'https://www.warnerbros.com/movies/batman-hush',
    id: 537056,
    imdb_id: 'tt8752440',
    original_language: 'en',
    original_title: 'Batman: Hush',
    overview:
      'Chuyển thể từ một arc truyện cùng tên, nội dung phim xoay quanh việc Batman đối đầu với một tên ác nhân mới xuất hiện ở Gotham. Liệu Dơi và các đồng minh sẽ giải quyết như thế nào đây, khi mà dường như hắn đang điều khiển tất cả tội phạm của Gotham để thực hiện âm mưu của mình? Ngoài ra, Batman còn phải đối phó với một ả mèo nào đó...',
    popularity: 28.586,
    poster_path:
      'https://image.tmdb.org/t/p/w342/eiVQORVyVuNNZHPAELuWtlXoQsD.jpg',
    production_companies: [
      {
        id: 9993,
        logo_path: '/2Tc1P3Ac8M479naPp1kYT3izLS5.png',
        name: 'DC Entertainment',
        origin_country: 'US',
      },
      {
        id: 2785,
        logo_path: '/l5zW8jjmQOCx2dFmvnmbYmqoBmL.png',
        name: 'Warner Bros. Animation',
        origin_country: 'US',
      },
      {
        id: 429,
        logo_path: '/2Tc1P3Ac8M479naPp1kYT3izLS5.png',
        name: 'DC Comics',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2019-07-19',
    revenue: 0,
    runtime: 82,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Người Dơi: Ác Nhân Bí Ẩn',
    video: false,
    vote_average: 7.3,
    vote_count: 584,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Batman: Hush - Official Trailer',
          key: 'cQFFnUg0u70',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2019-05-17T13:00:12.000Z',
          id: '5cded210c3a36846bcc111bb',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 183812,
          known_for_department: 'Diễn viên',
          name: "Jason O'Mara",
          original_name: "Jason O'Mara",
          popularity: 3.884,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hYylPvwMALoQU09r7tvCU24thh0.jpg',
          cast_id: 2,
          character: 'Batman / Bruce Wayne (voice)',
          credit_id: '5c9bed5a0e0a265cec363d5c',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 41421,
          known_for_department: 'Diễn viên',
          name: 'Jennifer Morrison',
          original_name: 'Jennifer Morrison',
          popularity: 7.747,
          profile_path:
            'https://image.tmdb.org/t/p/w185/i6dkHIME0BOPhbcPESHZND3vmtk.jpg',
          cast_id: 3,
          character: 'Catwoman / Selina Kyle (voice)',
          credit_id: '5c9bed6d9251410a4e09bdcd',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 65726,
          known_for_department: 'Diễn viên',
          name: 'Maury Sterling',
          original_name: 'Maury Sterling',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dO9rd0F67Jt9hkcLw4CXERE9q1z.jpg',
          cast_id: 11,
          character: 'Thomas Elliot (voice)',
          credit_id: '5c9bedfd9251410a6009cf16',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 55148,
          known_for_department: 'Diễn viên',
          name: 'Sean Maher',
          original_name: 'Sean Maher',
          popularity: 2.021,
          profile_path:
            'https://image.tmdb.org/t/p/w185/o7splcOIVAdbHnwohJOUAvXWVlk.jpg',
          cast_id: 7,
          character: 'Nightwing / Dick Grayson (voice)',
          credit_id: '5c9bedaa0e0a265ce7363bfa',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 5375,
          known_for_department: 'Diễn viên',
          name: 'Geoffrey Arend',
          original_name: 'Geoffrey Arend',
          popularity: 1.369,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bpqF3V5lK5GxuIU4VuTaVaztIvw.jpg',
          cast_id: 12,
          character: 'The Riddler / Edward Nigma (voice)',
          credit_id: '5c9bee110e0a265ce7363cc6',
          order: 4,
        },
        {
          adult: false,
          gender: 0,
          id: 1338541,
          known_for_department: 'Diễn viên',
          name: 'James Garrett',
          original_name: 'James Garrett',
          popularity: 0.959,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aE1gtncxpAcRmxBJdQN89uoT0VI.jpg',
          cast_id: 10,
          character: 'Alfred Pennyworth (voice)',
          credit_id: '5c9beddb9251410a5809c59f',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 3035,
          known_for_department: 'Diễn viên',
          name: "Jerry O'Connell",
          original_name: "Jerry O'Connell",
          popularity: 5.563,
          profile_path:
            'https://image.tmdb.org/t/p/w185/p2zcFeDIKUrPrbT5ODqoLifdN3Q.jpg',
          cast_id: 4,
          character: 'Superman / Kal-El / Clark Kent (voice)',
          credit_id: '5c9bed7c9251410a4c09bd3f',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 11008,
          known_for_department: 'Diễn viên',
          name: 'Rebecca Romijn',
          original_name: 'Rebecca Romijn',
          popularity: 4.49,
          profile_path:
            'https://image.tmdb.org/t/p/w185/phmDee6OVdrQo0IJhvCmuDnudM5.jpg',
          cast_id: 5,
          character: 'Lois Lane (voice)',
          credit_id: '5c9bed8d9251410a5209bd75',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 79497,
          known_for_department: 'Diễn viên',
          name: 'Bruce Thomas',
          original_name: 'Bruce Thomas',
          popularity: 1.301,
          profile_path:
            'https://image.tmdb.org/t/p/w185/u3AjbSbgYaUPBgVXhr8SMkMaQ67.jpg',
          cast_id: 8,
          character: 'Jim Gordon (voice)',
          credit_id: '5c9bedbc9251410a5809c56e',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 11678,
          known_for_department: 'Diễn viên',
          name: 'Rainn Wilson',
          original_name: 'Rainn Wilson',
          popularity: 8.358,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rEDRAFYX5n2JKJh9EKILX42klA5.jpg',
          cast_id: 6,
          character: 'Lex Luthor (voice)',
          credit_id: '5c9bed9cc3a3680247bb1bc3',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 1254435,
          known_for_department: 'Diễn viên',
          name: 'Peyton List',
          original_name: 'Peyton List',
          popularity: 14.012,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5p8KwRgBUYVcKBKTYFdD30o6dAc.jpg',
          cast_id: 17,
          character: 'Batgirl / Barbara Gordon (voice)',
          credit_id: '5c9bee699251410a6c09bca7',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 1164238,
          known_for_department: 'Diễn viên',
          name: 'Stuart Allan',
          original_name: 'Stuart Allan',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xCAGTIcgC7J6YCl2bviIADY8blp.jpg',
          cast_id: 9,
          character: 'Robin / Damian Wayne (voice)',
          credit_id: '5c9bedc8c3a368024fbb1cb7',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 27011,
          known_for_department: 'Diễn viên',
          name: 'Vanessa Williams',
          original_name: 'Vanessa Williams',
          popularity: 4.288,
          profile_path:
            'https://image.tmdb.org/t/p/w185/30O1Af0wy6UBt8EpVRuq28tTGoT.jpg',
          cast_id: 31,
          character: 'Amanda Waller (voice)',
          credit_id: '5d32d4f12f8d095259da0320',
          order: 12,
        },
        {
          adult: false,
          gender: 1,
          id: 229031,
          known_for_department: 'Diễn viên',
          name: 'Peyton List',
          original_name: 'Peyton List',
          popularity: 3.754,
          profile_path:
            'https://image.tmdb.org/t/p/w185/b1rEqHlkyHwRtockTE7WQNLyu9t.jpg',
          cast_id: 29,
          character: 'Poison Ivy / Pamela Isley (voice)',
          credit_id: '5c9d8790c3a3686ef7ff75f3',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 216973,
          known_for_department: 'Diễn viên',
          name: 'Jason Spisak',
          original_name: 'Jason Spisak',
          popularity: 1.928,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yxIWLB5Yf2fIB2WyHd6WYB0MbHD.jpg',
          cast_id: 14,
          character: 'The Joker (voice)',
          credit_id: '5c9bee390e0a265cdf3639b7',
          order: 14,
        },
        {
          adult: false,
          gender: 1,
          id: 113919,
          known_for_department: 'Diễn viên',
          name: 'Hynden Walch',
          original_name: 'Hynden Walch',
          popularity: 2.623,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oFfZaFF1o724BuZ3cLK6tl9L03.jpg',
          cast_id: 30,
          character: 'Harley Quinn (voice)',
          credit_id: '5d1a6db9af95905200cd230b',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 1330895,
          known_for_department: 'Diễn viên',
          name: 'Adam Gifford',
          original_name: 'Adam Gifford',
          popularity: 1.265,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xKxNqO3LMdbpXFyxPsAR42BaDMP.jpg',
          cast_id: 15,
          character: 'Bane / Clayface (voice)',
          credit_id: '5c9bee470e0a265ce7363d0a',
          order: 16,
        },
        {
          adult: false,
          gender: 1,
          id: 2194211,
          known_for_department: 'Diễn viên',
          name: 'Sachie Alessio',
          original_name: 'Sachie Alessio',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7FC1qBvxEoK9DvDw0zo3bcDe7sW.jpg',
          cast_id: 16,
          character: 'Lady Shiva (voice)',
          credit_id: '5c9bee560e0a265cda364125',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 136930,
          known_for_department: 'Diễn viên',
          name: 'Chris Cox',
          original_name: 'Chris Cox',
          popularity: 3.347,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sdLuGpLB0g5AtEr9VVnAqtIbZPt.jpg',
          cast_id: 36,
          character: 'Scarecrow (voice)',
          credit_id: '5d32ddcc6a300b1834aa91d2',
          order: 18,
        },
        {
          adult: false,
          gender: 1,
          id: 15762,
          known_for_department: 'Diễn viên',
          name: 'Tara Strong',
          original_name: 'Tara Strong',
          popularity: 6.675,
          profile_path:
            'https://image.tmdb.org/t/p/w185/y9S3QzI3L5aARP8GYYO86rREKxU.jpg',
          cast_id: 18,
          character: 'Reporter (voice)',
          credit_id: '5c9bee76c3a3680249bb1d44',
          order: 19,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 10949,
          known_for_department: 'Production',
          name: 'Michael Uslan',
          original_name: 'Michael Uslan',
          popularity: 0.921,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cXiiH0SSk5UHCvHOVAhHX7tNuls.jpg',
          credit_id: '5c9bef04c3a368024fbb1e6a',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 10951,
          known_for_department: 'Production',
          name: 'Benjamin Melniker',
          original_name: 'Benjamin Melniker',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5c9beef2c3a368023bbb1d2d',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 34936,
          known_for_department: 'Biên kịch',
          name: 'Alan Burnett',
          original_name: 'Alan Burnett',
          popularity: 2.271,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3gNmuxxdQbZ6nX2F63SMQNVbmqz.jpg',
          credit_id: '5c9bef1f9251410a5409c225',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 17310,
          known_for_department: 'Production',
          name: 'Jeph Loeb',
          original_name: 'Jeph Loeb',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5b53725f9251411f7e013abe',
          department: 'Biên kịch',
          job: 'Comic Book',
        },
        {
          adult: false,
          gender: 2,
          id: 141043,
          known_for_department: 'Production',
          name: 'Sam Register',
          original_name: 'Sam Register',
          popularity: 0.722,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9K1RTX51GDbegrAhMeLQLSGyF3B.jpg',
          credit_id: '5c9beee5c3a3680249bb1dc1',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 150856,
          known_for_department: 'Biên kịch',
          name: 'James Krieg',
          original_name: 'James Krieg',
          popularity: 1.078,
          profile_path: null,
          credit_id: '5c9bef2dc3a368024fbb1e9d',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 207202,
          known_for_department: 'Diễn viên',
          name: 'Jim Lee',
          original_name: 'Jim Lee',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cgCv75VFYq1LH8f0DzzBBrFwUJn.jpg',
          credit_id: '5d32dcabcaab6d77939760cb',
          department: 'Biên kịch',
          job: 'Comic Book',
        },
        {
          adult: false,
          gender: 0,
          id: 544355,
          known_for_department: 'Sound',
          name: 'Frederik Wiedmann',
          original_name: 'Frederik Wiedmann',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d32dcf3caab6d1dfc9c0483',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 0,
          id: 1033619,
          known_for_department: 'Editing',
          name: 'Christopher D. Lozinski',
          original_name: 'Christopher D. Lozinski',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5d32dd18caab6d1dfc9c04e3',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1220905,
          known_for_department: 'Biên kịch',
          name: 'Ernie Altbacker',
          original_name: 'Ernie Altbacker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c9beec70e0a265cdf363a6b',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 1225820,
          known_for_department: 'Production',
          name: 'James Tucker',
          original_name: 'James Tucker',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hgHn9NOOryQYn6rODxcfraSIX0R.jpg',
          credit_id: '5c9beed70e0a265ce1363be7',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1641642,
          known_for_department: 'Production',
          name: 'Wes Gleason',
          original_name: 'Wes Gleason',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d32dd272f8d094522d8f9cd',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 1964180,
          known_for_department: 'Production',
          name: 'Amy McKenna',
          original_name: 'Amy McKenna',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c9bef110e0a265cd7363da4',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2103986,
          known_for_department: 'Production',
          name: 'Brian E.S. Jones',
          original_name: 'Brian E.S. Jones',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d32deb8caab6d7793976748',
          department: 'Production',
          job: 'Executive In Charge Of Production',
        },
        {
          adult: false,
          gender: 0,
          id: 2147116,
          known_for_department: 'Art',
          name: 'Phillip Bourassa',
          original_name: 'Phillip Bourassa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c9bef3d0e0a265cda3642d5',
          department: 'Visual Effects',
          job: 'Character Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2169044,
          known_for_department: 'Production',
          name: 'Matthew Mahoney',
          original_name: 'Matthew Mahoney',
          popularity: 1.473,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zrIJDfMD755hZq6qC9yHoVy7j45.jpg',
          credit_id: '5d32de41caab6d1dfc9c094f',
          department: 'Production',
          job: 'Associate Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2275503,
          known_for_department: 'Directing',
          name: 'Justin Copeland',
          original_name: 'Justin Copeland',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c9beeb69251410a6409cb4d',
          department: 'Directing',
          job: 'Director',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'Gimly',
          author_details: {
            name: 'Gimly',
            username: 'Ruuz',
            avatar_path: '/xUObnJSvHrFPsIpoDmb1jiQZLq7.jpg',
            rating: 7.0,
          },
          content:
            "It's been a while since DC has brought out something that's better than passing grade, but _Hush_ was honestly kind of great. Even with the pretty massive deviation from the source material.\r\n\r\n_Final rating:★★★½ - I really liked it. Would strongly recommend you give it your time._",
          created_at: '2019-08-25T04:46:38.463Z',
          id: '5d6212ae6dea3a001294f4f0',
          updated_at: '2021-06-23T15:58:25.737Z',
          url: 'https://www.themoviedb.org/review/5d6212ae6dea3a001294f4f0',
        },
        {
          author: 'JPV852',
          author_details: {
            name: '',
            username: 'JPV852',
            avatar_path: '/xNLOqXXVJf9m7WngUMLIMFsjKgh.jpg',
            rating: 6.0,
          },
          content:
            'Okay DC animated movie that has its moments, and nice animation, but as a fan of the original graphic novel, was a little disappointed, though not entirely surprised they went the route they did considering how much back story was involved with the source material, so changes had to be made. Still, was entertaining enough but not top tier amongst the DC Animated Universe.',
          created_at: '2019-08-28T22:29:39.957Z',
          id: '5d6700532790bf0011324d15',
          updated_at: '2021-06-23T15:58:26.089Z',
          url: 'https://www.themoviedb.org/review/5d6700532790bf0011324d15',
        },
      ],
      total_pages: 1,
      total_results: 2,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/fPGeS6jgdLovQAKunNHX8l0avCy.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 28, name: 'Phim Hành Động' },
      { id: 53, name: 'Phim Gây Cấn' },
    ],
    homepage: 'https://www.amazon.com/dp/B08VFD1Y3B',
    id: 567189,
    imdb_id: 'tt0499097',
    original_language: 'en',
    original_title: "Tom Clancy's Without Remorse",
    overview:
      'Cốt truyện của tác phẩm theo chân John Kelly, một đặc vụ SEAL của Hải quân Hoa Kỳ bắt đầu con đường trả thù sau khi người vợ đang mang thai của anh ta và các thành viên trong đơn vị bị sát hại bởi những kẻ sát nhân người Nga.  Anh ta phải hợp tác với đồng nghiệp cũng là hải quân SEAL Karen Greer ( Jodie Turner-Smith ) và đặc vụ CIA mờ ám Robert Ritter  ( Jamie Bell ). Kelly cố gắng tìm ra sự thật kẻ đứng đằng sau các vụ tấn công, trong quá trình điều tra, anh đã phát hiện ra âm mưu bí mật chắc chắn sẽ dẫn tới chiến tranh, Kelly phải chiến đấu với kẻ thù của mình để ngăn chặn những thảm hoạ sắp xảy ra.',
    popularity: 219.821,
    poster_path:
      'https://image.tmdb.org/t/p/w342/6GCOpT8QcNzup09TAMmvvk22LTR.jpg',
    production_companies: [
      {
        id: 433,
        logo_path: null,
        name: 'Weed Road Pictures',
        origin_country: 'US',
      },
      {
        id: 102334,
        logo_path: '/espa8KYmHedu5p7GRrP9FFICLUp.png',
        name: 'Outlier Society Productions',
        origin_country: 'US',
      },
      { id: 156809, logo_path: null, name: 'The Saw Mill', origin_country: '' },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2021-04-29',
    revenue: 0,
    runtime: 109,
    spoken_languages: [
      { english_name: 'Russian', iso_639_1: 'ru', name: 'Pусский' },
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'From the author of Rainbow Six.',
    title: 'Không Hối Tiếc',
    video: false,
    vote_average: 7.1,
    vote_count: 1730,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Eyes on the Target - Prison Fight',
          key: 'Q0YDgmZjKYI',
          site: 'YouTube',
          size: 1080,
          type: 'Behind the Scenes',
          official: true,
          published_at: '2021-04-28T15:00:26.000Z',
          id: '6089ca4b2dda89007a455d46',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Without Remorse - Tom Clancy Social Featurette',
          key: 'x5QCFxsk6B8',
          site: 'YouTube',
          size: 1080,
          type: 'Featurette',
          official: true,
          published_at: '2021-04-12T18:00:11.000Z',
          id: '6089c98e54508d0057977942',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Final Trailer',
          key: 'kRpkRkO9KUI',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2021-04-06T13:59:49.000Z',
          id: '606cb617e04aca0079fba197',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Official Trailer',
          key: 'e-rw2cxFVLg',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2021-03-03T16:59:53.000Z',
          id: '603fc36597eab400775bae3f',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 135651,
          known_for_department: 'Diễn viên',
          name: 'Michael B. Jordan',
          original_name: 'Michael B. Jordan',
          popularity: 17.784,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hz9AOUWZ2zzS0dpPJ1yQv2grA35.jpg',
          cast_id: 0,
          character: 'John Kelly',
          credit_id: '5c0a9cec925141479e041a02',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 478,
          known_for_department: 'Diễn viên',
          name: 'Jamie Bell',
          original_name: 'Jamie Bell',
          popularity: 5.266,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xAfNYOJYOy5ee9PHbBF8Y6xzZ9I.jpg',
          cast_id: 8,
          character: 'Robert Ritter',
          credit_id: '5d816f8d5c071b001d4a766c',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 1695989,
          known_for_department: 'Diễn viên',
          name: 'Jodie Turner-Smith',
          original_name: 'Jodie Turner-Smith',
          popularity: 4.647,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sseYLDaztmJgJjw1E0dHlw9o6s.jpg',
          cast_id: 10,
          character: 'Karen Greer',
          credit_id: '5d82bfdcc8f85802247668ee',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 98772,
          known_for_department: 'Diễn viên',
          name: 'Lauren London',
          original_name: 'Lauren London',
          popularity: 3.255,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vfUJtwfux3nwEGWIbrC20LyH8fn.jpg',
          cast_id: 26,
          character: 'Pam Kelly',
          credit_id: '5f8aed7057176f0034831f90',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 224197,
          known_for_department: 'Diễn viên',
          name: 'Brett Gelman',
          original_name: 'Brett Gelman',
          popularity: 5.443,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ub2IuMWFNQGYghHTPq0lpmn2Ue0.jpg',
          cast_id: 17,
          character: 'Victor Rykov',
          credit_id: '5daa79dd223a8b001355bf48',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 2256312,
          known_for_department: 'Diễn viên',
          name: 'Jacob Scipio',
          original_name: 'Jacob Scipio',
          popularity: 1.569,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vMHqb74eN66yO0OJkXlq5gFnGeW.jpg',
          cast_id: 12,
          character: 'Hatchet',
          credit_id: '5d97d8d6b04605002a41896c',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 1292258,
          known_for_department: 'Diễn viên',
          name: 'Jack Kesy',
          original_name: 'Jack Kesy',
          popularity: 2.206,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6ilvKAf8mCvz48EcchLYuQiafsL.jpg',
          cast_id: 14,
          character: 'Thunder',
          credit_id: '5d97d8f4b04605001a417d0d',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 91671,
          known_for_department: 'Diễn viên',
          name: 'Colman Domingo',
          original_name: 'Colman Domingo',
          popularity: 1.672,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2tu6T9ugnf82qIMGVKWSb0dvvq5.jpg',
          cast_id: 18,
          character: 'Pastor West',
          credit_id: '5dbe814c7d2bc10017358c93',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 529,
          known_for_department: 'Diễn viên',
          name: 'Guy Pearce',
          original_name: 'Guy Pearce',
          popularity: 9.43,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vTqk6Nh3WgqPubkS23eOlMAwmwa.jpg',
          cast_id: 59,
          character: 'Thomas Clay',
          credit_id: '603fc3f71065d30042ba0b25',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 208907,
          known_for_department: 'Diễn viên',
          name: 'Todd Lasance',
          original_name: 'Todd Lasance',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dEkGdehSdAZJbGnBn0QKFeLB5Su.jpg',
          cast_id: 28,
          character: 'Dallas',
          credit_id: '5f8aedae1443f40039cd16d9',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 55086,
          known_for_department: 'Diễn viên',
          name: 'Cam Gigandet',
          original_name: 'Cam Gigandet',
          popularity: 3.348,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kdSVRqCR0p8KZTvVkRccBLoim7L.jpg',
          cast_id: 13,
          character: 'Keith Webb',
          credit_id: '5d97d8e7befd91002ba20a66',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 1181361,
          known_for_department: 'Diễn viên',
          name: 'Luke Mitchell',
          original_name: 'Luke Mitchell',
          popularity: 3.951,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7LFvkcJn2NqHu4pi2oLYfGqFJyz.jpg',
          cast_id: 11,
          character: 'Rowdy',
          credit_id: '5d93f293a06efe001259d8af',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 1622606,
          known_for_department: 'Diễn viên',
          name: 'Stephanie McIntyre',
          original_name: 'Stephanie McIntyre',
          popularity: 0.6,
          profile_path: null,
          cast_id: 25,
          character: 'Passenger',
          credit_id: '5f8aed53eb79c200370bcce5',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 1643,
          known_for_department: 'Diễn viên',
          name: 'Adrian Rawlins',
          original_name: 'Adrian Rawlins',
          popularity: 2.562,
          profile_path:
            'https://image.tmdb.org/t/p/w185/G0PGZqTjenuVTAQiib4ScU7vAI.jpg',
          cast_id: 27,
          character: 'Chief of Staff',
          credit_id: '5f8aed901443f40037ca7382',
          order: 13,
        },
        {
          adult: false,
          gender: 1,
          id: 28749,
          known_for_department: 'Diễn viên',
          name: 'Lucy Russell',
          original_name: 'Lucy Russell',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6aNWltms1Imbl9J4aXWk4p2KRZX.jpg',
          cast_id: 29,
          character: 'CIA Director Dillard',
          credit_id: '5f8aedc1a1353300361609c6',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 1464090,
          known_for_department: 'Diễn viên',
          name: 'Robert Maaser',
          original_name: 'Robert Maaser',
          popularity: 1.614,
          profile_path:
            'https://image.tmdb.org/t/p/w185/A1YhyTwttU94AsaA2zktcEeDMmz.jpg',
          cast_id: 30,
          character: 'Russian SWAT',
          credit_id: '5f8aedd1efd3c20039385640',
          order: 15,
        },
        {
          adult: false,
          gender: 0,
          id: 2818526,
          known_for_department: 'Diễn viên',
          name: 'Gina Jun',
          original_name: 'Gina Jun',
          popularity: 0.828,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kIbJ3TTGdYVShC7K8tE5OueZ1wQ.jpg',
          cast_id: 31,
          character: 'Pedestrian',
          credit_id: '5f8aedeaeb79c200370bcec6',
          order: 16,
        },
        {
          adult: false,
          gender: 0,
          id: 1988194,
          known_for_department: 'Diễn viên',
          name: 'Rae Lim',
          original_name: 'Rae Lim',
          popularity: 0.6,
          profile_path: null,
          cast_id: 32,
          character: 'First Sergeant Tran',
          credit_id: '5f8aedf9eb79c200370bceec',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 17817,
          known_for_department: 'Diễn viên',
          name: 'Merab Ninidze',
          original_name: 'Merab Ninidze',
          popularity: 1.855,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nCmkNQgJl4Dp1kNpUhEmWiJLWRP.jpg',
          cast_id: 33,
          character: 'Andrej Vaseliev',
          credit_id: '5f8aee07e9da690039e958cb',
          order: 18,
        },
        {
          adult: false,
          gender: 2,
          id: 1243338,
          known_for_department: 'Diễn viên',
          name: 'George Asprey',
          original_name: 'George Asprey',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/g3jb3oF2DbXBY4n7VNviuxWgMbu.jpg',
          cast_id: 34,
          character: 'Denis Stewart',
          credit_id: '5f8aee1857176f00348321d6',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 102777,
          known_for_department: 'Diễn viên',
          name: 'Mel Fair',
          original_name: 'Mel Fair',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9Q9sIiikHS5HvDO89KscfnruZrb.jpg',
          cast_id: 35,
          character: 'Hawkish Analyst',
          credit_id: '5f8aee292667780037e6400c',
          order: 20,
        },
        {
          adult: false,
          gender: 0,
          id: 1552773,
          known_for_department: 'Diễn viên',
          name: 'Reza Brojerdi',
          original_name: 'Reza Brojerdi',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oimN6FyXti8HU3qkxNGTiRol4UB.jpg',
          cast_id: 37,
          character: 'Aleppo Doctor',
          credit_id: '5f8aee52efd3c20037373158',
          order: 22,
        },
        {
          adult: false,
          gender: 2,
          id: 1430712,
          known_for_department: 'Diễn viên',
          name: 'Tom Colley',
          original_name: 'Tom Colley',
          popularity: 0.656,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cbLcj1pxXGxZpSe4ztAmpGvyI90.jpg',
          cast_id: 38,
          character: 'Pentagon Cop',
          credit_id: '5f8aee5fa135330035173918',
          order: 23,
        },
        {
          adult: false,
          gender: 0,
          id: 1436512,
          known_for_department: 'Diễn viên',
          name: 'Rich Graff',
          original_name: 'Rich Graff',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nVac8YhokONsXdLNYk9pwGj0npm.jpg',
          cast_id: 39,
          character: 'Detective Hue',
          credit_id: '5f8aee6dd05a030037dab1fb',
          order: 24,
        },
        {
          adult: false,
          gender: 2,
          id: 1543541,
          known_for_department: 'Diễn viên',
          name: 'Artjom Gilz',
          original_name: 'Artjom Gilz',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6tCa08v503Hu1s1SOkSrtrRwP6i.jpg',
          cast_id: 19,
          character: 'Artem',
          credit_id: '5dbe81719638640016e3535e',
          order: 25,
        },
        {
          adult: false,
          gender: 0,
          id: 2611200,
          known_for_department: 'Diễn viên',
          name: "Pedro Paulo D'Elia",
          original_name: "Pedro Paulo D'Elia",
          popularity: 0.6,
          profile_path: null,
          cast_id: 40,
          character: 'Train Station Passenger',
          credit_id: '5f8aeea5d05a030037dab2c1',
          order: 26,
        },
        {
          adult: false,
          gender: 0,
          id: 2435075,
          known_for_department: 'Diễn viên',
          name: 'Alec Rosenthal',
          original_name: 'Alec Rosenthal',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3TZwf6wYs4qEpCFzgCu31rOkQ13.jpg',
          cast_id: 41,
          character: 'Police Officer',
          credit_id: '5f8aef0b1443f40039cd1cf4',
          order: 27,
        },
        {
          adult: false,
          gender: 0,
          id: 1482388,
          known_for_department: 'Diễn viên',
          name: 'Rauand Taleb',
          original_name: 'Rauand Taleb',
          popularity: 1.156,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gDKW7d9eX8knyxoCqClHISYFNzs.jpg',
          cast_id: 42,
          character: 'Dalil',
          credit_id: '5f8aef1cd05a030037dab380',
          order: 28,
        },
        {
          adult: false,
          gender: 2,
          id: 2321048,
          known_for_department: 'Diễn viên',
          name: 'David Burnell IV',
          original_name: 'David Burnell IV',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jl5MsfUxXw1UwSlLKIQiKZyJl5Q.jpg',
          cast_id: 20,
          character: 'US Marshal',
          credit_id: '5dbe8198efe37c0015827d7a',
          order: 29,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 3615,
          known_for_department: 'Sound',
          name: 'Manfred Banach',
          original_name: 'Manfred Banach',
          popularity: 0.863,
          profile_path: null,
          credit_id: '609582c2b7abb5003d58bc85',
          department: 'Sound',
          job: 'Production Sound Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 1301,
          known_for_department: 'Camera',
          name: 'Philippe Rousselot',
          original_name: 'Philippe Rousselot',
          popularity: 0.702,
          profile_path: null,
          credit_id: '5fd5653e55937b003dc4fc14',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 1,
          id: 5914,
          known_for_department: 'Production',
          name: 'Mary Vernieu',
          original_name: 'Mary Vernieu',
          popularity: 1.96,
          profile_path: null,
          credit_id: '5fd56596a84ff700428a69e7',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 5575,
          known_for_department: 'Biên kịch',
          name: 'Akiva Goldsman',
          original_name: 'Akiva Goldsman',
          popularity: 4.103,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zjnY7yoXZifRJR9x8hdGIm9ducG.jpg',
          credit_id: '5dbe81c99638640016e3543f',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 40752,
          known_for_department: 'Art',
          name: 'Cornelia Ott',
          original_name: 'Cornelia Ott',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5fd5658355937b003ec4f235',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 13179,
          known_for_department: 'Sound',
          name: 'Tony Lamberti',
          original_name: 'Tony Lamberti',
          popularity: 1.165,
          profile_path: null,
          credit_id: '60958320fad8e9003d47e26f',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 12770,
          known_for_department: 'Production',
          name: 'Denis L. Stewart',
          original_name: 'Denis L. Stewart',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5dbe82379638640014e2feb6',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 15328,
          known_for_department: 'Art',
          name: 'Kevin Kavanaugh',
          original_name: 'Kevin Kavanaugh',
          popularity: 1.22,
          profile_path: null,
          credit_id: '5fd5655128723c0042a19a04',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 1,
          id: 21072,
          known_for_department: 'Production',
          name: 'Cornelia von Braun',
          original_name: 'Cornelia von Braun',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fd5658d006b01003ede164b',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 21846,
          known_for_department: 'Art',
          name: 'Bernhard Henrich',
          original_name: 'Bernhard Henrich',
          popularity: 0.728,
          profile_path: null,
          credit_id: '5fd56561414291003d4567ff',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 2,
          id: 26193,
          known_for_department: 'Art',
          name: 'Denis Schnegg',
          original_name: 'Denis Schnegg',
          popularity: 0.767,
          profile_path: null,
          credit_id: '5fd5657b60b58d0044847737',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 38568,
          known_for_department: 'Biên kịch',
          name: 'Tom Clancy',
          original_name: 'Tom Clancy',
          popularity: 1.01,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dDnkblF2qwBGLC04aIdYgc6Bv6b.jpg',
          credit_id: '5faf40ffec45520040f533be',
          department: 'Biên kịch',
          job: 'Novel',
        },
        {
          adult: false,
          gender: 2,
          id: 56737,
          known_for_department: 'Production',
          name: 'Don Granger',
          original_name: 'Don Granger',
          popularity: 1.284,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ilhrUzybaDqaZOiaw1M8dzkZ0ZF.jpg',
          credit_id: '5dbe821a9638640014e2fe68',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 58433,
          known_for_department: 'Production',
          name: 'David Ellison',
          original_name: 'David Ellison',
          popularity: 2.112,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jOhjFZWW2KqsOzm4IiE71FHmcIf.jpg',
          credit_id: '5dbe82079d893900152dbabe',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 120015,
          known_for_department: 'Biên kịch',
          name: 'Josh Appelbaum',
          original_name: 'Josh Appelbaum',
          popularity: 1.052,
          profile_path: null,
          credit_id: '5c5fc13b0e0a261de56b6b20',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 123286,
          known_for_department: 'Diễn viên',
          name: 'Jon Thor Birgisson',
          original_name: 'Jon Thor Birgisson',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pm0FwIVAp9sl8doIYfu0afrX1Ir.jpg',
          credit_id: '608bd028f8aee80040b5c507',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 2,
          id: 135651,
          known_for_department: 'Diễn viên',
          name: 'Michael B. Jordan',
          original_name: 'Michael B. Jordan',
          popularity: 17.784,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hz9AOUWZ2zzS0dpPJ1yQv2grA35.jpg',
          credit_id: '5c5fc157c3a3683a468ee6ac',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 142157,
          known_for_department: 'Crew',
          name: 'Doug Coleman',
          original_name: 'Doug Coleman',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/temeKPrQ9VosJXwb51O3EWxQ5yO.jpg',
          credit_id: '5d816fbbd34eb3001c4f773b',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 932533,
          known_for_department: 'Directing',
          name: 'Stefano Sollima',
          original_name: 'Stefano Sollima',
          popularity: 1.422,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vBv41EnEGVSD6EgSj2mD9dPSdJW.jpg',
          credit_id: '5c0a9d7ac3a3682518049ec3',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 966286,
          known_for_department: 'Editing',
          name: 'Matthew Newman',
          original_name: 'Matthew Newman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fd5654855937b003dc4fc1b',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1018751,
          known_for_department: 'Biên kịch',
          name: 'André Nemec',
          original_name: 'André Nemec',
          popularity: 2.189,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kuuEycNLQDeAhaH9QNd3lpnLM62.jpg',
          credit_id: '5c5fc1679251413254ba1334',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1024910,
          known_for_department: 'Production',
          name: 'Lindsay Graham',
          original_name: 'Lindsay Graham',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fd565a56f53e1003fbc0584',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 1118400,
          known_for_department: 'Sound',
          name: 'Jamey Scott',
          original_name: 'Jamey Scott',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6095833afad8e9003c486c69',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1118400,
          known_for_department: 'Sound',
          name: 'Jamey Scott',
          original_name: 'Jamey Scott',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60958342fd4f80003e32f864',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1215399,
          known_for_department: 'Biên kịch',
          name: 'Taylor Sheridan',
          original_name: 'Taylor Sheridan',
          popularity: 63.751,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vdGTrPJG95AhBXr3xId5Fj8cTCu.jpg',
          credit_id: '60216895ea37e000403f2042',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 1215399,
          known_for_department: 'Biên kịch',
          name: 'Taylor Sheridan',
          original_name: 'Taylor Sheridan',
          popularity: 63.751,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vdGTrPJG95AhBXr3xId5Fj8cTCu.jpg',
          credit_id: '6021688e5690b500402260eb',
          department: 'Biên kịch',
          job: 'Screenstory',
        },
        {
          adult: false,
          gender: 0,
          id: 1390353,
          known_for_department: 'Sound',
          name: 'Victor Ray Ennis',
          original_name: 'Victor Ray Ennis',
          popularity: 0.609,
          profile_path: null,
          credit_id: '609582dba2e602003c9c7396',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1444045,
          known_for_department: 'Biên kịch',
          name: 'Will Staples',
          original_name: 'Will Staples',
          popularity: 0.98,
          profile_path: null,
          credit_id: '602168a6ccde040041f33526',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 1444045,
          known_for_department: 'Biên kịch',
          name: 'Will Staples',
          original_name: 'Will Staples',
          popularity: 0.98,
          profile_path: null,
          credit_id: '602168adfd630000407346aa',
          department: 'Biên kịch',
          job: 'Screenstory',
        },
        {
          adult: false,
          gender: 1,
          id: 1599387,
          known_for_department: 'Production',
          name: 'Olivia Scott-Webb',
          original_name: 'Olivia Scott-Webb',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fd5659d091e62003e59e828',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 1609859,
          known_for_department: 'Sound',
          name: 'Chase Keehn',
          original_name: 'Chase Keehn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6095830763d713003bafdfc2',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1609859,
          known_for_department: 'Sound',
          name: 'Chase Keehn',
          original_name: 'Chase Keehn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60958300025764004048a402',
          department: 'Sound',
          job: 'ADR Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1737654,
          known_for_department: 'Sound',
          name: 'Judah Getz',
          original_name: 'Judah Getz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '609582f51b722c003cf9b24f',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 2045322,
          known_for_department: 'Sound',
          name: 'Bob Lacivita',
          original_name: 'Bob Lacivita',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60958315025764004048a426',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 2212041,
          known_for_department: 'Sound',
          name: 'Manuel Vogt',
          original_name: 'Manuel Vogt',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6095835ae2bca8003e199208',
          department: 'Sound',
          job: 'Production Sound Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 2694992,
          known_for_department: 'Costume & Make-Up',
          name: 'Tiffany Hasbourne',
          original_name: 'Tiffany Hasbourne',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fd5656807291c00417378f5',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 0,
          id: 3023838,
          known_for_department: 'Sound',
          name: 'Nick Friedrich',
          original_name: 'Nick Friedrich',
          popularity: 0.6,
          profile_path: null,
          credit_id: '609582e8b7abb5003c582e83',
          department: 'Sound',
          job: 'Sound Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 3082393,
          known_for_department: 'Sound',
          name: 'Lorenzo Millan',
          original_name: 'Lorenzo Millan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6095832fa2e602003a9bc580',
          department: 'Sound',
          job: 'Sound Mixer',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'msbreviews',
          author_details: {
            name: '',
            username: 'msbreviews',
            avatar_path:
              '/https://secure.gravatar.com/avatar/992eef352126a53d7e141bf9e8707576.jpg',
            rating: 6.0,
          },
          content:
            'If you enjoy reading my Spoiler-Free reviews, please follow my blog @\r\nhttps://www.msbreviews.com\r\n\r\nTom Clancy is the author behind the famous Jack Ryan series of books, which were eventually adapted to the big screen. While the original trilogy with Alec Baldwin and Harrison Ford is fondly remembered by most people, including myself, the XXI century’s reboots with Ben Affleck and Matt Damon were nothing but failed attempts at reviving a movie franchise. John Krasinski’s TV show was apparently successful, but unfortunately, I didn’t watch it. So, why not a spin-off? Michael B. Jordan comes in for a supposedly two-part film series with John Kelly - famously known as John Clark - as the main character. Stefano Sollima rejoins forces with Taylor Sheridan - both worked on Sicario: Day of the Soldado - accompanied by the debutant co-writer, Will Staples.  \r\n\r\nI can’t consider myself a Jack Ryan “fan”, but I do remember enjoying the first three movies. I don’t possess any knowledge about the story told in the books or John Kelly himself, so I watched this Amazon Studios flick with simple expectations of receiving a decent enough action film. Overall, that’s precisely what I got. The runtime under two hours flies by due to the numerous action sequences, which are obviously the most entertaining element of the entire movie. From the long takes with intense fight choreography to the more steady, suspense-driven situations, Without Remorse doesn’t have extended intervals between each action set piece, which will satisfy viewers solely looking for the more energetic stuff.\r\n\r\nThe stunt work needs to be complimented. The team behind the riveting, loud, exciting action deserves to be addressed since they’re the ones who truly make this type of film popular and successful. With that said, every movie requires the two pillars of filmmaking - story and characters - to be well-built, which is something this film only partially accomplishes. Despite John Kelly holding a tragic, dark backstory and emotionally compelling motivations, his character arc follows the generic development formula viewers have seen previously in other movies of the same genre. Regarding the narrative, it’s really no more than a direct revenge story with an inconsequential, uninteresting socio-economic, political angle, all being easily predictable from the get-go.\r\n\r\nMichael B. Jordan (Creed, Black Panther) delivers a remarkable physical and emotional performance, carrying the whole film on his shoulders. By incorporating his character’s complicated, complex feelings of anger, grief, sadness, and sorrow, Jordan offers a captivating display that holds the viewers’ attention until the very end. Unfortunately, every other actor-character combo is so far away from the efficiency of the protagonist that all are pretty forgettable. From Jamie Bell’s (Rocketman, Snowpiercer) bland interpretation to Jodie Turner-Smith’s (Queen & Slim) forced efforts, the scripts for every secondary character are filled with either exposition or irrelevant pieces of dialogue.\r\n\r\nClearly, this is yet another attempt to revive an action saga, which I don’t think has a place today. From Mission: Impossible to John Wick, passing through Fast & Furious and the superhero universes, a Jack Ryan spin-off might just be interpreted as another random flick instead of serious competition to any of the before-mentioned franchises. Final praises to Philippe Rousselot’s camera work and Matthew Newman’s editing, which contributed to some impressive, entertaining scenes. In the end, that’s all that matters to a massive chunk of the audience.\r\n\r\nWithout Remorse follows a compelling protagonist in a path of revenge through suspenseful, intense action sequences triggered by the usual cliches and storytelling formulas of the genre. Michael B. Jordan is the star of the show, delivering a remarkably captivating performance that helps Stefano Sollima’s movie survive its unsurprising screenplay. Taylor Sheridan and Will Staples focus on building an interesting “hero”, but forget to apply that same level of dedication to the narrative and the secondary characters. Overall, it’s a fast-paced, action-driven film that will satisfy most viewers looking for something to watch on the weekend. Exceptional stunt work that must not be forgotten. However, if you desire a more creative, unique take on the Jack Ryan universe, maybe the sequel will do a better job.\r\n\r\nRating: B-',
          created_at: '2021-04-28T16:37:04.159Z',
          id: '60898f30e19de90057936173',
          updated_at: '2021-06-23T15:58:54.919Z',
          url: 'https://www.themoviedb.org/review/60898f30e19de90057936173',
        },
        {
          author: 'Ryan',
          author_details: {
            name: 'Ryan',
            username: 'RMoore35',
            avatar_path: '/tay3DG4jd22DHnFEIclUq3cBfM.jpg',
            rating: 6.0,
          },
          content:
            'Better than I expected but not enough for anything higher than 3 stars...',
          created_at: '2021-06-22T00:44:16.387Z',
          id: '60d13260c9dbf900739913d6',
          updated_at: '2021-06-23T17:37:36.674Z',
          url: 'https://www.themoviedb.org/review/60d13260c9dbf900739913d6',
        },
        {
          author: 'Rene',
          author_details: {
            name: 'Rene',
            username: 'The_Bad_Critic',
            avatar_path: '/q3zcMPYz1m7sZ8jD4ol5m6gHBQI.png',
            rating: 3.0,
          },
          content:
            "So this movie started off great and THEN FLAT LINED... Ai i had such big expectation for this movie and all it did was disappoint.Don't get me wrong Michael B is a good actor but the story itself was missing so much and became more a drama than a action thriller. but it is what it is.",
          created_at: '2021-07-08T19:26:59.271Z',
          id: '60e75183168ea300247bc206',
          updated_at: '2021-07-08T23:09:57.388Z',
          url: 'https://www.themoviedb.org/review/60e75183168ea300247bc206',
        },
      ],
      total_pages: 1,
      total_results: 3,
    },
  },
  {
    adult: false,
    backdrop_path: null,
    belongs_to_collection: null,
    budget: 0,
    genres: [],
    homepage: '',
    id: 678199,
    imdb_id: 'tt10217336',
    original_language: 'vi',
    original_title: 'Mùa Gió Chướng',
    overview:
      'Được đạo diễn Hồng Sến thực hiện dựa theo tiểu thuyết Mùa Gió Chướng của nhà văn Nguyễn Quang Sáng là cuốn tiểu thuyến nổi tiếng đương thời mô tả tinh thần đấu tranh cách mạng của nhân dân miền Nam chống lại sự đàn áp, ý đồ dời dân lập ấp của kẻ địch. Cuộc đấu tranh đó đã trải qua biết bao gian nan, thử thách, biết bao hy sinh mất mát. Nhưng cuối cùng đã đạt được thắng lợi hoàn toàn. Một cách nào đó, Mùa Gió Chướng khái quát cuộc chiến tranh giải phóng dân tộc của nhân dân Việt Nam dưới sự lãnh đạo của Đảng cộng sản.',
    popularity: 0.6,
    poster_path:
      'https://image.tmdb.org/t/p/w342/x04vshBkq0RynemxauoEEkMdOaY.jpg',
    production_companies: [
      {
        id: 148583,
        logo_path: null,
        name: 'Xưởng Phim Tổng Hợp Thành Phố Hồ Chí Minh',
        origin_country: '',
      },
    ],
    production_countries: [],
    release_date: '1978-03-09',
    revenue: 0,
    runtime: 111,
    spoken_languages: [
      { english_name: 'Vietnamese', iso_639_1: 'vi', name: 'Tiếng Việt' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Mùa Gió Chướng',
    video: false,
    vote_average: 0.0,
    vote_count: 0,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Vietnamese War Movie: Whirlwind Season | English Subtitles',
          key: 'uM6fkER9CaQ',
          site: 'YouTube',
          size: 1080,
          type: 'Featurette',
          official: false,
          published_at: '2017-01-05T00:00:03.000Z',
          id: '601a4760a5743d00408b8261',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 0,
          id: 2963126,
          known_for_department: 'Diễn viên',
          name: 'Thùy Liên',
          original_name: 'Thùy Liên',
          popularity: 0.6,
          profile_path: null,
          cast_id: 6,
          character: 'Sáu Linh',
          credit_id: '601a45dc470ead004072f562',
          order: 1,
        },
        {
          adult: false,
          gender: 0,
          id: 2611482,
          known_for_department: 'Diễn viên',
          name: 'Lý Huỳnh',
          original_name: 'Lý Huỳnh',
          popularity: 0.6,
          profile_path: null,
          cast_id: 7,
          character: 'Captain Long',
          credit_id: '601a45fd1b70ae003c6a1dff',
          order: 2,
        },
        {
          adult: false,
          gender: 0,
          id: 1604926,
          known_for_department: 'Diễn viên',
          name: 'Thúy An',
          original_name: 'Thúy An',
          popularity: 0.6,
          profile_path: null,
          cast_id: 8,
          character: 'Ba',
          credit_id: '601a4648ca0e17003d4c2e56',
          order: 3,
        },
        {
          adult: false,
          gender: 0,
          id: 1307474,
          known_for_department: 'Diễn viên',
          name: 'NSND Lâm Tới',
          original_name: 'NSND Lâm Tới',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dzuo2LoEa6c5PFESpiCfQ9uOhs.jpg',
          cast_id: 9,
          character: 'Tám Quyện',
          credit_id: '601a469587a27a0045e6f6e9',
          order: 4,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 0,
          id: 1304581,
          known_for_department: 'Biên kịch',
          name: 'Nguyễn Quang Sáng',
          original_name: 'Nguyễn Quang Sáng',
          popularity: 0.6,
          profile_path: null,
          credit_id: '601a4408ca0e17003d4c2a8c',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 1325882,
          known_for_department: 'Directing',
          name: 'Hong Sen Nguyen',
          original_name: 'Hong Sen Nguyen',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ktuXquxaw2czlW2okqWdDi158Vv.jpg',
          credit_id: '601a43f3976a23003ea91c77',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2963123,
          known_for_department: 'Editing',
          name: 'Hồng Lực',
          original_name: 'Hồng Lực',
          popularity: 0.6,
          profile_path: null,
          credit_id: '601a4576b97442003f24ae05',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2963124,
          known_for_department: 'Crew',
          name: 'Đường Tuấn Ba',
          original_name: 'Đường Tuấn Ba',
          popularity: 0.6,
          profile_path: null,
          credit_id: '601a4587e942ee0041f4a458',
          department: 'Crew',
          job: 'Cinematography',
        },
        {
          adult: false,
          gender: 0,
          id: 2963125,
          known_for_department: 'Sound',
          name: 'Hoàng Hiệp',
          original_name: 'Hoàng Hiệp',
          popularity: 0.6,
          profile_path: null,
          credit_id: '601a459fb02f5e00415350f9',
          department: 'Sound',
          job: 'Music',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/nlbewUlvkldsVHDoZX8uqtnzFJS.jpg',
    belongs_to_collection: {
      id: 332342,
      name: 'The Flirting Scholar Collection',
      poster_path: '/fMboUE78XCOyniEjjGoJBrRrzlj.jpg',
      backdrop_path: null,
    },
    budget: 0,
    genres: [
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 35, name: 'Phim Hài' },
      { id: 10749, name: 'Phim Lãng Mạn' },
    ],
    homepage: '',
    id: 37703,
    imdb_id: 'tt0108289',
    original_language: 'cn',
    original_title: '唐伯虎點秋香',
    overview:
      'Đường Bá Hổ, Điểm Thu Hương (1993) là một trong những bộ phim hài hay nhất của Châu Tinh Trì. Châu Tinh Trì vào vai Đường Bá Hổ, một anh chàng đào hoa và mê thơ, sống buồn chán với 8 bà vợ của mình. Cho đến một ngày kia, anh tìm được tình yêu đích thực của mình là Thu Hương nhưng gia đình hai bên không hợp nhau. Liệu Bá Hổ và Thu Hương có đến được với nhau chăng?',
    popularity: 6.029,
    poster_path:
      'https://image.tmdb.org/t/p/w342/64ERuayNCjv9zP8bIpqMg61D461.jpg',
    production_companies: [
      {
        id: 3619,
        logo_path: null,
        name: "Win's Movie Productions",
        origin_country: 'HK',
      },
    ],
    production_countries: [{ iso_3166_1: 'HK', name: 'Hồng Kông' }],
    release_date: '1993-07-01',
    revenue: 0,
    runtime: 100,
    spoken_languages: [
      { english_name: 'Cantonese', iso_639_1: 'cn', name: '广州话 / 廣州話' },
    ],
    status: 'Đã phát hành',
    tagline: 'Đường Bá Hổ điểm Thu Hương - Flirting Scholar',
    title: 'Đường Bá Hổ điểm Thu Hương',
    video: false,
    vote_average: 7.3,
    vote_count: 79,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Flirting Scholar (1993) ORIGINAL TRAILER [HD 1080p]',
          key: 'dghEmuAjUPY',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: false,
          published_at: '2019-02-25T18:13:56.000Z',
          id: '5f0b12905e12000038f00b43',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 57607,
          known_for_department: 'Diễn viên',
          name: 'Stephen Chow',
          original_name: 'Stephen Chow',
          popularity: 9.156,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rO1e30Yq7KzgZFAXZDosyAShhhM.jpg',
          cast_id: 2,
          character: 'Tang Pak Fu / Wah On',
          credit_id: '52fe46659251416c91053223',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 643,
          known_for_department: 'Diễn viên',
          name: 'Gong Li',
          original_name: 'Gong Li',
          popularity: 9.871,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uP3Fs3QUsGBxhNqGFWMnN1Z2l8z.jpg',
          cast_id: 3,
          character: 'Chou Heung',
          credit_id: '52fe46659251416c91053227',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 990443,
          known_for_department: 'Diễn viên',
          name: 'Natalis Chan',
          original_name: 'Natalis Chan',
          popularity: 1.651,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uWoOtHkp5mrALDXVLss2e02uOAn.jpg',
          cast_id: 6,
          character: 'Chuck Chi San',
          credit_id: '52fe46659251416c9105322f',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 56811,
          known_for_department: 'Diễn viên',
          name: 'James Wong',
          original_name: 'James Wong',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gmZZNrvwFIpo3kB9L51wQircqlH.jpg',
          cast_id: 7,
          character: 'Master Wah',
          credit_id: '571b18d3925141343c000498',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 1624,
          known_for_department: 'Diễn viên',
          name: 'Cheng Pei-Pei',
          original_name: 'Cheng Pei-Pei',
          popularity: 2.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/l8ZFuYjqJpwqYFcHJHEKCNFkdx.jpg',
          cast_id: 5,
          character: 'Madame Wah',
          credit_id: '52fe46659251416c9105322b',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 227782,
          known_for_department: 'Diễn viên',
          name: 'Bryan Leung Kar-yan',
          original_name: 'Bryan Leung Kar-yan',
          popularity: 1.834,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1c8lLgbS3EDJvEB3LpNrW1GPfdF.jpg',
          cast_id: 8,
          character: 'Mo Chong Yuen',
          credit_id: '571b18e1c3a36824a30004ba',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 1135781,
          known_for_department: 'Diễn viên',
          name: 'Mimi Chu',
          original_name: 'Mimi Chu',
          popularity: 1.544,
          profile_path:
            'https://image.tmdb.org/t/p/w185/A1rpCGLmQysVqzqcGhiYtF35Nws.jpg',
          cast_id: 9,
          character: 'Chussy',
          credit_id: '571b18ea92514135ff000480',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 94076,
          known_for_department: 'Diễn viên',
          name: 'Kingdom Yuen',
          original_name: 'Kingdom Yuen',
          popularity: 3.229,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cuFctctF42GLEO6gdggVU24xkMs.jpg',
          cast_id: 10,
          character: 'Shek Lau',
          credit_id: '571b18f6c3a368195b001fa4',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 1329775,
          known_for_department: 'Diễn viên',
          name: 'Gabriel Wong',
          original_name: 'Gabriel Wong',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/e3om7myl5ZKXt1KaRbSYvAd0N35.jpg',
          cast_id: 11,
          character: 'Wah Man',
          credit_id: '571b18ffc3a368197c001e6d',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 1134944,
          known_for_department: 'Diễn viên',
          name: 'Dickson Lee',
          original_name: 'Dickson Lee',
          popularity: 0.6,
          profile_path: null,
          cast_id: 12,
          character: 'Wah Mo',
          credit_id: '571b190a925141343c0004a1',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 63584,
          known_for_department: 'Diễn viên',
          name: 'Francis Ng',
          original_name: 'Francis Ng',
          popularity: 2.28,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nu46zSuc3Kr7GQVIQHOgZD5P2s9.jpg',
          cast_id: 13,
          character: 'One of 4 Scholars',
          credit_id: '571b1916c3a36823cb0004bd',
          order: 10,
        },
        {
          adult: false,
          gender: 0,
          id: 999460,
          known_for_department: 'Diễn viên',
          name: 'Chan Fai-Hung',
          original_name: 'Chan Fai-Hung',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gudVe8YchL6PwGkqo0DExqptAnl.jpg',
          cast_id: 14,
          character: 'One of 4 Scholars',
          credit_id: '571b192392514172e50011b1',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 83630,
          known_for_department: 'Diễn viên',
          name: 'David Lam Wai',
          original_name: 'David Lam Wai',
          popularity: 0.972,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oZBSfYQPPPKRvw4Y8hrz24fndI9.jpg',
          cast_id: 22,
          character: 'King Ning',
          credit_id: '59ab2beec3a3682c6201ab21',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 1575541,
          known_for_department: 'Diễn viên',
          name: 'Chu Tit-Wo',
          original_name: 'Chu Tit-Wo',
          popularity: 1.96,
          profile_path: null,
          cast_id: 16,
          character: "Ning's envoy",
          credit_id: '571b193b925141715d003821',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 240171,
          known_for_department: 'Diễn viên',
          name: 'Gordon Liu Chia-Hui',
          original_name: 'Gordon Liu Chia-Hui',
          popularity: 2.725,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nGpgPSRGXJ808e1ay54nym3qUdp.jpg',
          cast_id: 17,
          character: 'Evil Scholar',
          credit_id: '571b1946925141343c0004a7',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 65934,
          known_for_department: 'Diễn viên',
          name: 'Vincent Kok',
          original_name: 'Vincent Kok',
          popularity: 1.546,
          profile_path:
            'https://image.tmdb.org/t/p/w185/foYVecYCYkAuwyPXNy3jSJYaVub.jpg',
          cast_id: 18,
          character: 'Tu Chuen Chang',
          credit_id: '571b195192514172e50011bb',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 1407528,
          known_for_department: 'Diễn viên',
          name: 'Joey Leung',
          original_name: 'Joey Leung',
          popularity: 0.648,
          profile_path:
            'https://image.tmdb.org/t/p/w185/f89Z3RJMNTUqzqNEUhD7L1FIF6r.jpg',
          cast_id: 19,
          character: 'Poor man',
          credit_id: '571b195cc3a36824340004d9',
          order: 16,
        },
        {
          adult: false,
          gender: 1,
          id: 230777,
          known_for_department: 'Diễn viên',
          name: 'Jessica Hsuan',
          original_name: 'Jessica Hsuan',
          popularity: 4.451,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dFIK7HvrLW4nPl397tTIy57L9bN.jpg',
          cast_id: 20,
          character: 'Ha Heung',
          credit_id: '57354943c3a3680258000ee8',
          order: 17,
        },
        {
          adult: false,
          gender: 0,
          id: 68563,
          known_for_department: 'Diễn viên',
          name: 'Carol Wan',
          original_name: 'Carol Wan',
          popularity: 1.532,
          profile_path: null,
          cast_id: 21,
          character: 'Tung Heung',
          credit_id: '5735494ec3a3680262000f95',
          order: 18,
        },
        {
          adult: false,
          gender: 2,
          id: 237235,
          known_for_department: 'Diễn viên',
          name: 'Lee Kin-Yan',
          original_name: 'Lee Kin-Yan',
          popularity: 1.826,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jdd3mcrISLwXpeIWndy6uhY2N6c.jpg',
          cast_id: 23,
          character: 'Robber',
          credit_id: '5e85c6535294e700134ab567',
          order: 19,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 57607,
          known_for_department: 'Diễn viên',
          name: 'Stephen Chow',
          original_name: 'Stephen Chow',
          popularity: 9.156,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rO1e30Yq7KzgZFAXZDosyAShhhM.jpg',
          credit_id: '60b57007435011003f834dc7',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 118355,
          known_for_department: 'Diễn viên',
          name: 'Lee Lik-Chi',
          original_name: 'Lee Lik-Chi',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vrSBx0NyJ2SqJ9sZPasM3MjwyXK.jpg',
          credit_id: '52fe46659251416c9105321f',
          department: 'Directing',
          job: 'Director',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/e1KSGoEzqZQeZ3mwsDcUlOARVDP.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [{ id: 35, name: 'Phim Hài' }],
    homepage: '',
    id: 385099,
    imdb_id: '',
    original_language: 'vi',
    original_title: 'Siêu Nhân X',
    overview:
      'Nội dung bộ phim sẽ xoay quanh một chàng thanh niên trẻ tên Nam ngoại hình ốm yếu gầy còm là bất lợi lớn nhất của cuộc đời anh chàng, từ nhỏ đã bị các bạn trêu chọc và hiếp đáp. Đến khi trưởng thành Nam lúc nào cũng thấy mặc cảm với bản thân vì không làm được việc nặng, anh ước rằng một ngày nào đó thoát khỏi căn bệnh đang hoành hành trong người mình. Trong lúc lang thang dọc bờ sông, Nam nhìn thấy một vật phát sáng kì lạ, quyết định lội xuống để mang về nghiên cứu thì một luồng sáng mạnh phát ra và chiếm lấy cơ thể của Nam. Sáng hôm sau thức dậy Nam thấy mình cao hơn và cơ thể rắn chắc, và điều kì lạ hơn là sở hữu một luồn năng lượng cực kì mạnh mẽ. Nhằm muốn sử dụng sức mạnh của mình cho việc có ích Nam quyết định giấu mình trong một trang phục siêu nhân để hoạt động vào ban đêm.',
    popularity: 0.918,
    poster_path:
      'https://image.tmdb.org/t/p/w342/lAnex2zhCiNSdSPZRwEW2iYBFVm.jpg',
    production_companies: [
      {
        id: 16405,
        logo_path: null,
        name: 'Galaxy Films',
        origin_country: 'IN',
      },
    ],
    production_countries: [{ iso_3166_1: 'VN', name: 'Vietnam' }],
    release_date: '2015-02-04',
    revenue: 0,
    runtime: 0,
    spoken_languages: [
      { english_name: 'Vietnamese', iso_639_1: 'vi', name: 'Tiếng Việt' },
    ],
    status: 'Đã phát hành',
    tagline: 'Sieu nhan X',
    title: 'Siêu Nhân X',
    video: false,
    vote_average: 4.0,
    vote_count: 1,
    videos: { results: [] },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 1597752,
          known_for_department: 'Diễn viên',
          name: 'Ngô Kiến Huy',
          original_name: 'Ngô Kiến Huy',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/Stpxt3MVOMoIzVtC7ls2ehEWYk.jpg',
          cast_id: 0,
          character: 'Sieu nhan X',
          credit_id: '57634fa9c3a3685406000989',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 83482,
          known_for_department: 'Diễn viên',
          name: 'Thanh Hằng',
          original_name: 'Thanh Hằng',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sa32gCX4i8b4cmArLtvOUC1k507.jpg',
          cast_id: 1,
          character: 'Ky Ky',
          credit_id: '57634fb4c3a36854fd000909',
          order: 2,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 1300743,
          known_for_department: 'Directing',
          name: 'Nguyễn Quang Dũng',
          original_name: 'Nguyễn Quang Dũng',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57634fc9c3a368558f0008ac',
          department: 'Directing',
          job: 'Director',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/uuCj46exjP6UOo976MAWACWFv1X.jpg',
    belongs_to_collection: {
      id: 526203,
      name: 'A Christmas Prince Collection',
      poster_path: '/comKD8Myrqs3xZ2GN7Qjdk8hXP9.jpg',
      backdrop_path: '/xxFyKwZPYqbvFy8gZC22wneOchT.jpg',
    },
    budget: 0,
    genres: [
      { id: 10749, name: 'Phim Lãng Mạn' },
      { id: 10751, name: 'Phim Gia Đình' },
    ],
    homepage: 'https://www.netflix.com/title/81029841',
    id: 587693,
    imdb_id: 'tt10006006',
    original_language: 'en',
    original_title: 'A Christmas Prince: The Royal Baby',
    overview:
      'Aldovia đón nhận món quà Giáng Sinh tuyệt vời: một em bé hoàng gia. Nhưng trước tiên, Hoàng hậu Amber phải tháo gỡ 1 bí ẩn của nền quân chủ để cứu gia đình và vương quốc.',
    popularity: 23.492,
    poster_path:
      'https://image.tmdb.org/t/p/w342/4RErLw0APt8qQiee0d8VCKasWwl.jpg',
    production_companies: [
      {
        id: 2090,
        logo_path: '/jYlUttNqcN5u1pzMQrh5AEhZ27t.png',
        name: 'Motion Picture Corporation of America',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2019-12-05',
    revenue: 0,
    runtime: 1,
    spoken_languages: [
      { english_name: 'Thai', iso_639_1: 'th', name: 'ภาษาไทย' },
      { english_name: 'Turkish', iso_639_1: 'tr', name: 'Türkçe' },
    ],
    status: 'Đã phát hành',
    tagline: 'Baby Makes 3',
    title: 'Hoàng Tử Giáng Sinh: Em Bé Hoàng Gia',
    video: false,
    vote_average: 6.4,
    vote_count: 419,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'A Christmas Prince 3: The Royal Baby | Official Trailer | Netflix',
          key: 'RK0zCsxBG3U',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2019-11-20T16:00:03.000Z',
          id: '5dd6b6a47f1d8300136272dc',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 53485,
          known_for_department: 'Diễn viên',
          name: 'Rose McIver',
          original_name: 'Rose McIver',
          popularity: 8.662,
          profile_path:
            'https://image.tmdb.org/t/p/w185/YUQRCXFZG2P1oAeRDXln8Iix1G.jpg',
          cast_id: 1,
          character: 'Queen Amber',
          credit_id: '5c87c7efc3a3684e95e21732',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 1173231,
          known_for_department: 'Diễn viên',
          name: 'Ben Lamb',
          original_name: 'Ben Lamb',
          popularity: 2.95,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mxbN5DgsT1YMFaEo7FZ4uMAJ14b.jpg',
          cast_id: 2,
          character: 'King Richard',
          credit_id: '5c87c7ff0e0a26430a69c7d0',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 2506,
          known_for_department: 'Diễn viên',
          name: 'Alice Krige',
          original_name: 'Alice Krige',
          popularity: 4.112,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gwkI4FAYnhkp9NWV3meATzQql0v.jpg',
          cast_id: 18,
          character: 'Queen Helena',
          credit_id: '5dea1111a313b80012954c9b',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 1363045,
          known_for_department: 'Diễn viên',
          name: 'Honor Kneafsey',
          original_name: 'Honor Kneafsey',
          popularity: 2.746,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pgk3qwXCUjYReOwrGCLWm8qCbBx.jpg',
          cast_id: 19,
          character: 'Princess Emily',
          credit_id: '5dea11353faba00013173c51',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 1366857,
          known_for_department: 'Diễn viên',
          name: 'Theo Devaney',
          original_name: 'Theo Devaney',
          popularity: 1.642,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zfc8Q26ew39M9d469Q6t1lqjZa3.jpg',
          cast_id: 9,
          character: 'Simon',
          credit_id: '5da9e94fb2681f0016909a1a',
          order: 4,
        },
        {
          adult: false,
          gender: 0,
          id: 1812318,
          known_for_department: 'Diễn viên',
          name: 'Kevin Shen',
          original_name: 'Kevin Shen',
          popularity: 1.38,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jEekVvhavKl9p8iBzkXjlVVA0se.jpg',
          cast_id: 33,
          character: 'King Tai',
          credit_id: '5dea12f411386c001359a8d6',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 2476377,
          known_for_department: 'Diễn viên',
          name: 'Momo Yeung',
          original_name: 'Momo Yeung',
          popularity: 0.745,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7WypnP8AJtGtklaFqdbluGMlOm6.jpg',
          cast_id: 34,
          character: 'Queen Ming',
          credit_id: '5dea130927d9cc0017ea3c67',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 31364,
          known_for_department: 'Diễn viên',
          name: 'Sarah Douglas',
          original_name: 'Sarah Douglas',
          popularity: 2.456,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rITQHmOLnZK0TrTSaSrANCtqdRf.jpg',
          cast_id: 8,
          character: 'Mrs. Averill',
          credit_id: '5da9e94fb2681f001290727c',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 179771,
          known_for_department: 'Diễn viên',
          name: 'Richard Ashton',
          original_name: 'Richard Ashton',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vXU9iUlWQ3iniENuebXjjhdtVbQ.jpg',
          cast_id: 11,
          character: 'Mr. Little',
          credit_id: '5da9e950ce6c4c0014b80edc',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 1376876,
          known_for_department: 'Diễn viên',
          name: 'Raj Bajaj',
          original_name: 'Raj Bajaj',
          popularity: 1.539,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5uLuK3AHgMBb9ojNjima0TJ57RL.jpg',
          cast_id: 32,
          character: 'Sahil',
          credit_id: '5dea12cb27d9cc0013ea24b3',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 2476378,
          known_for_department: 'Diễn viên',
          name: 'Crystal Yu',
          original_name: 'Crystal Yu',
          popularity: 0.84,
          profile_path: null,
          cast_id: 35,
          character: 'Lynn',
          credit_id: '5dea133aa313b800129550ec',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 25088,
          known_for_department: 'Diễn viên',
          name: 'Andy Lucas',
          original_name: 'Andy Lucas',
          popularity: 0.828,
          profile_path: null,
          cast_id: 31,
          character: 'Mr. Zabala',
          credit_id: '5dea12b63faba0001917faa3',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 1674277,
          known_for_department: 'Diễn viên',
          name: 'Tahirah Sharif',
          original_name: 'Tahirah Sharif',
          popularity: 2.912,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pOuvO7m9jrTyc0yg40JSaYS99qe.jpg',
          cast_id: 10,
          character: 'Melissa',
          credit_id: '5da9e94f9661fc00143f2fb4',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 218125,
          known_for_department: 'Diễn viên',
          name: 'John Guerrasio',
          original_name: 'John Guerrasio',
          popularity: 1.128,
          profile_path: null,
          cast_id: 20,
          character: 'Rudy',
          credit_id: '5dea119927d9cc0013ea2167',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 1911207,
          known_for_department: 'Diễn viên',
          name: 'Joel McVeagh',
          original_name: 'Joel McVeagh',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lBGLA1tcCEX45DD1idX55VKgBD0.jpg',
          cast_id: 12,
          character: 'Andy',
          credit_id: '5da9e9503d355700126c3d49',
          order: 14,
        },
        {
          adult: false,
          gender: 0,
          id: 2435625,
          known_for_department: 'Diễn viên',
          name: 'Madra Ihegborow',
          original_name: 'Madra Ihegborow',
          popularity: 0.6,
          profile_path: null,
          cast_id: 14,
          character: 'Dr. Magoro',
          credit_id: '5da9e951ce6c4c0014b80ee6',
          order: 15,
        },
        {
          adult: false,
          gender: 0,
          id: 2476380,
          known_for_department: 'Diễn viên',
          name: 'Billy Angel',
          original_name: 'Billy Angel',
          popularity: 0.6,
          profile_path: null,
          cast_id: 36,
          character: 'Tom Quill',
          credit_id: '5dea1383a313b8001495a6c5',
          order: 16,
        },
        {
          adult: false,
          gender: 0,
          id: 2476384,
          known_for_department: 'Diễn viên',
          name: 'Nicolae Stoica',
          original_name: 'Nicolae Stoica',
          popularity: 0.6,
          profile_path: null,
          cast_id: 40,
          character: 'Prince Claude',
          credit_id: '5dea14e127d9cc0013ea29a9',
          order: 17,
        },
        {
          adult: false,
          gender: 0,
          id: 2476385,
          known_for_department: 'Diễn viên',
          name: 'Shinji Ishigaki',
          original_name: 'Shinji Ishigaki',
          popularity: 0.6,
          profile_path: null,
          cast_id: 41,
          character: 'Prince Jun',
          credit_id: '5dea14f23faba0001917fff9',
          order: 18,
        },
        {
          adult: false,
          gender: 0,
          id: 1390112,
          known_for_department: 'Biên kịch',
          name: 'Tag Mendillo',
          original_name: 'Tag Mendillo',
          popularity: 0.6,
          profile_path: null,
          cast_id: 42,
          character: 'Reporter #1',
          credit_id: '5dea154027d9cc0017ea3e77',
          order: 19,
        },
        {
          adult: false,
          gender: 1,
          id: 1763891,
          known_for_department: 'Diễn viên',
          name: 'Diana Vladu',
          original_name: 'Diana Vladu',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5inou6CaIik6z9pYwBPvqwZymSM.jpg',
          cast_id: 13,
          character: 'Reporter #2',
          credit_id: '5da9e950126ec3001410a2dd',
          order: 20,
        },
        {
          adult: false,
          gender: 0,
          id: 2435626,
          known_for_department: 'Diễn viên',
          name: 'MJ Lee',
          original_name: 'MJ Lee',
          popularity: 0.6,
          profile_path: null,
          cast_id: 15,
          character: 'Suzanne',
          credit_id: '5da9e951ce6c4c0012b834d1',
          order: 21,
        },
        {
          adult: false,
          gender: 0,
          id: 1672005,
          known_for_department: 'Diễn viên',
          name: 'Alma Caldare',
          original_name: 'Alma Caldare',
          popularity: 0.6,
          profile_path: null,
          cast_id: 43,
          character: 'Crowd Member #2',
          credit_id: '5dea156b11386c001359ab46',
          order: 22,
        },
        {
          adult: false,
          gender: 0,
          id: 2435627,
          known_for_department: 'Diễn viên',
          name: 'Daniela Pirnac',
          original_name: 'Daniela Pirnac',
          popularity: 0.6,
          profile_path: null,
          cast_id: 16,
          character: 'Reporter #4 (uncredited)',
          credit_id: '5da9e951ce6c4c0014b80ef0',
          order: 23,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 31627,
          known_for_department: 'Camera',
          name: 'Viorel Sergovici',
          original_name: 'Viorel Sergovici',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5dea12503faba0001917f975',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 44993,
          known_for_department: 'Editing',
          name: 'Marshall Harvey',
          original_name: 'Marshall Harvey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dea127427d9cc0013ea23c7',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 51702,
          known_for_department: 'Production',
          name: 'Brad Krevoy',
          original_name: 'Brad Krevoy',
          popularity: 1.712,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fSGnlsFaIv2XismPpVOmJ9pHANi.jpg',
          credit_id: '5dea11f3a313b80012954de4',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 79656,
          known_for_department: 'Directing',
          name: 'John Schultz',
          original_name: 'John Schultz',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dYQG85NJmHimSdWYxjKT9iTXgJl.jpg',
          credit_id: '5dd566af3faba00013f4d4c7',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 1,
          id: 127499,
          known_for_department: 'Production',
          name: 'Amy Krell',
          original_name: 'Amy Krell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c87c91d0e0a2618885f709c',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 127499,
          known_for_department: 'Production',
          name: 'Amy Krell',
          original_name: 'Amy Krell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dea13d2a313b8001495a720',
          department: 'Production',
          job: 'Unit Production Manager',
        },
        {
          adult: false,
          gender: 2,
          id: 240965,
          known_for_department: 'Biên kịch',
          name: 'Nathan Atkins',
          original_name: 'Nathan Atkins',
          popularity: 1.473,
          profile_path: null,
          credit_id: '5dea11cf3faba0001917f7ca',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 489607,
          known_for_department: 'Sound',
          name: 'Zack Ryan',
          original_name: 'Zack Ryan',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5dea13b1a313b8001495a6fb',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 2,
          id: 1084852,
          known_for_department: 'Production',
          name: 'Jimmy Townsend',
          original_name: 'Jimmy Townsend',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dea123a27d9cc0013ea22f0',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1094636,
          known_for_department: 'Diễn viên',
          name: 'Razvan Gheorghiu',
          original_name: 'Razvan Gheorghiu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dea15c43faba0001918015d',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 1,
          id: 1156991,
          known_for_department: 'Production',
          name: 'Amanda Phillips Atkins',
          original_name: 'Amanda Phillips Atkins',
          popularity: 3.196,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7j4wTXIj5QNQjGkVOIt5zXh3Dst.jpg',
          credit_id: '5dea120d27d9cc0013ea228f',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1173302,
          known_for_department: 'Art',
          name: 'Ian Bailie',
          original_name: 'Ian Bailie',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dea126327d9cc0011ea1f05',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 1,
          id: 1193192,
          known_for_department: 'Production',
          name: 'Carolyn McLeod',
          original_name: 'Carolyn McLeod',
          popularity: 1.116,
          profile_path: null,
          credit_id: '5dea13a311386c001659c2c9',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 1390112,
          known_for_department: 'Biên kịch',
          name: 'Tag Mendillo',
          original_name: 'Tag Mendillo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dea123011386c001359a798',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1553277,
          known_for_department: 'Production',
          name: 'Cristian Bostanescu',
          original_name: 'Cristian Bostanescu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dea162211386c0011595ec3',
          department: 'Production',
          job: 'Line Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1628300,
          known_for_department: 'Production',
          name: 'Miruna Gheorghiu',
          original_name: 'Miruna Gheorghiu',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5dea1631a313b8001495acce',
          department: 'Production',
          job: 'Line Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1721266,
          known_for_department: 'Production',
          name: 'Eric Jarboe',
          original_name: 'Eric Jarboe',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/z4iXU6bjNWBbDxoZxx81RsDYP0l.jpg',
          credit_id: '5dea121a11386c001359a76a',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1923215,
          known_for_department: 'Biên kịch',
          name: 'Karen Schaler',
          original_name: 'Karen Schaler',
          popularity: 1.094,
          profile_path: null,
          credit_id: '5dea11e111386c001359a710',
          department: 'Biên kịch',
          job: 'Characters',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'Kamurai',
          author_details: {
            name: 'Kamurai',
            username: 'Kamurai',
            avatar_path: '/sKeC7qZLAKreuwxH4x6U3mN7Aa8.jpg',
            rating: 5.0,
          },
          content:
            "Decent watch, probably won't watch again, but can recommend, especially if you're a fan of the series.\r\n\r\nThis movie is much less about the \"main\" couple, and instead uses them as more of a setting for an international affair that happens to be around Christmas, and happens to be around the time she's going to have a baby.\r\n\r\nWhile the story itself is clever and a decent basis for a movie, it gets a little hamstrung from being shoe-horned into this movie.  Instead of being a clever Scooby Doo movie, it's a so-so Christmas movie.\r\n\r\nStill, it retains the charm of the previous movies, and is a decent watch, even if it's not a great movie.",
          created_at: '2020-12-10T18:41:32.520Z',
          id: '5fd26bdc22931a003e6d3032',
          updated_at: '2021-06-23T15:58:48.580Z',
          url: 'https://www.themoviedb.org/review/5fd26bdc22931a003e6d3032',
        },
      ],
      total_pages: 1,
      total_results: 1,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/j2oX7UeZJJD6tUczrVECcJCdLaG.jpg',
    belongs_to_collection: {
      id: 23616,
      name: 'Naruto Collection',
      poster_path: '/q9rrfRgPUFkFqDF74jlvNYp3RpN.jpg',
      backdrop_path: '/prLI2SNNkd9wcQkFh9iWXzQtR5D.jpg',
    },
    budget: 25000000,
    genres: [
      { id: 12, name: 'Phim Phiêu Lưu' },
      { id: 16, name: 'Phim Hoạt Hình' },
      { id: 28, name: 'Phim Hành Động' },
    ],
    homepage: 'http://www.naruto-movie.com/',
    id: 18861,
    imdb_id: 'tt1071815',
    original_language: 'ja',
    original_title:
      '劇場版 NARUTO -ナルト- 大興奮!みかづき島のアニマル騒動だってばよ',
    overview:
      'Câu chuyện bắt đầu từ việc bộ bốn Naruto, Sakura, Rock Lee và Kakashi nhận nhiệm vụ bảo vệ vị hoàng tử béo hay ham chơi Michiru và cậu con trai với cặp kính cận to Hikaru bắn mũi tên đầu cao su vào băng bảo vệ trán của Naruto và cho rằng những Ninja này thật vô dụng. Theo lời của Tsunade, đây là một nơi du lịch khá nổi tiếng với hòn đảo hình mặt trăng liềm cùng với biển đẹp luôn khiến bà bị cuốn hút bởi nó và rất mong một ngày nào đó sẽ được đến đây. Bộ bốn này phải chống lại bọn cướp tấn công những du khách theo cảnh báo của Tsunade. Ban đêm khi hai bố con Michiru ăn uống sung sướng mà cả bốn phải ăn mì ở ngoài, chưa kể cơn rét vào đêm khuya khoắt ...',
    popularity: 65.69,
    poster_path:
      'https://image.tmdb.org/t/p/w342/tNunlumSc4uHMOSGYogmM9ghxOz.jpg',
    production_companies: [],
    production_countries: [{ iso_3166_1: 'JP', name: 'Nhật Bản' }],
    release_date: '2006-08-05',
    revenue: 0,
    runtime: 95,
    spoken_languages: [
      { english_name: 'Nhật Bảnese', iso_639_1: 'ja', name: '日本語' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Naruto: Những Lính Gác Của Nguyệt Quốc',
    video: false,
    vote_average: 7.0,
    vote_count: 223,
    videos: { results: [] },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 82055,
          known_for_department: 'Diễn viên',
          name: 'Junko Takeuchi',
          original_name: 'Junko Takeuchi',
          popularity: 3.385,
          profile_path:
            'https://image.tmdb.org/t/p/w185/r0mRj4lNrKCmwGrzpgptKe096u1.jpg',
          cast_id: 3,
          character: 'Naruto Uzumaki (voice)',
          credit_id: '52fe47a29251416c750a05d9',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 82057,
          known_for_department: 'Diễn viên',
          name: 'Chie Nakamura',
          original_name: 'Chie Nakamura',
          popularity: 2.639,
          profile_path:
            'https://image.tmdb.org/t/p/w185/evB6vKUbm0CKgBcgikPeFXdwd29.jpg',
          cast_id: 4,
          character: 'Sakura Haruno (voice)',
          credit_id: '52fe47a29251416c750a05dd',
          order: 1,
        },
        {
          adult: false,
          gender: 0,
          id: 89971,
          known_for_department: 'Diễn viên',
          name: 'Yōichi Masukawa',
          original_name: 'Yōichi Masukawa',
          popularity: 1.46,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sE664CcqM1pvoWsYsca7szlIzl5.jpg',
          cast_id: 5,
          character: 'Rock Lee (voice)',
          credit_id: '52fe47a29251416c750a05e1',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 89968,
          known_for_department: 'Diễn viên',
          name: 'Kazuhiko Inoue',
          original_name: 'Kazuhiko Inoue',
          popularity: 2.804,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pbtAwOl8h7JU62w0IibV024No4z.jpg',
          cast_id: 6,
          character: 'Kakashi Hatake (voice)',
          credit_id: '52fe47a29251416c750a05e5',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 40451,
          known_for_department: 'Diễn viên',
          name: 'Akio Otsuka',
          original_name: 'Akio Otsuka',
          popularity: 4.996,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fBgebh93VAJC9lIVdB8JmFtdixL.jpg',
          cast_id: 7,
          character: 'Michiru Tsuki (voice)',
          credit_id: '5eb9712c7d2bc1001d005122',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 9709,
          known_for_department: 'Diễn viên',
          name: 'Kyousuke Ikeda',
          original_name: 'Kyousuke Ikeda',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7GkLOI1BhICz28tJVLbuImDPcIs.jpg',
          cast_id: 8,
          character: 'Hikaru Tsuki (voice)',
          credit_id: '5eb97138c3514c00205efe71',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 142712,
          known_for_department: 'Diễn viên',
          name: 'Rokuro Naya',
          original_name: 'Rokuro Naya',
          popularity: 1.943,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8mRUsy6nPOPEkbqfZ0HsaCj9U7N.jpg',
          cast_id: 9,
          character: 'Kakeru Tsuki (voice)',
          credit_id: '5eb97145bbe1dd0020845679',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 1252712,
          known_for_department: 'Diễn viên',
          name: 'Marika Hayashi',
          original_name: 'Marika Hayashi',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6DIXjGwLJv023PNMNUESjKTexGT.jpg',
          cast_id: 10,
          character: 'Amayo (voice)',
          credit_id: '5eb971867d2bc1001efe5b1f',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 81859,
          known_for_department: 'Diễn viên',
          name: 'Tomomichi Nishimura',
          original_name: 'Tomomichi Nishimura',
          popularity: 1.939,
          profile_path: null,
          cast_id: 11,
          character: 'Principal (voice)',
          credit_id: '5eb97195c3514c001e5bd1f0',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 1247847,
          known_for_department: 'Diễn viên',
          name: 'Kenji Hamada',
          original_name: 'Kenji Hamada',
          popularity: 1.744,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pco71k8P9XKBmbqX2tTN6sBfFBc.jpg',
          cast_id: 12,
          character: 'Korega (voice)',
          credit_id: '5eb971a0bbe1dd002186511d',
          order: 9,
        },
        {
          adult: false,
          gender: 0,
          id: 1243043,
          known_for_department: 'Diễn viên',
          name: 'Umeji Sasaki',
          original_name: 'Umeji Sasaki',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/z0qdUdhMj63GPRgr1NbEE2GHhnC.jpg',
          cast_id: 13,
          character: 'Shabadaba (voice)',
          credit_id: '5eb971ab62e86f001c113de1',
          order: 10,
        },
        {
          adult: false,
          gender: 0,
          id: 222339,
          known_for_department: 'Diễn viên',
          name: 'Masashi Sugawara',
          original_name: 'Masashi Sugawara',
          popularity: 1.14,
          profile_path:
            'https://image.tmdb.org/t/p/w185/58SYHyoQmGnHCrKFh0tZ1lTF7ge.jpg',
          cast_id: 14,
          character: 'Ishidate (voice)',
          credit_id: '5eb971b9cc277c00217077b3',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 1221108,
          known_for_department: 'Diễn viên',
          name: 'Haruhi Nanao',
          original_name: 'Haruhi Nanao',
          popularity: 0.833,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ewc6KuuCKrBfNKxudAls7um5Qst.jpg',
          cast_id: 15,
          character: 'Karenbana (voice)',
          credit_id: '5eb971c8bbe1dd002186515e',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 122654,
          known_for_department: 'Diễn viên',
          name: 'Hisao Egawa',
          original_name: 'Hisao Egawa',
          popularity: 1.152,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7uZ43mElJTJqLsQwTkntFN4REGT.jpg',
          cast_id: 16,
          character: 'Kongo (voice)',
          credit_id: '5eb971d5c3514c001f597003',
          order: 13,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 84196,
          known_for_department: 'Directing',
          name: 'Toshiyuki Tsuru',
          original_name: 'Toshiyuki Tsuru',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61980745e329430043d74b64',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 84196,
          known_for_department: 'Directing',
          name: 'Toshiyuki Tsuru',
          original_name: 'Toshiyuki Tsuru',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe47a29251416c750a05cf',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 84196,
          known_for_department: 'Directing',
          name: 'Toshiyuki Tsuru',
          original_name: 'Toshiyuki Tsuru',
          popularity: 0.6,
          profile_path: null,
          credit_id: '613785e3b7abb50043e78195',
          department: 'Art',
          job: 'Storyboard Artist',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/4mcOCiR06dqQ5eoEJcG3zvonjOa.jpg',
    belongs_to_collection: {
      id: 295130,
      name: 'Giải Mã Mê Cung',
      poster_path: '/wQ0l9sq0Bm6OAeqY4w6NWjP9jwS.jpg',
      backdrop_path: '/te8ibHFhjwWXZTCtQIPRUFjxWX2.jpg',
    },
    budget: 61000000,
    genres: [
      { id: 878, name: 'Phim Khoa Học Viễn Tưởng' },
      { id: 28, name: 'Phim Hành Động' },
      { id: 53, name: 'Phim Gây Cấn' },
      { id: 12, name: 'Phim Phiêu Lưu' },
    ],
    homepage: 'http://mazerunnermovies.com',
    id: 294254,
    imdb_id: 'tt4046784',
    original_language: 'en',
    original_title: 'Maze Runner: The Scorch Trials',
    overview:
      'Thomas và các bạn chưa bao giờ hình dung điều gì ghê gớm hơn các thách thức đã gặp phải trong Mê cung. Nhưng họ đã lầm. Trí nhớ khiếm khuyết của họ khiến họ không biết đến những gì đã và đang diễn ra ở thế giới bên ngoài. Những thứ còn khủng khiếp hơn bầy Nhím Sầu, lắt léo hơn các ngóc ngách Mê Cung và tàn nhẫn hơn cả sự Biến Đổi. Liệu vai trò thật sự của nhóm Thomas trong toàn bộ chuyện này là gì? Sẽ thế nào nếu họ biết rằng còn có những Mê Cung khác ngoài nơi mà họ vừa thoát ra?',
    popularity: 115.133,
    poster_path:
      'https://image.tmdb.org/t/p/w342/dGHToc6J9GPNAyPb9Fa2u5G2sk0.jpg',
    production_companies: [
      {
        id: 12292,
        logo_path: '/llGRXF5WYUW2fzXg0ebCoKMXjmT.png',
        name: 'Temple Hill Entertainment',
        origin_country: 'US',
      },
      {
        id: 3672,
        logo_path: '/5VWXJgYYrJZUE0hixvBdVfGSfmo.png',
        name: 'Gotham Group',
        origin_country: 'US',
      },
      {
        id: 22213,
        logo_path: '/qx9K6bFWJupwde0xQDwOvXkOaL8.png',
        name: 'TSG Entertainment',
        origin_country: 'US',
      },
      {
        id: 25,
        logo_path: '/qZCc1lty5FzX30aOCVRBLzaVmcp.png',
        name: '20th Century Fox',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2015-09-09',
    revenue: 312296056,
    runtime: 131,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'The Maze Was Just the Beginning.',
    title: 'Giải Mã Mê Cung 2: Thử Nghiệm Đất Cháy',
    video: false,
    vote_average: 6.7,
    vote_count: 8578,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Official Trailer 2',
          key: 'SDofO3P2HpE',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2015-07-24T00:29:58.000Z',
          id: '5dbf14adf1b5710010e6f1d0',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Official Trailer',
          key: '-44_igsZtgU',
          published_at: '2015-05-19T13:00:20.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '555b7d37c3a3681024002d40',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 527393,
          known_for_department: 'Diễn viên',
          name: "Dylan O'Brien",
          original_name: "Dylan O'Brien",
          popularity: 6.467,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cOP4CLCPUp8Nkjvwqv7DW6wvG5i.jpg',
          cast_id: 0,
          character: 'Thomas',
          credit_id: '5444af56c3a3683df2006daa',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 1310760,
          known_for_department: 'Diễn viên',
          name: 'Ki Hong Lee',
          original_name: 'Ki Hong Lee',
          popularity: 2.983,
          profile_path:
            'https://image.tmdb.org/t/p/w185/96zkB3e07LB1hw2segekZS1PlQb.jpg',
          cast_id: 3,
          character: 'Minho',
          credit_id: '5444af7e0e0a26633a006e74',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 115150,
          known_for_department: 'Diễn viên',
          name: 'Kaya Scodelario',
          original_name: 'Kaya Scodelario',
          popularity: 30.895,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oKsGrXKGrcVoQJQ6pbjZDPOQJcM.jpg',
          cast_id: 2,
          character: 'Teresa Agnes',
          credit_id: '5444af6f0e0a26632d006cd2',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 25663,
          known_for_department: 'Diễn viên',
          name: 'Thomas Brodie-Sangster',
          original_name: 'Thomas Brodie-Sangster',
          popularity: 12.902,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eFqJ1RbGChKJYRpd9iiwzQrgCED.jpg',
          cast_id: 1,
          character: 'Newt',
          credit_id: '5444af64c3a36819fb000d2b',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 1036196,
          known_for_department: 'Diễn viên',
          name: 'Dexter Darden',
          original_name: 'Dexter Darden',
          popularity: 3.821,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4Io5JOdl17GtCaXt0ZBv0p6IEEk.jpg',
          cast_id: 15,
          character: 'Frypan',
          credit_id: '55e2ab3b92514162c2001de3',
          order: 4,
        },
        {
          adult: false,
          gender: 0,
          id: 1340889,
          known_for_department: 'Diễn viên',
          name: 'Alexander Flores',
          original_name: 'Alexander Flores',
          popularity: 2.853,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sgosc9u09TUWm5oJFtNFF2dSlIy.jpg',
          cast_id: 121,
          character: 'Winston',
          credit_id: '5849a5d692514119bf0151fc',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 1171570,
          known_for_department: 'Diễn viên',
          name: 'Jacob Lofland',
          original_name: 'Jacob Lofland',
          popularity: 3.386,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hlDVsEhgvNX5xnAcqX3HaBXAgNS.jpg',
          cast_id: 15,
          character: 'Aris Jones',
          credit_id: '55e2ab3b92514162bf001d79',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 973667,
          known_for_department: 'Diễn viên',
          name: 'Rosa Salazar',
          original_name: 'Rosa Salazar',
          popularity: 8.991,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iJfsx7u76qWonJm6sKGwYPbNWDR.jpg',
          cast_id: 14,
          character: 'Brenda',
          credit_id: '55e2ab3bc3a3680b6c001e4c',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 4808,
          known_for_department: 'Diễn viên',
          name: 'Giancarlo Esposito',
          original_name: 'Giancarlo Esposito',
          popularity: 4.733,
          profile_path:
            'https://image.tmdb.org/t/p/w185/t8hlrcfKDI8Kl5yyiXoh6VWGlIg.jpg',
          cast_id: 4,
          character: 'Jorge',
          credit_id: '5444af8bc3a36819fb000d31',
          order: 8,
        },
        {
          adult: false,
          gender: 1,
          id: 1276,
          known_for_department: 'Diễn viên',
          name: 'Patricia Clarkson',
          original_name: 'Patricia Clarkson',
          popularity: 5.204,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rHHM9G83fpBAcFathbSyV4Tot5j.jpg',
          cast_id: 7,
          character: 'Ava Paige',
          credit_id: '547f9e599251416e720001de',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 49735,
          known_for_department: 'Diễn viên',
          name: 'Aidan Gillen',
          original_name: 'Aidan Gillen',
          popularity: 5.256,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ju5ho6nnwOQ2QLGLnDP9yOZhGpb.jpg',
          cast_id: 6,
          character: 'Janson',
          credit_id: '547f9e46c3a36829b2000241',
          order: 10,
        },
        {
          adult: false,
          gender: 1,
          id: 3127,
          known_for_department: 'Diễn viên',
          name: 'Lili Taylor',
          original_name: 'Lili Taylor',
          popularity: 4.31,
          profile_path:
            'https://image.tmdb.org/t/p/w185/if8rbaj1TXlzg0Oq4g0bpU3b5rh.jpg',
          cast_id: 8,
          character: 'Mary Cooper',
          credit_id: '547f9e6e9251416e7e0001ec',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 12834,
          known_for_department: 'Diễn viên',
          name: 'Barry Pepper',
          original_name: 'Barry Pepper',
          popularity: 4.481,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pmdNUqrpsoozh7QYqUgEgZQ69cA.jpg',
          cast_id: 12,
          character: 'Vince',
          credit_id: '55e284cbc3a3680b690015d9',
          order: 12,
        },
        {
          adult: false,
          gender: 1,
          id: 1251069,
          known_for_department: 'Diễn viên',
          name: 'Nathalie Emmanuel',
          original_name: 'Nathalie Emmanuel',
          popularity: 13.691,
          profile_path:
            'https://image.tmdb.org/t/p/w185/722FrTqERFzH7Sra9SLgr8CLqws.jpg',
          cast_id: 10,
          character: 'Harriet',
          credit_id: '547f9e8d9251416e7b0001b1',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 21088,
          known_for_department: 'Diễn viên',
          name: 'Alan Tudyk',
          original_name: 'Alan Tudyk',
          popularity: 5.373,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jUuUbPuMGonFT5E2pcs4alfqaCN.jpg',
          cast_id: 35,
          character: 'Blondie',
          credit_id: '560c2b65c3a36868100066ac',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 1576251,
          known_for_department: 'Diễn viên',
          name: 'Terry Dale Parks',
          original_name: 'Terry Dale Parks',
          popularity: 1.395,
          profile_path: null,
          cast_id: 116,
          character: 'Carl (Masked Man)',
          credit_id: '56bdc40592514140a6000e65',
          order: 15,
        },
        {
          adult: false,
          gender: 0,
          id: 1446097,
          known_for_department: 'Diễn viên',
          name: 'Kathryn Smith-McGlynn',
          original_name: 'Kathryn Smith-McGlynn',
          popularity: 0.6,
          profile_path: null,
          cast_id: 122,
          character: 'Dr. Crawford',
          credit_id: '5849a83692514119b30151ff',
          order: 16,
        },
        {
          adult: false,
          gender: 0,
          id: 1719996,
          known_for_department: 'Diễn viên',
          name: 'Matt Metzler',
          original_name: 'Matt Metzler',
          popularity: 0.6,
          profile_path: null,
          cast_id: 123,
          character: 'Barkley',
          credit_id: '584a0c6dc3a36814110196cd',
          order: 17,
        },
        {
          adult: false,
          gender: 1,
          id: 53971,
          known_for_department: 'Diễn viên',
          name: 'Jenny Gabrielle',
          original_name: 'Jenny Gabrielle',
          popularity: 1.593,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9pYUoRiCiJbT04JDXvLo4XXJ2P6.jpg',
          cast_id: 16,
          character: 'Ponytail',
          credit_id: '55e2ab3b92514162bb001c74',
          order: 18,
        },
        {
          adult: false,
          gender: 0,
          id: 79211,
          known_for_department: 'Diễn viên',
          name: 'David House',
          original_name: 'David House',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/t67HnLsCMecFLMdhtJQbkiQiyXq.jpg',
          cast_id: 124,
          character: 'Soldier',
          credit_id: '584a0d9cc3a368141101974b',
          order: 19,
        },
        {
          adult: false,
          gender: 1,
          id: 1151637,
          known_for_department: 'Diễn viên',
          name: 'Lora Martinez-Cunningham',
          original_name: 'Lora Martinez-Cunningham',
          popularity: 1.873,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gjbnJZCzNkshj2bKEe51sEcnPOV.jpg',
          cast_id: 13,
          character: "Thomas' Mother",
          credit_id: '55e2aaf492514162d0001ba5',
          order: 20,
        },
        {
          adult: false,
          gender: 0,
          id: 1719998,
          known_for_department: 'Diễn viên',
          name: 'Luke Gallegos',
          original_name: 'Luke Gallegos',
          popularity: 1.38,
          profile_path: null,
          cast_id: 125,
          character: 'Young Thomas',
          credit_id: '584a0e0c92514157fa007f67',
          order: 21,
        },
        {
          adult: false,
          gender: 0,
          id: 108036,
          known_for_department: 'Diễn viên',
          name: 'Shawn Prince',
          original_name: 'Shawn Prince',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/a0vl3ygNPOXNXahyAXYWGTQ0Zyo.jpg',
          cast_id: 36,
          character: 'David',
          credit_id: '563fe479c3a3681b5403202d',
          order: 22,
        },
        {
          adult: false,
          gender: 0,
          id: 1207564,
          known_for_department: 'Diễn viên',
          name: 'Jeremy Becerra',
          original_name: 'Jeremy Becerra',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8rFnPT7DoK165oBLAAZ1PhBJGMA.jpg',
          cast_id: 126,
          character: 'Riley',
          credit_id: '584b1fdcc3a368397200289b',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 1094319,
          known_for_department: 'Diễn viên',
          name: 'Matthew Page',
          original_name: 'Matthew Page',
          popularity: 3.71,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vMI1zxybJONZYqL8MI9gGxyfqfC.jpg',
          cast_id: 127,
          character: 'Harold (Soldier)',
          credit_id: '584b20f592514133b9002ad4',
          order: 24,
        },
        {
          adult: false,
          gender: 2,
          id: 307885,
          known_for_department: 'Diễn viên',
          name: 'Alex Knight',
          original_name: 'Alex Knight',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eojFYCdbTnv5VegIMoCVrJXur3K.jpg',
          cast_id: 128,
          character: 'Aide',
          credit_id: '584b216c92514133b3002a38',
          order: 25,
        },
        {
          adult: false,
          gender: 0,
          id: 1720434,
          known_for_department: 'Diễn viên',
          name: 'Marc Comstock',
          original_name: 'Marc Comstock',
          popularity: 0.6,
          profile_path: null,
          cast_id: 129,
          character: 'Med Tech',
          credit_id: '584b22e692514133bd002844',
          order: 26,
        },
        {
          adult: false,
          gender: 0,
          id: 1574846,
          known_for_department: 'Diễn viên',
          name: 'Brandon K. Hampton',
          original_name: 'Brandon K. Hampton',
          popularity: 0.652,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yJTVAtgPixDX6qU4O9B5xGfc0XW.jpg',
          cast_id: 130,
          character: 'Surveillance Room Attendant',
          credit_id: '584b29a8c3a368397a002f4c',
          order: 27,
        },
        {
          adult: false,
          gender: 2,
          id: 1488513,
          known_for_department: 'Diễn viên',
          name: 'John Trejo',
          original_name: 'John Trejo',
          popularity: 1.025,
          profile_path: null,
          cast_id: 120,
          character: 'M3 Soldier',
          credit_id: '57ca05afc3a3684b97000455',
          order: 28,
        },
        {
          adult: false,
          gender: 1,
          id: 968006,
          known_for_department: 'Diễn viên',
          name: 'Katherine McNamara',
          original_name: 'Katherine McNamara',
          popularity: 8.506,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cuGVMcnpi6HjobaGADo1xtaDglR.jpg',
          cast_id: 9,
          character: 'Sonya',
          credit_id: '547f9e7ec3a36829b2000248',
          order: 29,
        },
        {
          adult: false,
          gender: 2,
          id: 1112417,
          known_for_department: 'Diễn viên',
          name: 'Tatanka Means',
          original_name: 'Tatanka Means',
          popularity: 1.052,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vf5h5mlGRrQI5DGCRD1hM01MHah.jpg',
          cast_id: 15,
          character: 'Joe',
          credit_id: '55e2ab3bc3a3681c6a000277',
          order: 30,
        },
        {
          adult: false,
          gender: 2,
          id: 1670754,
          known_for_department: 'Diễn viên',
          name: 'Ryan Jason Cook',
          original_name: 'Ryan Jason Cook',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kPmz7t9z9h7lhCCsPZj9jOgnjOQ.jpg',
          cast_id: 131,
          character: 'Nurse',
          credit_id: '584b2b3392514133ad002d59',
          order: 31,
        },
        {
          adult: false,
          gender: 2,
          id: 1505457,
          known_for_department: 'Diễn viên',
          name: 'James Burnett',
          original_name: 'James Burnett',
          popularity: 0.982,
          profile_path: null,
          cast_id: 132,
          character: 'Rebel Sentry',
          credit_id: '584b2bacc3a3683975002c2b',
          order: 32,
        },
        {
          adult: false,
          gender: 0,
          id: 223395,
          known_for_department: 'Diễn viên',
          name: 'Morse Bicknell',
          original_name: 'Morse Bicknell',
          popularity: 1.008,
          profile_path:
            'https://image.tmdb.org/t/p/w185/14z7m7PpgLpNWN5EShCmKmm12zb.jpg',
          cast_id: 133,
          character: 'Doctor',
          credit_id: '584b2bf892514133ad002dd3',
          order: 33,
        },
        {
          adult: false,
          gender: 1,
          id: 2321359,
          known_for_department: 'Diễn viên',
          name: 'Adriana Acosta',
          original_name: 'Adriana Acosta',
          popularity: 1.388,
          profile_path:
            'https://image.tmdb.org/t/p/w185/AefmseQ2CHL5jY7JM48lwXnOgeS.jpg',
          cast_id: 138,
          character: 'Glader (uncredited)',
          credit_id: '5dbed5499638640012e3ca2d',
          order: 34,
        },
        {
          adult: false,
          gender: 0,
          id: 1670762,
          known_for_department: 'Costume & Make-Up',
          name: 'Brian Barela',
          original_name: 'Brian Barela',
          popularity: 0.6,
          profile_path: null,
          cast_id: 139,
          character: 'Bunker Soldier (uncredited)',
          credit_id: '5dbed55f9d893900152e2c1b',
          order: 35,
        },
        {
          adult: false,
          gender: 1,
          id: 1673619,
          known_for_department: 'Costume & Make-Up',
          name: 'Laramie Cooley',
          original_name: 'Laramie Cooley',
          popularity: 0.661,
          profile_path: null,
          cast_id: 119,
          character: 'Abigail (uncredited)',
          credit_id: '57c9ffda925141278a00022a',
          order: 36,
        },
        {
          adult: false,
          gender: 2,
          id: 1527957,
          known_for_department: 'Diễn viên',
          name: 'Jetto Dorsainville',
          original_name: 'Jetto Dorsainville',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9d4qY9HVlozo7qzkY8LNLSiMTGR.jpg',
          cast_id: 142,
          character: 'WCKD / Bunker Militia (uncredited)',
          credit_id: '5dbed59d9638640014e39366',
          order: 37,
        },
        {
          adult: false,
          gender: 1,
          id: 1884649,
          known_for_department: 'Diễn viên',
          name: 'Andrea Good',
          original_name: 'Andrea Good',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mJZYKe65wAY53QTht9KkgPpgFuL.jpg',
          cast_id: 146,
          character: 'Ash People (uncredited)',
          credit_id: '5dbed5eb7d2bc10013364fc1',
          order: 38,
        },
        {
          adult: false,
          gender: 0,
          id: 2164309,
          known_for_department: 'Art',
          name: 'Carma Harvey',
          original_name: 'Carma Harvey',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iX1B198At26oRdcghQcs96T9Rgv.jpg',
          cast_id: 148,
          character: 'Scavenger (uncredited)',
          credit_id: '5dbed6fc7d2bc10017361d00',
          order: 39,
        },
        {
          adult: false,
          gender: 0,
          id: 1415421,
          known_for_department: 'Diễn viên',
          name: 'Gary Hood',
          original_name: 'Gary Hood',
          popularity: 0.6,
          profile_path: null,
          cast_id: 149,
          character: 'Glader (uncredited)',
          credit_id: '5dbed746efe37c00138342aa',
          order: 40,
        },
        {
          adult: false,
          gender: 2,
          id: 78890,
          known_for_department: 'Diễn viên',
          name: 'Keith Jardine',
          original_name: 'Keith Jardine',
          popularity: 2.187,
          profile_path:
            'https://image.tmdb.org/t/p/w185/emN5dXAoqW9Naab4g3yOwxSfkvh.jpg',
          cast_id: 15,
          character: 'Scavenger Guard (Jim) (uncredited)',
          credit_id: '55e2ab3bc3a3680b65001ce5',
          order: 41,
        },
        {
          adult: false,
          gender: 2,
          id: 2025753,
          known_for_department: 'Crew',
          name: 'Jess King',
          original_name: 'Jess King',
          popularity: 1.614,
          profile_path:
            'https://image.tmdb.org/t/p/w185/o7abcDW4IN0SOV2eYVcCtd1mPLM.jpg',
          cast_id: 151,
          character: 'WCKD Soldier (uncredited)',
          credit_id: '5dbed8c4efe37c001383453c',
          order: 42,
        },
        {
          adult: false,
          gender: 0,
          id: 2293043,
          known_for_department: 'Diễn viên',
          name: 'John Christian Love',
          original_name: 'John Christian Love',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rMCi2a1zuFq1C8BHsOQQLhlg2Fi.jpg',
          cast_id: 137,
          character: 'Surveillance Room Attendant',
          credit_id: '5dbed4ed7d2bc10011360da9',
          order: 43,
        },
        {
          adult: false,
          gender: 2,
          id: 1365516,
          known_for_department: 'Diễn viên',
          name: 'Martin Palmer',
          original_name: 'Martin Palmer',
          popularity: 1.467,
          profile_path:
            'https://image.tmdb.org/t/p/w185/s8SNGCcNu00ca0KxDDx5uVWNjad.jpg',
          cast_id: 160,
          character: 'Rave Party Guest (uncredited)',
          credit_id: '5dbedbb47d2bc1001736252f',
          order: 44,
        },
        {
          adult: false,
          gender: 2,
          id: 1480202,
          known_for_department: 'Diễn viên',
          name: 'Frank Powers',
          original_name: 'Frank Powers',
          popularity: 0.694,
          profile_path: null,
          cast_id: 162,
          character: 'Soldier (uncredited)',
          credit_id: '5dbedbd4efe37c00188339c5',
          order: 45,
        },
        {
          adult: false,
          gender: 2,
          id: 1243782,
          known_for_department: 'Diễn viên',
          name: 'Ben Pronsky',
          original_name: 'Ben Pronsky',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/d4I1Y8LiELi6mY8A9RLX0ZHfdlL.jpg',
          cast_id: 163,
          character: 'Additional Voices (voice) (uncredited)',
          credit_id: '5dbedbe47d2bc1001736258d',
          order: 46,
        },
        {
          adult: false,
          gender: 2,
          id: 1808784,
          known_for_department: 'Diễn viên',
          name: 'James Tyler Robinson',
          original_name: 'James Tyler Robinson',
          popularity: 0.6,
          profile_path: null,
          cast_id: 165,
          character: 'Glader (uncredited)',
          credit_id: '5dbedbfa9d893900182e61f8',
          order: 47,
        },
        {
          adult: false,
          gender: 0,
          id: 1116699,
          known_for_department: 'Diễn viên',
          name: 'Gonzalo Robles',
          original_name: 'Gonzalo Robles',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ujtPkOgFVnsEGUrKWxD4q7NJEZC.jpg',
          cast_id: 166,
          character: 'Hazmat Soldier (uncredited)',
          credit_id: '5dbedc059d893900132e2e97',
          order: 48,
        },
        {
          adult: false,
          gender: 2,
          id: 1415436,
          known_for_department: 'Diễn viên',
          name: 'Bryce Romero',
          original_name: 'Bryce Romero',
          popularity: 1.718,
          profile_path:
            'https://image.tmdb.org/t/p/w185/750m9cmdAsNnxJEdziiFtd0VDx3.jpg',
          cast_id: 17,
          character: 'Jack (uncredited)',
          credit_id: '55e2ab3bc3a3680b4f001ea3',
          order: 49,
        },
        {
          adult: false,
          gender: 2,
          id: 1174371,
          known_for_department: 'Camera',
          name: 'Diego Romero',
          original_name: 'Diego Romero',
          popularity: 0.6,
          profile_path: null,
          cast_id: 167,
          character: 'Scavenger Guard (uncredited)',
          credit_id: '5dbedc229638640014e39f20',
          order: 50,
        },
        {
          adult: false,
          gender: 2,
          id: 1204226,
          known_for_department: 'Diễn viên',
          name: 'J. Nathan Simmons',
          original_name: 'J. Nathan Simmons',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/obcEumoCx3pXhhZBZcsImV3OtxQ.jpg',
          cast_id: 168,
          character: 'Ash Mob Evacuee (uncredited)',
          credit_id: '5dbedc2d9638640014e39f2a',
          order: 51,
        },
        {
          adult: false,
          gender: 0,
          id: 1505502,
          known_for_department: 'Diễn viên',
          name: 'Kaelee Vigil',
          original_name: 'Kaelee Vigil',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lYEh8UQM9f6vuoADep7efv221Hd.jpg',
          cast_id: 171,
          character: 'Civilian (uncredited)',
          credit_id: '5dbedc52efe37c0015830f2a',
          order: 52,
        },
        {
          adult: false,
          gender: 2,
          id: 1650124,
          known_for_department: 'Diễn viên',
          name: 'Alexander Wagenman',
          original_name: 'Alexander Wagenman',
          popularity: 0.6,
          profile_path: null,
          cast_id: 173,
          character: 'Kid on Train (uncredited)',
          credit_id: '5dbedc6a9638640012e3d4f3',
          order: 53,
        },
        {
          adult: false,
          gender: 2,
          id: 1673637,
          known_for_department: 'Diễn viên',
          name: 'Richard Daniel Williams',
          original_name: 'Richard Daniel Williams',
          popularity: 0.6,
          profile_path: null,
          cast_id: 174,
          character: 'Right Arm Militia (uncredited)',
          credit_id: '5dbedc789638640012e3d4f8',
          order: 54,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 1,
          id: 2215,
          known_for_department: 'Production',
          name: 'Denise Chamian',
          original_name: 'Denise Chamian',
          popularity: 0.694,
          profile_path: null,
          credit_id: '55fe9c50c3a3681334002f5b',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 1,
          id: 2519,
          known_for_department: 'Costume & Make-Up',
          name: 'Sanja Milković Hays',
          original_name: 'Sanja Milković Hays',
          popularity: 1.4,
          profile_path: null,
          credit_id: '55fa8f0fc3a3683136001aba',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 2,
          id: 6040,
          known_for_department: 'Production',
          name: 'Wyck Godfrey',
          original_name: 'Wyck Godfrey',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tKoS0O3m1UROqeM9ZLLfbvgY6Vf.jpg',
          credit_id: '55fa9152c3a3683138001d38',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 6043,
          known_for_department: 'Editing',
          name: 'Dan Zimmerman',
          original_name: 'Dan Zimmerman',
          popularity: 0.738,
          profile_path: null,
          credit_id: '55fa8f31c3a3683138001cce',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 12945,
          known_for_department: 'Sound',
          name: 'Jeff Carson',
          original_name: 'Jeff Carson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b086269251410b4b001de4',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 16177,
          known_for_department: 'Sound',
          name: 'Ron Bartlett',
          original_name: 'Ron Bartlett',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/AmFG81joHLkvnh4Io20TdCCBk8P.jpg',
          credit_id: '56b08c5d9251410b370020b4',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 19291,
          known_for_department: 'Art',
          name: 'Daniel T. Dorrance',
          original_name: 'Daniel T. Dorrance',
          popularity: 0.6,
          profile_path: null,
          credit_id: '55fa8fa492514132f100195e',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 2,
          id: 25046,
          known_for_department: 'Production',
          name: 'Marty Bowen',
          original_name: 'Marty Bowen',
          popularity: 2.18,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4G0hk2Pvc9Au6WEdYBv7g2nN7mt.jpg',
          credit_id: '55fa916492514132eb0019c0',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 30459,
          known_for_department: 'Camera',
          name: 'Gyula Pados',
          original_name: 'Gyula Pados',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/x8DiXFYllKoODQfpXyCH7QEjv8C.jpg',
          credit_id: '55fa8fde92514132e1001931',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 41592,
          known_for_department: 'Art',
          name: 'Andrew Max Cahn',
          original_name: 'Andrew Max Cahn',
          popularity: 0.829,
          profile_path: null,
          credit_id: '56b07d079251410b43001bca',
          department: 'Art',
          job: 'Supervising Art Director',
        },
        {
          adult: false,
          gender: 2,
          id: 113013,
          known_for_department: 'Production',
          name: 'David McKimmie',
          original_name: 'David McKimmie',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b97a4ca676002de3f623',
          department: 'Crew',
          job: 'Post Production Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 113041,
          known_for_department: 'Sound',
          name: 'David Betancourt',
          original_name: 'David Betancourt',
          popularity: 0.608,
          profile_path: null,
          credit_id: '60e4c17e22e480006033324b',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 113043,
          known_for_department: 'Sound',
          name: 'Scott Curtis',
          original_name: 'Scott Curtis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4c0ba6bdec300460b66e5',
          department: 'Sound',
          job: 'Foley Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 113048,
          known_for_department: 'Sound',
          name: 'Tim Gomillion',
          original_name: 'Tim Gomillion',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5adf36b1925141133100b24f',
          department: 'Sound',
          job: 'Sound Recordist',
        },
        {
          adult: false,
          gender: 0,
          id: 113049,
          known_for_department: 'Sound',
          name: 'Galen Goodpaster',
          original_name: 'Galen Goodpaster',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4c10a27ff99005dfc11a2',
          department: 'Sound',
          job: 'First Assistant Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 113086,
          known_for_department: 'Sound',
          name: 'John Murray',
          original_name: 'John Murray',
          popularity: 0.98,
          profile_path: null,
          credit_id: '60e4c06707faa2003018048c',
          department: 'Sound',
          job: 'Foley Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 66668,
          known_for_department: 'Diễn viên',
          name: 'Steve DeCastro',
          original_name: 'Steve DeCastro',
          popularity: 0.748,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vhBvctoNjv2tjGKvImNP8vWeuAy.jpg',
          credit_id: '60e4ab2184591c0045c57503',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 77949,
          known_for_department: 'Sound',
          name: 'John Paesano',
          original_name: 'John Paesano',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pHQM6fGdewxwoqzTEMmHonX4KFz.jpg',
          credit_id: '5adf36d3c3a3686adf00bec8',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 89714,
          known_for_department: 'Diễn viên',
          name: 'Ilram Choi',
          original_name: 'Ilram Choi',
          popularity: 1.094,
          profile_path: null,
          credit_id: '60e4aa6d26dac10023623f22',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 91123,
          known_for_department: 'Camera',
          name: 'Michael Kelem',
          original_name: 'Michael Kelem',
          popularity: 0.828,
          profile_path: null,
          credit_id: '56b086d79251410b4b001e03',
          department: 'Camera',
          job: 'Helicopter Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 91161,
          known_for_department: 'Production',
          name: 'Joe Hartwick Jr.',
          original_name: 'Joe Hartwick Jr.',
          popularity: 0.694,
          profile_path: null,
          credit_id: '55fa91bfc3a3683126001abb',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 109870,
          known_for_department: 'Costume & Make-Up',
          name: 'Tom Woodruff Jr.',
          original_name: 'Tom Woodruff Jr.',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/o5MW7KiROaA5uf9zzJmpHJfUjh3.jpg',
          credit_id: '56b084609251410b3a001de2',
          department: 'Costume & Make-Up',
          job: 'Makeup Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 148697,
          known_for_department: 'Art',
          name: 'Kelly Berry',
          original_name: 'Kelly Berry',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b07d40925141580a0012f1',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 2,
          id: 149731,
          known_for_department: 'Diễn viên',
          name: 'Mark Ginther',
          original_name: 'Mark Ginther',
          popularity: 0.67,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kaaLC5LcqpsLIdbaINQuUfbbrCr.jpg',
          credit_id: '60e4ad6f22e480006033034c',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 228253,
          known_for_department: 'Crew',
          name: 'Thomas E. Surprenant',
          original_name: 'Thomas E. Surprenant',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b0851fc3a3686480002037',
          department: 'Crew',
          job: 'Makeup Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 553928,
          known_for_department: 'Costume & Make-Up',
          name: 'Frieda Valenzuela',
          original_name: 'Frieda Valenzuela',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b0842fc3a3686480002013',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 574355,
          known_for_department: 'Crew',
          name: 'Glenn Foster',
          original_name: 'Glenn Foster',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nRdq7M6vXiXwtLHWKkCXzXS8Yzo.jpg',
          credit_id: '60e4acdc4ca676002de3d89b',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 1,
          id: 995358,
          known_for_department: 'Diễn viên',
          name: 'Alice Rietveld',
          original_name: 'Alice Rietveld',
          popularity: 2.554,
          profile_path:
            'https://image.tmdb.org/t/p/w185/41YzcR3uqLsTxsOcB9hmgEViHnk.jpg',
          credit_id: '60e4af2307faa200602ff28d',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1049137,
          known_for_department: 'Crew',
          name: 'Torrey Vogel',
          original_name: 'Torrey Vogel',
          popularity: 1.094,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2cEBDWZ3gD6BYgC3PhFb85LT9mc.jpg',
          credit_id: '60e4b16684591c002d724b3a',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1081074,
          known_for_department: 'Crew',
          name: 'George Cottle',
          original_name: 'George Cottle',
          popularity: 0.634,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jwQmBfZCJk7V9W96r7fXo3JGyMs.jpg',
          credit_id: '56b087e3c3a3686485001f5e',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1105706,
          known_for_department: 'Diễn viên',
          name: 'Tait Fletcher',
          original_name: 'Tait Fletcher',
          popularity: 4.72,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zAVsHT2GBLPaQ4RpTopnHvIrCbv.jpg',
          credit_id: '60e4ac99b76cbb002d4305b2',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1110109,
          known_for_department: 'Diễn viên',
          name: 'Damien Bray',
          original_name: 'Damien Bray',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4a95bdb154f001e6760e5',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1179066,
          known_for_department: 'Directing',
          name: 'Wes Ball',
          original_name: 'Wes Ball',
          popularity: 2.042,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zVPXrhuAxYAWlwDEWCaqeUPycFx.jpg',
          credit_id: '5444af9a0e0a266336006f5e',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1179066,
          known_for_department: 'Directing',
          name: 'Wes Ball',
          original_name: 'Wes Ball',
          popularity: 2.042,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zVPXrhuAxYAWlwDEWCaqeUPycFx.jpg',
          credit_id: '55fa8ff7c3a368313c001953',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1202779,
          known_for_department: 'Costume & Make-Up',
          name: 'Irena Stepić',
          original_name: 'Irena Stepić',
          popularity: 1.653,
          profile_path:
            'https://image.tmdb.org/t/p/w185/acN2okse9a9VjeZxOhBhPKVqHZ2.jpg',
          credit_id: '56b07de9c3a368647a001a92',
          department: 'Costume & Make-Up',
          job: 'Assistant Costume Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1228384,
          known_for_department: 'Directing',
          name: 'Steve Dubin',
          original_name: 'Steve Dubin',
          popularity: 0.84,
          profile_path: null,
          credit_id: '56b081ae92514156be00139a',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1231882,
          known_for_department: 'Production',
          name: 'Lindsay Williams',
          original_name: 'Lindsay Williams',
          popularity: 0.6,
          profile_path: null,
          credit_id: '55fa906992514132e7001930',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1257087,
          known_for_department: 'Biên kịch',
          name: 'James Dashner',
          original_name: 'James Dashner',
          popularity: 1.166,
          profile_path: null,
          credit_id: '55fa91e592514132e400193b',
          department: 'Biên kịch',
          job: 'Novel',
        },
        {
          adult: false,
          gender: 0,
          id: 1257144,
          known_for_department: 'Biên kịch',
          name: 'T.S. Nowlin',
          original_name: 'T.S. Nowlin',
          popularity: 1.339,
          profile_path: null,
          credit_id: '55fa91f292514132f4001935',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 0,
          id: 1257144,
          known_for_department: 'Biên kịch',
          name: 'T.S. Nowlin',
          original_name: 'T.S. Nowlin',
          popularity: 1.339,
          profile_path: null,
          credit_id: '55fa900692514132f40018ef',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1257754,
          known_for_department: 'Production',
          name: 'Ellen Goldsmith-Vein',
          original_name: 'Ellen Goldsmith-Vein',
          popularity: 0.98,
          profile_path: null,
          credit_id: '55fa912692514132ee00190b',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1269676,
          known_for_department: 'Costume & Make-Up',
          name: 'Karen McDonald',
          original_name: 'Karen McDonald',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b083f8c3a368647d001d37',
          department: 'Costume & Make-Up',
          job: 'Makeup Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 1287353,
          known_for_department: 'Costume & Make-Up',
          name: 'Jerrad Gray',
          original_name: 'Jerrad Gray',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b084d392514156be00141a',
          department: 'Crew',
          job: 'Makeup Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1328142,
          known_for_department: 'Production',
          name: 'Lee Stollman',
          original_name: 'Lee Stollman',
          popularity: 1.38,
          profile_path: null,
          credit_id: '55fa91a7c3a3683138001d45',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1330079,
          known_for_department: 'Art',
          name: 'Bjarne Sletteland',
          original_name: 'Bjarne Sletteland',
          popularity: 1.103,
          profile_path: null,
          credit_id: '60e4b265258823005d8145a5',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 1335375,
          known_for_department: 'Crew',
          name: 'Edward A. Duran',
          original_name: 'Edward A. Duran',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mzPJkVKg7ve3whmvyf2TyDIuewr.jpg',
          credit_id: '60e4ac0122e48000800e7d72',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1338372,
          known_for_department: 'Sound',
          name: "Dan O'Connell",
          original_name: "Dan O'Connell",
          popularity: 1.665,
          profile_path: null,
          credit_id: '56b08ba5925141580a001537',
          department: 'Sound',
          job: 'Foley',
        },
        {
          adult: false,
          gender: 0,
          id: 1344908,
          known_for_department: 'Visual Effects',
          name: 'Victor Huang',
          original_name: 'Victor Huang',
          popularity: 0.656,
          profile_path: null,
          credit_id: '56b07f53925141580a001342',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1347740,
          known_for_department: 'Sound',
          name: 'Shayna Brown',
          original_name: 'Shayna Brown',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b08c72c3a3686485002063',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1357044,
          known_for_department: 'Art',
          name: 'Richard K. Buoen',
          original_name: 'Richard K. Buoen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b0854c9251410b37001f2f',
          department: 'Art',
          job: 'Conceptual Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1357056,
          known_for_department: 'Art',
          name: 'Siobhan Roome',
          original_name: 'Siobhan Roome',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b37927ff99005dfbf94d',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1360099,
          known_for_department: 'Sound',
          name: 'Lee Gilmore',
          original_name: 'Lee Gilmore',
          popularity: 0.98,
          profile_path: null,
          credit_id: '56b08c12c3a3686477001d48',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1367493,
          known_for_department: 'Sound',
          name: 'John T. Cucci',
          original_name: 'John T. Cucci',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b08bbac3a3686480002172',
          department: 'Sound',
          job: 'Foley',
        },
        {
          adult: false,
          gender: 1,
          id: 1367494,
          known_for_department: 'Sound',
          name: 'Ai-Ling Lee',
          original_name: 'Ai-Ling Lee',
          popularity: 0.649,
          profile_path: null,
          credit_id: '56b08bdec3a3686477001d3a',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 1367494,
          known_for_department: 'Sound',
          name: 'Ai-Ling Lee',
          original_name: 'Ai-Ling Lee',
          popularity: 0.649,
          profile_path: null,
          credit_id: '56b08cb7c3a36864800021ae',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1367498,
          known_for_department: 'Visual Effects',
          name: 'Scott Puckett',
          original_name: 'Scott Puckett',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b081c59251410b43001cb3',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1367508,
          known_for_department: 'Directing',
          name: 'Steve Gehrke',
          original_name: 'Steve Gehrke',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b07ebc9251410b4b001c7b',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1367516,
          known_for_department: 'Diễn viên',
          name: 'Timothy Eulich',
          original_name: 'Timothy Eulich',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xIfRmiBGtWogkRYAjbgIX7i4cuv.jpg',
          credit_id: '60e4ac3122e480006032fffd',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1368872,
          known_for_department: 'Visual Effects',
          name: 'Richard E. Hollander',
          original_name: 'Richard E. Hollander',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ffea4f9223e200040af66e8',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1391383,
          known_for_department: 'Art',
          name: 'Bill Holmquist',
          original_name: 'Bill Holmquist',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b085b7925141580a001460',
          department: 'Art',
          job: 'Construction Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1391695,
          known_for_department: 'Visual Effects',
          name: 'R. Christopher White',
          original_name: 'R. Christopher White',
          popularity: 0.84,
          profile_path: null,
          credit_id: '56b0821ec3a3686472001b05',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1395275,
          known_for_department: 'Camera',
          name: 'Richard Foreman Jr.',
          original_name: 'Richard Foreman Jr.',
          popularity: 0.98,
          profile_path: null,
          credit_id: '56b087149251410b3a001e58',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 2,
          id: 1397196,
          known_for_department: 'Sound',
          name: 'Bob Kellough',
          original_name: 'Bob Kellough',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b08c2cc3a368647d001ec8',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1397740,
          known_for_department: 'Production',
          name: 'Jonathon Slator',
          original_name: 'Jonathon Slator',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4bcde88bbe6005dee0378',
          department: 'Production',
          job: 'Location Manager',
        },
        {
          adult: false,
          gender: 2,
          id: 1398946,
          known_for_department: 'Sound',
          name: 'John A. Larsen',
          original_name: 'John A. Larsen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b9b96bdec300460b2b3c',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1400506,
          known_for_department: 'Editing',
          name: 'Lisa Tutunjian',
          original_name: 'Lisa Tutunjian',
          popularity: 0.98,
          profile_path: null,
          credit_id: '60e4c326b76cbb0073e30b50',
          department: 'Editing',
          job: 'Digital Intermediate Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1401591,
          known_for_department: 'Crew',
          name: 'Frank Torres',
          original_name: 'Frank Torres',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b0d72811a1007e7f451c',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1402005,
          known_for_department: 'Costume & Make-Up',
          name: 'Jesse Trevino',
          original_name: 'Jesse Trevino',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4bb4c6bdec300460b377d',
          department: 'Costume & Make-Up',
          job: 'Ager/Dyer',
        },
        {
          adult: false,
          gender: 0,
          id: 1402947,
          known_for_department: 'Costume & Make-Up',
          name: 'Sara Roybal',
          original_name: 'Sara Roybal',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b08411c3a3686475001f46',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1404276,
          known_for_department: 'Costume & Make-Up',
          name: 'Geordie Sheffer',
          original_name: 'Geordie Sheffer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b082b49251410b3d001e41',
          department: 'Costume & Make-Up',
          job: 'Hair Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 1404698,
          known_for_department: 'Diễn viên',
          name: 'Saleem Watley',
          original_name: 'Saleem Watley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b1af6ee3d7002c28fb77',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1406086,
          known_for_department: 'Art',
          name: 'Derrick Ballard',
          original_name: 'Derrick Ballard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b3a126dac1007ed1aefd',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1406128,
          known_for_department: 'Lighting',
          name: 'James R. Tynes',
          original_name: 'James R. Tynes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b0872c9251410b4b001e11',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 1,
          id: 1406131,
          known_for_department: 'Costume & Make-Up',
          name: 'Maria Bentfield',
          original_name: 'Maria Bentfield',
          popularity: 0.605,
          profile_path: null,
          credit_id: '60e4bab6db154f0047027d29',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1406903,
          known_for_department: 'Editing',
          name: 'Loan Phan',
          original_name: 'Loan Phan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4c30e4ca676005e165cae',
          department: 'Editing',
          job: 'Digital Intermediate Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1407239,
          known_for_department: 'Crew',
          name: 'Wolf Schneider',
          original_name: 'Wolf Schneider',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4bfcbb76cbb0073e302b1',
          department: 'Crew',
          job: 'Unit Publicist',
        },
        {
          adult: false,
          gender: 0,
          id: 1410448,
          known_for_department: 'Crew',
          name: 'Shane Daniels',
          original_name: 'Shane Daniels',
          popularity: 0.828,
          profile_path: null,
          credit_id: '60e4aad3a3b5e600458b5b67',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1411868,
          known_for_department: 'Art',
          name: 'Severino Gonzales',
          original_name: 'Severino Gonzales',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b5184ca676007506a74b',
          department: 'Costume & Make-Up',
          job: 'On Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 1412687,
          known_for_department: 'Directing',
          name: 'Dave Snyder',
          original_name: 'Dave Snyder',
          popularity: 0.98,
          profile_path: null,
          credit_id: '56b085089251410b3a001dfe',
          department: 'Crew',
          job: 'Makeup Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1418374,
          known_for_department: 'Visual Effects',
          name: 'Shaun Friedberg',
          original_name: 'Shaun Friedberg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b07fbec3a3686480001f30',
          department: 'Visual Effects',
          job: 'Animation Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1418377,
          known_for_department: 'Visual Effects',
          name: 'Leon Woud',
          original_name: 'Leon Woud',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b07fdf9251410b37001e3c',
          department: 'Visual Effects',
          job: 'Animation Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1419730,
          known_for_department: 'Editing',
          name: 'P.J. Burch',
          original_name: 'P.J. Burch',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b08ce49251410b370020c9',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1424696,
          known_for_department: 'Camera',
          name: 'David J. Thompson',
          original_name: 'David J. Thompson',
          popularity: 0.828,
          profile_path: null,
          credit_id: '56b086f39251410b3a001e53',
          department: 'Camera',
          job: 'Steadicam Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 1425329,
          known_for_department: 'Visual Effects',
          name: 'Jason Chen',
          original_name: 'Jason Chen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b081dcc3a3686475001ee7',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1425343,
          known_for_department: 'Sound',
          name: 'Vanessa Lapato',
          original_name: 'Vanessa Lapato',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4bfee8805510045d1a34b',
          department: 'Sound',
          job: 'ADR Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1429251,
          known_for_department: 'Costume & Make-Up',
          name: 'Gina G. Aller',
          original_name: 'Gina G. Aller',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b07e1892514156be0012d1',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1430493,
          known_for_department: 'Editing',
          name: 'Rolf Fleischmann',
          original_name: 'Rolf Fleischmann',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b0814cc3a3686475001ecb',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1435194,
          known_for_department: 'Sound',
          name: 'Charles Martin Inouye',
          original_name: 'Charles Martin Inouye',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b0863b9251410b4b001de6',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1439109,
          known_for_department: 'Costume & Make-Up',
          name: 'Nava R. Sadan',
          original_name: 'Nava R. Sadan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b07e049251410b4b001c59',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1440664,
          known_for_department: 'Crew',
          name: 'Isaac Hamon',
          original_name: 'Isaac Hamon',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yBGcINj11twiOoR4vckwd5VqBnY.jpg',
          credit_id: '56b08819c3a3686472001bee',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1443965,
          known_for_department: 'Costume & Make-Up',
          name: 'Kari King',
          original_name: 'Kari King',
          popularity: 0.98,
          profile_path: null,
          credit_id: '56b07e5e92514156be0012eb',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 2,
          id: 1444925,
          known_for_department: 'Crew',
          name: 'Patrick A. Reynolds Jr.',
          original_name: 'Patrick A. Reynolds Jr.',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4bf6a27ff9900470e596c',
          department: 'Crew',
          job: 'Transportation Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1445583,
          known_for_department: 'Crew',
          name: 'Adam Hart',
          original_name: 'Adam Hart',
          popularity: 0.728,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lVQreqn2sL33TgPlqY12YymQ3e8.jpg',
          credit_id: '60e4ae1225882300740df6aa',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1446554,
          known_for_department: 'Crew',
          name: 'Jon Shroyer',
          original_name: 'Jon Shroyer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b084499251410b3d001e91',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1449093,
          known_for_department: 'Diễn viên',
          name: 'Bryan Thompson',
          original_name: 'Bryan Thompson',
          popularity: 0.84,
          profile_path: null,
          credit_id: '60e4b0b807faa20048607bca',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1449946,
          known_for_department: 'Sound',
          name: 'David Wolowic',
          original_name: 'David Wolowic',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4c134258823005d816870',
          department: 'Sound',
          job: 'Assistant Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1453673,
          known_for_department: 'Crew',
          name: 'Mark Rayner',
          original_name: 'Mark Rayner',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/CyWEruffC3sfzKyDZ3UdXTMyEz.jpg',
          credit_id: '60e4af0983ee670027c3ddf1',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 1,
          id: 1453905,
          known_for_department: 'Crew',
          name: 'Kara Petersen',
          original_name: 'Kara Petersen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4ae7db76cbb005dfe7011',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1457327,
          known_for_department: 'Visual Effects',
          name: 'Jade Mansueto',
          original_name: 'Jade Mansueto',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b07ffe9251410b3d001ddb',
          department: 'Visual Effects',
          job: 'Animation Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1458089,
          known_for_department: 'Visual Effects',
          name: 'Aaron Gilman',
          original_name: 'Aaron Gilman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b080139251410b43001c61',
          department: 'Visual Effects',
          job: 'Animation Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1459645,
          known_for_department: 'Sound',
          name: 'Christine Sirois',
          original_name: 'Christine Sirois',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4c1abdb154f0074cadf1c',
          department: 'Sound',
          job: 'ADR Recordist',
        },
        {
          adult: false,
          gender: 0,
          id: 1481552,
          known_for_department: 'Production',
          name: 'Beth Day',
          original_name: 'Beth Day',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b07c7992514156be001288',
          department: 'Production',
          job: 'Casting Associate',
        },
        {
          adult: false,
          gender: 0,
          id: 1481560,
          known_for_department: 'Production',
          name: 'Liz Ludwitzke',
          original_name: 'Liz Ludwitzke',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b07c8ac3a3686477001a51',
          department: 'Production',
          job: 'Casting Associate',
        },
        {
          adult: false,
          gender: 0,
          id: 1483579,
          known_for_department: 'Visual Effects',
          name: 'Martin Wiseman',
          original_name: 'Martin Wiseman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b082029251410b37001ea2',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1494525,
          known_for_department: 'Costume & Make-Up',
          name: 'Megan Daum',
          original_name: 'Megan Daum',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b083e39251410b3a001dcf',
          department: 'Costume & Make-Up',
          job: 'Key Hair Stylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1511129,
          known_for_department: 'Production',
          name: 'Edward Gamarra',
          original_name: 'Edward Gamarra',
          popularity: 0.6,
          profile_path: null,
          credit_id: '55fa90d292514132f4001914',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1530322,
          known_for_department: 'Sound',
          name: 'Matthew Harrison',
          original_name: 'Matthew Harrison',
          popularity: 1.38,
          profile_path: null,
          credit_id: '60e4c0a52811a100470de974',
          department: 'Sound',
          job: 'Foley Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1535095,
          known_for_department: 'Crew',
          name: 'Dan Brown',
          original_name: 'Dan Brown',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/Aa65AAZkoxPGt7L5royKFHIehYb.jpg',
          credit_id: '60e4a9c088bbe60045d717d9',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1538207,
          known_for_department: 'Crew',
          name: 'David Greene',
          original_name: 'David Greene',
          popularity: 0.6,
          profile_path: null,
          credit_id: '573630b8925141136e0009f3',
          department: 'Crew',
          job: 'Special Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1549418,
          known_for_department: 'Art',
          name: 'Stephen P. Durante',
          original_name: 'Stephen P. Durante',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b4b5880551002d0b4300',
          department: 'Art',
          job: 'Leadman',
        },
        {
          adult: false,
          gender: 0,
          id: 1552365,
          known_for_department: 'Crew',
          name: 'Leonard MacDonald',
          original_name: 'Leonard MacDonald',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b084e6c3a368648000202d',
          department: 'Crew',
          job: 'Makeup Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1555488,
          known_for_department: 'Sound',
          name: 'Paul Ledford',
          original_name: 'Paul Ledford',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b90db76cbb0073e2f573',
          department: 'Sound',
          job: 'Production Sound Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 1564250,
          known_for_department: 'Sound',
          name: 'James Ashwill',
          original_name: 'James Ashwill',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4c1e207faa20060301bc1',
          department: 'Sound',
          job: 'Foley Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1569332,
          known_for_department: 'Visual Effects',
          name: 'Drew Nielsen',
          original_name: 'Drew Nielsen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b080da925141580a001389',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1569333,
          known_for_department: 'Visual Effects',
          name: "Keith O'Hara",
          original_name: "Keith O'Hara",
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b080eec3a368647d001cb3',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1569334,
          known_for_department: 'Visual Effects',
          name: 'Chloe Feodoroff',
          original_name: 'Chloe Feodoroff',
          popularity: 1.094,
          profile_path: null,
          credit_id: '56b080c5c3a368647d001cab',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1569802,
          known_for_department: 'Crew',
          name: 'Kevin Abercrombie',
          original_name: 'Kevin Abercrombie',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4a8ec4ca676004623137a',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1571475,
          known_for_department: 'Art',
          name: 'Billy W. Ray',
          original_name: 'Billy W. Ray',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b07d1ac3a368647d001bfa',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 1,
          id: 1571476,
          known_for_department: 'Art',
          name: 'Vicki M. McWilliams',
          original_name: 'Vicki M. McWilliams',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b07d709251410b4b001c42',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1571478,
          known_for_department: 'Costume & Make-Up',
          name: 'Rosanna Dill',
          original_name: 'Rosanna Dill',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b07e2e9251410b43001bfe',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1571481,
          known_for_department: 'Costume & Make-Up',
          name: 'Ashley Edwards',
          original_name: 'Ashley Edwards',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b07e489251410b3d001d76',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1571486,
          known_for_department: 'Costume & Make-Up',
          name: 'Lora McKenny',
          original_name: 'Lora McKenny',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b07e739251410b3d001d87',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 1,
          id: 1571488,
          known_for_department: 'Costume & Make-Up',
          name: 'Katie L. Murphy',
          original_name: 'Katie L. Murphy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b07e8ac3a368647d001c43',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1571490,
          known_for_department: 'Visual Effects',
          name: 'Isaac Hai Swee Tan',
          original_name: 'Isaac Hai Swee Tan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b07ed7c3a3686485001de0',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 1571494,
          known_for_department: 'Visual Effects',
          name: 'Craig Young',
          original_name: 'Craig Young',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b07f75c3a3686485001e10',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1571498,
          known_for_department: 'Visual Effects',
          name: 'Ken Barthelmey',
          original_name: 'Ken Barthelmey',
          popularity: 1.38,
          profile_path: null,
          credit_id: '56b08037c3a3686480001f47',
          department: 'Visual Effects',
          job: 'Creature Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1571499,
          known_for_department: 'Visual Effects',
          name: 'Margaux Peach',
          original_name: 'Margaux Peach',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b081039251410b4b001ce8',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1571500,
          known_for_department: 'Visual Effects',
          name: 'Jeremy Hollis',
          original_name: 'Jeremy Hollis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b0811d9251410b43001c93',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1571501,
          known_for_department: 'Visual Effects',
          name: 'Jana Jungk',
          original_name: 'Jana Jungk',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b08134c3a3686475001ec2',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 1,
          id: 1571508,
          known_for_department: 'Costume & Make-Up',
          name: 'Janessa Bouldin',
          original_name: 'Janessa Bouldin',
          popularity: 0.828,
          profile_path: null,
          credit_id: '56b0838892514156be0013de',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1571509,
          known_for_department: 'Costume & Make-Up',
          name: 'Reyna Robinson',
          original_name: 'Reyna Robinson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b08398c3a3686482001ed8',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1571510,
          known_for_department: 'Costume & Make-Up',
          name: 'Delana Veirs',
          original_name: 'Delana Veirs',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b083a9c3a3686485001ece',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1571511,
          known_for_department: 'Costume & Make-Up',
          name: 'Elizabeth Lawson',
          original_name: 'Elizabeth Lawson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b083bbc3a3686477001bc8',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1571512,
          known_for_department: 'Costume & Make-Up',
          name: 'Teri Ann Uccan',
          original_name: 'Teri Ann Uccan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b083d09251410b3a001dc3',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1571513,
          known_for_department: 'Crew',
          name: 'Daniel Casillas',
          original_name: 'Daniel Casillas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b084bec3a368647d001d5c',
          department: 'Crew',
          job: 'Makeup Effects',
        },
        {
          adult: false,
          gender: 2,
          id: 1571514,
          known_for_department: 'Crew',
          name: 'Brett Andrews',
          original_name: 'Brett Andrews',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5adf36ea0e0a2615f000c6b4',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 1571516,
          known_for_department: 'Camera',
          name: 'Sharla Cipicchio',
          original_name: 'Sharla Cipicchio',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b0875492514156be001476',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1571517,
          known_for_department: 'Camera',
          name: 'Daniel Bombell',
          original_name: 'Daniel Bombell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b08788925141580a001493',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1571518,
          known_for_department: 'Camera',
          name: 'Kingslea Bueltel',
          original_name: 'Kingslea Bueltel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b0879d9251410b3a001e6e',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1571521,
          known_for_department: 'Editing',
          name: 'David Zimmerman',
          original_name: 'David Zimmerman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b08cfdc3a368648500207c',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1571524,
          known_for_department: 'Lighting',
          name: 'Brian Malone',
          original_name: 'Brian Malone',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56b08e23c3a36864850020bb',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 2,
          id: 1622657,
          known_for_department: 'Crew',
          name: 'Mark Aaron Wagner',
          original_name: 'Mark Aaron Wagner',
          popularity: 0.6,
          profile_path: null,
          credit_id: '573e6559c3a3687adf000822',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1681201,
          known_for_department: 'Crew',
          name: 'Ivor Shier',
          original_name: 'Ivor Shier',
          popularity: 0.609,
          profile_path: null,
          credit_id: '60e4af2fb76cbb0046178c49',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1687016,
          known_for_department: 'Crew',
          name: 'Brent Steffensen',
          original_name: 'Brent Steffensen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b037db154f001e677195',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1729095,
          known_for_department: 'Art',
          name: 'Patrick Scalise',
          original_name: 'Patrick Scalise',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b2cadb154f0074cac23b',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1737037,
          known_for_department: 'Diễn viên',
          name: 'Tom Crisp',
          original_name: 'Tom Crisp',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4aac327ff9900470e2ad7',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1738146,
          known_for_department: 'Costume & Make-Up',
          name: 'Wynema Chavez',
          original_name: 'Wynema Chavez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4baf86bdec300460b355f',
          department: 'Costume & Make-Up',
          job: 'Ager/Dyer',
        },
        {
          adult: false,
          gender: 2,
          id: 1746960,
          known_for_department: 'Crew',
          name: 'Horace Knight',
          original_name: 'Horace Knight',
          popularity: 0.98,
          profile_path: null,
          credit_id: '60e4ae6484591c002d7244e1',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1767546,
          known_for_department: 'Sound',
          name: 'Kevin Maloney',
          original_name: 'Kevin Maloney',
          popularity: 0.98,
          profile_path: null,
          credit_id: '60e4b93c8805510045d195ef',
          department: 'Sound',
          job: 'Boom Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1790639,
          known_for_department: 'Art',
          name: 'Ethan Scroggins',
          original_name: 'Ethan Scroggins',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b7336ee3d70046c1a253',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 2,
          id: 1842145,
          known_for_department: 'Art',
          name: 'Paul Mugavero',
          original_name: 'Paul Mugavero',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b77d22e4800049767c40',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 1853442,
          known_for_department: 'Crew',
          name: 'Cody Banta',
          original_name: 'Cody Banta',
          popularity: 0.828,
          profile_path: null,
          credit_id: '60e4a9162811a1005e95bd15',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1865647,
          known_for_department: 'Art',
          name: 'Forrest A. Haag',
          original_name: 'Forrest A. Haag',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4bd216bdec300460b458d',
          department: 'Art',
          job: 'Assistant Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 1967858,
          known_for_department: 'Sound',
          name: 'Richard Duarte',
          original_name: 'Richard Duarte',
          popularity: 0.84,
          profile_path: null,
          credit_id: '60e4c28307faa20048609e22',
          department: 'Sound',
          job: 'Foley Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 2015834,
          known_for_department: 'Sound',
          name: 'John Guentner',
          original_name: 'John Guentner',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4c20c2811a1005e95f1dc',
          department: 'Sound',
          job: 'Foley Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 2025753,
          known_for_department: 'Crew',
          name: 'Jess King',
          original_name: 'Jess King',
          popularity: 1.614,
          profile_path:
            'https://image.tmdb.org/t/p/w185/o7abcDW4IN0SOV2eYVcCtd1mPLM.jpg',
          credit_id: '60e4ae2aa3b5e600743d9dce',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 2045537,
          known_for_department: 'Directing',
          name: 'Justin Muller',
          original_name: 'Justin Muller',
          popularity: 0.98,
          profile_path: null,
          credit_id: '60e4a81988bbe60027962b1a',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2053064,
          known_for_department: 'Production',
          name: 'Elizabeth Gabel',
          original_name: 'Elizabeth Gabel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4bf1222e48000800e9f3a',
          department: 'Production',
          job: 'Extras Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 2062200,
          known_for_department: 'Art',
          name: 'David Clayton',
          original_name: 'David Clayton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4c2d5258823002d8aee46',
          department: 'Art',
          job: 'Title Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2071770,
          known_for_department: 'Art',
          name: 'Brooke Peters',
          original_name: 'Brooke Peters',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b35027ff99002ad28881',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2071787,
          known_for_department: 'Crew',
          name: 'Matthew Lee Christmas',
          original_name: 'Matthew Lee Christmas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4aa5527ff9900470e29d0',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 2090887,
          known_for_department: 'Art',
          name: 'Julian Scalia',
          original_name: 'Julian Scalia',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b49607faa20077502cc4',
          department: 'Art',
          job: 'Art Department Assistant',
        },
        {
          adult: false,
          gender: 1,
          id: 2137742,
          known_for_department: 'Art',
          name: 'Linda R. Gore',
          original_name: 'Linda R. Gore',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b606880551002d0b4668',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 2,
          id: 2142383,
          known_for_department: 'Crew',
          name: 'Greg Harris',
          original_name: 'Greg Harris',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4adeb8805510074e1780b',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 2164315,
          known_for_department: 'Art',
          name: 'Lonam Fogleman',
          original_name: 'Lonam Fogleman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b6746bdec300460b10e1',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2214788,
          known_for_department: 'Production',
          name: 'Liz Probst',
          original_name: 'Liz Probst',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4be6d22e48000497688ec',
          department: 'Production',
          job: 'Payroll Accountant',
        },
        {
          adult: false,
          gender: 0,
          id: 2228318,
          known_for_department: 'Directing',
          name: 'John M. Morse',
          original_name: 'John M. Morse',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4a84422e480006032f793',
          department: 'Directing',
          job: 'Second Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2237930,
          known_for_department: 'Crew',
          name: 'Christie Hayes',
          original_name: 'Christie Hayes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b1fe25882300740dff9f',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 2279267,
          known_for_department: 'Camera',
          name: 'Kurt Kornemann',
          original_name: 'Kurt Kornemann',
          popularity: 0.828,
          profile_path: null,
          credit_id: '60e4ba47a3b5e600743dbad5',
          department: 'Camera',
          job: 'Key Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2578165,
          known_for_department: 'Crew',
          name: 'Anthony Genova',
          original_name: 'Anthony Genova',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4ad132811a100470dbaa4',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 2585604,
          known_for_department: 'Diễn viên',
          name: 'Chris Donaldson',
          original_name: 'Chris Donaldson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4ab14b76cbb005dfe677d',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 2615929,
          known_for_department: 'Directing',
          name: 'Walter E. Myal',
          original_name: 'Walter E. Myal',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b83f88bbe6005dedfb17',
          department: 'Directing',
          job: 'Second Second Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2652383,
          known_for_department: 'Crew',
          name: 'Tommy Goodwin',
          original_name: 'Tommy Goodwin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4adbc83ee670046f77382',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 2685632,
          known_for_department: 'Crew',
          name: 'Ryan Staats',
          original_name: 'Ryan Staats',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4afbb2588230047280a69',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 2772407,
          known_for_department: 'Crew',
          name: 'Jay Torrez',
          original_name: 'Jay Torrez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b147db154f0047026992',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 2773768,
          known_for_department: 'Art',
          name: 'Graham Griswold',
          original_name: 'Graham Griswold',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b63a88bbe60027964a6b',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2773770,
          known_for_department: 'Art',
          name: 'Dale Lotreck',
          original_name: 'Dale Lotreck',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4b7b326dac1007ed1b7b1',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2899656,
          known_for_department: 'Crew',
          name: 'Alex Kingi',
          original_name: 'Alex Kingi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e4ae458805510074e17902',
          department: 'Crew',
          job: 'Stunts',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'Frank Ochieng',
          author_details: {
            name: 'Frank Ochieng',
            username: 'Frank Ochieng',
            avatar_path:
              '/https://secure.gravatar.com/avatar/d0204b6265e0cf3cc7cd80809df35ba2.jpg',
            rating: null,
          },
          content:
            'It is quite an automatic instinct to compare and contrast the first installment of 2014’s ‘The Maze Runner’ with the arrival of the latest entry in director Wes Ball’s distant dystopian drama ‘Maze Runner: Scorch Trials’. The original blueprint effectively captured a unique time and place of mystique and other morbid curiosities.  The audience was craftily introduced to The Glade, a head-scratching venue out in the middle of nowhere while being surrounded by a massive maze that pretty much rendered its survivors in vulnerability and uncertainty. Well, ‘Maze Runner: Scorch Trials’ looks to revisit that same kind of mystifying aura where our young and daring protagonists face the surreal obstacles in a futuristic facility that begs for the same kind of grandiose ambivalence. Sadly, ‘Scorch Trials’ is a derivative follow-up shadow of its former pronounced presentation. This formulaic fantasy fails to provide any distinctive punch or promise to its more competent predecessor.\r\n\r\nAs a post-apocalyptic Young Adult-oriented narrative ‘Maze Runner: Scorch Trials’ never really invests in its adventurous characterizations that seem to blankly react to the jittery surroundings without any genuine conviction. It certainly is not advisable to saddle a pack of imperiled individuals in a cocoon of dream-like devastation and not have them equally match the imaginative SF sensibilities of their enthralling, enveloped universe. One can speculate as to whether ‘Maze Runner: Scorch Trials’ does any justice to the James Dashner epic-driven YA novels or not. Still, there should be a sense of excitable freshness and intrigue to this eye-opening film project that comes off strangely as remote and mechanical despite the whimsical feel to its wasteland of wonderment.\r\n\r\nSure, some will be partially engaged in the exploits of our young harried heroes bouncing from post to post in a desolate desert known as the Scorch where unpredictable encounters with undesirable creatures and the regional elements are recounted with Ball’s simplistic by-the-dots direction. There will be your predictable share of over-the-top villains, outlandish yet awestruck special effects imagery and a centerpiece for youth-oriented romancing among the ruins. However, ‘Maze Runner: Scorch Trials’ should do a better job in whisking its viewers away in a bells-and-whistles story that should be convincingly subversive and challenging.\r\n\r\nBack in the Maze mold madness is Glade stud Thomas (Dylan O’Brien) and his band of fellow wanderers in Theresa (Kaya Scodelario), Minho (Ki Hong Lee), Newt (Thomas Brodie-Sangster), and Frypan (Dexter Darden). The group had learned that their ‘a-MAZE-ing’ (sorry…could not resist) past experiences had been at the devilish hands of the evil paramilitary outfit known as WCKD (as in the pronounced word ‘wicked’). The head honcho of the aforementioned WCKD is none other than diabolical diva Dr. Ava Paige (Patricia Clarkson). So now Thomas and his endangered entourage (along with a few more disposable tag-a-longs) are forced to roam in the treacherous Scorch where the ominous run-ins with the resident beastly zombie Cranks are inevitable.\r\n\r\nOf course, there are other factors working against Thomas and his Gladers. First, they must constantly hunt for their safety guaranteed in the arms of the resistance faction called The Right Hand based in mountainous terrain. Secondly, there is also the matter of an outbreak known as the Solar Flare virus that is running amok and the cure is to draw blood from those that are immune.  The underhanded Janson (Aiden Gillen, from television’s ‘Game Of Thrones’) heads up the laboratory where the shifty agenda for collecting pure blood from unsuspecting hosts is hatched. So the dilemma is presented as such: should Thomas and his put-upon colleagues be the sacrificial lambs in an experimentation that could benefit the numerous lives of their exposed society?\r\n\r\nThe problem, among others, is that ‘Maze Runner: Scorch Trials’ never seems to distinguish itself among the crop of other YA-related feature films that seem collectively familiar in theme and tone. The long line of impish and impulsive fare that includes ‘The Hunger Games’ film franchise and ‘Divergent’ movie series has already saturated the movie market to the point of no return. Unfortunately, this leaves little room for error for derivative knock-off films such as ‘Maze Runner: Scorch Trials’ to not only echo the same kind of entertainment value but be considered a few notches off the scale in doing so.\r\n\r\nT.S. Nowlin’s screenplay is shockingly synthetic and that is inexcusable for an escapist SF flick using Dashner’s colourful and descriptive tomes as its inspirational source. A few of the interesting supporting characters come and go while registering some servicing interest such as the dashing duo Jorge and Brenda (Giancarlo Esposito and Rosa Salazar) that befriend the Gladers en route to their destination for comfort and calmness. Gillen’s Janson is serviceable as the slimy opportunist blood baiter. Otherwise, the main performers that make up this cosmetic caper bring little to uplift this pseudo calculating landscape of imagined isolation and desperation.  Somehow, the charismatic presence of both O’Brien’s Thomas and Scodelario’s Theresa seem watered down from the first film.\r\n\r\nFor the second time around it is kind of a tough sell for ‘Scorch Trials’ to get the obligatory mouse to chase after the cheese in this particular misplaced maze.\r\n\r\nMaze Runner: Scorch Trials (2015)\r\n\r\n20th Century Fox\r\n\r\n2 hrs. 11 mins.\r\n\r\nStarring:  Dylan O’Brien, Kaya Scodelario, Thomas Brodie-Sangster, Dexter Darden, Ki Hong Lee, Patricia Clarkson, Aidan Gillen, Giancarlo Esposito, Rosa Salazar, Lilli Taylor and Barry Pepper\r\n\r\nDirected by: Wes Ball\r\n\r\nMPAA Rating: PG-13\r\n\r\nGenre: Sci-Fi Fantasy/Dystopian Drama/Young Adult Action & Suspense\r\n\r\nCritic’s rating: ** stars (out of 4 stars)',
          created_at: '2015-10-11T06:28:20.468Z',
          id: '561a0184c3a3681c28001a40',
          updated_at: '2021-06-23T15:57:37.746Z',
          url: 'https://www.themoviedb.org/review/561a0184c3a3681c28001a40',
        },
        {
          author: 'Reno',
          author_details: {
            name: 'Reno',
            username: 'Rangan',
            avatar_path: '/6ZpVUJzqXMzH35VprEtnX0sNI3.jpg',
            rating: 7.0,
          },
          content:
            "> The adventure expands outside the maze to seek the answers.\r\n\r\nAnother teen movie in the mid series on the line of 'Divergent' and 'Hunger Games'. As an adult, I don't know what to expect from it, but entertainment was the priority. The first film was just an introduction that happened in a small and a single location like the film 'Cube'. Now it has outspread in a large extent with more new characters and takes a wider adventure in the wastelands.\r\n\r\nMany doubts from the previous film were cleared, yet a few need to be clarified and hoping for the next one to do that job. But anyway the suspense was this franchise's specialty, that simply reminds us the TV series 'Lost'. This second part can be compared with plenty of other post apocalyptic films, but still I liked it better than the first.\r\n\r\nThe best thing was they retained the same director and he's going to be here for the next film as well. But I'm more interested in the prequel, I mean the fourth film than the third which brings an end to the story moving forward. Because the maze holds the key for many unresolved issues. So I'm anticipating the prequel trilogy than the current one to learn how it all began.\r\n\r\nSurprisingly, many new additions like zombies, bounty hunters in the mainstream boosted the film with its variety. Gives us a creepy atmosphere, along thrilling running and chasing. The twist was not that great, but kind of unpredictable, and again due to the mysteries surrounding it, it created more curious about what might happen next.\r\n\r\n6½/10",
          created_at: '2016-01-24T12:44:13.379Z',
          id: '56a4c71d92514144ba0060f9',
          updated_at: '2021-06-23T15:57:44.667Z',
          url: 'https://www.themoviedb.org/review/56a4c71d92514144ba0060f9',
        },
        {
          author: 'Andres Gomez',
          author_details: {
            name: 'Andres Gomez',
            username: 'tanty',
            avatar_path:
              '/https://secure.gravatar.com/avatar/03a53cd53b8254fe582d4fe1acc26c4e.jpg',
            rating: 3.0,
          },
          content:
            'Let\'s get to the point. This is bad.\r\n\r\nA dystopian future full of conspiracies in which we throw the typical ingredients thinking that, magically, would make a good movie: teenagers, zombies, a "Mad-Max"-like desert and a stupid story in which main characters and their enemies behave stupidly at every step.\r\n\r\nQuite a forgettable one ...',
          created_at: '2016-04-26T22:09:13.146Z',
          id: '571fe7099251416f9b0004ea',
          updated_at: '2021-06-23T15:57:47.129Z',
          url: 'https://www.themoviedb.org/review/571fe7099251416f9b0004ea',
        },
        {
          author: 'Gimly',
          author_details: {
            name: 'Gimly',
            username: 'Ruuz',
            avatar_path: '/xUObnJSvHrFPsIpoDmb1jiQZLq7.jpg',
            rating: 5.0,
          },
          content:
            'I believe the adage is meant to go "Ask me no questions and I tell you no lies". _Scorch Trials_ however seemed to be trialling the new "I pose you 500 questions, I tell you no answers". But there\'s still some interesting things to find the further the movie goes on. It lacks the cohesion of the first movie, for sure, but there\'s more going on, so that tracks.\r\n\r\n_Final rating:★★½ - Had a lot that appealed to me, didn’t quite work as a whole._',
          created_at: '2018-10-04T05:26:28.644Z',
          id: '5bb5a4849251410dbc008078',
          updated_at: '2021-06-23T15:58:13.166Z',
          url: 'https://www.themoviedb.org/review/5bb5a4849251410dbc008078',
        },
      ],
      total_pages: 1,
      total_results: 4,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/MLzW6BtHtQckHuNmvrmJX9jBqH.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 10751, name: 'Phim Gia Đình' },
      { id: 35, name: 'Phim Hài' },
      { id: 14, name: 'Phim Giả Tượng' },
      { id: 16, name: 'Phim Hoạt Hình' },
    ],
    homepage: 'https://disneyplusoriginals.disney.com/movie/22-vs-earth',
    id: 811367,
    imdb_id: 'tt14499632',
    original_language: 'en',
    original_title: '22 vs. Earth',
    overview:
      'Lấy bối cảnh trước các sự kiện của ‘Soul’, 22 từ chối xuống Trái đất, gia nhập một nhóm gồm 5 linh hồn mới nhằm tìm cách nổi loạn. Tuy nhiên, âm mưu lật đổ của 22 dẫn đến một tiết lộ đáng ngạc nhiên về ý nghĩa của cuộc sống.',
    popularity: 157.013,
    poster_path:
      'https://image.tmdb.org/t/p/w342/wnWMxwpXRFIEmwjhULNGYGg8SEM.jpg',
    production_companies: [
      {
        id: 3,
        logo_path: '/1TjvGVDMYsj6JBxOAkUHpPEwLf7.png',
        name: 'Pixar',
        origin_country: 'US',
      },
      {
        id: 2,
        logo_path: '/wdrCwmRnLFJhEoH8GSfymY85KHT.png',
        name: 'Walt Disney Pictures',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2021-04-30',
    revenue: 0,
    runtime: 9,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: '22 vs. Trái Đất',
    video: false,
    vote_average: 7.1,
    vote_count: 241,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: '22 vs. Earth First Look | Pixar',
          key: 'VJUnC2j9rgo',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: true,
          published_at: '2021-04-27T14:00:14.000Z',
          id: '608823cdcabfe40029509c97',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 56323,
          known_for_department: 'Diễn viên',
          name: 'Tina Fey',
          original_name: 'Tina Fey',
          popularity: 2.992,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yPTAi1iucXf85UpiFPtyiTSM6do.jpg',
          cast_id: 1,
          character: '22 (voice)',
          credit_id: '6064d373ac6c79005712f8cb',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 8602,
          known_for_department: 'Diễn viên',
          name: 'Alice Braga',
          original_name: 'Alice Braga',
          popularity: 7.646,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ykVmsm3For9dCBfWLRtTL0EU24b.jpg',
          cast_id: 6,
          character: 'Counselor Jerry (voice)',
          credit_id: '60898b9854a098003f741d79',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 98103,
          known_for_department: 'Diễn viên',
          name: 'Richard Ayoade',
          original_name: 'Richard Ayoade',
          popularity: 4.327,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qHKoy9kP4bsv4G9EkvU4FMUmYkS.jpg',
          cast_id: 7,
          character: 'Counselor Jerry (voice)',
          credit_id: '60898bb154a0980057d14a44',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 2863689,
          known_for_department: 'Diễn viên',
          name: 'Micah Chen',
          original_name: 'Micah Chen',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/i6KQp0Eku8kNv2zq0VhN6RA5zQ9.jpg',
          cast_id: 11,
          character: 'Moonbeam (voice)',
          credit_id: '608bab982588230040b260e8',
          order: 4,
        },
        {
          adult: false,
          gender: 0,
          id: 3073125,
          known_for_department: 'Diễn viên',
          name: 'Adela Drabek',
          original_name: 'Adela Drabek',
          popularity: 0.6,
          profile_path: null,
          cast_id: 17,
          character: 'Peanut (voice)',
          credit_id: '608bb141764841006f059a79',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 2473443,
          known_for_department: 'Diễn viên',
          name: 'Aiyanna Miorin',
          original_name: 'Aiyanna Miorin',
          popularity: 1.025,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tcmp8YoHsYXBelN9Cy4IYpB309.jpg',
          cast_id: 18,
          character: 'Zimmy (voice)',
          credit_id: '608bb3532588230040b2666d',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 2458595,
          known_for_department: 'Diễn viên',
          name: 'Karee Ducharme',
          original_name: 'Karee Ducharme',
          popularity: 1.4,
          profile_path: null,
          cast_id: 19,
          character: 'Macaroni (voice)',
          credit_id: '608bb36d1d1bf400786f9617',
          order: 7,
        },
        {
          adult: false,
          gender: 0,
          id: 3073134,
          known_for_department: 'Diễn viên',
          name: 'Samantha Ho',
          original_name: 'Samantha Ho',
          popularity: 0.98,
          profile_path: null,
          cast_id: 20,
          character: 'D-Pac (voice)',
          credit_id: '608bb39481a7fc0056b3c83f',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 2547056,
          known_for_department: 'Diễn viên',
          name: 'Azriel Dalman',
          original_name: 'Azriel Dalman',
          popularity: 1.4,
          profile_path: null,
          cast_id: 21,
          character: 'Neptune (voice)',
          credit_id: '608bb3bc77c01f0029c20e76',
          order: 9,
        },
        {
          adult: false,
          gender: 0,
          id: 3073135,
          known_for_department: 'Diễn viên',
          name: 'Juliana Alcaron',
          original_name: 'Juliana Alcaron',
          popularity: 0.6,
          profile_path: null,
          cast_id: 22,
          character: 'Happy Soul (voice)',
          credit_id: '608bb3ea07e28100781acdac',
          order: 10,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 3186,
          known_for_department: 'Sound',
          name: 'Trent Reznor',
          original_name: 'Trent Reznor',
          popularity: 1.038,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gzvgK9ydCfW5Sh9tsEeYcYCnxrh.jpg',
          credit_id: '60898b820c271000579fd297',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 0,
          id: 13060,
          known_for_department: 'Production',
          name: 'Noah Newman',
          original_name: 'Noah Newman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608babc081a7fc00776b4d33',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 12890,
          known_for_department: 'Biên kịch',
          name: 'Pete Docter',
          original_name: 'Pete Docter',
          popularity: 2.86,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rrAW10FlcOjqMllSwNBrFjfUT4k.jpg',
          credit_id: '608bab5b8c40f7003f35b409',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 84496,
          known_for_department: 'Biên kịch',
          name: 'Josh Cooley',
          original_name: 'Josh Cooley',
          popularity: 1.821,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jpAvewPQbym22SS4ePKhLmn1A7e.jpg',
          credit_id: '60898c272dda89002be80a05',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 139294,
          known_for_department: 'Editing',
          name: 'Jamie Datz',
          original_name: 'Jamie Datz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f52524befb09002f1a2ab9',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 142391,
          known_for_department: 'Sound',
          name: 'Atticus Ross',
          original_name: 'Atticus Ross',
          popularity: 1.4,
          profile_path: null,
          credit_id: '60898b8d0c27100040dc753d',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 0,
          id: 1291315,
          known_for_department: 'Sound',
          name: 'Tom MacDougall',
          original_name: 'Tom MacDougall',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f52572befb09007479dea1',
          department: 'Crew',
          job: 'Executive Music Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1422418,
          known_for_department: 'Sound',
          name: 'Jonathon Stevens',
          original_name: 'Jonathon Stevens',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608d7c26c9dbf9002b177d02',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1470862,
          known_for_department: 'Sound',
          name: 'Justin Pearson',
          original_name: 'Justin Pearson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608d7c6b9e4012006f3bb105',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1516156,
          known_for_department: 'Editing',
          name: 'Kevin Nolting',
          original_name: 'Kevin Nolting',
          popularity: 1.214,
          profile_path: null,
          credit_id: '60816ef32b8a430029cfd4ea',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1694608,
          known_for_department: 'Lighting',
          name: 'Luke Martorelli',
          original_name: 'Luke Martorelli',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608babe55b4fed0059795302',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 1924359,
          known_for_department: 'Production',
          name: 'Dana Murray',
          original_name: 'Dana Murray',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608bab6b9463180042a87240',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1976191,
          known_for_department: 'Sound',
          name: 'Coya Elliott',
          original_name: 'Coya Elliott',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f5257ff1759c002ea88a5e',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1982410,
          known_for_department: 'Production',
          name: 'Jeremy Slome',
          original_name: 'Jeremy Slome',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f525a44c2592002d269123',
          department: 'Crew',
          job: 'Post Production Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1993264,
          known_for_department: 'Visual Effects',
          name: 'Tiffany Erickson Klohn',
          original_name: 'Tiffany Erickson Klohn',
          popularity: 0.63,
          profile_path: null,
          credit_id: '608babfc2588230057043ba8',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1993621,
          known_for_department: 'Visual Effects',
          name: 'Brett Schulz',
          original_name: 'Brett Schulz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608bac18ac41610056e1fb2e',
          department: 'Visual Effects',
          job: 'Animation Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2003680,
          known_for_department: 'Art',
          name: 'Lourdes Marquez Alba',
          original_name: 'Lourdes Marquez Alba',
          popularity: 1.4,
          profile_path: null,
          credit_id: '60816f0101b1ca00586b05aa',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2005775,
          known_for_department: 'Sound',
          name: 'Liz Marston',
          original_name: 'Liz Marston',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f52594da9ef2002dd6d26a',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 2007233,
          known_for_department: 'Visual Effects',
          name: 'Rejean Bourdages',
          original_name: 'Rejean Bourdages',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608bb42f8c40f70057e82391',
          department: 'Biên kịch',
          job: 'Story',
        },
        {
          adult: false,
          gender: 0,
          id: 2134673,
          known_for_department: 'Directing',
          name: 'Andy Grisdale',
          original_name: 'Andy Grisdale',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608babd65b4fed002abb16e9',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 2719558,
          known_for_department: 'Biên kịch',
          name: 'Hyein Park',
          original_name: 'Hyein Park',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f524fe53866e00738a84b5',
          department: 'Biên kịch',
          job: 'Story',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/shJCJd6NFdO8I5QqHKlzWDDNXS6.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 80, name: 'Phim Hình Sự' },
      { id: 10749, name: 'Phim Lãng Mạn' },
    ],
    homepage: 'https://kendy.xyz',
    id: 452310,
    imdb_id: '',
    original_language: 'vi',
    original_title: 'Sứ Mệnh Trái Tim',
    overview:
      'Sứ Mệnh Trái Tim là câu chuyện về 7 người lính trẻ nhận nhiệm vụ rà phá bom mìn còn sót lại ở vùng biên giới. Giữa cuộc sống gian khổ của những chàng trai bỗng xuất hiện một bóng hồng xinh đẹp. Đó là Linh, cô giáo tiểu học vùng cao. Ngoài việc đề cao hình ảnh chịu thương chịu khó của những người lính, bộ phim còn được thổi thêm hơi thở tươi mới với câu chuyện tình lãng mạn nhưng cũng đầy sóng gió của cô giáo và anh lính Hoàng Bách. Phim có sự tham gia của nữ diễn viên nổi tiếng Angela Phương Trinh và trai đẹp vừa tấn công màn ảnh rộng Võ Cảnh.',
    popularity: 0.849,
    poster_path:
      'https://image.tmdb.org/t/p/w342/nClBp35CnWh2HboWRH9NmbiY4d5.jpg',
    production_companies: [
      { id: 73396, logo_path: null, name: 'Vietnam', origin_country: '' },
    ],
    production_countries: [{ iso_3166_1: 'VN', name: 'Vietnam' }],
    release_date: '2016-11-11',
    revenue: 0,
    runtime: 92,
    spoken_languages: [],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Sứ Mệnh Trái Tim',
    video: false,
    vote_average: 0.0,
    vote_count: 0,
    videos: { results: [] },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 1595493,
          known_for_department: 'Diễn viên',
          name: 'Angela Phương Trinh',
          original_name: 'Angela Phương Trinh',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dKahMDEaQ0X9UmOUCmp9HPjNkt4.jpg',
          cast_id: 0,
          character: 'Phong Linh',
          credit_id: '58f24e19c3a368081e000b1d',
          order: 1,
        },
        {
          adult: false,
          gender: 0,
          id: 1796746,
          known_for_department: 'Diễn viên',
          name: 'Võ Cảnh',
          original_name: 'Võ Cảnh',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bwhBKhHgh1QrGoVkhqAn2VOGFKw.jpg',
          cast_id: 1,
          character: 'Hoàng Bách',
          credit_id: '58f24e26c3a36807bd000b07',
          order: 2,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 1593129,
          known_for_department: 'Directing',
          name: 'NSƯT Đức Thịnh',
          original_name: 'NSƯT Đức Thịnh',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3zRVqDjr94R6cKz6WNuPtf7jGM9.jpg',
          credit_id: '58f253449251413d76000f59',
          department: 'Directing',
          job: 'Director',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/fssh5GyRUrXcS8OtX1b2sVAGh0l.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [{ id: 53, name: 'Phim Gây Cấn' }],
    homepage: '',
    id: 602147,
    imdb_id: 'tt7923220',
    original_language: 'en',
    original_title: 'Inheritance',
    overview:
      'Lauren Monroe (Lily Collins), một luật sư trẻ tuổi thành công và tham vọng, là con gái của một gia đình quyền lực và giàu có bậc nhất ở New York. Khi cha cô (Patrick Warburton) đột ngột qua đời, cô được trao chiếc chìa khóa dẫn đến một căn hầm tránh bom bí ẩn. Căn hầm này chứa đựng món thừa kế khổng lồ dành cho Lauren. Tuy nhiên, thay vì của cải vật chất, cô phát hiện "món thừa kế" của mình lại là một người đàn ông bí ẩn (Simon Pegg), bị nhốt và bị giam cầm trong nhiều năm trong căn hầm tối tăm. Lauren đứng trước sự lựa chọn giữa việc khám phá bí mật về người đàn ông đó hoặc quay trở lại cuộc sống bình thường, im lặng chấp nhận "tài sản thừa kế đặc biệt" của mình vì những gì Lauren khám phá ra được có thể sẽ đe dọa gia đình cô và tất cả những người xung quanh.',
    popularity: 15.578,
    poster_path:
      'https://image.tmdb.org/t/p/w342/5AcWpQCdTizs5U9kcjEJesCKOFq.jpg',
    production_companies: [
      {
        id: 76991,
        logo_path: '/pQjdvbv4y9yuIDSHDEHc9ijJKaS.png',
        name: 'Highland Film Group',
        origin_country: 'US',
      },
      {
        id: 290,
        logo_path: '/Q8mw2AOQQc8Qg0uNwLWq86DVZv.png',
        name: 'Ingenious Media',
        origin_country: 'GB',
      },
      {
        id: 30131,
        logo_path: null,
        name: 'Southpaw Entertainment',
        origin_country: 'US',
      },
      {
        id: 102837,
        logo_path: null,
        name: 'White Comet Films',
        origin_country: 'GB',
      },
      {
        id: 88606,
        logo_path: '/3w49QoRwptUujWxSjcR3iEr1XSU.png',
        name: 'Vertical Entertainment',
        origin_country: 'US',
      },
      {
        id: 34625,
        logo_path: '/ib6KkJ2zcTlKDAcyegY7UYJ7019.png',
        name: 'DirecTV',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2020-04-30',
    revenue: 0,
    runtime: 111,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
      { english_name: 'French', iso_639_1: 'fr', name: 'Français' },
    ],
    status: 'Đã phát hành',
    tagline: 'Một số bí mật nên được chôn cất.',
    title: 'Gia Tài Tội Lỗi',
    video: false,
    vote_average: 6.3,
    vote_count: 361,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Inheritance | Official Trailer (HD) | Vertical Entertainment',
          key: '3q7JOLZxjqY',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2020-03-19T21:58:02.000Z',
          id: '5ea8cf062d1e40001d841b51',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 112561,
          known_for_department: 'Diễn viên',
          name: 'Lily Collins',
          original_name: 'Lily Collins',
          popularity: 10.601,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zhJISAc4qi7xiHMzHMzUTgZSIRH.jpg',
          cast_id: 1,
          character: 'Lauren Monroe',
          credit_id: '5cd957880e0a2666decaad7b',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 11108,
          known_for_department: 'Diễn viên',
          name: 'Simon Pegg',
          original_name: 'Simon Pegg',
          popularity: 11.676,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nOWKXxgADG98RjKyfQ7oSDfns6J.jpg',
          cast_id: 5,
          character: 'Morgan Warner',
          credit_id: '5cd95899c3a36875bcc5bbe6',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 935,
          known_for_department: 'Diễn viên',
          name: 'Connie Nielsen',
          original_name: 'Connie Nielsen',
          popularity: 10.64,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lvQypTfeH2Gn2PTbzq6XkT2PLmn.jpg',
          cast_id: 4,
          character: 'Catherine Monroe',
          credit_id: '5cd958900e0a2666decaaf14',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 60899,
          known_for_department: 'Diễn viên',
          name: 'Chace Crawford',
          original_name: 'Chace Crawford',
          popularity: 4.184,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wEgaOcrKUqtqLht9IaI5ExR3uXB.jpg',
          cast_id: 41,
          character: 'William Monroe',
          credit_id: '5eb5cc860cb3350020cbe3bd',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 9657,
          known_for_department: 'Diễn viên',
          name: 'Patrick Warburton',
          original_name: 'Patrick Warburton',
          popularity: 7.799,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eLqDtbFYmlTxov9vT9Dwldn839v.jpg',
          cast_id: 16,
          character: 'Archer Monroe',
          credit_id: '5e7cfa8e109dec213c0244b5',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 1095608,
          known_for_department: 'Diễn viên',
          name: 'Marque Richardson',
          original_name: 'Marque Richardson',
          popularity: 1.141,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1TsiMsTDPbCX3IhmlcmdejuRlmS.jpg',
          cast_id: 6,
          character: 'Scott',
          credit_id: '5e7cf9aa13a32032172753ab',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 87118,
          known_for_department: 'Diễn viên',
          name: 'Michael Beach',
          original_name: 'Michael Beach',
          popularity: 4.323,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7gCBCpK2OSzuUWk5iTZds9NjqkF.jpg',
          cast_id: 7,
          character: 'Harold Thewlis',
          credit_id: '5e7cf9bcd861af28c0b8113d',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 2331323,
          known_for_department: 'Diễn viên',
          name: 'Joe Herrera',
          original_name: 'Joe Herrera',
          popularity: 0.6,
          profile_path: null,
          cast_id: 9,
          character: 'Detective Emilio Sanchez',
          credit_id: '5e7cf9e8d861af312ab862bc',
          order: 7,
        },
        {
          adult: false,
          gender: 1,
          id: 99624,
          known_for_department: 'Diễn viên',
          name: 'Christina DeRosa',
          original_name: 'Christina DeRosa',
          popularity: 1.178,
          profile_path:
            'https://image.tmdb.org/t/p/w185/m71UoF9SGtlSiAw8dOqez4IWaPU.jpg',
          cast_id: 10,
          character: 'Sofia Fiore',
          credit_id: '5e7cf9fd6c74b94e95cab5e1',
          order: 8,
        },
        {
          adult: false,
          gender: 0,
          id: 2428472,
          known_for_department: 'Diễn viên',
          name: 'Lucas Alexander Ayoub',
          original_name: 'Lucas Alexander Ayoub',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/v6t8rMSwnZaU15dpb3fjUrpUeo6.jpg',
          cast_id: 14,
          character: 'Eddie Parker',
          credit_id: '5e7cfa54ab1bc75874c2aade',
          order: 9,
        },
        {
          adult: false,
          gender: 0,
          id: 1704380,
          known_for_department: 'Production',
          name: 'Rebecca Adams',
          original_name: 'Rebecca Adams',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/smK7Eg2VeoEbNp71d6DNnynJXDm.jpg',
          cast_id: 12,
          character: 'Jen Monroe',
          credit_id: '5e7cfa22ab1bc75cb1c2b82b',
          order: 10,
        },
        {
          adult: false,
          gender: 0,
          id: 2579682,
          known_for_department: 'Diễn viên',
          name: 'Mariyah Francis',
          original_name: 'Mariyah Francis',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cs7Npx7o3fET9Vo9Zf0x1GcRPTC.jpg',
          cast_id: 13,
          character: 'Claire Monroe',
          credit_id: '5e7cfa3513a320321727544f',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 154837,
          known_for_department: 'Diễn viên',
          name: 'Chris Gann',
          original_name: 'Chris Gann',
          popularity: 1.396,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jX73lEGi5TNjordeEEZRKjqGL9x.jpg',
          cast_id: 8,
          character: 'Thomas Reindorff',
          credit_id: '5e7cf9d4109dec213c0242f0',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 1223403,
          known_for_department: 'Diễn viên',
          name: 'Jim E. Chandler',
          original_name: 'Jim E. Chandler',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aqapPNP4axZI9roXrlfdwf0shgo.jpg',
          cast_id: 15,
          character: 'Robert Haeven',
          credit_id: '5e7cfa796c74b94e95cab68a',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 1916438,
          known_for_department: 'Diễn viên',
          name: 'Harrison Stone',
          original_name: 'Harrison Stone',
          popularity: 0.665,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wQseyyHclVhxSJGjY9rcKGjJefM.jpg',
          cast_id: 11,
          character: 'Harvey',
          credit_id: '5e7cfa11109dec213c02434c',
          order: 14,
        },
        {
          adult: false,
          gender: 1,
          id: 2188076,
          known_for_department: 'Crew',
          name: 'Lydia Hand',
          original_name: 'Lydia Hand',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fEoRGiJIgBdJ58ILHtFML5kIUNY.jpg',
          cast_id: 43,
          character: 'Young Catherine',
          credit_id: '5ebbfc0c1dbc88001cda8365',
          order: 16,
        },
        {
          adult: false,
          gender: 1,
          id: 2489973,
          known_for_department: 'Diễn viên',
          name: 'Grae Marino',
          original_name: 'Grae Marino',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dhtTofwYThmn4y7DJuh84RSKupD.jpg',
          cast_id: 44,
          character: 'Jackie',
          credit_id: '5ebbfc5d0cb3350021d1fff6',
          order: 17,
        },
        {
          adult: false,
          gender: 1,
          id: 1565373,
          known_for_department: 'Diễn viên',
          name: 'Katie Callaway',
          original_name: 'Katie Callaway',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bB321kmvCAg8CH3y4cmtNmywgnu.jpg',
          cast_id: 45,
          character: 'Reporter #1',
          credit_id: '5ebbfcadaad9c200202492ef',
          order: 18,
        },
        {
          adult: false,
          gender: 1,
          id: 2178796,
          known_for_department: 'Diễn viên',
          name: 'Ashley Pereira',
          original_name: 'Ashley Pereira',
          popularity: 1.38,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ojGzIqqlHEIfu885Noi48z2MqR7.jpg',
          cast_id: 46,
          character: 'Young Sofia',
          credit_id: '5ebbfcdcaad9c20020249326',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 1637322,
          known_for_department: 'Diễn viên',
          name: 'Hamid-Reza Benjamin Thompson',
          original_name: 'Hamid-Reza Benjamin Thompson',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rOBcfuKyRp2mA6cAAOvxz8rfLIi.jpg',
          cast_id: 47,
          character: 'Hippie',
          credit_id: '5ebbfd231dbc88001cda84be',
          order: 20,
        },
        {
          adult: false,
          gender: 0,
          id: 2271219,
          known_for_department: 'Diễn viên',
          name: 'Meagan Bown',
          original_name: 'Meagan Bown',
          popularity: 0.6,
          profile_path: null,
          cast_id: 48,
          character: 'Courtroom Attendee (uncredited)',
          credit_id: '5f5b7d88629b2c0037c29535',
          order: 21,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 0,
          id: 2184,
          known_for_department: 'Production',
          name: 'Richard Barton Lewis',
          original_name: 'Richard Barton Lewis',
          popularity: 0.748,
          profile_path: null,
          credit_id: '5eb2667bedeb43001fcadd1f',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 128517,
          known_for_department: 'Production',
          name: 'Richard Goldberg',
          original_name: 'Richard Goldberg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5eb2664cfbe36f001ec40f01',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 134451,
          known_for_department: 'Production',
          name: 'Arianne Fraser',
          original_name: 'Arianne Fraser',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eJPvHgWatmQgho5KBNPVAE1uKH1.jpg',
          credit_id: '5eb2663c1089ba001c365203',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 928272,
          known_for_department: 'Production',
          name: 'Rich Delia',
          original_name: 'Rich Delia',
          popularity: 0.63,
          profile_path:
            'https://image.tmdb.org/t/p/w185/UiNvcLDmStXxpEmx6JrGKRI7UF.jpg',
          credit_id: '5eb266f8fbe36f0023c4021e',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 1049456,
          known_for_department: 'Sound',
          name: 'Ben Wilkins',
          original_name: 'Ben Wilkins',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/30VKN6GCNy9ux0BfmJ0cTo4HHQT.jpg',
          credit_id: '5eb26742bf0f63001e7ff5a0',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1114283,
          known_for_department: 'Diễn viên',
          name: 'Chris Brewster',
          original_name: 'Chris Brewster',
          popularity: 0.98,
          profile_path: null,
          credit_id: '6093b817a06efe0042171077',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 2,
          id: 1150952,
          known_for_department: 'Production',
          name: 'David M. Wulf',
          original_name: 'David M. Wulf',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5eb266c4edeb43001ccae65e',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1334791,
          known_for_department: 'Art',
          name: 'Diane Millett',
          original_name: 'Diane Millett',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5eb26702caab6d001bdbc756',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1404192,
          known_for_department: 'Visual Effects',
          name: 'May Satsuki Asai',
          original_name: 'May Satsuki Asai',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6093b84754508d002aee05bd',
          department: 'Visual Effects',
          job: 'Visual Effects',
        },
        {
          adult: false,
          gender: 1,
          id: 1464310,
          known_for_department: 'Crew',
          name: 'Eliza Coleman',
          original_name: 'Eliza Coleman',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wb7sr5O0WVADFsOUiC8hzekhDmd.jpg',
          credit_id: '6093b82954508d002aee05b6',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1573001,
          known_for_department: 'Biên kịch',
          name: 'Daniel Negret',
          original_name: 'Daniel Negret',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5eb26686bf0f63001f801a34',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1585062,
          known_for_department: 'Biên kịch',
          name: 'Vaughn Stein',
          original_name: 'Vaughn Stein',
          popularity: 0.837,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zucTrtX7tsT0UgLg0mhY8uk6CcZ.jpg',
          credit_id: '5cd95799c3a36831dec36da2',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 1,
          id: 1699523,
          known_for_department: 'Editing',
          name: 'Kristi Shimek',
          original_name: 'Kristi Shimek',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qZrIuFfxZuVZd2VBuI7DkagJAUA.jpg',
          credit_id: '5eb266e7caab6d001ddbca02',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1729863,
          known_for_department: 'Camera',
          name: 'Michael Merriman',
          original_name: 'Michael Merriman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5eb266df1fb94f001cf2a27d',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 1,
          id: 1781846,
          known_for_department: 'Production',
          name: 'Gabrielle Jerou',
          original_name: 'Gabrielle Jerou',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5eb266690b7316001c4357c8',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1805083,
          known_for_department: 'Production',
          name: 'Anders Erdén',
          original_name: 'Anders Erdén',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5eb266250b7316002443324f',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1863260,
          known_for_department: 'Production',
          name: 'Dan Reardon',
          original_name: 'Dan Reardon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5eb266a31089ba001e365dcc',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2005768,
          known_for_department: 'Sound',
          name: 'Marlon Espino',
          original_name: 'Marlon Espino',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5eb266ce00fb6b001feae04e',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 0,
          id: 2013950,
          known_for_department: 'Sound',
          name: 'Reuben Ripley',
          original_name: 'Reuben Ripley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5eb26734caab6d0023dbbf89',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 2044592,
          known_for_department: 'Sound',
          name: 'Antony Metaxakis',
          original_name: 'Antony Metaxakis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5eb26728cdbaff001ab54135',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2054139,
          known_for_department: 'Production',
          name: 'Delphine Perrier',
          original_name: 'Delphine Perrier',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5eb2669acdbaff0021b53b23',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 2195304,
          known_for_department: 'Production',
          name: 'Simon Williams',
          original_name: 'Simon Williams',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5eb266b8f74f5f001d95b58b',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2285007,
          known_for_department: 'Costume & Make-Up',
          name: 'Somica Spratley',
          original_name: 'Somica Spratley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5eb2671dedeb43001fcade2d',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2311889,
          known_for_department: 'Biên kịch',
          name: 'Matthew Kennedy',
          original_name: 'Matthew Kennedy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cd957dc0e0a2604afcbb1e4',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 2399201,
          known_for_department: 'Production',
          name: 'Santosh Govindaraju',
          original_name: 'Santosh Govindaraju',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5eb26658f74f5f001d95b53a',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2477513,
          known_for_department: 'Crew',
          name: 'Juliene Joyner',
          original_name: 'Juliene Joyner',
          popularity: 0.981,
          profile_path: null,
          credit_id: '6093b83654508d00417c53a5',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 0,
          id: 2618316,
          known_for_department: 'Art',
          name: 'Leslie Smoot',
          original_name: 'Leslie Smoot',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5eb2670bedeb43001ccae6da',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 2627240,
          known_for_department: 'Production',
          name: 'Peter Jarowey',
          original_name: 'Peter Jarowey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5eb26661cdbaff001cb529ee',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2627241,
          known_for_department: 'Production',
          name: 'Joseph Lanius',
          original_name: 'Joseph Lanius',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5eb26671fbe36f0023c40179',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2627242,
          known_for_department: 'Costume & Make-Up',
          name: 'Shawna Tisdale',
          original_name: 'Shawna Tisdale',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5eb26713fbe36f001cc41003',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path: null,
    belongs_to_collection: null,
    budget: 0,
    genres: [],
    homepage: '',
    id: 678260,
    imdb_id: null,
    original_language: 'vi',
    original_title: 'Thành Phố Lúc Rạng Đông',
    overview:
      'Bộ phim "Thành Phố Lúc Rạng Đông" ghi lại những khoảnh khắc của thành phố và người dân Sài Gòn trong những ngày mới giải phóng. Cờ cách mạng phấp phới bay trên khắp thành phố, trên nóc xe của quân giải phóng. Cha gặp lại con, Vợ gặp lại chồng, cả đất nước trong ngày vui chiến thắng.',
    popularity: 0.6,
    poster_path:
      'https://image.tmdb.org/t/p/w342/nbc2WCHHv7EHQ2xLsaPBnuRkNY6.jpg',
    production_companies: [],
    production_countries: [],
    release_date: '1975-12-31',
    revenue: 0,
    runtime: 0,
    spoken_languages: [],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Thành Phố Lúc Rạng Đông',
    video: false,
    vote_average: 0.0,
    vote_count: 0,
    videos: { results: [] },
    credits: {
      cast: [],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 1403625,
          known_for_department: 'Directing',
          name: 'Hai Ninh',
          original_name: 'Hai Ninh',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ch9OyuVeyjeMEVolHi4pVDh0bIC.jpg',
          credit_id: '6129f1880d9f5a002c53fb57',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 3214822,
          known_for_department: 'Biên kịch',
          name: 'Hoàng Tích Chỉ',
          original_name: 'Hoàng Tích Chỉ',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6129f16f06f984002d57ecd3',
          department: 'Biên kịch',
          job: 'Writer',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/3Uj4Cb73sGUYzpXJ9ow3rsyDlMp.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 35, name: 'Phim Hài' },
      { id: 18, name: 'Phim Chính Kịch' },
    ],
    homepage: 'https://www.netflix.com/title/81345777',
    id: 646955,
    imdb_id: 'tt11213372',
    original_language: 'tr',
    original_title: 'Azizler',
    overview:
      'Rơi vào khủng hoảng tuổi trung niên, Aziz tìm kiếm sự an ủi từ công việc nhàm chán, hội bạn cô độc và gia đình ồn ào trong khi ra vẻ mình vẫn rất ổn.',
    popularity: 5.521,
    poster_path:
      'https://image.tmdb.org/t/p/w342/gFefRcNMPVB2RqLtsYFId6hwsqz.jpg',
    production_companies: [
      {
        id: 110904,
        logo_path: '/3MBhI4NaLROtnko4LrRslEOkggN.png',
        name: 'Imaj Film',
        origin_country: 'TR',
      },
    ],
    production_countries: [{ iso_3166_1: 'TR', name: 'Turkey' }],
    release_date: '2021-01-08',
    revenue: 0,
    runtime: 96,
    spoken_languages: [
      { english_name: 'Turkish', iso_639_1: 'tr', name: 'Türkçe' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Gần Mặt Cách Lòng',
    video: false,
    vote_average: 6.2,
    vote_count: 28,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Stuck Apart (2021) - Official Trailer',
          key: 'fG96ROkdGVA',
          site: 'YouTube',
          size: 360,
          type: 'Trailer',
          official: false,
          published_at: '2020-12-28T22:23:20.000Z',
          id: '5ff83354383df2003c3288b6',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 115011,
          known_for_department: 'Diễn viên',
          name: 'Engin Günaydın',
          original_name: 'Engin Günaydın',
          popularity: 0.604,
          profile_path:
            'https://image.tmdb.org/t/p/w185/msUunHpnGJBXr6X5YcJKBAT1iSY.jpg',
          cast_id: 1,
          character: 'Aziz',
          credit_id: '5dc885a3ab1bc7001505b5a2',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 117640,
          known_for_department: 'Diễn viên',
          name: 'Haluk Bilginer',
          original_name: 'Haluk Bilginer',
          popularity: 4.675,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fXZTXaJ76k9Np7v4KxkwRGvlNSX.jpg',
          cast_id: 2,
          character: 'Erbil',
          credit_id: '5dc885b8ab1bc7001505b5db',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 115012,
          known_for_department: 'Diễn viên',
          name: 'Binnur Kaya',
          original_name: 'Binnur Kaya',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bk4kBXt3AXTXta3bbPQvezml6WU.jpg',
          cast_id: 3,
          character: 'Kamuran',
          credit_id: '5dc885d4ab1bc7001806613e',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 150279,
          known_for_department: 'Diễn viên',
          name: 'Öner Erkan',
          original_name: 'Öner Erkan',
          popularity: 0.932,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xqrlTZen9EbXxZCcAa2DStcLffK.jpg',
          cast_id: 4,
          character: 'Alp',
          credit_id: '5dc885de7d2bc15a3734ec0e',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 1254540,
          known_for_department: 'Diễn viên',
          name: 'Fatih Artman',
          original_name: 'Fatih Artman',
          popularity: 2.896,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bgCPHOvmwzq9KxoOrOagB267rr7.jpg',
          cast_id: 5,
          character: 'Cevdet',
          credit_id: '5dc885e97d2bc15a3734ec5a',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 1255934,
          known_for_department: 'Diễn viên',
          name: 'İrem Sak',
          original_name: 'İrem Sak',
          popularity: 2.971,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kLI49VsorbNwbMDuXnOe2yP6W7Z.jpg',
          cast_id: 6,
          character: 'Burcu',
          credit_id: '5dc885f47d2bc15a3734ec70',
          order: 6,
        },
        {
          adult: false,
          gender: 0,
          id: 150440,
          known_for_department: 'Diễn viên',
          name: 'Gülçin Santırcıoğlu',
          original_name: 'Gülçin Santırcıoğlu',
          popularity: 1.134,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sw7n4eL1V9zBIK5Hf1J89poewDA.jpg',
          cast_id: 7,
          character: 'Vildan',
          credit_id: '5dc88604ab1bc7001505b6ca',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 556113,
          known_for_department: 'Diễn viên',
          name: 'İlker Aksum',
          original_name: 'İlker Aksum',
          popularity: 1.614,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4hBCyX3h89LZXAc0QxX45YEUVpA.jpg',
          cast_id: 8,
          character: 'Rıza',
          credit_id: '5dc8861be635710014028bf1',
          order: 8,
        },
        {
          adult: false,
          gender: 1,
          id: 1006787,
          known_for_department: 'Diễn viên',
          name: 'Hülya Duyar',
          original_name: 'Hülya Duyar',
          popularity: 2.135,
          profile_path: null,
          cast_id: 12,
          character: 'Rüya',
          credit_id: '5f2dbf6712eb890035249c60',
          order: 9,
        },
        {
          adult: false,
          gender: 0,
          id: 2864160,
          known_for_department: 'Diễn viên',
          name: 'Göktug Yildirim',
          original_name: 'Göktug Yildirim',
          popularity: 0.6,
          profile_path: null,
          cast_id: 21,
          character: 'Caner',
          credit_id: '5ff9ad7f097c49003f9c27b7',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 121426,
          known_for_department: 'Diễn viên',
          name: 'Okan Yalabık',
          original_name: 'Okan Yalabık',
          popularity: 2.188,
          profile_path:
            'https://image.tmdb.org/t/p/w185/k8qCNNUr0bisYAQSEHnZIbPSdYv.jpg',
          cast_id: 22,
          character: 'Psikiyatrist',
          credit_id: '5ff9adb620af77003c17a62e',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 109137,
          known_for_department: 'Diễn viên',
          name: 'Bergüzar Korel',
          original_name: 'Bergüzar Korel',
          popularity: 1.755,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bKxEGRESwq9ExvkoZZWfUrqYxWJ.jpg',
          cast_id: 23,
          character: 'Füsun',
          credit_id: '5ff9adc11c04350040bb228f',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 59764,
          known_for_department: 'Diễn viên',
          name: 'Halit Ergenç',
          original_name: 'Halit Ergenç',
          popularity: 1.64,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7L5ivMz1S7ArHTvUaslVVV3ML42.jpg',
          cast_id: 24,
          character: 'Necati',
          credit_id: '5ff9adc9021cee0040a7a0a4',
          order: 13,
        },
        {
          adult: false,
          gender: 0,
          id: 2091979,
          known_for_department: 'Diễn viên',
          name: 'Helin Kandemir',
          original_name: 'Helin Kandemir',
          popularity: 1.432,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pQ9hy0uvNppsb775vuJOUMxzbZq.jpg',
          cast_id: 25,
          character: 'Cansu',
          credit_id: '5ffa29dbdd83fa003e6f0992',
          order: 14,
        },
        {
          adult: false,
          gender: 0,
          id: 2929728,
          known_for_department: 'Diễn viên',
          name: 'Deniz Tekin',
          original_name: 'Deniz Tekin',
          popularity: 0.6,
          profile_path: null,
          cast_id: 26,
          character: 'Sıla',
          credit_id: '5ffa2a1bfcec2e003f171a2e',
          order: 15,
        },
        {
          adult: false,
          gender: 0,
          id: 2929729,
          known_for_department: 'Diễn viên',
          name: 'Bugay Akman',
          original_name: 'Bugay Akman',
          popularity: 0.6,
          profile_path: null,
          cast_id: 27,
          character: 'Tezgahtar',
          credit_id: '5ffa2a2a383df2003c35d255',
          order: 16,
        },
        {
          adult: false,
          gender: 0,
          id: 2929730,
          known_for_department: 'Diễn viên',
          name: 'Hazal Araci',
          original_name: 'Hazal Araci',
          popularity: 0.6,
          profile_path: null,
          cast_id: 28,
          character: 'Hemşire',
          credit_id: '5ffa2a59383df2003b356d93',
          order: 17,
        },
        {
          adult: false,
          gender: 0,
          id: 2929731,
          known_for_department: 'Diễn viên',
          name: 'Gizem Sayacan',
          original_name: 'Gizem Sayacan',
          popularity: 0.6,
          profile_path: null,
          cast_id: 29,
          character: 'Ofis çalışanı',
          credit_id: '5ffa2a6c61bac4003cab3dd1',
          order: 18,
        },
        {
          adult: false,
          gender: 0,
          id: 2929732,
          known_for_department: 'Diễn viên',
          name: 'Alla Serimogu',
          original_name: 'Alla Serimogu',
          popularity: 0.6,
          profile_path: null,
          cast_id: 30,
          character: 'Olga',
          credit_id: '5ffa2a7891f0ea003e9651fe',
          order: 19,
        },
        {
          adult: false,
          gender: 0,
          id: 2929733,
          known_for_department: 'Diễn viên',
          name: 'Aslı Işık',
          original_name: 'Aslı Işık',
          popularity: 0.6,
          profile_path: null,
          cast_id: 31,
          character: 'Ece',
          credit_id: '5ffa2a8891f0ea003e965256',
          order: 20,
        },
        {
          adult: false,
          gender: 0,
          id: 2929735,
          known_for_department: 'Diễn viên',
          name: 'Olcay Zuhal Gören',
          original_name: 'Olcay Zuhal Gören',
          popularity: 0.6,
          profile_path: null,
          cast_id: 32,
          character: 'DJ',
          credit_id: '5ffa2a93021cee0040a8506c',
          order: 21,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 115009,
          known_for_department: 'Directing',
          name: 'Durul Taylan',
          original_name: 'Durul Taylan',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/q2RAboLaw8uIYZb91yRtYxqUQo2.jpg',
          credit_id: '5dc886346c0e4f00153afd39',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 115009,
          known_for_department: 'Directing',
          name: 'Durul Taylan',
          original_name: 'Durul Taylan',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/q2RAboLaw8uIYZb91yRtYxqUQo2.jpg',
          credit_id: '5fed4dbf6dc6c00040e1f386',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 115009,
          known_for_department: 'Directing',
          name: 'Durul Taylan',
          original_name: 'Durul Taylan',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/q2RAboLaw8uIYZb91yRtYxqUQo2.jpg',
          credit_id: '5fed4e040f3655003eab3a57',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 115010,
          known_for_department: 'Directing',
          name: 'Yağmur Taylan',
          original_name: 'Yağmur Taylan',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5dc8864c7d2bc15a3734ecd9',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 115010,
          known_for_department: 'Directing',
          name: 'Yağmur Taylan',
          original_name: 'Yağmur Taylan',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5fed4dc66dc6c0003fe1c0bc',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 115010,
          known_for_department: 'Directing',
          name: 'Yağmur Taylan',
          original_name: 'Yağmur Taylan',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5fed4dfe4ccc50003c800dc4',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 230768,
          known_for_department: 'Camera',
          name: 'Burak Kanbir',
          original_name: 'Burak Kanbir',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fed4dccc2ff3d003cd6099e',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 1604325,
          known_for_department: 'Production',
          name: 'Müge Kolat',
          original_name: 'Müge Kolat',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fed4db80fb3980041bd00a9',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1604797,
          known_for_department: 'Art',
          name: 'Yasar Kartoglu',
          original_name: 'Yasar Kartoglu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fed4deaf18ce7003dfe702a',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 2,
          id: 1685734,
          known_for_department: 'Biên kịch',
          name: 'Berkun Oya',
          original_name: 'Berkun Oya',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bs1l4WITHTvdtnbv9gJm5L6JUDJ.jpg',
          credit_id: '5dc8866a99259c67b27a6006',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 2779931,
          known_for_department: 'Directing',
          name: 'Cem Toluay',
          original_name: 'Cem Toluay',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fed4df2c2ff3d003bd65651',
          department: 'Directing',
          job: 'Assistant Director',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/uLuy3yMcD4WFkzHZe1ugLbJWX9Z.jpg',
    belongs_to_collection: null,
    budget: 31000000,
    genres: [
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 10749, name: 'Phim Lãng Mạn' },
    ],
    homepage: '',
    id: 121602,
    imdb_id: 'tt2071441',
    original_language: 'zh',
    original_title: '危險關係',
    overview:
      'Lấy cảm hứng từ cuốn tiểu thuyết Les liaisons dangereuses của nhà văn người Pháp Choderlos de Laclos, ra đời năm 1782. Dangerous liaisons đưa người xem về Thượng Hải những năm 30 của thế ký trước. Tạ Dịch Phàm là chàng công tử ăn chơi khét tiếng nhất thành phố phải lòng Đỗ Phấn Ngọc – người phụ nữ trong sáng, thuần khiết. Trong khi đó, Mạc Tiệp Dư, người đàn bà phóng đãng mà Tạ Dịch Phàm chưa bao giờ chinh phục được, lại muốn anh cướp đi trinh tiết của một nữ sinh trong trắng vì cô này được hứa hôn cho gã tài phiệt mà Tiệp Dư hẹn hò. Những mối quan hệ nguy hiểm diễn ra trong một Thượng Hải phù hoa và đầy toan tính. ..Đời loạn, tình cũng loạn',
    popularity: 2.592,
    poster_path:
      'https://image.tmdb.org/t/p/w342/xbJHRwxkOdcYhiOc8bf5yyeF31F.jpg',
    production_companies: [
      {
        id: 25660,
        logo_path: null,
        name: 'Huaxia Film Distribution Company',
        origin_country: '',
      },
    ],
    production_countries: [
      { iso_3166_1: 'CN', name: 'Trung Quốc' },
      { iso_3166_1: 'SG', name: 'Singapore' },
      { iso_3166_1: 'KR', name: 'South Korea' },
    ],
    release_date: '2012-09-27',
    revenue: 0,
    runtime: 110,
    spoken_languages: [
      { english_name: 'Mandarin', iso_639_1: 'zh', name: '普通话' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Mối Quan Hệ Nguy Hiểm',
    video: false,
    vote_average: 6.3,
    vote_count: 32,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Dangerous Liaisons - Caught In Love',
          key: '4MIVITkZOZk',
          published_at: '2013-02-08T19:24:16.000Z',
          site: 'YouTube',
          size: 480,
          type: 'Clip',
          official: true,
          id: '58fa68a9c3a36879be000dbf',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'DANGEROUS LIAISONS (2013) Official US Trailer - Well Go USA',
          key: 'mN4Ald5BfTs',
          published_at: '2012-10-26T20:01:44.000Z',
          site: 'YouTube',
          size: 720,
          type: 'Trailer',
          official: true,
          id: '58fa68ffc3a3687a15000ca0',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 16962,
          known_for_department: 'Diễn viên',
          name: 'Jang Dong-gun',
          original_name: 'Jang Dong-gun',
          popularity: 1.383,
          profile_path:
            'https://image.tmdb.org/t/p/w185/otbTFpdLWAkjVqtvxFUtlHQjPMQ.jpg',
          cast_id: 6,
          character: 'Xie Yifan',
          credit_id: '52fe4a68c3a368484e151937',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 1339,
          known_for_department: 'Diễn viên',
          name: 'Zhang Ziyi',
          original_name: 'Zhang Ziyi',
          popularity: 6.649,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6DUCAJzpw06VoAA9VWrvB2g4dpq.jpg',
          cast_id: 1,
          character: 'Du Fenyu',
          credit_id: '52fe4a68c3a368484e15191d',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 20652,
          known_for_department: 'Diễn viên',
          name: 'Cecilia Cheung',
          original_name: 'Cecilia Cheung',
          popularity: 2.246,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3vaMtd9Xh54v31qrFAo3gZQ8hkh.jpg',
          cast_id: 5,
          character: 'Mo Jieyu',
          credit_id: '52fe4a68c3a368484e151933',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 145093,
          known_for_department: 'Diễn viên',
          name: 'Shawn Dou',
          original_name: 'Shawn Dou',
          popularity: 3.473,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2nJiCYDaYsfTeI66SwhHv4ug9kq.jpg',
          cast_id: 7,
          character: 'Dai Wenzhou',
          credit_id: '52fe4a68c3a368484e15193b',
          order: 3,
        },
        {
          adult: false,
          gender: 0,
          id: 1119879,
          known_for_department: 'Diễn viên',
          name: 'Candy Wang',
          original_name: 'Candy Wang',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/g6vJGDtVNmgGqKRfoNnZJStq4SE.jpg',
          cast_id: 9,
          character: 'Beibei',
          credit_id: '52fe4a68c3a368484e151943',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 86633,
          known_for_department: 'Diễn viên',
          name: 'Lisa Lu',
          original_name: 'Lisa Lu',
          popularity: 1.286,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cK69ncJvlUVnJwsVinSYc4n8yWw.jpg',
          cast_id: 8,
          character: 'Madame Du Ruixue',
          credit_id: '52fe4a68c3a368484e15193f',
          order: 5,
        },
        {
          adult: false,
          gender: 0,
          id: 1619290,
          known_for_department: 'Diễn viên',
          name: 'Xiao Shu-Li',
          original_name: 'Xiao Shu-Li',
          popularity: 0.6,
          profile_path: null,
          cast_id: 10,
          character: 'Gui Zhen',
          credit_id: '5735595dc3a368024700127a',
          order: 6,
        },
        {
          adult: false,
          gender: 0,
          id: 1619291,
          known_for_department: 'Diễn viên',
          name: 'Wu Fang',
          original_name: 'Wu Fang',
          popularity: 0.6,
          profile_path: null,
          cast_id: 11,
          character: "Hong, Jieyu's maid",
          credit_id: '5735597bc3a36802510013bd',
          order: 7,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 11879,
          known_for_department: 'Biên kịch',
          name: 'Choderlos de Laclos',
          original_name: 'Choderlos de Laclos',
          popularity: 0.716,
          profile_path: null,
          credit_id: '52fe4a68c3a368484e15192f',
          department: 'Biên kịch',
          job: 'Novel',
        },
        {
          adult: false,
          gender: 2,
          id: 96631,
          known_for_department: 'Directing',
          name: 'Hur Jin-ho',
          original_name: 'Hur Jin-ho',
          popularity: 1.022,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tFh3wQY0MQreWMBAo9r7ZMMUSfF.jpg',
          credit_id: '52fe4a68c3a368484e151923',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 1,
          id: 121567,
          known_for_department: 'Biên kịch',
          name: 'Yan Geling',
          original_name: 'Yan Geling',
          popularity: 1.201,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2RT1mALyTwskFHwHJ41DRUva4ji.jpg',
          credit_id: '52fe4a68c3a368484e151929',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 1293085,
          known_for_department: 'Directing',
          name: 'Kim Byung-seo',
          original_name: 'Kim Byung-seo',
          popularity: 0.652,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gqRy9wYEusoapWB4lB26hHcfwFM.jpg',
          credit_id: '5c2db614c3a3682913a49d5b',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 1296355,
          known_for_department: 'Sound',
          name: 'Cho Sung-woo',
          original_name: 'Cho Sung-woo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e057f370284200016b84686',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 0,
          id: 2119924,
          known_for_department: 'Editing',
          name: 'Moon Se-kyoung',
          original_name: 'Moon Se-kyoung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ceba8a99251414398bb0ea3',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2220907,
          known_for_department: 'Costume & Make-Up',
          name: 'Lee Seo-jin',
          original_name: 'Lee Seo-jin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cd69957c3a36875bcc0c051',
          department: 'Costume & Make-Up',
          job: 'Makeup & Hair',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/88J6waYVTta8Qz3iX3qUeWNA5d5.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 10749, name: 'Phim Lãng Mạn' },
    ],
    homepage: '',
    id: 447362,
    imdb_id: 'tt6598238',
    original_language: 'en',
    original_title: 'Life in a Year',
    overview:
      'Phim kể về Daryn, 17 tuổi, người phát hiện ra rằng bạn gái của mình không còn sống được bao lâu nữa. Anh ấy đặt ra kế hoạch trong 1 năm cho cuộc sống của cô ấy trước khi cô ấy ra đi.',
    popularity: 81.838,
    poster_path:
      'https://image.tmdb.org/t/p/w342/bP7u19opmHXYeTCUwGjlLldmUMc.jpg',
    production_companies: [
      {
        id: 907,
        logo_path: '/ca5SWI5uvU985f8Kbb4xc8AmVWH.png',
        name: 'Overbrook Entertainment',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2020-11-27',
    revenue: 0,
    runtime: 107,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Một Năm Để Sống',
    video: false,
    vote_average: 9.4,
    vote_count: 908,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Official Trailer',
          key: 'BgmJ14p4Uuk',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2020-11-27T17:00:04.000Z',
          id: '61435ba893bd690043b21518',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 120724,
          known_for_department: 'Diễn viên',
          name: 'Jaden Smith',
          original_name: 'Jaden Smith',
          popularity: 4.248,
          profile_path:
            'https://image.tmdb.org/t/p/w185/meraACSN0LYwLeZlaXN9YW6JCZT.jpg',
          cast_id: 1,
          character: 'Daryn',
          credit_id: '58cb31379251415e2f005666',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 1289968,
          known_for_department: 'Diễn viên',
          name: 'Cara Delevingne',
          original_name: 'Cara Delevingne',
          popularity: 8.377,
          profile_path:
            'https://image.tmdb.org/t/p/w185/izZ8IbsIjNpjZ5S0HIYreVwVRzn.jpg',
          cast_id: 0,
          character: 'Isabelle',
          credit_id: '58cb31319251415e570050d0',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 9777,
          known_for_department: 'Diễn viên',
          name: 'Cuba Gooding Jr.',
          original_name: 'Cuba Gooding Jr.',
          popularity: 3.414,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2JguzbpOXoTGzSmLbWFlulKyyAe.jpg',
          cast_id: 9,
          character: 'Xavier',
          credit_id: '59180978c3a3684269043e53',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 9781,
          known_for_department: 'Diễn viên',
          name: 'Nia Long',
          original_name: 'Nia Long',
          popularity: 3.335,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2HnplqKDWkLyReeeAPsbEctkpPQ.jpg',
          cast_id: 6,
          character: 'Catherine',
          credit_id: '58f0914cc3a3686b4d00daea',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 150,
          known_for_department: 'Sound',
          name: 'RZA',
          original_name: 'RZA',
          popularity: 3.141,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2PVYCKXb1X3PLawJNoYGLN1x0In.jpg',
          cast_id: 7,
          character: 'Ron',
          credit_id: '58f09154925141259800d90b',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 1795840,
          known_for_department: 'Diễn viên',
          name: 'JT Neal',
          original_name: 'JT Neal',
          popularity: 0.669,
          profile_path:
            'https://image.tmdb.org/t/p/w185/619XoheJeeajNAUQd9hwnPSoUCB.jpg',
          cast_id: 8,
          character: 'Sammy',
          credit_id: '58f0916f92514125a500d7a3',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 1260036,
          known_for_department: 'Diễn viên',
          name: "Chris D'Elia",
          original_name: "Chris D'Elia",
          popularity: 1.38,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4ireISwJiMAhQdcm2zdZvYKtcWW.jpg',
          cast_id: 10,
          character: 'Phil',
          credit_id: '592c337ac3a368783e076b2d',
          order: 7,
        },
        {
          adult: false,
          gender: 1,
          id: 1639984,
          known_for_department: 'Diễn viên',
          name: 'Harper Gunn',
          original_name: 'Harper Gunn',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nmPGMMuBO2lqiWVOorActooMkS9.jpg',
          cast_id: 11,
          character: 'Little Girl',
          credit_id: '5b5bc65d925141522a008c37',
          order: 8,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 2888,
          known_for_department: 'Diễn viên',
          name: 'Will Smith',
          original_name: 'Will Smith',
          popularity: 16.185,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zCrnERhs0L8FNK6xz4f5wWp0pKK.jpg',
          credit_id: '60f5c52d12c6040074471dd5',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 9575,
          known_for_department: 'Diễn viên',
          name: 'Jada Pinkett Smith',
          original_name: 'Jada Pinkett Smith',
          popularity: 14.503,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jqVbh4LkOHyZ7Lq1mauEJMU9GTj.jpg',
          credit_id: '60f5c517f90b190045642ca1',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 46080,
          known_for_department: 'Production',
          name: 'James Lassiter',
          original_name: 'James Lassiter',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f5c4f7c439c000465a6fbc',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 56346,
          known_for_department: 'Sound',
          name: 'Photek',
          original_name: 'Photek',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5bcd9d13c3a368286d021e17',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 1,
          id: 501226,
          known_for_department: 'Camera',
          name: 'Quyen Tran',
          original_name: 'Quyen Tran',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/a8jmsx8t6fvONa2rIhZNTbYR2fQ.jpg',
          credit_id: '5bcd9d2ac3a36828630208f0',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 586154,
          known_for_department: 'Directing',
          name: 'Mitja Okorn',
          original_name: 'Mitja Okorn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58cb314c9251415e5d0050f9',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1567301,
          known_for_department: 'Costume & Make-Up',
          name: 'Catherine Ashton',
          original_name: 'Catherine Ashton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5bcd9d09c3a368286a022553',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1778035,
          known_for_department: 'Biên kịch',
          name: 'Jeffrey Addiss',
          original_name: 'Jeffrey Addiss',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58cb315d9251415e6f0055d9',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 1778036,
          known_for_department: 'Biên kịch',
          name: 'Will Matthews',
          original_name: 'Will Matthews',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58cb317ac3a368287d005ab3',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 3162784,
          known_for_department: 'Crew',
          name: 'Jordan Craig',
          original_name: 'Jordan Craig',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f5c587e72fe8002f89f1bb',
          department: 'Crew',
          job: 'Special Effects Coordinator',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'katch22',
          author_details: {
            name: '',
            username: 'katch22',
            avatar_path: null,
            rating: 6.0,
          },
          content:
            'Jaden Smith is still not much of an actor, but it\'s "Love Story" for teens.',
          created_at: '2021-07-09T11:46:35.242Z',
          id: '60e8371b9979d20046028b21',
          updated_at: '2021-07-09T14:10:44.404Z',
          url: 'https://www.themoviedb.org/review/60e8371b9979d20046028b21',
        },
      ],
      total_pages: 1,
      total_results: 1,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/AlFqBwJnokrp9zWTXOUv7uhkaeq.jpg',
    belongs_to_collection: {
      id: 529892,
      name: 'Black Panther Collection',
      poster_path: '/uVnN6KnfDuHiC8rsVsSc7kk0WRD.jpg',
      backdrop_path: '/1Jj7Frjjbewb6Q6dl6YXhL3kuvL.jpg',
    },
    budget: 200000000,
    genres: [
      { id: 28, name: 'Phim Hành Động' },
      { id: 12, name: 'Phim Phiêu Lưu' },
      { id: 878, name: 'Phim Khoa Học Viễn Tưởng' },
    ],
    homepage: 'https://marvel.com/movies/movie/224/black_panther',
    id: 284054,
    imdb_id: 'tt1825683',
    original_language: 'en',
    original_title: 'Black Panther',
    overview:
      "Vương quốc Wakanda, quê hương của Black Panther/ T'Challa hiện ra qua lời kể của một nhân chứng sống sót trở về. Đây là quốc gia khá khép kín và sở hữu lượng Vibranium lớn nhất trên thế giới. Black Panther - người cầm quyền của Wakanda sở hữu bộ áo giáp chống đạn và móng vuốt sắc nhọn, anh được miêu tả là “người tốt với trái tim nhân hậu”.\r Nhưng cũng chính vì những đức tính tốt này mà Black Panther gặp khó khăn khi kế thừa ngai vàng sau khi vua cha băng hà. Đối mặt với sự phản bội và hiểm nguy, vị vua trẻ phải tập hợp các đồng minh và phát huy toàn bộ sức mạnh của Black Panther để đánh bại kẻ thù, đem lại an bình cho nhân dân của mình.",
    popularity: 162.795,
    poster_path:
      'https://image.tmdb.org/t/p/w342/uxzzxijgPIY7slzFvMotPv8wjKA.jpg',
    production_companies: [
      {
        id: 420,
        logo_path: '/hUzeosd33nzE5MCNsZxCGEKTXaQ.png',
        name: 'Marvel Studios',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2018-02-13',
    revenue: 1346739107,
    runtime: 134,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
      { english_name: 'Korean', iso_639_1: 'ko', name: '한국어/조선말' },
      { english_name: 'Swahili', iso_639_1: 'sw', name: 'Kiswahili' },
      { english_name: 'Xhosa', iso_639_1: 'xh', name: '' },
    ],
    status: 'Đã phát hành',
    tagline: 'Long live the king.',
    title: 'Chiến Binh Báo Đen',
    video: false,
    vote_average: 7.4,
    vote_count: 18363,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: "It's A Set Up",
          key: 'u0SBlLWNe5s',
          published_at: '2018-01-30T05:11:42.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: true,
          id: '5aefc2a90e0a261d7400c1d4',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: "Let's Go TV Spot",
          key: 'zkWiTLKE0mg',
          published_at: '2018-01-29T03:00:01.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Teaser',
          official: true,
          id: '5aefc18b0e0a261d8600c902',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'War TV Spot',
          key: '2GTI0MHj3dM',
          published_at: '2018-01-25T19:00:01.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Teaser',
          official: true,
          id: '5aefc1b9c3a368142a00c59f',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Kinetic Energy',
          key: 'sgX_StgXGF0',
          published_at: '2018-01-24T17:01:18.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: true,
          id: '5aefc158c3a36813ff014327',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Wakanda Revealed',
          key: 'jJm2WFTscDM',
          published_at: '2018-01-22T19:38:20.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Featurette',
          official: true,
          id: '5a9730510e0a260153005b65',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Entourage TV Spot',
          key: 'mSAgLsrZG2Q',
          published_at: '2018-01-14T18:00:08.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Teaser',
          official: true,
          id: '5aefc24dc3a368141e009996',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Warriors of Wakanda',
          key: 'HnnRyhuX_jM',
          published_at: '2018-01-12T17:00:03.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Featurette',
          official: true,
          id: '5a9730300e0a26016500595d',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Good to Be King',
          key: 'y9fBzUtrKwY',
          published_at: '2018-01-11T18:00:29.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Featurette',
          official: true,
          id: '5a973072c3a368613d005542',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Rise TV Spot',
          key: 'PJBmeqpw3DY',
          published_at: '2018-01-09T03:13:21.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Teaser',
          official: true,
          id: '5aefc0fb0e0a261d8f00c2c0',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'From Page to Screen',
          key: 'yH72D12BkzY',
          published_at: '2018-01-04T17:00:06.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Featurette',
          official: true,
          id: '5a97309b92514128a70052b3',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'King TV Spot',
          key: '3nS_wzicYX4',
          published_at: '2017-12-25T17:00:00.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Teaser',
          official: true,
          id: '5aefc1fe925141768800db7c',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Official Trailer',
          key: 'xjDjIWPwcPU',
          published_at: '2017-10-16T13:00:07.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '5a96a57c0e0a26544a008cf9',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Black Panther Teaser Trailer [HD]',
          key: 'dxWvtMOGAhw',
          published_at: '2017-06-10T01:27:14.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '5af96a36925141399600762a',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 172069,
          known_for_department: 'Diễn viên',
          name: 'Chadwick Boseman',
          original_name: 'Chadwick Boseman',
          popularity: 6.644,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mXxiOTrTMJBRSVRfgaSDhOfvfxU.jpg',
          cast_id: 0,
          character: 'King T’Challa / Black Panther',
          credit_id: '544fe785c3a3680242002758',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 135651,
          known_for_department: 'Diễn viên',
          name: 'Michael B. Jordan',
          original_name: 'Michael B. Jordan',
          popularity: 17.784,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hz9AOUWZ2zzS0dpPJ1yQv2grA35.jpg',
          cast_id: 4,
          character: "N'Jadaka / Erik 'Killmonger' Stevens",
          credit_id: '57364cc69251410b27000e31',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 1267329,
          known_for_department: 'Diễn viên',
          name: "Lupita Nyong'o",
          original_name: "Lupita Nyong'o",
          popularity: 2.503,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fGBB6Er4S6hb5zOp8xQtpMrxx5q.jpg',
          cast_id: 5,
          character: 'Nakia',
          credit_id: '57374f77c3a3680516000c67',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 82104,
          known_for_department: 'Diễn viên',
          name: 'Danai Gurira',
          original_name: 'Danai Gurira',
          popularity: 4.698,
          profile_path:
            'https://image.tmdb.org/t/p/w185/z7H7QeQvr24vskGlANQhG43vozQ.jpg',
          cast_id: 30,
          character: 'Okoye',
          credit_id: '57951c20925141136a008222',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 7060,
          known_for_department: 'Diễn viên',
          name: 'Martin Freeman',
          original_name: 'Martin Freeman',
          popularity: 7.487,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pLG7mmxBXXTVAgzXvQl0ap3qlJU.jpg',
          cast_id: 38,
          character: 'Everett K. Ross',
          credit_id: '585e318192514115ca009b9f',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 206919,
          known_for_department: 'Diễn viên',
          name: 'Daniel Kaluuya',
          original_name: 'Daniel Kaluuya',
          popularity: 5.007,
          profile_path:
            'https://image.tmdb.org/t/p/w185/a07Tqzgp0IrW9YkcOQiuKavP4tm.jpg',
          cast_id: 33,
          character: "W'Kabi",
          credit_id: '57fb979fc3a36837960090b6',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 1083010,
          known_for_department: 'Diễn viên',
          name: 'Letitia Wright',
          original_name: 'Letitia Wright',
          popularity: 3.006,
          profile_path:
            'https://image.tmdb.org/t/p/w185/i6fbYNn5jWA6swWtaqgzaj02RMc.jpg',
          cast_id: 35,
          character: 'Shuri',
          credit_id: '580a43f09251411771000bc9',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 1447932,
          known_for_department: 'Diễn viên',
          name: 'Winston Duke',
          original_name: 'Winston Duke',
          popularity: 3.697,
          profile_path:
            'https://image.tmdb.org/t/p/w185/MhBiZbryibwuoEtPL9Ns8pYHC1.jpg',
          cast_id: 31,
          character: "M'Baku",
          credit_id: '57f83a19c3a3685f23000662',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 1225953,
          known_for_department: 'Diễn viên',
          name: 'Sterling K. Brown',
          original_name: 'Sterling K. Brown',
          popularity: 3.888,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ntIcqeHafMMmcH8OfKYN8itn0Sb.jpg',
          cast_id: 39,
          character: "N'Jobu",
          credit_id: '586eafc7925141295f00aaad',
          order: 8,
        },
        {
          adult: false,
          gender: 1,
          id: 9780,
          known_for_department: 'Diễn viên',
          name: 'Angela Bassett',
          original_name: 'Angela Bassett',
          popularity: 4.273,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7Oz53NKdglRzAzI2MKjM3eQXwn.jpg',
          cast_id: 36,
          character: 'Ramonda',
          credit_id: '5833e021c3a368338d007b99',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 2178,
          known_for_department: 'Diễn viên',
          name: 'Forest Whitaker',
          original_name: 'Forest Whitaker',
          popularity: 7.977,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fugyEeN6sisuYi07HSoxdVHm0CZ.jpg',
          cast_id: 32,
          character: 'Zuri',
          credit_id: '57f83a6dc3a3685f35000630',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 1333,
          known_for_department: 'Diễn viên',
          name: 'Andy Serkis',
          original_name: 'Andy Serkis',
          popularity: 18.858,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eNGqhebQ4cDssjVeNFrKtUvweV5.jpg',
          cast_id: 2,
          character: 'Ulysses Klaue / Klaw',
          credit_id: '54a9c37dc3a3680c210059c8',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 139900,
          known_for_department: 'Diễn viên',
          name: 'Florence Kasumba',
          original_name: 'Florence Kasumba',
          popularity: 1.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vivJLQhtwca5hupqoRRgL8BRs6o.jpg',
          cast_id: 34,
          character: 'Ayo',
          credit_id: '57fb97c29251411800000021',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 51878,
          known_for_department: 'Diễn viên',
          name: 'John Kani',
          original_name: 'John Kani',
          popularity: 2.843,
          profile_path:
            'https://image.tmdb.org/t/p/w185/g7tqg3q128a5O2qXMCwVnXsow9I.jpg',
          cast_id: 41,
          character: "T'Chaka",
          credit_id: '588697a7925141125e004ed1',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 71078,
          known_for_department: 'Diễn viên',
          name: 'David S. Lee',
          original_name: 'David S. Lee',
          popularity: 1.721,
          profile_path:
            'https://image.tmdb.org/t/p/w185/Je5btH3d4hREmOH7sHusD0J7ky.jpg',
          cast_id: 65,
          character: 'Limbani',
          credit_id: '597353dbc3a3686fc7056b8f',
          order: 14,
        },
        {
          adult: false,
          gender: 1,
          id: 1856116,
          known_for_department: 'Diễn viên',
          name: 'Nabiyah Be',
          original_name: 'Nabiyah Be',
          popularity: 0.917,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ptRZu76BQ9W4GEVQazLNEuqmH3j.jpg',
          cast_id: 70,
          character: 'Linda',
          credit_id: '597354fd9251414272005136',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 4812,
          known_for_department: 'Diễn viên',
          name: 'Isaach De Bankolé',
          original_name: 'Isaach De Bankolé',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tIihjWrBfzZahWaAwf8XFuYO0JS.jpg',
          cast_id: 44,
          character: 'River Tribe Elder',
          credit_id: '58debd68c3a3687c6f00f4b9',
          order: 16,
        },
        {
          adult: false,
          gender: 1,
          id: 1181397,
          known_for_department: 'Diễn viên',
          name: 'Connie Chiume',
          original_name: 'Connie Chiume',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3ET4rE2aAEyczhognWWi1rPAdWo.jpg',
          cast_id: 81,
          character: 'Mining Tribe Elder',
          credit_id: '597355f8c3a3681d7000510e',
          order: 17,
        },
        {
          adult: false,
          gender: 1,
          id: 1979169,
          known_for_department: 'Diễn viên',
          name: 'Dorothy  Steel',
          original_name: 'Dorothy  Steel',
          popularity: 1.708,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5KpjansHF7JUhozyWZhDTAsOjM9.jpg',
          cast_id: 197,
          character: 'Merchant Tribe Elder',
          credit_id: '5a8684c7c3a3682dbf039df1',
          order: 18,
        },
        {
          adult: false,
          gender: 2,
          id: 165424,
          known_for_department: 'Diễn viên',
          name: 'Danny Sapani',
          original_name: 'Danny Sapani',
          popularity: 2.311,
          profile_path:
            'https://image.tmdb.org/t/p/w185/h6goTpKA74Z6ePB2BAEEyQnGtCF.jpg',
          cast_id: 198,
          character: 'Border Tribe Elder',
          credit_id: '5a8684ddc3a3686316035710',
          order: 19,
        },
        {
          adult: false,
          gender: 1,
          id: 1104414,
          known_for_department: 'Diễn viên',
          name: 'Sydelle Noel',
          original_name: 'Sydelle Noel',
          popularity: 2.188,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fCOlRtkZVMOMDRPYhdRLeKqymVa.jpg',
          cast_id: 64,
          character: 'Xoliswa',
          credit_id: '597353a29251414272004f48',
          order: 20,
        },
        {
          adult: false,
          gender: 1,
          id: 1979170,
          known_for_department: 'Diễn viên',
          name: 'Marija Abney',
          original_name: 'Marija Abney',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/t7hF4WRqEDMksYPSNRx3fxEN6GY.jpg',
          cast_id: 199,
          character: 'Dora Milaje',
          credit_id: '5a86850ec3a36863e7031f6b',
          order: 21,
        },
        {
          adult: false,
          gender: 1,
          id: 1979176,
          known_for_department: 'Diễn viên',
          name: 'Zola Williams',
          original_name: 'Zola Williams',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/j1eJLQQbrfG4EZRFIgNuSsH6A8D.jpg',
          cast_id: 204,
          character: 'Dora Milaje',
          credit_id: '5a86856f0e0a2652ab032f54',
          order: 22,
        },
        {
          adult: false,
          gender: 1,
          id: 1580160,
          known_for_department: 'Diễn viên',
          name: 'Janeshia Adams-Ginyard',
          original_name: 'Janeshia Adams-Ginyard',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/j6Euv6cfgGxQhA7kf9MSenfB8Vl.jpg',
          cast_id: 200,
          character: 'Dora Milaje',
          credit_id: '5a868517c3a36862e103320d',
          order: 23,
        },
        {
          adult: false,
          gender: 1,
          id: 1979172,
          known_for_department: 'Diễn viên',
          name: 'Maria Hippolyte',
          original_name: 'Maria Hippolyte',
          popularity: 0.972,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pfHneM6l5FUiQuAzg6yXxoBQLsH.jpg',
          cast_id: 202,
          character: 'Dora Milaje',
          credit_id: '5a86853ec3a3682dbf039e5c',
          order: 24,
        },
        {
          adult: false,
          gender: 1,
          id: 1979183,
          known_for_department: 'Diễn viên',
          name: 'Marie Mouroum',
          original_name: 'Marie Mouroum',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/42kktBafPgWXvkrRHVqEglutj1p.jpg',
          cast_id: 208,
          character: 'Dora Milaje',
          credit_id: '5a868737c3a36863390360c3',
          order: 25,
        },
        {
          adult: false,
          gender: 1,
          id: 1903679,
          known_for_department: 'Diễn viên',
          name: 'Jénel Stevens',
          original_name: 'Jénel Stevens',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rDluL1q4RTPY54J95NH7JAIq4ch.jpg',
          cast_id: 203,
          character: 'Dora Milaje',
          credit_id: '5a8685680e0a264011042080',
          order: 26,
        },
        {
          adult: false,
          gender: 1,
          id: 1431508,
          known_for_department: 'Diễn viên',
          name: 'Sope Aluko',
          original_name: 'Sope Aluko',
          popularity: 1.126,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dNfAM8jNgwa1693nuplfjp70Ls4.jpg',
          cast_id: 48,
          character: 'Shaman',
          credit_id: '58debd699251411bbc0113fd',
          order: 27,
        },
        {
          adult: false,
          gender: 2,
          id: 7624,
          known_for_department: 'Biên kịch',
          name: 'Stan Lee',
          original_name: 'Stan Lee',
          popularity: 10.552,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kKeyWoFtTqOPsbmwylNHmuB3En9.jpg',
          cast_id: 37,
          character: 'Casino Patron',
          credit_id: '583762a2c3a36836a9018430',
          order: 28,
        },
        {
          adult: false,
          gender: 2,
          id: 1222428,
          known_for_department: 'Diễn viên',
          name: 'Atandwa Kani',
          original_name: 'Atandwa Kani',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/m2j7GJBMlOffc3DUcAbBb34KfOY.jpg',
          cast_id: 42,
          character: "Young T'Chaka",
          credit_id: '588697b9c3a3684736002475',
          order: 29,
        },
        {
          adult: false,
          gender: 2,
          id: 1734933,
          known_for_department: 'Diễn viên',
          name: 'Ashton Tyler',
          original_name: 'Ashton Tyler',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nVMGCpJmOyda68ZFuqPaXkGL5h7.jpg',
          cast_id: 206,
          character: "Young T'Challa",
          credit_id: '5a8685d69251410a890328bc',
          order: 30,
        },
        {
          adult: false,
          gender: 2,
          id: 77278,
          known_for_department: 'Diễn viên',
          name: 'Denzel Whitaker',
          original_name: 'Denzel Whitaker',
          popularity: 2.385,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8l5y5UDtkKJ13WQybqRXUEma7nm.jpg',
          cast_id: 207,
          character: 'Young Zuri',
          credit_id: '5a868625c3a36862a70309b8',
          order: 31,
        },
        {
          adult: false,
          gender: 1,
          id: 1787399,
          known_for_department: 'Diễn viên',
          name: 'Shaunette Renée Wilson',
          original_name: 'Shaunette Renée Wilson',
          popularity: 1.507,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fPjeTxxE2sB0bQUcAoO13mKsKK5.jpg',
          cast_id: 43,
          character: 'Dora Milaje',
          credit_id: '58debd68c3a3687c4500fbe3',
          order: 32,
        },
        {
          adult: false,
          gender: 1,
          id: 1979177,
          known_for_department: 'Diễn viên',
          name: 'Christine Hollingsworth',
          original_name: 'Christine Hollingsworth',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3Kv5wZpNh8yoV0OLx4hLctGqhSi.jpg',
          cast_id: 205,
          character: 'Dora Milaje',
          credit_id: '5a8685780e0a26400b037147',
          order: 33,
        },
        {
          adult: false,
          gender: 0,
          id: 1821546,
          known_for_department: 'Diễn viên',
          name: 'Lucy Hockings',
          original_name: 'Lucy Hockings',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nTcf3wQBsSSQNMCJt9AtLH20OBg.jpg',
          cast_id: 366,
          character: 'BBC Reporter',
          credit_id: '5acf2f900e0a2631cc05b45e',
          order: 34,
        },
        {
          adult: false,
          gender: 2,
          id: 965219,
          known_for_department: 'Diễn viên',
          name: 'Bambadjan Bamba',
          original_name: 'Bambadjan Bamba',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6Uk5XX0zRDYJeeIkjgtScS5zjFG.jpg',
          cast_id: 45,
          character: 'Military Leader',
          credit_id: '58debd689251411ba6010599',
          order: 35,
        },
        {
          adult: false,
          gender: 2,
          id: 1787404,
          known_for_department: 'Diễn viên',
          name: 'Roland Kilumbu',
          original_name: 'Roland Kilumbu',
          popularity: 1.62,
          profile_path: null,
          cast_id: 58,
          character: 'Young Military',
          credit_id: '58debd6c9251411b7a0110b9',
          order: 36,
        },
        {
          adult: false,
          gender: 1,
          id: 171733,
          known_for_department: 'Diễn viên',
          name: 'Francesca Faridany',
          original_name: 'Francesca Faridany',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fbXecW3S1MJMWWCIVgWWB3WcGfr.jpg',
          cast_id: 57,
          character: 'Museum Director',
          credit_id: '58debd6c9251411b7a0110b6',
          order: 37,
        },
        {
          adult: false,
          gender: 2,
          id: 1301772,
          known_for_department: 'Diễn viên',
          name: 'Mark Ashworth',
          original_name: 'Mark Ashworth',
          popularity: 2.778,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nfhUTghFe0izP9NguZsDVqmVgEk.jpg',
          cast_id: 67,
          character: 'Security Guard',
          credit_id: '5973541ec3a36830fb00b1d2',
          order: 38,
        },
        {
          adult: false,
          gender: 2,
          id: 1609481,
          known_for_department: 'Diễn viên',
          name: 'Seth Carr',
          original_name: 'Seth Carr',
          popularity: 1.654,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yUB4bPUv7pKU1hSfzxNjL16HVnn.jpg',
          cast_id: 52,
          character: 'Young Killmonger',
          credit_id: '58debd6a9251411b7a0110b4',
          order: 39,
        },
        {
          adult: false,
          gender: 0,
          id: 1456750,
          known_for_department: 'Diễn viên',
          name: 'Jeremy Sample',
          original_name: 'Jeremy Sample',
          popularity: 0.621,
          profile_path:
            'https://image.tmdb.org/t/p/w185/70zuIzKldndDy9fE21i8bZNEfxy.jpg',
          cast_id: 47,
          character: 'Jabari Fisherman',
          credit_id: '58debd699251411b87010f3b',
          order: 40,
        },
        {
          adult: false,
          gender: 1,
          id: 58930,
          known_for_department: 'Diễn viên',
          name: 'Alexis Rhee',
          original_name: 'Alexis Rhee',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ibTzWLoGOCwAwhMAWgrLjLcUlXp.jpg',
          cast_id: 51,
          character: 'Sophia',
          credit_id: '58debd6ac3a3687c4500fbe9',
          order: 41,
        },
        {
          adult: false,
          gender: 2,
          id: 1688889,
          known_for_department: 'Diễn viên',
          name: 'Alex Hibbert',
          original_name: 'Alex Hibbert',
          popularity: 1.094,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nGUjQOlY1pqsJtiWrui2ylzkmBm.jpg',
          cast_id: 209,
          character: 'Young Oakland Kid',
          credit_id: '5a87b55b0e0a2653b30486d1',
          order: 42,
        },
        {
          adult: false,
          gender: 2,
          id: 131133,
          known_for_department: 'Diễn viên',
          name: 'Trevor Noah',
          original_name: 'Trevor Noah',
          popularity: 1.176,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xwJ3MUh5wJ39KQZ3Lz8v8jzMTng.jpg',
          cast_id: 369,
          character: 'Griot (voice)',
          credit_id: '5b0af817c3a3684b280078c7',
          order: 43,
        },
        {
          adult: false,
          gender: 2,
          id: 1787407,
          known_for_department: 'Diễn viên',
          name: 'Danny Chung',
          original_name: 'Danny Chung',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zDdG3uBSPQCBFGYMIhtbv3uKzUG.jpg',
          cast_id: 61,
          character: 'Casino Dealer',
          credit_id: '58debd6d9251411b6f011a86',
          order: 44,
        },
        {
          adult: false,
          gender: 2,
          id: 973644,
          known_for_department: 'Diễn viên',
          name: 'Shad Gaspard',
          original_name: 'Shad Gaspard',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/NPn8XIKB9wvICevya40bvbsBNB.jpg',
          cast_id: 69,
          character: 'Actor',
          credit_id: '597354629251417fa602c358',
          order: 45,
        },
        {
          adult: false,
          gender: 2,
          id: 1771603,
          known_for_department: 'Diễn viên',
          name: 'William Cowboy Reed',
          original_name: 'William Cowboy Reed',
          popularity: 0.84,
          profile_path: null,
          cast_id: 90,
          character: 'Museum Guard',
          credit_id: '5973566a9251417fa602c695',
          order: 46,
        },
        {
          adult: false,
          gender: 2,
          id: 1787401,
          known_for_department: 'Diễn viên',
          name: 'Michael David Yuhl',
          original_name: 'Michael David Yuhl',
          popularity: 1.128,
          profile_path:
            'https://image.tmdb.org/t/p/w185/24nSjJMXpVtdwLl3swagokWO2dj.jpg',
          cast_id: 50,
          character: 'Ambassador',
          credit_id: '58debd6a9251411b7a0110ae',
          order: 47,
        },
        {
          adult: false,
          gender: 1,
          id: 1773399,
          known_for_department: 'Diễn viên',
          name: 'Liz Elkins Newcomer',
          original_name: 'Liz Elkins Newcomer',
          popularity: 0.659,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8FD3YbTAKBkA9F69P4ihGID1bg0.jpg',
          cast_id: 49,
          character: 'CIA Agent',
          credit_id: '58debd69c3a3687c5d00fd1a',
          order: 48,
        },
        {
          adult: false,
          gender: 1,
          id: 1787400,
          known_for_department: 'Diễn viên',
          name: 'Raven Wynn',
          original_name: 'Raven Wynn',
          popularity: 0.608,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lkkNJ5jyEhQC7xYeciCGndFXIYV.jpg',
          cast_id: 46,
          character: 'Korean Market Shopper',
          credit_id: '58debd69c3a3687c6f00f4bc',
          order: 49,
        },
        {
          adult: false,
          gender: 2,
          id: 1787402,
          known_for_department: 'Diễn viên',
          name: 'Amechi Okocha',
          original_name: 'Amechi Okocha',
          popularity: 0.833,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oTjzVrBS97sc4fVcJ7BYjBPNmZq.jpg',
          cast_id: 53,
          character: 'Bueze',
          credit_id: '58debd6b9251411b6f011a7c',
          order: 50,
        },
        {
          adult: false,
          gender: 2,
          id: 1460999,
          known_for_department: 'Diễn viên',
          name: 'Tony Sears',
          original_name: 'Tony Sears',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/h42w87dEqFTFBypjTnqJCTAMxfM.jpg',
          cast_id: 55,
          character: 'French Ambassador',
          credit_id: '58debd6b9251411bbc0113ff',
          order: 51,
        },
        {
          adult: false,
          gender: 2,
          id: 1787405,
          known_for_department: 'Diễn viên',
          name: 'Timothy Carr',
          original_name: 'Timothy Carr',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hVcWRcR8SLGIlmdhYILkC3q116a.jpg',
          cast_id: 59,
          character: 'UN Security Guard',
          credit_id: '58debd6cc3a3687c1c00fcf5',
          order: 52,
        },
        {
          adult: false,
          gender: 2,
          id: 1787406,
          known_for_department: 'Diễn viên',
          name: 'Apollo GT',
          original_name: 'Apollo GT',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fw6pIImSmsw6ywXuJzdhszULxkO.jpg',
          cast_id: 60,
          character: 'Fish Market Shopper',
          credit_id: '58debd6d92514176b0002cc5',
          order: 53,
        },
        {
          adult: false,
          gender: 0,
          id: 1787408,
          known_for_department: 'Diễn viên',
          name: 'James Siderits',
          original_name: 'James Siderits',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aFafHQ8w3AalIeejJ0E9JBt4qGv.jpg',
          cast_id: 62,
          character: 'U.N. Official / Translator',
          credit_id: '58debd6d9251411bbc011403',
          order: 54,
        },
        {
          adult: false,
          gender: 2,
          id: 1367313,
          known_for_department: 'Diễn viên',
          name: 'Travis Love',
          original_name: 'Travis Love',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cXSKpa4rts3r8AIqxP5MsRRTdYd.jpg',
          cast_id: 66,
          character: 'Jabari Warrior',
          credit_id: '59735402c3a3687c7d02aaa9',
          order: 55,
        },
        {
          adult: false,
          gender: 1,
          id: 1734929,
          known_for_department: 'Diễn viên',
          name: 'Lidya Jewett',
          original_name: 'Lidya Jewett',
          popularity: 1.445,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6jZdx71jIvAwpMVVHxtGkvEkfv6.jpg',
          cast_id: 68,
          character: 'Young Nakia',
          credit_id: '5973542dc3a3687c7d02aae3',
          order: 56,
        },
        {
          adult: false,
          gender: 1,
          id: 1795537,
          known_for_department: 'Diễn viên',
          name: 'Alona Leoine',
          original_name: 'Alona Leoine',
          popularity: 1.38,
          profile_path: null,
          cast_id: 71,
          character: 'School Child / Playground Kid',
          credit_id: '5973550e92514142a7004e9a',
          order: 57,
        },
        {
          adult: false,
          gender: 0,
          id: 1856121,
          known_for_department: 'Diễn viên',
          name: 'Kinley Fleurejuste',
          original_name: 'Kinley Fleurejuste',
          popularity: 0.6,
          profile_path: null,
          cast_id: 72,
          character: 'Uptown Patron',
          credit_id: '5973552692514112bb02cca0',
          order: 58,
        },
        {
          adult: false,
          gender: 0,
          id: 1856126,
          known_for_department: 'Diễn viên',
          name: 'Ofu Obekpa',
          original_name: 'Ofu Obekpa',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9ELtGcvjq0KwmB9sbGwWLof3eIX.jpg',
          cast_id: 74,
          character: 'Kings Guard',
          credit_id: '59735548c3a3687c7d02aca3',
          order: 59,
        },
        {
          adult: false,
          gender: 0,
          id: 1856124,
          known_for_department: 'Diễn viên',
          name: 'Michael R. Ciminna',
          original_name: 'Michael R. Ciminna',
          popularity: 0.6,
          profile_path: null,
          cast_id: 73,
          character: 'Security Guard',
          credit_id: '5973553ac3a3683c10009856',
          order: 60,
        },
        {
          adult: false,
          gender: 0,
          id: 1856128,
          known_for_department: 'Diễn viên',
          name: 'John Y Lee',
          original_name: 'John Y Lee',
          popularity: 0.968,
          profile_path: null,
          cast_id: 75,
          character: 'Casino Dealer',
          credit_id: '5973555dc3a3687c7d02accf',
          order: 61,
        },
        {
          adult: false,
          gender: 0,
          id: 1856131,
          known_for_department: 'Diễn viên',
          name: 'Byron Coolie',
          original_name: 'Byron Coolie',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sAO2UuVd1hEwXIkgWav0yqEAm51.jpg',
          cast_id: 76,
          character: 'Wakandan',
          credit_id: '597355689251411ece025634',
          order: 62,
        },
        {
          adult: false,
          gender: 0,
          id: 1754081,
          known_for_department: 'Diễn viên',
          name: 'Joseph Akharoh Jr.',
          original_name: 'Joseph Akharoh Jr.',
          popularity: 0.6,
          profile_path: null,
          cast_id: 78,
          character: 'Citizen of Wakanda',
          credit_id: '597355cbc3a3683c1000993d',
          order: 64,
        },
        {
          adult: false,
          gender: 0,
          id: 1856133,
          known_for_department: 'Diễn viên',
          name: 'Stanley Aughtry',
          original_name: 'Stanley Aughtry',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yldrgvhOyllzw8SDEbu395sks0c.jpg',
          cast_id: 79,
          character: 'Merchant Tribe Warrior',
          credit_id: '597355d69251411ece0256ef',
          order: 65,
        },
        {
          adult: false,
          gender: 0,
          id: 1856135,
          known_for_department: 'Diễn viên',
          name: 'Raenen Golez',
          original_name: 'Raenen Golez',
          popularity: 0.6,
          profile_path: null,
          cast_id: 80,
          character: 'Casino Patron',
          credit_id: '597355e39251417fa602c5a5',
          order: 66,
        },
        {
          adult: false,
          gender: 0,
          id: 1856136,
          known_for_department: 'Diễn viên',
          name: 'Leo De Rivera',
          original_name: 'Leo De Rivera',
          popularity: 0.6,
          profile_path: null,
          cast_id: 82,
          character: 'Casino Bartender',
          credit_id: '59735608925141787a00a1f7',
          order: 67,
        },
        {
          adult: false,
          gender: 0,
          id: 1856138,
          known_for_department: 'Diễn viên',
          name: 'Tevin Beech',
          original_name: 'Tevin Beech',
          popularity: 0.6,
          profile_path: null,
          cast_id: 84,
          character: 'Guard',
          credit_id: '5973561d9251415e86050506',
          order: 68,
        },
        {
          adult: false,
          gender: 0,
          id: 1856137,
          known_for_department: 'Diễn viên',
          name: 'Tari Omoro',
          original_name: 'Tari Omoro',
          popularity: 0.6,
          profile_path: null,
          cast_id: 83,
          character: 'Jabari Drummer',
          credit_id: '597356159251414fde0345b4',
          order: 69,
        },
        {
          adult: false,
          gender: 0,
          id: 1856139,
          known_for_department: 'Diễn viên',
          name: 'Andrea Antonio Canal',
          original_name: 'Andrea Antonio Canal',
          popularity: 1.094,
          profile_path:
            'https://image.tmdb.org/t/p/w185/y1YSVxid5rRsl03qt4qyhDSHuXU.jpg',
          cast_id: 85,
          character: 'Casino Guest',
          credit_id: '59735629c3a36830fb00b4e1',
          order: 70,
        },
        {
          adult: false,
          gender: 0,
          id: 1826048,
          known_for_department: 'Diễn viên',
          name: 'David Dunston',
          original_name: 'David Dunston',
          popularity: 0.6,
          profile_path: null,
          cast_id: 86,
          character: 'Citizen of Wakanda',
          credit_id: '59735637925141787a00a238',
          order: 71,
        },
        {
          adult: false,
          gender: 0,
          id: 1856140,
          known_for_department: 'Diễn viên',
          name: 'Josue Louis-Charles',
          original_name: 'Josue Louis-Charles',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vZm0CP95hTcEQAVrhZbS0BHZOWp.jpg',
          cast_id: 88,
          character: 'Mining Tribe',
          credit_id: '5973564a92514142a700506f',
          order: 72,
        },
        {
          adult: false,
          gender: 0,
          id: 1842230,
          known_for_department: 'Diễn viên',
          name: 'Isaac Phillips',
          original_name: 'Isaac Phillips',
          popularity: 0.6,
          profile_path: null,
          cast_id: 89,
          character: 'Mining Tribe #2',
          credit_id: '5973565f9251415e86050569',
          order: 73,
        },
        {
          adult: false,
          gender: 2,
          id: 60898,
          known_for_department: 'Diễn viên',
          name: 'Sebastian Stan',
          original_name: 'Sebastian Stan',
          popularity: 11.535,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nKZgixTbHFXpkzzIpMFdLX98GYh.jpg',
          cast_id: 196,
          character: "James 'Bucky' Barnes / Winter Soldier (uncredited)",
          credit_id: '5a8587aa9251410aae020290',
          order: 74,
        },
        {
          adult: false,
          gender: 0,
          id: 1787403,
          known_for_department: 'Diễn viên',
          name: 'Jamel Chambers',
          original_name: 'Jamel Chambers',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3GDbeJCVkTI3qwOGSIYYdyWXDea.jpg',
          cast_id: 54,
          character: 'Merchant (uncredited)',
          credit_id: '58debd6b9251411b6f011a81',
          order: 75,
        },
        {
          adult: false,
          gender: 2,
          id: 2123041,
          known_for_department: 'Diễn viên',
          name: 'Michael Christopher Rodney',
          original_name: 'Michael Christopher Rodney',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3sqly0o31iSGHr4Kd3eeEt2f2XW.jpg',
          cast_id: 370,
          character: 'Kings Guard (uncredited)',
          credit_id: '5b9185a49251412d3a0050ee',
          order: 76,
        },
        {
          adult: false,
          gender: 1,
          id: 1494393,
          known_for_department: 'Diễn viên',
          name: 'Sheril Rodgers',
          original_name: 'Sheril Rodgers',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nAaLT1k1kpMsPZFdhaQAtREuyU4.jpg',
          cast_id: 608,
          character: 'Oakland California Pedestrian (uncredited)',
          credit_id: '61a9a16b4a52f80044705124',
          order: 77,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 1,
          id: 7232,
          known_for_department: 'Production',
          name: 'Sarah Halley Finn',
          original_name: 'Sarah Halley Finn',
          popularity: 2.706,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pI3OhmnHhXLEwuv0Vq6qJHivCJA.jpg',
          credit_id: '578f9c79c3a3685b50002489',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 7237,
          known_for_department: 'Art',
          name: 'Jay Hart',
          original_name: 'Jay Hart',
          popularity: 0.629,
          profile_path: null,
          credit_id: '5973575b9251414fde034773',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 13670,
          known_for_department: 'Camera',
          name: 'Jacques Haitkin',
          original_name: 'Jacques Haitkin',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5aa7e7e70e0a263dd601fec2',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 7537,
          known_for_department: 'Sound',
          name: 'Steve Boeddeker',
          original_name: 'Steve Boeddeker',
          popularity: 1.094,
          profile_path: null,
          credit_id: '5c6f75ef9251410dba7c607c',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 7537,
          known_for_department: 'Sound',
          name: 'Steve Boeddeker',
          original_name: 'Steve Boeddeker',
          popularity: 1.094,
          profile_path: null,
          credit_id: '5c6f75d0c3a3685a2bd409a2',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 7624,
          known_for_department: 'Biên kịch',
          name: 'Stan Lee',
          original_name: 'Stan Lee',
          popularity: 10.552,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kKeyWoFtTqOPsbmwylNHmuB3En9.jpg',
          credit_id: '597356cbc3a36830fb00b5b5',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 7624,
          known_for_department: 'Biên kịch',
          name: 'Stan Lee',
          original_name: 'Stan Lee',
          popularity: 10.552,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kKeyWoFtTqOPsbmwylNHmuB3En9.jpg',
          credit_id: '578f9c59c3a368671a00017b',
          department: 'Biên kịch',
          job: 'Comic Book',
        },
        {
          adult: false,
          gender: 2,
          id: 10850,
          known_for_department: 'Production',
          name: 'Kevin Feige',
          original_name: 'Kevin Feige',
          popularity: 5.507,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kCBqXZ5PT5udYGEj2wfTSFbLMvT.jpg',
          credit_id: '544fe8ca0e0a263a0a002556',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 8157,
          known_for_department: 'Sound',
          name: 'Doc Kane',
          original_name: 'Doc Kane',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5faff965b54002003e58aa9f',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 8850,
          known_for_department: 'Production',
          name: 'Helen Pollak',
          original_name: 'Helen Pollak',
          popularity: 0.62,
          profile_path: null,
          credit_id: '59735971c3a3686f7c04d99c',
          department: 'Production',
          job: 'Unit Production Manager',
        },
        {
          adult: false,
          gender: 1,
          id: 15524,
          known_for_department: 'Costume & Make-Up',
          name: 'Ruth E. Carter',
          original_name: 'Ruth E. Carter',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/b1CtSVekrYuEmCYt9K3JxWfcJjt.jpg',
          credit_id: '578f9c8bc3a368664b0001a6',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 0,
          id: 15356,
          known_for_department: 'Visual Effects',
          name: 'Daniel Sudick',
          original_name: 'Daniel Sudick',
          popularity: 0.728,
          profile_path: null,
          credit_id: '5d360ec9caab6d791195e91c',
          department: 'Visual Effects',
          job: 'Special Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 16494,
          known_for_department: 'Art',
          name: 'Jesse Rosenthal',
          original_name: 'Jesse Rosenthal',
          popularity: 1.094,
          profile_path: null,
          credit_id: '59735751c3a36830fb00b662',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 18133,
          known_for_department: 'Costume & Make-Up',
          name: 'Ellen Ryba',
          original_name: 'Ellen Ryba',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb6427a97ab003fce51f7',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 2,
          id: 18866,
          known_for_department: 'Biên kịch',
          name: 'Jack Kirby',
          original_name: 'Jack Kirby',
          popularity: 3.597,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ihhR019gL1WrXdSQNJITAY6dont.jpg',
          credit_id: '578f9c4ec3a368664b000186',
          department: 'Biên kịch',
          job: 'Comic Book',
        },
        {
          adult: false,
          gender: 2,
          id: 24192,
          known_for_department: 'Sound',
          name: 'Dave Jordan',
          original_name: 'Dave Jordan',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5fb000fc5ed962003e1011e1',
          department: 'Sound',
          job: 'Music Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 40592,
          known_for_department: 'Production',
          name: 'Jeffrey Chernov',
          original_name: 'Jeffrey Chernov',
          popularity: 0.84,
          profile_path: null,
          credit_id: '5973569fc3a3681d700051fe',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 11102,
          known_for_department: 'Art',
          name: 'Chad S. Frey',
          original_name: 'Chad S. Frey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735a849251415e86050a13',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 113043,
          known_for_department: 'Sound',
          name: 'Scott Curtis',
          original_name: 'Scott Curtis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faffb8e4a4bfc0041b44871',
          department: 'Sound',
          job: 'Foley Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 57027,
          known_for_department: 'Production',
          name: "Louis D'Esposito",
          original_name: "Louis D'Esposito",
          popularity: 1.439,
          profile_path:
            'https://image.tmdb.org/t/p/w185/k9k3WWYdD3uDnrtwM60QirzG9cH.jpg',
          credit_id: '597356ab925141787a00a2d0',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 57158,
          known_for_department: 'Crew',
          name: 'Igor Meglic',
          original_name: 'Igor Meglic',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebf2f924ce6003f6de2e1',
          department: 'Camera',
          job: 'Second Unit Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 62724,
          known_for_department: 'Art',
          name: 'Marco Rubeo',
          original_name: 'Marco Rubeo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735c82c3a3686f7c04ddd1',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 62780,
          known_for_department: 'Art',
          name: 'Alan Hook',
          original_name: 'Alan Hook',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5973573ec3a3683ba4009cb5',
          department: 'Art',
          job: 'Supervising Art Director',
        },
        {
          adult: false,
          gender: 1,
          id: 113674,
          known_for_department: 'Production',
          name: 'Victoria Alonso',
          original_name: 'Victoria Alonso',
          popularity: 1.13,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xF7Qe1tqgk9KtY8kThKHBWhMqxc.jpg',
          credit_id: '59735692c3a3687c7d02ae98',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 75375,
          known_for_department: 'Costume & Make-Up',
          name: 'Joel Harlow',
          original_name: 'Joel Harlow',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tC8VpeOUQHkpPintf1Jaao2Igsg.jpg',
          credit_id: '5f56205684f2490035fd283d',
          department: 'Costume & Make-Up',
          job: 'Makeup Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 80816,
          known_for_department: 'Lighting',
          name: 'Greg Waddle',
          original_name: 'Greg Waddle',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5aa7eb0b0e0a263dc101ef4d',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 1,
          id: 80827,
          known_for_department: 'Sound',
          name: 'Shelley Roden',
          original_name: 'Shelley Roden',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5faffb51735205004013d290',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 130165,
          known_for_department: 'Crew',
          name: 'Ross Sebek',
          original_name: 'Ross Sebek',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7e7b59251415e3c01dbf9',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 1,
          id: 230436,
          known_for_department: 'Production',
          name: 'Barbara Harris',
          original_name: 'Barbara Harris',
          popularity: 2.086,
          profile_path:
            'https://image.tmdb.org/t/p/w185/d1BGeZT2b81Wa9gCOPdrXGWUtmR.jpg',
          credit_id: '5faeb365590086003e56186a',
          department: 'Production',
          job: 'ADR Voice Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 236529,
          known_for_department: 'Crew',
          name: 'Matthew Silva',
          original_name: 'Matthew Silva',
          popularity: 1.428,
          profile_path: null,
          credit_id: '5973591ac3a3686f7c04d940',
          department: 'Costume & Make-Up',
          job: 'Makeup Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 575767,
          known_for_department: 'Art',
          name: 'Raj Rihal',
          original_name: 'Raj Rihal',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735c78c3a3686f7c04ddbe',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 1,
          id: 587815,
          known_for_department: 'Directing',
          name: 'Lisa C. Satriano',
          original_name: 'Lisa C. Satriano',
          popularity: 0.608,
          profile_path: null,
          credit_id: '5ae342c292514124c403c767',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 1,
          id: 589094,
          known_for_department: 'Editing',
          name: 'Claudia Castello',
          original_name: 'Claudia Castello',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fnLj8Rp7LfYeRWbJvz3FA8catKK.jpg',
          credit_id: '59735703c3a36830fb00b60e',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 589094,
          known_for_department: 'Editing',
          name: 'Claudia Castello',
          original_name: 'Claudia Castello',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fnLj8Rp7LfYeRWbJvz3FA8catKK.jpg',
          credit_id: '5faffd15626208003db3630e',
          department: 'Editing',
          job: 'Additional Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 928158,
          known_for_department: 'Sound',
          name: 'Ludwig Göransson',
          original_name: 'Ludwig Göransson',
          popularity: 0.783,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5pcMPnicCdndaVYqWu163T5Zy3I.jpg',
          credit_id: '5be7358392514143db0161ce',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 936835,
          known_for_department: 'Camera',
          name: 'Teo Lee',
          original_name: 'Teo Lee',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebeece86017003e930029',
          department: 'Camera',
          job: 'Second Assistant Camera',
        },
        {
          adult: false,
          gender: 1,
          id: 984113,
          known_for_department: 'Camera',
          name: 'Rachel Morrison',
          original_name: 'Rachel Morrison',
          popularity: 0.619,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6efdDcDK1xvIiDf1u4IBTQsNGkZ.jpg',
          credit_id: '5a83a235c3a36862e1002721',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 1,
          id: 990139,
          known_for_department: 'Art',
          name: 'Hannah Beachler',
          original_name: 'Hannah Beachler',
          popularity: 0.98,
          profile_path: null,
          credit_id: '578f9c84c3a3685b5000248c',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 2,
          id: 1008292,
          known_for_department: 'Diễn viên',
          name: 'Kendrick Lamar',
          original_name: 'Kendrick Lamar',
          popularity: 0.657,
          profile_path:
            'https://image.tmdb.org/t/p/w185/e7aspyQQfmdkUoR3gqPy7hbtDnk.jpg',
          credit_id: '5d275d445f6c4906635d9b82',
          department: 'Sound',
          job: 'Theme Song Performance',
        },
        {
          adult: false,
          gender: 2,
          id: 1008292,
          known_for_department: 'Diễn viên',
          name: 'Kendrick Lamar',
          original_name: 'Kendrick Lamar',
          popularity: 0.657,
          profile_path:
            'https://image.tmdb.org/t/p/w185/e7aspyQQfmdkUoR3gqPy7hbtDnk.jpg',
          credit_id: '5d275ebc5f6c4916bc5d9c00',
          department: 'Sound',
          job: 'Music Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1012031,
          known_for_department: 'Costume & Make-Up',
          name: 'Erica Rice',
          original_name: 'Erica Rice',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7ec570e0a263dd30222cc',
          department: 'Costume & Make-Up',
          job: 'Assistant Costume Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1035029,
          known_for_department: 'Production',
          name: 'Scott Thaler',
          original_name: 'Scott Thaler',
          popularity: 0.694,
          profile_path: null,
          credit_id: '597359799251414fde0349e3',
          department: 'Production',
          job: 'Unit Production Manager',
        },
        {
          adult: false,
          gender: 2,
          id: 1056121,
          known_for_department: 'Directing',
          name: 'Ryan Coogler',
          original_name: 'Ryan Coogler',
          popularity: 1.522,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oc2jLwyc1rJjrqEK61YPewVwn4n.jpg',
          credit_id: '578f9c45c3a3685b260026e0',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 1056121,
          known_for_department: 'Directing',
          name: 'Ryan Coogler',
          original_name: 'Ryan Coogler',
          popularity: 1.522,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oc2jLwyc1rJjrqEK61YPewVwn4n.jpg',
          credit_id: '5e6616f755c9260013626d17',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 1,
          id: 1056127,
          known_for_department: 'Diễn viên',
          name: 'Charline St. Charles',
          original_name: 'Charline St. Charles',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/f0Dqvg9v1tT1gcCTOwIN99GABka.jpg',
          credit_id: '5fb0056c945c200040e86123',
          department: 'Production',
          job: 'Travel Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1059590,
          known_for_department: 'Camera',
          name: 'Matt Kennedy',
          original_name: 'Matt Kennedy',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5aa7eb4ac3a36839da01e3fb',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 0,
          id: 1067682,
          known_for_department: 'Diễn viên',
          name: 'Nate Moore',
          original_name: 'Nate Moore',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/y6aSGvSXO4ZUyTMx04DXOXddJeg.jpg',
          credit_id: '597356d4c3a3687c7d02aef2',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1077115,
          known_for_department: 'Art',
          name: 'Kasra Farahani',
          original_name: 'Kasra Farahani',
          popularity: 1.4,
          profile_path: null,
          credit_id: '59735a53c3a36830fb00b9e2',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 0,
          id: 1095320,
          known_for_department: 'Sound',
          name: 'Ronald J. Webb',
          original_name: 'Ronald J. Webb',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5fb000e14a4bfc0042b4dbb0',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1116937,
          known_for_department: 'Sound',
          name: 'John Roesch',
          original_name: 'John Roesch',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5faffb6313af5f00413bba67',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 1132183,
          known_for_department: 'Diễn viên',
          name: 'Hunter Elliott',
          original_name: 'Hunter Elliott',
          popularity: 1.048,
          profile_path: null,
          credit_id: '5aa93de39251415e4203376a',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1141734,
          known_for_department: 'Editing',
          name: 'Michael P. Shawver',
          original_name: 'Michael P. Shawver',
          popularity: 0.6,
          profile_path: null,
          credit_id: '578f9c71925141343e0023f8',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1145214,
          known_for_department: 'Visual Effects',
          name: 'Till Nowak',
          original_name: 'Till Nowak',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735bd6c3a3683ba400a227',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 2,
          id: 1151834,
          known_for_department: 'Biên kịch',
          name: 'Joe Robert Cole',
          original_name: 'Joe Robert Cole',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7BShwadFBLSnwPtdZDKzwZC4Mtr.jpg',
          credit_id: '578f9c3a9251411d5700018b',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 1192644,
          known_for_department: 'Lighting',
          name: 'Steve Mathis',
          original_name: 'Steve Mathis',
          popularity: 2.268,
          profile_path: null,
          credit_id: '5aa7e8e10e0a263dd3021eff',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1207434,
          known_for_department: 'Costume & Make-Up',
          name: 'Paul A. Simmons Jr.',
          original_name: 'Paul A. Simmons Jr.',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7eccbc3a36839d50218ae',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1259516,
          known_for_department: 'Crew',
          name: 'John Dixon',
          original_name: 'John Dixon',
          popularity: 0.629,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5aHPScnn7icFDPHhBSV1fggmtNZ.jpg',
          credit_id: '5f49f72dcfe48f0036b1d05a',
          department: 'Crew',
          job: 'Utility Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1309919,
          known_for_department: 'Costume & Make-Up',
          name: 'Peri Richards',
          original_name: 'Peri Richards',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5faeb6301d3143003f9b7ef2',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1318465,
          known_for_department: 'Costume & Make-Up',
          name: 'Aimee McCue',
          original_name: 'Aimee McCue',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7ed1f0e0a263dc701fe87',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1327146,
          known_for_department: 'Costume & Make-Up',
          name: 'Wendy M. Craig',
          original_name: 'Wendy M. Craig',
          popularity: 0.98,
          profile_path: null,
          credit_id: '595510139251412b2304f435',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1333930,
          known_for_department: 'Art',
          name: 'Sarah Forrest',
          original_name: 'Sarah Forrest',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735a5c9251415e860509de',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1335066,
          known_for_department: 'Art',
          name: 'Andrew Petrotta',
          original_name: 'Andrew Petrotta',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735c13c3a36830fb00bc77',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 1335882,
          known_for_department: 'Visual Effects',
          name: 'Kerstin Kensy',
          original_name: 'Kerstin Kensy',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5aa94029c3a36839d1037e63',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1337656,
          known_for_department: 'Production',
          name: 'Meagan Lewis',
          original_name: 'Meagan Lewis',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5faeb45e1d3143003c9c5b6f',
          department: 'Production',
          job: 'Local Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 1338585,
          known_for_department: 'Visual Effects',
          name: 'Brian Adler',
          original_name: 'Brian Adler',
          popularity: 0.728,
          profile_path: null,
          credit_id: '5c721cb40e0a262c097cb36c',
          department: 'Visual Effects',
          job: 'Visual Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1338983,
          known_for_department: 'Visual Effects',
          name: 'Florian Gellinger',
          original_name: 'Florian Gellinger',
          popularity: 1.094,
          profile_path: null,
          credit_id: '5aa9408b0e0a263dc7036986',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1339053,
          known_for_department: 'Visual Effects',
          name: 'Jonathan Weber',
          original_name: 'Jonathan Weber',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa9422d0e0a263dc40381c4',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1347321,
          known_for_department: 'Diễn viên',
          name: 'Aakomon Jones',
          original_name: 'Aakomon Jones',
          popularity: 0.656,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xtD3lRroYYT9x2vIQteSFNwXM2n.jpg',
          credit_id: '5fb0022eb54002003f590026',
          department: 'Crew',
          job: 'Choreographer',
        },
        {
          adult: false,
          gender: 1,
          id: 1347760,
          known_for_department: 'Crew',
          name: 'Elizabeth Himelstein',
          original_name: 'Elizabeth Himelstein',
          popularity: 1.467,
          profile_path: null,
          credit_id: '5fb002bdd8f44e003df67985',
          department: 'Crew',
          job: 'Dialect Coach',
        },
        {
          adult: false,
          gender: 0,
          id: 1350251,
          known_for_department: 'Visual Effects',
          name: 'Ivan Kondrup Jensen',
          original_name: 'Ivan Kondrup Jensen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa941a80e0a263dca03745a',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1352422,
          known_for_department: 'Sound',
          name: 'Kim Foscato',
          original_name: 'Kim Foscato',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faffa58202e1100401c9a25',
          department: 'Sound',
          job: 'ADR Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1352424,
          known_for_department: 'Sound',
          name: 'Brandon Proctor',
          original_name: 'Brandon Proctor',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c6f762ac3a3685a25d40904',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 1,
          id: 1355529,
          known_for_department: 'Art',
          name: 'Carol Kiefer',
          original_name: 'Carol Kiefer',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gJ5jzEJRw8y7FrM7y8S3ZJX0ITy.jpg',
          credit_id: '578f9cab9251411cd80001a7',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1355541,
          known_for_department: 'Camera',
          name: 'Jason Ellson',
          original_name: 'Jason Ellson',
          popularity: 0.608,
          profile_path: null,
          credit_id: '5aa7e71bc3a36839da01dfdb',
          department: 'Camera',
          job: 'Additional Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 1357044,
          known_for_department: 'Art',
          name: 'Richard K. Buoen',
          original_name: 'Richard K. Buoen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597359e6c3a3686f7c04da27',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 2,
          id: 1357063,
          known_for_department: 'Crew',
          name: 'Darrin Prescott',
          original_name: 'Darrin Prescott',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yTN1eNBSos16vWSgajcdxKuOGKw.jpg',
          credit_id: '5ae22b11c3a368151d016212',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1357063,
          known_for_department: 'Crew',
          name: 'Darrin Prescott',
          original_name: 'Darrin Prescott',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yTN1eNBSos16vWSgajcdxKuOGKw.jpg',
          credit_id: '5faea55901e4d10041558464',
          department: 'Directing',
          job: 'Second Unit Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1357066,
          known_for_department: 'Camera',
          name: 'P. Scott Sakamoto',
          original_name: 'P. Scott Sakamoto',
          popularity: 0.63,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sXFggMsCCF1ICOZgNiilkKFGnYQ.jpg',
          credit_id: '5aa7e8770e0a263dd601ff52',
          department: 'Camera',
          job: 'Steadicam Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1364426,
          known_for_department: 'Costume & Make-Up',
          name: 'Heather Sease',
          original_name: 'Heather Sease',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7ecf99251415e4201e661',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1367558,
          known_for_department: 'Visual Effects',
          name: 'Stuart Lashley',
          original_name: 'Stuart Lashley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa9410fc3a36839ce0368ee',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1371100,
          known_for_department: 'Crew',
          name: 'Guy T. Wiedmann',
          original_name: 'Guy T. Wiedmann',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeafb5e263bb004192688f',
          department: 'Editing',
          job: 'Stereoscopic Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1376891,
          known_for_department: 'Art',
          name: 'Joseph Hiura',
          original_name: 'Joseph Hiura',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597357339251411ece0258ef',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 1,
          id: 1376899,
          known_for_department: 'Sound',
          name: 'Cheryl Nardi',
          original_name: 'Cheryl Nardi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faffae9ec4552003ff658b4',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1379995,
          known_for_department: 'Visual Effects',
          name: 'Dominik Trimborn',
          original_name: 'Dominik Trimborn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa940b89251415e4b032815',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1388883,
          known_for_department: 'Crew',
          name: 'Mitul Patel',
          original_name: 'Mitul Patel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '578f9df6c3a368669e00022f',
          department: 'Crew',
          job: 'Security',
        },
        {
          adult: false,
          gender: 0,
          id: 1389128,
          known_for_department: 'Art',
          name: 'Nick S. Cross',
          original_name: 'Nick S. Cross',
          popularity: 0.628,
          profile_path: null,
          credit_id: '59735a339251415e86050991',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1389626,
          known_for_department: 'Production',
          name: 'Douglas Dresser',
          original_name: 'Douglas Dresser',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735966c3a3686f7c04d992',
          department: 'Production',
          job: 'Production Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1399117,
          known_for_department: 'Sound',
          name: 'David C. Hughes',
          original_name: 'David C. Hughes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faffc83945c20003fe82711',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 1400833,
          known_for_department: 'Directing',
          name: 'Dea Cantu',
          original_name: 'Dea Cantu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb0049013af5f003f3b1342',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1401284,
          known_for_department: 'Art',
          name: 'Mayumi Konishi-Valentine',
          original_name: 'Mayumi Konishi-Valentine',
          popularity: 0.694,
          profile_path: null,
          credit_id: '59735b32c3a3687c7d02b404',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1401698,
          known_for_department: 'Visual Effects',
          name: 'Andy Brown',
          original_name: 'Andy Brown',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa942069251415e3c03350a',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1401965,
          known_for_department: 'Visual Effects',
          name: 'Bryan Grill',
          original_name: 'Bryan Grill',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5aa93d560e0a263dca037009',
          department: 'Visual Effects',
          job: 'VFX Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1403412,
          known_for_department: 'Lighting',
          name: 'Dan Cornwall',
          original_name: 'Dan Cornwall',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5aa7e8bc0e0a263dcd01ff20',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 1,
          id: 1403421,
          known_for_department: 'Directing',
          name: 'Dawn Gilliam',
          original_name: 'Dawn Gilliam',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7efec0e0a263dc702018f',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1403474,
          known_for_department: 'Visual Effects',
          name: 'Robert E. Evans',
          original_name: 'Robert E. Evans',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa940cdc3a36839e4038173',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1403504,
          known_for_department: 'Crew',
          name: 'John Polyson',
          original_name: 'John Polyson',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5aa93f810e0a263dd303a5e1',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1404244,
          known_for_department: 'Camera',
          name: 'John Marzano',
          original_name: 'John Marzano',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7e75d9251415e3c01dbb6',
          department: 'Camera',
          job: 'Aerial Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 1405376,
          known_for_department: 'Art',
          name: 'Alex McCarroll',
          original_name: 'Alex McCarroll',
          popularity: 0.828,
          profile_path: null,
          credit_id: '59735747c3a3687c7d02af6c',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1409719,
          known_for_department: 'Editing',
          name: 'Erik Kaufmann',
          original_name: 'Erik Kaufmann',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faffec97352050041144d3d',
          department: 'Editing',
          job: 'Digital Intermediate Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1411322,
          known_for_department: 'Costume & Make-Up',
          name: 'Sian Richards',
          original_name: 'Sian Richards',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597358f8c3a36830fb00b82d',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1413119,
          known_for_department: 'Production',
          name: 'Michael-Ryan Fletchall',
          original_name: 'Michael-Ryan Fletchall',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7e813c3a36839cb01f0fd',
          department: 'Crew',
          job: 'Drone Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1415019,
          known_for_department: 'Costume & Make-Up',
          name: 'Shayne Allen Duhon',
          original_name: 'Shayne Allen Duhon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7ed7b9251415e4b01db4f',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 1,
          id: 1415026,
          known_for_department: 'Directing',
          name: 'Jillian Amburgey',
          original_name: 'Jillian Amburgey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb001509d592c003f57f3c7',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1415475,
          known_for_department: 'Visual Effects',
          name: 'Lisa Beroud',
          original_name: 'Lisa Beroud',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93fe90e0a263dd303a649',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1418439,
          known_for_department: 'Visual Effects',
          name: 'Evan Jacobs',
          original_name: 'Evan Jacobs',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5faeb048245dbe003e6aabad',
          department: 'Visual Effects',
          job: 'Stereoscopic Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1418470,
          known_for_department: 'Crew',
          name: 'Nicolas Anastassiou',
          original_name: 'Nicolas Anastassiou',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93f70c3a36839e4037fd4',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1424894,
          known_for_department: 'Costume & Make-Up',
          name: 'Camille Friend',
          original_name: 'Camille Friend',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735817c3a3683c10009c35',
          department: 'Costume & Make-Up',
          job: 'Hair Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 1425326,
          known_for_department: 'Costume & Make-Up',
          name: 'Bailey Domke',
          original_name: 'Bailey Domke',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597357c3c3a3686fc7057170',
          department: 'Crew',
          job: 'Makeup Effects',
        },
        {
          adult: false,
          gender: 2,
          id: 1427569,
          known_for_department: 'Visual Effects',
          name: 'Jerad Marantz',
          original_name: 'Jerad Marantz',
          popularity: 0.84,
          profile_path: null,
          credit_id: '5f29313ca35c8e003651b64b',
          department: 'Art',
          job: 'Concept Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1428893,
          known_for_department: 'Visual Effects',
          name: 'Daryl Sawchuk',
          original_name: 'Daryl Sawchuk',
          popularity: 1.094,
          profile_path: null,
          credit_id: '5faea78c7ecd28003cbaecc0',
          department: 'Visual Effects',
          job: 'Animation Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1432033,
          known_for_department: 'Costume & Make-Up',
          name: 'Heather Mages',
          original_name: 'Heather Mages',
          popularity: 0.694,
          profile_path: null,
          credit_id: '597358a492514142720055f9',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1432587,
          known_for_department: 'Art',
          name: 'John Naehrlich',
          original_name: 'John Naehrlich',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735bcb9251417fa602cd2f',
          department: 'Art',
          job: 'Leadman',
        },
        {
          adult: false,
          gender: 2,
          id: 1436174,
          known_for_department: 'Visual Effects',
          name: 'Chris Ryan',
          original_name: 'Chris Ryan',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5aa93acd0e0a263dc70363b8',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1436195,
          known_for_department: 'Costume & Make-Up',
          name: 'Branden Marks',
          original_name: 'Branden Marks',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7ed0e0e0a263dcd0203ac',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 1,
          id: 1436199,
          known_for_department: 'Crew',
          name: 'Carol McConnaughey',
          original_name: 'Carol McConnaughey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb005806262080040b2a6cd',
          department: 'Crew',
          job: 'Unit Publicist',
        },
        {
          adult: false,
          gender: 0,
          id: 1437304,
          known_for_department: 'Lighting',
          name: 'Michael Ambrose',
          original_name: 'Michael Ambrose',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7e8d29251415e3c01dce9',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1439104,
          known_for_department: 'Camera',
          name: 'Onofrio Nino Pansini',
          original_name: 'Onofrio Nino Pansini',
          popularity: 0.65,
          profile_path: null,
          credit_id: '5aa7e7a3c3a36839e4020a30',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1439108,
          known_for_department: 'Lighting',
          name: 'Tom Fendley',
          original_name: 'Tom Fendley',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5aa7eabf9251415e4201e3e1',
          department: 'Lighting',
          job: 'Rigging Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1442128,
          known_for_department: 'Art',
          name: 'Christine Mahuna',
          original_name: 'Christine Mahuna',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735b9892514142a70056bd',
          department: 'Art',
          job: 'Sculptor',
        },
        {
          adult: false,
          gender: 0,
          id: 1451544,
          known_for_department: 'Costume & Make-Up',
          name: 'Phoenix Mellow',
          original_name: 'Phoenix Mellow',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7ec460e0a263dcd0202dc',
          department: 'Costume & Make-Up',
          job: 'Assistant Costume Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1453661,
          known_for_department: 'Costume & Make-Up',
          name: 'Dorotka Sapinska',
          original_name: 'Dorotka Sapinska',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7ec8e0e0a263dd3022312',
          department: 'Costume & Make-Up',
          job: 'Assistant Costume Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1457910,
          known_for_department: 'Biên kịch',
          name: 'Simeon Wilkins',
          original_name: 'Simeon Wilkins',
          popularity: 0.6,
          profile_path: null,
          credit_id: '578f9d179251411cd80001da',
          department: 'Biên kịch',
          job: 'Storyboard',
        },
        {
          adult: false,
          gender: 0,
          id: 1457910,
          known_for_department: 'Biên kịch',
          name: 'Simeon Wilkins',
          original_name: 'Simeon Wilkins',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735ccb92514112bb02d6a2',
          department: 'Art',
          job: 'Storyboard Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1460624,
          known_for_department: 'Crew',
          name: 'Celia Jepson',
          original_name: 'Celia Jepson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93a599251415e4b03217b',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1460639,
          known_for_department: 'Diễn viên',
          name: 'Jason Bomstein',
          original_name: 'Jason Bomstein',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb0240fb39800408b14c5',
          department: 'Visual Effects',
          job: 'Stereoscopic Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1463324,
          known_for_department: 'Art',
          name: 'Fabian Lacey',
          original_name: 'Fabian Lacey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '578f9cb69251411d570001b6',
          department: 'Art',
          job: 'Conceptual Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1463324,
          known_for_department: 'Art',
          name: 'Fabian Lacey',
          original_name: 'Fabian Lacey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735b66c3a3681d700057b1',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 2,
          id: 1463387,
          known_for_department: 'Sound',
          name: 'Benjamin A. Burtt',
          original_name: 'Benjamin A. Burtt',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5c6f759c0e0a2623afd3df8d',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1463522,
          known_for_department: 'Editing',
          name: 'Jess Jansen',
          original_name: 'Jess Jansen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faffd8ce24e3a003ee63cfa',
          department: 'Editing',
          job: 'Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1463542,
          known_for_department: 'Diễn viên',
          name: 'Charles Lai',
          original_name: 'Charles Lai',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeaa22c86b3a0042687890',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1463779,
          known_for_department: 'Camera',
          name: 'Brook Willard',
          original_name: 'Brook Willard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeba297776f00040511798',
          department: 'Camera',
          job: 'Digital Imaging Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 1472708,
          known_for_department: 'Diễn viên',
          name: 'Andile Nebulane',
          original_name: 'Andile Nebulane',
          popularity: 0.656,
          profile_path: null,
          credit_id: '5fb002953a48c5003d7d5168',
          department: 'Crew',
          job: 'Dialect Coach',
        },
        {
          adult: false,
          gender: 2,
          id: 1472788,
          known_for_department: 'Visual Effects',
          name: 'Jamie Hallett',
          original_name: 'Jamie Hallett',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5aa94146c3a36839ce03692a',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1484209,
          known_for_department: 'Visual Effects',
          name: 'Craig Hammack',
          original_name: 'Craig Hammack',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa941bac3a36839dd02f8f3',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1484985,
          known_for_department: 'Lighting',
          name: 'Jonathan Terpstra',
          original_name: 'Jonathan Terpstra',
          popularity: 0.652,
          profile_path: null,
          credit_id: '5faebdcddb4ed60042b10071',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 1490941,
          known_for_department: 'Art',
          name: 'April LaBranche',
          original_name: 'April LaBranche',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735b5d9251417fa602cc9a',
          department: 'Art',
          job: 'Set Decorating Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1494531,
          known_for_department: 'Visual Effects',
          name: 'Michael Wortmann',
          original_name: 'Michael Wortmann',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5aa93d67c3a36839dd02f53c',
          department: 'Visual Effects',
          job: 'VFX Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1506365,
          known_for_department: 'Costume & Make-Up',
          name: 'Empress Holley',
          original_name: 'Empress Holley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7ed8cc3a36839e101f47b',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 2,
          id: 1526464,
          known_for_department: 'Costume & Make-Up',
          name: 'Shutchai Tym Buacharern',
          original_name: 'Shutchai Tym Buacharern',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735785c3a3684c7002460f',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1532723,
          known_for_department: 'Costume & Make-Up',
          name: 'Mark Walcott',
          original_name: 'Mark Walcott',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7ed9b9251415e4501dcba',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1533708,
          known_for_department: 'Production',
          name: 'David J. Grant',
          original_name: 'David J. Grant',
          popularity: 0.98,
          profile_path: null,
          credit_id: '597356c29251411ece025855',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1534970,
          known_for_department: 'Art',
          name: 'Chris Samp',
          original_name: 'Chris Samp',
          popularity: 0.694,
          profile_path: null,
          credit_id: '59735c97c3a3683c1000a1e0',
          department: 'Art',
          job: 'Painter',
        },
        {
          adult: false,
          gender: 2,
          id: 1534985,
          known_for_department: 'Sound',
          name: 'David Raymond',
          original_name: 'David Raymond',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735d1f9251414272005c16',
          department: 'Sound',
          job: 'Boom Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1543191,
          known_for_department: 'Production',
          name: 'Jason B. Stamey',
          original_name: 'Jason B. Stamey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '578f9d32c3a368671a0001fe',
          department: 'Production',
          job: 'Casting Associate',
        },
        {
          adult: false,
          gender: 0,
          id: 1543743,
          known_for_department: 'Visual Effects',
          name: 'Michael Perdew',
          original_name: 'Michael Perdew',
          popularity: 0.656,
          profile_path: null,
          credit_id: '5aa940620e0a263dc4037ff1',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1543747,
          known_for_department: 'Visual Effects',
          name: 'Marie Rheinschild-Jordan',
          original_name: 'Marie Rheinschild-Jordan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa94014c3a36839cb035ed0',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1544399,
          known_for_department: 'Crew',
          name: 'Bobby Jordan',
          original_name: 'Bobby Jordan',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tOFBAfy0LnrRqLscwZPeLYM0VnZ.jpg',
          credit_id: '5f0cd25a13a32000357fd739',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1545329,
          known_for_department: 'Diễn viên',
          name: 'Eric Stewart',
          original_name: 'Eric Stewart',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93e8c0e0a263dca037129',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 1,
          id: 1546812,
          known_for_department: 'Crew',
          name: 'Andrea Maxwell',
          original_name: 'Andrea Maxwell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93f3e9251415e39034be5',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1546840,
          known_for_department: 'Camera',
          name: 'Zoran Veselic',
          original_name: 'Zoran Veselic',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebba783ee67003d8b5437',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1547667,
          known_for_department: 'Sound',
          name: 'Nashia Wachsman',
          original_name: 'Nashia Wachsman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb000ca498ef90041804b96',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1547670,
          known_for_department: 'Costume & Make-Up',
          name: 'Adam Walls',
          original_name: 'Adam Walls',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735948c3a3686fc7057344',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1548416,
          known_for_department: 'Crew',
          name: 'Oliver Schulz',
          original_name: 'Oliver Schulz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60285d57e1ad79004016c306',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1548847,
          known_for_department: 'Art',
          name: 'Marlie Arnold',
          original_name: 'Marlie Arnold',
          popularity: 0.652,
          profile_path: null,
          credit_id: '578f9c97c3a368671a0001ad',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1549078,
          known_for_department: 'Directing',
          name: 'Marvin Williams',
          original_name: 'Marvin Williams',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea3aac86b3a004168bfe4',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1550780,
          known_for_department: 'Sound',
          name: 'Jonathan Borland',
          original_name: 'Jonathan Borland',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faffc9713af5f003e3b34d5',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1552062,
          known_for_department: 'Sound',
          name: 'Peter J. Devlin',
          original_name: 'Peter J. Devlin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735cdb9251414272005bc9',
          department: 'Sound',
          job: 'Sound Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1552346,
          known_for_department: 'Costume & Make-Up',
          name: 'Jessica Fasman',
          original_name: 'Jessica Fasman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7ece60e0a263dca020676',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 2,
          id: 1552780,
          known_for_department: 'Camera',
          name: 'Ted Sapp',
          original_name: 'Ted Sapp',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5faebd517ecd28003bba1002',
          department: 'Camera',
          job: 'Key Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1556976,
          known_for_department: 'Visual Effects',
          name: 'Alex Filipov',
          original_name: 'Alex Filipov',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeae7b7776f0003f50d33f',
          department: 'Visual Effects',
          job: 'Senior Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 1562067,
          known_for_department: 'Editing',
          name: 'Dylan Quirt',
          original_name: 'Dylan Quirt',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7eefd9251415e3901f1d7',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1566117,
          known_for_department: 'Costume & Make-Up',
          name: 'Synithia Cochran',
          original_name: 'Synithia Cochran',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb6fbfdc146003d6e7e98',
          department: 'Costume & Make-Up',
          job: 'Tailor',
        },
        {
          adult: false,
          gender: 0,
          id: 1568916,
          known_for_department: 'Camera',
          name: 'Alessandro Di Meo',
          original_name: 'Alessandro Di Meo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebc167a97ab003fce5c90',
          department: 'Camera',
          job: 'First Assistant "B" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1574043,
          known_for_department: 'Art',
          name: 'Jason T. Clark',
          original_name: 'Jason T. Clark',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973572992514112bb02cf6c',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1574819,
          known_for_department: 'Visual Effects',
          name: 'Todd Sheridan Perry',
          original_name: 'Todd Sheridan Perry',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa942199251415e45032d7a',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1580960,
          known_for_department: 'Camera',
          name: 'Adam Castro',
          original_name: 'Adam Castro',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebc288e8702003f945f04',
          department: 'Camera',
          job: 'First Assistant "C" Camera',
        },
        {
          adult: false,
          gender: 2,
          id: 1585817,
          known_for_department: 'Visual Effects',
          name: 'Abraham Schneider',
          original_name: 'Abraham Schneider',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb0cd470ead003f06f992',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1590391,
          known_for_department: 'Crew',
          name: 'Hayden Bilson',
          original_name: 'Hayden Bilson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb0020ed0b434003f9e27aa',
          department: 'Crew',
          job: 'Armorer',
        },
        {
          adult: false,
          gender: 0,
          id: 1605399,
          known_for_department: 'Art',
          name: 'Manuel Plank-Jorge',
          original_name: 'Manuel Plank-Jorge',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735c4f9251414fde034de4',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 2,
          id: 1610228,
          known_for_department: 'Costume & Make-Up',
          name: 'Craig Anthony',
          original_name: 'Craig Anthony',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5aa7edafc3a36839dd01bff5',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1619681,
          known_for_department: 'Crew',
          name: 'Christopher Chaber',
          original_name: 'Christopher Chaber',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93f139251415e4b032666',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1621226,
          known_for_department: 'Camera',
          name: 'Peter Chrimes',
          original_name: 'Peter Chrimes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebd41344a8e003c468fe7',
          department: 'Camera',
          job: 'Key Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1622341,
          known_for_department: 'Crew',
          name: 'André Freitas',
          original_name: 'André Freitas',
          popularity: 0.968,
          profile_path: null,
          credit_id: '5973580ec3a3686f7c04d82b',
          department: 'Crew',
          job: 'Makeup Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1630904,
          known_for_department: 'Crew',
          name: 'Danny Singh',
          original_name: 'Danny Singh',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93f5fc3a36839d1037d83',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1632329,
          known_for_department: 'Editing',
          name: 'Laura Holeman',
          original_name: 'Laura Holeman',
          popularity: 0.764,
          profile_path: null,
          credit_id: '5faffee09ca759003e4a5f2f',
          department: 'Editing',
          job: 'Digital Intermediate Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1635030,
          known_for_department: 'Visual Effects',
          name: 'Weldon Huang',
          original_name: 'Weldon Huang',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93e450e0a263dcd036ebd',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1635132,
          known_for_department: 'Camera',
          name: 'Zach Holloran',
          original_name: 'Zach Holloran',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebdfe590086003f5609ac',
          department: 'Crew',
          job: 'Loader',
        },
        {
          adult: false,
          gender: 0,
          id: 1635156,
          known_for_department: 'Costume & Make-Up',
          name: 'LuAndra Whitehurst',
          original_name: 'LuAndra Whitehurst',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973595292514142720056cb',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1635484,
          known_for_department: 'Costume & Make-Up',
          name: 'Jaime Leigh McIntosh',
          original_name: 'Jaime Leigh McIntosh',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597358ce9251414272005635',
          department: 'Costume & Make-Up',
          job: 'Key Hair Stylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1636651,
          known_for_department: 'Costume & Make-Up',
          name: 'Yen Do',
          original_name: 'Yen Do',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7ed69c3a36839e40210cc',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1637289,
          known_for_department: 'Visual Effects',
          name: 'Jye Skinn',
          original_name: 'Jye Skinn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93bfd0e0a263dd60367be',
          department: 'Visual Effects',
          job: 'Lead Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 1637297,
          known_for_department: 'Crew',
          name: 'Rachel Litz',
          original_name: 'Rachel Litz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93f960e0a263dd00378ae',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1643711,
          known_for_department: 'Costume & Make-Up',
          name: 'Ashley McGuire',
          original_name: 'Ashley McGuire',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597358c4c3a3683c10009cf1',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1644259,
          known_for_department: 'Crew',
          name: 'Oliver Eikhoff',
          original_name: 'Oliver Eikhoff',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93fca0e0a263dca037250',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1645886,
          known_for_department: 'Visual Effects',
          name: 'Signe Vinther',
          original_name: 'Signe Vinther',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa9403cc3a36839d1037e7c',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1649516,
          known_for_department: 'Visual Effects',
          name: 'Brendan Seals',
          original_name: 'Brendan Seals',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa941cf9251415e3c0334cd',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1653680,
          known_for_department: 'Art',
          name: 'Daniel Frank',
          original_name: 'Daniel Frank',
          popularity: 0.828,
          profile_path: null,
          credit_id: '578f9ca1c3a368671a0001b3',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1653682,
          known_for_department: 'Production',
          name: 'Molly Doyle',
          original_name: 'Molly Doyle',
          popularity: 1.214,
          profile_path: null,
          credit_id: '578f9d209251411cd80001e2',
          department: 'Production',
          job: 'Casting Associate',
        },
        {
          adult: false,
          gender: 0,
          id: 1653682,
          known_for_department: 'Production',
          name: 'Molly Doyle',
          original_name: 'Molly Doyle',
          popularity: 1.214,
          profile_path: null,
          credit_id: '5faeb3842b9320003e7216bb',
          department: 'Production',
          job: 'Casting Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 1653683,
          known_for_department: 'Production',
          name: 'Nicholas A. Mudd',
          original_name: 'Nicholas A. Mudd',
          popularity: 0.6,
          profile_path: null,
          credit_id: '578f9d2b9251411e0c000182',
          department: 'Production',
          job: 'Casting Associate',
        },
        {
          adult: false,
          gender: 0,
          id: 1653684,
          known_for_department: 'Crew',
          name: 'Jim Ely',
          original_name: 'Jim Ely',
          popularity: 0.6,
          profile_path: null,
          credit_id: '578f9d8ec3a368669e00020e',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1653687,
          known_for_department: 'Crew',
          name: 'Ryan Potter',
          original_name: 'Ryan Potter',
          popularity: 0.6,
          profile_path: null,
          credit_id: '578f9e359251411d57000266',
          department: 'Crew',
          job: 'Legal Services',
        },
        {
          adult: false,
          gender: 0,
          id: 1653688,
          known_for_department: 'Crew',
          name: 'Janine Schiro',
          original_name: 'Janine Schiro',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb001e03a48c5003d7d5070',
          department: 'Production',
          job: 'First Assistant Accountant',
        },
        {
          adult: false,
          gender: 0,
          id: 1658876,
          known_for_department: 'Visual Effects',
          name: 'Nikhil Deshmukh',
          original_name: 'Nikhil Deshmukh',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeae68e263bb0042929793',
          department: 'Visual Effects',
          job: 'Senior Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 1659155,
          known_for_department: 'Costume & Make-Up',
          name: 'Aida Scuffle',
          original_name: 'Aida Scuffle',
          popularity: 1.38,
          profile_path: null,
          credit_id: '59735908c3a36830fb00b840',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1673231,
          known_for_department: 'Visual Effects',
          name: 'Doug Spilatro',
          original_name: 'Doug Spilatro',
          popularity: 1.124,
          profile_path: null,
          credit_id: '5aa941220e0a263dc7036a3c',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1684678,
          known_for_department: 'Sound',
          name: 'Jeff Gersh',
          original_name: 'Jeff Gersh',
          popularity: 1.102,
          profile_path: null,
          credit_id: '5faff952c15f8900418377f0',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1691976,
          known_for_department: 'Visual Effects',
          name: 'Geoffrey Baumann',
          original_name: 'Geoffrey Baumann',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa940fe0e0a263dc1034dec',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1700086,
          known_for_department: 'Lighting',
          name: 'Rusty Edmonson',
          original_name: 'Rusty Edmonson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7e8f40e0a263dd3021f1b',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 1700118,
          known_for_department: 'Editing',
          name: 'Adam Kimmerlin',
          original_name: 'Adam Kimmerlin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7ef330e0a263dcd02062d',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1703132,
          known_for_department: 'Visual Effects',
          name: 'Mathew Cowie',
          original_name: 'Mathew Cowie',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea7a2e86017003c9351bf',
          department: 'Visual Effects',
          job: 'Animation Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1703137,
          known_for_department: 'Crew',
          name: 'Patrick Patzschke',
          original_name: 'Patrick Patzschke',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93fa70e0a263dd303a609',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1706712,
          known_for_department: 'Visual Effects',
          name: 'Mike F. Hedayati',
          original_name: 'Mike F. Hedayati',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa942419251415e4b032958',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1709657,
          known_for_department: 'Costume & Make-Up',
          name: 'Alan Lashbrook',
          original_name: 'Alan Lashbrook',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb620e86017003c936a78',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1721336,
          known_for_department: 'Crew',
          name: 'Andrew Zink',
          original_name: 'Andrew Zink',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93a79c3a36839d103782f',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1721445,
          known_for_department: 'Visual Effects',
          name: 'Immanuel Morris',
          original_name: 'Immanuel Morris',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5aa9416f925141722202b9ee',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1721862,
          known_for_department: 'Visual Effects',
          name: 'Kristen Drewski',
          original_name: 'Kristen Drewski',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93dce9251415e3c0330ed',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1724191,
          known_for_department: 'Crew',
          name: 'Espen Nordahl',
          original_name: 'Espen Nordahl',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5aa942570e0a263dd303a925',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1724279,
          known_for_department: 'Visual Effects',
          name: 'Kenneth Au',
          original_name: 'Kenneth Au',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa9415d0e0a263dd0037abb',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1725745,
          known_for_department: 'Costume & Make-Up',
          name: 'Korii Young',
          original_name: 'Korii Young',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb66e245dbe003e6ab1c3',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1737627,
          known_for_department: 'Costume & Make-Up',
          name: 'Keith Hudson',
          original_name: 'Keith Hudson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb811ad59b5003e5ac338',
          department: 'Art',
          job: 'Textile Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 1738169,
          known_for_department: 'Camera',
          name: 'C. Alan Rawlins',
          original_name: 'C. Alan Rawlins',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7e954c3a36839ce01f946',
          department: 'Camera',
          job: 'Key Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1739320,
          known_for_department: 'Crew',
          name: 'Ivan Andres Guerrero',
          original_name: 'Ivan Andres Guerrero',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93a89c3a36839d1037846',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1739846,
          known_for_department: 'Camera',
          name: 'Kenneth Coblentz',
          original_name: 'Kenneth Coblentz',
          popularity: 0.705,
          profile_path: null,
          credit_id: '5aa7e8a4c3a36839dd01bb34',
          department: 'Camera',
          job: 'Dolly Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1744665,
          known_for_department: 'Costume & Make-Up',
          name: 'Caroline Errington',
          original_name: 'Caroline Errington',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7ec33c3a36839e101f2e3',
          department: 'Costume & Make-Up',
          job: 'Assistant Costume Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1746433,
          known_for_department: 'Visual Effects',
          name: 'Alexandre Cancado',
          original_name: 'Alexandre Cancado',
          popularity: 1.008,
          profile_path: null,
          credit_id: '5aa93a680e0a263dc7036358',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1746543,
          known_for_department: 'Art',
          name: 'Warren Manser',
          original_name: 'Warren Manser',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb533590086003d552a78',
          department: 'Costume & Make-Up',
          job: 'Costume Illustrator',
        },
        {
          adult: false,
          gender: 2,
          id: 1753397,
          known_for_department: 'Art',
          name: 'Andy Park',
          original_name: 'Andy Park',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735c0192514112bb02d574',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 0,
          id: 1755689,
          known_for_department: 'Costume & Make-Up',
          name: 'Jack Taggart',
          original_name: 'Jack Taggart',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oztXS3hIIzZ6hZCrp6HZAClniYY.jpg',
          credit_id: '5aa7ec1e0e0a263dd302228d',
          department: 'Costume & Make-Up',
          job: 'Ager/Dyer',
        },
        {
          adult: false,
          gender: 2,
          id: 1755695,
          known_for_department: 'Camera',
          name: 'Joe Macaluso',
          original_name: 'Joe Macaluso',
          popularity: 0.728,
          profile_path: null,
          credit_id: '5aa7ea730e0a263dc101ee5d',
          department: 'Camera',
          job: 'Key Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1760559,
          known_for_department: 'Camera',
          name: 'Austin Harris',
          original_name: 'Austin Harris',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7e74392514172220159f8',
          department: 'Camera',
          job: 'Aerial Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1760561,
          known_for_department: 'Crew',
          name: 'Steven Blizzard',
          original_name: 'Steven Blizzard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebaeafdc146003f6df78b',
          department: 'Camera',
          job: 'Drone Pilot',
        },
        {
          adult: false,
          gender: 2,
          id: 1760572,
          known_for_department: 'Sound',
          name: 'Jason Oliver',
          original_name: 'Jason Oliver',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5faff99ad0b434003c9e43c5',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1763133,
          known_for_department: 'Sound',
          name: 'Jim Likowski',
          original_name: 'Jim Likowski',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5faffb79626208003db3604d',
          department: 'Sound',
          job: 'Foley Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1778013,
          known_for_department: 'Art',
          name: 'Gary Damian Thomas',
          original_name: 'Gary Damian Thomas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735ca3c3a3686fc70577fe',
          department: 'Art',
          job: 'Storyboard Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1787842,
          known_for_department: 'Sound',
          name: 'Chris Gridley',
          original_name: 'Chris Gridley',
          popularity: 0.609,
          profile_path: null,
          credit_id: '5faffad79ca759003e4a5afb',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1803705,
          known_for_department: 'Production',
          name: 'Jason Zorigian',
          original_name: 'Jason Zorigian',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973598a925141787a00a618',
          department: 'Production',
          job: 'Production Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1814699,
          known_for_department: 'Sound',
          name: 'Trygge Toven',
          original_name: 'Trygge Toven',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb0003b7352050041144e8d',
          department: 'Sound',
          job: 'Music Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1815823,
          known_for_department: 'Crew',
          name: 'John Slade',
          original_name: 'John Slade',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7eb80c3a36839da01e431',
          department: 'Crew',
          job: 'Techno Crane Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1815939,
          known_for_department: 'Visual Effects',
          name: 'Jan Reichmann',
          original_name: 'Jan Reichmann',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93d32c3a36839cb035be0',
          department: 'Visual Effects',
          job: 'VFX Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1821890,
          known_for_department: 'Crew',
          name: 'Scott Dwyer',
          original_name: 'Scott Dwyer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7f0549251415e4b01de27',
          department: 'Crew',
          job: 'Pyrotechnician',
        },
        {
          adult: false,
          gender: 0,
          id: 1824247,
          known_for_department: 'Crew',
          name: 'Luke Gray',
          original_name: 'Luke Gray',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faead7b2b9320003f7307d5',
          department: 'Visual Effects',
          job: 'Pipeline Technical Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1824513,
          known_for_department: 'Visual Effects',
          name: 'Aaron Colman-Hayes',
          original_name: 'Aaron Colman-Hayes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93a25c3a36839ce03619f',
          department: 'Visual Effects',
          job: '3D Modeller',
        },
        {
          adult: false,
          gender: 0,
          id: 1824955,
          known_for_department: 'Camera',
          name: 'Nino Neuboeck',
          original_name: 'Nino Neuboeck',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebbd6470ead00400799f8',
          department: 'Camera',
          job: 'First Assistant "A" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1829977,
          known_for_department: 'Visual Effects',
          name: 'Steph Lynn Robinson',
          original_name: 'Steph Lynn Robinson',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/n9vHOr54XygWhSpZsqVq1qMBAVB.jpg',
          credit_id: '5faeaf3e1d3143003e9c0a38',
          department: 'Visual Effects',
          job: 'Stereoscopic Coordinator',
        },
        {
          adult: false,
          gender: 1,
          id: 1840678,
          known_for_department: 'Crew',
          name: 'Nancy Valle',
          original_name: 'Nancy Valle',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uUe6ZkQOKg49WbyUlUHg9X7YFVJ.jpg',
          credit_id: '59735981c3a36830fb00b8e3',
          department: 'Crew',
          job: 'Post Production Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1842133,
          known_for_department: 'Directing',
          name: 'Christopher T. Sadler',
          original_name: 'Christopher T. Sadler',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea53b0d9f5a0042068b2b',
          department: 'Directing',
          job: 'Second Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1842138,
          known_for_department: 'Art',
          name: 'Patrick Dunn-Baker',
          original_name: 'Patrick Dunn-Baker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735a48c3a36830fb00b9ce',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1842157,
          known_for_department: 'Costume & Make-Up',
          name: 'Liz Oliver',
          original_name: 'Liz Oliver',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7ec0e0e0a263dc101f035',
          department: 'Costume & Make-Up',
          job: 'Ager/Dyer',
        },
        {
          adult: false,
          gender: 0,
          id: 1843778,
          known_for_department: 'Costume & Make-Up',
          name: 'Jennifer Jane',
          original_name: 'Jennifer Jane',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973587092514142a70052bb',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1844654,
          known_for_department: 'Art',
          name: 'Anthony Liberatore',
          original_name: 'Anthony Liberatore',
          popularity: 0.98,
          profile_path: null,
          credit_id: '59735b8fc3a3683ba400a1d3',
          department: 'Art',
          job: 'Storyboard Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1856146,
          known_for_department: 'Costume & Make-Up',
          name: 'Hagen Linss',
          original_name: 'Hagen Linss',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973589b9251414fde0348fc',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1856149,
          known_for_department: 'Costume & Make-Up',
          name: 'Ralph A. Ochoa',
          original_name: 'Ralph A. Ochoa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597358de9251417fa602c96e',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1856153,
          known_for_department: 'Costume & Make-Up',
          name: 'Kentaro Yano',
          original_name: 'Kentaro Yano',
          popularity: 1.095,
          profile_path: null,
          credit_id: '5973595ac3a3681d70005532',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1856156,
          known_for_department: 'Art',
          name: 'Maxwell Britton',
          original_name: 'Maxwell Britton',
          popularity: 0.828,
          profile_path: null,
          credit_id: '597359cf9251414fde034a3f',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 1856157,
          known_for_department: 'Art',
          name: 'Wesley Burt',
          original_name: 'Wesley Burt',
          popularity: 0.98,
          profile_path: null,
          credit_id: '597359ee9251415e86050934',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 0,
          id: 1856158,
          known_for_department: 'Art',
          name: 'Sam Carter',
          original_name: 'Sam Carter',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735a29c3a3686f7c04da6e',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 1856159,
          known_for_department: 'Art',
          name: 'Robert Lee Church',
          original_name: 'Robert Lee Church',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735a3c9251417fa602caf6',
          department: 'Art',
          job: 'Greensman',
        },
        {
          adult: false,
          gender: 0,
          id: 1856160,
          known_for_department: 'Art',
          name: 'Russ Gautier',
          original_name: 'Russ Gautier',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735a8fc3a3683ba400a071',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1856161,
          known_for_department: 'Art',
          name: 'Terry Hill',
          original_name: 'Terry Hill',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735a9d92514112bb02d379',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 1856162,
          known_for_department: 'Art',
          name: 'David James',
          original_name: 'David James',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735b0492514142a70055ce',
          department: 'Art',
          job: 'Sculptor',
        },
        {
          adult: false,
          gender: 2,
          id: 1856163,
          known_for_department: 'Art',
          name: 'Scott Johnson',
          original_name: 'Scott Johnson',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/prYSEAgvDkm47afYUtIfekblJno.jpg',
          credit_id: '59735b17c3a3686fc7057588',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 1856164,
          known_for_department: 'Art',
          name: 'Blade Ladish',
          original_name: 'Blade Ladish',
          popularity: 0.629,
          profile_path: null,
          credit_id: '59735b70c3a3681d700057c3',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 1856165,
          known_for_department: 'Art',
          name: 'Andrew H. Leung',
          original_name: 'Andrew H. Leung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735b7c9251411ece025e20',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 0,
          id: 1856166,
          known_for_department: 'Art',
          name: 'Konrad Lewis',
          original_name: 'Konrad Lewis',
          popularity: 0.98,
          profile_path: null,
          credit_id: '59735b85c3a3681d700057e8',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 1856167,
          known_for_department: 'Crew',
          name: 'Steve Mckean',
          original_name: 'Steve Mckean',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735ba19251414fde034ce2',
          department: 'Crew',
          job: 'Scenic Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1856168,
          known_for_department: 'Art',
          name: 'Dan Milligan',
          original_name: 'Dan Milligan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735bab925141787a00a8ff',
          department: 'Art',
          job: 'Storyboard Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1856170,
          known_for_department: 'Art',
          name: 'Graham Dane Parker',
          original_name: 'Graham Dane Parker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735c0a92514112bb02d58d',
          department: 'Art',
          job: 'Greensman',
        },
        {
          adult: false,
          gender: 0,
          id: 1856171,
          known_for_department: 'Crew',
          name: 'Garcia Jose Pineda',
          original_name: 'Garcia Jose Pineda',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735c25c3a3683c1000a141',
          department: 'Crew',
          job: 'Prop Maker',
        },
        {
          adult: false,
          gender: 0,
          id: 1856172,
          known_for_department: 'Crew',
          name: 'Jose F. Garcia Pineda',
          original_name: 'Jose F. Garcia Pineda',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735c43c3a36830fb00bcbd',
          department: 'Crew',
          job: 'Prop Maker',
        },
        {
          adult: false,
          gender: 0,
          id: 1856173,
          known_for_department: 'Art',
          name: 'Norah Plum',
          original_name: 'Norah Plum',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735c58c3a3681d70005912',
          department: 'Art',
          job: 'Sculptor',
        },
        {
          adult: false,
          gender: 0,
          id: 1856174,
          known_for_department: 'Art',
          name: 'Vicki Pui',
          original_name: 'Vicki Pui',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735c66c3a3687c7d02b59e',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 0,
          id: 1856175,
          known_for_department: 'Art',
          name: 'Marion Rex Smith',
          original_name: 'Marion Rex Smith',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735c8a9251414272005b5a',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 1856176,
          known_for_department: 'Crew',
          name: 'Kenneth Venghaus',
          original_name: 'Kenneth Venghaus',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735cb0c3a3683c1000a208',
          department: 'Crew',
          job: 'Prop Maker',
        },
        {
          adult: false,
          gender: 0,
          id: 1856177,
          known_for_department: 'Production',
          name: 'Cale Wilbanks',
          original_name: 'Cale Wilbanks',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735cbcc3a3687c7d02b626',
          department: 'Production',
          job: 'Researcher',
        },
        {
          adult: false,
          gender: 0,
          id: 1856178,
          known_for_department: 'Sound',
          name: 'Colt Logan',
          original_name: 'Colt Logan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59735ce492514142a70058b7',
          department: 'Sound',
          job: 'Boom Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1857756,
          known_for_department: 'Camera',
          name: 'Jacob Alvarez',
          original_name: 'Jacob Alvarez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7eae7c3a36839dd01bd28',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1868203,
          known_for_department: 'Visual Effects',
          name: "Katrissa 'Kat' Peterson",
          original_name: "Katrissa 'Kat' Peterson",
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93e6b9251415e3f03454f',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1869382,
          known_for_department: 'Visual Effects',
          name: 'Andrea Kistler',
          original_name: 'Andrea Kistler',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93e570e0a263dca0370fd',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1877422,
          known_for_department: 'Directing',
          name: 'Robin Meyers',
          original_name: 'Robin Meyers',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb0017b9d592c003c57baa1',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1882068,
          known_for_department: 'Costume & Make-Up',
          name: 'Chloe Ji Yoon',
          original_name: 'Chloe Ji Yoon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7ec6ac3a36839d1020bef',
          department: 'Costume & Make-Up',
          job: 'Assistant Costume Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1893166,
          known_for_department: 'Visual Effects',
          name: 'Andy Yamada',
          original_name: 'Andy Yamada',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeaf62a2d2e9003e14b243',
          department: 'Visual Effects',
          job: 'Stereoscopic Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1901057,
          known_for_department: 'Crew',
          name: 'Jack Runyon',
          original_name: 'Jack Runyon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93f4ec3a36839dd02f6d6',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1904000,
          known_for_department: 'Lighting',
          name: 'Morten Petersen',
          original_name: 'Morten Petersen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebe2801e4d1004155a1bc',
          department: 'Lighting',
          job: 'Rigging Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1904000,
          known_for_department: 'Lighting',
          name: 'Morten Petersen',
          original_name: 'Morten Petersen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7ead2c3a36839d5021665',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1907203,
          known_for_department: 'Lighting',
          name: 'Geoffrey Harper',
          original_name: 'Geoffrey Harper',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7eb300e0a263dc101ef66',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1908976,
          known_for_department: 'Production',
          name: 'Teodora Ilie',
          original_name: 'Teodora Ilie',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb0071c945c20003fe83239',
          department: 'Production',
          job: 'Assistant Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1913026,
          known_for_department: 'Costume & Make-Up',
          name: 'Carl Ulysses Bowen',
          original_name: 'Carl Ulysses Bowen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7edc69251415e3901f09c',
          department: 'Costume & Make-Up',
          job: 'Tailor',
        },
        {
          adult: false,
          gender: 0,
          id: 1914644,
          known_for_department: 'Visual Effects',
          name: 'Nimoul Nims Bun',
          original_name: 'Nimoul Nims Bun',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93cc49251415e4b03240a',
          department: 'Visual Effects',
          job: 'Creature Technical Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1915130,
          known_for_department: 'Visual Effects',
          name: 'Shawn Miller',
          original_name: 'Shawn Miller',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93c120e0a263dca036e96',
          department: 'Visual Effects',
          job: 'Lead Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 1915274,
          known_for_department: 'Visual Effects',
          name: 'Josh Dagg',
          original_name: 'Josh Dagg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa941809251415e3c033482',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1915275,
          known_for_department: 'Visual Effects',
          name: 'Megan Flood',
          original_name: 'Megan Flood',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa941940e0a263dd303a84b',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1917281,
          known_for_department: 'Visual Effects',
          name: 'Gary Wu',
          original_name: 'Gary Wu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93bbfc3a36839d5039243',
          department: 'Visual Effects',
          job: 'Creature Technical Director',
        },
        {
          adult: false,
          gender: 1,
          id: 1936701,
          known_for_department: 'Production',
          name: 'Tammy L. Smith',
          original_name: 'Tammy L. Smith',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb3db7f0540003e1f0db7',
          department: 'Production',
          job: 'Extras Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 1964786,
          known_for_department: 'Camera',
          name: 'Tim Ryan',
          original_name: 'Tim Ryan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebde61d3143003e9c1831',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 1974129,
          known_for_department: 'Editing',
          name: 'Josie Azzam',
          original_name: 'Josie Azzam',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faffd5fdb154f003d492e7c',
          department: 'Editing',
          job: 'Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1979944,
          known_for_department: 'Editing',
          name: 'Joe Binford Jr.',
          original_name: 'Joe Binford Jr.',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faffd77e24e3a0040e60f72',
          department: 'Editing',
          job: 'Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1982648,
          known_for_department: 'Visual Effects',
          name: 'Scott Meadows',
          original_name: 'Scott Meadows',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93c790e0a263dd603683f',
          department: 'Visual Effects',
          job: 'Pre-Visualization Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1988239,
          known_for_department: 'Crew',
          name: 'Nando Stille',
          original_name: 'Nando Stille',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea940924ce600416e3af5',
          department: 'Visual Effects',
          job: 'CG Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1988241,
          known_for_department: 'Visual Effects',
          name: 'Saskia Carolan',
          original_name: 'Saskia Carolan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea8762b9320003e720f08',
          department: 'Visual Effects',
          job: 'CG Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1993197,
          known_for_department: 'Visual Effects',
          name: 'Brett Dowler',
          original_name: 'Brett Dowler',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa940790e0a263dd303a706',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1995027,
          known_for_department: 'Production',
          name: 'Diane Howard',
          original_name: 'Diane Howard',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5fb004bfb54002003f590868',
          department: 'Production',
          job: 'Publicist',
        },
        {
          adult: false,
          gender: 0,
          id: 1997382,
          known_for_department: 'Camera',
          name: 'Dan Godar',
          original_name: 'Dan Godar',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7e7340e0a263dc101eb78',
          department: 'Camera',
          job: 'Aerial Camera',
        },
        {
          adult: false,
          gender: 2,
          id: 1997383,
          known_for_department: 'Camera',
          name: 'Grg Magidow',
          original_name: 'Grg Magidow',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7e7c5c3a36839ce01f7e1',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1997384,
          known_for_department: 'Camera',
          name: 'Craig Bauer',
          original_name: 'Craig Bauer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7e7d59251415e4201e10b',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1997385,
          known_for_department: 'Camera',
          name: 'Rob Weidner',
          original_name: 'Rob Weidner',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7e7f7c3a36839d1020732',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1997386,
          known_for_department: 'Lighting',
          name: 'Shane Humphries',
          original_name: 'Shane Humphries',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7e903c3a36839ce01f8fd',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 1997387,
          known_for_department: 'Lighting',
          name: 'Jack Rose',
          original_name: 'Jack Rose',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7e93ac3a36839d1020861',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 1997390,
          known_for_department: 'Lighting',
          name: 'Jeffery A. Taylor',
          original_name: 'Jeffery A. Taylor',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5aa7eafb0e0a263dc101ef38',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1997391,
          known_for_department: 'Lighting',
          name: 'Billy Witherington',
          original_name: 'Billy Witherington',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7eb1c0e0a263dca02047b',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1997392,
          known_for_department: 'Costume & Make-Up',
          name: 'German Lee Castillo',
          original_name: 'German Lee Castillo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7ebea9251415e4501dadc',
          department: 'Costume & Make-Up',
          job: 'Ager/Dyer',
        },
        {
          adult: false,
          gender: 1,
          id: 1997393,
          known_for_department: 'Costume & Make-Up',
          name: 'Katy Johnson',
          original_name: 'Katy Johnson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7ebfd0e0a263dca02056a',
          department: 'Costume & Make-Up',
          job: 'Ager/Dyer',
        },
        {
          adult: false,
          gender: 0,
          id: 1997394,
          known_for_department: 'Costume & Make-Up',
          name: 'Derica Cole Washington',
          original_name: 'Derica Cole Washington',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7ec7bc3a36839ce01fcb2',
          department: 'Costume & Make-Up',
          job: 'Assistant Costume Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1997395,
          known_for_department: 'Costume & Make-Up',
          name: 'Josie Works',
          original_name: 'Josie Works',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7eca4c3a36839ce01fcd7',
          department: 'Costume & Make-Up',
          job: 'Costume Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1997397,
          known_for_department: 'Costume & Make-Up',
          name: 'Gertrude Moore',
          original_name: 'Gertrude Moore',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7ed37c3a36839da01e5e1',
          department: 'Costume & Make-Up',
          job: 'Seamstress',
        },
        {
          adult: false,
          gender: 0,
          id: 1997398,
          known_for_department: 'Costume & Make-Up',
          name: 'Kathy B. Washington',
          original_name: 'Kathy B. Washington',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7ed4a9251415e4201e6c6',
          department: 'Costume & Make-Up',
          job: 'Seamstress',
        },
        {
          adult: false,
          gender: 0,
          id: 1997399,
          known_for_department: 'Costume & Make-Up',
          name: 'Kevin Mayes',
          original_name: 'Kevin Mayes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7eddcc3a36839da01e6a0',
          department: 'Costume & Make-Up',
          job: 'Tailor',
        },
        {
          adult: false,
          gender: 0,
          id: 1997400,
          known_for_department: 'Editing',
          name: 'Jessica T. Stone',
          original_name: 'Jessica T. Stone',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5aa7eebb9251415e4801db13',
          department: 'Editing',
          job: 'Digital Intermediate',
        },
        {
          adult: false,
          gender: 0,
          id: 1997401,
          known_for_department: 'Directing',
          name: 'Mia Brassell',
          original_name: 'Mia Brassell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb00164945c200041e8ae60',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1997402,
          known_for_department: 'Crew',
          name: 'Jesse Noel',
          original_name: 'Jesse Noel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7f0670e0a263dc4020f9a',
          department: 'Crew',
          job: 'Special Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1997403,
          known_for_department: 'Art',
          name: 'Maria Elia Castro',
          original_name: 'Maria Elia Castro',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa7f1240e0a263dd0021052',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1998206,
          known_for_department: 'Crew',
          name: 'Marc Roth',
          original_name: 'Marc Roth',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93aa2c3a36839ce03624b',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1998208,
          known_for_department: 'Crew',
          name: 'Ioan Boieriu',
          original_name: 'Ioan Boieriu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93af59251415e48032019',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1998211,
          known_for_department: 'Visual Effects',
          name: 'Kris Andrews',
          original_name: 'Kris Andrews',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93b3ec3a36839d10378fb',
          department: 'Visual Effects',
          job: 'Creature Technical Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1998212,
          known_for_department: 'Visual Effects',
          name: 'Tracy Nicole Irwin',
          original_name: 'Tracy Nicole Irwin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93b50925141722202b3f7',
          department: 'Visual Effects',
          job: 'Creature Technical Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1998213,
          known_for_department: 'Crew',
          name: 'James Kuroda',
          original_name: 'James Kuroda',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93b780e0a263dca036ddc',
          department: 'Crew',
          job: 'Digital Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1998218,
          known_for_department: 'Visual Effects',
          name: 'Kyle Robinson',
          original_name: 'Kyle Robinson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93c65c3a36839e1035309',
          department: 'Visual Effects',
          job: 'Pre-Visualization Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1998219,
          known_for_department: 'Visual Effects',
          name: 'Fady Kadry',
          original_name: 'Fady Kadry',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93c99c3a36839d503931c',
          department: 'Visual Effects',
          job: '3D Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1998220,
          known_for_department: 'Visual Effects',
          name: 'Daniel Kepler',
          original_name: 'Daniel Kepler',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93d1f0e0a263dd003764e',
          department: 'Visual Effects',
          job: 'VFX Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1998221,
          known_for_department: 'Visual Effects',
          name: 'Shayna Banaag',
          original_name: 'Shayna Banaag',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93d90c3a36839cb035c2c',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1998222,
          known_for_department: 'Visual Effects',
          name: 'Jessica Carrington',
          original_name: 'Jessica Carrington',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93da69251415e3c0330cc',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1998223,
          known_for_department: 'Visual Effects',
          name: 'Sarah Cave',
          original_name: 'Sarah Cave',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93db79251415e45032960',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1998227,
          known_for_department: 'Visual Effects',
          name: 'Matthew Enright',
          original_name: 'Matthew Enright',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93df59251415e3c03311f',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1998228,
          known_for_department: 'Visual Effects',
          name: 'Erin Fernie',
          original_name: 'Erin Fernie',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5aa93e1b0e0a263dd003773a',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1998229,
          known_for_department: 'Visual Effects',
          name: 'Simon Fraser',
          original_name: 'Simon Fraser',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93e32c3a36839e10354c7',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1998230,
          known_for_department: 'Visual Effects',
          name: 'Yegor Tesler',
          original_name: 'Yegor Tesler',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93ea0c3a36839d5039515',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1998231,
          known_for_department: 'Visual Effects',
          name: 'Robert Turnbridge',
          original_name: 'Robert Turnbridge',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93eb30e0a263dca037147',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1998232,
          known_for_department: 'Visual Effects',
          name: 'Jessica Wilson-Silas',
          original_name: 'Jessica Wilson-Silas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93ec40e0a263dc1034b90',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1998233,
          known_for_department: 'Visual Effects',
          name: 'Tae Hyun Kim',
          original_name: 'Tae Hyun Kim',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93ee19251415e45032a71',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1998234,
          known_for_department: 'Visual Effects',
          name: 'Aileen Mu',
          original_name: 'Aileen Mu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93ef8c3a36839d1037d16',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1998236,
          known_for_department: 'Visual Effects',
          name: 'Mario Dietz',
          original_name: 'Mario Dietz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93f259251415e4b03267d',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1998240,
          known_for_department: 'Crew',
          name: 'Kevin Walter',
          original_name: 'Kevin Walter',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa93fb99251415e45032b77',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1998243,
          known_for_department: 'Visual Effects',
          name: 'Rob Holland',
          original_name: 'Rob Holland',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa940020e0a263dd0037925',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1998244,
          known_for_department: 'Visual Effects',
          name: 'Lee Briggs',
          original_name: 'Lee Briggs',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa940500e0a263dc703693f',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1998245,
          known_for_department: 'Visual Effects',
          name: 'Doris Huber',
          original_name: 'Doris Huber',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa940a39251415e39034d58',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1998247,
          known_for_department: 'Visual Effects',
          name: 'Thomas Reppen',
          original_name: 'Thomas Reppen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa940e00e0a263dcd037150',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1998249,
          known_for_department: 'Visual Effects',
          name: 'Jesse James Chisholm',
          original_name: 'Jesse James Chisholm',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa941340e0a263dd0037a97',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1998251,
          known_for_department: 'Visual Effects',
          name: 'Michael S. Harbour',
          original_name: 'Michael S. Harbour',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aa941f2925141722202ba60',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2003323,
          known_for_department: 'Sound',
          name: 'Matthieu Baron',
          original_name: 'Matthieu Baron',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faffab1d55e4d003ccfb9e5',
          department: 'Sound',
          job: 'Boom Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 2014542,
          known_for_department: 'Sound',
          name: 'Marcus Petruska',
          original_name: 'Marcus Petruska',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faffac4d55e4d003ecf9227',
          department: 'Sound',
          job: 'Boom Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 2014829,
          known_for_department: 'Visual Effects',
          name: 'Matt Kowaliszyn',
          original_name: 'Matt Kowaliszyn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea76201e4d1004055ad41',
          department: 'Visual Effects',
          job: 'Animation Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 2016325,
          known_for_department: 'Sound',
          name: 'Richard Gould',
          original_name: 'Richard Gould',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eSIi2hvbOo7NUDvtC4sbFG66250.jpg',
          credit_id: '5ac63d470e0a26497a00ff6d',
          department: 'Sound',
          job: 'Foley Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 2020939,
          known_for_department: 'Crew',
          name: 'Michael Hansen',
          original_name: 'Michael Hansen',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5ace0cbf0e0a26320a041d5f',
          department: 'Crew',
          job: 'Utility Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 2028828,
          known_for_department: 'Camera',
          name: 'Stephen Early',
          original_name: 'Stephen Early',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebb987776f00041516e25',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 2,
          id: 2034931,
          known_for_department: 'Editing',
          name: 'Steven Pristin',
          original_name: 'Steven Pristin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faffd9fec4552003ef5ef2a',
          department: 'Editing',
          job: 'Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2038911,
          known_for_department: 'Sound',
          name: 'Milos Stojanovic',
          original_name: 'Milos Stojanovic',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faff9b1498ef900418044bf',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 2046817,
          known_for_department: 'Camera',
          name: 'Brent Egan',
          original_name: 'Brent Egan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebe9d7a97ab003fce5fae',
          department: 'Camera',
          job: 'Second Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2066262,
          known_for_department: 'Camera',
          name: 'Mateo Bourdieu',
          original_name: 'Mateo Bourdieu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebb88245dbe003e6ab79b',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2068439,
          known_for_department: 'Visual Effects',
          name: 'Dushyant Kashyap',
          original_name: 'Dushyant Kashyap',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faead8f0fb39800408b11aa',
          department: 'Visual Effects',
          job: 'Pipeline Technical Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2068450,
          known_for_department: 'Visual Effects',
          name: 'Prateek Kaushal',
          original_name: 'Prateek Kaushal',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb05c0fb39800408b14ff',
          department: 'Visual Effects',
          job: 'Stereoscopic Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2068880,
          known_for_department: 'Directing',
          name: 'Douglas Plasse',
          original_name: 'Douglas Plasse',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5faea38ea2d2e9003e14a5f5',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2073571,
          known_for_department: 'Camera',
          name: 'Dwight Campbell',
          original_name: 'Dwight Campbell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebf03db4ed6003fb18cd7',
          department: 'Camera',
          job: 'Second Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2080038,
          known_for_department: 'Costume & Make-Up',
          name: 'Houri Mahserejian',
          original_name: 'Houri Mahserejian',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb50ee86017003c936870',
          department: 'Costume & Make-Up',
          job: 'Costume Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2091368,
          known_for_department: 'Lighting',
          name: 'Jonathan Irizarry',
          original_name: 'Jonathan Irizarry',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebf51344a8e003e4703f8',
          department: 'Lighting',
          job: 'Best Boy Electric',
        },
        {
          adult: false,
          gender: 0,
          id: 2092278,
          known_for_department: 'Visual Effects',
          name: 'Ryan Albertson',
          original_name: 'Ryan Albertson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeadb8e263bb004092e653',
          department: 'Visual Effects',
          job: 'Pipeline Technical Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2092279,
          known_for_department: 'Visual Effects',
          name: 'Nathan Rusch',
          original_name: 'Nathan Rusch',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeada6c86b3a003f691f0a',
          department: 'Visual Effects',
          job: 'Pipeline Technical Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2092292,
          known_for_department: 'Visual Effects',
          name: 'Rohan Tirkey',
          original_name: 'Rohan Tirkey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb06fad59b500405b57ef',
          department: 'Visual Effects',
          job: 'Stereoscopic Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2092297,
          known_for_department: 'Crew',
          name: 'Kris Bieringa',
          original_name: 'Kris Bieringa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb0ab83ee67003d8b48d6',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 2092299,
          known_for_department: 'Crew',
          name: 'Jana Rexhausen',
          original_name: 'Jana Rexhausen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb0bc470ead0040078e88',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 2092300,
          known_for_department: 'Crew',
          name: 'Jérémie Sebban',
          original_name: 'Jérémie Sebban',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb0e0ad59b500405b58b4',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 2092940,
          known_for_department: 'Sound',
          name: 'Shannon Murphy',
          original_name: 'Shannon Murphy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb000299d592c003d57899e',
          department: 'Sound',
          job: 'Music Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2092973,
          known_for_department: 'Costume & Make-Up',
          name: 'Charelle Bronson',
          original_name: 'Charelle Bronson',
          popularity: 1.008,
          profile_path: null,
          credit_id: '5faeb5cab686b9003f888619',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 2,
          id: 2101139,
          known_for_department: 'Camera',
          name: 'Matt Fortlage',
          original_name: 'Matt Fortlage',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebf15590086003d553083',
          department: 'Camera',
          job: 'Second Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2102403,
          known_for_department: 'Crew',
          name: 'Eric Deinzer',
          original_name: 'Eric Deinzer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeaa07ad59b5003f5b1453',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2116611,
          known_for_department: 'Visual Effects',
          name: 'Mayur Dadarao Adhau',
          original_name: 'Mayur Dadarao Adhau',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb00411b6cff1003cc2deba',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2143543,
          known_for_department: 'Production',
          name: 'Ashish Kukian',
          original_name: 'Ashish Kukian',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb00780ec45520040f6b3ef',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 2144355,
          known_for_department: 'Visual Effects',
          name: 'Erik Schneider',
          original_name: 'Erik Schneider',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeaa64590086003e560de9',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2147630,
          known_for_department: 'Camera',
          name: 'Nicholas Kay',
          original_name: 'Nicholas Kay',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb9da924ce600416e486d',
          department: 'Camera',
          job: 'Digital Imaging Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2147631,
          known_for_department: 'Camera',
          name: 'Stuart Huggins',
          original_name: 'Stuart Huggins',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeba19a2d2e9003e14bdda',
          department: 'Camera',
          job: 'Digital Imaging Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2150884,
          known_for_department: 'Visual Effects',
          name: 'Sehwi Park',
          original_name: 'Sehwi Park',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeadeb7a97ab003ccd5df1',
          department: 'Visual Effects',
          job: 'Pipeline Technical Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2152399,
          known_for_department: 'Visual Effects',
          name: 'Chris Radcliffe',
          original_name: 'Chris Radcliffe',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5faeac84c86b3a003f691e21',
          department: 'Visual Effects',
          job: 'Modelling Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2155348,
          known_for_department: 'Visual Effects',
          name: 'Bharat De',
          original_name: 'Bharat De',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeab2a245dbe003e6aa571',
          department: 'Crew',
          job: 'Digital Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2189242,
          known_for_department: 'Visual Effects',
          name: 'Peter Cromwell',
          original_name: 'Peter Cromwell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faffdcc945c200040e858cb',
          department: 'Editing',
          job: 'Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2193893,
          known_for_department: 'Camera',
          name: 'Phil Greene',
          original_name: 'Phil Greene',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5faeb99401e4d1004055c12e',
          department: 'Camera',
          job: 'Camera Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2243563,
          known_for_department: 'Production',
          name: 'Stacy Parker',
          original_name: 'Stacy Parker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb0067ad0b434003e9dfe55',
          department: 'Production',
          job: 'Travel Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 2245167,
          known_for_department: 'Costume & Make-Up',
          name: 'Larry V. Steele',
          original_name: 'Larry V. Steele',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb651db4ed6003fb180db',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2245217,
          known_for_department: 'Visual Effects',
          name: 'Nils Nissing',
          original_name: 'Nils Nissing',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea90c924ce6003e6ee21a',
          department: 'Visual Effects',
          job: 'CG Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2253900,
          known_for_department: 'Lighting',
          name: 'Joshua D. Quick',
          original_name: 'Joshua D. Quick',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebcce83ee67003e8b9d11',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 2262019,
          known_for_department: 'Visual Effects',
          name: 'Wesley Vet',
          original_name: 'Wesley Vet',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeac021d3143003d9bdbd6',
          department: 'Visual Effects',
          job: 'Matchmove Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2267109,
          known_for_department: 'Visual Effects',
          name: 'Julia Strack',
          original_name: 'Julia Strack',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeaa77a2d2e9003f148e07',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2281421,
          known_for_department: 'Editing',
          name: 'Wayan Blue Palmieri',
          original_name: 'Wayan Blue Palmieri',
          popularity: 0.972,
          profile_path: null,
          credit_id: '5fafff51498ef9003e80f14f',
          department: 'Editing',
          job: 'Stereoscopic Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2285854,
          known_for_department: 'Visual Effects',
          name: 'Evan Fraser',
          original_name: 'Evan Fraser',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeabe7c613ce003f216d8c',
          department: 'Visual Effects',
          job: 'Matchmove Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 2298199,
          known_for_department: 'Production',
          name: 'Matt Hughes',
          original_name: 'Matt Hughes',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5fb0035f626208003eb32510',
          department: 'Production',
          job: 'Production Accountant',
        },
        {
          adult: false,
          gender: 0,
          id: 2311852,
          known_for_department: 'Camera',
          name: 'Andrew Crankshaw',
          original_name: 'Andrew Crankshaw',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebe8c01e4d1004055c794',
          department: 'Camera',
          job: 'Second Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2316471,
          known_for_department: 'Production',
          name: 'Deanna Greif',
          original_name: 'Deanna Greif',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb3a8db4ed60042b0f8ae',
          department: 'Production',
          job: 'Casting Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2328879,
          known_for_department: 'Production',
          name: 'Lathiem Groenmeyer',
          original_name: 'Lathiem Groenmeyer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb007a4202e11003f1d05c6',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 2372139,
          known_for_department: 'Production',
          name: 'Amanda Lomonaco',
          original_name: 'Amanda Lomonaco',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb00459b6cff1003cc2def6',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2384271,
          known_for_department: 'Visual Effects',
          name: 'Davide Binello',
          original_name: 'Davide Binello',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d4ff0667c6de30f0ba48d6f',
          department: 'Visual Effects',
          job: 'Matte Painter',
        },
        {
          adult: false,
          gender: 0,
          id: 2400817,
          known_for_department: 'Crew',
          name: 'YIM Jeonghyun',
          original_name: 'YIM Jeonghyun',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb97f8e8702003e94e2ce',
          department: 'Camera',
          job: 'Camera Production Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2478848,
          known_for_department: 'Costume & Make-Up',
          name: 'Jennifer Hryniw',
          original_name: 'Jennifer Hryniw',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5faeb858e86017003e92f8f3',
          department: 'Costume & Make-Up',
          job: 'Truck Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2482349,
          known_for_department: 'Visual Effects',
          name: 'Raphael A. Pimentel',
          original_name: 'Raphael A. Pimentel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea779c613ce003d21faf4',
          department: 'Visual Effects',
          job: 'Animation Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 2487977,
          known_for_department: 'Sound',
          name: 'Jeannette Browning',
          original_name: 'Jeannette Browning',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faff9d2735205004114478a',
          department: 'Sound',
          job: 'ADR Recordist',
        },
        {
          adult: false,
          gender: 0,
          id: 2488163,
          known_for_department: 'Production',
          name: 'Sainath Shinde',
          original_name: 'Sainath Shinde',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb00791945c200041e8b6e9',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 2540961,
          known_for_department: 'Camera',
          name: 'John C. Hoffler Jr.',
          original_name: 'John C. Hoffler Jr.',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebec0c86b3a004069823c',
          department: 'Camera',
          job: 'Second Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2544089,
          known_for_department: 'Crew',
          name: 'Jackie Bazan',
          original_name: 'Jackie Bazan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb004ab9ca759003f4a2324',
          department: 'Production',
          job: 'Publicist',
        },
        {
          adult: false,
          gender: 0,
          id: 2547596,
          known_for_department: 'Directing',
          name: 'Megan Schmidt',
          original_name: 'Megan Schmidt',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea512c613ce00402199d1',
          department: 'Directing',
          job: 'Second Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2559375,
          known_for_department: 'Visual Effects',
          name: 'Aleksandra Sienkiewicz',
          original_name: 'Aleksandra Sienkiewicz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeaa4e7f0540003f1f9087',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2559398,
          known_for_department: 'Visual Effects',
          name: 'Magnus Skagerlund',
          original_name: 'Magnus Skagerlund',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeaccb1d3143003c9c554a',
          department: 'Visual Effects',
          job: 'Modelling Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2606225,
          known_for_department: 'Visual Effects',
          name: 'Nicolas Rigaud',
          original_name: 'Nicolas Rigaud',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea6d68e87020040947eb4',
          department: 'Visual Effects',
          job: '2D Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2613415,
          known_for_department: 'Visual Effects',
          name: 'Adrien Lambert',
          original_name: 'Adrien Lambert',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeaefae263bb003f922847',
          department: 'Visual Effects',
          job: 'Senior Generalist',
        },
        {
          adult: false,
          gender: 0,
          id: 2617473,
          known_for_department: 'Diễn viên',
          name: 'Meredith Stedman',
          original_name: 'Meredith Stedman',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kWaSM7aX59I1hNNtYiLbGUORiQK.jpg',
          credit_id: '5faeb44a8e87020040948bee',
          department: 'Production',
          job: 'Extras Casting Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2661380,
          known_for_department: 'Production',
          name: 'Matthew Monaco',
          original_name: 'Matthew Monaco',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb0034113af5f003e3b3c50',
          department: 'Production',
          job: 'Production Accountant',
        },
        {
          adult: false,
          gender: 0,
          id: 2678600,
          known_for_department: 'Visual Effects',
          name: 'Goran Ognjanovic',
          original_name: 'Goran Ognjanovic',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5faeae8c8e8702003e94d579',
          department: 'Visual Effects',
          job: 'Senior Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 2733286,
          known_for_department: 'Visual Effects',
          name: 'Lersak Bunupuradah',
          original_name: 'Lersak Bunupuradah',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeac637ecd28003bba093b',
          department: 'Visual Effects',
          job: 'Modelling Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2733318,
          known_for_department: 'Editing',
          name: 'H.R. Barnett',
          original_name: 'H.R. Barnett',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeaf9f470ead004107d743',
          department: 'Editing',
          job: 'Stereoscopic Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2736540,
          known_for_department: 'Visual Effects',
          name: 'Pascal Raimbault',
          original_name: 'Pascal Raimbault',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeacb61d3143003d9bdca1',
          department: 'Visual Effects',
          job: 'Modelling Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2744254,
          known_for_department: 'Camera',
          name: 'Ian Campbell',
          original_name: 'Ian Campbell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebb77e86017003c936ff7',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2766893,
          known_for_department: 'Camera',
          name: 'Jung Woo Park',
          original_name: 'Jung Woo Park',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebb5e83ee67003d8b5406',
          department: 'Camera',
          job: 'Epk Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 2772713,
          known_for_department: 'Camera',
          name: 'Victor Chon',
          original_name: 'Victor Chon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebb4aa2d2e9003e14c052',
          department: 'Camera',
          job: 'Epk Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 2772713,
          known_for_department: 'Camera',
          name: 'Victor Chon',
          original_name: 'Victor Chon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb002df498ef9004081351a',
          department: 'Camera',
          job: 'Epk Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2776190,
          known_for_department: 'Visual Effects',
          name: 'Werner Reifberger',
          original_name: 'Werner Reifberger',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea92fa2d2e9003e14ac17',
          department: 'Visual Effects',
          job: 'CG Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2776192,
          known_for_department: 'Visual Effects',
          name: 'Merten Tremer',
          original_name: 'Merten Tremer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea95401e4d10041558937',
          department: 'Visual Effects',
          job: 'CG Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2776193,
          known_for_department: 'Visual Effects',
          name: 'Mona Wiemer',
          original_name: 'Mona Wiemer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea968924ce6003e6ee27f',
          department: 'Visual Effects',
          job: 'CG Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2776205,
          known_for_department: 'Visual Effects',
          name: 'Sameer Malik',
          original_name: 'Sameer Malik',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeaa3a8e8702003e94d041',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2788044,
          known_for_department: 'Lighting',
          name: 'Jeff C. Sutton',
          original_name: 'Jeff C. Sutton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebdba470ead004207421e',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2816052,
          known_for_department: 'Production',
          name: 'Sara Bartkiewicz',
          original_name: 'Sara Bartkiewicz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb003ed5ed962003f1073f5',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 2838145,
          known_for_department: 'Production',
          name: 'Eric C. Pike',
          original_name: 'Eric C. Pike',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb003c5d0b434003d9e9ce0',
          department: 'Crew',
          job: 'Production Controller',
        },
        {
          adult: false,
          gender: 0,
          id: 2854817,
          known_for_department: 'Directing',
          name: "Jigwang 'Jerry' Ko",
          original_name: "Jigwang 'Jerry' Ko",
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea375924ce6003f6dcfd0',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2854820,
          known_for_department: 'Directing',
          name: 'Cody Williams',
          original_name: 'Cody Williams',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea4b37f0540003f1f8947',
          department: 'Directing',
          job: 'Second Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2854830,
          known_for_department: 'Visual Effects',
          name: 'Henry van der Beek',
          original_name: 'Henry van der Beek',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea7b9e263bb00419261cd',
          department: 'Visual Effects',
          job: 'Animation Technical Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2854836,
          known_for_department: 'Visual Effects',
          name: 'Friderieke Bach',
          original_name: 'Friderieke Bach',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea8517776f000425187eb',
          department: 'Visual Effects',
          job: 'CG Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2854838,
          known_for_department: 'Visual Effects',
          name: 'Fritz Beck',
          original_name: 'Fritz Beck',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea863a2d2e9003e14ab5a',
          department: 'Visual Effects',
          job: 'CG Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2854840,
          known_for_department: 'Visual Effects',
          name: 'Manuel Dongowski',
          original_name: 'Manuel Dongowski',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea886590086003f55ed2e',
          department: 'Visual Effects',
          job: 'CG Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2854841,
          known_for_department: 'Visual Effects',
          name: 'Roderick Freidrich',
          original_name: 'Roderick Freidrich',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea898db4ed60042b0ef65',
          department: 'Visual Effects',
          job: 'CG Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2854842,
          known_for_department: 'Visual Effects',
          name: 'Sven Klimm',
          original_name: 'Sven Klimm',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea8a8b686b90040883e60',
          department: 'Visual Effects',
          job: 'CG Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2854843,
          known_for_department: 'Visual Effects',
          name: 'Oliver Markowski',
          original_name: 'Oliver Markowski',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea8e083ee67003d8b424a',
          department: 'Visual Effects',
          job: 'CG Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2854844,
          known_for_department: 'Visual Effects',
          name: 'Mariusz Miskiewicz',
          original_name: 'Mariusz Miskiewicz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea8f601e4d100415588ef',
          department: 'Visual Effects',
          job: 'CG Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2854846,
          known_for_department: 'Visual Effects',
          name: 'Olivia Puchalla',
          original_name: 'Olivia Puchalla',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faea91e2b9320004072a15f',
          department: 'Visual Effects',
          job: 'CG Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2854856,
          known_for_department: 'Visual Effects',
          name: 'Heather Howell',
          original_name: 'Heather Howell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeadd92b9320003e72128d',
          department: 'Visual Effects',
          job: 'Pipeline Technical Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2854858,
          known_for_department: 'Visual Effects',
          name: 'Ümit Dönmez',
          original_name: 'Ümit Dönmez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeaea1b686b9003e879cb7',
          department: 'Visual Effects',
          job: 'Senior Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 2854866,
          known_for_department: 'Visual Effects',
          name: 'Sashwata Das',
          original_name: 'Sashwata Das',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb0367776f000415163a3',
          department: 'Visual Effects',
          job: 'Stereoscopic Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2854868,
          known_for_department: 'Visual Effects',
          name: 'Jimmie MacDonald',
          original_name: 'Jimmie MacDonald',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb18883ee67003d8b4990',
          department: 'Visual Effects',
          job: 'Visual Effects Production Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2854869,
          known_for_department: 'Visual Effects',
          name: 'Jatin Bhavsar',
          original_name: 'Jatin Bhavsar',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb19d0fb39800428ac0ca',
          department: 'Visual Effects',
          job: 'Visual Effects Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 2854870,
          known_for_department: 'Visual Effects',
          name: 'Van Le Do',
          original_name: 'Van Le Do',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb1af2b9320004072a936',
          department: 'Visual Effects',
          job: 'Visual Effects Production Manager',
        },
        {
          adult: false,
          gender: 1,
          id: 2854871,
          known_for_department: 'Visual Effects',
          name: 'Nicole Rowley',
          original_name: 'Nicole Rowley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb1c3ad59b500405b59f6',
          department: 'Visual Effects',
          job: 'Visual Effects Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 2854874,
          known_for_department: 'Visual Effects',
          name: 'Sanchia Currie',
          original_name: 'Sanchia Currie',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb241344a8e003e46f140',
          department: 'Visual Effects',
          job: 'Visual Effects Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 2854876,
          known_for_department: 'Visual Effects',
          name: 'Christine Krumpholz',
          original_name: 'Christine Krumpholz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb2b42b9320003f730bbb',
          department: 'Visual Effects',
          job: 'Senior Animator',
        },
        {
          adult: false,
          gender: 2,
          id: 2854877,
          known_for_department: 'Production',
          name: 'Cody Kaylor',
          original_name: 'Cody Kaylor',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb396fdc146003f6defa1',
          department: 'Production',
          job: 'Casting Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2854878,
          known_for_department: 'Production',
          name: 'Fabian Dash McIntosh',
          original_name: 'Fabian Dash McIntosh',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb3ca7f054000401f67d2',
          department: 'Production',
          job: 'Extras Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 2854879,
          known_for_department: 'Production',
          name: 'Ashley R. Jackson',
          original_name: 'Ashley R. Jackson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb3ed7a97ab003dce0f9b',
          department: 'Production',
          job: 'Extras Casting Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2854884,
          known_for_department: 'Costume & Make-Up',
          name: 'Sheila Boateng',
          original_name: 'Sheila Boateng',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb5bb924ce6003f6dddba',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2854888,
          known_for_department: 'Costume & Make-Up',
          name: 'Tanja Caldwell',
          original_name: 'Tanja Caldwell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb5d9ad59b5003d5a61f6',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2854890,
          known_for_department: 'Costume & Make-Up',
          name: 'Erinique Ellison',
          original_name: 'Erinique Ellison',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb5e77ecd28003dba9e8d',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2854892,
          known_for_department: 'Costume & Make-Up',
          name: 'Tyron Graham',
          original_name: 'Tyron Graham',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb5f6344a8e003e46f5fa',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2854896,
          known_for_department: 'Costume & Make-Up',
          name: 'Justin Jones',
          original_name: 'Justin Jones',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb611e263bb0041926db5',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2854904,
          known_for_department: 'Costume & Make-Up',
          name: 'Bianca White',
          original_name: 'Bianca White',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb65fc86b3a004168cdb3',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2854907,
          known_for_department: 'Costume & Make-Up',
          name: 'Jeff Gillies',
          original_name: 'Jeff Gillies',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb70c01e4d1004055beb0',
          department: 'Costume & Make-Up',
          job: 'Tailor',
        },
        {
          adult: false,
          gender: 0,
          id: 2854908,
          known_for_department: 'Costume & Make-Up',
          name: 'Sharod T. Woods',
          original_name: 'Sharod T. Woods',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb71e344a8e003d469d2b',
          department: 'Costume & Make-Up',
          job: 'Tailor',
        },
        {
          adult: false,
          gender: 0,
          id: 2854916,
          known_for_department: 'Costume & Make-Up',
          name: 'Alanna Bryant',
          original_name: 'Alanna Bryant',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb8680d9f5a004005fc01',
          department: 'Costume & Make-Up',
          job: 'Wardrobe Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2854923,
          known_for_department: 'Camera',
          name: 'Lynne Hull',
          original_name: 'Lynne Hull',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb94eb686b90040884bbf',
          department: 'Camera',
          job: 'Camera Production Assistant',
        },
        {
          adult: false,
          gender: 1,
          id: 2854924,
          known_for_department: 'Camera',
          name: 'LaTerrian Officer-McIntosh',
          original_name: 'LaTerrian Officer-McIntosh',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb964ad59b5003e5ac3ed',
          department: 'Camera',
          job: 'Camera Production Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2854925,
          known_for_department: 'Camera',
          name: 'Jürgen Painczyk',
          original_name: 'Jürgen Painczyk',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeb9ebb686b9003f888af2',
          department: 'Camera',
          job: 'Digital Imaging Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2854927,
          known_for_department: 'Camera',
          name: 'Jason Johnson',
          original_name: 'Jason Johnson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faeba54db4ed60041b0b19e',
          department: 'Camera',
          job: 'Digital Imaging Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2854931,
          known_for_department: 'Lighting',
          name: 'Lorenza Amato',
          original_name: 'Lorenza Amato',
          popularity: 0.656,
          profile_path: null,
          credit_id: '5faebc605900860040558359',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 2854937,
          known_for_department: 'Lighting',
          name: 'Raul Peña',
          original_name: 'Raul Peña',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebcbc7ecd28003cbb0629',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 2854938,
          known_for_department: 'Lighting',
          name: 'Jordan Tyson',
          original_name: 'Jordan Tyson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebce28e87020040949478',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 2854940,
          known_for_department: 'Lighting',
          name: 'Sean Meyer',
          original_name: 'Sean Meyer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebcf9470ead0042074194',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 2854942,
          known_for_department: 'Lighting',
          name: 'Justin Cowart',
          original_name: 'Justin Cowart',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebd6d5900860040558425',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2854944,
          known_for_department: 'Lighting',
          name: 'Jeremy Hughes',
          original_name: 'Jeremy Hughes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebd7f924ce6003e6ef784',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2854945,
          known_for_department: 'Lighting',
          name: 'Timothy Jones',
          original_name: 'Timothy Jones',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebd96344a8e003e47022a',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2854946,
          known_for_department: 'Lighting',
          name: 'Clyde Sharman',
          original_name: 'Clyde Sharman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebdaa924ce600406e85e6',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2854947,
          known_for_department: 'Crew',
          name: 'Taylor Seaman',
          original_name: 'Taylor Seaman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebe0f8e8702003e94e7fd',
          department: 'Crew',
          job: 'Loader',
        },
        {
          adult: false,
          gender: 0,
          id: 2854953,
          known_for_department: 'Camera',
          name: 'Rapheal Cdeeq',
          original_name: 'Rapheal Cdeeq',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebe7be86017003e92ffd7',
          department: 'Camera',
          job: 'Second Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2854956,
          known_for_department: 'Camera',
          name: 'Cristi Lyn Hahn',
          original_name: 'Cristi Lyn Hahn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebead7f054000401f748b',
          department: 'Camera',
          job: 'Second Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2854957,
          known_for_department: 'Camera',
          name: 'Harry Young-Jamieson',
          original_name: 'Harry Young-Jamieson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faebed67f0540003f1faa76',
          department: 'Camera',
          job: 'Second Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2856281,
          known_for_department: 'Editing',
          name: 'W. Kale Whorton',
          original_name: 'W. Kale Whorton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faffdb6d0b434003c9e4899',
          department: 'Editing',
          job: 'Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2856285,
          known_for_department: 'Editing',
          name: 'Fergus Hally',
          original_name: 'Fergus Hally',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faffe09d55e4d003dcf8f8e',
          department: 'Editing',
          job: 'Colorist',
        },
        {
          adult: false,
          gender: 0,
          id: 2856286,
          known_for_department: 'Editing',
          name: 'Stephan Marliss',
          original_name: 'Stephan Marliss',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faffe1eec45520040f6a5c1',
          department: 'Editing',
          job: 'Dailies Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 2856287,
          known_for_department: 'Editing',
          name: 'David Austin Thompson',
          original_name: 'David Austin Thompson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5faffe36ec45520040f6a5d7',
          department: 'Editing',
          job: 'Dailies Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 2856317,
          known_for_department: 'Crew',
          name: 'Beth McGuire',
          original_name: 'Beth McGuire',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb00262ec4552003ef5f450',
          department: 'Crew',
          job: 'Dialect Coach',
        },
        {
          adult: false,
          gender: 0,
          id: 2856320,
          known_for_department: 'Crew',
          name: 'Shumba Patrick',
          original_name: 'Shumba Patrick',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb002a9d0b434003c9e4eff',
          department: 'Crew',
          job: 'Dialect Coach',
        },
        {
          adult: false,
          gender: 0,
          id: 2856323,
          known_for_department: 'Production',
          name: 'Gayoung Kim',
          original_name: 'Gayoung Kim',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb0037ad0b434003d9e9ca8',
          department: 'Production',
          job: 'Production Accountant',
        },
        {
          adult: false,
          gender: 0,
          id: 2856325,
          known_for_department: 'Production',
          name: 'Jamil Purnell',
          original_name: 'Jamil Purnell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb003fe5ed962003f10740c',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2856328,
          known_for_department: 'Production',
          name: 'Yeijin Cho',
          original_name: 'Yeijin Cho',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb00422b6cff1003bc29ee4',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2856331,
          known_for_department: 'Production',
          name: 'Kelly Mokris',
          original_name: 'Kelly Mokris',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb00434735205003f142606',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2856332,
          known_for_department: 'Production',
          name: 'Sydne Japtha',
          original_name: 'Sydne Japtha',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb004473a48c5003e7cd662',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2856365,
          known_for_department: 'Production',
          name: 'Andrew Lee Ross',
          original_name: 'Andrew Lee Ross',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb007b8498ef9003f80a1c8',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 2,
          id: 3202371,
          known_for_department: 'Crew',
          name: 'Don McGregor',
          original_name: 'Don McGregor',
          popularity: 0.6,
          profile_path: null,
          credit_id: '611ccad166540800287c95e2',
          department: 'Crew',
          job: 'Thanks',
        },
        {
          adult: false,
          gender: 0,
          id: 3240403,
          known_for_department: 'Visual Effects',
          name: 'Aviv Bar-Ami',
          original_name: 'Aviv Bar-Ami',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6147a4a7c2823a0090c0175c',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'Gimly',
          author_details: {
            name: 'Gimly',
            username: 'Ruuz',
            avatar_path: '/xUObnJSvHrFPsIpoDmb1jiQZLq7.jpg',
            rating: 7.0,
          },
          content:
            "The reviews for _Black Panther_ are all essentially saying the same thing: This is a great movie because it's so different from anything we've seen before, not just in the MCU but in the superhero genre overall, the villain is fantastic and _Black Panther_ is just a new and totally innovative film. Allow me to disagree (almost) entirely. _Black Panther_ is a great film, not because it breaks the mould, but because Marvel Studios has a successful pattern and _Black Panther_ adheres to it completely. Obviously the importance of a lead who is not just black but actually African is not to be understated, we have the least white cast of any superhero movie to date and they absolutely killed it, all very important socio-political stuff, to be sure. But the bones of _Black Panther_, the plot, the script, the events, the turns, all of that, it's a carbon copy of what's worked 17 times before. It works again, don't get me wrong, _Black Panther_ truly was an experience, both important and fantastic, but to say it re-invented the wheel here, is, to me, an outright lie.\r\n\r\n_Final rating:★★★½ - I really liked it. Would strongly recommend you give it your time._",
          created_at: '2018-02-14T14:56:15.274Z',
          id: '5a844e0fc3a36862e100c22f',
          updated_at: '2021-06-23T15:58:05.262Z',
          url: 'https://www.themoviedb.org/review/5a844e0fc3a36862e100c22f',
        },
        {
          author: 'hankster3000',
          author_details: {
            name: '',
            username: 'hankster3000',
            avatar_path: null,
            rating: 1.0,
          },
          content:
            'Overrated and overhyped. Definitely avoid. Watch on redbox if you must.',
          created_at: '2018-02-17T05:06:29.941Z',
          id: '5a87b8550e0a26535a047632',
          updated_at: '2021-06-23T15:58:05.499Z',
          url: 'https://www.themoviedb.org/review/5a87b8550e0a26535a047632',
        },
        {
          author: 'Movie Queen41',
          author_details: {
            name: '',
            username: 'Movie Queen41',
            avatar_path: null,
            rating: 10.0,
          },
          content:
            "This is definitely one of Marvel's best because the story is compelling and the characters are well developed. Black Panther and his friends and family must defend themselves and their homeland of Wakanda from the clutches of Klau (Andy Serkis) and Killmonger (Michael B. Jordan). Not only is the lead actor great as T'Challa/Black Panther, but the supporting cast does a fine job as well, especially the female actors. T'Challa is surrounded by smart, strong women. Marvel seems to break its villain curse with Klau and especially Killmonger. Killmonger is very well developed and even sympathetic at times, despite his villainy. He sort of reminded me of Tom Hiddleston's Loki. The action scenes and special effects are outstanding. Highly recommended if you enjoy comic book movies.",
          created_at: '2018-02-17T20:46:50.715Z',
          id: '5a8894ba0e0a2653db05d34f',
          updated_at: '2021-06-23T15:58:05.512Z',
          url: 'https://www.themoviedb.org/review/5a8894ba0e0a2653db05d34f',
        },
        {
          author: 'Crenor',
          author_details: {
            name: '',
            username: 'Crenor',
            avatar_path:
              '/https://secure.gravatar.com/avatar/94e0c8200321e724b8a87961c7194804.jpg',
            rating: null,
          },
          content:
            'Really good movie. Good story, lots of fun. This is what DC is missing.',
          created_at: '2018-02-21T23:16:31.669Z',
          id: '5a8dfdcf0e0a263e6e006d75',
          updated_at: '2021-06-23T15:58:05.885Z',
          url: 'https://www.themoviedb.org/review/5a8dfdcf0e0a263e6e006d75',
        },
        {
          author: 'Per Gunnar Jonsson',
          author_details: {
            name: 'Per Gunnar Jonsson',
            username: 'Dark Jedi',
            avatar_path:
              '/https://secure.gravatar.com/avatar/cbabaea0fa98692d00130498d7ac5d7c.jpg',
            rating: 7.0,
          },
          content:
            'It was with some hesitation that I went to see this movie. I was afraid that it would be burdened with too much political and social preaching. Especially knowing how much the movie is praised amongst certain factions in our society today. Sure enough there were indeed some of that nonsense but luckily it was much less than I feared.\r\n\r\nI actually found the movie fairly entertaining. It is far from great, certainly very far from the insane hype surrounding it, but pretty okay. It is more or less a standard issue super hero movie on a big budget. Of course this means a fairly mediocre underlying story beefed up with lots of action and special effects.\r\n\r\nThe story itself is a traditional revenge story with some black power stuff. Nothing to write home about but it works as a vehicle for the action and special effects which is what makes this movie. There are the usual nonsense and plot holes in it of course. Like Shuri claiming that Vibranium (silly name but never mind) is instable at high speeds yet they have no problem making flying ships and other fast moving stuff with it.\r\n\r\nThe characters are a wee bit disappointing as far as the main characters are concerned. I felt that the main protagonist has little in terms of charisma. Killmonger, the main bad guy, was downright disappointing. To me he looked like the stereotype of a dumb thug and mostly he behaved like one. Bloody hell could they not have found an actor that looked less…well…stupid!\r\n\r\nPersonally the character I liked best was actually Klaue which was pretty cool, insane but cool. The female warriors, which were both kick-ass and smart, and Shuri is also fairly high up on my approval list.\r\n\r\nSpecial effects! This is of course where this movie shines. Overall I think the special effects were good. The design of the various gadgets, ships etc were very nice. The rampaging rhinos in the final fight really made me laugh. I should have seen that coming. I definitely liked all the sonic effects. Obviously this movie would have been more or less null if the special effects would not have been a success.\r\n\r\nOn the whole Black Panther is a quite enjoyable special effects and action movie. Nothing more, nothing less. Some social preaching nonsense but less than I feared, hum ho story, lots of action and lots of special effects.',
          created_at: '2018-02-26T07:03:39.064Z',
          id: '5a93b14b0e0a2616c602de5e',
          updated_at: '2021-06-23T15:58:06.231Z',
          url: 'https://www.themoviedb.org/review/5a93b14b0e0a2616c602de5e',
        },
        {
          author: 'OblateSphereDroid',
          author_details: {
            name: '',
            username: 'OblateSphereDroid',
            avatar_path: null,
            rating: 9.0,
          },
          content:
            'I was really surprised how much I liked this movie.  There was so much going on; immigration concerns; the fight between saving the world and protecting your own country(sound familiar); the fear of an African country’s resources being pillaged; how best to handle the problems black people face worldwide; and many great authentic feeling cultural nods.  All this while not being heavy or preachy.  You can definitely eat popcorn to this.  The villain; Killmonger, is great.  Not great in that he is scary, though he is, but because he is more complex than some shadowy figure you should just trust is a bad guy because of visual effects or dramatic music.  \r\n\r\nThis movie isn’t just explosions and one-liners in an exotic location.  This is a great movie in general.  It’s always interesting.  There are great relationships between all the characters.  Finally; Wakanda is really a place.  It feels alive and lived in; not just impressive buildings used as a backdrop.  They did a wonderful job of worldbuilding; from the rituals, to the clothing, fancy tech, and scenery.  This movie is definitely worth a watch. \r\n\r\n☆☆☆☆-1/2\r\n\r\nI also have to add that; you get to actually see Andy Serkis!  When I saw his name I thought we was going to be some kind of CGI monster.  I’m just happy to see him get actual screen time.',
          created_at: '2018-04-13T01:33:42.336Z',
          id: '5ad008f6c3a36842e4004d4d',
          updated_at: '2021-06-23T15:58:07.653Z',
          url: 'https://www.themoviedb.org/review/5ad008f6c3a36842e4004d4d',
        },
        {
          author: 'Dsnake1',
          author_details: {
            name: '',
            username: 'Dsnake1',
            avatar_path:
              '/https://secure.gravatar.com/avatar/f52639d314bceec05e1d8ce193647ecf.jpg',
            rating: 7.0,
          },
          content:
            "The Black Panther is a fun romp, but it definitely has some issues. First, the good.\r\n\r\nThe action is fun, the emotions hit home, and the story isn't dirt-poor. \r\n\r\nWhile the CGI gets ripped on from time to time, I thought it was solid enough for a Marvel movie. The fight scenes were relatively well-choreographed, as well. The ritual combat scenes were exciting and visually appealing. The fights in Korea were also fun to see, and while I'm not a fan of car chase scenes as a whole, I did enjoy this one. It was reminiscent of a James Bond movie. \r\n\r\nIn fact, that's another appeal, at least to me. The secret technology base and the fun action scenes were a great callback to James Bond-type movies. I do think the movie would have been complemented by giving T'Challa a similar vice as Bond's, although Marvel probably wouldn't veer down that line for the seemingly morally absolute King of Wakanda.\r\n\r\nThe story, well, it's a mixed bag. Everything seemed crammed together with major emotional keys being rushed through or somewhat ignored. The concept is fine though. A long lost relative comes to challenge the new king, wins, and shows his colors, becoming something amoral. The king comes back and takes down the usurper, realizing something about themselves/their kingdom in the process. It's tired, but not so tired it damages the movie. \r\n\r\nThis is where the issues begin to rise, though. The movie is really a movie and a half or two movies crammed into one. Wakanda has a ton of wonderful mythology, but almost none of it is explained. The movie never really explains how the Wakandans used vibranium was used to make themselves wealthy. It touches on it in some exposition, but there was much more that was just glossed over. \r\n\r\nIn addition, W'Kabi became radicalized by Killmonger much too quickly for such a pivotal relationship to flip. Some of the emotional aspects of the movie fell flat because they weren't given enough screen time. \r\n\r\nDespite its flaws, Black Panther is a fun movie that adds to the Marvel Cinematic Universe. It should have been two movies, but I doubt this is the last we'll see of Wakanda.",
          created_at: '2018-05-07T20:29:04.388Z',
          id: '5af0b71092514119a6000099',
          updated_at: '2021-06-23T15:58:08.418Z',
          url: 'https://www.themoviedb.org/review/5af0b71092514119a6000099',
        },
        {
          author: 'DanDare',
          author_details: {
            name: '',
            username: 'DanDare',
            avatar_path: '/gY0Mjm4thleETxdESQPabdn5CB3.jpg',
            rating: 6.0,
          },
          content:
            "The character of T'Challa made his debut in Captain America 3: Civil War.\r\n\r\nIn Black Panther, T'Challa returns to his homeland of Wakanda after the death of his father who has been hiding a secret about his brother who lived in the USA. He now inherits the throne after a challenge from a rival.\r\n\r\nWakanda is an african country with wealth, power and immense technology that it hides from the outside world.\r\n\r\nT'Challa's uncle wanted an uprising in the USA. Now his son Killmonger comes to Wakanda and challenges T'Challa for the throne.\r\n\r\nKillmonger wins and leads the struggle for black power.\r\n\r\nBlack Panther is a well made efficient film from Marvel who really have nailed down their formula. The box office avalanche has surprised me. It simply is not that good with a very predictable story.",
          created_at: '2018-05-30T02:37:26.128Z',
          id: '5b0e0e66c3a368714d000179',
          updated_at: '2021-06-23T15:58:09.022Z',
          url: 'https://www.themoviedb.org/review/5b0e0e66c3a368714d000179',
        },
        {
          author: 'Wuchak',
          author_details: {
            name: '',
            username: 'Wuchak',
            avatar_path: '/4KVM1VkqmXLOuwj1jjaSdxbvBDk.jpg',
            rating: 6.0,
          },
          content:
            'Overrated due to political correctness; it’s noble and has its points of interest, but it’s also kinda meh\r\n\t\r\nĐã phát hành IN 2018 and directed by Ryan Coogler, "Black Panther” details events when T’Challa (Chadwick Boseman) takes over kingship of the hidden African nation Wakanda after his father passes (John Kani). The kingdom is technologically advanced due to its secret resource Vibranium, a priceless, almost magical metal. Unfortunately, T’Challa’s reign is challenged by an angry American former-black ops soldier, Erik “Killmonger” (Michael B. Jordan).\r\n\r\nWith its black director and mostly black cast (with a couple of token white dudes), “Black Panther” was overhyped and overrated upon release. Critics were apparently afraid of being called “racist” by liberal fascists if they dared to be honest and say anything negative (rolling my eyes). The movie’s likable and certainly has its points of interest, but the characters are rather dull, except for Killmonger, and the story isn’t all that involving. It’s basically a mediocre superhero movie that has some blatant Bond-isms and is set apart by its primarily black cast and African locale. It fails to rise to the entertainment level of even “Ant-Man” (2015).\r\n\r\nStill, it’s respectfully noble and the story provokes interesting questions, like isolationism vs. internationalism and African-American culture vs. Native African culture. But there’s some eye-rolling bits, like when Shuri (Letitia Wright) calls CIA agent Ross (Martin Freeman) a “colonizer,” which isn’t even accurate. Maybe it was supposed to be a joke.\r\n\r\nThe waterfall fight between the Black Panther and Killmonger was an homage to the first issue of The Black Panther series in Jungle Action: Issue #6, September, 1973. At the end of that comic’s story T\'Challa and Erik fight at the top of a waterfall culminating with Killmonger throwing Black Panther over the cliff. This issue was the beginning of the "Panther\'s Rage" storyline by Don McGregor (featuring artists Billy Graham, Rich Buckler and Gil Kane), which ran for over two years in 13 issues of Jungle Action #6-18 and 209 pages, including the Epilogue. Many consider it the first graphic novel. Of course, this wasn\'t the first appearance of the Black Panther (who debuted in 1966), but it was the first issue where he was the starring character. \r\n\r\nAnd it was this series that provided the intriguing exposition on T’Challa, Wakanda and its citizens, visitors & enemies. It’s a travesty that McGregor, who created the characters of Killmonger & W’Kabi (Daniel Kaluuya) and conceived this exposition, wasn’t acknowledged in this movie; shameful.\r\n\r\nTHE FILM RUNS 2 hours, 14 minutes and was shot in Georgia (Atlanta, Fayetteville), South Korea (Busan) and Iguazú Waterfalls, Argentina. Ironically, nothing was shot in Africa. WRITERS: Coogler and Joe Robert Cole (and, uncredited, Don McGregor).\r\n\r\nGRADE: B-',
          created_at: '2018-06-12T21:24:08.105Z',
          id: '5b2039f8c3a36814900052f3',
          updated_at: '2021-06-23T15:58:09.493Z',
          url: 'https://www.themoviedb.org/review/5b2039f8c3a36814900052f3',
        },
        {
          author: 'trinistud1',
          author_details: {
            name: '',
            username: 'trinistud1',
            avatar_path: null,
            rating: 10.0,
          },
          content: 'Awesome movie',
          created_at: '2018-08-24T18:20:18.509Z',
          id: '5b804c62c3a3687e19012e25',
          updated_at: '2021-06-23T15:58:11.649Z',
          url: 'https://www.themoviedb.org/review/5b804c62c3a3687e19012e25',
        },
        {
          author: 'moovies',
          author_details: {
            name: '',
            username: 'moovies',
            avatar_path: '/1aF4vxy9sdOP1Mdl6gWGlIOdy6V.jpg',
            rating: 8.0,
          },
          content:
            '"Black Panther is Marvelous (pun intended)"\r\n\r\nT’Challa (Chadwick Boseman) returns home to his native Wakanda to be crowned king. Not long after he’s challenged for the throne and war looms over his homeland.\r\n\r\nBlack Panther isn’t your typical hero because let’s face it… He’s black. And apart from Bilbo Baggins (Martin Freeman) and Smeagol (Andy Serkis), everybody’s black. And that’s the way it should be.\r\nThe entire cast delivers. Boseman is excellent as king T’Challa who struggles with his new role. It doesn’t get any easierr when Killmonger (Michael B. Jordan) shows up. Killmonger is a mean SOB yet you care for him (some good Biên kịch right there). He’s a worthy adversary and one of the better Marvel villains. Jordan portrays him perfectly. Director Ryan Coogler and Michael B. Jordan are a match made in heaven. This is their third collaboration after ‘Fruitvale Station’ and ‘Creed’ and again they’re successful. The movie itself gets better as Jordan’s role gets bigger.\r\n\r\nThe female characters and actors are equally impressive. Especially Nakia (Lupita Nyong’o) and Okoye (Danai Gurira) steal the show.\r\n\r\nThere’s less humour in ‘Black Panther’ than we’re used to seeing in Marvel films but that’s not a bad thing. The movie doesn’t need it.\r\n\r\nThough it’s set in (fictional) Africa there wasn’t any filming done in Africa. Nonetheless the movie looks right. The makers did a great job of creating Wakanda. Huge props to costume designer Ruth E. Carter and composer Ludwig Göransson who help bring Wakanda to life.\r\nOn the downside there’s a lot of CGI. Sometimes it’s too obvious (rhinos say hi). Despite that the battle scenes are beautifully choreographed. Especially Okoye wielding her spear is a thing to behold.\r\n\r\nAll in all ‘Black Panther’ is another wonderful addition to the MCU and we can’t wait to see what role T’Challa and his sidekicks are going to play in ‘Avengers: Infinity War’.',
          created_at: '2018-11-23T20:14:17.664Z',
          id: '5bf85f999251415cc80f0b3e',
          updated_at: '2021-06-23T15:58:14.562Z',
          url: 'https://www.themoviedb.org/review/5bf85f999251415cc80f0b3e',
        },
        {
          author: 'tmdb44006625',
          author_details: {
            name: '',
            username: 'tmdb44006625',
            avatar_path: null,
            rating: 7.0,
          },
          content:
            "Black Panther will probably be remembered as a culturally significant film more so than a great one, but that shouldn't take away from the movie's deeper theme of inclusivity. This is a really good movie with heart and intelligence.\r\n\r\nThe fact that I have issues with the pacing, the generic action, or that I don't find Killmonger as complex a villain as the movie thinks is my problem. But I don't understand how people can hate on Black Panther because it integrates social and political themes into its narrative. Isn't contemporary relevance key in determining the greatness of a film?",
          created_at: '2019-03-09T20:43:15.661Z',
          id: '5c8425630e0a26430363757a',
          updated_at: '2021-06-23T15:58:19.161Z',
          url: 'https://www.themoviedb.org/review/5c8425630e0a26430363757a',
        },
        {
          author: 'Nelson',
          author_details: {
            name: 'Nelson',
            username: 'TWDs',
            avatar_path:
              '/https://secure.gravatar.com/avatar/e48989d8a750d24e3523257414d0636f.jpg',
            rating: 10.0,
          },
          content:
            'I really enjoyed this film, it was new uncharted never done before, and they delivered a marvel masterpiece. I look forward to seeing the next one...',
          created_at: '2019-04-03T23:45:09.068Z',
          id: '5ca545850e0a261b89b4d296',
          updated_at: '2021-06-23T15:58:20.002Z',
          url: 'https://www.themoviedb.org/review/5ca545850e0a261b89b4d296',
        },
        {
          author: 'quasar1967',
          author_details: {
            name: '',
            username: 'quasar1967',
            avatar_path: '/4PHEqLJ6EKUspkT8qku1OtzyENS.jpg',
            rating: null,
          },
          content:
            'overhyped before release and overrated after release, Black Panther is nothing more than another paint by numbers MCU movie, with boring characters and a lead that lacks charisma',
          created_at: '2020-08-31T16:48:37.675Z',
          id: '5f4d29e5202e1100361ce3b7',
          updated_at: '2021-06-23T15:58:43.727Z',
          url: 'https://www.themoviedb.org/review/5f4d29e5202e1100361ce3b7',
        },
        {
          author: 'Adam Rife',
          author_details: {
            name: 'Adam Rife',
            username: 'AdamRife',
            avatar_path: '/9vaYFFgdkzacJ9hJpEnZWLp88if.jpg',
            rating: null,
          },
          content:
            'Overall Black Panther was an enjoyable movie, directed by Ryan Coogler. It is one of the biggest movies of 2018, with an outstanding cast who includes Chadwick Boseman and Michael b. jordan, amazing special effects, and a plot that leaves you on the downright edge of your seat for 2 hours and 15 minutes. After the tragic death of chadwick, had a thought about watch his movies and this one comes in my mind. This review is my tribute chadwick. This movie is pg-13, but it seems more 10 and up.  The awesome sci-fi action story about a prince of an utopian country facing the incredible truth about his family, <a href="https://paperhelp.nyc/">paperhelp</a> and the mantle of the black panther, protector of the country Wakanda, was amazing, and fits in with the mcu series perfectly. I reccomend that you watch Captain america:civil war first, as it would make some elements more understandable If you like superhero action movies, fantasy, or science fiction, come see this awesome movie.',
          created_at: '2020-09-11T10:51:59.010Z',
          id: '5f5b56cfe93e950038823008',
          updated_at: '2021-06-23T15:58:44.234Z',
          url: 'https://www.themoviedb.org/review/5f5b56cfe93e950038823008',
        },
        {
          author: 'r96sk',
          author_details: {
            name: '',
            username: 'r96sk',
            avatar_path:
              '/https://secure.gravatar.com/avatar/96c2e0e4ac98450f9e8e3c0a0a40aad8.jpg',
            rating: 8.0,
          },
          content:
            "Enjoyed that!\r\n\r\n<em>'Black Panther'</em>, the 18th MCU film, is very good. I really like the world building of Wakanda, as well as the cinematography and costume design. The cast are, as expected, excellent as well.\r\n\r\nChadwick Boseman is terrific as T'Challa, as I knew he would be based on the glimpse we see of him in 2016's <em>'Captain America: Civil War'</em>. He is the best actor here, but Danai Gurira runs him close. I'm a huge fan of Gurira's due to her performances in <em>'The Walking Dead'</em> so knew I'd rate her here too, she's fun to watch - it's cool to see her weapon-wielding once again.\r\n\r\nElsewhere, Lupita Nyong'o is good and so is Letitia Wright; she's great in 2015's <em>'Urban Hymn'</em>, which I had seen her in previously. It's a fairly stacked cast, with the likes of Forest Whitaker, Andy Serkis, Daniel Kaluuya and Michael B. Jordan also appearing; Jordan's character isn't the best, but he himself is more than solid.",
          created_at: '2021-01-22T22:30:15.886Z',
          id: '600b51f7cc277c003f1425ea',
          updated_at: '2021-06-23T15:58:50.513Z',
          url: 'https://www.themoviedb.org/review/600b51f7cc277c003f1425ea',
        },
      ],
      total_pages: 1,
      total_results: 16,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/fF9RAvRrEqI8DLS1AL0dVJmhXhL.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 10751, name: 'Phim Gia Đình' },
      { id: 35, name: 'Phim Hài' },
    ],
    homepage: 'https://kendy.men/',
    id: 487401,
    imdb_id: 'tt7228744',
    original_language: 'vi',
    original_title: 'Sắc Đẹp Ngàn Cân',
    overview:
      'Sắc Đẹp Ngàn Cân là một câu chuyện hài hước, lãng mạn về hai cô gái: Jolie (Jolie Phương Trinh) gợi cảm, quyến rũ nhưng có giọng hát dở tệ và Hà My (Minh Hằng) mập ú nhưng có giọng hát trời phú, phải đứng hát sau cánh gà sân khấu. Vì vẻ ngoài xấu xí, Hà My bị mọi người đối xử rất hững hờ nhưng cô luôn vô tư cho đến khi Jolie sỉ nhục cô ngay trước mặt người mà cô yêu thầm nhớ trộm là Duy Khang (Rocker Nguyễn). Mọi chuyện vì thế từ đây bắt đầu thay đổi.',
    popularity: 0.606,
    poster_path:
      'https://image.tmdb.org/t/p/w342/hLjq0Mrb8zYVjnuUzpw21AlXsj0.jpg',
    production_companies: [],
    production_countries: [{ iso_3166_1: 'VN', name: 'Vietnam' }],
    release_date: '2017-08-04',
    revenue: 0,
    runtime: 90,
    spoken_languages: [
      { english_name: 'Vietnamese', iso_639_1: 'vi', name: 'Tiếng Việt' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Sắc Đẹp Ngàn Cân',
    video: false,
    vote_average: 0.0,
    vote_count: 0,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: '(Official Trailer) SẮC ĐẸP NGÀN CÂN',
          key: 'JDFvVFnP8qU',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: false,
          published_at: '2017-06-01T09:24:13.000Z',
          id: '5f59ac7b7ad08c0039510123',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 0,
          id: 1594942,
          known_for_department: 'Diễn viên',
          name: 'Minh Hằng',
          original_name: 'Minh Hằng',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/z8ux3JWHmpo0k86GQKYLF7Ui1YY.jpg',
          cast_id: 0,
          character: 'Hà My',
          credit_id: '5a0d83a5c3a36812fe00f65a',
          order: 1,
        },
        {
          adult: false,
          gender: 0,
          id: 1793384,
          known_for_department: 'Diễn viên',
          name: 'Phương Trinh Jolie',
          original_name: 'Phương Trinh Jolie',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9tQjxyWPhF0ihVUMPMaf9cOpGq0.jpg',
          cast_id: 1,
          character: 'Jolie',
          credit_id: '5a0d83b8c3a368130b00e1f8',
          order: 2,
        },
        {
          adult: false,
          gender: 0,
          id: 1924639,
          known_for_department: 'Diễn viên',
          name: 'Rocker Nguyễn',
          original_name: 'Rocker Nguyễn',
          popularity: 0.6,
          profile_path: null,
          cast_id: 2,
          character: 'Duy Khang',
          credit_id: '5a0d83c7c3a36812ef00f149',
          order: 3,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 0,
          id: 1924641,
          known_for_department: 'Directing',
          name: 'James Ngô',
          original_name: 'James Ngô',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a0d84979251416ef000e9bc',
          department: 'Directing',
          job: 'Director',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/8DchpjXPy6QEeUq1X1nJUdFIc6L.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 35, name: 'Phim Hài' },
      { id: 53, name: 'Phim Gây Cấn' },
    ],
    homepage: '',
    id: 596054,
    imdb_id: 'tt10384744',
    original_language: 'es',
    original_title: 'La odisea de los giles',
    overview:
      'Tại một thị trấn ở phía Tây Bắc của tỉnh Buenos Aires, một nhóm hàng xóm được tổ chức để phục hồi nền kinh tế của khu vực, nhưng khi Corralito được thực hiện ở nước này và họ bị lừa đảo, hy vọng của họ biến mất. Bây giờ, họ sẽ đoàn kết để lấy lại số tiền đã mất và giáng một đòn mạnh vào cuộc sống của họ cho kẻ thù lớn nhất của họ.',
    popularity: 13.952,
    poster_path:
      'https://image.tmdb.org/t/p/w342/8rVakDWkFn1G0z6e1tRRY5IZ3aa.jpg',
    production_companies: [
      {
        id: 21914,
        logo_path: '/iF5QYCtPLuwkU90jWdjrul25d71.png',
        name: 'K & S Films',
        origin_country: 'AR',
      },
      { id: 159797, logo_path: null, name: 'Kenya Films', origin_country: '' },
      {
        id: 5444,
        logo_path: null,
        name: 'Mod Producciones',
        origin_country: 'ES',
      },
      {
        id: 981,
        logo_path: '/pkrdO9ykplO4Zc8edikoSX5APUN.png',
        name: 'TVE',
        origin_country: 'ES',
      },
      {
        id: 8046,
        logo_path: '/9Pvyw0vgN6PWoMJGsUil0DNlXdd.png',
        name: 'Telefe',
        origin_country: 'AR',
      },
    ],
    production_countries: [
      { iso_3166_1: 'AR', name: 'Argentina' },
      { iso_3166_1: 'ES', name: 'Spain' },
    ],
    release_date: '2019-08-15',
    revenue: 0,
    runtime: 116,
    spoken_languages: [
      { english_name: 'Spanish', iso_639_1: 'es', name: 'Español' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Cuộc phiêu lưu của Giles',
    video: false,
    vote_average: 7.8,
    vote_count: 416,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'HEROIC LOSERS Trailer | TIFF 2019',
          key: 'JLGouIpUrXg',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: false,
          published_at: '2019-07-26T17:46:44.000Z',
          id: '5d41e89db87aec61c23daeb4',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 69310,
          known_for_department: 'Diễn viên',
          name: 'Ricardo Darín',
          original_name: 'Ricardo Darín',
          popularity: 1.661,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cbS6prSUDcA8pE9CJp84FBZg8aJ.jpg',
          cast_id: 3,
          character: 'Fermín Perlassi',
          credit_id: '5cb9404b92514108d8f9075a',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 74896,
          known_for_department: 'Diễn viên',
          name: 'Luis Brandoni',
          original_name: 'Luis Brandoni',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/r20lS8Kxagg8d1LomPzpmCYTNDy.jpg',
          cast_id: 4,
          character: 'Antonio Fontana',
          credit_id: '5cb940a70e0a266b96f279cd',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 1308586,
          known_for_department: 'Diễn viên',
          name: 'Chino Darín',
          original_name: 'Chino Darín',
          popularity: 2.097,
          profile_path:
            'https://image.tmdb.org/t/p/w185/f3oYgbZQPNH1P2Q55j4v4DdzZNu.jpg',
          cast_id: 5,
          character: 'Rodrigo Perlassi',
          credit_id: '5cb940b69251410671f346f3',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 66959,
          known_for_department: 'Diễn viên',
          name: 'Verónica Llinás',
          original_name: 'Verónica Llinás',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eRT77QU9BxH6l1snTSGwYqPR8AC.jpg',
          cast_id: 6,
          character: 'Lidia',
          credit_id: '5cb940cbc3a3680a6f80ef73',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 138758,
          known_for_department: 'Diễn viên',
          name: 'Daniel Aráoz',
          original_name: 'Daniel Aráoz',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tx46xI0fjGPM6gtkYSOclwHUQqa.jpg',
          cast_id: 12,
          character: 'Belaúnde',
          credit_id: '5d39134aab68496bf784803b',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 130753,
          known_for_department: 'Diễn viên',
          name: 'Carlos Belloso',
          original_name: 'Carlos Belloso',
          popularity: 1.012,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zP0dVhtnTJHEUj814WyELtlvWbz.jpg',
          cast_id: 8,
          character: 'Medina',
          credit_id: '5cb942b10e0a261a55ec6375',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 99113,
          known_for_department: 'Diễn viên',
          name: 'Rita Cortese',
          original_name: 'Rita Cortese',
          popularity: 1.109,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3CtvCjKbUPyWq5SLAbYeBbb9M8d.jpg',
          cast_id: 10,
          character: 'Carmen Lorgio',
          credit_id: '5cb9430892514108d1f8c387',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 71200,
          known_for_department: 'Diễn viên',
          name: 'Andrés Parra',
          original_name: 'Andrés Parra',
          popularity: 0.612,
          profile_path:
            'https://image.tmdb.org/t/p/w185/z105wf0tuBN8Ul5jLAhGpHKHEPf.jpg',
          cast_id: 11,
          character: 'Fortunato Manzi',
          credit_id: '5cb9447a0e0a261a55ec661d',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 1656282,
          known_for_department: 'Diễn viên',
          name: 'Marco Antonio Caponi',
          original_name: 'Marco Antonio Caponi',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iPWVfj5jnfDRmV78ovN7iHtHIu4.jpg',
          cast_id: 9,
          character: 'Hernán',
          credit_id: '5cb942dd925141097df33348',
          order: 8,
        },
        {
          adult: false,
          gender: 0,
          id: 1050765,
          known_for_department: 'Diễn viên',
          name: 'Guillermo Jacubowicz ',
          original_name: 'Guillermo Jacubowicz ',
          popularity: 0.6,
          profile_path: null,
          cast_id: 13,
          character: 'Gómez',
          credit_id: '5d548c92a135330012fb582a',
          order: 9,
        },
        {
          adult: false,
          gender: 0,
          id: 2387415,
          known_for_department: 'Diễn viên',
          name: 'Alejandro Gigena',
          original_name: 'Alejandro Gigena',
          popularity: 0.6,
          profile_path: null,
          cast_id: 14,
          character: 'Gómez',
          credit_id: '5d548c9a00bfe80016318c36',
          order: 10,
        },
        {
          adult: false,
          gender: 0,
          id: 2387416,
          known_for_department: 'Diễn viên',
          name: 'Ailín Zaninovich',
          original_name: 'Ailín Zaninovich',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pq3IC8w1Kw8xeGdQLX38BZscnzS.jpg',
          cast_id: 15,
          character: 'Florencia',
          credit_id: '5d548ca4a135330013fb5122',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 1109925,
          known_for_department: 'Diễn viên',
          name: 'Luciano Cazaux',
          original_name: 'Luciano Cazaux',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vl5GWCsWmES6q8BOUnLCcwSvzz1.jpg',
          cast_id: 16,
          character: 'Alvarado',
          credit_id: '5d548d9eb76cbb38f4d8352b',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 2369505,
          known_for_department: 'Directing',
          name: 'Federico Berón',
          original_name: 'Federico Berón',
          popularity: 0.6,
          profile_path: null,
          cast_id: 33,
          character: 'Cliente',
          credit_id: '601293dacb8028003f0d0d32',
          order: 13,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 16941,
          known_for_department: 'Production',
          name: 'Fernando Bovaira',
          original_name: 'Fernando Bovaira',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d601af8924ce5314714b45b',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 26269,
          known_for_department: 'Production',
          name: 'Simón de Santiago',
          original_name: 'Simón de Santiago',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d601b079d6e330014b2ad4c',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 45546,
          known_for_department: 'Sound',
          name: 'Federico Jusid',
          original_name: 'Federico Jusid',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gK4EkeVqDvxuIMlNZB1SZSaGIFS.jpg',
          credit_id: '5d601a3b9d6e330018b2acd3',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 56220,
          known_for_department: 'Camera',
          name: 'Rolo Pulpeiro',
          original_name: 'Rolo Pulpeiro',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d601a55a894d609af9bc0bb',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 69310,
          known_for_department: 'Diễn viên',
          name: 'Ricardo Darín',
          original_name: 'Ricardo Darín',
          popularity: 1.661,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cbS6prSUDcA8pE9CJp84FBZg8aJ.jpg',
          credit_id: '5d601abaa894d66ff99acafe',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 81157,
          known_for_department: 'Directing',
          name: 'Sebastián Borensztein',
          original_name: 'Sebastián Borensztein',
          popularity: 1.38,
          profile_path:
            'https://image.tmdb.org/t/p/w185/h1GnmI7tP3WpQTxLojdugOWDPlg.jpg',
          credit_id: '5d601a95a894d609af9bc0ec',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 81157,
          known_for_department: 'Directing',
          name: 'Sebastián Borensztein',
          original_name: 'Sebastián Borensztein',
          popularity: 1.38,
          profile_path:
            'https://image.tmdb.org/t/p/w185/h1GnmI7tP3WpQTxLojdugOWDPlg.jpg',
          credit_id: '5cb94016c3a3683abf847ecf',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 93651,
          known_for_department: 'Biên kịch',
          name: 'Eduardo Sacheri',
          original_name: 'Eduardo Sacheri',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5cb940309251410671f345ce',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 0,
          id: 557732,
          known_for_department: 'Production',
          name: 'Hugo Sigman',
          original_name: 'Hugo Sigman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d601aaea894d643299ab69c',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 938781,
          known_for_department: 'Production',
          name: 'Axel Kuschevatzky',
          original_name: 'Axel Kuschevatzky',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1JTLhOFZKvgcVe4Irt81xw2RsO4.jpg',
          credit_id: '618958ede93e95008e96a567',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1061576,
          known_for_department: 'Directing',
          name: 'Daniel Gimelberg',
          original_name: 'Daniel Gimelberg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d601a7f924ce5183014e0c6',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1147902,
          known_for_department: 'Production',
          name: 'Federico Posternak',
          original_name: 'Federico Posternak',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d601ae39d6e330014b2ad37',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1152449,
          known_for_department: 'Editing',
          name: 'Alejandro Carrillo Penovi',
          original_name: 'Alejandro Carrillo Penovi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d601a45924ce54c7d14ca7a',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1308586,
          known_for_department: 'Diễn viên',
          name: 'Chino Darín',
          original_name: 'Chino Darín',
          popularity: 2.097,
          profile_path:
            'https://image.tmdb.org/t/p/w185/f3oYgbZQPNH1P2Q55j4v4DdzZNu.jpg',
          credit_id: '5d601ad7ea37e0140075dc9e',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1310722,
          known_for_department: 'Production',
          name: 'Javier Braier',
          original_name: 'Javier Braier',
          popularity: 0.652,
          profile_path: null,
          credit_id: '5d601a65e375c000131c84af',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1310729,
          known_for_department: 'Production',
          name: 'Leticia Cristi',
          original_name: 'Leticia Cristi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d601aee9d6e330016b2acfc',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1310730,
          known_for_department: 'Production',
          name: 'Matías Mosteirín',
          original_name: 'Matías Mosteirín',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d601ac8e375c03edc1c539b',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2112433,
          known_for_department: 'Production',
          name: 'Micky Buyé',
          original_name: 'Micky Buyé',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d601a6f9d6e330018b2ace7',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2235600,
          known_for_department: 'Sound',
          name: 'Martín Porta',
          original_name: 'Martín Porta',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d601a9f9d6e330017b2acbe',
          department: 'Sound',
          job: 'Sound',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/izqnNQMlZWoGxs8RhX29Zs8Vign.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 53, name: 'Phim Gây Cấn' },
      { id: 9648, name: 'Phim Bí Ẩn' },
    ],
    homepage: 'http://www.momentumpictures.net/looking-glass',
    id: 437375,
    imdb_id: 'tt6083648',
    original_language: 'en',
    original_title: 'Looking Glass',
    overview:
      'Vợ chồng Maggie và Ray quyết định mua lại một nhà nghỉ bỏ hoang để lập nghiệp ở vùng đất mới. Nhưng mỗi lần nhìn vào tấm gương dưới tầng hầm, Ray lại thấy những cảnh tượng kỳ lạ diễn ra trong căn phòng số 10. Không tin vào hiện tượng ma quỷ, Ray quyết tâm tìm ra sự thật để lật tẩy kẻ ám hại mình nhưng mọi việc không hề suôn sẻ như anh nghĩ…',
    popularity: 11.53,
    poster_path:
      'https://image.tmdb.org/t/p/w342/6zSzaUmoUCwII2pGTqX1jaX8F0p.jpg',
    production_companies: [
      {
        id: 95598,
        logo_path: null,
        name: 'Kirk Shaw Productions',
        origin_country: '',
      },
      { id: 40797, logo_path: null, name: 'Prettybird', origin_country: '' },
      {
        id: 49969,
        logo_path: null,
        name: 'Silver State Production Services',
        origin_country: '',
      },
      {
        id: 104639,
        logo_path: null,
        name: 'DTLV Cinema Society',
        origin_country: '',
      },
      {
        id: 104674,
        logo_path: null,
        name: 'Goldfinch Australia',
        origin_country: '',
      },
      {
        id: 76991,
        logo_path: '/pQjdvbv4y9yuIDSHDEHc9ijJKaS.png',
        name: 'Highland Film Group',
        origin_country: 'US',
      },
    ],
    production_countries: [
      { iso_3166_1: 'US', name: 'Hoa Kì' },
      { iso_3166_1: 'CA', name: 'Canada' },
    ],
    release_date: '2018-02-16',
    revenue: 0,
    runtime: 103,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'Seeing is deceiving',
    title: 'Bí Ẩn Sau Tấm Gương',
    video: false,
    vote_average: 4.7,
    vote_count: 214,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Looking Glass - Official Trailer',
          key: 'Y9jPUvijVa4',
          published_at: '2018-01-25T17:00:07.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '5a7562ef92514105a602cb38',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 2963,
          known_for_department: 'Diễn viên',
          name: 'Nicolas Cage',
          original_name: 'Nicolas Cage',
          popularity: 15.753,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ar33qcWbEgREn07ZpXv5Pbj8hbM.jpg',
          cast_id: 0,
          character: 'Ray',
          credit_id: '5889c33fc3a36819ce003722',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 17346,
          known_for_department: 'Diễn viên',
          name: 'Robin Tunney',
          original_name: 'Robin Tunney',
          popularity: 7.425,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vOmWyYNoVEaPPvoto4IW8dSXn7I.jpg',
          cast_id: 5,
          character: 'Maggie',
          credit_id: '5a66c7860e0a26194e0055e3',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 46772,
          known_for_department: 'Diễn viên',
          name: 'Marc Blucas',
          original_name: 'Marc Blucas',
          popularity: 4.168,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mk0YeUWkMsFKzJ8wFHsEXuGd2KK.jpg',
          cast_id: 6,
          character: 'Howard',
          credit_id: '5a66c791c3a3680cff005cda',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 59184,
          known_for_department: 'Diễn viên',
          name: 'Ernie Lively',
          original_name: 'Ernie Lively',
          popularity: 1.309,
          profile_path:
            'https://image.tmdb.org/t/p/w185/guIP10XZFN7p6UF6DiP3neSEifP.jpg',
          cast_id: 7,
          character: 'Tommy',
          credit_id: '5a75631fc3a36859fc0313ac',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 114930,
          known_for_department: 'Diễn viên',
          name: 'Jacque Gray',
          original_name: 'Jacque Gray',
          popularity: 2.779,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qaEmLACxeoo638nBUIsCKYEeQch.jpg',
          cast_id: 8,
          character: "Jessica 'Room 6'",
          credit_id: '5a75631f0e0a26642702ff6c',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 105649,
          known_for_department: 'Diễn viên',
          name: 'Bill Bolender',
          original_name: 'Bill Bolender',
          popularity: 1.817,
          profile_path:
            'https://image.tmdb.org/t/p/w185/x300IuivwmdtuEY1V52cAoprlBV.jpg',
          cast_id: 9,
          character: 'Ben',
          credit_id: '5a7563200e0a266433030552',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 1971391,
          known_for_department: 'Diễn viên',
          name: 'Barry Jay Minoff',
          original_name: 'Barry Jay Minoff',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5RQa6JJ4VzLD7SfVAztKvaRm7cu.jpg',
          cast_id: 10,
          character: 'Gas Station Owner',
          credit_id: '5a756320925141059402caac',
          order: 7,
        },
        {
          adult: false,
          gender: 1,
          id: 1971909,
          known_for_department: 'Diễn viên',
          name: 'Kassia Conway',
          original_name: 'Kassia Conway',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kF6kEMbwqstP1oydeuqpacQkse5.jpg',
          cast_id: 11,
          character: 'Cassie the Strawberry Blonde',
          credit_id: '5a756320925141059c02bf07',
          order: 8,
        },
        {
          adult: false,
          gender: 0,
          id: 1338033,
          known_for_department: 'Diễn viên',
          name: 'Jason K Wixom',
          original_name: 'Jason K Wixom',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9drVxzEyP3T3oOibGJHBzCtb2KG.jpg',
          cast_id: 12,
          character: 'Gas Station Mechanic',
          credit_id: '5a7563210e0a266433030554',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 277634,
          known_for_department: 'Diễn viên',
          name: 'Sila Agavale',
          original_name: 'Sila Agavale',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yGmr4BKKyMMJo10KOAnmXwZSZgm.jpg',
          cast_id: 13,
          character: 'Detective',
          credit_id: '5a7563210e0a26642702ff6f',
          order: 10,
        },
        {
          adult: false,
          gender: 1,
          id: 1971910,
          known_for_department: 'Diễn viên',
          name: 'Kimmy Jimenez',
          original_name: 'Kimmy Jimenez',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7NSQ7yyFdT5ET2BdbRaPPgVneBB.jpg',
          cast_id: 14,
          character: 'Becky',
          credit_id: '5a756321c3a3686b5100583e',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 1971911,
          known_for_department: 'Diễn viên',
          name: 'Pascoalina Dunham',
          original_name: 'Pascoalina Dunham',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iKORh6eBgUaLDDjJQ9wUIz1FBk2.jpg',
          cast_id: 15,
          character: 'Ava',
          credit_id: '5a756322c3a36859cf02b92a',
          order: 12,
        },
        {
          adult: false,
          gender: 0,
          id: 2154857,
          known_for_department: 'Diễn viên',
          name: 'Atticus Worman-Pope',
          original_name: 'Atticus Worman-Pope',
          popularity: 0.6,
          profile_path: null,
          cast_id: 59,
          character: 'Trina',
          credit_id: '5bca524ec3a368407f01a834',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 1029840,
          known_for_department: 'Diễn viên',
          name: 'Clint Vanderlinden',
          original_name: 'Clint Vanderlinden',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/f0unAFZRdGgecZGAosQg127JvVi.jpg',
          cast_id: 60,
          character: 'Crewcut',
          credit_id: '5bca539d0e0a260fc801b22e',
          order: 14,
        },
        {
          adult: false,
          gender: 0,
          id: 2154862,
          known_for_department: 'Diễn viên',
          name: 'Michael Christian',
          original_name: 'Michael Christian',
          popularity: 0.6,
          profile_path: null,
          cast_id: 61,
          character: 'Bartender',
          credit_id: '5bca54eb9251415627018ea4',
          order: 15,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 3278,
          known_for_department: 'Sound',
          name: 'Mark Adler',
          original_name: 'Mark Adler',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/g31rIHaTBeK0xHHMezl7NwmzYtP.jpg',
          credit_id: '5afd878dc3a36841b6006abb',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 2,
          id: 3956,
          known_for_department: 'Production',
          name: 'Henry Winterstern',
          original_name: 'Henry Winterstern',
          popularity: 1.094,
          profile_path: null,
          credit_id: '5b0f30bcc3a368623c000cb3',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 15858,
          known_for_department: 'Directing',
          name: 'Tim Hunter',
          original_name: 'Tim Hunter',
          popularity: 2.134,
          profile_path:
            'https://image.tmdb.org/t/p/w185/n03G1gCKqxpi6udwINygNiLoGdn.jpg',
          credit_id: '5a66c76e0e0a26195100570d',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 50101,
          known_for_department: 'Camera',
          name: 'Patrick Cady',
          original_name: 'Patrick Cady',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd87d10e0a266efe004c9b',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 108741,
          known_for_department: 'Production',
          name: 'Robert Milo Andrus',
          original_name: 'Robert Milo Andrus',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8d550e0a266f11004ee7',
          department: 'Production',
          job: 'Casting Associate',
        },
        {
          adult: false,
          gender: 1,
          id: 134451,
          known_for_department: 'Production',
          name: 'Arianne Fraser',
          original_name: 'Arianne Fraser',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eJPvHgWatmQgho5KBNPVAE1uKH1.jpg',
          credit_id: '5b0f2fd6c3a368622400037a',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 959314,
          known_for_department: 'Production',
          name: 'Braxton Pope',
          original_name: 'Braxton Pope',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8748925141269a00463c',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1047702,
          known_for_department: 'Camera',
          name: 'Anka Malatynska',
          original_name: 'Anka Malatynska',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5afd8b57c3a36841b6006daf',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1138365,
          known_for_department: 'Biên kịch',
          name: 'Jerry Rapp',
          original_name: 'Jerry Rapp',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5889c392925141553e0038b8',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 1150952,
          known_for_department: 'Production',
          name: 'David M. Wulf',
          original_name: 'David M. Wulf',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8772c3a36841cc003c1d',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1178650,
          known_for_department: 'Crew',
          name: 'Wray Featherstone',
          original_name: 'Wray Featherstone',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd89cdc3a36841b30077c8',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 2,
          id: 1194303,
          known_for_department: 'Camera',
          name: 'B.J. Iwen',
          original_name: 'B.J. Iwen',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pkuC0KG5Hrub2v08semx5yEzSHT.jpg',
          credit_id: '5afd8cd90e0a266ef4004e9c',
          department: 'Camera',
          job: 'First Assistant "C" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1308215,
          known_for_department: 'Camera',
          name: 'Mary Boregino',
          original_name: 'Mary Boregino',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8c47c3a36841b3007a06',
          department: 'Camera',
          job: 'First Assistant "A" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1315259,
          known_for_department: 'Lighting',
          name: 'Phil Shepherd',
          original_name: 'Phil Shepherd',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8d3d9251412686004e3d',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1324018,
          known_for_department: 'Art',
          name: 'Christopher R. DeMuri',
          original_name: 'Christopher R. DeMuri',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8813c3a36841b900543e',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1377740,
          known_for_department: 'Biên kịch',
          name: 'Matthew Wilder',
          original_name: 'Matthew Wilder',
          popularity: 1.531,
          profile_path: null,
          credit_id: '5889c3bc925141533b0040d7',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 1394715,
          known_for_department: 'Art',
          name: 'Scott Ruley',
          original_name: 'Scott Ruley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8826c3a36841b3007621',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 1394715,
          known_for_department: 'Art',
          name: 'Scott Ruley',
          original_name: 'Scott Ruley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd89b3c3a36841bf0061dc',
          department: 'Art',
          job: 'Leadman',
        },
        {
          adult: false,
          gender: 0,
          id: 1413833,
          known_for_department: 'Costume & Make-Up',
          name: 'Abigail Steele',
          original_name: 'Abigail Steele',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd88fdc3a36841b30076d7',
          department: 'Costume & Make-Up',
          job: 'Makeup & Hair',
        },
        {
          adult: false,
          gender: 2,
          id: 1435190,
          known_for_department: 'Sound',
          name: 'Kyle Rochlin',
          original_name: 'Kyle Rochlin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8a270e0a266f020050a9',
          department: 'Sound',
          job: 'Foley Mixer',
        },
        {
          adult: false,
          gender: 1,
          id: 1464310,
          known_for_department: 'Crew',
          name: 'Eliza Coleman',
          original_name: 'Eliza Coleman',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wb7sr5O0WVADFsOUiC8hzekhDmd.jpg',
          credit_id: '5afd8aa99251412659004c95',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1532327,
          known_for_department: 'Costume & Make-Up',
          name: 'Lora Laing',
          original_name: 'Lora Laing',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd88ac9251412652005180',
          department: 'Costume & Make-Up',
          job: 'Key Hair Stylist',
        },
        {
          adult: false,
          gender: 2,
          id: 1651750,
          known_for_department: 'Camera',
          name: 'Michael Marius Pessah',
          original_name: 'Michael Marius Pessah',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vSUnDOrhEJhiIAdgdtl5x4dECti.jpg',
          credit_id: '5afd8be20e0a266f17004c16',
          department: 'Camera',
          job: 'Additional Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 1657567,
          known_for_department: 'Sound',
          name: 'Kreigh Carter',
          original_name: 'Kreigh Carter',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8a0fc3a36841b0004fc1',
          department: 'Sound',
          job: 'Boom Operator',
        },
        {
          adult: false,
          gender: 1,
          id: 1699523,
          known_for_department: 'Editing',
          name: 'Kristi Shimek',
          original_name: 'Kristi Shimek',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qZrIuFfxZuVZd2VBuI7DkagJAUA.jpg',
          credit_id: '5afd87fac3a36841b0004eba',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1712033,
          known_for_department: 'Camera',
          name: 'Jed Seus',
          original_name: 'Jed Seus',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8b2b925141265f004258',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1718638,
          known_for_department: 'Camera',
          name: "David 'D.R.' Rhineer",
          original_name: "David 'D.R.' Rhineer",
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8c63c3a36841aa003c12',
          department: 'Camera',
          job: 'First Assistant "A" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1902003,
          known_for_department: 'Crew',
          name: 'Ryan Roundy',
          original_name: 'Ryan Roundy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8a899251412659004c60',
          department: 'Visual Effects',
          job: 'Special Effects Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1932108,
          known_for_department: 'Directing',
          name: 'Melissa Yount',
          original_name: 'Melissa Yount',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8dc40e0a266ef6005632',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1965873,
          known_for_department: 'Costume & Make-Up',
          name: 'Heather Gaither',
          original_name: 'Heather Gaither',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd88730e0a266f14005075',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 0,
          id: 2020998,
          known_for_department: 'Art',
          name: 'Ashley Cook',
          original_name: 'Ashley Cook',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8939c3a36841b300772a',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2044587,
          known_for_department: 'Sound',
          name: 'Kristin Gundred',
          original_name: 'Kristin Gundred',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd879f0e0a266efa005232',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 0,
          id: 2044589,
          known_for_department: 'Directing',
          name: 'Brent Geisler',
          original_name: 'Brent Geisler',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd891f92514126d3004c75',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2044590,
          known_for_department: 'Art',
          name: 'Dillon Ellefson',
          original_name: 'Dillon Ellefson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8998c3a36841cf005bb0',
          department: 'Art',
          job: 'Construction Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2044591,
          known_for_department: 'Art',
          name: 'Chelsea Carl',
          original_name: 'Chelsea Carl',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd89f0c3a36841bc004e71',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2044592,
          known_for_department: 'Sound',
          name: 'Antony Metaxakis',
          original_name: 'Antony Metaxakis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8a45c3a36841cf005c4e',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2044593,
          known_for_department: 'Sound',
          name: 'Joe Sanchez',
          original_name: 'Joe Sanchez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8a709251412656005525',
          department: 'Sound',
          job: 'Sound Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 2044594,
          known_for_department: 'Crew',
          name: 'Corbett McAllister',
          original_name: 'Corbett McAllister',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8ad5c3a36841cf005ce7',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 0,
          id: 2044595,
          known_for_department: 'Camera',
          name: 'R. Derek Keener',
          original_name: 'R. Derek Keener',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8b6c92514126ef005fab',
          department: 'Camera',
          job: 'Steadicam Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 2044597,
          known_for_department: 'Camera',
          name: 'Andy Baker',
          original_name: 'Andy Baker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8c2c9251412686004d9d',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2044599,
          known_for_department: 'Camera',
          name: 'Kevin Woodward',
          original_name: 'Kevin Woodward',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8cfb0e0a266efa00557b',
          department: 'Camera',
          job: 'Key Grip',
        },
        {
          adult: false,
          gender: 2,
          id: 2044600,
          known_for_department: 'Lighting',
          name: 'Kealii Johnson',
          original_name: 'Kealii Johnson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8d24c3a36841cf005e60',
          department: 'Lighting',
          job: 'Best Boy Electric',
        },
        {
          adult: false,
          gender: 0,
          id: 2044602,
          known_for_department: 'Production',
          name: 'Terry Prather',
          original_name: 'Terry Prather',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8d809251412670005a2a',
          department: 'Production',
          job: 'Extras Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 2044603,
          known_for_department: 'Costume & Make-Up',
          name: 'Crystal Puckett',
          original_name: 'Crystal Puckett',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5afd8d97925141269a00496a',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2054139,
          known_for_department: 'Production',
          name: 'Delphine Perrier',
          original_name: 'Delphine Perrier',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b0f3099c3a3686236000a67',
          department: 'Production',
          job: 'Executive Producer',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'Gimly',
          author_details: {
            name: 'Gimly',
            username: 'Ruuz',
            avatar_path: '/xUObnJSvHrFPsIpoDmb1jiQZLq7.jpg',
            rating: 4.0,
          },
          content:
            "It's nice to see Cage get through a movie without doing the thing he usually does, but _Looking Glass_ is pretty much a non-event.\r\n\r\n_Final rating:★★ - Had some things that appeal to me, but a poor finished product._",
          created_at: '2018-05-15T10:22:46.668Z',
          id: '5afab4f6c3a3680e8600c766',
          updated_at: '2021-06-23T15:58:08.698Z',
          url: 'https://www.themoviedb.org/review/5afab4f6c3a3680e8600c766',
        },
        {
          author: 'r96sk',
          author_details: {
            name: '',
            username: 'r96sk',
            avatar_path:
              '/https://secure.gravatar.com/avatar/96c2e0e4ac98450f9e8e3c0a0a40aad8.jpg',
            rating: 7.0,
          },
          content:
            "Nothing anywhere near perfect, or even super logical, but I still enjoyed watching <em>'Looking Glass'</em>.\r\n\r\nIt builds up the tension and darkness well, with the ghost town feel to everything. The cinematography, particularly the lighting, is rather nice. The premise and its execution, while intriguing, does have problems, but the two leads are fun to watch.\r\n\r\nNicolas Cage (Ray) and Robin Tunney (Maggie) make for a good pairing, both give satisfactory performances. Marc Blucas is, I thought anyway, pretty decent in his role as Howard; though the Biên kịch does let his character down. Other negatives for the film include the average music and crappy opening credits.\r\n\r\nOverall though, I felt suitably entertained by this.",
          created_at: '2020-10-15T16:45:47.195Z',
          id: '5f887cbb3103250037f0e4b5',
          updated_at: '2021-06-23T15:58:46.112Z',
          url: 'https://www.themoviedb.org/review/5f887cbb3103250037f0e4b5',
        },
      ],
      total_pages: 1,
      total_results: 2,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/sXcNY6rFQ8s5He8YqWjUuEYDhY2.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 10749, name: 'Phim Lãng Mạn' },
      { id: 53, name: 'Phim Gây Cấn' },
    ],
    homepage: '',
    id: 30301,
    imdb_id: 'tt0267261',
    original_language: 'it',
    original_title: 'Senso 45',
    overview:
      "Thiên Thần Sa Đọa - Senso '45 / Black Angel (2002) là một bộ phim thuộc thể loại 18+ Ãu Mỹ của đạo diễn nổi tiếng chuyên làm phim cấp 3 Tinto Brass với sự tham gia của các diễn viên Anna Galiena, Gabriel Garko, Franco Branciaroli... Nội dung phim được chuyển thể dựa trên tiểu thuyết của nhà văn Camillo Boito, ngoài ra kịch bản còn được đạo diễn góp ý vào một chút. Bối cảnh phim xoay quanh câu chuyện tình trong bí mật của Livia Mazzion, một người vợ xinh đẹp của Bộ Trưởng nhưng lại có tình cảm với anh chàng trung úy đang đi theo chồng của mình.",
    popularity: 6.304,
    poster_path:
      'https://image.tmdb.org/t/p/w342/nIarbeqivH4XK9oNBZ1h81Hx3RA.jpg',
    production_companies: [
      { id: 4817, logo_path: null, name: 'Cine 2000', origin_country: '' },
    ],
    production_countries: [{ iso_3166_1: 'IT', name: 'Italy' }],
    release_date: '2002-04-12',
    revenue: 0,
    runtime: 128,
    spoken_languages: [
      { english_name: 'Italian', iso_639_1: 'it', name: 'Italiano' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Thiên Thần Sa Đọa',
    video: false,
    vote_average: 5.5,
    vote_count: 36,
    videos: { results: [] },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 27391,
          known_for_department: 'Diễn viên',
          name: 'Anna Galiena',
          original_name: 'Anna Galiena',
          popularity: 1.564,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iOCkbd0PmIvy1EcZbIE3g6zXdsH.jpg',
          cast_id: 3,
          character: 'Livia Mazzoni',
          credit_id: '52fe440b9251416c91002fb9',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 90318,
          known_for_department: 'Diễn viên',
          name: 'Gabriel Garko',
          original_name: 'Gabriel Garko',
          popularity: 2.048,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1cjSWW3DKNPZDnR2uGnk5Xs69A2.jpg',
          cast_id: 4,
          character: 'Helmut Schultz',
          credit_id: '52fe440b9251416c91002fbd',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 137354,
          known_for_department: 'Diễn viên',
          name: 'Franco Branciaroli',
          original_name: 'Franco Branciaroli',
          popularity: 2.569,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kEQuxqA2Sl0ZmxUs5Yg21SY8iFj.jpg',
          cast_id: 5,
          character: 'Ugo Oggiano',
          credit_id: '52fe440b9251416c91002fc1',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 123548,
          known_for_department: 'Diễn viên',
          name: 'Antonio Salines',
          original_name: 'Antonio Salines',
          popularity: 2.084,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nLz6lePlHNQ7WDT9mRN8MTJ1BnB.jpg',
          cast_id: 10,
          character: 'Carlo',
          credit_id: '5966625b9251410a5912a606',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 130537,
          known_for_department: 'Diễn viên',
          name: 'Simona Borioni',
          original_name: 'Simona Borioni',
          popularity: 1.05,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8TrSva97ctEpploCricVbZFtreg.jpg',
          cast_id: 11,
          character: 'Elsa',
          credit_id: '59666265925141790408efcf',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 557004,
          known_for_department: 'Diễn viên',
          name: 'Loredana Cannata',
          original_name: 'Loredana Cannata',
          popularity: 1.884,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xI5koYqdbmaFRJV0KbzRhG9FKV8.jpg',
          cast_id: 12,
          character: 'Ninetta',
          credit_id: '596662729251415a400fd9a2',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 1524024,
          known_for_department: 'Diễn viên',
          name: 'Erika Savastani',
          original_name: 'Erika Savastani',
          popularity: 2.607,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ubQo2EjCXKpqyrNdff0mFtnEzA3.jpg',
          cast_id: 13,
          character: 'Emilietta',
          credit_id: '596662799251410c561218d2',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 1058102,
          known_for_department: 'Diễn viên',
          name: 'Sabrina Colle',
          original_name: 'Sabrina Colle',
          popularity: 1.094,
          profile_path: null,
          cast_id: 14,
          character: '',
          credit_id: '5966627f925141225110b5f4',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 1850038,
          known_for_department: 'Diễn viên',
          name: 'Agostino Nani',
          original_name: 'Agostino Nani',
          popularity: 0.6,
          profile_path: null,
          cast_id: 15,
          character: '',
          credit_id: '59666284c3a36828fc111ed1',
          order: 8,
        },
        {
          adult: false,
          gender: 1,
          id: 1850039,
          known_for_department: 'Diễn viên',
          name: 'Giulia De Gresy',
          original_name: 'Giulia De Gresy',
          popularity: 1.4,
          profile_path: null,
          cast_id: 16,
          character: '',
          credit_id: '5966628b9251410a5912a63f',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 67149,
          known_for_department: 'Diễn viên',
          name: 'Franco Barbero',
          original_name: 'Franco Barbero',
          popularity: 1.094,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yFkMDFduKwIsPooR1CGeX0sh6dw.jpg',
          cast_id: 17,
          character: '',
          credit_id: '596662919251410b8612f52a',
          order: 10,
        },
        {
          adult: false,
          gender: 1,
          id: 128749,
          known_for_department: 'Diễn viên',
          name: 'Eleonora Mazzoni',
          original_name: 'Eleonora Mazzoni',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rNGxrKcSU0nWu2zBneuJ7GonUhB.jpg',
          cast_id: 18,
          character: '',
          credit_id: '59666298c3a3680dec108899',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 1850040,
          known_for_department: 'Diễn viên',
          name: 'Ciro Scalera',
          original_name: 'Ciro Scalera',
          popularity: 0.6,
          profile_path: null,
          cast_id: 19,
          character: '',
          credit_id: '5966629e9251410bfa134045',
          order: 12,
        },
        {
          adult: false,
          gender: 1,
          id: 1453995,
          known_for_department: 'Diễn viên',
          name: 'Maria Pia Colonnello',
          original_name: 'Maria Pia Colonnello',
          popularity: 0.6,
          profile_path: null,
          cast_id: 20,
          character: '',
          credit_id: '596662a5c3a368265d12599f',
          order: 13,
        },
        {
          adult: false,
          gender: 1,
          id: 1850043,
          known_for_department: 'Diễn viên',
          name: 'Alessia Siniscalchi',
          original_name: 'Alessia Siniscalchi',
          popularity: 0.6,
          profile_path: null,
          cast_id: 22,
          character: '',
          credit_id: '596662b2c3a36828a114a31f',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 1452442,
          known_for_department: 'Diễn viên',
          name: 'Maurizio Prudenzi',
          original_name: 'Maurizio Prudenzi',
          popularity: 0.6,
          profile_path: null,
          cast_id: 23,
          character: '',
          credit_id: '596662b8c3a3680dec1088c6',
          order: 16,
        },
        {
          adult: false,
          gender: 1,
          id: 1850044,
          known_for_department: 'Diễn viên',
          name: 'Conchita Manfroi',
          original_name: 'Conchita Manfroi',
          popularity: 0.6,
          profile_path: null,
          cast_id: 24,
          character: '',
          credit_id: '596662c092514121f01107c2',
          order: 17,
        },
        {
          adult: false,
          gender: 1,
          id: 1850046,
          known_for_department: 'Diễn viên',
          name: 'Lele Masiol',
          original_name: 'Lele Masiol',
          popularity: 0.6,
          profile_path: null,
          cast_id: 25,
          character: '',
          credit_id: '596662c5c3a36828fc111f30',
          order: 18,
        },
        {
          adult: false,
          gender: 1,
          id: 1850047,
          known_for_department: 'Diễn viên',
          name: 'Giorgia Reberschack',
          original_name: 'Giorgia Reberschack',
          popularity: 0.6,
          profile_path: null,
          cast_id: 26,
          character: '',
          credit_id: '596662cdc3a36828fc111f3d',
          order: 19,
        },
        {
          adult: false,
          gender: 1,
          id: 1850050,
          known_for_department: 'Diễn viên',
          name: 'Marina Pegoraro',
          original_name: 'Marina Pegoraro',
          popularity: 0.6,
          profile_path: null,
          cast_id: 28,
          character: '',
          credit_id: '596662dbc3a368265d1259fc',
          order: 21,
        },
        {
          adult: false,
          gender: 2,
          id: 1850051,
          known_for_department: 'Diễn viên',
          name: 'Giuseppe Rossetto',
          original_name: 'Giuseppe Rossetto',
          popularity: 0.6,
          profile_path: null,
          cast_id: 29,
          character: '',
          credit_id: '596662e49251410bfa1340a7',
          order: 22,
        },
        {
          adult: false,
          gender: 1,
          id: 1524034,
          known_for_department: 'Diễn viên',
          name: 'Susanna Bugatti',
          original_name: 'Susanna Bugatti',
          popularity: 1.128,
          profile_path: null,
          cast_id: 30,
          character: '',
          credit_id: '596662eac3a368265d125a14',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 1850053,
          known_for_department: 'Diễn viên',
          name: 'Gianluca Magni',
          original_name: 'Gianluca Magni',
          popularity: 0.6,
          profile_path: null,
          cast_id: 31,
          character: '',
          credit_id: '596662f19251410a5912a6e5',
          order: 24,
        },
        {
          adult: false,
          gender: 1,
          id: 1321903,
          known_for_department: 'Production',
          name: 'Francesca Tosetti',
          original_name: 'Francesca Tosetti',
          popularity: 0.6,
          profile_path: null,
          cast_id: 32,
          character: '',
          credit_id: '596662f7c3a368253c10e29c',
          order: 25,
        },
        {
          adult: false,
          gender: 2,
          id: 30887,
          known_for_department: 'Biên kịch',
          name: 'Mario Francini',
          original_name: 'Mario Francini',
          popularity: 0.6,
          profile_path: null,
          cast_id: 33,
          character: '',
          credit_id: '596662fc9251410bfa1340c3',
          order: 26,
        },
        {
          adult: false,
          gender: 1,
          id: 1850054,
          known_for_department: 'Diễn viên',
          name: 'Lucrezia Andreotti',
          original_name: 'Lucrezia Andreotti',
          popularity: 0.6,
          profile_path: null,
          cast_id: 34,
          character: '',
          credit_id: '59666302925141225110b6c5',
          order: 27,
        },
        {
          adult: false,
          gender: 2,
          id: 1524031,
          known_for_department: 'Diễn viên',
          name: 'Gianni Demartiis',
          original_name: 'Gianni Demartiis',
          popularity: 0.6,
          profile_path: null,
          cast_id: 35,
          character: '',
          credit_id: '59666313925141790408f0c1',
          order: 28,
        },
        {
          adult: false,
          gender: 1,
          id: 1850055,
          known_for_department: 'Diễn viên',
          name: 'Martina Andreotti',
          original_name: 'Martina Andreotti',
          popularity: 0.6,
          profile_path: null,
          cast_id: 36,
          character: '',
          credit_id: '59666318c3a3680dec108959',
          order: 29,
        },
        {
          adult: false,
          gender: 2,
          id: 1850057,
          known_for_department: 'Diễn viên',
          name: 'Lorenzo Vitturi',
          original_name: 'Lorenzo Vitturi',
          popularity: 0.6,
          profile_path: null,
          cast_id: 37,
          character: '',
          credit_id: '5966631d92514121f0110842',
          order: 30,
        },
        {
          adult: false,
          gender: 1,
          id: 1850058,
          known_for_department: 'Diễn viên',
          name: 'Isabel Vitturi',
          original_name: 'Isabel Vitturi',
          popularity: 0.6,
          profile_path: null,
          cast_id: 38,
          character: '',
          credit_id: '596663229251415a400fda8b',
          order: 31,
        },
        {
          adult: false,
          gender: 2,
          id: 1850059,
          known_for_department: 'Diễn viên',
          name: 'Alberto Garbizza',
          original_name: 'Alberto Garbizza',
          popularity: 0.6,
          profile_path: null,
          cast_id: 39,
          character: '',
          credit_id: '596663289251410b8612f5fb',
          order: 32,
        },
        {
          adult: false,
          gender: 1,
          id: 1280051,
          known_for_department: 'Diễn viên',
          name: 'Jasmine',
          original_name: 'Jasmine',
          popularity: 0.6,
          profile_path: null,
          cast_id: 40,
          character: '',
          credit_id: '596663379251410bfa134113',
          order: 33,
        },
        {
          adult: false,
          gender: 2,
          id: 136411,
          known_for_department: 'Diễn viên',
          name: 'Osiride Pevarello',
          original_name: 'Osiride Pevarello',
          popularity: 0.656,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cGqwkE5y6xR56wpSAlNOgcql1pS.jpg',
          cast_id: 41,
          character: '',
          credit_id: '5966633c92514121f0110873',
          order: 34,
        },
        {
          adult: false,
          gender: 1,
          id: 936941,
          known_for_department: 'Diễn viên',
          name: 'Carla Solaro',
          original_name: 'Carla Solaro',
          popularity: 2.952,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1OW7XCY84jBlU3qr89wOjUKLXaj.jpg',
          cast_id: 42,
          character: '',
          credit_id: '59666341c3a368253c10e30c',
          order: 35,
        },
        {
          adult: false,
          gender: 1,
          id: 1850062,
          known_for_department: 'Diễn viên',
          name: 'Madame X',
          original_name: 'Madame X',
          popularity: 0.6,
          profile_path: null,
          cast_id: 44,
          character: '',
          credit_id: '59666355c3a368265d125aa3',
          order: 37,
        },
        {
          adult: false,
          gender: 1,
          id: 1850065,
          known_for_department: 'Diễn viên',
          name: 'Monica Del Pup',
          original_name: 'Monica Del Pup',
          popularity: 0.6,
          profile_path: null,
          cast_id: 46,
          character: '',
          credit_id: '59666361c3a3680dec1089b7',
          order: 39,
        },
        {
          adult: false,
          gender: 2,
          id: 1850067,
          known_for_department: 'Diễn viên',
          name: 'Claudio Castana',
          original_name: 'Claudio Castana',
          popularity: 0.6,
          profile_path: null,
          cast_id: 47,
          character: '',
          credit_id: '59666369c3a36828fc112014',
          order: 40,
        },
        {
          adult: false,
          gender: 1,
          id: 1850070,
          known_for_department: 'Diễn viên',
          name: 'Michela Fruet',
          original_name: 'Michela Fruet',
          popularity: 0.6,
          profile_path: null,
          cast_id: 48,
          character: '',
          credit_id: '59666370c3a368265d125ac9',
          order: 41,
        },
        {
          adult: false,
          gender: 2,
          id: 1452446,
          known_for_department: 'Art',
          name: 'Carlo De Marino',
          original_name: 'Carlo De Marino',
          popularity: 0.6,
          profile_path: null,
          cast_id: 49,
          character: '',
          credit_id: '596663799251410b8612f68e',
          order: 42,
        },
        {
          adult: false,
          gender: 1,
          id: 1850072,
          known_for_department: 'Diễn viên',
          name: 'Maria Grazia Morelli',
          original_name: 'Maria Grazia Morelli',
          popularity: 0.6,
          profile_path: null,
          cast_id: 50,
          character: '',
          credit_id: '59666389925141225110b792',
          order: 43,
        },
        {
          adult: false,
          gender: 2,
          id: 1850073,
          known_for_department: 'Diễn viên',
          name: 'Tony Leone',
          original_name: 'Tony Leone',
          popularity: 0.6,
          profile_path: null,
          cast_id: 51,
          character: '',
          credit_id: '5966638fc3a3680dec108a16',
          order: 44,
        },
        {
          adult: false,
          gender: 1,
          id: 1850075,
          known_for_department: 'Diễn viên',
          name: 'Silvana Archiapatti',
          original_name: 'Silvana Archiapatti',
          popularity: 0.6,
          profile_path: null,
          cast_id: 52,
          character: '',
          credit_id: '59666394c3a3680d5910678d',
          order: 45,
        },
        {
          adult: false,
          gender: 2,
          id: 1850076,
          known_for_department: 'Diễn viên',
          name: 'Massimo Sangalli',
          original_name: 'Massimo Sangalli',
          popularity: 0.6,
          profile_path: null,
          cast_id: 53,
          character: '',
          credit_id: '59666399c3a368253c10e387',
          order: 46,
        },
        {
          adult: false,
          gender: 1,
          id: 1850077,
          known_for_department: 'Diễn viên',
          name: 'Ivana Fontanabona',
          original_name: 'Ivana Fontanabona',
          popularity: 0.6,
          profile_path: null,
          cast_id: 54,
          character: '',
          credit_id: '5966639f9251410c56121a6c',
          order: 47,
        },
        {
          adult: false,
          gender: 2,
          id: 1850079,
          known_for_department: 'Diễn viên',
          name: 'Filippo Belletti',
          original_name: 'Filippo Belletti',
          popularity: 0.6,
          profile_path: null,
          cast_id: 55,
          character: '',
          credit_id: '596663a6c3a3680dec108a45',
          order: 48,
        },
        {
          adult: false,
          gender: 1,
          id: 1850080,
          known_for_department: 'Diễn viên',
          name: 'Francesca Piovesan',
          original_name: 'Francesca Piovesan',
          popularity: 0.6,
          profile_path: null,
          cast_id: 56,
          character: '',
          credit_id: '596663ac9251410b8612f6da',
          order: 49,
        },
        {
          adult: false,
          gender: 2,
          id: 45580,
          known_for_department: 'Diễn viên',
          name: 'Massimo Vanni',
          original_name: 'Massimo Vanni',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fKlNOSVbHQVcECQVjp3Q7EAtYwz.jpg',
          cast_id: 57,
          character: '',
          credit_id: '596663b4c3a3680dec108a57',
          order: 50,
        },
        {
          adult: false,
          gender: 1,
          id: 1850082,
          known_for_department: 'Diễn viên',
          name: 'Emanuela Del Zampo',
          original_name: 'Emanuela Del Zampo',
          popularity: 0.6,
          profile_path: null,
          cast_id: 58,
          character: '',
          credit_id: '596663bbc3a36828a114a49f',
          order: 51,
        },
        {
          adult: false,
          gender: 2,
          id: 1850083,
          known_for_department: 'Diễn viên',
          name: "Milko D'Angelo",
          original_name: "Milko D'Angelo",
          popularity: 0.6,
          profile_path: null,
          cast_id: 59,
          character: '',
          credit_id: '596663c19251410bfa1341dd',
          order: 52,
        },
        {
          adult: false,
          gender: 1,
          id: 1850084,
          known_for_department: 'Diễn viên',
          name: 'Silvia Demili',
          original_name: 'Silvia Demili',
          popularity: 0.6,
          profile_path: null,
          cast_id: 60,
          character: '',
          credit_id: '596663c79251410c56121aa7',
          order: 53,
        },
        {
          adult: false,
          gender: 2,
          id: 1850085,
          known_for_department: 'Diễn viên',
          name: 'Paolo Signora',
          original_name: 'Paolo Signora',
          popularity: 0.6,
          profile_path: null,
          cast_id: 61,
          character: '',
          credit_id: '596663cd925141225110b7f3',
          order: 54,
        },
        {
          adult: false,
          gender: 1,
          id: 1850086,
          known_for_department: 'Diễn viên',
          name: 'Camilla Ahluvist',
          original_name: 'Camilla Ahluvist',
          popularity: 0.6,
          profile_path: null,
          cast_id: 62,
          character: '',
          credit_id: '596663d392514121f0110948',
          order: 55,
        },
        {
          adult: false,
          gender: 2,
          id: 1850087,
          known_for_department: 'Diễn viên',
          name: 'Jacopo Molina',
          original_name: 'Jacopo Molina',
          popularity: 0.6,
          profile_path: null,
          cast_id: 63,
          character: '',
          credit_id: '596663d89251415a400fdb9b',
          order: 56,
        },
        {
          adult: false,
          gender: 2,
          id: 1850088,
          known_for_department: 'Diễn viên',
          name: 'Lorenzo Branchetti',
          original_name: 'Lorenzo Branchetti',
          popularity: 0.6,
          profile_path: null,
          cast_id: 64,
          character: 'Soldato',
          credit_id: '596663e2c3a36828a114a4d7',
          order: 57,
        },
        {
          adult: false,
          gender: 2,
          id: 1530990,
          known_for_department: 'Diễn viên',
          name: 'Lucas Di Medio',
          original_name: 'Lucas Di Medio',
          popularity: 0.6,
          profile_path: null,
          cast_id: 65,
          character: 'SS officer',
          credit_id: '596663eac3a3680dec108aac',
          order: 58,
        },
        {
          adult: false,
          gender: 2,
          id: 1761055,
          known_for_department: 'Diễn viên',
          name: 'Danilo Maria Valli',
          original_name: 'Danilo Maria Valli',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/x7Ju4hTpHlyovGTTifMxKMlus6y.jpg',
          cast_id: 66,
          character: '',
          credit_id: '596663f2925141225110b823',
          order: 59,
        },
        {
          adult: false,
          gender: 2,
          id: 58021,
          known_for_department: 'Directing',
          name: 'Tinto Brass',
          original_name: 'Tinto Brass',
          popularity: 6.403,
          profile_path:
            'https://image.tmdb.org/t/p/w185/80Uuq79rcYL1FgBPHAEHzAACQFa.jpg',
          cast_id: 67,
          character: '',
          credit_id: '596663fc925141790408f1ec',
          order: 60,
        },
        {
          adult: true,
          gender: 2,
          id: 44503,
          known_for_department: 'Biên kịch',
          name: 'Claudio Bernabei',
          original_name: 'Claudio Bernabei',
          popularity: 0.6,
          profile_path: null,
          cast_id: 68,
          character: '',
          credit_id: '596667e79251410bfa1347f5',
          order: 61,
        },
        {
          adult: true,
          gender: 2,
          id: 133648,
          known_for_department: 'Diễn viên',
          name: 'Roberto Malone',
          original_name: 'Roberto Malone',
          popularity: 5.27,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ocGJFGlNONsLBNkwtTHu2zz0EhK.jpg',
          cast_id: 69,
          character: '',
          credit_id: '59666a229251410bfa134b12',
          order: 62,
        },
        {
          adult: false,
          gender: 2,
          id: 1185610,
          known_for_department: 'Diễn viên',
          name: 'Hermann Weiskopf',
          original_name: 'Hermann Weiskopf',
          popularity: 0.6,
          profile_path: null,
          cast_id: 70,
          character: '',
          credit_id: '59666a6c9251410c56122342',
          order: 63,
        },
        {
          adult: true,
          gender: 2,
          id: 141115,
          known_for_department: 'Diễn viên',
          name: 'Max Parodi',
          original_name: 'Max Parodi',
          popularity: 1.115,
          profile_path:
            'https://image.tmdb.org/t/p/w185/s3HSLVuPbScPNOhhhcdKQEDmYv9.jpg',
          cast_id: 71,
          character: '',
          credit_id: '5a05b6aa9251417dfd019bd5',
          order: 64,
        },
        {
          adult: false,
          gender: 0,
          id: 1862643,
          known_for_department: 'Diễn viên',
          name: 'Francesco Forte',
          original_name: 'Francesco Forte',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5npEnR84vwXaf2jyyXhBZ16hfGs.jpg',
          cast_id: 74,
          character: 'Trenino',
          credit_id: '5ff001f1ecc7e8003f1437cd',
          order: 65,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 1259,
          known_for_department: 'Sound',
          name: 'Ennio Morricone',
          original_name: 'Ennio Morricone',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/avjgzi45bdXgC1AtyNsRc5nxtFM.jpg',
          credit_id: '5b785c23925141295f0168f1',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: true,
          gender: 2,
          id: 44503,
          known_for_department: 'Biên kịch',
          name: 'Claudio Bernabei',
          original_name: 'Claudio Bernabei',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b785c349251412957013be7',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 2,
          id: 58021,
          known_for_department: 'Directing',
          name: 'Tinto Brass',
          original_name: 'Tinto Brass',
          popularity: 6.403,
          profile_path:
            'https://image.tmdb.org/t/p/w185/80Uuq79rcYL1FgBPHAEHzAACQFa.jpg',
          credit_id: '52fe440a9251416c91002fb5',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 58021,
          known_for_department: 'Directing',
          name: 'Tinto Brass',
          original_name: 'Tinto Brass',
          popularity: 6.403,
          profile_path:
            'https://image.tmdb.org/t/p/w185/80Uuq79rcYL1FgBPHAEHzAACQFa.jpg',
          credit_id: '5966623ac3a36828fc111e66',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 58021,
          known_for_department: 'Directing',
          name: 'Tinto Brass',
          original_name: 'Tinto Brass',
          popularity: 6.403,
          profile_path:
            'https://image.tmdb.org/t/p/w185/80Uuq79rcYL1FgBPHAEHzAACQFa.jpg',
          credit_id: '59666230c3a368265d1258f3',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 106026,
          known_for_department: 'Biên kịch',
          name: 'Camillo Boito',
          original_name: 'Camillo Boito',
          popularity: 0.6,
          profile_path: null,
          credit_id: '596662279251410b8612f484',
          department: 'Biên kịch',
          job: 'Novel',
        },
        {
          adult: false,
          gender: 2,
          id: 1452446,
          known_for_department: 'Art',
          name: 'Carlo De Marino',
          original_name: 'Carlo De Marino',
          popularity: 0.6,
          profile_path: null,
          credit_id: '596662439251410c5612188d',
          department: 'Art',
          job: 'Art Direction',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/fRMpmzN4GdLRDrADukxHtuyioqB.jpg',
    belongs_to_collection: {
      id: 94039,
      name: 'Asterix and Obelix (Animation) Collection',
      poster_path: '/mJ85mdtrQl2LWTNAHHcSJC55dcs.jpg',
      backdrop_path: '/f0mc4ObY75CrFzOYGNGiHXjgKGz.jpg',
    },
    budget: 0,
    genres: [
      { id: 10751, name: 'Phim Gia Đình' },
      { id: 16, name: 'Phim Hoạt Hình' },
      { id: 35, name: 'Phim Hài' },
      { id: 12, name: 'Phim Phiêu Lưu' },
    ],
    homepage: '',
    id: 9385,
    imdb_id: 'tt0072901',
    original_language: 'fr',
    original_title: "Les 12 travaux d'Astérix",
    overview:
      'Sau khi trưởng làng nhận lời chịu 12 công việc mà Caesar thách thức để chứng minh người Gaul có phải là thần hay không, Asterix, Obelix được cả làng cử làm đại diện đương đầu với 12 thử thách đó.',
    popularity: 10.13,
    poster_path:
      'https://image.tmdb.org/t/p/w342/8P85y0rqTpT6oKeQ5MKIBf75XsQ.jpg',
    production_companies: [
      {
        id: 7964,
        logo_path: '/facxCmKiPTdHnKmxQhl71KtOO1d.png',
        name: 'Studios Idéfix',
        origin_country: 'FR',
      },
      {
        id: 5851,
        logo_path: null,
        name: 'Dargaud Films',
        origin_country: 'FR',
      },
      {
        id: 7963,
        logo_path: null,
        name: 'Les Productions René Goscinny',
        origin_country: '',
      },
    ],
    production_countries: [{ iso_3166_1: 'FR', name: 'France' }],
    release_date: '1976-06-26',
    revenue: 0,
    runtime: 82,
    spoken_languages: [
      { english_name: 'French', iso_639_1: 'fr', name: 'Français' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Mười Hai Thử Thách Của Asterix',
    video: false,
    vote_average: 7.4,
    vote_count: 876,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Homemade trailer for The 12 Tasks of Asterix',
          key: '1WVGszqwkkI',
          published_at: '2008-12-20T01:56:53.000Z',
          site: 'YouTube',
          size: 360,
          type: 'Trailer',
          official: false,
          id: '533ec665c3a36854480015e9',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 34676,
          known_for_department: 'Diễn viên',
          name: 'Roger Carel',
          original_name: 'Roger Carel',
          popularity: 0.76,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hEcbRZd9Utcrav9oCBtnsXzg1NL.jpg',
          cast_id: 1,
          character: 'Astérix / Caius Pupus / Idéfix / deux sénateurs',
          credit_id: '52fe44f0c3a36847f80b3083',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 57540,
          known_for_department: 'Diễn viên',
          name: 'Jacques Morel',
          original_name: 'Jacques Morel',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tXmF78bTeOC4SNFoTsusQxzSuYr.jpg',
          cast_id: 3,
          character: 'Obélix / l’employé sur sa balançoire',
          credit_id: '52fe44f0c3a36847f80b3087',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 57541,
          known_for_department: 'Diễn viên',
          name: 'Henri Labussière',
          original_name: 'Henri Labussière',
          popularity: 1.728,
          profile_path:
            'https://image.tmdb.org/t/p/w185/l1FlZHNvlL95ZeMdNKMWOatmKNA.jpg',
          cast_id: 4,
          character: 'L’huissier de la maison qui rend fou',
          credit_id: '52fe44f0c3a36847f80b308b',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 5185,
          known_for_department: 'Diễn viên',
          name: 'Jean Martinelli',
          original_name: 'Jean Martinelli',
          popularity: 0.992,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lDyifogyrchOeStey3zgsuVNg4s.jpg',
          cast_id: 5,
          character: 'Jules César / Jupiter',
          credit_id: '52fe44f0c3a36847f80b308f',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 589521,
          known_for_department: 'Diễn viên',
          name: 'Pierre Tornade',
          original_name: 'Pierre Tornade',
          popularity: 1.447,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mOHqoHM3QdoH9xq6UXeQs6SG4TE.jpg',
          cast_id: 18,
          character: 'Abraracourcix / Assurancetourix',
          credit_id: '52fe44f0c3a36847f80b30db',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 48417,
          known_for_department: 'Diễn viên',
          name: 'Roger Lumont',
          original_name: 'Roger Lumont',
          popularity: 0.766,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ziJQtP0tYua77eJdLRfoJ2lPPiB.jpg',
          cast_id: 19,
          character: 'Cylindrique le Germain (voice)',
          credit_id: '5d0e923dc3a36828e61fa9b5',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 131380,
          known_for_department: 'Diễn viên',
          name: 'Gérard Hernandez',
          original_name: 'Gérard Hernandez',
          popularity: 0.77,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uTFlCgZva7PMNCIRHnbTvJKbXKb.jpg',
          cast_id: 20,
          character: 'Le vénérable du sommet (voice)',
          credit_id: '5d0e93040e0a263dddcf2571',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 39098,
          known_for_department: 'Diễn viên',
          name: 'Henri Virlogeux',
          original_name: 'Henri Virlogeux',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cDNnWUqs3CPrHisXtQB82KQEB0n.jpg',
          cast_id: 21,
          character: 'Panoramix / Iris / le décurion',
          credit_id: '5d0e931e9251413945bd510d',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 35885,
          known_for_department: 'Diễn viên',
          name: 'Bernard Lavalette',
          original_name: 'Bernard Lavalette',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lzkcbGht0iDaOJlzJWNFJahzVBR.jpg',
          cast_id: 22,
          character: 'Le préfet (voice)',
          credit_id: '5d0e936c0e0a263dddcf263c',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 60688,
          known_for_department: 'Diễn viên',
          name: 'Micheline Dax',
          original_name: 'Micheline Dax',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5tenvBWqABF4lJSZdBxuDwapDbn.jpg',
          cast_id: 23,
          character: 'La grande prêtresse / Cléopâtre',
          credit_id: '5d0e93a8c3a368063a233055',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 126232,
          known_for_department: 'Diễn viên',
          name: 'Claude Bertrand',
          original_name: 'Claude Bertrand',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wRgau8Uay7KdHBAZP7tYG5XDkGD.jpg',
          cast_id: 24,
          character: 'Un sénateur et le centurion (voice)',
          credit_id: '5d0e93fcc3a3681682237239',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 54384,
          known_for_department: 'Diễn viên',
          name: 'Georges Atlas',
          original_name: 'Georges Atlas',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5fXDvDIRm3N0fwzKkVlh67R4vEs.jpg',
          cast_id: 25,
          character: 'Le fantôme de la plaine des Trépassés / Cétautomatix',
          credit_id: '5d0e942f925141779dbb7378',
          order: 12,
        },
        {
          adult: false,
          gender: 0,
          id: 2345195,
          known_for_department: 'Diễn viên',
          name: 'Stéphane Steeman',
          original_name: 'Stéphane Steeman',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7uD7gXhtWwqzhyHuJrDYp9IdJdZ.jpg',
          cast_id: 26,
          character: 'Mannekenpix',
          credit_id: '5d0e948e9251412460b9cc5b',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 34630,
          known_for_department: 'Biên kịch',
          name: 'Pierre Tchernia',
          original_name: 'Pierre Tchernia',
          popularity: 1.018,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uW0WbE8SYZyp3DvdKRWPaf9imVa.jpg',
          cast_id: 27,
          character: 'Récitant / Narrator (voice)',
          credit_id: '5d0e98390e0a2602a1cc928a',
          order: 14,
        },
        {
          adult: false,
          gender: 1,
          id: 559677,
          known_for_department: 'Diễn viên',
          name: 'Odette Laure',
          original_name: 'Odette Laure',
          popularity: 1.38,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1Jq4KxYEJRnqzczsL7z1SMN80gA.jpg',
          cast_id: 28,
          character: '',
          credit_id: '5f26e2cb2d8ef30037dce767',
          order: 15,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 24530,
          known_for_department: 'Biên kịch',
          name: 'René Goscinny',
          original_name: 'René Goscinny',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nm4ZK0nE7eXvyaGBit4VQ3sdPij.jpg',
          credit_id: '52fe44f0c3a36847f80b30ad',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 24530,
          known_for_department: 'Biên kịch',
          name: 'René Goscinny',
          original_name: 'René Goscinny',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nm4ZK0nE7eXvyaGBit4VQ3sdPij.jpg',
          credit_id: '52fe44f0c3a36847f80b3095',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 24530,
          known_for_department: 'Biên kịch',
          name: 'René Goscinny',
          original_name: 'René Goscinny',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nm4ZK0nE7eXvyaGBit4VQ3sdPij.jpg',
          credit_id: '52fe44f0c3a36847f80b30c5',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 24531,
          known_for_department: 'Biên kịch',
          name: 'Albert Uderzo',
          original_name: 'Albert Uderzo',
          popularity: 0.828,
          profile_path:
            'https://image.tmdb.org/t/p/w185/l7oRGaeAIg8Z7s68FDUwd4WsQHe.jpg',
          credit_id: '52fe44f0c3a36847f80b30b3',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 24531,
          known_for_department: 'Biên kịch',
          name: 'Albert Uderzo',
          original_name: 'Albert Uderzo',
          popularity: 0.828,
          profile_path:
            'https://image.tmdb.org/t/p/w185/l7oRGaeAIg8Z7s68FDUwd4WsQHe.jpg',
          credit_id: '52fe44f0c3a36847f80b30a1',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 24531,
          known_for_department: 'Biên kịch',
          name: 'Albert Uderzo',
          original_name: 'Albert Uderzo',
          popularity: 0.828,
          profile_path:
            'https://image.tmdb.org/t/p/w185/l7oRGaeAIg8Z7s68FDUwd4WsQHe.jpg',
          credit_id: '52fe44f0c3a36847f80b30cb',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 34630,
          known_for_department: 'Biên kịch',
          name: 'Pierre Tchernia',
          original_name: 'Pierre Tchernia',
          popularity: 1.018,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uW0WbE8SYZyp3DvdKRWPaf9imVa.jpg',
          credit_id: '52fe44f0c3a36847f80b30b9',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 35373,
          known_for_department: 'Sound',
          name: 'Gérard Calvi',
          original_name: 'Gérard Calvi',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/w1ni4q75P3eSX15lRqo2Ap0VSSs.jpg',
          credit_id: '52fe44f0c3a36847f80b30d1',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 0,
          id: 57542,
          known_for_department: 'Directing',
          name: 'Henri Gruel',
          original_name: 'Henri Gruel',
          popularity: 0.98,
          profile_path: null,
          credit_id: '52fe44f0c3a36847f80b309b',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 57543,
          known_for_department: 'Directing',
          name: 'Pierre Watrin',
          original_name: 'Pierre Watrin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe44f0c3a36847f80b30a7',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 57544,
          known_for_department: 'Production',
          name: 'Georges Dargaud',
          original_name: 'Georges Dargaud',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe44f0c3a36847f80b30bf',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 57545,
          known_for_department: 'Editing',
          name: 'Pierre Biecher',
          original_name: 'Pierre Biecher',
          popularity: 0.728,
          profile_path: null,
          credit_id: '52fe44f0c3a36847f80b30d7',
          department: 'Editing',
          job: 'Editor',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/zy1laRytpaHGv5LTcU2xFh6KsGI.jpg',
    belongs_to_collection: {
      id: 148065,
      name: 'Phim Điện Ảnh Doraemon',
      poster_path: '/4TLSP1KD1uAlp2q1rTrc6SFlktX.jpg',
      backdrop_path: '/rc6OFcSasL5YxBRPUQVwxmVF6h5.jpg',
    },
    budget: 46597700,
    genres: [
      { id: 35, name: 'Phim Hài' },
      { id: 16, name: 'Phim Hoạt Hình' },
      { id: 10751, name: 'Phim Gia Đình' },
      { id: 12, name: 'Phim Phiêu Lưu' },
      { id: 878, name: 'Phim Khoa Học Viễn Tưởng' },
      { id: 14, name: 'Phim Giả Tượng' },
    ],
    homepage: 'http://doraeiga.com/2015',
    id: 350650,
    imdb_id: 'tt4788602',
    original_language: 'ja',
    original_title: '映画ドラえもん のび太の宇宙英雄記',
    overview:
      'Một ngày Doraemon, Nobita, Shizuka, Gian và Suneo quay một bộ phim về đề tài những anh hùng vũ trụ. Khi họ đang làm thì bất ngờ gặp một sinh vật ngoài sinh vật tên là Aron đang chạy trốn kẻ thù, thấy được sức mạnh của nhóm Aron đã nhờ cứu giúp hành tinh của cậu ấy khỏi những quái vật vũ trụ. Nhóm Nobita đồng ý và chiến đấu hết mình để giúp mặc dù chiến đấu với những quái vật ấy là không dễ dàng.',
    popularity: 17.909,
    poster_path:
      'https://image.tmdb.org/t/p/w342/bD9wR8bmZ9umrPx8IhBQ0GzGHFu.jpg',
    production_companies: [
      {
        id: 5141,
        logo_path: '/fK2QKfHdSdw42Xx4MiD7KhDufBV.png',
        name: 'Shin-Ei Animation',
        origin_country: 'JP',
      },
    ],
    production_countries: [{ iso_3166_1: 'JP', name: 'Nhật Bản' }],
    release_date: '2015-03-07',
    revenue: 32700000,
    runtime: 100,
    spoken_languages: [
      { english_name: 'Nhật Bảnese', iso_639_1: 'ja', name: '日本語' },
    ],
    status: 'Đã phát hành',
    tagline: 'Doraemon: Nobita và những hiệp sĩ không gian',
    title: 'Doraemon: Nobita và những hiệp sĩ không gian',
    video: false,
    vote_average: 6.3,
    vote_count: 42,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Doraemon Movie : Nobita and The Space Heroes - Indonesia Trailer',
          key: 'K08UTl2IBfk',
          published_at: '2015-06-16T04:53:29.000Z',
          site: 'YouTube',
          size: 720,
          type: 'Trailer',
          official: false,
          id: '55ae04d7c3a3682ffc00a43c',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 1241939,
          known_for_department: 'Diễn viên',
          name: 'Wasabi Mizuta',
          original_name: 'Wasabi Mizuta',
          popularity: 1.315,
          profile_path: null,
          cast_id: 2,
          character: 'Doraemon',
          credit_id: '589904e9925141646d000e56',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 932986,
          known_for_department: 'Diễn viên',
          name: 'Megumi Oohara',
          original_name: 'Megumi Oohara',
          popularity: 1.38,
          profile_path: null,
          cast_id: 3,
          character: 'Nobita Nobi',
          credit_id: '58990513925141647b000d11',
          order: 2,
        },
        {
          adult: false,
          gender: 0,
          id: 1752394,
          known_for_department: 'Diễn viên',
          name: 'Yumi Kazaku',
          original_name: 'Yumi Kazaku',
          popularity: 0.694,
          profile_path: null,
          cast_id: 4,
          character: 'Shizuka Minamoto',
          credit_id: '5899054ac3a36867c9000cec',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 1142780,
          known_for_department: 'Diễn viên',
          name: 'Subaru Kimura',
          original_name: 'Subaru Kimura',
          popularity: 6.149,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wDymxmTctOsEbRQPUXfAI9dOWFk.jpg',
          cast_id: 5,
          character: 'Takeshi "Gian" Goda',
          credit_id: '589905769251416472000dfb',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 90567,
          known_for_department: 'Diễn viên',
          name: 'Tomokazu Seki',
          original_name: 'Tomokazu Seki',
          popularity: 3.138,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4N6i4cgtbeUj5AJd8kiBZ2BxxEJ.jpg',
          cast_id: 6,
          character: 'Suneo Honekawa',
          credit_id: '5899059b9251416470000df8',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 89903,
          known_for_department: 'Diễn viên',
          name: 'Mamiko Noto',
          original_name: 'Mamiko Noto',
          popularity: 3.373,
          profile_path:
            'https://image.tmdb.org/t/p/w185/raDUy21NNUHKAM24OUcQMcp6kAJ.jpg',
          cast_id: 7,
          character: 'Burger Director',
          credit_id: '589905c1c3a36867ae000cb9',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 90135,
          known_for_department: 'Diễn viên',
          name: 'Marina Inoue',
          original_name: 'Marina Inoue',
          popularity: 5.309,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mLOmX3hKRMqwIyHKAvWrxSi1U0x.jpg',
          cast_id: 8,
          character: 'Aron',
          credit_id: '58990661c3a36867b6000dbb',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 1017105,
          known_for_department: 'Diễn viên',
          name: 'Yûji Tanaka',
          original_name: 'Yûji Tanaka',
          popularity: 0.694,
          profile_path: null,
          cast_id: 9,
          character: 'Hyde',
          credit_id: '5899067cc3a36867bd000d2d',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 1752400,
          known_for_department: 'Diễn viên',
          name: 'Yutaka Furukawa',
          original_name: 'Yutaka Furukawa',
          popularity: 0.6,
          profile_path: null,
          cast_id: 10,
          character: 'Ogon',
          credit_id: '589906b09251416476000dc3',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 1248542,
          known_for_department: 'Diễn viên',
          name: 'Arisa Mizuki',
          original_name: 'Arisa Mizuki',
          popularity: 2.111,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mmI8Oun7V0WqXEhhbMD0pVw6I8N.jpg',
          cast_id: 11,
          character: 'Meba',
          credit_id: '589907009251416467000d93',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 9717,
          known_for_department: 'Diễn viên',
          name: 'Masachika Ichimura',
          original_name: 'Masachika Ichimura',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5Nc3qemEM26pTff5bJ9KF7qdhGU.jpg',
          cast_id: 12,
          character: 'Ikaros',
          credit_id: '58990719c3a36867bd000d77',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 215919,
          known_for_department: 'Diễn viên',
          name: 'Motomu Kiyokawa',
          original_name: 'Motomu Kiyokawa',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uD3KFs95z5zuQrv9p5Q5UjUQBxw.jpg',
          cast_id: 13,
          character: 'Councilor',
          credit_id: '589907409251416476000e07',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 1247658,
          known_for_department: 'Diễn viên',
          name: 'Nobuyuki Kobushi',
          original_name: 'Nobuyuki Kobushi',
          popularity: 1.932,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lALDgD7y64P1IuONJqPFHkBaOcV.jpg',
          cast_id: 14,
          character: 'Secretary',
          credit_id: '5899075c9251416479000e3e',
          order: 13,
        },
        {
          adult: false,
          gender: 0,
          id: 1241491,
          known_for_department: 'Diễn viên',
          name: 'Nobuaki Sekine',
          original_name: 'Nobuaki Sekine',
          popularity: 0.6,
          profile_path: null,
          cast_id: 15,
          character: 'Grandpa',
          credit_id: '589907709251416476000e25',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 1247476,
          known_for_department: 'Diễn viên',
          name: 'Katsumi Toriumi',
          original_name: 'Katsumi Toriumi',
          popularity: 1.38,
          profile_path: null,
          cast_id: 16,
          character: 'Space Pirate Minion',
          credit_id: '5899078dc3a36867b1000e0d',
          order: 15,
        },
        {
          adult: false,
          gender: 0,
          id: 1752409,
          known_for_department: 'Diễn viên',
          name: 'Kenji Kitamura',
          original_name: 'Kenji Kitamura',
          popularity: 0.6,
          profile_path: null,
          cast_id: 17,
          character: 'Space Pirate Minion',
          credit_id: '589907a3c3a36867c3000eaf',
          order: 16,
        },
        {
          adult: false,
          gender: 1,
          id: 1752411,
          known_for_department: 'Diễn viên',
          name: 'Ai Fukada',
          original_name: 'Ai Fukada',
          popularity: 0.6,
          profile_path: null,
          cast_id: 18,
          character: 'Child',
          credit_id: '589907bfc3a36867c9000e1f',
          order: 17,
        },
        {
          adult: false,
          gender: 0,
          id: 1752413,
          known_for_department: 'Diễn viên',
          name: 'Tomomi Tenjinbayashii',
          original_name: 'Tomomi Tenjinbayashii',
          popularity: 0.6,
          profile_path: null,
          cast_id: 20,
          character: 'Child',
          credit_id: '589907e2c3a36867ae000d8a',
          order: 19,
        },
        {
          adult: false,
          gender: 0,
          id: 1752414,
          known_for_department: 'Diễn viên',
          name: 'Shiori Matsuda',
          original_name: 'Shiori Matsuda',
          popularity: 0.6,
          profile_path: null,
          cast_id: 21,
          character: 'Child',
          credit_id: '589907f0c3a36867ab000db7',
          order: 20,
        },
        {
          adult: false,
          gender: 1,
          id: 77931,
          known_for_department: 'Diễn viên',
          name: 'Kotono Mitsuishi',
          original_name: 'Kotono Mitsuishi',
          popularity: 3.811,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1kqWHBmMGEjdyySvRPjh4ZHAnrm.jpg',
          cast_id: 22,
          character: 'Tamako Nobi',
          credit_id: '58990803925141646d000fdb',
          order: 21,
        },
        {
          adult: false,
          gender: 1,
          id: 1252635,
          known_for_department: 'Diễn viên',
          name: 'Miyako Takeuchi',
          original_name: 'Miyako Takeuchi',
          popularity: 0.6,
          profile_path: null,
          cast_id: 23,
          character: "Gian's Mama",
          credit_id: '5899081ac3a36867c9000e46',
          order: 22,
        },
        {
          adult: false,
          gender: 1,
          id: 1357106,
          known_for_department: 'Diễn viên',
          name: 'Kanami Satou',
          original_name: 'Kanami Satou',
          popularity: 1.576,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wp5hYJOZZVabj8YQ4qutRCwYrOv.jpg',
          cast_id: 25,
          character: 'Child (voice)',
          credit_id: '5fd7f997a3770a0040a509dc',
          order: 23,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 0,
          id: 1489004,
          known_for_department: 'Directing',
          name: 'Yoshihiro Osugi',
          original_name: 'Yoshihiro Osugi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '55ae086a9251411e0f00a54a',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1489005,
          known_for_department: 'Biên kịch',
          name: 'Higashi Shimzu',
          original_name: 'Higashi Shimzu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '55ae087d9251411e0600a337',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 1615783,
          known_for_department: 'Visual Effects',
          name: 'Jin Kim',
          original_name: 'Jin Kim',
          popularity: 0.731,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yD5UpN5ieLZ8SJKqwaGYNlLcqbI.jpg',
          credit_id: '60e5f8424ca676007508d299',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 2034871,
          known_for_department: 'Art',
          name: 'Yuka Okamoto',
          original_name: 'Yuka Okamoto',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aea1f3c92514172b7000f9a',
          department: 'Art',
          job: 'Background Designer',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/askg3SMvhqEl4OL52YuvdtY40Yb.jpg',
    belongs_to_collection: null,
    budget: 175000000,
    genres: [
      { id: 10751, name: 'Phim Gia Đình' },
      { id: 16, name: 'Phim Hoạt Hình' },
      { id: 14, name: 'Phim Giả Tượng' },
      { id: 10402, name: 'Phim Nhạc' },
      { id: 35, name: 'Phim Hài' },
      { id: 12, name: 'Phim Phiêu Lưu' },
    ],
    homepage: 'https://www.pixar.com/feature-films/coco',
    id: 354912,
    imdb_id: 'tt2380307',
    original_language: 'en',
    original_title: 'Coco',
    overview:
      'Coco sẽ kể về hành trình của Miguel, một cậu bé say mê những giai điệu nhưng lại sinh trưởng trong một gia đình cấm đoán sự xuất hiện của âm nhạc. Miguel luôn nung nấu giấc mơ trở thành một nhạc sĩ nổi tiếng giống như thần tượng Ernesto de la Cruz. Tuy nhiên, truyền thống ngang trái của gia đình đã khiến cậu không thể chứng minh tài năng của mình.  Rũ bỏ thực tế phũ phàng, Miguel tìm thấy chính mình ở Vùng Đất Linh Hồn (Land of the Dead) tuyệt đẹp và đầy sắc màu sau một chuỗi sự kiện huyền bí. Trong hành trình khám phá vùng đất mới, Miguel gặp gỡ “chuyên gia xảo quyệt” Hector. Cả hai cùng tạo nên chuyến phiêu lưu kỳ diệu để lật mở những bí mật chưa được tiết lộ về lịch sử của gia đình Miguel.',
    popularity: 318.7,
    poster_path:
      'https://image.tmdb.org/t/p/w342/fhdzscFm7chtwWtZaean2HqVQcp.jpg',
    production_companies: [
      {
        id: 3,
        logo_path: '/1TjvGVDMYsj6JBxOAkUHpPEwLf7.png',
        name: 'Pixar',
        origin_country: 'US',
      },
      {
        id: 2,
        logo_path: '/wdrCwmRnLFJhEoH8GSfymY85KHT.png',
        name: 'Walt Disney Pictures',
        origin_country: 'US',
      },
    ],
    production_countries: [
      { iso_3166_1: 'MX', name: 'Mexico' },
      { iso_3166_1: 'US', name: 'Hoa Kì' },
    ],
    release_date: '2017-10-27',
    revenue: 800526015,
    runtime: 105,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
      { english_name: 'Spanish', iso_639_1: 'es', name: 'Español' },
    ],
    status: 'Đã phát hành',
    tagline: 'Coco',
    title: 'Coco: Hội Ngộ Diệu Kỳ',
    video: false,
    vote_average: 8.2,
    vote_count: 15003,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Coco (2017) Teaser',
          key: 'k4vVAbIm3hA',
          site: 'YouTube',
          size: 1080,
          type: 'Teaser',
          official: false,
          published_at: '2019-05-05T03:07:22.000Z',
          id: '5cce60410e0a262d7bfe78b9',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Coco (2017) Australian Trailer',
          key: '_TLXORFumu0',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: false,
          published_at: '2019-05-05T02:57:42.000Z',
          id: '5cce5fb8c3a36836b7df9dd5',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Anthony Gonzalez, Gael García Bernal - Un Poco Loco',
          key: 'yg8116aeD7E',
          published_at: '2017-12-21T18:00:06.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: false,
          id: '5a6510769251410b2102b70f',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Facts About Coco',
          key: 'dPw0J6Kaj04',
          published_at: '2017-12-08T23:31:19.000Z',
          site: 'YouTube',
          size: 480,
          type: 'Featurette',
          official: true,
          id: '5a6510ce9251410b2a02c42c',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Music of Coco',
          key: 'O7PUsrGUUh0',
          published_at: '2017-11-29T16:58:11.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Featurette',
          official: true,
          id: '5aefc4580e0a261d7a00bd2b',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Clean Up Your Act',
          key: 'n3umjh6xYok',
          published_at: '2017-11-22T20:53:58.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: true,
          id: '5a6510910e0a2619fb02f132',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Battle of the Bands',
          key: 'TO_CrQbRdbo',
          published_at: '2017-11-20T22:06:23.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: true,
          id: '5a6510050e0a261a0102e0f0',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'A Great, Great Rescue',
          key: 'KbsOT6-LjSs',
          published_at: '2017-11-10T17:47:39.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: true,
          id: '5aefc4cb0e0a261d8f00c4fd',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Not Like the Rest',
          key: 'di2bCDqa_Ro',
          published_at: '2017-11-09T20:32:07.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: true,
          id: '5a6510aa0e0a2619f802e519',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Anything to Declare?',
          key: 'upT1iqrxNBw',
          published_at: '2017-11-07T23:24:08.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: true,
          id: '5aefc55c925141768800dda9',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Official Final Trailer',
          key: 'Rvr68u6k5sI',
          published_at: '2017-11-06T17:00:02.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '5a650fa29251410b1f02c5f9',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Land of the Dead',
          key: 'yOvfedkA_JM',
          published_at: '2017-11-02T18:14:25.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: true,
          id: '5aefc52b925141765e00d242',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Mariachi Plaza',
          key: 'bFqeYK96JXc',
          published_at: '2017-10-17T19:00:05.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: true,
          id: '5aefc4f3c3a368140f0102f1',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Crafting Coco',
          key: '946WZKoMSlU',
          published_at: '2017-10-17T19:00:00.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Featurette',
          official: true,
          id: '5aefc3b40e0a261d8000d2d9',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Official US "Find Your Voice" Trailer',
          key: 'bvomHFZO0mk',
          published_at: '2017-09-13T16:00:07.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '5a313af40e0a264cca185ac7',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Official US Trailer',
          key: 'xlnPHQ3TLX8',
          published_at: '2017-06-07T23:30:01.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '5a313ad0c3a36814a8001415',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Official US Teaser Trailer',
          key: 'zNCz4mQzfEI',
          published_at: '2017-03-15T13:00:17.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Teaser',
          official: true,
          id: '5a313ab2c3a3680b9d1774a9',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 1193391,
          known_for_department: 'Diễn viên',
          name: 'Anthony Gonzalez',
          original_name: 'Anthony Gonzalez',
          popularity: 1.222,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3SfBmj35OfL8eVIQt9nTixWqVJH.jpg',
          cast_id: 5,
          character: 'Miguel Rivera (voice)',
          credit_id: '58631e14c3a36852c300619a',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 258,
          known_for_department: 'Diễn viên',
          name: 'Gael García Bernal',
          original_name: 'Gael García Bernal',
          popularity: 11.692,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7uEO29wtdyY9bjt2JN43gVpE6vt.jpg',
          cast_id: 3,
          character: 'Héctor (voice)',
          credit_id: '58631de49251413cd6001360',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 4589,
          known_for_department: 'Diễn viên',
          name: 'Benjamin Bratt',
          original_name: 'Benjamin Bratt',
          popularity: 6.419,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hBenHPT4iJEG2kt5z2TOGnkRZwh.jpg',
          cast_id: 1,
          character: 'Ernesto de la Cruz (voice)',
          credit_id: '57e774a4c3a368352100da73',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 10402,
          known_for_department: 'Diễn viên',
          name: 'Alanna Ubach',
          original_name: 'Alanna Ubach',
          popularity: 3.35,
          profile_path:
            'https://image.tmdb.org/t/p/w185/p2sIpgftEIkhPrrpgu8wW8XEpDg.jpg',
          cast_id: 7,
          character: 'Mamá Imelda Rivera (voice)',
          credit_id: '59392ec6925141088000fce6',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 154004,
          known_for_department: 'Diễn viên',
          name: 'Renée Victor',
          original_name: 'Renée Victor',
          popularity: 2.588,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wAVDqwFhQsRQgO6VIYq6T9Wbbx8.jpg',
          cast_id: 4,
          character: 'Elena Rivera (voice)',
          credit_id: '58631dfec3a3680ab60012ce',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 545087,
          known_for_department: 'Diễn viên',
          name: 'Jaime Camil',
          original_name: 'Jaime Camil',
          popularity: 3.004,
          profile_path:
            'https://image.tmdb.org/t/p/w185/o9sd2V9Sx1Be7w9RGTI9JbUo9rU.jpg',
          cast_id: 10,
          character: 'Papá Enrique Rivera (voice)',
          credit_id: '59392f0bc3a368783f00f2a0',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 22767,
          known_for_department: 'Diễn viên',
          name: 'Alfonso Aráu',
          original_name: 'Alfonso Aráu',
          popularity: 2.188,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5ishPim5akWXSnMbwOWSc3KxDx8.jpg',
          cast_id: 12,
          character: 'Papá Julio Rivera (voice)',
          credit_id: '59392f2a925141089500f736',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 178667,
          known_for_department: 'Diễn viên',
          name: 'Herbert Siguenza',
          original_name: 'Herbert Siguenza',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aVLX3sRMZp1qIfqCRHgjjy2NfGI.jpg',
          cast_id: 16,
          character: 'Tío Oscar Rivera / Tío Felipe Rivera (voice)',
          credit_id: '59392f89925141088e00fdf0',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 4992,
          known_for_department: 'Diễn viên',
          name: 'Lombardo Boyar',
          original_name: 'Lombardo Boyar',
          popularity: 1.78,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wwWs0u2QDz1XOakR05C0BYJCfM1.jpg',
          cast_id: 13,
          character: 'Mariachi / Gustavo (voice)',
          credit_id: '59392f3dc3a368784c00eb93',
          order: 8,
        },
        {
          adult: false,
          gender: 1,
          id: 1043869,
          known_for_department: 'Diễn viên',
          name: 'Ana Ofelia Murguía',
          original_name: 'Ana Ofelia Murguía',
          popularity: 2.943,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qQYHGoGs5hN5jfrIIYilU1Ki5AG.jpg',
          cast_id: 6,
          character: 'Mamá Socorro "Coco" Rivera (voice)',
          credit_id: '58dbe1ef92514133c900d995',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 1007527,
          known_for_department: 'Diễn viên',
          name: 'Sofía Espinosa',
          original_name: 'Sofía Espinosa',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iOwPSogxUHNWh3B0aIR1DuEW921.jpg',
          cast_id: 14,
          character: 'Mamá Luisa Rivera (voice)',
          credit_id: '59392f58925141088900f4c3',
          order: 10,
        },
        {
          adult: false,
          gender: 1,
          id: 104382,
          known_for_department: 'Diễn viên',
          name: 'Dyana Ortelli',
          original_name: 'Dyana Ortelli',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5ucJJBjifV9tEiVWnTLFy8OUrzF.jpg',
          cast_id: 45,
          character: 'Tía Victoria Rivera (voice)',
          credit_id: '5a2c6633c3a3680b9d131ca9',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 86498,
          known_for_department: 'Diễn viên',
          name: 'Gabriel Iglesias',
          original_name: 'Gabriel Iglesias',
          popularity: 3.365,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8Bjy3RZ5TfNs3oUOUpxTv84G01f.jpg',
          cast_id: 9,
          character: 'Head Clerk (voice)',
          credit_id: '59392efd925141088000fd1d',
          order: 12,
        },
        {
          adult: false,
          gender: 1,
          id: 48161,
          known_for_department: 'Diễn viên',
          name: 'Selene Luna',
          original_name: 'Selene Luna',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dBVo0kKrIQGk3aqFbKUsvJp4DcJ.jpg',
          cast_id: 17,
          character: 'Tía Rosita Rivera (voice)',
          credit_id: '59392f99925141088900f503',
          order: 13,
        },
        {
          adult: false,
          gender: 1,
          id: 1693947,
          known_for_department: 'Diễn viên',
          name: 'Natalia Córdova-Buckley',
          original_name: 'Natalia Córdova-Buckley',
          popularity: 2.879,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sWqzbY7xgw9dPhFQJOcging3QMu.jpg',
          cast_id: 49,
          character: 'Frida Kahlo (voice)',
          credit_id: '5a2c66cb0e0a264cc41393f5',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 587,
          known_for_department: 'Diễn viên',
          name: 'Edward James Olmos',
          original_name: 'Edward James Olmos',
          popularity: 3.35,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mXnilUrQBIMLHSQkPjQk99mX70x.jpg',
          cast_id: 8,
          character: 'Chicharrón (voice)',
          credit_id: '59392ed9925141088e00fd20',
          order: 15,
        },
        {
          adult: false,
          gender: 0,
          id: 1938082,
          known_for_department: 'Diễn viên',
          name: 'Carla Medina',
          original_name: 'Carla Medina',
          popularity: 0.6,
          profile_path: null,
          cast_id: 48,
          character: 'Departure Agent (voice)',
          credit_id: '5a2c66aec3a3680b93143730',
          order: 16,
        },
        {
          adult: false,
          gender: 2,
          id: 82219,
          known_for_department: 'Directing',
          name: 'Luis Valdez',
          original_name: 'Luis Valdez',
          popularity: 0.6,
          profile_path: null,
          cast_id: 15,
          character: 'Tío Berto Rivera / Don Hidalgo (voice)',
          credit_id: '59392f78925141089500f799',
          order: 17,
        },
        {
          adult: false,
          gender: 1,
          id: 1830409,
          known_for_department: 'Diễn viên',
          name: 'Blanca Araceli',
          original_name: 'Blanca Araceli',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kDm6OwatIx7WWGumIhPUmGu2J3v.jpg',
          cast_id: 18,
          character: 'Emcee (voice)',
          credit_id: '59392fb4c3a36878c500eec1',
          order: 18,
        },
        {
          adult: false,
          gender: 0,
          id: 1938081,
          known_for_department: 'Diễn viên',
          name: 'Polo Rojas',
          original_name: 'Polo Rojas',
          popularity: 0.6,
          profile_path: null,
          cast_id: 46,
          character: 'Abel Rivera (voice)',
          credit_id: '5a2c6678c3a3680b8f140611',
          order: 19,
        },
        {
          adult: false,
          gender: 0,
          id: 1450386,
          known_for_department: 'Diễn viên',
          name: 'Montse Hernandez',
          original_name: 'Montse Hernandez',
          popularity: 0.981,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mQ8tY2ji2fSBnkrKJAsIAxHTZUG.jpg',
          cast_id: 47,
          character: 'Rosa Rivera (voice)',
          credit_id: '5a2c66840e0a264cc41393c4',
          order: 20,
        },
        {
          adult: false,
          gender: 0,
          id: 1499749,
          known_for_department: 'Costume & Make-Up',
          name: 'Octavio Solis',
          original_name: 'Octavio Solis',
          popularity: 0.6,
          profile_path: null,
          cast_id: 19,
          character: 'Arrival Agent (voice)',
          credit_id: '59392fc4c3a368785a00fad0',
          order: 21,
        },
        {
          adult: false,
          gender: 2,
          id: 11159,
          known_for_department: 'Diễn viên',
          name: 'Cheech Marin',
          original_name: 'Cheech Marin',
          popularity: 3.894,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eecHDNRn9K80ZcuSocsMhQb2G1i.jpg',
          cast_id: 11,
          character: 'Corrections Officer (voice)',
          credit_id: '59392f1c925141088900f46f',
          order: 22,
        },
        {
          adult: false,
          gender: 0,
          id: 1496949,
          known_for_department: 'Diễn viên',
          name: 'Salvador Reyes',
          original_name: 'Salvador Reyes',
          popularity: 0.6,
          profile_path: null,
          cast_id: 50,
          character: 'Security Guard (voice)',
          credit_id: '5a2c66db925141032413e47f',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 7907,
          known_for_department: 'Diễn viên',
          name: 'John Ratzenberger',
          original_name: 'John Ratzenberger',
          popularity: 3.247,
          profile_path:
            'https://image.tmdb.org/t/p/w185/e5aNU09v1q6WYTx9pNzC7yjSpve.jpg',
          cast_id: 34,
          character: 'Juan Ortodoncia (voice)',
          credit_id: '5a18e6899251410326023eb7',
          order: 24,
        },
        {
          adult: false,
          gender: 0,
          id: 1938080,
          known_for_department: 'Diễn viên',
          name: 'Antonio Sol',
          original_name: 'Antonio Sol',
          popularity: 0.6,
          profile_path: null,
          cast_id: 44,
          character: 'Ernesto de la Cruz (singing voice)',
          credit_id: '5a2c66000e0a264cbe13deb1',
          order: 25,
        },
        {
          adult: false,
          gender: 0,
          id: 1765706,
          known_for_department: 'Diễn viên',
          name: 'Liliana Barba Meinecke',
          original_name: 'Liliana Barba Meinecke',
          popularity: 0.6,
          profile_path: null,
          cast_id: 207,
          character: 'Additional voices (voice)',
          credit_id: '5aaad0c8c3a3686c0e00410e',
          order: 26,
        },
        {
          adult: false,
          gender: 0,
          id: 1999025,
          known_for_department: 'Diễn viên',
          name: 'Emmanuel Bernal',
          original_name: 'Emmanuel Bernal',
          popularity: 0.6,
          profile_path: null,
          cast_id: 208,
          character: 'Additional voices (voice)',
          credit_id: '5aaad0dec3a3686c230041d2',
          order: 27,
        },
        {
          adult: false,
          gender: 2,
          id: 84172,
          known_for_department: 'Diễn viên',
          name: 'David Berón',
          original_name: 'David Berón',
          popularity: 0.6,
          profile_path: null,
          cast_id: 273,
          character: 'Additional voices (voice)',
          credit_id: '5cd08b030e0a2627aa01b82d',
          order: 28,
        },
        {
          adult: false,
          gender: 0,
          id: 1026727,
          known_for_department: 'Diễn viên',
          name: 'Denise Blasor',
          original_name: 'Denise Blasor',
          popularity: 0.6,
          profile_path: null,
          cast_id: 210,
          character: 'Additional voices (voice)',
          credit_id: '5aaad6a89251413feb0042ce',
          order: 29,
        },
        {
          adult: false,
          gender: 1,
          id: 1576334,
          known_for_department: 'Diễn viên',
          name: 'Wilma Bonet',
          original_name: 'Wilma Bonet',
          popularity: 0.6,
          profile_path: null,
          cast_id: 211,
          character: 'Additional voices (voice)',
          credit_id: '5aaad6eb0e0a261e4f004ba2',
          order: 30,
        },
        {
          adult: false,
          gender: 2,
          id: 1826627,
          known_for_department: 'Diễn viên',
          name: 'Alex Castillo',
          original_name: 'Alex Castillo',
          popularity: 1.38,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pJ0Ma1ePA9kncJpEIDYEaXGCbfo.jpg',
          cast_id: 212,
          character: 'Additional voices (voice)',
          credit_id: '5aaad7209251413fee00459f',
          order: 31,
        },
        {
          adult: false,
          gender: 1,
          id: 154884,
          known_for_department: 'Diễn viên',
          name: 'Vicki Davis',
          original_name: 'Vicki Davis',
          popularity: 1.535,
          profile_path:
            'https://image.tmdb.org/t/p/w185/USXMj1xQi3Qb7SeFNDqn4t6ipr.jpg',
          cast_id: 213,
          character: 'Additional voices (voice)',
          credit_id: '5aaad7369251413ff7004331',
          order: 32,
        },
        {
          adult: false,
          gender: 0,
          id: 1999034,
          known_for_department: 'Diễn viên',
          name: 'Daniel Diaz',
          original_name: 'Daniel Diaz',
          popularity: 0.6,
          profile_path: null,
          cast_id: 214,
          character: 'Additional voices (voice)',
          credit_id: '5aaad7b10e0a261e3f004e10',
          order: 33,
        },
        {
          adult: false,
          gender: 2,
          id: 1445775,
          known_for_department: 'Diễn viên',
          name: 'Roberto Donati',
          original_name: 'Roberto Donati',
          popularity: 0.6,
          profile_path: null,
          cast_id: 215,
          character: 'Additional voices (voice)',
          credit_id: '5aaad82d0e0a261e4f004d41',
          order: 34,
        },
        {
          adult: false,
          gender: 2,
          id: 168164,
          known_for_department: 'Diễn viên',
          name: 'Efrain Figueroa',
          original_name: 'Efrain Figueroa',
          popularity: 0.84,
          profile_path: null,
          cast_id: 216,
          character: 'Additional voices (voice)',
          credit_id: '5aaad8520e0a261e3f004ed0',
          order: 35,
        },
        {
          adult: false,
          gender: 0,
          id: 1999037,
          known_for_department: 'Diễn viên',
          name: 'Deb Fink',
          original_name: 'Deb Fink',
          popularity: 0.6,
          profile_path: null,
          cast_id: 217,
          character: 'Additional voices (voice)',
          credit_id: '5aaad8950e0a261e42005363',
          order: 36,
        },
        {
          adult: false,
          gender: 0,
          id: 1999038,
          known_for_department: 'Diễn viên',
          name: 'Libertad García Fonzi',
          original_name: 'Libertad García Fonzi',
          popularity: 0.6,
          profile_path: null,
          cast_id: 218,
          character: 'Additional voices (voice)',
          credit_id: '5aaad8c2c3a3686c23004d0c',
          order: 37,
        },
        {
          adult: false,
          gender: 0,
          id: 1999042,
          known_for_department: 'Diễn viên',
          name: 'Emilio Fuentes',
          original_name: 'Emilio Fuentes',
          popularity: 0.6,
          profile_path: null,
          cast_id: 219,
          character: 'Additional voices (voice)',
          credit_id: '5aaad916c3a3686c1c00448c',
          order: 38,
        },
        {
          adult: false,
          gender: 1,
          id: 552525,
          known_for_department: 'Diễn viên',
          name: 'Daniella Garcia-Lorido',
          original_name: 'Daniella Garcia-Lorido',
          popularity: 1.593,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6VL4FwEyioMAfSjlQHgE3sgHS5K.jpg',
          cast_id: 220,
          character: 'Additional voices (voice)',
          credit_id: '5aaad9540e0a261e490049bb',
          order: 39,
        },
        {
          adult: false,
          gender: 0,
          id: 1999047,
          known_for_department: 'Diễn viên',
          name: 'Mike Gomez',
          original_name: 'Mike Gomez',
          popularity: 0.98,
          profile_path: null,
          cast_id: 221,
          character: 'Additional voices (voice)',
          credit_id: '5aaad97b0e0a261e3f005028',
          order: 40,
        },
        {
          adult: false,
          gender: 0,
          id: 1445642,
          known_for_department: 'Diễn viên',
          name: 'Lillian Groag',
          original_name: 'Lillian Groag',
          popularity: 0.6,
          profile_path: null,
          cast_id: 222,
          character: 'Additional voices (voice)',
          credit_id: '5aaad9d09251413fee00486e',
          order: 41,
        },
        {
          adult: false,
          gender: 0,
          id: 1695206,
          known_for_department: 'Diễn viên',
          name: 'Joshua Guerrero',
          original_name: 'Joshua Guerrero',
          popularity: 0.6,
          profile_path: null,
          cast_id: 223,
          character: 'Additional voices (voice)',
          credit_id: '5aaada009251413fe50047f9',
          order: 42,
        },
        {
          adult: false,
          gender: 0,
          id: 1450386,
          known_for_department: 'Diễn viên',
          name: 'Montse Hernandez',
          original_name: 'Montse Hernandez',
          popularity: 0.981,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mQ8tY2ji2fSBnkrKJAsIAxHTZUG.jpg',
          cast_id: 224,
          character: 'Additional voices (voice)',
          credit_id: '5aaada170e0a261e3c004d44',
          order: 43,
        },
        {
          adult: false,
          gender: 1,
          id: 1999048,
          known_for_department: 'Diễn viên',
          name: 'Marabina Jaimes',
          original_name: 'Marabina Jaimes',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xhp7Hmz2kGjfLD7UUi2nLLypAjt.jpg',
          cast_id: 225,
          character: 'Additional voices (voice)',
          credit_id: '5aaada37c3a3686c1c004599',
          order: 44,
        },
        {
          adult: false,
          gender: 1,
          id: 167325,
          known_for_department: 'Diễn viên',
          name: 'Jossara Jinaro',
          original_name: 'Jossara Jinaro',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5CmkRjVhGFID9seW5cYNvP5U50.jpg',
          cast_id: 226,
          character: 'Additional voices (voice)',
          credit_id: '5aaada51c3a3686c16005128',
          order: 45,
        },
        {
          adult: false,
          gender: 0,
          id: 1552817,
          known_for_department: 'Diễn viên',
          name: 'Christian Lanz',
          original_name: 'Christian Lanz',
          popularity: 0.732,
          profile_path:
            'https://image.tmdb.org/t/p/w185/AlHIm3XUPLTMSDY1oNr6R3ah12s.jpg',
          cast_id: 227,
          character: 'Additional voices (voice)',
          credit_id: '5aaada760e0a261e4f004f85',
          order: 46,
        },
        {
          adult: false,
          gender: 0,
          id: 1999049,
          known_for_department: 'Diễn viên',
          name: 'Constanza Lechuga',
          original_name: 'Constanza Lechuga',
          popularity: 0.6,
          profile_path: null,
          cast_id: 228,
          character: 'Additional voices (voice)',
          credit_id: '5aaada820e0a261e4f004f93',
          order: 47,
        },
        {
          adult: false,
          gender: 1,
          id: 106800,
          known_for_department: 'Diễn viên',
          name: 'Luisa Leschin',
          original_name: 'Luisa Leschin',
          popularity: 1.022,
          profile_path: null,
          cast_id: 229,
          character: 'Additional voices (voice)',
          credit_id: '5aaadaabc3a3686c1c004613',
          order: 48,
        },
        {
          adult: false,
          gender: 1,
          id: 155868,
          known_for_department: 'Diễn viên',
          name: 'Ruth Livier',
          original_name: 'Ruth Livier',
          popularity: 0.6,
          profile_path: null,
          cast_id: 230,
          character: 'Additional voices (voice)',
          credit_id: '5aaadaca0e0a261e3f005161',
          order: 49,
        },
        {
          adult: false,
          gender: 0,
          id: 1998940,
          known_for_department: 'Sound',
          name: 'Maria Dominique Lopez',
          original_name: 'Maria Dominique Lopez',
          popularity: 0.6,
          profile_path: null,
          cast_id: 231,
          character: 'Additional voices (voice)',
          credit_id: '5aaadae59251413fe2004b38',
          order: 50,
        },
        {
          adult: false,
          gender: 1,
          id: 1035243,
          known_for_department: 'Diễn viên',
          name: 'Valeria Maldonado',
          original_name: 'Valeria Maldonado',
          popularity: 0.6,
          profile_path: null,
          cast_id: 232,
          character: 'Additional voices (voice)',
          credit_id: '5aaadb5b9251413ff7004703',
          order: 51,
        },
        {
          adult: false,
          gender: 2,
          id: 64448,
          known_for_department: 'Diễn viên',
          name: 'Richard Miro',
          original_name: 'Richard Miro',
          popularity: 0.98,
          profile_path: null,
          cast_id: 233,
          character: 'Additional voices (voice)',
          credit_id: '5aaadb699251413fee0049ba',
          order: 52,
        },
        {
          adult: false,
          gender: 2,
          id: 1684652,
          known_for_department: 'Biên kịch',
          name: 'Adrian Molina',
          original_name: 'Adrian Molina',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aFSYItLNBrY3zrPr69YqYwezj7D.jpg',
          cast_id: 234,
          character: 'Additional voices (voice)',
          credit_id: '5aaadb779251413feb004782',
          order: 53,
        },
        {
          adult: false,
          gender: 2,
          id: 170293,
          known_for_department: 'Diễn viên',
          name: 'Daniel Edward Mora',
          original_name: 'Daniel Edward Mora',
          popularity: 1.469,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dBpw47m3KN8wDzmWbumt3oZyEdI.jpg',
          cast_id: 235,
          character: 'Additional voices (voice)',
          credit_id: '5aaadb939251413fe8004c59',
          order: 54,
        },
        {
          adult: false,
          gender: 0,
          id: 1999051,
          known_for_department: 'Diễn viên',
          name: 'Vivianne Nacif',
          original_name: 'Vivianne Nacif',
          popularity: 0.694,
          profile_path: null,
          cast_id: 236,
          character: 'Additional voices (voice)',
          credit_id: '5aaadba09251413ff4004726',
          order: 55,
        },
        {
          adult: false,
          gender: 0,
          id: 1999052,
          known_for_department: 'Diễn viên',
          name: 'Adriana Sevahn Nichols',
          original_name: 'Adriana Sevahn Nichols',
          popularity: 0.6,
          profile_path: null,
          cast_id: 237,
          character: 'Additional voices (voice)',
          credit_id: '5aaadbb20e0a261e3c004e77',
          order: 56,
        },
        {
          adult: false,
          gender: 0,
          id: 1999053,
          known_for_department: 'Diễn viên',
          name: 'Jonathan Nichols',
          original_name: 'Jonathan Nichols',
          popularity: 0.6,
          profile_path: null,
          cast_id: 238,
          character: 'Additional voices (voice)',
          credit_id: '5aaadbdc0e0a261e4f0050ce',
          order: 57,
        },
        {
          adult: false,
          gender: 0,
          id: 1999054,
          known_for_department: 'Diễn viên',
          name: 'Arthur Ortiz',
          original_name: 'Arthur Ortiz',
          popularity: 1.094,
          profile_path: null,
          cast_id: 239,
          character: 'Additional voices (voice)',
          credit_id: '5aaadc130e0a261e420056c9',
          order: 58,
        },
        {
          adult: false,
          gender: 0,
          id: 1999055,
          known_for_department: 'Diễn viên',
          name: 'Jessica Pacheco',
          original_name: 'Jessica Pacheco',
          popularity: 0.6,
          profile_path: null,
          cast_id: 240,
          character: 'Additional voices (voice)',
          credit_id: '5aaadc229251413ff400478b',
          order: 59,
        },
        {
          adult: false,
          gender: 2,
          id: 1363155,
          known_for_department: 'Diễn viên',
          name: 'Juan Pacheco',
          original_name: 'Juan Pacheco',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ffXpriyG5QbmjCLmQ4boEjxc1ID.jpg',
          cast_id: 241,
          character: 'Additional voices (voice)',
          credit_id: '5aaadc56c3a3686c160052db',
          order: 60,
        },
        {
          adult: false,
          gender: 1,
          id: 146392,
          known_for_department: 'Diễn viên',
          name: 'Jacqueline Pinol',
          original_name: 'Jacqueline Pinol',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cqGFRdObF3UkMc3aTTA8fYSHQez.jpg',
          cast_id: 242,
          character: 'Additional voices (voice)',
          credit_id: '5aaadd310e0a261e46005146',
          order: 61,
        },
        {
          adult: false,
          gender: 0,
          id: 1999058,
          known_for_department: 'Diễn viên',
          name: 'James Ponce',
          original_name: 'James Ponce',
          popularity: 0.6,
          profile_path: null,
          cast_id: 243,
          character: 'Additional voices (voice)',
          credit_id: '5aaadd489251413feb0048ac',
          order: 62,
        },
        {
          adult: false,
          gender: 2,
          id: 1214171,
          known_for_department: 'Diễn viên',
          name: 'Al Rodrigo',
          original_name: 'Al Rodrigo',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kyQSlxHVnla3MfXzs2XhKCRHWMw.jpg',
          cast_id: 244,
          character: 'Additional voices (voice)',
          credit_id: '5aaadd59c3a3686c05004858',
          order: 63,
        },
        {
          adult: false,
          gender: 2,
          id: 1870481,
          known_for_department: 'Diễn viên',
          name: 'J. Francisco Rodriguez',
          original_name: 'J. Francisco Rodriguez',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4Qem01rtO9dynlbbVmxlZckBD7Q.jpg',
          cast_id: 245,
          character: 'Additional voices (voice)',
          credit_id: '5aaadd670e0a261e4c00509e',
          order: 64,
        },
        {
          adult: false,
          gender: 0,
          id: 1938081,
          known_for_department: 'Diễn viên',
          name: 'Polo Rojas',
          original_name: 'Polo Rojas',
          popularity: 0.6,
          profile_path: null,
          cast_id: 246,
          character: 'Additional voices (voice)',
          credit_id: '5aaadd769251413ff1004bee',
          order: 65,
        },
        {
          adult: false,
          gender: 2,
          id: 932313,
          known_for_department: 'Diễn viên',
          name: 'Eduardo Roman',
          original_name: 'Eduardo Roman',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/i3yHibzoQQSL2Mtd9qRQnLbFFkb.jpg',
          cast_id: 247,
          character: 'Additional voices (voice)',
          credit_id: '5aaadda20e0a261e4c0050c3',
          order: 66,
        },
        {
          adult: false,
          gender: 0,
          id: 1524538,
          known_for_department: 'Diễn viên',
          name: 'Eddie Santiago',
          original_name: 'Eddie Santiago',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/559tixUHIB6CiK3nFcL5mbuts95.jpg',
          cast_id: 248,
          character: 'Additional voices (voice)',
          credit_id: '5aaaddb29251413fee004b37',
          order: 67,
        },
        {
          adult: false,
          gender: 1,
          id: 1472053,
          known_for_department: 'Diễn viên',
          name: 'Melissa Santos',
          original_name: 'Melissa Santos',
          popularity: 0.783,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lnGMxB02Hlq6x4Nhgw8kdYumCdW.jpg',
          cast_id: 249,
          character: 'Additional voices (voice)',
          credit_id: '5aaaddd99251413ff40048b7',
          order: 68,
        },
        {
          adult: false,
          gender: 0,
          id: 1999061,
          known_for_department: 'Diễn viên',
          name: 'Luis Solís',
          original_name: 'Luis Solís',
          popularity: 0.6,
          profile_path: null,
          cast_id: 250,
          character: 'Additional voices (voice)',
          credit_id: '5aaaddf90e0a261e4f005254',
          order: 69,
        },
        {
          adult: false,
          gender: 0,
          id: 1999063,
          known_for_department: 'Diễn viên',
          name: 'Rosalba Sotelo',
          original_name: 'Rosalba Sotelo',
          popularity: 0.6,
          profile_path: null,
          cast_id: 251,
          character: 'Additional voices (voice)',
          credit_id: '5aaade07c3a3686c0e0050b7',
          order: 70,
        },
        {
          adult: false,
          gender: 0,
          id: 1830412,
          known_for_department: 'Diễn viên',
          name: 'Chris Triana',
          original_name: 'Chris Triana',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8zjjV5yzOswym1K7uGXxxkafWMm.jpg',
          cast_id: 252,
          character: 'Additional voices (voice)',
          credit_id: '5aaade459251413fe2004d5d',
          order: 71,
        },
        {
          adult: false,
          gender: 0,
          id: 1999064,
          known_for_department: 'Diễn viên',
          name: 'Trujo',
          original_name: 'Trujo',
          popularity: 0.6,
          profile_path: null,
          cast_id: 253,
          character: 'Additional voices (voice)',
          credit_id: '5aaade559251413fe5004b38',
          order: 72,
        },
        {
          adult: false,
          gender: 2,
          id: 8,
          known_for_department: 'Directing',
          name: 'Lee Unkrich',
          original_name: 'Lee Unkrich',
          popularity: 3.289,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oeUkLlak2lqKRYZmJZZv5gI87Ok.jpg',
          cast_id: 254,
          character: 'Additional voices (voice)',
          credit_id: '5aaade620e0a261e3f005425',
          order: 73,
        },
        {
          adult: false,
          gender: 2,
          id: 1445768,
          known_for_department: 'Diễn viên',
          name: 'Ruth Zalduondo',
          original_name: 'Ruth Zalduondo',
          popularity: 1.286,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sf9FN5qZg07PdRR49N1ijBmcMap.jpg',
          cast_id: 255,
          character: 'Additional voices (voice)',
          credit_id: '5aaadea50e0a261e46005250',
          order: 74,
        },
        {
          adult: false,
          gender: 0,
          id: 1999065,
          known_for_department: 'Diễn viên',
          name: 'James Zavaleta',
          original_name: 'James Zavaleta',
          popularity: 0.6,
          profile_path: null,
          cast_id: 256,
          character: 'Additional voices (voice)',
          credit_id: '5aaadeb3c3a3686c0500492e',
          order: 75,
        },
        {
          adult: false,
          gender: 2,
          id: 1315140,
          known_for_department: 'Diễn viên',
          name: 'Bernardo Cubria',
          original_name: 'Bernardo Cubria',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lBo6arY6BC3KBbSGuEQ9niwq6qC.jpg',
          cast_id: 257,
          character: 'Additional voices (voice)',
          credit_id: '5aaadee39251413ff4004952',
          order: 76,
        },
        {
          adult: false,
          gender: 2,
          id: 48136,
          known_for_department: 'Diễn viên',
          name: 'Gary Carlos Cervantes',
          original_name: 'Gary Carlos Cervantes',
          popularity: 2.554,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bdmnlMM9tgAevlO4ZkiQLGZW0XD.jpg',
          cast_id: 258,
          character: 'Additional voices (voice)',
          credit_id: '5aaadf4d0e0a261e3f0054bf',
          order: 77,
        },
        {
          adult: false,
          gender: 2,
          id: 59783,
          known_for_department: 'Diễn viên',
          name: 'Johnny A. Sanchez',
          original_name: 'Johnny A. Sanchez',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dKM3WYwjtKe9dOSKkPiK2xI9LWr.jpg',
          cast_id: 259,
          character: 'Additional voices (voice)',
          credit_id: '5aaadf8e0e0a261e520053db',
          order: 78,
        },
        {
          adult: false,
          gender: 0,
          id: 584023,
          known_for_department: 'Diễn viên',
          name: 'Levi Nunez',
          original_name: 'Levi Nunez',
          popularity: 0.786,
          profile_path: null,
          cast_id: 261,
          character: 'Additional voices (voice)',
          credit_id: '5aaae0e70e0a261e520054c6',
          order: 79,
        },
        {
          adult: false,
          gender: 2,
          id: 1510983,
          known_for_department: 'Diễn viên',
          name: 'Óscar Bonfiglio',
          original_name: 'Óscar Bonfiglio',
          popularity: 1.332,
          profile_path:
            'https://image.tmdb.org/t/p/w185/s1YH4zC3f6GzielKsgzijLmXvE5.jpg',
          cast_id: 262,
          character: 'Additional voices (voice)',
          credit_id: '5aaae2050e0a261e4600548f',
          order: 80,
        },
        {
          adult: false,
          gender: 0,
          id: 1789683,
          known_for_department: 'Diễn viên',
          name: 'Lalo Alcaraz',
          original_name: 'Lalo Alcaraz',
          popularity: 0.6,
          profile_path: null,
          cast_id: 263,
          character: 'Additional voices (voice)',
          credit_id: '5aaae2280e0a261e42005af7',
          order: 81,
        },
        {
          adult: false,
          gender: 0,
          id: 1999073,
          known_for_department: 'Diễn viên',
          name: 'Marcela Davison Aviles',
          original_name: 'Marcela Davison Aviles',
          popularity: 0.6,
          profile_path: null,
          cast_id: 264,
          character: 'Additional voices (voice)',
          credit_id: '5aaae23d9251413ff1004ee1',
          order: 82,
        },
        {
          adult: false,
          gender: 0,
          id: 1999015,
          known_for_department: 'Production',
          name: 'Carolina Ángel',
          original_name: 'Carolina Ángel',
          popularity: 0.6,
          profile_path: null,
          cast_id: 265,
          character: 'Additional voices (voice)',
          credit_id: '5aaae2630e0a261e3f0056ab',
          order: 83,
        },
        {
          adult: false,
          gender: 2,
          id: 15347,
          known_for_department: 'Sound',
          name: 'Michael Giacchino',
          original_name: 'Michael Giacchino',
          popularity: 1.152,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1zKiTAfMpc3I8oxdLahx3k6KOOV.jpg',
          cast_id: 275,
          character: "Sunrise Spectacular's orchestra conductor",
          credit_id: '60d33b6235c30a0073d9ff7a',
          order: 84,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 8,
          known_for_department: 'Directing',
          name: 'Lee Unkrich',
          original_name: 'Lee Unkrich',
          popularity: 3.289,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oeUkLlak2lqKRYZmJZZv5gI87Ok.jpg',
          credit_id: '55d1c0b0c3a3686e35001ea6',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 8,
          known_for_department: 'Directing',
          name: 'Lee Unkrich',
          original_name: 'Lee Unkrich',
          popularity: 3.289,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oeUkLlak2lqKRYZmJZZv5gI87Ok.jpg',
          credit_id: '5a2ade53c3a3680b8a1264bd',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 8,
          known_for_department: 'Directing',
          name: 'Lee Unkrich',
          original_name: 'Lee Unkrich',
          popularity: 3.289,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oeUkLlak2lqKRYZmJZZv5gI87Ok.jpg',
          credit_id: '5a1637fb92514153a6002dfb',
          department: 'Biên kịch',
          job: 'Story',
        },
        {
          adult: false,
          gender: 2,
          id: 7879,
          known_for_department: 'Production',
          name: 'John Lasseter',
          original_name: 'John Lasseter',
          popularity: 2.341,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9EhRbLz6iLjpel7oAMX2Eoqlwht.jpg',
          credit_id: '5a2ade7a0e0a264ccd12f007',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 900,
          known_for_department: 'Sound',
          name: 'Christopher Boyes',
          original_name: 'Christopher Boyes',
          popularity: 0.706,
          profile_path: null,
          credit_id: '5aaab8510e0a261e4c001ac0',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 900,
          known_for_department: 'Sound',
          name: 'Christopher Boyes',
          original_name: 'Christopher Boyes',
          popularity: 0.706,
          profile_path: null,
          credit_id: '5aaab8460e0a261e490019d0',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 1,
          id: 7878,
          known_for_department: 'Production',
          name: 'Darla K. Anderson',
          original_name: 'Darla K. Anderson',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/j3u1xcRt3NzMQybuSbQ1BhHWUJs.jpg',
          credit_id: '5a2ade6792514103241280ba',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 7888,
          known_for_department: 'Art',
          name: 'Harley Jessup',
          original_name: 'Harley Jessup',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ukDqqxb9jmVdzkMLjlDGfb2xcu9.jpg',
          credit_id: '5a01e79d9251415726021de7',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 0,
          id: 7963,
          known_for_department: 'Visual Effects',
          name: 'Carter Goodrich',
          original_name: 'Carter Goodrich',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5aaaa71ac3a3686c110008ba',
          department: 'Visual Effects',
          job: 'Character Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 7999,
          known_for_department: 'Visual Effects',
          name: 'Gini Cruz Santos',
          original_name: 'Gini Cruz Santos',
          popularity: 0.968,
          profile_path: null,
          credit_id: '5aaac36fc3a3686c050028cc',
          department: 'Crew',
          job: 'Supervising Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 8053,
          known_for_department: 'Visual Effects',
          name: 'Michael Venturini',
          original_name: 'Michael Venturini',
          popularity: 1.163,
          profile_path: null,
          credit_id: '5aaac37a0e0a261e420031b9',
          department: 'Crew',
          job: 'Supervising Animator',
        },
        {
          adult: false,
          gender: 2,
          id: 8072,
          known_for_department: 'Editing',
          name: 'Greg Snyder',
          original_name: 'Greg Snyder',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab9190e0a261e49001ae4',
          department: 'Crew',
          job: 'Second Film Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 8109,
          known_for_department: 'Lighting',
          name: 'Tim Best',
          original_name: 'Tim Best',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab2a09251413fe20013f1',
          department: 'Lighting',
          job: 'Lighting Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 8157,
          known_for_department: 'Sound',
          name: 'Doc Kane',
          original_name: 'Doc Kane',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5aaab5a1c3a3686c0b00192a',
          department: 'Sound',
          job: 'ADR & Dubbing',
        },
        {
          adult: false,
          gender: 2,
          id: 8158,
          known_for_department: 'Sound',
          name: 'Michael Silvers',
          original_name: 'Michael Silvers',
          popularity: 0.996,
          profile_path: null,
          credit_id: '5aaaaee59251413fe2001034',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 8160,
          known_for_department: 'Sound',
          name: 'Dennie Thorpe',
          original_name: 'Dennie Thorpe',
          popularity: 1.166,
          profile_path: null,
          credit_id: '5aaab1569251413fe2001291',
          department: 'Sound',
          job: 'Foley',
        },
        {
          adult: false,
          gender: 0,
          id: 8163,
          known_for_department: 'Sound',
          name: 'Jana Vance',
          original_name: 'Jana Vance',
          popularity: 0.667,
          profile_path: null,
          credit_id: '5aaab1620e0a261e3f00138e',
          department: 'Sound',
          job: 'Foley',
        },
        {
          adult: false,
          gender: 0,
          id: 8165,
          known_for_department: 'Sound',
          name: 'Dee Selby',
          original_name: 'Dee Selby',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5aaab1760e0a261e46001407',
          department: 'Sound',
          job: 'Foley Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 15893,
          known_for_department: 'Sound',
          name: 'Teresa Eckton',
          original_name: 'Teresa Eckton',
          popularity: 1.106,
          profile_path: null,
          credit_id: '5aaab1a60e0a261e520013e6',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 15893,
          known_for_department: 'Sound',
          name: 'Teresa Eckton',
          original_name: 'Teresa Eckton',
          popularity: 1.106,
          profile_path: null,
          credit_id: '5aaab18fc3a3686c230013c4',
          department: 'Sound',
          job: 'Foley Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 15347,
          known_for_department: 'Sound',
          name: 'Michael Giacchino',
          original_name: 'Michael Giacchino',
          popularity: 1.152,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1zKiTAfMpc3I8oxdLahx3k6KOOV.jpg',
          credit_id: '5a2ade310e0a264ccd12efb2',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 15354,
          known_for_department: 'Sound',
          name: 'Stephen M. Davis',
          original_name: 'Stephen M. Davis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab38ec3a3686c110014ee',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 17674,
          known_for_department: 'Production',
          name: 'Carla Hool',
          original_name: 'Carla Hool',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4n9pbehYIrArk5CGRnMBeqmOQa5.jpg',
          credit_id: '5aaa92f8c3a36851d600e625',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 21698,
          known_for_department: 'Sound',
          name: 'Joel Iwataki',
          original_name: 'Joel Iwataki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab8a49251413fee0019a9',
          department: 'Sound',
          job: 'Scoring Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 57673,
          known_for_department: 'Production',
          name: 'Kevin Reher',
          original_name: 'Kevin Reher',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa932b0e0a26650200f1e5',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 61292,
          known_for_department: 'Production',
          name: 'Mary Alice Drumm',
          original_name: 'Mary Alice Drumm',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a2ade70c3a3680b8812efeb',
          department: 'Production',
          job: 'Associate Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 74343,
          known_for_department: 'Biên kịch',
          name: 'Matthew Aldrich',
          original_name: 'Matthew Aldrich',
          popularity: 1.301,
          profile_path: null,
          credit_id: '5a1637e492514153af002f0e',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 74343,
          known_for_department: 'Biên kịch',
          name: 'Matthew Aldrich',
          original_name: 'Matthew Aldrich',
          popularity: 1.301,
          profile_path: null,
          credit_id: '5a163808c3a3687046002eb7',
          department: 'Biên kịch',
          job: 'Story',
        },
        {
          adult: false,
          gender: 1,
          id: 186605,
          known_for_department: 'Production',
          name: 'Terri Douglas',
          original_name: 'Terri Douglas',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6yRCc5oKalchZuRvVJJbEDNmLEd.jpg',
          credit_id: '5aaa941f925141057900e7fb',
          department: 'Production',
          job: 'ADR Voice Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 652557,
          known_for_department: 'Editing',
          name: 'Steve Bloom',
          original_name: 'Steve Bloom',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5ac5c167c3a36834e8007685',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 958055,
          known_for_department: 'Biên kịch',
          name: 'Jason Katz',
          original_name: 'Jason Katz',
          popularity: 1.176,
          profile_path: null,
          credit_id: '5a16381692514153a3003187',
          department: 'Biên kịch',
          job: 'Story',
        },
        {
          adult: false,
          gender: 1,
          id: 963497,
          known_for_department: 'Production',
          name: 'Natalie Lyon',
          original_name: 'Natalie Lyon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9321c3a36851fe00e627',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 1018001,
          known_for_department: 'Sound',
          name: 'Bruce White',
          original_name: 'Bruce White',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac8909251413fe50030a3',
          department: 'Sound',
          job: 'Musician',
        },
        {
          adult: false,
          gender: 2,
          id: 1043374,
          known_for_department: 'Sound',
          name: 'George Doering',
          original_name: 'George Doering',
          popularity: 1.27,
          profile_path: null,
          credit_id: '5aaab46e0e0a261e4c001630',
          department: 'Sound',
          job: 'Musician',
        },
        {
          adult: false,
          gender: 1,
          id: 1108963,
          known_for_department: 'Sound',
          name: 'Germaine Franco',
          original_name: 'Germaine Franco',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5aaab43dc3a3686c1c0014e5',
          department: 'Sound',
          job: 'Additional Soundtrack',
        },
        {
          adult: false,
          gender: 1,
          id: 1108963,
          known_for_department: 'Sound',
          name: 'Germaine Franco',
          original_name: 'Germaine Franco',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5aaaacf2c3a3686c0b000fa0',
          department: 'Sound',
          job: 'Songs',
        },
        {
          adult: false,
          gender: 1,
          id: 1108963,
          known_for_department: 'Sound',
          name: 'Germaine Franco',
          original_name: 'Germaine Franco',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5aaaace9c3a3686c1c000de4',
          department: 'Sound',
          job: 'Orchestrator',
        },
        {
          adult: false,
          gender: 0,
          id: 1133632,
          known_for_department: 'Editing',
          name: 'Tim Fox',
          original_name: 'Tim Fox',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab8da0e0a261e4f001c7e',
          department: 'Crew',
          job: 'Second Film Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1191111,
          known_for_department: 'Sound',
          name: 'Justin Doyle',
          original_name: 'Justin Doyle',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaabba29251413fe8001f52',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1211220,
          known_for_department: 'Art',
          name: 'Greg Dykstra',
          original_name: 'Greg Dykstra',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xnGnvlzaDFHYQSGpaN93R3eCLpp.jpg',
          credit_id: '5aaaa7089251413fe200089c',
          department: 'Visual Effects',
          job: 'Character Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1218983,
          known_for_department: 'Biên kịch',
          name: 'Don Shank',
          original_name: 'Don Shank',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab3e76a0e0a265f2400d290',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1229800,
          known_for_department: 'Biên kịch',
          name: 'Robert Lopez',
          original_name: 'Robert Lopez',
          popularity: 1.008,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9UrQyBJHYZTl3STt3rATt9vBXfI.jpg',
          credit_id: '5aaab6db0e0a261e4c0018ed',
          department: 'Sound',
          job: 'Songs',
        },
        {
          adult: false,
          gender: 2,
          id: 1260745,
          known_for_department: 'Diễn viên',
          name: 'Tony Fucile',
          original_name: 'Tony Fucile',
          popularity: 0.695,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vKxLwEaL6qz7cwrT8m02Lye7wZO.jpg',
          credit_id: '5aaaa6eb0e0a261e4900084d',
          department: 'Visual Effects',
          job: 'Character Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1291315,
          known_for_department: 'Sound',
          name: 'Tom MacDougall',
          original_name: 'Tom MacDougall',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab456c3a3686c0500146e',
          department: 'Sound',
          job: 'Music Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1348397,
          known_for_department: 'Directing',
          name: 'Michael Bidinger',
          original_name: 'Michael Bidinger',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9abf0e0a2664fb00f0cd',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 1366120,
          known_for_department: 'Sound',
          name: 'Kristen Anderson-Lopez',
          original_name: 'Kristen Anderson-Lopez',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/j0IJP06I5SVUtxcbZ1oRG0SB2D8.jpg',
          credit_id: '5aaabb4f0e0a261e49001e27',
          department: 'Sound',
          job: 'Songs',
        },
        {
          adult: false,
          gender: 0,
          id: 1376901,
          known_for_department: 'Sound',
          name: 'Marshall Winn',
          original_name: 'Marshall Winn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaaaef6c3a3686c08001063',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1378828,
          known_for_department: 'Sound',
          name: 'Michael Semanick',
          original_name: 'Michael Semanick',
          popularity: 2.037,
          profile_path:
            'https://image.tmdb.org/t/p/w185/poGaVc3vdZmkZCvSLNIkkIsxffj.jpg',
          credit_id: '5aaab82f9251413fe8001a9a',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1406877,
          known_for_department: 'Visual Effects',
          name: 'Stephen Matthew Gustafson',
          original_name: 'Stephen Matthew Gustafson',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5aaac8c89251413fee0031a4',
          department: 'Visual Effects',
          job: 'Visual Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1408799,
          known_for_department: 'Sound',
          name: 'Jack Whittaker',
          original_name: 'Jack Whittaker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaabbaf0e0a261e5200214d',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1414177,
          known_for_department: 'Sound',
          name: 'J.R. Grubbs',
          original_name: 'J.R. Grubbs',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac3890e0a261e3c002c44',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1455596,
          known_for_department: 'Visual Effects',
          name: 'Shad Bradbury',
          original_name: 'Shad Bradbury',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9acc0e0a26650200f8d5',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1459764,
          known_for_department: 'Visual Effects',
          name: 'Luis Carlos Uribe',
          original_name: 'Luis Carlos Uribe',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5aaab1050e0a261e42001494',
          department: 'Visual Effects',
          job: 'Fix Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 1463388,
          known_for_department: 'Sound',
          name: 'Lisa Chino',
          original_name: 'Lisa Chino',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab0900e0a261e3f001299',
          department: 'Sound',
          job: 'First Assistant Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1463822,
          known_for_department: 'Sound',
          name: 'Jeff Kryka',
          original_name: 'Jeff Kryka',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5aaab4fdc3a3686c230017d9',
          department: 'Sound',
          job: 'Orchestrator',
        },
        {
          adult: false,
          gender: 0,
          id: 1464412,
          known_for_department: 'Visual Effects',
          name: 'Frank E. Abney III',
          original_name: 'Frank E. Abney III',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9UNcxSpcBuEmaDYWx8yWh6ca7Gx.jpg',
          credit_id: '5aaa9a86c3a36851da00f867',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1485791,
          known_for_department: 'Visual Effects',
          name: 'Royce Wesley',
          original_name: 'Royce Wesley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9d4f0e0a2664ff00fa67',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1519431,
          known_for_department: 'Sound',
          name: 'Warren Brown',
          original_name: 'Warren Brown',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab383c3a3686c080014de',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1544903,
          known_for_department: 'Sound',
          name: 'Michael Miller',
          original_name: 'Michael Miller',
          popularity: 0.611,
          profile_path: null,
          credit_id: '5aaab6000e0a261e3f00193a',
          department: 'Sound',
          job: 'ADR & Dubbing',
        },
        {
          adult: false,
          gender: 2,
          id: 1551367,
          known_for_department: 'Sound',
          name: 'Blake Collins',
          original_name: 'Blake Collins',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab1f49251413ff700122e',
          department: 'Sound',
          job: 'Foley',
        },
        {
          adult: false,
          gender: 0,
          id: 1565465,
          known_for_department: 'Diễn viên',
          name: 'Tony Maki',
          original_name: 'Tony Maki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1fbff69251413f720033e9',
          department: 'Biên kịch',
          job: 'Story Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1624187,
          known_for_department: 'Biên kịch',
          name: 'Vladimir Kooperman',
          original_name: 'Vladimir Kooperman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1fbfe50e0a267dfd003a22',
          department: 'Biên kịch',
          job: 'Story Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1678649,
          known_for_department: 'Directing',
          name: 'Matt Aspbury',
          original_name: 'Matt Aspbury',
          popularity: 0.766,
          profile_path: null,
          credit_id: '5a2ade3b9251410339129f15',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 1684652,
          known_for_department: 'Biên kịch',
          name: 'Adrian Molina',
          original_name: 'Adrian Molina',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aFSYItLNBrY3zrPr69YqYwezj7D.jpg',
          credit_id: '5a1637d80e0a2612d900317e',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 1684652,
          known_for_department: 'Biên kịch',
          name: 'Adrian Molina',
          original_name: 'Adrian Molina',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aFSYItLNBrY3zrPr69YqYwezj7D.jpg',
          credit_id: '5a1637f4c3a3687057002efc',
          department: 'Biên kịch',
          job: 'Story',
        },
        {
          adult: false,
          gender: 2,
          id: 1684652,
          known_for_department: 'Biên kịch',
          name: 'Adrian Molina',
          original_name: 'Adrian Molina',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aFSYItLNBrY3zrPr69YqYwezj7D.jpg',
          credit_id: '5a01e77592514156e60231b2',
          department: 'Directing',
          job: 'Co-Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1703200,
          known_for_department: 'Editing',
          name: 'Sarah K. Reimers',
          original_name: 'Sarah K. Reimers',
          popularity: 1.094,
          profile_path: null,
          credit_id: '5aaa93d9c3a36851d200e2e4',
          department: 'Editing',
          job: 'Additional Editorial Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 1711835,
          known_for_department: 'Visual Effects',
          name: 'Adam Rodriguez',
          original_name: 'Adam Rodriguez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9c91925141056400e6b2',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1711836,
          known_for_department: 'Visual Effects',
          name: 'Shaun Chacko',
          original_name: 'Shaun Chacko',
          popularity: 0.608,
          profile_path: null,
          credit_id: '5aaa9ad6c3a36851f50106fc',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1715749,
          known_for_department: 'Art',
          name: 'Dana Frankoff',
          original_name: 'Dana Frankoff',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab707c3a3686c080018cd',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1742706,
          known_for_department: 'Crew',
          name: 'Daniel Arriaga',
          original_name: 'Daniel Arriaga',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaaa6fe0e0a261e42000969',
          department: 'Visual Effects',
          job: 'Character Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1743196,
          known_for_department: 'Sound',
          name: 'Marshall Bowen',
          original_name: 'Marshall Bowen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaaad72c3a3686c0b00101e',
          department: 'Sound',
          job: 'Conductor',
        },
        {
          adult: false,
          gender: 2,
          id: 1749039,
          known_for_department: 'Visual Effects',
          name: 'Paulo Diaz',
          original_name: 'Paulo Diaz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9b9e0e0a2664ff00f8d4',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1763102,
          known_for_department: 'Visual Effects',
          name: 'Simon Christen',
          original_name: 'Simon Christen',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5aaa9aedc3a36851d600ed2d',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1763124,
          known_for_department: 'Visual Effects',
          name: 'K. C. Roeyer',
          original_name: 'K. C. Roeyer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9c9a925141056400e6c0',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1763133,
          known_for_department: 'Sound',
          name: 'Jim Likowski',
          original_name: 'Jim Likowski',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5aaab1830e0a261e42001543',
          department: 'Sound',
          job: 'Foley Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1765292,
          known_for_department: 'Directing',
          name: 'Youri Dekker',
          original_name: 'Youri Dekker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab0f50e0a261e46001373',
          department: 'Visual Effects',
          job: 'Fix Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 1777871,
          known_for_department: 'Visual Effects',
          name: 'Don Crum',
          original_name: 'Don Crum',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9af7c3a36851cf00f3bd',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1813793,
          known_for_department: 'Visual Effects',
          name: 'Aaron Conover',
          original_name: 'Aaron Conover',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac8a6c3a3686c0b0036dc',
          department: 'Visual Effects',
          job: 'Visual Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1821915,
          known_for_department: 'Sound',
          name: 'Andrew Synowiec',
          original_name: 'Andrew Synowiec',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab4809251413ff100157b',
          department: 'Sound',
          job: 'Musician',
        },
        {
          adult: false,
          gender: 0,
          id: 1830790,
          known_for_department: 'Crew',
          name: 'Danielle Feinberg',
          original_name: 'Danielle Feinberg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a2ade41c3a3680b9a13aa78',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 1844388,
          known_for_department: 'Visual Effects',
          name: 'Jason Johnston',
          original_name: 'Jason Johnston',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5ba2d9629251415237002b5e',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1938080,
          known_for_department: 'Diễn viên',
          name: 'Antonio Sol',
          original_name: 'Antonio Sol',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab6ec9251413ff70016fe',
          department: 'Sound',
          job: 'Playback Singer',
        },
        {
          adult: false,
          gender: 0,
          id: 1993246,
          known_for_department: 'Production',
          name: 'David Park',
          original_name: 'David Park',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab7169251413fe8001907',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1993282,
          known_for_department: 'Costume & Make-Up',
          name: 'Amy L. Allen',
          original_name: 'Amy L. Allen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaaba11c3a3686c23001e48',
          department: 'Art',
          job: 'Lead Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 1993300,
          known_for_department: 'Lighting',
          name: 'Mimia Arbelaez',
          original_name: 'Mimia Arbelaez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab2629251413fee001276',
          department: 'Lighting',
          job: 'Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1993364,
          known_for_department: 'Visual Effects',
          name: 'Guillaume Chartier',
          original_name: 'Guillaume Chartier',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9ae0c3a36851da00f8c1',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1993402,
          known_for_department: 'Visual Effects',
          name: 'Jonathan Hoffman',
          original_name: 'Jonathan Hoffman',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5aaac8da0e0a261e3c003380',
          department: 'Visual Effects',
          job: 'Visual Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1993403,
          known_for_department: 'Visual Effects',
          name: 'Michael Honsel',
          original_name: 'Michael Honsel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac8e40e0a261e3c00338a',
          department: 'Visual Effects',
          job: 'Visual Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1993476,
          known_for_department: 'Visual Effects',
          name: 'Aaron Koressel',
          original_name: 'Aaron Koressel',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5aaa9c540e0a2664ff00f98a',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1993479,
          known_for_department: 'Visual Effects',
          name: 'Bruce Kuei',
          original_name: 'Bruce Kuei',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9c5e0e0a26650501029f',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1993484,
          known_for_department: 'Costume & Make-Up',
          name: 'Alison Leaf',
          original_name: 'Alison Leaf',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab995c3a3686c16001e41',
          department: 'Costume & Make-Up',
          job: 'Set Dressing Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1993504,
          known_for_department: 'Lighting',
          name: 'Burt Peng',
          original_name: 'Burt Peng',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab27f9251413fe20013cb',
          department: 'Lighting',
          job: 'Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1993601,
          known_for_department: 'Visual Effects',
          name: 'Jayson Price',
          original_name: 'Jayson Price',
          popularity: 0.608,
          profile_path: null,
          credit_id: '5aaa9c7bc3a36851ec00d726',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1993607,
          known_for_department: 'Lighting',
          name: 'Jordan Rempel',
          original_name: 'Jordan Rempel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab34fc3a3686c230015d9',
          department: 'Lighting',
          job: 'Master Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1993619,
          known_for_department: 'Visual Effects',
          name: 'Michael Sauls',
          original_name: 'Michael Sauls',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9cadc3a36851d600eed5',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1993626,
          known_for_department: 'Lighting',
          name: 'Philip Shoebottom',
          original_name: 'Philip Shoebottom',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac9da9251413fe500321d',
          department: 'Lighting',
          job: 'Master Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1993632,
          known_for_department: 'Visual Effects',
          name: 'Matthew Strangio',
          original_name: 'Matthew Strangio',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9cc00e0a2664ff00f9ea',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1993633,
          known_for_department: 'Visual Effects',
          name: 'Daniela Strijleva',
          original_name: 'Daniela Strijleva',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaaa7850e0a261e460009db',
          department: 'Visual Effects',
          job: 'Character Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1993640,
          known_for_department: 'Visual Effects',
          name: 'Raphael Suter',
          original_name: 'Raphael Suter',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9cd3925141057300e321',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1993654,
          known_for_department: 'Visual Effects',
          name: 'Jessica Torres',
          original_name: 'Jessica Torres',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9d61c3a36851cf00f5e9',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1994305,
          known_for_department: 'Editing',
          name: 'Anna Wolitzky',
          original_name: 'Anna Wolitzky',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9391c3a36851ec00d060',
          department: 'Editing',
          job: 'Additional Editing',
        },
        {
          adult: false,
          gender: 0,
          id: 1994373,
          known_for_department: 'Crew',
          name: 'Jamie Hecker',
          original_name: 'Jamie Hecker',
          popularity: 0.84,
          profile_path: null,
          credit_id: '5aaac8d1c3a3686c080031f0',
          department: 'Visual Effects',
          job: 'Visual Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1994560,
          known_for_department: 'Visual Effects',
          name: 'Ken Lao',
          original_name: 'Ken Lao',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5aaab3460e0a261e49001407',
          department: 'Lighting',
          job: 'Master Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1994653,
          known_for_department: 'Crew',
          name: 'Ling Hsu',
          original_name: 'Ling Hsu',
          popularity: 0.615,
          profile_path: null,
          credit_id: '5aaac58a9251413fe2002ddd',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1994684,
          known_for_department: 'Crew',
          name: 'Andy Thomas',
          original_name: 'Andy Thomas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac7fa9251413ff4002eb4',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1994961,
          known_for_department: 'Visual Effects',
          name: 'Amanda Wagner',
          original_name: 'Amanda Wagner',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9d3a0e0a26650800e43e',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1996851,
          known_for_department: 'Visual Effects',
          name: 'Courtney Casper Kent',
          original_name: 'Courtney Casper Kent',
          popularity: 1.094,
          profile_path: null,
          credit_id: '5aaaa6250e0a261e4c0007d9',
          department: 'Art',
          job: 'Art Department Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1996863,
          known_for_department: 'Visual Effects',
          name: 'Benjamin Su',
          original_name: 'Benjamin Su',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9ccac3a36851cf00f577',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 1997757,
          known_for_department: 'Production',
          name: 'Becky Neiman',
          original_name: 'Becky Neiman',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5d15c6cd50f7ca0030152fcb',
          department: 'Crew',
          job: 'Thanks',
        },
        {
          adult: false,
          gender: 0,
          id: 1997761,
          known_for_department: 'Editing',
          name: 'Jesus Martinez',
          original_name: 'Jesus Martinez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9a2b0e0a2664fb00f03c',
          department: 'Visual Effects',
          job: 'Animation Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1997796,
          known_for_department: 'Visual Effects',
          name: 'Joshua Dai',
          original_name: 'Joshua Dai',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9b02c3a36851cf00f3cc',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1997801,
          known_for_department: 'Visual Effects',
          name: 'Mike Stern',
          original_name: 'Mike Stern',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9cb70e0a26650200fad9',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1997816,
          known_for_department: 'Lighting',
          name: 'Jose Luis Ramos',
          original_name: 'Jose Luis Ramos',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab30f0e0a261e520015a4',
          department: 'Lighting',
          job: 'Master Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1997825,
          known_for_department: 'Crew',
          name: 'Rachael Bigelow',
          original_name: 'Rachael Bigelow',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1fc0199251413f600030c8',
          department: 'Sound',
          job: 'Additional Production Sound Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1997877,
          known_for_department: 'Crew',
          name: 'Jonathan Hadden',
          original_name: 'Jonathan Hadden',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac5929251413ff7002b60',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1997878,
          known_for_department: 'Crew',
          name: "BoB 'Naked BoB' Morgan",
          original_name: "BoB 'Naked BoB' Morgan",
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac6c1c3a3686c05002cc6',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1997882,
          known_for_department: 'Crew',
          name: 'Shaun Brown',
          original_name: 'Shaun Brown',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac48a0e0a261e42003321',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1997887,
          known_for_department: 'Crew',
          name: 'Daryn Cash',
          original_name: 'Daryn Cash',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac7c59251413fe800319a',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1997904,
          known_for_department: 'Crew',
          name: 'Shawn Hovis',
          original_name: 'Shawn Hovis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac808c3a3686c1c002edd',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1997916,
          known_for_department: 'Lighting',
          name: 'Charu Clark',
          original_name: 'Charu Clark',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5aaab31d9251413ff7001340',
          department: 'Lighting',
          job: 'Master Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1998195,
          known_for_department: 'Editing',
          name: 'Tiffany Taira',
          original_name: 'Tiffany Taira',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac86a0e0a261e49003180',
          department: 'Editing',
          job: 'Archival Footage Research',
        },
        {
          adult: false,
          gender: 0,
          id: 1998387,
          known_for_department: 'Visual Effects',
          name: 'Andrew Atteberry',
          original_name: 'Andrew Atteberry',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9a97c3a36851f50106bd',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1998815,
          known_for_department: 'Art',
          name: 'Tim Evatt',
          original_name: 'Tim Evatt',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa934d925141057900e755',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1998816,
          known_for_department: 'Editing',
          name: 'Meghan Kraft',
          original_name: 'Meghan Kraft',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa93aa925141057000dd47',
          department: 'Editing',
          job: 'Additional Editorial Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 1998846,
          known_for_department: 'Visual Effects',
          name: 'Lance Fite',
          original_name: 'Lance Fite',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9bb8c3a36851da00f99f',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1998848,
          known_for_department: 'Visual Effects',
          name: 'Andrew Gonzalez',
          original_name: 'Andrew Gonzalez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9bddc3a36851d200e9a6',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1998851,
          known_for_department: 'Visual Effects',
          name: 'Dionys Heurtel',
          original_name: 'Dionys Heurtel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9c08c3a36851fe00edaf',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1998852,
          known_for_department: 'Visual Effects',
          name: 'Catherine Hicks',
          original_name: 'Catherine Hicks',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9c31c3a36851fe00eddb',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1998853,
          known_for_department: 'Visual Effects',
          name: 'Charles Larrieu',
          original_name: 'Charles Larrieu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9c67c3a36851f5010895',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1998854,
          known_for_department: 'Visual Effects',
          name: 'Cody Lyon',
          original_name: 'Cody Lyon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9c71c3a36851e200ec7d',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1998855,
          known_for_department: 'Visual Effects',
          name: 'Nicole Ridgwell',
          original_name: 'Nicole Ridgwell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9c84c3a36851d600eea9',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1998856,
          known_for_department: 'Visual Effects',
          name: 'Ben Rush',
          original_name: 'Ben Rush',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9ca3c3a36851d600eec7',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1998859,
          known_for_department: 'Visual Effects',
          name: 'David Torres',
          original_name: 'David Torres',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaa9d0b925141057900efa1',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1998906,
          known_for_department: 'Visual Effects',
          name: 'Daniel Lopez Muсoz',
          original_name: 'Daniel Lopez Muсoz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaaa6f5c3a3686c08000868',
          department: 'Visual Effects',
          job: 'Character Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1998908,
          known_for_department: 'Visual Effects',
          name: 'Zaruhi Galstyan',
          original_name: 'Zaruhi Galstyan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaaa7110e0a261e4c0008d5',
          department: 'Visual Effects',
          job: 'Character Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1998910,
          known_for_department: 'Visual Effects',
          name: 'Alonso Martinez',
          original_name: 'Alonso Martinez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaaa73c9251413fe8000900',
          department: 'Visual Effects',
          job: 'Character Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1998921,
          known_for_department: 'Sound',
          name: 'J.D. Aguilar',
          original_name: 'J.D. Aguilar',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaaae760e0a261e52001089',
          department: 'Sound',
          job: 'Conductor',
        },
        {
          adult: false,
          gender: 0,
          id: 1998923,
          known_for_department: 'Editing',
          name: 'Jessica Katz',
          original_name: 'Jessica Katz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab0390e0a261e4c0011cb',
          department: 'Editing',
          job: 'Editorial Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1998924,
          known_for_department: 'Editing',
          name: 'Freddie Sulit',
          original_name: 'Freddie Sulit',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab0439251413ff70010ab',
          department: 'Editing',
          job: 'Editorial Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1998926,
          known_for_department: 'Editing',
          name: 'Krissy Cababa',
          original_name: 'Krissy Cababa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab0529251413feb00115f',
          department: 'Editing',
          job: 'Editorial Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1998927,
          known_for_department: 'Editing',
          name: 'Max Sachar',
          original_name: 'Max Sachar',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab05f0e0a261e5200128d',
          department: 'Editing',
          job: 'Editorial Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1998928,
          known_for_department: 'Editing',
          name: 'Jennifer Neysa Jew',
          original_name: 'Jennifer Neysa Jew',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab0820e0a261e460012f9',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1998930,
          known_for_department: 'Sound',
          name: 'Geoff Vaughan',
          original_name: 'Geoff Vaughan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab16bc3a3686c0b001444',
          department: 'Sound',
          job: 'Foley',
        },
        {
          adult: false,
          gender: 0,
          id: 1998931,
          known_for_department: 'Sound',
          name: 'Federico Ramos',
          original_name: 'Federico Ramos',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab23d9251413ff100131a',
          department: 'Sound',
          job: 'Musician',
        },
        {
          adult: false,
          gender: 0,
          id: 1998932,
          known_for_department: 'Lighting',
          name: 'Dorien Gunnels',
          original_name: 'Dorien Gunnels',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab26c0e0a261e4c0013e3',
          department: 'Lighting',
          job: 'Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1998933,
          known_for_department: 'Lighting',
          name: 'Linhan Li',
          original_name: 'Linhan Li',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab2760e0a261e3f001526',
          department: 'Lighting',
          job: 'Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1998934,
          known_for_department: 'Lighting',
          name: 'Farhez Rayani',
          original_name: 'Farhez Rayani',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab28ac3a3686c1c001312',
          department: 'Lighting',
          job: 'Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1998935,
          known_for_department: 'Lighting',
          name: 'Lisa Fotheringham',
          original_name: 'Lisa Fotheringham',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab2950e0a261e52001508',
          department: 'Lighting',
          job: 'Lighting Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1998938,
          known_for_department: 'Sound',
          name: 'Luis David Reyes Reyes',
          original_name: 'Luis David Reyes Reyes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab460c3a3686c0b001757',
          department: 'Sound',
          job: 'Music Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1998940,
          known_for_department: 'Sound',
          name: 'Maria Dominique Lopez',
          original_name: 'Maria Dominique Lopez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab4779251413ff700148f',
          department: 'Sound',
          job: 'Musician',
        },
        {
          adult: false,
          gender: 0,
          id: 1998943,
          known_for_department: 'Crew',
          name: 'Maura Turner',
          original_name: 'Maura Turner',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab7229251413feb001882',
          department: 'Crew',
          job: 'Production Office Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 1998944,
          known_for_department: 'Crew',
          name: 'Adrian Bell',
          original_name: 'Adrian Bell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaab7c10e0a261e49001921',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1998949,
          known_for_department: 'Sound',
          name: 'Baraka May',
          original_name: 'Baraka May',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaaba630e0a261e4f001e79',
          department: 'Sound',
          job: 'Musician',
        },
        {
          adult: false,
          gender: 0,
          id: 1998950,
          known_for_department: 'Crew',
          name: 'Mike H. Mahony',
          original_name: 'Mike H. Mahony',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaaba79c3a3686c23001ef6',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1998951,
          known_for_department: 'Crew',
          name: 'Félix O. Santiago',
          original_name: 'Félix O. Santiago',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaabaf6c3a3686c11001e6a',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1998952,
          known_for_department: 'Crew',
          name: 'Gates Roberg-Clark',
          original_name: 'Gates Roberg-Clark',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaabb019251413feb001cda',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1998953,
          known_for_department: 'Crew',
          name: 'Lucas Miller',
          original_name: 'Lucas Miller',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaabb719251413ff7001cd7',
          department: 'Crew',
          job: 'Sound Design Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 1998972,
          known_for_department: 'Crew',
          name: 'Dan Berman',
          original_name: 'Dan Berman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac427c3a3686c0e002e94',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1998973,
          known_for_department: 'Crew',
          name: 'Nic Bishop',
          original_name: 'Nic Bishop',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac45d0e0a261e3c002d59',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1998974,
          known_for_department: 'Crew',
          name: 'Susanne Rublein',
          original_name: 'Susanne Rublein',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac4949251413fe2002c72',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1998978,
          known_for_department: 'Crew',
          name: 'Collin Allen',
          original_name: 'Collin Allen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac8290e0a261e4c00336c',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1998979,
          known_for_department: 'Crew',
          name: 'Teresa Conaty',
          original_name: 'Teresa Conaty',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac876c3a3686c230034a9',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1998980,
          known_for_department: 'Crew',
          name: 'John Henry Frankenhauser',
          original_name: 'John Henry Frankenhauser',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac880c3a3686c110033a8',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1998982,
          known_for_department: 'Visual Effects',
          name: 'Kristopher Campbell',
          original_name: 'Kristopher Campbell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac89a0e0a261e52003620',
          department: 'Visual Effects',
          job: 'Visual Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1998983,
          known_for_department: 'Visual Effects',
          name: 'Michael Frederickson',
          original_name: 'Michael Frederickson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac8b69251413ff4002f93',
          department: 'Visual Effects',
          job: 'Visual Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1998984,
          known_for_department: 'Visual Effects',
          name: 'Emron Grover',
          original_name: 'Emron Grover',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac8bfc3a3686c05002ef8',
          department: 'Visual Effects',
          job: 'Visual Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1998986,
          known_for_department: 'Visual Effects',
          name: 'Jonathan Pytko',
          original_name: 'Jonathan Pytko',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac8f29251413ff7002f87',
          department: 'Visual Effects',
          job: 'Visual Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1998988,
          known_for_department: 'Visual Effects',
          name: 'David Ryu',
          original_name: 'David Ryu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac8fd0e0a261e420039da',
          department: 'Visual Effects',
          job: 'Visual Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1998989,
          known_for_department: 'Visual Effects',
          name: 'Dave Strick',
          original_name: 'Dave Strick',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac9060e0a261e520036a5',
          department: 'Visual Effects',
          job: 'Visual Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1998993,
          known_for_department: 'Visual Effects',
          name: 'Shaun Galinak',
          original_name: 'Shaun Galinak',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac92a0e0a261e49003263',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1998995,
          known_for_department: 'Visual Effects',
          name: 'Erik Shepherd',
          original_name: 'Erik Shepherd',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac9350e0a261e3c0033ef',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1998997,
          known_for_department: 'Visual Effects',
          name: 'Chris Bolwyn',
          original_name: 'Chris Bolwyn',
          popularity: 0.656,
          profile_path: null,
          credit_id: '5aaac9410e0a261e520036ef',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1998998,
          known_for_department: 'Visual Effects',
          name: 'Tyler Bay',
          original_name: 'Tyler Bay',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaac94c0e0a261e4c0034df',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1999000,
          known_for_department: 'Visual Effects',
          name: "Michael O'Brien",
          original_name: "Michael O'Brien",
          popularity: 0.766,
          profile_path: null,
          credit_id: '5aaac99a9251413fe50031cc',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1999003,
          known_for_department: 'Sound',
          name: 'Sam Kriger',
          original_name: 'Sam Kriger',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaaca5dc3a3686c080033e6',
          department: 'Sound',
          job: 'Vocal Coach',
        },
        {
          adult: false,
          gender: 0,
          id: 1999015,
          known_for_department: 'Production',
          name: 'Carolina Ángel',
          original_name: 'Carolina Ángel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aaacde19251413ff4003696',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 2132337,
          known_for_department: 'Visual Effects',
          name: 'Jamie Williams',
          original_name: 'Jamie Williams',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ba56623c3a3680844023c54',
          department: 'Visual Effects',
          job: 'Visual Effects Technical Director',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'Gimly',
          author_details: {
            name: 'Gimly',
            username: 'Ruuz',
            avatar_path: '/xUObnJSvHrFPsIpoDmb1jiQZLq7.jpg',
            rating: 5.0,
          },
          content:
            'Spectacularly colourful with a sweet, (albeit predictable) path. Certainly not a misfire from Pixar, but also did not appeal to me personally in the way that many of their other films have.\r\n\r\n_Final rating:★★½ - Not quite for me, but I definitely get the appeal._',
          created_at: '2018-01-12T09:35:12.923Z',
          id: '5a5881500e0a2634f1006a6b',
          updated_at: '2021-06-23T15:58:04.034Z',
          url: 'https://www.themoviedb.org/review/5a5881500e0a2634f1006a6b',
        },
        {
          author: 'furious_iz',
          author_details: {
            name: '',
            username: 'furious_iz',
            avatar_path: '/h4qDB6FatPbpGhSe556dVmfoKaM.jpg',
            rating: 9.0,
          },
          content:
            '**Beautiful, colourful and sweet**\r\n\r\nThis film has real heart, with great messages about what family can and should do for each other.  Great voice Diễn viên, great songs without having the burden of exposition via song that you find in the more musical ventures by Disney.  I loved that you could see genuine guitar chords being played, so often in live action films the playing of musical instruments, especially guitar are poorly faked.  None of that in this animated gem.\r\n\r\nOne thing I personally loved was the depiction of Mexican culture.  Although I really enjoyed _Moana_, I thought it was a little bit too much of a pastiche of multiple Pacific cultures when it should have just picked one (Maori) and stuck with it.  _Coco_ celebrates Mexican culture, and depicts it well.  The only thing missing for me was more Mexican cuisine.\r\n\r\nIt can get a little dark in places, so maybe be careful when watching it with the little ones, but should appeal to most of the family.\r\n\r\n9/10',
          created_at: '2018-05-27T10:05:29.634Z',
          id: '5b0a82e99251411e6a004bc1',
          updated_at: '2021-06-23T15:58:08.912Z',
          url: 'https://www.themoviedb.org/review/5b0a82e99251411e6a004bc1',
        },
        {
          author: 'priya_',
          author_details: {
            name: '',
            username: 'priya_',
            avatar_path: '/tIuVweidHnUWaOrKngrvkzLv6o5.jpg',
            rating: 10.0,
          },
          content:
            'I loved the movie starting from the characters, animation, colors, emotions, story everything. A good way to tell how important a family is. Happy it had a happy ending.',
          created_at: '2019-04-24T11:30:58.056Z',
          id: '5cc048f2c3a368596a82957b',
          updated_at: '2021-06-23T15:58:20.534Z',
          url: 'https://www.themoviedb.org/review/5cc048f2c3a368596a82957b',
        },
        {
          author: 'r96sk',
          author_details: {
            name: '',
            username: 'r96sk',
            avatar_path:
              '/https://secure.gravatar.com/avatar/96c2e0e4ac98450f9e8e3c0a0a40aad8.jpg',
            rating: 10.0,
          },
          content:
            "Sensational! <em>'Coco'</em> is straight into my top five of Disney animations.\r\n\r\nThe whole 105 minutes are a joy to watch, thanks to its rich and highly meaningful story alongside the wonderful animation and sharp humour. Safe to say, I was not expecting this film to smash it out the park - which it totally does. This is why I don't, personally, look up about films before watching them, I love being surprised.\r\n\r\nBig credit also goes to the cast, who play some awesome characters. From Miguel (Anthony Gonzalez) to Héctor (Gael García Bernal) to Ernesto (Benjamin Bratt), among others, they are all very, very good.\r\n\r\nIt isn't just the characters that make this memorable, it is also the excellent plot which is told beautifully. It's filled with not just comedy but also a load of heart - there's a few nicely done twists too. The world that they create around the Day of the Dead is fantastic, while the music fits perfectly.\r\n\r\nIf you haven't already, you must watch this! It's brilliant!",
          created_at: '2020-09-07T16:36:39.664Z',
          id: '5f56619790dde00034ec6967',
          updated_at: '2021-06-23T15:58:44.061Z',
          url: 'https://www.themoviedb.org/review/5f56619790dde00034ec6967',
        },
      ],
      total_pages: 1,
      total_results: 4,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/1pKCSDWeWvrCiDUkKmMCMgIJSpr.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [],
    homepage: null,
    id: 616678,
    imdb_id: null,
    original_language: 'vi',
    original_title: 'Giang Hồ Chợ Mới',
    overview: 'Phim hài giang hồ chợ mới',
    popularity: 0.6,
    poster_path:
      'https://image.tmdb.org/t/p/w342/qVYjZYgfI8GEk6ZHoDZDhx47P0f.jpg',
    production_companies: [],
    production_countries: [],
    release_date: '',
    revenue: 0,
    runtime: 142,
    spoken_languages: [],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Giang Hồ Chợ Mới',
    video: false,
    vote_average: 0.0,
    vote_count: 0,
    videos: { results: [] },
    credits: {
      cast: [
        {
          adult: false,
          gender: 0,
          id: 2365296,
          known_for_department: 'Diễn viên',
          name: 'Xuân Nghị',
          original_name: 'Xuân Nghị',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9Vkz7aTzd43aH7MTJiCMPqKVrFt.jpg',
          cast_id: 1,
          character: '',
          credit_id: '5d313e9ecaab6d31b2a1fc98',
          order: 1,
        },
        {
          adult: false,
          gender: 0,
          id: 2365297,
          known_for_department: 'Diễn viên',
          name: 'Thanh Tân',
          original_name: 'Thanh Tân',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/14O4kAtRtirFQy4wuIz2qvvJSo5.jpg',
          cast_id: 2,
          character: '',
          credit_id: '5d313ea96a300b1834a5dea9',
          order: 2,
        },
        {
          adult: false,
          gender: 0,
          id: 2365298,
          known_for_department: 'Diễn viên',
          name: 'Duy Phước',
          original_name: 'Duy Phước',
          popularity: 0.6,
          profile_path: null,
          cast_id: 3,
          character: '',
          credit_id: '5d313eb16a300b16aaa7abe2',
          order: 3,
        },
        {
          adult: false,
          gender: 0,
          id: 1878200,
          known_for_department: 'Diễn viên',
          name: 'Nam Thư',
          original_name: 'Nam Thư',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3AgpI9NLQhrZpDJFSLdif6tjncG.jpg',
          cast_id: 4,
          character: '',
          credit_id: '5d313ebdcaab6d1640a36ad4',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 2185322,
          known_for_department: 'Diễn viên',
          name: 'Hứa Minh Đạt',
          original_name: 'Hứa Minh Đạt',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5cNSSIso5yjumx1RKh6mky35ih8.jpg',
          cast_id: 5,
          character: '',
          credit_id: '5d313ec4326c19000e1eb73d',
          order: 5,
        },
      ],
      crew: [],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/8W07L5fUOUtAen6gwDuK2ztTQGJ.jpg',
    belongs_to_collection: null,
    budget: 12000000,
    genres: [{ id: 28, name: 'Phim Hành Động' }],
    homepage: '',
    id: 581526,
    imdb_id: 'tt12763920',
    original_language: 'ko',
    original_title: '다만 악에서 구하소서',
    overview:
      'In-nam (Hwang Jung Min) – một tay sát thủ đã giải nghệ và Yui (Park Jeong Min) gặp nhau tại Thái Lan để tìm kiếm đứa con gái bị bắt cóc mà In-nam chưa một lần gặp mặt. Cuộc chạy đua với thời gian này trở nên khó khăn hơn bao giờ hết khi cả hai phải đương đầu với sự bám đuổi gắt gao từ Ray (Lee Jung Jae). Tên “đồ tể” máu lạnh truy sát In-nam sau khi biết rằng anh trai mình đã bị giết hại, Ray quyết tâm đòi lại món nợ máu này bằng mọi giá.',
    popularity: 8.911,
    poster_path:
      'https://image.tmdb.org/t/p/w342/2EQYD04nIXbGvUoEhq1KeBOzaSq.jpg',
    production_companies: [
      {
        id: 108532,
        logo_path: '/yKPkOrn1IbAc7gl1QO4FqfOtf3.png',
        name: 'Hive Media Corp',
        origin_country: 'KR',
      },
      {
        id: 7036,
        logo_path: '/javbyY0ZCvlFJtly3tpZqf2NwLX.png',
        name: 'CJ Entertainment',
        origin_country: 'KR',
      },
    ],
    production_countries: [
      { iso_3166_1: 'KR', name: 'South Korea' },
      { iso_3166_1: 'TH', name: 'Thailand' },
    ],
    release_date: '2020-08-05',
    revenue: 34662454,
    runtime: 108,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
      { english_name: 'Spanish', iso_639_1: 'es', name: 'Español' },
      { english_name: 'Korean', iso_639_1: 'ko', name: '한국어/조선말' },
      { english_name: 'Thai', iso_639_1: 'th', name: 'ภาษาไทย' },
    ],
    status: 'Đã phát hành',
    tagline: 'Nợ máu phải trả bằng máu.',
    title: 'Ác Quỷ Đối Đầu',
    video: false,
    vote_average: 6.8,
    vote_count: 93,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: '#BIFF2020 Korean Cinema Today Panorama - Deliver Us from Evil / 한국영화의 오늘 파노라마 - 다만 악에서 구하소서',
          key: 'z0naNOf1vIQ',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: false,
          published_at: '2020-09-22T11:00:13.000Z',
          id: '5f6ab7f3a7e363003623f502',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: "DELIVER US FROM EVIL Official Int'l Main Trailer",
          key: 'GGrKazlUfRk',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: false,
          published_at: '2020-07-16T08:34:58.000Z',
          id: '5f5fb940fd7aa40039ea2a4c',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 68903,
          known_for_department: 'Diễn viên',
          name: 'Hwang Jung-min',
          original_name: 'Hwang Jung-min',
          popularity: 2.913,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hKF1uh0iEfuZlBE79CXPw415qyn.jpg',
          cast_id: 1,
          character: 'Kim In-nam',
          credit_id: '5c6229c70e0a2650ad96e75e',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 73249,
          known_for_department: 'Diễn viên',
          name: 'Lee Jung-jae',
          original_name: 'Lee Jung-jae',
          popularity: 11.908,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3h5Cfm0X8ohWn7psZkqdNWqXAHH.jpg',
          cast_id: 4,
          character: 'Ray',
          credit_id: '5d8b291979b3d4001f869d48',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 571172,
          known_for_department: 'Diễn viên',
          name: 'Park Jeong-min',
          original_name: 'Park Jeong-min',
          popularity: 2.779,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fgmu7vAAB2hhWCQHdQDi8IbsDrN.jpg',
          cast_id: 5,
          character: 'Yoo-yi',
          credit_id: '5d8b291fd9f4a6000e514d58',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 1447365,
          known_for_department: 'Diễn viên',
          name: 'Choi Hee-seo',
          original_name: 'Choi Hee-seo',
          popularity: 1.156,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7IXoF4A7hhUgKCtXf1V4Ro4WytV.jpg',
          cast_id: 13,
          character: 'Seo Yeong-ju',
          credit_id: '5d95a2c0ea4263001294737e',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 1856377,
          known_for_department: 'Diễn viên',
          name: 'Oh Dae-hwan',
          original_name: 'Oh Dae-hwan',
          popularity: 1.38,
          profile_path:
            'https://image.tmdb.org/t/p/w185/d3ThGdnujocRKLHrwHbJqHlXpWC.jpg',
          cast_id: 11,
          character: 'Han Jong-su',
          credit_id: '5d941f2787ae7b002ca42726',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 1694435,
          known_for_department: 'Diễn viên',
          name: 'Park Myung-hoon',
          original_name: 'Park Myung-hoon',
          popularity: 1.004,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8IgD7YBQKi2K94RSCwXCCrKcQrA.jpg',
          cast_id: 12,
          character: 'Shimada',
          credit_id: '5d94202987ae7b0024a43ba3',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 88298,
          known_for_department: 'Diễn viên',
          name: 'Song Young-chang',
          original_name: 'Song Young-chang',
          popularity: 1.996,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gcidJKlJtyr7mAlI3ffMRxBj0qG.jpg',
          cast_id: 16,
          character: 'Kim Chun-seong',
          credit_id: '5f3153bd559d22003874b1fc',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 2204527,
          known_for_department: 'Diễn viên',
          name: 'Lee Seo-hwan',
          original_name: 'Lee Seo-hwan',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/v8c7i9Nfe1D5H7E6ycvvTAUT8B7.jpg',
          cast_id: 17,
          character: 'Yeong-bae',
          credit_id: '5f3153cc8ed03f0036f1176c',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 1102621,
          known_for_department: 'Diễn viên',
          name: 'Vithaya Pansringarm',
          original_name: 'Vithaya Pansringarm',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/d27LoRSKh6WBYSQo6MNPNFfB0BQ.jpg',
          cast_id: 21,
          character: 'Ran',
          credit_id: '5f539650b234b900341d10b4',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 2854670,
          known_for_department: 'Diễn viên',
          name: 'Kim Min-sik',
          original_name: 'Kim Min-sik',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ldc5Z7dm7F71OhUoQ6wSx5SNyDQ.jpg',
          cast_id: 22,
          character: 'Korean Couple',
          credit_id: '5fae6a4a7ecd28003dba478c',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 46582,
          known_for_department: 'Diễn viên',
          name: 'Hakuryu',
          original_name: 'Hakuryu',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/YJbMuqt9BEnSOyyYMwjLuSP91R.jpg',
          cast_id: 31,
          character: 'Sensei',
          credit_id: '60320d879af171003e4529bf',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 82875,
          known_for_department: 'Diễn viên',
          name: 'Kosuke Toyohara',
          original_name: 'Kosuke Toyohara',
          popularity: 0.961,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3lpCmqbi2AtUAuDzKDZPt03Wytr.jpg',
          cast_id: 32,
          character: 'Koraeda',
          credit_id: '60320dba20ecaf003d16cb4f',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 2644771,
          known_for_department: 'Diễn viên',
          name: 'Park So-yi',
          original_name: 'Park So-yi',
          popularity: 0.997,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1WXvk2PGf5IYnDTpURbHljMEaGx.jpg',
          cast_id: 33,
          character: 'Yoo-min',
          credit_id: '60320e1c5c32470040dd15e7',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 1607301,
          known_for_department: 'Diễn viên',
          name: 'Choi Byung-mo ',
          original_name: 'Choi Byung-mo ',
          popularity: 0.849,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eANEWvYi7yBygB2CjNHgZIX9EmA.jpg',
          cast_id: 34,
          character: 'Detective',
          credit_id: '60320e4d7f6c8d003d11930b',
          order: 13,
        },
        {
          adult: false,
          gender: 1,
          id: 2985385,
          known_for_department: 'Diễn viên',
          name: 'Shim Young-eun',
          original_name: 'Shim Young-eun',
          popularity: 0.6,
          profile_path: null,
          cast_id: 35,
          character: 'Lin Lin',
          credit_id: '60320e92fab3fa003bff0ec8',
          order: 14,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 38017,
          known_for_department: 'Art',
          name: 'Jo Hwa-seong',
          original_name: 'Jo Hwa-seong',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d8b2a576c1e040029ae00b4',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 2,
          id: 68909,
          known_for_department: 'Camera',
          name: 'Hong Kyung-pyo',
          original_name: 'Hong Kyung-pyo',
          popularity: 0.732,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mFl2oMc8UK5Ia4zEsPOgKbN1NMC.jpg',
          credit_id: '5c6229e90e0a266dac96c316',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 75918,
          known_for_department: 'Biên kịch',
          name: 'Hong Won-chan',
          original_name: 'Hong Won-chan',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wZIERsfTrvvfPNIT3w14IPBwb1X.jpg',
          credit_id: '5c6229d69251412fb4fbdec1',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 75918,
          known_for_department: 'Biên kịch',
          name: 'Hong Won-chan',
          original_name: 'Hong Won-chan',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wZIERsfTrvvfPNIT3w14IPBwb1X.jpg',
          credit_id: '5d8b294e79b3d4000f862927',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 929598,
          known_for_department: 'Sound',
          name: 'Mowg',
          original_name: 'Mowg',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jdQiBwQR9a93b6QCli79AR2gpNI.jpg',
          credit_id: '5d8b2a66abf8e2000f77c31f',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 0,
          id: 1293611,
          known_for_department: 'Lighting',
          name: 'Bae Il-hyuck',
          original_name: 'Bae Il-hyuck',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f4a815ecfe48f0035b20aec',
          department: 'Lighting',
          job: 'Lighting Director',
        },
        {
          adult: false,
          gender: 1,
          id: 1294087,
          known_for_department: 'Costume & Make-Up',
          name: 'Chae Kyung-hwa',
          original_name: 'Chae Kyung-hwa',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jUtzyNzLV8g0QXwMaYzo14TSRtz.jpg',
          credit_id: '5d8b2a726c1e04000fae0e3e',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 2,
          id: 2078582,
          known_for_department: 'Sound',
          name: 'Choi Tae-young',
          original_name: 'Choi Tae-young',
          popularity: 1.66,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rVi3rqXJ3E9GD9H2vJzZdvrTndW.jpg',
          credit_id: '5f4a8191d399e60034c9b841',
          department: 'Sound',
          job: 'Sound Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 2100272,
          known_for_department: 'Sound',
          name: 'Gang Hye-yeong',
          original_name: 'Gang Hye-yeong',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fbe0f88d9f4a6003d9a77f5',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 2187772,
          known_for_department: 'Production',
          name: 'William Kim',
          original_name: 'William Kim',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e3bcbd698f1f100180b77cf',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 2194916,
          known_for_department: 'Editing',
          name: 'Kim Hyung-ju',
          original_name: 'Kim Hyung-ju',
          popularity: 0.608,
          profile_path: null,
          credit_id: '5f4a8175858678003516304e',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2197546,
          known_for_department: 'Production',
          name: 'Kim Chul-yong',
          original_name: 'Kim Chul-yong',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e3bcbe3ac8e6b0011cb63f0',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2310049,
          known_for_department: 'Costume & Make-Up',
          name: 'Son Eun-ju',
          original_name: 'Son Eun-ju',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d8b2a7d6c1e040021adbb75',
          department: 'Costume & Make-Up',
          job: 'Makeup & Hair',
        },
        {
          adult: false,
          gender: 0,
          id: 2392774,
          known_for_department: 'Directing',
          name: 'Kim Seong-sik',
          original_name: 'Kim Seong-sik',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fbe0fa535c30a003e562a4b',
          department: 'Directing',
          job: 'Assistant Director',
        },
        {
          adult: false,
          gender: 1,
          id: 2761071,
          known_for_department: 'Art',
          name: 'Lee Ji-won',
          original_name: 'Lee Ji-won',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60762f3b2faf4d002aad7f71',
          department: 'Art',
          job: 'Props',
        },
        {
          adult: false,
          gender: 0,
          id: 2869402,
          known_for_department: 'Production',
          name: 'Kang Kwan-ho',
          original_name: 'Kang Kwan-ho',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fbe0e8a57530e00403b3a73',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2869403,
          known_for_department: 'Art',
          name: 'Tae Wook',
          original_name: 'Tae Wook',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fbe0ff87cffda003f18e722',
          department: 'Art',
          job: 'Props',
        },
        {
          adult: false,
          gender: 2,
          id: 2942751,
          known_for_department: 'Crew',
          name: 'Lee Gun-moon',
          original_name: 'Lee Gun-moon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60229493c0ae36003f55acd0',
          department: 'Crew',
          job: 'Martial Arts Choreographer',
        },
        {
          adult: false,
          gender: 1,
          id: 2968076,
          known_for_department: 'Editing',
          name: 'Park Jin-Yeong',
          original_name: 'Park Jin-Yeong',
          popularity: 0.6,
          profile_path: null,
          credit_id: '601f649e60b58d0040d666da',
          department: 'Editing',
          job: 'Digital Intermediate',
        },
        {
          adult: false,
          gender: 2,
          id: 2969691,
          known_for_department: 'Visual Effects',
          name: 'Kim Dae-jun',
          original_name: 'Kim Dae-jun',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6021425f458199003da72189',
          department: 'Visual Effects',
          job: 'VFX Supervisor',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/x7Vx9gBbGPnNoYNKnDTdaDABGxJ.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 14, name: 'Phim Giả Tượng' },
      { id: 16, name: 'Phim Hoạt Hình' },
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 10749, name: 'Phim Lãng Mạn' },
    ],
    homepage: 'https://www.netflix.com/title/81193214',
    id: 533514,
    imdb_id: 'tt8652818',
    original_language: 'ja',
    original_title: '劇場版 ヴァイオレット・エヴァーガーデン',
    overview:
      'Nhiều năm sau chiến tranh, "Búp bê ký ức" Violet Evergarden vẫn mãi nhớ về Thiếu tá Gilbert. Một ngày nọ, cô gặp Dietfried - anh trai của Gilbert, người khuyên cô hãy cố quên Gilbert và bắt đầu cuộc sống mới.',
    popularity: 25.153,
    poster_path:
      'https://image.tmdb.org/t/p/w342/hkUPWnVVara3shgn7mCZLgMlg1c.jpg',
    production_companies: [
      {
        id: 5438,
        logo_path: '/nrvweD25GIYmfTIaFyIncLy4p3G.png',
        name: 'Kyoto Animation',
        origin_country: 'JP',
      },
      {
        id: 86839,
        logo_path: '/4gMnTQACykjt0KSRV1N8vSKpkVt.png',
        name: 'ABC Animation',
        origin_country: 'JP',
      },
      {
        id: 9148,
        logo_path: '/rtW3NadfF4kR5mTW00ahiFxw6k7.png',
        name: 'Pony Canyon',
        origin_country: 'JP',
      },
      { id: 31364, logo_path: null, name: 'Rakuonsha', origin_country: 'JP' },
      {
        id: 136217,
        logo_path: '/dBYuplhBgeOsGPQOI0LukWNbFWE.png',
        name: 'Bandai Namco Arts',
        origin_country: 'JP',
      },
      {
        id: 6683,
        logo_path: '/reCkuk3GEomdx5gQpsm15Zl1sgX.png',
        name: 'Lantis',
        origin_country: 'JP',
      },
      {
        id: 155271,
        logo_path: '/z5E1jpLIrwDckeWcMqcPZ9qHvTw.png',
        name: 'Heart Company',
        origin_country: 'JP',
      },
      {
        id: 155307,
        logo_path: null,
        name: 'Miracle Bus',
        origin_country: 'JP',
      },
      {
        id: 154230,
        logo_path: null,
        name: 'Violet Evergarden Production Committee',
        origin_country: 'JP',
      },
    ],
    production_countries: [{ iso_3166_1: 'JP', name: 'Nhật Bản' }],
    release_date: '2020-09-18',
    revenue: 20339624,
    runtime: 140,
    spoken_languages: [
      { english_name: 'Nhật Bảnese', iso_639_1: 'ja', name: '日本語' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Violet Evergarden: Hồi Ức Không Quên',
    video: false,
    vote_average: 9.8,
    vote_count: 169,
    videos: { results: [] },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 1224288,
          known_for_department: 'Diễn viên',
          name: 'Yui Ishikawa',
          original_name: 'Yui Ishikawa',
          popularity: 5.259,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7IUIHnRDWZq71EHMdomW3AvInd1.jpg',
          cast_id: 6,
          character: 'Violet Evergarden (voice)',
          credit_id: '5dc706cda14e1000105d6e10',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 110665,
          known_for_department: 'Diễn viên',
          name: 'Daisuke Namikawa',
          original_name: 'Daisuke Namikawa',
          popularity: 4.332,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iw0X8oDutxaBAri3Ifga8nhdUJK.jpg',
          cast_id: 7,
          character: 'Gilbert Bougainvillea (voice)',
          credit_id: '5e723220357c000016481d34',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 84508,
          known_for_department: 'Diễn viên',
          name: 'Takehito Koyasu',
          original_name: 'Takehito Koyasu',
          popularity: 5.573,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8uBkNDKPNmp9JWgMUI02NVyfhi1.jpg',
          cast_id: 19,
          character: 'Claudia Hodgins (voice)',
          credit_id: '5f5b7aecd8cc4a0038e4979c',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 225655,
          known_for_department: 'Diễn viên',
          name: 'Hidenobu Kiuchi',
          original_name: 'Hidenobu Kiuchi',
          popularity: 1.134,
          profile_path:
            'https://image.tmdb.org/t/p/w185/SpxriXj1RnC7av28Ee47YL3bS2.jpg',
          cast_id: 18,
          character: 'Dietfried Bougainvillea (voice)',
          credit_id: '5f5b7ad2fd7aa4003bddcb70',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 1248340,
          known_for_department: 'Diễn viên',
          name: 'Haruka Tomatsu',
          original_name: 'Haruka Tomatsu',
          popularity: 6.608,
          profile_path:
            'https://image.tmdb.org/t/p/w185/geVvuA2zMGE5xzfc20aDelJSelu.jpg',
          cast_id: 90,
          character: 'Iris Cannary (voice)',
          credit_id: '60414a27b77d4b0058838233',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 1254052,
          known_for_department: 'Diễn viên',
          name: 'Koki Uchiyama',
          original_name: 'Koki Uchiyama',
          popularity: 5.061,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sllSm3iZZWVLTBrDZQRtWrZUfEj.jpg',
          cast_id: 91,
          character: 'Benedict Blue (voice)',
          credit_id: '60414a28db705800792c9253',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 223687,
          known_for_department: 'Diễn viên',
          name: 'Aya Endo',
          original_name: 'Aya Endo',
          popularity: 4.139,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5Ol3mkVwxYqY55bw35AHgP1mlgS.jpg',
          cast_id: 17,
          character: 'Cattleya Baudelaire (voice)',
          credit_id: '5f5b7ab07314a10036e05c58',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 144648,
          known_for_department: 'Diễn viên',
          name: 'Minori Chihara',
          original_name: 'Minori Chihara',
          popularity: 1.933,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qSqXpdLUq4prPtL7mkp0go6SbrF.jpg',
          cast_id: 92,
          character: 'Erica Brown (voice)',
          credit_id: '60414a28ac617c005ad0fecf',
          order: 7,
        },
        {
          adult: false,
          gender: 1,
          id: 1239110,
          known_for_department: 'Diễn viên',
          name: 'Kaori Mizuhashi',
          original_name: 'Kaori Mizuhashi',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eDhVZ9en7T4lvsQ99OkRizroSQd.jpg',
          cast_id: 93,
          character: 'Ulysses (voice)',
          credit_id: '60414a288efe730059a9819f',
          order: 8,
        },
        {
          adult: false,
          gender: 1,
          id: 1241566,
          known_for_department: 'Diễn viên',
          name: 'Rina Sato',
          original_name: 'Rina Sato',
          popularity: 5.526,
          profile_path:
            'https://image.tmdb.org/t/p/w185/c79SXutqQ02zaGi07sqWCbO96re.jpg',
          cast_id: 94,
          character: 'Luca (voice)',
          credit_id: '60414a297cffda0045f6676c',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 1505549,
          known_for_department: 'Diễn viên',
          name: 'Daichi Endo',
          original_name: 'Daichi Endo',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xRfaKcaSrUVtzUtb8SyrTRbceqG.jpg',
          cast_id: 95,
          character: "Ulysses' father (voice)",
          credit_id: '60414a299a358d00459b6404',
          order: 10,
        },
        {
          adult: false,
          gender: 1,
          id: 1253451,
          known_for_department: 'Diễn viên',
          name: 'Mayuno Yasokawa',
          original_name: 'Mayuno Yasokawa',
          popularity: 0.982,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nnyAx35H2LKQ7OC0Qwc6BleA9xu.jpg',
          cast_id: 96,
          character: "Ulysses' mother (voice)",
          credit_id: '60414a2906f98400581f4be7',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 144652,
          known_for_department: 'Diễn viên',
          name: 'Megumi Matsumoto',
          original_name: 'Megumi Matsumoto',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1W2r9zJsHLhfE0VPgH7Sg4CezxF.jpg',
          cast_id: 97,
          character: 'Shion (voice)',
          credit_id: '60414a2ad71fb4004682b6d0',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 23987,
          known_for_department: 'Diễn viên',
          name: 'Jouji Nakata',
          original_name: 'Jouji Nakata',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aFx0ForDkSc119U3nTC7NymStkn.jpg',
          cast_id: 98,
          character: 'Lord Bougainvillea (voice)',
          credit_id: '60414a2ac525c400752ec68d',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 217144,
          known_for_department: 'Diễn viên',
          name: 'Mugihito',
          original_name: 'Mugihito',
          popularity: 0.987,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aAeRJLnOEtikBPN5V7bEAUfZ4Ak.jpg',
          cast_id: 108,
          character: 'Old man (voice)',
          credit_id: '60414c1c8efe730059a983bd',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 1506816,
          known_for_department: 'Diễn viên',
          name: 'Yasuhiro Mamiya',
          original_name: 'Yasuhiro Mamiya',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rjNAfSfRQZyBS8hn33uohOib4Zf.jpg',
          cast_id: 99,
          character: 'Mayor (voice)',
          credit_id: '60414a2a8efe730045a12980',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 2674264,
          known_for_department: 'Diễn viên',
          name: 'Yuuki Sanpei',
          original_name: 'Yuuki Sanpei',
          popularity: 1.094,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eD0aoE0JQzXVmwhA3SBJYjvBtQD.jpg',
          cast_id: 101,
          character: 'Moderator (voice)',
          credit_id: '60414a2b1c63290044e0b6ed',
          order: 16,
        },
        {
          adult: false,
          gender: 1,
          id: 2998587,
          known_for_department: 'Diễn viên',
          name: 'Kozue Harashima',
          original_name: 'Kozue Harashima',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tEdEX69ZwXzuONM1AkEZSOVDtGB.jpg',
          cast_id: 103,
          character: 'Mother (voice)',
          credit_id: '60414a2bd1ca2a005973aec2',
          order: 17,
        },
        {
          adult: false,
          gender: 1,
          id: 2998588,
          known_for_department: 'Diễn viên',
          name: 'Kanako Sakuragi',
          original_name: 'Kanako Sakuragi',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/x6oS92yKFTOF4f44OEbxSlbUflA.jpg',
          cast_id: 105,
          character: 'Mother (voice)',
          credit_id: '60414a2c5690b5006f17432e',
          order: 18,
        },
        {
          adult: false,
          gender: 1,
          id: 1935828,
          known_for_department: 'Diễn viên',
          name: 'Aya Saito',
          original_name: 'Aya Saito',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7IL0IgXuK4SK2Ly3eaSYeYWVmfJ.jpg',
          cast_id: 106,
          character: 'Child (voice)',
          credit_id: '60414a2c651fcf00448ef988',
          order: 19,
        },
        {
          adult: false,
          gender: 1,
          id: 2019928,
          known_for_department: 'Diễn viên',
          name: 'Rie Hikisaka',
          original_name: 'Rie Hikisaka',
          popularity: 0.947,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aOtLO2Pn3Mh9ifPqIOZDyi8EAJv.jpg',
          cast_id: 107,
          character: 'Child (voice)',
          credit_id: '60414a2d06f984004342fd2e',
          order: 20,
        },
        {
          adult: false,
          gender: 1,
          id: 1254135,
          known_for_department: 'Diễn viên',
          name: 'Sumire Morohoshi',
          original_name: 'Sumire Morohoshi',
          popularity: 2.319,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sVRDVTYpsIyXIScHDTvgOY8Q8xQ.jpg',
          cast_id: 89,
          character: 'Daisy Magnolia (voice)',
          credit_id: '60414837c525c400752ec480',
          order: 21,
        },
        {
          adult: false,
          gender: 2,
          id: 115304,
          known_for_department: 'Diễn viên',
          name: 'Mitsuru Miyamoto',
          original_name: 'Mitsuru Miyamoto',
          popularity: 1.744,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tS61Ua1FTXSLUd4lo5VWf4ys8Uk.jpg',
          cast_id: 100,
          character: "Daisy's father (voice)",
          credit_id: '60414a2a63aad2004223029f',
          order: 22,
        },
        {
          adult: false,
          gender: 1,
          id: 81851,
          known_for_department: 'Diễn viên',
          name: 'Emi Shinohara',
          original_name: 'Emi Shinohara',
          popularity: 2.722,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ryGauSE9aoEh5DFMrlFw3H8sATC.jpg',
          cast_id: 102,
          character: "Daisy's mother (voice)",
          credit_id: '60414a2b8efe730045a12983',
          order: 23,
        },
        {
          adult: false,
          gender: 1,
          id: 615,
          known_for_department: 'Diễn viên',
          name: 'Hisako Kyoda',
          original_name: 'Hisako Kyoda',
          popularity: 2.142,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7p7kVXNp1ZhJp2KejBPQwD8j9nE.jpg',
          cast_id: 104,
          character: 'Nerine (voice)',
          credit_id: '60414a2c3429ff00288f59d2',
          order: 24,
        },
        {
          adult: false,
          gender: 1,
          id: 151183,
          known_for_department: 'Diễn viên',
          name: 'Ayako Kawasumi',
          original_name: 'Ayako Kawasumi',
          popularity: 3.931,
          profile_path:
            'https://image.tmdb.org/t/p/w185/brhzQo2ecJFAmyHpx7ZF7GQLDdp.jpg',
          cast_id: 32,
          character: 'Clara Magnolia (voice)',
          credit_id: '5fd36836ab6849003fa43678',
          order: 25,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 1,
          id: 78373,
          known_for_department: 'Biên kịch',
          name: 'Reiko Yoshida',
          original_name: 'Reiko Yoshida',
          popularity: 3.197,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5LUxL8rdUtMdqxx8pnWp6PM0wKp.jpg',
          credit_id: '60021bf36aa8e0003f78b775',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 24003,
          known_for_department: 'Sound',
          name: 'Yōta Tsuruoka',
          original_name: 'Yōta Tsuruoka',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pKx6YaitQUVmoSyIrg7I85DW8g1.jpg',
          credit_id: '60e6e9a3b76cbb00461bc7b7',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 24003,
          known_for_department: 'Sound',
          name: 'Yōta Tsuruoka',
          original_name: 'Yōta Tsuruoka',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pKx6YaitQUVmoSyIrg7I85DW8g1.jpg',
          credit_id: '5f4f6627da10f000355b081e',
          department: 'Sound',
          job: 'Sound Director',
        },
        {
          adult: false,
          gender: 2,
          id: 144662,
          known_for_department: 'Editing',
          name: 'Kengo Shigemura',
          original_name: 'Kengo Shigemura',
          popularity: 0.98,
          profile_path: null,
          credit_id: '60f8701c07e281004679364b',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 144668,
          known_for_department: 'Sound',
          name: 'Satoshi Yano',
          original_name: 'Satoshi Yano',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6179a360229ae2002a573c95',
          department: 'Sound',
          job: 'Sound Recordist',
        },
        {
          adult: false,
          gender: 1,
          id: 144670,
          known_for_department: 'Visual Effects',
          name: 'Shouko Ikeda',
          original_name: 'Shouko Ikeda',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5fd8c00ea127e50040142618',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 144673,
          known_for_department: 'Sound',
          name: 'Shigeru Saito',
          original_name: 'Shigeru Saito',
          popularity: 1.532,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dbMKgEpezlWhduXPfc0JtCzZjpC.jpg',
          credit_id: '609d69fcfd4a9600634ecf64',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 144673,
          known_for_department: 'Sound',
          name: 'Shigeru Saito',
          original_name: 'Shigeru Saito',
          popularity: 1.532,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dbMKgEpezlWhduXPfc0JtCzZjpC.jpg',
          credit_id: '60f87000f1759c00765f9f43',
          department: 'Sound',
          job: 'Music Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 237224,
          known_for_department: 'Production',
          name: 'Yoko Hatta',
          original_name: 'Yoko Hatta',
          popularity: 0.98,
          profile_path: null,
          credit_id: '60e6e98cb7d352005e1cdf32',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1301231,
          known_for_department: 'Sound',
          name: 'Shunji Inoue',
          original_name: 'Shunji Inoue',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e6e99ca3b5e6005d935def',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1347805,
          known_for_department: 'Visual Effects',
          name: 'Rin Yamamoto',
          original_name: 'Rin Yamamoto',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5f4f660c7352050034ef1c4a',
          department: 'Visual Effects',
          job: '3D Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1368260,
          known_for_department: 'Production',
          name: 'Shinichi Nakamura',
          original_name: 'Shinichi Nakamura',
          popularity: 0.6,
          profile_path: null,
          credit_id: '609d69e6ec8a43002a758d87',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1400629,
          known_for_department: 'Art',
          name: 'Ikuko Tamine',
          original_name: 'Ikuko Tamine',
          popularity: 1.38,
          profile_path: null,
          credit_id: '60f87285fd140b007e5c9701',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1446127,
          known_for_department: 'Sound',
          name: 'Youki Yamamoto',
          original_name: 'Youki Yamamoto',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pg3ktm5hqvNHmxv94JeZ71aBDTN.jpg',
          credit_id: '6179a423d6dbba0091e8cfbf',
          department: 'Sound',
          job: 'Conductor',
        },
        {
          adult: false,
          gender: 2,
          id: 1484773,
          known_for_department: 'Directing',
          name: 'Taichi Ishidate',
          original_name: 'Taichi Ishidate',
          popularity: 2.107,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nBPuRvo9oWFWqzZiS8U4P9j0qtg.jpg',
          credit_id: '5cb9c8db9251417d39f3ddee',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1484773,
          known_for_department: 'Directing',
          name: 'Taichi Ishidate',
          original_name: 'Taichi Ishidate',
          popularity: 2.107,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nBPuRvo9oWFWqzZiS8U4P9j0qtg.jpg',
          credit_id: '611fbf1cf031740045adf877',
          department: 'Art',
          job: 'Storyboard Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 1484773,
          known_for_department: 'Directing',
          name: 'Taichi Ishidate',
          original_name: 'Taichi Ishidate',
          popularity: 2.107,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nBPuRvo9oWFWqzZiS8U4P9j0qtg.jpg',
          credit_id: '5fd3672a9a9f9a0040926174',
          department: 'Directing',
          job: 'Second Unit Director',
        },
        {
          adult: false,
          gender: 1,
          id: 1484775,
          known_for_department: 'Visual Effects',
          name: 'Miku Kadowaki',
          original_name: 'Miku Kadowaki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fd367deab68490041a3fe70',
          department: 'Visual Effects',
          job: 'Animation Director',
        },
        {
          adult: false,
          gender: 1,
          id: 1565042,
          known_for_department: 'Art',
          name: 'Mikiko Watanabe',
          original_name: 'Mikiko Watanabe',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5f4f65b0db705800344e0ca1',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 1565044,
          known_for_department: 'Camera',
          name: 'Kazuya Takao',
          original_name: 'Kazuya Takao',
          popularity: 1.4,
          profile_path: null,
          credit_id: '60f873bc960331004724438a',
          department: 'Visual Effects',
          job: 'Compositing Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 1565045,
          known_for_department: 'Visual Effects',
          name: 'Joji Unoguchi',
          original_name: 'Joji Unoguchi',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5f4f65c006f98400321f3bdc',
          department: 'Visual Effects',
          job: '3D Artist',
        },
        {
          adult: false,
          gender: 1,
          id: 1565046,
          known_for_department: 'Visual Effects',
          name: 'Yuka Yoneda',
          original_name: 'Yuka Yoneda',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f4f65cbeea34d00329ec17b',
          department: 'Visual Effects',
          job: 'Color Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1647493,
          known_for_department: 'Production',
          name: 'Masayuki Nishide',
          original_name: 'Masayuki Nishide',
          popularity: 0.98,
          profile_path: null,
          credit_id: '60e6e995b7d3520046d8e884',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1661031,
          known_for_department: 'Visual Effects',
          name: 'Nobuaki Maruki',
          original_name: 'Nobuaki Maruki',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5fd36a42ab6849003fa43849',
          department: 'Visual Effects',
          job: 'Animation Director',
        },
        {
          adult: false,
          gender: 1,
          id: 1661032,
          known_for_department: 'Directing',
          name: 'Haruka Fujita',
          original_name: 'Haruka Fujita',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/d17kGnlHzGKXA1zOp5PJCaDY0r.jpg',
          credit_id: '6041461163aad2005685a133',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 1661033,
          known_for_department: 'Visual Effects',
          name: 'Hiroyuki Takahashi',
          original_name: 'Hiroyuki Takahashi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6179a28dbe2d490045b9f155',
          department: 'Art',
          job: 'Prop Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1661033,
          known_for_department: 'Visual Effects',
          name: 'Hiroyuki Takahashi',
          original_name: 'Hiroyuki Takahashi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fea59e3a14bef003e2f9c25',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 1661034,
          known_for_department: 'Visual Effects',
          name: 'Kayo Hikiyama',
          original_name: 'Kayo Hikiyama',
          popularity: 0.98,
          profile_path: null,
          credit_id: '604146e0c525c400752ec28b',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 1661035,
          known_for_department: 'Directing',
          name: 'Taichi Ogawa',
          original_name: 'Taichi Ogawa',
          popularity: 1.164,
          profile_path: null,
          credit_id: '5fd366a1ab6849003fa434d5',
          department: 'Directing',
          job: 'Second Unit Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1661036,
          known_for_department: 'Directing',
          name: 'Noriyuki Kitanohara',
          original_name: 'Noriyuki Kitanohara',
          popularity: 1.4,
          profile_path: null,
          credit_id: '60414744db705800313e0b3e',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 1661037,
          known_for_department: 'Visual Effects',
          name: 'Seiichi Akitake',
          original_name: 'Seiichi Akitake',
          popularity: 0.6,
          profile_path: null,
          credit_id: '604145e096670e0028f3a2b1',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1661040,
          known_for_department: 'Directing',
          name: 'Takuya Yamamura',
          original_name: 'Takuya Yamamura',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fd365b15a9915003ecb8234',
          department: 'Directing',
          job: 'Second Unit Director',
        },
        {
          adult: false,
          gender: 1,
          id: 1661041,
          known_for_department: 'Visual Effects',
          name: 'Kazumi Ikeda',
          original_name: 'Kazumi Ikeda',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fd36952848eb9003edd8d4d',
          department: 'Visual Effects',
          job: 'Animation Director',
        },
        {
          adult: false,
          gender: 1,
          id: 1661042,
          known_for_department: 'Visual Effects',
          name: 'Rie Sezaki',
          original_name: 'Rie Sezaki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6041474dd3719700789b0e11',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 1669020,
          known_for_department: 'Visual Effects',
          name: 'Yuji Shibata',
          original_name: 'Yuji Shibata',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f873a5fd140b007e5c996a',
          department: 'Visual Effects',
          job: '3D Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 1898715,
          known_for_department: 'Visual Effects',
          name: 'Norihiro Tomiita',
          original_name: 'Norihiro Tomiita',
          popularity: 1.38,
          profile_path: null,
          credit_id: '60f873af6e3deb007ebe079a',
          department: 'Visual Effects',
          job: '3D Animator',
        },
        {
          adult: false,
          gender: 1,
          id: 1898720,
          known_for_department: 'Crew',
          name: 'Rina Miura',
          original_name: 'Rina Miura',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f8735ff1759c004666541c',
          department: 'Crew',
          job: 'Special Effects',
        },
        {
          adult: false,
          gender: 2,
          id: 1898721,
          known_for_department: 'Sound',
          name: 'Hiromune Kurahashi',
          original_name: 'Hiromune Kurahashi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f87014944a570046e292e6',
          department: 'Sound',
          job: 'Sound Effects',
        },
        {
          adult: false,
          gender: 2,
          id: 1959241,
          known_for_department: 'Biên kịch',
          name: 'Takaaki Suzuki',
          original_name: 'Takaaki Suzuki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60be33ec0721660029dfc186',
          department: 'Art',
          job: 'Settings',
        },
        {
          adult: false,
          gender: 1,
          id: 1982590,
          known_for_department: 'Production',
          name: 'Megumi Suzuki',
          original_name: 'Megumi Suzuki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '609d69f44202280029b2f15e',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 2020130,
          known_for_department: 'Sound',
          name: 'Evan Call',
          original_name: 'Evan Call',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/o65ANgmbZOpYKw6dCdHAnQ5pKWV.jpg',
          credit_id: '5f71aab6d38b580039e9ddd1',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 0,
          id: 2020131,
          known_for_department: 'Production',
          name: 'Kazusa Umeda',
          original_name: 'Kazusa Umeda',
          popularity: 0.6,
          profile_path: null,
          credit_id: '609d69eddd47e1002988820d',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 2020132,
          known_for_department: 'Biên kịch',
          name: 'Kana Akatsuki',
          original_name: 'Kana Akatsuki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f805e753429ff0039bb15e2',
          department: 'Biên kịch',
          job: 'Novel',
        },
        {
          adult: false,
          gender: 2,
          id: 2155689,
          known_for_department: 'Sound',
          name: 'Adam Klemens',
          original_name: 'Adam Klemens',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6179a415e9da6900645b3566',
          department: 'Sound',
          job: 'Conductor',
        },
        {
          adult: false,
          gender: 1,
          id: 2160238,
          known_for_department: 'Art',
          name: 'Etsuko Abe',
          original_name: 'Etsuko Abe',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f870cac8f858005da04ea1',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2160930,
          known_for_department: 'Art',
          name: 'Kazuki Ikeda',
          original_name: 'Kazuki Ikeda',
          popularity: 0.694,
          profile_path: null,
          credit_id: '60f871a6fd140b007e5c94f6',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 2336352,
          known_for_department: 'Art',
          name: 'Sagako Itakura',
          original_name: 'Sagako Itakura',
          popularity: 0.98,
          profile_path: null,
          credit_id: '60f871ab6e3deb005cce29a1',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 2431883,
          known_for_department: 'Visual Effects',
          name: 'Kyohei Ando',
          original_name: 'Kyohei Ando',
          popularity: 0.6,
          profile_path: null,
          credit_id: '604146efd3719700789b0dc6',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 2431893,
          known_for_department: 'Art',
          name: 'Naoki Hosokawa',
          original_name: 'Naoki Hosokawa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f8719efd140b002938c2eb',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 2532750,
          known_for_department: 'Production',
          name: 'Shinichiro Hatta',
          original_name: 'Shinichiro Hatta',
          popularity: 0.6,
          profile_path: null,
          credit_id: '609d69defd4a960080583992',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2532771,
          known_for_department: 'Visual Effects',
          name: 'Hiroki Ueda',
          original_name: 'Hiroki Ueda',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f873cb6e3deb007ebe07e2',
          department: 'Visual Effects',
          job: 'Compositing Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 2532776,
          known_for_department: 'Visual Effects',
          name: 'Kunihiro Hane',
          original_name: 'Kunihiro Hane',
          popularity: 0.6,
          profile_path: null,
          credit_id: '604146031c63290044e0b357',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 2532780,
          known_for_department: 'Visual Effects',
          name: 'Hiroshi Karata',
          original_name: 'Hiroshi Karata',
          popularity: 0.98,
          profile_path: null,
          credit_id: '604145e78efe73002b3d7cdd',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 2532798,
          known_for_department: 'Visual Effects',
          name: 'Ryouhei Muta',
          original_name: 'Ryouhei Muta',
          popularity: 0.6,
          profile_path: null,
          credit_id: '604146d09a358d005913f4cb',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 2532807,
          known_for_department: 'Visual Effects',
          name: 'Fumie Okano',
          original_name: 'Fumie Okano',
          popularity: 0.6,
          profile_path: null,
          credit_id: '604145f0d3719700789b0cb3',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 2532815,
          known_for_department: 'Visual Effects',
          name: 'Tatsuya Satou',
          original_name: 'Tatsuya Satou',
          popularity: 1.094,
          profile_path: null,
          credit_id: '604146da22df2e002aed2f52',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 2532817,
          known_for_department: 'Visual Effects',
          name: 'Shinpei Sawa',
          original_name: 'Shinpei Sawa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60414733c525c400752ec345',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 2532817,
          known_for_department: 'Visual Effects',
          name: 'Shinpei Sawa',
          original_name: 'Shinpei Sawa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fd365fb880c9200435060a8',
          department: 'Directing',
          job: 'Second Unit Director',
        },
        {
          adult: false,
          gender: 1,
          id: 2532819,
          known_for_department: 'Visual Effects',
          name: 'Mariko Takahashi',
          original_name: 'Mariko Takahashi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6041472c5690b5002a450be5',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2532821,
          known_for_department: 'Visual Effects',
          name: 'Yuki Tsunoda',
          original_name: 'Yuki Tsunoda',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fd369acf48e0d0040c15c0d',
          department: 'Visual Effects',
          job: 'Animation Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2532825,
          known_for_department: 'Visual Effects',
          name: 'Taira Yamaguchi',
          original_name: 'Taira Yamaguchi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6041460b5690b5005a05b11f',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 2532828,
          known_for_department: 'Visual Effects',
          name: 'Minoru Ota',
          original_name: 'Minoru Ota',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6179a292d236e6002a8255b4',
          department: 'Art',
          job: 'Prop Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2532828,
          known_for_department: 'Visual Effects',
          name: 'Minoru Ota',
          original_name: 'Minoru Ota',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fd3661ff056d5003d632398',
          department: 'Directing',
          job: 'Second Unit Director',
        },
        {
          adult: false,
          gender: 2,
          id: 2763426,
          known_for_department: 'Visual Effects',
          name: 'Kohei Funamoto',
          original_name: 'Kohei Funamoto',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5f4f65ffda10f000325b063b',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 1,
          id: 2804583,
          known_for_department: 'Visual Effects',
          name: 'Akiko Takase',
          original_name: 'Akiko Takase',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gpnoeDM4Ewm7rbjSfhODlXzBlwZ.jpg',
          credit_id: '5fd37173f056d5003e63093e',
          department: 'Visual Effects',
          job: 'Animation Director',
        },
        {
          adult: false,
          gender: 1,
          id: 2804583,
          known_for_department: 'Visual Effects',
          name: 'Akiko Takase',
          original_name: 'Akiko Takase',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gpnoeDM4Ewm7rbjSfhODlXzBlwZ.jpg',
          credit_id: '5f7b785b35c30a00376db05c',
          department: 'Visual Effects',
          job: 'Character Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 2804583,
          known_for_department: 'Visual Effects',
          name: 'Akiko Takase',
          original_name: 'Akiko Takase',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gpnoeDM4Ewm7rbjSfhODlXzBlwZ.jpg',
          credit_id: '5fd36913cee481003ee12280',
          department: 'Visual Effects',
          job: 'Supervising Animation Director',
        },
        {
          adult: false,
          gender: 1,
          id: 2882832,
          known_for_department: 'Visual Effects',
          name: 'Yuki Yokoyama',
          original_name: 'Yuki Yokoyama',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6041475fb77d4b0076656206',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 2889594,
          known_for_department: 'Visual Effects',
          name: 'Kohei Okamura',
          original_name: 'Kohei Okamura',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fd367ea9a9f9a003e928ff0',
          department: 'Visual Effects',
          job: 'Animation Director',
        },
        {
          adult: false,
          gender: 2,
          id: 2889594,
          known_for_department: 'Visual Effects',
          name: 'Kohei Okamura',
          original_name: 'Kohei Okamura',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6041473c1c6329002e508263',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2889602,
          known_for_department: 'Visual Effects',
          name: 'Yuko Myouken',
          original_name: 'Yuko Myouken',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fd370e4880c9200405036af',
          department: 'Visual Effects',
          job: 'Animation Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2889603,
          known_for_department: 'Visual Effects',
          name: 'Tatsunari Maruko',
          original_name: 'Tatsunari Maruko',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fd3711fcee481003de189d2',
          department: 'Visual Effects',
          job: 'Animation Director',
        },
        {
          adult: false,
          gender: 1,
          id: 2936303,
          known_for_department: 'Visual Effects',
          name: 'Saeko Fujita',
          original_name: 'Saeko Fujita',
          popularity: 0.608,
          profile_path: null,
          credit_id: '604146b4945c20002a1c451b',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2998223,
          known_for_department: 'Visual Effects',
          name: 'Sana Suzuki',
          original_name: 'Sana Suzuki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6041462d22df2e002aed2e5e',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2998224,
          known_for_department: 'Visual Effects',
          name: 'Chiharu Kuroda',
          original_name: 'Chiharu Kuroda',
          popularity: 0.6,
          profile_path: null,
          credit_id: '604146ad96670e005857a09a',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2998249,
          known_for_department: 'Visual Effects',
          name: 'Sayaka Watanabe',
          original_name: 'Sayaka Watanabe',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6041469b8efe73006eb8eddc',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 2998309,
          known_for_department: 'Visual Effects',
          name: 'Yoshinori Urata',
          original_name: 'Yoshinori Urata',
          popularity: 1.38,
          profile_path: null,
          credit_id: '604145cb8efe730059a97c3d',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 2998314,
          known_for_department: 'Visual Effects',
          name: 'Aoi Matsumoto',
          original_name: 'Aoi Matsumoto',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6041475863aad2005685a254',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 2998315,
          known_for_department: 'Visual Effects',
          name: 'Hidehiro Asama',
          original_name: 'Hidehiro Asama',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6041461b945c2000433baa3d',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 2998316,
          known_for_department: 'Visual Effects',
          name: 'Kota Sato',
          original_name: 'Kota Sato',
          popularity: 1.008,
          profile_path: null,
          credit_id: '60414634d71fb4002b60206c',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 2998317,
          known_for_department: 'Visual Effects',
          name: 'Ryo Miyaki',
          original_name: 'Ryo Miyaki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6041465206f9840076959dba',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2998320,
          known_for_department: 'Visual Effects',
          name: 'Chika Kamo',
          original_name: 'Chika Kamo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60414767ac617c005ad0fb89',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2998342,
          known_for_department: 'Visual Effects',
          name: 'Ami Kuriki',
          original_name: 'Ami Kuriki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60414694db7058005b1fe992',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2998347,
          known_for_department: 'Visual Effects',
          name: 'Shiho Morisaki',
          original_name: 'Shiho Morisaki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6041464ad71fb4004682b2ec',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 2998353,
          known_for_department: 'Visual Effects',
          name: 'Ryosuke Shirakawa',
          original_name: 'Ryosuke Shirakawa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6041463b63aad200223f36f7',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2998354,
          known_for_department: 'Visual Effects',
          name: 'Sumire Kusano',
          original_name: 'Sumire Kusano',
          popularity: 0.6,
          profile_path: null,
          credit_id: '604146bb63aad200745fecb2',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2998358,
          known_for_department: 'Visual Effects',
          name: 'Maiko Hado',
          original_name: 'Maiko Hado',
          popularity: 0.84,
          profile_path: null,
          credit_id: '604146e722df2e006f7b4b85',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2998359,
          known_for_department: 'Visual Effects',
          name: 'Yurika Oono',
          original_name: 'Yurika Oono',
          popularity: 0.6,
          profile_path: null,
          credit_id: '604146ff9a358d002cec844e',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 2998361,
          known_for_department: 'Visual Effects',
          name: 'Seiya Kumano',
          original_name: 'Seiya Kumano',
          popularity: 0.6,
          profile_path: null,
          credit_id: '604146f6651fcf002a311c40',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2998363,
          known_for_department: 'Visual Effects',
          name: 'Tomomi Sato',
          original_name: 'Tomomi Sato',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6041470dd4cc8e00785c99c5',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2998364,
          known_for_department: 'Visual Effects',
          name: 'Momoka Yoshizaki',
          original_name: 'Momoka Yoshizaki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '604147c1d4cc8e00599d7bbc',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2998370,
          known_for_department: 'Visual Effects',
          name: 'Sae Sawada',
          original_name: 'Sae Sawada',
          popularity: 0.6,
          profile_path: null,
          credit_id: '604146439a358d006e677e78',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 2998512,
          known_for_department: 'Visual Effects',
          name: 'Yusuke Miyahara',
          original_name: 'Yusuke Miyahara',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60414774b77d4b0058837f3b',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2998513,
          known_for_department: 'Visual Effects',
          name: 'Maiko Mibu',
          original_name: 'Maiko Mibu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '604147b2af6e940044b13f67',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 2998514,
          known_for_department: 'Visual Effects',
          name: 'Kakeru Isokawa',
          original_name: 'Kakeru Isokawa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '604147e2d1ca2a0045f44f12',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2998519,
          known_for_department: 'Visual Effects',
          name: 'Miho Takechi',
          original_name: 'Miho Takechi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6041477e22df2e002aed303d',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 2998521,
          known_for_department: 'Visual Effects',
          name: 'Seiya Kawaguchi',
          original_name: 'Seiya Kawaguchi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '604147b922df2e002aed3103',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2998528,
          known_for_department: 'Visual Effects',
          name: 'Tamami Tokuyama',
          original_name: 'Tamami Tokuyama',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6041476ed3719700449831a4',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2998530,
          known_for_department: 'Visual Effects',
          name: 'Aya Hikita',
          original_name: 'Aya Hikita',
          popularity: 0.6,
          profile_path: null,
          credit_id: '604147a97cffda005990be20',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2998533,
          known_for_department: 'Visual Effects',
          name: 'Mei Issei',
          original_name: 'Mei Issei',
          popularity: 0.6,
          profile_path: null,
          credit_id: '604147c95690b5005a05b26b',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 3059684,
          known_for_department: 'Production',
          name: 'Yoko Kogawa',
          original_name: 'Yoko Kogawa',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aHEY7YDL2F5q55CelvnfwypZzqK.jpg',
          credit_id: '60e6e9c0b7d3520075ba90cb',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 3111174,
          known_for_department: 'Art',
          name: 'Park Jung-ah',
          original_name: 'Park Jung-ah',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f8727fdf857c005eab77a9',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3111175,
          known_for_department: 'Art',
          name: 'Lee Mi-jin',
          original_name: 'Lee Mi-jin',
          popularity: 0.98,
          profile_path: null,
          credit_id: '60f87209c439c00029eb6335',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 3111633,
          known_for_department: 'Art',
          name: 'Marie Kitai',
          original_name: 'Marie Kitai',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f871fec8f858002e223d02',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3111636,
          known_for_department: 'Art',
          name: 'Kim Ji-hee',
          original_name: 'Kim Ji-hee',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f871f7df857c0075c40340',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 3112162,
          known_for_department: 'Visual Effects',
          name: 'Azumi Hata',
          original_name: 'Azumi Hata',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f8733507e281002cda1bf8',
          department: 'Crew',
          job: 'Special Effects',
        },
        {
          adult: false,
          gender: 2,
          id: 3112778,
          known_for_department: 'Art',
          name: 'Shuuya Uchiyama',
          original_name: 'Shuuya Uchiyama',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f87309960331002ea89c9a',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 3112780,
          known_for_department: 'Art',
          name: 'Shingo Kasai',
          original_name: 'Shingo Kasai',
          popularity: 0.98,
          profile_path: null,
          credit_id: '60f871b1e039f1005e1dec0d',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3112781,
          known_for_department: 'Art',
          name: 'Tomoki Hiraishi',
          original_name: 'Tomoki Hiraishi',
          popularity: 1.4,
          profile_path: null,
          credit_id: '60f870d53103250072a85e49',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 3112782,
          known_for_department: 'Art',
          name: 'Momoka Hase',
          original_name: 'Momoka Hase',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f8718ae039f1005e1deb9b',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 3112783,
          known_for_department: 'Art',
          name: 'Sayaka Ichiyama',
          original_name: 'Sayaka Ichiyama',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f872fef1759c002eae28b3',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3112784,
          known_for_department: 'Art',
          name: 'Mao Takayama',
          original_name: 'Mao Takayama',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f87319f056d5005e6f24da',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3112785,
          known_for_department: 'Art',
          name: 'Shiori Yamazaki',
          original_name: 'Shiori Yamazaki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f87314209f18002b723263',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 3112786,
          known_for_department: 'Art',
          name: 'Harumi Nakamura',
          original_name: 'Harumi Nakamura',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f8730439a1a600481cff77',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3112788,
          known_for_department: 'Art',
          name: 'Miyuki Hiratoko',
          original_name: 'Miyuki Hiratoko',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f87199fd140b005d2c680d',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3112791,
          known_for_department: 'Art',
          name: 'Nozomi Oishi',
          original_name: 'Nozomi Oishi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f8727a07e281007d7ee7f5',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 3112792,
          known_for_department: 'Art',
          name: 'Shuhei Okude',
          original_name: 'Shuhei Okude',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f87274f1759c005f369ea5',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 3112794,
          known_for_department: 'Art',
          name: 'Aki Yamatogi',
          original_name: 'Aki Yamatogi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f8729231032500236dd2ed',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 3112795,
          known_for_department: 'Art',
          name: 'Lee Cheon-bok',
          original_name: 'Lee Cheon-bok',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f87204e039f10074ae2eb6',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3112941,
          known_for_department: 'Editing',
          name: 'Gen Itakura',
          original_name: 'Gen Itakura',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f873ea944a570075d8088d',
          department: 'Editing',
          job: 'Online Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 3117129,
          known_for_department: 'Art',
          name: 'Kouji Maruyama',
          original_name: 'Kouji Maruyama',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f8720fc439c000465fcacc',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3150795,
          known_for_department: 'Visual Effects',
          name: 'Teru Matsumoto',
          original_name: 'Teru Matsumoto',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f873d8209f180044bdb9af',
          department: 'Visual Effects',
          job: 'Compositing Artist',
        },
        {
          adult: false,
          gender: 1,
          id: 3150796,
          known_for_department: 'Visual Effects',
          name: 'Yoshiko Tanaka',
          original_name: 'Yoshiko Tanaka',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f873c307e2810046793db4',
          department: 'Visual Effects',
          job: 'Compositing Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 3151476,
          known_for_department: 'Visual Effects',
          name: 'Tatsunori Kase',
          original_name: 'Tatsunori Kase',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f873b539a1a600481d00c8',
          department: 'Visual Effects',
          job: '3D Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 3151480,
          known_for_department: 'Visual Effects',
          name: 'Kazuki Ueno',
          original_name: 'Kazuki Ueno',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f873d3c8f858005da05642',
          department: 'Visual Effects',
          job: 'Compositing Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 3151633,
          known_for_department: 'Visual Effects',
          name: 'Shouta Eino',
          original_name: 'Shouta Eino',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f873def056d500756ac152',
          department: 'Visual Effects',
          job: 'Compositing Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 3151634,
          known_for_department: 'Visual Effects',
          name: 'Keisuke Sudo',
          original_name: 'Keisuke Sudo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f873e4310325005da4a728',
          department: 'Visual Effects',
          job: 'Compositing Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 3151644,
          known_for_department: 'Visual Effects',
          name: 'Mitsuki Takaki',
          original_name: 'Mitsuki Takaki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f873a939a1a60030b414ec',
          department: 'Visual Effects',
          job: '3D Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 3166392,
          known_for_department: 'Art',
          name: 'Arou Ozaki',
          original_name: 'Arou Ozaki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f8730ff1759c002eae28b7',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 3166525,
          known_for_department: 'Crew',
          name: 'Rina Sasaki',
          original_name: 'Rina Sasaki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f8736be039f1004671a61c',
          department: 'Crew',
          job: 'Special Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 3166526,
          known_for_department: 'Crew',
          name: 'Yuki Semori',
          original_name: 'Yuki Semori',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f8739039a1a600618022ee',
          department: 'Crew',
          job: 'Special Effects',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/jRi6AKMPLnMtsFtWY0FUXZOlnVb.jpg',
    belongs_to_collection: {
      id: 473971,
      name: "Daddy's Home Collection",
      poster_path: '/sKjm3JtHz3Z5ggyNZC4IEz4z4Dl.jpg',
      backdrop_path: '/16w6DLmX0OqGT5qBdMpfpWh4VkU.jpg',
    },
    budget: 69000000,
    genres: [{ id: 35, name: 'Phim Hài' }],
    homepage: 'http://www.daddyshomemovie.com/',
    id: 419680,
    imdb_id: 'tt5657846',
    original_language: 'en',
    original_title: "Daddy's Home 2",
    overview:
      'Sau thành công của phần 1 vào năm 2015, cha đẻ Dusty (Mark Wahlberg) và cha dượng Brad (Will Ferrell) đã bắt tay nhau để cùng mang tới cho những đứa trẻ của họ một mùa Giáng sinh hoàn hảo. Sự hợp tác mới này đã được thử thách khi mà cha đẻ của Dusty (Mel Gibson) và người cha đa cảm của Brad (John Lithgow) cùng lúc xuất hiện và biến kỳ nghỉ thành một mớ hỗn loạn hoàn toàn.',
    popularity: 70.644,
    poster_path:
      'https://image.tmdb.org/t/p/w342/rF2IoKL0IFmumEXQFUuB8LajTYP.jpg',
    production_companies: [
      {
        id: 19177,
        logo_path: null,
        name: 'Red Granite Pictures',
        origin_country: '',
      },
      {
        id: 4740,
        logo_path: '/20IuOPEwlHRXnn0MTOsEmw0wcql.png',
        name: 'Gary Sanchez Productions',
        origin_country: 'US',
      },
      {
        id: 4,
        logo_path: '/fycMZt242LVjagMByZOLUGbCvv3.png',
        name: 'Paramount',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2017-11-09',
    revenue: 180613180,
    runtime: 100,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'More Daddies. More Problems.',
    title: 'Bố Ngoan, Bố Hư 2',
    video: false,
    vote_average: 6.3,
    vote_count: 1977,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Official Trailer #2',
          key: 'hTKMUn87SxA',
          published_at: '2017-09-06T13:00:04.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '59f70e20925141422102f948',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Official Trailer',
          key: 'huaGQdrkrK0',
          published_at: '2017-06-15T16:00:07.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '594330a2c3a3686c59016144',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 23659,
          known_for_department: 'Diễn viên',
          name: 'Will Ferrell',
          original_name: 'Will Ferrell',
          popularity: 6.641,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fwzwHyh4bWASls0tGjdNwClfpuS.jpg',
          cast_id: 1,
          character: 'Brad Whitaker',
          credit_id: '57f5f6bac3a368160c003927',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 13240,
          known_for_department: 'Diễn viên',
          name: 'Mark Wahlberg',
          original_name: 'Mark Wahlberg',
          popularity: 19.719,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bTEFpaWd7A6AZVWOqKKBWzKEUe8.jpg',
          cast_id: 0,
          character: 'Dusty Mayron',
          credit_id: '57f5f6a8c3a3681610003be3',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 12074,
          known_for_department: 'Diễn viên',
          name: 'John Lithgow',
          original_name: 'John Lithgow',
          popularity: 5.294,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8Y1sjBdnVR483S8PrnAQzlESwhx.jpg',
          cast_id: 10,
          character: 'Don Whitaker',
          credit_id: '5890e8e3c3a368701a008f2b',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 2461,
          known_for_department: 'Diễn viên',
          name: 'Mel Gibson',
          original_name: 'Mel Gibson',
          popularity: 13.128,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bLzZZRyAsGJvQqsQ1hdptv93aIL.jpg',
          cast_id: 9,
          character: 'Kurt Mayron',
          credit_id: '5890e8ddc3a3687010009bf7',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 1817,
          known_for_department: 'Diễn viên',
          name: 'Linda Cardellini',
          original_name: 'Linda Cardellini',
          popularity: 7.948,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bcycvynDprC1rrhBNrnBjn5uOUd.jpg',
          cast_id: 11,
          character: 'Sara Whitaker',
          credit_id: '58d9202c9251411f9006f842',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 56446,
          known_for_department: 'Diễn viên',
          name: 'John Cena',
          original_name: 'John Cena',
          popularity: 7.932,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rgB2eIOt7WyQjdgJCOuESdDlrjg.jpg',
          cast_id: 2,
          character: 'Roger',
          credit_id: '57f5f7029251413613003f71',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 207606,
          known_for_department: 'Diễn viên',
          name: 'Alessandra Ambrosio',
          original_name: 'Alessandra Ambrosio',
          popularity: 4.777,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nkxU0cLs90wuyRfUMLlo99Neb9N.jpg',
          cast_id: 14,
          character: 'Karen Mayron',
          credit_id: '5949eb2dc3a36861b5004b13',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 1552636,
          known_for_department: 'Diễn viên',
          name: 'Owen Vaccaro',
          original_name: 'Owen Vaccaro',
          popularity: 2.089,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pNTtj9L4eVQQIb6o79D0dJC87HS.jpg',
          cast_id: 12,
          character: 'Dylan Mayron',
          credit_id: '58d92078c3a368124f06c6d1',
          order: 7,
        },
        {
          adult: false,
          gender: 1,
          id: 1512021,
          known_for_department: 'Diễn viên',
          name: 'Scarlett Estevez',
          original_name: 'Scarlett Estevez',
          popularity: 13.513,
          profile_path:
            'https://image.tmdb.org/t/p/w185/c8T1SJxcHs0bV1W66qvWVfaINOt.jpg',
          cast_id: 13,
          character: 'Megan Mayron',
          credit_id: '58d92092c3a368123406bc24',
          order: 8,
        },
        {
          adult: false,
          gender: 1,
          id: 1363621,
          known_for_department: 'Diễn viên',
          name: 'Didi Costine',
          original_name: 'Didi Costine',
          popularity: 2.286,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nWEWKAgvTOUud8wMYljYrkPnt3g.jpg',
          cast_id: 15,
          character: 'Adrianna',
          credit_id: '5949eb6f92514145a8004ab8',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 1185286,
          known_for_department: 'Diễn viên',
          name: 'Chesley Sullenberger',
          original_name: 'Chesley Sullenberger',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/r2xvlk0MUAGlnIC1HERStJo7akM.jpg',
          cast_id: 17,
          character: "Brad's Stepfather",
          credit_id: '5a0d029ec3a368130b0053b2',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 3896,
          known_for_department: 'Diễn viên',
          name: 'Liam Neeson',
          original_name: 'Liam Neeson',
          popularity: 23.845,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bboldwqSC6tdw2iL6631c98l2Mn.jpg',
          cast_id: 18,
          character: 'Himself (voice)',
          credit_id: '5a11a859c3a368629204cbd9',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 928638,
          known_for_department: 'Diễn viên',
          name: 'John Franchi',
          original_name: 'John Franchi',
          popularity: 0.6,
          profile_path: null,
          cast_id: 19,
          character: 'Pedestrian',
          credit_id: '5ad7722ac3a36847de00f2c3',
          order: 12,
        },
        {
          adult: false,
          gender: 1,
          id: 1216355,
          known_for_department: 'Diễn viên',
          name: 'Andrea Anders',
          original_name: 'Andrea Anders',
          popularity: 2.584,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rTRgTbxzZFdYnnmooOCZ2XHk3vC.jpg',
          cast_id: 21,
          character: 'Principal Hayes',
          credit_id: '5dff29b79824c80013e15851',
          order: 13,
        },
        {
          adult: false,
          gender: 1,
          id: 2487963,
          known_for_department: 'Diễn viên',
          name: 'Yamilah Saravong',
          original_name: 'Yamilah Saravong',
          popularity: 0.6,
          profile_path: null,
          cast_id: 22,
          character: 'Casey',
          credit_id: '5dff29e3d236e600168e2b59',
          order: 14,
        },
        {
          adult: false,
          gender: 0,
          id: 1664094,
          known_for_department: 'Diễn viên',
          name: 'Hector Presedo',
          original_name: 'Hector Presedo',
          popularity: 0.6,
          profile_path: null,
          cast_id: 23,
          character: 'Pepe',
          credit_id: '5dff29f7d236e600108e45b1',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 1566690,
          known_for_department: 'Diễn viên',
          name: 'Daniel DiMaggio',
          original_name: 'Daniel DiMaggio',
          popularity: 2.192,
          profile_path:
            'https://image.tmdb.org/t/p/w185/d6CF7v4icnnEpeuueUm2piuR8qH.jpg',
          cast_id: 24,
          character: 'Young Dusty',
          credit_id: '5dff2a21d236e600168e2b9c',
          order: 16,
        },
        {
          adult: false,
          gender: 0,
          id: 1918846,
          known_for_department: 'Diễn viên',
          name: 'Yimmy Yim',
          original_name: 'Yimmy Yim',
          popularity: 0.6,
          profile_path: null,
          cast_id: 25,
          character: 'Yimmy',
          credit_id: '5dff2a6bd236e600108e4a2b',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 1593005,
          known_for_department: 'Diễn viên',
          name: 'Bill Mootos',
          original_name: 'Bill Mootos',
          popularity: 0.831,
          profile_path: null,
          cast_id: 26,
          character: 'Bill',
          credit_id: '5dff2a86d1a893001989bc87',
          order: 18,
        },
        {
          adult: false,
          gender: 2,
          id: 1730745,
          known_for_department: 'Diễn viên',
          name: 'Oscar Wahlberg',
          original_name: 'Oscar Wahlberg',
          popularity: 0.996,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6rqiVDXR0wGIHHawd71LrGyjxWe.jpg',
          cast_id: 27,
          character: 'Roberto C. Fishman Pratt',
          credit_id: '5dff2aac65686e0018947080',
          order: 19,
        },
        {
          adult: false,
          gender: 0,
          id: 1456299,
          known_for_department: 'Diễn viên',
          name: 'Hillary Olinger',
          original_name: 'Hillary Olinger',
          popularity: 0.6,
          profile_path: null,
          cast_id: 28,
          character: 'Ms. Pratt',
          credit_id: '5dff2ad165686e001894709f',
          order: 20,
        },
        {
          adult: false,
          gender: 0,
          id: 2487964,
          known_for_department: 'Diễn viên',
          name: 'Sylvia Barjolo',
          original_name: 'Sylvia Barjolo',
          popularity: 0.6,
          profile_path: null,
          cast_id: 29,
          character: 'Marlene',
          credit_id: '5dff2aecd236e600168e2d10',
          order: 21,
        },
        {
          adult: false,
          gender: 0,
          id: 1807175,
          known_for_department: 'Diễn viên',
          name: 'Matthew Delamater',
          original_name: 'Matthew Delamater',
          popularity: 0.6,
          profile_path: null,
          cast_id: 30,
          character: 'Gun Salesman',
          credit_id: '5dff2b2a26dac10012614a56',
          order: 22,
        },
        {
          adult: false,
          gender: 1,
          id: 2506992,
          known_for_department: 'Diễn viên',
          name: 'Frankie Francois',
          original_name: 'Frankie Francois',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ui9JaZW4ZK71ufr7VjrgiGDvKj.jpg',
          cast_id: 111,
          character: 'Movie Theater Patron (uncredited)',
          credit_id: '5e83c29dd236e60013fdc081',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 109708,
          known_for_department: 'Diễn viên',
          name: 'Bill Burr',
          original_name: 'Bill Burr',
          popularity: 2.727,
          profile_path:
            'https://image.tmdb.org/t/p/w185/q2EjbwF1oDjuwpsTF1BSpKo6RDh.jpg',
          cast_id: 112,
          character: 'Jerry',
          credit_id: '5ee6328b97eab4001de36f52',
          order: 24,
        },
        {
          adult: false,
          gender: 2,
          id: 2188198,
          known_for_department: 'Diễn viên',
          name: 'Colton Osorio',
          original_name: 'Colton Osorio',
          popularity: 1.38,
          profile_path:
            'https://image.tmdb.org/t/p/w185/26QYXUN5sa6ZjFCy24y3nnL89SV.jpg',
          cast_id: 113,
          character: 'Little Boy (uncredited)',
          credit_id: '60bc0b8deb64f1003fa4b217',
          order: 25,
        },
        {
          adult: false,
          gender: 0,
          id: 1244097,
          known_for_department: 'Diễn viên',
          name: 'Lance Norris',
          original_name: 'Lance Norris',
          popularity: 0.84,
          profile_path: null,
          cast_id: 114,
          character: 'Hunter (uncredited)',
          credit_id: '61c65dd2a93d250061ad34f4',
          order: 26,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 1589,
          known_for_department: 'Sound',
          name: 'Michael Andrews',
          original_name: 'Michael Andrews',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff3065d236e600168e37cd',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 2,
          id: 1597,
          known_for_department: 'Sound',
          name: 'Michael Payne',
          original_name: 'Michael Payne',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff3558d1a8930014892593',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 2080,
          known_for_department: 'Diễn viên',
          name: 'Todd Bryant',
          original_name: 'Todd Bryant',
          popularity: 0.708,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sauMN1jgnOhafbxMytr2x42kBdG.jpg',
          credit_id: '5dff2e6526dac1001761e12f',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 8157,
          known_for_department: 'Sound',
          name: 'Doc Kane',
          original_name: 'Doc Kane',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5dff34359824c80017e1c095',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 1,
          id: 10397,
          known_for_department: 'Costume & Make-Up',
          name: 'Carol Ramsey',
          original_name: 'Carol Ramsey',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5dff2c6565686e0013952df3',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 2,
          id: 11506,
          known_for_department: 'Camera',
          name: 'Julio Macat',
          original_name: 'Julio Macat',
          popularity: 0.611,
          profile_path: null,
          credit_id: '5dff2b9465686e0013952c01',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 23659,
          known_for_department: 'Diễn viên',
          name: 'Will Ferrell',
          original_name: 'Will Ferrell',
          popularity: 6.641,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fwzwHyh4bWASls0tGjdNwClfpuS.jpg',
          credit_id: '588ae26392514156a6011a58',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 37012,
          known_for_department: 'Editing',
          name: 'Brad E. Wilhite',
          original_name: 'Brad E. Wilhite',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff2bb0d236e600168e2f7d',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 29211,
          known_for_department: 'Crew',
          name: 'Jay Vinitsky',
          original_name: 'Jay Vinitsky',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff2c8b65686e0013952e53',
          department: 'Crew',
          job: 'Post Production Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 41080,
          known_for_department: 'Production',
          name: 'Allison Jones',
          original_name: 'Allison Jones',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/d0Kk5DHy2dtoxwX7IelactzN0Hw.jpg',
          credit_id: '5dff2be59824c80017e1b801',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 54585,
          known_for_department: 'Art',
          name: 'Clayton Hartley',
          original_name: 'Clayton Hartley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff2c00d1a893001989c175',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 2,
          id: 55710,
          known_for_department: 'Directing',
          name: 'Adam McKay',
          original_name: 'Adam McKay',
          popularity: 12.074,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vOyZXNJq7Oo01LPtSD5AZHjctgH.jpg',
          credit_id: '588ae27ac3a368413b023f20',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 113045,
          known_for_department: 'Sound',
          name: 'Dawn Lunsford',
          original_name: 'Dawn Lunsford',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gaGtvXaFT7hZzGc12KsYp91etlh.jpg',
          credit_id: '5dff345065686e00159454d0',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 1,
          id: 113090,
          known_for_department: 'Sound',
          name: 'Alicia Stevenson',
          original_name: 'Alicia Stevenson',
          popularity: 3.534,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kgYtaWN4VSFh2B0jkHa1GMBOcNU.jpg',
          credit_id: '5dff3622d1a893001989d3fc',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 92343,
          known_for_department: 'Directing',
          name: 'Matt Rebenkoff',
          original_name: 'Matt Rebenkoff',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5dff2e22d1a8930014891a70',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 2,
          id: 74619,
          known_for_department: 'Biên kịch',
          name: 'Sean Anders',
          original_name: 'Sean Anders',
          popularity: 2.744,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vWO1FiGZPOL4FdhbxeykOXRfcXJ.jpg',
          credit_id: '588ae23b925141533b0127fc',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 74619,
          known_for_department: 'Biên kịch',
          name: 'Sean Anders',
          original_name: 'Sean Anders',
          popularity: 2.744,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vWO1FiGZPOL4FdhbxeykOXRfcXJ.jpg',
          credit_id: '588ae2479251411bbe0250c9',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 74978,
          known_for_department: 'Sound',
          name: 'Terry Porter',
          original_name: 'Terry Porter',
          popularity: 1.094,
          profile_path: null,
          credit_id: '5dff35b1d1a89300148925f0',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 90042,
          known_for_department: 'Crew',
          name: 'Rene Mousseux',
          original_name: 'Rene Mousseux',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rlJeyY5IbWbudi0Ri2f1s9hG3uw.jpg',
          credit_id: '5dff2f5f26dac10012615164',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 0,
          id: 28285,
          known_for_department: 'Sound',
          name: 'Rick Giovinazzo',
          original_name: 'Rick Giovinazzo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff38019824c80015e19cf7',
          department: 'Sound',
          job: 'Orchestrator',
        },
        {
          adult: false,
          gender: 2,
          id: 202648,
          known_for_department: 'Biên kịch',
          name: 'Brian Burns',
          original_name: 'Brian Burns',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff2b74d1a893001288da46',
          department: 'Biên kịch',
          job: 'Characters',
        },
        {
          adult: false,
          gender: 1,
          id: 204408,
          known_for_department: 'Diễn viên',
          name: 'Helena Barrett',
          original_name: 'Helena Barrett',
          popularity: 2.26,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3etCIazLPUAUDWW4qKEsFPnPcsp.jpg',
          credit_id: '5dff2e8626dac1001761e143',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 2,
          id: 212576,
          known_for_department: 'Biên kịch',
          name: 'John Morris',
          original_name: 'John Morris',
          popularity: 1.614,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dI4L5EBAPLlxocjIcGUtB7YHZqY.jpg',
          credit_id: '588ae253925141533b01280f',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 1031764,
          known_for_department: 'Sound',
          name: 'Darren Sunny Warkentin',
          original_name: 'Darren Sunny Warkentin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff368bd1a89300148927a1',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1031811,
          known_for_department: 'Sound',
          name: 'Andrew DeCristofaro',
          original_name: 'Andrew DeCristofaro',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff33639824c80017e1bfc1',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1095093,
          known_for_department: 'Costume & Make-Up',
          name: 'Bridget Cook',
          original_name: 'Bridget Cook',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff2d0226dac100146234c3',
          department: 'Costume & Make-Up',
          job: 'Hair Department Head',
        },
        {
          adult: false,
          gender: 2,
          id: 1242111,
          known_for_department: 'Art',
          name: 'Jeremy Woodward',
          original_name: 'Jeremy Woodward',
          popularity: 1.96,
          profile_path: null,
          credit_id: '5dff32bb65686e001594530a',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1283905,
          known_for_department: 'Crew',
          name: 'Patrick Ruth',
          original_name: 'Patrick Ruth',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff3a8365686e001894909f',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1301652,
          known_for_department: 'Crew',
          name: 'Stephen W. Schriver',
          original_name: 'Stephen W. Schriver',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff2f2365686e00189478ec',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 0,
          id: 1318465,
          known_for_department: 'Costume & Make-Up',
          name: 'Aimee McCue',
          original_name: 'Aimee McCue',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff389a26dac100146246d5',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 1,
          id: 1321011,
          known_for_department: 'Art',
          name: 'Debbie Cutler',
          original_name: 'Debbie Cutler',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff2c389824c80013e15cb2',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 1334462,
          known_for_department: 'Art',
          name: 'Joseph Kearney',
          original_name: 'Joseph Kearney',
          popularity: 0.6,
          profile_path: null,
          credit_id: '588ae28b9251411bbe0250f7',
          department: 'Art',
          job: 'Construction Coordinator',
        },
        {
          adult: false,
          gender: 1,
          id: 1352977,
          known_for_department: 'Costume & Make-Up',
          name: 'Valerie Zielonka',
          original_name: 'Valerie Zielonka',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5dff392126dac10012616374',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1377293,
          known_for_department: 'Sound',
          name: 'Karen Vassar Triest',
          original_name: 'Karen Vassar Triest',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff3664d236e600168e453e',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1387183,
          known_for_department: 'Sound',
          name: 'John C. Stuver',
          original_name: 'John C. Stuver',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5dff3641d1a893001989d4a3',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1395023,
          known_for_department: 'Sound',
          name: 'Bill R. Dean',
          original_name: 'Bill R. Dean',
          popularity: 0.702,
          profile_path: null,
          credit_id: '5dff3348d1a8930014891efd',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1400534,
          known_for_department: 'Camera',
          name: 'Claire Folger',
          original_name: 'Claire Folger',
          popularity: 1.166,
          profile_path: null,
          credit_id: '5dff39ad9824c80013e1752c',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 1,
          id: 1401687,
          known_for_department: 'Sound',
          name: 'Anna Behlmer',
          original_name: 'Anna Behlmer',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kUsjqvtj653USV4FXxJmPiqJCW4.jpg',
          credit_id: '5dff3309d1a8930014891ed6',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 1,
          id: 1405232,
          known_for_department: 'Sound',
          name: 'Laura Harris Atkinson',
          original_name: 'Laura Harris Atkinson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff32e3d1a893001288e95c',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1406826,
          known_for_department: 'Sound',
          name: 'Hector C. Gika',
          original_name: 'Hector C. Gika',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1yJ3xp1jj4Az44n6fdIw4F6lCz6.jpg',
          credit_id: '5dff33e4d236e600108e56fc',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1408395,
          known_for_department: 'Lighting',
          name: 'Frans Wetterings III',
          original_name: 'Frans Wetterings III',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff3abdd1a893001288f5eb',
          department: 'Lighting',
          job: 'Chief Lighting Technician',
        },
        {
          adult: false,
          gender: 2,
          id: 1412643,
          known_for_department: 'Sound',
          name: 'Ryan Young',
          original_name: 'Ryan Young',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff36f626dac1001761f0d9',
          department: 'Sound',
          job: 'ADR Recordist',
        },
        {
          adult: false,
          gender: 0,
          id: 1440272,
          known_for_department: 'Editing',
          name: 'Brett Carroll',
          original_name: 'Brett Carroll',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff375f26dac1001761f163',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1447941,
          known_for_department: 'Costume & Make-Up',
          name: 'Nichole Pleau',
          original_name: 'Nichole Pleau',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff2d6b26dac10014623541',
          department: 'Costume & Make-Up',
          job: 'Key Makeup Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 1449446,
          known_for_department: 'Editing',
          name: 'Matt Willard',
          original_name: 'Matt Willard',
          popularity: 0.994,
          profile_path: null,
          credit_id: '5dff37c2d1a893001288ee7a',
          department: 'Editing',
          job: 'Assistant Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1459221,
          known_for_department: 'Sound',
          name: 'Brian Magrum',
          original_name: 'Brian Magrum',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff347ed236e600168e424d',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1461169,
          known_for_department: 'Sound',
          name: 'Gayle Wesley',
          original_name: 'Gayle Wesley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff36c29824c80017e1c7dd',
          department: 'Sound',
          job: 'Foley Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1464955,
          known_for_department: 'Costume & Make-Up',
          name: 'Cheryl Daniels',
          original_name: 'Cheryl Daniels',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5dff2d1c65686e0018947506',
          department: 'Costume & Make-Up',
          job: 'Key Hair Stylist',
        },
        {
          adult: false,
          gender: 1,
          id: 1478953,
          known_for_department: 'Directing',
          name: 'Cate Hardman',
          original_name: 'Cate Hardman',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5dff2fa426dac100126151bb',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1491848,
          known_for_department: 'Sound',
          name: 'Chris Navarro',
          original_name: 'Chris Navarro',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5dff34fed236e600168e4303',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1494535,
          known_for_department: 'Costume & Make-Up',
          name: 'Liz Pecos',
          original_name: 'Liz Pecos',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff38bb9824c80017e1ce68',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1500286,
          known_for_department: 'Sound',
          name: 'Carl Sealove',
          original_name: 'Carl Sealove',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff3826d236e600108e6050',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1506368,
          known_for_department: 'Costume & Make-Up',
          name: 'Autumn Butler',
          original_name: 'Autumn Butler',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff2ce1d1a893001288dd0b',
          department: 'Costume & Make-Up',
          job: 'Makeup Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 1532245,
          known_for_department: 'Costume & Make-Up',
          name: 'Senna Shanti',
          original_name: 'Senna Shanti',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5dff38e826dac100126162f7',
          department: 'Costume & Make-Up',
          job: 'Assistant Costume Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1537105,
          known_for_department: 'Costume & Make-Up',
          name: 'Juliet Loveland',
          original_name: 'Juliet Loveland',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff2d44d1a893001989c330',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1543203,
          known_for_department: 'Art',
          name: 'Rachel Block',
          original_name: 'Rachel Block',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5dff2c1fd236e600108e4dc3',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1550832,
          known_for_department: 'Sound',
          name: 'Ed Novick',
          original_name: 'Ed Novick',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c1077b60e0a2638b80f097e',
          department: 'Sound',
          job: 'Sound Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1575619,
          known_for_department: 'Camera',
          name: 'Christian Gibson',
          original_name: 'Christian Gibson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff39f3d1a893001288f3fe',
          department: 'Camera',
          job: 'Steadicam Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1608760,
          known_for_department: 'Art',
          name: 'Chris Sullivan',
          original_name: 'Chris Sullivan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff327165686e00159451db',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1717724,
          known_for_department: 'Production',
          name: 'Ben Harris',
          original_name: 'Ben Harris',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/p56oMFwshowbC049JPoO5h2qMwm.jpg',
          credit_id: '5dff2bd326dac1001462337c',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 1729094,
          known_for_department: 'Art',
          name: 'Anthony Raymond',
          original_name: 'Anthony Raymond',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff313f9824c80017e1be5d',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1737654,
          known_for_department: 'Sound',
          name: 'Judah Getz',
          original_name: 'Judah Getz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff33b9d236e600168e4177',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 1737660,
          known_for_department: 'Sound',
          name: 'David Jobe',
          original_name: 'David Jobe',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wej0TWRlW8mKuIQd5F8JMu7owdG.jpg',
          credit_id: '5dff341326dac1001761e7dc',
          department: 'Sound',
          job: 'Foley Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1739772,
          known_for_department: 'Art',
          name: 'Ashley L. Sykes',
          original_name: 'Ashley L. Sykes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff3294d1a893001989cdf9',
          department: 'Art',
          job: 'Set Decorating Coordinator',
        },
        {
          adult: false,
          gender: 1,
          id: 1739777,
          known_for_department: 'Costume & Make-Up',
          name: 'Elizabeth Clifford',
          original_name: 'Elizabeth Clifford',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff3871d236e600168e4982',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1739780,
          known_for_department: 'Camera',
          name: 'John Garrett',
          original_name: 'John Garrett',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff39df26dac1001761f442',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1760561,
          known_for_department: 'Crew',
          name: 'Steven Blizzard',
          original_name: 'Steven Blizzard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff395ad236e600128e5578',
          department: 'Camera',
          job: 'Drone Pilot',
        },
        {
          adult: false,
          gender: 0,
          id: 1769079,
          known_for_department: 'Sound',
          name: 'Joel Reidy',
          original_name: 'Joel Reidy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff35eed236e600128e5281',
          department: 'Sound',
          job: 'Boom Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1769789,
          known_for_department: 'Art',
          name: 'Morgan Kling',
          original_name: 'Morgan Kling',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff30ee65686e00139535c2',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 2,
          id: 1841285,
          known_for_department: 'Art',
          name: 'Steve Brennan',
          original_name: 'Steve Brennan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff31abd1a893001989cb7d',
          department: 'Art',
          job: 'Assistant Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 1904006,
          known_for_department: 'Production',
          name: 'Shari LaFranchi Blakney',
          original_name: 'Shari LaFranchi Blakney',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff300265686e0015944ca9',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1994224,
          known_for_department: 'Sound',
          name: "Thomas J. O'Connell",
          original_name: "Thomas J. O'Connell",
          popularity: 1.4,
          profile_path: null,
          credit_id: '5dff35329824c80017e1c3d1',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 2105488,
          known_for_department: 'Costume & Make-Up',
          name: 'Jennifer Lynn Tremblay',
          original_name: 'Jennifer Lynn Tremblay',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff390465686e0015945bea',
          department: 'Costume & Make-Up',
          job: 'Tailor',
        },
        {
          adult: false,
          gender: 0,
          id: 2137984,
          known_for_department: 'Crew',
          name: 'Joann Connolly',
          original_name: 'Joann Connolly',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff2de19824c80013e16126',
          department: 'Directing',
          job: 'Second Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2149470,
          known_for_department: 'Crew',
          name: 'Mark Menard',
          original_name: 'Mark Menard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff320526dac100126158c3',
          department: 'Art',
          job: 'Construction Foreman',
        },
        {
          adult: false,
          gender: 0,
          id: 2149479,
          known_for_department: 'Art',
          name: 'Adam McClain',
          original_name: 'Adam McClain',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff31f765686e0013953868',
          department: 'Art',
          job: 'Construction Foreman',
        },
        {
          adult: false,
          gender: 0,
          id: 2149494,
          known_for_department: 'Crew',
          name: 'Paula Bird',
          original_name: 'Paula Bird',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff316526dac10014623b20',
          department: 'Art',
          job: 'Painter',
        },
        {
          adult: false,
          gender: 1,
          id: 2161465,
          known_for_department: 'Crew',
          name: 'Juliana Potter',
          original_name: 'Juliana Potter',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff2ee665686e0013953324',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 2,
          id: 2193910,
          known_for_department: 'Camera',
          name: 'Chris Malenfant',
          original_name: 'Chris Malenfant',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff3a3a65686e0015945e82',
          department: 'Camera',
          job: 'Epk Camera Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 2246643,
          known_for_department: 'Editing',
          name: 'Roger Cooper',
          original_name: 'Roger Cooper',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff3787d236e600128e53c9',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2487967,
          known_for_department: 'Costume & Make-Up',
          name: 'Joanna Raskin',
          original_name: 'Joanna Raskin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff2db126dac1001761e017',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 2487969,
          known_for_department: 'Crew',
          name: 'Mark Freeman Schotz',
          original_name: 'Mark Freeman Schotz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff2efe26dac1001462379e',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 0,
          id: 2487972,
          known_for_department: 'Art',
          name: 'Lima Hyelim Kang',
          original_name: 'Lima Hyelim Kang',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff31db65686e00139537c2',
          department: 'Art',
          job: 'Graphic Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2487974,
          known_for_department: 'Art',
          name: 'David T. Parsons',
          original_name: 'David T. Parsons',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff321665686e00139538a4',
          department: 'Art',
          job: 'Construction Foreman',
        },
        {
          adult: false,
          gender: 0,
          id: 2487975,
          known_for_department: 'Art',
          name: 'James Rocci',
          original_name: 'James Rocci',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff32369824c80013e16925',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 2487977,
          known_for_department: 'Sound',
          name: 'Jeannette Browning',
          original_name: 'Jeannette Browning',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dff331c26dac10012615a18',
          department: 'Sound',
          job: 'ADR Recordist',
        },
        {
          adult: false,
          gender: 0,
          id: 2487984,
          known_for_department: 'Costume & Make-Up',
          name: 'Margaret Galvin',
          original_name: 'Margaret Galvin',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5dff3886d1a893001288f12a',
          department: 'Costume & Make-Up',
          job: 'Costume Coordinator',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'r96sk',
          author_details: {
            name: '',
            username: 'r96sk',
            avatar_path:
              '/https://secure.gravatar.com/avatar/96c2e0e4ac98450f9e8e3c0a0a40aad8.jpg',
            rating: 7.0,
          },
          content:
            "Like the first film, <em>'Daddy’s Home 2'</em> is nothing special but isn't bad either. A fine watch, nothing more or less.\r\n\r\nThe plot doesn't have nearly as many laughs as it needs, with that said there are a couple of decent bits - and some weird parts, particularly one at the end. Talking of the end, it's very cringe. Mark Wahlberg (Dusty) is probably the best onscreen, Will Ferrell (Brad) does well enough too.\r\n\r\nMel Gibson (Kurt) and John Lithgow (Don) are two newcomers. Both have one or two moments, though nothing more - I liked Lithgow the most. I kinda, somewhat randomly, felt Kurt Russell would've made a much better Kurt - didn't even clock the name clash before having that thought either, funnily enough. Linda Cardellini, meanwhile, is alright.\r\n\r\nIt needed more, but it's nothing notably worse than its predecessor which is always a positive for a sequel.",
          created_at: '2021-02-23T00:00:36.557Z',
          id: '603445a4be55b7003e953005',
          updated_at: '2021-06-23T15:58:52.177Z',
          url: 'https://www.themoviedb.org/review/603445a4be55b7003e953005',
        },
      ],
      total_pages: 1,
      total_results: 1,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/gkkBhctHPGg8hrmtWbO3ySZoj4z.jpg',
    belongs_to_collection: null,
    budget: 30000000,
    genres: [
      { id: 53, name: 'Phim Gây Cấn' },
      { id: 36, name: 'Phim Lịch Sử' },
      { id: 18, name: 'Phim Chính Kịch' },
    ],
    homepage: 'http://www.1517toparis.com',
    id: 453201,
    imdb_id: 'tt6802308',
    original_language: 'en',
    original_title: 'The 15:17 to Paris',
    overview:
      'The 15:17 to Paris là bộ phim tâm lý tiểu sử của Mỹ ra mắt vào năm 2018. Bộ phim tái hiện lại một câu chuyện có thật về 3 người lính Mỹ tình cờ ngăn chặn một vụ khủng bố diễn ra trên chuyến tàu Thalys đi từ Amsterdam đến Paris.  Câu chuyện bắt đầu khi ba người lính Mỹ cũng là ba người bạn thân Spencer Stone, Alek Skarlatos và Anthony Sadler quyết định cùng nhau đi du lịch bụi khắp Châu Âu trong thời gian được nghỉ phép. Khi cả ba cùng lên chuyến tàu Thalys đi từ Amsterdam đến Paris, một tình huống bất ngờ đã xảy ra khi hành khách trên tàu phát hiện ra một người Hồi giáo bí ẩn có tên là Khazzani mang theo rất nhiều vũ khí sát thương hạng nặng lên tàu trong đó bao gồm cả khẩu súng lớn Kalashnikov.  Tuy nhiên ngay khi Khazzani chuẩn bị dùng súng để tấn công các hành khách trên tàu thì ba người lính dũng cảm đã nhanh chóng trấn áp hắn đồng thời  chặn đứng vụ khủng bố sắp sửa diễn ra.',
    popularity: 17.212,
    poster_path:
      'https://image.tmdb.org/t/p/w342/qxJQ0VBCuJkJhJmuWzxI408ngwd.jpg',
    production_companies: [
      {
        id: 174,
        logo_path: '/IuAlhI9eVC9Z8UQWOIDdWRKSEJ.png',
        name: 'Warner Bros. Pictures',
        origin_country: 'US',
      },
      {
        id: 171,
        logo_path: null,
        name: 'Malpaso Productions',
        origin_country: 'US',
      },
      {
        id: 79,
        logo_path: '/tpFpsqbleCzEE2p5EgvUq6ozfCA.png',
        name: 'Village Roadshow Pictures',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2018-02-02',
    revenue: 57076286,
    runtime: 1,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'In the face of fear ordinary people can do the extraordinary',
    title: 'Những Người Hùng Paris',
    video: false,
    vote_average: 5.4,
    vote_count: 1346,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The 15:17 To Paris - Trailer',
          key: 'PtngiTJZTos',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2018-04-23T15:27:34.000Z',
          id: '5eac9bc2ba131b001d432be5',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'THE 15:17 TO PARIS - Official Trailer [HD]',
          key: 'IC_lnyn2R2Q',
          published_at: '2017-12-13T14:12:41.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '5a315262c3a3680b9d1787af',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 1956664,
          known_for_department: 'Diễn viên',
          name: 'Ray Corasani',
          original_name: 'Ray Corasani',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dKlxWvrXnIX5UkOFHWXoLqO4CpB.jpg',
          cast_id: 15,
          character: 'Ayoub',
          credit_id: '5a54c3fc0e0a2607d700f072',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 1956663,
          known_for_department: 'Diễn viên',
          name: 'Spencer Stone',
          original_name: 'Spencer Stone',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yL6DJbzHmxhLwk5ajDrnMvaOiDX.jpg',
          cast_id: 13,
          character: 'Himself',
          credit_id: '5a54c39fc3a3685ebf00e32b',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 1861739,
          known_for_department: 'Diễn viên',
          name: 'Anthony Sadler',
          original_name: 'Anthony Sadler',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9xrFzaRCDzQKC3ki6m7h77nes3q.jpg',
          cast_id: 37,
          character: 'Himself',
          credit_id: '5a7e19dbc3a36817bf005d26',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 1956662,
          known_for_department: 'Diễn viên',
          name: 'Alek Skarlatos',
          original_name: 'Alek Skarlatos',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aoXqkTqbyoMkX0LbBa3ASFp7KGM.jpg',
          cast_id: 14,
          character: 'Himself',
          credit_id: '5a54c3bac3a3685ee600dd36',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 20750,
          known_for_department: 'Diễn viên',
          name: 'Judy Greer',
          original_name: 'Judy Greer',
          popularity: 10.006,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pTLjIjh83R424RGxIfq4U0yx947.jpg',
          cast_id: 6,
          character: 'Joyce Eskel',
          credit_id: '5a39c5cbc3a36814b907fc01',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 51856,
          known_for_department: 'Diễn viên',
          name: 'Jenna Fischer',
          original_name: 'Jenna Fischer',
          popularity: 6.827,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tMq4qJ8bbZqJqde9BSrAWe06vQP.jpg',
          cast_id: 5,
          character: 'Heidi Skarlatos',
          credit_id: '5a39c5a90e0a264cd020972b',
          order: 5,
        },
        {
          adult: false,
          gender: 0,
          id: 1975195,
          known_for_department: 'Diễn viên',
          name: 'William Jennings',
          original_name: 'William Jennings',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jkscyZorav3q3FtXRRpmYfQ6mnk.jpg',
          cast_id: 38,
          character: 'Young Spencer',
          credit_id: '5a7e1a6b0e0a2654f30060a4',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 1975196,
          known_for_department: 'Diễn viên',
          name: 'Paul-Mikél Williams',
          original_name: 'Paul-Mikél Williams',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5f6YOmEZkAzt95Hm2oihuvRCdRK.jpg',
          cast_id: 40,
          character: 'Young Anthony',
          credit_id: '5a7e1ac1c3a36817b5005630',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 1668151,
          known_for_department: 'Diễn viên',
          name: 'Bryce Gheisar',
          original_name: 'Bryce Gheisar',
          popularity: 2.601,
          profile_path:
            'https://image.tmdb.org/t/p/w185/62kQs2PogzLtS56UDQMZGrtvDUW.jpg',
          cast_id: 8,
          character: 'Young Alek',
          credit_id: '5a39c6000e0a264cbe201763',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 539,
          known_for_department: 'Diễn viên',
          name: 'Thomas Lennon',
          original_name: 'Thomas Lennon',
          popularity: 3.833,
          profile_path:
            'https://image.tmdb.org/t/p/w185/s8pw7BfuMxN7P0p5XJ9POfod7zW.jpg',
          cast_id: 41,
          character: 'Principal Michael Akers',
          credit_id: '5a7e1af4c3a36817bf005e02',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 1211946,
          known_for_department: 'Diễn viên',
          name: 'P. J. Byrne',
          original_name: 'P. J. Byrne',
          popularity: 1.447,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sKqr3A3LjLYlRCXJGJI8rjpdMOs.jpg',
          cast_id: 39,
          character: 'Mr. Henry',
          credit_id: '5a7e1a9d9251416ad1005421',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 87079,
          known_for_department: 'Diễn viên',
          name: 'Jaleel White',
          original_name: 'Jaleel White',
          popularity: 1.64,
          profile_path:
            'https://image.tmdb.org/t/p/w185/txSsldskYkO4PbxKML8NvUq2sCk.jpg',
          cast_id: 9,
          character: 'Garrett Walden',
          credit_id: '5a39c61d9251410324205b72',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 25147,
          known_for_department: 'Diễn viên',
          name: 'Tony Hale',
          original_name: 'Tony Hale',
          popularity: 6.366,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ar4uapp4w5wMkThZcqWUNMSTO8z.jpg',
          cast_id: 36,
          character: 'Coach Murray',
          credit_id: '5a7e19120e0a2654e7005e94',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 97844,
          known_for_department: 'Diễn viên',
          name: 'Robert Pralgo',
          original_name: 'Robert Pralgo',
          popularity: 1.348,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lF2UcQemojihJM4XlLGkWEEsJuJ.jpg',
          cast_id: 42,
          character: 'Mr. Skarlatos',
          credit_id: '5a7e1b169251416ad40056c5',
          order: 13,
        },
        {
          adult: false,
          gender: 1,
          id: 1265852,
          known_for_department: 'Diễn viên',
          name: 'Alisa Allapach',
          original_name: 'Alisa Allapach',
          popularity: 1.466,
          profile_path:
            'https://image.tmdb.org/t/p/w185/o4qJkgBT7amTaMczm4No3vNAoxE.jpg',
          cast_id: 43,
          character: 'Lisa',
          credit_id: '5a7e1b3c9251416ace0055e4',
          order: 14,
        },
        {
          adult: false,
          gender: 1,
          id: 1521843,
          known_for_department: 'Diễn viên',
          name: 'Jeanne Goursaud',
          original_name: 'Jeanne Goursaud',
          popularity: 4.023,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pM1bL8MCNC8ZrofSJ0aAaee3sIs.jpg',
          cast_id: 44,
          character: 'Lea',
          credit_id: '5a7e1b539251416add00568a',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 964848,
          known_for_department: 'Diễn viên',
          name: 'Ethan Rains',
          original_name: 'Ethan Rains',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pfg0mBcN3WytEemCc16MXKO9Ycf.jpg',
          cast_id: 45,
          character: 'Ben Zomerdyk',
          credit_id: '5a7e1b6cc3a36817b50056ad',
          order: 16,
        },
        {
          adult: false,
          gender: 0,
          id: 1181558,
          known_for_department: 'Diễn viên',
          name: 'Seth Meriwether',
          original_name: 'Seth Meriwether',
          popularity: 1.538,
          profile_path:
            'https://image.tmdb.org/t/p/w185/c2SlCLZWrw91tE1ZGuswx2W1Byj.jpg',
          cast_id: 46,
          character: 'Francis',
          credit_id: '5a7e1b990e0a2654e7006097',
          order: 17,
        },
        {
          adult: false,
          gender: 1,
          id: 1388928,
          known_for_department: 'Diễn viên',
          name: 'Irene White',
          original_name: 'Irene White',
          popularity: 1.537,
          profile_path:
            'https://image.tmdb.org/t/p/w185/h36SC97lS8Fy46viYlrp4sCNRJG.jpg',
          cast_id: 47,
          character: 'Elementary Teacher',
          credit_id: '5a7e1bc8c3a36817db0050db',
          order: 18,
        },
        {
          adult: false,
          gender: 1,
          id: 2000489,
          known_for_department: 'Diễn viên',
          name: 'Julianne Binard',
          original_name: 'Julianne Binard',
          popularity: 1.614,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rTCZ0S23IYq6JMd2oTMQZcPZRZj.jpg',
          cast_id: 48,
          character: 'Jennifer',
          credit_id: '5aad558692514116ba014546',
          order: 19,
        },
        {
          adult: false,
          gender: 1,
          id: 1126301,
          known_for_department: 'Diễn viên',
          name: 'Alix Bénézech',
          original_name: 'Alix Bénézech',
          popularity: 2.259,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dyPVcKkDl95XDwNeduWbsoPbEk2.jpg',
          cast_id: 49,
          character: 'Server',
          credit_id: '5aad55ad92514116b10148f8',
          order: 20,
        },
        {
          adult: false,
          gender: 0,
          id: 1720043,
          known_for_department: 'Diễn viên',
          name: 'Lillian Solange Beaudoin',
          original_name: 'Lillian Solange Beaudoin',
          popularity: 2.129,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nX4GuIRClLzxIc7GpMjgSt1Ym69.jpg',
          cast_id: 7,
          character: 'Carolyn',
          credit_id: '5a39c5e9c3a3680b882081f7',
          order: 21,
        },
        {
          adult: false,
          gender: 2,
          id: 1691431,
          known_for_department: 'Crew',
          name: 'Matt Thompson',
          original_name: 'Matt Thompson',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mQTaGaIHDLLeUXx6iG0ZryqWXC6.jpg',
          cast_id: 155,
          character: 'Man on Train',
          credit_id: '5c2c4077c3a3682908a2561c',
          order: 22,
        },
        {
          adult: false,
          gender: 1,
          id: 1460731,
          known_for_department: 'Diễn viên',
          name: 'Camille Razat',
          original_name: 'Camille Razat',
          popularity: 12.746,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iNOrfcHK0Ahr9w3spUbEtI9niyO.jpg',
          cast_id: 50,
          character: 'Train Attendant #1',
          credit_id: '5aad55c7c3a36846d50144b5',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 2004111,
          known_for_department: 'Diễn viên',
          name: 'Braxton Bjerken',
          original_name: 'Braxton Bjerken',
          popularity: 1.754,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3fQA8q4L7320p3pqWq1rVLXqQsa.jpg',
          cast_id: 199,
          character: 'Everett Stone (uncredited)',
          credit_id: '6061a2b253866e003d61f773',
          order: 24,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 190,
          known_for_department: 'Diễn viên',
          name: 'Clint Eastwood',
          original_name: 'Clint Eastwood',
          popularity: 17.836,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dU35NnjZ4aGw5abIJe3WXVf3Eey.jpg',
          credit_id: '58f90e7592514106e200016e',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 190,
          known_for_department: 'Diễn viên',
          name: 'Clint Eastwood',
          original_name: 'Clint Eastwood',
          popularity: 17.836,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dU35NnjZ4aGw5abIJe3WXVf3Eey.jpg',
          credit_id: '58fa60dac3a36879f40007ef',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 460,
          known_for_department: 'Camera',
          name: 'Tom Stern',
          original_name: 'Tom Stern',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wKcwnnvdWrGBqdho0SYSp7xFKv7.jpg',
          credit_id: '5a7a1f57c3a368226502d348',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 1,
          id: 461,
          known_for_department: 'Costume & Make-Up',
          name: 'Deborah Hopper',
          original_name: 'Deborah Hopper',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/A5WFHouyxu7CDZKP7gCRDHFeOjK.jpg',
          credit_id: '5a7a1fcc925141775c0295e9',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 2,
          id: 1296,
          known_for_department: 'Production',
          name: 'Bruce Berman',
          original_name: 'Bruce Berman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b20a9076ce800242cc312',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 2529,
          known_for_department: 'Art',
          name: 'Ronald R. Reiss',
          original_name: 'Ronald R. Reiss',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a7a1fb6925141775702b788',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 45762,
          known_for_department: 'Lighting',
          name: 'Erno Das',
          original_name: 'Erno Das',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb813c3a3687d2000888b',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 10571,
          known_for_department: 'Production',
          name: 'John Bernard',
          original_name: 'John Bernard',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5e9b20cceb79c200205b8c48',
          department: 'Production',
          job: 'Line Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 6878,
          known_for_department: 'Art',
          name: 'Kevin Ishioka',
          original_name: 'Kevin Ishioka',
          popularity: 1.62,
          profile_path: null,
          credit_id: '5a7a1f71c3a368226502d362',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 2,
          id: 8748,
          known_for_department: 'Production',
          name: 'Enzo Sisti',
          original_name: 'Enzo Sisti',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b20fd310325001ac71264',
          department: 'Production',
          job: 'Line Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 9025,
          known_for_department: 'Art',
          name: 'James E. Tocci',
          original_name: 'James E. Tocci',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5b2bb4ef92514164e600665f',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 9439,
          known_for_department: 'Sound',
          name: 'Catherine Harper',
          original_name: 'Catherine Harper',
          popularity: 0.766,
          profile_path: null,
          credit_id: '5e9b2391d18fb9001b8eeba4',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 63946,
          known_for_department: 'Production',
          name: 'Tim Moore',
          original_name: 'Tim Moore',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58fa60f2c3a36879db0008d6',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 63946,
          known_for_department: 'Production',
          name: 'Tim Moore',
          original_name: 'Tim Moore',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b215bfd6fa100240205cd',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 2,
          id: 83091,
          known_for_department: 'Sound',
          name: 'Dean A. Zupancic',
          original_name: 'Dean A. Zupancic',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b256b076ce800242cc8ea',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 117202,
          known_for_department: 'Production',
          name: 'Erwin Godschalk',
          original_name: 'Erwin Godschalk',
          popularity: 0.838,
          profile_path: null,
          credit_id: '5e9b20e2e22d28001b5fb2f9',
          department: 'Production',
          job: 'Line Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 230436,
          known_for_department: 'Production',
          name: 'Barbara Harris',
          original_name: 'Barbara Harris',
          popularity: 2.086,
          profile_path:
            'https://image.tmdb.org/t/p/w185/d1BGeZT2b81Wa9gCOPdrXGWUtmR.jpg',
          credit_id: '5b2bbb690e0a260860007643',
          department: 'Production',
          job: 'ADR Voice Casting',
        },
        {
          adult: false,
          gender: 1,
          id: 935494,
          known_for_department: 'Production',
          name: 'Eve Streger',
          original_name: 'Eve Streger',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbbae0e0a260854007191',
          department: 'Production',
          job: 'Casting Associate',
        },
        {
          adult: false,
          gender: 2,
          id: 937622,
          known_for_department: 'Crew',
          name: 'Charles-Axel Vollard',
          original_name: 'Charles-Axel Vollard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbf47c3a3687dfe00687c',
          department: 'Visual Effects',
          job: 'Special Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1061203,
          known_for_department: 'Editing',
          name: 'Blu Murray',
          original_name: 'Blu Murray',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5zSabDsf704LN2IkctaYrV2iunR.jpg',
          credit_id: '5a7a1f62c3a368225102a669',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1073096,
          known_for_department: 'Sound',
          name: 'Christian Jacob',
          original_name: 'Christian Jacob',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a7a1f400e0a26599102e9bc',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 0,
          id: 1178615,
          known_for_department: 'Camera',
          name: 'Liz Radley',
          original_name: 'Liz Radley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbfe6c3a3687dfb007ae3',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1181575,
          known_for_department: 'Camera',
          name: 'Keith Bernstein',
          original_name: 'Keith Bernstein',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb9850e0a2608750072f9',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 0,
          id: 1181576,
          known_for_department: 'Lighting',
          name: 'Ross Dunkerley',
          original_name: 'Ross Dunkerley',
          popularity: 0.972,
          profile_path: null,
          credit_id: '5b2bb7f492514164d5005074',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1322015,
          known_for_department: 'Costume & Make-Up',
          name: 'Luisa Abel',
          original_name: 'Luisa Abel',
          popularity: 1.05,
          profile_path: null,
          credit_id: '5b2bbafa92514164ce00653b',
          department: 'Costume & Make-Up',
          job: 'Makeup Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 1323092,
          known_for_department: 'Costume & Make-Up',
          name: 'Mitchell Ray Kenney',
          original_name: 'Mitchell Ray Kenney',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbcb60e0a2608560072ca',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1335882,
          known_for_department: 'Visual Effects',
          name: 'Kerstin Kensy',
          original_name: 'Kerstin Kensy',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5b2bc0dc92514164fc007731',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1338147,
          known_for_department: 'Art',
          name: 'Bruce DiValerio',
          original_name: 'Bruce DiValerio',
          popularity: 0.605,
          profile_path: null,
          credit_id: '5b2bb2e392514164ce006173',
          department: 'Art',
          job: 'Construction Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1338372,
          known_for_department: 'Sound',
          name: "Dan O'Connell",
          original_name: "Dan O'Connell",
          popularity: 1.665,
          profile_path: null,
          credit_id: '5e9b23a5d18fb9001d8ee821',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1339439,
          known_for_department: 'Art',
          name: 'Lindsay Good',
          original_name: 'Lindsay Good',
          popularity: 1.094,
          profile_path: null,
          credit_id: '5b2bb1f092514164e0006257',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1342626,
          known_for_department: 'Sound',
          name: 'John T. Reitz',
          original_name: 'John T. Reitz',
          popularity: 1.566,
          profile_path: null,
          credit_id: '5a7a200ac3a3682261028654',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1357067,
          known_for_department: 'Costume & Make-Up',
          name: 'Corey Bronson',
          original_name: 'Corey Bronson',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5b2bbd8b92514164ca00613b',
          department: 'Costume & Make-Up',
          job: 'Key Set Costumer',
        },
        {
          adult: false,
          gender: 1,
          id: 1364410,
          known_for_department: 'Sound',
          name: 'Julie Feiner',
          original_name: 'Julie Feiner',
          popularity: 0.972,
          profile_path: null,
          credit_id: '5e9b22b8e22d28001b5fb730',
          department: 'Sound',
          job: 'ADR Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1367493,
          known_for_department: 'Sound',
          name: 'John T. Cucci',
          original_name: 'John T. Cucci',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b2381eb79c200275b6de2',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1367665,
          known_for_department: 'Sound',
          name: 'Craig Dollinger',
          original_name: 'Craig Dollinger',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b2336fd6fa1001f0204b9',
          department: 'Sound',
          job: 'Boom Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 1368865,
          known_for_department: 'Sound',
          name: 'Alan Robert Murray',
          original_name: 'Alan Robert Murray',
          popularity: 0.828,
          profile_path:
            'https://image.tmdb.org/t/p/w185/76bFzsbABwtFk2nUgHLIpVHui5V.jpg',
          credit_id: '5a7a1ffd0e0a26598e02e0f7',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1377131,
          known_for_department: 'Camera',
          name: 'Stephen S. Campanelli',
          original_name: 'Stephen S. Campanelli',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5b2bb688925141650f007545',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1377291,
          known_for_department: 'Sound',
          name: 'Gautier Isern',
          original_name: 'Gautier Isern',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b2349076ce8001f2cdb75',
          department: 'Sound',
          job: 'Boom Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1386904,
          known_for_department: 'Art',
          name: 'Bria Kinter',
          original_name: 'Bria Kinter',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb4dec3a3687d17006852',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1387246,
          known_for_department: 'Sound',
          name: 'Willard Overstreet',
          original_name: 'Willard Overstreet',
          popularity: 0.73,
          profile_path: null,
          credit_id: '5e9b23ca4a4bfc001ed4e276',
          department: 'Sound',
          job: 'Foley Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1400399,
          known_for_department: 'Sound',
          name: 'Katherine Rose',
          original_name: 'Katherine Rose',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b23b7e22d28001d5fc17c',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 1404717,
          known_for_department: 'Sound',
          name: 'Curt Schulkey',
          original_name: 'Curt Schulkey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b236d076ce8001d2cdd15',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1407372,
          known_for_department: 'Editing',
          name: 'Adam Ohl',
          original_name: 'Adam Ohl',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bc0ac92514164ed006162',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1409719,
          known_for_department: 'Editing',
          name: 'Erik Kaufmann',
          original_name: 'Erik Kaufmann',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b1e64d18fb9001d8ee33f',
          department: 'Editing',
          job: 'Digital Intermediate Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1415617,
          known_for_department: 'Sound',
          name: 'Adam Kopald',
          original_name: 'Adam Kopald',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b246ae22d28001d5fc1f0',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1417399,
          known_for_department: 'Costume & Make-Up',
          name: 'Patricia DeHaney',
          original_name: 'Patricia DeHaney',
          popularity: 0.968,
          profile_path: null,
          credit_id: '5b2bba15c3a3687d30005ed2',
          department: 'Costume & Make-Up',
          job: 'Hair Department Head',
        },
        {
          adult: false,
          gender: 2,
          id: 1418398,
          known_for_department: 'Camera',
          name: 'Will Arnot',
          original_name: 'Will Arnot',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb6e30e0a260851007587',
          department: 'Camera',
          job: 'Steadicam Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1424160,
          known_for_department: 'Sound',
          name: 'Cameron Steenhagen',
          original_name: 'Cameron Steenhagen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b25a3eec4f3001cac84b4',
          department: 'Sound',
          job: 'Supervising Dialogue Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1428595,
          known_for_department: 'Sound',
          name: 'Jason King',
          original_name: 'Jason King',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a7a1fe4925141775702b7af',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1428596,
          known_for_department: 'Sound',
          name: 'Kevin Murray',
          original_name: 'Kevin Murray',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b2452eec4f3001eac7104',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1428596,
          known_for_department: 'Sound',
          name: 'Kevin Murray',
          original_name: 'Kevin Murray',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b1d71e22d2800225fa4f3',
          department: 'Editing',
          job: 'Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1432033,
          known_for_department: 'Costume & Make-Up',
          name: 'Heather Mages',
          original_name: 'Heather Mages',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5b2bba940e0a26084e007182',
          department: 'Costume & Make-Up',
          job: 'Key Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1452641,
          known_for_department: 'Art',
          name: "Timothy David O'Brien",
          original_name: "Timothy David O'Brien",
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a7a1f7bc3a36822610285d7',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1452689,
          known_for_department: 'Production',
          name: 'Patrick Mignano',
          original_name: 'Patrick Mignano',
          popularity: 0.618,
          profile_path: null,
          credit_id: '5e9b2036eb79c200205b8bac',
          department: 'Production',
          job: 'Associate Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1458583,
          known_for_department: 'Editing',
          name: 'Bob Peishel',
          original_name: 'Bob Peishel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b1e98eb79c2001e5b799f',
          department: 'Editing',
          job: 'Digital Intermediate Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1464955,
          known_for_department: 'Costume & Make-Up',
          name: 'Cheryl Daniels',
          original_name: 'Cheryl Daniels',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5b2bba680e0a2608540070a4',
          department: 'Costume & Make-Up',
          job: 'Key Hair Stylist',
        },
        {
          adult: false,
          gender: 2,
          id: 1466245,
          known_for_department: 'Sound',
          name: 'Steven Morrow',
          original_name: 'Steven Morrow',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a7a1fefc3a368227302d6a4',
          department: 'Sound',
          job: 'Sound Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1466775,
          known_for_department: 'Art',
          name: 'Massimo Pauletto',
          original_name: 'Massimo Pauletto',
          popularity: 1.094,
          profile_path: null,
          credit_id: '5a7a1f85925141775702b766',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1531512,
          known_for_department: 'Crew',
          name: 'Joseph Farrant',
          original_name: 'Joseph Farrant',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5b2bc07bc3a3687d20008ed6',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1533035,
          known_for_department: 'Crew',
          name: 'Marc Leroyer',
          original_name: 'Marc Leroyer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbe9ec3a3687d11007ff3',
          department: 'Crew',
          job: 'Armorer',
        },
        {
          adult: false,
          gender: 0,
          id: 1549255,
          known_for_department: 'Lighting',
          name: 'Brent Studler',
          original_name: 'Brent Studler',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb7520e0a260856006fdb',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 1559784,
          known_for_department: 'Art',
          name: 'Kil Won Yu',
          original_name: 'Kil Won Yu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb50092514164f2007018',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1564250,
          known_for_department: 'Sound',
          name: 'James Ashwill',
          original_name: 'James Ashwill',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b24074a4bfc001cd4e6ac',
          department: 'Sound',
          job: 'Foley Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1565732,
          known_for_department: 'Art',
          name: 'Aimee Athnos',
          original_name: 'Aimee Athnos',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb20692514164e000625e',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1567459,
          known_for_department: 'Lighting',
          name: 'Steve Zigler',
          original_name: 'Steve Zigler',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb9280e0a2608750072ce',
          department: 'Lighting',
          job: 'Rigging Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1599059,
          known_for_department: 'Costume & Make-Up',
          name: 'Catherine Jabes',
          original_name: 'Catherine Jabes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bba260e0a26085a006c4a',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1606663,
          known_for_department: 'Lighting',
          name: 'Buzzy Burwell',
          original_name: 'Buzzy Burwell',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5b2bb62ac3a3687d2000877c',
          department: 'Lighting',
          job: 'Best Boy Electric',
        },
        {
          adult: false,
          gender: 0,
          id: 1616041,
          known_for_department: 'Camera',
          name: 'Hugues Espinasse',
          original_name: 'Hugues Espinasse',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb6a19251416522006672',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 1630948,
          known_for_department: 'Art',
          name: 'Emmanuel Delis',
          original_name: 'Emmanuel Delis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a7a1f9fc3a368226502d37e',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 1,
          id: 1634057,
          known_for_department: 'Costume & Make-Up',
          name: 'Odile Fourquin',
          original_name: 'Odile Fourquin',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9RNDrKiiMk7x9vXD1oZaG7jamUW.jpg',
          credit_id: '5b2bbaa90e0a2608600075ea',
          department: 'Costume & Make-Up',
          job: 'Key Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1635156,
          known_for_department: 'Costume & Make-Up',
          name: 'LuAndra Whitehurst',
          original_name: 'LuAndra Whitehurst',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbabbc3a3687d30005f0e',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1635180,
          known_for_department: 'Crew',
          name: 'Brian C.A. Thomas',
          original_name: 'Brian C.A. Thomas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb407925141650f0073a1',
          department: 'Crew',
          job: 'Scenic Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1635275,
          known_for_department: 'Costume & Make-Up',
          name: 'Tony KoTrung Quốcs',
          original_name: 'Tony KoTrung Quốcs',
          popularity: 0.608,
          profile_path: null,
          credit_id: '5b2bbcfac3a3687d2c00647e',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1643706,
          known_for_department: 'Production',
          name: 'Jessica Meier',
          original_name: 'Jessica Meier',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58fa6117925141642f000860',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1643708,
          known_for_department: 'Production',
          name: 'Kristina Rivera',
          original_name: 'Kristina Rivera',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58fa6104925141642f000851',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1643713,
          known_for_department: 'Directing',
          name: 'David M. Bernstein',
          original_name: 'David M. Bernstein',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b2061eb79c2001e5b7b45',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1643713,
          known_for_department: 'Directing',
          name: 'David M. Bernstein',
          original_name: 'David M. Bernstein',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b1f19eec4f3001cac7f03',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1643720,
          known_for_department: 'Art',
          name: 'Greg Gonzalez',
          original_name: 'Greg Gonzalez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb23d0e0a26084a006d82',
          department: 'Art',
          job: 'Assistant Property Master',
        },
        {
          adult: false,
          gender: 2,
          id: 1646494,
          known_for_department: 'Sound',
          name: 'Steven Ghouti',
          original_name: 'Steven Ghouti',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/r79XoDhXwW5IdI6EJodoKClLIKI.jpg',
          credit_id: '5e9b22cfeb79c200275b6cbd',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1661081,
          known_for_department: 'Directing',
          name: 'Sunil Kumar Yadav',
          original_name: 'Sunil Kumar Yadav',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bc03b9251416507007d52',
          department: 'Visual Effects',
          job: 'Digital Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 1683361,
          known_for_department: 'Art',
          name: 'Julien Pougnier',
          original_name: 'Julien Pougnier',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb19392514165070073ce',
          department: 'Art',
          job: 'Supervising Art Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1703013,
          known_for_department: 'Art',
          name: 'Mick Cummings',
          original_name: 'Mick Cummings',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb4449251416503005c07',
          department: 'Art',
          job: 'Set Decoration Buyer',
        },
        {
          adult: false,
          gender: 0,
          id: 1736643,
          known_for_department: 'Costume & Make-Up',
          name: 'Vicente Parada',
          original_name: 'Vicente Parada',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbd3192514165220069dc',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1738628,
          known_for_department: 'Art',
          name: 'Letizia Santucci',
          original_name: 'Letizia Santucci',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a7a1fc10e0a26599402db3c',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 1746045,
          known_for_department: 'Visual Effects',
          name: 'Richard R. Reed',
          original_name: 'Richard R. Reed',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bc10692514164f200778f',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1746157,
          known_for_department: 'Production',
          name: 'Franco Basaglia',
          original_name: 'Franco Basaglia',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b1f563103250021c71005',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1757637,
          known_for_department: 'Sound',
          name: 'Roberto Dominguez Alegria',
          original_name: 'Roberto Dominguez Alegria',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b23de4a4bfc001ed4e282',
          department: 'Sound',
          job: 'Foley Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 1760572,
          known_for_department: 'Sound',
          name: 'Jason Oliver',
          original_name: 'Jason Oliver',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5e9b22e5e22d2800225faa1c',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1760573,
          known_for_department: 'Sound',
          name: 'Darrin Mann',
          original_name: 'Darrin Mann',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b241c4a4bfc001cd4e6b5',
          department: 'Sound',
          job: 'Foley Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1763654,
          known_for_department: 'Editing',
          name: 'Jeff Pantaleo',
          original_name: 'Jeff Pantaleo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b1e22eb79c2001e5b794f',
          department: 'Editing',
          job: 'Digital Colorist',
        },
        {
          adult: false,
          gender: 0,
          id: 1770991,
          known_for_department: 'Visual Effects',
          name: 'John Moffatt',
          original_name: 'John Moffatt',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bc0f20e0a2608750077c2',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1815823,
          known_for_department: 'Crew',
          name: 'John Slade',
          original_name: 'John Slade',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb99992514164d8006d47',
          department: 'Crew',
          job: 'Techno Crane Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1824235,
          known_for_department: 'Production',
          name: 'Roxanne Pinheiro',
          original_name: 'Roxanne Pinheiro',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b2199eb79c200275b6b5e',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 2,
          id: 1824276,
          known_for_department: 'Editing',
          name: 'Fred Brown II',
          original_name: 'Fred Brown II',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b1d8a4a4bfc001ed4dcdd',
          department: 'Editing',
          job: 'Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1825179,
          known_for_department: 'Art',
          name: 'Chuck McCourt',
          original_name: 'Chuck McCourt',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb586c3a3687d39005baa',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 1826450,
          known_for_department: 'Art',
          name: 'Nelson Hagood',
          original_name: 'Nelson Hagood',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb54e925141651a0064f5',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 1826980,
          known_for_department: 'Costume & Make-Up',
          name: 'Elodie Taquet',
          original_name: 'Elodie Taquet',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbaca0e0a260848007579',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1846000,
          known_for_department: 'Sound',
          name: 'Russell Gorsky',
          original_name: 'Russell Gorsky',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b24b3310325001ac7168d',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1849150,
          known_for_department: 'Camera',
          name: 'Laurent Schepman',
          original_name: 'Laurent Schepman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb66dc3a3687d2c006133',
          department: 'Camera',
          job: 'Best Boy Grip',
        },
        {
          adult: false,
          gender: 2,
          id: 1861739,
          known_for_department: 'Diễn viên',
          name: 'Anthony Sadler',
          original_name: 'Anthony Sadler',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9xrFzaRCDzQKC3ki6m7h77nes3q.jpg',
          credit_id: '5af33bad925141788f0001d2',
          department: 'Biên kịch',
          job: 'Book',
        },
        {
          adult: false,
          gender: 0,
          id: 1865470,
          known_for_department: 'Crew',
          name: 'Gustav Hoegen',
          original_name: 'Gustav Hoegen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbf1e9251416507007c8e',
          department: 'Crew',
          job: 'Animatronics Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1924206,
          known_for_department: 'Lighting',
          name: 'Paolo Sartori',
          original_name: 'Paolo Sartori',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb93bc3a3687d30005e6b',
          department: 'Lighting',
          job: 'Rigging Gaffer',
        },
        {
          adult: false,
          gender: 1,
          id: 1924207,
          known_for_department: 'Costume & Make-Up',
          name: 'Catherine Buyse Dian',
          original_name: 'Catherine Buyse Dian',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbdc5c3a3687d17006d76',
          department: 'Costume & Make-Up',
          job: 'Wardrobe Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1924210,
          known_for_department: 'Production',
          name: 'Fabrizio Cerato',
          original_name: 'Fabrizio Cerato',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b217a076ce800242cc3da',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1928000,
          known_for_department: 'Lighting',
          name: 'Kevin Jackson',
          original_name: 'Kevin Jackson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb96d92514164ca005f4c',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1928002,
          known_for_department: 'Lighting',
          name: 'Joseph Kendrick',
          original_name: 'Joseph Kendrick',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb94c92514164fc00731a',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 1,
          id: 1936701,
          known_for_department: 'Production',
          name: 'Tammy L. Smith',
          original_name: 'Tammy L. Smith',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbc04c3a3687d29006705',
          department: 'Production',
          job: 'Extras Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 1956657,
          known_for_department: 'Biên kịch',
          name: 'Dorothy Blyskal',
          original_name: 'Dorothy Blyskal',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af33b5c92514178b80001ac',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 1956662,
          known_for_department: 'Diễn viên',
          name: 'Alek Skarlatos',
          original_name: 'Alek Skarlatos',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aoXqkTqbyoMkX0LbBa3ASFp7KGM.jpg',
          credit_id: '5af33b890e0a26394b000208',
          department: 'Biên kịch',
          job: 'Book',
        },
        {
          adult: false,
          gender: 2,
          id: 1956663,
          known_for_department: 'Diễn viên',
          name: 'Spencer Stone',
          original_name: 'Spencer Stone',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yL6DJbzHmxhLwk5ajDrnMvaOiDX.jpg',
          credit_id: '5af33be492514178d800018a',
          department: 'Biên kịch',
          job: 'Book',
        },
        {
          adult: false,
          gender: 0,
          id: 1962600,
          known_for_department: 'Camera',
          name: 'Giorgio Pezzotti',
          original_name: 'Giorgio Pezzotti',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb656c3a3687d39005c14',
          department: 'Camera',
          job: 'Best Boy Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1973219,
          known_for_department: 'Lighting',
          name: 'Elvis Pasqual',
          original_name: 'Elvis Pasqual',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb8030e0a260871006c84',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1973818,
          known_for_department: 'Biên kịch',
          name: 'Jeffrey E. Stern',
          original_name: 'Jeffrey E. Stern',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af33c0b0e0a26396a00020d',
          department: 'Biên kịch',
          job: 'Book',
        },
        {
          adult: false,
          gender: 0,
          id: 2004523,
          known_for_department: 'Camera',
          name: 'François Vigon',
          original_name: 'François Vigon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb7b90e0a260869006a67',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2010416,
          known_for_department: 'Visual Effects',
          name: 'Paige Andrews',
          original_name: 'Paige Andrews',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bc068c3a3687d20008ec8',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2012545,
          known_for_department: 'Production',
          name: 'Nelson Dsouza',
          original_name: 'Nelson Dsouza',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bc0c6925141650a00806e',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2017021,
          known_for_department: 'Editing',
          name: 'Gina Zappala',
          original_name: 'Gina Zappala',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5e9b1eafeec4f3001cac7eae',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2038901,
          known_for_department: 'Costume & Make-Up',
          name: 'Maurizio Nardi',
          original_name: 'Maurizio Nardi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbb0ec3a3687d14007f26',
          department: 'Costume & Make-Up',
          job: 'Makeup Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2052478,
          known_for_department: 'Costume & Make-Up',
          name: 'Rhonda Earick',
          original_name: 'Rhonda Earick',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbc530e0a26086c007687',
          department: 'Costume & Make-Up',
          job: 'Ager/Dyer',
        },
        {
          adult: false,
          gender: 2,
          id: 2060934,
          known_for_department: 'Crew',
          name: 'Johnny Land',
          original_name: 'Johnny Land',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4fcEVu9muZIygv1QErdUzJ5ZgjX.jpg',
          credit_id: '5b2bb3f40e0a260856006dca',
          department: 'Crew',
          job: 'Scenic Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2069364,
          known_for_department: 'Crew',
          name: 'Yannick Heuveline',
          original_name: 'Yannick Heuveline',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb24d0e0a26087100696a',
          department: 'Crew',
          job: 'Carpenter',
        },
        {
          adult: false,
          gender: 0,
          id: 2069365,
          known_for_department: 'Art',
          name: 'Tommaso Borrelli',
          original_name: 'Tommaso Borrelli',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb36ec3a3687d39005aaa',
          department: 'Art',
          job: 'Graphic Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2069366,
          known_for_department: 'Art',
          name: 'Patrizio Lauria',
          original_name: 'Patrizio Lauria',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb3dcc3a3687d39005ad1',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 2069368,
          known_for_department: 'Art',
          name: 'Joshua Green',
          original_name: 'Joshua Green',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb4ad92514164ed005b09',
          department: 'Art',
          job: 'Set Decoration Buyer',
        },
        {
          adult: false,
          gender: 0,
          id: 2069369,
          known_for_department: 'Art',
          name: 'Tina Trottin',
          original_name: 'Tina Trottin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb4ca0e0a26085d006576',
          department: 'Art',
          job: 'Set Decoration Buyer',
        },
        {
          adult: false,
          gender: 0,
          id: 2069370,
          known_for_department: 'Art',
          name: 'Mathias Canard',
          original_name: 'Mathias Canard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb5110e0a26086c00729d',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2069371,
          known_for_department: 'Art',
          name: 'Sam Jones',
          original_name: 'Sam Jones',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb573c3a3687d1a005dd7',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2069372,
          known_for_department: 'Lighting',
          name: 'Pascal Doyen',
          original_name: 'Pascal Doyen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb64192514164ce0062d7',
          department: 'Lighting',
          job: 'Best Boy Electric',
        },
        {
          adult: false,
          gender: 0,
          id: 2069373,
          known_for_department: 'Camera',
          name: 'Arthur To',
          original_name: 'Arthur To',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb70992514164e6006762',
          department: 'Camera',
          job: 'Digital Imaging Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2069374,
          known_for_department: 'Camera',
          name: 'Roy van den Vlekkert',
          original_name: 'Roy van den Vlekkert',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb72092514164e6006786',
          department: 'Camera',
          job: 'Dolly Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2069375,
          known_for_department: 'Lighting',
          name: 'Christophe Bassoulet',
          original_name: 'Christophe Bassoulet',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb7320e0a26086000740e',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 2069376,
          known_for_department: 'Lighting',
          name: 'Pietro Rosso',
          original_name: 'Pietro Rosso',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb7410e0a2608510075c6',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 2069378,
          known_for_department: 'Lighting',
          name: 'Steven David Walton',
          original_name: 'Steven David Walton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb76292514164fc007237',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 2069379,
          known_for_department: 'Lighting',
          name: 'Matteo Caocci',
          original_name: 'Matteo Caocci',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb77092514164e60067b1',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 2069380,
          known_for_department: 'Lighting',
          name: 'Tommaso Copetta',
          original_name: 'Tommaso Copetta',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb782c3a3687dfe006449',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 2069381,
          known_for_department: 'Camera',
          name: 'Jeremy Mauroy',
          original_name: 'Jeremy Mauroy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb7ce0e0a26085600701b',
          department: 'Camera',
          job: 'First Assistant "B" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2069382,
          known_for_department: 'Lighting',
          name: 'Stéphane Assié',
          original_name: 'Stéphane Assié',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bb7e492514164d5005070',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 2069383,
          known_for_department: 'Lighting',
          name: 'Jeff LaBaume',
          original_name: 'Jeff LaBaume',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5b2bb8df0e0a26085d006780',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2069384,
          known_for_department: 'Lighting',
          name: 'Louis Rendemonti',
          original_name: 'Louis Rendemonti',
          popularity: 0.605,
          profile_path: null,
          credit_id: '5b2bb8ee92514165070078bd',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2069386,
          known_for_department: 'Costume & Make-Up',
          name: 'Marta Iacoponi',
          original_name: 'Marta Iacoponi',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5b2bba350e0a26085d006829',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 2069387,
          known_for_department: 'Costume & Make-Up',
          name: 'Maurilio Lazzaro',
          original_name: 'Maurilio Lazzaro',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bba44c3a3687d14007e90',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 2069389,
          known_for_department: 'Costume & Make-Up',
          name: 'Consuelo Vitturi',
          original_name: 'Consuelo Vitturi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bba56c3a3687d20008a29',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 2069390,
          known_for_department: 'Costume & Make-Up',
          name: 'Kay Philips',
          original_name: 'Kay Philips',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bba7b925141650f00773a',
          department: 'Costume & Make-Up',
          job: 'Key Hair Stylist',
        },
        {
          adult: false,
          gender: 1,
          id: 2069391,
          known_for_department: 'Costume & Make-Up',
          name: 'Maria Solberg Lepre',
          original_name: 'Maria Solberg Lepre',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbad80e0a260854007107',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2069392,
          known_for_department: 'Costume & Make-Up',
          name: 'Roberta Galesso',
          original_name: 'Roberta Galesso',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbae7c3a3687d14007f1d',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2069393,
          known_for_department: 'Production',
          name: 'Sierra Scott',
          original_name: 'Sierra Scott',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbb8492514165220068c7',
          department: 'Production',
          job: 'Casting Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2069394,
          known_for_department: 'Production',
          name: 'Kyle Allen Nichols',
          original_name: 'Kyle Allen Nichols',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbb990e0a260856007225',
          department: 'Production',
          job: 'Casting Associate',
        },
        {
          adult: false,
          gender: 0,
          id: 2069395,
          known_for_department: 'Production',
          name: 'Britt van der Gaag',
          original_name: 'Britt van der Gaag',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbbccc3a3687d36007c4a',
          department: 'Production',
          job: 'Extras Casting Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2069397,
          known_for_department: 'Costume & Make-Up',
          name: 'Felicia Leilani Jarvis',
          original_name: 'Felicia Leilani Jarvis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbc6e0e0a2608510078e8',
          department: 'Costume & Make-Up',
          job: 'Assistant Costume Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2069398,
          known_for_department: 'Costume & Make-Up',
          name: 'Raphaël Chouchan',
          original_name: 'Raphaël Chouchan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbc8792514164ed005f06',
          department: 'Costume & Make-Up',
          job: 'Costume Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2069399,
          known_for_department: 'Costume & Make-Up',
          name: 'Kristen Kadel',
          original_name: 'Kristen Kadel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbc9a9251416507007af6',
          department: 'Costume & Make-Up',
          job: 'Costume Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2069400,
          known_for_department: 'Costume & Make-Up',
          name: 'Jessica Croy',
          original_name: 'Jessica Croy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbcd10e0a2608560072de',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2069401,
          known_for_department: 'Costume & Make-Up',
          name: 'Jimmy Kenney',
          original_name: 'Jimmy Kenney',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5b2bbce2c3a3687d39005f45',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2069402,
          known_for_department: 'Costume & Make-Up',
          name: 'Josh Mar',
          original_name: 'Josh Mar',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbd14c3a3687d39005f68',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2069414,
          known_for_department: 'Visual Effects',
          name: 'Yuka Hosomi',
          original_name: 'Yuka Hosomi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bbfb2c3a3687d2300801c',
          department: 'Visual Effects',
          job: 'Digital Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 2069415,
          known_for_department: 'Visual Effects',
          name: 'Hemant Parshuram Sawant',
          original_name: 'Hemant Parshuram Sawant',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bc0010e0a260869006f27',
          department: 'Visual Effects',
          job: 'Digital Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 2069416,
          known_for_department: 'Visual Effects',
          name: 'Devendra Verma',
          original_name: 'Devendra Verma',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bc015925141651a006a6b',
          department: 'Visual Effects',
          job: 'Digital Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 2069419,
          known_for_department: 'Visual Effects',
          name: 'Vibhas Mathkar',
          original_name: 'Vibhas Mathkar',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b2bc0510e0a26084a007542',
          department: 'Visual Effects',
          job: 'Matte Painter',
        },
        {
          adult: false,
          gender: 0,
          id: 2130303,
          known_for_department: 'Editing',
          name: 'Maxine Gervais',
          original_name: 'Maxine Gervais',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b1ec7eb79c2001e5b79c4',
          department: 'Editing',
          job: 'Senior Colorist',
        },
        {
          adult: false,
          gender: 0,
          id: 2130884,
          known_for_department: 'Production',
          name: 'Chris Giuffrida',
          original_name: 'Chris Giuffrida',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b1dd3fd6fa1001f020055',
          department: 'Editing',
          job: 'Colorist',
        },
        {
          adult: false,
          gender: 2,
          id: 2142785,
          known_for_department: 'Sound',
          name: 'Christian Wenger',
          original_name: 'Christian Wenger',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b2324e22d28001d5fc0f8',
          department: 'Sound',
          job: 'Assistant Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2245695,
          known_for_department: 'Production',
          name: 'Prashant Sharan',
          original_name: 'Prashant Sharan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b21b63103250021c7127e',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 2266455,
          known_for_department: 'Sound',
          name: 'Jason Chiodo',
          original_name: 'Jason Chiodo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b2585d18fb9001b8eed7f',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 2318822,
          known_for_department: 'Editing',
          name: 'Travis Avitabile',
          original_name: 'Travis Avitabile',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b1e7eeec4f3001cac7e90',
          department: 'Editing',
          job: 'Digital Intermediate Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2606225,
          known_for_department: 'Visual Effects',
          name: 'Nicolas Rigaud',
          original_name: 'Nicolas Rigaud',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e9b1c88e22d28001b5fae9c',
          department: 'Visual Effects',
          job: '2D Supervisor',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'Screen-Space',
          author_details: {
            name: 'Screen-Space',
            username: 'Simon Foster',
            avatar_path:
              '/https://secure.gravatar.com/avatar/3bff69010e6f17c610be482a5c2623c0.jpg',
            rating: null,
          },
          content:
            '"An instinctual act of remarkable heroism is afforded the least remarkable effort of director Clint Eastwood’s long career.."\r\n\r\nRead the full review here: http://screen-space.squarespace.com/reviews/2018/2/8/the-1517-to-paris.html',
          created_at: '2018-02-08T05:00:59.891Z',
          id: '5a7bd98b9251414b1f007cd1',
          updated_at: '2021-06-23T15:58:04.992Z',
          url: 'https://www.themoviedb.org/review/5a7bd98b9251414b1f007cd1',
        },
      ],
      total_pages: 1,
      total_results: 1,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/4hEp8ZAycjitk7UOX0VpfSFnwRU.jpg',
    belongs_to_collection: null,
    budget: 24000000,
    genres: [
      { id: 10752, name: 'Phim Chiến Tranh' },
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 36, name: 'Phim Lịch Sử' },
    ],
    homepage: 'https://www.netflix.com/title/80067522',
    id: 433247,
    imdb_id: 'tt4882376',
    original_language: 'en',
    original_title: 'First They Killed My Father',
    overview:
      'Bộ phim dựa trên cuốn tự truyện của nhà hoạt động nhân quyền Campuchia Loung Ung Jolie, kể về câu chuyện có thật dưới thời kỳ Khmer Đỏ thống trị ở nước này trong những năm 1970 hay còn gọi là chế độ diệt chủng Pol Pot. Bên cạnh việc tái hiện lại thời kỳ đẫm máu ở xứ sở Chùa Vàng với hơn 7 triệu người dân bị giết hại, phim còn khắc họa chi tiết cuộc đời bi thương của một bé gái 5 tuổi tên Loung Ung (tác giả cuốn tự truyện). Đó là những năm tháng mà Loung Ung sẽ không bao giờ quên trong cuộc đời cô.',
    popularity: 12.194,
    poster_path:
      'https://image.tmdb.org/t/p/w342/5370jxJfZQY8TUZiiGkpNgvRwU9.jpg',
    production_companies: [
      {
        id: 26255,
        logo_path: null,
        name: 'Bophana Production',
        origin_country: '',
      },
    ],
    production_countries: [
      { iso_3166_1: 'KH', name: 'Cambodia' },
      { iso_3166_1: 'US', name: 'Hoa Kì' },
    ],
    release_date: '2017-02-18',
    revenue: 0,
    runtime: 136,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
      { english_name: 'French', iso_639_1: 'fr', name: 'Français' },
      { english_name: 'Khmer', iso_639_1: 'km', name: '' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Một Người Con Gái Của Đất Nước Cambuchia Nhớ Lại',
    video: false,
    vote_average: 7.4,
    vote_count: 515,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'First They Killed My Father | Acclaim Trailer [HD] | Netflix',
          key: '5K_SpNqLwzI',
          published_at: '2017-09-25T14:31:48.000Z',
          site: 'YouTube',
          size: 720,
          type: 'Trailer',
          official: true,
          id: '59c91455c3a36814610661a8',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'First They Killed My Father | Official Trailer [HD] | Netflix',
          key: 'uS3Vp_quGCw',
          published_at: '2017-08-02T13:29:22.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '59869b79c3a368326600e48c',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: "First They Killed My Father | Featurette: Director's Editorial | Netflix",
          key: 'Ty34ABLXur8',
          published_at: '2017-02-20T02:25:18.000Z',
          site: 'YouTube',
          size: 720,
          type: 'Featurette',
          official: true,
          id: '58ab0ce1925141418a004c4d',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 0,
          id: 1780411,
          known_for_department: 'Diễn viên',
          name: 'Sareum Srey Moch',
          original_name: 'Sareum Srey Moch',
          popularity: 0.6,
          profile_path: null,
          cast_id: 3,
          character: 'Loung',
          credit_id: '58cf8d189251415a6103467c',
          order: 0,
        },
        {
          adult: false,
          gender: 0,
          id: 1363126,
          known_for_department: 'Diễn viên',
          name: 'Phoeung Kompheak',
          original_name: 'Phoeung Kompheak',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/48ixNFHOj03IF4XhJHBX4zAtT9h.jpg',
          cast_id: 1,
          character: 'Pa',
          credit_id: '586d9662c3a3683b690002ca',
          order: 1,
        },
        {
          adult: false,
          gender: 0,
          id: 1732840,
          known_for_department: 'Diễn viên',
          name: 'Sveng Socheata',
          original_name: 'Sveng Socheata',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1IG3QcavC4iMTNmiYAjVtKKujr0.jpg',
          cast_id: 2,
          character: 'Ma',
          credit_id: '586d968d925141295f00037e',
          order: 2,
        },
        {
          adult: false,
          gender: 0,
          id: 1892522,
          known_for_department: 'Diễn viên',
          name: 'Mun Kimhak',
          original_name: 'Mun Kimhak',
          popularity: 0.6,
          profile_path: null,
          cast_id: 9,
          character: 'Kim',
          credit_id: '59c434a9c3a368145401b728',
          order: 3,
        },
        {
          adult: false,
          gender: 0,
          id: 1892523,
          known_for_department: 'Diễn viên',
          name: 'Heng Dara',
          original_name: 'Heng Dara',
          popularity: 0.6,
          profile_path: null,
          cast_id: 10,
          character: 'Meng',
          credit_id: '59c434b1c3a36813a901be8a',
          order: 4,
        },
        {
          adult: false,
          gender: 0,
          id: 1892524,
          known_for_department: 'Diễn viên',
          name: 'Khoun Sothea',
          original_name: 'Khoun Sothea',
          popularity: 0.98,
          profile_path: null,
          cast_id: 11,
          character: 'Khouy',
          credit_id: '59c434bd9251415b2801d5b3',
          order: 5,
        },
        {
          adult: false,
          gender: 0,
          id: 1892525,
          known_for_department: 'Diễn viên',
          name: 'Sarun Nika',
          original_name: 'Sarun Nika',
          popularity: 0.98,
          profile_path: null,
          cast_id: 12,
          character: 'Geak',
          credit_id: '59c434c69251415b5d01c624',
          order: 6,
        },
        {
          adult: false,
          gender: 0,
          id: 1892526,
          known_for_department: 'Diễn viên',
          name: 'Run Malyna',
          original_name: 'Run Malyna',
          popularity: 1.4,
          profile_path: null,
          cast_id: 13,
          character: 'Chaou',
          credit_id: '59c434d19251415b2801d5cc',
          order: 7,
        },
        {
          adult: false,
          gender: 0,
          id: 1892527,
          known_for_department: 'Diễn viên',
          name: 'Oun Srey Neang',
          original_name: 'Oun Srey Neang',
          popularity: 0.6,
          profile_path: null,
          cast_id: 14,
          character: 'Keav',
          credit_id: '59c434dbc3a3681461019144',
          order: 8,
        },
        {
          adult: false,
          gender: 0,
          id: 1892528,
          known_for_department: 'Diễn viên',
          name: 'Horm Chhora',
          original_name: 'Horm Chhora',
          popularity: 0.6,
          profile_path: null,
          cast_id: 15,
          character: '',
          credit_id: '59c434e49251415b8701bfa3',
          order: 9,
        },
        {
          adult: false,
          gender: 0,
          id: 1892529,
          known_for_department: 'Diễn viên',
          name: 'Nout Sophal',
          original_name: 'Nout Sophal',
          popularity: 0.6,
          profile_path: null,
          cast_id: 16,
          character: '',
          credit_id: '59c434ebc3a368140301e0ed',
          order: 10,
        },
        {
          adult: false,
          gender: 0,
          id: 1367704,
          known_for_department: 'Diễn viên',
          name: 'Tharoth Sam',
          original_name: 'Tharoth Sam',
          popularity: 0.6,
          profile_path: null,
          cast_id: 17,
          character: 'Khmer Rouge Leader',
          credit_id: '59c434f9c3a36813a901bec4',
          order: 11,
        },
        {
          adult: false,
          gender: 0,
          id: 1678180,
          known_for_department: 'Diễn viên',
          name: 'Mony Rous',
          original_name: 'Mony Rous',
          popularity: 0.98,
          profile_path: null,
          cast_id: 18,
          character: '',
          credit_id: '59c43501c3a36813ed01d2df',
          order: 12,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 1570,
          known_for_department: 'Camera',
          name: 'Anthony Dod Mantle',
          original_name: 'Anthony Dod Mantle',
          popularity: 0.661,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tAOFdzN6tJuV3EgKNbEeyEHUihP.jpg',
          credit_id: '5a465348c3a36859160763ea',
          department: 'Crew',
          job: 'Cinematography',
        },
        {
          adult: false,
          gender: 1,
          id: 7735,
          known_for_department: 'Costume & Make-Up',
          name: 'Ellen Mirojnick',
          original_name: 'Ellen Mirojnick',
          popularity: 4.262,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fVldZUbyEG0fHTTzmGp5CeqadCc.jpg',
          credit_id: '5b7f201ec3a368341a01f700',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 2,
          id: 7229,
          known_for_department: 'Sound',
          name: 'Marco Beltrami',
          original_name: 'Marco Beltrami',
          popularity: 1.442,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fb3TfFITlOC0BN3kNpUXj1FL0LN.jpg',
          credit_id: '5a4653350e0a264fd207b252',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 1,
          id: 4528,
          known_for_department: 'Editing',
          name: 'Patricia Rommel',
          original_name: 'Patricia Rommel',
          popularity: 0.652,
          profile_path: null,
          credit_id: '5b7f1f9e92514104eb01ace3',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 11653,
          known_for_department: 'Production',
          name: 'Steven P. Saeta',
          original_name: 'Steven P. Saeta',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5f38167a6bdec30034c8779c',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 1,
          id: 11701,
          known_for_department: 'Diễn viên',
          name: 'Angelina Jolie',
          original_name: 'Angelina Jolie',
          popularity: 20.374,
          profile_path:
            'https://image.tmdb.org/t/p/w185/k3W1XXddDOH2zibPkNotIh5amHo.jpg',
          credit_id: '58cf8d459251415a39031d37',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 1,
          id: 11701,
          known_for_department: 'Diễn viên',
          name: 'Angelina Jolie',
          original_name: 'Angelina Jolie',
          popularity: 20.374,
          profile_path:
            'https://image.tmdb.org/t/p/w185/k3W1XXddDOH2zibPkNotIh5amHo.jpg',
          credit_id: '586d964bc3a3683b85000312',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 1,
          id: 11701,
          known_for_department: 'Diễn viên',
          name: 'Angelina Jolie',
          original_name: 'Angelina Jolie',
          popularity: 20.374,
          profile_path:
            'https://image.tmdb.org/t/p/w185/k3W1XXddDOH2zibPkNotIh5amHo.jpg',
          credit_id: '58cf8d53c3a36850e902f7b5',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 60859,
          known_for_department: 'Art',
          name: 'Lek Chaiyan Chunsuttiwat',
          original_name: 'Lek Chaiyan Chunsuttiwat',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b7f1fd992514104f601ca0d',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 92302,
          known_for_department: 'Art',
          name: 'Tom Reta',
          original_name: 'Tom Reta',
          popularity: 1.144,
          profile_path: null,
          credit_id: '5b7f1ff50e0a2615c301ecb4',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 129896,
          known_for_department: 'Directing',
          name: 'Rithy Panh',
          original_name: 'Rithy Panh',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fMfHlfQMTGbg17DfDR0WSyg9xOj.jpg',
          credit_id: '58cf8d5f9251415a610346af',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 148697,
          known_for_department: 'Art',
          name: 'Kelly Berry',
          original_name: 'Kelly Berry',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b7f2003c3a368340f01f2a5',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 2,
          id: 1097577,
          known_for_department: 'Production',
          name: 'Ted Sarandos',
          original_name: 'Ted Sarandos',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5b7f2041c3a3683406023435',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1242862,
          known_for_department: 'Diễn viên',
          name: 'Maddox Jolie-Pitt',
          original_name: 'Maddox Jolie-Pitt',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fgZUH0QpyeBXPKmwvRMZmFeuP6a.jpg',
          credit_id: '5d63711e6dea3a4830941454',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1322142,
          known_for_department: 'Art',
          name: 'Tom Brown',
          original_name: 'Tom Brown',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b7f1fc90e0a2615bf01ffc5',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 1,
          id: 1327762,
          known_for_department: 'Art',
          name: 'Judy Farr',
          original_name: 'Judy Farr',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b7f20100e0a2615bf01ffdf',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 1422219,
          known_for_department: 'Costume & Make-Up',
          name: 'Eric Luling',
          original_name: 'Eric Luling',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b7f1fe9c3a368341701e0b8',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 1530865,
          known_for_department: 'Production',
          name: 'Michael Vieira',
          original_name: 'Michael Vieira',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b7f20500e0a2615c301ecfc',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1780412,
          known_for_department: 'Biên kịch',
          name: 'Loung Ung',
          original_name: 'Loung Ung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58cf8d34c3a36850e902f795',
          department: 'Biên kịch',
          job: 'Book',
        },
        {
          adult: false,
          gender: 0,
          id: 1780413,
          known_for_department: 'Biên kịch',
          name: 'Loung Ung',
          original_name: 'Loung Ung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58cf8d39c3a36850c002bfd1',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 0,
          id: 1812637,
          known_for_department: 'Editing',
          name: 'Xavier Box',
          original_name: 'Xavier Box',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b7f1f940e0a2615bd01ecee',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2113799,
          known_for_department: 'Production',
          name: 'Sreyra In',
          original_name: 'Sreyra In',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b7f1faa0e0a2615c501e142',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 2978232,
          known_for_department: 'Crew',
          name: 'Chris Bailey',
          original_name: 'Chris Bailey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '606cc9cb9ca7590029eb3464',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/8kZT97Ml1ZyawrfHCajmP2b0wPC.jpg',
    belongs_to_collection: {
      id: 10455,
      name: "Child's Play Collection",
      poster_path: '/fLWDbZziq47lcN28Q1ILnIMLHEC.jpg',
      backdrop_path: '/iK3cQXDzWNAkKU9PONBtUM0lZCu.jpg',
    },
    budget: 13000000,
    genres: [
      { id: 27, name: 'Phim Kinh Dị' },
      { id: 53, name: 'Phim Gây Cấn' },
    ],
    homepage: '',
    id: 11187,
    imdb_id: 'tt0103956',
    original_language: 'en',
    original_title: "Child's Play 3",
    overview:
      'Tám năm đã trôi qua kể từ các sự kiện của bộ phim thứ hai. Chucky đã được hồi sinh một lần nữa và tìm cách trả thù Andy, chủ cũ của anh, người hiện đang là một thiếu niên đăng ký vào trường quân sự.',
    popularity: 64.667,
    poster_path:
      'https://image.tmdb.org/t/p/w342/6toMk9OCuDYEEf733Bzlq3yiw3z.jpg',
    production_companies: [
      {
        id: 33,
        logo_path: '/8lvHyhjr8oUKOOy2dKXoALWKdp0.png',
        name: 'Universal Pictures',
        origin_country: 'US',
      },
    ],
    production_countries: [
      { iso_3166_1: 'GB', name: 'United Kingdom' },
      { iso_3166_1: 'US', name: 'Hoa Kì' },
    ],
    release_date: '1991-08-30',
    revenue: 20560255,
    runtime: 90,
    spoken_languages: [
      { english_name: 'Hungarian', iso_639_1: 'hu', name: 'Magyar' },
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'Chucky has a new playmate.',
    title: 'Búp Bê Sát Nhân 3',
    video: false,
    vote_average: 5.9,
    vote_count: 1091,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: "Child's Play 3 (1991) - Trailer",
          key: 'AS9tqE2dY8I',
          published_at: '2014-07-19T19:46:18.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: false,
          id: '592740199251413b5b02c38a',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 68494,
          known_for_department: 'Diễn viên',
          name: 'Justin Whalin',
          original_name: 'Justin Whalin',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oEKsEJsmAj1ozJ2ehZ60NeJvfW0.jpg',
          cast_id: 1,
          character: 'Andy Barclay',
          credit_id: '52fe440b9251416c75026fe3',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 68495,
          known_for_department: 'Diễn viên',
          name: 'Perrey Reeves',
          original_name: 'Perrey Reeves',
          popularity: 4.909,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xgsCxH6GbrAj4JGrVk89hH7aOdW.jpg',
          cast_id: 2,
          character: 'Kristen De Silva',
          credit_id: '52fe440b9251416c75026fe7',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 68496,
          known_for_department: 'Diễn viên',
          name: 'Jeremy Sylvers',
          original_name: 'Jeremy Sylvers',
          popularity: 1.274,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dnHX6Dcm7SzzDj5R4W8JIQWE00c.jpg',
          cast_id: 3,
          character: 'Ronald Tyler',
          credit_id: '52fe440b9251416c75026feb',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 32802,
          known_for_department: 'Diễn viên',
          name: 'Travis Fine',
          original_name: 'Travis Fine',
          popularity: 1.799,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4gjRxvndiZllcCsdpNQr5I0mfY2.jpg',
          cast_id: 4,
          character: 'Brett C. Shelton',
          credit_id: '52fe440b9251416c75026fef',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 68497,
          known_for_department: 'Diễn viên',
          name: 'Dean Jacobson',
          original_name: 'Dean Jacobson',
          popularity: 0.6,
          profile_path: null,
          cast_id: 5,
          character: 'Harold Aubrey Whitehurst',
          credit_id: '52fe440b9251416c75026ff3',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 1370,
          known_for_department: 'Diễn viên',
          name: 'Brad Dourif',
          original_name: 'Brad Dourif',
          popularity: 17.299,
          profile_path:
            'https://image.tmdb.org/t/p/w185/z2LYR7Ickql7g5hnWJSIAWMPD4o.jpg',
          cast_id: 6,
          character: 'Chucky (voice)',
          credit_id: '52fe440b9251416c75026ff7',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 43364,
          known_for_department: 'Diễn viên',
          name: 'Dakin Matthews',
          original_name: 'Dakin Matthews',
          popularity: 1.621,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sIYsLZnEUTeYHnybPumEZ1Zi2CB.jpg',
          cast_id: 16,
          character: 'Colonel Cochrane',
          credit_id: '52fe440b9251416c75027031',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 14782,
          known_for_department: 'Diễn viên',
          name: 'Andrew Robinson',
          original_name: 'Andrew Robinson',
          popularity: 4.047,
          profile_path:
            'https://image.tmdb.org/t/p/w185/v9PVuHgPBpmR7ey5PO354djs40Z.jpg',
          cast_id: 17,
          character: 'Sergeant Botnick',
          credit_id: '52fe440b9251416c75027035',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 109761,
          known_for_department: 'Diễn viên',
          name: 'Burke Byrnes',
          original_name: 'Burke Byrnes',
          popularity: 0.6,
          profile_path: null,
          cast_id: 18,
          character: 'Sergeant Clark',
          credit_id: '56e76187c3a368408c000914',
          order: 8,
        },
        {
          adult: false,
          gender: 0,
          id: 1681930,
          known_for_department: 'Diễn viên',
          name: 'Donna Eskra',
          original_name: 'Donna Eskra',
          popularity: 0.736,
          profile_path: null,
          cast_id: 19,
          character: 'Ivers',
          credit_id: '58e9913fc3a36872af06256b',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 1228823,
          known_for_department: 'Diễn viên',
          name: 'Matthew Walker',
          original_name: 'Matthew Walker',
          popularity: 1.142,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vxuf0ftTqC0AvEUQvTczcG1Ggq6.jpg',
          cast_id: 20,
          character: 'Ellis',
          credit_id: '58e99169925141351f02cd7e',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 134340,
          known_for_department: 'Diễn viên',
          name: 'Edan Gross',
          original_name: 'Edan Gross',
          popularity: 0.63,
          profile_path:
            'https://image.tmdb.org/t/p/w185/SoJHmoRzkhTivy18y9qTTyCSqz.jpg',
          cast_id: 21,
          character: 'Good Guy Doll (voice)',
          credit_id: '58e99177c3a3687302064451',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 152647,
          known_for_department: 'Diễn viên',
          name: 'Peter Haskell',
          original_name: 'Peter Haskell',
          popularity: 2.148,
          profile_path: null,
          cast_id: 22,
          character: 'Sullivan',
          credit_id: '5995b48e9251417d17000369',
          order: 12,
        },
        {
          adult: false,
          gender: 0,
          id: 1212458,
          known_for_department: 'Diễn viên',
          name: 'Terry Wills',
          original_name: 'Terry Wills',
          popularity: 0.6,
          profile_path: null,
          cast_id: 23,
          character: 'Garbage Man',
          credit_id: '5995b4a992514107ba0161a5',
          order: 13,
        },
        {
          adult: false,
          gender: 0,
          id: 1729762,
          known_for_department: 'Diễn viên',
          name: 'Richard Marion',
          original_name: 'Richard Marion',
          popularity: 0.6,
          profile_path: null,
          cast_id: 24,
          character: 'Patterson',
          credit_id: '5995b4bac3a36856ef0163bb',
          order: 14,
        },
        {
          adult: false,
          gender: 0,
          id: 174912,
          known_for_department: 'Diễn viên',
          name: 'Laura Owens',
          original_name: 'Laura Owens',
          popularity: 0.6,
          profile_path: null,
          cast_id: 25,
          character: 'Lady Executive',
          credit_id: '5995b5089251417d1700040b',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 66661,
          known_for_department: 'Diễn viên',
          name: 'Ron Fassler',
          original_name: 'Ron Fassler',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zelw7e7YMCgdxbmvxrfOEoYV8gV.jpg',
          cast_id: 26,
          character: 'Petzold',
          credit_id: '5995b517c3a3683fa500021d',
          order: 16,
        },
        {
          adult: false,
          gender: 2,
          id: 112053,
          known_for_department: 'Diễn viên',
          name: 'Michael Chieffo',
          original_name: 'Michael Chieffo',
          popularity: 1.141,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fzXtIMBIiVN5FuqEPwYZuFq7P5q.jpg',
          cast_id: 27,
          character: 'Security Guard',
          credit_id: '5995b527c3a3683fba000254',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 16506,
          known_for_department: 'Diễn viên',
          name: 'Henry G. Sanders',
          original_name: 'Henry G. Sanders',
          popularity: 1.025,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4HWUP5K5kPxt5c0Xp65QOyV5gPG.jpg',
          cast_id: 28,
          character: 'Major',
          credit_id: '5995b534c3a3683dc1000391',
          order: 18,
        },
        {
          adult: false,
          gender: 0,
          id: 1233188,
          known_for_department: 'Diễn viên',
          name: 'Lois Foraker',
          original_name: 'Lois Foraker',
          popularity: 1.4,
          profile_path: null,
          cast_id: 29,
          character: 'Sgt. Frazier',
          credit_id: '5995b5cac3a3683fba00032c',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 171540,
          known_for_department: 'Diễn viên',
          name: 'David Ellzey',
          original_name: 'David Ellzey',
          popularity: 0.6,
          profile_path: null,
          cast_id: 30,
          character: 'Ghoul',
          credit_id: '5995b5d59251417f2f0002d7',
          order: 20,
        },
        {
          adult: false,
          gender: 2,
          id: 33501,
          known_for_department: 'Diễn viên',
          name: 'Mark Christopher Lawrence',
          original_name: 'Mark Christopher Lawrence',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uQgXQbaDS0hoPyqUhs5Z97KIZPA.jpg',
          cast_id: 31,
          character: 'Cop',
          credit_id: '5995b5e49251417bd40005c4',
          order: 21,
        },
        {
          adult: false,
          gender: 0,
          id: 1871509,
          known_for_department: 'Diễn viên',
          name: 'Richard A. Pack',
          original_name: 'Richard A. Pack',
          popularity: 0.6,
          profile_path: null,
          cast_id: 32,
          character: 'Nelson',
          credit_id: '5995b5ef9251417ee300035c',
          order: 22,
        },
        {
          adult: false,
          gender: 0,
          id: 1871511,
          known_for_department: 'Diễn viên',
          name: 'Michael Renna',
          original_name: 'Michael Renna',
          popularity: 0.6,
          profile_path: null,
          cast_id: 33,
          character: 'Cadet',
          credit_id: '5995b5fec3a3683cd3000556',
          order: 23,
        },
        {
          adult: false,
          gender: 0,
          id: 1871514,
          known_for_department: 'Diễn viên',
          name: 'Ryan Austine',
          original_name: 'Ryan Austine',
          popularity: 0.6,
          profile_path: null,
          cast_id: 34,
          character: 'Cadet',
          credit_id: '5995b611c3a36856ef016535',
          order: 24,
        },
        {
          adult: false,
          gender: 0,
          id: 1871517,
          known_for_department: 'Diễn viên',
          name: 'Kent Winfrey',
          original_name: 'Kent Winfrey',
          popularity: 0.6,
          profile_path: null,
          cast_id: 35,
          character: 'Cadet',
          credit_id: '5995b61a9251417c0d000654',
          order: 25,
        },
        {
          adult: false,
          gender: 0,
          id: 1871520,
          known_for_department: 'Diễn viên',
          name: 'Kim Stockdale',
          original_name: 'Kim Stockdale',
          popularity: 0.6,
          profile_path: null,
          cast_id: 36,
          character: 'Mother',
          credit_id: '5995b64bc3a3683ad1000692',
          order: 26,
        },
        {
          adult: false,
          gender: 0,
          id: 1871521,
          known_for_department: 'Diễn viên',
          name: 'Mark Taormino',
          original_name: 'Mark Taormino',
          popularity: 0.6,
          profile_path: null,
          cast_id: 38,
          character: 'Kent Blue Team Cadet',
          credit_id: '5995b6669251417d1700060a',
          order: 28,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 10631,
          known_for_department: 'Visual Effects',
          name: 'John Frazier',
          original_name: 'John Frazier',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5995b6ffc3a3683e330005b4',
          department: 'Crew',
          job: 'Special Effects Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 26714,
          known_for_department: 'Camera',
          name: 'John R. Leonetti',
          original_name: 'John R. Leonetti',
          popularity: 0.753,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uksq1bamaA4MfpBPaP4Vv8BvLpu.jpg',
          credit_id: '52fe440b9251416c75027021',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 13596,
          known_for_department: 'Production',
          name: 'David Kirschner',
          original_name: 'David Kirschner',
          popularity: 1.166,
          profile_path: null,
          credit_id: '52fe440b9251416c7502700f',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 15438,
          known_for_department: 'Crew',
          name: 'Erik Stabenau',
          original_name: 'Erik Stabenau',
          popularity: 1.38,
          profile_path:
            'https://image.tmdb.org/t/p/w185/FXAvL8IXyByCAPhXlPLTqXh9kj.jpg',
          credit_id: '5995b7a69251417c0d00083e',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 16175,
          known_for_department: 'Production',
          name: 'Glenn Daniels',
          original_name: 'Glenn Daniels',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5995b6ab9251417bd40006cf',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 14654,
          known_for_department: 'Production',
          name: 'Robert Latham Brown',
          original_name: 'Robert Latham Brown',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aO50W8UlXEkMG1tAqAQb1mK1u5r.jpg',
          credit_id: '52fe440b9251416c75027009',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 14663,
          known_for_department: 'Diễn viên',
          name: 'Dick Warlock',
          original_name: 'Dick Warlock',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5995b7dec3a3683fa50005d5',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 27583,
          known_for_department: 'Editing',
          name: 'Edward A. Warschilka',
          original_name: 'Edward A. Warschilka',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe440b9251416c7502702d',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 29060,
          known_for_department: 'Art',
          name: 'Ethel Robins Richards',
          original_name: 'Ethel Robins Richards',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5995b6c5c3a3683dc10005c9',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 2,
          id: 65677,
          known_for_department: 'Biên kịch',
          name: 'Don Mancini',
          original_name: 'Don Mancini',
          popularity: 1.644,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bp7vtf9n9uOPOK1WzdITpwFZqbQ.jpg',
          credit_id: '52fe440b9251416c75027003',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 28976,
          known_for_department: 'Directing',
          name: 'Jack Bender',
          original_name: 'Jack Bender',
          popularity: 1.207,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8BKWjdfFdjdqPxvJ880Y76qzSCT.jpg',
          credit_id: '52fe440b9251416c75026ffd',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 68498,
          known_for_department: 'Sound',
          name: "John D'Andrea",
          original_name: "John D'Andrea",
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe440b9251416c75027015',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 0,
          id: 68499,
          known_for_department: 'Sound',
          name: 'Cory Lerios',
          original_name: 'Cory Lerios',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe440b9251416c7502701b',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 0,
          id: 68500,
          known_for_department: 'Editing',
          name: 'Scott K. Wallace',
          original_name: 'Scott K. Wallace',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe440b9251416c75027027',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 92494,
          known_for_department: 'Crew',
          name: 'Kim Robert Koscki',
          original_name: 'Kim Robert Koscki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5995b77bc3a3683fa5000578',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 91242,
          known_for_department: 'Diễn viên',
          name: 'Bob Herron',
          original_name: 'Bob Herron',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uY9xIZFTlVd41PzUSC39IH5tidh.jpg',
          credit_id: '600d5cb00cd4460040e09579',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 589956,
          known_for_department: 'Diễn viên',
          name: 'John Cann',
          original_name: 'John Cann',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5995b73ec3a3683dc1000654',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1077936,
          known_for_department: 'Crew',
          name: 'Guy Mansker',
          original_name: 'Guy Mansker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5995b78e9251417c0d000821',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1224156,
          known_for_department: 'Crew',
          name: 'Tom Morga',
          original_name: 'Tom Morga',
          popularity: 0.786,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mSYW38zL1wA4GvntN1TNrdtB6C1.jpg',
          credit_id: '5995b79a9251417bd40007cf',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1377422,
          known_for_department: 'Sound',
          name: 'Milton C. Burrow',
          original_name: 'Milton C. Burrow',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6111f2f7394a870046257c5b',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1397305,
          known_for_department: 'Art',
          name: 'Richard Sawyer',
          original_name: 'Richard Sawyer',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5995b6bbc3a3683dc10005be',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1405236,
          known_for_department: 'Visual Effects',
          name: 'Thomas Boland',
          original_name: 'Thomas Boland',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5995b72cc3a3683ad10007bd',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1441163,
          known_for_department: 'Crew',
          name: 'Craig Reardon',
          original_name: 'Craig Reardon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5995b716c3a3683ad10007a9',
          department: 'Crew',
          job: 'Special Effects',
        },
        {
          adult: false,
          gender: 2,
          id: 1493887,
          known_for_department: 'Camera',
          name: 'Bruce Alan Greene',
          original_name: 'Bruce Alan Greene',
          popularity: 0.714,
          profile_path: null,
          credit_id: '5acf17fd9251410c03034f2c',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1525985,
          known_for_department: 'Costume & Make-Up',
          name: 'Kimberly Felix',
          original_name: 'Kimberly Felix',
          popularity: 0.714,
          profile_path: null,
          credit_id: '5995b6dc9251417bd400070a',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 1,
          id: 1682321,
          known_for_department: 'Diễn viên',
          name: 'Diana Cuevas',
          original_name: 'Diana Cuevas',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5995b7489251417ee3000524',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1846138,
          known_for_department: 'Production',
          name: 'Laura Moskowitz',
          original_name: 'Laura Moskowitz',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5995b69dc3a3683ad10006ff',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1871523,
          known_for_department: 'Costume & Make-Up',
          name: 'Dorinda Carey',
          original_name: 'Dorinda Carey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5995b6d1c3a3683fba0004a1',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1871524,
          known_for_department: 'Crew',
          name: 'David Amborn',
          original_name: 'David Amborn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5995b6f2c3a3683cd30006a8',
          department: 'Crew',
          job: 'Special Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1913792,
          known_for_department: 'Sound',
          name: 'Scott Burrow',
          original_name: 'Scott Burrow',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6111f319344a8e002efffbfa',
          department: 'Sound',
          job: 'Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1959730,
          known_for_department: 'Sound',
          name: 'Richard Oswald',
          original_name: 'Richard Oswald',
          popularity: 0.98,
          profile_path: null,
          credit_id: '6111f32765e0a200268791b0',
          department: 'Sound',
          job: 'Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1998464,
          known_for_department: 'Sound',
          name: 'Richard Burrow',
          original_name: 'Richard Burrow',
          popularity: 0.98,
          profile_path: null,
          credit_id: '6111f30ed05a03002df5d4f3',
          department: 'Sound',
          job: 'Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 2040553,
          known_for_department: 'Sound',
          name: 'Jim Yant',
          original_name: 'Jim Yant',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6111f338cd204600475e43dc',
          department: 'Sound',
          job: 'Sound Editor',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'Gimly',
          author_details: {
            name: 'Gimly',
            username: 'Ruuz',
            avatar_path: '/xUObnJSvHrFPsIpoDmb1jiQZLq7.jpg',
            rating: 5.0,
          },
          content:
            "Rides the line between the original _Child's Play_ movies and the _X of Chucky_ movies not just in timeframe, but also in tone. It doesn't always work in _Child's Play 3's_ favour, but there is still some fun to be had with this entry.\r\n\r\n_Final rating:★★½ - Had a lot that appealed to me, didn’t quite work as a whole._",
          created_at: '2017-10-18T09:51:58.520Z',
          id: '59e7243e9251413bd500c119',
          updated_at: '2021-06-23T15:58:01.878Z',
          url: 'https://www.themoviedb.org/review/59e7243e9251413bd500c119',
        },
      ],
      total_pages: 1,
      total_results: 1,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/bZVGqBE9ejZAvhKYLAg4SpstdAD.jpg',
    belongs_to_collection: {
      id: 423173,
      name: 'Bad Santa Collection',
      poster_path: '/2OkB4GagVy1n7M8Q94FRzsOErPE.jpg',
      backdrop_path: '/5hmQCwMOoZWzCgI08Yx7lNdxhqH.jpg',
    },
    budget: 26000000,
    genres: [
      { id: 35, name: 'Phim Hài' },
      { id: 80, name: 'Phim Hình Sự' },
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 9648, name: 'Phim Bí Ẩn' },
    ],
    homepage: 'http://www.badsanta2.com/',
    id: 338964,
    imdb_id: 'tt1798603',
    original_language: 'en',
    original_title: 'Bad Santa 2',
    overview:
      'Bad Santa 2 là bộ phim tâm lý tội phạm hài hước của Mỹ ra mắt vào năm 2016. Nối tiếp thành công của phần 1, Bad Santa 2 tiếp tục theo chân Willie và Marcus, hai tên lừa đảo chuyên đóng giả ông già Noel và yêu tinh trong một phi vụ mới.\r Bối cảnh phim diễn ra 13 năm sau phần phim đầu tiên, cuộc sống của Willie hiện đang trở nên vô cùng tồi tệ sau khi anh phát hiện ra bản thân mắc chứng trầm cảm nặng. Mặc dù đã cố gắng để tự sát thế nhưng hết lần này đến lần khác Willie đều thất bại. Một ngày nọ, Willie tình cờ gặp được Thurman “The Kid” Merman, cháu của Willie và là một nhân viên 21 tuổi làm việc tại cửa hàng bánh sandwich Hungry Hoagies, đến thăm.',
    popularity: 24.801,
    poster_path:
      'https://image.tmdb.org/t/p/w342/xmsEwpA2fSq6IO3sfKrLuIPLHSc.jpg',
    production_companies: [
      {
        id: 290,
        logo_path: '/Q8mw2AOQQc8Qg0uNwLWq86DVZv.png',
        name: 'Ingenious Media',
        origin_country: 'GB',
      },
      {
        id: 49389,
        logo_path: '/3rOhrdjnUHsf0GPa66b9KyR2MUx.png',
        name: 'Broad Green Pictures',
        origin_country: 'US',
      },
      {
        id: 14,
        logo_path: '/m6AHu84oZQxvq7n1rsvMNJIAsMu.png',
        name: 'Miramax',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2016-11-23',
    revenue: 23229371,
    runtime: 1,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'ÔNG GIÀ NOEL XẤU TÍNH 2',
    title: 'ÔNG GIÀ NOEL XẤU TÍNH 2',
    video: false,
    vote_average: 5.3,
    vote_count: 604,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Bad Santa 2 Official Red Band Trailer #2 (2016) - Broad Green Pictures',
          key: '8anWq67nXhY',
          published_at: '2016-09-21T16:04:24.000Z',
          site: 'YouTube',
          size: 720,
          type: 'Trailer',
          official: true,
          id: '57e31150c3a368758900037c',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Bad Santa 2 Official Teaser Trailer (2016) - Broad Green Pictures',
          key: 'HGcZxBNNpKM',
          published_at: '2016-08-11T16:47:07.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '57e3117d92514112370003ab',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Bad Santa 2 Official Red Band Teaser Trailer (2016) - Broad Green Pictures',
          key: 'JFJtk4nXjl4',
          published_at: '2016-08-09T15:49:29.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '57e311bac3a368758d0003b1',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Bad Santa 2 - Date Announcement',
          key: 'bpmO8Cz2PLA',
          published_at: '2016-07-28T21:57:36.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Teaser',
          official: true,
          id: '57e3120c925141123a000411',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 879,
          known_for_department: 'Diễn viên',
          name: 'Billy Bob Thornton',
          original_name: 'Billy Bob Thornton',
          popularity: 5.922,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uJBFml6efjg34u2jvT5ugVa1cPI.jpg',
          cast_id: 1,
          character: 'Willie Soke',
          credit_id: '5690d52f9251414565001dc0',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 8534,
          known_for_department: 'Diễn viên',
          name: 'Kathy Bates',
          original_name: 'Kathy Bates',
          popularity: 5.462,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3MsayDvY73uXGVbCFHyy1ABTacV.jpg',
          cast_id: 2,
          character: 'Sunny Soke',
          credit_id: '5690d5389251414563001e2a',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 63992,
          known_for_department: 'Diễn viên',
          name: 'Brett Kelly',
          original_name: 'Brett Kelly',
          popularity: 2.877,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kHPBsKWF4Cap70LVy41vL5ADyLW.jpg',
          cast_id: 3,
          character: 'Thurman Merman',
          credit_id: '5690d542c3a3686b55001d15',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 19754,
          known_for_department: 'Diễn viên',
          name: 'Tony Cox',
          original_name: 'Tony Cox',
          popularity: 4.384,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wMXBdnkCOoPM8iPPALcaKaO77Oc.jpg',
          cast_id: 4,
          character: 'Marcus Skidmore',
          credit_id: '5690d54b9251414565001dc5',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 110014,
          known_for_department: 'Diễn viên',
          name: 'Christina Hendricks',
          original_name: 'Christina Hendricks',
          popularity: 11.523,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fqQWrKDhOTAPjjNTHSU4tBfq5NJ.jpg',
          cast_id: 0,
          character: 'Diane Hastings',
          credit_id: '5690d526c3a3686b41001cab',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 78433,
          known_for_department: 'Diễn viên',
          name: 'Ryan Hansen',
          original_name: 'Ryan Hansen',
          popularity: 2.891,
          profile_path:
            'https://image.tmdb.org/t/p/w185/n4d1DiK3KyrQNN3G2QKt4Tos53Q.jpg',
          cast_id: 10,
          character: 'Regent Hastings',
          credit_id: '584b486c92514133b1003efc',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 229558,
          known_for_department: 'Diễn viên',
          name: 'Cristina Rosato',
          original_name: 'Cristina Rosato',
          popularity: 3.325,
          profile_path:
            'https://image.tmdb.org/t/p/w185/w5UkUzt5DZykqKPcHswzCMBOMaC.jpg',
          cast_id: 13,
          character: 'Alice',
          credit_id: '584b48afc3a368397a004117',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 6944,
          known_for_department: 'Diễn viên',
          name: 'Octavia Spencer',
          original_name: 'Octavia Spencer',
          popularity: 7.919,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jnQTP4RRkoWnyO3yL2PgRHZi0tK.jpg',
          cast_id: 14,
          character: 'Opal',
          credit_id: '584b4906c3a36839720040b5',
          order: 7,
        },
        {
          adult: false,
          gender: 0,
          id: 1720527,
          known_for_department: 'Diễn viên',
          name: 'Jenny Zigrino',
          original_name: 'Jenny Zigrino',
          popularity: 0.6,
          profile_path: null,
          cast_id: 11,
          character: 'Gina De Luca',
          credit_id: '584b488992514133ad003dd5',
          order: 8,
        },
        {
          adult: false,
          gender: 0,
          id: 1720528,
          known_for_department: 'Diễn viên',
          name: 'Jeff Skowron',
          original_name: 'Jeff Skowron',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oEVdoNJ62VV1KhwYXhBC3ETpJ2D.jpg',
          cast_id: 12,
          character: 'Dorfman',
          credit_id: '584b489ec3a3683987003dad',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 5170,
          known_for_department: 'Diễn viên',
          name: 'Mike Starr',
          original_name: 'Mike Starr',
          popularity: 2.06,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mv5UWjH3ukiMQuuHuSZCsnZ9cOw.jpg',
          cast_id: 32,
          character: 'Jolly Santa',
          credit_id: '5df92ddad1a89300127eaaf4',
          order: 10,
        },
        {
          adult: false,
          gender: 1,
          id: 1099804,
          known_for_department: 'Diễn viên',
          name: 'Ranee Lee',
          original_name: 'Ranee Lee',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6kuhdGCt051FZrMZKcAaLY1B2cd.jpg',
          cast_id: 33,
          character: 'Choirmaster',
          credit_id: '5df92dfa7f2d4a0018976ab5',
          order: 11,
        },
        {
          adult: false,
          gender: 0,
          id: 1574303,
          known_for_department: 'Diễn viên',
          name: 'Selah Victor',
          original_name: 'Selah Victor',
          popularity: 0.994,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gYwyZXmaKLnBuznGkyG9G9n0xTN.jpg',
          cast_id: 34,
          character: 'Breast Feeding Mom',
          credit_id: '5df92e12be2d49001251009a',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 4992,
          known_for_department: 'Diễn viên',
          name: 'Lombardo Boyar',
          original_name: 'Lombardo Boyar',
          popularity: 1.78,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wwWs0u2QDz1XOakR05C0BYJCfM1.jpg',
          cast_id: 35,
          character: 'Valet Boss',
          credit_id: '5df92e2e26dac10017572c76',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 203349,
          known_for_department: 'Diễn viên',
          name: 'Dean Hagopian',
          original_name: 'Dean Hagopian',
          popularity: 0.6,
          profile_path: null,
          cast_id: 36,
          character: 'Costume Greeter',
          credit_id: '5fcf93386af8f8003f0b3701',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 1294229,
          known_for_department: 'Diễn viên',
          name: 'Marc-André Boulanger',
          original_name: 'Marc-André Boulanger',
          popularity: 0.6,
          profile_path: null,
          cast_id: 37,
          character: 'Tattooed Jail Dude',
          credit_id: '5fcf94017314a10040d0c4ff',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 92264,
          known_for_department: 'Diễn viên',
          name: 'Sean Devine',
          original_name: 'Sean Devine',
          popularity: 1.397,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zk51yajMerVFWcfTsTCNfzLynbZ.jpg',
          cast_id: 38,
          character: 'Jail Guard',
          credit_id: '5fcf9432590086003dfd5fc1',
          order: 16,
        },
        {
          adult: false,
          gender: 1,
          id: 188983,
          known_for_department: 'Diễn viên',
          name: 'Maria Herrera',
          original_name: 'Maria Herrera',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/crIm7JB1fxWv3nVvTNWYjdhUY1h.jpg',
          cast_id: 39,
          character: 'Bus Driver',
          credit_id: '5fcf9486590086003dfd6021',
          order: 17,
        },
        {
          adult: false,
          gender: 1,
          id: 1504484,
          known_for_department: 'Diễn viên',
          name: 'Valérie Wiseman',
          original_name: 'Valérie Wiseman',
          popularity: 0.677,
          profile_path: null,
          cast_id: 40,
          character: 'Greta',
          credit_id: '5fcf94b8a5743d00420915e0',
          order: 18,
        },
        {
          adult: false,
          gender: 2,
          id: 30617,
          known_for_department: 'Diễn viên',
          name: 'Jason Cavalier',
          original_name: 'Jason Cavalier',
          popularity: 0.733,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iDAdIN4fo9hfxa6Ms6iIA89klSO.jpg',
          cast_id: 129,
          character: 'Chicago Policeman',
          credit_id: '603f2706719aeb006fceea90',
          order: 19,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 1,
          id: 434,
          known_for_department: 'Production',
          name: 'Lisa Beach',
          original_name: 'Lisa Beach',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf95a8590086003ffd07b5',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 1,
          id: 436,
          known_for_department: 'Production',
          name: 'Sarah Katzman',
          original_name: 'Sarah Katzman',
          popularity: 1.259,
          profile_path: null,
          credit_id: '5fcf95bbe32943003c42bba5',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 1586,
          known_for_department: 'Production',
          name: 'Adam Fields',
          original_name: 'Adam Fields',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c20a1e192514167efc0df85',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 4657,
          known_for_department: 'Visual Effects',
          name: 'Louis Craig',
          original_name: 'Louis Craig',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf9c6b590086003dfd6cae',
          department: 'Visual Effects',
          job: 'Special Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 6053,
          known_for_department: 'Art',
          name: 'Paul Hotte',
          original_name: 'Paul Hotte',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf966fa6725400417a36d5',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 8704,
          known_for_department: 'Art',
          name: 'Isabelle Guay',
          original_name: 'Isabelle Guay',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c20a17a9251416805c0c678',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 2,
          id: 10815,
          known_for_department: 'Camera',
          name: 'Theo van de Sande',
          original_name: 'Theo van de Sande',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf957657530e003f8f5f31',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 16341,
          known_for_department: 'Costume & Make-Up',
          name: 'Christophe Giraud',
          original_name: 'Christophe Giraud',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf96bea67254003e79e402',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 29016,
          known_for_department: 'Production',
          name: 'David Thwaites',
          original_name: 'David Thwaites',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/22QYHt6ClgmxaK5aw12Eu13DJsv.jpg',
          credit_id: '5c20a23d925141520dbec860',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 30617,
          known_for_department: 'Diễn viên',
          name: 'Jason Cavalier',
          original_name: 'Jason Cavalier',
          popularity: 0.733,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iDAdIN4fo9hfxa6Ms6iIA89klSO.jpg',
          credit_id: '603f2751c4ad59006f5183cd',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 1,
          id: 41588,
          known_for_department: 'Production',
          name: 'Zanne Devine',
          original_name: 'Zanne Devine',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hYDmtSxOWzgZQCWPPisuGeI7fT5.jpg',
          credit_id: '5c20a1b5c3a3687001eb072d',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 41892,
          known_for_department: 'Production',
          name: 'Geyer Kosinski',
          original_name: 'Geyer Kosinski',
          popularity: 0.656,
          profile_path: null,
          credit_id: '5c20a22d0e0a264df2ecf5d4',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 53012,
          known_for_department: 'Sound',
          name: 'Lyle Workman',
          original_name: 'Lyle Workman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf952a7314a1003ecf6a6e',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 54050,
          known_for_department: 'Directing',
          name: 'Mark Waters',
          original_name: 'Mark Waters',
          popularity: 0.732,
          profile_path:
            'https://image.tmdb.org/t/p/w185/afouy66zeJ1hn7fcjLp8QkcTeQJ.jpg',
          credit_id: '5690d55dc3a3686b41001cc7',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 54050,
          known_for_department: 'Directing',
          name: 'Mark Waters',
          original_name: 'Mark Waters',
          popularity: 0.732,
          profile_path:
            'https://image.tmdb.org/t/p/w185/afouy66zeJ1hn7fcjLp8QkcTeQJ.jpg',
          credit_id: '5c20a2880e0a264ddeecf08a',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 113045,
          known_for_department: 'Sound',
          name: 'Dawn Lunsford',
          original_name: 'Dawn Lunsford',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gaGtvXaFT7hZzGc12KsYp91etlh.jpg',
          credit_id: '5fcf9af995c0af003fa96a6a',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 1,
          id: 113090,
          known_for_department: 'Sound',
          name: 'Alicia Stevenson',
          original_name: 'Alicia Stevenson',
          popularity: 3.534,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kgYtaWN4VSFh2B0jkHa1GMBOcNU.jpg',
          credit_id: '5fcf9be36af8f8003e0a9d49',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 56411,
          known_for_department: 'Biên kịch',
          name: 'Glenn Ficarra',
          original_name: 'Glenn Ficarra',
          popularity: 4.32,
          profile_path:
            'https://image.tmdb.org/t/p/w185/23EaR6q7B1wcg9trxtr7xHzKu7q.jpg',
          credit_id: '591058ae9251414edb030cf5',
          department: 'Biên kịch',
          job: 'Characters',
        },
        {
          adult: false,
          gender: 2,
          id: 56412,
          known_for_department: 'Biên kịch',
          name: 'John Requa',
          original_name: 'John Requa',
          popularity: 2.279,
          profile_path: null,
          credit_id: '591058ba9251414ead02e82f',
          department: 'Biên kịch',
          job: 'Characters',
        },
        {
          adult: false,
          gender: 2,
          id: 64830,
          known_for_department: 'Production',
          name: 'Andrew Gunn',
          original_name: 'Andrew Gunn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c20a1ff9251416801c0ba5d',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 74978,
          known_for_department: 'Sound',
          name: 'Terry Porter',
          original_name: 'Terry Porter',
          popularity: 1.094,
          profile_path: null,
          credit_id: '5fcf9bb0a6725400407b1f18',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 113894,
          known_for_department: 'Costume & Make-Up',
          name: 'Mario Davignon',
          original_name: 'Mario Davignon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf9685a67254003f7aa7c7',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 1,
          id: 101903,
          known_for_department: 'Biên kịch',
          name: 'Shauna Cross',
          original_name: 'Shauna Cross',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/a1cKu1728ctQUakhwgWkTZdSrut.jpg',
          credit_id: '591058a1c3a368651902cf1d',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 107594,
          known_for_department: 'Sound',
          name: 'Simon Poudrette',
          original_name: 'Simon Poudrette',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf9bc2a5743d004109f3ad',
          department: 'Sound',
          job: 'Sound Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 127541,
          known_for_department: 'Diễn viên',
          name: 'John Thaddeus',
          original_name: 'John Thaddeus',
          popularity: 1.008,
          profile_path: null,
          credit_id: '5fcf9cdefba62500407dd570',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 0,
          id: 132642,
          known_for_department: 'Camera',
          name: 'Jan Thijs',
          original_name: 'Jan Thijs',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa2fe680be8003e20aebd',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 2,
          id: 183036,
          known_for_department: 'Biên kịch',
          name: 'Doug Ellin',
          original_name: 'Doug Ellin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c20a1c8c3a3686fffeb0b45',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 936320,
          known_for_department: 'Costume & Make-Up',
          name: 'Josée Boisvert',
          original_name: 'Josée Boisvert',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa4905b4fed00410ace5a',
          department: 'Costume & Make-Up',
          job: 'Wardrobe Master',
        },
        {
          adult: false,
          gender: 1,
          id: 965987,
          known_for_department: 'Production',
          name: 'Jessica Tuchinsky',
          original_name: 'Jessica Tuchinsky',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c20a252c3a368700beb5a92',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 966593,
          known_for_department: 'Editing',
          name: 'Travis Sittard',
          original_name: 'Travis Sittard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c20a1550e0a264dd8ed1eab',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1031764,
          known_for_department: 'Sound',
          name: 'Darren Sunny Warkentin',
          original_name: 'Darren Sunny Warkentin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf9c31fba62500407dd472',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1039264,
          known_for_department: 'Sound',
          name: 'Paul Bercovitch',
          original_name: 'Paul Bercovitch',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf99ff7314a10040d0cfbb',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1190616,
          known_for_department: 'Crew',
          name: 'David Falicki',
          original_name: 'David Falicki',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5fcfa6ad5a991500407cb51a',
          department: 'Crew',
          job: 'Set Medic',
        },
        {
          adult: false,
          gender: 0,
          id: 1327907,
          known_for_department: 'Art',
          name: 'Jean-Pierre Paquet',
          original_name: 'Jean-Pierre Paquet',
          popularity: 0.728,
          profile_path: null,
          credit_id: '5fcf95d895c0af0041aa0984',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1380382,
          known_for_department: 'Art',
          name: 'David Gaucher',
          original_name: 'David Gaucher',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf98fa95c0af0041aa0e09',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1384399,
          known_for_department: 'Production',
          name: 'Michèle St-Arnaud',
          original_name: 'Michèle St-Arnaud',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa5e65a991500407cb44a',
          department: 'Production',
          job: 'Location Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1390524,
          known_for_department: 'Sound',
          name: 'Jay Wilkinson',
          original_name: 'Jay Wilkinson',
          popularity: 1.96,
          profile_path: null,
          credit_id: '5fcf9c5195c0af0040aab042',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1394740,
          known_for_department: 'Art',
          name: 'Helene Lamarre',
          original_name: 'Helene Lamarre',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf994c680be8003e209d52',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 1,
          id: 1401687,
          known_for_department: 'Sound',
          name: 'Anna Behlmer',
          original_name: 'Anna Behlmer',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kUsjqvtj653USV4FXxJmPiqJCW4.jpg',
          credit_id: '5fcf99cb57530e003e8f90c1',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1401770,
          known_for_department: 'Editing',
          name: 'Ian Vertovec',
          original_name: 'Ian Vertovec',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa5b75a991500407cb419',
          department: 'Editing',
          job: 'Digital Intermediate Colorist',
        },
        {
          adult: false,
          gender: 0,
          id: 1402019,
          known_for_department: 'Costume & Make-Up',
          name: 'Colleen Quinton',
          original_name: 'Colleen Quinton',
          popularity: 0.656,
          profile_path: null,
          credit_id: '5fcf96f3a6725400417a371a',
          department: 'Costume & Make-Up',
          job: 'Makeup Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 1402032,
          known_for_department: 'Camera',
          name: 'Francois Archambault',
          original_name: 'Francois Archambault',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf9d3d7314a1003fd1914c',
          department: 'Camera',
          job: 'Steadicam Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1402034,
          known_for_department: 'Lighting',
          name: 'Eames Gagnon',
          original_name: 'Eames Gagnon',
          popularity: 0.84,
          profile_path: null,
          credit_id: '5fcfa0ddfba62500407ddb19',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 1,
          id: 1404903,
          known_for_department: 'Sound',
          name: 'Becky Sullivan',
          original_name: 'Becky Sullivan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf9c17e32943003e438fe1',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1406390,
          known_for_department: 'Sound',
          name: 'Dan Hegeman',
          original_name: 'Dan Hegeman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf9aa0a6725400417a3bf3',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1409696,
          known_for_department: 'Art',
          name: 'Robert Parle',
          original_name: 'Robert Parle',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5fcf95ec590086003efd37bb',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 1412919,
          known_for_department: 'Camera',
          name: 'Mark Gerasimenko',
          original_name: 'Mark Gerasimenko',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5fcfa10aa67254003f7ab682',
          department: 'Camera',
          job: 'Aerial Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 1419733,
          known_for_department: 'Crew',
          name: 'Puelo Deir',
          original_name: 'Puelo Deir',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa68b680be8003e20b474',
          department: 'Crew',
          job: 'Unit Publicist',
        },
        {
          adult: false,
          gender: 0,
          id: 1435194,
          known_for_department: 'Sound',
          name: 'Charles Martin Inouye',
          original_name: 'Charles Martin Inouye',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa626e32943003e439e15',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1447120,
          known_for_department: 'Art',
          name: 'Daniel Hamelin',
          original_name: 'Daniel Hamelin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf963f57530e00408fb8ce',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 2,
          id: 1451649,
          known_for_department: 'Sound',
          name: 'Paul Drenning',
          original_name: 'Paul Drenning',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf9a6457530e00448f421e',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1460838,
          known_for_department: 'Production',
          name: 'Gabriel Hammond',
          original_name: 'Gabriel Hammond',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c20a21fc3a368700eeb2ec7',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1510496,
          known_for_department: 'Diễn viên',
          name: 'Rodney Alexandre',
          original_name: 'Rodney Alexandre',
          popularity: 0.728,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2yWvyUvq4dNEamZPjpTCWNYR9jo.jpg',
          credit_id: '5fcfa41d6af8f8003e0aa673',
          department: 'Production',
          job: 'Extras Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 1521104,
          known_for_department: 'Costume & Make-Up',
          name: 'Carol F. Doran',
          original_name: 'Carol F. Doran',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf96adfba625003f7d99c7',
          department: 'Costume & Make-Up',
          job: 'Wigmaker',
        },
        {
          adult: false,
          gender: 0,
          id: 1525883,
          known_for_department: 'Costume & Make-Up',
          name: 'Martine Gagnon',
          original_name: 'Martine Gagnon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa4c47314a1003ecf7ca6',
          department: 'Costume & Make-Up',
          job: 'Assistant Costume Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 1526823,
          known_for_department: 'Sound',
          name: 'Tracy McKnight',
          original_name: 'Tracy McKnight',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5fcfa64bdcf875004046975b',
          department: 'Sound',
          job: 'Music Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1530870,
          known_for_department: 'Crew',
          name: 'Lisa Rodgers',
          original_name: 'Lisa Rodgers',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf9739a5743d003f0b1281',
          department: 'Crew',
          job: 'Post Production Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1544669,
          known_for_department: 'Sound',
          name: 'John Morris',
          original_name: 'John Morris',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf9b5cdcf8750042459244',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1548463,
          known_for_department: 'Sound',
          name: 'Edmond J. Coblentz Jr.',
          original_name: 'Edmond J. Coblentz Jr.',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf9a2b95c0af003fa96867',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1560389,
          known_for_department: 'Biên kịch',
          name: 'Johnny Rosenthal',
          original_name: 'Johnny Rosenthal',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59105898c3a36864a702f4d0',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 1575710,
          known_for_department: 'Editing',
          name: 'Steve La Ponsie',
          original_name: 'Steve La Ponsie',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa520e32943003f41e5a6',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1586394,
          known_for_department: 'Sound',
          name: 'Jeff Gomillion',
          original_name: 'Jeff Gomillion',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf9a8aa67254003f7aadf4',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1590080,
          known_for_department: 'Camera',
          name: 'Kenneth MacKenzie',
          original_name: 'Kenneth MacKenzie',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa269680be8003d1fb2d5',
          department: 'Camera',
          job: 'Key Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1593425,
          known_for_department: 'Biên kịch',
          name: 'Pierre Daudelin',
          original_name: 'Pierre Daudelin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa081a5743d003f0b203f',
          department: 'Lighting',
          job: 'Best Boy Electric',
        },
        {
          adult: false,
          gender: 0,
          id: 1611794,
          known_for_department: 'Crew',
          name: 'David McKeown',
          original_name: 'David McKeown',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5fcf9cf67314a1003fd190ed',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1611794,
          known_for_department: 'Crew',
          name: 'David McKeown',
          original_name: 'David McKeown',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5fcf97e2e32943003d440f03',
          department: 'Directing',
          job: 'Second Unit Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1631607,
          known_for_department: 'Camera',
          name: 'Eric Aubin',
          original_name: 'Eric Aubin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf9d53590086003dfd6dd8',
          department: 'Camera',
          job: 'Second Assistant "A" Camera',
        },
        {
          adult: false,
          gender: 1,
          id: 1638380,
          known_for_department: 'Costume & Make-Up',
          name: 'Sabrina Trudel',
          original_name: 'Sabrina Trudel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf970bdcf875004147a0a5',
          department: 'Costume & Make-Up',
          job: 'Assistant Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1642954,
          known_for_department: 'Production',
          name: 'Daniel Hammond',
          original_name: 'Daniel Hammond',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c20a2100e0a264dd8ed2049',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1646484,
          known_for_department: 'Production',
          name: 'Hélène Ross',
          original_name: 'Hélène Ross',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5fcf97506af8f8003d0af2e9',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 2,
          id: 1725888,
          known_for_department: 'Sound',
          name: 'Louis Piché',
          original_name: 'Louis Piché',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mgdivDIwwcSeYBl6hTr5reihEmr.jpg',
          credit_id: '5fcf9b7ea6725400407b1eb6',
          department: 'Sound',
          job: 'Boom Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1730833,
          known_for_department: 'Costume & Make-Up',
          name: 'Fabienne April',
          original_name: 'Fabienne April',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa46ea5743d003f0b2525',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1737660,
          known_for_department: 'Sound',
          name: 'David Jobe',
          original_name: 'David Jobe',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wej0TWRlW8mKuIQd5F8JMu7owdG.jpg',
          credit_id: '5fcf9adfdcf87500424590c8',
          department: 'Sound',
          job: 'Foley Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1755097,
          known_for_department: 'Camera',
          name: 'Gunther Campine',
          original_name: 'Gunther Campine',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa04c5b4fed00410ac77d',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 0,
          id: 1777636,
          known_for_department: 'Directing',
          name: 'Isabelle Faivre-Duboz',
          original_name: 'Isabelle Faivre-Duboz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa66f6c0e4f0040bf3f59',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1777639,
          known_for_department: 'Costume & Make-Up',
          name: 'Viriya Say',
          original_name: 'Viriya Say',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa4fbdcf875004147b4d3',
          department: 'Costume & Make-Up',
          job: 'Seamstress',
        },
        {
          adult: false,
          gender: 0,
          id: 1789643,
          known_for_department: 'Directing',
          name: 'Renato De Cotiis',
          original_name: 'Renato De Cotiis',
          popularity: 1.214,
          profile_path: null,
          credit_id: '5fcf9765a6725400417a3815',
          department: 'Directing',
          job: 'Second Assistant Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1797240,
          known_for_department: 'Directing',
          name: 'Andrew Shea',
          original_name: 'Andrew Shea',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf982757530e003e8f8e19',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 1,
          id: 1810161,
          known_for_department: 'Art',
          name: 'Marie-Soleil Dénommé',
          original_name: 'Marie-Soleil Dénommé',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf961857530e00408fb893',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 1810163,
          known_for_department: 'Art',
          name: 'Jean Gagnon',
          original_name: 'Jean Gagnon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf98de95c0af0040aaab79',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1823542,
          known_for_department: 'Crew',
          name: 'Alex Stines',
          original_name: 'Alex Stines',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/i5xUF2joFz5J4lRU1Utq65mtkv6.jpg',
          credit_id: '5fcf9ca1e32943003e439037',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 0,
          id: 1867387,
          known_for_department: 'Costume & Make-Up',
          name: 'Cynthia Patton',
          original_name: 'Cynthia Patton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf96dea6725400407b1410',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 2,
          id: 1890965,
          known_for_department: 'Art',
          name: 'Frédéric Berthiaume',
          original_name: 'Frédéric Berthiaume',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf9604590086003ffd083d',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 1,
          id: 1929028,
          known_for_department: 'Costume & Make-Up',
          name: 'Catherine Gélinas',
          original_name: 'Catherine Gélinas',
          popularity: 1.094,
          profile_path: null,
          credit_id: '5fcfa4e495c0af0040aabca3',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1973351,
          known_for_department: 'Editing',
          name: 'Megan Pollin',
          original_name: 'Megan Pollin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa5576c0e4f0041be7dea',
          department: 'Production',
          job: 'Post Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2054780,
          known_for_department: 'Production',
          name: 'Johanne Titley',
          original_name: 'Johanne Titley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa438e32943003e439b2e',
          department: 'Production',
          job: 'Extras Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 2054801,
          known_for_department: 'Camera',
          name: 'Brad MacLean',
          original_name: 'Brad MacLean',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa285590086003efd4f46',
          department: 'Camera',
          job: 'Dolly Grip',
        },
        {
          adult: false,
          gender: 2,
          id: 2114263,
          known_for_department: 'Lighting',
          name: 'Cameron Smith',
          original_name: 'Cameron Smith',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa2ba680be85cc219ab7c',
          department: 'Lighting',
          job: 'Best Boy Electric',
        },
        {
          adult: false,
          gender: 0,
          id: 2145806,
          known_for_department: 'Art',
          name: 'Carl Lessard',
          original_name: 'Carl Lessard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf998657530e00408fc0f6',
          department: 'Art',
          job: 'Graphic Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2427862,
          known_for_department: 'Camera',
          name: 'Laurent Alexis Guertin',
          original_name: 'Laurent Alexis Guertin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa1845b4fed00400ac8a7',
          department: 'Camera',
          job: 'Second Assistant "B" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2427866,
          known_for_department: 'Production',
          name: 'Linda Torino Tondreau',
          original_name: 'Linda Torino Tondreau',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa603680be8003d1fb908',
          department: 'Production',
          job: 'Assistant Location Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 2433008,
          known_for_department: 'Camera',
          name: 'Rémi Giroux',
          original_name: 'Rémi Giroux',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa13cfba625003f7da64f',
          department: 'Camera',
          job: 'Best Boy Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2640536,
          known_for_department: 'Directing',
          name: 'Anik Drapeau',
          original_name: 'Anik Drapeau',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf977e95c0af0041aa0adf',
          department: 'Directing',
          job: 'Second Second Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2759030,
          known_for_department: 'Camera',
          name: 'Chris Kovalski',
          original_name: 'Chris Kovalski',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa226a67254003f7ab839',
          department: 'Camera',
          job: 'Best Boy Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2805288,
          known_for_department: 'Crew',
          name: 'Jeremy Lavalley',
          original_name: 'Jeremy Lavalley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf9d1995c0af0046a8d94b',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 0,
          id: 2873722,
          known_for_department: 'Directing',
          name: 'Natalia Ortelli',
          original_name: 'Natalia Ortelli',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf9800dcf8750042458c4e',
          department: 'Directing',
          job: 'Third Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2886461,
          known_for_department: 'Directing',
          name: 'Nathalie Lacoste',
          original_name: 'Nathalie Lacoste',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf978f590086003ffd09ab',
          department: 'Directing',
          job: 'Third Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2886463,
          known_for_department: 'Art',
          name: 'Antoine Bianchi',
          original_name: 'Antoine Bianchi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf986a7314a10040d0cbd8',
          department: 'Art',
          job: 'Greensman',
        },
        {
          adult: false,
          gender: 0,
          id: 2886465,
          known_for_department: 'Art',
          name: 'Diane Legris',
          original_name: 'Diane Legris',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf9973fba625003f7d9d3f',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 2886467,
          known_for_department: 'Crew',
          name: 'Carole Gauthier',
          original_name: 'Carole Gauthier',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcf9c7c95c0af0040aab090',
          department: 'Crew',
          job: 'Special Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2886495,
          known_for_department: 'Camera',
          name: 'René Fréchette',
          original_name: 'René Fréchette',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa0c45b4fed00400ac7f8',
          department: 'Camera',
          job: 'Second Assistant "C" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2886516,
          known_for_department: 'Camera',
          name: 'Hugues Tremblay',
          original_name: 'Hugues Tremblay',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa31ba5743d003f0b2381',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 2886517,
          known_for_department: 'Camera',
          name: 'William Tricarico',
          original_name: 'William Tricarico',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa3317314a10041d054f5',
          department: 'Camera',
          job: 'Dolly Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2886528,
          known_for_department: 'Costume & Make-Up',
          name: 'Cristina Carvalho',
          original_name: 'Cristina Carvalho',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa4a495c0af0041aa2081',
          department: 'Costume & Make-Up',
          job: 'Seamstress',
        },
        {
          adult: false,
          gender: 0,
          id: 2886536,
          known_for_department: 'Editing',
          name: 'Richard Saulnier II',
          original_name: 'Richard Saulnier II',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa57257530e00448f4fd0',
          department: 'Editing',
          job: 'Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2886543,
          known_for_department: 'Production',
          name: 'Angie Marquis',
          original_name: 'Angie Marquis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fcfa6e1e32943003d4428bf',
          department: 'Production',
          job: 'Production Secretary',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'Reno',
          author_details: {
            name: 'Reno',
            username: 'Rangan',
            avatar_path: '/6ZpVUJzqXMzH35VprEtnX0sNI3.jpg',
            rating: 6.0,
          },
          content:
            "**The return of the bad Santa!**\r\n\r\nI did not expect this sequel, especially not after 13 years. Even the first film has been just a good for me. I won't say it was an unnecessary follow up. They retained main cast, well, only lead two plus the boy who is now in his early 20s. A similar pattern storyline. If you have already seen the previous one, you would know what to expect from it, but not how much and that was the main issue with this. So anyone would predict the scenes, as well as the twist. Like most of the sequels, it indeed weakened. Though somewhat enjoyable for the good performances.\r\n\r\nR rated comedy. That's another advantage for the grownup audience. But if you aren't a fan of that thematic, then it is even worse than what it's rated everywhere. The length was good, a simple plot, yet the characters had not seriously developed, particularly the new ones. The big excuse was it is a comedy film. They all just came in and straight away displayed whatever they were up to as if we knew them very well. Despite an average film, it can be watched once, even if you liked or not the first part. And it is mainly because of Billy Bob Thornton.\r\n\r\n_6/10_",
          created_at: '2017-06-15T22:16:50.954Z',
          id: '594307529251417f6b0138da',
          updated_at: '2021-06-23T15:57:58.456Z',
          url: 'https://www.themoviedb.org/review/594307529251417f6b0138da',
        },
        {
          author: 'Gimly',
          author_details: {
            name: 'Gimly',
            username: 'Ruuz',
            avatar_path: '/xUObnJSvHrFPsIpoDmb1jiQZLq7.jpg',
            rating: 4.0,
          },
          content:
            "A massive drop in quality compared to the first _Bad Santa_ movie, and although Kathy Bates was a welcome addition to the series, based on this entry, I don't think we're likely to ever see a _Bad Santa 3_. \r\n\r\n_Final rating:★★ - Had some things that appeal to me, but a poor finished product_.",
          created_at: '2018-09-06T13:30:44.324Z',
          id: '5b912c04925141669f00eb47',
          updated_at: '2021-06-23T15:58:12.179Z',
          url: 'https://www.themoviedb.org/review/5b912c04925141669f00eb47',
        },
      ],
      total_pages: 1,
      total_results: 2,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/sqlQt6Orr2hEOb7fekhjCefhiED.jpg',
    belongs_to_collection: null,
    budget: 20000000,
    genres: [
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 35, name: 'Phim Hài' },
    ],
    homepage: 'http://www.roughnightmovie.com/',
    id: 397422,
    imdb_id: 'tt4799050',
    original_language: 'en',
    original_title: 'Rough Night',
    overview:
      'Phim Tiệc Độc Thân Nhớ Đời được coi là phiên bản nữ của siêu phẩm hài The Hangover, Rough Night là câu chuyện về năm cô gái trẻ cùng thuê vũ công thoát y để chơi bời trọn đêm. Đang phấn khích thì “trai nhảy” bỗng nhiên đột tử, báo hại các cô nàng phải khổ sở tìm cách phi tang xác. Vận dụng mọi thủ đoạn có thể nghĩ ra để tạo chứng cứ ngoại phạm giả, các cô gái đem cái xác di chuyển khắp nơi. Thế nhưng, càng sửa lại càng sai, họ phải đương đầu cùng hàng loạt rắc rối.',
    popularity: 23.429,
    poster_path:
      'https://image.tmdb.org/t/p/w342/ttC00xcQ5UIO04kU8y0h5OAIYYJ.jpg',
    production_companies: [
      {
        id: 76778,
        logo_path: null,
        name: 'Paulilu Productions',
        origin_country: '',
      },
      {
        id: 34,
        logo_path: '/GagSvqWlyPdkFHMfQ3pNq6ix9P.png',
        name: 'Sony Pictures',
        origin_country: 'US',
      },
      {
        id: 5,
        logo_path: '/71BqEFAF4V3qjjMPCpLuyJFB9A.png',
        name: 'Columbia Pictures',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2017-06-15',
    revenue: 45056771,
    runtime: 101,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'The hangover will be the least of their problems',
    title: 'Tiệc Độc Thân Nhớ Đời',
    video: false,
    vote_average: 5.7,
    vote_count: 1692,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'ROUGH NIGHT - Official Restricted Trailer (HD)',
          key: 'oIB4jNYeRY4',
          published_at: '2017-03-08T19:00:05.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '58c06ccc9251412c820000bd',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 1245,
          known_for_department: 'Diễn viên',
          name: 'Scarlett Johansson',
          original_name: 'Scarlett Johansson',
          popularity: 24.802,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6NsMbJXRlDZuDzatN2akFdGuTvx.jpg',
          cast_id: 3,
          character: 'Jess Thayer',
          credit_id: '57367eb0c3a3687e1d0017ee',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 1226302,
          known_for_department: 'Diễn viên',
          name: 'Jillian Bell',
          original_name: 'Jillian Bell',
          popularity: 1.822,
          profile_path:
            'https://image.tmdb.org/t/p/w185/v3oJlWGjdV3aHNXtGjWea3X1Tov.jpg',
          cast_id: 7,
          character: 'Alice',
          credit_id: '57367f40c3a3687e2f0018d4',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 37153,
          known_for_department: 'Diễn viên',
          name: 'Zoë Kravitz',
          original_name: 'Zoë Kravitz',
          popularity: 6.627,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zx74kkI931iiQATJybvRKWYnOe9.jpg',
          cast_id: 4,
          character: 'Blair',
          credit_id: '57367ebbc3a3687e2a00189d',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 1240487,
          known_for_department: 'Diễn viên',
          name: 'Kate McKinnon',
          original_name: 'Kate McKinnon',
          popularity: 5.359,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2cNetzianFcxPQbyOQnkAIkKUZE.jpg',
          cast_id: 5,
          character: 'Pippa',
          credit_id: '57367ec79251417b3a000b97',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 1325716,
          known_for_department: 'Diễn viên',
          name: 'Ilana Glazer',
          original_name: 'Ilana Glazer',
          popularity: 0.738,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ay29sY5IxYvQNFhCYP9j1o1vLIk.jpg',
          cast_id: 6,
          character: 'Frankie',
          credit_id: '57367f369251417b3a000bb3',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 15232,
          known_for_department: 'Diễn viên',
          name: 'Ty Burrell',
          original_name: 'Ty Burrell',
          popularity: 3.651,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zXrrbvW2ZKHYHbhujDj8aBlO4yx.jpg',
          cast_id: 10,
          character: 'Pietro',
          credit_id: '57e58110925141414f001150',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 3416,
          known_for_department: 'Diễn viên',
          name: 'Demi Moore',
          original_name: 'Demi Moore',
          popularity: 5.764,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lgojmzzzNS6qnho24NdUYDy9nxS.jpg',
          cast_id: 9,
          character: 'Lea',
          credit_id: '57e580a6c3a3681bd80010c6',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 211800,
          known_for_department: 'Diễn viên',
          name: 'Colton Haynes',
          original_name: 'Colton Haynes',
          popularity: 3.685,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gBWDLczwlKDrWcgI8MY126GehEt.jpg',
          cast_id: 13,
          character: 'Officer Scotty',
          credit_id: '57e581b29251414146001373',
          order: 7,
        },
        {
          adult: false,
          gender: 0,
          id: 1607044,
          known_for_department: 'Diễn viên',
          name: 'Paul W. Downs',
          original_name: 'Paul W. Downs',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7sOqM5c4XX4SWzAEKuyGBRRcWwK.jpg',
          cast_id: 8,
          character: 'Peter',
          credit_id: '57367f49c3a36823dc000b9d',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 1102453,
          known_for_department: 'Diễn viên',
          name: 'Ryan Cooper',
          original_name: 'Ryan Cooper',
          popularity: 7.129,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mcwDwDirh8YzkMvWKZNZttMQ3fp.jpg',
          cast_id: 12,
          character: 'Jay',
          credit_id: '57e5816ac3a3681bdb00114f',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 11516,
          known_for_department: 'Diễn viên',
          name: 'Devin Ratray',
          original_name: 'Devin Ratray',
          popularity: 14.099,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gb0IIdsnvOG2j0Dt1FSSsCQZXt6.jpg',
          cast_id: 37,
          character: 'Bud',
          credit_id: '59471e5ac3a368261900fc5f',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 68763,
          known_for_department: 'Diễn viên',
          name: 'Dean Winters',
          original_name: 'Dean Winters',
          popularity: 3.45,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4kwzxdILxtCfo33Z8EJQdlAc1e3.jpg',
          cast_id: 11,
          character: 'Detective Frazier',
          credit_id: '57e5812bc3a3681be8001074',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 12798,
          known_for_department: 'Diễn viên',
          name: 'Enrique Murciano',
          original_name: 'Enrique Murciano',
          popularity: 3.121,
          profile_path:
            'https://image.tmdb.org/t/p/w185/r1KGKFRzPyAGqqPI8adzlZfNO20.jpg',
          cast_id: 29,
          character: 'Detective Ruiz',
          credit_id: '593d645e925141058f020a79',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 934159,
          known_for_department: 'Diễn viên',
          name: 'Eric André',
          original_name: 'Eric André',
          popularity: 5.391,
          profile_path:
            'https://image.tmdb.org/t/p/w185/e9XlcFnZQiBSQ1vISQVyTOrkIaq.jpg',
          cast_id: 31,
          character: 'Jake',
          credit_id: '593d6479c3a3680f670208f1',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 115128,
          known_for_department: 'Diễn viên',
          name: 'Bo Burnham',
          original_name: 'Bo Burnham',
          popularity: 2.659,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dUScnqhmmSgxbzxq8D2QlxgpRVA.jpg',
          cast_id: 30,
          character: 'Tobey',
          credit_id: '593d646ec3a3680f670208e6',
          order: 14,
        },
        {
          adult: false,
          gender: 0,
          id: 1456328,
          known_for_department: 'Diễn viên',
          name: 'Patrick Carlyle',
          original_name: 'Patrick Carlyle',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2YQfQ1Yby5haOqkYTtpWZkflWA3.jpg',
          cast_id: 32,
          character: 'Patrick',
          credit_id: '59471dedc3a368170f03395c',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 552252,
          known_for_department: 'Diễn viên',
          name: 'Hasan Minhaj',
          original_name: 'Hasan Minhaj',
          popularity: 1.286,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3BLk3tMJ1p8aIMRKPTk9NrbSt9A.jpg',
          cast_id: 33,
          character: 'Joe',
          credit_id: '59471e019251413fc2030674',
          order: 16,
        },
        {
          adult: false,
          gender: 2,
          id: 1109702,
          known_for_department: 'Diễn viên',
          name: 'Karan Soni',
          original_name: 'Karan Soni',
          popularity: 1.88,
          profile_path:
            'https://image.tmdb.org/t/p/w185/s7jfz0OA9PeCEf1Te5b2heOia0b.jpg',
          cast_id: 19,
          character: 'Raviv',
          credit_id: '5848f93ac3a36814140106b8',
          order: 17,
        },
        {
          adult: false,
          gender: 0,
          id: 1448661,
          known_for_department: 'Biên kịch',
          name: 'Laura Grey',
          original_name: 'Laura Grey',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rZMilpG4RjKntaci9YhEGkXv1P7.jpg',
          cast_id: 39,
          character: 'Lisa',
          credit_id: '594b8f3bc3a36832bd00e14f',
          order: 18,
        },
        {
          adult: false,
          gender: 2,
          id: 1344380,
          known_for_department: 'Diễn viên',
          name: 'Mark Tallman',
          original_name: 'Mark Tallman',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vJN40G3AE6S94VH32m7f7XDueo7.jpg',
          cast_id: 34,
          character: 'Malcolm',
          credit_id: '59471e119251417e4c011191',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 181876,
          known_for_department: 'Diễn viên',
          name: 'Daniel Raymont',
          original_name: 'Daniel Raymont',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qe1J4MwhvJuTmlFghcLne8tEBaL.jpg',
          cast_id: 41,
          character: 'Sommelier',
          credit_id: '599b8f96c3a36823190056ee',
          order: 20,
        },
        {
          adult: false,
          gender: 2,
          id: 66297,
          known_for_department: 'Diễn viên',
          name: 'Madison Arnold',
          original_name: 'Madison Arnold',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rbgHUIcP9rD0AwWNliCD3ZR80ep.jpg',
          cast_id: 14,
          character: 'Morty',
          credit_id: '57e581e3c3a3681bd800116e',
          order: 21,
        },
        {
          adult: false,
          gender: 0,
          id: 1874142,
          known_for_department: 'Diễn viên',
          name: 'Gina Cottone',
          original_name: 'Gina Cottone',
          popularity: 0.6,
          profile_path: null,
          cast_id: 42,
          character: 'Betty',
          credit_id: '599b8fa0c3a36823000057f6',
          order: 22,
        },
        {
          adult: false,
          gender: 2,
          id: 1016304,
          known_for_department: 'Diễn viên',
          name: 'Matty Blake',
          original_name: 'Matty Blake',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dl8Dyx3iSpgspdlP4xMS3KHTBN9.jpg',
          cast_id: 43,
          character: 'Gary',
          credit_id: '599b8fac9251410e71005a8d',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 1154221,
          known_for_department: 'Diễn viên',
          name: 'Peter Grosz',
          original_name: 'Peter Grosz',
          popularity: 0.716,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9aVKXpi1MmFB9m8uNR65AH8UD7z.jpg',
          cast_id: 36,
          character: 'Cliff',
          credit_id: '59471e52c3a368111501f158',
          order: 24,
        },
        {
          adult: false,
          gender: 2,
          id: 113230,
          known_for_department: 'Diễn viên',
          name: 'Peter Francis James',
          original_name: 'Peter Francis James',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5SoURAlFOANJ9ZnaGoVHtTjurbF.jpg',
          cast_id: 38,
          character: 'Jack Eason',
          credit_id: '59471e67c3a36816e4031468',
          order: 25,
        },
        {
          adult: false,
          gender: 0,
          id: 1431441,
          known_for_department: 'Diễn viên',
          name: 'Miriam Tolan',
          original_name: 'Miriam Tolan',
          popularity: 0.6,
          profile_path: null,
          cast_id: 44,
          character: 'Maureen',
          credit_id: '599b8fbcc3a3682337005d83',
          order: 26,
        },
        {
          adult: false,
          gender: 0,
          id: 1230389,
          known_for_department: 'Diễn viên',
          name: 'Brian Stack',
          original_name: 'Brian Stack',
          popularity: 0.869,
          profile_path: null,
          cast_id: 45,
          character: 'Bob',
          credit_id: '599b8fc6c3a368228c0057ea',
          order: 27,
        },
        {
          adult: false,
          gender: 1,
          id: 1457224,
          known_for_department: 'Diễn viên',
          name: 'Doris McCarthy',
          original_name: 'Doris McCarthy',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gqHrbT8exZoyS2w7dmLGzmBldV8.jpg',
          cast_id: 17,
          character: 'Victory Party Guest',
          credit_id: '57e5835a925141413d0011f4',
          order: 28,
        },
        {
          adult: false,
          gender: 1,
          id: 1684010,
          known_for_department: 'Diễn viên',
          name: 'Emmy Elliott',
          original_name: 'Emmy Elliott',
          popularity: 0.6,
          profile_path: null,
          cast_id: 18,
          character: 'Go-Go Dancer',
          credit_id: '57e58382925141413a0013a1',
          order: 29,
        },
        {
          adult: false,
          gender: 3,
          id: 1772622,
          known_for_department: 'Diễn viên',
          name: 'Bob the Drag Queen',
          original_name: 'Bob the Drag Queen',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uhCV6dA5GoNaa3VYGIT7qfKxUKC.jpg',
          cast_id: 47,
          character: 'DJ (Club Liv)',
          credit_id: '5a531a6b0e0a26026c02e63c',
          order: 30,
        },
        {
          adult: false,
          gender: 2,
          id: 1998733,
          known_for_department: 'Diễn viên',
          name: 'Jaboukie Young-White',
          original_name: 'Jaboukie Young-White',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/itB6SyGCGxdcd3DcS8L2RCdicVo.jpg',
          cast_id: 50,
          character: '',
          credit_id: '5bc2bfb992514179b603c661',
          order: 31,
        },
        {
          adult: false,
          gender: 2,
          id: 1939366,
          known_for_department: 'Diễn viên',
          name: 'Azhy Robertson',
          original_name: 'Azhy Robertson',
          popularity: 1.924,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6RoaHJAdnQPioROie1JKAgCwqjm.jpg',
          cast_id: 49,
          character: 'Charlie (uncredited)',
          credit_id: '5bb802b00e0a2677cf00225b',
          order: 32,
        },
        {
          adult: false,
          gender: 2,
          id: 2115854,
          known_for_department: 'Diễn viên',
          name: 'Winslow Fegley',
          original_name: 'Winslow Fegley',
          popularity: 2.304,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fx72xnTrHYLsFA3CUlDbwojH8G7.jpg',
          cast_id: 48,
          character: 'Boy in the Playground (uncredited)',
          credit_id: '5b833b22c3a3686555036151',
          order: 33,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 6742,
          known_for_department: 'Editing',
          name: 'Craig Alpert',
          original_name: 'Craig Alpert',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57e58313c3a3681be3001161',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 59724,
          known_for_department: 'Production',
          name: 'Jonathan Shoemaker',
          original_name: 'Jonathan Shoemaker',
          popularity: 0.694,
          profile_path: null,
          credit_id: '58db0de3c3a3687d1d001ec9',
          department: 'Production',
          job: 'Unit Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 60194,
          known_for_department: 'Art',
          name: 'Carol Silverman',
          original_name: 'Carol Silverman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58db0da4c3a3687d28001f4a',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 2,
          id: 65918,
          known_for_department: 'Production',
          name: 'Dave Becky',
          original_name: 'Dave Becky',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58db0d4b92514133d1001dcf',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 971528,
          known_for_department: 'Costume & Make-Up',
          name: 'Leah Katznelson',
          original_name: 'Leah Katznelson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58db0dbb92514133b9001c73',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 2,
          id: 977941,
          known_for_department: 'Production',
          name: 'Matt Tolmach',
          original_name: 'Matt Tolmach',
          popularity: 2.189,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8mniHJVwoJdVpwxW278yJwz8c1T.jpg',
          credit_id: '598cc93cc3a3683a7f00039a',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1010024,
          known_for_department: 'Camera',
          name: 'Sean Porter',
          original_name: 'Sean Porter',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yEHtAfCTAG4TbJOHCkGai98N1Wz.jpg',
          credit_id: '57e582ed925141414300137e',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 1399858,
          known_for_department: 'Production',
          name: 'Matthew Hirsch',
          original_name: 'Matthew Hirsch',
          popularity: 0.828,
          profile_path: null,
          credit_id: '58db0d7f92514133d1001dfe',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1410302,
          known_for_department: 'Visual Effects',
          name: 'David Van Dyke',
          original_name: 'David Van Dyke',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58db0e11c3a3687d63001e25',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 1,
          id: 1480620,
          known_for_department: 'Biên kịch',
          name: 'Lucia Aniello',
          original_name: 'Lucia Aniello',
          popularity: 0.75,
          profile_path:
            'https://image.tmdb.org/t/p/w185/60s5psYbHSs6NvgOHzMIQTlUJf0.jpg',
          credit_id: '57367d72c3a36823dc000b01',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 1,
          id: 1480620,
          known_for_department: 'Biên kịch',
          name: 'Lucia Aniello',
          original_name: 'Lucia Aniello',
          popularity: 0.75,
          profile_path:
            'https://image.tmdb.org/t/p/w185/60s5psYbHSs6NvgOHzMIQTlUJf0.jpg',
          credit_id: '58db0d32c3a3687d54001bc8',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1480620,
          known_for_department: 'Biên kịch',
          name: 'Lucia Aniello',
          original_name: 'Lucia Aniello',
          popularity: 0.75,
          profile_path:
            'https://image.tmdb.org/t/p/w185/60s5psYbHSs6NvgOHzMIQTlUJf0.jpg',
          credit_id: '57367de6c3a36823dc000b22',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 1607044,
          known_for_department: 'Diễn viên',
          name: 'Paul W. Downs',
          original_name: 'Paul W. Downs',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7sOqM5c4XX4SWzAEKuyGBRRcWwK.jpg',
          credit_id: '58db0d5ec3a3687d1d001e56',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1607044,
          known_for_department: 'Diễn viên',
          name: 'Paul W. Downs',
          original_name: 'Paul W. Downs',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7sOqM5c4XX4SWzAEKuyGBRRcWwK.jpg',
          credit_id: '57367df49251410b2100170a',
          department: 'Biên kịch',
          job: 'Writer',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'chrisman28',
          author_details: {
            name: 'chrisman28',
            username: 'Chrisman1989',
            avatar_path: null,
            rating: 6.0,
          },
          content:
            "I went to see this alone lol and I am a straight man and let me tell you I laughed out loud several times the characters were loveable and very welcoming one of the years best comedies ' I know that's not saying much ' but I truly enjoyed it and do recommend you go see it male or female you should enjoy this movie like I said I got a good long laugh try it enjoy,",
          created_at: '2017-07-06T16:06:59.035Z',
          id: '595e60239251410c5608591f',
          updated_at: '2021-06-23T15:57:59.060Z',
          url: 'https://www.themoviedb.org/review/595e60239251410c5608591f',
        },
        {
          author: 'Gimly',
          author_details: {
            name: 'Gimly',
            username: 'Ruuz',
            avatar_path: '/xUObnJSvHrFPsIpoDmb1jiQZLq7.jpg',
            rating: 3.0,
          },
          content:
            "The Australian accent is one that is very hard to nail down, I know that. But getting it wrong is just so bloody aggravating. Simple solutions: \r\nA) If the character doesn't have to be Australian, then just don't make them Australian.\r\nB) Just hire an actual Australian! Hollywood is full of the bastards!\r\nC) Hire one of the like... 3 actors who can actually do the job outside of these two options.\r\nKate McKinnon is not one of those 3 actors.\r\n\r\n...Oh and also _Rough Night_ was not very good.\r\n\r\n_Final rating:★½: - Boring/disappointing. Avoid where possible._",
          created_at: '2017-09-26T04:43:11.710Z',
          id: '59c9dadfc3a36803b7003e37',
          updated_at: '2021-06-23T15:58:01.357Z',
          url: 'https://www.themoviedb.org/review/59c9dadfc3a36803b7003e37',
        },
        {
          author: 'Reno',
          author_details: {
            name: 'Reno',
            username: 'Rangan',
            avatar_path: '/6ZpVUJzqXMzH35VprEtnX0sNI3.jpg',
            rating: 6.0,
          },
          content:
            "**Bachelorette gone wrong!**\r\n\r\nThis kind of girls night out flicks are not fun anymore. Yet it is hard to ignore them from watching. So I watched it not expecting anything special out of it. And I did not get any. But... it was okayish. Moreover, Scarlett Johansson was the main reason I wanted to watch it. You can't always do superhero, action films. This is something offbeat. Often need to take this path, no to fail miserably, but to relax from the mainstream. So this was enjoyable, but not by all.\r\n\r\nIt is like the female version of 'Hangover'. Five friends go to Miami for one of theirs bachelorette party. It's supposed to be fun without any rules, but a disaster strikes in the early and makes them to cover all the evidence. The night turns their worst nightmare ever. How they manage to come out of it are the remaining film that revealed with a twist at the end.\r\n\r\nThe reception was as expected, but it was not that bad if you are seeking only a timepass. It ended like there could be a sequel, but now it seems very unlikely. One of the issues with the film is it was so traditional narrative. With so many jokes repeated from other flicks. The majority won't approve that. As far as I think it is watch and forget kind of film. An average film. Disliking it does not change what it is!\r\n\r\n_6/10_",
          created_at: '2018-02-04T13:59:04.132Z',
          id: '5a7711a892514105a9043e51',
          updated_at: '2021-06-23T15:58:04.752Z',
          url: 'https://www.themoviedb.org/review/5a7711a892514105a9043e51',
        },
      ],
      total_pages: 1,
      total_results: 3,
    },
  },
  {
    adult: false,
    backdrop_path: null,
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 35, name: 'Phim Hài' },
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 53, name: 'Phim Gây Cấn' },
    ],
    homepage: '',
    id: 699361,
    imdb_id: 'tt13326736',
    original_language: 'vi',
    original_title: 'Tiệc Trăng Máu',
    overview:
      'Trong buổi họp mặt của nhóm bạn thân, một thành viên bất ngờ đề xuất trò chơi chia sẻ điện thoại nhằm tăng tinh thần “đoàn kết”. Từ đó, những góc khuất của từng người dần hé lộ và khiến cho mối quan hệ vốn khắng khít của họ bắt đầu lay chuyển.',
    popularity: 0.84,
    poster_path:
      'https://image.tmdb.org/t/p/w342/1gtr8Js6yS7gWrQylbIK4sGQGih.jpg',
    production_companies: [
      {
        id: 3657,
        logo_path: '/2YXnZa6yPjxdHKzBLgmf57D8QpM.png',
        name: 'Sidus',
        origin_country: 'KR',
      },
      {
        id: 113553,
        logo_path: null,
        name: 'Film Monster',
        origin_country: 'KR',
      },
      {
        id: 144986,
        logo_path: null,
        name: 'Anh Teu Studio',
        origin_country: '',
      },
      {
        id: 7819,
        logo_path: '/ghFZAt4edln0M7BzDExyYMzUGX1.png',
        name: 'Lotte Entertainment',
        origin_country: 'KR',
      },
    ],
    production_countries: [{ iso_3166_1: 'VN', name: 'Vietnam' }],
    release_date: '2020-10-23',
    revenue: 0,
    runtime: 118,
    spoken_languages: [
      { english_name: 'Vietnamese', iso_639_1: 'vi', name: 'Tiếng Việt' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Tiệc Trăng Máu',
    video: false,
    vote_average: 5.5,
    vote_count: 2,
    videos: { results: [] },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 1157996,
          known_for_department: 'Diễn viên',
          name: 'Thái Hòa',
          original_name: 'Thái Hòa',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3U8qrKPAzXe2Qa3tl5DUN19Skar.jpg',
          cast_id: 1,
          character: 'Bình',
          credit_id: '5eace3de5a7884001cc359dc',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 1841831,
          known_for_department: 'Diễn viên',
          name: 'Hồng Ánh',
          original_name: 'Hồng Ánh',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7xFPF7ms90QIozs3W8L44wHtBLK.jpg',
          cast_id: 3,
          character: 'Nguyệt Ánh',
          credit_id: '5eace3fd0c3ec8001dcb14f6',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 1598145,
          known_for_department: 'Diễn viên',
          name: 'Hứa Vĩ Văn',
          original_name: 'Hứa Vĩ Văn',
          popularity: 0.608,
          profile_path:
            'https://image.tmdb.org/t/p/w185/i4xQ5KdIUFBoEcTIV3VuPICzK11.jpg',
          cast_id: 4,
          character: 'Quang',
          credit_id: '5eace40c5a7884001ac34b32',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 1841829,
          known_for_department: 'Diễn viên',
          name: 'Thu Trang',
          original_name: 'Thu Trang',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oSpHBUKu9vNcmQTJD9w936jJD7R.jpg',
          cast_id: 5,
          character: 'Quỳnh',
          credit_id: '5eace41466469a001f5c97f3',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 1330249,
          known_for_department: 'Diễn viên',
          name: 'Kiều Minh Tuấn',
          original_name: 'Kiều Minh Tuấn',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bcbOUKabmDtiRjZlNL2UpJvxJzz.jpg',
          cast_id: 6,
          character: 'Linh',
          credit_id: '5eace42366469a001c5ca95f',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 1841663,
          known_for_department: 'Diễn viên',
          name: 'Kaity Nguyễn',
          original_name: 'Kaity Nguyễn',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rLaOlWxXif7OX1mTWcQJkIcu154.jpg',
          cast_id: 7,
          character: 'Kathy',
          credit_id: '5eace42fba131b001d43974b',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 1593129,
          known_for_department: 'Directing',
          name: 'NSƯT Đức Thịnh',
          original_name: 'NSƯT Đức Thịnh',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3zRVqDjr94R6cKz6WNuPtf7jGM9.jpg',
          cast_id: 16,
          character: 'Mạnh',
          credit_id: '60ca1b47c390c50079db71d7',
          order: 8,
        },
        {
          adult: false,
          gender: 1,
          id: 3128699,
          known_for_department: 'Diễn viên',
          name: 'Việt Linh',
          original_name: 'Việt Linh',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/138J7TnM3mAcKJunLAtKR7MvFZI.jpg',
          cast_id: 17,
          character: 'Ánh Dương',
          credit_id: '60ccc0b6a9117f006eb060b3',
          order: 9,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 149349,
          known_for_department: 'Diễn viên',
          name: 'Rolando Ravello',
          original_name: 'Rolando Ravello',
          popularity: 1.135,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gbs0o5DCN4WyyHL4y1UcXPzs5CM.jpg',
          credit_id: '5fc9f2e3a5743d004203329f',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 225160,
          known_for_department: 'Biên kịch',
          name: 'Paolo Genovese',
          original_name: 'Paolo Genovese',
          popularity: 1.449,
          profile_path:
            'https://image.tmdb.org/t/p/w185/inn6owypkGYh8zzGiD7s3HgSCQc.jpg',
          credit_id: '5fc9f2dc66a7c3003f4674f7',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 225880,
          known_for_department: 'Biên kịch',
          name: 'Paolo Costella',
          original_name: 'Paolo Costella',
          popularity: 1.026,
          profile_path: null,
          credit_id: '5fc9f2d3d8e22500429113ac',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 1269894,
          known_for_department: 'Biên kịch',
          name: 'Filippo Bologna',
          original_name: 'Filippo Bologna',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5fc9f2c1ec8a43004042fad3',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 1300743,
          known_for_department: 'Directing',
          name: 'Nguyễn Quang Dũng',
          original_name: 'Nguyễn Quang Dũng',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5eace45766469a001c5ca99a',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1575877,
          known_for_department: 'Biên kịch',
          name: 'Paola Mammini',
          original_name: 'Paola Mammini',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fc9f2cb8261ee00413e41ef',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 1588256,
          known_for_department: 'Directing',
          name: 'Phan Gia Nhật Linh',
          original_name: 'Phan Gia Nhật Linh',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xV5tRwraRT5L52zwvBI8JrIXDvD.jpg',
          credit_id: '5eace46a60c51d001e916b63',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2880876,
          known_for_department: 'Production',
          name: 'Choi Yun-ho',
          original_name: 'Choi Yun-ho',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fc9f1c0b0040a0040267e42',
          department: 'Production',
          job: 'Producer',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/5rYnygKCkmqWuMv1O5yAnzGF8gV.jpg',
    belongs_to_collection: null,
    budget: 177200000,
    genres: [
      { id: 12, name: 'Phim Phiêu Lưu' },
      { id: 878, name: 'Phim Khoa Học Viễn Tưởng' },
      { id: 28, name: 'Phim Hành Động' },
    ],
    homepage: '',
    id: 339964,
    imdb_id: 'tt2239822',
    original_language: 'en',
    original_title: 'Valerian and the City of a Thousand Planets',
    overview:
      'Trong phim, Valerian là một mật vụ của chính phủ loài người, được cử đến một thành phố thuộc thiên hà Alpha, nơi đây qui tụ hàng ngàn giống loài khác nhau khắp vũ trụ đến sinh sống. Từ việc này, Valerian phát hiện âm mưu hủy diệt Trái đất và anh buộc phải tìm cách ngăn cản việc đó xảy ra.',
    popularity: 48.101,
    poster_path:
      'https://image.tmdb.org/t/p/w342/5lBPaVovoK2iZId4Y3BTeEm5n0B.jpg',
    production_companies: [
      { id: 98007, logo_path: null, name: 'BNP Paribas', origin_country: 'FR' },
      {
        id: 1145,
        logo_path: '/995rL7XQxJiG4eE7gHYB82sO61S.png',
        name: 'Belga Films',
        origin_country: 'BE',
      },
      {
        id: 1246,
        logo_path: '/lmeFQGzHEds5t2UfmODyrbf2nXm.png',
        name: 'River Road Entertainment',
        origin_country: 'US',
      },
      {
        id: 6877,
        logo_path: null,
        name: 'Grive Productions',
        origin_country: '',
      },
      {
        id: 6896,
        logo_path: '/2Q89KvzxTKB5BAv9RqFIPI1qb7E.png',
        name: 'EuropaCorp',
        origin_country: 'FR',
      },
      { id: 12372, logo_path: null, name: 'UFA', origin_country: 'DE' },
      {
        id: 55244,
        logo_path: '/6tjtQvghRRXFmCsuN8SsKJW6cIm.png',
        name: 'Fundamental Films',
        origin_country: 'CN',
      },
      { id: 96686, logo_path: null, name: 'Gulf Film', origin_country: '' },
      { id: 96687, logo_path: null, name: 'Novo Pictures', origin_country: '' },
      {
        id: 356,
        logo_path: '/9tW5wZEGotn1Ei5pErA88m47XiD.png',
        name: 'TF1 Films Production',
        origin_country: 'FR',
      },
      {
        id: 15433,
        logo_path: '/9nnaDAbuHwbikxAV1t1BC2Z60GC.png',
        name: 'Orange Studio',
        origin_country: 'FR',
      },
    ],
    production_countries: [
      { iso_3166_1: 'BE', name: 'Belgium' },
      { iso_3166_1: 'CA', name: 'Canada' },
      { iso_3166_1: 'CN', name: 'Trung Quốc' },
      { iso_3166_1: 'FR', name: 'France' },
      { iso_3166_1: 'DE', name: 'Germany' },
      { iso_3166_1: 'AE', name: 'United Arab Emirates' },
      { iso_3166_1: 'GB', name: 'United Kingdom' },
      { iso_3166_1: 'US', name: 'Hoa Kì' },
    ],
    release_date: '2017-07-20',
    revenue: 225874228,
    runtime: 136,
    spoken_languages: [
      { english_name: 'French', iso_639_1: 'fr', name: 'Français' },
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'A universe without boundaries needs heroes without limits.',
    title: 'Valerian Và Thành Phố Ngàn Hành Tinh',
    video: false,
    vote_average: 6.6,
    vote_count: 6150,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Valerian and the City of a Thousand Planets (2017) Teaser',
          key: 'BASgoRz72R0',
          published_at: '2017-12-10T19:08:18.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Teaser',
          official: false,
          id: '5a2d86000e0a264cca14f047',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Valerian and the City of a Thousand Planets Trailer #1 (2017) | Movieclips Trailers',
          key: '_shrCoqWh9k',
          published_at: '2017-05-24T13:30:01.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: false,
          id: '5a05a0519251417e12017c0e',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 122889,
          known_for_department: 'Diễn viên',
          name: 'Dane DeHaan',
          original_name: 'Dane DeHaan',
          popularity: 5.19,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vZ7ix8UeRYgepFPFc4FIVKDLKDX.jpg',
          cast_id: 7,
          character: 'Valerian',
          credit_id: '555272409251415b21001667',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 1289968,
          known_for_department: 'Diễn viên',
          name: 'Cara Delevingne',
          original_name: 'Cara Delevingne',
          popularity: 8.377,
          profile_path:
            'https://image.tmdb.org/t/p/w185/izZ8IbsIjNpjZ5S0HIYreVwVRzn.jpg',
          cast_id: 6,
          character: 'Laureline',
          credit_id: '55527233c3a368436d00445b',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 2296,
          known_for_department: 'Diễn viên',
          name: 'Clive Owen',
          original_name: 'Clive Owen',
          popularity: 6.057,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ed0LT4wH1rUCviCFexd4XPZVHE1.jpg',
          cast_id: 8,
          character: 'Commander Arün Filitt',
          credit_id: '55e92935c3a3682c6400464b',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 131519,
          known_for_department: 'Diễn viên',
          name: 'Rihanna',
          original_name: 'Rihanna',
          popularity: 4.592,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6hWZI5Oj9YmVRvXwFUNk6psMw3V.jpg',
          cast_id: 9,
          character: 'Bubble',
          credit_id: '5630fb49c3a3681b54010473',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 569,
          known_for_department: 'Diễn viên',
          name: 'Ethan Hawke',
          original_name: 'Ethan Hawke',
          popularity: 12.719,
          profile_path:
            'https://image.tmdb.org/t/p/w185/a7rgJl8TYUWAfJuM4fxbLHgD7BL.jpg',
          cast_id: 10,
          character: 'Jolly the Pimp',
          credit_id: '566cd2a4c3a3682647009966',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 15193,
          known_for_department: 'Diễn viên',
          name: 'Herbie Hancock',
          original_name: 'Herbie Hancock',
          popularity: 1.286,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xjXWB5vdaiU9wUiOAkQeRY0cwob.jpg',
          cast_id: 20,
          character: 'Defence Minister',
          credit_id: '58eb50eec3a36873260815f4',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 1390948,
          known_for_department: 'Diễn viên',
          name: 'Kris Wu',
          original_name: 'Kris Wu',
          popularity: 4.332,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ht8RrzYbOEB3K2vheg51X33zmxt.jpg',
          cast_id: 12,
          character: 'Sergeant Neza',
          credit_id: '580ac8c5c3a368296700480b',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 585,
          known_for_department: 'Diễn viên',
          name: 'Rutger Hauer',
          original_name: 'Rutger Hauer',
          popularity: 8.474,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aNvyDYD0YscuwMfgy15wb5gRKph.jpg',
          cast_id: 13,
          character: 'President of the World State Federation',
          credit_id: '5831122cc3a3685b9301a6ec',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 1230,
          known_for_department: 'Diễn viên',
          name: 'John Goodman',
          original_name: 'John Goodman',
          popularity: 5.702,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yyYqoyKHO7hE1zpgEV2XlqYWcNV.jpg',
          cast_id: 11,
          character: 'Igon Siruss (voice)',
          credit_id: '566cd2a4c3a368535a00a4fe',
          order: 8,
        },
        {
          adult: false,
          gender: 1,
          id: 1133349,
          known_for_department: 'Diễn viên',
          name: 'Elizabeth Debicki',
          original_name: 'Elizabeth Debicki',
          popularity: 9.148,
          profile_path:
            'https://image.tmdb.org/t/p/w185/etzJKGHJPEB28CVMnW55JqucjNI.jpg',
          cast_id: 24,
          character: 'Emperor Haban-Limaï (voice)',
          credit_id: '594eabc3925141315503d3db',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 55585,
          known_for_department: 'Diễn viên',
          name: 'Sam Spruell',
          original_name: 'Sam Spruell',
          popularity: 8.131,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mV62no6D4yYtYS4A6dkHCGPTugZ.jpg',
          cast_id: 18,
          character: 'General Okto Bar',
          credit_id: '58eb50ed925141351f04913f',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 11045,
          known_for_department: 'Diễn viên',
          name: 'Ola Rapace',
          original_name: 'Ola Rapace',
          popularity: 1.707,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mVraMjR3X6wnlQCH2QoOXBXSkiX.jpg',
          cast_id: 394,
          character: 'Major Gibson',
          credit_id: '5973c0d1925141582b004240',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 4275,
          known_for_department: 'Diễn viên',
          name: 'Alain Chabat',
          original_name: 'Alain Chabat',
          popularity: 1.933,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xRjymE6LIJd0useKWN2R1WgKDRy.jpg',
          cast_id: 14,
          character: 'Bob the Pirate',
          credit_id: '58419ba09251417d59008704',
          order: 12,
        },
        {
          adult: false,
          gender: 0,
          id: 1867052,
          known_for_department: 'Diễn viên',
          name: 'Thom Findlay',
          original_name: 'Thom Findlay',
          popularity: 0.6,
          profile_path: null,
          cast_id: 440,
          character: 'Pirates (voice)',
          credit_id: '598bca71c3a368730e0052bb',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 2406,
          known_for_department: 'Diễn viên',
          name: 'Mathieu Kassovitz',
          original_name: 'Mathieu Kassovitz',
          popularity: 4.238,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3FRBEdKKlxhvPWPt0jzgmSjeHwn.jpg',
          cast_id: 16,
          character: 'Hawker',
          credit_id: '58eb50ed9251413ce4028d0a',
          order: 14,
        },
        {
          adult: false,
          gender: 1,
          id: 1315501,
          known_for_department: 'Diễn viên',
          name: 'Aymeline Valade',
          original_name: 'Aymeline Valade',
          popularity: 1.094,
          profile_path:
            'https://image.tmdb.org/t/p/w185/irkqkuAb7tF6FMOdcaY8eO9xO81.jpg',
          cast_id: 27,
          character: 'Emperor Haban-Limaï',
          credit_id: '59580f6bc3a368253c00fedc',
          order: 15,
        },
        {
          adult: false,
          gender: 1,
          id: 1411561,
          known_for_department: 'Diễn viên',
          name: 'Sasha Luss',
          original_name: 'Sasha Luss',
          popularity: 2.719,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vMLpPLLsVq6uphpAbfq55XrkMjf.jpg',
          cast_id: 383,
          character: "Princess Lïhio-Minaa / Creature 'Candy Dress'",
          credit_id: '5973c032c3a3685ded004817',
          order: 16,
        },
        {
          adult: false,
          gender: 1,
          id: 1740333,
          known_for_department: 'Diễn viên',
          name: 'Pauline Hoarau',
          original_name: 'Pauline Hoarau',
          popularity: 4.12,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rwrAPvdmQvi1LTDGh1MKeVphKuf.jpg',
          cast_id: 384,
          character: "Empress Aloï / Creature 'Swing Angel'",
          credit_id: '5973c05392514158430046a3',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 566080,
          known_for_department: 'Diễn viên',
          name: 'Jonas Bloquet',
          original_name: 'Jonas Bloquet',
          popularity: 1.598,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pzQAv6ghx5hc4gSpxHII0oUzqkL.jpg',
          cast_id: 21,
          character: 'K-Tron Warrior / Control Room Soldier',
          credit_id: '58eb50eec3a3684aa40739fc',
          order: 18,
        },
        {
          adult: false,
          gender: 1,
          id: 1842624,
          known_for_department: 'Diễn viên',
          name: 'Sand Van Roy',
          original_name: 'Sand Van Roy',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eubiUcgPAFxuLowLoi5y66OqXJz.jpg',
          cast_id: 29,
          character: "Creature 'Jessica Rabbit'",
          credit_id: '59580fc8c3a36825e8010b3e',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 18865,
          known_for_department: 'Directing',
          name: 'Louis Leterrier',
          original_name: 'Louis Leterrier',
          popularity: 2.643,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pJl1hNtZOIxrdzQjwGlicWWGSXg.jpg',
          cast_id: 363,
          character: 'Captain Welcoming Mercurys',
          credit_id: '5973becb92514157f2004644',
          order: 20,
        },
        {
          adult: false,
          gender: 2,
          id: 75035,
          known_for_department: 'Directing',
          name: 'Olivier Megaton',
          original_name: 'Olivier Megaton',
          popularity: 1.633,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rqZxRsAvHj63fEZepYo0ICt0poi.jpg',
          cast_id: 366,
          character: 'Captain Welcoming KCO2',
          credit_id: '5973bef2c3a3685d7f004460',
          order: 21,
        },
        {
          adult: false,
          gender: 2,
          id: 17072,
          known_for_department: 'Diễn viên',
          name: 'Sam Douglas',
          original_name: 'Sam Douglas',
          popularity: 2.188,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hGtVDo5BF4utyCbrEUm3RDNA28B.jpg',
          cast_id: 31,
          character: 'Male Tourist',
          credit_id: '59581019c3a36828e7011f6b',
          order: 22,
        },
        {
          adult: false,
          gender: 0,
          id: 1793073,
          known_for_department: 'Diễn viên',
          name: 'Diva Sicard',
          original_name: 'Diva Sicard',
          popularity: 0.6,
          profile_path: null,
          cast_id: 17,
          character: "Mâatri (Tsûuri's Friend)",
          credit_id: '58eb50ed925141354c04a4e0',
          order: 23,
        },
        {
          adult: false,
          gender: 0,
          id: 1333630,
          known_for_department: 'Diễn viên',
          name: 'Eric Lampaert',
          original_name: 'Eric Lampaert',
          popularity: 1.788,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oUnxykzDGG7GN3GxPsxWydtJ5E0.jpg',
          cast_id: 22,
          character: 'Guide Thaziit',
          credit_id: '58eb50efc3a3684aa40739fe',
          order: 24,
        },
        {
          adult: false,
          gender: 2,
          id: 135944,
          known_for_department: 'Diễn viên',
          name: 'Alexandre Willaume',
          original_name: 'Alexandre Willaume',
          popularity: 8.851,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9idbbstYInVyKSpbDaLMjwwRFns.jpg',
          cast_id: 28,
          character: 'Captain Kris',
          credit_id: '59580fbf9251410c5601030c',
          order: 25,
        },
        {
          adult: false,
          gender: 0,
          id: 1168928,
          known_for_department: 'Diễn viên',
          name: 'Gavin Drea',
          original_name: 'Gavin Drea',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6UjJETk9PHdZuBCkMkhE7d7SAXV.jpg',
          cast_id: 30,
          character: 'Sergent Cooper',
          credit_id: '59580fd49251410cbc010f3b',
          order: 26,
        },
        {
          adult: false,
          gender: 0,
          id: 1842643,
          known_for_department: 'Diễn viên',
          name: 'Réginal Kudiwu',
          original_name: 'Réginal Kudiwu',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6BDq15IEOifIPm5Lwwp0SGsOH7L.jpg',
          cast_id: 40,
          character: 'Major Samk',
          credit_id: '595811b5c3a36828e701210d',
          order: 27,
        },
        {
          adult: false,
          gender: 2,
          id: 104617,
          known_for_department: 'Diễn viên',
          name: 'David Michie',
          original_name: 'David Michie',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/87z5A1ylR4I3jB8lzrLgfILYdYu.jpg',
          cast_id: 37,
          character: 'Pearl Tsuuri (voice)',
          credit_id: '595810d0c3a36828fc010563',
          order: 28,
        },
        {
          adult: false,
          gender: 1,
          id: 1842631,
          known_for_department: 'Diễn viên',
          name: 'Marion Roussignol',
          original_name: 'Marion Roussignol',
          popularity: 0.6,
          profile_path: null,
          cast_id: 33,
          character: 'Pearl',
          credit_id: '595810819251410bfa011f86',
          order: 29,
        },
        {
          adult: false,
          gender: 1,
          id: 1842640,
          known_for_department: 'Diễn viên',
          name: 'Emilie Pommelet',
          original_name: 'Emilie Pommelet',
          popularity: 0.694,
          profile_path: null,
          cast_id: 38,
          character: 'Pearl',
          credit_id: '59581191c3a36825e8010d0a',
          order: 30,
        },
        {
          adult: false,
          gender: 2,
          id: 1677364,
          known_for_department: 'Diễn viên',
          name: 'Roman Blomme',
          original_name: 'Roman Blomme',
          popularity: 1.632,
          profile_path:
            'https://image.tmdb.org/t/p/w185/h3QJHBqZXlpd4Tmf80TVMwVGsV7.jpg',
          cast_id: 39,
          character: 'Boulan Bathor',
          credit_id: '595811a69251410a5901197d',
          order: 31,
        },
        {
          adult: false,
          gender: 1,
          id: 1725126,
          known_for_department: 'Diễn viên',
          name: 'Emilie Livingston',
          original_name: 'Emilie Livingston',
          popularity: 0.6,
          profile_path: null,
          cast_id: 15,
          character: 'Bubble Dancer',
          credit_id: '58eb50ed925141354c04a4dc',
          order: 32,
        },
        {
          adult: false,
          gender: 2,
          id: 1373280,
          known_for_department: 'Diễn viên',
          name: 'Alexandre Nguyen',
          original_name: 'Alexandre Nguyen',
          popularity: 0.6,
          profile_path: null,
          cast_id: 19,
          character: 'Nhật Bảnese Delegate',
          credit_id: '58eb50ee9251414b28042bf0',
          order: 33,
        },
        {
          adult: false,
          gender: 2,
          id: 235573,
          known_for_department: 'Diễn viên',
          name: 'Aurelien Gaya',
          original_name: 'Aurelien Gaya',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9gHUwyzbDnZjXzPL3ATGKwjBE6j.jpg',
          cast_id: 32,
          character: 'Igon Sirus Guard',
          credit_id: '59581034c3a36828fc0104c5',
          order: 34,
        },
        {
          adult: false,
          gender: 2,
          id: 1842632,
          known_for_department: 'Diễn viên',
          name: 'Mikael Buxton',
          original_name: 'Mikael Buxton',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9KMu0IyXHUNfrEjwVLV8UKxWJ45.jpg',
          cast_id: 34,
          character: 'Paradise Alley Soldier',
          credit_id: '595810919251410b860121e8',
          order: 35,
        },
        {
          adult: false,
          gender: 2,
          id: 1651578,
          known_for_department: 'Diễn viên',
          name: 'Yun Lai',
          original_name: 'Yun Lai',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dTpuriVsx87igaTxpDb9cf8Rf64.jpg',
          cast_id: 35,
          character: 'Valley Chinois',
          credit_id: '595810a29251410c560103e1',
          order: 36,
        },
        {
          adult: false,
          gender: 0,
          id: 1430283,
          known_for_department: 'Diễn viên',
          name: 'Anders Heinrichsen',
          original_name: 'Anders Heinrichsen',
          popularity: 0.613,
          profile_path:
            'https://image.tmdb.org/t/p/w185/z9bKgT6rLkoeCYEEQVNzdqnmd1i.jpg',
          cast_id: 36,
          character: 'Police Officer',
          credit_id: '595810b69251410a59011875',
          order: 37,
        },
        {
          adult: false,
          gender: 2,
          id: 1375679,
          known_for_department: 'Diễn viên',
          name: 'Tristan Robin',
          original_name: 'Tristan Robin',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uvDXTTR7DI9L8LzvYvF9RzZuTi6.jpg',
          cast_id: 41,
          character: 'Roper',
          credit_id: '595811e59251410cbc011166',
          order: 38,
        },
        {
          adult: false,
          gender: 2,
          id: 1842645,
          known_for_department: 'Diễn viên',
          name: 'Yun-Ping He',
          original_name: 'Yun-Ping He',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4czYd2IUNFKHwBSIToajrlUZDzd.jpg',
          cast_id: 42,
          character: 'Controller of the Technical Chamber',
          credit_id: '595811fa92514109e40116b2',
          order: 39,
        },
        {
          adult: false,
          gender: 2,
          id: 1252225,
          known_for_department: 'Production',
          name: 'James Flynn',
          original_name: 'James Flynn',
          popularity: 0.94,
          profile_path:
            'https://image.tmdb.org/t/p/w185/470fGSEWBDBqMSjgRksJKjCvyqn.jpg',
          cast_id: 43,
          character: 'Guide #2',
          credit_id: '595812239251410c56010581',
          order: 40,
        },
        {
          adult: false,
          gender: 0,
          id: 1842652,
          known_for_department: 'Diễn viên',
          name: 'David Clark',
          original_name: 'David Clark',
          popularity: 0.694,
          profile_path: null,
          cast_id: 44,
          character: 'Astronaut',
          credit_id: '595812d09251410c56010617',
          order: 41,
        },
        {
          adult: false,
          gender: 0,
          id: 1367809,
          known_for_department: 'Art',
          name: 'Ben Mauro',
          original_name: 'Ben Mauro',
          popularity: 0.6,
          profile_path: null,
          cast_id: 45,
          character: 'Commander Arün Filitt Guard',
          credit_id: '595812e4c3a36828fc010787',
          order: 42,
        },
        {
          adult: false,
          gender: 0,
          id: 1825304,
          known_for_department: 'Diễn viên',
          name: 'Jean-François Lenogue',
          original_name: 'Jean-François Lenogue',
          popularity: 0.6,
          profile_path: null,
          cast_id: 46,
          character: 'Igon Sirus Guard',
          credit_id: '595812f29251410883012070',
          order: 43,
        },
        {
          adult: false,
          gender: 0,
          id: 1125648,
          known_for_department: 'Diễn viên',
          name: 'Peter Eberst',
          original_name: 'Peter Eberst',
          popularity: 0.6,
          profile_path: null,
          cast_id: 48,
          character: 'Igon Sirus Guard',
          credit_id: '5958130e9251410c890114de',
          order: 44,
        },
        {
          adult: false,
          gender: 2,
          id: 113855,
          known_for_department: 'Directing',
          name: 'Xavier Giannoli',
          original_name: 'Xavier Giannoli',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sxZbrqQeSsLIvFq1Kb6ZKnCMdGF.jpg',
          cast_id: 362,
          character: 'Captain Norton',
          credit_id: '5973bebdc3a3685e0f00498c',
          order: 45,
        },
        {
          adult: false,
          gender: 2,
          id: 129433,
          known_for_department: 'Directing',
          name: 'Eric Rochant',
          original_name: 'Eric Rochant',
          popularity: 1.826,
          profile_path: null,
          cast_id: 364,
          character: 'Captain Welcoming Palm Müret',
          credit_id: '5973bed6c3a3685d7f004443',
          order: 46,
        },
        {
          adult: false,
          gender: 2,
          id: 229263,
          known_for_department: 'Directing',
          name: 'Benoît Jacquot',
          original_name: 'Benoît Jacquot',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qs4pQ0iK5L61kDfc15iB5ZfIv5y.jpg',
          cast_id: 365,
          character: 'Captain Welcoming Arysum',
          credit_id: '5973bee792514157fb004450',
          order: 47,
        },
        {
          adult: false,
          gender: 2,
          id: 21647,
          known_for_department: 'Directing',
          name: 'Gérard Krawczyk',
          original_name: 'Gérard Krawczyk',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3As3jvza5WtPIbIbLl8hYQToNmV.jpg',
          cast_id: 367,
          character: 'Captain Welcoming Martapuraïs',
          credit_id: '5973befb925141584300455c',
          order: 48,
        },
        {
          adult: false,
          gender: 2,
          id: 1856293,
          known_for_department: 'Diễn viên',
          name: 'Pierre Cachia',
          original_name: 'Pierre Cachia',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xdXK8EAugiCxJmWVhlCuBGGPLTm.jpg',
          cast_id: 368,
          character: 'Kortan Dahük',
          credit_id: '5973bf06c3a3685e0100456e',
          order: 49,
        },
        {
          adult: false,
          gender: 2,
          id: 1152094,
          known_for_department: 'Diễn viên',
          name: 'David Saada',
          original_name: 'David Saada',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cN9jUwMyiGtcILr4vJbesh0enrj.jpg',
          cast_id: 369,
          character: 'Kortan Dahük',
          credit_id: '5973bf0cc3a3685d5e0042ea',
          order: 50,
        },
        {
          adult: false,
          gender: 0,
          id: 1856294,
          known_for_department: 'Diễn viên',
          name: 'Hippolyte Burkhart-Uhlen',
          original_name: 'Hippolyte Burkhart-Uhlen',
          popularity: 0.6,
          profile_path: null,
          cast_id: 370,
          character: 'Kortan Dahük',
          credit_id: '5973bf1392514158360045fd',
          order: 51,
        },
        {
          adult: false,
          gender: 0,
          id: 1856295,
          known_for_department: 'Diễn viên',
          name: 'Florian Guichard',
          original_name: 'Florian Guichard',
          popularity: 0.6,
          profile_path: null,
          cast_id: 371,
          character: 'Mercury',
          credit_id: '5973bf1bc3a3685dba003d0d',
          order: 52,
        },
        {
          adult: false,
          gender: 0,
          id: 1283308,
          known_for_department: 'Diễn viên',
          name: 'Stéphane Mir',
          original_name: 'Stéphane Mir',
          popularity: 0.6,
          profile_path: null,
          cast_id: 372,
          character: 'Mercury',
          credit_id: '5973bf23925141584300457d',
          order: 53,
        },
        {
          adult: false,
          gender: 0,
          id: 1856296,
          known_for_department: 'Diễn viên',
          name: 'Thierry Barthe',
          original_name: 'Thierry Barthe',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lghOV53Hd17DGL7kdOe3PO9Msac.jpg',
          cast_id: 373,
          character: 'Mercury',
          credit_id: '5973bf3a9251415843004591',
          order: 54,
        },
        {
          adult: false,
          gender: 0,
          id: 1856297,
          known_for_department: 'Diễn viên',
          name: 'Pier Ewudu',
          original_name: 'Pier Ewudu',
          popularity: 0.84,
          profile_path: null,
          cast_id: 374,
          character: 'Palm Müret',
          credit_id: '5973bf4bc3a3685dd8004c9f',
          order: 55,
        },
        {
          adult: false,
          gender: 0,
          id: 1842655,
          known_for_department: 'Diễn viên',
          name: 'Andrew Tisba',
          original_name: 'Andrew Tisba',
          popularity: 0.6,
          profile_path: null,
          cast_id: 375,
          character: 'Palm Müret',
          credit_id: '5973bf51c3a3685da400455a',
          order: 56,
        },
        {
          adult: false,
          gender: 0,
          id: 1856298,
          known_for_department: 'Diễn viên',
          name: 'Yannick Lorté',
          original_name: 'Yannick Lorté',
          popularity: 0.694,
          profile_path: null,
          cast_id: 376,
          character: 'Palm Müret',
          credit_id: '5973bf96c3a3685e010045fe',
          order: 57,
        },
        {
          adult: false,
          gender: 0,
          id: 1856299,
          known_for_department: 'Diễn viên',
          name: 'Charly Akakpo',
          original_name: 'Charly Akakpo',
          popularity: 0.6,
          profile_path: null,
          cast_id: 377,
          character: 'Arysum-Kormn',
          credit_id: '5973bf9d92514157fb0044fb',
          order: 58,
        },
        {
          adult: false,
          gender: 0,
          id: 1856300,
          known_for_department: 'Diễn viên',
          name: 'Clément Beauruelle',
          original_name: 'Clément Beauruelle',
          popularity: 0.6,
          profile_path: null,
          cast_id: 378,
          character: 'Arysum-Kormn',
          credit_id: '5973bfa5925141582b004130',
          order: 59,
        },
        {
          adult: false,
          gender: 1,
          id: 1856301,
          known_for_department: 'Diễn viên',
          name: 'Audrey Kamp',
          original_name: 'Audrey Kamp',
          popularity: 0.6,
          profile_path: null,
          cast_id: 379,
          character: 'Arysum-Kormn',
          credit_id: '5973bfadc3a3685dba003da6',
          order: 60,
        },
        {
          adult: false,
          gender: 0,
          id: 1856302,
          known_for_department: 'Diễn viên',
          name: 'Anthony Hornez',
          original_name: 'Anthony Hornez',
          popularity: 0.6,
          profile_path: null,
          cast_id: 380,
          character: 'Martapuraï',
          credit_id: '5973bffcc3a3685d7f00456b',
          order: 61,
        },
        {
          adult: false,
          gender: 0,
          id: 1842656,
          known_for_department: 'Diễn viên',
          name: 'Julien Bleitrach',
          original_name: 'Julien Bleitrach',
          popularity: 0.6,
          profile_path: null,
          cast_id: 381,
          character: 'Martapuraï',
          credit_id: '5973c009c3a3685e0f004b32',
          order: 62,
        },
        {
          adult: false,
          gender: 1,
          id: 1856303,
          known_for_department: 'Diễn viên',
          name: 'Maxime Babara Touré',
          original_name: 'Maxime Babara Touré',
          popularity: 0.6,
          profile_path: null,
          cast_id: 382,
          character: 'Martapuraï',
          credit_id: '5973c023c3a3685e010046a9',
          order: 63,
        },
        {
          adult: false,
          gender: 0,
          id: 1856304,
          known_for_department: 'Diễn viên',
          name: 'Barbare Weber Scaff',
          original_name: 'Barbare Weber Scaff',
          popularity: 1.4,
          profile_path: null,
          cast_id: 385,
          character: 'Empress Aloï (voice)',
          credit_id: '5973c06092514158430046ba',
          order: 64,
        },
        {
          adult: false,
          gender: 1,
          id: 1856305,
          known_for_department: 'Diễn viên',
          name: 'Marilhéa Peillard',
          original_name: 'Marilhéa Peillard',
          popularity: 0.6,
          profile_path: null,
          cast_id: 386,
          character: 'Tsûuri',
          credit_id: '5973c06d92514157fb0045d8',
          order: 65,
        },
        {
          adult: false,
          gender: 1,
          id: 61610,
          known_for_department: 'Diễn viên',
          name: 'Lee Delong',
          original_name: 'Lee Delong',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jsyvatf0NCpFUfRUm0HVbHx13O8.jpg',
          cast_id: 387,
          character: 'Tsûuri / Tourist (voice)',
          credit_id: '5973c07ac3a3685e0f004bb0',
          order: 66,
        },
        {
          adult: false,
          gender: 1,
          id: 1856306,
          known_for_department: 'Diễn viên',
          name: 'Judith Brunett',
          original_name: 'Judith Brunett',
          popularity: 0.6,
          profile_path: null,
          cast_id: 388,
          character: "Mâatri (Tsûuri's Friend) (voice)",
          credit_id: '5973c09092514157fb004606',
          order: 67,
        },
        {
          adult: false,
          gender: 1,
          id: 1856307,
          known_for_department: 'Diễn viên',
          name: 'Marie Barrouillet',
          original_name: 'Marie Barrouillet',
          popularity: 0.6,
          profile_path: null,
          cast_id: 389,
          character: 'Tsûuri Child',
          credit_id: '5973c09e925141582b004210',
          order: 68,
        },
        {
          adult: false,
          gender: 1,
          id: 1701031,
          known_for_department: 'Diễn viên',
          name: 'Cindy Bruna',
          original_name: 'Cindy Bruna',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/Ae6e2WwMJwVLofxOZ4xbHnamABE.jpg',
          cast_id: 390,
          character: 'Guard',
          credit_id: '5973c0a892514157ec004841',
          order: 69,
        },
        {
          adult: false,
          gender: 1,
          id: 1856308,
          known_for_department: 'Diễn viên',
          name: 'Sija Titko',
          original_name: 'Sija Titko',
          popularity: 0.6,
          profile_path: null,
          cast_id: 391,
          character: 'Guard',
          credit_id: '5973c0b2c3a3685da40046ad',
          order: 70,
        },
        {
          adult: false,
          gender: 1,
          id: 1856309,
          known_for_department: 'Diễn viên',
          name: 'Daphnée Kbidi',
          original_name: 'Daphnée Kbidi',
          popularity: 0.6,
          profile_path: null,
          cast_id: 392,
          character: 'Tortured Pearl',
          credit_id: '5973c0bdc3a3685da40046c0',
          order: 71,
        },
        {
          adult: false,
          gender: 2,
          id: 1856311,
          known_for_department: 'Diễn viên',
          name: 'Nick Marzock',
          original_name: 'Nick Marzock',
          popularity: 0.6,
          profile_path: null,
          cast_id: 393,
          character: 'Tortured Pearl (voice)',
          credit_id: '5973c0c7c3a3685da40046dc',
          order: 72,
        },
        {
          adult: false,
          gender: 2,
          id: 48480,
          known_for_department: 'Diễn viên',
          name: 'Stefan Konarske',
          original_name: 'Stefan Konarske',
          popularity: 1.386,
          profile_path: null,
          cast_id: 395,
          character: 'Captain Zito',
          credit_id: '5973c0dbc3a3685dd8004e62',
          order: 73,
        },
        {
          adult: false,
          gender: 2,
          id: 1165295,
          known_for_department: 'Diễn viên',
          name: 'Mahamadou Coulibaly',
          original_name: 'Mahamadou Coulibaly',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bXqIC1trx8ExJUoOfE0aT2vwC6U.jpg',
          cast_id: 396,
          character: "Major Gibon's Soldier / Igon Junio",
          credit_id: '5973c0e79251415843004754',
          order: 74,
        },
        {
          adult: false,
          gender: 0,
          id: 1856312,
          known_for_department: 'Diễn viên',
          name: 'Julien Marlin',
          original_name: 'Julien Marlin',
          popularity: 0.6,
          profile_path: null,
          cast_id: 397,
          character: "Major Gibon's Soldier",
          credit_id: '5973c0f7c3a3685dba003ecd',
          order: 75,
        },
        {
          adult: false,
          gender: 0,
          id: 1856313,
          known_for_department: 'Diễn viên',
          name: 'Yvan Lucker',
          original_name: 'Yvan Lucker',
          popularity: 0.6,
          profile_path: null,
          cast_id: 398,
          character: "Major Gibon's Soldier",
          credit_id: '5973c0ffc3a3685dba003ed3',
          order: 76,
        },
        {
          adult: false,
          gender: 0,
          id: 1745350,
          known_for_department: 'Diễn viên',
          name: 'Tom Hygreck',
          original_name: 'Tom Hygreck',
          popularity: 0.6,
          profile_path: null,
          cast_id: 399,
          character: "Major Gibon's Soldier",
          credit_id: '5973c106c3a3685dd8004ea2',
          order: 77,
        },
        {
          adult: false,
          gender: 2,
          id: 570809,
          known_for_department: 'Diễn viên',
          name: 'Abel Jafri',
          original_name: 'Abel Jafri',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nZ476kQTZZMjb7sDJZCV9otlWM6.jpg',
          cast_id: 400,
          character: 'Bus Driver',
          credit_id: '5973c11ec3a3685dd8004eaf',
          order: 78,
        },
        {
          adult: false,
          gender: 2,
          id: 1792507,
          known_for_department: 'Diễn viên',
          name: 'Laurent Ferraro',
          original_name: 'Laurent Ferraro',
          popularity: 0.968,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ea2zlDgQZWFctbczy48fZ6Q8Lj5.jpg',
          cast_id: 401,
          character: 'Igon Siruss / Doghan Dagui',
          credit_id: '5973c12992514157fb0046ac',
          order: 79,
        },
        {
          adult: false,
          gender: 0,
          id: 1856314,
          known_for_department: 'Diễn viên',
          name: 'Jean-Robert Lombard',
          original_name: 'Jean-Robert Lombard',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/maqWNSa95tKlCc5TdEzUMd9Ut10.jpg',
          cast_id: 402,
          character: 'Igon Sirus Guard',
          credit_id: '5973c139c3a3685ded00493a',
          order: 80,
        },
        {
          adult: false,
          gender: 0,
          id: 1856315,
          known_for_department: 'Diễn viên',
          name: 'Leonid Glushchenko',
          original_name: 'Leonid Glushchenko',
          popularity: 0.6,
          profile_path: null,
          cast_id: 403,
          character: 'Igon Sirus Guard',
          credit_id: '5973c14492514158430047ca',
          order: 81,
        },
        {
          adult: false,
          gender: 2,
          id: 962954,
          known_for_department: 'Diễn viên',
          name: 'Akim Chir',
          original_name: 'Akim Chir',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rvGtMasSuTPAhcc55xTtahCpKiN.jpg',
          cast_id: 404,
          character: 'Igon Sirus Guard',
          credit_id: '5973c15dc3a3685d7f0046b0',
          order: 82,
        },
        {
          adult: false,
          gender: 0,
          id: 1186854,
          known_for_department: 'Diễn viên',
          name: 'Laminé Ba',
          original_name: 'Laminé Ba',
          popularity: 1.4,
          profile_path: null,
          cast_id: 405,
          character: 'Igon Sirus Guard',
          credit_id: '5973c17cc3a3685da4004784',
          order: 83,
        },
        {
          adult: false,
          gender: 2,
          id: 1464571,
          known_for_department: 'Diễn viên',
          name: 'Paul Lefèvre',
          original_name: 'Paul Lefèvre',
          popularity: 0.605,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wFmELVlahLRT8ZsjvOXTs8OD1nT.jpg',
          cast_id: 406,
          character: 'Siirt Guard / Siirt Salesman',
          credit_id: '5973c19692514157f70048f4',
          order: 84,
        },
        {
          adult: false,
          gender: 0,
          id: 1856316,
          known_for_department: 'Diễn viên',
          name: 'Guillaume Maison',
          original_name: 'Guillaume Maison',
          popularity: 0.6,
          profile_path: null,
          cast_id: 407,
          character: 'Siirt Salesman',
          credit_id: '5973c1a29251415806004531',
          order: 85,
        },
        {
          adult: false,
          gender: 0,
          id: 1856317,
          known_for_department: 'Diễn viên',
          name: 'Jean-Christophe Brizard',
          original_name: 'Jean-Christophe Brizard',
          popularity: 0.6,
          profile_path: null,
          cast_id: 408,
          character: 'Siirt Salesman',
          credit_id: '5973c1a992514157ec00492a',
          order: 86,
        },
        {
          adult: false,
          gender: 2,
          id: 1856318,
          known_for_department: 'Diễn viên',
          name: 'Patrick Cottet-Moine',
          original_name: 'Patrick Cottet-Moine',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/QL9SIfwn9h42ETGkh43y0BCL8O.jpg',
          cast_id: 409,
          character: 'Siirt Cop',
          credit_id: '5973c1b2925141584300482c',
          order: 87,
        },
        {
          adult: false,
          gender: 1,
          id: 1856319,
          known_for_department: 'Diễn viên',
          name: 'Irene Palko',
          original_name: 'Irene Palko',
          popularity: 0.6,
          profile_path: null,
          cast_id: 410,
          character: 'Female Tourist',
          credit_id: '5973c1c3925141582b0042f6',
          order: 88,
        },
        {
          adult: false,
          gender: 2,
          id: 61623,
          known_for_department: 'Diễn viên',
          name: 'Tonio Descanvelle',
          original_name: 'Tonio Descanvelle',
          popularity: 1.932,
          profile_path:
            'https://image.tmdb.org/t/p/w185/l5xgE93R5bjwenULIItboKYVmve.jpg',
          cast_id: 411,
          character: 'DA / Doghan-Dagui',
          credit_id: '5973c1dc92514158360048ae',
          order: 89,
        },
        {
          adult: false,
          gender: 1,
          id: 1856320,
          known_for_department: 'Diễn viên',
          name: "Velvet D'Amour",
          original_name: "Velvet D'Amour",
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yOWqA5azwY4znN2k243DVLId2uE.jpg',
          cast_id: 412,
          character: 'Tourist',
          credit_id: '5973c1ec92514157ec00496d',
          order: 92,
        },
        {
          adult: false,
          gender: 2,
          id: 61609,
          known_for_department: 'Diễn viên',
          name: 'Doug Rand',
          original_name: 'Doug Rand',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kBDawasRQXDvZThX75bMEgl1xcd.jpg',
          cast_id: 413,
          character: 'Doghan-Dagui',
          credit_id: '5973c212925141584300487c',
          order: 93,
        },
        {
          adult: false,
          gender: 2,
          id: 1418117,
          known_for_department: 'Diễn viên',
          name: 'Grant Moninger',
          original_name: 'Grant Moninger',
          popularity: 1.214,
          profile_path:
            'https://image.tmdb.org/t/p/w185/szpBFHr8iu6d1XsZ57fBKoZuHvC.jpg',
          cast_id: 414,
          character: 'Doghan-Dagui (voice)',
          credit_id: '5973c23092514157f2004982',
          order: 94,
        },
        {
          adult: false,
          gender: 2,
          id: 77157,
          known_for_department: 'Diễn viên',
          name: 'Robbie Rist',
          original_name: 'Robbie Rist',
          popularity: 1.4,
          profile_path: null,
          cast_id: 415,
          character: 'Doghan-Dagui (voice)',
          credit_id: '5973c23892514157fb00478a',
          order: 95,
        },
        {
          adult: false,
          gender: 0,
          id: 1856321,
          known_for_department: 'Diễn viên',
          name: 'Christopher Swindel',
          original_name: 'Christopher Swindel',
          popularity: 0.6,
          profile_path: null,
          cast_id: 416,
          character: 'Doghan-Dagui (voice)',
          credit_id: '5973c24f92514158060045a5',
          order: 96,
        },
        {
          adult: false,
          gender: 1,
          id: 1426355,
          known_for_department: 'Diễn viên',
          name: 'Claire Tran',
          original_name: 'Claire Tran',
          popularity: 1.932,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hfDgetPGGLOi5EqZ5BmjK3SG5lD.jpg',
          cast_id: 417,
          character: 'Bubble / Glamopod / Control Room Sergeant',
          credit_id: '5973c267925141582b00437d',
          order: 97,
        },
        {
          adult: false,
          gender: 0,
          id: 1488230,
          known_for_department: 'Production',
          name: 'Alain Etoundi',
          original_name: 'Alain Etoundi',
          popularity: 0.6,
          profile_path: null,
          cast_id: 418,
          character: 'Club Bouncer',
          credit_id: '5973c278c3a3685e010048ba',
          order: 98,
        },
        {
          adult: false,
          gender: 0,
          id: 1856322,
          known_for_department: 'Diễn viên',
          name: 'Fayet Nsumoto',
          original_name: 'Fayet Nsumoto',
          popularity: 0.6,
          profile_path: null,
          cast_id: 419,
          character: 'Club Bouncer',
          credit_id: '5973c27f92514157ec0049fb',
          order: 99,
        },
        {
          adult: false,
          gender: 1,
          id: 1856323,
          known_for_department: 'Diễn viên',
          name: 'Kristina Kachinskaya',
          original_name: 'Kristina Kachinskaya',
          popularity: 0.6,
          profile_path: null,
          cast_id: 420,
          character: "Creature 'Twin'",
          credit_id: '5973c28c925141582b00439f',
          order: 100,
        },
        {
          adult: false,
          gender: 1,
          id: 1856324,
          known_for_department: 'Diễn viên',
          name: 'Veronika Khayla',
          original_name: 'Veronika Khayla',
          popularity: 0.6,
          profile_path: null,
          cast_id: 421,
          character: "Creature 'Twin'",
          credit_id: '5973c29392514158060045e6',
          order: 101,
        },
        {
          adult: false,
          gender: 1,
          id: 549323,
          known_for_department: 'Diễn viên',
          name: 'Sissi Duparc',
          original_name: 'Sissi Duparc',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8iRTmiKZfKFhcikkKdPRfwKIyJf.jpg',
          cast_id: 422,
          character: "Creature 'Louis XVI'",
          credit_id: '5973c29f92514158060045f5',
          order: 102,
        },
        {
          adult: false,
          gender: 0,
          id: 1856325,
          known_for_department: 'Diễn viên',
          name: 'Noam Frost',
          original_name: 'Noam Frost',
          popularity: 0.6,
          profile_path: null,
          cast_id: 423,
          character: "Creature 'Bird Woman'",
          credit_id: '5973c2ac9251415806004604',
          order: 103,
        },
        {
          adult: false,
          gender: 1,
          id: 1856327,
          known_for_department: 'Diễn viên',
          name: 'Pauline Serreau',
          original_name: 'Pauline Serreau',
          popularity: 1.38,
          profile_path: null,
          cast_id: 424,
          character: "Creature 'Tattoo'",
          credit_id: '5973c2db92514157f2004a34',
          order: 104,
        },
        {
          adult: false,
          gender: 0,
          id: 1363556,
          known_for_department: 'Diễn viên',
          name: 'Philippe Rigot',
          original_name: 'Philippe Rigot',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tmlPbecbSxgUBPog9tIGp90SqXR.jpg',
          cast_id: 425,
          character: 'Hero Merchant',
          credit_id: '5973c30492514157f2004a5e',
          order: 105,
        },
        {
          adult: false,
          gender: 2,
          id: 1670780,
          known_for_department: 'Diễn viên',
          name: 'Étienne Ménard',
          original_name: 'Étienne Ménard',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9kSZdZZezov0uZY68nzwiPhDktk.jpg',
          cast_id: 426,
          character: 'Red Zone Captain',
          credit_id: '5973c31ec3a3685dba00408e',
          order: 106,
        },
        {
          adult: false,
          gender: 0,
          id: 1559887,
          known_for_department: 'Diễn viên',
          name: 'Peter Lamarque',
          original_name: 'Peter Lamarque',
          popularity: 0.728,
          profile_path: null,
          cast_id: 427,
          character: 'Warship Captain',
          credit_id: '5973c32ac3a3685d5e0046b5',
          order: 107,
        },
        {
          adult: false,
          gender: 0,
          id: 1696029,
          known_for_department: 'Diễn viên',
          name: 'Maximilien Seweryn',
          original_name: 'Maximilien Seweryn',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cmI4gHnoRepcSE2l2T0mPXdAfGC.jpg',
          cast_id: 428,
          character: 'K-Tron Captain',
          credit_id: '5973c33992514157ec004aab',
          order: 108,
        },
        {
          adult: false,
          gender: 0,
          id: 1856328,
          known_for_department: 'Diễn viên',
          name: 'Zouheir Zerhouni',
          original_name: 'Zouheir Zerhouni',
          popularity: 0.6,
          profile_path: null,
          cast_id: 429,
          character: 'K-Tron Warrior',
          credit_id: '5973c34092514157f7004a89',
          order: 109,
        },
        {
          adult: false,
          gender: 0,
          id: 1856329,
          known_for_department: 'Diễn viên',
          name: 'Tristan Zerbib',
          original_name: 'Tristan Zerbib',
          popularity: 0.6,
          profile_path: null,
          cast_id: 430,
          character: 'K-Tron Warrior',
          credit_id: '5973c34792514157ec004ac1',
          order: 110,
        },
        {
          adult: false,
          gender: 0,
          id: 1723791,
          known_for_department: 'Diễn viên',
          name: 'Elliot Jenicot',
          original_name: 'Elliot Jenicot',
          popularity: 0.728,
          profile_path: null,
          cast_id: 431,
          character: 'Interrogation Room Captain',
          credit_id: '5973c35c92514157ec004add',
          order: 111,
        },
        {
          adult: false,
          gender: 0,
          id: 1856331,
          known_for_department: 'Diễn viên',
          name: 'Staiv Gentis',
          original_name: 'Staiv Gentis',
          popularity: 0.6,
          profile_path: null,
          cast_id: 432,
          character: 'Control Room Soldier',
          credit_id: '5973c36592514157f7004ab9',
          order: 112,
        },
        {
          adult: false,
          gender: 1,
          id: 583898,
          known_for_department: 'Diễn viên',
          name: 'Chloé Hollings',
          original_name: 'Chloé Hollings',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qsi1sA5HfzEluUV3z0i23sxqLKb.jpg',
          cast_id: 433,
          character: "Alex-Intruder's Voice (voice)",
          credit_id: '5973c371925141582b004478',
          order: 113,
        },
        {
          adult: false,
          gender: 1,
          id: 1856332,
          known_for_department: 'Diễn viên',
          name: 'Aguendia Fotabong',
          original_name: 'Aguendia Fotabong',
          popularity: 0.6,
          profile_path: null,
          cast_id: 434,
          character: 'Boulan Bathor Emperor',
          credit_id: '5973c3789251415836004a3b',
          order: 114,
        },
        {
          adult: false,
          gender: 1,
          id: 145088,
          known_for_department: 'Diễn viên',
          name: 'Tania Dessources',
          original_name: 'Tania Dessources',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wmlvqVFRH3QxWBTPgHkRBVti9Tu.jpg',
          cast_id: 435,
          character: "Boulan Bathor Emperor's Wife",
          credit_id: '5973c37f925141582b004482',
          order: 115,
        },
        {
          adult: false,
          gender: 0,
          id: 1856333,
          known_for_department: 'Diễn viên',
          name: 'Gaëtan Cotigny',
          original_name: 'Gaëtan Cotigny',
          popularity: 0.6,
          profile_path: null,
          cast_id: 436,
          character: 'Fisherman',
          credit_id: '5973c386c3a3685ded004b85',
          order: 116,
        },
        {
          adult: false,
          gender: 2,
          id: 1637449,
          known_for_department: 'Diễn viên',
          name: 'François Bredon',
          original_name: 'François Bredon',
          popularity: 1.094,
          profile_path: null,
          cast_id: 437,
          character: 'Fisherman',
          credit_id: '5973c38e92514157f7004adb',
          order: 117,
        },
        {
          adult: false,
          gender: 2,
          id: 1277975,
          known_for_department: 'Diễn viên',
          name: 'Peter Hudson',
          original_name: 'Peter Hudson',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gTiHdNw4siCuQlEhfnserILryOz.jpg',
          cast_id: 448,
          character: 'Captain Crowford',
          credit_id: '5cda0deb0e0a265585cd0d46',
          order: 119,
        },
        {
          adult: false,
          gender: 2,
          id: 94066,
          known_for_department: 'Diễn viên',
          name: 'Cédric Chevalme',
          original_name: 'Cédric Chevalme',
          popularity: 0.6,
          profile_path: null,
          cast_id: 450,
          character: 'Bubble / Boulan-Bathor / Valerian',
          credit_id: '5f8d8e30cb80280036063311',
          order: 120,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 59,
          known_for_department: 'Directing',
          name: 'Luc Besson',
          original_name: 'Luc Besson',
          popularity: 6.092,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dXJdczT1NcvcZtnoWVGT0NmG11v.jpg',
          credit_id: '5552701e9251411487000a5e',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 59,
          known_for_department: 'Directing',
          name: 'Luc Besson',
          original_name: 'Luc Besson',
          popularity: 6.092,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dXJdczT1NcvcZtnoWVGT0NmG11v.jpg',
          credit_id: '555271c7c3a368419100405b',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 59,
          known_for_department: 'Directing',
          name: 'Luc Besson',
          original_name: 'Luc Besson',
          popularity: 6.092,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dXJdczT1NcvcZtnoWVGT0NmG11v.jpg',
          credit_id: '5552702e9251414dd9003e71',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 997,
          known_for_department: 'Camera',
          name: 'Thierry Arbogast',
          original_name: 'Thierry Arbogast',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4dr2TooU5KX9YdL3h0dfZA2fwSC.jpg',
          credit_id: '5fbf1d06ac8e6b003f32ab0e',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 1,
          id: 2186,
          known_for_department: 'Production',
          name: 'Nathalie Chéron',
          original_name: 'Nathalie Chéron',
          popularity: 1.104,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rmd2WzsLnb2GIv2eTZwFL62kqAr.jpg',
          credit_id: '595813819251410cbc01131d',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 2949,
          known_for_department: 'Sound',
          name: 'Alexandre Desplat',
          original_name: 'Alexandre Desplat',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vPsv5UYNLrQkzjOvng1OAAYCTIz.jpg',
          credit_id: '5958135ec3a36828e70122e6',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 0,
          id: 3504,
          known_for_department: 'Sound',
          name: 'David Farmer',
          original_name: 'David Farmer',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oYNchEjc32GucUPvXAHMXajk3xJ.jpg',
          credit_id: '59731e1ec3a3686fc7052185',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 3996,
          known_for_department: 'Sound',
          name: 'Tom Johnson',
          original_name: 'Tom Johnson',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/joF3OdCBQjzQ2keyQ9l7uhcZafo.jpg',
          credit_id: '59731e5792514112bb0284f9',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 8166,
          known_for_department: 'Sound',
          name: 'Juan Peralta',
          original_name: 'Juan Peralta',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6ImDm04R5VmUAwBiXbvkJgJO480.jpg',
          credit_id: '59731f6fc3a3683c1000577c',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 16369,
          known_for_department: 'Visual Effects',
          name: 'Philippe Hubin',
          original_name: 'Philippe Hubin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597321c7925141787a006077',
          department: 'Visual Effects',
          job: 'Special Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 16370,
          known_for_department: 'Crew',
          name: 'Jean-Christophe Magnaud',
          original_name: 'Jean-Christophe Magnaud',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597321d49251414fde030358',
          department: 'Visual Effects',
          job: 'Special Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 20722,
          known_for_department: 'Costume & Make-Up',
          name: 'Olivier Bériot',
          original_name: 'Olivier Bériot',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lRsjmXQqaen453QYXV9HfNOsAgw.jpg',
          credit_id: '595813edc3a36828fc0108a1',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 2,
          id: 35455,
          known_for_department: 'Art',
          name: 'Hugues Tissandier',
          original_name: 'Hugues Tissandier',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/azWzT3YZ3HvnoUFyVgYS9CFPWLQ.jpg',
          credit_id: '5958138f9251410b860124dc',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 0,
          id: 39651,
          known_for_department: 'Sound',
          name: 'Jean-Pascal Beintus',
          original_name: 'Jean-Pascal Beintus',
          popularity: 0.84,
          profile_path: null,
          credit_id: '59733ae8c3a3684c7002234e',
          department: 'Sound',
          job: 'Orchestrator',
        },
        {
          adult: false,
          gender: 2,
          id: 43592,
          known_for_department: 'Sound',
          name: 'Conrad Pope',
          original_name: 'Conrad Pope',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733b419251411ece02361b',
          department: 'Sound',
          job: 'Orchestrator',
        },
        {
          adult: false,
          gender: 0,
          id: 46291,
          known_for_department: 'Sound',
          name: 'Didier Lozahic',
          original_name: 'Didier Lozahic',
          popularity: 0.648,
          profile_path: null,
          credit_id: '59731f59c3a3687c7d026ac3',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 46291,
          known_for_department: 'Sound',
          name: 'Didier Lozahic',
          original_name: 'Didier Lozahic',
          popularity: 0.648,
          profile_path: null,
          credit_id: '59731e68925141787a005d03',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 50237,
          known_for_department: 'Production',
          name: 'Alan Collis',
          original_name: 'Alan Collis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '595814be9251410bfa0123d9',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 50950,
          known_for_department: 'Production',
          name: 'Virginie Besson-Silla',
          original_name: 'Virginie Besson-Silla',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59581336c3a368265d011790',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 113120,
          known_for_department: 'Visual Effects',
          name: 'Joanie Croteau',
          original_name: 'Joanie Croteau',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597324cfc3a36830fb007488',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 113134,
          known_for_department: 'Visual Effects',
          name: 'Veronique Guay',
          original_name: 'Veronique Guay',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732cea925141787a006e15',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 113141,
          known_for_department: 'Visual Effects',
          name: 'Francois Leduc',
          original_name: 'Francois Leduc',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732eaa9251414fde03134b',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 113152,
          known_for_department: 'Crew',
          name: 'Nicolas-Alexandre Noel',
          original_name: 'Nicolas-Alexandre Noel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733181c3a3684c70021770',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 113159,
          known_for_department: 'Visual Effects',
          name: 'Sébastien Rioux',
          original_name: 'Sébastien Rioux',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973329ac3a3686f7c04a9d9',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 2,
          id: 113175,
          known_for_department: 'Visual Effects',
          name: 'Guillaume St-Aubin-Seers',
          original_name: 'Guillaume St-Aubin-Seers',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597333f4c3a3683ba400713a',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 113180,
          known_for_department: 'Visual Effects',
          name: 'Philippe Theroux',
          original_name: 'Philippe Theroux',
          popularity: 0.98,
          profile_path: null,
          credit_id: '597334b1c3a3687c7d028437',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 113184,
          known_for_department: 'Visual Effects',
          name: 'Véronique Tremblay',
          original_name: 'Véronique Tremblay',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597334fbc3a3687c7d028476',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 61598,
          known_for_department: 'Biên kịch',
          name: 'Patrice Garcia',
          original_name: 'Patrice Garcia',
          popularity: 0.745,
          profile_path: null,
          credit_id: '5fe5c506cee481003f289aba',
          department: 'Art',
          job: 'Conceptual Design',
        },
        {
          adult: false,
          gender: 0,
          id: 114363,
          known_for_department: 'Editing',
          name: 'Julien Rey',
          original_name: 'Julien Rey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59581376c3a36828a10149aa',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 118678,
          known_for_department: 'Biên kịch',
          name: 'Pierre Christin',
          original_name: 'Pierre Christin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '594eac60925141312703b031',
          department: 'Biên kịch',
          job: 'Comic Book',
        },
        {
          adult: false,
          gender: 0,
          id: 119204,
          known_for_department: 'Crew',
          name: 'Laurent Demianoff',
          original_name: 'Laurent Demianoff',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nsGugq0t58YckgPBggVxS8U0L34.jpg',
          credit_id: '597336afc3a3683c100071e2',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 119204,
          known_for_department: 'Crew',
          name: 'Laurent Demianoff',
          original_name: 'Laurent Demianoff',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nsGugq0t58YckgPBggVxS8U0L34.jpg',
          credit_id: '597336a792514112bb02a423',
          department: 'Crew',
          job: 'Fight Choreographer',
        },
        {
          adult: false,
          gender: 2,
          id: 235573,
          known_for_department: 'Diễn viên',
          name: 'Aurelien Gaya',
          original_name: 'Aurelien Gaya',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9gHUwyzbDnZjXzPL3ATGKwjBE6j.jpg',
          credit_id: '5973370ec3a36830fb008ab3',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 928495,
          known_for_department: 'Sound',
          name: 'Stéphane Bucher',
          original_name: 'Stéphane Bucher',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59731decc3a3681d70000b6d',
          department: 'Sound',
          job: 'Sound Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 980285,
          known_for_department: 'Directing',
          name: 'Mateo Guez',
          original_name: 'Mateo Guez',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8ymuFaQuUVzBpTyrXZavHNPhhtg.jpg',
          credit_id: '59733a40c3a3683ba40078b7',
          department: 'Production',
          job: 'Casting Assistant',
        },
        {
          adult: false,
          gender: 2,
          id: 1023192,
          known_for_department: 'Art',
          name: 'Gilles Boillot',
          original_name: 'Gilles Boillot',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pajQ39rGZ2yi7p0WI2gYGhHuxRP.jpg',
          credit_id: '5958139cc3a36828fc010842',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1040056,
          known_for_department: 'Directing',
          name: 'Louise Molière',
          original_name: 'Louise Molière',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59731af6c3a3681d700007a8',
          department: 'Directing',
          job: 'Third Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1151866,
          known_for_department: 'Sound',
          name: 'Clémence Stoloff',
          original_name: 'Clémence Stoloff',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c689160e73003ead1b73',
          department: 'Sound',
          job: 'ADR Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1169353,
          known_for_department: 'Diễn viên',
          name: 'François Rivière',
          original_name: 'François Rivière',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733a4f9251414fde032358',
          department: 'Production',
          job: 'Casting Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 1180479,
          known_for_department: 'Diễn viên',
          name: 'Claude Varis',
          original_name: 'Claude Varis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c836d70594003d0224d8',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1183766,
          known_for_department: 'Diễn viên',
          name: 'Kefi Abrikh',
          original_name: 'Kefi Abrikh',
          popularity: 0.84,
          profile_path: null,
          credit_id: '5973363092514112bb02a3a2',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1183768,
          known_for_department: 'Crew',
          name: 'Daren Nop',
          original_name: 'Daren Nop',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973375a9251414fde031ed4',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1183769,
          known_for_department: 'Crew',
          name: 'Antoine Piquet',
          original_name: 'Antoine Piquet',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733779925141787a007b8b',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1183775,
          known_for_department: 'Crew',
          name: 'Clément Huet',
          original_name: 'Clément Huet',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973372692514112bb02a4d0',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1183778,
          known_for_department: 'Diễn viên',
          name: 'Anthony Pho',
          original_name: 'Anthony Pho',
          popularity: 1.094,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hnK7xqcYj5mrnV7vH5YMY1McXjK.jpg',
          credit_id: '59733770c3a3683c1000732b',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1219104,
          known_for_department: 'Editing',
          name: 'Alexander Aquino',
          original_name: 'Alexander Aquino',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733a739251414fde032388',
          department: 'Editing',
          job: 'Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1321357,
          known_for_department: 'Costume & Make-Up',
          name: 'Corinne Bruand',
          original_name: 'Corinne Bruand',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5a216c2dc3a3680b880a6e66',
          department: 'Costume & Make-Up',
          job: 'Assistant Costume Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1321362,
          known_for_department: 'Costume & Make-Up',
          name: 'Marylin Fitoussi',
          original_name: 'Marylin Fitoussi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a216bf60e0a264cd00a4fd0',
          department: 'Costume & Make-Up',
          job: 'Assistant Costume Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 1347760,
          known_for_department: 'Crew',
          name: 'Elizabeth Himelstein',
          original_name: 'Elizabeth Himelstein',
          popularity: 1.467,
          profile_path: null,
          credit_id: '59733beac3a3684c7002247e',
          department: 'Crew',
          job: 'Dialect Coach',
        },
        {
          adult: false,
          gender: 0,
          id: 1356670,
          known_for_department: 'Camera',
          name: 'Giovanni Quéné',
          original_name: 'Giovanni Quéné',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597338779251414272002ce4',
          department: 'Camera',
          job: 'Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1361341,
          known_for_department: 'Biên kịch',
          name: 'Eric Gandois',
          original_name: 'Eric Gandois',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5958150c9251410cbc0114b0',
          department: 'Art',
          job: 'Storyboard Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1361341,
          known_for_department: 'Biên kịch',
          name: 'Eric Gandois',
          original_name: 'Eric Gandois',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c460cee4810043291533',
          department: 'Art',
          job: 'Storyboard Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 1363862,
          known_for_department: 'Visual Effects',
          name: 'Simon Descamps',
          original_name: 'Simon Descamps',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973253cc3a3683c10005e52',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1367655,
          known_for_department: 'Sound',
          name: 'Cecile Tournesac',
          original_name: 'Cecile Tournesac',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733b5092514142a7002f0c',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1367797,
          known_for_department: 'Art',
          name: 'Dominique Moisan',
          original_name: 'Dominique Moisan',
          popularity: 1.096,
          profile_path: null,
          credit_id: '595813b0c3a368265d011813',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1367798,
          known_for_department: 'Art',
          name: 'Stéphane Robuchon',
          original_name: 'Stéphane Robuchon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '595813b9c3a368293b012b9c',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1367799,
          known_for_department: 'Art',
          name: 'Thierry Zemmour',
          original_name: 'Thierry Zemmour',
          popularity: 0.6,
          profile_path: null,
          credit_id: '595813d8c3a368253c010306',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1367800,
          known_for_department: 'Art',
          name: 'Evelyne Tissandier',
          original_name: 'Evelyne Tissandier',
          popularity: 0.6,
          profile_path: null,
          credit_id: '595813e39251410c56010718',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 1367804,
          known_for_department: 'Art',
          name: 'Charlie Clerc',
          original_name: 'Charlie Clerc',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c39d160e73003dab397d',
          department: 'Art',
          job: 'Graphic Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1367806,
          known_for_department: 'Art',
          name: 'Paulo Gonçalves',
          original_name: 'Paulo Gonçalves',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c52b160e73003dab3ae5',
          department: 'Art',
          job: 'Construction Buyer',
        },
        {
          adult: false,
          gender: 0,
          id: 1367809,
          known_for_department: 'Art',
          name: 'Ben Mauro',
          original_name: 'Ben Mauro',
          popularity: 0.6,
          profile_path: null,
          credit_id: '595813a69251410c560106d3',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1367809,
          known_for_department: 'Art',
          name: 'Ben Mauro',
          original_name: 'Ben Mauro',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59731d7a9251414fde02fe7b',
          department: 'Art',
          job: 'Conceptual Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1367811,
          known_for_department: 'Art',
          name: 'Olivier Nguyen',
          original_name: 'Olivier Nguyen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59731d9192514112bb0283db',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 2,
          id: 1367814,
          known_for_department: 'Sound',
          name: 'Guillaume Bouchateau',
          original_name: 'Guillaume Bouchateau',
          popularity: 1.38,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gB1bq7XbZFtfOmrgYFn5nw24zzg.jpg',
          credit_id: '59731dd69251417fa6027f4b',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1367815,
          known_for_department: 'Sound',
          name: 'Aymeric Devoldère',
          original_name: 'Aymeric Devoldère',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yBYqUXyN8TfJb7bS1bzk9pnxr54.jpg',
          credit_id: '59731e08c3a36830fb006c33',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1367815,
          known_for_department: 'Sound',
          name: 'Aymeric Devoldère',
          original_name: 'Aymeric Devoldère',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yBYqUXyN8TfJb7bS1bzk9pnxr54.jpg',
          credit_id: '59731e11c3a3686fc7052177',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1367821,
          known_for_department: 'Visual Effects',
          name: 'François Dumoulin',
          original_name: 'François Dumoulin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597325fd92514142a700155a',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1367828,
          known_for_department: 'Lighting',
          name: 'Gregory Fromentin',
          original_name: 'Gregory Fromentin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597338329251417fa602a00d',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 1,
          id: 1372087,
          known_for_department: 'Editing',
          name: 'Katia Boutin',
          original_name: 'Katia Boutin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59731de0c3a3683ba40057e2',
          department: 'Editing',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1372951,
          known_for_department: 'Crew',
          name: 'Raimundo Querido',
          original_name: 'Raimundo Querido',
          popularity: 0.652,
          profile_path: null,
          credit_id: '59733783c3a3686f7c04af16',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1374461,
          known_for_department: 'Sound',
          name: 'Philippe Penot',
          original_name: 'Philippe Penot',
          popularity: 1.048,
          profile_path: null,
          credit_id: '5fe5c6695be00e003fa3a1d4',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1376272,
          known_for_department: 'Costume & Make-Up',
          name: 'Stéphanie Watrigant',
          original_name: 'Stéphanie Watrigant',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733a6692514112bb02a9c8',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1377289,
          known_for_department: 'Art',
          name: 'Augustin Collet',
          original_name: 'Augustin Collet',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a216a88c3a3680b8f0a48eb',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1384366,
          known_for_department: 'Sound',
          name: 'Maxime Ferland',
          original_name: 'Maxime Ferland',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732867c3a36830fb00789b',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1390362,
          known_for_department: 'Visual Effects',
          name: 'Martin Hill',
          original_name: 'Martin Hill',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732d41c3a3687c7d027ad0',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1390382,
          known_for_department: 'Sound',
          name: 'Kirsty Whalley',
          original_name: 'Kirsty Whalley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733b609251415e8604e331',
          department: 'Sound',
          job: 'Scoring Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1401569,
          known_for_department: 'Visual Effects',
          name: 'Sophie Leclerc',
          original_name: 'Sophie Leclerc',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732e9bc3a3683ba4006adb',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1401891,
          known_for_department: 'Crew',
          name: 'Jeremy Bradley',
          original_name: 'Jeremy Bradley',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5973232cc3a36830fb007256',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1406872,
          known_for_department: 'Sound',
          name: 'Nia Hansen',
          original_name: 'Nia Hansen',
          popularity: 0.929,
          profile_path: null,
          credit_id: '59731e2ec3a3684c700200ff',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 1407211,
          known_for_department: 'Costume & Make-Up',
          name: 'Frédérique Ney',
          original_name: 'Frédérique Ney',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5958143fc3a36828fc0108f3',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1411835,
          known_for_department: 'Visual Effects',
          name: 'Scott Stokdyk',
          original_name: 'Scott Stokdyk',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5973344c9251415e8604d9bf',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1412476,
          known_for_department: 'Costume & Make-Up',
          name: 'Aya Yabuuchi',
          original_name: 'Aya Yabuuchi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59581479c3a36828fc010924',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1412487,
          known_for_department: 'Camera',
          name: 'Lorenzo Donati',
          original_name: 'Lorenzo Donati',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973380a92514112bb02a623',
          department: 'Camera',
          job: 'Steadicam Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1412921,
          known_for_department: 'Production',
          name: 'Marc Guidetti',
          original_name: 'Marc Guidetti',
          popularity: 0.6,
          profile_path: null,
          credit_id: '595814cb9251410c5601081e',
          department: 'Production',
          job: 'Unit Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1418384,
          known_for_department: 'Visual Effects',
          name: 'Paul Story',
          original_name: 'Paul Story',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973346ac3a3683c10007001',
          department: 'Visual Effects',
          job: 'Animation Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1418481,
          known_for_department: 'Visual Effects',
          name: 'Danny Gordon Taylor',
          original_name: 'Danny Gordon Taylor',
          popularity: 0.77,
          profile_path: null,
          credit_id: '59733a2ec3a3686fc70547ae',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1424684,
          known_for_department: 'Sound',
          name: 'Loïc Gourbe',
          original_name: 'Loïc Gourbe',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c64df14dad003ad1b6e7',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1425575,
          known_for_department: 'Directing',
          name: 'Charles Jodoin-Keaton',
          original_name: 'Charles Jodoin-Keaton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732dd0925141787a006f2e',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1428902,
          known_for_department: 'Crew',
          name: 'Conor Byrne',
          original_name: 'Conor Byrne',
          popularity: 1.094,
          profile_path: null,
          credit_id: '597323de9251415e8604c58a',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1439931,
          known_for_department: 'Diễn viên',
          name: 'Ben Fransham',
          original_name: 'Ben Fransham',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/CYz0u1P9QFO57WDW5gN5UnjWNg.jpg',
          credit_id: '59733c3092514112bb02abd5',
          department: 'Crew',
          job: 'Motion Actor',
        },
        {
          adult: false,
          gender: 0,
          id: 1447146,
          known_for_department: 'Visual Effects',
          name: 'Thai Son Doan',
          original_name: 'Thai Son Doan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597325a39251411ece021a37',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1453002,
          known_for_department: 'Visual Effects',
          name: 'Nick Stein',
          original_name: 'Nick Stein',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733a1cc3a3683c10007701',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1453931,
          known_for_department: 'Visual Effects',
          name: 'Jonathan Macintosh',
          original_name: 'Jonathan Macintosh',
          popularity: 1.094,
          profile_path: null,
          credit_id: '5973394dc3a3686f7c04b1be',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1457938,
          known_for_department: 'Visual Effects',
          name: 'Chris Crowell',
          original_name: 'Chris Crowell',
          popularity: 1.178,
          profile_path: null,
          credit_id: '597324f8c3a3684c70020901',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1458128,
          known_for_department: 'Visual Effects',
          name: 'Ken McGaugh',
          original_name: 'Ken McGaugh',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973300dc3a3686f7c04a66e',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1459754,
          known_for_department: 'Visual Effects',
          name: 'Lee McNair',
          original_name: 'Lee McNair',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973395ac3a36830fb008e63',
          department: 'Visual Effects',
          job: 'Lead Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 1460671,
          known_for_department: 'Sound',
          name: 'Peter Cobbin',
          original_name: 'Peter Cobbin',
          popularity: 0.84,
          profile_path: null,
          credit_id: '59733b269251415e8604e2ed',
          department: 'Sound',
          job: 'Scoring Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1463458,
          known_for_department: 'Visual Effects',
          name: 'Joel Cheyne',
          original_name: 'Joel Cheyne',
          popularity: 1.094,
          profile_path: null,
          credit_id: '59732465c3a36830fb0073f5',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1463489,
          known_for_department: 'Visual Effects',
          name: 'Alexis Forni',
          original_name: 'Alexis Forni',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597328e6c3a3683c10006240',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1463642,
          known_for_department: 'Visual Effects',
          name: 'Virginia Wilson',
          original_name: 'Virginia Wilson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733597c3a3683c10007104',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1466515,
          known_for_department: 'Crew',
          name: 'Jean-Claude Mézières',
          original_name: 'Jean-Claude Mézières',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c58ccbd0e0a26185ac9a873',
          department: 'Biên kịch',
          job: 'Comic Book',
        },
        {
          adult: false,
          gender: 2,
          id: 1483231,
          known_for_department: 'Crew',
          name: 'Philippe Rebours',
          original_name: 'Philippe Rebours',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733289925141787a0074ec',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1487230,
          known_for_department: 'Art',
          name: 'Christian Vallat',
          original_name: 'Christian Vallat',
          popularity: 0.6,
          profile_path: null,
          credit_id: '595813cec3a36828fc01087a',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1487590,
          known_for_department: 'Biên kịch',
          name: 'Sylvain Despretz',
          original_name: 'Sylvain Despretz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59581501925141088301227f',
          department: 'Art',
          job: 'Conceptual Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1488231,
          known_for_department: 'Production',
          name: 'Fanny Besson',
          original_name: 'Fanny Besson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59581495c3a368253c0103c0',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1529255,
          known_for_department: 'Art',
          name: 'Fabrice Bourderioux',
          original_name: 'Fabrice Bourderioux',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c31a70309f003e832279',
          department: 'Art',
          job: 'Assistant Property Master',
        },
        {
          adult: false,
          gender: 2,
          id: 1531440,
          known_for_department: 'Visual Effects',
          name: 'Tobias Wiesner',
          original_name: 'Tobias Wiesner',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973357ec3a3687c7d0284df',
          department: 'Crew',
          job: 'Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1540472,
          known_for_department: 'Sound',
          name: 'Nicolas Charron',
          original_name: 'Nicolas Charron',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733b17925141787a0080b7',
          department: 'Sound',
          job: 'Orchestrator',
        },
        {
          adult: false,
          gender: 0,
          id: 1540473,
          known_for_department: 'Sound',
          name: 'Sylvain Morizet',
          original_name: 'Sylvain Morizet',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733b3792514142720030c2',
          department: 'Sound',
          job: 'Orchestrator',
        },
        {
          adult: false,
          gender: 0,
          id: 1542917,
          known_for_department: 'Editing',
          name: 'Yvan Lucas',
          original_name: 'Yvan Lucas',
          popularity: 1.38,
          profile_path:
            'https://image.tmdb.org/t/p/w185/d6yrMuK3YBqAB5gylXshRwOJdYJ.jpg',
          credit_id: '5fe5c26531644b003df92960',
          department: 'Editing',
          job: 'Digital Intermediate Colorist',
        },
        {
          adult: false,
          gender: 0,
          id: 1546433,
          known_for_department: 'Visual Effects',
          name: 'Matt Holmes',
          original_name: 'Matt Holmes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732d71c3a3687c7d027b02',
          department: 'Visual Effects',
          job: 'VFX Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1557616,
          known_for_department: 'Visual Effects',
          name: 'Julian Bryant',
          original_name: 'Julian Bryant',
          popularity: 0.656,
          profile_path: null,
          credit_id: '5973236dc3a3686fc7052847',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1567911,
          known_for_department: 'Visual Effects',
          name: 'Lori C. Miller',
          original_name: 'Lori C. Miller',
          popularity: 1.38,
          profile_path: null,
          credit_id: '59733067c3a36830fb00828b',
          department: 'Crew',
          job: 'Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1568460,
          known_for_department: 'Crew',
          name: 'Sebastien Francoeur',
          original_name: 'Sebastien Francoeur',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973294a92514142a70018e0',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1569332,
          known_for_department: 'Visual Effects',
          name: 'Drew Nielsen',
          original_name: 'Drew Nielsen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597331749251415e8604d5fb',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1569334,
          known_for_department: 'Visual Effects',
          name: 'Chloe Feodoroff',
          original_name: 'Chloe Feodoroff',
          popularity: 1.094,
          profile_path: null,
          credit_id: '5973285a92514112bb029148',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1575787,
          known_for_department: 'Costume & Make-Up',
          name: 'Daniel Auber',
          original_name: 'Daniel Auber',
          popularity: 0.6,
          profile_path: null,
          credit_id: '595814ecc3a368275000fc05',
          department: 'Art',
          job: 'Storyboard Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1578412,
          known_for_department: 'Visual Effects',
          name: 'Deak Ferrand',
          original_name: 'Deak Ferrand',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732899c3a3683ba40063ff',
          department: 'Art',
          job: 'Conceptual Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1578412,
          known_for_department: 'Visual Effects',
          name: 'Deak Ferrand',
          original_name: 'Deak Ferrand',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597328b09251414fde030bcf',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 2,
          id: 1591830,
          known_for_department: 'Visual Effects',
          name: 'Xavier Fourmond',
          original_name: 'Xavier Fourmond',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973292ec3a3684c70020dbc',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1597961,
          known_for_department: 'Visual Effects',
          name: 'Kimberly Aller',
          original_name: 'Kimberly Aller',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597322119251411ece021555',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1621763,
          known_for_department: 'Editing',
          name: 'Katrina Taylor',
          original_name: 'Katrina Taylor',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973348e925141787a007792',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1621770,
          known_for_department: 'Visual Effects',
          name: 'Louise Bertrand',
          original_name: 'Louise Bertrand',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597322b292514112bb0289e7',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1621771,
          known_for_department: 'Visual Effects',
          name: 'Joseph Kasparian',
          original_name: 'Joseph Kasparian',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732dfb9251417fa6029309',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1621911,
          known_for_department: 'Costume & Make-Up',
          name: 'Thi Thanh Tu Nguyen',
          original_name: 'Thi Thanh Tu Nguyen',
          popularity: 0.98,
          profile_path: null,
          credit_id: '59f3b0f4c3a36820010000eb',
          department: 'Costume & Make-Up',
          job: 'Makeup Department Head',
        },
        {
          adult: false,
          gender: 1,
          id: 1621911,
          known_for_department: 'Costume & Make-Up',
          name: 'Thi Thanh Tu Nguyen',
          original_name: 'Thi Thanh Tu Nguyen',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5958144cc3a368293b012c54',
          department: 'Costume & Make-Up',
          job: 'Key Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1630957,
          known_for_department: 'Sound',
          name: 'Gurwal Coïc-Gallas',
          original_name: 'Gurwal Coïc-Gallas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59731df89251414fde02ff21',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1646534,
          known_for_department: 'Visual Effects',
          name: 'Xavier Bourque',
          original_name: 'Xavier Bourque',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973231ac3a3686fc70527e2',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 1,
          id: 1646537,
          known_for_department: 'Visual Effects',
          name: 'Cynthia Rodriguez del Castillo',
          original_name: 'Cynthia Rodriguez del Castillo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597323f9925141787a006344',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1646541,
          known_for_department: 'Visual Effects',
          name: 'Matthieu Chatelier',
          original_name: 'Matthieu Chatelier',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732457c3a3683ba4005f32',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1646565,
          known_for_department: 'Visual Effects',
          name: 'Mathieu Girard',
          original_name: 'Mathieu Girard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732a329251414272001ae2',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1646568,
          known_for_department: 'Visual Effects',
          name: 'Olivier Gravel',
          original_name: 'Olivier Gravel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732cd2c3a3683ba4006914',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1646576,
          known_for_department: 'Visual Effects',
          name: 'Bruno-Pierre Jobin',
          original_name: 'Bruno-Pierre Jobin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732dc2c3a3687c7d027b67',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1646585,
          known_for_department: 'Visual Effects',
          name: 'Xavier Larocque',
          original_name: 'Xavier Larocque',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732e56c3a3684c700213d3',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1646592,
          known_for_department: 'Visual Effects',
          name: 'Maxime Lemieux',
          original_name: 'Maxime Lemieux',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732ec3c3a3683ba4006b00',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1646593,
          known_for_department: 'Visual Effects',
          name: 'Samuel Lepage-Bedard',
          original_name: 'Samuel Lepage-Bedard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732ecdc3a3686fc7053763',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1646598,
          known_for_department: 'Visual Effects',
          name: 'Martine Losier',
          original_name: 'Martine Losier',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732f25c3a3686fc70537bb',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1646601,
          known_for_department: 'Visual Effects',
          name: 'Karina Mariano',
          original_name: 'Karina Mariano',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732f69c3a3681d7000205f',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1646603,
          known_for_department: 'Visual Effects',
          name: 'Belly Mingmuong',
          original_name: 'Belly Mingmuong',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597330719251414fde031563',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1658880,
          known_for_department: 'Visual Effects',
          name: 'Deborah Zadzora',
          original_name: 'Deborah Zadzora',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597335ff92514142720029a0',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1662961,
          known_for_department: 'Costume & Make-Up',
          name: 'Hue Lan Van Duc',
          original_name: 'Hue Lan Van Duc',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5958146d9251410b860125b0',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 1669139,
          known_for_department: 'Sound',
          name: 'Samson Neslund',
          original_name: 'Samson Neslund',
          popularity: 1.4,
          profile_path: null,
          credit_id: '59731f64c3a3686f7c049368',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1670736,
          known_for_department: 'Crew',
          name: 'Ludo Silemetzoglou',
          original_name: 'Ludo Silemetzoglou',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597337959251415e8604de17',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1690843,
          known_for_department: 'Crew',
          name: 'Yannick Ben',
          original_name: 'Yannick Ben',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973363ac3a3687c7d02857f',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1720805,
          known_for_department: 'Visual Effects',
          name: 'David Pate',
          original_name: 'David Pate',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973397a9251417fa602a1f5',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1721867,
          known_for_department: 'Visual Effects',
          name: 'Laetitia Seguin',
          original_name: 'Laetitia Seguin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733393c3a3684c700219fc',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1723047,
          known_for_department: 'Costume & Make-Up',
          name: 'Simon Livet',
          original_name: 'Simon Livet',
          popularity: 0.6,
          profile_path: null,
          credit_id: '595814169251410c89011606',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 1,
          id: 1725126,
          known_for_department: 'Diễn viên',
          name: 'Emilie Livingston',
          original_name: 'Emilie Livingston',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733bf8c3a3683c10007958',
          department: 'Crew',
          job: 'Choreographer',
        },
        {
          adult: false,
          gender: 0,
          id: 1727648,
          known_for_department: 'Visual Effects',
          name: 'Seth Kenlon',
          original_name: 'Seth Kenlon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732e0ac3a3686f7c04a43f',
          department: 'Visual Effects',
          job: 'Visual Effects',
        },
        {
          adult: false,
          gender: 2,
          id: 1728124,
          known_for_department: 'Visual Effects',
          name: 'Olle Petersson',
          original_name: 'Olle Petersson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597331d1c3a3686f7c04a8b8',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1730518,
          known_for_department: 'Costume & Make-Up',
          name: 'Clarisse Domine',
          original_name: 'Clarisse Domine',
          popularity: 0.6,
          profile_path: null,
          credit_id: '595813f8c3a368275000fb22',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1734678,
          known_for_department: 'Visual Effects',
          name: 'Laurie Kotfila',
          original_name: 'Laurie Kotfila',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732e1ac3a36830fb007fe8',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1737529,
          known_for_department: 'Crew',
          name: 'Benoit Lavelatte',
          original_name: 'Benoit Lavelatte',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5973373192514112bb02a4ea',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1739317,
          known_for_department: 'Crew',
          name: 'Alan Woods',
          original_name: 'Alan Woods',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597335b5c3a3687c7d028506',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1759787,
          known_for_department: 'Visual Effects',
          name: 'Catherine Lecavalier',
          original_name: 'Catherine Lecavalier',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732e8d9251414fde03132e',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1759802,
          known_for_department: 'Visual Effects',
          name: 'Yanick Wilisky',
          original_name: 'Yanick Wilisky',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597335899251411ece022dca',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1773768,
          known_for_department: 'Crew',
          name: 'Jérôme Gaspard',
          original_name: 'Jérôme Gaspard',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/52kIfU0P46gyDcNQtVJnLLuoKev.jpg',
          credit_id: '59733704c3a3686fc705429f',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1773769,
          known_for_department: 'Camera',
          name: 'Jean-Marc Duez',
          original_name: 'Jean-Marc Duez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733817c3a3687c7d028828',
          department: 'Camera',
          job: 'Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1799758,
          known_for_department: 'Camera',
          name: 'Jonathan Ly',
          original_name: 'Jonathan Ly',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597338539251411ece023210',
          department: 'Camera',
          job: 'Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1811602,
          known_for_department: 'Sound',
          name: 'Jérémy Babinet',
          original_name: 'Jérémy Babinet',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c62a70309f004084d975',
          department: 'Sound',
          job: 'Foley Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1814934,
          known_for_department: 'Editing',
          name: 'Jeremy Ian Thomas',
          original_name: 'Jeremy Ian Thomas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733abfc3a3681d70002ef1',
          department: 'Editing',
          job: 'Additional Editing',
        },
        {
          adult: false,
          gender: 2,
          id: 1823882,
          known_for_department: 'Sound',
          name: 'Alexis Place',
          original_name: 'Alexis Place',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59731f7992514142a7000dcf',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1823884,
          known_for_department: 'Visual Effects',
          name: 'Marc Jouveneau',
          original_name: 'Marc Jouveneau',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732de0c3a3681d70001eb8',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1826926,
          known_for_department: 'Camera',
          name: 'Julien Moine',
          original_name: 'Julien Moine',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597338619251414fde03204a',
          department: 'Camera',
          job: 'Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1826940,
          known_for_department: 'Crew',
          name: 'John Medalin',
          original_name: 'John Medalin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973374692514142a700297a',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1842657,
          known_for_department: 'Production',
          name: 'Camille Courau',
          original_name: 'Camille Courau',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59581350c3a368253c010274',
          department: 'Production',
          job: 'Line Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1842658,
          known_for_department: 'Art',
          name: 'Etienne Rohde',
          original_name: 'Etienne Rohde',
          popularity: 0.6,
          profile_path: null,
          credit_id: '595813c3c3a368275000fafe',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1842659,
          known_for_department: 'Costume & Make-Up',
          name: 'Aurelija Liansbergaite',
          original_name: 'Aurelija Liansbergaite',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59581403c3a368293b012c09',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 1,
          id: 1842660,
          known_for_department: 'Costume & Make-Up',
          name: 'Elodie Leprince',
          original_name: 'Elodie Leprince',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5958140cc3a36828e70123a1',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1842661,
          known_for_department: 'Costume & Make-Up',
          name: 'Lola Maillard',
          original_name: 'Lola Maillard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '595814349251410a59011c1f',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1842662,
          known_for_department: 'Costume & Make-Up',
          name: 'Vesna Peborde',
          original_name: 'Vesna Peborde',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59581458c3a36828a1014ab3',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 1842663,
          known_for_department: 'Costume & Make-Up',
          name: 'Félix Puget',
          original_name: 'Félix Puget',
          popularity: 0.84,
          profile_path: null,
          credit_id: '59581462c3a368275000fb8a',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1842664,
          known_for_department: 'Production',
          name: 'Solène Zavagno',
          original_name: 'Solène Zavagno',
          popularity: 0.6,
          profile_path: null,
          credit_id: '595814ddc3a36828e701248f',
          department: 'Production',
          job: 'Executive In Charge Of Production',
        },
        {
          adult: false,
          gender: 0,
          id: 1842665,
          known_for_department: 'Art',
          name: 'Isaac Hannaford',
          original_name: 'Isaac Hannaford',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59581526c3a368275000fc3c',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 0,
          id: 1848081,
          known_for_department: 'Crew',
          name: 'Paul Randall',
          original_name: 'Paul Randall',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733279c3a3683ba4006f73',
          department: 'Crew',
          job: 'Motion Actor',
        },
        {
          adult: false,
          gender: 2,
          id: 1849011,
          known_for_department: 'Crew',
          name: 'Marc David',
          original_name: 'Marc David',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/htb4shyGCel92VlmQUICDqeVtse.jpg',
          credit_id: '597336859251411ece022f1b',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1855804,
          known_for_department: 'Directing',
          name: 'Elise Cresson',
          original_name: 'Elise Cresson',
          popularity: 0.608,
          profile_path: null,
          credit_id: '59731ac69251414272000824',
          department: 'Directing',
          job: 'Third Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1855805,
          known_for_department: 'Directing',
          name: 'Emmanuelle Fourault',
          original_name: 'Emmanuelle Fourault',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59731ad2c3a3683ba40053d9',
          department: 'Directing',
          job: 'Second Assistant Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1855806,
          known_for_department: 'Directing',
          name: 'Stéphane Gluck',
          original_name: 'Stéphane Gluck',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aJmLlMEozIWpxkfJRibIIwjg9Rh.jpg',
          credit_id: '59731addc3a3686f7c048d5f',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1855807,
          known_for_department: 'Directing',
          name: 'Grégoire Jeudy',
          original_name: 'Grégoire Jeudy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59731aea92514142a70007c0',
          department: 'Directing',
          job: 'Third Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1855808,
          known_for_department: 'Directing',
          name: 'Abigail L.S. Yardley',
          original_name: 'Abigail L.S. Yardley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59731b0b9251414272000876',
          department: 'Directing',
          job: 'Second Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1855809,
          known_for_department: 'Directing',
          name: 'Jawahine Zentar',
          original_name: 'Jawahine Zentar',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59731b1a9251414fde02faf8',
          department: 'Directing',
          job: 'Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1855820,
          known_for_department: 'Art',
          name: 'Thibault Pinto',
          original_name: 'Thibault Pinto',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59731da6c3a3683ba400578e',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1855821,
          known_for_department: 'Sound',
          name: 'Jérôme Rabu',
          original_name: 'Jérôme Rabu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59731f82c3a3684c700202b7',
          department: 'Sound',
          job: 'Boom Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1855822,
          known_for_department: 'Sound',
          name: 'Chris Trueman',
          original_name: 'Chris Trueman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59731f94c3a3683c100057a5',
          department: 'Sound',
          job: 'Sound Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1855824,
          known_for_department: 'Crew',
          name: 'Emmanuel Galtier',
          original_name: 'Emmanuel Galtier',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597321b992514142720010c3',
          department: 'Crew',
          job: 'Special Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1855827,
          known_for_department: 'Visual Effects',
          name: 'Gerardo Aguilera',
          original_name: 'Gerardo Aguilera',
          popularity: 0.98,
          profile_path: null,
          credit_id: '597321f79251417fa602842f',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1855828,
          known_for_department: 'Visual Effects',
          name: 'Neichols Alice',
          original_name: 'Neichols Alice',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732203c3a3684c70020552',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1855830,
          known_for_department: 'Visual Effects',
          name: 'Romain Bavent',
          original_name: 'Romain Bavent',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973224b925141787a00610e',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855832,
          known_for_department: 'Visual Effects',
          name: 'Marie-Eve Bedard-Tremblay',
          original_name: 'Marie-Eve Bedard-Tremblay',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732260c3a3686fc70526ba',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1855833,
          known_for_department: 'Visual Effects',
          name: 'Vincent Bergeron',
          original_name: 'Vincent Bergeron',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732279c3a3681d70001074',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855834,
          known_for_department: 'Visual Effects',
          name: 'Alex Berson',
          original_name: 'Alex Berson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973229dc3a3686fc7052723',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855835,
          known_for_department: 'Visual Effects',
          name: 'Olivier Blanchet',
          original_name: 'Olivier Blanchet',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597322d09251411ece021645',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855836,
          known_for_department: 'Visual Effects',
          name: 'Robert Bock',
          original_name: 'Robert Bock',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597322f09251414fde0304de',
          department: 'Visual Effects',
          job: 'VFX Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 1855837,
          known_for_department: 'Visual Effects',
          name: 'Bertrand Breuze',
          original_name: 'Bertrand Breuze',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973233c92514112bb028abc',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855838,
          known_for_department: 'Visual Effects',
          name: 'Eloi Brunelle',
          original_name: 'Eloi Brunelle',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597323479251415e8604c4d1',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855839,
          known_for_department: 'Visual Effects',
          name: 'C.J. Burbage',
          original_name: 'C.J. Burbage',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597323879251417fa602863b',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1855841,
          known_for_department: 'Visual Effects',
          name: 'Jose Burgos',
          original_name: 'Jose Burgos',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597323af9251411ece021749',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1855843,
          known_for_department: 'Production',
          name: 'Andy Campion',
          original_name: 'Andy Campion',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597323edc3a3683c10005c9c',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1855847,
          known_for_department: 'Visual Effects',
          name: 'William Cote',
          original_name: 'William Cote',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597324a592514142a70013ae',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855853,
          known_for_department: 'Visual Effects',
          name: 'Gabriel Couture-Bojanowski',
          original_name: 'Gabriel Couture-Bojanowski',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597324b19251411ece0218d2',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855854,
          known_for_department: 'Visual Effects',
          name: 'Jaume Creus',
          original_name: 'Jaume Creus',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597324bfc3a3683ba4005fc1',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855855,
          known_for_department: 'Production',
          name: 'Céline Cruz',
          original_name: 'Céline Cruz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973250592514142720014e0',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1855856,
          known_for_department: 'Visual Effects',
          name: 'Vanessa Delarosbil',
          original_name: 'Vanessa Delarosbil',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973251c9251411ece021956',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855857,
          known_for_department: 'Visual Effects',
          name: 'Etienne Deshaies',
          original_name: 'Etienne Deshaies',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973254bc3a3687c7d0271ae',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855858,
          known_for_department: 'Visual Effects',
          name: 'Ashish Dewan',
          original_name: 'Ashish Dewan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597325799251414fde03083d',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855859,
          known_for_department: 'Crew',
          name: 'Gareth Dinneen',
          original_name: 'Gareth Dinneen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973258fc3a3683c10005ec7',
          department: 'Crew',
          job: 'Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855860,
          known_for_department: 'Visual Effects',
          name: 'Rémi Ducharme',
          original_name: 'Rémi Ducharme',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597325e39251411ece021a75',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1855861,
          known_for_department: 'Visual Effects',
          name: 'Elliott Ducruy',
          original_name: 'Elliott Ducruy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597325efc3a36830fb0075fd',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855862,
          known_for_department: 'Visual Effects',
          name: 'Samuel Durocher',
          original_name: 'Samuel Durocher',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597326139251414272001666',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855864,
          known_for_department: 'Visual Effects',
          name: 'Marco Aurélio Engelmann Santos',
          original_name: 'Marco Aurélio Engelmann Santos',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973284792514112bb02912f',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855865,
          known_for_department: 'Visual Effects',
          name: 'Elisa Mar Ferre',
          original_name: 'Elisa Mar Ferre',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732876c3a3687c7d027535',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855866,
          known_for_department: 'Visual Effects',
          name: 'Jérôme Foucout',
          original_name: 'Jérôme Foucout',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597329229251411ece021dbc',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855867,
          known_for_department: 'Visual Effects',
          name: 'Melissa Franco',
          original_name: 'Melissa Franco',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973293c925141787a006997',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1855868,
          known_for_department: 'Art',
          name: 'Frederic Perrin Fredleew',
          original_name: 'Frederic Perrin Fredleew',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597329709251417fa6028d64',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 0,
          id: 1855869,
          known_for_department: 'Crew',
          name: 'Brian Goodwin',
          original_name: 'Brian Goodwin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732cc4c3a3681d70001d7a',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1855870,
          known_for_department: 'Crew',
          name: 'Joshua Guitar',
          original_name: 'Joshua Guitar',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732cf9c3a3681d70001da0',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1855871,
          known_for_department: 'Visual Effects',
          name: 'Kathrin Günther',
          original_name: 'Kathrin Günther',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732d03c3a3683c10006724',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855872,
          known_for_department: 'Visual Effects',
          name: 'James Daniel Haines',
          original_name: 'James Daniel Haines',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732d0e925141787a006e44',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855873,
          known_for_department: 'Visual Effects',
          name: 'Ahman Hung',
          original_name: 'Ahman Hung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732d819251417fa6029272',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1855874,
          known_for_department: 'Visual Effects',
          name: 'Sébastien Jacob',
          original_name: 'Sébastien Jacob',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732da7c3a3684c70021307',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855875,
          known_for_department: 'Visual Effects',
          name: 'Antoine Jannic',
          original_name: 'Antoine Jannic',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732db2c3a3681d70001e76',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 1,
          id: 1855876,
          known_for_department: 'Visual Effects',
          name: 'Kimberly Julien',
          original_name: 'Kimberly Julien',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732decc3a3686fc705365c',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1855877,
          known_for_department: 'Visual Effects',
          name: 'Melissa Laframboise-Maille',
          original_name: 'Melissa Laframboise-Maille',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732e279251414fde0312c9',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855878,
          known_for_department: 'Visual Effects',
          name: 'Martin Larrivée',
          original_name: 'Martin Larrivée',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732e649251414272001fde',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855879,
          known_for_department: 'Visual Effects',
          name: 'Jean-Marc Laurin',
          original_name: 'Jean-Marc Laurin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732e749251417fa602938b',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855880,
          known_for_department: 'Visual Effects',
          name: 'Virginie Lavallée',
          original_name: 'Virginie Lavallée',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732e8092514112bb029952',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1855881,
          known_for_department: 'Visual Effects',
          name: 'Mathieu Legros',
          original_name: 'Mathieu Legros',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732eb8c3a3683ba4006af4',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855882,
          known_for_department: 'Visual Effects',
          name: 'Julien Leveugle',
          original_name: 'Julien Leveugle',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732ed89251411ece022525',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855883,
          known_for_department: 'Visual Effects',
          name: 'Cedric Lo',
          original_name: 'Cedric Lo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732ef1c3a3684c70021465',
          department: 'Visual Effects',
          job: 'Animation Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1855885,
          known_for_department: 'Crew',
          name: 'Owen Longstaff',
          original_name: 'Owen Longstaff',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732f0dc3a3683ba4006b4d',
          department: 'Crew',
          job: 'Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855886,
          known_for_department: 'Visual Effects',
          name: 'Louis-Alexandre Lord',
          original_name: 'Louis-Alexandre Lord',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732f19c3a3687c7d027cf2',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855887,
          known_for_department: 'Visual Effects',
          name: 'Olivier Lukaszczyk',
          original_name: 'Olivier Lukaszczyk',
          popularity: 0.84,
          profile_path: null,
          credit_id: '59732f31c3a3686fc70537c7',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855888,
          known_for_department: 'Visual Effects',
          name: 'Darren MacKay',
          original_name: 'Darren MacKay',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732f3ec3a3687c7d027d2d',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855889,
          known_for_department: 'Visual Effects',
          name: 'Renaud Madeline',
          original_name: 'Renaud Madeline',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732f499251415e8604d34e',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855890,
          known_for_department: 'Visual Effects',
          name: 'Jocelyn Maher',
          original_name: 'Jocelyn Maher',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732f53c3a3684c700214c1',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855891,
          known_for_department: 'Visual Effects',
          name: 'Jérémie Maheu',
          original_name: 'Jérémie Maheu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732f5d92514112bb029a59',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855892,
          known_for_department: 'Visual Effects',
          name: 'Giorgio Marino',
          original_name: 'Giorgio Marino',
          popularity: 0.98,
          profile_path: null,
          credit_id: '59732f73c3a3687c7d027d6f',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855893,
          known_for_department: 'Art',
          name: 'Olivier Martin',
          original_name: 'Olivier Martin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732fdec3a3686f7c04a61c',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1855894,
          known_for_department: 'Visual Effects',
          name: 'Philippe Massonnat',
          original_name: 'Philippe Massonnat',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732fefc3a3683c10006a2e',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1855895,
          known_for_department: 'Crew',
          name: 'Haydn Masuda',
          original_name: 'Haydn Masuda',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59732ff9c3a3686f7c04a647',
          department: 'Crew',
          job: 'Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855897,
          known_for_department: 'Crew',
          name: 'Steve McGee',
          original_name: 'Steve McGee',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973303b9251411ece0226d5',
          department: 'Crew',
          job: 'Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855898,
          known_for_department: 'Crew',
          name: 'Carlton McRae',
          original_name: 'Carlton McRae',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733050c3a3684c700215f7',
          department: 'Crew',
          job: 'Motion Actor',
        },
        {
          adult: false,
          gender: 0,
          id: 1855899,
          known_for_department: 'Visual Effects',
          name: 'Trevor Moniz',
          original_name: 'Trevor Moniz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973307dc3a3687c7d027ecf',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855900,
          known_for_department: 'Art',
          name: 'Rene Morel',
          original_name: 'Rene Morel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973308cc3a36830fb0082af',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 0,
          id: 1855901,
          known_for_department: 'Crew',
          name: 'Alexandre Ménard',
          original_name: 'Alexandre Ménard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973315ec3a3686fc7053acc',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1855902,
          known_for_department: 'Visual Effects',
          name: 'Neila Ouahmed',
          original_name: 'Neila Ouahmed',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733198c3a3683ba4006e35',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855903,
          known_for_department: 'Visual Effects',
          name: 'Rob Ozaeta',
          original_name: 'Rob Ozaeta',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597331a29251415e8604d64d',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855904,
          known_for_department: 'Visual Effects',
          name: 'Anna Pacchioni',
          original_name: 'Anna Pacchioni',
          popularity: 0.98,
          profile_path: null,
          credit_id: '597331adc3a3681d7000234e',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855905,
          known_for_department: 'Visual Effects',
          name: 'Philippe Pelletier',
          original_name: 'Philippe Pelletier',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597331c5925141787a0073da',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855906,
          known_for_department: 'Visual Effects',
          name: 'Christine Petrov',
          original_name: 'Christine Petrov',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597331dac3a3686f7c04a8c8',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855907,
          known_for_department: 'Visual Effects',
          name: 'Ugo Pierantoni',
          original_name: 'Ugo Pierantoni',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597331e7c3a3686fc7053bb5',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855908,
          known_for_department: 'Visual Effects',
          name: 'Xenia Pirojenko',
          original_name: 'Xenia Pirojenko',
          popularity: 1.38,
          profile_path: null,
          credit_id: '597331f29251411ece02290e',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855909,
          known_for_department: 'Crew',
          name: 'François Poirier',
          original_name: 'François Poirier',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973320cc3a3683ba4006ed0',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1855910,
          known_for_department: 'Visual Effects',
          name: 'Jennifer Ramos',
          original_name: 'Jennifer Ramos',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973324592514112bb029e6b',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1855911,
          known_for_department: 'Visual Effects',
          name: 'Troy Ramsey',
          original_name: 'Troy Ramsey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973325392514142720024e4',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855912,
          known_for_department: 'Visual Effects',
          name: 'Marianne Roberge',
          original_name: 'Marianne Roberge',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597332aa925141787a00751b',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855913,
          known_for_department: 'Visual Effects',
          name: 'Stephen Robertson',
          original_name: 'Stephen Robertson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597332dbc3a3686fc7053d3d',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 2,
          id: 1855914,
          known_for_department: 'Visual Effects',
          name: 'Paul Saint-Hilaire',
          original_name: 'Paul Saint-Hilaire',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597332ed9251415e8604d82a',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855915,
          known_for_department: 'Visual Effects',
          name: 'Mauricio Salas',
          original_name: 'Mauricio Salas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597332f7c3a3683ba4007009',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855916,
          known_for_department: 'Visual Effects',
          name: 'Katy Savoie',
          original_name: 'Katy Savoie',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733306c3a3684c70021960',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855917,
          known_for_department: 'Visual Effects',
          name: 'Carlo Scaduto',
          original_name: 'Carlo Scaduto',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5973331092514112bb029f78',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 2,
          id: 1855918,
          known_for_department: 'Visual Effects',
          name: 'David M. Scott',
          original_name: 'David M. Scott',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973338692514142a70024e6',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855919,
          known_for_department: 'Production',
          name: 'Georgina Selby',
          original_name: 'Georgina Selby',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973339ec3a3683ba40070ca',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1855920,
          known_for_department: 'Visual Effects',
          name: 'Brian Sepanzyk',
          original_name: 'Brian Sepanzyk',
          popularity: 0.84,
          profile_path: null,
          credit_id: '597333aa92514142a7002509',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1855921,
          known_for_department: 'Visual Effects',
          name: 'Micha Sher',
          original_name: 'Micha Sher',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597333bfc3a3683c10006f23',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855922,
          known_for_department: 'Visual Effects',
          name: 'Ziad Shureih',
          original_name: 'Ziad Shureih',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597333d3c3a3683c10006f3b',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855923,
          known_for_department: 'Visual Effects',
          name: 'Michael Solon',
          original_name: 'Michael Solon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597333e19251417fa6029aa4',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855924,
          known_for_department: 'Visual Effects',
          name: 'Mark Stanger',
          original_name: 'Mark Stanger',
          popularity: 0.98,
          profile_path: null,
          credit_id: '597334079251411ece022bbf',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1855925,
          known_for_department: 'Visual Effects',
          name: 'Tim Stern',
          original_name: 'Tim Stern',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5973343a9251414fde031a84',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855926,
          known_for_department: 'Visual Effects',
          name: 'Giuseppe Tagliavini',
          original_name: 'Giuseppe Tagliavini',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973347c9251415e8604d9f4',
          department: 'Crew',
          job: 'Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855927,
          known_for_department: 'Visual Effects',
          name: 'Mehdi Tessier',
          original_name: 'Mehdi Tessier',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597334a092514142720027e1',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855928,
          known_for_department: 'Visual Effects',
          name: 'Julie Therrien',
          original_name: 'Julie Therrien',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597334bec3a3683c10007065',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855929,
          known_for_department: 'Visual Effects',
          name: 'Liu Tiansheng',
          original_name: 'Liu Tiansheng',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597334d3c3a3686f7c04ac69',
          department: 'Visual Effects',
          job: 'Visual Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1855930,
          known_for_department: 'Visual Effects',
          name: 'Will Towle',
          original_name: 'Will Towle',
          popularity: 0.694,
          profile_path: null,
          credit_id: '597334ee92514112bb02a208',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855931,
          known_for_department: 'Visual Effects',
          name: 'Dirk Valk',
          original_name: 'Dirk Valk',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733511925141787a007864',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 1855932,
          known_for_department: 'Visual Effects',
          name: 'Raphael Valle',
          original_name: 'Raphael Valle',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973351c9251415e8604dac6',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855933,
          known_for_department: 'Visual Effects',
          name: 'Jean Frédéric Veilleux',
          original_name: 'Jean Frédéric Veilleux',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973352bc3a3686fc7054076',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855934,
          known_for_department: 'Visual Effects',
          name: 'Sebastien Veilleux',
          original_name: 'Sebastien Veilleux',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597335369251414fde031bee',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855935,
          known_for_department: 'Visual Effects',
          name: 'Armando Velazquez',
          original_name: 'Armando Velazquez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597335459251414fde031c09',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855936,
          known_for_department: 'Visual Effects',
          name: 'Pau Viladot',
          original_name: 'Pau Viladot',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597335529251417fa6029c60',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855938,
          known_for_department: 'Visual Effects',
          name: 'Lea Vuillemin',
          original_name: 'Lea Vuillemin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973355d9251411ece022d8e',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855940,
          known_for_department: 'Visual Effects',
          name: 'Ji Hyun Yoon',
          original_name: 'Ji Hyun Yoon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597335e8c3a3686f7c04ad38',
          department: 'Visual Effects',
          job: 'Visual Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1855941,
          known_for_department: 'Visual Effects',
          name: 'Vladimir Yordanov',
          original_name: 'Vladimir Yordanov',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597335f3c3a3686fc705414f',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1855942,
          known_for_department: 'Crew',
          name: 'Yann Brouet',
          original_name: 'Yann Brouet',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733644c3a3686f7c04ad6f',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1855943,
          known_for_department: 'Crew',
          name: 'Amadéo Cazzela',
          original_name: 'Amadéo Cazzela',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973364e9251415e8604dc56',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1855944,
          known_for_department: 'Crew',
          name: 'Gary Cothenet',
          original_name: 'Gary Cothenet',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597336579251414272002a0d',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1855946,
          known_for_department: 'Crew',
          name: 'Jessica Decalion',
          original_name: 'Jessica Decalion',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597336929251414272002a5d',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1855947,
          known_for_department: 'Crew',
          name: 'David Demianoff',
          original_name: 'David Demianoff',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973369c9251415e8604dcb3',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1855948,
          known_for_department: 'Crew',
          name: 'Lyne Doffagne',
          original_name: 'Lyne Doffagne',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597336bb9251411ece022fa7',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1855949,
          known_for_department: 'Crew',
          name: 'Christophe Dupuis',
          original_name: 'Christophe Dupuis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597336c6925141787a007a70',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1855950,
          known_for_department: 'Crew',
          name: 'Cullet Eric',
          original_name: 'Cullet Eric',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597336d4c3a3683c10007226',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1855951,
          known_for_department: 'Crew',
          name: 'Bodie Fitzpatrick',
          original_name: 'Bodie Fitzpatrick',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597336ea92514112bb02a46c',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1855951,
          known_for_department: 'Crew',
          name: 'Bodie Fitzpatrick',
          original_name: 'Bodie Fitzpatrick',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597336f8c3a3683c1000726c',
          department: 'Crew',
          job: 'Motion Actor',
        },
        {
          adult: false,
          gender: 0,
          id: 1855952,
          known_for_department: 'Crew',
          name: 'Wilfried Gomba',
          original_name: 'Wilfried Gomba',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973371a92514112bb02a4b2',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1855953,
          known_for_department: 'Crew',
          name: 'Alexandre Lopoka',
          original_name: 'Alexandre Lopoka',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973373b92514142a700296b',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1855955,
          known_for_department: 'Crew',
          name: 'Ilya Nikitenko',
          original_name: 'Ilya Nikitenko',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597337519251417fa6029ecc',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1855956,
          known_for_department: 'Crew',
          name: 'David Nop',
          original_name: 'David Nop',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597337639251414272002b79',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1855959,
          known_for_department: 'Crew',
          name: 'Brayane Rafiq',
          original_name: 'Brayane Rafiq',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973378cc3a3686fc7054365',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1855960,
          known_for_department: 'Crew',
          name: 'Arman Vossougui',
          original_name: 'Arman Vossougui',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973379fc3a3684c70021ec6',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1855961,
          known_for_department: 'Lighting',
          name: 'Brice Bailly',
          original_name: 'Brice Bailly',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597337b09251415e8604de3f',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 1855962,
          known_for_department: 'Lighting',
          name: 'Franck-Norman Bihi',
          original_name: 'Franck-Norman Bihi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597337bac3a3686f7c04af5c',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 1855963,
          known_for_department: 'Camera',
          name: 'Philippe Brunel',
          original_name: 'Philippe Brunel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597337c792514112bb02a5c3',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1855964,
          known_for_department: 'Camera',
          name: 'Philippe Canu',
          original_name: 'Philippe Canu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597337d0c3a3686f7c04af7b',
          department: 'Camera',
          job: 'Key Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1855965,
          known_for_department: 'Lighting',
          name: 'Charles Carpentier',
          original_name: 'Charles Carpentier',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597337dac3a3684c70021f1d',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 1855966,
          known_for_department: 'Lighting',
          name: 'Thibaud Charles',
          original_name: 'Thibaud Charles',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597337e4c3a3683c100073b8',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 1855967,
          known_for_department: 'Camera',
          name: 'Lucie Chauveau',
          original_name: 'Lucie Chauveau',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597337f19251417fa6029fa6',
          department: 'Camera',
          job: 'Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1855968,
          known_for_department: 'Lighting',
          name: 'Stéphane Cry',
          original_name: 'Stéphane Cry',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597337ffc3a3686fc705442c',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 1855971,
          known_for_department: 'Camera',
          name: 'Yannick Freess',
          original_name: 'Yannick Freess',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733823c3a3684c70021f81',
          department: 'Camera',
          job: 'Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1855972,
          known_for_department: 'Lighting',
          name: 'Quentin Jorquera',
          original_name: 'Quentin Jorquera',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973383cc3a36830fb008cc8',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 1855973,
          known_for_department: 'Lighting',
          name: 'Frédéric Thurot',
          original_name: 'Frédéric Thurot',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733882c3a36830fb008d28',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 1855974,
          known_for_department: 'Camera',
          name: 'Jean-Mary Vodoz',
          original_name: 'Jean-Mary Vodoz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973388c9251415e8604df51',
          department: 'Camera',
          job: 'Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1855975,
          known_for_department: 'Visual Effects',
          name: 'Kristian Antonelli',
          original_name: 'Kristian Antonelli',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5973389c92514142a7002b4e',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1855977,
          known_for_department: 'Visual Effects',
          name: 'Andrew Butterfield',
          original_name: 'Andrew Butterfield',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597338a792514142a7002b74',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1855979,
          known_for_department: 'Visual Effects',
          name: 'Tom Chou',
          original_name: 'Tom Chou',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597338b3c3a3686f7c04b0c7',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1855981,
          known_for_department: 'Visual Effects',
          name: 'Jazmin Evans',
          original_name: 'Jazmin Evans',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597338bec3a3683c100074d6',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1855982,
          known_for_department: 'Visual Effects',
          name: 'Ben Folkman',
          original_name: 'Ben Folkman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597338c8c3a3683ba40076a0',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 1855983,
          known_for_department: 'Visual Effects',
          name: 'Elizabeth Gray',
          original_name: 'Elizabeth Gray',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597338fdc3a3683c10007524',
          department: 'Visual Effects',
          job: 'Lead Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 1855985,
          known_for_department: 'Visual Effects',
          name: 'HyunKyung Jung',
          original_name: 'HyunKyung Jung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597339089251414fde032137',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1855986,
          known_for_department: 'Visual Effects',
          name: 'Adrian Lim',
          original_name: 'Adrian Lim',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733930c3a3686f7c04b17d',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1855990,
          known_for_department: 'Visual Effects',
          name: 'Nathaniel Seymour',
          original_name: 'Nathaniel Seymour',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733985c3a3686f7c04b21e',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1855991,
          known_for_department: 'Visual Effects',
          name: 'Divyesh Shah',
          original_name: 'Divyesh Shah',
          popularity: 0.6,
          profile_path: null,
          credit_id: '597339909251414fde032203',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1855994,
          known_for_department: 'Visual Effects',
          name: 'Mark Smith',
          original_name: 'Mark Smith',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733a00c3a3686fc7054764',
          department: 'Visual Effects',
          job: 'Lead Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 1855997,
          known_for_department: 'Editing',
          name: 'Clemence Gabrielidis',
          original_name: 'Clemence Gabrielidis',
          popularity: 0.98,
          profile_path: null,
          credit_id: '59733a7d9251414fde032397',
          department: 'Editing',
          job: 'Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1855999,
          known_for_department: 'Editing',
          name: 'Tom Isaac Scott',
          original_name: 'Tom Isaac Scott',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733a87c3a3683c1000779b',
          department: 'Editing',
          job: 'Assistant Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1856011,
          known_for_department: 'Crew',
          name: 'Cameron Brown',
          original_name: 'Cameron Brown',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jLEKQbppMDHeiFX23bxrcmT5dmh.jpg',
          credit_id: '59733babc3a36830fb0091b0',
          department: 'Crew',
          job: 'Motion Actor',
        },
        {
          adult: false,
          gender: 0,
          id: 1856017,
          known_for_department: 'Production',
          name: 'Ariane Cousi',
          original_name: 'Ariane Cousi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733bd192514112bb02ab66',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1856019,
          known_for_department: 'Directing',
          name: 'Marie Gennesseaux',
          original_name: 'Marie Gennesseaux',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733bdf9251414fde032534',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1856026,
          known_for_department: 'Crew',
          name: 'Kate Venables',
          original_name: 'Kate Venables',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59733c199251415e8604e3e8',
          department: 'Crew',
          job: 'Motion Actor',
        },
        {
          adult: false,
          gender: 2,
          id: 1884430,
          known_for_department: 'Camera',
          name: 'Vincent Richard-Marquis',
          original_name: 'Vincent Richard-Marquis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5b5ba160e73003ead0914',
          department: 'Camera',
          job: 'First Assistant "A" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1932922,
          known_for_department: 'Costume & Make-Up',
          name: 'Sarah Nakhle-Cerruti',
          original_name: 'Sarah Nakhle-Cerruti',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a216bdb0e0a264cc10a2b17',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1932924,
          known_for_department: 'Costume & Make-Up',
          name: 'Daniel Bihin',
          original_name: 'Daniel Bihin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a216c1692514103360a5ef5',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2083224,
          known_for_department: 'Camera',
          name: 'François Perrault-Alix',
          original_name: 'François Perrault-Alix',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5b552e18b97003c8a6147',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2146127,
          known_for_department: 'Production',
          name: 'Vincent Stevenel',
          original_name: 'Vincent Stevenel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c80666565a003cd5fcc0',
          department: 'Production',
          job: 'Production Accountant',
        },
        {
          adult: false,
          gender: 0,
          id: 2450742,
          known_for_department: 'Costume & Make-Up',
          name: 'Frédéric Tournant',
          original_name: 'Frédéric Tournant',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5b6f1d70594003e018bac',
          department: 'Costume & Make-Up',
          job: 'Costume Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2450816,
          known_for_department: 'Editing',
          name: 'Katie Jordan',
          original_name: 'Katie Jordan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c2365be00e003da203cc',
          department: 'Editing',
          job: 'Colorist',
        },
        {
          adult: false,
          gender: 2,
          id: 2501009,
          known_for_department: 'Art',
          name: 'Adrien Ernandez',
          original_name: 'Adrien Ernandez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c40931644b003ff9fb67',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 2,
          id: 2501018,
          known_for_department: 'Art',
          name: 'Simon Witte',
          original_name: 'Simon Witte',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c5dbcee48100432915c1',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 2,
          id: 2553002,
          known_for_department: 'Visual Effects',
          name: 'Ronan Binding',
          original_name: 'Ronan Binding',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e5a65d7357c00001926cac8',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 2705550,
          known_for_department: 'Production',
          name: 'Maël Marivint',
          original_name: 'Maël Marivint',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c76df14dad003ad1b7e7',
          department: 'Production',
          job: 'Production Accountant',
        },
        {
          adult: false,
          gender: 0,
          id: 2781966,
          known_for_department: 'Art',
          name: 'Norman Thaler',
          original_name: 'Norman Thaler',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c5b9f14dad003cd14de5',
          department: 'Art',
          job: 'Storyboard Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2909405,
          known_for_department: 'Lighting',
          name: 'Franck Bonomi',
          original_name: 'Franck Bonomi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5b486d70594003e018953',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2909406,
          known_for_department: 'Lighting',
          name: 'Remy Freess',
          original_name: 'Remy Freess',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5b4b1c7176d003f758d71',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2909407,
          known_for_department: 'Camera',
          name: 'Domitille Girard',
          original_name: 'Domitille Girard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5b4cd1ac292003ebb707b',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 0,
          id: 2909408,
          known_for_department: 'Camera',
          name: 'Maria Heras',
          original_name: 'Maria Heras',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5b4e770309f003d828707',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 0,
          id: 2909409,
          known_for_department: 'Lighting',
          name: 'Pascal Lombardo',
          original_name: 'Pascal Lombardo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5b4fe72d855003cc68800',
          department: 'Lighting',
          job: 'Rigging Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 2909410,
          known_for_department: 'Lighting',
          name: 'Strasser Matteo',
          original_name: 'Strasser Matteo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5b5125be00e003fa3807d',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2909411,
          known_for_department: 'Camera',
          name: 'Benoît Meignan',
          original_name: 'Benoît Meignan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5b52931644b003df91ef6',
          department: 'Camera',
          job: 'Second Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2909412,
          known_for_department: 'Lighting',
          name: 'Brice Pillot',
          original_name: 'Brice Pillot',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5b579d70594003d020b13',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2909414,
          known_for_department: 'Lighting',
          name: 'Eric Thurot',
          original_name: 'Eric Thurot',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5b5d7f14dad003ad19ede',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2909416,
          known_for_department: 'Costume & Make-Up',
          name: 'Marion Bugnon',
          original_name: 'Marion Bugnon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5b6ac160e73003dab2b7c',
          department: 'Costume & Make-Up',
          job: 'Seamstress',
        },
        {
          adult: false,
          gender: 0,
          id: 2909441,
          known_for_department: 'Art',
          name: 'Gilles Brette',
          original_name: 'Gilles Brette',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c336d705940040015070',
          department: 'Art',
          job: 'Construction Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2909442,
          known_for_department: 'Art',
          name: 'Alain Brion',
          original_name: 'Alain Brion',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c34c31644b0040fac273',
          department: 'Art',
          job: 'Conceptual Design',
        },
        {
          adult: false,
          gender: 0,
          id: 2909443,
          known_for_department: 'Art',
          name: 'Noémie Brunet',
          original_name: 'Noémie Brunet',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c36270309f003e8322a5',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2909444,
          known_for_department: 'Art',
          name: 'Pascal Casolari',
          original_name: 'Pascal Casolari',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c3851ac292003fba328e',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2909449,
          known_for_department: 'Art',
          name: 'Brynn Metheney',
          original_name: 'Brynn Metheney',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c55bcee48100402a16c9',
          department: 'Art',
          job: 'Concept Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2909450,
          known_for_department: 'Art',
          name: 'Elody Sermay',
          original_name: 'Elody Sermay',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c59a66565a003cd5fae9',
          department: 'Art',
          job: 'Assistant Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 2909457,
          known_for_department: 'Production',
          name: 'Alexandre Fournier Des Corats',
          original_name: 'Alexandre Fournier Des Corats',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c6ebd70594003e019ef8',
          department: 'Production',
          job: 'Production Accountant',
        },
        {
          adult: false,
          gender: 0,
          id: 2909460,
          known_for_department: 'Production',
          name: 'Tess Medina',
          original_name: 'Tess Medina',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c7dbd70594003e019fc7',
          department: 'Production',
          job: 'Production Secretary',
        },
        {
          adult: false,
          gender: 0,
          id: 2909464,
          known_for_department: 'Art',
          name: 'Aleth Galen',
          original_name: 'Aleth Galen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe5c8dde18b97003d8af4e2',
          department: 'Art',
          job: 'Sculptor',
        },
        {
          adult: false,
          gender: 1,
          id: 3146046,
          known_for_department: 'Production',
          name: 'Rachael Kent',
          original_name: 'Rachael Kent',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e234e927ff99005df84706',
          department: 'Production',
          job: 'Production Coordinator',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'tmdb15214618',
          author_details: {
            name: '',
            username: 'tmdb15214618',
            avatar_path: null,
            rating: 7.0,
          },
          content:
            "A spectacular spectacle of a movie that faithfully adapts a French 1970s sci-fi comic book. If you think you might see it some day, you owe it to yourself to catch it in 3D on a big screen now. In a world of paint-by-numbers blockbusters, this is an invigorating slap to the eyeballs.\r\n\r\nThe flick would benefit from more focus and deliberation; often, story beats are glancing blows instead  of precision hits. The biggest flaws, however, are found in the dialogue, which is at best serviceable and at times painful, probably owing to its transition through times, languages, and mediums.\r\n\r\nValerian isn't perfect, it's a bit clunky, but the sheer unusualness, whimsy, and wonder overpowers the movie's faults, making it well worth watching.",
          created_at: '2017-07-21T13:06:29.750Z',
          id: '5971fc55c3a368712803aa03',
          updated_at: '2021-06-23T15:57:59.419Z',
          url: 'https://www.themoviedb.org/review/5971fc55c3a368712803aa03',
        },
        {
          author: 'Movie Queen41',
          author_details: {
            name: '',
            username: 'Movie Queen41',
            avatar_path: null,
            rating: 6.0,
          },
          content:
            "It's a fun movie, but it's not what I would call a sci fi classic. It's all spectacle, with eye popping visuals. It creates some really interesting side characters and alien worlds. The drawback is the two leads. They seem rather bland and one dimensional. Their romantic bantering is quite boring. The supporting characters are more colorful and interesting. If you are a fan of Luc Besson's The Fifth Element, you will probably enjoy this. Just don't expect anything too deep from this movie.",
          created_at: '2017-07-22T05:47:36.465Z',
          id: '5972e6f8c3a3687c7d0225ed',
          updated_at: '2021-06-23T15:57:59.430Z',
          url: 'https://www.themoviedb.org/review/5972e6f8c3a3687c7d0225ed',
        },
        {
          author: 'Gimly',
          author_details: {
            name: 'Gimly',
            username: 'Ruuz',
            avatar_path: '/xUObnJSvHrFPsIpoDmb1jiQZLq7.jpg',
            rating: 5.0,
          },
          content:
            "Well, the scenes start comin' and they don't stop comin'. Aaaand that's basically the whole movie.\r\n\r\nNo, honestly by the end of it I was actually pretty on board. It took me a lot to get to that point though. The ham-fisted romance subplot they kept awkwardly grinding the movie to a standstill for was chief amongst the swill I felt I had to wade through to get to that point of enjoyment. The primary alien race being the most poorly animated was another. But somewhere between the Rhianna actually being bearable in this, and the Ethan Hawke character I want to see 500 more times, I did actually somewhat enjoy _Valerian_... Somewhat.\r\n\r\n_Final rating:★★½ - Had a lot that appealed to me, didn’t quite work as a whole._",
          created_at: '2017-11-28T01:58:09.180Z',
          id: '5a1cc2b1925141032405cc04',
          updated_at: '2021-06-23T15:58:03.003Z',
          url: 'https://www.themoviedb.org/review/5a1cc2b1925141032405cc04',
        },
        {
          author: 'Per Gunnar Jonsson',
          author_details: {
            name: 'Per Gunnar Jonsson',
            username: 'Dark Jedi',
            avatar_path:
              '/https://secure.gravatar.com/avatar/cbabaea0fa98692d00130498d7ac5d7c.jpg',
            rating: 10.0,
          },
          content:
            'I guess I am going to disagree both with the critics, wich of course is not at all unusual, as well as with a lot of the actual viewers of this movie by saying that I really liked this movie.\n\nI guess that I can to some extent understand that some viewers are disappointed. That would be the viewers that have read the comics that the movie is based on. Unfortunately someone in the production team decided to take bits and pieces from several comic books and mash them together as well as change some key elements. It is really annoying when that is done. It is usually an indication that somewhere some dumbass who did not understand, and certainly did not respect, the source material had way too much influence on the production. It is really a shame since the comic book from wich the core of the of the story seems to be taken is certainly more than good enough to stand on its own.\n\nWell luckily the mashup that they produced is actually bloody good. Something wich in my experience is quite rare. The Valerian comics lends themselves very well as a base for some spectacular sci-fi  with plenty of weird creatures and spectacular scenery. Add Luc Besson to the mix and you have to spell spectacular in all caps.\n\nThis is definitely a Luc Besson movie. Plenty of action, spectacular (yes I repeat myself but this movie deserves it) scenery, a fair amount of weirdness. In short a lot of stuff this particular viewer likes.\n\nThe mashed up story is not too bad. It is predictable as hell of course, even though it is not following the comics, but it is making a decent job of tying together all the action and FX and the action and FX is really the main reason to watch this movie after all.\nI have to say that I think most of the characters were pretty okay. It seems that the performance of the two main characters where generally not so well received by a lot of people. I guess I can somewhat understand that but I still cannot refrain from saying: Read the fucking comics! Okay it is a French comic and there are probably few people outside of France (or at least outside of Europe) that have read them. Me being one of the few of course. Anyway, Valerian and Laureline are supposed to be somewhat weird, silly and a little bit childish. Personally I think they did a fair job of interpreting the comic book characters the way they should be. We probably have Luc Besson to thank for not getting a some Hollywood, thirteen on a dozen, characters.\n\nI do miss some bits of the real comics though. The transmutation animal played a much more visible role in the comic and so did the three information peddlers wich gave a much more professional impression in the comic book by the way. I also think it was a shame that they changed the story of the Muh so much. Their role in the comic book was much more impressive to me.\n\nStill, most of the bits and pieces that is taken from the different comic books and mashed together are quite faithfully reproduced, at least visually and the results turned out really really good as far as I am concerned.\n\nTo wrap it up, to me, this movie was a fun, spectacular, action filled sci-fi extravaganza. A typical Luc Besson movie and I mean that in a good way.',
          created_at: '2017-12-18T20:28:36.807Z',
          id: '5a3824f4c3a36814ab06fc79',
          updated_at: '2021-06-23T15:58:03.477Z',
          url: 'https://www.themoviedb.org/review/5a3824f4c3a36814ab06fc79',
        },
        {
          author: 'melani',
          author_details: {
            name: '',
            username: 'melani',
            avatar_path: null,
            rating: 10.0,
          },
          content:
            'I like this Movie very much. It reminds a bit about Avatar & John Carter. I can not Understand why it did Not make it to the Australian Cinemas. For this type of High Budget it would be worth watching in 3D Cinemas.\r\nI gave it 10/10 **********',
          created_at: '2017-12-25T08:51:12.798Z',
          id: '5a40bc00925141740300d87e',
          updated_at: '2021-06-23T15:58:03.584Z',
          url: 'https://www.themoviedb.org/review/5a40bc00925141740300d87e',
        },
        {
          author: 'torysa',
          author_details: {
            name: '',
            username: 'torysa',
            avatar_path:
              '/https://secure.gravatar.com/avatar/07a277c7e6442a78329f48c2498e5b12.jpg',
            rating: 6.0,
          },
          content:
            "A disorrienting but somewhat delightful run through all manner of sci-fi imaginations. The Diễn viên was not good, and the storyline was sometimes incoherent, yet I have this strange urge to rewatch this thing. It's harmless, fascinating fun, in ways like the original starwars experience (though much more visually spectacular, and much less narratively coherent).",
          created_at: '2018-11-24T15:40:51.783Z',
          id: '5bf9710392514104d80146d7',
          updated_at: '2021-06-23T15:58:14.597Z',
          url: 'https://www.themoviedb.org/review/5bf9710392514104d80146d7',
        },
      ],
      total_pages: 1,
      total_results: 6,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/4kj2XoGln0X93EcEMaAHBcUJ6fn.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 28, name: 'Phim Hành Động' },
      { id: 12, name: 'Phim Phiêu Lưu' },
      { id: 36, name: 'Phim Lịch Sử' },
    ],
    homepage: '',
    id: 14539,
    imdb_id: 'tt1186803',
    original_language: 'zh',
    original_title: '江山美人',
    overview:
      'Câu truyện vào thời cổ đại khi Trung Quốc vẫn chưa thống nhất , là cuộc chiến tranh giành giữa vô số quốc gia . Yến Phi Nhi (Kelly Trần Tuệ Lâm) là người thừa kế vương vị khi phụ hoàng của cô chết trên sa trường . Phi Nhi cùng tướng quân trung thành Mộ Dung Thạch Hổ (Chân Tử Đơn) phải ra sức bảo vệ đát nước . Nhưng người anh họ tham vọng của cô Võ Ba đã cho sát thủ đến giế Phi Nhi. Một người đàn ông bí ẩn Doãn Lan Quân (Lê Minh) đã cứu Phi Nhi công chúa. Phi Nhi đã yêu Lan Quân . Nhưng Phi Nhi buộc phải lựa chọn giữa 1 bên là vận mệnh quốc gia và một bên là giấc mơ tự do.',
    popularity: 6.87,
    poster_path:
      'https://image.tmdb.org/t/p/w342/4vLNworV62WAunbiZy1LclRCrBm.jpg',
    production_companies: [
      {
        id: 21334,
        logo_path: null,
        name: 'Beijing Poly-bona Film Distribution Company',
        origin_country: '',
      },
      {
        id: 2269,
        logo_path: null,
        name: 'Trung Quốc Film Co-Production Corporation',
        origin_country: '',
      },
    ],
    production_countries: [
      { iso_3166_1: 'CN', name: 'Trung Quốc' },
      { iso_3166_1: 'HK', name: 'Hồng Kông' },
    ],
    release_date: '2008-02-09',
    revenue: 9323473,
    runtime: 99,
    spoken_languages: [
      { english_name: 'Mandarin', iso_639_1: 'zh', name: '普通话' },
      { english_name: 'Turkish', iso_639_1: 'tr', name: 'Türkçe' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Giang Sơn Mỹ Nhân',
    video: false,
    vote_average: 6.1,
    vote_count: 77,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'An Empress and the Warriors (2008) 1080p Trailer (Kelly Chen) (Mandarin audio, English subtitles)',
          key: 'LukpT0YG2_A',
          published_at: '2011-10-25T12:21:48.000Z',
          site: 'YouTube',
          size: 720,
          type: 'Trailer',
          official: false,
          id: '533ec677c3a36854480027bc',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Kingdom of War Trailer',
          key: 'MALVaxRBbUI',
          published_at: '2010-03-02T22:41:00.000Z',
          site: 'YouTube',
          size: 480,
          type: 'Trailer',
          official: false,
          id: '533ec677c3a36854480027bb',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 72730,
          known_for_department: 'Diễn viên',
          name: 'Kelly Chen',
          original_name: 'Kelly Chen',
          popularity: 1.052,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2m2mTNM8LxLPYyCQrgVZg93PR6j.jpg',
          cast_id: 2,
          character: 'Princess Yan Feier',
          credit_id: '52fe45fd9251416c7506963f',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 1341,
          known_for_department: 'Diễn viên',
          name: 'Donnie Yen',
          original_name: 'Donnie Yen',
          popularity: 13.894,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hTlhrrZMj8hZVvD17j4KyAFWBHc.jpg',
          cast_id: 1,
          character: 'General Muyong Xuehu',
          credit_id: '52fe45fd9251416c7506963b',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 66761,
          known_for_department: 'Diễn viên',
          name: 'Leon Lai',
          original_name: 'Leon Lai',
          popularity: 2.747,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fGlxNX2WozXLWiJC3d5jQ1NdRP1.jpg',
          cast_id: 3,
          character: 'Duan Lan Quan',
          credit_id: '52fe45fd9251416c75069643',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 116636,
          known_for_department: 'Diễn viên',
          name: 'Guo Xiaodong',
          original_name: 'Guo Xiaodong',
          popularity: 1.606,
          profile_path: null,
          cast_id: 5,
          character: 'Wu Ba',
          credit_id: '52fe45fd9251416c7506964d',
          order: 3,
        },
        {
          adult: false,
          gender: 0,
          id: 1174455,
          known_for_department: 'Diễn viên',
          name: 'Kau Jan-Hoi',
          original_name: 'Kau Jan-Hoi',
          popularity: 0.6,
          profile_path: null,
          cast_id: 6,
          character: 'Teng Bochang',
          credit_id: '52fe45fd9251416c75069651',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 1044559,
          known_for_department: 'Diễn viên',
          name: 'Zhang Shan',
          original_name: 'Zhang Shan',
          popularity: 0.6,
          profile_path: null,
          cast_id: 7,
          character: 'King Zhao Wu',
          credit_id: '52fe45fd9251416c75069655',
          order: 5,
        },
        {
          adult: false,
          gender: 0,
          id: 1174456,
          known_for_department: 'Diễn viên',
          name: 'Liu Wei-Hua',
          original_name: 'Liu Wei-Hua',
          popularity: 0.6,
          profile_path: null,
          cast_id: 8,
          character: 'King Yan',
          credit_id: '52fe45fd9251416c75069659',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 224927,
          known_for_department: 'Diễn viên',
          name: 'Chen Zhihui',
          original_name: 'Chen Zhihui',
          popularity: 1.096,
          profile_path:
            'https://image.tmdb.org/t/p/w185/srljsIgg5TPF52XIxG0BvPz7l97.jpg',
          cast_id: 20,
          character: 'Diao Erbao',
          credit_id: '59fe20a9c3a36868530256ee',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 1174458,
          known_for_department: 'Diễn viên',
          name: 'Yan Jie',
          original_name: 'Yan Jie',
          popularity: 1.099,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mmh8Z4F0ltRplpbTAbSsKdSGclW.jpg',
          cast_id: 11,
          character: 'Prince Zhao',
          credit_id: '52fe45fd9251416c75069665',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 1021201,
          known_for_department: 'Diễn viên',
          name: 'Zhou Bo',
          original_name: 'Zhou Bo',
          popularity: 0.694,
          profile_path: null,
          cast_id: 10,
          character: 'Ao Jia',
          credit_id: '52fe45fd9251416c75069661',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 1183808,
          known_for_department: 'Diễn viên',
          name: 'Zhang Jin',
          original_name: 'Zhang Jin',
          popularity: 6.357,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2i6nREFIyRYvIWxCBgWiarsGC1t.jpg',
          cast_id: 19,
          character: 'Assassin',
          credit_id: '591ef400c3a3687a4b0310d4',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 1436153,
          known_for_department: 'Diễn viên',
          name: 'Deng Limin',
          original_name: 'Deng Limin',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/BP2VOf7z6siJ3047ZyMSnWG5Oq.jpg',
          cast_id: 22,
          character: "Yan's deputy",
          credit_id: '5b7f57bcc3a3687e19002bf8',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 1092178,
          known_for_department: 'Diễn viên',
          name: 'Peng Bo',
          original_name: 'Peng Bo',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1mVgIiFr6pBgQLs5b82QpDo6sLO.jpg',
          cast_id: 23,
          character: "Yan's deputy",
          credit_id: '5b7f5936c3a3687e0a003222',
          order: 14,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 67259,
          known_for_department: 'Directing',
          name: 'Tony Ching Siu-Tung',
          original_name: 'Tony Ching Siu-Tung',
          popularity: 0.791,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iqw8vUPyZ5TMbk9G2XPYHTTyxZN.jpg',
          credit_id: '52fe45fd9251416c75069649',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 56808,
          known_for_department: 'Production',
          name: 'Claudie Chung Chun',
          original_name: 'Claudie Chung Chun',
          popularity: 1.38,
          profile_path: null,
          credit_id: '52fe45fd9251416c7506967d',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 57913,
          known_for_department: 'Camera',
          name: 'Zhao Xiaoding',
          original_name: 'Zhao Xiaoding',
          popularity: 0.6,
          profile_path: null,
          credit_id: '532ed9469251413a85003405',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 126805,
          known_for_department: 'Biên kịch',
          name: 'James Yuen',
          original_name: 'James Yuen',
          popularity: 1.286,
          profile_path: null,
          credit_id: '53a64b19c3a3687a40002548',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 577420,
          known_for_department: 'Biên kịch',
          name: 'Charcoal Tan',
          original_name: 'Charcoal Tan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe45fd9251416c75069671',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 1174459,
          known_for_department: 'Biên kịch',
          name: 'Chun Tin-Nam',
          original_name: 'Chun Tin-Nam',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe45fd9251416c75069677',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 1174460,
          known_for_department: 'Production',
          name: 'Don Yu Dong',
          original_name: 'Don Yu Dong',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe45fd9251416c75069683',
          department: 'Production',
          job: 'Producer',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path: null,
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 28, name: 'Phim Hành Động' },
      { id: 35, name: 'Phim Hài' },
      { id: 14, name: 'Phim Giả Tượng' },
    ],
    homepage: '',
    id: 628202,
    imdb_id: 'tt10720666',
    original_language: 'zh',
    original_title: '新封神之哪吒闹海',
    overview:
      'Thời nhà Thương thảo, Thần vị Thiên giới thiếu trống, Nhân gian ma quỷ lộng hành, Lê dân chịu vàn khổ cực. Trong đêm Trần Đường quan, Xà tinh Thạc Ty vào một hộ dân, đại khai sát giới,trong lúc cướp đi con nhỏ của nhà này, thì Lý Tịnh nghe tin xông tới, Kéo cung càn khôn bắn ba múi tên, mũi thứ ba bắn lật xà tinh, Xà tinh trọng thương độn thổ đi mất. Lý Tịnh không bắt đước xà tinh, nản lòng. Xà tinh trốn ở một chỗ trị thương ,trong lòng thù hận vô cùng , tìn thời cơ báo thù.',
    popularity: 3.44,
    poster_path:
      'https://image.tmdb.org/t/p/w342/hNf8rQoICiK0ujDhnBWStrXbsc1.jpg',
    production_companies: [],
    production_countries: [{ iso_3166_1: 'CN', name: 'Trung Quốc' }],
    release_date: '2019-05-14',
    revenue: 0,
    runtime: 95,
    spoken_languages: [
      { english_name: 'Mandarin', iso_639_1: 'zh', name: '普通话' },
    ],
    status: 'Đã phát hành',
    tagline: 'TÂN PHONG THẦN: NA TRA PHÁ HẢI',
    title: 'TÂN PHONG THẦN: NA TRA PHÁ HẢI',
    video: false,
    vote_average: 0.0,
    vote_count: 0,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: '新封神之哪吒闹海',
          key: '7_4RePCi4f8',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: false,
          published_at: '2019-05-13T15:04:17.000Z',
          id: '5d6dc72a65686e5b9b89e1cf',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 83487,
          known_for_department: 'Diễn viên',
          name: 'Tse Miu',
          original_name: 'Tse Miu',
          popularity: 8.809,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xdXmp28jBrv0r9FwLEKYTC36dnM.jpg',
          cast_id: 4,
          character: 'Nezha',
          credit_id: '5f2cd274cdbaff0036a32b07',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 544797,
          known_for_department: 'Diễn viên',
          name: 'Chin Siu-Ho',
          original_name: 'Chin Siu-Ho',
          popularity: 2.505,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6Xs2S8kF3pwDLXDmik02BwEmeCR.jpg',
          cast_id: 5,
          character: 'Li Jing',
          credit_id: '5f2cd287cdbaff0036a32b15',
          order: 4,
        },
        {
          adult: false,
          gender: 0,
          id: 2734017,
          known_for_department: 'Diễn viên',
          name: 'Kan Xin',
          original_name: 'Kan Xin',
          popularity: 0.6,
          profile_path: null,
          cast_id: 6,
          character: 'Lingzhu',
          credit_id: '5f2cd297afe2240037fc957d',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 2408613,
          known_for_department: 'Diễn viên',
          name: 'Li Xianshi',
          original_name: 'Li Xianshi',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/giD42kLyZM3ulNsNpxPRyqPZWOU.jpg',
          cast_id: 7,
          character: 'Cheng Lu',
          credit_id: '5f2cd2a2cdbaff0034a35950',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 2734018,
          known_for_department: 'Diễn viên',
          name: 'Fan Zi Qi',
          original_name: 'Fan Zi Qi',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wRfvzDRgCDhgGy6PCoN9Dz4v6gS.jpg',
          cast_id: 8,
          character: 'Shi Ji',
          credit_id: '5f2cd2aea9117f0036adecdd',
          order: 7,
        },
        {
          adult: false,
          gender: 0,
          id: 2734023,
          known_for_department: 'Diễn viên',
          name: 'Ji Zhao',
          original_name: 'Ji Zhao',
          popularity: 0.6,
          profile_path: null,
          cast_id: 10,
          character: 'Zhang Fenglei',
          credit_id: '5f2cd34da9117f0036aded80',
          order: 8,
        },
        {
          adult: false,
          gender: 1,
          id: 2734043,
          known_for_department: 'Diễn viên',
          name: 'Jessica Luk',
          original_name: 'Jessica Luk',
          popularity: 0.6,
          profile_path: null,
          cast_id: 11,
          character: '',
          credit_id: '5f2cd416596a910035faf303',
          order: 9,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 2402405,
          known_for_department: 'Directing',
          name: 'Luo Le',
          original_name: 'Luo Le',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d6dc60c65686e389987e78f',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2734020,
          known_for_department: 'Biên kịch',
          name: 'Xin Chen',
          original_name: 'Xin Chen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f2cd2e446e75f0039077d0c',
          department: 'Biên kịch',
          job: 'Writer',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/9OaIWmWI7Ph3jqj235zQIrh5yVd.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 35, name: 'Phim Hài' },
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 10749, name: 'Phim Lãng Mạn' },
    ],
    homepage: 'https://www.netflix.com/title/81056195',
    id: 652483,
    imdb_id: 'tt10731748',
    original_language: 'pt',
    original_title: 'Modo Avião',
    overview:
      'Gây ra vụ đâm xe vì mải nói chuyện điện thoại, cô nàng nổi tiếng Ana bị đưa đến trang trại của người đàn ông cục cằn - nơi cô buộc phải "kiêng" mạng và "kiêng" điện thoại.',
    popularity: 12.084,
    poster_path:
      'https://image.tmdb.org/t/p/w342/hDZBhyl83F07syVhQ0q21NBZSCC.jpg',
    production_companies: [
      { id: 112698, logo_path: null, name: 'A Fabrica', origin_country: 'BR' },
      { id: 129999, logo_path: null, name: 'Edge Films', origin_country: '' },
    ],
    production_countries: [{ iso_3166_1: 'BR', name: 'Brazil' }],
    release_date: '2020-01-23',
    revenue: 0,
    runtime: 96,
    spoken_languages: [
      { english_name: 'Italian', iso_639_1: 'it', name: 'Italiano' },
      { english_name: 'Portuguese', iso_639_1: 'pt', name: 'Português' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Chế Độ Máy Bay',
    video: false,
    vote_average: 6.3,
    vote_count: 619,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Airplane Mode | Official Trailer | Netflix',
          key: '2Jn3s33ca44',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: false,
          published_at: '2020-01-10T01:24:11.000Z',
          id: '5eefb3d52e2b2c00376d19d2',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 1073487,
          known_for_department: 'Diễn viên',
          name: 'Larissa Manoela',
          original_name: 'Larissa Manoela',
          popularity: 1.82,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rCsKkSHjJm4nOx1FiNSmJP4SxeY.jpg',
          cast_id: 18,
          character: 'Ana',
          credit_id: '5de2db9a4f5801000f01ea9d',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 1150967,
          known_for_department: 'Diễn viên',
          name: 'Erasmo Carlos',
          original_name: 'Erasmo Carlos',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oI3EW0nVUFx099XZ3xOnJzslOaD.jpg',
          cast_id: 19,
          character: 'Germano',
          credit_id: '5de2dbc10cd446001436d14c',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 2207669,
          known_for_department: 'Diễn viên',
          name: 'André Luiz Frambach',
          original_name: 'André Luiz Frambach',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rza8Eq9aJXrSNOYo8LTSu4ewKPl.jpg',
          cast_id: 20,
          character: 'João',
          credit_id: '5de2dbe4c51acd0013f83dd4',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 1161887,
          known_for_department: 'Diễn viên',
          name: 'Katiuscia Canoro',
          original_name: 'Katiuscia Canoro',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7hKuPRlTx5NA3TwUgDrThXyQ0JX.jpg',
          cast_id: 21,
          character: 'Carola',
          credit_id: '5de2dc070cd446001436d1b4',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 560263,
          known_for_department: 'Diễn viên',
          name: 'Danielle Ornelas',
          original_name: 'Danielle Ornelas',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8m0McvV4yTAU7nV0cRIQEbNLvY7.jpg',
          cast_id: 22,
          character: 'Antônia',
          credit_id: '5de2dc113faba000150bf639',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 1085278,
          known_for_department: 'Diễn viên',
          name: 'Sílvia Lourenço',
          original_name: 'Sílvia Lourenço',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uu1r60Q9N8eXhx0zVtLz4bdo3Xo.jpg',
          cast_id: 25,
          character: 'Laura',
          credit_id: '5e90edce15376c0015fcd18a',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 150494,
          known_for_department: 'Diễn viên',
          name: 'Michel Bercovitch',
          original_name: 'Michel Bercovitch',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2FWmZRKhXWwUwM1tno1uX6SDAfF.jpg',
          cast_id: 26,
          character: 'Inácio',
          credit_id: '5e90edd93679a100183709a2',
          order: 7,
        },
        {
          adult: false,
          gender: 1,
          id: 2597009,
          known_for_department: 'Diễn viên',
          name: 'Mariana Amâncio',
          original_name: 'Mariana Amâncio',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pQ8posK59JLEjF5m4fZFbtY8w8J.jpg',
          cast_id: 27,
          character: 'Rebeca',
          credit_id: '5e90ede715959f0012ee84ac',
          order: 8,
        },
        {
          adult: false,
          gender: 1,
          id: 2597014,
          known_for_department: 'Diễn viên',
          name: 'Nayobe Nzainab',
          original_name: 'Nayobe Nzainab',
          popularity: 0.6,
          profile_path: null,
          cast_id: 28,
          character: 'Julia',
          credit_id: '5e90ee318ec4ab001bf0ba57',
          order: 9,
        },
        {
          adult: false,
          gender: 0,
          id: 2597015,
          known_for_department: 'Diễn viên',
          name: 'Phellyx Moura',
          original_name: 'Phellyx Moura',
          popularity: 0.6,
          profile_path: null,
          cast_id: 29,
          character: 'Fausto',
          credit_id: '5e90ee3f15959f0014ee70e1',
          order: 10,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 92272,
          known_for_department: 'Camera',
          name: 'José Roberto Eliezer',
          original_name: 'José Roberto Eliezer',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2mNN4JtkTh0CMHeCpXrS3NkgsvP.jpg',
          credit_id: '5de2d6a73faba000130ad152',
          department: 'Crew',
          job: 'Cinematography',
        },
        {
          adult: false,
          gender: 2,
          id: 543378,
          known_for_department: 'Production',
          name: 'Luiz Noronha',
          original_name: 'Luiz Noronha',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5de2d6854f5801000f01e3c9',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 592438,
          known_for_department: 'Directing',
          name: 'César Rodrigues',
          original_name: 'César Rodrigues',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5de2d515c51acd0013f8325f',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1016218,
          known_for_department: 'Sound',
          name: 'Ricardo Cutz',
          original_name: 'Ricardo Cutz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5de2d80c0cd4460012373400',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1016218,
          known_for_department: 'Sound',
          name: 'Ricardo Cutz',
          original_name: 'Ricardo Cutz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5de2d7eda7e363001469421c',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 1,
          id: 1397428,
          known_for_department: 'Art',
          name: 'Marghe Pennacchi',
          original_name: 'Marghe Pennacchi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5de2d6e34f5801001601603e',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 2,
          id: 1478330,
          known_for_department: 'Biên kịch',
          name: 'Renato Fagundes',
          original_name: 'Renato Fagundes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5de2d5423faba000130aceb3',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 1703329,
          known_for_department: 'Biên kịch',
          name: 'Alberto Bremer',
          original_name: 'Alberto Bremer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5de2d5daa61de10013e4e39c',
          department: 'Biên kịch',
          job: 'Original Story',
        },
        {
          adult: false,
          gender: 2,
          id: 1720733,
          known_for_department: 'Directing',
          name: 'Leonardo Carvalho',
          original_name: 'Leonardo Carvalho',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5df0260dc5c1ef0013a0f844',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1756311,
          known_for_department: 'Sound',
          name: 'Matheus Miguens',
          original_name: 'Matheus Miguens',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5de2d7c3c51acd0011f89787',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1793644,
          known_for_department: 'Editing',
          name: 'Eduardo Hartung',
          original_name: 'Eduardo Hartung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5de2d6b23faba000130ad161',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1797712,
          known_for_department: 'Sound',
          name: 'Victor Quintanilha',
          original_name: 'Victor Quintanilha',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8EGl9LoEJ5vzqb6CaA9evl4UbyZ.jpg',
          credit_id: '5de2d79cc51acd0011f89771',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1859213,
          known_for_department: 'Sound',
          name: 'Tatiana Cantalejo',
          original_name: 'Tatiana Cantalejo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5de2d8560cd446001436ca67',
          department: 'Sound',
          job: 'Sound Assistant',
        },
        {
          adult: false,
          gender: 2,
          id: 2245203,
          known_for_department: 'Sound',
          name: 'Tiago Picado',
          original_name: 'Tiago Picado',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5de2d7a84f5801000f01e53c',
          department: 'Sound',
          job: 'Foley Recordist',
        },
        {
          adult: false,
          gender: 1,
          id: 2267160,
          known_for_department: 'Art',
          name: 'Mariana Hermann',
          original_name: 'Mariana Hermann',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5de2d6c0a61de10011e4b547',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 1,
          id: 2459843,
          known_for_department: 'Production',
          name: 'Ada Luisa Gomez',
          original_name: 'Ada Luisa Gomez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5de2d7633faba000190b53bb',
          department: 'Production',
          job: 'Location Manager',
        },
        {
          adult: false,
          gender: 1,
          id: 2471833,
          known_for_department: 'Art',
          name: 'Nina Meirelles',
          original_name: 'Nina Meirelles',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5de2d728c51acd0013f83541',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2519328,
          known_for_department: 'Biên kịch',
          name: 'Alice Name-Bomtempo',
          original_name: 'Alice Name-Bomtempo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e2b1449c56d2d00134a0752',
          department: 'Biên kịch',
          job: 'Writer',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path: null,
    belongs_to_collection: null,
    budget: 5,
    genres: [],
    homepage: '',
    id: 795370,
    imdb_id: null,
    original_language: 'vi',
    original_title: 'Bần',
    overview: 'Tại một quán cafe, Lộc không thể tìm thấy cái ví của mình.',
    popularity: 0.6,
    poster_path:
      'https://image.tmdb.org/t/p/w342/AoFM1h5nEYLOYm4SGQJZkxnfyOc.jpg',
    production_companies: [],
    production_countries: [],
    release_date: '2004-02-21',
    revenue: 0,
    runtime: 4,
    spoken_languages: [
      { english_name: 'Vietnamese', iso_639_1: 'vi', name: 'Tiếng Việt' },
    ],
    status: 'Đã phát hành',
    tagline: 'Nước chảy, cặc bần rung bây bẩy. Gió đưa, dái mít giãy tê tê.',
    title: 'Bần',
    video: false,
    vote_average: 0.0,
    vote_count: 0,
    videos: { results: [] },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 2772635,
          known_for_department: 'Directing',
          name: 'Trần Minh Hiếu',
          original_name: 'Trần Minh Hiếu',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rZbdGcwOh9elYX73uEuSPJBhUx3.jpg',
          cast_id: 1,
          character: 'Lộc',
          credit_id: '6023b7af9d2b63003e65ce6e',
          order: 1,
        },
        {
          adult: false,
          gender: 0,
          id: 2793983,
          known_for_department: 'Directing',
          name: 'namngbth',
          original_name: 'namngbth',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jG0OM46PNlGxXAOwXlQREmZPKh1.jpg',
          cast_id: 2,
          character: '',
          credit_id: '6023b7c5d6c30000416bab81',
          order: 2,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 2772635,
          known_for_department: 'Directing',
          name: 'Trần Minh Hiếu',
          original_name: 'Trần Minh Hiếu',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rZbdGcwOh9elYX73uEuSPJBhUx3.jpg',
          credit_id: '6023b83f0e597b003ca82097',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 2772635,
          known_for_department: 'Directing',
          name: 'Trần Minh Hiếu',
          original_name: 'Trần Minh Hiếu',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rZbdGcwOh9elYX73uEuSPJBhUx3.jpg',
          credit_id: '6023b82bbc2cb30040a29683',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 2772635,
          known_for_department: 'Directing',
          name: 'Trần Minh Hiếu',
          original_name: 'Trần Minh Hiếu',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rZbdGcwOh9elYX73uEuSPJBhUx3.jpg',
          credit_id: '6023b84ec0ae36003c5893a2',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2793983,
          known_for_department: 'Directing',
          name: 'namngbth',
          original_name: 'namngbth',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jG0OM46PNlGxXAOwXlQREmZPKh1.jpg',
          credit_id: '6023b86abc2cb3003da30dae',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2793983,
          known_for_department: 'Directing',
          name: 'namngbth',
          original_name: 'namngbth',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jG0OM46PNlGxXAOwXlQREmZPKh1.jpg',
          credit_id: '6023b85ec669ad003ec3a005',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 2793983,
          known_for_department: 'Directing',
          name: 'namngbth',
          original_name: 'namngbth',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jG0OM46PNlGxXAOwXlQREmZPKh1.jpg',
          credit_id: '6023b872149565004174b466',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2793983,
          known_for_department: 'Directing',
          name: 'namngbth',
          original_name: 'namngbth',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jG0OM46PNlGxXAOwXlQREmZPKh1.jpg',
          credit_id: '6023b87bc5ada5003e7e0abe',
          department: 'Biên kịch',
          job: 'Writer',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/nN4Gs3vZAOJ1D6FRtrwbU9VGYwU.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 16, name: 'Phim Hoạt Hình' },
      { id: 10749, name: 'Phim Lãng Mạn' },
      { id: 10751, name: 'Phim Gia Đình' },
    ],
    homepage: '',
    id: 486589,
    imdb_id: 'tt4429160',
    original_language: 'en',
    original_title: 'Red Shoes and the Seven Dwarfs',
    overview:
      '7 chàng hoàng tử vì bị phù phép mà biến thành 7 chú lùn da xanh. Muốn hóa giải lời nguyền ác độc này, họ phải có được tình yêu chân thành từ cô gái mang đôi hài đỏ xinh đẹp nhất trần đời. Đến một ngày, nàng Hài Đỏ đã tìm đến ngôi nhà của 7 chú lùn, nhưng việc hóa giải lời nguyền lại không đơn giản đến thế…',
    popularity: 94.088,
    poster_path:
      'https://image.tmdb.org/t/p/w342/fV7ehJEjFiQlljrDhfknEDxELCU.jpg',
    production_companies: [
      {
        id: 3657,
        logo_path: '/2YXnZa6yPjxdHKzBLgmf57D8QpM.png',
        name: 'Sidus',
        origin_country: 'KR',
      },
      {
        id: 20064,
        logo_path: '/2In7Heq6DuXDjOwPmJqHWkpohaL.png',
        name: 'Next Entertainment World',
        origin_country: 'KR',
      },
      {
        id: 121669,
        logo_path: null,
        name: 'Locus Creative Studios',
        origin_country: '',
      },
    ],
    production_countries: [{ iso_3166_1: 'KR', name: 'South Korea' }],
    release_date: '2019-07-25',
    revenue: 10054356,
    runtime: 92,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'Khi cổ tích bị đảo lộn',
    title: 'Hài Đỏ & Bảy Chú Lùn',
    video: false,
    vote_average: 7.8,
    vote_count: 823,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Official Trailer',
          key: 'NB3mZMyxcM0',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2020-08-06T16:00:07.000Z',
          id: '5f2e3846f48b340038af613b',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 56734,
          known_for_department: 'Diễn viên',
          name: 'Chloë Grace Moretz',
          original_name: 'Chloë Grace Moretz',
          popularity: 59.721,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yq4rYmaTRC5degaOYmJQFpaiho1.jpg',
          cast_id: 0,
          character: 'Snow White (voice)',
          credit_id: '5a079fa2c3a36833ee008480',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 237455,
          known_for_department: 'Diễn viên',
          name: 'Sam Claflin',
          original_name: 'Sam Claflin',
          popularity: 4.72,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5DtmRlRZc7wPbat1INQPqsxaH4a.jpg',
          cast_id: 1,
          character: 'Merlin (voice)',
          credit_id: '5a079faec3a36833ee008492',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 11150,
          known_for_department: 'Diễn viên',
          name: 'Gina Gershon',
          original_name: 'Gina Gershon',
          popularity: 12.151,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tpx72NUZwxZlcUgqWRxwbpvJjYo.jpg',
          cast_id: 2,
          character: 'The Evil Queen (voice)',
          credit_id: '5a079fb89251414c19008292',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 9657,
          known_for_department: 'Diễn viên',
          name: 'Patrick Warburton',
          original_name: 'Patrick Warburton',
          popularity: 7.799,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eLqDtbFYmlTxov9vT9Dwldn839v.jpg',
          cast_id: 5,
          character: 'Magic Mirror (voice)',
          credit_id: '5a07a0fbc3a36834060088f3',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 161932,
          known_for_department: 'Diễn viên',
          name: 'Jim Rash',
          original_name: 'Jim Rash',
          popularity: 2.674,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cXat9HZ5ajQZsrAZ8xE4zIEVEcb.jpg',
          cast_id: 3,
          character: 'Prince Average (voice)',
          credit_id: '5a079fbe9251414c1900829e',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 1234388,
          known_for_department: 'Diễn viên',
          name: 'Simon Kassianides',
          original_name: 'Simon Kassianides',
          popularity: 1.214,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3CyrW8ZRsXvBw0ogXHuxnArz7Dt.jpg',
          cast_id: 22,
          character: 'Arthur (voice)',
          credit_id: '5eda3c104d6791001ea6ff0f',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 2666664,
          known_for_department: 'Diễn viên',
          name: 'Frederik Hamel',
          original_name: 'Frederik Hamel',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wXAvCMC2I8dOayUZNSNwGFM1QiN.jpg',
          cast_id: 23,
          character: 'Jack (voice)',
          credit_id: '5eda3c2921c4ca0021e88c93',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 19508,
          known_for_department: 'Diễn viên',
          name: 'Nolan North',
          original_name: 'Nolan North',
          popularity: 2.527,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gb499KZIoBTZnKCGKE4zwzlcfSe.jpg',
          cast_id: 20,
          character: 'Hans/Twin Guards/King White (voice)',
          credit_id: '5e9f864f07faa20020f9b216',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 2263505,
          known_for_department: 'Diễn viên',
          name: 'Frank Todaro',
          original_name: 'Frank Todaro',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vuHWWdSF4pRrZkG6rxgTNx2y557.jpg',
          cast_id: 24,
          character: 'Pino / Noki / Kio (voice)',
          credit_id: '5eda3fe581a7fc001ecff909',
          order: 8,
        },
        {
          adult: false,
          gender: 1,
          id: 1508532,
          known_for_department: 'Diễn viên',
          name: 'Ava Kolker',
          original_name: 'Ava Kolker',
          popularity: 2.989,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qfuE5b4PNwVHKi1TweMIRdRwzx7.jpg',
          cast_id: 25,
          character: 'Wooden Bear 1 (voice)',
          credit_id: '5eda4014b3f6f50020987453',
          order: 9,
        },
        {
          adult: false,
          gender: 0,
          id: 1523670,
          known_for_department: 'Diễn viên',
          name: 'Asher Blinkoff',
          original_name: 'Asher Blinkoff',
          popularity: 2.481,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jMGlMK31z98DOVU9Yh1yruo6Zp8.jpg',
          cast_id: 26,
          character: 'Wooden Bear 2 (voice)',
          credit_id: '5eda4398b3f6f5002297a047',
          order: 10,
        },
        {
          adult: false,
          gender: 1,
          id: 2425569,
          known_for_department: 'Diễn viên',
          name: 'Juju Journey Brener',
          original_name: 'Juju Journey Brener',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ftCiijdwW7R2p8NTe4OKhXY3Kss.jpg',
          cast_id: 27,
          character: 'Wooden Bear 3 (voice)',
          credit_id: '5eda43c821c4ca001fe42b7a',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 1386148,
          known_for_department: 'Diễn viên',
          name: 'Brian T. Delaney',
          original_name: 'Brian T. Delaney',
          popularity: 1.805,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zzkAnz4HcnUIDJKTxuL0HS7uHk2.jpg',
          cast_id: 28,
          character: 'Big Bunny / Sculpter (voice)',
          credit_id: '5eda440096e30b002298410a',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 1449707,
          known_for_department: 'Diễn viên',
          name: 'Piotr Michael',
          original_name: 'Piotr Michael',
          popularity: 2.743,
          profile_path:
            'https://image.tmdb.org/t/p/w185/g86nUW1Yvx5RKEiYrw8NuKvtO66.jpg',
          cast_id: 29,
          character: 'Soldier A (voice)',
          credit_id: '5eda45481b157d001e59c5e6',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 1178795,
          known_for_department: 'Diễn viên',
          name: 'Ben Diskin',
          original_name: 'Ben Diskin',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4RWjcrPgfTG1yp19kFKRZYimv2B.jpg',
          cast_id: 30,
          character: 'Soldier B (voice)',
          credit_id: '5eda45651b157d001e59c62b',
          order: 14,
        },
        {
          adult: false,
          gender: 1,
          id: 116315,
          known_for_department: 'Diễn viên',
          name: 'Kari Wahlgren',
          original_name: 'Kari Wahlgren',
          popularity: 4.516,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9phhl0oubAKt8D50xLGAb81KPSb.jpg',
          cast_id: 21,
          character: 'Additional Voices (voice)',
          credit_id: '5e9f86d307faa20024f9b76a',
          order: 15,
        },
        {
          adult: false,
          gender: 1,
          id: 186605,
          known_for_department: 'Production',
          name: 'Terri Douglas',
          original_name: 'Terri Douglas',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6yRCc5oKalchZuRvVJJbEDNmLEd.jpg',
          cast_id: 31,
          character: 'Additional Voices (voice)',
          credit_id: '5eda45bb4d6791001ca6b23d',
          order: 16,
        },
        {
          adult: false,
          gender: 1,
          id: 1354657,
          known_for_department: 'Diễn viên',
          name: 'Amanda Troop',
          original_name: 'Amanda Troop',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oIiz7YCwDCphqCWNA6zUzl30WQ9.jpg',
          cast_id: 32,
          character: 'Additional Voices (voice)',
          credit_id: '5eda45df21c4ca0021e89d75',
          order: 17,
        },
        {
          adult: false,
          gender: 1,
          id: 2666680,
          known_for_department: 'Diễn viên',
          name: 'Katie DiCicco',
          original_name: 'Katie DiCicco',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7HFInw7V2Bt36aOCXjrh0qB0YMw.jpg',
          cast_id: 33,
          character: 'Dorothy Gale (voice)',
          credit_id: '5eda45f94d6791001da79f92',
          order: 18,
        },
        {
          adult: false,
          gender: 0,
          id: 2719014,
          known_for_department: 'Diễn viên',
          name: 'Thibaut Belfodil',
          original_name: 'Thibaut Belfodil',
          popularity: 0.6,
          profile_path: null,
          cast_id: 34,
          character: '',
          credit_id: '5f16f8be51e6ab0038cbe46e',
          order: 19,
        },
        {
          adult: false,
          gender: 0,
          id: 2719023,
          known_for_department: 'Diễn viên',
          name: 'Julien Allouf',
          original_name: 'Julien Allouf',
          popularity: 0.6,
          profile_path: null,
          cast_id: 35,
          character: '',
          credit_id: '5f16fa2f28723c0037d598d1',
          order: 20,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 17767,
          known_for_department: 'Sound',
          name: 'Geoff Zanelli',
          original_name: 'Geoff Zanelli',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lACUhRiyPMhNwz2S58ZDRR0eeQH.jpg',
          credit_id: '5e2b7d1a532acb0015518a39',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 2,
          id: 61419,
          known_for_department: 'Production',
          name: 'Matthew Jon Beck',
          original_name: 'Matthew Jon Beck',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e2b7d2898f1f10012f8b335',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 1273447,
          known_for_department: 'Directing',
          name: 'Jang Moo-hyun',
          original_name: 'Jang Moo-hyun',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e2b7c53688cd00017c7b628',
          department: 'Directing',
          job: 'Co-Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1615783,
          known_for_department: 'Visual Effects',
          name: 'Jin Kim',
          original_name: 'Jin Kim',
          popularity: 0.731,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yD5UpN5ieLZ8SJKqwaGYNlLcqbI.jpg',
          credit_id: '60e5f82e4d67910046b558d9',
          department: 'Visual Effects',
          job: 'Animation Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1854967,
          known_for_department: 'Production',
          name: 'Micah Dahlberg',
          original_name: 'Micah Dahlberg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e2b7d311fb94f001535ce69',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 1922138,
          known_for_department: 'Directing',
          name: 'Hong Sung-ho',
          original_name: 'Hong Sung-ho',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6kthKm6I2bCRBX1NNXYAADnH9C1.jpg',
          credit_id: '5a079fec9251414bce0085ac',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1922138,
          known_for_department: 'Directing',
          name: 'Hong Sung-ho',
          original_name: 'Hong Sung-ho',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6kthKm6I2bCRBX1NNXYAADnH9C1.jpg',
          credit_id: '5d1caae7283ed9000f185f87',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 2078570,
          known_for_department: 'Production',
          name: 'Myun Young Jung',
          original_name: 'Myun Young Jung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e2b7ce998f1f10012f8b2b3',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2519593,
          known_for_department: 'Directing',
          name: 'Uhm Young Sik',
          original_name: 'Uhm Young Sik',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e2b7c74532acb00135183b5',
          department: 'Directing',
          job: 'Co-Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2519597,
          known_for_department: 'Crew',
          name: 'Juliano SungPil Choi',
          original_name: 'Juliano SungPil Choi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e2b7ccb98f1f10014f9244f',
          department: 'Crew',
          job: 'Post-Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 2519598,
          known_for_department: 'Production',
          name: 'Sujin Hwang',
          original_name: 'Sujin Hwang',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e2b7cd7532acb001351842d',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2519600,
          known_for_department: 'Production',
          name: 'HyungSoon Kim',
          original_name: 'HyungSoon Kim',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e2b7cfa688cd00017c7b740',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2519601,
          known_for_department: 'Production',
          name: 'Yoona Ko',
          original_name: 'Yoona Ko',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e2b7d051685da0011e5b6d1',
          department: 'Production',
          job: 'Line Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2519602,
          known_for_department: 'Art',
          name: 'Jung ChiYeol',
          original_name: 'Jung ChiYeol',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e2b7d4e688cd00013c7a052',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 2519603,
          known_for_department: 'Art',
          name: 'Lee SeoKi',
          original_name: 'Lee SeoKi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e2b7d5e1685da0017e61866',
          department: 'Art',
          job: 'Art Direction',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/yo6p0c9p1CAc3hMWpIuePqrhWM9.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [{ id: 10749, name: 'Phim Lãng Mạn' }],
    homepage: '',
    id: 539699,
    imdb_id: 'tt10915948',
    original_language: 'vi',
    original_title: 'Em Gái Mưa',
    overview:
      'Câu chuyện lấy bối cảnh những năm đầu 2000 về Nguyễn Hà Vy, cô nữ sinh lớp 12A1 trường trung học Thanh Xuân tưởng chừng như sẽ "kết thúc hời học sinh trong nhạt nhẽo" mà không có lấy cho riêng mình một “kỷ niệm sâu sắc” nào thì bỗng gặp được thầy Minh Vũ trong đoàn giáo sinh đến trường thực tập.',
    popularity: 0.602,
    poster_path:
      'https://image.tmdb.org/t/p/w342/rvXlk4A5h20kee1ViNn4BtHdQxj.jpg',
    production_companies: [],
    production_countries: [{ iso_3166_1: 'VN', name: 'Vietnam' }],
    release_date: '2018-01-06',
    revenue: 0,
    runtime: 102,
    spoken_languages: [
      { english_name: 'Vietnamese', iso_639_1: 'vi', name: 'Tiếng Việt' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Em Gái Mưa',
    video: false,
    vote_average: 0.0,
    vote_count: 0,
    videos: { results: [] },
    credits: {
      cast: [
        {
          adult: false,
          gender: 0,
          id: 1587520,
          known_for_department: 'Diễn viên',
          name: 'Thùy Linh',
          original_name: 'Thùy Linh',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kVznWpyhr1biw9XMhE0CIdFmhF7.jpg',
          cast_id: 0,
          character: 'Hạ Vy',
          credit_id: '5b626cef92514140600231ba',
          order: 1,
        },
        {
          adult: false,
          gender: 0,
          id: 2097813,
          known_for_department: 'Diễn viên',
          name: 'Mai Tài Phến',
          original_name: 'Mai Tài Phến',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bBSI8gCbzBeOjgX1MauWafEogFV.jpg',
          cast_id: 1,
          character: 'Minh Vũ',
          credit_id: '5b626cfec3a368189402b87d',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 2040628,
          known_for_department: 'Diễn viên',
          name: 'Phương Anh Đào',
          original_name: 'Phương Anh Đào',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gnbYK8XXL87WHzFmDtLUUmf7Kpm.jpg',
          cast_id: 2,
          character: 'Thảo Ly',
          credit_id: '5b626e140e0a267ef4024dd5',
          order: 3,
        },
        {
          adult: false,
          gender: 0,
          id: 2097816,
          known_for_department: 'Diễn viên',
          name: 'Tiến Vũ',
          original_name: 'Tiến Vũ',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/f2OAMSw9aJZGlaC2utLalOENQ0Q.jpg',
          cast_id: 3,
          character: 'Bảo',
          credit_id: '5b626e5592514140680232da',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 1594383,
          known_for_department: 'Diễn viên',
          name: 'Việt Hương',
          original_name: 'Việt Hương',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9v9E5OM91kILN7zkkE2pBSRNHbZ.jpg',
          cast_id: 4,
          character: 'Minh Châu',
          credit_id: '5b626e680e0a267ee7026774',
          order: 5,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 0,
          id: 2097818,
          known_for_department: 'Directing',
          name: 'Kawaii Tuấn Anh',
          original_name: 'Kawaii Tuấn Anh',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5b626e7c0e0a267ee702678c',
          department: 'Directing',
          job: 'Director',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path: null,
    belongs_to_collection: {
      id: 600094,
      name: 'The Incredible Monk Collection',
      poster_path: '/yRWGKYRiMkuuodXS8lJinOCb5h9.jpg',
      backdrop_path: null,
    },
    budget: 0,
    genres: [
      { id: 35, name: 'Phim Hài' },
      { id: 14, name: 'Phim Giả Tượng' },
    ],
    homepage: '',
    id: 543616,
    imdb_id: null,
    original_language: 'zh',
    original_title: '济公之神龙再现',
    overview:
      'Tướng quân Cao Nhân Kiệt chính là danh tiếng triều đình, đã tham gia nhiều trận lớn nhỏ và giành nhiều chiến thắng, lập được không ít công lao hiển hách, trở thành người anh hùng dân tộc. Cao Bân và Tự Thiếu phải lòng thanh mai trúc mã Phượng Nghi, nhưng ý trời lại lệnh Phượng Nghi bị ép phải xuống biển làm kỹ nữ. Cao Nhân Kiệt yêu Phượng Nghi, lại bị mọi người chỉ trích lại không dám cưới Phượng Nghi làm thê tử. Cao Nhân Kiệt cầu Tế Công giúp, Tế Công trải qua bao nhiêu khó khăn, thề phải làm mối cho hai người mệnh khổ này! Khi tất cả đã thành công, thuộc hạ của Cao lại hạ độc thủ, giết chết Phượng Nghi, muốn Cao Nhân Kiệt quên đi tình cảm trai gái, dốc lòng vì nước vì dân. Tế Công phẫn nộ, oán hận ông trời vì sao lại chia cách uyên ương? Lẽ trời ở đâu? Giận dữ biến thành rồng thần, thề phải thay đổi vận mệnh, đi ngượi thiên ý, trực tiếp đi xuống địa phủ, chiến đầu chống lại các linh hồn tà ác, cướp lại nguyên thần của Phượng Nghi',
    popularity: 1.272,
    poster_path:
      'https://image.tmdb.org/t/p/w342/ckWWOU1ybeqZ8SaeZguwdCc2glN.jpg',
    production_companies: [
      {
        id: 74307,
        logo_path: null,
        name: 'iQiyi Motion Pictures',
        origin_country: 'CN',
      },
    ],
    production_countries: [{ iso_3166_1: 'CN', name: 'Trung Quốc' }],
    release_date: '2018-08-09',
    revenue: 0,
    runtime: 100,
    spoken_languages: [
      { english_name: 'Mandarin', iso_639_1: 'zh', name: '普通话' },
    ],
    status: 'Đã phát hành',
    tagline:
      'Tế Công, Tế Công2, Thần Long Tái Xuất, The Incredible Monk, Dragon Return',
    title: 'Tế Công 2: Thần Long Tái Xuất',
    video: false,
    vote_average: 0.0,
    vote_count: 0,
    videos: { results: [] },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 1314817,
          known_for_department: 'Diễn viên',
          name: 'Chan Ho-Man',
          original_name: 'Chan Ho-Man',
          popularity: 2.818,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cGNOprzxJntHcg6db0HZOdyCZX8.jpg',
          cast_id: 2,
          character: 'Ji Gong',
          credit_id: '5c64b6f10e0a2625d1971aea',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 545277,
          known_for_department: 'Diễn viên',
          name: 'Lam Tze-chung',
          original_name: 'Lam Tze-chung',
          popularity: 1.795,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ipqqly0bvP7SIl0840m50VXsIKY.jpg',
          cast_id: 3,
          character: 'He Shang',
          credit_id: '5c64b92792514177bdfba676',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 1828892,
          known_for_department: 'Diễn viên',
          name: 'Sun Mingming',
          original_name: 'Sun Mingming',
          popularity: 0.6,
          profile_path: null,
          cast_id: 4,
          character: '',
          credit_id: '5c64b93b0e0a267b90966580',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 2029799,
          known_for_department: 'Diễn viên',
          name: 'Joe Hsieh',
          original_name: 'Joe Hsieh',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ul3jWlglYrDgyKgcMi5qpptNhD9.jpg',
          cast_id: 5,
          character: 'General Gao Renjie',
          credit_id: '5c64b999c3a3684cecd73172',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 1615350,
          known_for_department: 'Diễn viên',
          name: 'Jin Gang',
          original_name: 'Jin Gang',
          popularity: 0.857,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hBYAhCU8Zms7z1rH3CWcUGdMADW.jpg',
          cast_id: 6,
          character: '',
          credit_id: '5c64ba039251412fbfff423a',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 2799133,
          known_for_department: 'Diễn viên',
          name: 'Zhang Yiqian',
          original_name: 'Zhang Yiqian',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ge6EIJne0EB8ho3WCIcgUZWdUqU.jpg',
          cast_id: 13,
          character: 'Little Devil',
          credit_id: '619b7478e2ff320065957baa',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 1173223,
          known_for_department: 'Diễn viên',
          name: 'Danny Chan Kwok-kwan',
          original_name: 'Danny Chan Kwok-kwan',
          popularity: 9.101,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hkHu1Z4EtN47bPwh6PlBIE3Jz76.jpg',
          cast_id: 10,
          character: 'Fu Hu',
          credit_id: '5c64bb97c3a36847bbd71f88',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 548474,
          known_for_department: 'Biên kịch',
          name: 'Wong Jing',
          original_name: 'Wong Jing',
          popularity: 3.543,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gMmaDRst3OwnY1wClKt541AmslD.jpg',
          cast_id: 11,
          character: 'Jade Emperor',
          credit_id: '5c64bba69251417aa2fba492',
          order: 7,
        },
        {
          adult: false,
          gender: 0,
          id: 2100996,
          known_for_department: 'Diễn viên',
          name: 'Yang Neng',
          original_name: 'Yang Neng',
          popularity: 1.4,
          profile_path: null,
          cast_id: 12,
          character: '',
          credit_id: '5c64bbf7c3a3684cecd735c3',
          order: 8,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 545277,
          known_for_department: 'Diễn viên',
          name: 'Lam Tze-chung',
          original_name: 'Lam Tze-chung',
          popularity: 1.795,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ipqqly0bvP7SIl0840m50VXsIKY.jpg',
          credit_id: '5c64ba910e0a266dac9a962b',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 545277,
          known_for_department: 'Diễn viên',
          name: 'Lam Tze-chung',
          original_name: 'Lam Tze-chung',
          popularity: 1.795,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ipqqly0bvP7SIl0840m50VXsIKY.jpg',
          credit_id: '5c64baa00e0a267b9096680d',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 1314817,
          known_for_department: 'Diễn viên',
          name: 'Chan Ho-Man',
          original_name: 'Chan Ho-Man',
          popularity: 2.818,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cGNOprzxJntHcg6db0HZOdyCZX8.jpg',
          credit_id: '5c64bb27925141250aff013b',
          department: 'Production',
          job: 'Producer',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/1R8DAnrfryNkNmHn1U2SvBzeBc.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 28, name: 'Phim Hành Động' },
      { id: 53, name: 'Phim Gây Cấn' },
    ],
    homepage: 'http://www.echelonconspiracy.com/',
    id: 16325,
    imdb_id: 'tt1124039',
    original_language: 'en',
    original_title: 'Echelon Conspiracy',
    overview:
      'Trong chuyến công tác tại Thái Lan, Max Peterson, một kỹ sư tin học tình cờ nhân được một thùng đồ. Trong đó là một điện thoại công nghệ mới hiện đại và có khả năng "tư duy" khi luôn đưa ra những sự thật của “tương lai". Với cái phone trời cho, Max đã vào sòng bài lớn nhất nước Nga và toàn thắng. Thậm chí anh còn thắng được giải thưởng lớn nhất trị giá 3 triệu USD. Tuy nhiên, mọi hành động của anh đều bị FBI và thế lực sau lưng chú ý. Max hoàn toàn không biết mình chỉ là 1 nạn nhân kiếm tiền của người đứng sau hê thống thông minh. Hệ thống này đã lợi dụng sự bảo mật lỏng lẽo của cổng thông tin Hoa Kỳ. Khi mà mọi thông tin và hoạt động của con người đều được đưa vào máy tính một cách bí mật. Bằng sự quản lý của computer, họ dần mất đi quyền tự chủ và tự do của chính mình...',
    popularity: 14.275,
    poster_path:
      'https://image.tmdb.org/t/p/w342/eQgT8kdjWJots3dX5Xy11le2vHk.jpg',
    production_companies: [
      {
        id: 1786,
        logo_path: '/joLFuCWg9e2lweYnFQtRPJKSLlI.png',
        name: 'Dark Castle Entertainment',
        origin_country: 'US',
      },
      {
        id: 11640,
        logo_path: null,
        name: 'Mobicom Entertainment',
        origin_country: '',
      },
      {
        id: 8935,
        logo_path: null,
        name: 'Zinc Entertainment Inc.',
        origin_country: '',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2009-02-27',
    revenue: 2186782,
    runtime: 105,
    spoken_languages: [
      { english_name: 'Russian', iso_639_1: 'ru', name: 'Pусский' },
      { english_name: 'Hungarian', iso_639_1: 'hu', name: 'Magyar' },
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'Security comes at a price...',
    title: 'Học Thuyết Khủng Bố',
    video: false,
    vote_average: 6.3,
    vote_count: 342,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Gift (aka Echelon Conspiracy) Trailer [HQ]',
          key: 'UVEusP3F_V0',
          published_at: '2012-06-01T16:48:08.000Z',
          site: 'YouTube',
          size: 720,
          type: 'Trailer',
          official: false,
          id: '533ec67ac3a3685448002b61',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 81295,
          known_for_department: 'Diễn viên',
          name: 'Shane West',
          original_name: 'Shane West',
          popularity: 3.063,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rt1G1bdjgQe6NEIWiNu7iVqhNKG.jpg',
          cast_id: 1,
          character: 'Max Peterson',
          credit_id: '52fe46c69251416c750831e7',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 12833,
          known_for_department: 'Diễn viên',
          name: 'Edward Burns',
          original_name: 'Edward Burns',
          popularity: 3.396,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pTLdPUSxDUcdmvy91LGCF3pk0AM.jpg',
          cast_id: 2,
          character: 'John Reed',
          credit_id: '52fe46c69251416c750831eb',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 10182,
          known_for_department: 'Diễn viên',
          name: 'Ving Rhames',
          original_name: 'Ving Rhames',
          popularity: 31.164,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4gpLVNKPZlVucc4fT2fSZ7DksTK.jpg',
          cast_id: 3,
          character: 'Agent Dave Grant',
          credit_id: '52fe46c69251416c750831ef',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 8349,
          known_for_department: 'Diễn viên',
          name: 'Martin Sheen',
          original_name: 'Martin Sheen',
          popularity: 5.82,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eANpr603scA1jfR6aOh42YqSke7.jpg',
          cast_id: 4,
          character: 'Raymond Burke',
          credit_id: '52fe46c69251416c750831f3',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 80371,
          known_for_department: 'Diễn viên',
          name: 'Steven Elder',
          original_name: 'Steven Elder',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nEfyzjSe43laenyiDUj2JEDT6Nt.jpg',
          cast_id: 5,
          character: 'Charles',
          credit_id: '52fe46c69251416c750831f7',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 80373,
          known_for_department: 'Diễn viên',
          name: 'Sandra De Sousa',
          original_name: 'Sandra De Sousa',
          popularity: 0.6,
          profile_path: null,
          cast_id: 7,
          character: 'Female Casino Tech',
          credit_id: '52fe46c69251416c750831fb',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 40667,
          known_for_department: 'Diễn viên',
          name: 'Greg Donaldson',
          original_name: 'Greg Donaldson',
          popularity: 0.694,
          profile_path: null,
          cast_id: 8,
          character: 'Casino Tech',
          credit_id: '52fe46c69251416c750831ff',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 29839,
          known_for_department: 'Diễn viên',
          name: 'Yuriy Kutsenko',
          original_name: 'Yuriy Kutsenko',
          popularity: 1.788,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3vvHueMFpeSs6Zt1l7oTvaJscb.jpg',
          cast_id: 10,
          character: 'Russian General',
          credit_id: '52fe46c69251416c75083209',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 378,
          known_for_department: 'Diễn viên',
          name: 'Jonathan Pryce',
          original_name: 'Jonathan Pryce',
          popularity: 2.138,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zwSv5uXzPTtmitFe39UdqnVwmdL.jpg',
          cast_id: 30,
          character: 'Mueller',
          credit_id: '52fe46c69251416c7508327f',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 70899,
          known_for_department: 'Diễn viên',
          name: 'Amara Zaragoza',
          original_name: 'Amara Zaragoza',
          popularity: 1.788,
          profile_path:
            'https://image.tmdb.org/t/p/w185/986s1pET41HjhHjOCkxvLFKzP2d.jpg',
          cast_id: 31,
          character: 'Kamila',
          credit_id: '52fe46c69251416c75083283',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 238125,
          known_for_department: 'Diễn viên',
          name: 'Sergey Gubanov',
          original_name: 'Sergey Gubanov',
          popularity: 1.013,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qPvrY9RUViJZsLtDTOuBt1yVrjT.jpg',
          cast_id: 33,
          character: 'Yuri Malanin',
          credit_id: '52fe46c69251416c7508328b',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 1121975,
          known_for_department: 'Diễn viên',
          name: 'Ilan Goodman',
          original_name: 'Ilan Goodman',
          popularity: 0.828,
          profile_path: null,
          cast_id: 34,
          character: 'Dennis',
          credit_id: '52fe46c69251416c7508328f',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 58794,
          known_for_department: 'Diễn viên',
          name: 'Todd Jensen',
          original_name: 'Todd Jensen',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pVOlsb92c5XcsTXt23to6hGqJQj.jpg',
          cast_id: 35,
          character: 'Agent Fletcher',
          credit_id: '52fe46c69251416c75083293',
          order: 14,
        },
        {
          adult: false,
          gender: 0,
          id: 1121976,
          known_for_department: 'Diễn viên',
          name: 'Andrea Enright',
          original_name: 'Andrea Enright',
          popularity: 0.6,
          profile_path: null,
          cast_id: 36,
          character: 'NSA Tech #2',
          credit_id: '52fe46c69251416c75083297',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 1431255,
          known_for_department: 'Diễn viên',
          name: 'Trevor White',
          original_name: 'Trevor White',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oziIah969dJDcq24hH4TRA5PX2U.jpg',
          cast_id: 37,
          character: 'Paul Spencer',
          credit_id: '52fe46c69251416c7508329b',
          order: 16,
        },
        {
          adult: false,
          gender: 2,
          id: 62417,
          known_for_department: 'Diễn viên',
          name: 'Richard Ng',
          original_name: 'Richard Ng',
          popularity: 3.332,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oEFqGH1vQjRoNlVfZseRMYTzAsY.jpg',
          cast_id: 62,
          character: 'Wong',
          credit_id: '5fd76e188c44b9003cd9118b',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 575735,
          known_for_department: 'Diễn viên',
          name: 'Danko Jordanov',
          original_name: 'Danko Jordanov',
          popularity: 0.98,
          profile_path: null,
          cast_id: 63,
          character: "Max's Attacker 2",
          credit_id: '60e00e2ab686b9005e47346b',
          order: 18,
        },
        {
          adult: false,
          gender: 2,
          id: 559374,
          known_for_department: 'Diễn viên',
          name: 'Velizar Peev',
          original_name: 'Velizar Peev',
          popularity: 1.53,
          profile_path:
            'https://image.tmdb.org/t/p/w185/riKRf08zCalpgdkAQQkeqW43F4A.jpg',
          cast_id: 64,
          character: 'NSA Agent #2',
          credit_id: '60e38d1fcaa5080060eea52f',
          order: 19,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 7205,
          known_for_department: 'Art',
          name: 'Giovanni Natalucci',
          original_name: 'Giovanni Natalucci',
          popularity: 0.98,
          profile_path: null,
          credit_id: '565714eec3a3681982008d57',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 2,
          id: 20951,
          known_for_department: 'Biên kịch',
          name: 'Kevin Elders',
          original_name: 'Kevin Elders',
          popularity: 1.4,
          profile_path: null,
          credit_id: '52fe46c69251416c7508321b',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 1,
          id: 29940,
          known_for_department: 'Production',
          name: 'Gillian Hawser',
          original_name: 'Gillian Hawser',
          popularity: 1.276,
          profile_path: null,
          credit_id: '52fe46c69251416c7508326f',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 30874,
          known_for_department: 'Production',
          name: 'Donald Paul Pemrick',
          original_name: 'Donald Paul Pemrick',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dTrBQgwAbxQvIydb6V5C8A6hf9X.jpg',
          credit_id: '52fe46c69251416c75083275',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 30876,
          known_for_department: 'Production',
          name: 'Dean E. Fronk',
          original_name: 'Dean E. Fronk',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/b3jBbYGzoeaWL4b9QrK4o3UouEQ.jpg',
          credit_id: '52fe46c69251416c75083269',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 39726,
          known_for_department: 'Production',
          name: 'Steve Richards',
          original_name: 'Steve Richards',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe46c69251416c7508322d',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 52046,
          known_for_department: 'Production',
          name: 'Jonathan Tzachor',
          original_name: 'Jonathan Tzachor',
          popularity: 0.972,
          profile_path: null,
          credit_id: '52fe46c69251416c7508324b',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 56917,
          known_for_department: 'Editing',
          name: 'James Herbert',
          original_name: 'James Herbert',
          popularity: 1.38,
          profile_path: null,
          credit_id: '52fe46c69251416c75083263',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 57125,
          known_for_department: 'Directing',
          name: 'Greg Marcks',
          original_name: 'Greg Marcks',
          popularity: 0.989,
          profile_path: null,
          credit_id: '52fe46c69251416c75083205',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 61844,
          known_for_department: 'Production',
          name: 'Roee Sharon',
          original_name: 'Roee Sharon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe46c69251416c75083233',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 61851,
          known_for_department: 'Camera',
          name: 'Lorenzo Senatore',
          original_name: 'Lorenzo Senatore',
          popularity: 0.613,
          profile_path: null,
          credit_id: '5657176dc3a368196e009997',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 61863,
          known_for_department: 'Costume & Make-Up',
          name: 'Alison Freer',
          original_name: 'Alison Freer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5657151c925141018f008f3d',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 0,
          id: 72975,
          known_for_department: 'Editing',
          name: 'Joseph Gutowski',
          original_name: 'Joseph Gutowski',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe46c69251416c7508325d',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 124715,
          known_for_department: 'Sound',
          name: 'Bobby Tahouri',
          original_name: 'Bobby Tahouri',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe46c69251416c75083251',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 959506,
          known_for_department: 'Art',
          name: 'Antonello Rubino',
          original_name: 'Antonello Rubino',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe46c69251416c7508327b',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 2,
          id: 1015620,
          known_for_department: 'Biên kịch',
          name: 'Michael Nitsberg',
          original_name: 'Michael Nitsberg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe46c69251416c75083215',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 1015620,
          known_for_department: 'Biên kịch',
          name: 'Michael Nitsberg',
          original_name: 'Michael Nitsberg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe46c69251416c7508320f',
          department: 'Biên kịch',
          job: 'Story',
        },
        {
          adult: false,
          gender: 2,
          id: 1015621,
          known_for_department: 'Production',
          name: 'Alexander Leyviman',
          original_name: 'Alexander Leyviman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe46c69251416c75083227',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1015623,
          known_for_department: 'Art',
          name: 'Ivan Ranghelov',
          original_name: 'Ivan Ranghelov',
          popularity: 0.98,
          profile_path: null,
          credit_id: '565714bdc3a368196b00935a',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1018077,
          known_for_department: 'Production',
          name: 'Navid McIlhargey',
          original_name: 'Navid McIlhargey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe46c69251416c75083245',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1121972,
          known_for_department: 'Production',
          name: 'John Corser',
          original_name: 'John Corser',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe46c69251416c75083221',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1121973,
          known_for_department: 'Production',
          name: 'Stephen Bender',
          original_name: 'Stephen Bender',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe46c69251416c75083239',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1121974,
          known_for_department: 'Production',
          name: 'Charles V. Bender',
          original_name: 'Charles V. Bender',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe46c69251416c7508323f',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1318091,
          known_for_department: 'Art',
          name: 'Valentina Mladenova',
          original_name: 'Valentina Mladenova',
          popularity: 0.6,
          profile_path: null,
          credit_id: '565714d39251410198008fa2',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 1322577,
          known_for_department: 'Costume & Make-Up',
          name: 'Lyubomir Doichinov',
          original_name: 'Lyubomir Doichinov',
          popularity: 0.6,
          profile_path: null,
          credit_id: '565715059251410198008faa',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1350233,
          known_for_department: 'Art',
          name: 'Anna Hadzhieva',
          original_name: 'Anna Hadzhieva',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56571546c3a368196b00937a',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1350258,
          known_for_department: 'Costume & Make-Up',
          name: 'Vyarka Sirkova',
          original_name: 'Vyarka Sirkova',
          popularity: 0.6,
          profile_path: null,
          credit_id: '565716cec3a368196b0093ba',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 1,
          id: 1350261,
          known_for_department: 'Directing',
          name: 'Shelly Stoyanova',
          original_name: 'Shelly Stoyanova',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56571717c3a3681996009a62',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1363347,
          known_for_department: 'Costume & Make-Up',
          name: 'Nikolai Kirilov',
          original_name: 'Nikolai Kirilov',
          popularity: 0.6,
          profile_path: null,
          credit_id: '565716b6925141018f008f8f',
          department: 'Costume & Make-Up',
          job: 'Assistant Costume Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1368862,
          known_for_department: 'Art',
          name: 'Dirk Buchmann',
          original_name: 'Dirk Buchmann',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5e1b804f6c19ea001392c9ee',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 2,
          id: 1391693,
          known_for_department: 'Visual Effects',
          name: 'Erick Geisler',
          original_name: 'Erick Geisler',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56571612c3a368196e00994b',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1409722,
          known_for_department: 'Sound',
          name: 'Derek Somaru',
          original_name: 'Derek Somaru',
          popularity: 0.6,
          profile_path: null,
          credit_id: '565716e99251410191008afe',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1437161,
          known_for_department: 'Visual Effects',
          name: 'Eran Barnea',
          original_name: 'Eran Barnea',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56571635c3a368196b0093a3',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1447172,
          known_for_department: 'Costume & Make-Up',
          name: "Tatyana 'Tita' Sleptsova",
          original_name: "Tatyana 'Tita' Sleptsova",
          popularity: 0.6,
          profile_path: null,
          credit_id: '5657174e92514109e8003b32',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1539310,
          known_for_department: 'Costume & Make-Up',
          name: 'Desislava Grozdeva',
          original_name: 'Desislava Grozdeva',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56571735925141018800894f',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1541445,
          known_for_department: 'Art',
          name: 'Ivaylo Nikolov',
          original_name: 'Ivaylo Nikolov',
          popularity: 0.6,
          profile_path: null,
          credit_id: '565714aac3a3681984008c53',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1541447,
          known_for_department: 'Costume & Make-Up',
          name: 'Maria Mladenoza',
          original_name: 'Maria Mladenoza',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5657152fc3a368196b009375',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1541448,
          known_for_department: 'Crew',
          name: 'Bogdan Bogdanov',
          original_name: 'Bogdan Bogdanov',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5657158c9251410198008fc9',
          department: 'Crew',
          job: 'Carpenter',
        },
        {
          adult: false,
          gender: 0,
          id: 1541457,
          known_for_department: 'Editing',
          name: 'Travis Dultz',
          original_name: 'Travis Dultz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '565716509251410188008919',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1541458,
          known_for_department: 'Visual Effects',
          name: 'Josh Sahley',
          original_name: 'Josh Sahley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5657167d9251410198008fff',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1541459,
          known_for_department: 'Visual Effects',
          name: 'Mark Spatny',
          original_name: 'Mark Spatny',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56571695c3a3681992009a88',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1541461,
          known_for_department: 'Sound',
          name: 'Matt Biffa',
          original_name: 'Matt Biffa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '565716fd925141018c008ec2',
          department: 'Sound',
          job: 'Music Supervisor',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/uLncvZmXnAUcJJbpAgRod2PN4HU.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [{ id: 35, name: 'Phim Hài' }],
    homepage: '',
    id: 173133,
    imdb_id: 'tt0095236',
    original_language: 'cn',
    original_title: '公子多情',
    overview:
      'Một bộ phim hài thú vị về ba người nhập cư bất hợp pháp từ Trung Quốc, một trong số họ được đưa vào một khóa đào tạo quý ông do Mui dạy. Để trả thù một số người đẹp xấu tính.',
    popularity: 0.716,
    poster_path:
      'https://image.tmdb.org/t/p/w342/gLoLWsC0bxrOOhyefJ8Hv87MSFH.jpg',
    production_companies: [
      {
        id: 39985,
        logo_path: null,
        name: 'Golden Harvest Productions',
        origin_country: '',
      },
    ],
    production_countries: [{ iso_3166_1: 'HK', name: 'Hồng Kông' }],
    release_date: '1988-07-30',
    revenue: 0,
    runtime: 115,
    spoken_languages: [
      { english_name: 'Cantonese', iso_639_1: 'cn', name: '广州话 / 廣州話' },
    ],
    status: 'Đã phát hành',
    tagline: 'The Greatest Lover (1988)',
    title: 'Công Tử Đa Tình',
    video: false,
    vote_average: 5.0,
    vote_count: 3,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: '[Trailer] 公子多情 ( Greatest Lover, The ) - HD Version',
          key: 'mO1A4GC9Dwk',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2019-05-20T04:00:03.000Z',
          id: '5d0dc665c3a3682f6820b970',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 1619,
          known_for_department: 'Diễn viên',
          name: 'Chow Yun-Fat',
          original_name: 'Chow Yun-Fat',
          popularity: 4.992,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uDPYSiZrW7OZ79qgcgkWefALlXY.jpg',
          cast_id: 3,
          character: 'Qian Jin / Nelson Chow',
          credit_id: '591de416c3a3687a4b022512',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 26724,
          known_for_department: 'Diễn viên',
          name: 'Eric Tsang',
          original_name: 'Eric Tsang',
          popularity: 3.112,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vrPBadugqlMkfNIYzLZbP4sEF1j.jpg',
          cast_id: 9,
          character: 'Tall',
          credit_id: '591de483925141485e025703',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 119447,
          known_for_department: 'Diễn viên',
          name: 'Shing Fui-On',
          original_name: 'Shing Fui-On',
          popularity: 2.261,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iLGQZ8OjGdZW3imJlgiUNv9ER8y.jpg',
          cast_id: 11,
          character: 'Silly Chick',
          credit_id: '591de4e1c3a3687a8e022ced',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 44917,
          known_for_department: 'Diễn viên',
          name: 'Anita Mui',
          original_name: 'Anita Mui',
          popularity: 4.301,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nGLogfEGhhVqGlECQqDFmQZ6Tid.jpg',
          cast_id: 4,
          character: 'Anita Ko',
          credit_id: '591de426c3a3687a8e022c60',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 26785,
          known_for_department: 'Diễn viên',
          name: 'Nina Li Chi',
          original_name: 'Nina Li Chi',
          popularity: 3.987,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lL76hgrDqmtUZMtSW8AB2o7GD8f.jpg',
          cast_id: 6,
          character: 'Lychee',
          credit_id: '591de44e9251414ab1022eb5',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 88495,
          known_for_department: 'Diễn viên',
          name: 'Sandra Ng Kwun-Yu',
          original_name: 'Sandra Ng Kwun-Yu',
          popularity: 2.823,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dSfchIatXOJkJ6FNhNuwrMhcqe5.jpg',
          cast_id: 8,
          character: 'Lily Zhu',
          credit_id: '591de46ac3a3687a8e022c9b',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 121709,
          known_for_department: 'Diễn viên',
          name: 'Elizabeth Lee Mei-Fung',
          original_name: 'Elizabeth Lee Mei-Fung',
          popularity: 2.646,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7qZN5YCnQg2jcGXOammL9vI96wj.jpg',
          cast_id: 5,
          character: 'Fiona Tung',
          credit_id: '591de43f9251414990024123',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 544906,
          known_for_department: 'Diễn viên',
          name: 'Pauline Wong Siu-Fung',
          original_name: 'Pauline Wong Siu-Fung',
          popularity: 1.27,
          profile_path: null,
          cast_id: 7,
          character: 'Sheung Guan Fei Fung',
          credit_id: '591de45d92514149f3023b46',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 990468,
          known_for_department: 'Diễn viên',
          name: 'Wong Ching',
          original_name: 'Wong Ching',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vsMDcPa7iGDtWJxvoG1THPtNDp0.jpg',
          cast_id: 10,
          character: 'Big Mouth Shi',
          credit_id: '591de4b9925141485e025736',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 548474,
          known_for_department: 'Biên kịch',
          name: 'Wong Jing',
          original_name: 'Wong Jing',
          popularity: 3.543,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gMmaDRst3OwnY1wClKt541AmslD.jpg',
          cast_id: 12,
          character: 'Expert Tung',
          credit_id: '591de4f1c3a36878fe02185c',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 57609,
          known_for_department: 'Diễn viên',
          name: 'Yuen Wah',
          original_name: 'Yuen Wah',
          popularity: 8.821,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yMkMgs0tWlJXdTjYkiMcjvhYnRw.jpg',
          cast_id: 13,
          character: 'Comrade Zhu Bai Dao',
          credit_id: '591de5089251414ab1022f46',
          order: 10,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 57609,
          known_for_department: 'Diễn viên',
          name: 'Yuen Wah',
          original_name: 'Yuen Wah',
          popularity: 8.821,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yMkMgs0tWlJXdTjYkiMcjvhYnRw.jpg',
          credit_id: '5e31797198f1f10018ff6c6e',
          department: 'Directing',
          job: 'Action Director',
        },
        {
          adult: false,
          gender: 2,
          id: 235186,
          known_for_department: 'Production',
          name: 'Johnny Mak',
          original_name: 'Johnny Mak',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/v1H2HwNuumYZsxKlHkubljGDRPz.jpg',
          credit_id: '5e31799d98f1f10014ff10fb',
          department: 'Crew',
          job: 'Script',
        },
        {
          adult: false,
          gender: 2,
          id: 235187,
          known_for_department: 'Biên kịch',
          name: 'Stephen Shiu',
          original_name: 'Stephen Shiu',
          popularity: 0.63,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cnpvrF8ZH3RMz2MUN0fRhM7GBL4.jpg',
          credit_id: '5e317987ac8e6b0015bf668e',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 235187,
          known_for_department: 'Biên kịch',
          name: 'Stephen Shiu',
          original_name: 'Stephen Shiu',
          popularity: 0.63,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cnpvrF8ZH3RMz2MUN0fRhM7GBL4.jpg',
          credit_id: '5e3179f5c56d2d00185121d3',
          department: 'Crew',
          job: 'Script',
        },
        {
          adult: false,
          gender: 2,
          id: 931778,
          known_for_department: 'Directing',
          name: 'Clarence Yiu-leung Fok',
          original_name: 'Clarence Yiu-leung Fok',
          popularity: 3.436,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1AnldwOu1YgK5dpwJjzy0F5UjwB.jpg',
          credit_id: '5e3179584ca676001a4c2ae5',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2415204,
          known_for_department: 'Costume & Make-Up',
          name: 'Man Yun-Ling',
          original_name: 'Man Yun-Ling',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e317a6fc56d2d001350b4e0',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/pqsGkkwYN0hL4Z08fyOs6OIhbrf.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [{ id: 35, name: 'Phim Hài' }],
    homepage: '',
    id: 542969,
    imdb_id: 'tt9076512',
    original_language: 'ko',
    original_title: '배반의 장미',
    overview:
      'Ba người đàn ông và một người phụ nữ tuyên bố cuộc sống của họ là buồn nhất trên thế giới quyết định kết thúc cuộc sống của họ cùng một lúc. Nhưng kế hoạch không diễn ra như mong muốn, vì quá khứ gây sốc của họ bắt đầu được tiết lộ.',
    popularity: 0.945,
    poster_path:
      'https://image.tmdb.org/t/p/w342/tYim5dxbAj33Ow38mtjLG9m5OSt.jpg',
    production_companies: [
      {
        id: 7819,
        logo_path: '/ghFZAt4edln0M7BzDExyYMzUGX1.png',
        name: 'Lotte Entertainment',
        origin_country: 'KR',
      },
      {
        id: 3965,
        logo_path: null,
        name: 'Taewon Entertainment',
        origin_country: 'KR',
      },
    ],
    production_countries: [{ iso_3166_1: 'KR', name: 'South Korea' }],
    release_date: '2018-10-18',
    revenue: 0,
    runtime: 99,
    spoken_languages: [
      { english_name: 'Korean', iso_639_1: 'ko', name: '한국어/조선말' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Chơi Hoặc Chết',
    video: false,
    vote_average: 6.7,
    vote_count: 3,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'TOO HOT TO DIE (2018) - Trailer',
          key: '284666413',
          site: 'Vimeo',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2018-08-13T05:14:54.000Z',
          id: '5cc1d9949251413a1cf2c4e1',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 115904,
          known_for_department: 'Diễn viên',
          name: 'Kim In-kwon',
          original_name: 'Kim In-kwon',
          popularity: 4.707,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vMPHVFE0FhItp2uMMgGRYq5z5Bj.jpg',
          cast_id: 0,
          character: 'Byung-nam',
          credit_id: '5b774f4e0e0a26473100134a',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 1715383,
          known_for_department: 'Diễn viên',
          name: 'Jung Sang-hoon',
          original_name: 'Jung Sang-hoon',
          popularity: 1.011,
          profile_path:
            'https://image.tmdb.org/t/p/w185/grYaUj88IUp95AF4MhQgtv3FUxs.jpg',
          cast_id: 1,
          character: 'Sim-sun',
          credit_id: '5b774f5b9251412957001341',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 1354108,
          known_for_department: 'Diễn viên',
          name: 'Son Dam-bi',
          original_name: 'Son Dam-bi',
          popularity: 1.433,
          profile_path:
            'https://image.tmdb.org/t/p/w185/i0R2y8uIVGgLr0KZLDh8O2hzA7s.jpg',
          cast_id: 2,
          character: 'Mi-ji',
          credit_id: '5b774f699251412947001477',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 1916087,
          known_for_department: 'Diễn viên',
          name: 'Kim Sung-cheol',
          original_name: 'Kim Sung-cheol',
          popularity: 1.214,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hfu2D13Bt2oHPrVqkOpBtoTjbfH.jpg',
          cast_id: 3,
          character: 'Du-seok',
          credit_id: '5b774f77925141294900134d',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 138527,
          known_for_department: 'Diễn viên',
          name: 'Park Chul-min',
          original_name: 'Park Chul-min',
          popularity: 2.087,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7IZSnaNTuK2vBHJuhc0iR31iq56.jpg',
          cast_id: 4,
          character: 'Gwang-gi',
          credit_id: '5b774f830e0a2647360019eb',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 2109814,
          known_for_department: 'Diễn viên',
          name: 'Lee Kyu-bok',
          original_name: 'Lee Kyu-bok',
          popularity: 0.652,
          profile_path:
            'https://image.tmdb.org/t/p/w185/l0OUU7Q3eH7ILDN4DJsCyOOahO2.jpg',
          cast_id: 5,
          character: 'Gwang-tae',
          credit_id: '5b774f8c92514129540013d3',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 2252329,
          known_for_department: 'Diễn viên',
          name: 'Heo Ga-yoon',
          original_name: 'Heo Ga-yoon',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ieXQXzHPQu8sDlEaBWBQBoodowH.jpg',
          cast_id: 16,
          character: 'Jang-mi',
          credit_id: '5e6249ec357c00001133a381',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 2463467,
          known_for_department: 'Diễn viên',
          name: 'Kim Jung-hui',
          original_name: 'Kim Jung-hui',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/h65AnP2S5WKvWIHtFkKrK72WSyI.jpg',
          cast_id: 17,
          character: '',
          credit_id: '60047e34cb3084003bdcf487',
          order: 7,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 87533,
          known_for_department: 'Production',
          name: 'Chung Tae-won',
          original_name: 'Chung Tae-won',
          popularity: 0.606,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qDZHUKOeIGPRY1eowNzl6wvVIkN.jpg',
          credit_id: '5ceeaf810e0a2613cdcae5b8',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 87533,
          known_for_department: 'Production',
          name: 'Chung Tae-won',
          original_name: 'Chung Tae-won',
          popularity: 0.606,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qDZHUKOeIGPRY1eowNzl6wvVIkN.jpg',
          credit_id: '5ceeaf75c3a368441e223491',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2109816,
          known_for_department: 'Directing',
          name: 'Park Jin-young',
          original_name: 'Park Jin-young',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b8551b192514159d905372f',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2157201,
          known_for_department: 'Biên kịch',
          name: 'Son Geun-joo',
          original_name: 'Son Geun-joo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5bccffefc3a36828630151c5',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 0,
          id: 2157202,
          known_for_department: 'Production',
          name: 'Yang Chang-hoon',
          original_name: 'Yang Chang-hoon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5bcd00020e0a26015b01415b',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2157203,
          known_for_department: 'Camera',
          name: 'Kim Jae-sung',
          original_name: 'Kim Jae-sung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5bcd0012925141613e0123a9',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 2157206,
          known_for_department: 'Sound',
          name: 'Kim Woo-chul',
          original_name: 'Kim Woo-chul',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5bcd0033925141613b012804',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 2327590,
          known_for_department: 'Editing',
          name: 'Kim Woo-hyun',
          original_name: 'Kim Woo-hyun',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf33a3d0e0a261e1bcd7266',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2382784,
          known_for_department: 'Production',
          name: 'Ko Sung-mi',
          original_name: 'Ko Sung-mi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d4e24350d5d8500163ded5c',
          department: 'Production',
          job: 'Producer',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/gGQvvkgiYf35FbG3K5Cw75m7KGt.jpg',
    belongs_to_collection: null,
    budget: 34000000,
    genres: [
      { id: 80, name: 'Phim Hình Sự' },
      { id: 53, name: 'Phim Gây Cấn' },
      { id: 18, name: 'Phim Chính Kịch' },
    ],
    homepage: '',
    id: 241,
    imdb_id: 'tt0110632',
    original_language: 'en',
    original_title: 'Natural Born Killers',
    overview:
      'Hai kẻ bất hạnh Mickey và Mallory, những kẻ vô gia cư và là hai tên giết người hàng loạt. Mickey Knox, một tên giao thịt bò có người yêu là Mallory Wilson. Hắn giúp cô giết chết ông bố bệnh hoạn và thiêu cháy bà mẹ đang ngủ rồi cùng nhau bắt đầu cuộc hành trình rùng rợn trên đường Route 666. Cứ mỗi dặm, bọn họ lại tấn công những người đi cùng đường với mình…',
    popularity: 15.703,
    poster_path:
      'https://image.tmdb.org/t/p/w342/fEKZwT91gxvkAoyPgpNXo8W5fu0.jpg',
    production_companies: [
      {
        id: 68551,
        logo_path: null,
        name: 'J D Productions',
        origin_country: '',
      },
      {
        id: 508,
        logo_path: '/7PzJdsLGlR7oW4J0J5Xcd0pHGRg.png',
        name: 'Regency Enterprises',
        origin_country: 'US',
      },
      { id: 644, logo_path: null, name: 'Alcor Films', origin_country: '' },
      { id: 4198, logo_path: null, name: 'Ixtlan', origin_country: '' },
      {
        id: 10104,
        logo_path: '/hNuGhsKVlmhnwSRcmOejDBDjh6w.png',
        name: 'New Regency Pictures',
        origin_country: 'US',
      },
      {
        id: 174,
        logo_path: '/IuAlhI9eVC9Z8UQWOIDdWRKSEJ.png',
        name: 'Warner Bros. Pictures',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '1994-08-25',
    revenue: 50282766,
    runtime: 118,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
      { english_name: 'Navajo', iso_639_1: 'nv', name: '' },
      { english_name: 'Nhật Bảnese', iso_639_1: 'ja', name: '日本語' },
    ],
    status: 'Đã phát hành',
    tagline: 'The media made them superstars.',
    title: 'Kẻ Giết Người Bẩm Sinh',
    video: false,
    vote_average: 7.1,
    vote_count: 2595,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Natural Born Killers - Trailer',
          key: 'PgxH1-yeWNI',
          published_at: '2012-04-26T23:45:20.000Z',
          site: 'YouTube',
          size: 360,
          type: 'Trailer',
          official: true,
          id: '5b18bd1f0e0a261f9f0037c3',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 57755,
          known_for_department: 'Diễn viên',
          name: 'Woody Harrelson',
          original_name: 'Woody Harrelson',
          popularity: 18.8,
          profile_path:
            'https://image.tmdb.org/t/p/w185/igxYDQBbTEdAqaJxaW6ffqswmUU.jpg',
          cast_id: 49,
          character: 'Mickey Knox',
          credit_id: '52fe422bc3a36847f800967d',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 3196,
          known_for_department: 'Diễn viên',
          name: 'Juliette Lewis',
          original_name: 'Juliette Lewis',
          popularity: 13.978,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oErIsGmtxeluwtzRoWI3dx2pYGQ.jpg',
          cast_id: 50,
          character: 'Mallory Knox',
          credit_id: '52fe422bc3a36847f8009681',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 3223,
          known_for_department: 'Diễn viên',
          name: 'Robert Downey Jr.',
          original_name: 'Robert Downey Jr.',
          popularity: 16.841,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5qHNjhtjMD4YWH3UP0rm4tKwxCL.jpg',
          cast_id: 51,
          character: 'Wayne Gale',
          credit_id: '52fe422bc3a36847f8009685',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 2176,
          known_for_department: 'Diễn viên',
          name: 'Tommy Lee Jones',
          original_name: 'Tommy Lee Jones',
          popularity: 18.249,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zixpaPmOonRh1I3TWgxDkeGxkrv.jpg',
          cast_id: 52,
          character: 'Warden Dwight McClusky',
          credit_id: '52fe422bc3a36847f8009689',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 3197,
          known_for_department: 'Diễn viên',
          name: 'Tom Sizemore',
          original_name: 'Tom Sizemore',
          popularity: 7.36,
          profile_path:
            'https://image.tmdb.org/t/p/w185/soINOuacuiThRb2LyPD4tTWve7C.jpg',
          cast_id: 53,
          character: 'Det. Jack Scagnetti',
          credit_id: '52fe422bc3a36847f800968d',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 3198,
          known_for_department: 'Diễn viên',
          name: 'Rodney Dangerfield',
          original_name: 'Rodney Dangerfield',
          popularity: 2.934,
          profile_path:
            'https://image.tmdb.org/t/p/w185/szBltzA7vmkuv0V9SXACxSahxzo.jpg',
          cast_id: 54,
          character: "Mallory's Dad",
          credit_id: '52fe422bc3a36847f8009691',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 3202,
          known_for_department: 'Diễn viên',
          name: 'Edie McClurg',
          original_name: 'Edie McClurg',
          popularity: 3.355,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vU5y4hZe1WhqDAPP5jEfrWv4Iaq.jpg',
          cast_id: 55,
          character: "Mallory's Mom",
          credit_id: '52fe422bc3a36847f8009695',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 15440,
          known_for_department: 'Diễn viên',
          name: 'Jared Harris',
          original_name: 'Jared Harris',
          popularity: 6.577,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jAyPWkmge3BqXtgxIG9MfXBzOGj.jpg',
          cast_id: 61,
          character: 'London Boy',
          credit_id: '54971b40c3a36831b800434b',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 3203,
          known_for_department: 'Diễn viên',
          name: 'Russell Means',
          original_name: 'Russell Means',
          popularity: 1.666,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5qBgrr6eror0bEene4LthnjUFnT.jpg',
          cast_id: 56,
          character: 'Old Indian',
          credit_id: '52fe422bc3a36847f8009699',
          order: 8,
        },
        {
          adult: false,
          gender: 1,
          id: 3208,
          known_for_department: 'Diễn viên',
          name: 'Maria Pitillo',
          original_name: 'Maria Pitillo',
          popularity: 5.001,
          profile_path:
            'https://image.tmdb.org/t/p/w185/flyIimpItY1RmYYXsHxw74uWfcX.jpg',
          cast_id: 57,
          character: 'Deborah',
          credit_id: '52fe422bc3a36847f800969d',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 3210,
          known_for_department: 'Diễn viên',
          name: 'Sean Stone',
          original_name: 'Sean Stone',
          popularity: 0.6,
          profile_path: null,
          cast_id: 58,
          character: 'Kevin',
          credit_id: '52fe422bc3a36847f80096a1',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 3199,
          known_for_department: 'Diễn viên',
          name: 'Everett Quinton',
          original_name: 'Everett Quinton',
          popularity: 0.6,
          profile_path: null,
          cast_id: 59,
          character: 'Deputy Warden Wurlitzer',
          credit_id: '54971aec92514130fc0052d8',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 1912,
          known_for_department: 'Diễn viên',
          name: 'O-Lan Jones',
          original_name: 'O-Lan Jones',
          popularity: 2.196,
          profile_path:
            'https://image.tmdb.org/t/p/w185/urRA3z6QFJdiKEXGsQlUy3yvoZH.jpg',
          cast_id: 62,
          character: 'Mabel',
          credit_id: '56462628c3a368260800021b',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 3201,
          known_for_department: 'Diễn viên',
          name: 'Pruitt Taylor Vince',
          original_name: 'Pruitt Taylor Vince',
          popularity: 3.671,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jqC1v8tF92QcmkQycnaLSuJiQfl.jpg',
          cast_id: 63,
          character: 'Deputy Warden Kavanaugh',
          credit_id: '56462656c3a36826140001f3',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 3214,
          known_for_department: 'Diễn viên',
          name: 'Steven Wright',
          original_name: 'Steven Wright',
          popularity: 1.691,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9Q9buDjfm6uq0VE86MZ01o96lyG.jpg',
          cast_id: 64,
          character: 'Dr. Emil Reingold',
          credit_id: '56462682c3a368261a0001ea',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 3204,
          known_for_department: 'Diễn viên',
          name: 'Lanny Flaherty',
          original_name: 'Lanny Flaherty',
          popularity: 1.425,
          profile_path:
            'https://image.tmdb.org/t/p/w185/e5CScAPucGbyEAgJbZyiATbwua1.jpg',
          cast_id: 65,
          character: 'Earl',
          credit_id: '57d3c3d6925141609e0027c1',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 3205,
          known_for_department: 'Diễn viên',
          name: 'Richard Lineback',
          original_name: 'Richard Lineback',
          popularity: 0.762,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3Tfczd6FkLkAoIZvklGGEVFkhUq.jpg',
          cast_id: 66,
          character: 'Sonny',
          credit_id: '57d3db46c3a368557200327f',
          order: 16,
        },
        {
          adult: false,
          gender: 2,
          id: 3206,
          known_for_department: 'Diễn viên',
          name: 'Kirk Baltz',
          original_name: 'Kirk Baltz',
          popularity: 1.102,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8PkKnqLOjfWm33GFk2Azt7MvY2Q.jpg',
          cast_id: 67,
          character: 'Roger',
          credit_id: '57d3dbe4c3a368557a002b67',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 1677045,
          known_for_department: 'Diễn viên',
          name: 'Ed White',
          original_name: 'Ed White',
          popularity: 0.6,
          profile_path: null,
          cast_id: 68,
          character: 'Pinball Cowboy',
          credit_id: '57d3dcbac3a3685577002edf',
          order: 18,
        },
        {
          adult: false,
          gender: 1,
          id: 3207,
          known_for_department: 'Diễn viên',
          name: 'Terrylene',
          original_name: 'Terrylene',
          popularity: 0.6,
          profile_path: null,
          cast_id: 69,
          character: 'Julie',
          credit_id: '57d3dde1925141609e003099',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 3209,
          known_for_department: 'Diễn viên',
          name: 'Josh Richman',
          original_name: 'Josh Richman',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/unuGGek4a7AmGsNivCTduFido55.jpg',
          cast_id: 70,
          character: 'Soundman',
          credit_id: '57d3de4392514160ae002fe1',
          order: 20,
        },
        {
          adult: false,
          gender: 1,
          id: 180533,
          known_for_department: 'Diễn viên',
          name: 'Melinda Renna',
          original_name: 'Melinda Renna',
          popularity: 0.6,
          profile_path: null,
          cast_id: 71,
          character: 'Antonia Chavez',
          credit_id: '57d3de9e92514174d8000624',
          order: 21,
        },
        {
          adult: false,
          gender: 2,
          id: 3211,
          known_for_department: 'Diễn viên',
          name: 'Dale Dye',
          original_name: 'Dale Dye',
          popularity: 1.77,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bkMcK2hvB1wRJT1YFgNTl7ivlF2.jpg',
          cast_id: 72,
          character: 'Dale Wrigley',
          credit_id: '57d3df45c3a3685568002fa7',
          order: 22,
        },
        {
          adult: false,
          gender: 2,
          id: 92490,
          known_for_department: 'Diễn viên',
          name: 'Edward Conna',
          original_name: 'Edward Conna',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3sh4iidfo26DsXXZJmYSj3TImcu.jpg',
          cast_id: 73,
          character: 'Gerald Nash',
          credit_id: '57d3dfd492514160a7003386',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 3212,
          known_for_department: 'Diễn viên',
          name: 'Evan Handler',
          original_name: 'Evan Handler',
          popularity: 1.426,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yU0OXeZ0K1ppe1o9SpHiAMHy1rc.jpg',
          cast_id: 74,
          character: 'David',
          credit_id: '57d3e01bc3a368556f0031f9',
          order: 24,
        },
        {
          adult: false,
          gender: 2,
          id: 80541,
          known_for_department: 'Diễn viên',
          name: 'Matthew Faber',
          original_name: 'Matthew Faber',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7AN24bHosFTglFqsqSyCRioLLUf.jpg',
          cast_id: 75,
          character: 'Kid #1',
          credit_id: '57d3e05a92514160a200316a',
          order: 25,
        },
        {
          adult: false,
          gender: 2,
          id: 86919,
          known_for_department: 'Diễn viên',
          name: 'Jamie Harrold',
          original_name: 'Jamie Harrold',
          popularity: 2.233,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vtBL6DCxCL2qCCh8aI6LRHOtc8V.jpg',
          cast_id: 76,
          character: 'Kid #2',
          credit_id: '57d3e08dc3a368556d003678',
          order: 26,
        },
        {
          adult: false,
          gender: 1,
          id: 16146,
          known_for_department: 'Diễn viên',
          name: 'Saemi Nakamura',
          original_name: 'Saemi Nakamura',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bZMyohvYBNumQRw8JB0sRRpPHmN.jpg',
          cast_id: 77,
          character: 'Nhật Bảnese Girl #1 / Nhật Bảnese Reporter',
          credit_id: '57d3e0e89251416099003036',
          order: 27,
        },
        {
          adult: false,
          gender: 1,
          id: 1265216,
          known_for_department: 'Diễn viên',
          name: 'Keiko Seiko',
          original_name: 'Keiko Seiko',
          popularity: 1.266,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6jgiSifCu7b7YHKLFAkGY6BZx3Y.jpg',
          cast_id: 78,
          character: 'Nhật Bảnese Girl #2',
          credit_id: '57d3e118c3a3685577003056',
          order: 28,
        },
        {
          adult: false,
          gender: 2,
          id: 7041,
          known_for_department: 'Diễn viên',
          name: 'Salvator Xuereb',
          original_name: 'Salvator Xuereb',
          popularity: 1.92,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aJPHt4Y5JMPQ65MsjlD3mUb9tpY.jpg',
          cast_id: 79,
          character: 'French Boy #1',
          credit_id: '57d3e17692514160a20031bd',
          order: 29,
        },
        {
          adult: false,
          gender: 0,
          id: 1392525,
          known_for_department: 'Diễn viên',
          name: 'Natalie Karp',
          original_name: 'Natalie Karp',
          popularity: 0.6,
          profile_path: null,
          cast_id: 80,
          character: 'French Girl',
          credit_id: '57d3e7b392514160a7003702',
          order: 30,
        },
        {
          adult: false,
          gender: 2,
          id: 137416,
          known_for_department: 'Diễn viên',
          name: 'Emmanuel Xuereb',
          original_name: 'Emmanuel Xuereb',
          popularity: 1.166,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7euWFldTnZgRh9DUjNXofkiE9G5.jpg',
          cast_id: 81,
          character: 'French Boy #2',
          credit_id: '57d3e7f7c3a368557a002fc7',
          order: 31,
        },
        {
          adult: false,
          gender: 2,
          id: 9296,
          known_for_department: 'Diễn viên',
          name: 'Balthazar Getty',
          original_name: 'Balthazar Getty',
          popularity: 2.703,
          profile_path:
            'https://image.tmdb.org/t/p/w185/q8AzfrQZtCTj8P9jgFaSdQUJylp.jpg',
          cast_id: 82,
          character: 'Gas Station Attendant',
          credit_id: '57d3e85792514160ae00343d',
          order: 32,
        },
        {
          adult: false,
          gender: 2,
          id: 1378239,
          known_for_department: 'Crew',
          name: 'Phil Neilson',
          original_name: 'Phil Neilson',
          popularity: 0.626,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yxsaQoFnfwh4ZuyfTqgIEm1b41J.jpg',
          cast_id: 83,
          character: "Mickey's Dad",
          credit_id: '57d3ea6e92514160a400341e',
          order: 33,
        },
        {
          adult: false,
          gender: 2,
          id: 60508,
          known_for_department: 'Diễn viên',
          name: 'Red West',
          original_name: 'Red West',
          popularity: 1.019,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wSJw9XFodrZJEBsMHKM0EsShDjE.jpg',
          cast_id: 84,
          character: 'Cowboy Sheriff',
          credit_id: '57d3eaf4c3a36855720038fa',
          order: 34,
        },
        {
          adult: false,
          gender: 0,
          id: 582668,
          known_for_department: 'Diễn viên',
          name: 'Jeremiah Bitsui',
          original_name: 'Jeremiah Bitsui',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jB4u8jekprqQeB0xhdB4YSgO8FG.jpg',
          cast_id: 85,
          character: 'Young Indian Boy',
          credit_id: '57d3eb5a92514160ae0035aa',
          order: 35,
        },
        {
          adult: false,
          gender: 1,
          id: 3213,
          known_for_department: 'Diễn viên',
          name: 'Lorraine Farris',
          original_name: 'Lorraine Farris',
          popularity: 0.993,
          profile_path:
            'https://image.tmdb.org/t/p/w185/n5ztZlzWW5THpctPtoe91Vpnn00.jpg',
          cast_id: 86,
          character: 'Pinky',
          credit_id: '57d3eb8e92514160a200364a',
          order: 36,
        },
        {
          adult: false,
          gender: 2,
          id: 166963,
          known_for_department: 'Diễn viên',
          name: 'Glen Chin',
          original_name: 'Glen Chin',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9pPFU6AlvvTzThOpZ2c7kHoFLCV.jpg',
          cast_id: 87,
          character: 'Druggist',
          credit_id: '57d3ec5992514160a7003954',
          order: 37,
        },
        {
          adult: false,
          gender: 2,
          id: 30487,
          known_for_department: 'Diễn viên',
          name: 'Peter Crombie',
          original_name: 'Peter Crombie',
          popularity: 1.913,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3pqskepZqGEqFiwtuJ5bB2fHHVs.jpg',
          cast_id: 88,
          character: 'Intense Cop',
          credit_id: '57d3ecf0c3a3685572003a1d',
          order: 38,
        },
        {
          adult: false,
          gender: 2,
          id: 1659415,
          known_for_department: 'Diễn viên',
          name: 'John M. Watson Sr.',
          original_name: 'John M. Watson Sr.',
          popularity: 0.656,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9IzEZ321WB7jdZPUNQsFwt69VTM.jpg',
          cast_id: 89,
          character: 'Black Inmate',
          credit_id: '57d3ed3592514160ae0036aa',
          order: 39,
        },
        {
          adult: false,
          gender: 2,
          id: 4887,
          known_for_department: 'Diễn viên',
          name: 'Joe Grifasi',
          original_name: 'Joe Grifasi',
          popularity: 2.729,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ru4eQVcz4i6o9CzWnXmGGXjfpkN.jpg',
          cast_id: 90,
          character: 'Deputy Sheriff Duncan Homolka',
          credit_id: '57d3ed9692514160ae0036cb',
          order: 40,
        },
        {
          adult: false,
          gender: 2,
          id: 155535,
          known_for_department: 'Crew',
          name: 'Douglas Crosby',
          original_name: 'Douglas Crosby',
          popularity: 0.6,
          profile_path: null,
          cast_id: 91,
          character: "Mallory's Guard #1",
          credit_id: '57d3ede692514160ae0036fa',
          order: 41,
        },
        {
          adult: false,
          gender: 2,
          id: 42824,
          known_for_department: 'Diễn viên',
          name: 'Carl Ciarfalio',
          original_name: 'Carl Ciarfalio',
          popularity: 2.197,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yADROfK7uJkmd8p3GyjxH8WZqRL.jpg',
          cast_id: 92,
          character: "Mallory's Guard #2",
          credit_id: '57d3ee37c3a3685568003609',
          order: 42,
        },
        {
          adult: false,
          gender: 2,
          id: 3041,
          known_for_department: 'Diễn viên',
          name: 'Marshall Bell',
          original_name: 'Marshall Bell',
          popularity: 3.415,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8pZ12nmxnaB1EIxDxcp9znrubNM.jpg',
          cast_id: 93,
          character: 'Deputy #1',
          credit_id: '57d3ee8092514160ae003745',
          order: 43,
        },
        {
          adult: false,
          gender: 0,
          id: 3216,
          known_for_department: 'Diễn viên',
          name: 'Jim Carrane',
          original_name: 'Jim Carrane',
          popularity: 0.6,
          profile_path: null,
          cast_id: 94,
          character: 'Smithy',
          credit_id: '57d3eefec3a3685572003b1e',
          order: 44,
        },
        {
          adult: false,
          gender: 0,
          id: 3217,
          known_for_department: 'Diễn viên',
          name: 'Robert Swan',
          original_name: 'Robert Swan',
          popularity: 1.37,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gD2tRlaXI5dV8kR747dalapUKWi.jpg',
          cast_id: 95,
          character: 'Deputy Napalatoni',
          credit_id: '57d3ef4fc3a3685572003b3c',
          order: 45,
        },
        {
          adult: false,
          gender: 2,
          id: 3218,
          known_for_department: 'Diễn viên',
          name: 'Louis Lombardi',
          original_name: 'Louis Lombardi',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cYxbGCEf0mnsACuxCIX0faCjGUQ.jpg',
          cast_id: 96,
          character: 'Deputy Sparky',
          credit_id: '57d3eff1c3a368556a00399e',
          order: 46,
        },
        {
          adult: false,
          gender: 2,
          id: 13925,
          known_for_department: 'Diễn viên',
          name: 'Paul Dillon',
          original_name: 'Paul Dillon',
          popularity: 1.533,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tnCzILAe8EBBjPwADXUrzs9ESzD.jpg',
          cast_id: 97,
          character: 'Prison Inmate who breaks TV',
          credit_id: '5a5791a0c3a36825ae000945',
          order: 47,
        },
        {
          adult: false,
          gender: 2,
          id: 74487,
          known_for_department: 'Diễn viên',
          name: 'David Pasquesi',
          original_name: 'David Pasquesi',
          popularity: 1.433,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vlXVxJSH6ja8RPf1Bv6UTnFdyhq.jpg',
          cast_id: 98,
          character: 'Cameraman',
          credit_id: '5a5791b10e0a2669cb000a0e',
          order: 48,
        },
        {
          adult: false,
          gender: 2,
          id: 16433,
          known_for_department: 'Diễn viên',
          name: 'James Gammon',
          original_name: 'James Gammon',
          popularity: 3.657,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ars75g9cpq6fqOSLDo3voNkZcak.jpg',
          cast_id: 99,
          character: "Redneck's Buddy in Diner",
          credit_id: '5a5791d19251413aea000a12',
          order: 49,
        },
        {
          adult: false,
          gender: 2,
          id: 3229,
          known_for_department: 'Diễn viên',
          name: 'Arliss Howard',
          original_name: 'Arliss Howard',
          popularity: 2.141,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zDBEVA7Skrje3A8bmR2VOJRwkZc.jpg',
          cast_id: 100,
          character: 'Owen Traft',
          credit_id: '5a5792119251413af0000969',
          order: 50,
        },
        {
          adult: false,
          gender: 2,
          id: 19728,
          known_for_department: 'Diễn viên',
          name: 'Mark Harmon',
          original_name: 'Mark Harmon',
          popularity: 5.432,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lMqKPig7zBoGfou7wWf88sZEGHo.jpg',
          cast_id: 101,
          character: 'Mickey Knox in TV',
          credit_id: '5a5792269251413aea000a55',
          order: 51,
        },
        {
          adult: false,
          gender: 1,
          id: 106837,
          known_for_department: 'Diễn viên',
          name: 'Cory Everson',
          original_name: 'Cory Everson',
          popularity: 2.75,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ijOGlyqynxmdIkuVe6kFP2Rn3Qr.jpg',
          cast_id: 102,
          character: 'Mallory Knox in TV',
          credit_id: '5a579299c3a36825d9000907',
          order: 52,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 138,
          known_for_department: 'Directing',
          name: 'Quentin Tarantino',
          original_name: 'Quentin Tarantino',
          popularity: 11.294,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1gjcpAa99FAOWGnrUvHEXXsRs7o.jpg',
          credit_id: '52fe422bc3a36847f8009679',
          department: 'Biên kịch',
          job: 'Story',
        },
        {
          adult: false,
          gender: 1,
          id: 2324,
          known_for_department: 'Production',
          name: 'Heidi Levitt',
          original_name: 'Heidi Levitt',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pdssZWtmN07CUyq55qFxxNupap4.jpg',
          credit_id: '52fe422bc3a36847f8009667',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 149,
          known_for_department: 'Camera',
          name: 'Robert Richardson',
          original_name: 'Robert Richardson',
          popularity: 2.449,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lmJy31oZtN5l2VAGpkrt3xEXsxL.jpg',
          credit_id: '52fe422bc3a36847f8009643',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 3188,
          known_for_department: 'Art',
          name: 'Victor Kempster',
          original_name: 'Victor Kempster',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe422bc3a36847f8009649',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 2,
          id: 1152,
          known_for_department: 'Directing',
          name: 'Oliver Stone',
          original_name: 'Oliver Stone',
          popularity: 2.583,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nPFtjueZHmU56boVKXEvAoQOTWf.jpg',
          credit_id: '52fe422bc3a36847f8009619',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 1152,
          known_for_department: 'Directing',
          name: 'Oliver Stone',
          original_name: 'Oliver Stone',
          popularity: 2.583,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nPFtjueZHmU56boVKXEvAoQOTWf.jpg',
          credit_id: '52fe422bc3a36847f8009607',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 3180,
          known_for_department: 'Biên kịch',
          name: 'David Veloz',
          original_name: 'David Veloz',
          popularity: 0.656,
          profile_path: null,
          credit_id: '52fe422bc3a36847f800960d',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 3181,
          known_for_department: 'Production',
          name: 'Richard Rutowski',
          original_name: 'Richard Rutowski',
          popularity: 1.55,
          profile_path:
            'https://image.tmdb.org/t/p/w185/acojGQeEAcDpvKHgJOiEA67xCzN.jpg',
          credit_id: '52fe422bc3a36847f8009613',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 1,
          id: 3182,
          known_for_department: 'Production',
          name: 'Jane Hamsher',
          original_name: 'Jane Hamsher',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe422bc3a36847f800961f',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 3183,
          known_for_department: 'Production',
          name: 'Don Murphy',
          original_name: 'Don Murphy',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xX9mLKLbsnYhdRMrdpK2ULJIe0s.jpg',
          credit_id: '52fe422bc3a36847f8009625',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 3184,
          known_for_department: 'Production',
          name: 'Clayton Townsend',
          original_name: 'Clayton Townsend',
          popularity: 0.612,
          profile_path: null,
          credit_id: '52fe422bc3a36847f800962b',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 3185,
          known_for_department: 'Diễn viên',
          name: 'Leonard Cohen',
          original_name: 'Leonard Cohen',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cRHWtGOa7IOJWayAQM3FBLCM82x.jpg',
          credit_id: '52fe422bc3a36847f8009631',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 3186,
          known_for_department: 'Sound',
          name: 'Trent Reznor',
          original_name: 'Trent Reznor',
          popularity: 1.038,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gzvgK9ydCfW5Sh9tsEeYcYCnxrh.jpg',
          credit_id: '52fe422bc3a36847f8009637',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 3187,
          known_for_department: 'Sound',
          name: 'Brent Lewis',
          original_name: 'Brent Lewis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe422bc3a36847f800963d',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 0,
          id: 3190,
          known_for_department: 'Editing',
          name: 'Hank Corwin',
          original_name: 'Hank Corwin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe422bc3a36847f800964f',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 3189,
          known_for_department: 'Editing',
          name: 'Brian Berdan',
          original_name: 'Brian Berdan',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6XdyyjxRcWX1vhkcmoeTjzq04RY.jpg',
          credit_id: '52fe422bc3a36847f8009655',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 3191,
          known_for_department: 'Production',
          name: 'Risa Bramon Garcia',
          original_name: 'Risa Bramon Garcia',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe422bc3a36847f800965b',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 3192,
          known_for_department: 'Production',
          name: 'Billy Hopkins',
          original_name: 'Billy Hopkins',
          popularity: 0.927,
          profile_path: null,
          credit_id: '52fe422bc3a36847f8009661',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 3194,
          known_for_department: 'Sound',
          name: 'David Kneupper',
          original_name: 'David Kneupper',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe422bc3a36847f800966d',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 3193,
          known_for_department: 'Sound',
          name: 'Scott Martin Gershin',
          original_name: 'Scott Martin Gershin',
          popularity: 0.728,
          profile_path: null,
          credit_id: '52fe422bc3a36847f8009673',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 7857,
          known_for_department: 'Art',
          name: 'Merideth Boswell',
          original_name: 'Merideth Boswell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aac7292514127ea01dcc2',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 2,
          id: 10880,
          known_for_department: 'Art',
          name: 'Alan Tomkins',
          original_name: 'Alan Tomkins',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aac5f0e0a2630b802aa22',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 23788,
          known_for_department: 'Costume & Make-Up',
          name: 'Matthew W. Mungle',
          original_name: 'Matthew W. Mungle',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tqWimllnrZzZdi5Bdw7Wlrs5nnl.jpg',
          credit_id: '5a9aac9ec3a3680b99023452',
          department: 'Costume & Make-Up',
          job: 'Key Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 936467,
          known_for_department: 'Biên kịch',
          name: 'Raymond Mackintosh',
          original_name: 'Raymond Mackintosh',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aacf10e0a2630b802aacc',
          department: 'Costume & Make-Up',
          job: 'Makeup Effects Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 960585,
          known_for_department: 'Costume & Make-Up',
          name: 'Richard Hornung',
          original_name: 'Richard Hornung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aac540e0a2605e4022169',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 2,
          id: 1065720,
          known_for_department: 'Sound',
          name: 'Nicholas James',
          original_name: 'Nicholas James',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aac34c3a3680beb01e7c6',
          department: 'Sound',
          job: 'Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1323076,
          known_for_department: 'Costume & Make-Up',
          name: 'John E. Jackson',
          original_name: 'John E. Jackson',
          popularity: 0.702,
          profile_path: null,
          credit_id: '5a9aac88925141286d01db91',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 1352969,
          known_for_department: 'Sound',
          name: 'Wylie Stateman',
          original_name: 'Wylie Stateman',
          popularity: 0.734,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cnqFtKb2x6nrbbFFPgT9pM9GiHb.jpg',
          credit_id: '5a9aabe30e0a26061101fef2',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1364417,
          known_for_department: 'Sound',
          name: 'Christian P. Minkler',
          original_name: 'Christian P. Minkler',
          popularity: 0.859,
          profile_path: null,
          credit_id: '5a9aabb692514127ea01dc21',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1372880,
          known_for_department: 'Sound',
          name: 'Barney Cabral',
          original_name: 'Barney Cabral',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aac0f92514128af01d03e',
          department: 'Sound',
          job: 'Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1392081,
          known_for_department: 'Sound',
          name: 'Randy Kelley',
          original_name: 'Randy Kelley',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5a9aab8d0e0a2605f201dfe1',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1399141,
          known_for_department: 'Sound',
          name: 'Michael Minkler',
          original_name: 'Michael Minkler',
          popularity: 0.998,
          profile_path: null,
          credit_id: '5a9aabbfc3a3680b2d01adfa',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 1400072,
          known_for_department: 'Sound',
          name: 'Tom Fleischman',
          original_name: 'Tom Fleischman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aab8192514127ea01dbec',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 1408608,
          known_for_department: 'Sound',
          name: 'Mark Lanza',
          original_name: 'Mark Lanza',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aab970e0a26064901fd1c',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1417972,
          known_for_department: 'Sound',
          name: 'Michael D. Wilhoit',
          original_name: 'Michael D. Wilhoit',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aac05c3a3680b9601e58a',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1444908,
          known_for_department: 'Costume & Make-Up',
          name: 'Cydney Cornell',
          original_name: 'Cydney Cornell',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5a9aac7fc3a3680b9902342d',
          department: 'Costume & Make-Up',
          job: 'Hair Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 1444909,
          known_for_department: 'Costume & Make-Up',
          name: 'Melissa Yonkey',
          original_name: 'Melissa Yonkey',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7O1NlyiWOLdiJ43BOsxHFFAWRkY.jpg',
          credit_id: '5a9aacc192514128be01d64a',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1455291,
          known_for_department: 'Sound',
          name: 'Robert Batha',
          original_name: 'Robert Batha',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5a9aab720e0a2605e4022076',
          department: 'Sound',
          job: 'Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1551215,
          known_for_department: 'Sound',
          name: 'Peter J. Lehman',
          original_name: 'Peter J. Lehman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aaba2c3a3680b2d01ade8',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1603300,
          known_for_department: 'Costume & Make-Up',
          name: 'Gordon J. Smith',
          original_name: 'Gordon J. Smith',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aacb092514128cc01d87f',
          department: 'Costume & Make-Up',
          job: 'Makeup Effects Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1635458,
          known_for_department: 'Sound',
          name: 'David MacMillan',
          original_name: 'David MacMillan',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5a9aabab92514128af01cfe7',
          department: 'Sound',
          job: 'Sound Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1968458,
          known_for_department: 'Sound',
          name: 'Jeff Watts',
          original_name: 'Jeff Watts',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aabf192514128af01d025',
          department: 'Sound',
          job: 'Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1989411,
          known_for_department: 'Sound',
          name: 'Joseph Phillips',
          original_name: 'Joseph Phillips',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aabd70e0a2605d501f2d5',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1989412,
          known_for_department: 'Art',
          name: 'Margery Zweizig',
          original_name: 'Margery Zweizig',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aac68c3a3680b9601e60a',
          department: 'Art',
          job: 'Art Direction',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/91qfG6VaxRsCh1SbIi1w2vxknsL.jpg',
    belongs_to_collection: {
      id: 10194,
      name: 'Bộ sưu tập Câu Chuyện Đồ Chơi',
      poster_path: '/7G9915LfUQ2lVfwMEEhDsn3kT4B.jpg',
      backdrop_path: '/9FBwqcd9IRruEDUrTdcaafOMKUq.jpg',
    },
    budget: 90000000,
    genres: [
      { id: 16, name: 'Phim Hoạt Hình' },
      { id: 35, name: 'Phim Hài' },
      { id: 10751, name: 'Phim Gia Đình' },
    ],
    homepage: 'http://toystory.disney.com/toy-story-2',
    id: 863,
    imdb_id: 'tt0120363',
    original_language: 'en',
    original_title: 'Toy Story 2',
    overview:
      'Câu Chuyện Đồ Chơi 2 là cuộc phiêu lưu của Woody (Tom Hanks lồng tiếng) và Buzz Lightyear (Tim Allen) lại tiếp tục khi chủ nhân của chúng Andy (John Morris) đi tham dự trại hè và để mặc chúng ở nhà tự lo liệu. Woody không may bị một tay buôn bán đồ chơi đánh cắp. Buzz cùng các bạn đồ chơi bèn tìm cách giải cứu Woody. Mọi chuyện tưởng chừng thuận lợi nhưng trong khi bị giam giữ, Woody quen được Jessy - một tay "cowgirl". Thế là cả nhóm quyết định đưa luôn Jessy trở về nhà... sau khi trải qua bao khó khăn.',
    popularity: 126.245,
    poster_path:
      'https://image.tmdb.org/t/p/w342/xVhEI1WCgNCCa5I86AqiwuZoog3.jpg',
    production_companies: [
      {
        id: 3,
        logo_path: '/1TjvGVDMYsj6JBxOAkUHpPEwLf7.png',
        name: 'Pixar',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '1999-10-30',
    revenue: 497366869,
    runtime: 92,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'The toys are back!',
    title: 'Câu Chuyện Đồ Chơi 2',
    video: false,
    vote_average: 7.6,
    vote_count: 11124,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Disney + Pixar Toy Story 2 | Trailer',
          key: '450203324',
          site: 'Vimeo',
          size: 720,
          type: 'Trailer',
          official: false,
          published_at: '2020-08-21T18:00:03.000Z',
          id: '5ff13b45bd990c004473afe0',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Toy Story 2 (1999) Trailer',
          key: 'b75lZw8nkvo',
          published_at: '2015-08-13T03:36:05.000Z',
          site: 'YouTube',
          size: 360,
          type: 'Trailer',
          official: false,
          id: '58b79cb0c3a36835a3000f34',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Toy Story 2 (1999) Teaser',
          key: 'pQCXbqSDzR4',
          published_at: '2015-08-13T03:25:57.000Z',
          site: 'YouTube',
          size: 360,
          type: 'Teaser',
          official: false,
          id: '58b79cc29251412732000f61',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 31,
          known_for_department: 'Diễn viên',
          name: 'Tom Hanks',
          original_name: 'Tom Hanks',
          popularity: 18.458,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xndWFsBlClOJFRdhSt4NBwiPq2o.jpg',
          cast_id: 403,
          character: 'Woody (voice)',
          credit_id: '5ac0152ec3a368443f034084',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 12898,
          known_for_department: 'Diễn viên',
          name: 'Tim Allen',
          original_name: 'Tim Allen',
          popularity: 11.23,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6qlDjidQSKNcJFHzTXh0gQS83ub.jpg',
          cast_id: 404,
          character: 'Buzz Lightyear (voice)',
          credit_id: '5ac16ecdc3a3682db5010610',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 3234,
          known_for_department: 'Diễn viên',
          name: 'Joan Cusack',
          original_name: 'Joan Cusack',
          popularity: 8.182,
          profile_path:
            'https://image.tmdb.org/t/p/w185/69cfjfZFjVxfu2QbngnXOkipcyn.jpg',
          cast_id: 406,
          character: 'Jessie the Yodeling Cowgirl (voice)',
          credit_id: '5ac16f5a92514126be0110e6',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 7090,
          known_for_department: 'Diễn viên',
          name: 'Kelsey Grammer',
          original_name: 'Kelsey Grammer',
          popularity: 7.582,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cjUCogoFRnFKAgeyRmGGpekz0TF.jpg',
          cast_id: 405,
          character: 'Stinky Pete the Prospector (voice)',
          credit_id: '5ac16ef40e0a260c4d010867',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 7167,
          known_for_department: 'Diễn viên',
          name: 'Don Rickles',
          original_name: 'Don Rickles',
          popularity: 4.28,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iJLQV4dcbTUgxlWJakjDldzlMXS.jpg',
          cast_id: 21,
          character: 'Mr. Potato Head (voice)',
          credit_id: '52fe4284c3a36847f80250dd',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 12899,
          known_for_department: 'Diễn viên',
          name: 'Jim Varney',
          original_name: 'Jim Varney',
          popularity: 4.894,
          profile_path:
            'https://image.tmdb.org/t/p/w185/j2De8KaACIbi4IX8WfUZGmCW1k2.jpg',
          cast_id: 407,
          character: 'Slinky Dog (voice)',
          credit_id: '5ac56b360e0a2649710011dc',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 12900,
          known_for_department: 'Diễn viên',
          name: 'Wallace Shawn',
          original_name: 'Wallace Shawn',
          popularity: 8.141,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jviZU3Ae0vVKW6cYeEtjfxq2TWS.jpg',
          cast_id: 23,
          character: 'Rex the Green Dinosaur (voice)',
          credit_id: '52fe4284c3a36847f80250e5',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 7907,
          known_for_department: 'Diễn viên',
          name: 'John Ratzenberger',
          original_name: 'John Ratzenberger',
          popularity: 3.247,
          profile_path:
            'https://image.tmdb.org/t/p/w185/e5aNU09v1q6WYTx9pNzC7yjSpve.jpg',
          cast_id: 24,
          character: 'Hamm the Piggy Bank (voice)',
          credit_id: '52fe4284c3a36847f80250e9',
          order: 7,
        },
        {
          adult: false,
          gender: 1,
          id: 8873,
          known_for_department: 'Diễn viên',
          name: 'Annie Potts',
          original_name: 'Annie Potts',
          popularity: 3.866,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nugPVN28qOhOIoHawrDJ6fIfrxR.jpg',
          cast_id: 25,
          character: 'Bo Peep (voice)',
          credit_id: '52fe4284c3a36847f80250ed',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 4201,
          known_for_department: 'Diễn viên',
          name: 'Wayne Knight',
          original_name: 'Wayne Knight',
          popularity: 4.338,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xlGqbZjn48xAUa7eqTybZP360w0.jpg',
          cast_id: 26,
          character: 'Al McWhiggin (voice)',
          credit_id: '52fe4284c3a36847f80250f1',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 1116442,
          known_for_department: 'Diễn viên',
          name: 'John Morris',
          original_name: 'John Morris',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lSdNMhN3DoXEQJ37IeOD5mTMUQK.jpg',
          cast_id: 29,
          character: 'Andy (voice)',
          credit_id: '52fe4284c3a36847f80250f9',
          order: 10,
        },
        {
          adult: false,
          gender: 1,
          id: 12133,
          known_for_department: 'Diễn viên',
          name: 'Laurie Metcalf',
          original_name: 'Laurie Metcalf',
          popularity: 3.647,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ixABJoiZcGv2FRBtdno6i3bVAcY.jpg',
          cast_id: 30,
          character: "Andy's Mom (voice)",
          credit_id: '52fe4284c3a36847f80250fd',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 61964,
          known_for_department: 'Diễn viên',
          name: 'Estelle Harris',
          original_name: 'Estelle Harris',
          popularity: 5.848,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8L9umRwdjVs9CysJW24hhm2wNZ2.jpg',
          cast_id: 31,
          character: 'Mrs. Potato Head (voice)',
          credit_id: '52fe4284c3a36847f8025101',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 8655,
          known_for_department: 'Diễn viên',
          name: 'R. Lee Ermey',
          original_name: 'R. Lee Ermey',
          popularity: 2.933,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vOX3JHPLrKn2HJoPNguKcTN8Lk0.jpg',
          cast_id: 32,
          character: 'Army Sarge (voice)',
          credit_id: '52fe4284c3a36847f8025105',
          order: 13,
        },
        {
          adult: false,
          gender: 1,
          id: 63978,
          known_for_department: 'Diễn viên',
          name: 'Jodi Benson',
          original_name: 'Jodi Benson',
          popularity: 3.147,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2qX8QKHCaFWnCcIhb3VgZeX9HPz.jpg',
          cast_id: 33,
          character: 'Tour Guide Barbie / Barbie on Backpack (voice)',
          credit_id: '52fe4284c3a36847f8025109',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 123037,
          known_for_department: 'Diễn viên',
          name: 'Jonathan Harris',
          original_name: 'Jonathan Harris',
          popularity: 1.836,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ieLNe2cBJTJ2Aeb3QAXVp6w1sKu.jpg',
          cast_id: 37,
          character: 'Geri the Cleaner (voice)',
          credit_id: '55f99947c3a3686782002df3',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 7911,
          known_for_department: 'Biên kịch',
          name: 'Joe Ranft',
          original_name: 'Joe Ranft',
          popularity: 2.275,
          profile_path:
            'https://image.tmdb.org/t/p/w185/f1BoWC2JbCcfP1e5hKfGsxkHzVU.jpg',
          cast_id: 38,
          character: 'Wheezy the Penguin / Heimlich (voice)',
          credit_id: '55f99961c3a368677f002ed8',
          order: 16,
        },
        {
          adult: false,
          gender: 2,
          id: 7,
          known_for_department: 'Biên kịch',
          name: 'Andrew Stanton',
          original_name: 'Andrew Stanton',
          popularity: 4.731,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gasNitCwepbqNcYBmDHpsCgZH0I.jpg',
          cast_id: 39,
          character: 'Evil Emperor Zurg (voice)',
          credit_id: '55f99979c3a368678b0030dc',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 7882,
          known_for_department: 'Biên kịch',
          name: 'Jeff Pidgeon',
          original_name: 'Jeff Pidgeon',
          popularity: 1.705,
          profile_path:
            'https://image.tmdb.org/t/p/w185/t8LV9Y6s1qwQQNSRfo6GWEExffd.jpg',
          cast_id: 40,
          character: 'Green Aliens / Mr. Spell (voice)',
          credit_id: '55f9998fc3a368678e002c91',
          order: 18,
        },
        {
          adult: false,
          gender: 2,
          id: 19545,
          known_for_department: 'Diễn viên',
          name: 'Jack Angel',
          original_name: 'Jack Angel',
          popularity: 2.179,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5MsVwIULYJotUSbDs61uSJff7ei.jpg',
          cast_id: 380,
          character: 'Rocky Gibraltar / Shark (voice)',
          credit_id: '5ab17c7a0e0a2676cb016bad',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 78317,
          known_for_department: 'Diễn viên',
          name: 'Bob Bergen',
          original_name: 'Bob Bergen',
          popularity: 1.265,
          profile_path:
            'https://image.tmdb.org/t/p/w185/soDD1xiV3zVQWOJzVdJwfgIqzfe.jpg',
          cast_id: 381,
          character: 'Green Army Men (voice)',
          credit_id: '5ab17c8d0e0a2676d0016709',
          order: 20,
        },
        {
          adult: false,
          gender: 1,
          id: 30695,
          known_for_department: 'Diễn viên',
          name: 'Mary Kay Bergman',
          original_name: 'Mary Kay Bergman',
          popularity: 2.26,
          profile_path:
            'https://image.tmdb.org/t/p/w185/heTLLKqi4g7QqFa2JtOfoOGNpWh.jpg',
          cast_id: 382,
          character: 'Jessie - yodeling / additional voices (voice)',
          credit_id: '5ab17ca8c3a36861ac0144c0',
          order: 21,
        },
        {
          adult: false,
          gender: 0,
          id: 1232331,
          known_for_department: 'Diễn viên',
          name: 'Sheryl Bernstein',
          original_name: 'Sheryl Bernstein',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9YV2wsKdV0ZTczdMzUea8FKRsx4.jpg',
          cast_id: 383,
          character: '(voice)',
          credit_id: '5ab17cb592514111ca013d91',
          order: 22,
        },
        {
          adult: false,
          gender: 2,
          id: 70615,
          known_for_department: 'Diễn viên',
          name: 'Rodger Bumpass',
          original_name: 'Rodger Bumpass',
          popularity: 1.902,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lGQkw6adxqB6Hcm7VK8nVHbKupe.jpg',
          cast_id: 384,
          character: 'Clerk (voice)',
          credit_id: '5ab17cc292514111be0144a8',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 35219,
          known_for_department: 'Diễn viên',
          name: 'Corey Burton',
          original_name: 'Corey Burton',
          popularity: 3.409,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wcpFwdL7m01cZoBJiUSMQVakK2G.jpg',
          cast_id: 57,
          character: "Woody's Roundup Announcer (voice)",
          credit_id: '55f99ba1c3a368678b003121',
          order: 24,
        },
        {
          adult: false,
          gender: 0,
          id: 2003611,
          known_for_department: 'Diễn viên',
          name: 'Rachel Davey',
          original_name: 'Rachel Davey',
          popularity: 0.656,
          profile_path: null,
          cast_id: 385,
          character: '(voice)',
          credit_id: '5ab17cd192514111d00144c9',
          order: 25,
        },
        {
          adult: false,
          gender: 1,
          id: 73016,
          known_for_department: 'Diễn viên',
          name: 'Debi Derryberry',
          original_name: 'Debi Derryberry',
          popularity: 4.344,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aCVgHnvGBw7ssZA9kl1Pnr5pJjU.jpg',
          cast_id: 386,
          character: '(voice)',
          credit_id: '5ab17cdf0e0a2676c901565c',
          order: 26,
        },
        {
          adult: false,
          gender: 1,
          id: 2003612,
          known_for_department: 'Diễn viên',
          name: 'Jessica Evans',
          original_name: 'Jessica Evans',
          popularity: 0.728,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8SDxlZ9thwA0VYPpQyywbSKzgpV.jpg',
          cast_id: 387,
          character: 'Woman #2 (voice)',
          credit_id: '5ab17d290e0a2676ce015a80',
          order: 27,
        },
        {
          adult: false,
          gender: 2,
          id: 84213,
          known_for_department: 'Diễn viên',
          name: 'Bill Farmer',
          original_name: 'Bill Farmer',
          popularity: 2.959,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lhezx68R12s5Bsv7d77BrQb7tWA.jpg',
          cast_id: 388,
          character: 'Man #1 (voice)',
          credit_id: '5ab17d52c3a36861ac014553',
          order: 28,
        },
        {
          adult: false,
          gender: 2,
          id: 34737,
          known_for_department: 'Diễn viên',
          name: 'Pat Fraley',
          original_name: 'Pat Fraley',
          popularity: 0.985,
          profile_path:
            'https://image.tmdb.org/t/p/w185/snkbfNQ9JNUCEzG7SdRIR083P0u.jpg',
          cast_id: 389,
          character: 'Toy Store Buzz Lightyears (voice)',
          credit_id: '5ab17d600e0a2676c90156c4',
          order: 29,
        },
        {
          adult: false,
          gender: 2,
          id: 84495,
          known_for_department: 'Diễn viên',
          name: 'Jess Harnell',
          original_name: 'Jess Harnell',
          popularity: 1.48,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zQ2zg7PL3ut4JhfXMKSRV4FMnxR.jpg',
          cast_id: 390,
          character: 'Man #2 (voice)',
          credit_id: '5ab17d6b92514111d30143c6',
          order: 30,
        },
        {
          adult: false,
          gender: 2,
          id: 7879,
          known_for_department: 'Production',
          name: 'John Lasseter',
          original_name: 'John Lasseter',
          popularity: 2.341,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9EhRbLz6iLjpel7oAMX2Eoqlwht.jpg',
          cast_id: 58,
          character: "Blue Rock 'Em Sock 'Em Robot (voice)",
          credit_id: '55f99c079251410812002ccf',
          order: 31,
        },
        {
          adult: false,
          gender: 1,
          id: 1174402,
          known_for_department: 'Diễn viên',
          name: 'Nicolette Little',
          original_name: 'Nicolette Little',
          popularity: 0.6,
          profile_path: null,
          cast_id: 391,
          character: 'Little Girl at Yard Sale (voice)',
          credit_id: '5ab17d93c3a36861ac014594',
          order: 32,
        },
        {
          adult: false,
          gender: 1,
          id: 214701,
          known_for_department: 'Diễn viên',
          name: 'Sherry Lynn',
          original_name: 'Sherry Lynn',
          popularity: 1.278,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cp7SYig9JVbBWgc2YD4wEUNQGzh.jpg',
          cast_id: 234,
          character: 'Barbie Girl (voice)',
          credit_id: '59f54790c3a3682e0c00581e',
          order: 33,
        },
        {
          adult: false,
          gender: 1,
          id: 84493,
          known_for_department: 'Diễn viên',
          name: 'Mickie McGowan',
          original_name: 'Mickie McGowan',
          popularity: 5.276,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4K1HF10EvDjdaIoDAnWqFZjnmvk.jpg',
          cast_id: 59,
          character: 'Mom at Yard Sale (voice)',
          credit_id: '55f99c39925141080c002c26',
          order: 34,
        },
        {
          adult: false,
          gender: 2,
          id: 61969,
          known_for_department: 'Diễn viên',
          name: 'Phil Proctor',
          original_name: 'Phil Proctor',
          popularity: 1.015,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iLTvGROn3XvT0MPPspF2e3OsFCs.jpg',
          cast_id: 60,
          character: 'Sign-off Voice / Airline Rep / Mr. Konishi (voice)',
          credit_id: '55f99c66c3a368677d002cab',
          order: 35,
        },
        {
          adult: false,
          gender: 2,
          id: 157626,
          known_for_department: 'Diễn viên',
          name: 'Jan Rabson',
          original_name: 'Jan Rabson',
          popularity: 1.095,
          profile_path: null,
          cast_id: 393,
          character: 'Nhật Bảnese Businessman (voice)',
          credit_id: '5ab17df2c3a36861b9016560',
          order: 36,
        },
        {
          adult: false,
          gender: 1,
          id: 58899,
          known_for_department: 'Diễn viên',
          name: 'Carly Schroeder',
          original_name: 'Carly Schroeder',
          popularity: 1.099,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oMkfn2kBQIGjURHcUFUNTgo93jd.jpg',
          cast_id: 394,
          character: '(voice)',
          credit_id: '5ab17e00c3a36861af015426',
          order: 37,
        },
        {
          adult: false,
          gender: 1,
          id: 1229502,
          known_for_department: 'Diễn viên',
          name: 'Madylin Sweeten',
          original_name: 'Madylin Sweeten',
          popularity: 2.631,
          profile_path:
            'https://image.tmdb.org/t/p/w185/brGX4YYt4n7bXVJBGBYlLGNYYFZ.jpg',
          cast_id: 395,
          character: 'Woman #1 (voice)',
          credit_id: '5ab17e0c0e0a2676c901574d',
          order: 38,
        },
        {
          adult: false,
          gender: 0,
          id: 2003613,
          known_for_department: 'Diễn viên',
          name: 'Hannah Unkrich',
          original_name: 'Hannah Unkrich',
          popularity: 0.6,
          profile_path: null,
          cast_id: 396,
          character: 'Molly Davis (voice)',
          credit_id: '5ab17e170e0a2676db0145b7',
          order: 39,
        },
        {
          adult: false,
          gender: 2,
          id: 8,
          known_for_department: 'Directing',
          name: 'Lee Unkrich',
          original_name: 'Lee Unkrich',
          popularity: 3.289,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oeUkLlak2lqKRYZmJZZv5gI87Ok.jpg',
          cast_id: 61,
          character: "Red Rock 'Em Sock 'Em Robot (voice)",
          credit_id: '55f99c97925141080f002e8e',
          order: 40,
        },
        {
          adult: false,
          gender: 2,
          id: 1216382,
          known_for_department: 'Diễn viên',
          name: 'Andi Peters',
          original_name: 'Andi Peters',
          popularity: 1.614,
          profile_path:
            'https://image.tmdb.org/t/p/w185/s9JJ313rJLa4QFAW3UjRzSNBtQc.jpg',
          cast_id: 412,
          character: 'Baggage Handler (voice)',
          credit_id: '5e9ce0d2d18fb9001d9101a0',
          order: 41,
        },
        {
          adult: false,
          gender: 2,
          id: 21290,
          known_for_department: 'Diễn viên',
          name: 'Dave Foley',
          original_name: 'Dave Foley',
          popularity: 2.826,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8R7ERAiPMRy9EMfQYkZseKBuwI3.jpg',
          cast_id: 415,
          character: 'Flik the Ant (voice) (uncredited)',
          credit_id: '608e5e2dc439c0002921f0e1',
          order: 42,
        },
        {
          adult: false,
          gender: 2,
          id: 15831,
          known_for_department: 'Diễn viên',
          name: 'Frank Welker',
          original_name: 'Frank Welker',
          popularity: 6.965,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xXODQ5AX6pG4my8ieeEIuiAREXs.jpg',
          cast_id: 413,
          character: 'Bullseye / Buster (voice) ( uncredited)',
          credit_id: '5f0ce1981f98d100391b05a0',
          order: 43,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 7,
          known_for_department: 'Biên kịch',
          name: 'Andrew Stanton',
          original_name: 'Andrew Stanton',
          popularity: 4.731,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gasNitCwepbqNcYBmDHpsCgZH0I.jpg',
          credit_id: '52fe4284c3a36847f8025073',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 7,
          known_for_department: 'Biên kịch',
          name: 'Andrew Stanton',
          original_name: 'Andrew Stanton',
          popularity: 4.731,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gasNitCwepbqNcYBmDHpsCgZH0I.jpg',
          credit_id: '589465209251414271004c33',
          department: 'Biên kịch',
          job: 'Original Story',
        },
        {
          adult: false,
          gender: 2,
          id: 8,
          known_for_department: 'Directing',
          name: 'Lee Unkrich',
          original_name: 'Lee Unkrich',
          popularity: 3.289,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oeUkLlak2lqKRYZmJZZv5gI87Ok.jpg',
          credit_id: '52fe4284c3a36847f80250b5',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 8,
          known_for_department: 'Directing',
          name: 'Lee Unkrich',
          original_name: 'Lee Unkrich',
          popularity: 3.289,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oeUkLlak2lqKRYZmJZZv5gI87Ok.jpg',
          credit_id: '61af98071108a8005cede338',
          department: 'Directing',
          job: 'Co-Director',
        },
        {
          adult: false,
          gender: 2,
          id: 9,
          known_for_department: 'Production',
          name: 'Graham Walters',
          original_name: 'Graham Walters',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rmFFUsCJBjtl2xgsED6hODix9cy.jpg',
          credit_id: '5751af2a9251412b0f00291d',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 2,
          id: 11,
          known_for_department: 'Biên kịch',
          name: 'David Reynolds',
          original_name: 'David Reynolds',
          popularity: 1.281,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5iKtATPbLpv2lT7q9DPX2v2qPS1.jpg',
          credit_id: '5a82a49a0e0a26083e006edf',
          department: 'Crew',
          job: 'Additional Biên kịch',
        },
        {
          adult: false,
          gender: 2,
          id: 7879,
          known_for_department: 'Production',
          name: 'John Lasseter',
          original_name: 'John Lasseter',
          popularity: 2.341,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9EhRbLz6iLjpel7oAMX2Eoqlwht.jpg',
          credit_id: '52fe4284c3a36847f802506d',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 7879,
          known_for_department: 'Production',
          name: 'John Lasseter',
          original_name: 'John Lasseter',
          popularity: 2.341,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9EhRbLz6iLjpel7oAMX2Eoqlwht.jpg',
          credit_id: '5751add29251411a6c0029e4',
          department: 'Biên kịch',
          job: 'Original Story',
        },
        {
          adult: false,
          gender: 2,
          id: 12914,
          known_for_department: 'Editing',
          name: 'David Ian Salter',
          original_name: 'David Ian Salter',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aJDZtglLTbX0OEvvsdQYPUodBSQ.jpg',
          credit_id: '52fe4284c3a36847f80250af',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1918,
          known_for_department: 'Editing',
          name: 'Richard Halsey',
          original_name: 'Richard Halsey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946dd092514142710052c7',
          department: 'Editing',
          job: 'Additional Editing',
        },
        {
          adult: false,
          gender: 2,
          id: 2216,
          known_for_department: 'Sound',
          name: 'Gary Rydstrom',
          original_name: 'Gary Rydstrom',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1DoKaxoJlz6hV9bai43e07GxGQf.jpg',
          credit_id: '58946621c3a36840a7004f03',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 2216,
          known_for_department: 'Sound',
          name: 'Gary Rydstrom',
          original_name: 'Gary Rydstrom',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1DoKaxoJlz6hV9bai43e07GxGQf.jpg',
          credit_id: '58947045925141426e0059a8',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 1,
          id: 7880,
          known_for_department: 'Production',
          name: 'Kori Rae',
          original_name: 'Kori Rae',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hJzft4hMsnsditH3ObMzFyKR104.jpg',
          credit_id: '5ab178bb92514111be01413a',
          department: 'Visual Effects',
          job: 'Animation Manager',
        },
        {
          adult: false,
          gender: 1,
          id: 7881,
          known_for_department: 'Visual Effects',
          name: 'Jill Culton',
          original_name: 'Jill Culton',
          popularity: 0.832,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mtEH7qmhT4jJMWBukJ7G7ql5M7b.jpg',
          credit_id: '589467f7c3a36840a4004d71',
          department: 'Visual Effects',
          job: 'Character Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 7885,
          known_for_department: 'Sound',
          name: 'Randy Newman',
          original_name: 'Randy Newman',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/u4b5Jaqyd5QAl407Zf3PHEf1HWD.jpg',
          credit_id: '5e9033e24a4bf6001553efc8',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 7885,
          known_for_department: 'Sound',
          name: 'Randy Newman',
          original_name: 'Randy Newman',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/u4b5Jaqyd5QAl407Zf3PHEf1HWD.jpg',
          credit_id: '589482249251414271006470',
          department: 'Sound',
          job: 'Orchestrator',
        },
        {
          adult: false,
          gender: 2,
          id: 7886,
          known_for_department: 'Editing',
          name: 'Jim Stewart',
          original_name: 'Jim Stewart',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946db9925141426c0055d4',
          department: 'Editing',
          job: 'Additional Editing',
        },
        {
          adult: false,
          gender: 2,
          id: 7888,
          known_for_department: 'Art',
          name: 'Harley Jessup',
          original_name: 'Harley Jessup',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ukDqqxb9jmVdzkMLjlDGfb2xcu9.jpg',
          credit_id: '589468409251414275004dab',
          department: 'Visual Effects',
          job: 'Visual Development',
        },
        {
          adult: false,
          gender: 2,
          id: 7892,
          known_for_department: 'Crew',
          name: 'Glenn McQueen',
          original_name: 'Glenn McQueen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589465a1925141427e004bb0',
          department: 'Crew',
          job: 'Supervising Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 7893,
          known_for_department: 'Visual Effects',
          name: 'Rich Quade',
          original_name: 'Rich Quade',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946bd9c3a36840a2005228',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 7894,
          known_for_department: 'Lighting',
          name: 'Jean-Claude Kalache',
          original_name: 'Jean-Claude Kalache',
          popularity: 0.92,
          profile_path: null,
          credit_id: '5722978792514176da000397',
          department: 'Lighting',
          job: 'Lighting Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 7897,
          known_for_department: 'Visual Effects',
          name: 'Eben Ostby',
          original_name: 'Eben Ostby',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab162eac3a36861b3012aec',
          department: 'Visual Effects',
          job: 'Character Modelling Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 7898,
          known_for_department: 'Costume & Make-Up',
          name: 'Sophie Vincelette',
          original_name: 'Sophie Vincelette',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589468dfc3a36840a70050e0',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 1,
          id: 7902,
          known_for_department: 'Production',
          name: 'Ruth Lambert',
          original_name: 'Ruth Lambert',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4284c3a36847f80250c1',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 1,
          id: 7903,
          known_for_department: 'Production',
          name: 'Mary Hidalgo',
          original_name: 'Mary Hidalgo',
          popularity: 1.052,
          profile_path: null,
          credit_id: '52fe4284c3a36847f80250bb',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 7910,
          known_for_department: 'Diễn viên',
          name: 'Samuel Lord Black',
          original_name: 'Samuel Lord Black',
          popularity: 0.728,
          profile_path: null,
          credit_id: '5ab167e70e0a2676ce013a28',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 2,
          id: 7918,
          known_for_department: 'Diễn viên',
          name: 'Bud Luckey',
          original_name: 'Bud Luckey',
          popularity: 1.712,
          profile_path:
            'https://image.tmdb.org/t/p/w185/csLjHwg7x1OFTiHjJAPpqNjjDiH.jpg',
          credit_id: '58946806c3a36840ab004e14',
          department: 'Visual Effects',
          job: 'Character Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 7921,
          known_for_department: 'Art',
          name: 'Ken Mitchroney',
          original_name: 'Ken Mitchroney',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946816c3a368409f004d6b',
          department: 'Visual Effects',
          job: 'Character Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 7929,
          known_for_department: 'Visual Effects',
          name: 'Angus MacLane',
          original_name: 'Angus MacLane',
          popularity: 0.66,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aVjfb4A3Nms5JFyYP7yqx5s7YtQ.jpg',
          credit_id: '572f6e65c3a36874eb0006b0',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 7942,
          known_for_department: 'Visual Effects',
          name: 'Bryn Imagire',
          original_name: 'Bryn Imagire',
          popularity: 0.989,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jvEWh6td2p4R1FVK2Rod4TMXY0p.jpg',
          credit_id: '572b81d6c3a36848120030c7',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 7942,
          known_for_department: 'Visual Effects',
          name: 'Bryn Imagire',
          original_name: 'Bryn Imagire',
          popularity: 0.989,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jvEWh6td2p4R1FVK2Rod4TMXY0p.jpg',
          credit_id: '5894676cc3a368409f004d0e',
          department: 'Visual Effects',
          job: 'Shading',
        },
        {
          adult: false,
          gender: 0,
          id: 7943,
          known_for_department: 'Visual Effects',
          name: 'Glenn Kim',
          original_name: 'Glenn Kim',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5894679ec3a36840ab004dc5',
          department: 'Visual Effects',
          job: 'CG Painter',
        },
        {
          adult: false,
          gender: 1,
          id: 7944,
          known_for_department: 'Visual Effects',
          name: 'Laura Phillips',
          original_name: 'Laura Phillips',
          popularity: 0.6,
          profile_path: null,
          credit_id: '572f677bc3a3682faa000adf',
          department: 'Visual Effects',
          job: 'CG Painter',
        },
        {
          adult: false,
          gender: 0,
          id: 7948,
          known_for_department: 'Visual Effects',
          name: 'Yvonne Herbst',
          original_name: 'Yvonne Herbst',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946797925141427800527b',
          department: 'Visual Effects',
          job: 'CG Painter',
        },
        {
          adult: false,
          gender: 0,
          id: 7949,
          known_for_department: 'Visual Effects',
          name: 'Robin Cooper',
          original_name: 'Robin Cooper',
          popularity: 0.694,
          profile_path: null,
          credit_id: '572e2541c3a3680fe50035d8',
          department: 'Visual Effects',
          job: 'CG Painter',
        },
        {
          adult: false,
          gender: 0,
          id: 7952,
          known_for_department: 'Visual Effects',
          name: 'Randy Berrett',
          original_name: 'Randy Berrett',
          popularity: 0.828,
          profile_path: null,
          credit_id: '57214ef0c3a3681193000f9e',
          department: 'Visual Effects',
          job: 'CG Painter',
        },
        {
          adult: false,
          gender: 0,
          id: 7952,
          known_for_department: 'Visual Effects',
          name: 'Randy Berrett',
          original_name: 'Randy Berrett',
          popularity: 0.828,
          profile_path: null,
          credit_id: '589467d4c3a36840b1004fbe',
          department: 'Visual Effects',
          job: 'Character Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 7954,
          known_for_department: 'Crew',
          name: 'Gary Schultz',
          original_name: 'Gary Schultz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1679692514111d30125bf',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 7956,
          known_for_department: 'Visual Effects',
          name: 'Nathaniel McLaughlin',
          original_name: 'Nathaniel McLaughlin',
          popularity: 0.84,
          profile_path: null,
          credit_id: '5894680ec3a36840b1004ff0',
          department: 'Visual Effects',
          job: 'Character Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 7960,
          known_for_department: 'Art',
          name: 'Jerome Ranft',
          original_name: 'Jerome Ranft',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/76XFeM9FdbGkd0mxkEMstQu6na2.jpg',
          credit_id: '589467bac3a36840b500482c',
          department: 'Art',
          job: 'Sculptor',
        },
        {
          adult: false,
          gender: 0,
          id: 7961,
          known_for_department: 'Art',
          name: 'Norm DeCarlo',
          original_name: 'Norm DeCarlo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589467c3925141427e004d32',
          department: 'Art',
          job: 'Sculptor',
        },
        {
          adult: false,
          gender: 0,
          id: 7975,
          known_for_department: 'Camera',
          name: 'Patrick Lin',
          original_name: 'Patrick Lin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16405c3a36861a3012319',
          department: 'Crew',
          job: 'Sequence Leads',
        },
        {
          adult: false,
          gender: 0,
          id: 7978,
          known_for_department: 'Camera',
          name: 'Shawn Brennan',
          original_name: 'Shawn Brennan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab163e50e0a2676d8012d83',
          department: 'Crew',
          job: 'Sequence Leads',
        },
        {
          adult: false,
          gender: 0,
          id: 7979,
          known_for_department: 'Directing',
          name: 'Gregg Olsson',
          original_name: 'Gregg Olsson',
          popularity: 1.96,
          profile_path: null,
          credit_id: '5ab164140e0a2676d8012df2',
          department: 'Crew',
          job: 'Sequence Leads',
        },
        {
          adult: false,
          gender: 0,
          id: 7980,
          known_for_department: 'Directing',
          name: 'Derek Williams',
          original_name: 'Derek Williams',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5750ccbb925141088c00044e',
          department: 'Directing',
          job: 'Layout',
        },
        {
          adult: false,
          gender: 0,
          id: 7980,
          known_for_department: 'Directing',
          name: 'Derek Williams',
          original_name: 'Derek Williams',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589468e8c3a36840a4004e09',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 2,
          id: 7981,
          known_for_department: 'Directing',
          name: 'Robert Anderson',
          original_name: 'Robert Anderson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5894688f9251414271004ed1',
          department: 'Directing',
          job: 'Layout',
        },
        {
          adult: false,
          gender: 0,
          id: 7984,
          known_for_department: 'Directing',
          name: 'Mark Sanford',
          original_name: 'Mark Sanford',
          popularity: 0.6,
          profile_path: null,
          credit_id: '576d6b309251414105001a04',
          department: 'Directing',
          job: 'Layout',
        },
        {
          adult: false,
          gender: 0,
          id: 7988,
          known_for_department: 'Camera',
          name: 'Jeremy Lasky',
          original_name: 'Jeremy Lasky',
          popularity: 0.772,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cLCaRu88SE70pwGsRNsNGszeulq.jpg',
          credit_id: '5ab163f60e0a2676db011eae',
          department: 'Crew',
          job: 'Sequence Leads',
        },
        {
          adult: false,
          gender: 0,
          id: 7995,
          known_for_department: 'Visual Effects',
          name: 'Billy Merritt',
          original_name: 'Billy Merritt',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946b5a925141428000527b',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 7996,
          known_for_department: 'Visual Effects',
          name: 'Brett Pulliam',
          original_name: 'Brett Pulliam',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946bd0925141427a004bee',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 7998,
          known_for_department: 'Diễn viên',
          name: "Bret 'Brook' Parker",
          original_name: "Bret 'Brook' Parker",
          popularity: 1.294,
          profile_path:
            'https://image.tmdb.org/t/p/w185/A1Bz3MJwMOkoCQSjHCGN0Z7mlYC.jpg',
          credit_id: '58946b97925141427800558b',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 7999,
          known_for_department: 'Visual Effects',
          name: 'Gini Cruz Santos',
          original_name: 'Gini Cruz Santos',
          popularity: 0.968,
          profile_path: null,
          credit_id: '58946c16925141426c0054c0',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8002,
          known_for_department: 'Art',
          name: 'Jon Childress Farmer',
          original_name: 'Jon Childress Farmer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589468cc925141428000508f',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 8007,
          known_for_department: 'Costume & Make-Up',
          name: 'David Eisenmann',
          original_name: 'David Eisenmann',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589465c5c3a36840ab004c96',
          department: 'Costume & Make-Up',
          job: 'Set Dressing Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 8009,
          known_for_department: 'Visual Effects',
          name: 'Sarah Jo Helton',
          original_name: 'Sarah Jo Helton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab167bc0e0a2676d5014400',
          department: 'Crew',
          job: 'Schedule Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 8010,
          known_for_department: 'Visual Effects',
          name: 'Doug Sweetland',
          original_name: 'Doug Sweetland',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zYxgikK0IBkMUmUBXBppJJDK4ZD.jpg',
          credit_id: '58946c3b92514142780055fa',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 8011,
          known_for_department: 'Visual Effects',
          name: 'Scott Clark',
          original_name: 'Scott Clark',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589469db925141426e0054a1',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8013,
          known_for_department: 'Visual Effects',
          name: 'Andrew Gordon',
          original_name: 'Andrew Gordon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '576eb2fec3a3683c24004494',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8015,
          known_for_department: 'Visual Effects',
          name: 'Shawn Krause',
          original_name: 'Shawn Krause',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1659892514111be0121d5',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8017,
          known_for_department: 'Visual Effects',
          name: 'Jeff Pratt',
          original_name: 'Jeff Pratt',
          popularity: 1.4,
          profile_path: null,
          credit_id: '58946bc0c3a36840ab0050cb',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8018,
          known_for_department: 'Visual Effects',
          name: 'David DeVan',
          original_name: 'David DeVan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946a03925141426e0054d3',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8019,
          known_for_department: 'Visual Effects',
          name: 'Stephen Gregory',
          original_name: 'Stephen Gregory',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946a60c3a36840a70051e8',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8020,
          known_for_department: 'Visual Effects',
          name: 'John Kahrs',
          original_name: 'John Kahrs',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4rIHgaFUG5pMiqawXKNiLe9GXSj.jpg',
          credit_id: '58946ae2c3a36840a7005244',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8021,
          known_for_department: 'Visual Effects',
          name: 'Bobby Podesta',
          original_name: 'Bobby Podesta',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uGUi8AUJFIyvRgEnQQlTI7BV0Fv.jpg',
          credit_id: '58946bb8c3a36840a2005212',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 8023,
          known_for_department: 'Directing',
          name: 'Kyle Balda',
          original_name: 'Kyle Balda',
          popularity: 2.077,
          profile_path: null,
          credit_id: '58946911c3a36840ab004ec9',
          department: 'Visual Effects',
          job: 'Animation Director',
        },
        {
          adult: false,
          gender: 0,
          id: 8024,
          known_for_department: 'Visual Effects',
          name: 'Stephen Barnes',
          original_name: 'Stephen Barnes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5894699b92514142780053dd',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8025,
          known_for_department: 'Visual Effects',
          name: 'Michael Berenstein',
          original_name: 'Michael Berenstein',
          popularity: 0.98,
          profile_path: null,
          credit_id: '589469abc3a36840ab004f3f',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8026,
          known_for_department: 'Visual Effects',
          name: 'Brett Coderre',
          original_name: 'Brett Coderre',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589469e4c3a36840a4004eaf',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 8029,
          known_for_department: 'Visual Effects',
          name: 'Jimmy Hayward',
          original_name: 'Jimmy Hayward',
          popularity: 0.648,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iUPWT3m14xpl3WSLm8LblKHRmwy.jpg',
          credit_id: '58946a67925141426e00552e',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8030,
          known_for_department: 'Visual Effects',
          name: 'Nancy Kato',
          original_name: 'Nancy Kato',
          popularity: 0.84,
          profile_path: null,
          credit_id: '58946aeb9251414271005091',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 8031,
          known_for_department: 'Visual Effects',
          name: 'Bobby Beck',
          original_name: 'Bobby Beck',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589469a39251414271004f96',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8033,
          known_for_department: 'Visual Effects',
          name: 'Tim Crawfurd',
          original_name: 'Tim Crawfurd',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589469fbc3a36840a7005192',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8034,
          known_for_department: 'Visual Effects',
          name: 'Ike Feldman',
          original_name: 'Ike Feldman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946a57925141426e005524',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8035,
          known_for_department: 'Visual Effects',
          name: 'Karen Kiser',
          original_name: 'Karen Kiser',
          popularity: 1.22,
          profile_path: null,
          credit_id: '5ab17889c3a36861b3014f67',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8036,
          known_for_department: 'Visual Effects',
          name: 'Wendell Lee',
          original_name: 'Wendell Lee',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946b0c92514142710050a3',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8037,
          known_for_department: 'Visual Effects',
          name: 'Daniel Mason',
          original_name: 'Daniel Mason',
          popularity: 0.696,
          profile_path: null,
          credit_id: '58946b36925141426c005424',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 8039,
          known_for_department: 'Visual Effects',
          name: 'James Ford Murphy',
          original_name: 'James Ford Murphy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946b7bc3a36840ab005098',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8041,
          known_for_department: 'Visual Effects',
          name: 'Robert H. Russ',
          original_name: 'Robert H. Russ',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946c0dc3a36840b5004b12',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8043,
          known_for_department: 'Visual Effects',
          name: 'Patty Kihm Stevenson',
          original_name: 'Patty Kihm Stevenson',
          popularity: 0.84,
          profile_path: null,
          credit_id: '58946af3c3a36840a7005255',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8044,
          known_for_department: 'Visual Effects',
          name: 'David Tart',
          original_name: 'David Tart',
          popularity: 0.652,
          profile_path: null,
          credit_id: '58946c49925141427e005040',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8045,
          known_for_department: 'Visual Effects',
          name: 'Jon Mead',
          original_name: 'Jon Mead',
          popularity: 0.98,
          profile_path: null,
          credit_id: '58946b5292514142710050ec',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8047,
          known_for_department: 'Visual Effects',
          name: 'Peter Nash',
          original_name: 'Peter Nash',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946b83c3a36840b5004abd',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 8048,
          known_for_department: 'Visual Effects',
          name: 'Sanjay Patel',
          original_name: 'Sanjay Patel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946bafc3a36840a2005208',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8050,
          known_for_department: 'Visual Effects',
          name: 'Alan Sperling',
          original_name: 'Alan Sperling',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946c29925141426e00568e',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8051,
          known_for_department: 'Visual Effects',
          name: 'Ross Stevenson',
          original_name: 'Ross Stevenson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946c32c3a36840b80052a3',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8052,
          known_for_department: 'Visual Effects',
          name: 'J. Warren Trezevant',
          original_name: 'J. Warren Trezevant',
          popularity: 0.728,
          profile_path: null,
          credit_id: '58946c54c3a36840a200527f',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 8054,
          known_for_department: 'Directing',
          name: 'Adam Wood',
          original_name: 'Adam Wood',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946c6ec3a36840a7005368',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 8055,
          known_for_department: 'Visual Effects',
          name: 'Tasha Wedeen',
          original_name: 'Tasha Wedeen',
          popularity: 0.661,
          profile_path: null,
          credit_id: '58946c65c3a36840a400508b',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8056,
          known_for_department: 'Visual Effects',
          name: 'Kureha Yokoo',
          original_name: 'Kureha Yokoo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946c82925141426e0056c3',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 8058,
          known_for_department: 'Visual Effects',
          name: 'Paul Mendoza',
          original_name: 'Paul Mendoza',
          popularity: 0.98,
          profile_path: null,
          credit_id: '58946c8fc3a36840a40050a7',
          department: 'Visual Effects',
          job: 'Fix Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 8059,
          known_for_department: 'Visual Effects',
          name: 'Jenni Tsoi',
          original_name: 'Jenni Tsoi',
          popularity: 1.473,
          profile_path: null,
          credit_id: '5ab178a90e0a2676de016989',
          department: 'Visual Effects',
          job: 'Animation Fix Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 8063,
          known_for_department: 'Editing',
          name: 'Ken Schretzmann',
          original_name: 'Ken Schretzmann',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946dc4925141427500517b',
          department: 'Editing',
          job: 'Additional Editing',
        },
        {
          adult: false,
          gender: 0,
          id: 8064,
          known_for_department: 'Editing',
          name: 'Robert Grahamjones',
          original_name: 'Robert Grahamjones',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946d0ac3a36840b5004bc3',
          department: 'Crew',
          job: 'Second Film Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 8065,
          known_for_department: 'Editing',
          name: 'Torbin Xan Bullock',
          original_name: 'Torbin Xan Bullock',
          popularity: 0.98,
          profile_path: null,
          credit_id: '58946e0292514142750051ab',
          department: 'Editing',
          job: 'Additional Editorial Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 8066,
          known_for_department: 'Editing',
          name: 'Katherine Ringgold',
          original_name: 'Katherine Ringgold',
          popularity: 0.65,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nTzaTCurvdA15J4j3C70jKqHJ12.jpg',
          credit_id: '58946e5f92514142780057a7',
          department: 'Editing',
          job: 'Additional Editorial Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 8071,
          known_for_department: 'Editing',
          name: 'Axel Geddes',
          original_name: 'Axel Geddes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946e24925141428000548c',
          department: 'Editing',
          job: 'Additional Editorial Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 8073,
          known_for_department: 'Editing',
          name: 'Chris Vallance',
          original_name: 'Chris Vallance',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946e1c92514142750051bf',
          department: 'Editing',
          job: 'Additional Editorial Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 8074,
          known_for_department: 'Editing',
          name: 'Mark Yeager',
          original_name: 'Mark Yeager',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946e7ec3a36840a2005407',
          department: 'Editing',
          job: 'Additional Editorial Assistant',
        },
        {
          adult: false,
          gender: 2,
          id: 8075,
          known_for_department: 'Editing',
          name: 'Luis Alvarez y Alvarez',
          original_name: 'Luis Alvarez y Alvarez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946dfa92514142710052de',
          department: 'Editing',
          job: 'Additional Editorial Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 8076,
          known_for_department: 'Sound',
          name: 'Jack Curtis Dubowsky',
          original_name: 'Jack Curtis Dubowsky',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946e0cc3a368409f0051f0',
          department: 'Editing',
          job: 'Additional Editorial Assistant',
        },
        {
          adult: false,
          gender: 2,
          id: 8085,
          known_for_department: 'Editing',
          name: 'Christian Hoffman',
          original_name: 'Christian Hoffman',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5ab1677f9251417d3600e3dc',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 2,
          id: 8085,
          known_for_department: 'Editing',
          name: 'Christian Hoffman',
          original_name: 'Christian Hoffman',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5ab16334c3a36861b5013777',
          department: 'Lighting',
          job: 'Master Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 8086,
          known_for_department: 'Visual Effects',
          name: 'Mark Adams',
          original_name: 'Mark Adams',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1620c0e0a2676d5013701',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 8087,
          known_for_department: 'Visual Effects',
          name: 'James Bancroft',
          original_name: 'James Bancroft',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1622cc3a36861a80124ca',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 8088,
          known_for_department: 'Visual Effects',
          name: 'Paul Aichele',
          original_name: 'Paul Aichele',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab162160e0a2676cb013d79',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 8089,
          known_for_department: 'Visual Effects',
          name: 'Jason Bickerstaff',
          original_name: 'Jason Bickerstaff',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab17777c3a368619e013698',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 8096,
          known_for_department: 'Visual Effects',
          name: 'Daniel McCoy',
          original_name: 'Daniel McCoy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1792b92514111d001419b',
          department: 'Visual Effects',
          job: 'Shading',
        },
        {
          adult: false,
          gender: 0,
          id: 8097,
          known_for_department: 'Visual Effects',
          name: 'Ben Jordan',
          original_name: 'Ben Jordan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab178fa0e0a2676db0141c7',
          department: 'Visual Effects',
          job: 'Shading',
        },
        {
          adult: false,
          gender: 0,
          id: 8100,
          known_for_department: 'Visual Effects',
          name: 'David Batte',
          original_name: 'David Batte',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab178d30e0a2676de0169b6',
          department: 'Visual Effects',
          job: 'Shading',
        },
        {
          adult: false,
          gender: 0,
          id: 8104,
          known_for_department: 'Lighting',
          name: 'Janet Lucroy',
          original_name: 'Janet Lucroy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab177e0c3a36861a30143ca',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 8105,
          known_for_department: 'Lighting',
          name: 'Joyce Powell',
          original_name: 'Joyce Powell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16369c3a36861a30121e8',
          department: 'Lighting',
          job: 'Master Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 8106,
          known_for_department: 'Lighting',
          name: 'Lauren Alpert',
          original_name: 'Lauren Alpert',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1622292514111c7011cf4',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 8106,
          known_for_department: 'Lighting',
          name: 'Lauren Alpert',
          original_name: 'Lauren Alpert',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab163000e0a2676de01402e',
          department: 'Lighting',
          job: 'Master Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 8124,
          known_for_department: 'Crew',
          name: 'Brad Andalman',
          original_name: 'Brad Andalman',
          popularity: 1.048,
          profile_path: null,
          credit_id: '5ab16dcd92514111ca012cef',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 8125,
          known_for_department: 'Crew',
          name: 'Rob Cook',
          original_name: 'Rob Cook',
          popularity: 0.84,
          profile_path: null,
          credit_id: '5ab1607792514111be011785',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 8126,
          known_for_department: 'Crew',
          name: 'Bena Currin',
          original_name: 'Bena Currin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16dee0e0a2676d80142e7',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 8127,
          known_for_department: 'Crew',
          name: 'Thomas Hahn',
          original_name: 'Thomas Hahn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16df892514111c70135b0',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 8128,
          known_for_department: 'Crew',
          name: 'John Alex',
          original_name: 'John Alex',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16dc30e0a2676ce01476a',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 8129,
          known_for_department: 'Crew',
          name: 'Ronen Barzel',
          original_name: 'Ronen Barzel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16dd8c3a36861af014187',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 8130,
          known_for_department: 'Crew',
          name: 'Tom Duff',
          original_name: 'Tom Duff',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1608a92514111ca0111f9',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 8134,
          known_for_department: 'Camera',
          name: 'Perrin Cutting',
          original_name: 'Perrin Cutting',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946f8bc3a36840ab005375',
          department: 'Camera',
          job: 'Camera Department Manager',
        },
        {
          adult: false,
          gender: 2,
          id: 8135,
          known_for_department: 'Camera',
          name: 'Louis Rivera',
          original_name: 'Louis Rivera',
          popularity: 0.766,
          profile_path: null,
          credit_id: '58946f98925141426c005751',
          department: 'Camera',
          job: 'Camera Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 8137,
          known_for_department: 'Crew',
          name: 'Drew Rogge',
          original_name: 'Drew Rogge',
          popularity: 0.84,
          profile_path: null,
          credit_id: '5ab176c792514111ca013895',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 8138,
          known_for_department: 'Camera',
          name: 'Don Conway',
          original_name: 'Don Conway',
          popularity: 0.6,
          profile_path: null,
          credit_id: '574f14a39251415c9200007d',
          department: 'Camera',
          job: 'Camera Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 8139,
          known_for_department: 'Crew',
          name: 'David DiFrancesco',
          original_name: 'David DiFrancesco',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16d79c3a36861b5014cb4',
          department: 'Crew',
          job: 'Photoscience Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 8142,
          known_for_department: 'Production',
          name: 'Catherine Roehl',
          original_name: 'Catherine Roehl',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946fbb92514142800055c9',
          department: 'Production',
          job: 'Production Accountant',
        },
        {
          adult: false,
          gender: 0,
          id: 8150,
          known_for_department: 'Crew',
          name: 'Erik Forman',
          original_name: 'Erik Forman',
          popularity: 0.603,
          profile_path: null,
          credit_id: '5ab192480e0a2634d70004c4',
          department: 'Crew',
          job: 'Information Systems Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 8153,
          known_for_department: 'Crew',
          name: 'Paul Cichocki',
          original_name: 'Paul Cichocki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5751aed2c3a3686b870011e1',
          department: 'Crew',
          job: 'Post Production Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 8157,
          known_for_department: 'Sound',
          name: 'Doc Kane',
          original_name: 'Doc Kane',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5ab1783d9251417d36010003',
          department: 'Sound',
          job: 'ADR & Dubbing',
        },
        {
          adult: false,
          gender: 2,
          id: 8158,
          known_for_department: 'Sound',
          name: 'Michael Silvers',
          original_name: 'Michael Silvers',
          popularity: 0.996,
          profile_path: null,
          credit_id: '58948125c3a36840b5005cc7',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 8159,
          known_for_department: 'Sound',
          name: 'Shannon Mills',
          original_name: 'Shannon Mills',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5894814992514142710063c3',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 8160,
          known_for_department: 'Sound',
          name: 'Dennie Thorpe',
          original_name: 'Dennie Thorpe',
          popularity: 1.166,
          profile_path: null,
          credit_id: '5ab178530e0a2676d50160b9',
          department: 'Sound',
          job: 'Foley',
        },
        {
          adult: false,
          gender: 0,
          id: 8163,
          known_for_department: 'Sound',
          name: 'Jana Vance',
          original_name: 'Jana Vance',
          popularity: 0.667,
          profile_path: null,
          credit_id: '5ab1785dc3a36861af014f5d',
          department: 'Sound',
          job: 'Foley',
        },
        {
          adult: false,
          gender: 2,
          id: 8172,
          known_for_department: 'Sound',
          name: 'Bruno Coon',
          original_name: 'Bruno Coon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589481aec3a36840a2006669',
          department: 'Sound',
          job: 'Supervising Music Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 12890,
          known_for_department: 'Biên kịch',
          name: 'Pete Docter',
          original_name: 'Pete Docter',
          popularity: 2.86,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rrAW10FlcOjqMllSwNBrFjfUT4k.jpg',
          credit_id: '5751adeb9251413be80011c4',
          department: 'Biên kịch',
          job: 'Original Story',
        },
        {
          adult: false,
          gender: 2,
          id: 12905,
          known_for_department: 'Biên kịch',
          name: 'Ash Brannon',
          original_name: 'Ash Brannon',
          popularity: 0.921,
          profile_path:
            'https://image.tmdb.org/t/p/w185/meH6AhBnCyX4w0lBFvRQWDJmvjv.jpg',
          credit_id: '589469b3c3a36840a700515c',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 12905,
          known_for_department: 'Biên kịch',
          name: 'Ash Brannon',
          original_name: 'Ash Brannon',
          popularity: 0.921,
          profile_path:
            'https://image.tmdb.org/t/p/w185/meH6AhBnCyX4w0lBFvRQWDJmvjv.jpg',
          credit_id: '5751ae02c3a3683772002b74',
          department: 'Biên kịch',
          job: 'Original Story',
        },
        {
          adult: false,
          gender: 2,
          id: 12905,
          known_for_department: 'Biên kịch',
          name: 'Ash Brannon',
          original_name: 'Ash Brannon',
          popularity: 0.921,
          profile_path:
            'https://image.tmdb.org/t/p/w185/meH6AhBnCyX4w0lBFvRQWDJmvjv.jpg',
          credit_id: '61af9813a24232001c767aae',
          department: 'Directing',
          job: 'Co-Director',
        },
        {
          adult: false,
          gender: 2,
          id: 12905,
          known_for_department: 'Biên kịch',
          name: 'Ash Brannon',
          original_name: 'Ash Brannon',
          popularity: 0.921,
          profile_path:
            'https://image.tmdb.org/t/p/w185/meH6AhBnCyX4w0lBFvRQWDJmvjv.jpg',
          credit_id: '589467dac3a368409f004d4c',
          department: 'Visual Effects',
          job: 'Character Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 12906,
          known_for_department: 'Biên kịch',
          name: 'Rita Hsiao',
          original_name: 'Rita Hsiao',
          popularity: 1.4,
          profile_path: null,
          credit_id: '52fe4284c3a36847f8025079',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 0,
          id: 12907,
          known_for_department: 'Biên kịch',
          name: 'Doug Chamberlin',
          original_name: 'Doug Chamberlin',
          popularity: 1.4,
          profile_path: null,
          credit_id: '52fe4284c3a36847f802507f',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 0,
          id: 12908,
          known_for_department: 'Biên kịch',
          name: 'Chris Webb',
          original_name: 'Chris Webb',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4284c3a36847f8025085',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 0,
          id: 12909,
          known_for_department: 'Production',
          name: 'Karen Robert Jackson',
          original_name: 'Karen Robert Jackson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4284c3a36847f802508b',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 12910,
          known_for_department: 'Production',
          name: 'Sarah McArthur',
          original_name: 'Sarah McArthur',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4284c3a36847f8025091',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 12911,
          known_for_department: 'Production',
          name: 'Helene Plotkin',
          original_name: 'Helene Plotkin',
          popularity: 1.38,
          profile_path: null,
          credit_id: '52fe4284c3a36847f8025097',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 12912,
          known_for_department: 'Camera',
          name: 'Sharon Calahan',
          original_name: 'Sharon Calahan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4284c3a36847f80250a3',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 1,
          id: 12913,
          known_for_department: 'Editing',
          name: 'Edie Ichioka',
          original_name: 'Edie Ichioka',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d9ae01d43250f00199afe88',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 12915,
          known_for_department: 'Visual Effects',
          name: 'William Cone',
          original_name: 'William Cone',
          popularity: 0.708,
          profile_path: null,
          credit_id: '52fe4284c3a36847f80250c7',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 0,
          id: 12916,
          known_for_department: 'Visual Effects',
          name: 'Jim Pearson',
          original_name: 'Jim Pearson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4284c3a36847f80250cd',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 0,
          id: 12916,
          known_for_department: 'Visual Effects',
          name: 'Jim Pearson',
          original_name: 'Jim Pearson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5894681dc3a36840ab004e25',
          department: 'Visual Effects',
          job: 'Character Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 15893,
          known_for_department: 'Sound',
          name: 'Teresa Eckton',
          original_name: 'Teresa Eckton',
          popularity: 1.106,
          profile_path: null,
          credit_id: '58948140c3a36840a200661a',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 15894,
          known_for_department: 'Sound',
          name: 'Tom Myers',
          original_name: 'Tom Myers',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5894813092514142710063a9',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 15898,
          known_for_department: 'Diễn viên',
          name: 'Guido Quaroni',
          original_name: 'Guido Quaroni',
          popularity: 1.62,
          profile_path: null,
          credit_id: '5ab17964c3a36861b301501c',
          department: 'Visual Effects',
          job: 'Shading',
        },
        {
          adult: false,
          gender: 2,
          id: 15898,
          known_for_department: 'Diễn viên',
          name: 'Guido Quaroni',
          original_name: 'Guido Quaroni',
          popularity: 1.62,
          profile_path: null,
          credit_id: '5ab178c80e0a2676db0141a1',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 1,
          id: 16497,
          known_for_department: 'Sound',
          name: 'Lisa Jaime',
          original_name: 'Lisa Jaime',
          popularity: 0.6,
          profile_path: null,
          credit_id: '563d2647c3a36862da001019',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 7899,
          known_for_department: 'Production',
          name: 'Galyn Susman',
          original_name: 'Galyn Susman',
          popularity: 1.128,
          profile_path: null,
          credit_id: '58946571c3a36840ab004c5d',
          department: 'Crew',
          job: 'Supervising Technical Director',
        },
        {
          adult: false,
          gender: 0,
          id: 21637,
          known_for_department: 'Sound',
          name: 'Ira Hearshen',
          original_name: 'Ira Hearshen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58948219c3a36840a40063a0',
          department: 'Sound',
          job: 'Orchestrator',
        },
        {
          adult: false,
          gender: 1,
          id: 113055,
          known_for_department: 'Sound',
          name: 'Mildred Iatrou',
          original_name: 'Mildred Iatrou',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946de3925141427e00517d',
          department: 'Editing',
          job: 'Additional Editing',
        },
        {
          adult: false,
          gender: 0,
          id: 72753,
          known_for_department: 'Production',
          name: 'Lindsey Collins',
          original_name: 'Lindsey Collins',
          popularity: 0.755,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ihcDtiQaSfTcDa99QJc4LuUFrpM.jpg',
          credit_id: '5ab1647b0e0a2676de0143ba',
          department: 'Editing',
          job: 'Editorial Manager',
        },
        {
          adult: false,
          gender: 1,
          id: 84493,
          known_for_department: 'Diễn viên',
          name: 'Mickie McGowan',
          original_name: 'Mickie McGowan',
          popularity: 5.276,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4K1HF10EvDjdaIoDAnWqFZjnmvk.jpg',
          credit_id: '5894818ec3a36840b5005d1c',
          department: 'Production',
          job: 'ADR Voice Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 78009,
          known_for_department: 'Visual Effects',
          name: 'Colin Brady',
          original_name: 'Colin Brady',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589467e1c3a36840b1004fcd',
          department: 'Visual Effects',
          job: 'Character Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 89425,
          known_for_department: 'Sound',
          name: 'Ronald G. Roumas',
          original_name: 'Ronald G. Roumas',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5ab15ed00e0a2676ce012622',
          department: 'Sound',
          job: 'Sound Recordist',
        },
        {
          adult: false,
          gender: 1,
          id: 189120,
          known_for_department: 'Diễn viên',
          name: 'Karen Prell',
          original_name: 'Karen Prell',
          popularity: 1.001,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jkM0VMUzmFnhiJexioqxSDzEcbk.jpg',
          credit_id: '58946bc8925141426c00547e',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 226629,
          known_for_department: 'Sound',
          name: 'Reid Gershbein',
          original_name: 'Reid Gershbein',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab177c10e0a2676d00162c2',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 2,
          id: 229924,
          known_for_department: 'Directing',
          name: 'Chris Perry',
          original_name: 'Chris Perry',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8GLTgO0WqLqrZSHTVCJXx54NnGP.jpg',
          credit_id: '5ab171ed0e0a2676cb015fe3',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 231202,
          known_for_department: 'Visual Effects',
          name: 'Dylan Brown',
          original_name: 'Dylan Brown',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5894691c9251414278005384',
          department: 'Visual Effects',
          job: 'Animation Director',
        },
        {
          adult: false,
          gender: 2,
          id: 384204,
          known_for_department: 'Visual Effects',
          name: 'Anthony Scott',
          original_name: 'Anthony Scott',
          popularity: 0.6,
          profile_path: null,
          credit_id: '552c7d62c3a36861a1001f4c',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 555795,
          known_for_department: 'Biên kịch',
          name: 'Mark Oftedal',
          original_name: 'Mark Oftedal',
          popularity: 0.98,
          profile_path: null,
          credit_id: '58946b8b925141427800557b',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 953331,
          known_for_department: 'Crew',
          name: 'Chris Montan',
          original_name: 'Chris Montan',
          popularity: 0.659,
          profile_path: null,
          credit_id: '589466369251414271004cf4',
          department: 'Crew',
          job: 'Executive Music Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1092247,
          known_for_department: 'Visual Effects',
          name: 'Mark A. Walsh',
          original_name: 'Mark A. Walsh',
          popularity: 0.619,
          profile_path: null,
          credit_id: '58946c5bc3a36840a7005355',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 1108501,
          known_for_department: 'Editing',
          name: 'Jennifer Leo Russ',
          original_name: 'Jennifer Leo Russ',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946d33c3a368409f005116',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1122223,
          known_for_department: 'Crew',
          name: 'Barney Jones',
          original_name: 'Barney Jones',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946ef4925141427a004ded',
          department: 'Crew',
          job: 'Temp Music Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1122225,
          known_for_department: 'Sound',
          name: 'David Slusser',
          original_name: 'David Slusser',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946ed2c3a36840b80054bf',
          department: 'Crew',
          job: 'Temp Music Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1140576,
          known_for_department: 'Visual Effects',
          name: 'Michael Parks',
          original_name: 'Michael Parks',
          popularity: 0.6,
          profile_path: null,
          credit_id: '552c4823925141387a000d67',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1205975,
          known_for_department: 'Visual Effects',
          name: 'Timothy Hittle',
          original_name: 'Timothy Hittle',
          popularity: 0.648,
          profile_path: null,
          credit_id: '58946a9cc3a36840a200512f',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1249957,
          known_for_department: 'Diễn viên',
          name: 'Mike Quinn',
          original_name: 'Mike Quinn',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tRrg4imvBuv1EOJnaGcFPYUu4EM.jpg',
          credit_id: '58946be192514142800052e5',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1258222,
          known_for_department: 'Camera',
          name: 'Dave Gordon',
          original_name: 'Dave Gordon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589468499251414275004db3',
          department: 'Visual Effects',
          job: 'Visual Development',
        },
        {
          adult: false,
          gender: 0,
          id: 1262197,
          known_for_department: 'Biên kịch',
          name: 'Peter Lepeniotis',
          original_name: 'Peter Lepeniotis',
          popularity: 0.622,
          profile_path: null,
          credit_id: '58946b1592514142710050aa',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1268117,
          known_for_department: 'Diễn viên',
          name: 'Josh Qualtieri',
          original_name: 'Josh Qualtieri',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16c33c3a36861b3013e00',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1321700,
          known_for_department: 'Art',
          name: 'Sean Hargreaves',
          original_name: 'Sean Hargreaves',
          popularity: 0.84,
          profile_path: null,
          credit_id: '58946838925141426e005382',
          department: 'Visual Effects',
          job: 'Visual Development',
        },
        {
          adult: false,
          gender: 2,
          id: 1371609,
          known_for_department: 'Visual Effects',
          name: 'Stephen King',
          original_name: 'Stephen King',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1626dc3a36861b5013591',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 1391429,
          known_for_department: 'Costume & Make-Up',
          name: 'Christina Yim',
          original_name: 'Christina Yim',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946c78c3a36840a7005375',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1397887,
          known_for_department: 'Art',
          name: 'Graham Moloy',
          original_name: 'Graham Moloy',
          popularity: 0.694,
          profile_path: null,
          credit_id: '589468d5c3a36840ab004ea0',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 1401794,
          known_for_department: 'Crew',
          name: 'Lucas Putnam',
          original_name: 'Lucas Putnam',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946e56925141427e0051dc',
          department: 'Editing',
          job: 'Additional Editorial Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 1404532,
          known_for_department: 'Editing',
          name: 'Sarah Schubart',
          original_name: 'Sarah Schubart',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946e7192514142780057bc',
          department: 'Editing',
          job: 'Additional Editorial Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 1406885,
          known_for_department: 'Visual Effects',
          name: 'Steven Clay Hunter',
          original_name: 'Steven Clay Hunter',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946ad2c3a368409f004f7e',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1412465,
          known_for_department: 'Directing',
          name: 'Kristina Perez',
          original_name: 'Kristina Perez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16af3c3a36861b3013b53',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1422411,
          known_for_department: 'Sound',
          name: 'Al Nelson',
          original_name: 'Al Nelson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab17849c3a36861b3014f25',
          department: 'Sound',
          job: 'Assistant Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1425978,
          known_for_department: 'Sound',
          name: 'Gary Summers',
          original_name: 'Gary Summers',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589481189251414271006397',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1429549,
          known_for_department: 'Editing',
          name: 'Dale E. Grahn',
          original_name: 'Dale E. Grahn',
          popularity: 1.635,
          profile_path: null,
          credit_id: '57c1be07925141444a001115',
          department: 'Editing',
          job: 'Color Timer',
        },
        {
          adult: false,
          gender: 0,
          id: 1443479,
          known_for_department: 'Production',
          name: 'A.J. Riebli III',
          original_name: 'A.J. Riebli III',
          popularity: 1.38,
          profile_path: null,
          credit_id: '58946fe592514142780058fe',
          department: 'Production',
          job: 'Production Office Coordinator',
        },
        {
          adult: false,
          gender: 1,
          id: 1449388,
          known_for_department: 'Directing',
          name: 'M.T. Silvia',
          original_name: 'M.T. Silvia',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16c4f92514111c7013273',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1458006,
          known_for_department: 'Art',
          name: 'Susan Bradley',
          original_name: 'Susan Bradley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5894825fc3a368409f006475',
          department: 'Art',
          job: 'Title Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1459760,
          known_for_department: 'Directing',
          name: 'Adam Schnitzer',
          original_name: 'Adam Schnitzer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589468c1c3a36840b50048d2',
          department: 'Directing',
          job: 'Layout',
        },
        {
          adult: false,
          gender: 0,
          id: 1462679,
          known_for_department: 'Visual Effects',
          name: 'Mark R.R. Farquhar',
          original_name: 'Mark R.R. Farquhar',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946a0d9251414275004eda',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1480810,
          known_for_department: 'Diễn viên',
          name: 'Bruce Perens',
          original_name: 'Bruce Perens',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16e410e0a2676db0134ac',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1508427,
          known_for_department: 'Visual Effects',
          name: 'David Orecklin',
          original_name: 'David Orecklin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946cb7c3a36840ab005186',
          department: 'Visual Effects',
          job: 'Animation Department Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1531912,
          known_for_department: 'Editing',
          name: 'Steven Liu',
          original_name: 'Steven Liu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1773ac3a36861b3014e13',
          department: 'Editing',
          job: 'Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1539107,
          known_for_department: 'Diễn viên',
          name: 'Kitt Hirasaki',
          original_name: 'Kitt Hirasaki',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5ab16e060e0a2676db01342e',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1550172,
          known_for_department: 'Sound',
          name: 'Mark Fontana',
          original_name: 'Mark Fontana',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab178e70e0a2676de0169cd',
          department: 'Visual Effects',
          job: 'Shading',
        },
        {
          adult: false,
          gender: 0,
          id: 1552883,
          known_for_department: 'Sound',
          name: 'Mary Helen Leasman',
          original_name: 'Mary Helen Leasman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58948153c3a36840a2006625',
          department: 'Sound',
          job: 'Foley Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1556635,
          known_for_department: 'Crew',
          name: 'James Burgess',
          original_name: 'James Burgess',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16d69c3a36861b5014c90',
          department: 'Crew',
          job: 'Photoscience Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1596323,
          known_for_department: 'Sound',
          name: 'Jennifer Barin',
          original_name: 'Jennifer Barin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab15f3f92514111c4011586',
          department: 'Sound',
          job: 'Sound Recordist',
        },
        {
          adult: false,
          gender: 0,
          id: 1623540,
          known_for_department: 'Sound',
          name: 'Jonathan Sacks',
          original_name: 'Jonathan Sacks',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5894820fc3a36840ab0063f5',
          department: 'Sound',
          job: 'Orchestrator',
        },
        {
          adult: false,
          gender: 0,
          id: 1623548,
          known_for_department: 'Visual Effects',
          name: 'Dan Lee',
          original_name: 'Dan Lee',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589467ff9251414280005023',
          department: 'Visual Effects',
          job: 'Character Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1645696,
          known_for_department: 'Visual Effects',
          name: 'Ethan Hurd',
          original_name: 'Ethan Hurd',
          popularity: 0.648,
          profile_path: null,
          credit_id: '58946ad9c3a36840b10051da',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1711831,
          known_for_department: 'Lighting',
          name: 'Jesse Hollander',
          original_name: 'Jesse Hollander',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1633e0e0a2676cb01406e',
          department: 'Lighting',
          job: 'Master Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1742751,
          known_for_department: 'Camera',
          name: 'Jeff Wan',
          original_name: 'Jeff Wan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946fa492514142800055bc',
          department: 'Camera',
          job: 'Camera Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 1748691,
          known_for_department: 'Visual Effects',
          name: 'Doug Sheppeck',
          original_name: 'Doug Sheppeck',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946c20925141428000530f',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1748707,
          known_for_department: 'Directing',
          name: 'Roman Figun',
          original_name: 'Roman Figun',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589468a5925141426c00524f',
          department: 'Directing',
          job: 'Layout',
        },
        {
          adult: false,
          gender: 0,
          id: 1748710,
          known_for_department: 'Art',
          name: "Kelly O'Connell",
          original_name: "Kelly O'Connell",
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab177e9c3a36861b3014ebf',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 1748710,
          known_for_department: 'Art',
          name: "Kelly O'Connell",
          original_name: "Kelly O'Connell",
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1627992514111cd0116a4',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 1748716,
          known_for_department: 'Editing',
          name: 'Tom Freeman',
          original_name: 'Tom Freeman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946e14c3a36840b8005426',
          department: 'Editing',
          job: 'Additional Editorial Assistant',
        },
        {
          adult: false,
          gender: 1,
          id: 1748724,
          known_for_department: 'Sound',
          name: 'Susan Sanford',
          original_name: 'Susan Sanford',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5894815dc3a36840a400630a',
          department: 'Sound',
          job: 'Foley Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1749735,
          known_for_department: 'Art',
          name: 'Matt White',
          original_name: 'Matt White',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589467349251414271004dbb',
          department: 'Art',
          job: 'Art Department Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1749736,
          known_for_department: 'Art',
          name: 'David Skelly',
          original_name: 'David Skelly',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589467619251414280004faf',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1749739,
          known_for_department: 'Art',
          name: 'Jen Kinavey',
          original_name: 'Jen Kinavey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946858c3a36840b1005022',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1749740,
          known_for_department: 'Directing',
          name: 'Wade Childress',
          original_name: 'Wade Childress',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5894689ec3a36840a2004fa8',
          department: 'Directing',
          job: 'Layout',
        },
        {
          adult: false,
          gender: 0,
          id: 1749741,
          known_for_department: 'Directing',
          name: 'Craig McGillivray',
          original_name: 'Craig McGillivray',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589468b1c3a36840ab004e85',
          department: 'Directing',
          job: 'Layout',
        },
        {
          adult: false,
          gender: 0,
          id: 1749742,
          known_for_department: 'Directing',
          name: 'Stephen Moros',
          original_name: 'Stephen Moros',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589468b9c3a36840a2004fc2',
          department: 'Directing',
          job: 'Layout',
        },
        {
          adult: false,
          gender: 0,
          id: 1749746,
          known_for_department: 'Visual Effects',
          name: 'Nicolas Alan Barillaro',
          original_name: 'Nicolas Alan Barillaro',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589469929251414280005113',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1749748,
          known_for_department: 'Visual Effects',
          name: 'Jennifer Cha',
          original_name: 'Jennifer Cha',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589469d09251414271004fbb',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1749749,
          known_for_department: 'Visual Effects',
          name: 'Melanie Cordan',
          original_name: 'Melanie Cordan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '589469f2925141427e004e91',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1749757,
          known_for_department: 'Visual Effects',
          name: 'Bob Koch',
          original_name: 'Bob Koch',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946b04925141427100509d',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1749765,
          known_for_department: 'Visual Effects',
          name: 'Karyn Metlen',
          original_name: 'Karyn Metlen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946b69925141426e00560c',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1749766,
          known_for_department: 'Visual Effects',
          name: 'Valerie Mih',
          original_name: 'Valerie Mih',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946b73c3a36840a70052c0',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1749773,
          known_for_department: 'Visual Effects',
          name: 'Andrea Schultz',
          original_name: 'Andrea Schultz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946cabc3a36840b5004b87',
          department: 'Visual Effects',
          job: 'Fix Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 1749775,
          known_for_department: 'Editing',
          name: 'Christian Hill',
          original_name: 'Christian Hill',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946e3d92514142800054a7',
          department: 'Editing',
          job: 'Additional Editorial Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 1749778,
          known_for_department: 'Editing',
          name: 'Mike Marsh',
          original_name: 'Mike Marsh',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58946ec7c3a36840a700550e',
          department: 'Editing',
          job: 'Additional Editorial Assistant',
        },
        {
          adult: false,
          gender: 2,
          id: 1792389,
          known_for_department: 'Biên kịch',
          name: 'Michael R. King',
          original_name: 'Michael R. King',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab17917c3a36861b9016115',
          department: 'Visual Effects',
          job: 'Shading',
        },
        {
          adult: false,
          gender: 0,
          id: 1830790,
          known_for_department: 'Crew',
          name: 'Danielle Feinberg',
          original_name: 'Danielle Feinberg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab17825c3a36861a8014a68',
          department: 'Lighting',
          job: 'Master Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1847643,
          known_for_department: 'Production',
          name: 'Miguel Ángel Poveda',
          original_name: 'Miguel Ángel Poveda',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab15402c3a36861a8010e5d',
          department: 'Crew',
          job: 'Post Production Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1993274,
          known_for_department: 'Visual Effects',
          name: 'Dale Ruffolo',
          original_name: 'Dale Ruffolo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1628f92514111d3011afc',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 1993274,
          known_for_department: 'Visual Effects',
          name: 'Dale Ruffolo',
          original_name: 'Dale Ruffolo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab17765c3a36861b9015f69',
          department: 'Lighting',
          job: 'Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1993421,
          known_for_department: 'Visual Effects',
          name: 'Rob Jensen',
          original_name: 'Rob Jensen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1625f92514111c7011d77',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 1993421,
          known_for_department: 'Visual Effects',
          name: 'Rob Jensen',
          original_name: 'Rob Jensen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16349c3a36861a30121a2',
          department: 'Lighting',
          job: 'Master Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1994334,
          known_for_department: 'Sound',
          name: 'Andrew Page',
          original_name: 'Andrew Page',
          popularity: 2.744,
          profile_path: null,
          credit_id: '5ab178710e0a2676de016949',
          department: 'Sound',
          job: 'Music Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1994361,
          known_for_department: 'Crew',
          name: 'Michael Kass',
          original_name: 'Michael Kass',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16e1f0e0a2676db01345c',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1994376,
          known_for_department: 'Crew',
          name: 'Michael B. Johnson',
          original_name: 'Michael B. Johnson',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rU1648PRHaCLPsU4x1ICbpvpsgs.jpg',
          credit_id: '5ab177cec3a36861a30143bd',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 1994376,
          known_for_department: 'Crew',
          name: 'Michael B. Johnson',
          original_name: 'Michael B. Johnson',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rU1648PRHaCLPsU4x1ICbpvpsgs.jpg',
          credit_id: '5ab16e100e0a2676ce0147fa',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1994383,
          known_for_department: 'Crew',
          name: 'Dirk Van Gelder',
          original_name: 'Dirk Van Gelder',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab176e90e0a2676db013ff2',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 2,
          id: 1994503,
          known_for_department: 'Crew',
          name: 'Patrick Wilson',
          original_name: 'Patrick Wilson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1629ac3a36861ac011d6b',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 1994534,
          known_for_department: 'Visual Effects',
          name: 'Lars R. Damerow',
          original_name: 'Lars R. Damerow',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab168900e0a2676ce013ba9',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1994536,
          known_for_department: 'Visual Effects',
          name: 'Cynthia Dueltgen',
          original_name: 'Cynthia Dueltgen',
          popularity: 0.84,
          profile_path: null,
          credit_id: '5ab162450e0a2676c9012913',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 1994536,
          known_for_department: 'Visual Effects',
          name: 'Cynthia Dueltgen',
          original_name: 'Cynthia Dueltgen',
          popularity: 0.84,
          profile_path: null,
          credit_id: '5ab163210e0a2676de014084',
          department: 'Lighting',
          job: 'Master Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1994544,
          known_for_department: 'Visual Effects',
          name: 'Patrick Guenette',
          original_name: 'Patrick Guenette',
          popularity: 0.648,
          profile_path: null,
          credit_id: '5ab168e09251417d3600e6c4',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1994551,
          known_for_department: 'Directing',
          name: 'Jongo',
          original_name: 'Jongo',
          popularity: 1.021,
          profile_path: null,
          credit_id: '5ab177d7c3a36861b9015fe7',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 1994558,
          known_for_department: 'Lighting',
          name: 'Ana Lacaze',
          original_name: 'Ana Lacaze',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab179200e0a2676cb01688c',
          department: 'Visual Effects',
          job: 'Shading',
        },
        {
          adult: false,
          gender: 0,
          id: 1994558,
          known_for_department: 'Lighting',
          name: 'Ana Lacaze',
          original_name: 'Ana Lacaze',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16354c3a36861b50137c2',
          department: 'Lighting',
          job: 'Master Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1994560,
          known_for_department: 'Visual Effects',
          name: 'Ken Lao',
          original_name: 'Ken Lao',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5ab1635f92514111cd0118b9',
          department: 'Lighting',
          job: 'Master Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1994572,
          known_for_department: 'Lighting',
          name: "Eileen O'Neill",
          original_name: "Eileen O'Neill",
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab177f50e0a2676c901520d',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 1994572,
          known_for_department: 'Lighting',
          name: "Eileen O'Neill",
          original_name: "Eileen O'Neill",
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab179500e0a2676cb0168c1',
          department: 'Visual Effects',
          job: 'Shading',
        },
        {
          adult: false,
          gender: 0,
          id: 1994572,
          known_for_department: 'Lighting',
          name: "Eileen O'Neill",
          original_name: "Eileen O'Neill",
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1628492514111be011b9b',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 1994574,
          known_for_department: 'Visual Effects',
          name: 'Keith Olenick',
          original_name: 'Keith Olenick',
          popularity: 0.728,
          profile_path: null,
          credit_id: '5ab179590e0a2676d501619f',
          department: 'Visual Effects',
          job: 'Shading',
        },
        {
          adult: false,
          gender: 0,
          id: 1994576,
          known_for_department: 'Visual Effects',
          name: 'John Singh Pottebaum',
          original_name: 'John Singh Pottebaum',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5ab177fe0e0a2676c9015217',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 1994576,
          known_for_department: 'Visual Effects',
          name: 'John Singh Pottebaum',
          original_name: 'John Singh Pottebaum',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5ab168030e0a2676c9013601',
          department: 'Visual Effects',
          job: 'Shading',
        },
        {
          adult: false,
          gender: 0,
          id: 1994576,
          known_for_department: 'Visual Effects',
          name: 'John Singh Pottebaum',
          original_name: 'John Singh Pottebaum',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5ab167f90e0a2676d5014492',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1994583,
          known_for_department: 'Visual Effects',
          name: 'Allison Torres',
          original_name: 'Allison Torres',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab17812c3a36861af014f19',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 1994584,
          known_for_department: 'Lighting',
          name: 'John Warren',
          original_name: 'John Warren',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab179d60e0a2676cb01693e',
          department: 'Visual Effects',
          job: 'Shading',
        },
        {
          adult: false,
          gender: 0,
          id: 1994629,
          known_for_department: 'Crew',
          name: 'Timothy Sorensen',
          original_name: 'Timothy Sorensen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16d8592514111d0013288',
          department: 'Crew',
          job: 'Post Production Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 1994653,
          known_for_department: 'Crew',
          name: 'Ling Hsu',
          original_name: 'Ling Hsu',
          popularity: 0.615,
          profile_path: null,
          credit_id: '5ab168eb92514111c4012869',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1994656,
          known_for_department: 'Directing',
          name: 'Tom Kim',
          original_name: 'Tom Kim',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab163c2c3a368619e011787',
          department: 'Lighting',
          job: 'Lighting Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1994660,
          known_for_department: 'Crew',
          name: 'Chris King',
          original_name: 'Chris King',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16e2b0e0a2676de015a70',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1994669,
          known_for_department: 'Crew',
          name: 'Manny Ponce',
          original_name: 'Manny Ponce',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab176f50e0a2676d00161de',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1994671,
          known_for_department: 'Crew',
          name: 'Sudeep Rangaswamy',
          original_name: 'Sudeep Rangaswamy',
          popularity: 0.972,
          profile_path: null,
          credit_id: '5ab17808c3a36861af014f0c',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 1994671,
          known_for_department: 'Crew',
          name: 'Sudeep Rangaswamy',
          original_name: 'Sudeep Rangaswamy',
          popularity: 0.972,
          profile_path: null,
          credit_id: '5ab176bb92514111ca013887',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1994673,
          known_for_department: 'Crew',
          name: 'Don Schreiter',
          original_name: 'Don Schreiter',
          popularity: 0.608,
          profile_path: null,
          credit_id: '5ab1678ac3a368619e011e62',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 1994676,
          known_for_department: 'Crew',
          name: 'Michael Shantzis',
          original_name: 'Michael Shantzis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab176d19251417d3600fea3',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1994679,
          known_for_department: 'Crew',
          name: 'Nelson Siu',
          original_name: 'Nelson Siu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab176ff92514111ca0138cb',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1994681,
          known_for_department: 'Crew',
          name: 'Heidi Stettner',
          original_name: 'Heidi Stettner',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab176de92514111be013f77',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1994684,
          known_for_department: 'Crew',
          name: 'Andy Thomas',
          original_name: 'Andy Thomas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16cadc3a36861a3013457',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1994685,
          known_for_department: 'Crew',
          name: 'Tien Truong',
          original_name: 'Tien Truong',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5ab1611892514111d301181c',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1994687,
          known_for_department: 'Crew',
          name: 'Eric Veach',
          original_name: 'Eric Veach',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab161290e0a2676de013b86',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1994689,
          known_for_department: 'Crew',
          name: 'Christopher C. Walker',
          original_name: 'Christopher C. Walker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16cb8c3a36861a8013aa1',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1994690,
          known_for_department: 'Crew',
          name: 'Jay Weiland',
          original_name: 'Jay Weiland',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16cc4c3a36861af013f84',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1994692,
          known_for_department: 'Crew',
          name: 'Andy Witkin',
          original_name: 'Andy Witkin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab165510e0a2676d80130b3',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1996110,
          known_for_department: 'Art',
          name: 'Terry McQueen',
          original_name: 'Terry McQueen',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5ab163990e0a2676ce013048',
          department: 'Lighting',
          job: 'Lighting Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1996241,
          known_for_department: 'Visual Effects',
          name: 'Deborah R. Fowler',
          original_name: 'Deborah R. Fowler',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1632ac3a36861a801270e',
          department: 'Lighting',
          job: 'Master Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1996243,
          known_for_department: 'Visual Effects',
          name: 'Damir Frkovic',
          original_name: 'Damir Frkovic',
          popularity: 0.648,
          profile_path: null,
          credit_id: '5ab162510e0a2676c9012927',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 1996301,
          known_for_department: 'Visual Effects',
          name: 'Larry Gritz',
          original_name: 'Larry Gritz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab178f00e0a2676cb01685a',
          department: 'Visual Effects',
          job: 'Shading',
        },
        {
          adult: false,
          gender: 0,
          id: 1996301,
          known_for_department: 'Visual Effects',
          name: 'Larry Gritz',
          original_name: 'Larry Gritz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab160a50e0a2676de013a69',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1997868,
          known_for_department: 'Crew',
          name: 'Alisa Gilden',
          original_name: 'Alisa Gilden',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1925c0e0a2634d70004d7',
          department: 'Crew',
          job: 'Information Systems Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1997869,
          known_for_department: 'Crew',
          name: 'May Pon',
          original_name: 'May Pon',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5ab16c2492514111d3012ef5',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1997896,
          known_for_department: 'Crew',
          name: 'Bryan Bird',
          original_name: 'Bryan Bird',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab168860e0a2676de014d44',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1997908,
          known_for_department: 'Crew',
          name: 'Peter Kaldis',
          original_name: 'Peter Kaldis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1691992514111d00129ad',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 1999000,
          known_for_department: 'Visual Effects',
          name: "Michael O'Brien",
          original_name: "Michael O'Brien",
          popularity: 0.766,
          profile_path: null,
          credit_id: '5ab192a1c3a3681e3f0004b5',
          department: 'Crew',
          job: 'Information Systems Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 2001300,
          known_for_department: 'Editing',
          name: 'Ed Fuller',
          original_name: 'Ed Fuller',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab164500e0a2676cb0142fb',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2003474,
          known_for_department: 'Directing',
          name: 'Lee Cruikshank',
          original_name: 'Lee Cruikshank',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab15e7ec3a36861b3012214',
          department: 'Directing',
          job: 'Script Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2003476,
          known_for_department: 'Crew',
          name: 'Phil Beffrey',
          original_name: 'Phil Beffrey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab15f5392514111d0011534',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 2003477,
          known_for_department: 'Crew',
          name: 'Loren Carpenter',
          original_name: 'Loren Carpenter',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab15f9ac3a36861ac0117e5',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 2003481,
          known_for_department: 'Crew',
          name: 'Dan Lyke',
          original_name: 'Dan Lyke',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab160c692514111d3011793',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 2003482,
          known_for_department: 'Crew',
          name: 'Shaun Oborn',
          original_name: 'Shaun Oborn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab160d50e0a2676de013ad4',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 2003483,
          known_for_department: 'Crew',
          name: 'Matt Pharr',
          original_name: 'Matt Pharr',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1610892514111d30117f7',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 2003487,
          known_for_department: 'Visual Effects',
          name: 'Ruieta DaSilva',
          original_name: 'Ruieta DaSilva',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab162360e0a2676d5013775',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 2003494,
          known_for_department: 'Lighting',
          name: 'Jun Han Cho',
          original_name: 'Jun Han Cho',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16317c3a36861b501372c',
          department: 'Lighting',
          job: 'Master Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2003495,
          known_for_department: 'Lighting',
          name: 'Molly Naughton',
          original_name: 'Molly Naughton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab163a892514111cd01195c',
          department: 'Lighting',
          job: 'Lighting Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 2003499,
          known_for_department: 'Visual Effects',
          name: 'Jenny Head Appleton',
          original_name: 'Jenny Head Appleton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab166619251417d3600e18e',
          department: 'Visual Effects',
          job: 'Animation Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 2003500,
          known_for_department: 'Lighting',
          name: 'Cynthia Pettit',
          original_name: 'Cynthia Pettit',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16743c3a36861b5013fd4',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2003502,
          known_for_department: 'Crew',
          name: 'Jason B. Hendrix',
          original_name: 'Jason B. Hendrix',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16824c3a36861b5014174',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 2003503,
          known_for_department: 'Crew',
          name: 'Nathan Ardaiz',
          original_name: 'Nathan Ardaiz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab168680e0a2676c90136e3',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 2003504,
          known_for_department: 'Crew',
          name: 'George Bagtas',
          original_name: 'George Bagtas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab168710e0a2676d8013779',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 2003505,
          known_for_department: 'Crew',
          name: 'Adam Beeman',
          original_name: 'Adam Beeman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1687b0e0a2676ce013b75',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 2003513,
          known_for_department: 'Crew',
          name: 'Gregory Yong Paik',
          original_name: 'Gregory Yong Paik',
          popularity: 0.656,
          profile_path: null,
          credit_id: '5ab169730e0a2676ce013db3',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 2003540,
          known_for_department: 'Crew',
          name: 'Edilberto A. Soriano Jr.',
          original_name: 'Edilberto A. Soriano Jr.',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16c5ac3a36861a80139ee',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 2003541,
          known_for_department: 'Crew',
          name: 'Alex Stahl',
          original_name: 'Alex Stahl',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16c8492514111c401300b',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 2003546,
          known_for_department: 'Crew',
          name: 'Dallas Wisehaupt',
          original_name: 'Dallas Wisehaupt',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16ccf0e0a2676d8014094',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 2003551,
          known_for_department: 'Crew',
          name: 'David Gordon',
          original_name: 'David Gordon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16d12c3a36861ac0131c9',
          department: 'Crew',
          job: 'Systems Administrators & Support',
        },
        {
          adult: false,
          gender: 0,
          id: 2003557,
          known_for_department: 'Crew',
          name: 'Lance Martin',
          original_name: 'Lance Martin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16db50e0a2676db013390',
          department: 'Crew',
          job: 'Production Office Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2003559,
          known_for_department: 'Crew',
          name: 'Malcolm Blanchard',
          original_name: 'Malcolm Blanchard',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5ab16de30e0a2676d80142cb',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 2003566,
          known_for_department: 'Crew',
          name: 'Eric Lebel',
          original_name: 'Eric Lebel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab16e3692514111ca012d91',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 2003597,
          known_for_department: 'Crew',
          name: 'Rona Michele',
          original_name: 'Rona Michele',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1770f0e0a2676cb016660',
          department: 'Crew',
          job: 'Temp Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2003598,
          known_for_department: 'Editing',
          name: 'Anne Pia',
          original_name: 'Anne Pia',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab17748c3a36861b9015f44',
          department: 'Editing',
          job: 'Editorial Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2003599,
          known_for_department: 'Editing',
          name: 'Shannon Menendez-Chu',
          original_name: 'Shannon Menendez-Chu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1775592514111ca013922',
          department: 'Editing',
          job: 'Editorial Production Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2003600,
          known_for_department: 'Lighting',
          name: 'Kirk Bowers',
          original_name: 'Kirk Bowers',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab17782c3a36861b5015ace',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2003600,
          known_for_department: 'Lighting',
          name: 'Kirk Bowers',
          original_name: 'Kirk Bowers',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab178dd0e0a2676ce0156f7',
          department: 'Visual Effects',
          job: 'Shading',
        },
        {
          adult: false,
          gender: 0,
          id: 2003602,
          known_for_department: 'Lighting',
          name: 'Brian Daniel Young',
          original_name: 'Brian Daniel Young',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1781b0e0a2676ce01560a',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2003603,
          known_for_department: 'Visual Effects',
          name: 'Steve Upstill',
          original_name: 'Steve Upstill',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1796e0e0a2676d50161c4',
          department: 'Visual Effects',
          job: 'Shading',
        },
        {
          adult: false,
          gender: 0,
          id: 2003604,
          known_for_department: 'Visual Effects',
          name: 'David Valdez',
          original_name: 'David Valdez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab179afc3a36861b5015cd7',
          department: 'Visual Effects',
          job: 'Shading',
        },
        {
          adult: false,
          gender: 0,
          id: 2003682,
          known_for_department: 'Crew',
          name: 'Warren Hays',
          original_name: 'Warren Hays',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab1927092514151110004f8',
          department: 'Crew',
          job: 'Information Systems Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 2003683,
          known_for_department: 'Crew',
          name: 'Duncan Keefe',
          original_name: 'Duncan Keefe',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab192870e0a2634c5000532',
          department: 'Crew',
          job: 'Information Systems Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 2004942,
          known_for_department: 'Visual Effects',
          name: 'Roger Rose',
          original_name: 'Roger Rose',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ab3b5e0c3a368615f008e64',
          department: 'Visual Effects',
          job: 'Animation',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'Gimly',
          author_details: {
            name: 'Gimly',
            username: 'Ruuz',
            avatar_path: '/xUObnJSvHrFPsIpoDmb1jiQZLq7.jpg',
            rating: 6.0,
          },
          content:
            "When I was a kid, I remember thinking that _Toy Story 2_ was pretty good, but nothing on the original. Over the years, I've known many, many, many people, and seen a great number more online, who are of the opinion that this second entry is not only better than its predecessor, but that it went on to stay the best film in the (now 4 movie strong) series. I always sorta figured, that when I grew up and rewatched it, I'd reach the same conclusion, so, uh, nope. Basically. That never happened. _Toy Story 2_ is pretty good, but nothing on the original.\r\n\r\n_Final rating:★★★ - I liked it. Would personally recommend you give it a go._",
          created_at: '2019-07-16T14:53:49.987Z',
          id: '5d2de4fda294f064562eaa5d',
          updated_at: '2021-06-23T15:58:24.317Z',
          url: 'https://www.themoviedb.org/review/5d2de4fda294f064562eaa5d',
        },
        {
          author: 'r96sk',
          author_details: {
            name: '',
            username: 'r96sk',
            avatar_path:
              '/https://secure.gravatar.com/avatar/96c2e0e4ac98450f9e8e3c0a0a40aad8.jpg',
            rating: 10.0,
          },
          content:
            "One of the greatest sequels around. <em>'Toy Story 2'</em>, whilst marginally inferior, still manages to create the same magic that the original has - which is mightily impressive.\r\n\r\nIt, at least to me, has less humour but what it loses there it makes up for in the premise, which is arguably more interesting when compared to the 1995 film. I very much enjoy it, especially the location of the finale.\r\n\r\nTom Hanks is again fabulous as Woody, while Tim Allen (Buzz) & Co. remain as entertaining as before. They also introduce some cool new characters, with the standout being Jessie who is voiced astutely by Joan Cusack; Jessie's backstory is so well done. Al (Wayne Knight) and Pete (Kelsey Grammer) are good additions, too.\r\n\r\nThere are some tremendous scenes here, that one for Cusack's character and the conclusion are my favourites alongside the ultra satisfying restoration scene; the end credits are amusing, also. It's all fun.\r\n\r\nThe other two sequels are brilliant, but this is the pick of the three. I'd highly recommend, evidently.",
          created_at: '2020-06-28T16:11:54.654Z',
          id: '5ef8c14a5b950800362bedfc',
          updated_at: '2021-06-23T15:58:39.894Z',
          url: 'https://www.themoviedb.org/review/5ef8c14a5b950800362bedfc',
        },
      ],
      total_pages: 1,
      total_results: 2,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/iXlHfi9hq7nfSv31pBab8fpMfZh.jpg',
    belongs_to_collection: null,
    budget: 36000000,
    genres: [
      { id: 35, name: 'Phim Hài' },
      { id: 10751, name: 'Phim Gia Đình' },
      { id: 14, name: 'Phim Giả Tượng' },
    ],
    homepage: '',
    id: 10830,
    imdb_id: 'tt0117008',
    original_language: 'en',
    original_title: 'Matilda',
    overview:
      'Câu chuyện kể về Matilda Wormwood, một cô bé hơn 6 tuổi rất ham mê đọc sách. Gia đình cô bé không bao giờ để ý đến sở thích của cô, chỉ có cô giáo tại trường học là thường xuyên động viên và tỏ ra yêu thương cô hết mực. Và rồi 1 ngày cô bé đã khám phá ra 1 điều bí mật ở mình.',
    popularity: 34.844,
    poster_path:
      'https://image.tmdb.org/t/p/w342/wnLbqoGRGdnPNjMV6rY75wgRamd.jpg',
    production_companies: [
      { id: 216, logo_path: null, name: 'Jersey Films', origin_country: 'US' },
      {
        id: 559,
        logo_path: '/jqWioYeGSyTLuHth0141bTGvu6H.png',
        name: 'TriStar Pictures',
        origin_country: 'US',
      },
      {
        id: 34,
        logo_path: '/GagSvqWlyPdkFHMfQ3pNq6ix9P.png',
        name: 'Sony Pictures',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '1996-08-02',
    revenue: 33459416,
    runtime: 98,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'A little magic goes a long way.',
    title: 'Cô Bé Matilda',
    video: false,
    vote_average: 7.1,
    vote_count: 3371,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Matilda trailer',
          key: 'pnzLRDDijW0',
          published_at: '2009-08-26T00:13:41.000Z',
          site: 'YouTube',
          size: 360,
          type: 'Trailer',
          official: false,
          id: '533ec66cc3a3685448001ccd',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 11717,
          known_for_department: 'Diễn viên',
          name: 'Mara Wilson',
          original_name: 'Mara Wilson',
          popularity: 13.56,
          profile_path:
            'https://image.tmdb.org/t/p/w185/305mjPnTI7ep8rDJ4i7H6XyvLqP.jpg',
          cast_id: 1,
          character: 'Matilda Wormwood',
          credit_id: '52fe43be9251416c7501c641',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 518,
          known_for_department: 'Diễn viên',
          name: 'Danny DeVito',
          original_name: 'Danny DeVito',
          popularity: 5.504,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uLW4Y9yjtwxtVmcJfwHZ7sKJai4.jpg',
          cast_id: 2,
          character: 'Harry Wormwood',
          credit_id: '52fe43be9251416c7501c645',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 24203,
          known_for_department: 'Diễn viên',
          name: 'Rhea Perlman',
          original_name: 'Rhea Perlman',
          popularity: 5.065,
          profile_path:
            'https://image.tmdb.org/t/p/w185/utg7mKbhNvxRWfWBwSb27tQTaOE.jpg',
          cast_id: 3,
          character: 'Zinnia Wormwood',
          credit_id: '52fe43be9251416c7501c649',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 6368,
          known_for_department: 'Diễn viên',
          name: 'Embeth Davidtz',
          original_name: 'Embeth Davidtz',
          popularity: 9.832,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nwsdu9lOsKJ5v9RwOCc7kAiuxSO.jpg',
          cast_id: 4,
          character: 'Miss Honey',
          credit_id: '52fe43be9251416c7501c64d',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 11213,
          known_for_department: 'Diễn viên',
          name: 'Pam Ferris',
          original_name: 'Pam Ferris',
          popularity: 14.164,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aVvdYkgolh22FYqqCJhVO8jd7To.jpg',
          cast_id: 14,
          character: 'Agatha Trunchbull',
          credit_id: '52fe43be9251416c7501c687',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 5129,
          known_for_department: 'Diễn viên',
          name: 'Paul Reubens',
          original_name: 'Paul Reubens',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7T0ExonMf6PAvphKVaTm73BXdLW.jpg',
          cast_id: 15,
          character: 'FBI Agent',
          credit_id: '52fe43be9251416c7501c68b',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 3801,
          known_for_department: 'Diễn viên',
          name: 'Tracey Walter',
          original_name: 'Tracey Walter',
          popularity: 2.653,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9aALfdCcP0PDYcBmqB6auHF0Eud.jpg',
          cast_id: 16,
          character: 'FBI Agent',
          credit_id: '52fe43be9251416c7501c68f',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 8188,
          known_for_department: 'Diễn viên',
          name: 'Jean Speegle Howard',
          original_name: 'Jean Speegle Howard',
          popularity: 0.764,
          profile_path: null,
          cast_id: 38,
          character: 'Miss Phelps',
          credit_id: '5f02e1cd53f83300369f01dd',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 109693,
          known_for_department: 'Diễn viên',
          name: 'Brian Levinson',
          original_name: 'Brian Levinson',
          popularity: 0.996,
          profile_path: null,
          cast_id: 17,
          character: 'Michael Wormwood',
          credit_id: '52fe43be9251416c7501c693',
          order: 8,
        },
        {
          adult: false,
          gender: 0,
          id: 2059552,
          known_for_department: 'Diễn viên',
          name: 'Sara Magdalin',
          original_name: 'Sara Magdalin',
          popularity: 0.6,
          profile_path: null,
          cast_id: 22,
          character: 'Four-Year-Old Matilda',
          credit_id: '5b19a8ee0e0a261f8800c25c',
          order: 9,
        },
        {
          adult: false,
          gender: 0,
          id: 12711,
          known_for_department: 'Diễn viên',
          name: 'R.D. Robb',
          original_name: 'R.D. Robb',
          popularity: 1.242,
          profile_path: null,
          cast_id: 39,
          character: 'Roy',
          credit_id: '5f02e30615959f00375ae977',
          order: 10,
        },
        {
          adult: false,
          gender: 0,
          id: 2581003,
          known_for_department: 'Diễn viên',
          name: 'Gregory R. Goliath',
          original_name: 'Gregory R. Goliath',
          popularity: 0.6,
          profile_path: null,
          cast_id: 40,
          character: 'Luther',
          credit_id: '5f02e32e11c0660039b56362',
          order: 11,
        },
        {
          adult: false,
          gender: 0,
          id: 1527274,
          known_for_department: 'Biên kịch',
          name: 'Fred Parnes',
          original_name: 'Fred Parnes',
          popularity: 0.6,
          profile_path: null,
          cast_id: 23,
          character: 'Waiter',
          credit_id: '5b19a9539251414bb400ccd1',
          order: 12,
        },
        {
          adult: false,
          gender: 1,
          id: 109694,
          known_for_department: 'Diễn viên',
          name: 'Kiami Davael',
          original_name: 'Kiami Davael',
          popularity: 0.6,
          profile_path: null,
          cast_id: 18,
          character: 'Lavender',
          credit_id: '52fe43be9251416c7501c697',
          order: 13,
        },
        {
          adult: false,
          gender: 0,
          id: 228236,
          known_for_department: 'Diễn viên',
          name: 'Leor Livneh Hackel',
          original_name: 'Leor Livneh Hackel',
          popularity: 0.6,
          profile_path: null,
          cast_id: 41,
          character: 'Julius Rottwinkle',
          credit_id: '5f02e53811c0660039b5643f',
          order: 14,
        },
        {
          adult: false,
          gender: 1,
          id: 167189,
          known_for_department: 'Diễn viên',
          name: 'Jacqueline Steiger',
          original_name: 'Jacqueline Steiger',
          popularity: 3.591,
          profile_path: null,
          cast_id: 34,
          character: 'Amanda Thripp',
          credit_id: '5eb8ab01b7d3520021e783e1',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 156734,
          known_for_department: 'Diễn viên',
          name: 'Jimmy Karz',
          original_name: 'Jimmy Karz',
          popularity: 3.134,
          profile_path: null,
          cast_id: 20,
          character: 'Bruce Bogtrotter',
          credit_id: '5a0cfe1c9251416ef2005336',
          order: 16,
        },
        {
          adult: false,
          gender: 0,
          id: 2703644,
          known_for_department: 'Diễn viên',
          name: 'Michael Valentine',
          original_name: 'Michael Valentine',
          popularity: 0.6,
          profile_path: null,
          cast_id: 42,
          character: 'Nigel HIcks',
          credit_id: '5f02e5c07caa470036e18893',
          order: 17,
        },
        {
          adult: false,
          gender: 0,
          id: 1942314,
          known_for_department: 'Diễn viên',
          name: 'Liam Kearns',
          original_name: 'Liam Kearns',
          popularity: 0.6,
          profile_path: null,
          cast_id: 43,
          character: 'Charles',
          credit_id: '5f02e5d40f36550038d703f4',
          order: 18,
        },
        {
          adult: false,
          gender: 2,
          id: 216040,
          known_for_department: 'Diễn viên',
          name: 'Mark Watson',
          original_name: 'Mark Watson',
          popularity: 0.6,
          profile_path: null,
          cast_id: 21,
          character: 'Magnus',
          credit_id: '5afa4dbf0e0a263b8b00585a',
          order: 19,
        },
        {
          adult: false,
          gender: 0,
          id: 1520039,
          known_for_department: 'Diễn viên',
          name: 'Kira Spencer Hesser',
          original_name: 'Kira Spencer Hesser',
          popularity: 0.84,
          profile_path: null,
          cast_id: 35,
          character: 'Hortensia',
          credit_id: '5eb8ab40b7d3520021e784d3',
          order: 20,
        },
        {
          adult: false,
          gender: 0,
          id: 2703645,
          known_for_department: 'Diễn viên',
          name: 'J.C. Alexander',
          original_name: 'J.C. Alexander',
          popularity: 0.6,
          profile_path: null,
          cast_id: 44,
          character: 'Nearby Boy',
          credit_id: '5f02e68c8a0e9b0033992de3',
          order: 21,
        },
        {
          adult: false,
          gender: 0,
          id: 2703646,
          known_for_department: 'Diễn viên',
          name: 'Malone Brinton',
          original_name: 'Malone Brinton',
          popularity: 0.6,
          profile_path: null,
          cast_id: 45,
          character: 'Older Boy',
          credit_id: '5f02e6a053f83300389ef4f1',
          order: 22,
        },
        {
          adult: false,
          gender: 0,
          id: 1785629,
          known_for_department: 'Diễn viên',
          name: 'Marion Dugan',
          original_name: 'Marion Dugan',
          popularity: 0.6,
          profile_path: null,
          cast_id: 46,
          character: 'Cookie',
          credit_id: '5f02e6b215959f00385c53fb',
          order: 23,
        },
        {
          adult: false,
          gender: 0,
          id: 2059555,
          known_for_department: 'Diễn viên',
          name: 'Joshua Alvarez',
          original_name: 'Joshua Alvarez',
          popularity: 0.6,
          profile_path: null,
          cast_id: 24,
          character: 'Child at Assembly',
          credit_id: '5b19a961c3a368490e00d3fe',
          order: 24,
        },
        {
          adult: false,
          gender: 0,
          id: 2059556,
          known_for_department: 'Diễn viên',
          name: 'Max E. Blum',
          original_name: 'Max E. Blum',
          popularity: 0.6,
          profile_path: null,
          cast_id: 25,
          character: 'Child at Assembly',
          credit_id: '5b19a96dc3a368490400bdee',
          order: 25,
        },
        {
          adult: false,
          gender: 0,
          id: 2703650,
          known_for_department: 'Diễn viên',
          name: 'Erin M. Gray',
          original_name: 'Erin M. Gray',
          popularity: 0.6,
          profile_path: null,
          cast_id: 47,
          character: 'Child at Assembly',
          credit_id: '5f02e75a7a3c52003aea6b0c',
          order: 26,
        },
        {
          adult: false,
          gender: 1,
          id: 2703652,
          known_for_department: 'Diễn viên',
          name: 'Misty L. Oppenheim',
          original_name: 'Misty L. Oppenheim',
          popularity: 0.6,
          profile_path: null,
          cast_id: 48,
          character: 'Child in Assembly',
          credit_id: '5f02e770dd258900379db2af',
          order: 27,
        },
        {
          adult: false,
          gender: 0,
          id: 2703654,
          known_for_department: 'Diễn viên',
          name: 'Christopher Shepard Hughes',
          original_name: 'Christopher Shepard Hughes',
          popularity: 0.6,
          profile_path: null,
          cast_id: 49,
          character: 'Child in Assembly',
          credit_id: '5f02e7d4e19de90038cf7262',
          order: 28,
        },
        {
          adult: false,
          gender: 0,
          id: 1226451,
          known_for_department: 'Diễn viên',
          name: 'Rachel Snow',
          original_name: 'Rachel Snow',
          popularity: 0.6,
          profile_path: null,
          cast_id: 36,
          character: 'Child in Assembly',
          credit_id: '5eb8ab7bbbe1dd00208348d5',
          order: 29,
        },
        {
          adult: false,
          gender: 0,
          id: 1228691,
          known_for_department: 'Diễn viên',
          name: 'Craig Lamar Traylor',
          original_name: 'Craig Lamar Traylor',
          popularity: 0.6,
          profile_path: null,
          cast_id: 50,
          character: 'Child in Classroom',
          credit_id: '5f02e900f056d50036d449c6',
          order: 30,
        },
        {
          adult: false,
          gender: 0,
          id: 2703655,
          known_for_department: 'Diễn viên',
          name: 'Jennifer Key',
          original_name: 'Jennifer Key',
          popularity: 0.6,
          profile_path: null,
          cast_id: 51,
          character: 'Child in Classroom',
          credit_id: '5f02e9198ec4ab0035409961',
          order: 31,
        },
        {
          adult: false,
          gender: 0,
          id: 2703656,
          known_for_department: 'Diễn viên',
          name: 'Marty Bautista',
          original_name: 'Marty Bautista',
          popularity: 0.6,
          profile_path: null,
          cast_id: 52,
          character: 'Child in Classroom',
          credit_id: '5f02e931f03174003959fdbb',
          order: 32,
        },
        {
          adult: false,
          gender: 0,
          id: 2703657,
          known_for_department: 'Diễn viên',
          name: 'Anthony Hernandez',
          original_name: 'Anthony Hernandez',
          popularity: 0.6,
          profile_path: null,
          cast_id: 53,
          character: 'Child in Classroom',
          credit_id: '5f02e949f0317400365eec40',
          order: 33,
        },
        {
          adult: false,
          gender: 0,
          id: 2059558,
          known_for_department: 'Diễn viên',
          name: 'Raina Cease',
          original_name: 'Raina Cease',
          popularity: 0.6,
          profile_path: null,
          cast_id: 27,
          character: 'Child in Classroom',
          credit_id: '5b19a9ba9251414bbb00d541',
          order: 34,
        },
        {
          adult: false,
          gender: 2,
          id: 166944,
          known_for_department: 'Diễn viên',
          name: 'Jonathan Osser',
          original_name: 'Jonathan Osser',
          popularity: 0.6,
          profile_path: null,
          cast_id: 54,
          character: 'Child in Classroom',
          credit_id: '5f02e9eb5ed962003797df39',
          order: 35,
        },
        {
          adult: false,
          gender: 0,
          id: 2703661,
          known_for_department: 'Diễn viên',
          name: 'Vinnie Buffolino',
          original_name: 'Vinnie Buffolino',
          popularity: 0.6,
          profile_path: null,
          cast_id: 55,
          character: 'Child in Classroom',
          credit_id: '5f02ea318ec4ab0034401ac0',
          order: 36,
        },
        {
          adult: false,
          gender: 0,
          id: 2703662,
          known_for_department: 'Diễn viên',
          name: 'Marcella Sassano',
          original_name: 'Marcella Sassano',
          popularity: 0.6,
          profile_path: null,
          cast_id: 56,
          character: 'Child in Classroom',
          credit_id: '5f02ea527caa470037df468f',
          order: 37,
        },
        {
          adult: false,
          gender: 0,
          id: 2703663,
          known_for_department: 'Diễn viên',
          name: 'Johnny Thomas III',
          original_name: 'Johnny Thomas III',
          popularity: 0.6,
          profile_path: null,
          cast_id: 57,
          character: 'Child in Classroom',
          credit_id: '5f02ea638ec4ab00334151e1',
          order: 38,
        },
        {
          adult: false,
          gender: 0,
          id: 1210256,
          known_for_department: 'Diễn viên',
          name: 'Shannon Hughes',
          original_name: 'Shannon Hughes',
          popularity: 0.6,
          profile_path: null,
          cast_id: 58,
          character: 'Child in Classroom',
          credit_id: '5f02ea704e6742003256dc3f',
          order: 39,
        },
        {
          adult: false,
          gender: 1,
          id: 1213734,
          known_for_department: 'Diễn viên',
          name: 'Christel Khalil',
          original_name: 'Christel Khalil',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9xlNl80RbPmsdlxCiKZBVf4lxvP.jpg',
          cast_id: 37,
          character: 'Child in Classroom',
          credit_id: '5eb8abc4cc277c00206c1fbe',
          order: 40,
        },
        {
          adult: false,
          gender: 0,
          id: 2703664,
          known_for_department: 'Diễn viên',
          name: 'Cassie Colaw',
          original_name: 'Cassie Colaw',
          popularity: 0.6,
          profile_path: null,
          cast_id: 59,
          character: 'Child in Classroom',
          credit_id: '5f02ead18a0e9b0033992ef2',
          order: 41,
        },
        {
          adult: false,
          gender: 2,
          id: 88736,
          known_for_department: 'Diễn viên',
          name: 'Austin Stout',
          original_name: 'Austin Stout',
          popularity: 0.6,
          profile_path: null,
          cast_id: 60,
          character: 'Child in Classroom',
          credit_id: '5f02eae261bac400369a8d1f',
          order: 42,
        },
        {
          adult: false,
          gender: 0,
          id: 2703665,
          known_for_department: 'Diễn viên',
          name: 'Cindy Tran',
          original_name: 'Cindy Tran',
          popularity: 0.6,
          profile_path: null,
          cast_id: 61,
          character: 'Child in Classroom',
          credit_id: '5f02eb03f056d50036d44aa4',
          order: 43,
        },
        {
          adult: false,
          gender: 2,
          id: 15036,
          known_for_department: 'Diễn viên',
          name: 'Jonathan Feyer',
          original_name: 'Jonathan Feyer',
          popularity: 0.6,
          profile_path: null,
          cast_id: 62,
          character: 'Child in Classroom',
          credit_id: '5f02eb0f61bac400369a8d32',
          order: 44,
        },
        {
          adult: false,
          gender: 0,
          id: 2703666,
          known_for_department: 'Diễn viên',
          name: 'Alissa Graham',
          original_name: 'Alissa Graham',
          popularity: 0.6,
          profile_path: null,
          cast_id: 63,
          character: 'Newborn Matilda',
          credit_id: '5f02eb310f36550039d71c44',
          order: 45,
        },
        {
          adult: false,
          gender: 0,
          id: 2703667,
          known_for_department: 'Diễn viên',
          name: 'Amanda Graham',
          original_name: 'Amanda Graham',
          popularity: 0.6,
          profile_path: null,
          cast_id: 64,
          character: 'Newborn Matilda',
          credit_id: '5f02eb45f056d50036d44b13',
          order: 46,
        },
        {
          adult: false,
          gender: 0,
          id: 2703669,
          known_for_department: 'Diễn viên',
          name: 'Trevor Gallagher',
          original_name: 'Trevor Gallagher',
          popularity: 0.6,
          profile_path: null,
          cast_id: 65,
          character: 'Newborn Matilda',
          credit_id: '5f02eb5e5ed962003897e456',
          order: 47,
        },
        {
          adult: false,
          gender: 0,
          id: 2703672,
          known_for_department: 'Diễn viên',
          name: 'James Gallagher',
          original_name: 'James Gallagher',
          popularity: 0.6,
          profile_path: null,
          cast_id: 66,
          character: 'Newborn Matilda',
          credit_id: '5f02eb6b0f36550039d71c68',
          order: 48,
        },
        {
          adult: false,
          gender: 0,
          id: 2059559,
          known_for_department: 'Diễn viên',
          name: 'Kayla Fredericks',
          original_name: 'Kayla Fredericks',
          popularity: 0.98,
          profile_path: null,
          cast_id: 28,
          character: 'Nine-Months Old Matilda',
          credit_id: '5b19a9c99251414bb400ccf4',
          order: 49,
        },
        {
          adult: false,
          gender: 0,
          id: 2703676,
          known_for_department: 'Diễn viên',
          name: 'Kelsey Fredericks',
          original_name: 'Kelsey Fredericks',
          popularity: 0.6,
          profile_path: null,
          cast_id: 67,
          character: 'Nine-Months Old Matilda',
          credit_id: '5f02eba461bac400369a8daa',
          order: 50,
        },
        {
          adult: false,
          gender: 1,
          id: 1351208,
          known_for_department: 'Diễn viên',
          name: 'Amanda Fein',
          original_name: 'Amanda Fein',
          popularity: 0.828,
          profile_path: null,
          cast_id: 68,
          character: 'Toddler Matilda',
          credit_id: '5f02ebc08ec4ab0035409a98',
          order: 51,
        },
        {
          adult: false,
          gender: 1,
          id: 1236031,
          known_for_department: 'Diễn viên',
          name: 'Caitlin Fein',
          original_name: 'Caitlin Fein',
          popularity: 0.6,
          profile_path: null,
          cast_id: 69,
          character: 'Toddler Matilda',
          credit_id: '5f02ebcc15959f0036592e3e',
          order: 52,
        },
        {
          adult: false,
          gender: 0,
          id: 2703682,
          known_for_department: 'Diễn viên',
          name: 'Nicholas Cox',
          original_name: 'Nicholas Cox',
          popularity: 0.6,
          profile_path: null,
          cast_id: 70,
          character: 'Six-Year-Old Michael',
          credit_id: '5f02ecaa61bac400349a878c',
          order: 53,
        },
        {
          adult: false,
          gender: 0,
          id: 2703684,
          known_for_department: 'Diễn viên',
          name: 'Amanda Summers',
          original_name: 'Amanda Summers',
          popularity: 0.6,
          profile_path: null,
          cast_id: 71,
          character: 'Two-Year-Old Miss Honey',
          credit_id: '5f02ed498a0e9b0036992525',
          order: 54,
        },
        {
          adult: false,
          gender: 0,
          id: 2703685,
          known_for_department: 'Diễn viên',
          name: 'Kristin Summers',
          original_name: 'Kristin Summers',
          popularity: 0.6,
          profile_path: null,
          cast_id: 72,
          character: 'Two-Year-Old Miss Honey',
          credit_id: '5f02ed6d4e6742003356d56f',
          order: 55,
        },
        {
          adult: false,
          gender: 0,
          id: 2703686,
          known_for_department: 'Diễn viên',
          name: 'Phoebe Garcia-Pearl',
          original_name: 'Phoebe Garcia-Pearl',
          popularity: 1.166,
          profile_path: null,
          cast_id: 73,
          character: 'Five-Year-Old Miss Honey',
          credit_id: '5f02eda5f056d50035d36448',
          order: 56,
        },
        {
          adult: false,
          gender: 0,
          id: 1532955,
          known_for_department: 'Diễn viên',
          name: 'Kathy Barbour',
          original_name: 'Kathy Barbour',
          popularity: 0.6,
          profile_path: null,
          cast_id: 74,
          character: 'Million $ Sticky Showgirl',
          credit_id: '5f02ee438ec4ab00323f965b',
          order: 57,
        },
        {
          adult: false,
          gender: 1,
          id: 102938,
          known_for_department: 'Diễn viên',
          name: 'Donna Spangler',
          original_name: 'Donna Spangler',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2IaI9mH3YfgatiRKbJbPMKyaZN.jpg',
          cast_id: 29,
          character: 'Million $ Sticky Showgirl',
          credit_id: '5b19a9d8c3a368490b00a460',
          order: 58,
        },
        {
          adult: false,
          gender: 0,
          id: 2703692,
          known_for_department: 'Diễn viên',
          name: 'Marianne Curan',
          original_name: 'Marianne Curan',
          popularity: 0.6,
          profile_path: null,
          cast_id: 75,
          character: 'Million $ Sticky Contestant',
          credit_id: '5f02eebd7a3c520039ea7e25',
          order: 59,
        },
        {
          adult: false,
          gender: 0,
          id: 2703693,
          known_for_department: 'Diễn viên',
          name: 'Penny Holland',
          original_name: 'Penny Holland',
          popularity: 0.6,
          profile_path: null,
          cast_id: 76,
          character: 'Million $ Sticky Contestant',
          credit_id: '5f02eed55ed962003597edbf',
          order: 60,
        },
        {
          adult: false,
          gender: 0,
          id: 2703694,
          known_for_department: 'Diễn viên',
          name: 'Richard E. Coe',
          original_name: 'Richard E. Coe',
          popularity: 0.6,
          profile_path: null,
          cast_id: 77,
          character: 'Million $ Sticky Contestant',
          credit_id: '5f02ef07f0317400365eef99',
          order: 61,
        },
        {
          adult: false,
          gender: 1,
          id: 183426,
          known_for_department: 'Diễn viên',
          name: 'Sabrina Bryan',
          original_name: 'Sabrina Bryan',
          popularity: 1.114,
          profile_path:
            'https://image.tmdb.org/t/p/w185/riXHjz6swlU0FMA7aXqbJh68g2u.jpg',
          cast_id: 30,
          character: 'Girl (uncredited)',
          credit_id: '5b19a9e80e0a261f9700c083',
          order: 62,
        },
        {
          adult: false,
          gender: 0,
          id: 1137847,
          known_for_department: 'Diễn viên',
          name: 'Trevor Coppola',
          original_name: 'Trevor Coppola',
          popularity: 1.528,
          profile_path: null,
          cast_id: 31,
          character: 'Restaurant Patron (uncredited)',
          credit_id: '5b19a9f60e0a261f9a00bfc4',
          order: 63,
        },
        {
          adult: false,
          gender: 2,
          id: 37891,
          known_for_department: 'Diễn viên',
          name: 'Simon Jones',
          original_name: 'Simon Jones',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2qQNI2E8iZW3Uce4sZzB1AOzYgz.jpg',
          cast_id: 32,
          character: 'Shellhammer (uncredited)',
          credit_id: '5e336dd14ca676001a4e37b3',
          order: 64,
        },
        {
          adult: false,
          gender: 2,
          id: 16165,
          known_for_department: 'Diễn viên',
          name: 'Jon Lovitz',
          original_name: 'Jon Lovitz',
          popularity: 6.83,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jBXSLoDEVwYkNqSVWHV9yDo8whA.jpg',
          cast_id: 33,
          character: 'Million $ Sticky Host (uncredited)',
          credit_id: '5e925979ca4f6700147f509c',
          order: 65,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 518,
          known_for_department: 'Diễn viên',
          name: 'Danny DeVito',
          original_name: 'Danny DeVito',
          popularity: 5.504,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uLW4Y9yjtwxtVmcJfwHZ7sKJai4.jpg',
          credit_id: '52fe43be9251416c7501c653',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 518,
          known_for_department: 'Diễn viên',
          name: 'Danny DeVito',
          original_name: 'Danny DeVito',
          popularity: 5.504,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uLW4Y9yjtwxtVmcJfwHZ7sKJai4.jpg',
          credit_id: '52fe43be9251416c7501c665',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1299,
          known_for_department: 'Biên kịch',
          name: 'Roald Dahl',
          original_name: 'Roald Dahl',
          popularity: 2.737,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hbYOdJ8KK5aPFX6JioRhMiwbMOf.jpg',
          credit_id: '52fe43be9251416c7501c659',
          department: 'Biên kịch',
          job: 'Novel',
        },
        {
          adult: false,
          gender: 2,
          id: 1919,
          known_for_department: 'Camera',
          name: 'Stefan Czapsky',
          original_name: 'Stefan Czapsky',
          popularity: 0.608,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gThptqMLOBUkea1x8BhenwIXGlJ.jpg',
          credit_id: '52fe43be9251416c7501c677',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 3393,
          known_for_department: 'Sound',
          name: 'David Newman',
          original_name: 'David Newman',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gK3u0Xi2OCCF6ZImm0vciW82Sj9.jpg',
          credit_id: '52fe43be9251416c7501c671',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 1,
          id: 3394,
          known_for_department: 'Editing',
          name: 'Lynzee Klingman',
          original_name: 'Lynzee Klingman',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/m8cII1Wkc5Omuua8mkasiKwd7in.jpg',
          credit_id: '52fe43be9251416c7501c67d',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 20213,
          known_for_department: 'Biên kịch',
          name: 'Nicholas Kazan',
          original_name: 'Nicholas Kazan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe43be9251416c7501c65f',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 41079,
          known_for_department: 'Editing',
          name: 'Brent White',
          original_name: 'Brent White',
          popularity: 0.98,
          profile_path: null,
          credit_id: '52fe43be9251416c7501c683',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 68896,
          known_for_department: 'Production',
          name: 'Liccy Dahl',
          original_name: 'Liccy Dahl',
          popularity: 0.98,
          profile_path: null,
          credit_id: '52fe43be9251416c7501c66b',
          department: 'Production',
          job: 'Producer',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'Gimly',
          author_details: {
            name: 'Gimly',
            username: 'Ruuz',
            avatar_path: '/xUObnJSvHrFPsIpoDmb1jiQZLq7.jpg',
            rating: 8.0,
          },
          content:
            'Hold on to this gem tightly, because movies like _Matilda_ will probably never get made again.\r\n\r\n_Final rating:★★★★ - Very strong appeal. A personal favourite._',
          created_at: '2018-09-08T03:48:18.420Z',
          id: '5b9346820e0a261985001c5e',
          updated_at: '2021-06-23T15:58:12.376Z',
          url: 'https://www.themoviedb.org/review/5b9346820e0a261985001c5e',
        },
      ],
      total_pages: 1,
      total_results: 1,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/sKWh9hF0ekVhHHyGuJwdA3fnMGZ.jpg',
    belongs_to_collection: null,
    budget: 60000000,
    genres: [
      { id: 10749, name: 'Phim Lãng Mạn' },
      { id: 878, name: 'Phim Khoa Học Viễn Tưởng' },
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 14, name: 'Phim Giả Tượng' },
    ],
    homepage: '',
    id: 58244,
    imdb_id: 'tt1374992',
    original_language: 'en',
    original_title: 'Upside Down',
    overview:
      'Với sự giúp đỡ của một công thức, một chàng trai bình thường, Adam, đã bất chấp thế giới, quy luật khoa học và lực hấp dẫn để lấy lại tình yêu thời thơ ấu của mình, Eden, người sống ở một thế giới khác.',
    popularity: 16.929,
    poster_path:
      'https://image.tmdb.org/t/p/w342/2Td1nknvCcpc03EtgKULNH2PEjI.jpg',
    production_companies: [
      {
        id: 53495,
        logo_path: null,
        name: 'Upside Down Films',
        origin_country: '',
      },
      {
        id: 53496,
        logo_path: null,
        name: 'Les Films Upside Down',
        origin_country: '',
      },
      { id: 2203, logo_path: null, name: 'Onyx Films', origin_country: '' },
      { id: 48188, logo_path: null, name: 'Transfilm', origin_country: '' },
      {
        id: 2577,
        logo_path: '/QZ4zbeJ0sULzGNJvfukrzgx4d8.png',
        name: 'Studio 37',
        origin_country: 'FR',
      },
      {
        id: 53497,
        logo_path: null,
        name: 'Kinologic Films',
        origin_country: '',
      },
      {
        id: 12391,
        logo_path: null,
        name: 'Jouror Productions',
        origin_country: 'FR',
      },
      {
        id: 83,
        logo_path: '/9OQ0rm55xtlgX7KcAKMUePJSrQc.png',
        name: 'France 2 Cinéma',
        origin_country: 'FR',
      },
    ],
    production_countries: [
      { iso_3166_1: 'CA', name: 'Canada' },
      { iso_3166_1: 'FR', name: 'France' },
    ],
    release_date: '2012-09-27',
    revenue: 22187813,
    runtime: 104,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'Two worlds. One future.',
    title: 'Thế Giới Ngược',
    video: false,
    vote_average: 6.2,
    vote_count: 2118,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Upside Down (2013) Trailer',
          key: '3bTHH3O3MSM',
          published_at: '2013-02-15T20:19:43.000Z',
          site: 'YouTube',
          size: 720,
          type: 'Trailer',
          official: false,
          id: '533ec6b4c3a36854480060db',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 205,
          known_for_department: 'Diễn viên',
          name: 'Kirsten Dunst',
          original_name: 'Kirsten Dunst',
          popularity: 43.533,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5dI5s8Oq2Ook5PFzTWMW6DCXVjm.jpg',
          cast_id: 4,
          character: 'Eden Moore',
          credit_id: '52fe495bc3a36847f8195ebf',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 38941,
          known_for_department: 'Diễn viên',
          name: 'Jim Sturgess',
          original_name: 'Jim Sturgess',
          popularity: 3.065,
          profile_path:
            'https://image.tmdb.org/t/p/w185/c1Q99UEGfU4Laa4o8yu7kGJFIY1.jpg',
          cast_id: 5,
          character: 'Adam Kirk',
          credit_id: '52fe495bc3a36847f8195ec3',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 9191,
          known_for_department: 'Diễn viên',
          name: 'Timothy Spall',
          original_name: 'Timothy Spall',
          popularity: 7.205,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lBOO3ZnoYAeN0xKa81W28i74BD.jpg',
          cast_id: 10,
          character: 'Bob Boruchowitz',
          credit_id: '52fe495bc3a36847f8195ed7',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 38565,
          known_for_department: 'Diễn viên',
          name: 'James Kidnie',
          original_name: 'James Kidnie',
          popularity: 1.632,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iq8ZPSTUq7tbLzll0smHzve9RrT.jpg',
          cast_id: 6,
          character: 'Lagavullan',
          credit_id: '52fe495bc3a36847f8195ec7',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 85168,
          known_for_department: 'Diễn viên',
          name: 'Holly Uloth',
          original_name: 'Holly Uloth',
          popularity: 0.828,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5sLJUJvdOrQk9lpSe2IXd7v0xIf.jpg',
          cast_id: 9,
          character: 'Paula',
          credit_id: '52fe495bc3a36847f8195ed3',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 44150,
          known_for_department: 'Diễn viên',
          name: 'Blu Mankuma',
          original_name: 'Blu Mankuma',
          popularity: 2.938,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qtTavjxroUffUwYAS7kItVmlepU.jpg',
          cast_id: 11,
          character: 'Albert',
          credit_id: '555703449251411e4d005371',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 1234315,
          known_for_department: 'Diễn viên',
          name: 'Nicholas Rose',
          original_name: 'Nicholas Rose',
          popularity: 2.06,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nzQW8KMZndQgoMeWoVmO6Le2vmW.jpg',
          cast_id: 12,
          character: 'Pablo',
          credit_id: '555703579251411ff0001e6b',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 58169,
          known_for_department: 'Diễn viên',
          name: 'Vlasta Vrána',
          original_name: 'Vlasta Vrána',
          popularity: 0.634,
          profile_path:
            'https://image.tmdb.org/t/p/w185/z5ujCvCkNv7ikka6tJVaxqegldY.jpg',
          cast_id: 13,
          character: 'Mr. Hunt',
          credit_id: '555703849251412ff9003aa1',
          order: 7,
        },
        {
          adult: false,
          gender: 1,
          id: 59794,
          known_for_department: 'Diễn viên',
          name: 'Kate Trotter',
          original_name: 'Kate Trotter',
          popularity: 2.323,
          profile_path: null,
          cast_id: 14,
          character: 'Becky',
          credit_id: '55570396c3a3687772005624',
          order: 8,
        },
        {
          adult: false,
          gender: 1,
          id: 180691,
          known_for_department: 'Diễn viên',
          name: 'Janine Theriault',
          original_name: 'Janine Theriault',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/Al96Hh99MhtY7fmRjzTidL05TjZ.jpg',
          cast_id: 17,
          character: 'Miss Maguire',
          credit_id: '555703e69251411e54004ed3',
          order: 9,
        },
        {
          adult: false,
          gender: 0,
          id: 1467538,
          known_for_department: 'Diễn viên',
          name: 'Vincent Messina',
          original_name: 'Vincent Messina',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/urgkcjRRrOdiljf5m6YJwoTyX7b.jpg',
          cast_id: 18,
          character: 'Tommy',
          credit_id: '555703fc9251411e4d005393',
          order: 10,
        },
        {
          adult: false,
          gender: 0,
          id: 1467539,
          known_for_department: 'Diễn viên',
          name: 'Cole K. Mickenzie',
          original_name: 'Cole K. Mickenzie',
          popularity: 0.6,
          profile_path: null,
          cast_id: 19,
          character: 'Pato',
          credit_id: '5557040c9251411e4d005399',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 81427,
          known_for_department: 'Diễn viên',
          name: 'Paul Ahmarani',
          original_name: 'Paul Ahmarani',
          popularity: 0.972,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iJc83Aagsajon0PHBJVtLeSue73.jpg',
          cast_id: 20,
          character: 'Mr. Tenet',
          credit_id: '5557041d9251411e51005402',
          order: 12,
        },
        {
          adult: false,
          gender: 0,
          id: 1504592,
          known_for_department: 'Diễn viên',
          name: 'Carolyn Guillet',
          original_name: 'Carolyn Guillet',
          popularity: 0.6,
          profile_path: null,
          cast_id: 25,
          character: 'Mrs. Nathanson',
          credit_id: '55e83fe79251413e320022b8',
          order: 13,
        },
        {
          adult: false,
          gender: 0,
          id: 1504595,
          known_for_department: 'Diễn viên',
          name: 'Jesse Sherman',
          original_name: 'Jesse Sherman',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rZhMrWeRkMpWvg7S7SXewPu57rB.jpg',
          cast_id: 32,
          character: 'Kevin',
          credit_id: '55e83fe9c3a3682c6400200f',
          order: 14,
        },
        {
          adult: false,
          gender: 0,
          id: 1504596,
          known_for_department: 'Diễn viên',
          name: 'Francis B. Goldberg',
          original_name: 'Francis B. Goldberg',
          popularity: 0.6,
          profile_path: null,
          cast_id: 35,
          character: 'Mrs. Kiefer',
          credit_id: '55e83fea9251413e350022dc',
          order: 15,
        },
        {
          adult: false,
          gender: 0,
          id: 1684837,
          known_for_department: 'Diễn viên',
          name: 'Francois Cote',
          original_name: 'Francois Cote',
          popularity: 0.6,
          profile_path: null,
          cast_id: 109,
          character: 'Marshall Heavy',
          credit_id: '57e7f37f9251416c69009c9d',
          order: 16,
        },
        {
          adult: false,
          gender: 1,
          id: 1467536,
          known_for_department: 'Diễn viên',
          name: 'Maurane Arcand',
          original_name: 'Maurane Arcand',
          popularity: 0.6,
          profile_path: null,
          cast_id: 15,
          character: 'Eden 10 Years Old',
          credit_id: '555703b7c3a3687782005bc4',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 1467537,
          known_for_department: 'Diễn viên',
          name: 'Elliott Larson',
          original_name: 'Elliott Larson',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/n4jBfu9D8cZ8u6oNDR20BBAirJk.jpg',
          cast_id: 16,
          character: 'Adam 12 Years Old',
          credit_id: '555703d49251411ff0001e7a',
          order: 18,
        },
        {
          adult: false,
          gender: 1,
          id: 101219,
          known_for_department: 'Diễn viên',
          name: 'Heidi Hawkins',
          original_name: 'Heidi Hawkins',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/h3dqTejLHfq2fELuUkgBRASh6jB.jpg',
          cast_id: 7,
          character: 'Reporter',
          credit_id: '52fe495bc3a36847f8195ecb',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 92263,
          known_for_department: 'Diễn viên',
          name: 'Don Jordan',
          original_name: 'Don Jordan',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nWsmdxLaNCEj0GifyzjcyLlRjD9.jpg',
          cast_id: 8,
          character: 'TV Host',
          credit_id: '52fe495bc3a36847f8195ecf',
          order: 20,
        },
        {
          adult: false,
          gender: 0,
          id: 147016,
          known_for_department: 'Diễn viên',
          name: 'Pablo Verón',
          original_name: 'Pablo Verón',
          popularity: 0.694,
          profile_path: null,
          cast_id: 26,
          character: 'Tango Dancer',
          credit_id: '55e83fe79251413e3800227e',
          order: 21,
        },
        {
          adult: false,
          gender: 0,
          id: 1504593,
          known_for_department: 'Diễn viên',
          name: 'Edward Langham',
          original_name: 'Edward Langham',
          popularity: 0.6,
          profile_path: null,
          cast_id: 27,
          character: 'Old Waiter (Fernando)',
          credit_id: '55e83fe79251413e350022d7',
          order: 22,
        },
        {
          adult: false,
          gender: 2,
          id: 101220,
          known_for_department: 'Diễn viên',
          name: 'Keir Cutler',
          original_name: 'Keir Cutler',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tCbjwKYr877uAiz4H272HdY4yEM.jpg',
          cast_id: 29,
          character: 'Security Guard #1',
          credit_id: '55e83fe89251413e3e002496',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 108302,
          known_for_department: 'Diễn viên',
          name: 'Matt Holland',
          original_name: 'Matt Holland',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ic37ED27NTrKm5FnJS2tTts1vVG.jpg',
          cast_id: 47,
          character: 'Security Guard #2',
          credit_id: '55e83fedc3a3682c670023d2',
          order: 24,
        },
        {
          adult: false,
          gender: 2,
          id: 1050988,
          known_for_department: 'Diễn viên',
          name: 'Alex Bisping',
          original_name: 'Alex Bisping',
          popularity: 0.646,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dk0NjcM18VQ0sYru5wyyx1RPhTV.jpg',
          cast_id: 30,
          character: 'Contest Winner',
          credit_id: '55e83fe8c3a3682c5f002547',
          order: 25,
        },
        {
          adult: false,
          gender: 2,
          id: 1504594,
          known_for_department: 'Diễn viên',
          name: 'George Mantis',
          original_name: 'George Mantis',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bFzpRMXkhpYVVHSAFraRDzbCxQI.jpg',
          cast_id: 31,
          character: 'Police Officer',
          credit_id: '55e83fe89251413e38002283',
          order: 26,
        },
        {
          adult: false,
          gender: 2,
          id: 1301505,
          known_for_department: 'Diễn viên',
          name: 'Holden Wong',
          original_name: 'Holden Wong',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tB6Oh9M3rGF0DN47b8AffbMw580.jpg',
          cast_id: 28,
          character: 'Executive #1',
          credit_id: '55e83fe7c3a3682c6400200c',
          order: 27,
        },
        {
          adult: false,
          gender: 1,
          id: 29460,
          known_for_department: 'Diễn viên',
          name: 'Jayne Heitmeyer',
          original_name: 'Jayne Heitmeyer',
          popularity: 1.31,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ytX3cW1i2UYklrs4UZ1jw6hxmoH.jpg',
          cast_id: 33,
          character: 'Executive #2',
          credit_id: '55e83fe99251413e2f00234d',
          order: 28,
        },
        {
          adult: false,
          gender: 2,
          id: 21021,
          known_for_department: 'Diễn viên',
          name: 'John Maclaren',
          original_name: 'John Maclaren',
          popularity: 0.702,
          profile_path:
            'https://image.tmdb.org/t/p/w185/deFq2FqpyUoMes9Jlm7kzP671I1.jpg',
          cast_id: 34,
          character: 'Moderator',
          credit_id: '55e83fe9c3a3682c6b0022cf',
          order: 29,
        },
        {
          adult: false,
          gender: 2,
          id: 78687,
          known_for_department: 'Diễn viên',
          name: 'Robert Higden',
          original_name: 'Robert Higden',
          popularity: 0.6,
          profile_path: null,
          cast_id: 36,
          character: 'Amnesiac',
          credit_id: '55e83feac3a3682c700022f8',
          order: 30,
        },
        {
          adult: false,
          gender: 2,
          id: 79623,
          known_for_department: 'Diễn viên',
          name: 'Noël Burton',
          original_name: 'Noël Burton',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7Sj8iHUlE7QKwhE1DSnfSflktCC.jpg',
          cast_id: 37,
          character: 'CEO',
          credit_id: '55e83fea9251413e350022e0',
          order: 31,
        },
        {
          adult: false,
          gender: 2,
          id: 1504597,
          known_for_department: 'Diễn viên',
          name: 'Jean-Marc Dalphond',
          original_name: 'Jean-Marc Dalphond',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sSD14PjMDluBFvLqSk6ENZy5vlJ.jpg',
          cast_id: 38,
          character: 'Man Up Top',
          credit_id: '55e83feac3a3682c64002014',
          order: 32,
        },
        {
          adult: false,
          gender: 2,
          id: 60907,
          known_for_department: 'Diễn viên',
          name: 'Larry Day',
          original_name: 'Larry Day',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xDZUZ1qWPsov3dqjcbzCWQXFt8y.jpg',
          cast_id: 39,
          character: 'Soldier',
          credit_id: '55e83feb9251413e350022e2',
          order: 33,
        },
        {
          adult: false,
          gender: 0,
          id: 1504598,
          known_for_department: 'Editing',
          name: 'Paul van Dyck',
          original_name: 'Paul van Dyck',
          popularity: 0.6,
          profile_path: null,
          cast_id: 40,
          character: 'Colleague Up Top #1',
          credit_id: '55e83febc3a3682c6b0022d2',
          order: 34,
        },
        {
          adult: false,
          gender: 0,
          id: 115594,
          known_for_department: 'Diễn viên',
          name: 'Patrick Costello',
          original_name: 'Patrick Costello',
          popularity: 0.828,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wAlkY5bQhObo5oCi1oVAZOtvuNy.jpg',
          cast_id: 41,
          character: 'Colleague Up Top #2',
          credit_id: '55e83feb9251413e450022be',
          order: 35,
        },
        {
          adult: false,
          gender: 2,
          id: 198750,
          known_for_department: 'Diễn viên',
          name: 'Pierre Leblanc',
          original_name: 'Pierre Leblanc',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vXEGJSdd8PGlqqAN3lD6glVcBLb.jpg',
          cast_id: 42,
          character: 'Passerby',
          credit_id: '55e83fecc3a3682c5f002549',
          order: 36,
        },
        {
          adult: false,
          gender: 0,
          id: 1504599,
          known_for_department: 'Diễn viên',
          name: 'David Alexandre',
          original_name: 'David Alexandre',
          popularity: 0.6,
          profile_path: null,
          cast_id: 43,
          character: 'Marketing Executive #1',
          credit_id: '55e83fec9251413e38002289',
          order: 37,
        },
        {
          adult: false,
          gender: 2,
          id: 21293,
          known_for_department: 'Diễn viên',
          name: 'Alan Fawcett',
          original_name: 'Alan Fawcett',
          popularity: 0.84,
          profile_path: null,
          cast_id: 44,
          character: 'Marketing Executive #2',
          credit_id: '55e83fecc3a3682c64002018',
          order: 38,
        },
        {
          adult: false,
          gender: 1,
          id: 548204,
          known_for_department: 'Diễn viên',
          name: 'Miranda Handford',
          original_name: 'Miranda Handford',
          popularity: 0.84,
          profile_path: null,
          cast_id: 24,
          character: 'Test Subject #1',
          credit_id: '55e7ecab9251413e380014f5',
          order: 39,
        },
        {
          adult: false,
          gender: 0,
          id: 1504600,
          known_for_department: 'Diễn viên',
          name: 'Francine Pilote',
          original_name: 'Francine Pilote',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/knveGa96DH467morukyzpWOg8ST.jpg',
          cast_id: 45,
          character: 'Test Subject #2',
          credit_id: '55e83fed9251413e3a002373',
          order: 40,
        },
        {
          adult: false,
          gender: 1,
          id: 1504601,
          known_for_department: 'Diễn viên',
          name: 'Angie Larocque',
          original_name: 'Angie Larocque',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1vHmMuCVvnLPMUxhb0N8aLMdddo.jpg',
          cast_id: 46,
          character: 'Test Subject #3',
          credit_id: '55e83fed9251413e450022c1',
          order: 41,
        },
        {
          adult: false,
          gender: 0,
          id: 198647,
          known_for_department: 'Diễn viên',
          name: 'Emma Stevens',
          original_name: 'Emma Stevens',
          popularity: 0.6,
          profile_path: null,
          cast_id: 48,
          character: 'Old Lady',
          credit_id: '55e83fed9251413e320022be',
          order: 42,
        },
        {
          adult: false,
          gender: 2,
          id: 129419,
          known_for_department: 'Diễn viên',
          name: 'Richard Zeman',
          original_name: 'Richard Zeman',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gqoFOlEJAMBk7MzF8QPetXNtJRL.jpg',
          cast_id: 49,
          character: 'Head of Security',
          credit_id: '55e83feec3a3682c6b0022d7',
          order: 43,
        },
        {
          adult: false,
          gender: 2,
          id: 1674587,
          known_for_department: 'Diễn viên',
          name: 'Al Dubois',
          original_name: 'Al Dubois',
          popularity: 0.6,
          profile_path: null,
          cast_id: 108,
          character: 'Newscaster',
          credit_id: '57e7f2f99251412ae3012908',
          order: 44,
        },
        {
          adult: false,
          gender: 0,
          id: 1375493,
          known_for_department: 'Diễn viên',
          name: 'Paul Burke',
          original_name: 'Paul Burke',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tIV9QsxR5hK3aY5Lzn65gdNT0C2.jpg',
          cast_id: 120,
          character: 'Security Guard',
          credit_id: '5b3b47f3c3a36845fb01d8f2',
          order: 45,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 1303,
          known_for_department: 'Art',
          name: 'Alex McDowell',
          original_name: 'Alex McDowell',
          popularity: 1.22,
          profile_path: null,
          credit_id: '57348ce1c3a3681deb001e54',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 2,
          id: 4657,
          known_for_department: 'Visual Effects',
          name: 'Louis Craig',
          original_name: 'Louis Craig',
          popularity: 0.6,
          profile_path: null,
          credit_id: '573491f3c3a36829c100003b',
          department: 'Visual Effects',
          job: 'Special Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 6053,
          known_for_department: 'Art',
          name: 'Paul Hotte',
          original_name: 'Paul Hotte',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57348cf4c3a368247a000d2a',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 2,
          id: 6064,
          known_for_department: 'Crew',
          name: 'Marcello Bezina',
          original_name: 'Marcello Bezina',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5e5d2d3b9b86160015fc85c1',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 8370,
          known_for_department: 'Directing',
          name: 'Pierre Henry',
          original_name: 'Pierre Henry',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e5d2b11357c0000162bbfb4',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 8704,
          known_for_department: 'Art',
          name: 'Isabelle Guay',
          original_name: 'Isabelle Guay',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57348d67c3a3681e6e001e85',
          department: 'Art',
          job: 'Supervising Art Director',
        },
        {
          adult: false,
          gender: 2,
          id: 25744,
          known_for_department: 'Camera',
          name: 'Pierre Gill',
          original_name: 'Pierre Gill',
          popularity: 1.094,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3ArCxrQdXL1s7l16EsOvbPxsZpd.jpg',
          credit_id: '57348c25c3a3681e6e001e4b',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 41968,
          known_for_department: 'Biên kịch',
          name: 'Santiago Amigorena',
          original_name: 'Santiago Amigorena',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/e4DL02eHOqNRtzamQOerpa6a1Cz.jpg',
          credit_id: '57348a29c3a3682a18002daa',
          department: 'Biên kịch',
          job: 'Adaptation',
        },
        {
          adult: false,
          gender: 2,
          id: 52244,
          known_for_department: 'Biên kịch',
          name: 'Juan Diego Solanas',
          original_name: 'Juan Diego Solanas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe495bc3a36847f8195ebb',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 52244,
          known_for_department: 'Biên kịch',
          name: 'Juan Diego Solanas',
          original_name: 'Juan Diego Solanas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe495bc3a36847f8195eaf',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 53228,
          known_for_department: 'Production',
          name: 'Aton Soumache',
          original_name: 'Aton Soumache',
          popularity: 0.6,
          profile_path: null,
          credit_id: '559e8735c3a368081400167f',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 53229,
          known_for_department: 'Production',
          name: 'Alexis Vonarb',
          original_name: 'Alexis Vonarb',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57348bf89251410b450006ba',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 59446,
          known_for_department: 'Sound',
          name: 'Benoît Charest',
          original_name: 'Benoît Charest',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57348c0c92514174bc001c62',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 0,
          id: 69376,
          known_for_department: 'Editing',
          name: 'Paul Jutras',
          original_name: 'Paul Jutras',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57348c51925141676500209c',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 72903,
          known_for_department: 'Production',
          name: 'Jonathan Vanger',
          original_name: 'Jonathan Vanger',
          popularity: 1.4,
          profile_path: null,
          credit_id: '57348bbdc3a36861430006c8',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 90354,
          known_for_department: 'Crew',
          name: 'Michael Scherer',
          original_name: 'Michael Scherer',
          popularity: 1.094,
          profile_path: null,
          credit_id: '5e5d2f629b86160015fc899e',
          department: 'Crew',
          job: 'Stunt Driver',
        },
        {
          adult: false,
          gender: 1,
          id: 84577,
          known_for_department: 'Diễn viên',
          name: 'Jessica Kardos',
          original_name: 'Jessica Kardos',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4r0WAh6A2slhMK8ZdgUfytSCTFx.jpg',
          credit_id: '5734921592514140f000005b',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 114358,
          known_for_department: 'Sound',
          name: 'Olivier Calvert',
          original_name: 'Olivier Calvert',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5734943b9251417540001e2f',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 207818,
          known_for_department: 'Crew',
          name: 'Patrick Kerton',
          original_name: 'Patrick Kerton',
          popularity: 1.128,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jj9uVCBSSUFvOi663jMbs7YJ3G3.jpg',
          credit_id: '5e5d2e7e9b8616000ffca816',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 1,
          id: 229989,
          known_for_department: 'Production',
          name: 'Susan Forrest',
          original_name: 'Susan Forrest',
          popularity: 1.38,
          profile_path: null,
          credit_id: '57348c75c3a368247a000d14',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 405004,
          known_for_department: 'Sound',
          name: 'Patrick Rousseau',
          original_name: 'Patrick Rousseau',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e5d2cca66ae4d0019895561',
          department: 'Sound',
          job: 'Sound Mixer',
        },
        {
          adult: false,
          gender: 1,
          id: 959634,
          known_for_department: 'Costume & Make-Up',
          name: 'Nicoletta Massone',
          original_name: 'Nicoletta Massone',
          popularity: 0.729,
          profile_path: null,
          credit_id: '57348d90925141198f0004de',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 2,
          id: 967604,
          known_for_department: 'Production',
          name: 'Dimitri Rassam',
          original_name: 'Dimitri Rassam',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/x4i2MOnVdKJRXGkeAHr2Htb0xVM.jpg',
          credit_id: '559e8724925141300e00132c',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 982406,
          known_for_department: 'Diễn viên',
          name: 'David Rigby',
          original_name: 'David Rigby',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e5d2f1287e63e001a7414ab',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1039357,
          known_for_department: 'Production',
          name: 'Claude Léger',
          original_name: 'Claude Léger',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57348b6ec3a36875e90004cd',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1180758,
          known_for_department: 'Directing',
          name: 'Mario Janelle',
          original_name: 'Mario Janelle',
          popularity: 0.6,
          profile_path: null,
          credit_id: '573490049251417540001d85',
          department: 'Crew',
          job: 'Second Unit Cinematographer',
        },
        {
          adult: false,
          gender: 0,
          id: 1197112,
          known_for_department: 'Sound',
          name: 'Luc Boudrias',
          original_name: 'Luc Boudrias',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57349425c3a3682a18002f33',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 1236388,
          known_for_department: 'Crew',
          name: 'Jim Filippone',
          original_name: 'Jim Filippone',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1b45afc3a3680b9d04398e',
          department: 'Crew',
          job: 'Pilot',
        },
        {
          adult: false,
          gender: 0,
          id: 1267055,
          known_for_department: 'Sound',
          name: 'Lise Wedlock',
          original_name: 'Lise Wedlock',
          popularity: 0.6,
          profile_path: null,
          credit_id: '573493fe9251410acf000816',
          department: 'Sound',
          job: 'Foley',
        },
        {
          adult: false,
          gender: 0,
          id: 1276648,
          known_for_department: 'Visual Effects',
          name: 'Marine Tuloup',
          original_name: 'Marine Tuloup',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5734936492514174f1001d53',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1327213,
          known_for_department: 'Costume & Make-Up',
          name: 'Michelle Côté',
          original_name: 'Michelle Côté',
          popularity: 0.6,
          profile_path: null,
          credit_id: '573494859251417515001e10',
          department: 'Costume & Make-Up',
          job: 'Hair Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 1327907,
          known_for_department: 'Art',
          name: 'Jean-Pierre Paquet',
          original_name: 'Jean-Pierre Paquet',
          popularity: 0.728,
          profile_path: null,
          credit_id: '57348c939251410acf0006dc',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1367819,
          known_for_department: 'Visual Effects',
          name: 'Marie-Cecile Dahan',
          original_name: 'Marie-Cecile Dahan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '573493499251410acf0007fb',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1367821,
          known_for_department: 'Visual Effects',
          name: 'François Dumoulin',
          original_name: 'François Dumoulin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57349379c3a36829c100006e',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1384362,
          known_for_department: 'Art',
          name: 'Lucie Tremblay',
          original_name: 'Lucie Tremblay',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57348d4ec3a36875b20004e1',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1384366,
          known_for_department: 'Sound',
          name: 'Maxime Ferland',
          original_name: 'Maxime Ferland',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e5d2c0887e63e0013742459',
          department: 'Sound',
          job: 'Boom Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1391751,
          known_for_department: 'Art',
          name: 'Frédéric Amblard',
          original_name: 'Frédéric Amblard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57348d0dc3a36850f1002ac7',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1391759,
          known_for_department: 'Crew',
          name: 'Denis Hamel',
          original_name: 'Denis Hamel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e5d2b6a357c0000132bf2b0',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 1392106,
          known_for_department: 'Camera',
          name: 'Takashi Seida',
          original_name: 'Takashi Seida',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57348f389251410acf000746',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 1,
          id: 1392908,
          known_for_department: 'Visual Effects',
          name: 'Karen M. Murphy',
          original_name: 'Karen M. Murphy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '573492fec3a36875b20005da',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1394740,
          known_for_department: 'Art',
          name: 'Helene Lamarre',
          original_name: 'Helene Lamarre',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57348cb59251417515001cdf',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1399558,
          known_for_department: 'Sound',
          name: 'Natalie Fleurant',
          original_name: 'Natalie Fleurant',
          popularity: 0.98,
          profile_path: null,
          credit_id: '573493a29251417540001e1c',
          department: 'Sound',
          job: 'ADR & Dubbing',
        },
        {
          adult: false,
          gender: 2,
          id: 1399916,
          known_for_department: 'Crew',
          name: 'Jean-Alexandre Villemer',
          original_name: 'Jean-Alexandre Villemer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '573493eb9251410acf000812',
          department: 'Crew',
          job: 'Sound Recordist',
        },
        {
          adult: false,
          gender: 0,
          id: 1399920,
          known_for_department: 'Visual Effects',
          name: 'François-Xavier Aubague',
          original_name: 'François-Xavier Aubague',
          popularity: 0.6,
          profile_path: null,
          credit_id: '573492adc3a3681deb001f43',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1401569,
          known_for_department: 'Visual Effects',
          name: 'Sophie Leclerc',
          original_name: 'Sophie Leclerc',
          popularity: 0.6,
          profile_path: null,
          credit_id: '573492eac3a368614300082b',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1402019,
          known_for_department: 'Costume & Make-Up',
          name: 'Colleen Quinton',
          original_name: 'Colleen Quinton',
          popularity: 0.656,
          profile_path: null,
          credit_id: '5734949dc3a3682a18002f47',
          department: 'Costume & Make-Up',
          job: 'Makeup Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 1407007,
          known_for_department: 'Costume & Make-Up',
          name: 'Gaétan Landry',
          original_name: 'Gaétan Landry',
          popularity: 0.6,
          profile_path: null,
          credit_id: '573494719251410acf000831',
          department: 'Costume & Make-Up',
          job: 'Hair Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 1409704,
          known_for_department: 'Art',
          name: 'Lucie Paquet',
          original_name: 'Lucie Paquet',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57348d2cc3a36850f1002ace',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1409712,
          known_for_department: 'Camera',
          name: 'John Trapman',
          original_name: 'John Trapman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57348ef8c3a36850f1002b19',
          department: 'Camera',
          job: 'Helicopter Camera',
        },
        {
          adult: false,
          gender: 2,
          id: 1409712,
          known_for_department: 'Camera',
          name: 'John Trapman',
          original_name: 'John Trapman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1b449d9251410326048888',
          department: 'Camera',
          job: 'Aerial Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 1410598,
          known_for_department: 'Crew',
          name: 'Luc Froehlicher',
          original_name: 'Luc Froehlicher',
          popularity: 0.6,
          profile_path: null,
          credit_id: '573491a9c3a36850f1002b70',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1412593,
          known_for_department: 'Visual Effects',
          name: 'Olivier Goulet',
          original_name: 'Olivier Goulet',
          popularity: 0.6,
          profile_path: null,
          credit_id: '573491c9c3a3681deb001f20',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1419718,
          known_for_department: 'Costume & Make-Up',
          name: 'Corald Giroux',
          original_name: 'Corald Giroux',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5734945f9251417515001e06',
          department: 'Costume & Make-Up',
          job: 'Hair Department Head',
        },
        {
          adult: false,
          gender: 2,
          id: 1419723,
          known_for_department: 'Editing',
          name: 'Mathieu Berube',
          original_name: 'Mathieu Berube',
          popularity: 0.828,
          profile_path: null,
          credit_id: '57349241c3a3681e6e001f37',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1425387,
          known_for_department: 'Visual Effects',
          name: 'Scott Shapiro',
          original_name: 'Scott Shapiro',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57349326c3a36875e90005fa',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1466536,
          known_for_department: 'Crew',
          name: 'Thomas Liccioni',
          original_name: 'Thomas Liccioni',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aEkJUsCu4lU2yFFR37kNm5Ojq4C.jpg',
          credit_id: '5e5d2ed355c92600195354b9',
          department: 'Crew',
          job: 'Utility Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1519867,
          known_for_department: 'Directing',
          name: 'Lorette Leblanc',
          original_name: 'Lorette Leblanc',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1b45c70e0a264ccd047c0a',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1536642,
          known_for_department: 'Editing',
          name: 'Edith Bellehumeur',
          original_name: 'Edith Bellehumeur',
          popularity: 0.6,
          profile_path: null,
          credit_id: '573494e792514174f1001d81',
          department: 'Editing',
          job: 'Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1548182,
          known_for_department: 'Editing',
          name: 'David Di Francesco',
          original_name: 'David Di Francesco',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57349299c3a36850f1002b9a',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1551663,
          known_for_department: 'Crew',
          name: 'Stephanie Keating',
          original_name: 'Stephanie Keating',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e5d3130357c0000192c113d',
          department: 'Crew',
          job: 'Unit Publicist',
        },
        {
          adult: false,
          gender: 2,
          id: 1574652,
          known_for_department: 'Directing',
          name: 'Stéphane Byl',
          original_name: 'Stéphane Byl',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e5d2a9b87e63e001573fc17',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1611794,
          known_for_department: 'Crew',
          name: 'David McKeown',
          original_name: 'David McKeown',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5e5d2d0a87e63e0013742653',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1618797,
          known_for_department: 'Directing',
          name: 'Pierre Magny',
          original_name: 'Pierre Magny',
          popularity: 0.676,
          profile_path: null,
          credit_id: '57348a3d92514174bc001c1b',
          department: 'Biên kịch',
          job: 'Adaptation',
        },
        {
          adult: false,
          gender: 0,
          id: 1618801,
          known_for_department: 'Costume & Make-Up',
          name: 'Priscilla Collin',
          original_name: 'Priscilla Collin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57348e0992514174bc001ca3',
          department: 'Costume & Make-Up',
          job: 'Seamstress',
        },
        {
          adult: false,
          gender: 0,
          id: 1618802,
          known_for_department: 'Costume & Make-Up',
          name: 'Nicole Cyr',
          original_name: 'Nicole Cyr',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57348e1ac3a368614300073d',
          department: 'Costume & Make-Up',
          job: 'Seamstress',
        },
        {
          adult: false,
          gender: 0,
          id: 1618803,
          known_for_department: 'Costume & Make-Up',
          name: 'Marie-Eve Journeault',
          original_name: 'Marie-Eve Journeault',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57348e2dc3a368247a000d53',
          department: 'Costume & Make-Up',
          job: 'Seamstress',
        },
        {
          adult: false,
          gender: 0,
          id: 1618804,
          known_for_department: 'Costume & Make-Up',
          name: 'Marie-Sophie Rodrigue',
          original_name: 'Marie-Sophie Rodrigue',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57348e4ac3a36850f1002af7',
          department: 'Costume & Make-Up',
          job: 'Seamstress',
        },
        {
          adult: false,
          gender: 2,
          id: 1618805,
          known_for_department: 'Sound',
          name: 'Joe Rudge',
          original_name: 'Joe Rudge',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57348e62c3a36875b200050e',
          department: 'Sound',
          job: 'Music Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1618806,
          known_for_department: 'Camera',
          name: 'Geoffroy St-Hilaire',
          original_name: 'Geoffroy St-Hilaire',
          popularity: 0.694,
          profile_path: null,
          credit_id: '57348edd925141198f000515',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1618806,
          known_for_department: 'Camera',
          name: 'Geoffroy St-Hilaire',
          original_name: 'Geoffroy St-Hilaire',
          popularity: 0.694,
          profile_path: null,
          credit_id: '57348f1bc3a36875b200052a',
          department: 'Camera',
          job: 'Steadicam Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1618807,
          known_for_department: 'Camera',
          name: 'Geoffroy Beauchemin',
          original_name: 'Geoffroy Beauchemin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57348f4c9251410acf00074b',
          department: 'Camera',
          job: 'Underwater Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1618808,
          known_for_department: 'Camera',
          name: 'Patrick Beaulac',
          original_name: 'Patrick Beaulac',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57348f6ac3a36875e900056c',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1618809,
          known_for_department: 'Camera',
          name: 'Maxime Gagnon',
          original_name: 'Maxime Gagnon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57348f8192514174f1001ca8',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1618810,
          known_for_department: 'Visual Effects',
          name: 'Alexandra Vaillancourt',
          original_name: 'Alexandra Vaillancourt',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57349229c3a3682a18002eed',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1618811,
          known_for_department: 'Visual Effects',
          name: 'Caroline Audebert',
          original_name: 'Caroline Audebert',
          popularity: 0.6,
          profile_path: null,
          credit_id: '573492c192514140f000007e',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1618812,
          known_for_department: 'Costume & Make-Up',
          name: 'Melissa Fafard',
          original_name: 'Melissa Fafard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '573494af92514140c30000a3',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1618813,
          known_for_department: 'Costume & Make-Up',
          name: 'Fanny Vachon',
          original_name: 'Fanny Vachon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '573494c29251410acf000841',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1684368,
          known_for_department: 'Production',
          name: 'Jim Kontos',
          original_name: 'Jim Kontos',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1b44310e0a264cc80486c6',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1758133,
          known_for_department: 'Production',
          name: 'Ginette Guillard',
          original_name: 'Ginette Guillard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1b44170e0a264cc80486b0',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1789643,
          known_for_department: 'Directing',
          name: 'Renato De Cotiis',
          original_name: 'Renato De Cotiis',
          popularity: 1.214,
          profile_path: null,
          credit_id: '5e5d2ac2357c0000162bbe84',
          department: 'Directing',
          job: 'Second Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1823551,
          known_for_department: 'Diễn viên',
          name: 'Stéphane Julien',
          original_name: 'Stéphane Julien',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zUUv6gU8HB8hngtchyLjlo2mJAp.jpg',
          credit_id: '5e5d2e5c55c9260019535420',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1854994,
          known_for_department: 'Camera',
          name: 'Patrick Lima',
          original_name: 'Patrick Lima',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1b44d40e0a264ccd047b05',
          department: 'Camera',
          job: 'Dolly Grip',
        },
        {
          adult: false,
          gender: 2,
          id: 1890932,
          known_for_department: 'Crew',
          name: 'Tyler Hall',
          original_name: 'Tyler Hall',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lN0FFCcqLTAKMv9uyWYR2o1OPRl.jpg',
          credit_id: '5e5d2e4866ae4d00178963b8',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 0,
          id: 1930305,
          known_for_department: 'Lighting',
          name: 'Gaël Giraud',
          original_name: 'Gaël Giraud',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1b452cc3a3680b8a045b56',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1930307,
          known_for_department: 'Lighting',
          name: 'Simon Touzin',
          original_name: 'Simon Touzin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1b454b0e0a264ccd047b93',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1930309,
          known_for_department: 'Costume & Make-Up',
          name: 'Manon Brodeur',
          original_name: 'Manon Brodeur',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1b45669251410329047f9d',
          department: 'Costume & Make-Up',
          job: 'Costume Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1930310,
          known_for_department: 'Costume & Make-Up',
          name: 'Jacqueline Rousseau',
          original_name: 'Jacqueline Rousseau',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1b458692514103390466f5',
          department: 'Costume & Make-Up',
          job: 'Tailor',
        },
        {
          adult: false,
          gender: 2,
          id: 1943586,
          known_for_department: 'Crew',
          name: 'Felix Famelart',
          original_name: 'Felix Famelart',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e5d2dcb55c926001753c3f4',
          department: 'Crew',
          job: 'Stunt Driver',
        },
        {
          adult: false,
          gender: 2,
          id: 2040368,
          known_for_department: 'Sound',
          name: 'James Hyde',
          original_name: 'James Hyde',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e5d2c2d55c926001353f56b',
          department: 'Sound',
          job: 'ADR Recordist',
        },
        {
          adult: false,
          gender: 0,
          id: 2073953,
          known_for_department: 'Sound',
          name: 'Mark Lafbery',
          original_name: 'Mark Lafbery',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e5d2c6b87e63e001573ff36',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 2207514,
          known_for_department: 'Sound',
          name: 'Yann Cleary',
          original_name: 'Yann Cleary',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e5d2bc287e63e00137423b3',
          department: 'Sound',
          job: 'Sound Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 2236499,
          known_for_department: 'Camera',
          name: 'David Dinel',
          original_name: 'David Dinel',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5e5d2f8b66ae4d001489ad80',
          department: 'Camera',
          job: 'Key Grip',
        },
        {
          adult: false,
          gender: 2,
          id: 2490985,
          known_for_department: 'Diễn viên',
          name: 'Miguel Dugal',
          original_name: 'Miguel Dugal',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e5d2dab87e63e00137427af',
          department: 'Crew',
          job: 'Utility Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 2555200,
          known_for_department: 'Directing',
          name: 'Mario Janelle',
          original_name: 'Mario Janelle',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e5d2b3866ae4d0019895054',
          department: 'Directing',
          job: 'Second Unit Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2555201,
          known_for_department: 'Sound',
          name: 'Nicolas Dallaire',
          original_name: 'Nicolas Dallaire',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e5d2bee87e63e001573fe39',
          department: 'Sound',
          job: 'ADR Recordist',
        },
        {
          adult: false,
          gender: 0,
          id: 2555204,
          known_for_department: 'Crew',
          name: 'Marco Desjean',
          original_name: 'Marco Desjean',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e5d2d8d357c0000132bf63a',
          department: 'Crew',
          job: 'Utility Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 2555209,
          known_for_department: 'Crew',
          name: 'Alexandre Prefontaine',
          original_name: 'Alexandre Prefontaine',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e5d2ee755c926001353f86d',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 2555219,
          known_for_department: 'Crew',
          name: 'Cynthia Bibeau',
          original_name: 'Cynthia Bibeau',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e5d3110357c0000192c1108',
          department: 'Crew',
          job: 'Set Medic',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/lo4BllBfNgNUHHTohb218lNgaM3.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [{ id: 99, name: 'Phim Tài Liệu' }],
    homepage: 'https://www.netflix.com/title/80117542',
    id: 566222,
    imdb_id: 'tt4736550',
    original_language: 'en',
    original_title: 'The Great Hack',
    overview:
      'Một bộ phim tài liệu của Netflix về Cambridge Analytica đã làm sáng tỏ một trong những vụ bê bối phức tạp nhất của thời đại chúng ta.',
    popularity: 11.016,
    poster_path:
      'https://image.tmdb.org/t/p/w342/uIrGgUzasEUA7v8uChRhUUFzLwE.jpg',
    production_companies: [
      { id: 27197, logo_path: null, name: 'Noujaim Films', origin_country: '' },
      {
        id: 121268,
        logo_path: '/vPtiQxlA2S3Z77eduT6TFqBG9NE.png',
        name: 'The Othrs',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2019-01-26',
    revenue: 0,
    runtime: 114,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'Họ lấy dữ liệu của bạn. Sau đó, họ nắm quyền kiểm soát.',
    title: 'Hacker Vĩ Đại',
    video: false,
    vote_average: 6.9,
    vote_count: 379,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Great Hack | Official Trailer | Netflix',
          key: 'iX8GxLP1FHo',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2019-07-11T13:00:05.000Z',
          id: '5d27860a5f6c4902c35e155a',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 0,
          id: 2359379,
          known_for_department: 'Diễn viên',
          name: 'Brittany Kaiser',
          original_name: 'Brittany Kaiser',
          popularity: 0.735,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dTT6N5edu82P7XMyRanK4rrWDlR.jpg',
          cast_id: 12,
          character:
            'Self - Former Dir. of Business Development, Cambridge Analytica',
          credit_id: '5d27360ebe4b361ac49d2c94',
          order: 0,
        },
        {
          adult: false,
          gender: 0,
          id: 2359378,
          known_for_department: 'Diễn viên',
          name: 'David Carroll',
          original_name: 'David Carroll',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/MIaVNPK5UzQKSWAoqt7rZahiAm.jpg',
          cast_id: 11,
          character: 'Self - Associate Professor Parsons School of Design',
          credit_id: '5d273604be4b361ac49d2c71',
          order: 1,
        },
        {
          adult: false,
          gender: 0,
          id: 2372056,
          known_for_department: 'Diễn viên',
          name: 'Paul-Olivier Dehaye',
          original_name: 'Paul-Olivier Dehaye',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bBMTFjfOShp3sRQ3ZUMCx8cbRLp.jpg',
          cast_id: 16,
          character: 'Self - Founder @PersonalDataIO',
          credit_id: '5d3c2a1aa1d33200100bb5bc',
          order: 2,
        },
        {
          adult: false,
          gender: 0,
          id: 2372059,
          known_for_department: 'Diễn viên',
          name: 'Ravi Naik',
          original_name: 'Ravi Naik',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3ii3sWmA5UfT2FOmL1PsR7gwXqv.jpg',
          cast_id: 17,
          character: 'Self - Data Rights Solicitor',
          credit_id: '5d3c2a94ede1b00014eab0f3',
          order: 3,
        },
        {
          adult: false,
          gender: 0,
          id: 2359380,
          known_for_department: 'Diễn viên',
          name: 'Julian Wheatland',
          original_name: 'Julian Wheatland',
          popularity: 0.6,
          profile_path: null,
          cast_id: 13,
          character: 'Self - Former COO/CFO Cambridge Analytica/SCL',
          credit_id: '5d27361b5f6c4916bc5d13d7',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 2359376,
          known_for_department: 'Diễn viên',
          name: 'Carole Cadwalladr',
          original_name: 'Carole Cadwalladr',
          popularity: 0.6,
          profile_path: null,
          cast_id: 10,
          character: 'Self - Investigative Journalist for The Guardian',
          credit_id: '5d2735ecbe4b361ac49d2c48',
          order: 5,
        },
        {
          adult: false,
          gender: 0,
          id: 2372060,
          known_for_department: 'Diễn viên',
          name: 'Christopher Wiley',
          original_name: 'Christopher Wiley',
          popularity: 0.6,
          profile_path: null,
          cast_id: 19,
          character:
            'Self - Former Cambridge Analytica Employee and Whistleblower',
          credit_id: '5d3c2dc2ede1b00012eab874',
          order: 6,
        },
        {
          adult: false,
          gender: 0,
          id: 2372062,
          known_for_department: 'Diễn viên',
          name: 'Paul Hilder',
          original_name: 'Paul Hilder',
          popularity: 0.6,
          profile_path: null,
          cast_id: 21,
          character: 'Self - Writer/Political Technologist',
          credit_id: '5d3c313da1d33200130bc1d5',
          order: 7,
        },
        {
          adult: false,
          gender: 0,
          id: 2372071,
          known_for_department: 'Diễn viên',
          name: 'Emma Graham-Harrison',
          original_name: 'Emma Graham-Harrison',
          popularity: 0.6,
          profile_path: null,
          cast_id: 22,
          character: 'Self - International Affairs Correspondent, The Observer',
          credit_id: '5d3c3e4fede1b02f43ea5186',
          order: 8,
        },
        {
          adult: false,
          gender: 0,
          id: 2372072,
          known_for_department: 'Diễn viên',
          name: 'Gill Phillips',
          original_name: 'Gill Phillips',
          popularity: 0.6,
          profile_path: null,
          cast_id: 23,
          character: 'Self - Legal Council, The Guardian',
          credit_id: '5d3c3e71ede1b0617ee9e512',
          order: 9,
        },
        {
          adult: false,
          gender: 0,
          id: 2372074,
          known_for_department: 'Diễn viên',
          name: 'Sarah Donaldson',
          original_name: 'Sarah Donaldson',
          popularity: 0.6,
          profile_path: null,
          cast_id: 24,
          character: 'Self - Arts Editor, The Observer',
          credit_id: '5d3c3e96a1d33200120be278',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 2372076,
          known_for_department: 'Diễn viên',
          name: 'Roger McNamee',
          original_name: 'Roger McNamee',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cYfxRezFb0JriVpoLwEfjg6BgJC.jpg',
          cast_id: 25,
          character: 'Self - Early Facebook Investor',
          credit_id: '5d3c3fc721621b0013ee61a9',
          order: 11,
        },
        {
          adult: false,
          gender: 0,
          id: 2017401,
          known_for_department: 'Diễn viên',
          name: 'Alexander Nix',
          original_name: 'Alexander Nix',
          popularity: 0.6,
          profile_path: null,
          cast_id: 18,
          character: 'Self - CEO, Cambridge Analytica (archive footage)',
          credit_id: '5d3c2b2bede1b00013eab701',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 223736,
          known_for_department: 'Diễn viên',
          name: 'Steve Bannon',
          original_name: 'Steve Bannon',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pLfnDZvXofoArdO3xtgQ7qch8s6.jpg',
          cast_id: 20,
          character:
            'Self - Former Chief Executive Trump Campaign (archive footage)',
          credit_id: '5d3c2e3921621b0013ee3360',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 1188953,
          known_for_department: 'Diễn viên',
          name: 'Mark Zuckerberg',
          original_name: 'Mark Zuckerberg',
          popularity: 1.385,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eTkGvG0FHdE2Q3w6LsSZZ4N2WPP.jpg',
          cast_id: 14,
          character: 'Self (archive footage)',
          credit_id: '5d273c4dbe4b3612f49d4bb9',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 33663,
          known_for_department: 'Diễn viên',
          name: 'Donald Trump',
          original_name: 'Donald Trump',
          popularity: 3.611,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oDmVFoqIzxOyZejGjy3J5QrUmjM.jpg',
          cast_id: 15,
          character: 'Self (archive footage)',
          credit_id: '5d273c55caab6d6658957a06',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 1666438,
          known_for_department: 'Diễn viên',
          name: 'Ted Cruz',
          original_name: 'Ted Cruz',
          popularity: 0.994,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mxxlRn0lCSDal5VIsyivcWic7iv.jpg',
          cast_id: 49,
          character: 'Self (archive footage)',
          credit_id: '5d414e5c7a97ab000fa73352',
          order: 16,
        },
        {
          adult: false,
          gender: 1,
          id: 216674,
          known_for_department: 'Diễn viên',
          name: 'Hillary Clinton',
          original_name: 'Hillary Clinton',
          popularity: 1.071,
          profile_path:
            'https://image.tmdb.org/t/p/w185/67D6LJgwfbF0baKknUx6OPIoVlu.jpg',
          cast_id: 50,
          character: 'Self (archive footage)',
          credit_id: '5d414ec0b87aec23a4391298',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 1442411,
          known_for_department: 'Diễn viên',
          name: 'Nigel Farage',
          original_name: 'Nigel Farage',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yRYBYrCJjBl2c5Mg5nrNbzbHH6r.jpg',
          cast_id: 51,
          character: 'Self (archive footage)',
          credit_id: '5d4159767a97ab0012a74abb',
          order: 18,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 1,
          id: 60007,
          known_for_department: 'Editing',
          name: 'Sloane Klevin',
          original_name: 'Sloane Klevin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d3c4fc3a1d33200110c054d',
          department: 'Editing',
          job: 'Consulting Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 115892,
          known_for_department: 'Directing',
          name: 'Jehane Noujaim',
          original_name: 'Jehane Noujaim',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tzuPRUermMYuUUfcdNrvGC2Eq70.jpg',
          credit_id: '5c042a8992514169ad0af7e4',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 543385,
          known_for_department: 'Editing',
          name: 'Pedro Kos',
          original_name: 'Pedro Kos',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d3c496a21621b000fee754e',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 543385,
          known_for_department: 'Editing',
          name: 'Pedro Kos',
          original_name: 'Pedro Kos',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c1b145ec3a3680b50872b97',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 1,
          id: 1126877,
          known_for_department: 'Production',
          name: 'Geralyn White Dreyfous',
          original_name: 'Geralyn White Dreyfous',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/t25RCx0fyLkUJFOsc3uoPsPiIlM.jpg',
          credit_id: '5c1b148cc3a3680b6087312b',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1140481,
          known_for_department: 'Production',
          name: 'Mike Lerner',
          original_name: 'Mike Lerner',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d3c4f2aa1d33200100c0e82',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1147955,
          known_for_department: 'Production',
          name: 'Regina K. Scully',
          original_name: 'Regina K. Scully',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5d3c4e24a1d33200110c01c1',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1231251,
          known_for_department: 'Production',
          name: 'Nina Sing Fialkow',
          original_name: 'Nina Sing Fialkow',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d3c4d1321621b0011ee82e3',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1280039,
          known_for_department: 'Production',
          name: 'Sarah E. Johnson',
          original_name: 'Sarah E. Johnson',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bQvFg3QkOcDHduMyS4mTIztGLmb.jpg',
          credit_id: '5d3c4ecc21621b0010ee86a5',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1475288,
          known_for_department: 'Sound',
          name: 'Gil Talmi',
          original_name: 'Gil Talmi',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tCF96xaAo3ODVxrd5pcLOvmZC4x.jpg',
          credit_id: '5c1b14b99251414afb535f11',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 1,
          id: 1627129,
          known_for_department: 'Editing',
          name: 'Erin Barnett',
          original_name: 'Erin Barnett',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c1b146a9251414b01535a97',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1627129,
          known_for_department: 'Editing',
          name: 'Erin Barnett',
          original_name: 'Erin Barnett',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c1b144e9251414b01535a7e',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 1667919,
          known_for_department: 'Camera',
          name: 'Marni Grossman',
          original_name: 'Marni Grossman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d3c4e83a1d33200130c113e',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1739125,
          known_for_department: 'Production',
          name: 'Karim Amer',
          original_name: 'Karim Amer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c042a7ac3a36864760d13b9',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1739125,
          known_for_department: 'Production',
          name: 'Karim Amer',
          original_name: 'Karim Amer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c1b14809251414b0a535a7b',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1739125,
          known_for_department: 'Production',
          name: 'Karim Amer',
          original_name: 'Karim Amer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c1b14350e0a265f6b55e7d4',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 1745168,
          known_for_department: 'Editing',
          name: 'Christopher Passig',
          original_name: 'Christopher Passig',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5d3c4ae121621b0013ee7d47',
          department: 'Editing',
          job: 'Co-Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1854919,
          known_for_department: 'Production',
          name: 'Nion McEvoy',
          original_name: 'Nion McEvoy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d3c4f38ede1b02f43ea7ca3',
          department: 'Production',
          job: 'Co-Executive Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 2032572,
          known_for_department: 'Production',
          name: 'Lynda Weinman',
          original_name: 'Lynda Weinman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d3c4ef321621b0013ee8819',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2096222,
          known_for_department: 'Production',
          name: 'Jamie Wolf',
          original_name: 'Jamie Wolf',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d3c4f46a1d33200120c1256',
          department: 'Production',
          job: 'Co-Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2151688,
          known_for_department: 'Camera',
          name: 'Ian Moubayed',
          original_name: 'Ian Moubayed',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d3c4a31a1d33200110bf86b',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 1,
          id: 2198531,
          known_for_department: 'Production',
          name: 'Judy Korin',
          original_name: 'Judy Korin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c1b149e9251414b0a535a9d',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2259272,
          known_for_department: 'Editing',
          name: 'Carlos Rojas Felice',
          original_name: 'Carlos Rojas Felice',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d3c49df21621b0010ee7d40',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2372095,
          known_for_department: 'Camera',
          name: 'Basil Childers',
          original_name: 'Basil Childers',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d3c4a2221621b000fee76c7',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 2372096,
          known_for_department: 'Editing',
          name: 'Andrès Arias',
          original_name: 'Andrès Arias',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d3c4ab0ede1b02f43ea6fbc',
          department: 'Editing',
          job: 'Co-Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2372097,
          known_for_department: 'Editing',
          name: 'Daniel Claridge',
          original_name: 'Daniel Claridge',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d3c4b1021621b000fee78ba',
          department: 'Editing',
          job: 'Co-Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 2372098,
          known_for_department: 'Production',
          name: 'Elizabeth Woodward',
          original_name: 'Elizabeth Woodward',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d3c4b4c21621b0010ee814d',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2372099,
          known_for_department: 'Production',
          name: 'Bits Sola',
          original_name: 'Bits Sola',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d3c4b5eede1b00014eb0250',
          department: 'Production',
          job: 'Associate Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2372111,
          known_for_department: 'Production',
          name: 'Lyn Davis Lear',
          original_name: 'Lyn Davis Lear',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d3c4e18ede1b02f43ea794f',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2372118,
          known_for_department: 'Production',
          name: 'Tracy Nguyen-Chung',
          original_name: 'Tracy Nguyen-Chung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d3c4fe1ede1b00014eb0d34',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2372119,
          known_for_department: 'Production',
          name: 'Claire Read',
          original_name: 'Claire Read',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d3c500aa1d332000f0bfedd',
          department: 'Production',
          job: 'Associate Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2372120,
          known_for_department: 'Production',
          name: 'Christopher de la Torre',
          original_name: 'Christopher de la Torre',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d3c5022ede1b00014eb0ea4',
          department: 'Production',
          job: 'Associate Producer',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/hgFIvyAAPvQ72jGOkAry6ZtDQo3.jpg',
    belongs_to_collection: null,
    budget: 209000000,
    genres: [
      { id: 53, name: 'Phim Gây Cấn' },
      { id: 28, name: 'Phim Hành Động' },
      { id: 12, name: 'Phim Phiêu Lưu' },
      { id: 878, name: 'Phim Khoa Học Viễn Tưởng' },
    ],
    homepage: '',
    id: 44833,
    imdb_id: 'tt1440129',
    original_language: 'en',
    original_title: 'Battleship',
    overview:
      'Battleship là câu chuyện giả tưởng về cuộc chiến giữa David và gã khổng lồ Goliah mà ở đây cư dân địa cầu chính là chàng David nhỏ bé chiến đấu với những vị khách UFO trang bị những công nghệ tiên tiến vượt bậc so với sự hiểu biết của con người. Peter Berg, được biết đến bởi 2 bộ phim The Kingdom Và Hancook, có lẽ đã học tập những kinh nghiệm đạo diễn từ Michael Bay trong việc giới thiệu và xây dựng nhân vật. Người anh hùng của chúng ta ban đầu là một kẻ chuyên gây rối Alex Hoppers được tuyển vào quân đội bởi người anh trai Stone (Alexnder Skarsgard). Từ con số 0, Alex đã ngày càng trưởng thành, chịu trách nhiệm chỉ huy đoàn tàu chống lại lực lượng UFO hung hãn. Khá giống với anh chàng Sam của Shia Labeouf trong Transformer.',
    popularity: 34.216,
    poster_path:
      'https://image.tmdb.org/t/p/w342/nlTlkZkdcP7xX4HBwq4QbrIllue.jpg',
    production_companies: [
      {
        id: 33,
        logo_path: '/8lvHyhjr8oUKOOy2dKXoALWKdp0.png',
        name: 'Universal Pictures',
        origin_country: 'US',
      },
      {
        id: 2598,
        logo_path: '/i42C5gRq7XqlG4S9vkchuJZfrBn.png',
        name: 'Hasbro',
        origin_country: '',
      },
      {
        id: 13778,
        logo_path: null,
        name: 'Bluegrass Films',
        origin_country: 'US',
      },
      { id: 20153, logo_path: null, name: 'Film 44', origin_country: 'US' },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2012-04-11',
    revenue: 303025485,
    runtime: 131,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
      { english_name: 'Nhật Bảnese', iso_639_1: 'ja', name: '日本語' },
    ],
    status: 'Đã phát hành',
    tagline: 'The Battle for Earth Begins at Sea',
    title: 'Chiến Hạm',
    video: false,
    vote_average: 5.8,
    vote_count: 4469,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Battleship | First Fight With the Aliens in 4K HDR',
          key: '3qJEFIVYr_c',
          site: 'YouTube',
          size: 2160,
          type: 'Clip',
          official: true,
          published_at: '2021-07-10T13:00:05.000Z',
          id: '60f5d4a453866e002d412dd7',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Battleship | The Final Battle in 4K HDR',
          key: 'nCqDdsZY7RA',
          site: 'YouTube',
          size: 2160,
          type: 'Clip',
          official: true,
          published_at: '2020-08-29T13:00:22.000Z',
          id: '60f5d493ad87f700478895cf',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Battleship - Trailer 3 (HD)',
          key: 'wvXKvbIAq2k',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2012-03-29T17:44:01.000Z',
          id: '60f5d4ddd7cd0600459b0115',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Final Trailer',
          key: 'JpoabtbEJOI',
          site: 'YouTube',
          size: 720,
          type: 'Trailer',
          official: true,
          published_at: '2012-03-14T18:37:14.000Z',
          id: '5d6d8ebfa284eb01bf334c18',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Battleship - Super Bowl Spot (HD)',
          key: '2nYGxit86Ok',
          site: 'YouTube',
          size: 1080,
          type: 'Teaser',
          official: true,
          published_at: '2012-02-05T19:17:20.000Z',
          id: '60f5d4c08258fc0073968817',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Official Global Trailer',
          key: 'okOsyezoR7s',
          site: 'YouTube',
          size: 720,
          type: 'Trailer',
          official: true,
          published_at: '2011-12-12T18:24:42.000Z',
          id: '5dbcc18f97a4e600187c6e9d',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Global Teaser Trailer',
          key: 'Lavw95kpgyo',
          site: 'YouTube',
          size: 720,
          type: 'Teaser',
          official: true,
          published_at: '2011-07-22T16:52:19.000Z',
          id: '5dbcc187d2c0c1001b1fed46',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 60900,
          known_for_department: 'Diễn viên',
          name: 'Taylor Kitsch',
          original_name: 'Taylor Kitsch',
          popularity: 5.13,
          profile_path:
            'https://image.tmdb.org/t/p/w185/m39IoFjaJWiCoFYv0DfYCklOeOS.jpg',
          cast_id: 3,
          character: 'Lieutenant Alex Hopper',
          credit_id: '52fe469ec3a36847f8108ccb',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 13275,
          known_for_department: 'Diễn viên',
          name: 'Tadanobu Asano',
          original_name: 'Tadanobu Asano',
          popularity: 4.585,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wDw1z9Pk9dEzopzlZQ4X8wTbj1t.jpg',
          cast_id: 21,
          character: 'Captain Yugi Nagata',
          credit_id: '52fe469ec3a36847f8108d1b',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 131519,
          known_for_department: 'Diễn viên',
          name: 'Rihanna',
          original_name: 'Rihanna',
          popularity: 4.592,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6hWZI5Oj9YmVRvXwFUNk6psMw3V.jpg',
          cast_id: 4,
          character: "Petty Officer Cora 'Weps' Raikes",
          credit_id: '52fe469ec3a36847f8108ccf',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 131520,
          known_for_department: 'Diễn viên',
          name: 'Brooklyn Decker',
          original_name: 'Brooklyn Decker',
          popularity: 3.229,
          profile_path:
            'https://image.tmdb.org/t/p/w185/x3JWepaXTopE9k0g87Q9diRM5Nc.jpg',
          cast_id: 6,
          character: 'Sam',
          credit_id: '52fe469ec3a36847f8108cd3',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 1052162,
          known_for_department: 'Diễn viên',
          name: 'Gregory D. Gadson',
          original_name: 'Gregory D. Gadson',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/su0peRJPQ9NHOUk2aIUr9zUnhk4.jpg',
          cast_id: 43,
          character: 'Lieutenant Colonel Mick Canales',
          credit_id: '539f697ac3a3682820000da6',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 184581,
          known_for_department: 'Diễn viên',
          name: 'Hamish Linklater',
          original_name: 'Hamish Linklater',
          popularity: 5.625,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eCFhrVVPw17SdqfhyRFZfflQCGE.jpg',
          cast_id: 35,
          character: 'Cal Zapata',
          credit_id: '52fe469ec3a36847f8108d63',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 3896,
          known_for_department: 'Diễn viên',
          name: 'Liam Neeson',
          original_name: 'Liam Neeson',
          popularity: 23.845,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bboldwqSC6tdw2iL6631c98l2Mn.jpg',
          cast_id: 9,
          character: 'Admiral Shane',
          credit_id: '52fe469ec3a36847f8108cdb',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 28846,
          known_for_department: 'Diễn viên',
          name: 'Alexander Skarsgård',
          original_name: 'Alexander Skarsgård',
          popularity: 11.358,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hIuDik6KDmHLrqZWxBVdXzUw1kq.jpg',
          cast_id: 8,
          character: 'Commander Stone Hopper',
          credit_id: '52fe469ec3a36847f8108cd7',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 98953,
          known_for_department: 'Diễn viên',
          name: 'Jerry Ferrara',
          original_name: 'Jerry Ferrara',
          popularity: 1.674,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yGziAkYkdtBmYolQg7MNkK5XP7J.jpg',
          cast_id: 38,
          character: 'Sampson JOOD Strodell',
          credit_id: '52fe469ec3a36847f8108d6f',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 88124,
          known_for_department: 'Diễn viên',
          name: 'Jesse Plemons',
          original_name: 'Jesse Plemons',
          popularity: 24.149,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ckTthGclQE0y6b7gR0RpRo7LskL.jpg',
          cast_id: 20,
          character: 'Boatswain Mate Seaman Jimmy "Ordy" Ord',
          credit_id: '52fe469ec3a36847f8108d17',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 205406,
          known_for_department: 'Diễn viên',
          name: 'John Tui',
          original_name: 'John Tui',
          popularity: 0.607,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2jIc9M5kl2GmK8fZtbtUr2s1jkS.jpg',
          cast_id: 36,
          character: 'Chief Petty Officer Walter "The Beast" Lynch',
          credit_id: '52fe469ec3a36847f8108d67',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 60875,
          known_for_department: 'Diễn viên',
          name: 'David Jensen',
          original_name: 'David Jensen',
          popularity: 0.656,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eMKoRn7Xz7Z7JEfBLkZA5pV2k5t.jpg',
          cast_id: 33,
          character: 'NASA Director',
          credit_id: '52fe469ec3a36847f8108d5b',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 36602,
          known_for_department: 'Directing',
          name: 'Peter Berg',
          original_name: 'Peter Berg',
          popularity: 3.478,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1pR16H0zqRG49ns8cYykYpodgGF.jpg',
          cast_id: 34,
          character: 'JPJ 2nd Gunner',
          credit_id: '52fe469ec3a36847f8108d5f',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 23429,
          known_for_department: 'Diễn viên',
          name: 'Adam Godley',
          original_name: 'Adam Godley',
          popularity: 1.97,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xOM0zOb2KZ2q8M6lRrDo9bEBeJE.jpg',
          cast_id: 51,
          character: 'Dr. Nogrady',
          credit_id: '53a159c2c3a3687bbc001fcf',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 987677,
          known_for_department: 'Production',
          name: 'Rico McClinton',
          original_name: 'Rico McClinton',
          popularity: 0.6,
          profile_path: null,
          cast_id: 52,
          character: 'Captain Browley',
          credit_id: '53a159fdc3a3687ba60020be',
          order: 14,
        },
        {
          adult: false,
          gender: 0,
          id: 1331643,
          known_for_department: 'Diễn viên',
          name: 'Joji Yoshida',
          original_name: 'Joji Yoshida',
          popularity: 0.6,
          profile_path: null,
          cast_id: 53,
          character: 'Chief Engineer Hiroki',
          credit_id: '53a15a43c3a3687bbc001fe1',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 55205,
          known_for_department: 'Diễn viên',
          name: 'Stephen Bishop',
          original_name: 'Stephen Bishop',
          popularity: 1.579,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9DDF9z96Aax6tQ6WrJyMDlF1Rtl.jpg',
          cast_id: 54,
          character: 'JPJ OOD',
          credit_id: '53a15a74c3a3687bb000221d',
          order: 16,
        },
        {
          adult: false,
          gender: 0,
          id: 1044953,
          known_for_department: 'Diễn viên',
          name: 'Austin Naulty',
          original_name: 'Austin Naulty',
          popularity: 0.6,
          profile_path: null,
          cast_id: 55,
          character: 'JPJ Fireman',
          credit_id: '53a15abec3a3685b2c000987',
          order: 17,
        },
        {
          adult: false,
          gender: 0,
          id: 565508,
          known_for_department: 'Diễn viên',
          name: 'James Rawlings',
          original_name: 'James Rawlings',
          popularity: 0.6,
          profile_path: null,
          cast_id: 56,
          character: 'JPJ Scat',
          credit_id: '53a15b02c3a3687b980020ac',
          order: 18,
        },
        {
          adult: false,
          gender: 0,
          id: 1337274,
          known_for_department: 'Diễn viên',
          name: 'Dustin J. Reno',
          original_name: 'Dustin J. Reno',
          popularity: 0.6,
          profile_path: null,
          cast_id: 151,
          character: 'Electronic Warfare Supervisor',
          credit_id: '549ac3a6925141312c001711',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 1216133,
          known_for_department: 'Diễn viên',
          name: 'Rick Hoffman',
          original_name: 'Rick Hoffman',
          popularity: 3.332,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yRjH4z0lKgvjxZ07P7bvRpZy95q.jpg',
          cast_id: 152,
          character: 'Chairman, Joint Chiefs of Staff',
          credit_id: '549ac3e5925141312300190f',
          order: 20,
        },
        {
          adult: false,
          gender: 2,
          id: 68180,
          known_for_department: 'Diễn viên',
          name: 'Gary Grubbs',
          original_name: 'Gary Grubbs',
          popularity: 2.517,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uXJG4skJTElTQ5BJ9pkJjzfKIDv.jpg',
          cast_id: 153,
          character: 'Air Force Chief of Staff',
          credit_id: '549ac409c3a3680b2700114e',
          order: 21,
        },
        {
          adult: false,
          gender: 2,
          id: 17838,
          known_for_department: 'Diễn viên',
          name: 'Rami Malek',
          original_name: 'Rami Malek',
          popularity: 10.159,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2OuFzCbMibXGouG79tG1U4BLPbe.jpg',
          cast_id: 159,
          character: 'Watch Officer',
          credit_id: '556fe4cc9251410872001749',
          order: 22,
        },
        {
          adult: false,
          gender: 2,
          id: 12688,
          known_for_department: 'Diễn viên',
          name: 'Peter MacNicol',
          original_name: 'Peter MacNicol',
          popularity: 4.0,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xo09hN0cqYh1V7z986yFOTdaKhU.jpg',
          cast_id: 160,
          character: 'Secretary of Defense',
          credit_id: '55e83b369251413e450021ea',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 3218,
          known_for_department: 'Diễn viên',
          name: 'Louis Lombardi',
          original_name: 'Louis Lombardi',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cYxbGCEf0mnsACuxCIX0faCjGUQ.jpg',
          cast_id: 161,
          character: 'Bartender',
          credit_id: '55e83b369251413e2f002296',
          order: 24,
        },
        {
          adult: false,
          gender: 0,
          id: 1326245,
          known_for_department: 'Diễn viên',
          name: 'Jordan Kirkwood',
          original_name: 'Jordan Kirkwood',
          popularity: 0.6,
          profile_path: null,
          cast_id: 167,
          character: 'JPJ Sailor',
          credit_id: '55e83b389251413e450021f1',
          order: 25,
        },
        {
          adult: false,
          gender: 0,
          id: 210542,
          known_for_department: 'Diễn viên',
          name: 'Doug Penty',
          original_name: 'Doug Penty',
          popularity: 0.6,
          profile_path: null,
          cast_id: 168,
          character: 'CIC Watch Supervisor',
          credit_id: '56a90b839251417dcb0004dd',
          order: 26,
        },
        {
          adult: false,
          gender: 0,
          id: 66678,
          known_for_department: 'Diễn viên',
          name: 'Carson Aune',
          original_name: 'Carson Aune',
          popularity: 0.6,
          profile_path: null,
          cast_id: 169,
          character: 'CIC Gunner',
          credit_id: '56a90e1bc3a36872db00055b',
          order: 27,
        },
        {
          adult: false,
          gender: 2,
          id: 928532,
          known_for_department: 'Diễn viên',
          name: 'Josh Pence',
          original_name: 'Josh Pence',
          popularity: 1.635,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tkDFl0BEVCUcwKR30ICeG3yCTbr.jpg',
          cast_id: 170,
          character: 'Combat Systems Coordinator',
          credit_id: '56a90e9cc3a36872d80005ab',
          order: 28,
        },
        {
          adult: false,
          gender: 2,
          id: 1044956,
          known_for_department: 'Diễn viên',
          name: 'Lloyd Pitts',
          original_name: 'Lloyd Pitts',
          popularity: 1.267,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xHbhOv2BzC3hKekpDDXK9Up4XYp.jpg',
          cast_id: 171,
          character: 'JPJ Port Gunner',
          credit_id: '56a90eeec3a36872d80005c8',
          order: 29,
        },
        {
          adult: false,
          gender: 1,
          id: 29054,
          known_for_department: 'Diễn viên',
          name: 'Michelle Arthur',
          original_name: 'Michelle Arthur',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cC6R8hK8FUH007zbZnMjypu8C2T.jpg',
          cast_id: 175,
          character: 'British Newscaster',
          credit_id: '56a914d29251417dd4000646',
          order: 30,
        },
        {
          adult: false,
          gender: 1,
          id: 1367223,
          known_for_department: 'Diễn viên',
          name: 'Natalia Castellanos',
          original_name: 'Natalia Castellanos',
          popularity: 0.6,
          profile_path: null,
          cast_id: 172,
          character: 'Spanish Newscaster',
          credit_id: '56a90fca9251417dd4000565',
          order: 31,
        },
        {
          adult: false,
          gender: 0,
          id: 937232,
          known_for_department: 'Diễn viên',
          name: 'Leni Ito',
          original_name: 'Leni Ito',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/a2I4RWXAjnEGpX5ujMcvH3lXFad.jpg',
          cast_id: 176,
          character: 'Nhật Bảnese Newscaster',
          credit_id: '56a9153dc3a36872e90006df',
          order: 32,
        },
        {
          adult: false,
          gender: 1,
          id: 1569054,
          known_for_department: 'Diễn viên',
          name: 'Jackie Johnson',
          original_name: 'Jackie Johnson',
          popularity: 0.6,
          profile_path: null,
          cast_id: 173,
          character: 'Jackie Johnson',
          credit_id: '56a9105bc3a36872d800060e',
          order: 33,
        },
        {
          adult: false,
          gender: 1,
          id: 1049830,
          known_for_department: 'Diễn viên',
          name: 'Kerry Cahill',
          original_name: 'Kerry Cahill',
          popularity: 1.722,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zu2Sv5mod9UYdYaiZp1idH9W7vV.jpg',
          cast_id: 174,
          character: "Cal's Female Colleague",
          credit_id: '56a914129251417dd4000630',
          order: 34,
        },
        {
          adult: false,
          gender: 2,
          id: 1504579,
          known_for_department: 'Diễn viên',
          name: 'Norman Vincent McLafferty',
          original_name: 'Norman Vincent McLafferty',
          popularity: 0.6,
          profile_path: null,
          cast_id: 162,
          character: 'Old Salt',
          credit_id: '55e83b369251413e3e0023b2',
          order: 35,
        },
        {
          adult: false,
          gender: 2,
          id: 1504580,
          known_for_department: 'Diễn viên',
          name: 'Dante Jimenez',
          original_name: 'Dante Jimenez',
          popularity: 0.6,
          profile_path: null,
          cast_id: 163,
          character: 'JPJ XO Mullenaro',
          credit_id: '55e83b379251413e380021bb',
          order: 36,
        },
        {
          adult: false,
          gender: 2,
          id: 1504581,
          known_for_department: 'Diễn viên',
          name: 'Daven Arce',
          original_name: 'Daven Arce',
          popularity: 0.6,
          profile_path: null,
          cast_id: 164,
          character: 'JPJ Helmsman',
          credit_id: '55e83b379251413e450021ed',
          order: 37,
        },
        {
          adult: false,
          gender: 2,
          id: 1504582,
          known_for_department: 'Diễn viên',
          name: 'Ralph Richardson',
          original_name: 'Ralph Richardson',
          popularity: 0.6,
          profile_path: null,
          cast_id: 165,
          character: 'JPJ Starboard Gunner',
          credit_id: '55e83b379251413e3e0023b7',
          order: 38,
        },
        {
          adult: false,
          gender: 0,
          id: 1504583,
          known_for_department: 'Diễn viên',
          name: 'Biunca Love',
          original_name: 'Biunca Love',
          popularity: 0.6,
          profile_path: null,
          cast_id: 166,
          character: 'JPJ BMOW',
          credit_id: '55e83b379251413e3500221f',
          order: 39,
        },
        {
          adult: false,
          gender: 2,
          id: 84756,
          known_for_department: 'Diễn viên',
          name: 'Kyle Clements',
          original_name: 'Kyle Clements',
          popularity: 1.03,
          profile_path: null,
          cast_id: 178,
          character: 'Regent Sea Commander',
          credit_id: '57d1f39cc3a3684733000345',
          order: 40,
        },
        {
          adult: false,
          gender: 0,
          id: 204235,
          known_for_department: 'Diễn viên',
          name: 'Yutaka Takeuchi',
          original_name: 'Yutaka Takeuchi',
          popularity: 1.812,
          profile_path:
            'https://image.tmdb.org/t/p/w185/z8jCaZnVGWrex0FTgmOHdiQSf28.jpg',
          cast_id: 179,
          character: 'Myoko XO',
          credit_id: '57e842959251410344000a58',
          order: 41,
        },
        {
          adult: false,
          gender: 2,
          id: 1685026,
          known_for_department: 'Diễn viên',
          name: 'John A Weaver',
          original_name: 'John A Weaver',
          popularity: 0.6,
          profile_path: null,
          cast_id: 180,
          character: 'JPJ Sailor',
          credit_id: '57e846aa92514102ed000c0f',
          order: 42,
        },
        {
          adult: false,
          gender: 2,
          id: 1685027,
          known_for_department: 'Diễn viên',
          name: 'Dane Justman',
          original_name: 'Dane Justman',
          popularity: 0.6,
          profile_path: null,
          cast_id: 181,
          character: 'Sampson OOD',
          credit_id: '57e84721925141039b000c6a',
          order: 43,
        },
        {
          adult: false,
          gender: 2,
          id: 989607,
          known_for_department: 'Diễn viên',
          name: 'Drew Rausch',
          original_name: 'Drew Rausch',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pE2wnxxMWk2aZoks6ekJX7fIhnj.jpg',
          cast_id: 182,
          character: 'Sampson XO',
          credit_id: '57e84770c3a36835a20151b2',
          order: 44,
        },
        {
          adult: false,
          gender: 2,
          id: 86536,
          known_for_department: 'Diễn viên',
          name: 'Bill Stinchcomb',
          original_name: 'Bill Stinchcomb',
          popularity: 0.705,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xewENuv4Ntsw8jLgXBCprPPibHD.jpg',
          cast_id: 183,
          character: 'Marine Commandant',
          credit_id: '57e847b7c3a368475d00c998',
          order: 45,
        },
        {
          adult: false,
          gender: 2,
          id: 126667,
          known_for_department: 'Diễn viên',
          name: 'John Bell',
          original_name: 'John Bell',
          popularity: 1.834,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mqAAEgGjqbInINb99n5wYNxLYwr.jpg',
          cast_id: 184,
          character: 'Angus',
          credit_id: '59fe1eb5925141471d025418',
          order: 46,
        },
        {
          adult: false,
          gender: 1,
          id: 2075883,
          known_for_department: 'Diễn viên',
          name: 'Arlene Newman',
          original_name: 'Arlene Newman',
          popularity: 0.828,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gY5HiCtmSYTSPLCyuA3KGBA1f1e.jpg',
          cast_id: 194,
          character: 'Naval Officer',
          credit_id: '5b3855cf92514157ce000653',
          order: 47,
        },
        {
          adult: false,
          gender: 2,
          id: 152289,
          known_for_department: 'Diễn viên',
          name: "George O'Hanlon Jr.",
          original_name: "George O'Hanlon Jr.",
          popularity: 0.743,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jVWtAwIQtuDA4fXDQynIrA7cwtn.jpg',
          cast_id: 195,
          character: 'Tourist Guide',
          credit_id: '5b5437019251411f82027849',
          order: 48,
        },
        {
          adult: false,
          gender: 2,
          id: 1093709,
          known_for_department: 'Diễn viên',
          name: 'Jay Jackson',
          original_name: 'Jay Jackson',
          popularity: 0.68,
          profile_path:
            'https://image.tmdb.org/t/p/w185/emur6RNO75YoAFWlXUmwPAf4vEy.jpg',
          cast_id: 197,
          character: 'American Newscaster',
          credit_id: '5eb70d66ca7ec6001f7bbdda',
          order: 49,
        },
        {
          adult: false,
          gender: 2,
          id: 141762,
          known_for_department: 'Diễn viên',
          name: 'Joe Chrest',
          original_name: 'Joe Chrest',
          popularity: 1.394,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ox45oYzfnI9mxDYNeP01ZTRWGXC.jpg',
          cast_id: 406,
          character: 'JPL Controller',
          credit_id: '6080439801b1ca005869a351',
          order: 50,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 10816,
          known_for_department: 'Editing',
          name: 'Paul Rubell',
          original_name: 'Paul Rubell',
          popularity: 1.094,
          profile_path: null,
          credit_id: '52fe469ec3a36847f8108d45',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1366,
          known_for_department: 'Diễn viên',
          name: 'Sala Baker',
          original_name: 'Sala Baker',
          popularity: 3.259,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zSWNRVboxLJ3bhj7YBIS76HPCrC.jpg',
          credit_id: '5b018ff9925141097300b2ab',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 3995,
          known_for_department: 'Costume & Make-Up',
          name: 'Jeff Dawn',
          original_name: 'Jeff Dawn',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ouFPaT1I5q5s3iM6veb1cq0MIMI.jpg',
          credit_id: '53a158d00e0a266537002926',
          department: 'Costume & Make-Up',
          job: 'Makeup Department Head',
        },
        {
          adult: false,
          gender: 2,
          id: 6870,
          known_for_department: 'Production',
          name: 'Duncan Henderson',
          original_name: 'Duncan Henderson',
          popularity: 1.511,
          profile_path: null,
          credit_id: '52fe469ec3a36847f8108cff',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 11411,
          known_for_department: 'Art',
          name: 'Neil Spisak',
          original_name: 'Neil Spisak',
          popularity: 1.4,
          profile_path: null,
          credit_id: '53a158510e0a26654e00285d',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 2,
          id: 8678,
          known_for_department: 'Art',
          name: 'Oliver Scholl',
          original_name: 'Oliver Scholl',
          popularity: 2.215,
          profile_path:
            'https://image.tmdb.org/t/p/w185/CSv6Dh9koDtXLjHJNAo0kjtbg8.jpg',
          credit_id: '5f89b409a13533003711c706',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 0,
          id: 8763,
          known_for_department: 'Sound',
          name: 'Dan Yale',
          original_name: 'Dan Yale',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549aabb4c3a3682f16001795',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 8848,
          known_for_department: 'Art',
          name: 'William Ladd Skinner',
          original_name: 'William Ladd Skinner',
          popularity: 0.6,
          profile_path: null,
          credit_id: '53a1588e0e0a26654e002869',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 1,
          id: 9043,
          known_for_department: 'Costume & Make-Up',
          name: 'Louise Mingenbach',
          original_name: 'Louise Mingenbach',
          popularity: 1.96,
          profile_path: null,
          credit_id: '52fe469ec3a36847f8108d51',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 0,
          id: 10126,
          known_for_department: 'Costume & Make-Up',
          name: 'Mitzi Haralson',
          original_name: 'Mitzi Haralson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549ac1039251414bb200001b',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 13223,
          known_for_department: 'Editing',
          name: 'Jim Passon',
          original_name: 'Jim Passon',
          popularity: 1.052,
          profile_path: null,
          credit_id: '549ac164c3a3682f1e0019d6',
          department: 'Editing',
          job: 'Color Timer',
        },
        {
          adult: false,
          gender: 2,
          id: 15559,
          known_for_department: 'Camera',
          name: 'Tobias A. Schliessler',
          original_name: 'Tobias A. Schliessler',
          popularity: 0.694,
          profile_path: null,
          credit_id: '52fe469ec3a36847f8108d33',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 18264,
          known_for_department: 'Sound',
          name: 'Steve Jablonsky',
          original_name: 'Steve Jablonsky',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aJntUZkZzlHRszlxzSaztAN9N7O.jpg',
          credit_id: '52fe469ec3a36847f8108d2d',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 0,
          id: 18617,
          known_for_department: 'Editing',
          name: 'Colby Parker Jr.',
          original_name: 'Colby Parker Jr.',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe469ec3a36847f8108d39',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 19282,
          known_for_department: 'Production',
          name: 'Scott Stuber',
          original_name: 'Scott Stuber',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/BIpxpQaS4v6eukU3Mgjc9KBf0l.jpg',
          credit_id: '52fe469ec3a36847f8108d0b',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 24308,
          known_for_department: 'Production',
          name: 'Brian Goldner',
          original_name: 'Brian Goldner',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe469ec3a36847f8108cf9',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 20170,
          known_for_department: 'Production',
          name: 'Linda Lowy',
          original_name: 'Linda Lowy',
          popularity: 0.694,
          profile_path: null,
          credit_id: '52fe469ec3a36847f8108d85',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 1,
          id: 20359,
          known_for_department: 'Costume & Make-Up',
          name: 'Kimberly A. Tillman',
          original_name: 'Kimberly A. Tillman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe469ec3a36847f8108d57',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 2,
          id: 20406,
          known_for_department: 'Camera',
          name: 'Larry Blanford',
          original_name: 'Larry Blanford',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886f968258fc0036ac720e',
          department: 'Camera',
          job: 'Second Unit Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 21984,
          known_for_department: 'Art',
          name: 'Larry Dias',
          original_name: 'Larry Dias',
          popularity: 0.98,
          profile_path: null,
          credit_id: '52fe469ec3a36847f8108d4b',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 2,
          id: 23352,
          known_for_department: 'Costume & Make-Up',
          name: 'Steve LaPorte',
          original_name: 'Steve LaPorte',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549aa657c3a3682f280016ad',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 23620,
          known_for_department: 'Costume & Make-Up',
          name: 'Cheri Minns',
          original_name: 'Cheri Minns',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549aa639c3a3682f2300175f',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 32282,
          known_for_department: 'Costume & Make-Up',
          name: 'Mary L. Mastro',
          original_name: 'Mary L. Mastro',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549aa5fdc3a3682f2300175a',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 2,
          id: 36602,
          known_for_department: 'Directing',
          name: 'Peter Berg',
          original_name: 'Peter Berg',
          popularity: 3.478,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1pR16H0zqRG49ns8cYykYpodgGF.jpg',
          credit_id: '52fe469ec3a36847f8108cc7',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 36602,
          known_for_department: 'Directing',
          name: 'Peter Berg',
          original_name: 'Peter Berg',
          popularity: 3.478,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1pR16H0zqRG49ns8cYykYpodgGF.jpg',
          credit_id: '52fe469ec3a36847f8108cf3',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 50769,
          known_for_department: 'Production',
          name: 'Sarah Aubrey',
          original_name: 'Sarah Aubrey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe469ec3a36847f8108ced',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 113067,
          known_for_department: 'Sound',
          name: 'David Lucarelli',
          original_name: 'David Lucarelli',
          popularity: 0.659,
          profile_path: null,
          credit_id: '5f89c2db238513003439593a',
          department: 'Sound',
          job: 'ADR Recordist',
        },
        {
          adult: false,
          gender: 2,
          id: 113073,
          known_for_department: 'Sound',
          name: 'Paul Massey',
          original_name: 'Paul Massey',
          popularity: 0.985,
          profile_path: null,
          credit_id: '549aba0ec3a3682f19001930',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 1,
          id: 113088,
          known_for_department: 'Sound',
          name: 'Charleen Richards',
          original_name: 'Charleen Richards',
          popularity: 0.84,
          profile_path: null,
          credit_id: '5f89c29ad4b9d900352a666d',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 1,
          id: 59055,
          known_for_department: 'Production',
          name: 'Caitlin McKenna-Wilkinson',
          original_name: 'Caitlin McKenna-Wilkinson',
          popularity: 1.804,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cPfk4htR9X7gUnr1jYsKs0Y5qBq.jpg',
          credit_id: '5f8872a623851300353781e6',
          department: 'Production',
          job: 'ADR Voice Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 62723,
          known_for_department: 'Editing',
          name: 'Stefan Sonnenfeld',
          original_name: 'Stefan Sonnenfeld',
          popularity: 0.645,
          profile_path: null,
          credit_id: '5f887399238513003635f112',
          department: 'Editing',
          job: 'Colorist',
        },
        {
          adult: false,
          gender: 0,
          id: 68016,
          known_for_department: 'Sound',
          name: 'Kevin Kaska',
          original_name: 'Kevin Kaska',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/azlSu8Sz9QGeK3xgQS9p3ZvR9q9.jpg',
          credit_id: '579d02ea9251411b360085b0',
          department: 'Sound',
          job: 'Orchestrator',
        },
        {
          adult: false,
          gender: 2,
          id: 25549,
          known_for_department: 'Production',
          name: 'John Brace',
          original_name: 'John Brace',
          popularity: 0.84,
          profile_path: null,
          credit_id: '52fe469ec3a36847f8108d7f',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 83083,
          known_for_department: 'Sound',
          name: 'G.W. Brown',
          original_name: 'G.W. Brown',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5ad7bec99251413cc4004517',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 83083,
          known_for_department: 'Sound',
          name: 'G.W. Brown',
          original_name: 'G.W. Brown',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5ad7bed70e0a26433f004855',
          department: 'Sound',
          job: 'ADR Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 91905,
          known_for_department: 'Camera',
          name: "Jeff 'Moose' Howery",
          original_name: "Jeff 'Moose' Howery",
          popularity: 0.98,
          profile_path: null,
          credit_id: '5f8868bb39549a0036b39f46',
          department: 'Camera',
          job: 'Dolly Grip',
        },
        {
          adult: false,
          gender: 2,
          id: 91941,
          known_for_department: 'Crew',
          name: 'Ernie Malik',
          original_name: 'Ernie Malik',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549ac30192514131230018f7',
          department: 'Crew',
          job: 'Unit Publicist',
        },
        {
          adult: false,
          gender: 2,
          id: 102343,
          known_for_department: 'Costume & Make-Up',
          name: 'Allan A. Apone',
          original_name: 'Allan A. Apone',
          popularity: 1.056,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eoxFJ1e3tyDkCqdKIKwHOhsUd3l.jpg',
          credit_id: '53a158e60e0a26654e002871',
          department: 'Costume & Make-Up',
          job: 'Makeup Department Head',
        },
        {
          adult: false,
          gender: 2,
          id: 112947,
          known_for_department: 'Biên kịch',
          name: 'Erich Hoeber',
          original_name: 'Erich Hoeber',
          popularity: 3.1,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iIV4kJKeaOth7n7iYVMOl2DQ3lw.jpg',
          credit_id: '52fe469ec3a36847f8108ce1',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 112948,
          known_for_department: 'Biên kịch',
          name: 'Jon Hoeber',
          original_name: 'Jon Hoeber',
          popularity: 0.998,
          profile_path: null,
          credit_id: '52fe469ec3a36847f8108ce7',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 143894,
          known_for_department: 'Production',
          name: 'Eric Heffron',
          original_name: 'Eric Heffron',
          popularity: 0.728,
          profile_path: null,
          credit_id: '5f8863cad4b9d90036264d56',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 224388,
          known_for_department: 'Art',
          name: 'Scott P. Murphy',
          original_name: 'Scott P. Murphy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '53a1587a0e0a26654e002865',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 575769,
          known_for_department: 'Crew',
          name: 'Aaron Skalka',
          original_name: 'Aaron Skalka',
          popularity: 0.828,
          profile_path: null,
          credit_id: '549ac1d1c3a3682f28001947',
          department: 'Crew',
          job: 'Transportation Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 579405,
          known_for_department: 'Sound',
          name: 'Beau Borders',
          original_name: 'Beau Borders',
          popularity: 1.4,
          profile_path: null,
          credit_id: '549ab9cdc3a3680b27001058',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 937231,
          known_for_department: 'Production',
          name: 'Bennett Schneir',
          original_name: 'Bennett Schneir',
          popularity: 0.98,
          profile_path: null,
          credit_id: '52fe469ec3a36847f8108d05',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 978127,
          known_for_department: 'Sound',
          name: 'Andy Koyama',
          original_name: 'Andy Koyama',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549aba25c3a3682f23001985',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 1012973,
          known_for_department: 'Crew',
          name: 'Kevin Scott',
          original_name: 'Kevin Scott',
          popularity: 0.608,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vu95dFKWH8nnZz3v1BuP0Sonz1T.jpg',
          credit_id: '549abe63c3a3682f280018f6',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1017296,
          known_for_department: 'Editing',
          name: 'Billy Rich',
          original_name: 'Billy Rich',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe469ec3a36847f8108d3f',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1018071,
          known_for_department: 'Editing',
          name: 'Robert Malina',
          original_name: 'Robert Malina',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8874828258fc0037a6a1e6',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1081072,
          known_for_department: 'Art',
          name: 'Harald Belker',
          original_name: 'Harald Belker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b367a1353300351318bb',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 2,
          id: 1086456,
          known_for_department: 'Art',
          name: 'David J. Negron Jr.',
          original_name: 'David J. Negron Jr.',
          popularity: 0.656,
          profile_path: null,
          credit_id: '5f89ba0ef6fd180036b2d449',
          department: 'Art',
          job: 'Storyboard Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 1171098,
          known_for_department: 'Art',
          name: 'Darrell L. Wight',
          original_name: 'Darrell L. Wight',
          popularity: 1.4,
          profile_path: null,
          credit_id: '549aa9f6c3a3682f19001773',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1182907,
          known_for_department: 'Art',
          name: 'Aaron Haye',
          original_name: 'Aaron Haye',
          popularity: 0.6,
          profile_path: null,
          credit_id: '53a158670e0a26654e002861',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1197278,
          known_for_department: 'Production',
          name: 'Jamie Castro',
          original_name: 'Jamie Castro',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe469ec3a36847f8108d79',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 1235712,
          known_for_department: 'Crew',
          name: 'Austin Basile',
          original_name: 'Austin Basile',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549abb28925141312600192f',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1322017,
          known_for_department: 'Art',
          name: 'Jann K. Engel',
          original_name: 'Jann K. Engel',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mlW1L37BwEVUG9yk1adzDn3axgq.jpg',
          credit_id: '549aa8dc9251413132001675',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1323092,
          known_for_department: 'Costume & Make-Up',
          name: 'Mitchell Ray Kenney',
          original_name: 'Mitchell Ray Kenney',
          popularity: 0.6,
          profile_path: null,
          credit_id: '53a1592ec3a3685b2c000939',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1325055,
          known_for_department: 'Camera',
          name: 'Steve Graves',
          original_name: 'Steve Graves',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8866e8e33f830039fe754d',
          department: 'Camera',
          job: 'Best Boy Grip',
        },
        {
          adult: false,
          gender: 1,
          id: 1325215,
          known_for_department: 'Costume & Make-Up',
          name: 'Suzanne M.B. Chambliss',
          original_name: 'Suzanne M.B. Chambliss',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8871958258fc0035a8c2e2',
          department: 'Costume & Make-Up',
          job: 'Seamstress',
        },
        {
          adult: false,
          gender: 0,
          id: 1325573,
          known_for_department: 'Production',
          name: 'Judith Bouley',
          original_name: 'Judith Bouley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8872cf8258fc0036ac7762',
          department: 'Production',
          job: 'Additional Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 1326550,
          known_for_department: 'Camera',
          name: 'David McGrory',
          original_name: 'David McGrory',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9WJ7dmegag5MQaOxMerNxTkTxwJ.jpg',
          credit_id: '5f8869baf3b49a0033b9bc98',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 2,
          id: 1335066,
          known_for_department: 'Art',
          name: 'Andrew Petrotta',
          original_name: 'Andrew Petrotta',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89c5b02667780037e211ec',
          department: 'Crew',
          job: 'Armorer',
        },
        {
          adult: false,
          gender: 0,
          id: 1335873,
          known_for_department: 'Art',
          name: 'George Hull',
          original_name: 'George Hull',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5f89b3942385130034392e00',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 0,
          id: 1337418,
          known_for_department: 'Visual Effects',
          name: 'Nathan McGuinness',
          original_name: 'Nathan McGuinness',
          popularity: 0.629,
          profile_path: null,
          credit_id: '549abc10925141312600194b',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1337656,
          known_for_department: 'Production',
          name: 'Meagan Lewis',
          original_name: 'Meagan Lewis',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5f8872fef3b49a0035bc9245',
          department: 'Production',
          job: 'Additional Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 1338134,
          known_for_department: 'Sound',
          name: 'John Sievert',
          original_name: 'John Sievert',
          popularity: 1.214,
          profile_path: null,
          credit_id: '5f89c3c4f6fd180034b415cf',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1338136,
          known_for_department: 'Sound',
          name: 'Randy Wilson',
          original_name: 'Randy Wilson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89c3e8f6fd180035b5707a',
          department: 'Sound',
          job: 'Foley Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1347720,
          known_for_department: 'Crew',
          name: 'Aaron McBride',
          original_name: 'Aaron McBride',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549abd3dc3a3682f2100192c',
          department: 'Crew',
          job: 'Visual Effects Art Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1347763,
          known_for_department: 'Camera',
          name: 'Chris Moseley',
          original_name: 'Chris Moseley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549abf4092514131290019b0',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1352981,
          known_for_department: 'Sound',
          name: 'Sam Zeines',
          original_name: 'Sam Zeines',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549ac1b0c3a3682f1b0019db',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1355605,
          known_for_department: 'Production',
          name: 'Katie Doyle',
          original_name: 'Katie Doyle',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/quEEShWQuJA4oVgAY1CA9Rksrn5.jpg',
          credit_id: '5f8872e53103250036f12b45',
          department: 'Production',
          job: 'Additional Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 1357052,
          known_for_department: 'Art',
          name: 'Jeff Julian',
          original_name: 'Jeff Julian',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b3c7e9da69003ae62218',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 0,
          id: 1357067,
          known_for_department: 'Costume & Make-Up',
          name: 'Corey Bronson',
          original_name: 'Corey Bronson',
          popularity: 1.38,
          profile_path: null,
          credit_id: '549ac0c5c3a3682f23001a19',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1364239,
          known_for_department: 'Art',
          name: 'Mark Robert Taylor',
          original_name: 'Mark Robert Taylor',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b2e01443f40039c86569',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1367672,
          known_for_department: 'Lighting',
          name: 'Bob E. Krattiger',
          original_name: 'Bob E. Krattiger',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549ac00bc3a3682f1e0019ad',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1368877,
          known_for_department: 'Visual Effects',
          name: 'Danielle Plantec',
          original_name: 'Danielle Plantec',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549abc6b925141312c001669',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1370904,
          known_for_department: 'Art',
          name: 'Chris Hopkins',
          original_name: 'Chris Hopkins',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549aaa589251413123001665',
          department: 'Art',
          job: 'Sculptor',
        },
        {
          adult: false,
          gender: 1,
          id: 1371069,
          known_for_department: 'Directing',
          name: 'Julie Pitkanen',
          original_name: 'Julie Pitkanen',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5f8864962385130035375af9',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1376893,
          known_for_department: 'Art',
          name: 'Robert Andrew Johnson',
          original_name: 'Robert Andrew Johnson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549aa95ec3a3680b27000ef4',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1377221,
          known_for_department: 'Sound',
          name: 'Jeffrey A. Humphreys',
          original_name: 'Jeffrey A. Humphreys',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89c3968d2f8d003894068e',
          department: 'Sound',
          job: 'Boom Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1377225,
          known_for_department: 'Visual Effects',
          name: 'Pablo Helman',
          original_name: 'Pablo Helman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549abbc5c3a3682f16001917',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1377241,
          known_for_department: 'Production',
          name: 'Michael John Meehan',
          original_name: 'Michael John Meehan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549ac23cc3a3682f1e0019e7',
          department: 'Production',
          job: 'Location Manager',
        },
        {
          adult: false,
          gender: 2,
          id: 1378169,
          known_for_department: 'Sound',
          name: 'Rick Kline',
          original_name: 'Rick Kline',
          popularity: 1.008,
          profile_path: null,
          credit_id: '5f89c2073af92900394f5d4f',
          department: 'Sound',
          job: 'Additional Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1378240,
          known_for_department: 'Camera',
          name: 'Frank Masi',
          original_name: 'Frank Masi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549ac026c3a3682f1b0019c0',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 2,
          id: 1378241,
          known_for_department: 'Camera',
          name: 'Maurice K. McGuire',
          original_name: 'Maurice K. McGuire',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549abf2892514131290019aa',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 1378724,
          known_for_department: 'Sound',
          name: 'Jim Schultz',
          original_name: 'Jim Schultz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549ac19c92514131230018d6',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1378830,
          known_for_department: 'Visual Effects',
          name: 'Jeanmarie King',
          original_name: 'Jeanmarie King',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549abd72c3a3682f230019d6',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1380477,
          known_for_department: 'Sound',
          name: 'Barbara Delpuech',
          original_name: 'Barbara Delpuech',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549aab41c3a3682f1b0017ed',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 1389129,
          known_for_department: 'Art',
          name: 'Theresa Greene',
          original_name: 'Theresa Greene',
          popularity: 0.98,
          profile_path: null,
          credit_id: '549aa7359251413126001722',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1394130,
          known_for_department: 'Sound',
          name: 'Frank A. Montaño',
          original_name: 'Frank A. Montaño',
          popularity: 1.008,
          profile_path: null,
          credit_id: '549ab9ef925141312c001641',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1394322,
          known_for_department: 'Crew',
          name: 'Brian C. Hirono',
          original_name: 'Brian C. Hirono',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549ac2129251414bb2000037',
          department: 'Crew',
          job: 'Dialect Coach',
        },
        {
          adult: false,
          gender: 0,
          id: 1394445,
          known_for_department: 'Visual Effects',
          name: 'David Sanger',
          original_name: 'David Sanger',
          popularity: 0.989,
          profile_path: null,
          credit_id: '549abcfc9251413132001867',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1395902,
          known_for_department: 'Camera',
          name: 'Robby Baumgartner',
          original_name: 'Robby Baumgartner',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549abe8ec3a3680b270010c7',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 1398972,
          known_for_department: 'Camera',
          name: 'Pete Romano',
          original_name: 'Pete Romano',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886ff28258fc0035a8c11f',
          department: 'Camera',
          job: 'Underwater Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 1399071,
          known_for_department: 'Camera',
          name: 'Hans Bjerno',
          original_name: 'Hans Bjerno',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5f88657a021cee0038bc6d05',
          department: 'Camera',
          job: 'Aerial Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 1399865,
          known_for_department: 'Visual Effects',
          name: 'Chad Wiebe',
          original_name: 'Chad Wiebe',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bc46a13533003612a25a',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1399917,
          known_for_department: 'Sound',
          name: 'Stefan Fraticelli',
          original_name: 'Stefan Fraticelli',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5f89c3ac1443f40038c5a9bf',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1400079,
          known_for_department: 'Camera',
          name: "Patrick B. O'Brien",
          original_name: "Patrick B. O'Brien",
          popularity: 0.98,
          profile_path: null,
          credit_id: '5f8867bbe33f83003afde3ad',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 1400906,
          known_for_department: 'Sound',
          name: 'Christopher Scarabosio',
          original_name: 'Christopher Scarabosio',
          popularity: 0.771,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9lOLuw52TKHXbzOzzlOsTYS3UEu.jpg',
          credit_id: '549aab9f925141312c0014ff',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1401109,
          known_for_department: 'Camera',
          name: 'Chris Haarhoff',
          original_name: 'Chris Haarhoff',
          popularity: 1.008,
          profile_path:
            'https://image.tmdb.org/t/p/w185/s8rWd96a0I2IPKOjESrHtaZyQ8U.jpg',
          credit_id: '549abec19251413126001975',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 1401109,
          known_for_department: 'Camera',
          name: 'Chris Haarhoff',
          original_name: 'Chris Haarhoff',
          popularity: 1.008,
          profile_path:
            'https://image.tmdb.org/t/p/w185/s8rWd96a0I2IPKOjESrHtaZyQ8U.jpg',
          credit_id: '549abfa9c3a3682f1b0019b2',
          department: 'Camera',
          job: 'Steadicam Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 1403085,
          known_for_department: 'Art',
          name: 'Douglas Fox',
          original_name: 'Douglas Fox',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5ad286cfc3a3683eed018f72',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 1403424,
          known_for_department: 'Costume & Make-Up',
          name: 'Roberto Craciunica',
          original_name: 'Roberto Craciunica',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549aa5be92514131260016f3',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1403425,
          known_for_department: 'Costume & Make-Up',
          name: 'Mahealani Diego',
          original_name: 'Mahealani Diego',
          popularity: 0.652,
          profile_path: null,
          credit_id: '549aa5e7c3a3682f160016c0',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1403426,
          known_for_department: 'Costume & Make-Up',
          name: 'Yolanda Mercadel',
          original_name: 'Yolanda Mercadel',
          popularity: 1.566,
          profile_path: null,
          credit_id: '549aa614925141312c00145c',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1403427,
          known_for_department: 'Production',
          name: 'Candice D. Campos',
          original_name: 'Candice D. Campos',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549aa684c3a3682f1b001766',
          department: 'Production',
          job: 'Production Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1403428,
          known_for_department: 'Production',
          name: 'Renee Confair',
          original_name: 'Renee Confair',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549aa69ec3a3682f23001772',
          department: 'Production',
          job: 'Production Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1403429,
          known_for_department: 'Production',
          name: 'Wendy Wong',
          original_name: 'Wendy Wong',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549aa6b7925141312600170e',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1403430,
          known_for_department: 'Art',
          name: 'Christine Youngstrom',
          original_name: 'Christine Youngstrom',
          popularity: 0.694,
          profile_path: null,
          credit_id: '549aa7049251413132001637',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1403432,
          known_for_department: 'Art',
          name: 'Robert A. Blackburn',
          original_name: 'Robert A. Blackburn',
          popularity: 0.656,
          profile_path: null,
          credit_id: '549aa814925141312f001875',
          department: 'Art',
          job: 'Construction Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1403433,
          known_for_department: 'Crew',
          name: 'Andrew M. Casbon III',
          original_name: 'Andrew M. Casbon III',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549aa834925141311f0015fe',
          department: 'Crew',
          job: 'Scenic Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1403434,
          known_for_department: 'Art',
          name: 'Brett C. Smith',
          original_name: 'Brett C. Smith',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549aa89a925141312f00188d',
          department: 'Art',
          job: 'Leadman',
        },
        {
          adult: false,
          gender: 2,
          id: 1403435,
          known_for_department: 'Art',
          name: 'Edward J. Protiva',
          original_name: 'Edward J. Protiva',
          popularity: 0.648,
          profile_path: null,
          credit_id: '549aa8b0925141312c0014b2',
          department: 'Art',
          job: 'Leadman',
        },
        {
          adult: false,
          gender: 2,
          id: 1403438,
          known_for_department: 'Sound',
          name: 'Darren King',
          original_name: 'Darren King',
          popularity: 1.094,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yiK8MMwsOiahv1uH8rzzn5v44K8.jpg',
          credit_id: '549aaaeac3a3682f19001794',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1403438,
          known_for_department: 'Sound',
          name: 'Darren King',
          original_name: 'Darren King',
          popularity: 1.094,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yiK8MMwsOiahv1uH8rzzn5v44K8.jpg',
          credit_id: '5ad7bf39c3a368719c004298',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1403438,
          known_for_department: 'Sound',
          name: 'Darren King',
          original_name: 'Darren King',
          popularity: 1.094,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yiK8MMwsOiahv1uH8rzzn5v44K8.jpg',
          credit_id: '5ad7bf2a0e0a264342004c82',
          department: 'Sound',
          job: 'ADR Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1403439,
          known_for_department: 'Sound',
          name: 'Gregory King',
          original_name: 'Gregory King',
          popularity: 0.739,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tmyEC5zNGoPyfzNzsyBGor6Bn4P.jpg',
          credit_id: '549aab12925141312300167c',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1403439,
          known_for_department: 'Sound',
          name: 'Gregory King',
          original_name: 'Gregory King',
          popularity: 0.739,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tmyEC5zNGoPyfzNzsyBGor6Bn4P.jpg',
          credit_id: '5f89c2202667780036e1314f',
          department: 'Sound',
          job: 'Additional Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1403440,
          known_for_department: 'Sound',
          name: 'Yann Delpuech',
          original_name: 'Yann Delpuech',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549aab54c3a3682f2100177c',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1403441,
          known_for_department: 'Sound',
          name: 'Shaughnessy Hare',
          original_name: 'Shaughnessy Hare',
          popularity: 0.716,
          profile_path:
            'https://image.tmdb.org/t/p/w185/v4ptvI8B8JbFU22ysFmgyyf4sZN.jpg',
          credit_id: '549aab6ec3a3682f21001783',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1403442,
          known_for_department: 'Sound',
          name: 'Mike McKone',
          original_name: 'Mike McKone',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549aab8a925141312c0014f9',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1403443,
          known_for_department: 'Sound',
          name: 'Joel Shryack',
          original_name: 'Joel Shryack',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad7bf0c0e0a26433c004c50',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1403443,
          known_for_department: 'Sound',
          name: 'Joel Shryack',
          original_name: 'Joel Shryack',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad7beefc3a36871a1004146',
          department: 'Sound',
          job: 'ADR Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1403458,
          known_for_department: 'Visual Effects',
          name: 'Grady Cofer',
          original_name: 'Grady Cofer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549abb529251415dc10010fd',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1403460,
          known_for_department: 'Crew',
          name: 'Joseph Derrico III',
          original_name: 'Joseph Derrico III',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549abb6d9251415dc1001103',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1403461,
          known_for_department: 'Visual Effects',
          name: 'Chris Harvey',
          original_name: 'Chris Harvey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549abb91925141312600193d',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1403463,
          known_for_department: 'Visual Effects',
          name: 'Winston Helgason',
          original_name: 'Winston Helgason',
          popularity: 0.728,
          profile_path: null,
          credit_id: '549abbafc3a3682f230019a6',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1403464,
          known_for_department: 'Visual Effects',
          name: 'Pete Jopling',
          original_name: 'Pete Jopling',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549abbe8c3a3682f2100191a',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1403465,
          known_for_department: 'Visual Effects',
          name: 'Paul Mitchell',
          original_name: 'Paul Mitchell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549abc46c3a3682f1e001937',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1403467,
          known_for_department: 'Crew',
          name: 'Xinyi Puah',
          original_name: 'Xinyi Puah',
          popularity: 0.98,
          profile_path: null,
          credit_id: '549abc81c3a3682f230019c4',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1403468,
          known_for_department: 'Visual Effects',
          name: 'Stephan Trojansky',
          original_name: 'Stephan Trojansky',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549abcab925141312900196d',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1403469,
          known_for_department: 'Visual Effects',
          name: 'Dominic Sidoli',
          original_name: 'Dominic Sidoli',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549abce3925141312f001a99',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1403470,
          known_for_department: 'Crew',
          name: 'Jody Rogers',
          original_name: 'Jody Rogers',
          popularity: 0.648,
          profile_path: null,
          credit_id: '549abd13c3a3682f1e00194e',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1403471,
          known_for_department: 'Visual Effects',
          name: 'Rick Lupton',
          original_name: 'Rick Lupton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549abd55c3a3682f21001932',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1403472,
          known_for_department: 'Visual Effects',
          name: 'Colleen Jenkinson',
          original_name: 'Colleen Jenkinson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549abd9bc3a3682f280018db',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1403474,
          known_for_department: 'Visual Effects',
          name: 'Robert E. Evans',
          original_name: 'Robert E. Evans',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549abdc3925141311f00180c',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1403475,
          known_for_department: 'Visual Effects',
          name: 'Kevin Elam',
          original_name: 'Kevin Elam',
          popularity: 1.214,
          profile_path: null,
          credit_id: '549abddc925141312f001aae',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1403478,
          known_for_department: 'Camera',
          name: 'Don King',
          original_name: 'Don King',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549abee6c3a3682f1600195a',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1403479,
          known_for_department: 'Camera',
          name: 'Duane Manwiller',
          original_name: 'Duane Manwiller',
          popularity: 0.759,
          profile_path: null,
          credit_id: '549abf05925141312c00169e',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1403480,
          known_for_department: 'Lighting',
          name: 'Frank R. Jimenez Jr.',
          original_name: 'Frank R. Jimenez Jr.',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549abff392514131320018bb',
          department: 'Lighting',
          job: 'Best Boy Electric',
        },
        {
          adult: false,
          gender: 0,
          id: 1403481,
          known_for_department: 'Crew',
          name: 'Paul Murphey',
          original_name: 'Paul Murphey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549ac045c3a3682f2800191c',
          department: 'Crew',
          job: 'Video Assist Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1403482,
          known_for_department: 'Crew',
          name: "Richard O'Linke Jr.",
          original_name: "Richard O'Linke Jr.",
          popularity: 0.6,
          profile_path: null,
          credit_id: '549ac06bc3a3682f28001923',
          department: 'Crew',
          job: 'Cableman',
        },
        {
          adult: false,
          gender: 0,
          id: 1403484,
          known_for_department: 'Costume & Make-Up',
          name: 'Maryann Dearmore',
          original_name: 'Maryann Dearmore',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549ac0dbc3a3682f21001992',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1403485,
          known_for_department: 'Costume & Make-Up',
          name: 'Daniel Dirks',
          original_name: 'Daniel Dirks',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549ac0efc3a3682f190019d1',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1403487,
          known_for_department: 'Costume & Make-Up',
          name: 'Alema K. Ryder',
          original_name: 'Alema K. Ryder',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549ac118925141312c0016d1',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1403488,
          known_for_department: 'Editing',
          name: 'Erik Rogers',
          original_name: 'Erik Rogers',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8873d5f3b49a0034b7d55e',
          department: 'Editing',
          job: 'Digital Intermediate Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1403490,
          known_for_department: 'Sound',
          name: 'Alex Gibson',
          original_name: 'Alex Gibson',
          popularity: 0.612,
          profile_path: null,
          credit_id: '549ac186c3a3682f23001a2a',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1403491,
          known_for_department: 'Production',
          name: 'Laura Sode-Matteson',
          original_name: 'Laura Sode-Matteson',
          popularity: 0.828,
          profile_path: null,
          credit_id: '549ac27a9251414bb2000043',
          department: 'Production',
          job: 'Location Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1403492,
          known_for_department: 'Production',
          name: 'George Wong',
          original_name: 'George Wong',
          popularity: 0.6,
          profile_path: null,
          credit_id: '549ac29b925141313200190a',
          department: 'Production',
          job: 'Location Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1403540,
          known_for_department: 'Crew',
          name: 'Jason Gaudio',
          original_name: 'Jason Gaudio',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f88745ce33f83003afe0381',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1408360,
          known_for_department: 'Lighting',
          name: 'Dan Riffel',
          original_name: 'Dan Riffel',
          popularity: 0.728,
          profile_path: null,
          credit_id: '5f886b03a275027b2ac8401c',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1408515,
          known_for_department: 'Sound',
          name: 'Brian Slack',
          original_name: 'Brian Slack',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89c2813af92900384d7eab',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1410570,
          known_for_department: 'Diễn viên',
          name: 'Jeff Taylor',
          original_name: 'Jeff Taylor',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886f022cefc200372079d0',
          department: 'Camera',
          job: 'Second Assistant "C" Camera',
        },
        {
          adult: false,
          gender: 2,
          id: 1413124,
          known_for_department: 'Lighting',
          name: 'Dennis J. Lootens',
          original_name: 'Dennis J. Lootens',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886c54e9da69003ae40cbf',
          department: 'Lighting',
          job: 'Rigging Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1413201,
          known_for_department: 'Production',
          name: 'Allen E. Taylor',
          original_name: 'Allen E. Taylor',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8b0c19a135330035178721',
          department: 'Crew',
          job: 'Production Controller',
        },
        {
          adult: false,
          gender: 0,
          id: 1413464,
          known_for_department: 'Crew',
          name: 'Andy Lesniak',
          original_name: 'Andy Lesniak',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5f89bba6a1353300351339b8',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1414187,
          known_for_department: 'Crew',
          name: 'Robert Weaver',
          original_name: 'Robert Weaver',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bc082667780038e013d3',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1417415,
          known_for_department: 'Art',
          name: 'Mychael Bates',
          original_name: 'Mychael Bates',
          popularity: 0.676,
          profile_path: null,
          credit_id: '5f89b5852667780037e1d1e5',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 1417996,
          known_for_department: 'Camera',
          name: 'Tim Nagasawa',
          original_name: 'Tim Nagasawa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8867e139549a0036b39e9f',
          department: 'Camera',
          job: 'Digital Imaging Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 1418065,
          known_for_department: 'Lighting',
          name: 'Tim Stratton',
          original_name: 'Tim Stratton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886944e9da690037e442e9',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 1421794,
          known_for_department: 'Lighting',
          name: 'Mikey Jechort',
          original_name: 'Mikey Jechort',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8869992385130034364d9d',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 1425931,
          known_for_department: 'Directing',
          name: 'Rebecca Boyle',
          original_name: 'Rebecca Boyle',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8864b8d4b9d9003829471a',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1431029,
          known_for_department: 'Crew',
          name: 'Michael Blackbourn',
          original_name: 'Michael Blackbourn',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5f89bc561443f40037c737f7',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1431068,
          known_for_department: 'Visual Effects',
          name: 'Stephen Pepper',
          original_name: 'Stephen Pepper',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bcf2e9da690038e7ffd9',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1435641,
          known_for_department: 'Art',
          name: 'Antonio Andraus',
          original_name: 'Antonio Andraus',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b9011443f40039c8878a',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 1448602,
          known_for_department: 'Visual Effects',
          name: 'Justin Mitchell',
          original_name: 'Justin Mitchell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bc3723851300373adc84',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1451676,
          known_for_department: 'Crew',
          name: 'Earl A. Hibbert',
          original_name: 'Earl A. Hibbert',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5542cf39c3a3680ce600082e',
          department: 'Crew',
          job: 'Digital Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1459736,
          known_for_department: 'Visual Effects',
          name: 'Travis Tohill',
          original_name: 'Travis Tohill',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5549593d92514104be00087b',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1459914,
          known_for_department: 'Visual Effects',
          name: 'Stefano Trivelli',
          original_name: 'Stefano Trivelli',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5f89bcdc8d2f8d003695aa15',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1460499,
          known_for_department: 'Visual Effects',
          name: "Rick O'Connor",
          original_name: "Rick O'Connor",
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bd763af929003a4e20c2',
          department: 'Visual Effects',
          job: 'Lead Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 1463345,
          known_for_department: 'Art',
          name: 'William H. Phen Jr.',
          original_name: 'William H. Phen Jr.',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b49d3af929003750790c',
          department: 'Art',
          job: 'Construction Foreman',
        },
        {
          adult: false,
          gender: 2,
          id: 1463384,
          known_for_department: 'Art',
          name: 'Ben Woodworth',
          original_name: 'Ben Woodworth',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b5501443f40036c64302',
          department: 'Art',
          job: 'Painter',
        },
        {
          adult: false,
          gender: 0,
          id: 1463631,
          known_for_department: 'Visual Effects',
          name: 'Rene Toye',
          original_name: 'Rene Toye',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bf8f23851300373ae659',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1463751,
          known_for_department: 'Diễn viên',
          name: 'Jason Marvel',
          original_name: 'Jason Marvel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886736f3b49a0036b65b82',
          department: 'Camera',
          job: 'BTS Photographer',
        },
        {
          adult: false,
          gender: 0,
          id: 1463785,
          known_for_department: 'Visual Effects',
          name: 'Jeremy Stewart',
          original_name: 'Jeremy Stewart',
          popularity: 0.6,
          profile_path: null,
          credit_id: '554956fd92514104b800082f',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1484991,
          known_for_department: 'Costume & Make-Up',
          name: 'Heather Rae Miller',
          original_name: 'Heather Rae Miller',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f887119a275027b2ac849d1',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1509977,
          known_for_department: 'Editing',
          name: 'Gabriel Fleming',
          original_name: 'Gabriel Fleming',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f88740ef3b49a0035bc943e',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1530720,
          known_for_department: 'Lighting',
          name: 'Rob Skuse',
          original_name: 'Rob Skuse',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886c8af3b49a0034b7c9dd',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1532751,
          known_for_department: 'Visual Effects',
          name: 'Catherine Liu',
          original_name: 'Catherine Liu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bf491443f40038c5a3c3',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1536551,
          known_for_department: 'Crew',
          name: 'Greg Hyman',
          original_name: 'Greg Hyman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89c03aa13533003612ae06',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1536636,
          known_for_department: 'Camera',
          name: 'Jeffrey S. Lorenz',
          original_name: 'Jeffrey S. Lorenz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886ac02385130034365022',
          department: 'Camera',
          job: 'First Assistant "C" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1537430,
          known_for_department: 'Lighting',
          name: 'Rell Putt',
          original_name: 'Rell Putt',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886d2e8258fc0034afa2a3',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 2,
          id: 1548879,
          known_for_department: 'Camera',
          name: 'Jimmy E. Jensen',
          original_name: 'Jimmy E. Jensen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886a1aa275020039cf6999',
          department: 'Camera',
          job: 'First Assistant "A" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1550761,
          known_for_department: 'Visual Effects',
          name: 'Jean-Denis Haas',
          original_name: 'Jean-Denis Haas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8870688258fc0037a69c33',
          department: 'Visual Effects',
          job: 'Lead Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 1551056,
          known_for_department: 'Lighting',
          name: 'Kim Heath',
          original_name: 'Kim Heath',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886bdae9da690038e429ad',
          department: 'Lighting',
          job: 'Key Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1552626,
          known_for_department: 'Costume & Make-Up',
          name: 'Sarah P. Koeppe',
          original_name: 'Sarah P. Koeppe',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8871482cefc200361ebdf1',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1555488,
          known_for_department: 'Sound',
          name: 'Paul Ledford',
          original_name: 'Paul Ledford',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad7bf829251413cc70042e0',
          department: 'Sound',
          job: 'Sound Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1565105,
          known_for_department: 'Sound',
          name: 'Jeffrey Dyal',
          original_name: 'Jeffrey Dyal',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89c2f03af92900394f5fa6',
          department: 'Sound',
          job: 'Assistant Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1578175,
          known_for_department: 'Camera',
          name: 'Ian Clampett',
          original_name: 'Ian Clampett',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886aae238513003635e34e',
          department: 'Camera',
          job: 'First Assistant "C" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1590406,
          known_for_department: 'Crew',
          name: 'David Marsh',
          original_name: 'David Marsh',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bec5f6fd180035b55e4e',
          department: 'Crew',
          job: 'Sequence Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1597180,
          known_for_department: 'Art',
          name: 'Jesse Valdez',
          original_name: 'Jesse Valdez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b9a2f6fd180034b3f370',
          department: 'Art',
          job: 'Standby Painter',
        },
        {
          adult: false,
          gender: 0,
          id: 1619974,
          known_for_department: 'Camera',
          name: 'Michael Anderson',
          original_name: 'Michael Anderson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886b91e33f830039fe8298',
          department: 'Camera',
          job: 'Key Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1621223,
          known_for_department: 'Art',
          name: 'Tani Kunitake',
          original_name: 'Tani Kunitake',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b3e839549a0038b9afef',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 0,
          id: 1636849,
          known_for_department: 'Editing',
          name: 'Melissa Lawson Cheung',
          original_name: 'Melissa Lawson Cheung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f88746fd4b9d900372b7742',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1637981,
          known_for_department: 'Costume & Make-Up',
          name: 'Dallas D. Dornan',
          original_name: 'Dallas D. Dornan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8871738258fc0036ac74cc',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1645683,
          known_for_department: 'Lighting',
          name: 'Danielle Greenup',
          original_name: 'Danielle Greenup',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f88692839549a0038b4a067',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 1646507,
          known_for_department: 'Crew',
          name: 'Christopher Ahrens',
          original_name: 'Christopher Ahrens',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bde339549a0038b9dd6a',
          department: 'Lighting',
          job: 'Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1659138,
          known_for_department: 'Visual Effects',
          name: 'Marshall Richard Krasser',
          original_name: 'Marshall Richard Krasser',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bccbd4b9d900382d2e15',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1674670,
          known_for_department: 'Visual Effects',
          name: 'Michael Conte',
          original_name: 'Michael Conte',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bcb61443f40039c89625',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1684977,
          known_for_department: 'Art',
          name: 'Vinson Jae',
          original_name: 'Vinson Jae',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b98ff6fd180036b2d21a',
          department: 'Art',
          job: 'Standby Painter',
        },
        {
          adult: false,
          gender: 0,
          id: 1693550,
          known_for_department: 'Sound',
          name: 'Charles J. Bond',
          original_name: 'Charles J. Bond',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89c32b23851300353ce405',
          department: 'Sound',
          job: 'Boom Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1722170,
          known_for_department: 'Costume & Make-Up',
          name: 'Cory Ching',
          original_name: 'Cory Ching',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8871e4a275020039cf83ad',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 1,
          id: 1728282,
          known_for_department: 'Camera',
          name: 'Louie DeMarco',
          original_name: 'Louie DeMarco',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886a992385130035376afe',
          department: 'Camera',
          job: 'First Assistant "B" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1732753,
          known_for_department: 'Costume & Make-Up',
          name: 'Amy Arnold',
          original_name: 'Amy Arnold',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f88715f39549a0038b4bfd3',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 2,
          id: 1734699,
          known_for_department: 'Directing',
          name: 'Michael J. Moore',
          original_name: 'Michael J. Moore',
          popularity: 0.652,
          profile_path: null,
          credit_id: '5f8863e43103250035f0e318',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1736215,
          known_for_department: 'Crew',
          name: "Matthew H. O'Connor",
          original_name: "Matthew H. O'Connor",
          popularity: 0.98,
          profile_path: null,
          credit_id: '5f89c5c4f6fd180036b2f219',
          department: 'Crew',
          job: 'Marine Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1738163,
          known_for_department: 'Camera',
          name: 'Chris Gordon',
          original_name: 'Chris Gordon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f88689139549a0036b39f35',
          department: 'Camera',
          job: 'Dolly Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1740448,
          known_for_department: 'Camera',
          name: 'Mike Schwake',
          original_name: 'Mike Schwake',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8868a9d4b9d90038294d19',
          department: 'Camera',
          job: 'Dolly Grip',
        },
        {
          adult: false,
          gender: 2,
          id: 1744424,
          known_for_department: 'Camera',
          name: 'Paul V. Perkins',
          original_name: 'Paul V. Perkins',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8868cfd4b9d90035278bef',
          department: 'Camera',
          job: 'Dolly Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1745942,
          known_for_department: 'Directing',
          name: 'Richard Oswald',
          original_name: 'Richard Oswald',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fd065b20ce1bc003ef062b0',
          department: 'Directing',
          job: 'Second Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1760570,
          known_for_department: 'Camera',
          name: 'Miguel Pask',
          original_name: 'Miguel Pask',
          popularity: 1.094,
          profile_path: null,
          credit_id: '5f886ea439549a0037b437a7',
          department: 'Camera',
          job: 'Second Assistant "A" Camera',
        },
        {
          adult: false,
          gender: 2,
          id: 1763700,
          known_for_department: 'Crew',
          name: 'Elvin Yoshida',
          original_name: 'Elvin Yoshida',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b4531443f40037c71a6e',
          department: 'Art',
          job: 'Construction Buyer',
        },
        {
          adult: false,
          gender: 0,
          id: 1764096,
          known_for_department: 'Sound',
          name: 'E. Niles Klein',
          original_name: 'E. Niles Klein',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89c3023af92900394f5fd2',
          department: 'Sound',
          job: 'Assistant Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1770873,
          known_for_department: 'Camera',
          name: 'Doug Cowden',
          original_name: 'Doug Cowden',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886ba7a275020037cd30a7',
          department: 'Camera',
          job: 'Key Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1774358,
          known_for_department: 'Production',
          name: 'Michael A. Galasso',
          original_name: 'Michael A. Galasso',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8b0c602667780038e20cc2',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1788365,
          known_for_department: 'Lighting',
          name: 'Jon Philion',
          original_name: 'Jon Philion',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886c14d4b9d900372b5ec9',
          department: 'Camera',
          job: 'Libra Head Technician',
        },
        {
          adult: false,
          gender: 2,
          id: 1795426,
          known_for_department: 'Lighting',
          name: 'Mike Gerzevitz',
          original_name: 'Mike Gerzevitz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886987e33f83003afde60b',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 1840135,
          known_for_department: 'Costume & Make-Up',
          name: 'Michele Flynn',
          original_name: 'Michele Flynn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8870aef3b49a0034b7d2da',
          department: 'Costume & Make-Up',
          job: 'Ager/Dyer',
        },
        {
          adult: false,
          gender: 2,
          id: 1848844,
          known_for_department: 'Camera',
          name: 'Todd Schlopy',
          original_name: 'Todd Schlopy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886a7439549a0036b3a172',
          department: 'Camera',
          job: 'First Assistant "A" Camera',
        },
        {
          adult: false,
          gender: 1,
          id: 1848861,
          known_for_department: 'Production',
          name: 'Nancy Honeycutt',
          original_name: 'Nancy Honeycutt',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8b0c48eb79c200380b8057',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1854964,
          known_for_department: 'Camera',
          name: 'Victor A. Shelehov',
          original_name: 'Victor A. Shelehov',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5f88686cf3b49a0034b7c33b',
          department: 'Camera',
          job: 'Dolly Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1859993,
          known_for_department: 'Costume & Make-Up',
          name: 'Charles W. Kaeo',
          original_name: 'Charles W. Kaeo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f88722f3af92900374b8f77',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1860863,
          known_for_department: 'Lighting',
          name: 'Mike Nami Jr.',
          original_name: 'Mike Nami Jr.',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886cd43103250036f118a9',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1882076,
          known_for_department: 'Lighting',
          name: 'Justin Wright',
          original_name: 'Justin Wright',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f88695639549a0036b3a03b',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 1,
          id: 1898645,
          known_for_department: 'Editing',
          name: 'Chi-Yoon Chung',
          original_name: 'Chi-Yoon Chung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8874283103250036f12f7d',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1902577,
          known_for_department: 'Camera',
          name: 'Gerald Autin',
          original_name: 'Gerald Autin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886650e33f830039fe745d',
          department: 'Camera',
          job: 'Best Boy Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1916293,
          known_for_department: 'Art',
          name: 'Rachel Nowik',
          original_name: 'Rachel Nowik',
          popularity: 1.62,
          profile_path: null,
          credit_id: '5f89b6542667780037e1d4b1',
          department: 'Art',
          job: 'Set Decorating Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1916489,
          known_for_department: 'Camera',
          name: 'Jeremy Webre',
          original_name: 'Jeremy Webre',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f88687de9da69003ae407a8',
          department: 'Camera',
          job: 'Dolly Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1921576,
          known_for_department: 'Sound',
          name: 'Trent Richmond',
          original_name: 'Trent Richmond',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89c3d639549a0038b9f993',
          department: 'Sound',
          job: 'Foley Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1933513,
          known_for_department: 'Visual Effects',
          name: 'Joshua Wassung',
          original_name: 'Joshua Wassung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89be65a13533003612a88b',
          department: 'Visual Effects',
          job: 'Pre-Visualization Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1935168,
          known_for_department: 'Art',
          name: 'Daniel Coulthard',
          original_name: 'Daniel Coulthard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b6dee9da69003ae62707',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 1939899,
          known_for_department: 'Art',
          name: 'Christian Pearce',
          original_name: 'Christian Pearce',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b3502667780036e1018a',
          department: 'Art',
          job: 'Concept Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1982524,
          known_for_department: 'Costume & Make-Up',
          name: 'Steve Jung',
          original_name: 'Steve Jung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b3d7f6fd180035b52d79',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 0,
          id: 1982646,
          known_for_department: 'Crew',
          name: 'Zai Ortiz',
          original_name: 'Zai Ortiz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bc1923851300373ada57',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2026621,
          known_for_department: 'Lighting',
          name: 'Jeremy Selsor',
          original_name: 'Jeremy Selsor',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886c7cf3b49a0034b7c9c5',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 2,
          id: 2028029,
          known_for_department: 'Art',
          name: 'Michael P. Sweeney',
          original_name: 'Michael P. Sweeney',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b2fe2667780037e1c4bc',
          department: 'Art',
          job: 'Assistant Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 2032738,
          known_for_department: 'Crew',
          name: 'David Homcy',
          original_name: 'David Homcy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886ad5a275020039cf6aed',
          department: 'Camera',
          job: 'First Assistant "D" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2045362,
          known_for_department: 'Visual Effects',
          name: 'Carlos Huante',
          original_name: 'Carlos Huante',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b37d39549a0036b62ef3',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 0,
          id: 2045384,
          known_for_department: 'Camera',
          name: 'Bryan Ashford',
          original_name: 'Bryan Ashford',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f88685ae33f83003afde479',
          department: 'Camera',
          job: 'Dolly Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2046817,
          known_for_department: 'Camera',
          name: 'Brent Egan',
          original_name: 'Brent Egan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886e93a275020037cd3c24',
          department: 'Camera',
          job: 'Second Assistant "A" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2057527,
          known_for_department: 'Art',
          name: 'Richard Bennett',
          original_name: 'Richard Bennett',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b9f9f6fd180034b3f533',
          department: 'Art',
          job: 'Storyboard Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2083600,
          known_for_department: 'Lighting',
          name: 'Steve Zeiger',
          original_name: 'Steve Zeiger',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8869dc021cee0038bc7570',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 2,
          id: 2089435,
          known_for_department: 'Art',
          name: 'Andrew Campbell',
          original_name: 'Andrew Campbell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b4f81443f40039c87336',
          department: 'Art',
          job: 'Graphic Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2092733,
          known_for_department: 'Production',
          name: 'Mimi N. McGreal',
          original_name: 'Mimi N. McGreal',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8b0d232667780037e6a656',
          department: 'Production',
          job: 'Travel Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2098318,
          known_for_department: 'Visual Effects',
          name: 'Courteney Smith',
          original_name: 'Courteney Smith',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89c0bae9da69003ae63bb8',
          department: 'Visual Effects',
          job: 'Visual Effects Production Assistant',
        },
        {
          adult: false,
          gender: 2,
          id: 2101062,
          known_for_department: 'Sound',
          name: 'Ron Mellegers',
          original_name: 'Ron Mellegers',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89c3f91443f40037c74e35',
          department: 'Sound',
          job: 'Foley Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 2120525,
          known_for_department: 'Lighting',
          name: 'Gary Cadow',
          original_name: 'Gary Cadow',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886c6b23851300373705eb',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2121199,
          known_for_department: 'Crew',
          name: 'Mark Haas',
          original_name: 'Mark Haas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886b1ee33f830038fd224a',
          department: 'Crew',
          job: 'Generator Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 2121580,
          known_for_department: 'Production',
          name: 'Robin Batherson',
          original_name: 'Robin Batherson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f88731df6fd180035b028fa',
          department: 'Production',
          job: 'Extras Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 2131178,
          known_for_department: 'Costume & Make-Up',
          name: 'Jose S. Hernandez',
          original_name: 'Jose S. Hernandez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f887182a275020039cf82e6',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2134464,
          known_for_department: 'Visual Effects',
          name: 'John Zdankiewicz',
          original_name: 'John Zdankiewicz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bd878d2f8d003893fbde',
          department: 'Visual Effects',
          job: 'Lead Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 2134505,
          known_for_department: 'Visual Effects',
          name: 'Maia Kayser',
          original_name: 'Maia Kayser',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bd64e9da69003ae6353c',
          department: 'Visual Effects',
          job: 'Lead Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 2142686,
          known_for_department: 'Production',
          name: 'Karla Torres',
          original_name: 'Karla Torres',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8b0c32efd3c2003637f9c8',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2143600,
          known_for_department: 'Art',
          name: 'Tracey Wilson',
          original_name: 'Tracey Wilson',
          popularity: 0.677,
          profile_path: null,
          credit_id: '5f89ba292385130034394355',
          department: 'Art',
          job: 'Storyboard Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 2151003,
          known_for_department: 'Lighting',
          name: 'Jason Gross',
          original_name: 'Jason Gross',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bdb6d4b9d900352a5b2a',
          department: 'Lighting',
          job: 'Lighting Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 2156317,
          known_for_department: 'Art',
          name: 'George Hess',
          original_name: 'George Hess',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b720f6fd180034b3e682',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 1,
          id: 2191302,
          known_for_department: 'Art',
          name: 'Dorothy Street',
          original_name: 'Dorothy Street',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b2998d2f8d00369573a2',
          department: 'Art',
          job: 'Art Department Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2200592,
          known_for_department: 'Production',
          name: 'Cheri Hall',
          original_name: 'Cheri Hall',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8b0befd05a030034db0aaa',
          department: 'Production',
          job: 'Production Accountant',
        },
        {
          adult: false,
          gender: 0,
          id: 2204130,
          known_for_department: 'Lighting',
          name: 'Russell Beard',
          original_name: 'Russell Beard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886967238513003635e1cc',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 2212073,
          known_for_department: 'Visual Effects',
          name: 'Blair Werschler',
          original_name: 'Blair Werschler',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bdf5a13533003612a77a',
          department: 'Lighting',
          job: 'Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2234240,
          known_for_department: 'Art',
          name: 'Marcus Epps',
          original_name: 'Marcus Epps',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b6f63af92900394f3767',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2239490,
          known_for_department: 'Camera',
          name: 'Chris Bangma',
          original_name: 'Chris Bangma',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886bf3f3b49a0033b9c1b1',
          department: 'Camera',
          job: 'Libra Head Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2242978,
          known_for_department: 'Lighting',
          name: 'Michael Nissen',
          original_name: 'Michael Nissen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886d0bf3b49a0033b9c4ec',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2243490,
          known_for_department: 'Visual Effects',
          name: 'C. Alexander Sears',
          original_name: 'C. Alexander Sears',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bf5ee9da690039e6db1d',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2243539,
          known_for_department: 'Production',
          name: 'Drew Barnett-Hamilton',
          original_name: 'Drew Barnett-Hamilton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8b0c99efd3c2003637fa96',
          department: 'Production',
          job: 'Production Secretary',
        },
        {
          adult: false,
          gender: 0,
          id: 2253799,
          known_for_department: 'Camera',
          name: 'Tony Nagy',
          original_name: 'Tony Nagy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886a868258fc0034af9aa3',
          department: 'Camera',
          job: 'First Assistant "B" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2253801,
          known_for_department: 'Camera',
          name: 'Rylan Akama',
          original_name: 'Rylan Akama',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886ec48258fc0034afaaa0',
          department: 'Camera',
          job: 'Second Assistant "B" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2253804,
          known_for_department: 'Crew',
          name: 'Brian Matsumura',
          original_name: 'Brian Matsumura',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886f112cefc200361ebbb3',
          department: 'Camera',
          job: 'Second Assistant "C" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2266374,
          known_for_department: 'Camera',
          name: 'Tony Muller',
          original_name: 'Tony Muller',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886ed6f3b49a0034b7cef4',
          department: 'Camera',
          job: 'Second Assistant "B" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2278028,
          known_for_department: 'Camera',
          name: 'Walter Royle',
          original_name: 'Walter Royle',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8866fb2cefc20037205cf4',
          department: 'Camera',
          job: 'Best Boy Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2281378,
          known_for_department: 'Lighting',
          name: 'James Hatridge',
          original_name: 'James Hatridge',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8865f4021cee0036bc4d49',
          department: 'Lighting',
          job: 'Best Boy Electric',
        },
        {
          adult: false,
          gender: 2,
          id: 2299116,
          known_for_department: 'Lighting',
          name: 'Dave Lujan',
          original_name: 'Dave Lujan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8869a98258fc0036ac6161',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 2,
          id: 2299160,
          known_for_department: 'Camera',
          name: 'Scott Whitbread',
          original_name: 'Scott Whitbread',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886ee9021cee0039bcaa24',
          department: 'Camera',
          job: 'Second Assistant "B" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2327362,
          known_for_department: 'Art',
          name: 'Joe Pfaltzgraf',
          original_name: 'Joe Pfaltzgraf',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5f89b7301443f40036c64815',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2395850,
          known_for_department: 'Camera',
          name: 'Eric Wheeler',
          original_name: 'Eric Wheeler',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886f288258fc0035a8bfca',
          department: 'Camera',
          job: 'Second Assistant "C" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2542831,
          known_for_department: 'Camera',
          name: 'Maninder K. Saini',
          original_name: 'Maninder K. Saini',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8867f4e33f830038fd1f90',
          department: 'Camera',
          job: 'Digital Imaging Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2625816,
          known_for_department: 'Production',
          name: 'David Becker',
          original_name: 'David Becker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8b0cd8e9da690038eb920f',
          department: 'Production',
          job: 'Production Secretary',
        },
        {
          adult: false,
          gender: 2,
          id: 2703853,
          known_for_department: 'Art',
          name: 'Kristopher Gifford',
          original_name: 'Kristopher Gifford',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b2318d2f8d0037948dae',
          department: 'Art',
          job: 'Art Department Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2729270,
          known_for_department: 'Visual Effects',
          name: 'Paul Ghezzo',
          original_name: 'Paul Ghezzo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bc28f6fd180035b553d6',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2742103,
          known_for_department: 'Art',
          name: 'Benton E. Tedlie',
          original_name: 'Benton E. Tedlie',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b77e3af929003a4e0ad7',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2815088,
          known_for_department: 'Crew',
          name: 'Derick Broderman',
          original_name: 'Derick Broderman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b5c8f6fd180035b538c9',
          department: 'Crew',
          job: 'Propmaker',
        },
        {
          adult: false,
          gender: 0,
          id: 2815093,
          known_for_department: 'Art',
          name: 'Gordon Thomas',
          original_name: 'Gordon Thomas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b7cce9da69003ae62984',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2816112,
          known_for_department: 'Camera',
          name: 'Bobby Davison',
          original_name: 'Bobby Davison',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8865c0238513003635dcab',
          department: 'Camera',
          job: 'Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2816115,
          known_for_department: 'Lighting',
          name: 'Jason Lamport',
          original_name: 'Jason Lamport',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886936d4b9d90038294def',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 2816116,
          known_for_department: 'Lighting',
          name: 'Jacob Borck',
          original_name: 'Jacob Borck',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886977021cee0039bc8c3b',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 2816118,
          known_for_department: 'Lighting',
          name: 'Ralph Walters',
          original_name: 'Ralph Walters',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8869cbe33f830038fd2139',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 2816122,
          known_for_department: 'Camera',
          name: 'Jason Hibarger',
          original_name: 'Jason Hibarger',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886c03e9da690037e448d0',
          department: 'Camera',
          job: 'Libra Head Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2816123,
          known_for_department: 'Lighting',
          name: 'Bridget Da Gama',
          original_name: 'Bridget Da Gama',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886cc1a275020038cb98b3',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2816125,
          known_for_department: 'Lighting',
          name: 'Jonathan Plaeger',
          original_name: 'Jonathan Plaeger',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886d1df3b49a0033b9c50e',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2816128,
          known_for_department: 'Lighting',
          name: 'Daniel Strong',
          original_name: 'Daniel Strong',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886d3c23851300343654bf',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2816130,
          known_for_department: 'Lighting',
          name: 'Curt Burlin',
          original_name: 'Curt Burlin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886d568258fc0036ac6b1e',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2816131,
          known_for_department: 'Lighting',
          name: 'James J. Hughes',
          original_name: 'James J. Hughes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886dbb8258fc0036ac6c00',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2816132,
          known_for_department: 'Lighting',
          name: 'James W. Larkin III',
          original_name: 'James W. Larkin III',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886dfca275020038cb9b77',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2816133,
          known_for_department: 'Crew',
          name: 'Art Villasenor',
          original_name: 'Art Villasenor',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f886fd5e9da690037e45915',
          department: 'Crew',
          job: 'Techno Crane Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 2816135,
          known_for_department: 'Costume & Make-Up',
          name: 'Max Juette',
          original_name: 'Max Juette',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8870bfa275020038cba416',
          department: 'Costume & Make-Up',
          job: 'Costume Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2816136,
          known_for_department: 'Costume & Make-Up',
          name: 'Patrick Byrnes',
          original_name: 'Patrick Byrnes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8870d8a275020039cf81a1',
          department: 'Costume & Make-Up',
          job: 'Costume Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2816137,
          known_for_department: 'Costume & Make-Up',
          name: 'Robyn Zucker',
          original_name: 'Robyn Zucker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f887132e33f83003afdfc0d',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2817264,
          known_for_department: 'Art',
          name: 'Sean Frohling',
          original_name: 'Sean Frohling',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b21b39549a0035b570e9',
          department: 'Art',
          job: 'Art Department Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2817266,
          known_for_department: 'Art',
          name: 'Austin Lawrence',
          original_name: 'Austin Lawrence',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b2468d2f8d0036957203',
          department: 'Art',
          job: 'Art Department Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2817268,
          known_for_department: 'Art',
          name: 'Christopher Poveromo',
          original_name: 'Christopher Poveromo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b25b3af92900384d646b',
          department: 'Art',
          job: 'Art Department Assistant',
        },
        {
          adult: false,
          gender: 2,
          id: 2817270,
          known_for_department: 'Art',
          name: 'Michael Shapiro',
          original_name: 'Michael Shapiro',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b2833af92900394f2c4e',
          department: 'Art',
          job: 'Art Department Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2817284,
          known_for_department: 'Art',
          name: 'Josh Nizzi',
          original_name: 'Josh Nizzi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b3f7e9da690038e7d28f',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 0,
          id: 2817286,
          known_for_department: 'Art',
          name: 'Roger Johnson',
          original_name: 'Roger Johnson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b514e9da690039e6c17b',
          department: 'Art',
          job: 'Graphic Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2817288,
          known_for_department: 'Crew',
          name: 'Edward Medeiros Jr.',
          original_name: 'Edward Medeiros Jr.',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b5de1443f40037c72277',
          department: 'Crew',
          job: 'Propmaker',
        },
        {
          adult: false,
          gender: 0,
          id: 2817292,
          known_for_department: 'Art',
          name: 'K. Wing Chin',
          original_name: 'K. Wing Chin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b69f8d2f8d0037949c1b',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2817294,
          known_for_department: 'Art',
          name: 'Ron Cookson',
          original_name: 'Ron Cookson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b6c7f6fd180036b2c937',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2817296,
          known_for_department: 'Art',
          name: 'Daniel Hamilton',
          original_name: 'Daniel Hamilton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b7103af92900375084be',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2817299,
          known_for_department: 'Art',
          name: 'Jana Treadwell',
          original_name: 'Jana Treadwell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b7dba135330035132b61',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2817300,
          known_for_department: 'Art',
          name: 'Joe Viau',
          original_name: 'Joe Viau',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b7eb2667780037e1dc1c',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2817301,
          known_for_department: 'Art',
          name: 'Karl Weaver',
          original_name: 'Karl Weaver',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b7fc23851300353cb5aa',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2817303,
          known_for_department: 'Art',
          name: 'Daniel A. Maes',
          original_name: 'Daniel A. Maes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b83639549a0035b57a45',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2817307,
          known_for_department: 'Art',
          name: 'Michael C. Magno',
          original_name: 'Michael C. Magno',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b891e9da690038e7f0d7',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2817308,
          known_for_department: 'Art',
          name: 'Rick Reeder',
          original_name: 'Rick Reeder',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89b9112667780037e1e2b0',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2817319,
          known_for_department: 'Art',
          name: 'Hugh England',
          original_name: 'Hugh England',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89ba3f1443f40037c72f71',
          department: 'Art',
          job: 'Swing',
        },
        {
          adult: false,
          gender: 0,
          id: 2817321,
          known_for_department: 'Art',
          name: 'Tom Penny',
          original_name: 'Tom Penny',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89ba531443f40039c88ae0',
          department: 'Art',
          job: 'Swing',
        },
        {
          adult: false,
          gender: 0,
          id: 2817325,
          known_for_department: 'Art',
          name: 'Mike Peters',
          original_name: 'Mike Peters',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89baaf3af9290037509947',
          department: 'Art',
          job: 'Swing',
        },
        {
          adult: false,
          gender: 0,
          id: 2817330,
          known_for_department: 'Crew',
          name: 'Willi Geiger',
          original_name: 'Willi Geiger',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bbf42667780037e1ec4f',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2817343,
          known_for_department: 'Lighting',
          name: 'Ross Wallis',
          original_name: 'Ross Wallis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bdca1443f40037c73d25',
          department: 'Lighting',
          job: 'Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2817346,
          known_for_department: 'Visual Effects',
          name: 'Kalene Dunsmoor',
          original_name: 'Kalene Dunsmoor',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89be0e2667780037e1f41b',
          department: 'Visual Effects',
          job: 'Matte Painter',
        },
        {
          adult: false,
          gender: 0,
          id: 2817349,
          known_for_department: 'Visual Effects',
          name: 'Barry Howell',
          original_name: 'Barry Howell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89be511443f40036c65e73',
          department: 'Visual Effects',
          job: 'Pre-Visualization Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2817361,
          known_for_department: 'Visual Effects',
          name: 'Adam J. Cohn',
          original_name: 'Adam J. Cohn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bf372667780038e01a41',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2817363,
          known_for_department: 'Visual Effects',
          name: 'Zachary Smith',
          original_name: 'Zachary Smith',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bf7ee9da690039e6dbfb',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2817365,
          known_for_department: 'Visual Effects',
          name: 'Wyatt Hannon',
          original_name: 'Wyatt Hannon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89bfa01443f40036c660a9',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2817378,
          known_for_department: 'Sound',
          name: 'Daniel R. Garab',
          original_name: 'Daniel R. Garab',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89c33fd4b9d900382d4464',
          department: 'Sound',
          job: 'Boom Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 2817385,
          known_for_department: 'Camera',
          name: 'Brandon Carroll',
          original_name: 'Brandon Carroll',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89c4b28d2f8d003794ca0e',
          department: 'Camera',
          job: 'Epk Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2817390,
          known_for_department: 'Crew',
          name: 'Scot A. McKay',
          original_name: 'Scot A. McKay',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f89c4fe3af92900384d81cb',
          department: 'Crew',
          job: 'Armorer',
        },
        {
          adult: false,
          gender: 0,
          id: 2818623,
          known_for_department: 'Production',
          name: 'Evan Johnson',
          original_name: 'Evan Johnson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8b0cbb57176f003583354b',
          department: 'Production',
          job: 'Production Secretary',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'John Chard',
          author_details: {
            name: '',
            username: 'John Chard',
            avatar_path: '/utEXl2EDiXBK6f41wCLsvprvMg4.jpg',
            rating: 5.0,
          },
          content:
            "It rhymes with ship!\r\n\r\nActually that's a little unfair, for those after a two hour plus movie of noise and robotic like destruction, then this has a modicum of popcorn frivolity about it. But it's all so vacuous, any semblance of a story is given over for a chance to show some Transformers effects work, the human characters constantly an afterthought as they play second fiddle to another CGI action scene. It feels like an extended toy advertisement, the Diễn viên is sub-standard and the editing - appropriately enough for the film's setting - is akin to a bout of sea sickness. The action sequences all carry a familiarity about them, while like their human counterparts, the alien foe here are devoid of any rhyme or reason as to their motive and being.\r\n\r\nCash infused metallic porn at its most tiresome. 5/10",
          created_at: '2015-12-05T06:20:43.829Z',
          id: '5662823bc3a3682be9002a22',
          updated_at: '2021-06-23T15:57:41.619Z',
          url: 'https://www.themoviedb.org/review/5662823bc3a3682be9002a22',
        },
        {
          author: 'Per Gunnar Jonsson',
          author_details: {
            name: 'Per Gunnar Jonsson',
            username: 'Dark Jedi',
            avatar_path:
              '/https://secure.gravatar.com/avatar/cbabaea0fa98692d00130498d7ac5d7c.jpg',
            rating: 6.0,
          },
          content:
            'I have to say that I enjoyed this movie. The visual effects are great, the alien designs are interesting and there’s lots of explosive hardware flying around. Although not exactly a very logical/practical design I did like the cool rolling “balls” of destruction that the aliens where using. Seeing the “Mighty Mo” in action was of course an additional plus. It’s really a shame that these magnificent floating fortresses have become obsolete.\n\nHowever, the enjoyment brought by this movie was almost purely one of visual effects. Well, I generally like Liam Neeson as well but not much else in this movie was of any higher standards. The story is the usual Hollywood stuff. The holes in the logic are big enough to drive, well, a battleship through. For instance, the aliens can come from far away, navigate between the stars, but they cannot avoid accidentally colliding with a satellite in earth orbit? Come on.\n \nIt unfortunately becomes even worse when they decide to fire up the Missouri. I could live with the fact that there’s no way that a handful of veterans could have gotten that ship into running state. I could even live with the fact that the film ignores that it would take days to fire the ship up from cold storage even under optimal circumstances and with a full crew. But what really got me pissed off is when they drop the anchor to make a “hand break turn” and turn the ship around on a dime actually sliding the ship on the water. What the fuck !!!\n\nHow utterly ignorant, dumb, stupid can you become as a Hollywood producer/scriptwriter/director? I’m actually being kind to these morons now because if the people that wrote that scene is not total idiots then they are assuming that the audience are such idiots which would be even worse.\n\nThat part alone dropped it two stars for me. I still gave it 6 out of 10 because I enjoyed the visual effects and the sea battles so much.',
          created_at: '2017-12-19T21:04:02.902Z',
          id: '5a397ec20e0a264cd02060ec',
          updated_at: '2021-06-23T15:58:03.487Z',
          url: 'https://www.themoviedb.org/review/5a397ec20e0a264cd02060ec',
        },
      ],
      total_pages: 1,
      total_results: 2,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/556uLAlg7GhBv0c0dvJtexKABEE.jpg',
    belongs_to_collection: null,
    budget: 25000000,
    genres: [
      { id: 14, name: 'Phim Giả Tượng' },
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 35, name: 'Phim Hài' },
      { id: 10751, name: 'Phim Gia Đình' },
    ],
    homepage:
      'http://disney.go.com/disneypictures/the-odd-life-of-timothy-green/',
    id: 71864,
    imdb_id: 'tt1462769',
    original_language: 'en',
    original_title: 'The Odd Life of Timothy Green',
    overview:
      'Chuyện phim kể về một cặp vợ chồng hạnh phúc, Cindy và Jim, nhưng lại hiếm muộn. Họ vẫn mong ước hàng đêm mình sẽ trở thành cha, mẹ thực sự nhưng điều đó dường như quá xa vời. Một ngày nọ, Cindy và Jim viết tất cả ý tưởng mà họ mường tượng về đứa con tương lai rồi cho vào một chiếc hộp và chôn ở vườn sau nhà. Trong đêm mưa bão, cậu bé Timothy xuất hiện như một món quà bất ngờ dành cho đôi vợ chồng hiếm muộn. Tuy nhiên, ở đôi chân của cậu bé lại mọc lên những chiếc lá xanh tươi khác thường.',
    popularity: 15.553,
    poster_path:
      'https://image.tmdb.org/t/p/w342/wKOLe7Bv9Txtm47WPmwN1iSHKHY.jpg',
    production_companies: [
      {
        id: 2,
        logo_path: '/wdrCwmRnLFJhEoH8GSfymY85KHT.png',
        name: 'Walt Disney Pictures',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2012-08-15',
    revenue: 56012642,
    runtime: 105,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
      { english_name: 'Spanish', iso_639_1: 'es', name: 'Español' },
    ],
    status: 'Đã phát hành',
    tagline: "He's a force of nature.",
    title: 'Mảnh Đời Kỳ Lạ',
    video: false,
    vote_average: 7.0,
    vote_count: 972,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Odd Life of Timothy Green Trailer',
          key: 'mMSkbH0LuTc',
          published_at: '2011-08-09T17:17:27.000Z',
          site: 'YouTube',
          size: 720,
          type: 'Trailer',
          official: true,
          id: '533ec6c2c3a3685448006c60',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 9278,
          known_for_department: 'Diễn viên',
          name: 'Jennifer Garner',
          original_name: 'Jennifer Garner',
          popularity: 6.946,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ftymEXqdTnXfaI6dGd9qrJoFOSE.jpg',
          cast_id: 3,
          character: 'Cindy Green',
          credit_id: '52fe484cc3a368484e0f1ddf',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 33192,
          known_for_department: 'Diễn viên',
          name: 'Joel Edgerton',
          original_name: 'Joel Edgerton',
          popularity: 11.633,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uFLxGHmPaNoTD6EMpMmu5bfP9Fr.jpg',
          cast_id: 4,
          character: 'Jim Green',
          credit_id: '52fe484cc3a368484e0f1de3',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 17402,
          known_for_department: 'Diễn viên',
          name: 'Ron Livingston',
          original_name: 'Ron Livingston',
          popularity: 4.703,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pr5CjWnkaf5WKTIYh8wtNufjmyb.jpg',
          cast_id: 5,
          character: 'Franklin Crudstaff',
          credit_id: '52fe484cc3a368484e0f1de7',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 14892,
          known_for_department: 'Diễn viên',
          name: 'Rosemarie DeWitt',
          original_name: 'Rosemarie DeWitt',
          popularity: 6.029,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lsjURTbXasRXYGtujwAbEj3bdZk.jpg',
          cast_id: 6,
          character: 'Brenda Best',
          credit_id: '52fe484cc3a368484e0f1deb',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 1107800,
          known_for_department: 'Diễn viên',
          name: 'CJ Adams',
          original_name: 'CJ Adams',
          popularity: 2.638,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fk1zZZwkEgoqWSBQMaCTI7ECwMj.jpg',
          cast_id: 7,
          character: 'Timothy Green',
          credit_id: '52fe484cc3a368484e0f1def',
          order: 4,
        },
        {
          adult: false,
          gender: 0,
          id: 1108054,
          known_for_department: 'Diễn viên',
          name: 'Patrick Brouder',
          original_name: 'Patrick Brouder',
          popularity: 0.6,
          profile_path: null,
          cast_id: 8,
          character: 'Dash Best',
          credit_id: '52fe484cc3a368484e0f1df3',
          order: 5,
        },
        {
          adult: false,
          gender: 0,
          id: 1108057,
          known_for_department: 'Diễn viên',
          name: 'Chan Creswell',
          original_name: 'Chan Creswell',
          popularity: 0.6,
          profile_path: null,
          cast_id: 10,
          character: 'Billy CrudStaff',
          credit_id: '52fe484cc3a368484e0f1dfb',
          order: 6,
        },
        {
          adult: false,
          gender: 0,
          id: 1108059,
          known_for_department: 'Diễn viên',
          name: 'William J. Harrison',
          original_name: 'William J. Harrison',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/a8ru5Rg74AO3utRRtHtLRPaCOdg.jpg',
          cast_id: 11,
          character: 'Bobby Crudstaff',
          credit_id: '52fe484cc3a368484e0f1dff',
          order: 7,
        },
        {
          adult: false,
          gender: 1,
          id: 1121786,
          known_for_department: 'Diễn viên',
          name: 'Odeya Rush',
          original_name: 'Odeya Rush',
          popularity: 7.178,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1eDPlshKwSIs3tvvkPItLr0LUrZ.jpg',
          cast_id: 12,
          character: 'Joni Jerome',
          credit_id: '52fe484cc3a368484e0f1e03',
          order: 8,
        },
        {
          adult: false,
          gender: 1,
          id: 21041,
          known_for_department: 'Diễn viên',
          name: 'Shohreh Aghdashloo',
          original_name: 'Shohreh Aghdashloo',
          popularity: 6.646,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vuE7zU05kmnalORwIzVTi8uIMRA.jpg',
          cast_id: 13,
          character: 'Evette Onat',
          credit_id: '52fe484cc3a368484e0f1e07',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 52,
          known_for_department: 'Diễn viên',
          name: 'David Morse',
          original_name: 'David Morse',
          popularity: 5.405,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lu4eZp6rmqrdvNGsDxQiTiJugWy.jpg',
          cast_id: 14,
          character: 'James Green, Sr.',
          credit_id: '52fe484cc3a368484e0f1e0b',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 588,
          known_for_department: 'Diễn viên',
          name: 'M. Emmet Walsh',
          original_name: 'M. Emmet Walsh',
          popularity: 3.624,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5vPeWEixelZfQsDAr9tbm26JPtW.jpg',
          cast_id: 15,
          character: 'Uncle Bub',
          credit_id: '52fe484cc3a368484e0f1e0f',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 2207,
          known_for_department: 'Diễn viên',
          name: 'Lois Smith',
          original_name: 'Lois Smith',
          popularity: 5.333,
          profile_path:
            'https://image.tmdb.org/t/p/w185/unvPSZshdNoj7c5wl6D30gPwKtS.jpg',
          cast_id: 16,
          character: 'Aunt Mel',
          credit_id: '52fe484cc3a368484e0f1e13',
          order: 12,
        },
        {
          adult: false,
          gender: 1,
          id: 1902,
          known_for_department: 'Diễn viên',
          name: 'Dianne Wiest',
          original_name: 'Dianne Wiest',
          popularity: 5.921,
          profile_path:
            'https://image.tmdb.org/t/p/w185/axqtFLgJNNz0N9i443USHCOvrmY.jpg',
          cast_id: 17,
          character: 'Ms. Bernice Crudstaff',
          credit_id: '52fe484cc3a368484e0f1e17',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 8986,
          known_for_department: 'Diễn viên',
          name: 'James Rebhorn',
          original_name: 'James Rebhorn',
          popularity: 4.868,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jRdR3q28gTPQU6eWRgiIqzGuMKU.jpg',
          cast_id: 19,
          character: 'Joseph Crudstaff',
          credit_id: '52fe484cc3a368484e0f1e1f',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 4238,
          known_for_department: 'Diễn viên',
          name: 'Lonnie Rashid Lynn Jr.',
          original_name: 'Lonnie Rashid Lynn Jr.',
          popularity: 2.204,
          profile_path:
            'https://image.tmdb.org/t/p/w185/c45lu37VIcmBMcoBRaLdouqgHcC.jpg',
          cast_id: 20,
          character: 'Coach Cal',
          credit_id: '52fe484cc3a368484e0f1e23',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 1179651,
          known_for_department: 'Diễn viên',
          name: 'Lin-Manuel Miranda',
          original_name: 'Lin-Manuel Miranda',
          popularity: 2.607,
          profile_path:
            'https://image.tmdb.org/t/p/w185/r0wFwPa041pZ1QM66yJWuQXCkqx.jpg',
          cast_id: 23,
          character: 'Reggie',
          credit_id: '5847205b92514119b9001161',
          order: 16,
        },
        {
          adult: false,
          gender: 0,
          id: 1544037,
          known_for_department: 'Diễn viên',
          name: 'Shimei Bailey',
          original_name: 'Shimei Bailey',
          popularity: 0.6,
          profile_path: null,
          cast_id: 24,
          character: 'Little Boy in Elevator',
          credit_id: '585e168992514115c00085b2',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 83874,
          known_for_department: 'Diễn viên',
          name: 'Michael Arden',
          original_name: 'Michael Arden',
          popularity: 1.016,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tdrCDSuIBWNazW7wY8I2Cej0ChR.jpg',
          cast_id: 25,
          character: 'Doug Wert',
          credit_id: '58658c55c3a36852c9021df8',
          order: 18,
        },
        {
          adult: false,
          gender: 1,
          id: 51456,
          known_for_department: 'Diễn viên',
          name: 'Rhoda Griffis',
          original_name: 'Rhoda Griffis',
          popularity: 3.833,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jO50PgihnZ0gAlJDulpzxMoLgRB.jpg',
          cast_id: 26,
          character: 'Doctor Lesley Hunt',
          credit_id: '58658c96c3a3680ab601df48',
          order: 19,
        },
        {
          adult: false,
          gender: 0,
          id: 935721,
          known_for_department: 'Diễn viên',
          name: 'Karan Kendrick',
          original_name: 'Karan Kendrick',
          popularity: 0.963,
          profile_path: null,
          cast_id: 27,
          character: "Mother at Doctor's Office",
          credit_id: '58658cc3c3a36852c9021e67',
          order: 20,
        },
        {
          adult: false,
          gender: 2,
          id: 1034526,
          known_for_department: 'Diễn viên',
          name: 'Kendall Ryan Sanders',
          original_name: 'Kendall Ryan Sanders',
          popularity: 2.264,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fVwccVvKfPzp6qMoT52EYFjY7yZ.jpg',
          cast_id: 29,
          character: 'Rod Best',
          credit_id: '58e289d4c3a3684aa4001950',
          order: 21,
        },
        {
          adult: false,
          gender: 0,
          id: 1953593,
          known_for_department: 'Diễn viên',
          name: 'Judy Langford',
          original_name: 'Judy Langford',
          popularity: 0.6,
          profile_path: null,
          cast_id: 37,
          character: "Ms. Crudstaff's Assistant",
          credit_id: '604b0699d8e225005a7d4732',
          order: 22,
        },
        {
          adult: false,
          gender: 2,
          id: 143261,
          known_for_department: 'Diễn viên',
          name: 'Michael Beasley',
          original_name: 'Michael Beasley',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/w1sqMMzBG4M5K9b4Wrhejh0LS5a.jpg',
          cast_id: 38,
          character: 'Cop',
          credit_id: '604b06d254508d00775b0e50',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 1215021,
          known_for_department: 'Diễn viên',
          name: 'Cullen Moss',
          original_name: 'Cullen Moss',
          popularity: 0.759,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zjVvER4Bg4mz38u2JQfLgypYrSP.jpg',
          cast_id: 39,
          character: 'Cop',
          credit_id: '604b06f21c09fb0077b07f69',
          order: 24,
        },
        {
          adult: false,
          gender: 0,
          id: 1194944,
          known_for_department: 'Diễn viên',
          name: 'Gene Jones',
          original_name: 'Gene Jones',
          popularity: 1.96,
          profile_path: null,
          cast_id: 40,
          character: 'Neighbor',
          credit_id: '604b0718982f74002e9ff877',
          order: 25,
        },
        {
          adult: false,
          gender: 2,
          id: 58733,
          known_for_department: 'Diễn viên',
          name: 'Jason Davis',
          original_name: 'Jason Davis',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/thSH5TatER5b1WbgFpGt5YDdOu.jpg',
          cast_id: 41,
          character: 'Bart Best',
          credit_id: '604b076cfa40460045048578',
          order: 26,
        },
        {
          adult: false,
          gender: 0,
          id: 2707620,
          known_for_department: 'Diễn viên',
          name: 'Lucy Gebhardt',
          original_name: 'Lucy Gebhardt',
          popularity: 0.6,
          profile_path: null,
          cast_id: 42,
          character: 'Bethany Best',
          credit_id: '604b07b55f622b00598c8d0c',
          order: 27,
        },
        {
          adult: false,
          gender: 1,
          id: 142374,
          known_for_department: 'Diễn viên',
          name: 'Sharon Conley',
          original_name: 'Sharon Conley',
          popularity: 2.899,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aWRhym8s65teBaxsJKO5KO0JWp8.jpg',
          cast_id: 43,
          character: 'Principal Morrison',
          credit_id: '604b07d5fa4046002ecae409',
          order: 28,
        },
        {
          adult: false,
          gender: 1,
          id: 2763556,
          known_for_department: 'Diễn viên',
          name: 'Dorothy Vollmer',
          original_name: 'Dorothy Vollmer',
          popularity: 0.6,
          profile_path: null,
          cast_id: 44,
          character: 'Trixie Crudstaff',
          credit_id: '604b07fcc4ad590044ecd3de',
          order: 29,
        },
        {
          adult: false,
          gender: 2,
          id: 83602,
          known_for_department: 'Diễn viên',
          name: 'Dwayne Boyd',
          original_name: 'Dwayne Boyd',
          popularity: 1.383,
          profile_path: null,
          cast_id: 45,
          character: 'Ref',
          credit_id: '604b08a3982f740044bb35ac',
          order: 30,
        },
        {
          adult: false,
          gender: 0,
          id: 931104,
          known_for_department: 'Diễn viên',
          name: 'Mattie Liptak',
          original_name: 'Mattie Liptak',
          popularity: 0.6,
          profile_path: null,
          cast_id: 46,
          character: '#8',
          credit_id: '604b08c8ec4552002abe9191',
          order: 31,
        },
        {
          adult: false,
          gender: 0,
          id: 2671709,
          known_for_department: 'Diễn viên',
          name: 'Jay Freer',
          original_name: 'Jay Freer',
          popularity: 0.6,
          profile_path: null,
          cast_id: 47,
          character: 'Coach Bob Francesconi',
          credit_id: '604b08f4c4ad59002a4fd7c4',
          order: 32,
        },
        {
          adult: false,
          gender: 2,
          id: 86938,
          known_for_department: 'Diễn viên',
          name: 'Tim Ware',
          original_name: 'Tim Ware',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sZope09mLYOPaRT32DYIPxNH6Q1.jpg',
          cast_id: 48,
          character: 'Mayor Handelman',
          credit_id: '604b09119e458600792ff1fb',
          order: 33,
        },
        {
          adult: false,
          gender: 1,
          id: 1237353,
          known_for_department: 'Diễn viên',
          name: 'Susan Bruce',
          original_name: 'Susan Bruce',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2EVwWnUufP87GSQk3CFHXM6ZD7J.jpg',
          cast_id: 49,
          character: 'Molly Frohn',
          credit_id: '604b0955ea37e0006e84ee6f',
          order: 34,
        },
        {
          adult: false,
          gender: 1,
          id: 1541155,
          known_for_department: 'Diễn viên',
          name: 'Tara Lee',
          original_name: 'Tara Lee',
          popularity: 1.174,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wbT8mAO2AKwf5DeXdoTQO1IRvZg.jpg',
          cast_id: 28,
          character: 'Nurse',
          credit_id: '58658d049251412b8d02255c',
          order: 36,
        },
        {
          adult: false,
          gender: 0,
          id: 1785996,
          known_for_department: 'Diễn viên',
          name: 'Joe Crosson',
          original_name: 'Joe Crosson',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/npA2WAe88QClLGtw2LtMWsIL8yA.jpg',
          cast_id: 51,
          character: 'Factory Worker',
          credit_id: '604b0a1b982f74006da0d6ba',
          order: 37,
        },
        {
          adult: false,
          gender: 2,
          id: 40275,
          known_for_department: 'Diễn viên',
          name: 'Tim Guinee',
          original_name: 'Tim Guinee',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rS2K7cJx6Vm2buE0HhIUp9tuC1g.jpg',
          cast_id: 36,
          character: 'Marty Rader (voice)',
          credit_id: '5fad70c04b6d9d003e23fb6e',
          order: 38,
        },
        {
          adult: false,
          gender: 0,
          id: 2907894,
          known_for_department: 'Diễn viên',
          name: "Shaun O'Banion",
          original_name: "Shaun O'Banion",
          popularity: 0.6,
          profile_path: null,
          cast_id: 52,
          character: 'Alan Rust (voice)',
          credit_id: '604b0a575f622b002afd3033',
          order: 39,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 2483,
          known_for_department: 'Camera',
          name: 'John Toll',
          original_name: 'John Toll',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cfL9A6tC7L5Ps5fq1o3WpVKGMb1.jpg',
          credit_id: '5c93bcc49251412b5c78be6e',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 3290,
          known_for_department: 'Biên kịch',
          name: 'Peter Hedges',
          original_name: 'Peter Hedges',
          popularity: 0.84,
          profile_path: null,
          credit_id: '52fe484cc3a368484e0f1ddb',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 3290,
          known_for_department: 'Biên kịch',
          name: 'Peter Hedges',
          original_name: 'Peter Hedges',
          popularity: 0.84,
          profile_path: null,
          credit_id: '52fe484cc3a368484e0f1dd5',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 5327,
          known_for_department: 'Editing',
          name: 'Andrew Mondshein',
          original_name: 'Andrew Mondshein',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5c93bd2d0e0a261053e91962',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 17767,
          known_for_department: 'Sound',
          name: 'Geoff Zanelli',
          original_name: 'Geoff Zanelli',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lACUhRiyPMhNwz2S58ZDRR0eeQH.jpg',
          credit_id: '5c93bd3f0e0a261048e8fc95',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 40375,
          known_for_department: 'Production',
          name: 'Jim Whitaker',
          original_name: 'Jim Whitaker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c93bce99251412b5178c5e6',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 68016,
          known_for_department: 'Sound',
          name: 'Kevin Kaska',
          original_name: 'Kevin Kaska',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/azlSu8Sz9QGeK3xgQS9p3ZvR9q9.jpg',
          credit_id: '579d013cc3a36855d2009331',
          department: 'Sound',
          job: 'Orchestrator',
        },
        {
          adult: false,
          gender: 2,
          id: 86906,
          known_for_department: 'Diễn viên',
          name: 'Ahmet Zappa',
          original_name: 'Ahmet Zappa',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lrQVoDzAVaHKBhUhbS7dOdPwIyQ.jpg',
          credit_id: '5c93bcf8c3a3685899e41076',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1237747,
          known_for_department: 'Production',
          name: 'Scott Sanders',
          original_name: 'Scott Sanders',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5bdf7830c3a3682b34035a4f',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1463178,
          known_for_department: 'Directing',
          name: 'Daniel Erickson',
          original_name: 'Daniel Erickson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5548d0eac3a3687877002346',
          department: 'Camera',
          job: 'Camera Technician',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'r96sk',
          author_details: {
            name: '',
            username: 'r96sk',
            avatar_path:
              '/https://secure.gravatar.com/avatar/96c2e0e4ac98450f9e8e3c0a0a40aad8.jpg',
            rating: 8.0,
          },
          content:
            "Lovely.\r\n\r\n<em>'The Odd Life of Timothy Green'</em> is a well intentioned - if, indeed, odd - 2012 film from Disney. CJ Adams gives a respectable and sweet performance as Timothy, while Jennifer Garner and Joel Edgerton bring the heart in their roles as Cindy and James. The other characters are absolutely terrible, I will say that - especially Rosemarie DeWitt's Brenda.\r\n\r\nWhat it severely lacks in a supporting cast, it makes up for with its hearty narrative and nicely paced story. I don't think it's perfect or anything close, but it brings the feels that it intended to bring. Definitely worth a watch.",
          created_at: '2020-11-12T04:35:05.614Z',
          id: '5facbb79d14443003dd1f5f1',
          updated_at: '2021-06-23T15:58:47.397Z',
          url: 'https://www.themoviedb.org/review/5facbb79d14443003dd1f5f1',
        },
      ],
      total_pages: 1,
      total_results: 1,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/zUpfkp0xz3mXvFjdn7h7l7nvxQG.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 28, name: 'Phim Hành Động' },
      { id: 53, name: 'Phim Gây Cấn' },
    ],
    homepage: '',
    id: 18060,
    imdb_id: 'tt1330525',
    original_language: 'cn',
    original_title: '証人',
    overview:
      'Một cảnh sát dính vào một tai nạn làm thay đổi cuộc đời. Anh muốn gặp lại hai mẹ con nhà nọ. Các diễn viên chính: Tạ Đình Phong và Trương Gia Huy.',
    popularity: 3.9,
    poster_path:
      'https://image.tmdb.org/t/p/w342/hlaIVAyQc2Wo5AIpprYIkpbirAT.jpg',
    production_companies: [
      {
        id: 5686,
        logo_path: null,
        name: 'Sil-Metropole Organisation',
        origin_country: '',
      },
      {
        id: 2726,
        logo_path: null,
        name: 'Emperor Motion Pictures',
        origin_country: '',
      },
    ],
    production_countries: [{ iso_3166_1: 'HK', name: 'Hồng Kông' }],
    release_date: '2008-11-27',
    revenue: 0,
    runtime: 109,
    spoken_languages: [
      { english_name: 'Cantonese', iso_639_1: 'cn', name: '广州话 / 廣州話' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Nhân Chứng',
    video: false,
    vote_average: 6.8,
    vote_count: 51,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Beast Stalker | 証人 | Trailer | HD',
          key: 'CayVm-cgmfs',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2016-07-25T10:53:19.000Z',
          id: '60cc2e6f76142100570134b7',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 70106,
          known_for_department: 'Diễn viên',
          name: 'Nicholas Tse',
          original_name: 'Nicholas Tse',
          popularity: 4.235,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gNn875jcFFxQD9IX7LhpZeAPqtk.jpg',
          cast_id: 1,
          character: 'Ann Gao',
          credit_id: '52fe475d9251416c75096afb',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 72731,
          known_for_department: 'Diễn viên',
          name: 'Nick Cheung',
          original_name: 'Nick Cheung',
          popularity: 4.623,
          profile_path:
            'https://image.tmdb.org/t/p/w185/drxKdDHtaqUQycTwK2z2QHO3gMm.jpg',
          cast_id: 4,
          character: 'Hung King',
          credit_id: '52fe475d9251416c75096b09',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 41894,
          known_for_department: 'Diễn viên',
          name: 'Zhang Jingchu',
          original_name: 'Zhang Jingchu',
          popularity: 5.341,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hYcyxwK9mjV9tLc1j9QSnjjJNYn.jpg',
          cast_id: 3,
          character: 'Ann Gao',
          credit_id: '52fe475d9251416c75096b05',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 118726,
          known_for_department: 'Diễn viên',
          name: 'Miao Pu',
          original_name: 'Miao Pu',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sdYRCxw36vyUsEbIeSldwtqrvR1.jpg',
          cast_id: 5,
          character: 'Li',
          credit_id: '52fe475d9251416c75096b0d',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 140477,
          known_for_department: 'Diễn viên',
          name: 'Sherman Chung',
          original_name: 'Sherman Chung',
          popularity: 0.6,
          profile_path: null,
          cast_id: 7,
          character: 'Christy',
          credit_id: '52fe475d9251416c75096b15',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 1190190,
          known_for_department: 'Diễn viên',
          name: 'Zhang He',
          original_name: 'Zhang He',
          popularity: 0.6,
          profile_path: null,
          cast_id: 8,
          character: 'Thomas',
          credit_id: '52fe475d9251416c75096b19',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 140481,
          known_for_department: 'Diễn viên',
          name: 'Lau Kong',
          original_name: 'Lau Kong',
          popularity: 1.176,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bV3lewuW7snJ5lHO1nL6gqOEUM1.jpg',
          cast_id: 9,
          character: 'Chuen',
          credit_id: '52fe475d9251416c75096b1d',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 140479,
          known_for_department: 'Diễn viên',
          name: 'Derek Kwok',
          original_name: 'Derek Kwok',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cFypay2ZkDNThKVgpighp9msAfk.jpg',
          cast_id: 10,
          character: 'Michael',
          credit_id: '52fe475d9251416c75096b21',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 1002925,
          known_for_department: 'Diễn viên',
          name: 'Joe Cheung',
          original_name: 'Joe Cheung',
          popularity: 0.611,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4RJ9r6FP6kQUmEUWZylPByh7TtG.jpg',
          cast_id: 11,
          character: 'Judge Lee',
          credit_id: '52fe475d9251416c75096b25',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 140478,
          known_for_department: 'Diễn viên',
          name: 'Philip Keung',
          original_name: 'Philip Keung',
          popularity: 1.118,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tDFQK5iHlNrLyrORJdJiDcf0zMg.jpg',
          cast_id: 12,
          character: 'Cheung Yat-Tung',
          credit_id: '52fe475d9251416c75096b29',
          order: 9,
        },
        {
          adult: false,
          gender: 0,
          id: 1190193,
          known_for_department: 'Diễn viên',
          name: 'Wong Suet-Yin',
          original_name: 'Wong Suet-Yin',
          popularity: 0.6,
          profile_path: null,
          cast_id: 13,
          character: 'Ling',
          credit_id: '52fe475d9251416c75096b2d',
          order: 10,
        },
        {
          adult: false,
          gender: 0,
          id: 1190194,
          known_for_department: 'Diễn viên',
          name: 'Wong Sum-Yin',
          original_name: 'Wong Sum-Yin',
          popularity: 0.6,
          profile_path: null,
          cast_id: 14,
          character: 'Yee',
          credit_id: '52fe475d9251416c75096b31',
          order: 11,
        },
        {
          adult: false,
          gender: 0,
          id: 1190195,
          known_for_department: 'Diễn viên',
          name: 'Accord Cheung Kwok-Wai',
          original_name: 'Accord Cheung Kwok-Wai',
          popularity: 0.6,
          profile_path: null,
          cast_id: 15,
          character: 'Fai',
          credit_id: '52fe475d9251416c75096b35',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 1190196,
          known_for_department: 'Diễn viên',
          name: 'Eddie Chan Shu-Chi',
          original_name: 'Eddie Chan Shu-Chi',
          popularity: 0.6,
          profile_path: null,
          cast_id: 16,
          character: 'Chi',
          credit_id: '52fe475d9251416c75096b39',
          order: 13,
        },
        {
          adult: false,
          gender: 0,
          id: 1190197,
          known_for_department: 'Diễn viên',
          name: 'Tommy Tse Kai-Cheung',
          original_name: 'Tommy Tse Kai-Cheung',
          popularity: 0.6,
          profile_path: null,
          cast_id: 17,
          character: 'Tommy',
          credit_id: '52fe475d9251416c75096b3d',
          order: 14,
        },
        {
          adult: false,
          gender: 0,
          id: 1188819,
          known_for_department: 'Diễn viên',
          name: 'Kingman Cho',
          original_name: 'Kingman Cho',
          popularity: 0.6,
          profile_path: null,
          cast_id: 25,
          character: 'King Man',
          credit_id: '5e695662a0b69000138b5946',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 116423,
          known_for_department: 'Diễn viên',
          name: 'Liu Kai-Chi',
          original_name: 'Liu Kai-Chi',
          popularity: 0.965,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tOqH5blJzabTfM9dk6EWQ6uIDz7.jpg',
          cast_id: 24,
          character: 'Sun',
          credit_id: '550513a4c3a36862e5002028',
          order: 16,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 81220,
          known_for_department: 'Directing',
          name: 'Dante Lam',
          original_name: 'Dante Lam',
          popularity: 0.692,
          profile_path: null,
          credit_id: '52fe475d9251416c75096b01',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 81220,
          known_for_department: 'Directing',
          name: 'Dante Lam',
          original_name: 'Dante Lam',
          popularity: 0.692,
          profile_path: null,
          credit_id: '52fe475d9251416c75096b47',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 81222,
          known_for_department: 'Production',
          name: 'Candy Leung',
          original_name: 'Candy Leung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe475d9251416c75096b53',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 81223,
          known_for_department: 'Production',
          name: 'Cheung Hong-Tat',
          original_name: 'Cheung Hong-Tat',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe475d9251416c75096b5f',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1173802,
          known_for_department: 'Production',
          name: 'Albert Lee Nga-Bok',
          original_name: 'Albert Lee Nga-Bok',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe475d9251416c75096b59',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1190199,
          known_for_department: 'Biên kịch',
          name: 'Jack Ng Wai-Lun',
          original_name: 'Jack Ng Wai-Lun',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe475d9251416c75096b4d',
          department: 'Biên kịch',
          job: 'Writer',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/ndEKPIoJrmiaFdPH2AwCAkjBRye.jpg',
    belongs_to_collection: {
      id: 9887,
      name: 'Species Collection',
      poster_path: '/t5J0JH1L8L7CmtC3sL3K2ybgTbE.jpg',
      backdrop_path: '/vnpcoCTZhg1EdEog1kAS0pklx1o.jpg',
    },
    budget: 0,
    genres: [
      { id: 878, name: 'Phim Khoa Học Viễn Tưởng' },
      { id: 28, name: 'Phim Hành Động' },
      { id: 27, name: 'Phim Kinh Dị' },
    ],
    homepage: '',
    id: 9711,
    imdb_id: 'tt0410650',
    original_language: 'en',
    original_title: 'Species III',
    overview:
      'Phần tiếp theo của loạt phim kinh dị giả tưởng Species I và II về những người lai bởi ADN của con người và người ngoài hành tinh, những kẻ cực kỳ quyến rũ nhưng cũng cực kỳ độc ác với sức mạnh khủng khiếp. Ngoại trừ Sara, đứa con của Eve – cô nàng kiều diễm thích giết đàn ông trong phần II – có dòng máu thuần nhất, những kẻ nửa người nửa alien đều đang mắc phải một căn bệnh chết người. Sara được giáo sư Almond và chàng sinh viên Dean che chở trước sự truy lùng của quân đội, trong lúc này những kẻ mang ADN của alien khác cũng đang lùng sục cô, nhằm từ Sara tìm ra giải pháp chữa trị căn bệnh tai quái của chúng. Và cũng như các phần trước, những cô nàng nóng bỏng đi đến đâu, nơi đó sẽ xuất hiện vài cái xác của những ...',
    popularity: 25.654,
    poster_path:
      'https://image.tmdb.org/t/p/w342/8BelHo8qmaurZjPS9hipSQ79Rr6.jpg',
    production_companies: [
      {
        id: 2347,
        logo_path: null,
        name: 'FGM Entertainment',
        origin_country: 'US',
      },
      {
        id: 21,
        logo_path: '/aOWKh4gkNrfFZ3Ep7n0ckPhoGb5.png',
        name: 'Metro-Goldwyn-Mayer',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2004-11-26',
    revenue: 0,
    runtime: 111,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'Beauty is only skin deep',
    title: 'Loài Ác Độc 3',
    video: false,
    vote_average: 5.2,
    vote_count: 296,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Species III (2004) - Official Trailer (HD)',
          key: 'zfEd03oAWUQ',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2016-02-29T17:11:20.000Z',
          id: '5f462e1defca000036b98780',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 43426,
          known_for_department: 'Diễn viên',
          name: 'Robin Dunne',
          original_name: 'Robin Dunne',
          popularity: 4.158,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4TW7bd7yyRB1hjQdn0Ej3XAKVnu.jpg',
          cast_id: 1,
          character: 'Dean',
          credit_id: '52fe4520c3a36847f80bdf17',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 17343,
          known_for_department: 'Diễn viên',
          name: 'Robert Knepper',
          original_name: 'Robert Knepper',
          popularity: 9.499,
          profile_path:
            'https://image.tmdb.org/t/p/w185/w40AttR4OPQvjYyTVanq5Rm5iOb.jpg',
          cast_id: 2,
          character: 'Dr. Abbot',
          credit_id: '52fe4520c3a36847f80bdf1b',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 58707,
          known_for_department: 'Diễn viên',
          name: 'Sunny Mabrey',
          original_name: 'Sunny Mabrey',
          popularity: 6.408,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kY4QiKUYVBfCV7SJaWstug7hVE7.jpg',
          cast_id: 3,
          character: 'Sara',
          credit_id: '52fe4520c3a36847f80bdf1f',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 58708,
          known_for_department: 'Diễn viên',
          name: 'Amelia Cooke',
          original_name: 'Amelia Cooke',
          popularity: 1.638,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xbLE6tR8jnbei4RbVQ7qssIJvEF.jpg',
          cast_id: 4,
          character: 'Amelia',
          credit_id: '52fe4520c3a36847f80bdf23',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 58860,
          known_for_department: 'Diễn viên',
          name: 'Christopher Neame',
          original_name: 'Christopher Neame',
          popularity: 1.944,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rbZmUXeo3jfUDO2o1P3HB2Grq8x.jpg',
          cast_id: 11,
          character: 'Dr. Nicholas Turner',
          credit_id: '52fe4520c3a36847f80bdf37',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 169585,
          known_for_department: 'Diễn viên',
          name: 'Patricia Bethune',
          original_name: 'Patricia Bethune',
          popularity: 1.723,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qAzLLrlh9vd2VerZS9rkftvPMjV.jpg',
          cast_id: 12,
          character: 'Colleen',
          credit_id: '52fe4520c3a36847f80bdf3b',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 99583,
          known_for_department: 'Diễn viên',
          name: 'Michael Warren',
          original_name: 'Michael Warren',
          popularity: 1.73,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vEieZTdPgOKIddmvScA1pzQUN0D.jpg',
          cast_id: 20,
          character: 'Agent Wasach',
          credit_id: '52fe4520c3a36847f80bdf5b',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 57395,
          known_for_department: 'Diễn viên',
          name: 'Natasha Henstridge',
          original_name: 'Natasha Henstridge',
          popularity: 9.06,
          profile_path:
            'https://image.tmdb.org/t/p/w185/A2e6Fq2yyqQrouYn27MdYuv0pXv.jpg',
          cast_id: 16,
          character: 'Eve',
          credit_id: '52fe4520c3a36847f80bdf4b',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 19226,
          known_for_department: 'Diễn viên',
          name: 'John Paul Pitoc',
          original_name: 'John Paul Pitoc',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zzLv5gAJVIokZUDDhF72T3fJiCN.jpg',
          cast_id: 9,
          character: 'Hastings',
          credit_id: '52fe4520c3a36847f80bdf33',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 155978,
          known_for_department: 'Diễn viên',
          name: 'Joel Stoffer',
          original_name: 'Joel Stoffer',
          popularity: 1.044,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fePhj3rc4CHCSVuLZIFsTV6lLvz.jpg',
          cast_id: 13,
          character: 'Portus',
          credit_id: '52fe4520c3a36847f80bdf3f',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 154720,
          known_for_department: 'Diễn viên',
          name: 'James Leo Ryan',
          original_name: 'James Leo Ryan',
          popularity: 0.715,
          profile_path: null,
          cast_id: 14,
          character: 'Yosef',
          credit_id: '52fe4520c3a36847f80bdf43',
          order: 10,
        },
        {
          adult: false,
          gender: 1,
          id: 554409,
          known_for_department: 'Diễn viên',
          name: 'Savanna Fields',
          original_name: 'Savanna Fields',
          popularity: 0.6,
          profile_path: null,
          cast_id: 15,
          character: 'Young Sara',
          credit_id: '52fe4520c3a36847f80bdf47',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 177910,
          known_for_department: 'Production',
          name: 'Reed Frerichs',
          original_name: 'Reed Frerichs',
          popularity: 0.6,
          profile_path: null,
          cast_id: 17,
          character: 'ISD Staffer',
          credit_id: '52fe4520c3a36847f80bdf4f',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 180168,
          known_for_department: 'Diễn viên',
          name: 'Marc D. Wilson',
          original_name: 'Marc D. Wilson',
          popularity: 0.6,
          profile_path: null,
          cast_id: 18,
          character: 'Crew Chief',
          credit_id: '52fe4520c3a36847f80bdf53',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 157067,
          known_for_department: 'Diễn viên',
          name: 'Matthew Yang King',
          original_name: 'Matthew Yang King',
          popularity: 1.676,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jcLJIw0s2uP4PSnH5E8oM3pUyiV.jpg',
          cast_id: 19,
          character: 'Specialist Robert Kelley',
          credit_id: '52fe4520c3a36847f80bdf57',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 101850,
          known_for_department: 'Diễn viên',
          name: 'Rick Dean',
          original_name: 'Rick Dean',
          popularity: 1.109,
          profile_path: null,
          cast_id: 27,
          character: 'Cobb the Gas Station Guy',
          credit_id: '582bae44c3a36872c9000d32',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 1720753,
          known_for_department: 'Diễn viên',
          name: 'Christopher R. Gillum',
          original_name: 'Christopher R. Gillum',
          popularity: 0.6,
          profile_path: null,
          cast_id: 44,
          character: 'Young Portus',
          credit_id: '584c0226c3a368397e00b16c',
          order: 16,
        },
        {
          adult: false,
          gender: 2,
          id: 1720754,
          known_for_department: 'Diễn viên',
          name: 'Billy Bacon',
          original_name: 'Billy Bacon',
          popularity: 0.6,
          profile_path: null,
          cast_id: 45,
          character: 'Commander',
          credit_id: '584c022ec3a368398700aac3',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 92328,
          known_for_department: 'Diễn viên',
          name: 'Jim Cody Williams',
          original_name: 'Jim Cody Williams',
          popularity: 0.696,
          profile_path: null,
          cast_id: 46,
          character: 'Farmer at Gas Station',
          credit_id: '584c023592514133a800a35e',
          order: 18,
        },
        {
          adult: false,
          gender: 2,
          id: 1720755,
          known_for_department: 'Diễn viên',
          name: 'Mark Zecca',
          original_name: 'Mark Zecca',
          popularity: 0.6,
          profile_path: null,
          cast_id: 47,
          character: 'Tour Guest',
          credit_id: '584c024292514133ab00aa9f',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 1720756,
          known_for_department: 'Diễn viên',
          name: 'Sean C. Ching',
          original_name: 'Sean C. Ching',
          popularity: 0.6,
          profile_path: null,
          cast_id: 48,
          character: 'Grad Student',
          credit_id: '584c024d92514133b100b08b',
          order: 20,
        },
        {
          adult: false,
          gender: 2,
          id: 1225638,
          known_for_department: 'Diễn viên',
          name: 'Dan Wells',
          original_name: 'Dan Wells',
          popularity: 0.98,
          profile_path: null,
          cast_id: 49,
          character: 'Jake',
          credit_id: '584c026e92514133b300b399',
          order: 21,
        },
        {
          adult: false,
          gender: 2,
          id: 1559704,
          known_for_department: 'Diễn viên',
          name: 'Frank Crim',
          original_name: 'Frank Crim',
          popularity: 0.6,
          profile_path: null,
          cast_id: 50,
          character: 'Communications Officer',
          credit_id: '584c027892514133a800a36e',
          order: 22,
        },
        {
          adult: false,
          gender: 1,
          id: 1484694,
          known_for_department: 'Diễn viên',
          name: 'Boni Yanagisawa',
          original_name: 'Boni Yanagisawa',
          popularity: 0.732,
          profile_path:
            'https://image.tmdb.org/t/p/w185/voWOhP4IUcy0o3aeOVcEKbv010r.jpg',
          cast_id: 51,
          character: 'Female Student',
          credit_id: '584c02bf92514133b300b3c3',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 1425900,
          known_for_department: 'Costume & Make-Up',
          name: 'Rob Hinderstein',
          original_name: 'Rob Hinderstein',
          popularity: 0.6,
          profile_path: null,
          cast_id: 52,
          character: 'Security Guard #1',
          credit_id: '584c02c692514133ad00a9cf',
          order: 24,
        },
        {
          adult: false,
          gender: 2,
          id: 42824,
          known_for_department: 'Diễn viên',
          name: 'Carl Ciarfalio',
          original_name: 'Carl Ciarfalio',
          popularity: 2.197,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yADROfK7uJkmd8p3GyjxH8WZqRL.jpg',
          cast_id: 53,
          character: 'Security Guard #2',
          credit_id: '584c02cd92514133ad00a9d4',
          order: 25,
        },
        {
          adult: false,
          gender: 2,
          id: 154742,
          known_for_department: 'Diễn viên',
          name: 'Troy Blendell',
          original_name: 'Troy Blendell',
          popularity: 1.616,
          profile_path:
            'https://image.tmdb.org/t/p/w185/x63p8KjNN3jns9LonNCWqRnOLvi.jpg',
          cast_id: 54,
          character: 'Autopsy Tech',
          credit_id: '584c02d992514133ad00a9db',
          order: 26,
        },
        {
          adult: false,
          gender: 2,
          id: 1720757,
          known_for_department: 'Diễn viên',
          name: 'Keith Camire',
          original_name: 'Keith Camire',
          popularity: 0.6,
          profile_path: null,
          cast_id: 55,
          character: 'Military Soldier (uncredited)',
          credit_id: '584c02e192514133ad00a9df',
          order: 27,
        },
        {
          adult: false,
          gender: 2,
          id: 1720758,
          known_for_department: 'Diễn viên',
          name: 'Josh Cook',
          original_name: 'Josh Cook',
          popularity: 0.6,
          profile_path: null,
          cast_id: 56,
          character: 'Jock (uncredited)',
          credit_id: '584c02ffc3a368397e00b1e7',
          order: 28,
        },
        {
          adult: false,
          gender: 2,
          id: 1069534,
          known_for_department: 'Diễn viên',
          name: 'Joss Gomez',
          original_name: 'Joss Gomez',
          popularity: 0.6,
          profile_path: null,
          cast_id: 57,
          character: 'Student (uncredited)',
          credit_id: '584c030a92514133a800a3c5',
          order: 29,
        },
        {
          adult: false,
          gender: 1,
          id: 1241255,
          known_for_department: 'Diễn viên',
          name: 'Kari Ann Peniche',
          original_name: 'Kari Ann Peniche',
          popularity: 0.6,
          profile_path: null,
          cast_id: 58,
          character: 'Cheerleader (uncredited)',
          credit_id: '584c0312c3a368398700ab46',
          order: 30,
        },
        {
          adult: false,
          gender: 2,
          id: 169352,
          known_for_department: 'Diễn viên',
          name: 'Jason Sarcinelli',
          original_name: 'Jason Sarcinelli',
          popularity: 1.073,
          profile_path: null,
          cast_id: 59,
          character: 'Adult Male Alien (uncredited)',
          credit_id: '584c031bc3a368398b00b1fe',
          order: 31,
        },
        {
          adult: false,
          gender: 2,
          id: 1549741,
          known_for_department: 'Crew',
          name: 'Marc Scizak',
          original_name: 'Marc Scizak',
          popularity: 0.766,
          profile_path: null,
          cast_id: 60,
          character: 'Football Player (uncredited)',
          credit_id: '584c0323c3a368398b00b203',
          order: 32,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 42686,
          known_for_department: 'Directing',
          name: 'David Dwiggins',
          original_name: 'David Dwiggins',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4520c3a36847f80bdf61',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 43609,
          known_for_department: 'Sound',
          name: 'Elia Cmiral',
          original_name: 'Elia Cmiral',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fb045744a4bfc0040b4b0cd',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 2,
          id: 49284,
          known_for_department: 'Production',
          name: 'Frank Mancuso Jr.',
          original_name: 'Frank Mancuso Jr.',
          popularity: 2.009,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2DONUVbnaX47hpclMWqKQX14vAJ.jpg',
          credit_id: '584c0187c3a368397500a453',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 25882,
          known_for_department: 'Directing',
          name: 'Brad Turner',
          original_name: 'Brad Turner',
          popularity: 0.67,
          profile_path: null,
          credit_id: '52fe4520c3a36847f80bdf2f',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 66693,
          known_for_department: 'Costume & Make-Up',
          name: 'Richard Redlefsen',
          original_name: 'Richard Redlefsen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '584c019092514133bd00a7ca',
          department: 'Art',
          job: 'Lead Painter',
        },
        {
          adult: false,
          gender: 2,
          id: 57396,
          known_for_department: 'Biên kịch',
          name: 'Dennis Feldman',
          original_name: 'Dennis Feldman',
          popularity: 0.708,
          profile_path: null,
          credit_id: '584c017e92514133b600b020',
          department: 'Biên kịch',
          job: 'Characters',
        },
        {
          adult: false,
          gender: 2,
          id: 57858,
          known_for_department: 'Editing',
          name: 'James Coblentz',
          original_name: 'James Coblentz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b18524a9251414b9b00030e',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 58709,
          known_for_department: 'Biên kịch',
          name: 'Ben Ripley',
          original_name: 'Ben Ripley',
          popularity: 1.411,
          profile_path: null,
          credit_id: '52fe4520c3a36847f80bdf29',
          department: 'Biên kịch',
          job: 'Author',
        },
        {
          adult: false,
          gender: 2,
          id: 26080,
          known_for_department: 'Production',
          name: 'Paul Weber',
          original_name: 'Paul Weber',
          popularity: 1.38,
          profile_path: null,
          credit_id: '537361400e0a267c5900187c',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 1,
          id: 64407,
          known_for_department: 'Production',
          name: 'Ivy Isenberg',
          original_name: 'Ivy Isenberg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '584c01fdc3a368397500a49a',
          department: 'Production',
          job: 'Casting Associate',
        },
        {
          adult: false,
          gender: 2,
          id: 75375,
          known_for_department: 'Costume & Make-Up',
          name: 'Joel Harlow',
          original_name: 'Joel Harlow',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tC8VpeOUQHkpPintf1Jaao2Igsg.jpg',
          credit_id: '5b185acd0e0a261f800007e9',
          department: 'Visual Effects',
          job: 'Creature Design',
        },
        {
          adult: false,
          gender: 2,
          id: 75375,
          known_for_department: 'Costume & Make-Up',
          name: 'Joel Harlow',
          original_name: 'Joel Harlow',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tC8VpeOUQHkpPintf1Jaao2Igsg.jpg',
          credit_id: '5b1852c59251414b8e000564',
          department: 'Costume & Make-Up',
          job: 'Special Effects Makeup Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 75636,
          known_for_department: 'Crew',
          name: 'Jalil Jay Lynch',
          original_name: 'Jalil Jay Lynch',
          popularity: 0.67,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lpU7fTd5MTv4nXcmmr1WdPcKnVN.jpg',
          credit_id: '584c01bcc3a368397a00b4a0',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 91938,
          known_for_department: 'Crew',
          name: 'George Hesse',
          original_name: 'George Hesse',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5b185cc8c3a36848ed0007eb',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 2,
          id: 98681,
          known_for_department: 'Art',
          name: 'Todd Rex',
          original_name: 'Todd Rex',
          popularity: 0.786,
          profile_path:
            'https://image.tmdb.org/t/p/w185/x1MPEs5LrvqzdPdDuwDnJjENhMH.jpg',
          credit_id: '584c01aa92514133b300b331',
          department: 'Art',
          job: 'Sculptor',
        },
        {
          adult: false,
          gender: 0,
          id: 132626,
          known_for_department: 'Visual Effects',
          name: 'Sarah McMurdo',
          original_name: 'Sarah McMurdo',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5b1859b40e0a261f8800076b',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 202955,
          known_for_department: 'Crew',
          name: 'Theo Kypri',
          original_name: 'Theo Kypri',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4JrpMbLip6wZY0BmHvnfM5OZO3j.jpg',
          credit_id: '5b78658a0e0a2647340166f8',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 1,
          id: 964101,
          known_for_department: 'Art',
          name: 'Halina Siwolop',
          original_name: 'Halina Siwolop',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wXITOqKWKoKPFwFd3xt8rCR9Hke.jpg',
          credit_id: '5373616e0e0a267c620017a4',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 1,
          id: 986304,
          known_for_department: 'Production',
          name: 'Zora DeHorter',
          original_name: 'Zora DeHorter',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5373612d0e0a267c6200179d',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 1002652,
          known_for_department: 'Visual Effects',
          name: 'Dennis Berardi',
          original_name: 'Dennis Berardi',
          popularity: 0.705,
          profile_path: null,
          credit_id: '5b1859fb0e0a261f9d00086b',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1171245,
          known_for_department: 'Art',
          name: 'Cameron Birnie',
          original_name: 'Cameron Birnie',
          popularity: 0.6,
          profile_path: null,
          credit_id: '537361560e0a267c5f0017b2',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1191813,
          known_for_department: 'Sound',
          name: 'Noel Vought',
          original_name: 'Noel Vought',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1856df0e0a261fa300071d',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 1,
          id: 1279727,
          known_for_department: 'Crew',
          name: 'Debbie Evans',
          original_name: 'Debbie Evans',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oLONr71aymvTbaNpNSnMfiA46SE.jpg',
          credit_id: '584c01b4c3a3682c3a000b7a',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 1,
          id: 1319415,
          known_for_department: 'Costume & Make-Up',
          name: 'Kathleen Crawford',
          original_name: 'Kathleen Crawford',
          popularity: 0.6,
          profile_path: null,
          credit_id: '537361880e0a267c59001884',
          department: 'Costume & Make-Up',
          job: 'Makeup Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 1394282,
          known_for_department: 'Visual Effects',
          name: 'Allan Magled',
          original_name: 'Allan Magled',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b185a1a0e0a261f9f000840',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1395021,
          known_for_department: 'Art',
          name: 'Brent Rice',
          original_name: 'Brent Rice',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1853e10e0a261fa70005aa',
          department: 'Art',
          job: 'Leadman',
        },
        {
          adult: false,
          gender: 2,
          id: 1401292,
          known_for_department: 'Visual Effects',
          name: 'Eric J. Robertson',
          original_name: 'Eric J. Robertson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1859ca9251414bb4000855',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1401360,
          known_for_department: 'Crew',
          name: 'Gregory C. Tippie',
          original_name: 'Gregory C. Tippie',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b185c110e0a261fa3000920',
          department: 'Crew',
          job: 'Special Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1401566,
          known_for_department: 'Visual Effects',
          name: 'Michael Kowalski',
          original_name: 'Michael Kowalski',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1859e40e0a261f97000921',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1402560,
          known_for_department: 'Camera',
          name: 'Saeed Adyani',
          original_name: 'Saeed Adyani',
          popularity: 0.6,
          profile_path: null,
          credit_id: '584c01df92514133b300b355',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 2,
          id: 1408608,
          known_for_department: 'Sound',
          name: 'Mark Lanza',
          original_name: 'Mark Lanza',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b18574dc3a36848eb0005a9',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1417988,
          known_for_department: 'Crew',
          name: 'Jorge Razon',
          original_name: 'Jorge Razon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1858a29251414b9b000476',
          department: 'Visual Effects',
          job: '3D Animator',
        },
        {
          adult: false,
          gender: 2,
          id: 1423017,
          known_for_department: 'Camera',
          name: 'Ken Glassing',
          original_name: 'Ken Glassing',
          popularity: 0.6,
          profile_path: null,
          credit_id: '584c01f3c3a368398b00b168',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 1423017,
          known_for_department: 'Camera',
          name: 'Ken Glassing',
          original_name: 'Ken Glassing',
          popularity: 0.6,
          profile_path: null,
          credit_id: '584c01e8c3a368397e00b142',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 1423861,
          known_for_department: 'Sound',
          name: 'Jeff Rosen',
          original_name: 'Jeff Rosen',
          popularity: 0.608,
          profile_path: null,
          credit_id: '5b1857659251414bb00006c5',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1425812,
          known_for_department: 'Costume & Make-Up',
          name: 'Maggie Hayes-Jackson',
          original_name: 'Maggie Hayes-Jackson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1852919251414bcd000464',
          department: 'Costume & Make-Up',
          job: 'Key Hair Stylist',
        },
        {
          adult: false,
          gender: 2,
          id: 1425900,
          known_for_department: 'Costume & Make-Up',
          name: 'Rob Hinderstein',
          original_name: 'Rob Hinderstein',
          popularity: 0.6,
          profile_path: null,
          credit_id: '584c0198c3a368398200a88f',
          department: 'Visual Effects',
          job: 'Creature Design',
        },
        {
          adult: false,
          gender: 2,
          id: 1433735,
          known_for_department: 'Crew',
          name: 'Jim Vickers',
          original_name: 'Jim Vickers',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pjBhOb9r4zh4EeXNqoOXzbD05Jz.jpg',
          credit_id: '584c0205c3a368398200a8d9',
          department: 'Crew',
          job: 'Choreographer',
        },
        {
          adult: false,
          gender: 2,
          id: 1433735,
          known_for_department: 'Crew',
          name: 'Jim Vickers',
          original_name: 'Jim Vickers',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pjBhOb9r4zh4EeXNqoOXzbD05Jz.jpg',
          credit_id: '584c01ce92514133b100b04c',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1433735,
          known_for_department: 'Crew',
          name: 'Jim Vickers',
          original_name: 'Jim Vickers',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pjBhOb9r4zh4EeXNqoOXzbD05Jz.jpg',
          credit_id: '5b185e1d9251414ba2000552',
          department: 'Crew',
          job: 'Fight Choreographer',
        },
        {
          adult: false,
          gender: 2,
          id: 1451649,
          known_for_department: 'Sound',
          name: 'Paul Drenning',
          original_name: 'Paul Drenning',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1856a89251414bc600072a',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1484526,
          known_for_department: 'Visual Effects',
          name: 'Jeff Jingle',
          original_name: 'Jeff Jingle',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5b185a6c0e0a261f85000813',
          department: 'Crew',
          job: 'Animatronics Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1484694,
          known_for_department: 'Diễn viên',
          name: 'Boni Yanagisawa',
          original_name: 'Boni Yanagisawa',
          popularity: 0.732,
          profile_path:
            'https://image.tmdb.org/t/p/w185/voWOhP4IUcy0o3aeOVcEKbv010r.jpg',
          credit_id: '584c01d792514133b600b055',
          department: 'Crew',
          job: 'Utility Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1540246,
          known_for_department: 'Camera',
          name: 'Paul Janossy',
          original_name: 'Paul Janossy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b185cdec3a36848ed0007f6',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 2,
          id: 1549741,
          known_for_department: 'Crew',
          name: 'Marc Scizak',
          original_name: 'Marc Scizak',
          popularity: 0.766,
          profile_path: null,
          credit_id: '584c01c592514133a800a318',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1552088,
          known_for_department: 'Sound',
          name: 'Victor Iorillo',
          original_name: 'Victor Iorillo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b185800c3a3684913000705',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1560824,
          known_for_department: 'Sound',
          name: 'Phillip W. Palmer',
          original_name: 'Phillip W. Palmer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b18571bc3a36848ff000a19',
          department: 'Sound',
          job: 'Production Sound Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1596307,
          known_for_department: 'Crew',
          name: 'John Bocchicchio',
          original_name: 'John Bocchicchio',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b185ea80e0a261fa3000a46',
          department: 'Crew',
          job: 'Set Medic',
        },
        {
          adult: false,
          gender: 1,
          id: 1636058,
          known_for_department: 'Sound',
          name: 'Marla McGuire',
          original_name: 'Marla McGuire',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b18568a0e0a261fb0000647',
          department: 'Sound',
          job: 'ADR Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1652231,
          known_for_department: 'Visual Effects',
          name: 'Barb Benoit',
          original_name: 'Barb Benoit',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b185937c3a36848f60008d3',
          department: 'Visual Effects',
          job: 'Digital Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 1662324,
          known_for_department: 'Art',
          name: 'Jeff Hay',
          original_name: 'Jeff Hay',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1855129251414bb8000743',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 2,
          id: 1692502,
          known_for_department: 'Sound',
          name: 'Kurt Kassulke',
          original_name: 'Kurt Kassulke',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1857eac3a36848ed000643',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1695256,
          known_for_department: 'Costume & Make-Up',
          name: 'Thomas D. Krausz',
          original_name: 'Thomas D. Krausz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b185524c3a36848f2000767',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 1735835,
          known_for_department: 'Visual Effects',
          name: 'Daniel Lu',
          original_name: 'Daniel Lu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1858899251414bb8000918',
          department: 'Visual Effects',
          job: '3D Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 1754884,
          known_for_department: 'Sound',
          name: 'David S. DiPietro',
          original_name: 'David S. DiPietro',
          popularity: 1.094,
          profile_path: null,
          credit_id: '5b1856bd0e0a261f8000065b',
          department: 'Sound',
          job: 'ADR Recordist',
        },
        {
          adult: false,
          gender: 0,
          id: 1757613,
          known_for_department: 'Visual Effects',
          name: 'Keith Sellers',
          original_name: 'Keith Sellers',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1858b49251414bd4000714',
          department: 'Visual Effects',
          job: '3D Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 1802527,
          known_for_department: 'Art',
          name: 'Scott W. Leslie',
          original_name: 'Scott W. Leslie',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1855350e0a261fb00005c6',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 1,
          id: 1820041,
          known_for_department: 'Visual Effects',
          name: 'Kristy Blackwell',
          original_name: 'Kristy Blackwell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1858f59251414b8e000810',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1854787,
          known_for_department: 'Visual Effects',
          name: 'Jef Lonn',
          original_name: 'Jef Lonn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b18594c0e0a261fb0000756',
          department: 'Visual Effects',
          job: 'Digital Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 1883234,
          known_for_department: 'Biên kịch',
          name: 'Betsy Bagg',
          original_name: 'Betsy Bagg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b185d319251414bb8000b57',
          department: 'Production',
          job: 'Casting Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 1907208,
          known_for_department: 'Visual Effects',
          name: 'Mark Della Rosa',
          original_name: 'Mark Della Rosa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1858769251414ba2000424',
          department: 'Visual Effects',
          job: '3D Animator',
        },
        {
          adult: false,
          gender: 1,
          id: 1919342,
          known_for_department: 'Directing',
          name: 'Heather Cappiello',
          original_name: 'Heather Cappiello',
          popularity: 1.094,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cAmibLkpzkGK4Mbd25rMcqTd9E4.jpg',
          credit_id: '5b185e8c9251414bd7000899',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1935519,
          known_for_department: 'Crew',
          name: 'John Tamburro',
          original_name: 'John Tamburro',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b185e30c3a36848ff000dce',
          department: 'Crew',
          job: 'Pilot',
        },
        {
          adult: false,
          gender: 0,
          id: 1946470,
          known_for_department: 'Sound',
          name: 'Timothy Pearson',
          original_name: 'Timothy Pearson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1856d0c3a36848ed0005da',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1948867,
          known_for_department: 'Camera',
          name: 'Gary A. Williams',
          original_name: 'Gary A. Williams',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b185c690e0a261fac0008ab',
          department: 'Camera',
          job: 'Dolly Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1958486,
          known_for_department: 'Production',
          name: 'Amy De Souza',
          original_name: 'Amy De Souza',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b185d420e0a261f8500094c',
          department: 'Production',
          job: 'Casting Assistant',
        },
        {
          adult: false,
          gender: 2,
          id: 2002274,
          known_for_department: 'Production',
          name: 'Brad Kenny',
          original_name: 'Brad Kenny',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b185d6a0e0a261f8000094d',
          department: 'Production',
          job: 'Extras Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 2011061,
          known_for_department: 'Visual Effects',
          name: 'Steve Wittmann',
          original_name: 'Steve Wittmann',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1858c90e0a261f8500076c',
          department: 'Visual Effects',
          job: 'CG Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 2037684,
          known_for_department: 'Visual Effects',
          name: 'Matt Ralph',
          original_name: 'Matt Ralph',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b18584c0e0a261f9a000745',
          department: 'Visual Effects',
          job: '3D Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 2058965,
          known_for_department: 'Costume & Make-Up',
          name: 'Kent Nelson',
          original_name: 'Kent Nelson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1852a90e0a261fa7000523',
          department: 'Costume & Make-Up',
          job: 'Key Hair Stylist',
        },
        {
          adult: false,
          gender: 0,
          id: 2058966,
          known_for_department: 'Art',
          name: 'Kay Kropp',
          original_name: 'Kay Kropp',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1853f60e0a261f9a00056b',
          department: 'Art',
          job: 'Lead Painter',
        },
        {
          adult: false,
          gender: 2,
          id: 2058967,
          known_for_department: 'Costume & Make-Up',
          name: 'Julián Navarro',
          original_name: 'Julián Navarro',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1854480e0a261f80000588',
          department: 'Costume & Make-Up',
          job: 'On Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2058968,
          known_for_department: 'Costume & Make-Up',
          name: 'Brendan C. Fenton',
          original_name: 'Brendan C. Fenton',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5b18545bc3a36848f80005aa',
          department: 'Costume & Make-Up',
          job: 'On Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2058969,
          known_for_department: 'Art',
          name: 'Maret Wicken',
          original_name: 'Maret Wicken',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1854710e0a261f9a0005a6',
          department: 'Art',
          job: 'Painter',
        },
        {
          adult: false,
          gender: 0,
          id: 2058970,
          known_for_department: 'Art',
          name: 'Gary Antista',
          original_name: 'Gary Antista',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b18548bc3a36848f2000718',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 2058971,
          known_for_department: 'Art',
          name: 'Jeannine Stevens',
          original_name: 'Jeannine Stevens',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1855479251414bb800075d',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 1,
          id: 2058975,
          known_for_department: 'Sound',
          name: 'Stacey Michaels',
          original_name: 'Stacey Michaels',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1856f50e0a261f88000641',
          department: 'Sound',
          job: 'Foley Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 2058977,
          known_for_department: 'Visual Effects',
          name: 'Derek Sunderland',
          original_name: 'Derek Sunderland',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b18585ec3a36848f200091b',
          department: 'Visual Effects',
          job: '3D Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 2058985,
          known_for_department: 'Visual Effects',
          name: 'Karl Sisson',
          original_name: 'Karl Sisson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1858dd0e0a261f9d000809',
          department: 'Visual Effects',
          job: 'CG Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2058989,
          known_for_department: 'Visual Effects',
          name: 'Mike Mombourquette',
          original_name: 'Mike Mombourquette',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b18598c9251414bc1000984',
          department: 'Visual Effects',
          job: 'Digital Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 2058990,
          known_for_department: 'Lighting',
          name: 'Greg McCurley',
          original_name: 'Greg McCurley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b185cf6c3a36848fb00084c',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2058991,
          known_for_department: 'Editing',
          name: 'Randy Beveridge',
          original_name: 'Randy Beveridge',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b185d919251414bc6000a62',
          department: 'Editing',
          job: 'Colorist',
        },
        {
          adult: false,
          gender: 0,
          id: 2058992,
          known_for_department: 'Editing',
          name: 'Michelle Walsh',
          original_name: 'Michelle Walsh',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b185de19251414bd7000872',
          department: 'Editing',
          job: 'Assistant Editor',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path: null,
    belongs_to_collection: null,
    budget: 0,
    genres: [{ id: 27, name: 'Phim Kinh Dị' }],
    homepage: '',
    id: 129123,
    imdb_id: 'tt0344839',
    original_language: 'cn',
    original_title: 'Erotic Nightmare',
    overview:
      'Huỳnh Thu Sanh vào vai một gã đàn ông thiếu thốn đời sống tình dục. Đến gặp thầy pháp, ông được ban cho những giấc mơ ân ái hàng đêm. Ông dần nghiện mơ và si mê một trong những cô gái hay gặp trong giấc mơ của mình. Không may, những giấc mơ ngọt ngào đó là một phần âm mưu của lão thầy pháp, nhằm nắm bắt tâm hồn ông ta…',
    popularity: 5.265,
    poster_path:
      'https://image.tmdb.org/t/p/w342/nRFxugw69D1qGzNixRwSUyKyHzU.jpg',
    production_companies: [],
    production_countries: [{ iso_3166_1: 'HK', name: 'Hồng Kông' }],
    release_date: '1999-05-01',
    revenue: 0,
    runtime: 88,
    spoken_languages: [
      { english_name: 'Cantonese', iso_639_1: 'cn', name: '广州话 / 廣州話' },
      { english_name: 'Mandarin', iso_639_1: 'zh', name: '普通话' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Ác mộng đêm hè',
    video: false,
    vote_average: 3.5,
    vote_count: 1,
    videos: { results: [] },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 66717,
          known_for_department: 'Diễn viên',
          name: 'Anthony Wong',
          original_name: 'Anthony Wong',
          popularity: 6.492,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7UYRnOZXSmJFcQGPBUSFbyY07zZ.jpg',
          cast_id: 1,
          character: 'Lok Yep',
          credit_id: '52fe4b34c3a368484e17d05b',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 112982,
          known_for_department: 'Diễn viên',
          name: 'Pinky Cheung',
          original_name: 'Pinky Cheung',
          popularity: 3.02,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cKmeSkj1QmQIaL0OSgPoyk7I3Dz.jpg',
          cast_id: 5,
          character: "Fong's Wife",
          credit_id: '5946d067c3a36816e402d5e1',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 1139045,
          known_for_department: 'Diễn viên',
          name: 'Berg Ng',
          original_name: 'Berg Ng',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xGljYvkse4FLPm7pBjsdojia6dv.jpg',
          cast_id: 7,
          character: 'Fong',
          credit_id: '5946d087c3a368170f02f964',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 1247371,
          known_for_department: 'Diễn viên',
          name: 'Eric Wan',
          original_name: 'Eric Wan',
          popularity: 1.511,
          profile_path:
            'https://image.tmdb.org/t/p/w185/k7wOpNUsMYbWesyEcps0vETAkcs.jpg',
          cast_id: 9,
          character: 'Lok Man',
          credit_id: '5b024222c3a3686c8901ae58',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 2990236,
          known_for_department: 'Diễn viên',
          name: 'Kei Heung',
          original_name: 'Kei Heung',
          popularity: 0.6,
          profile_path: null,
          cast_id: 10,
          character: 'Ball Ball',
          credit_id: '603775e0d132d60040a44b02',
          order: 6,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 0,
          id: 134183,
          known_for_department: 'Biên kịch',
          name: 'Sap Sam Chan',
          original_name: 'Sap Sam Chan',
          popularity: 0.742,
          profile_path: null,
          credit_id: '5946d0a39251413fb1030163',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 1413664,
          known_for_department: 'Directing',
          name: 'Steve Cheng',
          original_name: 'Steve Cheng',
          popularity: 0.98,
          profile_path: null,
          credit_id: '561a6a4ac3a3684837001bfc',
          department: 'Directing',
          job: 'Director',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/gHtCBCQrzT6MvCylcvgFWPMZ1E2.jpg',
    belongs_to_collection: {
      id: 107674,
      name: 'The Princess Diaries Collection',
      poster_path: '/3uDvh88xbVpRKMBw5JD0gbptvPJ.jpg',
      backdrop_path: '/7YtskA8cdK2WO7l7MKwMHt5Pqxt.jpg',
    },
    budget: 37000000,
    genres: [
      { id: 35, name: 'Phim Hài' },
      { id: 10751, name: 'Phim Gia Đình' },
      { id: 10749, name: 'Phim Lãng Mạn' },
    ],
    homepage: '',
    id: 9880,
    imdb_id: 'tt0247638',
    original_language: 'en',
    original_title: 'The Princess Diaries',
    overview:
      'Ngay cả trong giấc mơ hoang đường nhất, cô học trò Mia nghịch ngợm, đôi phần luộm thuộm cũng chẳng bao giờ nghĩ mình sẽ là con gái một thái tử. Ấy vậy mà một ngày, đích thân nữ hoàng của vương quốc Genovia từ châu Âu xa xôi đã lặn lội tới Mỹ để biến Mia thành công chúa xinh đẹp. Gia nhập cuộc sống hoàng gia, Mia gặp vô số niềm vui, nhưng rắc rối cũng đầy ắp. Dưới sự chỉ dẫn của bà nội - nữ hoàng, Mia phải học cách trị vì đất nước, phải thực hiện cho được một nhiệm vụ quá khó khăn với một cô công chúa 18 tuổi: kén phò mã trong 30 ngày. Lợi dụng dịp này, một thành viên trong nghị viện Genovia đã tự đề cử cháu trai mình làm phò mã với mục tiêu thao túng đất nước. Thật không ngờ là Mia lại yêu chàng trai này say đắm.',
    popularity: 34.436,
    poster_path:
      'https://image.tmdb.org/t/p/w342/wA4lgl8gmoICSShviCkEB61nIBB.jpg',
    production_companies: [
      {
        id: 65559,
        logo_path: null,
        name: 'Bottom of the Ninth Productions',
        origin_country: '',
      },
      {
        id: 2,
        logo_path: '/wdrCwmRnLFJhEoH8GSfymY85KHT.png',
        name: 'Walt Disney Pictures',
        origin_country: 'US',
      },
      {
        id: 26423,
        logo_path: null,
        name: 'BrownHouse Productions',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2001-08-03',
    revenue: 165335153,
    runtime: 115,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'She rocks. She rules. She reigns.',
    title: 'Nhật Ký Công Chúa',
    video: false,
    vote_average: 6.9,
    vote_count: 3973,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Princess Diaries - Trailer',
          key: '2CkcwPi20ms',
          published_at: '2012-04-25T04:34:11.000Z',
          site: 'YouTube',
          size: 360,
          type: 'Trailer',
          official: true,
          id: '585c3940c3a3685416000eeb',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Princess Diaries (2001)  trailer',
          key: 'D2WofresyA4',
          published_at: '2011-08-21T23:13:26.000Z',
          site: 'YouTube',
          size: 360,
          type: 'Trailer',
          official: false,
          id: '585c3957c3a368541000102d',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 5823,
          known_for_department: 'Diễn viên',
          name: 'Julie Andrews',
          original_name: 'Julie Andrews',
          popularity: 3.805,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kTXM2KfsXh2vSav0s9vaDKfs4lR.jpg',
          cast_id: 15,
          character: 'Queen Clarisse Renaldi',
          credit_id: '52fe4540c3a36847f80c3a19',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 115730,
          known_for_department: 'Diễn viên',
          name: 'Patrick John Flueger',
          original_name: 'Patrick John Flueger',
          popularity: 5.068,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pnERPmUO3o0tNdDuyq67wdJP430.jpg',
          cast_id: 20,
          character: 'Jeremiah Hart',
          credit_id: '52fe4540c3a36847f80c3a2d',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 33656,
          known_for_department: 'Diễn viên',
          name: 'Heather Matarazzo',
          original_name: 'Heather Matarazzo',
          popularity: 4.287,
          profile_path:
            'https://image.tmdb.org/t/p/w185/afZhMKmsAHZA9jHq7F9tNUFZci6.jpg',
          cast_id: 12,
          character: 'Lilly Moscovitz',
          credit_id: '52fe4540c3a36847f80c3a0d',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 1210,
          known_for_department: 'Diễn viên',
          name: 'Héctor Elizondo',
          original_name: 'Héctor Elizondo',
          popularity: 4.122,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7Mfx9xeOFKXtzVpAc1488LiHs0b.jpg',
          cast_id: 14,
          character: 'Joe',
          credit_id: '52fe4540c3a36847f80c3a15',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 16855,
          known_for_department: 'Diễn viên',
          name: 'Mandy Moore',
          original_name: 'Mandy Moore',
          popularity: 4.659,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1Z5yJ6FUsEtlVZzpyzOpfzvcpcm.jpg',
          cast_id: 16,
          character: 'Lana Thomas',
          credit_id: '52fe4540c3a36847f80c3a1d',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 1813,
          known_for_department: 'Diễn viên',
          name: 'Anne Hathaway',
          original_name: 'Anne Hathaway',
          popularity: 19.684,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tLelKoPNiyJCSEtQTz1FGv4TLGc.jpg',
          cast_id: 10,
          character: 'Amelia "Mia" Thermopolis',
          credit_id: '52fe4540c3a36847f80c3a09',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 6692,
          known_for_department: 'Diễn viên',
          name: 'Caroline Goodall',
          original_name: 'Caroline Goodall',
          popularity: 2.051,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4cagGtMqACvkuw6Llq8Li8UJ1AR.jpg',
          cast_id: 17,
          character: 'Helen Thermopolis',
          credit_id: '52fe4540c3a36847f80c3a21',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 17242,
          known_for_department: 'Diễn viên',
          name: 'Robert Schwartzman',
          original_name: 'Robert Schwartzman',
          popularity: 0.793,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aA0kVZY28PHOmCfWfDALS4oYZ6u.jpg',
          cast_id: 13,
          character: 'Michael Moscovitz',
          credit_id: '52fe4540c3a36847f80c3a11',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 12901,
          known_for_department: 'Diễn viên',
          name: 'Erik von Detten',
          original_name: 'Erik von Detten',
          popularity: 4.369,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7fHjKnLKmqzR0kmvRPLxpQE7BsK.jpg',
          cast_id: 18,
          character: 'Josh Bryant',
          credit_id: '52fe4540c3a36847f80c3a25',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 33836,
          known_for_department: 'Diễn viên',
          name: "Sean O'Bryan",
          original_name: "Sean O'Bryan",
          popularity: 2.713,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5CZMf2bRnV9o5kcylbtUPlSbI7P.jpg',
          cast_id: 24,
          character: "Patrick O'Connell",
          credit_id: '5620bf22c3a3680e1d007aab',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 25540,
          known_for_department: 'Diễn viên',
          name: 'Sandra Oh',
          original_name: 'Sandra Oh',
          popularity: 4.706,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zU8vjebHxcP60ESEL5Ok68KWZvj.jpg',
          cast_id: 19,
          character: 'Vice Principal Gupta',
          credit_id: '52fe4540c3a36847f80c3a29',
          order: 10,
        },
        {
          adult: false,
          gender: 1,
          id: 303542,
          known_for_department: 'Diễn viên',
          name: 'Kathleen Marshall',
          original_name: 'Kathleen Marshall',
          popularity: 1.052,
          profile_path: null,
          cast_id: 25,
          character: 'Charlotte Kutaway',
          credit_id: '5620bf4192514171d0007574',
          order: 11,
        },
        {
          adult: false,
          gender: 0,
          id: 75333,
          known_for_department: 'Diễn viên',
          name: 'Mindy Burbano',
          original_name: 'Mindy Burbano',
          popularity: 0.6,
          profile_path: null,
          cast_id: 26,
          character: 'Ms. Harbula',
          credit_id: '5620bf53c3a36868680022de',
          order: 12,
        },
        {
          adult: false,
          gender: 0,
          id: 1464357,
          known_for_department: 'Diễn viên',
          name: 'Kimleigh Smith',
          original_name: 'Kimleigh Smith',
          popularity: 0.84,
          profile_path: null,
          cast_id: 29,
          character: 'Ms. Wells',
          credit_id: '5620bf8692514171d0007590',
          order: 13,
        },
        {
          adult: false,
          gender: 1,
          id: 1523044,
          known_for_department: 'Diễn viên',
          name: 'Elizabeth Gudenrath',
          original_name: 'Elizabeth Gudenrath',
          popularity: 0.6,
          profile_path: null,
          cast_id: 28,
          character: 'Anna',
          credit_id: '5620bf7fc3a3680e16006dfb',
          order: 14,
        },
        {
          adult: false,
          gender: 1,
          id: 149213,
          known_for_department: 'Diễn viên',
          name: 'Bianca Lopez',
          original_name: 'Bianca Lopez',
          popularity: 1.292,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mfiMebY1XSnFEDplwN3aExUThEO.jpg',
          cast_id: 30,
          character: 'Fontana',
          credit_id: '562b3bbf925141284c004491',
          order: 15,
        },
        {
          adult: false,
          gender: 0,
          id: 568659,
          known_for_department: 'Diễn viên',
          name: 'Tamara Levinson',
          original_name: 'Tamara Levinson',
          popularity: 0.6,
          profile_path: null,
          cast_id: 34,
          character: 'Lupe',
          credit_id: '5829df37c3a368360103574a',
          order: 16,
        },
        {
          adult: false,
          gender: 1,
          id: 62737,
          known_for_department: 'Diễn viên',
          name: 'Lenore Thomas',
          original_name: 'Lenore Thomas',
          popularity: 0.98,
          profile_path: null,
          cast_id: 35,
          character: 'Melissa',
          credit_id: '5829dfe99251417b2c038f3b',
          order: 17,
        },
        {
          adult: false,
          gender: 0,
          id: 168249,
          known_for_department: 'Diễn viên',
          name: 'Erik Bragg',
          original_name: 'Erik Bragg',
          popularity: 1.179,
          profile_path: null,
          cast_id: 36,
          character: 'Bobby Bad',
          credit_id: '5829e02cc3a3682358002f01',
          order: 18,
        },
        {
          adult: false,
          gender: 0,
          id: 1708672,
          known_for_department: 'Diễn viên',
          name: 'Meredith Shevory',
          original_name: 'Meredith Shevory',
          popularity: 0.6,
          profile_path: null,
          cast_id: 37,
          character: 'Meredith',
          credit_id: '5829e0899251417b1803a30b',
          order: 19,
        },
        {
          adult: false,
          gender: 0,
          id: 1526177,
          known_for_department: 'Diễn viên',
          name: 'Anita Marie Curran',
          original_name: 'Anita Marie Curran',
          popularity: 0.6,
          profile_path: null,
          cast_id: 38,
          character: 'Anita',
          credit_id: '5829e1019251417b1a03a852',
          order: 20,
        },
        {
          adult: false,
          gender: 1,
          id: 1708675,
          known_for_department: 'Diễn viên',
          name: 'Cassie Rowell',
          original_name: 'Cassie Rowell',
          popularity: 0.6,
          profile_path: null,
          cast_id: 39,
          character: 'Alice',
          credit_id: '5829e19e9251417b1a03a8bf',
          order: 21,
        },
        {
          adult: false,
          gender: 2,
          id: 191277,
          known_for_department: 'Diễn viên',
          name: 'Todd Lowe',
          original_name: 'Todd Lowe',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4TAmLB4DGNZnAzYAskNZtVWMMPB.jpg',
          cast_id: 40,
          character: 'Eric',
          credit_id: '5829e3459251417b2603bca2',
          order: 22,
        },
        {
          adult: false,
          gender: 0,
          id: 1708678,
          known_for_department: 'Diễn viên',
          name: 'Joe Unitas',
          original_name: 'Joe Unitas',
          popularity: 0.6,
          profile_path: null,
          cast_id: 41,
          character: 'Coach Joe Ewe',
          credit_id: '5829e4149251417b23038912',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 12223,
          known_for_department: 'Diễn viên',
          name: 'Joel McCrary',
          original_name: 'Joel McCrary',
          popularity: 2.407,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2zFMn8HRSkjz1PwVrev9P3dm9if.jpg',
          cast_id: 42,
          character: 'Prime Minister Motaz',
          credit_id: '5829e551c3a3683601035bd2',
          order: 24,
        },
        {
          adult: false,
          gender: 1,
          id: 1274512,
          known_for_department: 'Biên kịch',
          name: 'Clare Sera',
          original_name: 'Clare Sera',
          popularity: 0.98,
          profile_path: null,
          cast_id: 43,
          character: 'Maria Motaz',
          credit_id: '5829e699c3a3683608035161',
          order: 25,
        },
        {
          adult: false,
          gender: 2,
          id: 33832,
          known_for_department: 'Diễn viên',
          name: 'Greg Lewis',
          original_name: 'Greg Lewis',
          popularity: 1.528,
          profile_path: null,
          cast_id: 32,
          character: 'Siegfried von Troken',
          credit_id: '56c0ad27c3a368180600bce8',
          order: 26,
        },
        {
          adult: false,
          gender: 1,
          id: 87287,
          known_for_department: 'Diễn viên',
          name: 'Bonnie Aarons',
          original_name: 'Bonnie Aarons',
          popularity: 5.062,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iEtWuoXKx4ZKbIWwJp1V76Heavy.jpg',
          cast_id: 44,
          character: 'Joy von Troken',
          credit_id: '5829e760c3a3683601035d28',
          order: 27,
        },
        {
          adult: false,
          gender: 0,
          id: 1708683,
          known_for_department: 'Diễn viên',
          name: 'Darwood Chung',
          original_name: 'Darwood Chung',
          popularity: 0.6,
          profile_path: null,
          cast_id: 45,
          character: 'Emperor Sakamoto',
          credit_id: '5829e7949251417b2c039531',
          order: 28,
        },
        {
          adult: false,
          gender: 1,
          id: 1708684,
          known_for_department: 'Diễn viên',
          name: 'Julie Paris',
          original_name: 'Julie Paris',
          popularity: 0.6,
          profile_path: null,
          cast_id: 46,
          character: 'Princess Palisades',
          credit_id: '5829e8409251417b1803a930',
          order: 29,
        },
        {
          adult: false,
          gender: 2,
          id: 1708688,
          known_for_department: 'Diễn viên',
          name: 'Jeff Michalski',
          original_name: 'Jeff Michalski',
          popularity: 1.312,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3PkPMrxFMQDnlJt2Zqjr543JXlt.jpg',
          cast_id: 47,
          character: 'Scottish Duke',
          credit_id: '5829e95bc3a368360803533b',
          order: 30,
        },
        {
          adult: false,
          gender: 0,
          id: 1708689,
          known_for_department: 'Diễn viên',
          name: "Erin O'Reilly",
          original_name: "Erin O'Reilly",
          popularity: 0.6,
          profile_path: null,
          cast_id: 48,
          character: 'Scottish Duchess',
          credit_id: '5829e9f8c3a368623f015d95',
          order: 31,
        },
        {
          adult: false,
          gender: 0,
          id: 549087,
          known_for_department: 'Diễn viên',
          name: 'Steve Restivo',
          original_name: 'Steve Restivo',
          popularity: 0.6,
          profile_path: null,
          cast_id: 49,
          character: 'Count Vitello',
          credit_id: '5829ebdbc3a368360b03e721',
          order: 32,
        },
        {
          adult: false,
          gender: 1,
          id: 1708713,
          known_for_department: 'Diễn viên',
          name: 'Brigitta Lauren',
          original_name: 'Brigitta Lauren',
          popularity: 0.6,
          profile_path: null,
          cast_id: 50,
          character: 'Lady Lindenlaub',
          credit_id: '5829f34f9251417b2103a0ea',
          order: 33,
        },
        {
          adult: false,
          gender: 1,
          id: 13451,
          known_for_department: 'Diễn viên',
          name: 'Jane Morris',
          original_name: 'Jane Morris',
          popularity: 1.642,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8rNS5qEl8ALKa5spSExpuIUA4vR.jpg',
          cast_id: 51,
          character: 'Lady Evergreen',
          credit_id: '5829f94d9251417b1d039db3',
          order: 34,
        },
        {
          adult: false,
          gender: 2,
          id: 999716,
          known_for_department: 'Crew',
          name: 'Gary Combs',
          original_name: 'Gary Combs',
          popularity: 0.6,
          profile_path: null,
          cast_id: 52,
          character: 'Lord Fricker',
          credit_id: '5829f9d29251417b1d039e04',
          order: 35,
        },
        {
          adult: false,
          gender: 2,
          id: 83056,
          known_for_department: 'Diễn viên',
          name: 'Marvin Braverman',
          original_name: 'Marvin Braverman',
          popularity: 0.6,
          profile_path: null,
          cast_id: 53,
          character: 'State Dinner Waiter',
          credit_id: '5829fad69251417b23039556',
          order: 36,
        },
        {
          adult: false,
          gender: 2,
          id: 1708724,
          known_for_department: 'Diễn viên',
          name: 'Allan Kent',
          original_name: 'Allan Kent',
          popularity: 0.6,
          profile_path: null,
          cast_id: 54,
          character: 'State Dinner Waiter',
          credit_id: '5829fb479251417b1d039eac',
          order: 37,
        },
        {
          adult: false,
          gender: 0,
          id: 140252,
          known_for_department: 'Diễn viên',
          name: 'Robert Glaudini',
          original_name: 'Robert Glaudini',
          popularity: 1.38,
          profile_path: null,
          cast_id: 55,
          character: 'Adolpho',
          credit_id: '582a1093c3a368360f03d74e',
          order: 38,
        },
        {
          adult: false,
          gender: 0,
          id: 101266,
          known_for_department: 'Diễn viên',
          name: 'Bill Ferrell',
          original_name: 'Bill Ferrell',
          popularity: 0.6,
          profile_path: null,
          cast_id: 56,
          character: 'Darrell',
          credit_id: '582a1201c3a368623f0172f3',
          order: 39,
        },
        {
          adult: false,
          gender: 2,
          id: 106056,
          known_for_department: 'Diễn viên',
          name: 'Joe Ross',
          original_name: 'Joe Ross',
          popularity: 0.6,
          profile_path: null,
          cast_id: 57,
          character: "Consulate Maitre D'",
          credit_id: '582a12a89251417b2303a17d',
          order: 40,
        },
        {
          adult: false,
          gender: 2,
          id: 177205,
          known_for_department: 'Diễn viên',
          name: 'Charles Guardino',
          original_name: 'Charles Guardino',
          popularity: 0.84,
          profile_path: null,
          cast_id: 58,
          character: 'Mel',
          credit_id: '582a137ec3a368360f03d90b',
          order: 41,
        },
        {
          adult: false,
          gender: 0,
          id: 1708777,
          known_for_department: 'Diễn viên',
          name: 'Sparrow Heatley',
          original_name: 'Sparrow Heatley',
          popularity: 0.6,
          profile_path: null,
          cast_id: 59,
          character: 'Gretchen',
          credit_id: '582a13b89251417b1a03c534',
          order: 42,
        },
        {
          adult: false,
          gender: 1,
          id: 1708778,
          known_for_department: 'Diễn viên',
          name: 'Gwenda Perez',
          original_name: 'Gwenda Perez',
          popularity: 0.6,
          profile_path: null,
          cast_id: 60,
          character: 'Helga',
          credit_id: '582a145f9251417b2c03ac54',
          order: 43,
        },
        {
          adult: false,
          gender: 1,
          id: 1424545,
          known_for_department: 'Crew',
          name: 'Barbara Marshall',
          original_name: 'Barbara Marshall',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/irxfgI3BafRwZTzYxnCz47ShvQf.jpg',
          cast_id: 61,
          character: 'Lady Jerome',
          credit_id: '582a1611c3a3683601037416',
          order: 44,
        },
        {
          adult: false,
          gender: 0,
          id: 1229463,
          known_for_department: 'Production',
          name: 'Sam Denoff',
          original_name: 'Sam Denoff',
          popularity: 0.6,
          profile_path: null,
          cast_id: 62,
          character: 'Lord Jerome',
          credit_id: '582a16f8c3a368360f03daca',
          order: 45,
        },
        {
          adult: false,
          gender: 1,
          id: 8189,
          known_for_department: 'Diễn viên',
          name: 'Tracy Reiner',
          original_name: 'Tracy Reiner',
          popularity: 0.673,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tfIh2dPe4tGITdlsPZXBNeqvZwW.jpg',
          cast_id: 63,
          character: 'Spencer',
          credit_id: '582a1735c3a368038102fa0f',
          order: 46,
        },
        {
          adult: false,
          gender: 0,
          id: 1708790,
          known_for_department: 'Diễn viên',
          name: 'Daru Kawalkowski',
          original_name: 'Daru Kawalkowski',
          popularity: 0.6,
          profile_path: null,
          cast_id: 64,
          character: 'Countess Puck',
          credit_id: '582a178cc3a368038102fa3c',
          order: 47,
        },
        {
          adult: false,
          gender: 1,
          id: 1708794,
          known_for_department: 'Diễn viên',
          name: 'Diane Frazen',
          original_name: 'Diane Frazen',
          popularity: 0.828,
          profile_path: null,
          cast_id: 65,
          character: 'Ball Guest Diane',
          credit_id: '582a1841c3a368360603e0f0',
          order: 48,
        },
        {
          adult: false,
          gender: 2,
          id: 32125,
          known_for_department: 'Editing',
          name: 'Stanley Frazen',
          original_name: 'Stanley Frazen',
          popularity: 0.6,
          profile_path: null,
          cast_id: 66,
          character: 'Stanley',
          credit_id: '582b07d89251417b2104291a',
          order: 49,
        },
        {
          adult: false,
          gender: 0,
          id: 1709144,
          known_for_department: 'Diễn viên',
          name: 'Barbara Nabozny',
          original_name: 'Barbara Nabozny',
          popularity: 0.6,
          profile_path: null,
          cast_id: 67,
          character: 'Barbara',
          credit_id: '582b088f9251417b2604535f',
          order: 50,
        },
        {
          adult: false,
          gender: 0,
          id: 1709148,
          known_for_department: 'Diễn viên',
          name: 'Ira Glick',
          original_name: 'Ira Glick',
          popularity: 0.6,
          profile_path: null,
          cast_id: 68,
          character: 'Dr. Glunk',
          credit_id: '582b0909c3a368360103e1d2',
          order: 51,
        },
        {
          adult: false,
          gender: 0,
          id: 1709149,
          known_for_department: 'Diễn viên',
          name: 'Sol Rosenthal',
          original_name: 'Sol Rosenthal',
          popularity: 0.6,
          profile_path: null,
          cast_id: 69,
          character: 'Lawyer Ball Guest',
          credit_id: '582b099c9251417b230417ce',
          order: 52,
        },
        {
          adult: false,
          gender: 1,
          id: 83053,
          known_for_department: 'Diễn viên',
          name: 'Hope Alexander-Willis',
          original_name: 'Hope Alexander-Willis',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/e3SRG8yhIHxC3KPq8KN30fz68jO.jpg',
          cast_id: 33,
          character: 'Lady Caroline',
          credit_id: '57dd99f6c3a368141f001814',
          order: 53,
        },
        {
          adult: false,
          gender: 0,
          id: 225804,
          known_for_department: 'Diễn viên',
          name: 'Joe Allen Price',
          original_name: 'Joe Allen Price',
          popularity: 0.6,
          profile_path: null,
          cast_id: 70,
          character: 'Father Joseph',
          credit_id: '582b0a12c3a368360803d605',
          order: 54,
        },
        {
          adult: false,
          gender: 0,
          id: 196286,
          known_for_department: 'Diễn viên',
          name: 'Willie Brown',
          original_name: 'Willie Brown',
          popularity: 0.6,
          profile_path: null,
          cast_id: 71,
          character: 'Himself',
          credit_id: '582b0ab7c3a368360803d675',
          order: 55,
        },
        {
          adult: false,
          gender: 2,
          id: 31471,
          known_for_department: 'Diễn viên',
          name: 'Patrick Richwood',
          original_name: 'Patrick Richwood',
          popularity: 2.644,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sSp6c5VrBfARdCLwbDBJvtAkePM.jpg',
          cast_id: 72,
          character: 'Mr. Robutusen',
          credit_id: '582b0c7d9251417b290434c2',
          order: 56,
        },
        {
          adult: false,
          gender: 0,
          id: 1709163,
          known_for_department: 'Diễn viên',
          name: 'Terry Brown',
          original_name: 'Terry Brown',
          popularity: 0.6,
          profile_path: null,
          cast_id: 73,
          character: 'Arthur Washington',
          credit_id: '582b0d239251417b180439c7',
          order: 57,
        },
        {
          adult: false,
          gender: 2,
          id: 1709164,
          known_for_department: 'Diễn viên',
          name: 'James Brown Orleans',
          original_name: 'James Brown Orleans',
          popularity: 0.6,
          profile_path: null,
          cast_id: 74,
          character: 'Dr. Motors',
          credit_id: '582b0d94c3a36836060460b6',
          order: 58,
        },
        {
          adult: false,
          gender: 0,
          id: 1709166,
          known_for_department: 'Diễn viên',
          name: 'Rob Zylowski',
          original_name: 'Rob Zylowski',
          popularity: 0.6,
          profile_path: null,
          cast_id: 75,
          character: 'Pizza Delivery Man',
          credit_id: '582b0e169251417b26045741',
          order: 59,
        },
        {
          adult: false,
          gender: 2,
          id: 1216158,
          known_for_department: 'Diễn viên',
          name: 'Karl Makinen',
          original_name: 'Karl Makinen',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kqiUJ9Mx5NsNnB9fsPl3ijeIYgp.jpg',
          cast_id: 76,
          character: 'Schiavone',
          credit_id: '582b0e94c3a368623f01f386',
          order: 60,
        },
        {
          adult: false,
          gender: 0,
          id: 1542807,
          known_for_department: 'Diễn viên',
          name: 'Sunny Hawks',
          original_name: 'Sunny Hawks',
          popularity: 0.828,
          profile_path: null,
          cast_id: 77,
          character: 'Vivian',
          credit_id: '582b0ed5c3a368623f01f3b7',
          order: 61,
        },
        {
          adult: false,
          gender: 1,
          id: 1214463,
          known_for_department: 'Diễn viên',
          name: 'Kathy Garver',
          original_name: 'Kathy Garver',
          popularity: 0.6,
          profile_path: null,
          cast_id: 78,
          character: 'Cable Tourist',
          credit_id: '582b0f1c9251417b1d042412',
          order: 62,
        },
        {
          adult: false,
          gender: 0,
          id: 222719,
          known_for_department: 'Diễn viên',
          name: 'Erika Young',
          original_name: 'Erika Young',
          popularity: 0.6,
          profile_path: null,
          cast_id: 79,
          character: 'Umbrella Lady',
          credit_id: '582b0f9f9251417b21042dd4',
          order: 63,
        },
        {
          adult: false,
          gender: 2,
          id: 166654,
          known_for_department: 'Diễn viên',
          name: 'Ethan Sandler',
          original_name: 'Ethan Sandler',
          popularity: 0.6,
          profile_path: null,
          cast_id: 80,
          character: 'Tour Bus Driver',
          credit_id: '582b0fe29251417b21042df6',
          order: 64,
        },
        {
          adult: false,
          gender: 0,
          id: 159940,
          known_for_department: 'Diễn viên',
          name: 'Shan Elliot',
          original_name: 'Shan Elliot',
          popularity: 0.6,
          profile_path: null,
          cast_id: 81,
          character: "Michael's Bandmate",
          credit_id: '582b117cc3a368360f04597a',
          order: 65,
        },
        {
          adult: false,
          gender: 0,
          id: 1660185,
          known_for_department: 'Diễn viên',
          name: 'Trey Carter',
          original_name: 'Trey Carter',
          popularity: 0.972,
          profile_path: null,
          cast_id: 82,
          character: "Michael's Bandmate",
          credit_id: '582b12449251417b1d0425e1',
          order: 66,
        },
        {
          adult: false,
          gender: 0,
          id: 1709176,
          known_for_department: 'Diễn viên',
          name: 'Bud Markowitz',
          original_name: 'Bud Markowitz',
          popularity: 0.608,
          profile_path: null,
          cast_id: 83,
          character: 'Pear Juggler',
          credit_id: '582b127e9251417b29043828',
          order: 67,
        },
        {
          adult: false,
          gender: 2,
          id: 1215608,
          known_for_department: 'Diễn viên',
          name: 'Mark Thompson',
          original_name: 'Mark Thompson',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uQLEE9AzJsZcZcdzgTbNiTUWFWw.jpg',
          cast_id: 84,
          character: 'DJ Mark',
          credit_id: '582b1bd3c3a368360f045f4a',
          order: 68,
        },
        {
          adult: false,
          gender: 2,
          id: 1229767,
          known_for_department: 'Diễn viên',
          name: 'Brian Phelps',
          original_name: 'Brian Phelps',
          popularity: 0.6,
          profile_path: null,
          cast_id: 86,
          character: 'DJ Brian',
          credit_id: '582b1d74c3a368623f01fc26',
          order: 69,
        },
        {
          adult: false,
          gender: 1,
          id: 1709182,
          known_for_department: 'Diễn viên',
          name: 'Lily Marshall-Fricker',
          original_name: 'Lily Marshall-Fricker',
          popularity: 0.6,
          profile_path: null,
          cast_id: 85,
          character: 'Kid Autograph Seeker',
          credit_id: '582b1c329251417b23042216',
          order: 70,
        },
        {
          adult: false,
          gender: 1,
          id: 32291,
          known_for_department: 'Diễn viên',
          name: 'Sandra Taylor',
          original_name: 'Sandra Taylor',
          popularity: 2.716,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8NHNTDoOEkL0JaTrN9uq6T6J3Fk.jpg',
          cast_id: 88,
          character: 'Suki Sanchez',
          credit_id: '582b30cfc3a3683606047655',
          order: 71,
        },
        {
          adult: false,
          gender: 2,
          id: 210311,
          known_for_department: 'Diễn viên',
          name: 'Tom Hines',
          original_name: 'Tom Hines',
          popularity: 1.4,
          profile_path: null,
          cast_id: 89,
          character: 'Nelson Davenport',
          credit_id: '582b3225c3a368235800d3b1',
          order: 72,
        },
        {
          adult: false,
          gender: 1,
          id: 35241,
          known_for_department: 'Diễn viên',
          name: 'Nicholle Tom',
          original_name: 'Nicholle Tom',
          popularity: 5.249,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cjFw8BrIpptxMJrDkEWEE25E8bi.jpg',
          cast_id: 90,
          character: 'Cassie',
          credit_id: '582b341092514166af000912',
          order: 73,
        },
        {
          adult: false,
          gender: 0,
          id: 1709197,
          known_for_department: 'Diễn viên',
          name: 'Patrick Noonan',
          original_name: 'Patrick Noonan',
          popularity: 0.6,
          profile_path: null,
          cast_id: 91,
          character: "Suki's Cameraman",
          credit_id: '582b352d9251417b180451a8',
          order: 74,
        },
        {
          adult: false,
          gender: 0,
          id: 552470,
          known_for_department: 'Diễn viên',
          name: 'Ali Gage',
          original_name: 'Ali Gage',
          popularity: 0.6,
          profile_path: null,
          cast_id: 92,
          character: 'Beach Reporter Ali',
          credit_id: '582b3ad59251417b2604712b',
          order: 75,
        },
        {
          adult: false,
          gender: 0,
          id: 101072,
          known_for_department: 'Diễn viên',
          name: 'John Moran',
          original_name: 'John Moran',
          popularity: 0.6,
          profile_path: null,
          cast_id: 93,
          character: 'Beach Photographer',
          credit_id: '582b3b8e9251417b26047198',
          order: 76,
        },
        {
          adult: false,
          gender: 0,
          id: 1709208,
          known_for_department: 'Diễn viên',
          name: 'Tanya DiFrancesco',
          original_name: 'Tanya DiFrancesco',
          popularity: 0.764,
          profile_path: null,
          cast_id: 94,
          character: 'Beach Reporter',
          credit_id: '582b3c34c3a368360103fbe2',
          order: 77,
        },
        {
          adult: false,
          gender: 1,
          id: 95469,
          known_for_department: 'Diễn viên',
          name: 'Shannon Wilcox',
          original_name: 'Shannon Wilcox',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4GPHCEcw02i2QN94EGfRIu04ymV.jpg',
          cast_id: 31,
          character: 'Ball Reporter',
          credit_id: '56b67f90c3a368481600470c',
          order: 78,
        },
        {
          adult: false,
          gender: 0,
          id: 1709209,
          known_for_department: 'Diễn viên',
          name: 'Tonje Larsgard',
          original_name: 'Tonje Larsgard',
          popularity: 0.6,
          profile_path: null,
          cast_id: 95,
          character: 'Ball Reporter',
          credit_id: '582b3d119251417b290450f1',
          order: 79,
        },
        {
          adult: false,
          gender: 0,
          id: 175588,
          known_for_department: 'Diễn viên',
          name: 'Rueben Grundy',
          original_name: 'Rueben Grundy',
          popularity: 0.972,
          profile_path: null,
          cast_id: 96,
          character: 'Street Reporter',
          credit_id: '582b3e7e92514166af000efd',
          order: 80,
        },
        {
          adult: false,
          gender: 1,
          id: 79075,
          known_for_department: 'Diễn viên',
          name: 'Gwen Holloway',
          original_name: 'Gwen Holloway',
          popularity: 1.215,
          profile_path: null,
          cast_id: 97,
          character: 'Street Reporter',
          credit_id: '582b3f589251417b18045722',
          order: 81,
        },
        {
          adult: false,
          gender: 1,
          id: 1709210,
          known_for_department: 'Diễn viên',
          name: 'Lori Sigrist',
          original_name: 'Lori Sigrist',
          popularity: 0.608,
          profile_path: null,
          cast_id: 98,
          character: 'Twin Reporter',
          credit_id: '582b3f9ac3a3683606047f67',
          order: 82,
        },
        {
          adult: false,
          gender: 1,
          id: 1709211,
          known_for_department: 'Diễn viên',
          name: 'Terri Sigrist',
          original_name: 'Terri Sigrist',
          popularity: 0.694,
          profile_path: null,
          cast_id: 99,
          character: 'Twin Reporter',
          credit_id: '582b3fefc3a368235800daf6',
          order: 83,
        },
        {
          adult: false,
          gender: 2,
          id: 928579,
          known_for_department: 'Diễn viên',
          name: 'Andy Arness',
          original_name: 'Andy Arness',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4QoytkR9sdqQ9H4r0PiFdvXkTm9.jpg',
          cast_id: 100,
          character: 'Teacher (uncredited)',
          credit_id: '5b5392259251411f7c01621e',
          order: 84,
        },
        {
          adult: false,
          gender: 2,
          id: 9807,
          known_for_department: 'Diễn viên',
          name: 'René Auberjonois',
          original_name: 'René Auberjonois',
          popularity: 4.024,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1EZ6FnJGzwRl7XndkX8fBo8Tej3.jpg',
          cast_id: 101,
          character: 'Philippe Renaldi (uncredited)',
          credit_id: '5b53924d0e0a2623140179f3',
          order: 85,
        },
        {
          adult: false,
          gender: 0,
          id: 80224,
          known_for_department: 'Diễn viên',
          name: 'Ned Brower',
          original_name: 'Ned Brower',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gJASkbpnZZEPzbztyZQarP7bqi7.jpg',
          cast_id: 102,
          character: "Michael's Bandmate (uncredited)",
          credit_id: '5b53926bc3a3680b5901bd7f',
          order: 86,
        },
        {
          adult: false,
          gender: 1,
          id: 1786598,
          known_for_department: 'Diễn viên',
          name: 'Jodi Essex',
          original_name: 'Jodi Essex',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kdVw2AFsYe2zRUTQpUw0v3ZzENp.jpg',
          cast_id: 103,
          character: 'Model (uncredited)',
          credit_id: '5b53927ec3a3680b6601a9c4',
          order: 87,
        },
        {
          adult: false,
          gender: 2,
          id: 1211,
          known_for_department: 'Diễn viên',
          name: 'Larry Miller',
          original_name: 'Larry Miller',
          popularity: 4.362,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ajnXlXG20LJwAwxne8G94ucVj0v.jpg',
          cast_id: 104,
          character: 'Paolo (uncredited)',
          credit_id: '5b5392c50e0a26231f017fa2',
          order: 88,
        },
        {
          adult: false,
          gender: 2,
          id: 84792,
          known_for_department: 'Diễn viên',
          name: 'Barry J. Ratcliffe',
          original_name: 'Barry J. Ratcliffe',
          popularity: 1.192,
          profile_path:
            'https://image.tmdb.org/t/p/w185/btQlqpvKhNe0TvOVGGO8sSfbKxU.jpg',
          cast_id: 105,
          character: 'Cop #2 (uncredited)',
          credit_id: '5b5392e79251411f8a016dd0',
          order: 89,
        },
        {
          adult: false,
          gender: 2,
          id: 932287,
          known_for_department: 'Diễn viên',
          name: 'Craig Richards',
          original_name: 'Craig Richards',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7xMTA69DhIA7es4eIX82sfLebrv.jpg',
          cast_id: 106,
          character: "Student's Father (uncredited)",
          credit_id: '5b53930ac3a3680b5f015005',
          order: 90,
        },
        {
          adult: false,
          gender: 0,
          id: 1300519,
          known_for_department: 'Diễn viên',
          name: 'Terry Wayne',
          original_name: 'Terry Wayne',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5HjCgXE7TiKg1H61I1QCnVgM1Kr.jpg',
          cast_id: 107,
          character: 'Clark (uncredited)',
          credit_id: '5b53934b0e0a262327018b74',
          order: 91,
        },
        {
          adult: false,
          gender: 1,
          id: 2972882,
          known_for_department: 'Diễn viên',
          name: 'Charlotte Marshall-Fricker',
          original_name: 'Charlotte Marshall-Fricker',
          popularity: 0.6,
          profile_path: null,
          cast_id: 127,
          character: 'Kid Autograph Seeker',
          credit_id: '6024943adcf875003e37230b',
          order: 92,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 11423,
          known_for_department: 'Art',
          name: 'Mayne Berke',
          original_name: 'Mayne Berke',
          popularity: 0.6,
          profile_path: null,
          credit_id: '55783958c3a36842ee00177f',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 2,
          id: 1201,
          known_for_department: 'Diễn viên',
          name: 'Garry Marshall',
          original_name: 'Garry Marshall',
          popularity: 2.524,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ergjvb7J3UnbBnX1f7GvFVZSaci.jpg',
          credit_id: '52fe4540c3a36847f80c39d5',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 4500,
          known_for_department: 'Sound',
          name: 'John Debney',
          original_name: 'John Debney',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iUwBpunUEdknzkRpgAyodwIEh4n.jpg',
          credit_id: '557834559251413d32001934',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 8677,
          known_for_department: 'Camera',
          name: 'Karl Walter Lindenlaub',
          original_name: 'Karl Walter Lindenlaub',
          popularity: 0.994,
          profile_path: null,
          credit_id: '52fe4540c3a36847f80c39ff',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 1,
          id: 8851,
          known_for_department: 'Diễn viên',
          name: 'Whitney Houston',
          original_name: 'Whitney Houston',
          popularity: 1.171,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5su69sRCQReFTS94j2OtcgIQLne.jpg',
          credit_id: '52fe4540c3a36847f80c39ed',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 8870,
          known_for_department: 'Costume & Make-Up',
          name: 'Leonard Engelman',
          original_name: 'Leonard Engelman',
          popularity: 0.766,
          profile_path: null,
          credit_id: '5f28dc18869e7500375c83d0',
          department: 'Costume & Make-Up',
          job: 'Assistant Makeup Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 12970,
          known_for_department: 'Editing',
          name: 'Bruce Green',
          original_name: 'Bruce Green',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4540c3a36847f80c3a05',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 38415,
          known_for_department: 'Production',
          name: 'Mario Iscovich',
          original_name: 'Mario Iscovich',
          popularity: 0.828,
          profile_path: null,
          credit_id: '52fe4540c3a36847f80c39e7',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 38416,
          known_for_department: 'Production',
          name: 'Ellen H. Schwartz',
          original_name: 'Ellen H. Schwartz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f28d1c63e09f300381debd1',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 38416,
          known_for_department: 'Production',
          name: 'Ellen H. Schwartz',
          original_name: 'Ellen H. Schwartz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f28db5f9f37b0003425038b',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 1,
          id: 51557,
          known_for_department: 'Production',
          name: 'Marcia Ross',
          original_name: 'Marcia Ross',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f28d0f33e09f300371ccba6',
          department: 'Production',
          job: 'Casting Director',
        },
        {
          adult: false,
          gender: 1,
          id: 59973,
          known_for_department: 'Production',
          name: 'Debra Martin Chase',
          original_name: 'Debra Martin Chase',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lBxCPxKW5Rh5V5SGVqKDjs7L7rH.jpg',
          credit_id: '52fe4540c3a36847f80c39f3',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 59971,
          known_for_department: 'Biên kịch',
          name: 'Meg Cabot',
          original_name: 'Meg Cabot',
          popularity: 0.98,
          profile_path: null,
          credit_id: '557834ee9251413d760017e3',
          department: 'Biên kịch',
          job: 'Novel',
        },
        {
          adult: false,
          gender: 1,
          id: 59972,
          known_for_department: 'Biên kịch',
          name: 'Gina Wendkos',
          original_name: 'Gina Wendkos',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4540c3a36847f80c39e1',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 1,
          id: 63672,
          known_for_department: 'Production',
          name: 'Gail Goldberg',
          original_name: 'Gail Goldberg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f28d10d3e09f300381de9c2',
          department: 'Production',
          job: 'Casting Director',
        },
        {
          adult: false,
          gender: 0,
          id: 11063,
          known_for_department: 'Art',
          name: 'Casey Hallenbeck',
          original_name: 'Casey Hallenbeck',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f28dbe14e674200347818a5',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 83066,
          known_for_department: 'Costume & Make-Up',
          name: "Carol A. O'Connell",
          original_name: "Carol A. O'Connell",
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f28dc229f37b0003425045b',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 2,
          id: 83070,
          known_for_department: 'Diễn viên',
          name: 'Scott Marshall',
          original_name: 'Scott Marshall',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5Vwgp604S7x3Npes4iCuKrm8EZ6.jpg',
          credit_id: '5f28dbb09f37b00033271d33',
          department: 'Directing',
          job: 'Second Unit Director',
        },
        {
          adult: false,
          gender: 0,
          id: 110645,
          known_for_department: 'Production',
          name: 'Heidi Klein',
          original_name: 'Heidi Klein',
          popularity: 0.656,
          profile_path: null,
          credit_id: '5f28d1a33e09f300381deb22',
          department: 'Production',
          job: 'Additional Casting',
        },
        {
          adult: false,
          gender: 1,
          id: 137175,
          known_for_department: 'Art',
          name: 'Caty Maxey',
          original_name: 'Caty Maxey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f28dbd72d8ef30038dfd652',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 543194,
          known_for_department: 'Costume & Make-Up',
          name: 'Gary Jones',
          original_name: 'Gary Jones',
          popularity: 0.728,
          profile_path: null,
          credit_id: '5f28d20d2d8ef30038dfb262',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 1,
          id: 1096443,
          known_for_department: 'Production',
          name: 'Donna Morong',
          original_name: 'Donna Morong',
          popularity: 0.996,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hB7SmMZqWTUofv1JnGQAGBrS4J4.jpg',
          credit_id: '5f28d106b1f68d00386b46be',
          department: 'Production',
          job: 'Casting Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1106751,
          known_for_department: 'Production',
          name: 'Tommy Harper',
          original_name: 'Tommy Harper',
          popularity: 1.132,
          profile_path: null,
          credit_id: '5f28db742d8ef30036dc9176',
          department: 'Directing',
          job: 'Second Assistant Director',
        },
        {
          adult: false,
          gender: 1,
          id: 1327149,
          known_for_department: 'Costume & Make-Up',
          name: "Hallie D'Amore",
          original_name: "Hallie D'Amore",
          popularity: 1.024,
          profile_path: null,
          credit_id: '5f28dc094e6742003278e221',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 1,
          id: 1402016,
          known_for_department: 'Costume & Make-Up',
          name: 'Carolyn Elias',
          original_name: 'Carolyn Elias',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f28dc33a35c8e0036508bb8',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1417398,
          known_for_department: 'Costume & Make-Up',
          name: 'Janice Alexander',
          original_name: 'Janice Alexander',
          popularity: 1.286,
          profile_path: null,
          credit_id: '5f28dc414e67420033794d75',
          department: 'Costume & Make-Up',
          job: 'Assistant Hairstylist',
        },
        {
          adult: false,
          gender: 1,
          id: 1545949,
          known_for_department: 'Production',
          name: 'Margaret Hilliard',
          original_name: 'Margaret Hilliard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f28db47d8cc4a00381b07b0',
          department: 'Production',
          job: 'Unit Production Manager',
        },
        {
          adult: false,
          gender: 1,
          id: 1556310,
          known_for_department: 'Sound',
          name: 'Dawn Soler',
          original_name: 'Dawn Soler',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f28d1e22d8ef3791fd45966',
          department: 'Sound',
          job: 'Music Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2036592,
          known_for_department: 'Production',
          name: 'Robin Klein',
          original_name: 'Robin Klein',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f28d190b1f68d00376cb53c',
          department: 'Production',
          job: 'Additional Casting',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'Kamurai',
          author_details: {
            name: 'Kamurai',
            username: 'Kamurai',
            avatar_path: '/sKeC7qZLAKreuwxH4x6U3mN7Aa8.jpg',
            rating: 6.0,
          },
          content:
            'Good watch, would watch again, and can recommend.\r\n\r\nThis feels like a trope, but I\'m honestly not sure if "surprise, you\'re royal" is a trope.  Making up a country for this also feels like a special sub-trope.\r\n\r\nWhat I\'m sure is a trope is the "She\'s All That" where you have a clumsy, homely girl that you turn into a beautiful, graceful desirable.\r\n\r\nThe fun of cultures clashing between America and "Genovia" is fun, and a family reuniting is touching, but all the high school girl drama, all the flavors, is overdone and boring.  I understand it is needed to develop Mia as a character with which we empathize, but there have to be better ways to establish a character.  Unfortunately, we would lose quite a lot by speeding it up, so I get it.\r\n\r\nWhile this movie doesn\'t do much special, it\'s equally good from start to finish, and reliably so.',
          created_at: '2020-08-06T00:25:10.909Z',
          id: '5f2b4de6a698cf0031565734',
          updated_at: '2021-06-23T15:58:42.088Z',
          url: 'https://www.themoviedb.org/review/5f2b4de6a698cf0031565734',
        },
        {
          author: 'r96sk',
          author_details: {
            name: '',
            username: 'r96sk',
            avatar_path:
              '/https://secure.gravatar.com/avatar/96c2e0e4ac98450f9e8e3c0a0a40aad8.jpg',
            rating: 7.0,
          },
          content:
            "It goes on for a bit too long, but <em>'The Princess Diaries'</em> is just about a good film.\r\n\r\nAnne Hathaway (Mia) is the star no doubt, she's the only character I'll likely remember from this 2001 production. Julie Andrews (Clarisse) is decent too, while Héctor Elizondo (Joe) is extremely likeable in his role. There's also a (incredibly) small appearance from <em>'The Walking Dead'</em> alum Karl Makinen.\r\n\r\nI found the plot a little tedious to watch in parts, not helped by a few cringey gags. I also, in live-action/non-fantasy films, always find it difficult to believe in fictional places - in this case \"Genovia\". It's a small gripe of mine. Anyway, I do of course appreciate and rate the overall message of the film.\r\n\r\nOverall, when all is said and done, I did narrowly enjoy watching this. The main reason being Hathaway, but also the moral of the story.",
          created_at: '2020-10-12T23:49:25.125Z',
          id: '5f84eb8525b955003629f243',
          updated_at: '2021-06-23T15:58:46.019Z',
          url: 'https://www.themoviedb.org/review/5f84eb8525b955003629f243',
        },
      ],
      total_pages: 1,
      total_results: 2,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/uMDrlSv4QFsRhb3K5VWHWP7ykZO.jpg',
    belongs_to_collection: {
      id: 315595,
      name: 'Tinker Bell Collection',
      poster_path: '/wzt5eeX5YeJ4CLi165id4dKEgfW.jpg',
      backdrop_path: '/8wvxr06XNW2zofbOHQqEgokTmLx.jpg',
    },
    budget: 48000000,
    genres: [
      { id: 16, name: 'Phim Hoạt Hình' },
      { id: 10751, name: 'Phim Gia Đình' },
      { id: 12, name: 'Phim Phiêu Lưu' },
      { id: 14, name: 'Phim Giả Tượng' },
    ],
    homepage: 'http://disney.go.com/fairies/movies/about.html',
    id: 13179,
    imdb_id: 'tt0823671',
    original_language: 'en',
    original_title: 'Tinker Bell',
    overview:
      'Đã có bao giờ bạn tự hỏi vẻ đẹp của thiên nhiên là có từ đâu? Ai đã mang đến những tia nắng cũng như những sắc màu rực rỡ khi mùa xuân đến và đi? Hãy ghé thăm vùng đất phiêu lưu và huyền bí Pixie Hollow, nơi mà Tinker Bell và 4 người bạn thân của cô cùng nhau đem mùa xuân ấm áp đến thay cho mùa đông giá lạnh bằng sức mạnh của niềm tin và hi vọng cùng với một chút những phép màu huyền diệu, nhận ra được sự quan trọng khi là chính mình trong cuộc sống',
    popularity: 30.893,
    poster_path:
      'https://image.tmdb.org/t/p/w342/3Ma0r1n8kfH7UaQMS7bJ9KsYUjT.jpg',
    production_companies: [
      {
        id: 5391,
        logo_path: '/o5AcK10ViutenSa4XTD18ClCEWe.png',
        name: 'DisneyToon Studios',
        origin_country: 'US',
      },
      {
        id: 22135,
        logo_path: null,
        name: 'Prana Animation Studios',
        origin_country: '',
      },
    ],
    production_countries: [
      { iso_3166_1: 'IN', name: 'India' },
      { iso_3166_1: 'US', name: 'Hoa Kì' },
    ],
    release_date: '2008-09-11',
    revenue: 0,
    runtime: 78,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'Enter the world of fairies',
    title: 'Nàng Tiên Tinker Bell',
    video: false,
    vote_average: 6.8,
    vote_count: 1068,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Tinker Bell (2008) Trailer',
          key: '2HMbcoV25ss',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: false,
          published_at: '2020-12-21T23:55:19.000Z',
          id: '5fe140a80c3ec8003e2ddba8',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Tinker Bell (2008) Teaser',
          key: 'ns-VcMJiZtQ',
          site: 'YouTube',
          size: 1080,
          type: 'Teaser',
          official: false,
          published_at: '2020-12-21T23:52:42.000Z',
          id: '5fe140bbf3b49a003e8ee0bf',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Tinker Bell trailer (HQ)',
          key: 'g0CTqqTkXH8',
          published_at: '2008-10-01T23:14:50.000Z',
          site: 'YouTube',
          size: 360,
          type: 'Trailer',
          official: false,
          id: '533ec674c3a3685448002416',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 52404,
          known_for_department: 'Diễn viên',
          name: 'Mae Whitman',
          original_name: 'Mae Whitman',
          popularity: 6.421,
          profile_path:
            'https://image.tmdb.org/t/p/w185/x0DdzjoYN8K2PwjrnH3ogPYv2zo.jpg',
          cast_id: 1,
          character: 'Tinker Bell (voice)',
          credit_id: '52fe45499251416c75051655',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 52775,
          known_for_department: 'Diễn viên',
          name: 'Kristin Chenoweth',
          original_name: 'Kristin Chenoweth',
          popularity: 6.951,
          profile_path:
            'https://image.tmdb.org/t/p/w185/q3ENDu5n23FARhyij4FVRaTkSg4.jpg',
          cast_id: 2,
          character: 'Rosetta (voice)',
          credit_id: '52fe45499251416c75051659',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 66896,
          known_for_department: 'Diễn viên',
          name: 'Raven-Symoné',
          original_name: 'Raven-Symoné',
          popularity: 2.705,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iyz6AbVgumSMsgZeSfsWpr4vewB.jpg',
          cast_id: 3,
          character: 'Iridessa (voice)',
          credit_id: '52fe45499251416c7505165d',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 140,
          known_for_department: 'Diễn viên',
          name: 'Lucy Liu',
          original_name: 'Lucy Liu',
          popularity: 12.515,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9nbtjqsx3De7hO2XDtrBQ7M9VCH.jpg',
          cast_id: 4,
          character: 'Silvermist (voice)',
          credit_id: '52fe45499251416c75051661',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 59174,
          known_for_department: 'Diễn viên',
          name: 'America Ferrera',
          original_name: 'America Ferrera',
          popularity: 3.955,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7F84Lh2lKpvkM3EiOvqqvlOmw93.jpg',
          cast_id: 5,
          character: 'Fawn (voice)',
          credit_id: '52fe45499251416c75051665',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 34902,
          known_for_department: 'Diễn viên',
          name: 'Jane Horrocks',
          original_name: 'Jane Horrocks',
          popularity: 2.647,
          profile_path:
            'https://image.tmdb.org/t/p/w185/phYKQdBZgRwMT8w6ZEhvGc8zgvB.jpg',
          cast_id: 6,
          character: 'Fairy Mary (voice)',
          credit_id: '52fe45499251416c75051669',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 49915,
          known_for_department: 'Diễn viên',
          name: 'Jesse McCartney',
          original_name: 'Jesse McCartney',
          popularity: 1.346,
          profile_path:
            'https://image.tmdb.org/t/p/w185/95f7jVXUwkHUUfj3AjvTJYx3pei.jpg',
          cast_id: 7,
          character: 'Terence (voice)',
          credit_id: '52fe45499251416c7505166d',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 43125,
          known_for_department: 'Diễn viên',
          name: 'Rob Paulsen',
          original_name: 'Rob Paulsen',
          popularity: 4.683,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7buvKWIjPlspqruaO3b28V5owJr.jpg',
          cast_id: 21,
          character: 'Bobble (voice)',
          credit_id: '52fe454a9251416c7505169d',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 34982,
          known_for_department: 'Diễn viên',
          name: 'Jeff Bennett',
          original_name: 'Jeff Bennett',
          popularity: 5.129,
          profile_path:
            'https://image.tmdb.org/t/p/w185/p78svoOr99IA2oBOUzAH9cnPOwf.jpg',
          cast_id: 8,
          character: 'Clank (voice)',
          credit_id: '52fe45499251416c75051671',
          order: 8,
        },
        {
          adult: false,
          gender: 1,
          id: 21063,
          known_for_department: 'Diễn viên',
          name: 'Pamela Adlon',
          original_name: 'Pamela Adlon',
          popularity: 5.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/e541ePtwZuHYP3zT0ANmpqUDFlw.jpg',
          cast_id: 10,
          character: 'Vidia (voice)',
          credit_id: '52fe45499251416c75051675',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 5657,
          known_for_department: 'Diễn viên',
          name: 'Anjelica Huston',
          original_name: 'Anjelica Huston',
          popularity: 4.515,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6hnYeHa7Rc1w1MmQ3JsLSIb7yCX.jpg',
          cast_id: 11,
          character: 'Queen Clarion (voice)',
          credit_id: '52fe45499251416c75051679',
          order: 10,
        },
        {
          adult: false,
          gender: 1,
          id: 78310,
          known_for_department: 'Diễn viên',
          name: 'Loreena McKennitt',
          original_name: 'Loreena McKennitt',
          popularity: 1.054,
          profile_path:
            'https://image.tmdb.org/t/p/w185/23sMvcEeYLnKVHiUJhKD5818lPO.jpg',
          cast_id: 12,
          character: 'Narrator',
          credit_id: '52fe45499251416c7505167d',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 78311,
          known_for_department: 'Diễn viên',
          name: 'Steve Valentine',
          original_name: 'Steve Valentine',
          popularity: 1.625,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sH1oZYtiiG9c5NNfnn5ZH8GkIpB.jpg',
          cast_id: 13,
          character: 'Minister of Spring (voice)',
          credit_id: '52fe45499251416c75051681',
          order: 12,
        },
        {
          adult: false,
          gender: 1,
          id: 11074,
          known_for_department: 'Diễn viên',
          name: 'Kathy Najimy',
          original_name: 'Kathy Najimy',
          popularity: 8.959,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nqbZF7Igr0SC8Xq8y0jwmx0mLDN.jpg',
          cast_id: 14,
          character: 'Minister of Summer (voice)',
          credit_id: '52fe45499251416c75051685',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 4255,
          known_for_department: 'Diễn viên',
          name: 'Richard Portnow',
          original_name: 'Richard Portnow',
          popularity: 1.898,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uQZ3vSa2HHXywkDjGY8dN0oH5oY.jpg',
          cast_id: 15,
          character: 'Minister of Autumn (voice)',
          credit_id: '52fe454a9251416c75051689',
          order: 14,
        },
        {
          adult: false,
          gender: 1,
          id: 78312,
          known_for_department: 'Diễn viên',
          name: 'Gail Borges',
          original_name: 'Gail Borges',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qgmvr9WvXsevUILTXHgjRH6R5a3.jpg',
          cast_id: 16,
          character: 'Minister of Winter (voice)',
          credit_id: '52fe454a9251416c7505168d',
          order: 15,
        },
        {
          adult: false,
          gender: 1,
          id: 63333,
          known_for_department: 'Diễn viên',
          name: 'America Young',
          original_name: 'America Young',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xK63OkSPzYqNS9GwoMpg8oUqYZr.jpg',
          cast_id: 17,
          character: 'Wendy (voice)',
          credit_id: '52fe454a9251416c75051691',
          order: 16,
        },
        {
          adult: false,
          gender: 1,
          id: 78315,
          known_for_department: 'Diễn viên',
          name: 'Kathryn Cressida',
          original_name: 'Kathryn Cressida',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mjDMZHcql1s2fnh6JLh3gfYh3cZ.jpg',
          cast_id: 18,
          character: 'Mrs. Darling (voice)',
          credit_id: '52fe454a9251416c75051695',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 78317,
          known_for_department: 'Diễn viên',
          name: 'Bob Bergen',
          original_name: 'Bob Bergen',
          popularity: 1.265,
          profile_path:
            'https://image.tmdb.org/t/p/w185/soDD1xiV3zVQWOJzVdJwfgIqzfe.jpg',
          cast_id: 20,
          character: 'Fireflies (voice)',
          credit_id: '52fe454a9251416c75051699',
          order: 18,
        },
        {
          adult: false,
          gender: 0,
          id: 1096776,
          known_for_department: 'Diễn viên',
          name: 'Christian Traeumer',
          original_name: 'Christian Traeumer',
          popularity: 0.6,
          profile_path: null,
          cast_id: 65,
          character: '(Voice) (uncredited)',
          credit_id: '5dbeec19f1b5710010e6af8b',
          order: 19,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 7879,
          known_for_department: 'Production',
          name: 'John Lasseter',
          original_name: 'John Lasseter',
          popularity: 2.341,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9EhRbLz6iLjpel7oAMX2Eoqlwht.jpg',
          credit_id: '52fe454a9251416c750516bb',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 13223,
          known_for_department: 'Editing',
          name: 'Jim Passon',
          original_name: 'Jim Passon',
          popularity: 1.052,
          profile_path: null,
          credit_id: '577a1fb1c3a3685ed200057f',
          department: 'Editing',
          job: 'Color Timer',
        },
        {
          adult: false,
          gender: 2,
          id: 14687,
          known_for_department: 'Biên kịch',
          name: 'J.M. Barrie',
          original_name: 'J.M. Barrie',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gbApVvWseqj1JSAA3KHWUBiNqgM.jpg',
          credit_id: '577a213a9251413c730013eb',
          department: 'Biên kịch',
          job: 'Characters',
        },
        {
          adult: false,
          gender: 2,
          id: 49285,
          known_for_department: 'Sound',
          name: 'Joel McNeely',
          original_name: 'Joel McNeely',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6wMGJHDe1F0UWc3p7BZapekbpqw.jpg',
          credit_id: '52fe454a9251416c750516d9',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 0,
          id: 58830,
          known_for_department: 'Production',
          name: 'Jeannine Roussel',
          original_name: 'Jeannine Roussel',
          popularity: 0.917,
          profile_path: null,
          credit_id: '52fe454a9251416c750516c1',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 60731,
          known_for_department: 'Art',
          name: 'Fred Warter',
          original_name: 'Fred Warter',
          popularity: 1.38,
          profile_path: null,
          credit_id: '577a1a24c3a3685e1e0001e4',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 69416,
          known_for_department: 'Directing',
          name: 'Bradley Raymond',
          original_name: 'Bradley Raymond',
          popularity: 1.38,
          profile_path: null,
          credit_id: '52fe454a9251416c750516a3',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 69416,
          known_for_department: 'Directing',
          name: 'Bradley Raymond',
          original_name: 'Bradley Raymond',
          popularity: 1.38,
          profile_path: null,
          credit_id: '52fe454a9251416c750516b5',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 69416,
          known_for_department: 'Directing',
          name: 'Bradley Raymond',
          original_name: 'Bradley Raymond',
          popularity: 1.38,
          profile_path: null,
          credit_id: '577a1916c3a3685d4e000186',
          department: 'Biên kịch',
          job: 'Original Story',
        },
        {
          adult: false,
          gender: 2,
          id: 229916,
          known_for_department: 'Biên kịch',
          name: 'Jeffrey M. Howard',
          original_name: 'Jeffrey M. Howard',
          popularity: 0.98,
          profile_path: null,
          credit_id: '577a193e92514114fd001ed1',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 229916,
          known_for_department: 'Biên kịch',
          name: 'Jeffrey M. Howard',
          original_name: 'Jeffrey M. Howard',
          popularity: 0.98,
          profile_path: null,
          credit_id: '577a1900c3a3682ea6000f2b',
          department: 'Biên kịch',
          job: 'Original Story',
        },
        {
          adult: false,
          gender: 0,
          id: 229917,
          known_for_department: 'Production',
          name: 'Noel Wolfman',
          original_name: 'Noel Wolfman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '577a1b26c3a3685d4e0002d9',
          department: 'Production',
          job: 'Associate Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 937490,
          known_for_department: 'Production',
          name: 'Jamie Thomason',
          original_name: 'Jamie Thomason',
          popularity: 1.38,
          profile_path: null,
          credit_id: '52fe454a9251416c750516d3',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 1148320,
          known_for_department: 'Editing',
          name: 'Mark W. Rosenbaum',
          original_name: 'Mark W. Rosenbaum',
          popularity: 0.6,
          profile_path: null,
          credit_id: '577a1afd925141611d00026f',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1381901,
          known_for_department: 'Production',
          name: 'Jennifer Teter',
          original_name: 'Jennifer Teter',
          popularity: 0.6,
          profile_path: null,
          credit_id: '577a1b89925141614f000285',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 2,
          id: 1387244,
          known_for_department: 'Sound',
          name: 'Ronald Eng',
          original_name: 'Ronald Eng',
          popularity: 0.98,
          profile_path: null,
          credit_id: '577a1fddc3a3685ed2000596',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1387246,
          known_for_department: 'Sound',
          name: 'Willard Overstreet',
          original_name: 'Willard Overstreet',
          popularity: 0.73,
          profile_path: null,
          credit_id: '577a2045c3a3686d8b000012',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1421706,
          known_for_department: 'Sound',
          name: 'Tom E. Dahl',
          original_name: 'Tom E. Dahl',
          popularity: 0.6,
          profile_path: null,
          credit_id: '577a20339251413b99001405',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1451269,
          known_for_department: 'Visual Effects',
          name: 'Joel Parod',
          original_name: 'Joel Parod',
          popularity: 1.4,
          profile_path: null,
          credit_id: '577a1d6fc3a3685ed2000423',
          department: 'Visual Effects',
          job: 'Visual Development',
        },
        {
          adult: false,
          gender: 0,
          id: 1451661,
          known_for_department: 'Crew',
          name: 'John Bermudes',
          original_name: 'John Bermudes',
          popularity: 0.648,
          profile_path: null,
          credit_id: '55374794925141129b0016b8',
          department: 'Art',
          job: 'Art Department Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1516887,
          known_for_department: 'Crew',
          name: 'Desi Scarpone',
          original_name: 'Desi Scarpone',
          popularity: 0.6,
          profile_path: null,
          credit_id: '577a1f9fc3a3685d4e000598',
          department: 'Crew',
          job: 'Post Production Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1536029,
          known_for_department: 'Sound',
          name: 'Dominick Certo',
          original_name: 'Dominick Certo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '577a20ddc3a3686e52000039',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1551519,
          known_for_department: 'Sound',
          name: 'Mark D. Fleming',
          original_name: 'Mark D. Fleming',
          popularity: 0.98,
          profile_path: null,
          credit_id: '577a2016c3a3685d9e000528',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1645128,
          known_for_department: 'Crew',
          name: 'Doug Little',
          original_name: 'Doug Little',
          popularity: 0.6,
          profile_path: null,
          credit_id: '577a1a36c3a3682ea6000ff7',
          department: 'Crew',
          job: 'Digital Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1645131,
          known_for_department: 'Visual Effects',
          name: 'Sheryl Sardina Sackett',
          original_name: 'Sheryl Sardina Sackett',
          popularity: 0.6,
          profile_path: null,
          credit_id: '577a1a9b92514160fd0001fe',
          department: 'Visual Effects',
          job: 'Animation Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1645134,
          known_for_department: 'Production',
          name: 'Niki Carras',
          original_name: 'Niki Carras',
          popularity: 0.6,
          profile_path: null,
          credit_id: '577a1b4fc3a3685ed20002d0',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1645136,
          known_for_department: 'Production',
          name: 'Jenny Aleman-Holman',
          original_name: 'Jenny Aleman-Holman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '577a1be2c3a3685d4e000348',
          department: 'Production',
          job: 'Production Accountant',
        },
        {
          adult: false,
          gender: 0,
          id: 1645138,
          known_for_department: 'Visual Effects',
          name: 'Nicolás Villarreal',
          original_name: 'Nicolás Villarreal',
          popularity: 0.6,
          profile_path: null,
          credit_id: '577a1dc3c3a3685d9e0003e1',
          department: 'Visual Effects',
          job: 'Visual Development',
        },
        {
          adult: false,
          gender: 0,
          id: 1645139,
          known_for_department: 'Visual Effects',
          name: 'Will Weston',
          original_name: 'Will Weston',
          popularity: 0.6,
          profile_path: null,
          credit_id: '577a1e089251413c7300123c',
          department: 'Visual Effects',
          job: 'Visual Development',
        },
        {
          adult: false,
          gender: 0,
          id: 1645142,
          known_for_department: 'Production',
          name: 'Jared Heisterkamp',
          original_name: 'Jared Heisterkamp',
          popularity: 0.98,
          profile_path: null,
          credit_id: '577a1e91925141614f000441',
          department: 'Production',
          job: 'Production Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1645150,
          known_for_department: 'Crew',
          name: 'Matt Walker',
          original_name: 'Matt Walker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '577a20ac92514114fd0022fa',
          department: 'Crew',
          job: 'Executive Music Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1645263,
          known_for_department: 'Production',
          name: 'Pamela D. Ho',
          original_name: 'Pamela D. Ho',
          popularity: 0.6,
          profile_path: null,
          credit_id: '577a884c925141753f0001d9',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1645266,
          known_for_department: 'Production',
          name: 'Jasmine Johnson',
          original_name: 'Jasmine Johnson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '577a88569251415600000e1a',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1645285,
          known_for_department: 'Production',
          name: 'Adam Iscove',
          original_name: 'Adam Iscove',
          popularity: 0.84,
          profile_path: null,
          credit_id: '577a8867c3a368200800029d',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1645286,
          known_for_department: 'Production',
          name: 'Charlie Holden-Corbett',
          original_name: 'Charlie Holden-Corbett',
          popularity: 0.6,
          profile_path: null,
          credit_id: '577a887892514155f4000d62',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1725466,
          known_for_department: 'Sound',
          name: 'Brett Swain',
          original_name: 'Brett Swain',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5859aaf4c3a368258c068aae',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 1,
          id: 3348886,
          known_for_department: 'Art',
          name: 'Jane Wu',
          original_name: 'Jane Wu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5518cc77c3a36815520029c4',
          department: 'Biên kịch',
          job: 'Storyboard',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/4EtSV3LmwHQSlmAeyn9pJ3ANtC8.jpg',
    belongs_to_collection: {
      id: 709271,
      name: 'The Debt Collector Collection',
      poster_path: '/77EJTRm0207RsX8BznrhbNqVP1e.jpg',
      backdrop_path: '/wIBTn04q3QIG8Z8akSJtdEd2ylz.jpg',
    },
    budget: 0,
    genres: [{ id: 28, name: 'Phim Hành Động' }],
    homepage: '',
    id: 513691,
    imdb_id: 'tt7448180',
    original_language: 'en',
    original_title: 'The Debt Collector',
    overview:
      'Một võ sĩ được đào tạo theo phong cách cổ điển đi làm việc như là một kẻ thu nợ nần. Công việc dường như dễ dàng, cho đến khi một khách hàng kéo anh ta vào một tình huống sâu hơn bao giờ hết không thể được dự đoán dược các nguy hiểm đang rình rập anh..',
    popularity: 27.588,
    poster_path:
      'https://image.tmdb.org/t/p/w342/5XyuUPoIeEf3guWLQW9lATON84v.jpg',
    production_companies: [
      {
        id: 103755,
        logo_path: null,
        name: 'Tarzana Productions',
        origin_country: 'US',
      },
      {
        id: 103833,
        logo_path: null,
        name: 'Cohesive Entertainment Group (CEG)',
        origin_country: '',
      },
      {
        id: 4322,
        logo_path: '/AkdxBRkqgx0bHjjLvIyl0Mu8sxa.png',
        name: 'Compound B',
        origin_country: 'US',
      },
    ],
    production_countries: [
      { iso_3166_1: 'GB', name: 'United Kingdom' },
      { iso_3166_1: 'US', name: 'Hoa Kì' },
    ],
    release_date: '2018-06-05',
    revenue: 0,
    runtime: 96,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'Violence first. Questions later.',
    title: 'Đòi Nợ Thuê',
    video: false,
    vote_average: 5.9,
    vote_count: 133,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Debt Collector (2018) | Official International Trailer',
          key: 'N0O5iwmXzXM',
          published_at: '2018-03-20T21:44:25.000Z',
          site: 'YouTube',
          size: 720,
          type: 'Trailer',
          official: true,
          id: '5ab622c5925141395b007099',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 78110,
          known_for_department: 'Diễn viên',
          name: 'Scott Adkins',
          original_name: 'Scott Adkins',
          popularity: 7.797,
          profile_path:
            'https://image.tmdb.org/t/p/w185/n1L8652hJAKi5l2sdrZ07oZJmos.jpg',
          cast_id: 0,
          character: 'French',
          credit_id: '5ab61fbac3a3680a31006dc4',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 54649,
          known_for_department: 'Diễn viên',
          name: 'Louis Mandylor',
          original_name: 'Louis Mandylor',
          popularity: 5.48,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tnNxkjimfJQ6rY87Ryr5R72KMRH.jpg',
          cast_id: 1,
          character: 'Sue',
          credit_id: '5ab620330e0a261fee007245',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 60650,
          known_for_department: 'Diễn viên',
          name: 'Michael Paré',
          original_name: 'Michael Paré',
          popularity: 2.536,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zPRYpV096EaEunh9CirBw8okSne.jpg',
          cast_id: 2,
          character: 'Mad Alex',
          credit_id: '5ab620a40e0a261fe2007aea',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 19384,
          known_for_department: 'Diễn viên',
          name: 'Tony Todd',
          original_name: 'Tony Todd',
          popularity: 3.074,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iFISUOjo3ICCQuLwaDUeuGeYKnW.jpg',
          cast_id: 3,
          character: 'Barbosa',
          credit_id: '5ab620fb9251413967006ca2',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 19898,
          known_for_department: 'Diễn viên',
          name: 'Vladimir Kulich',
          original_name: 'Vladimir Kulich',
          popularity: 4.453,
          profile_path:
            'https://image.tmdb.org/t/p/w185/z6pfLx4kJvqWj501SIxExu6rYFi.jpg',
          cast_id: 6,
          character: 'Tommy',
          credit_id: '5ad8a3290e0a264333013cc1',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 52306,
          known_for_department: 'Diễn viên',
          name: 'Robert Rusler',
          original_name: 'Robert Rusler',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dZ9ZU5afsftWHThl3YmoekhzJNA.jpg',
          cast_id: 7,
          character: 'Tarva',
          credit_id: '5ad8a3299251413cc4012c73',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 115500,
          known_for_department: 'Diễn viên',
          name: 'Selina Lo',
          original_name: 'Selina Lo',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ybl4DwmJNXYTQSzumJh2rmKncYb.jpg',
          cast_id: 8,
          character: 'Sandy',
          credit_id: '5ad8a329c3a368718f014bd4',
          order: 7,
        },
        {
          adult: false,
          gender: 1,
          id: 1537527,
          known_for_department: 'Diễn viên',
          name: 'Nihan Gur',
          original_name: 'Nihan Gur',
          popularity: 2.201,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hmOxxI02rxygokkIWXgjbr5ZXuN.jpg',
          cast_id: 9,
          character: 'Angelica',
          credit_id: '5ad8a32a0e0a26433c013864',
          order: 8,
        },
        {
          adult: false,
          gender: 0,
          id: 2025821,
          known_for_department: 'Diễn viên',
          name: 'Sara Finley',
          original_name: 'Sara Finley',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jreRWgFOE4irAX9fFfgKbITucW9.jpg',
          cast_id: 10,
          character: 'Lola',
          credit_id: '5ad8a32a9251413cc4012c7a',
          order: 9,
        },
        {
          adult: false,
          gender: 0,
          id: 2025822,
          known_for_department: 'Diễn viên',
          name: 'Essam Ferris',
          original_name: 'Essam Ferris',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kKbJXJWUgsycBhnpWJvvblcO1vS.jpg',
          cast_id: 11,
          character: 'The Serb',
          credit_id: '5ad8a32a9251413cca011d3f',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 1066204,
          known_for_department: 'Diễn viên',
          name: 'Marshal Hilton',
          original_name: 'Marshal Hilton',
          popularity: 0.659,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3wcAzIUC7KbE425OvecKBRnjUwb.jpg',
          cast_id: 12,
          character: 'Priest',
          credit_id: '5ad8a32ac3a36871890153da',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 2025823,
          known_for_department: 'Diễn viên',
          name: 'Danice Cabanela',
          original_name: 'Danice Cabanela',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6AgShMrFnio0Ge4nKREMr8ysZ3c.jpg',
          cast_id: 13,
          character: 'Jeanette',
          credit_id: '5ad8a32b9251413cc10126d6',
          order: 12,
        },
        {
          adult: false,
          gender: 0,
          id: 2025824,
          known_for_department: 'Diễn viên',
          name: 'Grant Harling',
          original_name: 'Grant Harling',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hTsp0oRGFtdUdEADRhRbidxH6mr.jpg',
          cast_id: 14,
          character: 'Crisp',
          credit_id: '5ad8a32b0e0a264330012aff',
          order: 13,
        },
        {
          adult: false,
          gender: 0,
          id: 1723928,
          known_for_department: 'Diễn viên',
          name: 'Geordie Robinson',
          original_name: 'Geordie Robinson',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mDVmHmCB728KZLCrGMqkdZ2vQ5h.jpg',
          cast_id: 15,
          character: 'Tim',
          credit_id: '5ad8a32bc3a36871a60122f6',
          order: 14,
        },
        {
          adult: false,
          gender: 0,
          id: 2025825,
          known_for_department: 'Diễn viên',
          name: 'Jack Lowe',
          original_name: 'Jack Lowe',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8l0TlozdhBnW8FsfezOcuktsadj.jpg',
          cast_id: 16,
          character: 'Conor Mulligan',
          credit_id: '5ad8a32c0e0a264342013945',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 1588955,
          known_for_department: 'Diễn viên',
          name: 'Rich Manley',
          original_name: 'Rich Manley',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/npp9yOFBuhShhJJBolC5I3pjIDt.jpg',
          cast_id: 18,
          character: 'Clive',
          credit_id: '5ad8a32c9251413cca011d46',
          order: 17,
        },
        {
          adult: false,
          gender: 0,
          id: 1660444,
          known_for_department: 'Biên kịch',
          name: 'Sean Crampton',
          original_name: 'Sean Crampton',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rMmPWpM6agOzG6K1KghAsDNq1MY.jpg',
          cast_id: 19,
          character: 'Bill',
          credit_id: '5ad8a32d0e0a26433f0134db',
          order: 18,
        },
        {
          adult: false,
          gender: 2,
          id: 2025827,
          known_for_department: 'Crew',
          name: 'Justin Gant',
          original_name: 'Justin Gant',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4tCNbb09jWgC7oJeZeTCgd23Ion.jpg',
          cast_id: 20,
          character: 'Ollie',
          credit_id: '5ad8a32d0e0a264336012c64',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 165422,
          known_for_department: 'Diễn viên',
          name: 'Robert Hallak',
          original_name: 'Robert Hallak',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/f6Ehx6lwDQpFjFigAoHEuaz4tUj.jpg',
          cast_id: 21,
          character: 'Gordon Karp',
          credit_id: '5ad8a32d9251413cca011d48',
          order: 20,
        },
        {
          adult: false,
          gender: 1,
          id: 2025828,
          known_for_department: 'Diễn viên',
          name: 'Josie M. Parker',
          original_name: 'Josie M. Parker',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uBlx7FbfsFToHvQUqITzAi05pN1.jpg',
          cast_id: 22,
          character: 'Laine',
          credit_id: '5ad8a32dc3a368718f014be4',
          order: 21,
        },
        {
          adult: false,
          gender: 2,
          id: 2025829,
          known_for_department: 'Diễn viên',
          name: 'Matt Harrison',
          original_name: 'Matt Harrison',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7d3B66amwLmTewx0jQJjcNzYP2M.jpg',
          cast_id: 23,
          character: 'Assistant Dealer',
          credit_id: '5ad8a32e9251413cc7012057',
          order: 22,
        },
        {
          adult: false,
          gender: 1,
          id: 2025830,
          known_for_department: 'Diễn viên',
          name: 'Alex Jungers',
          original_name: 'Alex Jungers',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/RjvumYcstl6OO4B2pB69TblcdH.jpg',
          cast_id: 24,
          character: 'Sadie',
          credit_id: '5ad8a32ec3a368719601319d',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 2025831,
          known_for_department: 'Diễn viên',
          name: 'Jake McDermott',
          original_name: 'Jake McDermott',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dJKeHHEDWJkf25RHHgi9kDythvk.jpg',
          cast_id: 25,
          character: 'Patrick',
          credit_id: '5ad8a32e9251413ccd011de2',
          order: 24,
        },
        {
          adult: false,
          gender: 2,
          id: 84905,
          known_for_department: 'Crew',
          name: 'Marc Schaffer',
          original_name: 'Marc Schaffer',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/AtsDe0KfqANxwLDF7iUSGmjGit3.jpg',
          cast_id: 26,
          character: 'Good Samaritan',
          credit_id: '5ad8a32f0e0a264330012b08',
          order: 25,
        },
        {
          adult: false,
          gender: 1,
          id: 2025832,
          known_for_department: 'Diễn viên',
          name: 'Kelly Tucci',
          original_name: 'Kelly Tucci',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/42Diwbwz5m3LLyvEStltCYAk5jH.jpg',
          cast_id: 27,
          character: 'Trista',
          credit_id: '5ad8a32fc3a368718c01304e',
          order: 26,
        },
        {
          adult: false,
          gender: 1,
          id: 2025833,
          known_for_department: 'Diễn viên',
          name: 'Rachel Brann',
          original_name: 'Rachel Brann',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dRmC3ZKOQbRf6955iTWPvwyrBOV.jpg',
          cast_id: 28,
          character: 'Amanda',
          credit_id: '5ad8a32fc3a368718c013053',
          order: 27,
        },
        {
          adult: false,
          gender: 2,
          id: 1856976,
          known_for_department: 'Diễn viên',
          name: 'Michael Meir Saltzman',
          original_name: 'Michael Meir Saltzman',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/suKtTrhRhAIDm6P9sBZ2f6nvLD1.jpg',
          cast_id: 29,
          character: 'Pot-Head',
          credit_id: '5ad8a3309251413cd3012af2',
          order: 28,
        },
        {
          adult: false,
          gender: 2,
          id: 1155485,
          known_for_department: 'Diễn viên',
          name: 'David William No',
          original_name: 'David William No',
          popularity: 0.97,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fni6nDWUqcKC0zdYLnV7CxnABqk.jpg',
          cast_id: 31,
          character: 'Roger',
          credit_id: '5af8297b9251412c6000a3a1',
          order: 29,
        },
        {
          adult: false,
          gender: 0,
          id: 2659713,
          known_for_department: 'Diễn viên',
          name: 'Alexa Bondar',
          original_name: 'Alexa Bondar',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ixPRUJpKZlO1QozJ8sNdxzQis3I.jpg',
          cast_id: 80,
          character: 'Bikini Girl',
          credit_id: '5ed1d9f996386400236f4784',
          order: 30,
        },
        {
          adult: false,
          gender: 2,
          id: 1221121,
          known_for_department: 'Diễn viên',
          name: 'Dennis Keiffer',
          original_name: 'Dennis Keiffer',
          popularity: 1.312,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wk41g9M8qXAOOKifY6AZMNgcH2.jpg',
          cast_id: 81,
          character: "Manno's Sidekick #1",
          credit_id: '6015e9731511aa0041542a27',
          order: 31,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 36999,
          known_for_department: 'Production',
          name: 'Ehud Bleiberg',
          original_name: 'Ehud Bleiberg',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5Qebounle7loRbVYc4YPXJR2Wx0.jpg',
          credit_id: '5b9bc6d2925141424b0150c8',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 78110,
          known_for_department: 'Diễn viên',
          name: 'Scott Adkins',
          original_name: 'Scott Adkins',
          popularity: 7.797,
          profile_path:
            'https://image.tmdb.org/t/p/w185/n1L8652hJAKi5l2sdrZ07oZJmos.jpg',
          credit_id: '5df960d3d1a89300197f2dc2',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 25294,
          known_for_department: 'Sound',
          name: 'Sean Murray',
          original_name: 'Sean Murray',
          popularity: 1.029,
          profile_path: null,
          credit_id: '5b9bc717c3a3686c0201822a',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 1,
          id: 56362,
          known_for_department: 'Production',
          name: 'Deborah Del Prete',
          original_name: 'Deborah Del Prete',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bc6f10e0a2628d0016fab',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 77295,
          known_for_department: 'Directing',
          name: 'Jesse V. Johnson',
          original_name: 'Jesse V. Johnson',
          popularity: 1.566,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8LqBbiV21OHfyYqnnxCICdKMWU4.jpg',
          credit_id: '5ab621c592514139550070b8',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 77295,
          known_for_department: 'Directing',
          name: 'Jesse V. Johnson',
          original_name: 'Jesse V. Johnson',
          popularity: 1.566,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8LqBbiV21OHfyYqnnxCICdKMWU4.jpg',
          credit_id: '5ab626aa0e0a261fe5007c18',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 225626,
          known_for_department: 'Diễn viên',
          name: 'Luke LaFontaine',
          original_name: 'Luke LaFontaine',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5b9bcae8c3a3686c0b018b8f',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 225626,
          known_for_department: 'Diễn viên',
          name: 'Luke LaFontaine',
          original_name: 'Luke LaFontaine',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5b9bcadd925141424801724c',
          department: 'Crew',
          job: 'Fight Choreographer',
        },
        {
          adult: false,
          gender: 2,
          id: 964820,
          known_for_department: 'Camera',
          name: 'Jonathan Hall',
          original_name: 'Jonathan Hall',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bc7339251414255015b21',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 1044042,
          known_for_department: 'Production',
          name: 'Charles Arthur Berg',
          original_name: 'Charles Arthur Berg',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/z2mU2Ffgwh3kcW1F5pAeJAWeJKH.jpg',
          credit_id: '5df960e0be2d490012514e15',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1193259,
          known_for_department: 'Editing',
          name: 'Matthew Lorentz',
          original_name: 'Matthew Lorentz',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5b9bc78cc3a3686c08017aab',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1207558,
          known_for_department: 'Directing',
          name: 'Nimrod Zalmanowitz',
          original_name: 'Nimrod Zalmanowitz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bccfdc3a3686c08017fd3',
          department: 'Production',
          job: 'Post Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1341378,
          known_for_department: 'Production',
          name: 'Joshua Lang',
          original_name: 'Joshua Lang',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ergwKxBeXSOzouekhhZhO5fPEKT.jpg',
          credit_id: '5b9bca94c3a3686c08017d7e',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1343586,
          known_for_department: 'Directing',
          name: 'Max Schouweiler',
          original_name: 'Max Schouweiler',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bcd1ac3a3686c110152f4',
          department: 'Crew',
          job: 'Picture Car Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1403008,
          known_for_department: 'Sound',
          name: 'Brad Whitcanack',
          original_name: 'Brad Whitcanack',
          popularity: 1.22,
          profile_path: null,
          credit_id: '5b9bc9e99251414255015d79',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1420596,
          known_for_department: 'Costume & Make-Up',
          name: 'Kris Deskins',
          original_name: 'Kris Deskins',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zSMo39sgTdC5fjVgqhIk4vkREDQ.jpg',
          credit_id: '5b9bc7ec0e0a2628d3017011',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 2,
          id: 1582563,
          known_for_department: 'Camera',
          name: 'Brent Johnson',
          original_name: 'Brent Johnson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bcbb59251414251015dc9',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 2,
          id: 1601610,
          known_for_department: 'Crew',
          name: 'Matthew Ballard',
          original_name: 'Matthew Ballard',
          popularity: 0.675,
          profile_path: null,
          credit_id: '5b9bcd5f0e0a2628d701906f',
          department: 'Crew',
          job: 'Transportation Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1636523,
          known_for_department: 'Sound',
          name: 'Ray Quintana',
          original_name: 'Ray Quintana',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5b9bc92cc3a3686c0e016587',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1636523,
          known_for_department: 'Sound',
          name: 'Ray Quintana',
          original_name: 'Ray Quintana',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5b9bc8d9c3a3686c040173e6',
          department: 'Sound',
          job: 'ADR Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1636833,
          known_for_department: 'Sound',
          name: 'Vincent Deng',
          original_name: 'Vincent Deng',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bc943925141424801710c',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1636837,
          known_for_department: 'Sound',
          name: "Terah 'Bishop' Woodley II",
          original_name: "Terah 'Bishop' Woodley II",
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bc9ff925141424e014524',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1664922,
          known_for_department: 'Camera',
          name: 'Hunter Sandison',
          original_name: 'Hunter Sandison',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bcbc50e0a2628d7018f03',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 2,
          id: 1677658,
          known_for_department: 'Camera',
          name: 'Satir Gonzalez',
          original_name: 'Satir Gonzalez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bcc6ac3a3686c08017f56',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 0,
          id: 1695044,
          known_for_department: 'Production',
          name: 'Nicholas Donnermeyer',
          original_name: 'Nicholas Donnermeyer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5df96110d1a89300147f08f2',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1696998,
          known_for_department: 'Sound',
          name: 'Mark Sutton',
          original_name: 'Mark Sutton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bca48c3a3686c0e01667a',
          department: 'Sound',
          job: 'Sound Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1742673,
          known_for_department: 'Diễn viên',
          name: 'Brien Chatfield',
          original_name: 'Brien Chatfield',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bcc160e0a2628e3016ce2',
          department: 'Camera',
          job: 'Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1748554,
          known_for_department: 'Camera',
          name: 'Alex F. Harris',
          original_name: 'Alex F. Harris',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bcc3d9251414259014d84',
          department: 'Camera',
          job: 'Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1792398,
          known_for_department: 'Production',
          name: 'Daryn Simons',
          original_name: 'Daryn Simons',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bc79f9251414246014408',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 1792398,
          known_for_department: 'Production',
          name: 'Daryn Simons',
          original_name: 'Daryn Simons',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5df96150be2d490014515595',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1903329,
          known_for_department: 'Art',
          name: 'Ryan Kaercher',
          original_name: 'Ryan Kaercher',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bc7bec3a3686c0b018885',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1903331,
          known_for_department: 'Art',
          name: 'Brian Massey',
          original_name: 'Brian Massey',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5b9bc7d6c3a3686c0b01889f',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 1906289,
          known_for_department: 'Camera',
          name: 'Steve Gilbert',
          original_name: 'Steve Gilbert',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5b9bcc4ec3a3686c0e016832',
          department: 'Camera',
          job: 'Key Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1956496,
          known_for_department: 'Diễn viên',
          name: 'Stu Small',
          original_name: 'Stu Small',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ae2a04bc3a36876b2027cad',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 2049587,
          known_for_department: 'Production',
          name: 'Scott Salter',
          original_name: 'Scott Salter',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bcc88c3a3686c11015287',
          department: 'Production',
          job: 'Extras Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 2127885,
          known_for_department: 'Production',
          name: 'Mame Benson',
          original_name: 'Mame Benson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bc83d925141424e0143df',
          department: 'Production',
          job: 'Art Department Production Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2127886,
          known_for_department: 'Art',
          name: 'Scotty Schiefer',
          original_name: 'Scotty Schiefer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bc85cc3a3686c0e0164dc',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 2127887,
          known_for_department: 'Sound',
          name: 'Neil Hillman',
          original_name: 'Neil Hillman',
          popularity: 0.968,
          profile_path: null,
          credit_id: '5b9bc9010e0a2628d001719a',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 2127888,
          known_for_department: 'Sound',
          name: 'Josh Murphy',
          original_name: 'Josh Murphy',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5b9bc956925141424b0152a0',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2127889,
          known_for_department: 'Sound',
          name: 'Sean M. Baker',
          original_name: 'Sean M. Baker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bc97ac3a3686c08017c53',
          department: 'Sound',
          job: 'Foley Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2127890,
          known_for_department: 'Sound',
          name: 'Brahm Patel',
          original_name: 'Brahm Patel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bc991c3a3686c14017bec',
          department: 'Sound',
          job: 'Foley Recordist',
        },
        {
          adult: false,
          gender: 2,
          id: 2127891,
          known_for_department: 'Sound',
          name: 'Anthony Cabacungan',
          original_name: 'Anthony Cabacungan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bc9a5c3a3686c08017c7b',
          department: 'Sound',
          job: 'Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2127893,
          known_for_department: 'Sound',
          name: 'Daniel Navajas',
          original_name: 'Daniel Navajas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bc9ce0e0a2628ce01810a',
          department: 'Sound',
          job: 'Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2127894,
          known_for_department: 'Sound',
          name: 'Scott Esterly',
          original_name: 'Scott Esterly',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bca309251414251015c6b',
          department: 'Sound',
          job: 'Sound Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 2127895,
          known_for_department: 'Crew',
          name: 'John D. Eggett',
          original_name: 'John D. Eggett',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bca62c3a3686c110150c9',
          department: 'Crew',
          job: 'Special Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2127896,
          known_for_department: 'Visual Effects',
          name: 'Natalia Wong',
          original_name: 'Natalia Wong',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bcabec3a3686c14017cf9',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2127901,
          known_for_department: 'Camera',
          name: 'Bryan Harris',
          original_name: 'Bryan Harris',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bcb26925141424e0145eb',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 2127904,
          known_for_department: 'Camera',
          name: 'Jason Elliott',
          original_name: 'Jason Elliott',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bcb9b925141424b015497',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2127906,
          known_for_department: 'Biên kịch',
          name: 'Ariel Bleiberg',
          original_name: 'Ariel Bleiberg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9bcd7c0e0a2628dc016c40',
          department: 'Biên kịch',
          job: 'Script Consultant',
        },
        {
          adult: false,
          gender: 0,
          id: 2357872,
          known_for_department: 'Production',
          name: 'Melanie Kollar',
          original_name: 'Melanie Kollar',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5df9611c26dac10012572c58',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2484972,
          known_for_department: 'Production',
          name: 'Edward Robin',
          original_name: 'Edward Robin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5df961366097500015311018',
          department: 'Production',
          job: 'Executive Producer',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/tTlAA0REGPXSZPBfWyTW9ipIv1I.jpg',
    belongs_to_collection: {
      id: 531241,
      name: 'Spider-Man (Avengers) Collection',
      poster_path: '/nogV4th2P5QWYvQIMiWHj4CFLU9.jpg',
      backdrop_path: '/AvnqpRwlEaYNVL6wzC4RN94EdSd.jpg',
    },
    budget: 175000000,
    genres: [
      { id: 28, name: 'Phim Hành Động' },
      { id: 12, name: 'Phim Phiêu Lưu' },
      { id: 878, name: 'Phim Khoa Học Viễn Tưởng' },
      { id: 18, name: 'Phim Chính Kịch' },
    ],
    homepage: 'http://www.spidermanhomecoming.com',
    id: 315635,
    imdb_id: 'tt2250912',
    original_language: 'en',
    original_title: 'Spider-Man: Homecoming',
    overview:
      'Tạm biệt hai franchise về thời sinh viên, Spider-Man: Homecoming sẽ lần đầu tiên đưa các khán giả đến với cuộc sống trung học của Peter Paker – siêu anh hùng Người Nhện. Liệu một cậu bé chưa trưởng thành sẽ làm thế nào để cân bằng cuộc sống bình thường và trách nhiệm của một anh hùng giải cứu thế giới.\r Sau những sự kiện ở Captain America: Civil War, Peter Parker trở về cuộc sống thường nhật, tiếp tục làm cậu học sinh trung học nhút nhát trong mắt bạn bè. Song song đó, chàng thiếu niên 15 tuổi vẫn có thể làm người hùng bảo vệ New York nhờ bộ giáp do Tony Stark / Iron Man (Robert Downey Jr.) tặng cho và nằm dưới sự giám sát từ xa của Happy Hogan (Jon Favreau) ...',
    popularity: 2543.804,
    poster_path:
      'https://image.tmdb.org/t/p/w342/bir2PxlndrUrdXyvY9OqmfGRQJI.jpg',
    production_companies: [
      {
        id: 420,
        logo_path: '/hUzeosd33nzE5MCNsZxCGEKTXaQ.png',
        name: 'Marvel Studios',
        origin_country: 'US',
      },
      {
        id: 5,
        logo_path: '/71BqEFAF4V3qjjMPCpLuyJFB9A.png',
        name: 'Columbia Pictures',
        origin_country: 'US',
      },
      {
        id: 84041,
        logo_path: '/nw4kyc29QRpNtFbdsBHkRSFavvt.png',
        name: 'Pascal Pictures',
        origin_country: 'US',
      },
      {
        id: 34034,
        logo_path: null,
        name: 'LStar Capital',
        origin_country: 'US',
      },
      {
        id: 34,
        logo_path: '/GagSvqWlyPdkFHMfQ3pNq6ix9P.png',
        name: 'Sony Pictures',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2017-07-05',
    revenue: 880166924,
    runtime: 133,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: "Homework can wait. The city can't.",
    title: 'Người Nhện: Trở Về Nhà',
    video: false,
    vote_average: 7.4,
    vote_count: 17555,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Aunt May Finds Out Peter Is Spider-Man',
          key: 'gslt9X5oafQ',
          site: 'YouTube',
          size: 2160,
          type: 'Clip',
          official: true,
          published_at: '2021-12-18T01:00:10.000Z',
          id: '61bd61ee6a300b009780774f',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Ned Finds Out Peter Is Spider-Man',
          key: 'jwh5iGgmNr4',
          site: 'YouTube',
          size: 2160,
          type: 'Clip',
          official: true,
          published_at: '2021-12-16T01:00:18.000Z',
          id: '61bd6240105611001cc82f92',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'First 10 Minutes',
          key: 'rcBzXxW-aj4',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: true,
          published_at: '2017-10-20T17:05:38.000Z',
          id: '615f923e635013008d225cea',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Official Trailer #3',
          key: 'xEvV3OsE2WM',
          published_at: '2017-05-24T07:00:05.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '592540c4c3a36877bc00dacd',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'International Trailer #3',
          key: 'xbQdPBiF3Co',
          published_at: '2017-05-24T07:00:02.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '5925cde9c3a36877bc014de4',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'International Trailer #2',
          key: 'xpu9yRO_rvU',
          published_at: '2017-03-28T16:21:43.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '58f1430ac3a3681a52004703',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Official Trailer #2',
          key: 'DiTECkLZ8HM',
          published_at: '2017-03-28T13:00:01.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '58f142cd9251415556004851',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Official International Trailer',
          key: 'lCkVr1n1eCA',
          published_at: '2016-12-10T04:55:57.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '58f14331c3a36819db004235',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Official Trailer',
          key: 'rk-dF1lIbIg',
          published_at: '2016-12-10T04:55:39.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '58f142879251415536004a66',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 1136406,
          known_for_department: 'Diễn viên',
          name: 'Tom Holland',
          original_name: 'Tom Holland',
          popularity: 124.093,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2qhIDp44cAqP2clOgt2afQI07X8.jpg',
          cast_id: 16,
          character: 'Peter Parker / Spider-Man',
          credit_id: '558993e49251414371001b1b',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 2232,
          known_for_department: 'Diễn viên',
          name: 'Michael Keaton',
          original_name: 'Michael Keaton',
          popularity: 11.712,
          profile_path:
            'https://image.tmdb.org/t/p/w185/baeHNv3qrVsnApuKbZXiJOhqMnw.jpg',
          cast_id: 28,
          character: 'Adrian Toomes / Vulture',
          credit_id: '573fb95cc3a368082e000e74',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 3223,
          known_for_department: 'Diễn viên',
          name: 'Robert Downey Jr.',
          original_name: 'Robert Downey Jr.',
          popularity: 16.841,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5qHNjhtjMD4YWH3UP0rm4tKwxCL.jpg',
          cast_id: 26,
          character: 'Tony Stark / Iron Man',
          credit_id: '571924449251412ccc0003b1',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 3141,
          known_for_department: 'Diễn viên',
          name: 'Marisa Tomei',
          original_name: 'Marisa Tomei',
          popularity: 21.937,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pP0J79KUzPPjW4QO42iF4KKM7C6.jpg',
          cast_id: 17,
          character: 'May Parker',
          credit_id: '55b5c1829251411e0f015f39',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 15277,
          known_for_department: 'Diễn viên',
          name: 'Jon Favreau',
          original_name: 'Jon Favreau',
          popularity: 12.172,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8MtRRnEHaBSw8Ztdl8saXiw1egP.jpg',
          cast_id: 71,
          character: "Harold 'Happy' Hogan",
          credit_id: '57c8ef3992514148e3002bc8',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 12052,
          known_for_department: 'Diễn viên',
          name: 'Gwyneth Paltrow',
          original_name: 'Gwyneth Paltrow',
          popularity: 6.889,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mLarlXA8G02AdIMKptZmUzQluqF.jpg',
          cast_id: 93,
          character: "Virginia 'Pepper' Potts",
          credit_id: '594e1813c3a36832ca032971',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 505710,
          known_for_department: 'Diễn viên',
          name: 'Zendaya',
          original_name: 'Zendaya',
          popularity: 53.185,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jHWlWOasiqKS8JI40g9GDH5X6AL.jpg',
          cast_id: 23,
          character: "Michelle 'MJ' Jones",
          credit_id: '56decc5d92514122ac000c2c',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 119589,
          known_for_department: 'Diễn viên',
          name: 'Donald Glover',
          original_name: 'Donald Glover',
          popularity: 3.37,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nilV7NtnML6PDa9VrvxD79F85K9.jpg',
          cast_id: 32,
          character: 'Aaron Davis',
          credit_id: '57604a479251415e2e002fee',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 1649152,
          known_for_department: 'Diễn viên',
          name: 'Jacob Batalon',
          original_name: 'Jacob Batalon',
          popularity: 24.739,
          profile_path:
            'https://image.tmdb.org/t/p/w185/53YhaL4xw4Sb1ssoHkeSSBaO29c.jpg',
          cast_id: 60,
          character: 'Ned',
          credit_id: '5784e45d92514117d4003253',
          order: 8,
        },
        {
          adult: false,
          gender: 1,
          id: 1606394,
          known_for_department: 'Diễn viên',
          name: 'Laura Harrier',
          original_name: 'Laura Harrier',
          popularity: 4.387,
          profile_path:
            'https://image.tmdb.org/t/p/w185/udfQvYY4SRthaAfykVZhzlOqnLv.jpg',
          cast_id: 25,
          character: 'Liz',
          credit_id: '5711891c9251417fc0000c73',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 1291350,
          known_for_department: 'Diễn viên',
          name: 'Tony Revolori',
          original_name: 'Tony Revolori',
          popularity: 9.417,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ouuo4ulVO9j6T8JixFp4lWTVdtd.jpg',
          cast_id: 24,
          character: "Eugene 'Flash' Thompson",
          credit_id: '57118904925141322d004cd1',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 71913,
          known_for_department: 'Diễn viên',
          name: 'Bokeem Woodbine',
          original_name: 'Bokeem Woodbine',
          popularity: 12.041,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pnPyA5pJn94zUzuLWTNkGBNZxza.jpg',
          cast_id: 45,
          character: 'Herman Schultz / Shocker',
          credit_id: '576bde8192514151740004d3',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 66221,
          known_for_department: 'Diễn viên',
          name: 'Tyne Daly',
          original_name: 'Tyne Daly',
          popularity: 7.181,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uR0nx2bniih1Kdhst5R3LH59smk.jpg',
          cast_id: 56,
          character: 'Anne Marie Hoag',
          credit_id: '577436b0c3a3686ef40022db',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 1421427,
          known_for_department: 'Diễn viên',
          name: 'Abraham Attah',
          original_name: 'Abraham Attah',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8r5GdE98NDuj8hMJktXtFWVtxxl.jpg',
          cast_id: 44,
          character: 'Abraham',
          credit_id: '576a860d9251412c6100091c',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 500427,
          known_for_department: 'Diễn viên',
          name: 'Hannibal Buress',
          original_name: 'Hannibal Buress',
          popularity: 3.0,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mcw3Orbg4vbALXTVG4hriZjH1sj.jpg',
          cast_id: 37,
          character: 'Coach Wilson',
          credit_id: '576958f4c3a368696f000237',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 41561,
          known_for_department: 'Diễn viên',
          name: 'Kenneth Choi',
          original_name: 'Kenneth Choi',
          popularity: 4.156,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ycHOQV42jsYXoWMaobKTzGXy9g4.jpg',
          cast_id: 31,
          character: 'Principal Morita',
          credit_id: '575a5c79c3a3683ada000227',
          order: 15,
        },
        {
          adult: false,
          gender: 1,
          id: 162503,
          known_for_department: 'Diễn viên',
          name: 'Selenis Leyva',
          original_name: 'Selenis Leyva',
          popularity: 1.221,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nTiw98CjQt1wKToT1K1jGBcui95.jpg',
          cast_id: 38,
          character: 'Ms. Warren',
          credit_id: '5769903f92514114f700039e',
          order: 16,
        },
        {
          adult: false,
          gender: 1,
          id: 1265629,
          known_for_department: 'Diễn viên',
          name: 'Angourie Rice',
          original_name: 'Angourie Rice',
          popularity: 11.511,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5zf2Cr4p7KQEcSv7ZPSLfT2R7mR.jpg',
          cast_id: 59,
          character: 'Betty Brant',
          credit_id: '577dc8aec3a36817e3004afa',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 41089,
          known_for_department: 'Diễn viên',
          name: 'Martin Starr',
          original_name: 'Martin Starr',
          popularity: 5.848,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gNyCdend3C5gY3ucq42Zt3swfg2.jpg',
          cast_id: 33,
          character: 'Mr. Harrington',
          credit_id: '5763e87c92514129860001d2',
          order: 18,
        },
        {
          adult: false,
          gender: 1,
          id: 31647,
          known_for_department: 'Diễn viên',
          name: 'Garcelle Beauvais',
          original_name: 'Garcelle Beauvais',
          popularity: 3.734,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bKR6NHtAJUYInnCMdb36YoAWirm.jpg',
          cast_id: 57,
          character: 'Doris Toomes',
          credit_id: '5775cf45c3a3680906001af5',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 87070,
          known_for_department: 'Diễn viên',
          name: 'Michael Chernus',
          original_name: 'Michael Chernus',
          popularity: 2.589,
          profile_path:
            'https://image.tmdb.org/t/p/w185/Df2ZE3P9BiXawPtewinxLPNAu2.jpg',
          cast_id: 67,
          character: 'Phineas Mason / Tinkerer',
          credit_id: '57b5c756925141201e001392',
          order: 20,
        },
        {
          adult: false,
          gender: 2,
          id: 829372,
          known_for_department: 'Diễn viên',
          name: 'Michael Mando',
          original_name: 'Michael Mando',
          popularity: 1.845,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qLCDUTgbtLdND4HW8aUsDY28gcm.jpg',
          cast_id: 46,
          character: 'Mac Gargan',
          credit_id: '576bdea8c3a36863d1002e9d',
          order: 21,
        },
        {
          adult: false,
          gender: 2,
          id: 130253,
          known_for_department: 'Diễn viên',
          name: 'Logan Marshall-Green',
          original_name: 'Logan Marshall-Green',
          popularity: 2.74,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oogXh2Osxw43bfjMVCcCH8SGsUB.jpg',
          cast_id: 39,
          character: 'Jackson Brice / Shocker',
          credit_id: '576a821e9251412bf10008ef',
          order: 22,
        },
        {
          adult: false,
          gender: 1,
          id: 6161,
          known_for_department: 'Diễn viên',
          name: 'Jennifer Connelly',
          original_name: 'Jennifer Connelly',
          popularity: 19.605,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3oYDftEbM3YgBiHYcbbIPRNZrTL.jpg',
          cast_id: 92,
          character: 'Karen (voice)',
          credit_id: '594e180392514131110338d3',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 168875,
          known_for_department: 'Diễn viên',
          name: 'Gary Weeks',
          original_name: 'Gary Weeks',
          popularity: 4.301,
          profile_path:
            'https://image.tmdb.org/t/p/w185/n4taftpteF6qUTeYRDkdGPHC58.jpg',
          cast_id: 94,
          character: 'Agent Foster',
          credit_id: '594e1910925141314b0332e5',
          order: 24,
        },
        {
          adult: false,
          gender: 2,
          id: 1173099,
          known_for_department: 'Diễn viên',
          name: 'Christopher Berry',
          original_name: 'Christopher Berry',
          popularity: 0.603,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8y2HybPVLxUabwnMPjdBREbitKZ.jpg',
          cast_id: 95,
          character: 'Randy',
          credit_id: '594e198dc3a3683232031159',
          order: 25,
        },
        {
          adult: false,
          gender: 2,
          id: 1563266,
          known_for_department: 'Diễn viên',
          name: 'Jorge Lendeborg Jr.',
          original_name: 'Jorge Lendeborg Jr.',
          popularity: 4.207,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1633mS58BuM33No4kTPsusePEJa.jpg',
          cast_id: 43,
          character: 'Jason Ionello',
          credit_id: '576a82c59251412bcd000988',
          order: 26,
        },
        {
          adult: false,
          gender: 2,
          id: 94476,
          known_for_department: 'Diễn viên',
          name: 'Tunde Adebimpe',
          original_name: 'Tunde Adebimpe',
          popularity: 1.176,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4PlgqGFsr6ESYKAtB2mySs7L6u.jpg',
          cast_id: 68,
          character: 'Mr. Cobbwell',
          credit_id: '57b7598cc3a3683585000f6b',
          order: 27,
        },
        {
          adult: false,
          gender: 1,
          id: 211937,
          known_for_department: 'Diễn viên',
          name: 'Tiffany Espensen',
          original_name: 'Tiffany Espensen',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/srxz35x7Xxe7JxHeHzX0cRNF3ON.jpg',
          cast_id: 58,
          character: 'Cindy',
          credit_id: '5775cf9dc3a36808fa001c07',
          order: 28,
        },
        {
          adult: false,
          gender: 1,
          id: 1517836,
          known_for_department: 'Diễn viên',
          name: 'Isabella Amara',
          original_name: 'Isabella Amara',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hz2uP4Qjucj5my9rLc0FO9aWV2E.jpg',
          cast_id: 41,
          character: 'Sally',
          credit_id: '576a828cc3a3682206000901',
          order: 29,
        },
        {
          adult: false,
          gender: 2,
          id: 1551547,
          known_for_department: 'Diễn viên',
          name: 'Michael Barbieri',
          original_name: 'Michael Barbieri',
          popularity: 1.4,
          profile_path: null,
          cast_id: 30,
          character: 'Charles',
          credit_id: '5755abf49251417e790002cc',
          order: 30,
        },
        {
          adult: false,
          gender: 1,
          id: 1520451,
          known_for_department: 'Diễn viên',
          name: 'Josie Totah',
          original_name: 'Josie Totah',
          popularity: 6.856,
          profile_path:
            'https://image.tmdb.org/t/p/w185/125iM9BTPVDfRjKGVSqmvgeGsai.jpg',
          cast_id: 42,
          character: 'Seymour',
          credit_id: '576a82999251412c30000929',
          order: 31,
        },
        {
          adult: false,
          gender: 2,
          id: 164208,
          known_for_department: 'Diễn viên',
          name: 'Hemky Madera',
          original_name: 'Hemky Madera',
          popularity: 2.972,
          profile_path:
            'https://image.tmdb.org/t/p/w185/net1kEEpSrr9QC9be6YRhLGuM0k.jpg',
          cast_id: 96,
          character: 'Mr. Delmar',
          credit_id: '594e19c3925141314b0333b2',
          order: 32,
        },
        {
          adult: false,
          gender: 2,
          id: 1838225,
          known_for_department: 'Diễn viên',
          name: 'Zach Cherry',
          original_name: 'Zach Cherry',
          popularity: 3.824,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fT3Wv8ef0Vn0daHWAObCp2Bd4Y.jpg',
          cast_id: 103,
          character: 'Street Vendor',
          credit_id: '594e1b499251413115034550',
          order: 33,
        },
        {
          adult: false,
          gender: 2,
          id: 145446,
          known_for_department: 'Directing',
          name: 'Kirk R. Thatcher',
          original_name: 'Kirk R. Thatcher',
          popularity: 0.907,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tC3lxuff2li0h6jks9EM0d53mFw.jpg',
          cast_id: 203,
          character: 'Punk on Street',
          credit_id: '59816d4a92514151d400e179',
          order: 34,
        },
        {
          adult: false,
          gender: 2,
          id: 1842670,
          known_for_department: 'Diễn viên',
          name: 'Yu Lew',
          original_name: 'Yu Lew',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/chpfAkStjoMZeUIaK2QArjCpbR3.jpg',
          cast_id: 106,
          character: 'Car Jacker',
          credit_id: '59581d1dc3a368253c010b2c',
          order: 35,
        },
        {
          adult: false,
          gender: 1,
          id: 171297,
          known_for_department: 'Diễn viên',
          name: 'Sondra James',
          original_name: 'Sondra James',
          popularity: 1.157,
          profile_path:
            'https://image.tmdb.org/t/p/w185/y0AuGOeO9qnVEu0oskPS2RrPNK1.jpg',
          cast_id: 97,
          character: 'Yelling Woman',
          credit_id: '594e19f292514131150343a5',
          order: 36,
        },
        {
          adult: false,
          gender: 0,
          id: 1328063,
          known_for_department: 'Diễn viên',
          name: 'Bob Adrian',
          original_name: 'Bob Adrian',
          popularity: 0.964,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tY11cR250ETCYDhLL1a13VV4gM1.jpg',
          cast_id: 98,
          character: 'Yelling Man',
          credit_id: '594e19ff9251413127032fca',
          order: 37,
        },
        {
          adult: false,
          gender: 2,
          id: 1842673,
          known_for_department: 'Diễn viên',
          name: 'Gary Richardson',
          original_name: 'Gary Richardson',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qZnYgEpMMnA2tih2zTa5uj1Fc7.jpg',
          cast_id: 107,
          character: 'Day Sleeper',
          credit_id: '59581d5cc3a368293b0135ab',
          order: 38,
        },
        {
          adult: false,
          gender: 2,
          id: 7624,
          known_for_department: 'Biên kịch',
          name: 'Stan Lee',
          original_name: 'Stan Lee',
          popularity: 10.552,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kKeyWoFtTqOPsbmwylNHmuB3En9.jpg',
          cast_id: 99,
          character: 'Gary',
          credit_id: '594e1a109251413111033b75',
          order: 39,
        },
        {
          adult: false,
          gender: 2,
          id: 1838226,
          known_for_department: 'Diễn viên',
          name: 'Joe Hang',
          original_name: 'Joe Hang',
          popularity: 0.732,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5Gf03mE8IC8ZixTrXzkhEpWLAbq.jpg',
          cast_id: 104,
          character: 'Thai Waiter',
          credit_id: '594e1cb2c3a368329b038534',
          order: 40,
        },
        {
          adult: false,
          gender: 2,
          id: 31528,
          known_for_department: 'Diễn viên',
          name: 'Wayne Pére',
          original_name: 'Wayne Pére',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ppVRC4a061nwAOBerUhg0E9sUDJ.jpg',
          cast_id: 100,
          character: 'History Teacher',
          credit_id: '594e1a1ec3a3683279032e9b',
          order: 41,
        },
        {
          adult: false,
          gender: 2,
          id: 16828,
          known_for_department: 'Diễn viên',
          name: 'Chris Evans',
          original_name: 'Chris Evans',
          popularity: 13.815,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3bOGNsHlrswhyW79uvIHH1V43JI.jpg',
          cast_id: 74,
          character: 'Steve Rogers / Captain America',
          credit_id: '58dba047c3a3687d4700a813',
          order: 42,
        },
        {
          adult: false,
          gender: 1,
          id: 1842674,
          known_for_department: 'Diễn viên',
          name: 'Alexa Laraki',
          original_name: 'Alexa Laraki',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sjEnTFw2CTXEDeaG1d69xcD3W7t.jpg',
          cast_id: 108,
          character: 'Tent Kid',
          credit_id: '59581d7d92514109e4012153',
          order: 44,
        },
        {
          adult: false,
          gender: 1,
          id: 1842675,
          known_for_department: 'Diễn viên',
          name: 'Liza Fagin',
          original_name: 'Liza Fagin',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5oCzqacwq0MG8mN4ktASolaVxYp.jpg',
          cast_id: 109,
          character: 'Tent Kid',
          credit_id: '59581d8dc3a36828e7012ce5',
          order: 45,
        },
        {
          adult: false,
          gender: 1,
          id: 62105,
          known_for_department: 'Diễn viên',
          name: 'Kerry Condon',
          original_name: 'Kerry Condon',
          popularity: 6.266,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9UinfSwMqlgNrpoeppRtQqI6yZG.jpg',
          cast_id: 101,
          character: 'F.R.I.D.A.Y. (voice)',
          credit_id: '594e1ab9c3a36832320312bc',
          order: 46,
        },
        {
          adult: false,
          gender: 2,
          id: 1842676,
          known_for_department: 'Diễn viên',
          name: 'John Penick',
          original_name: 'John Penick',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3k2bw51T88gQV1tvNbRTPi75lUu.jpg',
          cast_id: 110,
          character: 'Mr. Hapgood',
          credit_id: '59581dabc3a368293b0135ff',
          order: 47,
        },
        {
          adult: false,
          gender: 2,
          id: 212003,
          known_for_department: 'Diễn viên',
          name: 'Ethan Dizon',
          original_name: 'Ethan Dizon',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2Zqioe3D9Yb4B8dMUcea6Cy6aoQ.jpg',
          cast_id: 69,
          character: 'Tiny',
          credit_id: '57b75a7792514133be000e7f',
          order: 48,
        },
        {
          adult: false,
          gender: 1,
          id: 59401,
          known_for_department: 'Diễn viên',
          name: 'Amy Hill',
          original_name: 'Amy Hill',
          popularity: 2.713,
          profile_path:
            'https://image.tmdb.org/t/p/w185/x5vR2MXZiWGHkppRXlXYj7y7611.jpg',
          cast_id: 111,
          character: 'Decathlon Moderator',
          credit_id: '59581edac3a36825e801196d',
          order: 49,
        },
        {
          adult: false,
          gender: 2,
          id: 1380492,
          known_for_department: 'Diễn viên',
          name: 'Miles Mussenden',
          original_name: 'Miles Mussenden',
          popularity: 0.6,
          profile_path: null,
          cast_id: 102,
          character: 'Park Ranger',
          credit_id: '594e1b1fc3a368328b02f0e1',
          order: 50,
        },
        {
          adult: false,
          gender: 0,
          id: 1572541,
          known_for_department: 'Diễn viên',
          name: 'Martha Kelly',
          original_name: 'Martha Kelly',
          popularity: 0.698,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ac7HoARDIHdYNqpzgJBzpmKHXHR.jpg',
          cast_id: 66,
          character: 'Tour Guide',
          credit_id: '579d1c71925141066e001815',
          order: 51,
        },
        {
          adult: false,
          gender: 2,
          id: 1779572,
          known_for_department: 'Diễn viên',
          name: 'Kevin LaRosa Jr.',
          original_name: 'Kevin LaRosa Jr.',
          popularity: 0.716,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jFAq7TRkQlPHeiIXNpBcXtxPEwG.jpg',
          cast_id: 112,
          character: 'Helicopter Pilot',
          credit_id: '59581efc9251410883012bf7',
          order: 52,
        },
        {
          adult: false,
          gender: 2,
          id: 1842677,
          known_for_department: 'Diễn viên',
          name: 'Ren Colley',
          original_name: 'Ren Colley',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kzSBpfFCRJIFDiPkx5BkS8LKfJD.jpg',
          cast_id: 113,
          character: 'Ferry Kid',
          credit_id: '59581f0ac3a36828fc0112de',
          order: 53,
        },
        {
          adult: false,
          gender: 1,
          id: 1077345,
          known_for_department: 'Diễn viên',
          name: 'Jennifer Kim',
          original_name: 'Jennifer Kim',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2hzOQRZBBQilLBEhElZhU2TImEH.jpg',
          cast_id: 114,
          character: 'Ferry Mom',
          credit_id: '59581f1e9251410cbc011dd8',
          order: 54,
        },
        {
          adult: false,
          gender: 1,
          id: 1842678,
          known_for_department: 'Diễn viên',
          name: 'Ari Groover',
          original_name: 'Ari Groover',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qTtHDcx0ne7gs1FdNPlXlGRWnf8.jpg',
          cast_id: 115,
          character: 'Ferry Commuter',
          credit_id: '59581f2a92514109e40122cd',
          order: 55,
        },
        {
          adult: false,
          gender: 0,
          id: 1842679,
          known_for_department: 'Diễn viên',
          name: 'Louis Gonzalez',
          original_name: 'Louis Gonzalez',
          popularity: 0.828,
          profile_path: null,
          cast_id: 116,
          character: 'Ferry Commuter',
          credit_id: '59581f3fc3a368265d01230c',
          order: 56,
        },
        {
          adult: false,
          gender: 2,
          id: 1719599,
          known_for_department: 'Diễn viên',
          name: 'Stewart Steinberg',
          original_name: 'Stewart Steinberg',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/muyY09op8PdYdn5FcPdZUouhji8.jpg',
          cast_id: 117,
          character: 'Ferry Commuter',
          credit_id: '59581f519251410bfa012dff',
          order: 57,
        },
        {
          adult: false,
          gender: 0,
          id: 1216011,
          known_for_department: 'Diễn viên',
          name: 'Andy Powers',
          original_name: 'Andy Powers',
          popularity: 1.619,
          profile_path: null,
          cast_id: 118,
          character: 'Ferry Commuter',
          credit_id: '59581f6ac3a368253c010d2a',
          order: 58,
        },
        {
          adult: false,
          gender: 2,
          id: 1842683,
          known_for_department: 'Diễn viên',
          name: 'Omar Capra',
          original_name: 'Omar Capra',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wgJ2UIBen4XyWwiM8Vkj0J1XdVm.jpg',
          cast_id: 119,
          character: 'Yeah Spider-Man Guy',
          credit_id: '59581f7ac3a36825e8011a11',
          order: 59,
        },
        {
          adult: false,
          gender: 2,
          id: 1842686,
          known_for_department: 'Diễn viên',
          name: 'Nitin Nohria',
          original_name: 'Nitin Nohria',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/k1zHc8z1hyZCVWy9VbOzPZSPvUO.jpg',
          cast_id: 120,
          character: 'Dean Crimson',
          credit_id: '59581f87c3a368265d01234b',
          order: 60,
        },
        {
          adult: false,
          gender: 2,
          id: 1497467,
          known_for_department: 'Diễn viên',
          name: 'Vince Foster',
          original_name: 'Vince Foster',
          popularity: 1.38,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5sgQH8EmpAkrXsFRV4RJjP4xODa.jpg',
          cast_id: 121,
          character: 'Stark Tower Technician',
          credit_id: '59581f9cc3a36828e7012ee5',
          order: 61,
        },
        {
          adult: false,
          gender: 2,
          id: 1265796,
          known_for_department: 'Diễn viên',
          name: 'Brian Schaeffer',
          original_name: 'Brian Schaeffer',
          popularity: 1.228,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jY25MFVciYg6pv576QbY9XqalCd.jpg',
          cast_id: 122,
          character: 'Stark Tower Employee',
          credit_id: '59581fac92514109e4012378',
          order: 62,
        },
        {
          adult: false,
          gender: 0,
          id: 1842691,
          known_for_department: 'Diễn viên',
          name: 'Chris Adams',
          original_name: 'Chris Adams',
          popularity: 1.094,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xYyqz8opJ3PpB1Nq9uPY2CHK7aO.jpg',
          cast_id: 123,
          character: 'NYC Pedestrian (uncredited)',
          credit_id: '595820589251410c5601122a',
          order: 63,
        },
        {
          adult: false,
          gender: 1,
          id: 1842697,
          known_for_department: 'Diễn viên',
          name: 'Maiya Boyd',
          original_name: 'Maiya Boyd',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ijAc9zlEHat1RYdDs4xmGO5ykYW.jpg',
          cast_id: 130,
          character: 'Indian Flower Girl (uncredited)',
          credit_id: '595820e29251410883012db2',
          order: 65,
        },
        {
          adult: false,
          gender: 1,
          id: 1649779,
          known_for_department: 'Diễn viên',
          name: 'Rebeca Donovan',
          original_name: 'Rebeca Donovan',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ggP7Db56DMvKEFVEHQISeHVE999.jpg',
          cast_id: 61,
          character: 'Drama Club Member (uncredited)',
          credit_id: '57868bdcc3a36869720015b7',
          order: 68,
        },
        {
          adult: false,
          gender: 2,
          id: 1691379,
          known_for_department: 'Diễn viên',
          name: 'Elli',
          original_name: 'Elli',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tlvgW1CCNxEvUOMEQd01zKzfoSr.jpg',
          cast_id: 145,
          character: 'Rabbi on Subway (uncredited)',
          credit_id: '595822b39251410b8601338f',
          order: 70,
        },
        {
          adult: false,
          gender: 2,
          id: 1502304,
          known_for_department: 'Diễn viên',
          name: 'Nickolas Wolf',
          original_name: 'Nickolas Wolf',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7j34Du62js5m8cr9hXMOQQXywxH.jpg',
          cast_id: 171,
          character: 'Mascot (uncredited)',
          credit_id: '595824a5c3a368265d012892',
          order: 72,
        },
        {
          adult: false,
          gender: 1,
          id: 1732648,
          known_for_department: 'Diễn viên',
          name: 'Jaine Ye',
          original_name: 'Jaine Ye',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5Dqmly7LjZ0svylVfzJpqSBmboZ.jpg',
          cast_id: 333,
          character: 'Chemistry Student (uncredited)',
          credit_id: '5c48cf3cc3a3684793891541',
          order: 73,
        },
        {
          adult: false,
          gender: 1,
          id: 2224813,
          known_for_department: 'Diễn viên',
          name: 'Gina Cordan',
          original_name: 'Gina Cordan',
          popularity: 0.828,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xYL2doYw7nLO8eKED9tSZslgMDG.jpg',
          cast_id: 334,
          character: 'DC Tourist (uncredited)',
          credit_id: '5c48d0370e0a26494fcd5f31',
          order: 74,
        },
        {
          adult: false,
          gender: 1,
          id: 1718174,
          known_for_department: 'Diễn viên',
          name: 'Friday Chamberlain',
          original_name: 'Friday Chamberlain',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/12c1FEmzRLQhdwbU7UA19K4EZ7t.jpg',
          cast_id: 138,
          character: 'Skateboarder (uncredited)',
          credit_id: '595822149251410c560113a7',
          order: 75,
        },
        {
          adult: false,
          gender: 0,
          id: 1842698,
          known_for_department: 'Diễn viên',
          name: 'Dante Brattelli',
          original_name: 'Dante Brattelli',
          popularity: 0.6,
          profile_path: null,
          cast_id: 131,
          character: 'Homecoming Dance Student (uncredited)',
          credit_id: '595820f09251410b860131a5',
          order: 82,
        },
        {
          adult: false,
          gender: 0,
          id: 1842714,
          known_for_department: 'Art',
          name: 'Melissa Kay Glaze',
          original_name: 'Melissa Kay Glaze',
          popularity: 0.6,
          profile_path: null,
          cast_id: 150,
          character: 'New Yorker (uncredited)',
          credit_id: '595822fcc3a36825e8011d6d',
          order: 98,
        },
        {
          adult: false,
          gender: 0,
          id: 1635159,
          known_for_department: 'Diễn viên',
          name: 'Donald K. Overstreet',
          original_name: 'Donald K. Overstreet',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nv5cSyQ78PDnZqNG0NCcOHfirRH.jpg',
          cast_id: 160,
          character: "Avenger's Staff Agent (uncredited)",
          credit_id: '595823bec3a36825e8011e36',
          order: 106,
        },
        {
          adult: false,
          gender: 1,
          id: 1373622,
          known_for_department: 'Diễn viên',
          name: 'Hallie Ricardo',
          original_name: 'Hallie Ricardo',
          popularity: 1.214,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qOQFbOXKO56b3yR9atAVpfSd4Qh.jpg',
          cast_id: 165,
          character: 'DC News Reporter (uncredited)',
          credit_id: '59582418c3a36828a1015c71',
          order: 111,
        },
        {
          adult: false,
          gender: 2,
          id: 1463430,
          known_for_department: 'Production',
          name: 'Doug Scroggins III',
          original_name: 'Doug Scroggins III',
          popularity: 1.094,
          profile_path: null,
          cast_id: 166,
          character: 'Stark VTOL Pilot (uncredited)',
          credit_id: '59582429c3a36828a1015c88',
          order: 112,
        },
        {
          adult: false,
          gender: 1,
          id: 1461314,
          known_for_department: 'Diễn viên',
          name: 'Marmee Regine Cosico',
          original_name: 'Marmee Regine Cosico',
          popularity: 0.699,
          profile_path: null,
          cast_id: 388,
          character: 'NY Pedestrian (uncredited)',
          credit_id: '5d87808a336e010021173dab',
          order: 113,
        },
        {
          adult: false,
          gender: 2,
          id: 2234460,
          known_for_department: 'Diễn viên',
          name: 'Harrison Osterfield',
          original_name: 'Harrison Osterfield',
          popularity: 1.799,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yX5auOS06AgMzOXEOs9f0eqiuNg.jpg',
          cast_id: 389,
          character: 'Midtown High Student',
          credit_id: '5e24e48da894d600123aafa3',
          order: 114,
        },
        {
          adult: false,
          gender: 0,
          id: 1736808,
          known_for_department: 'Diễn viên',
          name: 'Nicholas Azarian',
          original_name: 'Nicholas Azarian',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/y3sBSkTDlFnWFBrhR1p2zCY68Zb.jpg',
          cast_id: 392,
          character: 'High School Student (uncredited)',
          credit_id: '5ecc2ef7283ed9001f8ae023',
          order: 115,
        },
        {
          adult: false,
          gender: 2,
          id: 1569769,
          known_for_department: 'Diễn viên',
          name: 'Chris Silcox',
          original_name: 'Chris Silcox',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sg45hdjGI8pce7fZG1JHzFEOvee.jpg',
          cast_id: 400,
          character: 'Helicopter D.C. Metro Sniper (uncredited)',
          credit_id: '6192cf8dc4ad59002bc50270',
          order: 116,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 1,
          id: 4061,
          known_for_department: 'Costume & Make-Up',
          name: 'Louise Frogley',
          original_name: 'Louise Frogley',
          popularity: 0.84,
          profile_path: null,
          credit_id: '5773de68c3a36870b80002cf',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 1,
          id: 7232,
          known_for_department: 'Production',
          name: 'Sarah Halley Finn',
          original_name: 'Sarah Halley Finn',
          popularity: 2.706,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pI3OhmnHhXLEwuv0Vq6qJHivCJA.jpg',
          credit_id: '55cfdb029251413198006010',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 7235,
          known_for_department: 'Art',
          name: 'Beat Frutiger',
          original_name: 'Beat Frutiger',
          popularity: 1.888,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2VMPjH8Olb5qHqsKNelSxkViH9b.jpg',
          credit_id: '5773dee192514103f0000318',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 5957,
          known_for_department: 'Art',
          name: 'Gene Serdena',
          original_name: 'Gene Serdena',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5773df1392514104bf000313',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 2,
          id: 7624,
          known_for_department: 'Biên kịch',
          name: 'Stan Lee',
          original_name: 'Stan Lee',
          popularity: 10.552,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kKeyWoFtTqOPsbmwylNHmuB3En9.jpg',
          credit_id: '55cfdab49251413198005ffc',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 7624,
          known_for_department: 'Biên kịch',
          name: 'Stan Lee',
          original_name: 'Stan Lee',
          popularity: 10.552,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kKeyWoFtTqOPsbmwylNHmuB3En9.jpg',
          credit_id: '5511cd24c3a36801bb002015',
          department: 'Biên kịch',
          job: 'Characters',
        },
        {
          adult: false,
          gender: 2,
          id: 7625,
          known_for_department: 'Biên kịch',
          name: 'Steve Ditko',
          original_name: 'Steve Ditko',
          popularity: 5.314,
          profile_path:
            'https://image.tmdb.org/t/p/w185/x270c7XwNTnt8qhoZhW4xUzAqEX.jpg',
          credit_id: '5511cd19c3a3683e7f007eac',
          department: 'Biên kịch',
          job: 'Characters',
        },
        {
          adult: false,
          gender: 2,
          id: 7626,
          known_for_department: 'Production',
          name: 'Avi Arad',
          original_name: 'Avi Arad',
          popularity: 1.164,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zFNtix6jjAfjKeE687w1VgU4H1T.jpg',
          credit_id: '5ae66b160e0a262b97000793',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 10850,
          known_for_department: 'Production',
          name: 'Kevin Feige',
          original_name: 'Kevin Feige',
          popularity: 5.507,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kCBqXZ5PT5udYGEj2wfTSFbLMvT.jpg',
          credit_id: '54a9b1e1c3a3680c2b004fa5',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 8408,
          known_for_department: 'Camera',
          name: 'Salvatore Totino',
          original_name: 'Salvatore Totino',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1583da92514178c5010c8a',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 1,
          id: 8703,
          known_for_department: 'Production',
          name: 'Patricia Whitcher',
          original_name: 'Patricia Whitcher',
          popularity: 1.4,
          profile_path: null,
          credit_id: '60626993a5d84900283f99a6',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 8705,
          known_for_department: 'Art',
          name: 'Brad Ricker',
          original_name: 'Brad Ricker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59582b97c3a36828e7013a03',
          department: 'Art',
          job: 'Supervising Art Director',
        },
        {
          adult: false,
          gender: 2,
          id: 8678,
          known_for_department: 'Art',
          name: 'Oliver Scholl',
          original_name: 'Oliver Scholl',
          popularity: 2.215,
          profile_path:
            'https://image.tmdb.org/t/p/w185/CSv6Dh9koDtXLjHJNAo0kjtbg8.jpg',
          credit_id: '5773de52c3a3686ef4000315',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 2,
          id: 11455,
          known_for_department: 'Editing',
          name: 'Dan Lebental',
          original_name: 'Dan Lebental',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kG4N93eMa6fzkJjBsRPQXUcGQlg.jpg',
          credit_id: '59582b0d9251410c56011b94',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 14348,
          known_for_department: 'Art',
          name: 'Lauri Gaffin',
          original_name: 'Lauri Gaffin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59582ba69251410bfa0139de',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 2,
          id: 15347,
          known_for_department: 'Sound',
          name: 'Michael Giacchino',
          original_name: 'Michael Giacchino',
          popularity: 1.152,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1zKiTAfMpc3I8oxdLahx3k6KOOV.jpg',
          credit_id: '5ae6da4f0e0a261060008c9e',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 0,
          id: 42275,
          known_for_department: 'Crew',
          name: 'Theodore Bialek',
          original_name: 'Theodore Bialek',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e7600e0a2612d900d0cc',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 52935,
          known_for_department: 'Diễn viên',
          name: 'John Francis Daley',
          original_name: 'John Francis Daley',
          popularity: 6.232,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rKZL3e8gI2tQD6Kv0QojXK5sG4u.jpg',
          credit_id: '55b5c1969251411e0f015f3c',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 52935,
          known_for_department: 'Diễn viên',
          name: 'John Francis Daley',
          original_name: 'John Francis Daley',
          popularity: 6.232,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rKZL3e8gI2tQD6Kv0QojXK5sG4u.jpg',
          credit_id: '59582ac992514109e4012e18',
          department: 'Biên kịch',
          job: 'Screenstory',
        },
        {
          adult: false,
          gender: 2,
          id: 57027,
          known_for_department: 'Production',
          name: "Louis D'Esposito",
          original_name: "Louis D'Esposito",
          popularity: 1.439,
          profile_path:
            'https://image.tmdb.org/t/p/w185/k9k3WWYdD3uDnrtwM60QirzG9cH.jpg',
          credit_id: '606269725b0714003d9d3792',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 113674,
          known_for_department: 'Production',
          name: 'Victoria Alonso',
          original_name: 'Victoria Alonso',
          popularity: 1.13,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xF7Qe1tqgk9KtY8kThKHBWhMqxc.jpg',
          credit_id: '6062698127ff990056cfb719',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 113675,
          known_for_department: 'Production',
          name: 'Jeremy Latcham',
          original_name: 'Jeremy Latcham',
          popularity: 1.4,
          profile_path: null,
          credit_id: '6062699f5c071b00549cde57',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 64855,
          known_for_department: 'Editing',
          name: 'Todd Busch',
          original_name: 'Todd Busch',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e630c3a368704600cad9',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 92491,
          known_for_department: 'Crew',
          name: 'Danny Downey',
          original_name: 'Danny Downey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c48db4392514151a94f38cf',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 0,
          id: 71270,
          known_for_department: 'Editing',
          name: 'Debbie Berman',
          original_name: 'Debbie Berman',
          popularity: 0.764,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mtvNcYPtRDd48Bj2b8ua4Ysjm1u.jpg',
          credit_id: '591302b3c3a368651904daf7',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 71127,
          known_for_department: 'Camera',
          name: 'Peter Zuccarini',
          original_name: 'Peter Zuccarini',
          popularity: 0.732,
          profile_path: null,
          credit_id: '5a158aa9c3a368071a011e7e',
          department: 'Camera',
          job: 'Underwater Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 76747,
          known_for_department: 'Crew',
          name: 'Henrik Tamm',
          original_name: 'Henrik Tamm',
          popularity: 0.706,
          profile_path: null,
          credit_id: '5a158d3792514178c801266b',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 2,
          id: 89714,
          known_for_department: 'Diễn viên',
          name: 'Ilram Choi',
          original_name: 'Ilram Choi',
          popularity: 1.094,
          profile_path: null,
          credit_id: '5c48d3e89251415e34537ca3',
          department: 'Crew',
          job: 'Fight Choreographer',
        },
        {
          adult: false,
          gender: 2,
          id: 91042,
          known_for_department: 'Crew',
          name: 'Al Cerullo',
          original_name: 'Al Cerullo',
          popularity: 1.219,
          profile_path: null,
          credit_id: '5a15850492514178c5010e29',
          department: 'Crew',
          job: 'Pilot',
        },
        {
          adult: false,
          gender: 0,
          id: 101814,
          known_for_department: 'Biên kịch',
          name: 'Christopher D. Ford',
          original_name: 'Christopher D. Ford',
          popularity: 0.874,
          profile_path: null,
          credit_id: '5794d060c3a3683fcf002c89',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 105643,
          known_for_department: 'Biên kịch',
          name: 'Jay Oliva',
          original_name: 'Jay Oliva',
          popularity: 3.616,
          profile_path:
            'https://image.tmdb.org/t/p/w185/y7EbnuoKFMvU7uZ4aD50jThyNoF.jpg',
          credit_id: '5b394d01c3a36846d70068f7',
          department: 'Biên kịch',
          job: 'Storyboard',
        },
        {
          adult: false,
          gender: 2,
          id: 112856,
          known_for_department: 'Crew',
          name: "Christopher 'Critter' Antonucci",
          original_name: "Christopher 'Critter' Antonucci",
          popularity: 1.38,
          profile_path: null,
          credit_id: '5c48d46c0e0a264962cd6ec7',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 162522,
          known_for_department: 'Crew',
          name: 'Blaise Corrigan',
          original_name: 'Blaise Corrigan',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ycsMR3gck2D8jJT6QEtzyrjUmC6.jpg',
          credit_id: '5c48da150e0a260419ca1d00',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 169691,
          known_for_department: 'Diễn viên',
          name: 'Thomas DuPont',
          original_name: 'Thomas DuPont',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5c48db6d9251415e3453918f',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 555329,
          known_for_department: 'Costume & Make-Up',
          name: 'Greg Funk',
          original_name: 'Greg Funk',
          popularity: 0.766,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eCKDzWvyHEuwJPfgW5xHd2PEqxo.jpg',
          credit_id: '59582c58c3a36825e80125e3',
          department: 'Costume & Make-Up',
          job: 'Key Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 575766,
          known_for_department: 'Art',
          name: 'Ed Natividad',
          original_name: 'Ed Natividad',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a158cfa92514178c5011a32',
          department: 'Art',
          job: 'Conceptual Design',
        },
        {
          adult: false,
          gender: 2,
          id: 969743,
          known_for_department: 'Art',
          name: 'Dean Wolcott',
          original_name: 'Dean Wolcott',
          popularity: 1.976,
          profile_path: null,
          credit_id: '5a158ddfc3a368072901279e',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 977941,
          known_for_department: 'Production',
          name: 'Matt Tolmach',
          original_name: 'Matt Tolmach',
          popularity: 2.189,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8mniHJVwoJdVpwxW278yJwz8c1T.jpg',
          credit_id: '598cc9649251414c03000464',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 979175,
          known_for_department: 'Camera',
          name: 'Brad Shield',
          original_name: 'Brad Shield',
          popularity: 0.728,
          profile_path: null,
          credit_id: '5a158872c3a368073301194d',
          department: 'Camera',
          job: 'Second Unit Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 1081074,
          known_for_department: 'Crew',
          name: 'George Cottle',
          original_name: 'George Cottle',
          popularity: 0.634,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jwQmBfZCJk7V9W96r7fXo3JGyMs.jpg',
          credit_id: '5c48da26c3a368477a89e624',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1117747,
          known_for_department: 'Production',
          name: 'Mitchell Bell',
          original_name: 'Mitchell Bell',
          popularity: 0.98,
          profile_path: null,
          credit_id: '606269b31b7c5900288845b2',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1150954,
          known_for_department: 'Editing',
          name: 'Matt Sweat',
          original_name: 'Matt Sweat',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e94792514153af00cd59',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1185949,
          known_for_department: 'Production',
          name: 'Kyle David Crosby',
          original_name: 'Kyle David Crosby',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59582dd0c3a36828fc011fdc',
          department: 'Production',
          job: 'Production Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1205741,
          known_for_department: 'Diễn viên',
          name: 'Kevin Cassidy',
          original_name: 'Kevin Cassidy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c48d65b9251415e345385f2',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1236679,
          known_for_department: 'Biên kịch',
          name: 'Jonathan M. Goldstein',
          original_name: 'Jonathan M. Goldstein',
          popularity: 1.88,
          profile_path:
            'https://image.tmdb.org/t/p/w185/s1fwSaxlYvw3KdmRvT1ZSYhsEkJ.jpg',
          credit_id: '55b5c1a292514104570060dd',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 1236679,
          known_for_department: 'Biên kịch',
          name: 'Jonathan M. Goldstein',
          original_name: 'Jonathan M. Goldstein',
          popularity: 1.88,
          profile_path:
            'https://image.tmdb.org/t/p/w185/s1fwSaxlYvw3KdmRvT1ZSYhsEkJ.jpg',
          credit_id: '59582ab8c3a3682750010eb8',
          department: 'Biên kịch',
          job: 'Screenstory',
        },
        {
          adult: false,
          gender: 2,
          id: 1246890,
          known_for_department: 'Biên kịch',
          name: 'Chris McKenna',
          original_name: 'Chris McKenna',
          popularity: 5.781,
          profile_path: null,
          credit_id: '5794d034925141423600136d',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 1273235,
          known_for_department: 'Diễn viên',
          name: 'Stephen Conroy',
          original_name: 'Stephen Conroy',
          popularity: 1.491,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ngy98NITtbHvVPxcmcTMkSz1Knf.jpg',
          credit_id: '5c48d9099251410e245499a2',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 1,
          id: 1289978,
          known_for_department: 'Diễn viên',
          name: 'Chelsea Bruland',
          original_name: 'Chelsea Bruland',
          popularity: 0.652,
          profile_path: null,
          credit_id: '5c48d5e50e0a264965cd70b7',
          department: 'Crew',
          job: 'Utility Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1293994,
          known_for_department: 'Directing',
          name: 'Jon Watts',
          original_name: 'Jon Watts',
          popularity: 8.825,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fkXChMX6CUXY1yOxBehAzvaTCl7.jpg',
          credit_id: '5e8672d3e375c000143dea73',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1293994,
          known_for_department: 'Directing',
          name: 'Jon Watts',
          original_name: 'Jon Watts',
          popularity: 8.825,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fkXChMX6CUXY1yOxBehAzvaTCl7.jpg',
          credit_id: '587c26319251413ecb014a87',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 1319747,
          known_for_department: 'Costume & Make-Up',
          name: 'Garet Reilly',
          original_name: 'Garet Reilly',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1586c0c3a368071200fbe1',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1327405,
          known_for_department: 'Costume & Make-Up',
          name: 'Christian Cordella',
          original_name: 'Christian Cordella',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1585ba92514178c5010f21',
          department: 'Costume & Make-Up',
          job: 'Costume Illustrator',
        },
        {
          adult: false,
          gender: 0,
          id: 1329114,
          known_for_department: 'Costume & Make-Up',
          name: 'Susan J. Wright',
          original_name: 'Susan J. Wright',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1585e0c3a368071200fa93',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1329527,
          known_for_department: 'Crew',
          name: 'Jared Burke',
          original_name: 'Jared Burke',
          popularity: 1.13,
          profile_path:
            'https://image.tmdb.org/t/p/w185/g8vthdw69j4rmU0aEpJC2qMoa2I.jpg',
          credit_id: '5c48d5f8c3a368663485ca40',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1338421,
          known_for_department: 'Crew',
          name: 'Sean Christopher',
          original_name: 'Sean Christopher',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c48d6ea0e0a263ccdccf92b',
          department: 'Crew',
          job: 'Utility Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1338482,
          known_for_department: 'Sound',
          name: 'Chris Diebold',
          original_name: 'Chris Diebold',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5913042bc3a36864a7051d72',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1350918,
          known_for_department: 'Biên kịch',
          name: 'Erik Sommers',
          original_name: 'Erik Sommers',
          popularity: 4.779,
          profile_path: null,
          credit_id: '5794d026c3a3683fcf002c66',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 1,
          id: 1355532,
          known_for_department: 'Directing',
          name: 'Kerry Lyn McKissick',
          original_name: 'Kerry Lyn McKissick',
          popularity: 1.555,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5IAKLVCEBwqWBmMG0JEYgjfDaO0.jpg',
          credit_id: '5a15845992514178bf010dcd',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1358564,
          known_for_department: 'Crew',
          name: 'Trampas Thompson',
          original_name: 'Trampas Thompson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c48dff6c3a3684793893c9e',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 0,
          id: 1360098,
          known_for_department: 'Sound',
          name: 'Luis Galdames',
          original_name: 'Luis Galdames',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59130439c3a368650a050e04',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1365773,
          known_for_department: 'Diễn viên',
          name: 'Kate Boyer',
          original_name: 'Kate Boyer',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6xY6NgNLYyJTGUn4Ry0Hq3owSj0.jpg',
          credit_id: '5c48d5940e0a26495acd6836',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1365981,
          known_for_department: 'Diễn viên',
          name: 'Evan Dane Taylor',
          original_name: 'Evan Dane Taylor',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vAa36T4nIgAsDT3KRfllm5DxbWy.jpg',
          credit_id: '5c48ded6c3a3684793893a92',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 0,
          id: 1367661,
          known_for_department: 'Art',
          name: 'Audra Avery',
          original_name: 'Audra Avery',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59582b55c3a368265d012eb6',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 1,
          id: 1370799,
          known_for_department: 'Diễn viên',
          name: 'Jwaundace Candece',
          original_name: 'Jwaundace Candece',
          popularity: 1.681,
          profile_path: null,
          credit_id: '5c48d60d0e0a26495dcd5165',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1373709,
          known_for_department: 'Art',
          name: 'Jeffrey D. Simon',
          original_name: 'Jeffrey D. Simon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a158ccec3a3680733012047',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 1,
          id: 1378150,
          known_for_department: 'Crew',
          name: 'Elizabeth Davidovich',
          original_name: 'Elizabeth Davidovich',
          popularity: 0.865,
          profile_path: null,
          credit_id: '5c48db039251415e34539104',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 1,
          id: 1382498,
          known_for_department: 'Production',
          name: 'Leeann Stonebreaker',
          original_name: 'Leeann Stonebreaker',
          popularity: 1.286,
          profile_path: null,
          credit_id: '5913031b9251414eca050aec',
          department: 'Production',
          job: 'Unit Production Manager',
        },
        {
          adult: false,
          gender: 2,
          id: 1386320,
          known_for_department: 'Crew',
          name: 'Gianni Biasetti Jr.',
          original_name: 'Gianni Biasetti Jr.',
          popularity: 0.971,
          profile_path:
            'https://image.tmdb.org/t/p/w185/frt102sL0yaSl51pTv3hWj5NQAY.jpg',
          credit_id: '5c48d580c3a368477a89da83',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1389131,
          known_for_department: 'Art',
          name: 'John Hoskins',
          original_name: 'John Hoskins',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a158d4ac3a368071a012279',
          department: 'Art',
          job: 'Construction Coordinator',
        },
        {
          adult: false,
          gender: 1,
          id: 1389609,
          known_for_department: 'Costume & Make-Up',
          name: 'Heba Thorisdottir',
          original_name: 'Heba Thorisdottir',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/i8B2cXDxv58NoSCEG1XALUuu8CQ.jpg',
          credit_id: '59582d61925141088301393e',
          department: 'Costume & Make-Up',
          job: 'Makeup Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 1391591,
          known_for_department: 'Camera',
          name: 'Bruce MacCallum',
          original_name: 'Bruce MacCallum',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a15881ac3a36807330118e5',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1392143,
          known_for_department: 'Costume & Make-Up',
          name: 'Bob Moore Jr.',
          original_name: 'Bob Moore Jr.',
          popularity: 0.656,
          profile_path: null,
          credit_id: '5a158701c3a368071200fc43',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1393581,
          known_for_department: 'Costume & Make-Up',
          name: 'Jack Lazzaro',
          original_name: 'Jack Lazzaro',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59582c65c3a368265d012f93',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1394578,
          known_for_department: 'Lighting',
          name: 'Orlando Hernandez',
          original_name: 'Orlando Hernandez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a8f6844c3a3682dbc0063e5',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1394724,
          known_for_department: 'Camera',
          name: 'Chuck Zlotnick',
          original_name: 'Chuck Zlotnick',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a158a7f92514178cb011548',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 0,
          id: 1396840,
          known_for_department: 'Sound',
          name: 'Felipe Borrero',
          original_name: 'Felipe Borrero',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5913046f9251414eca050bf4',
          department: 'Sound',
          job: 'Sound Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 1397196,
          known_for_department: 'Sound',
          name: 'Bob Kellough',
          original_name: 'Bob Kellough',
          popularity: 0.6,
          profile_path: null,
          credit_id: '591304579251414e85053c83',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1398100,
          known_for_department: 'Visual Effects',
          name: 'Kilou Picard',
          original_name: 'Kilou Picard',
          popularity: 1.22,
          profile_path: null,
          credit_id: '5a16e7090e0a2612e800cf51',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1399315,
          known_for_department: 'Visual Effects',
          name: 'John Clinton',
          original_name: 'John Clinton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e6a4c3a368705500dba2',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1399319,
          known_for_department: 'Camera',
          name: 'Jaimie Trueblood',
          original_name: 'Jaimie Trueblood',
          popularity: 1.22,
          profile_path: null,
          credit_id: '5a158a9292514178b90121ad',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 0,
          id: 1399866,
          known_for_department: 'Crew',
          name: 'Joel Thompson',
          original_name: 'Joel Thompson',
          popularity: 0.648,
          profile_path: null,
          credit_id: '5a16e65cc3a368704600cb08',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1400085,
          known_for_department: 'Costume & Make-Up',
          name: 'Steve Constancio',
          original_name: 'Steve Constancio',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1586d4c3a368071a011861',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1401147,
          known_for_department: 'Crew',
          name: 'Anik Seguin',
          original_name: 'Anik Seguin',
          popularity: 1.094,
          profile_path: null,
          credit_id: '5a16e6490e0a2612e800cea8',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1401269,
          known_for_department: 'Production',
          name: 'Raul J. Marin',
          original_name: 'Raul J. Marin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1589e292514178bc011df2',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1401731,
          known_for_department: 'Visual Effects',
          name: 'Diana Giorgiutti',
          original_name: 'Diana Giorgiutti',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e71f0e0a2612ec00db92',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1401810,
          known_for_department: 'Visual Effects',
          name: 'Taisuke Tanimura',
          original_name: 'Taisuke Tanimura',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e4fc92514153a000d47a',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1401823,
          known_for_department: 'Production',
          name: 'Don J. Hug',
          original_name: 'Don J. Hug',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59582daa9251410b86013d52',
          department: 'Production',
          job: 'Production Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1401824,
          known_for_department: 'Production',
          name: 'Nadia Paine',
          original_name: 'Nadia Paine',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59130326c3a368650a050d33',
          department: 'Production',
          job: 'Unit Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1401968,
          known_for_department: 'Visual Effects',
          name: 'Janek Sirrs',
          original_name: 'Janek Sirrs',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e7880e0a2612ec00dc07',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1403412,
          known_for_department: 'Lighting',
          name: 'Dan Cornwall',
          original_name: 'Dan Cornwall',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5a1588e192514178c2011c8f',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1406780,
          known_for_department: 'Camera',
          name: 'Brian Heller',
          original_name: 'Brian Heller',
          popularity: 0.613,
          profile_path: null,
          credit_id: '5a1587d692514178c8011e6a',
          department: 'Camera',
          job: 'Aerial Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 1406893,
          known_for_department: 'Costume & Make-Up',
          name: 'Suzy Mazzarese-Allison',
          original_name: 'Suzy Mazzarese-Allison',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59582c739251410c56011cd3',
          department: 'Costume & Make-Up',
          job: 'Key Hair Stylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1409237,
          known_for_department: 'Visual Effects',
          name: 'Pimentel A. Raphael',
          original_name: 'Pimentel A. Raphael',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5a16e139c3a368705200d425',
          department: 'Visual Effects',
          job: 'Animation Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1410448,
          known_for_department: 'Crew',
          name: 'Shane Daniels',
          original_name: 'Shane Daniels',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5c48daef0e0a26494fcd73cd',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1412208,
          known_for_department: 'Costume & Make-Up',
          name: 'Carlane Passman',
          original_name: 'Carlane Passman',
          popularity: 1.011,
          profile_path: null,
          credit_id: '5a1585cd92514178c20117f4',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1412316,
          known_for_department: 'Art',
          name: 'Drew Monahan',
          original_name: 'Drew Monahan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59582b649251410883013792',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1412721,
          known_for_department: 'Editing',
          name: 'Elizabeth Hitt',
          original_name: 'Elizabeth Hitt',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5a16e929c3a368705700cdaf',
          department: 'Editing',
          job: 'Digital Intermediate',
        },
        {
          adult: false,
          gender: 2,
          id: 1413090,
          known_for_department: 'Art',
          name: 'Kirk Corwin',
          original_name: 'Kirk Corwin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a158d7ac3a36807120105f2',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 2,
          id: 1413092,
          known_for_department: 'Sound',
          name: 'James Morioka',
          original_name: 'James Morioka',
          popularity: 0.84,
          profile_path: null,
          credit_id: '5ae6da719251410cdc00855c',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1414993,
          known_for_department: 'Art',
          name: 'Heather Elwell',
          original_name: 'Heather Elwell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a158c6192514178bc012217',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1416093,
          known_for_department: 'Costume & Make-Up',
          name: 'Janine Rath',
          original_name: 'Janine Rath',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59582d4b9251410bfa013b6e',
          department: 'Costume & Make-Up',
          job: 'Hair Department Head',
        },
        {
          adult: false,
          gender: 2,
          id: 1416820,
          known_for_department: 'Lighting',
          name: 'Jason Velez',
          original_name: 'Jason Velez',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5a15890192514178b9011f09',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1417839,
          known_for_department: 'Costume & Make-Up',
          name: 'David Butler',
          original_name: 'David Butler',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5a15868fc3a3680733011674',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1418348,
          known_for_department: 'Costume & Make-Up',
          name: "Lucy O'Reilly",
          original_name: "Lucy O'Reilly",
          popularity: 0.6,
          profile_path: null,
          credit_id: '59582d24c3a368253c0118c7',
          department: 'Costume & Make-Up',
          job: 'Makeup Department Head',
        },
        {
          adult: false,
          gender: 2,
          id: 1418398,
          known_for_department: 'Camera',
          name: 'Will Arnot',
          original_name: 'Will Arnot',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a15883792514178c8011ed3',
          department: 'Camera',
          job: 'Steadicam Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1424160,
          known_for_department: 'Sound',
          name: 'Cameron Steenhagen',
          original_name: 'Cameron Steenhagen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ae6da7e9251410d20006fb1',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1424897,
          known_for_department: 'Art',
          name: 'Lauren Abiouness',
          original_name: 'Lauren Abiouness',
          popularity: 0.664,
          profile_path: null,
          credit_id: '5773dec3c3a36870b80002f1',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 1,
          id: 1425343,
          known_for_department: 'Sound',
          name: 'Vanessa Lapato',
          original_name: 'Vanessa Lapato',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ae6d9fd9251410d44006c08',
          department: 'Sound',
          job: 'Supervising ADR Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1425343,
          known_for_department: 'Sound',
          name: 'Vanessa Lapato',
          original_name: 'Vanessa Lapato',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ae6d9dcc3a368134e00d6e3',
          department: 'Sound',
          job: 'Supervising Dialogue Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1425616,
          known_for_department: 'Production',
          name: 'Amy Pascal',
          original_name: 'Amy Pascal',
          popularity: 1.295,
          profile_path:
            'https://image.tmdb.org/t/p/w185/texxoBV4naFHyuSii6jyxlfuEvK.jpg',
          credit_id: '54da5a25c3a368122700002d',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1428227,
          known_for_department: 'Costume & Make-Up',
          name: 'Tom Cummins',
          original_name: 'Tom Cummins',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1586ed92514178c8011cf0',
          department: 'Costume & Make-Up',
          job: 'Key Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1434544,
          known_for_department: 'Editing',
          name: 'Barry Goch',
          original_name: 'Barry Goch',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e9150e0a2612d700d335',
          department: 'Editing',
          job: 'Digital Intermediate',
        },
        {
          adult: false,
          gender: 0,
          id: 1436195,
          known_for_department: 'Costume & Make-Up',
          name: 'Branden Marks',
          original_name: 'Branden Marks',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1586af92514178bf01116f',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1442097,
          known_for_department: 'Costume & Make-Up',
          name: 'Jeri Baker',
          original_name: 'Jeri Baker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59582c0ac3a36828fc011e90',
          department: 'Costume & Make-Up',
          job: 'Hair Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 1455608,
          known_for_department: 'Visual Effects',
          name: 'Julius Kwan',
          original_name: 'Julius Kwan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e3d992514153ac00c939',
          department: 'Visual Effects',
          job: 'Lead Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 1461193,
          known_for_department: 'Costume & Make-Up',
          name: 'Jillian Erickson',
          original_name: 'Jillian Erickson',
          popularity: 0.98,
          profile_path: null,
          credit_id: '59582c4ac3a36828fc011ebd',
          department: 'Costume & Make-Up',
          job: 'Makeup Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 1462705,
          known_for_department: 'Crew',
          name: 'Elaine C. Andrianos',
          original_name: 'Elaine C. Andrianos',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e61ec3a368705200d9bb',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1463656,
          known_for_department: 'Crew',
          name: 'Dean Bailey',
          original_name: 'Dean Bailey',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xocAhU173kVnHnnC3cM8DaQKncT.jpg',
          credit_id: '5c48d3a30e0a26495acd6568',
          department: 'Crew',
          job: 'Stunt Driver',
        },
        {
          adult: false,
          gender: 0,
          id: 1473412,
          known_for_department: 'Visual Effects',
          name: 'Liz Bernard',
          original_name: 'Liz Bernard',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5a16e40f92514153af00c767',
          department: 'Visual Effects',
          job: 'Lead Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 1473417,
          known_for_department: 'Visual Effects',
          name: 'Ellen Hoffmann',
          original_name: 'Ellen Hoffmann',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e3f2c3a368705b00c089',
          department: 'Visual Effects',
          job: 'Lead Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 1473421,
          known_for_department: 'Visual Effects',
          name: 'Richard Smith',
          original_name: 'Richard Smith',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e185c3a368704f00d406',
          department: 'Visual Effects',
          job: 'Animation Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1483220,
          known_for_department: 'Crew',
          name: 'Brad Alexander',
          original_name: 'Brad Alexander',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e47e92514153a300d1f6',
          department: 'Visual Effects',
          job: 'Pre-Visualization Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1494208,
          known_for_department: 'Camera',
          name: 'Peter Gulla',
          original_name: 'Peter Gulla',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1587fbc3a368071a011a22',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1503694,
          known_for_department: 'Crew',
          name: 'Florian Hotz',
          original_name: 'Florian Hotz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c48d42e0e0a264965cd6daa',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1503698,
          known_for_department: 'Diễn viên',
          name: 'Alrik Kreemke',
          original_name: 'Alrik Kreemke',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bu5zesXpuJSKv0ezIThrYVfPahk.jpg',
          credit_id: '5c48dce1c3a36847778995fa',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 1,
          id: 1512725,
          known_for_department: 'Costume & Make-Up',
          name: 'Kat Percy',
          original_name: 'Kat Percy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59582d33c3a368265d013046',
          department: 'Costume & Make-Up',
          job: 'Hair Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 1533545,
          known_for_department: 'Sound',
          name: 'Joe Iemola',
          original_name: 'Joe Iemola',
          popularity: 0.6,
          profile_path: null,
          credit_id: '591304479251414e8d05124e',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1535095,
          known_for_department: 'Crew',
          name: 'Dan Brown',
          original_name: 'Dan Brown',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/Aa65AAZkoxPGt7L5royKFHIehYb.jpg',
          credit_id: '5c48d5b20e0a26494dcd06a9',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1543191,
          known_for_department: 'Production',
          name: 'Jason B. Stamey',
          original_name: 'Jason B. Stamey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a158739c3a368074201239a',
          department: 'Production',
          job: 'Casting Associate',
        },
        {
          adult: false,
          gender: 0,
          id: 1543197,
          known_for_department: 'Costume & Make-Up',
          name: 'Michelle Diamantides',
          original_name: 'Michelle Diamantides',
          popularity: 0.828,
          profile_path: null,
          credit_id: '59582c26925141088301382c',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1543198,
          known_for_department: 'Art',
          name: 'Cameron Beasley',
          original_name: 'Cameron Beasley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a158dacc3a3680712010630',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1543203,
          known_for_department: 'Art',
          name: 'Rachel Block',
          original_name: 'Rachel Block',
          popularity: 0.98,
          profile_path: null,
          credit_id: '591304099251414e80053cd4',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1543747,
          known_for_department: 'Visual Effects',
          name: 'Marie Rheinschild-Jordan',
          original_name: 'Marie Rheinschild-Jordan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e6ca92514153a000d697',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1543757,
          known_for_department: 'Lighting',
          name: 'Gary Blair',
          original_name: 'Gary Blair',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1589aac3a368071200ffa8',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1545984,
          known_for_department: 'Visual Effects',
          name: 'Maricel Pagulayan',
          original_name: 'Maricel Pagulayan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e6b692514153af00ca69',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1548530,
          known_for_department: 'Costume & Make-Up',
          name: 'Robert Wilson',
          original_name: 'Robert Wilson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59582d939251410bfa013ba7',
          department: 'Costume & Make-Up',
          job: 'Key Hair Stylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1549432,
          known_for_department: 'Crew',
          name: 'Kenton Hulme',
          original_name: 'Kenton Hulme',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e5db0e0a2612e800ce2a',
          department: 'Visual Effects',
          job: 'VFX Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1550725,
          known_for_department: 'Crew',
          name: 'Chris Cenatiempo',
          original_name: 'Chris Cenatiempo',
          popularity: 1.171,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9po0q1c33g3iu6vpAYnTxBVqQt1.jpg',
          credit_id: '5c48d694c3a36847938926e4',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1551872,
          known_for_department: 'Crew',
          name: 'Carlos-Christian Nickel',
          original_name: 'Carlos-Christian Nickel',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5a16e1b90e0a2612ec00d571',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1554754,
          known_for_department: 'Costume & Make-Up',
          name: 'Cynthia L. Chapman',
          original_name: 'Cynthia L. Chapman',
          popularity: 0.828,
          profile_path: null,
          credit_id: '59582c3ac3a368293b01446a',
          department: 'Costume & Make-Up',
          job: 'Hair Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 1559784,
          known_for_department: 'Art',
          name: 'Kil Won Yu',
          original_name: 'Kil Won Yu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a158def92514178cb011a91',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1560966,
          known_for_department: 'Camera',
          name: 'Bela Trutz',
          original_name: 'Bela Trutz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a15884ac3a368071a011a7b',
          department: 'Camera',
          job: 'Steadicam Operator',
        },
        {
          adult: false,
          gender: 1,
          id: 1565455,
          known_for_department: 'Sound',
          name: 'Andrea Datzman',
          original_name: 'Andrea Datzman',
          popularity: 1.83,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xUK8fv9LwC822En6w8FdpObuA13.jpg',
          credit_id: '5ba427f5c3a3680847001cd1',
          department: 'Biên kịch',
          job: 'Lyricist',
        },
        {
          adult: false,
          gender: 2,
          id: 1569769,
          known_for_department: 'Diễn viên',
          name: 'Chris Silcox',
          original_name: 'Chris Silcox',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sg45hdjGI8pce7fZG1JHzFEOvee.jpg',
          credit_id: '6192cec953866e008762d7c1',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 0,
          id: 1573037,
          known_for_department: 'Costume & Make-Up',
          name: 'Suzanna Boykin',
          original_name: 'Suzanna Boykin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59582c199251410cbc012993',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 2,
          id: 1576380,
          known_for_department: 'Diễn viên',
          name: 'Alvin Chong',
          original_name: 'Alvin Chong',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c48d6c10e0a264962cd75d1',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1578364,
          known_for_department: 'Crew',
          name: 'Keith Splinter Davis',
          original_name: 'Keith Splinter Davis',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5c48db18c3a368663485d5cb',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 1,
          id: 1590405,
          known_for_department: 'Visual Effects',
          name: 'Simone Kraus Townsend',
          original_name: 'Simone Kraus Townsend',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e122c3a368705500d565',
          department: 'Visual Effects',
          job: 'Animation Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1609856,
          known_for_department: 'Visual Effects',
          name: 'Nikos Kalaitzidis',
          original_name: 'Nikos Kalaitzidis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e2e092514153a900c903',
          department: 'Crew',
          job: 'Digital Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1634438,
          known_for_department: 'Crew',
          name: 'Allan Padelford',
          original_name: 'Allan Padelford',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c48deb49251410e2454a68b',
          department: 'Crew',
          job: 'Stunt Driver',
        },
        {
          adult: false,
          gender: 0,
          id: 1635159,
          known_for_department: 'Diễn viên',
          name: 'Donald K. Overstreet',
          original_name: 'Donald K. Overstreet',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nv5cSyQ78PDnZqNG0NCcOHfirRH.jpg',
          credit_id: '5c48de2a9251410e0a542f96',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 1,
          id: 1635194,
          known_for_department: 'Diễn viên',
          name: 'Adrienne Ballenger',
          original_name: 'Adrienne Ballenger',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c48d3bac3a36847898919a4',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 1,
          id: 1635195,
          known_for_department: 'Crew',
          name: 'Kelly Bellini',
          original_name: 'Kelly Bellini',
          popularity: 1.322,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yDd35tz7eSmZc2MgJqLFumAUIuy.jpg',
          credit_id: '5c48d5589251410e2454927a',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1635197,
          known_for_department: 'Crew',
          name: 'Marcelle Coletti',
          original_name: 'Marcelle Coletti',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c48d8f59251410e1b546e74',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1635201,
          known_for_department: 'Crew',
          name: 'Joe Dryden',
          original_name: 'Joe Dryden',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c48db560e0a26494fcd74e9',
          department: 'Crew',
          job: 'Utility Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1635202,
          known_for_department: 'Crew',
          name: 'Kevin Dyer',
          original_name: 'Kevin Dyer',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/omK2mx2UC1jKIjrj5pHgQuxABMx.jpg',
          credit_id: '5c48dbaa9251410e1b54735f',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1635212,
          known_for_department: 'Crew',
          name: 'Jared Losano',
          original_name: 'Jared Losano',
          popularity: 0.65,
          profile_path: null,
          credit_id: '5c48dde10e0a264965cd84b5',
          department: 'Crew',
          job: 'Stunt Driver',
        },
        {
          adult: false,
          gender: 2,
          id: 1637322,
          known_for_department: 'Diễn viên',
          name: 'Hamid-Reza Benjamin Thompson',
          original_name: 'Hamid-Reza Benjamin Thompson',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rOBcfuKyRp2mA6cAAOvxz8rfLIi.jpg',
          credit_id: '5c48dfe092514151a94f41b0',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 0,
          id: 1637396,
          known_for_department: 'Visual Effects',
          name: 'Dominik Zimmerle',
          original_name: 'Dominik Zimmerle',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e845c3a368705200dc1e',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1643142,
          known_for_department: 'Production',
          name: 'Eric Hauserman Carroll',
          original_name: 'Eric Hauserman Carroll',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6rswcsUV6vrAgx0hM5pOpnhlaQl.jpg',
          credit_id: '5773de059251417fde0003f7',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1643711,
          known_for_department: 'Costume & Make-Up',
          name: 'Ashley McGuire',
          original_name: 'Ashley McGuire',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59582cae9251410cbc012a25',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1649516,
          known_for_department: 'Visual Effects',
          name: 'Brendan Seals',
          original_name: 'Brendan Seals',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e818c3a368705b00c500',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1661555,
          known_for_department: 'Camera',
          name: 'Rick Marroquin',
          original_name: 'Rick Marroquin',
          popularity: 1.214,
          profile_path: null,
          credit_id: '5a15893d92514178c5011445',
          department: 'Camera',
          job: 'Key Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1673231,
          known_for_department: 'Visual Effects',
          name: 'Doug Spilatro',
          original_name: 'Doug Spilatro',
          popularity: 1.124,
          profile_path: null,
          credit_id: '5a16e79d92514153a300d580',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1691335,
          known_for_department: 'Diễn viên',
          name: 'Brittini London',
          original_name: 'Brittini London',
          popularity: 0.982,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jLWaFwYXors0fNFeI2BzYUzQcaI.jpg',
          credit_id: '5c48dd78c3a368576a88c076',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 2,
          id: 1702414,
          known_for_department: 'Crew',
          name: 'Scott Dale',
          original_name: 'Scott Dale',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c48dab592514154484f2510',
          department: 'Crew',
          job: 'Stunt Driver',
        },
        {
          adult: false,
          gender: 0,
          id: 1706712,
          known_for_department: 'Visual Effects',
          name: 'Mike F. Hedayati',
          original_name: 'Mike F. Hedayati',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e82f0e0a2612ec00dcd4',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1712002,
          known_for_department: 'Costume & Make-Up',
          name: 'Kellie Robinson',
          original_name: 'Kellie Robinson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59582d56c3a36827500110c3',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1712002,
          known_for_department: 'Costume & Make-Up',
          name: 'Kellie Robinson',
          original_name: 'Kellie Robinson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5913030c9251414edb0543af',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1713056,
          known_for_department: 'Crew',
          name: 'Jep Hill',
          original_name: 'Jep Hill',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e2900e0a2612d900cbc0',
          department: 'Crew',
          job: 'Digital Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1718655,
          known_for_department: 'Crew',
          name: 'Floyd Anthony Johns Jr.',
          original_name: 'Floyd Anthony Johns Jr.',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lC0PaMSccKZ8gkV9qihWbOtdqo0.jpg',
          credit_id: '5c48dcc8c3a368477a89e9cb',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 0,
          id: 1721336,
          known_for_department: 'Crew',
          name: 'Andrew Zink',
          original_name: 'Andrew Zink',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e1eb925141539d00d128',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1721445,
          known_for_department: 'Visual Effects',
          name: 'Immanuel Morris',
          original_name: 'Immanuel Morris',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5a16e7ed92514153a600c997',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1723161,
          known_for_department: 'Crew',
          name: 'Holland Diaz',
          original_name: 'Holland Diaz',
          popularity: 0.84,
          profile_path: null,
          credit_id: '5c48d41392514154484f1597',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 0,
          id: 1724279,
          known_for_department: 'Visual Effects',
          name: 'Kenneth Au',
          original_name: 'Kenneth Au',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e7c792514153a900ce41',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1738103,
          known_for_department: 'Camera',
          name: 'Jared Slater',
          original_name: 'Jared Slater',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1587c392514178c5011244',
          department: 'Camera',
          job: 'Aerial Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1738651,
          known_for_department: 'Crew',
          name: 'Roy Malhi',
          original_name: 'Roy Malhi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e1c8c3a368704a00c613',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1746433,
          known_for_department: 'Visual Effects',
          name: 'Alexandre Cancado',
          original_name: 'Alexandre Cancado',
          popularity: 1.008,
          profile_path: null,
          credit_id: '5a16e1d992514153af00c55b',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1747926,
          known_for_department: 'Camera',
          name: 'John D. Miller',
          original_name: 'John D. Miller',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a15892c92514178c801201d',
          department: 'Camera',
          job: 'Key Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1747999,
          known_for_department: 'Costume & Make-Up',
          name: 'Julia Gombert',
          original_name: 'Julia Gombert',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a15866392514178b6011423',
          department: 'Costume & Make-Up',
          job: 'Ager/Dyer',
        },
        {
          adult: false,
          gender: 1,
          id: 1770927,
          known_for_department: 'Costume & Make-Up',
          name: 'Denise Pugh-Ruiz',
          original_name: 'Denise Pugh-Ruiz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59582d4092514109e4013055',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 1,
          id: 1774412,
          known_for_department: 'Production',
          name: "Rachel O'Connor",
          original_name: "Rachel O'Connor",
          popularity: 0.6,
          profile_path: null,
          credit_id: '619fdf0b35db450043393f12',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1787829,
          known_for_department: 'Editing',
          name: 'Dawn Michelle King',
          original_name: 'Dawn Michelle King',
          popularity: 0.766,
          profile_path: null,
          credit_id: '5a16e96492514153af00cd7f',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1797602,
          known_for_department: 'Diễn viên',
          name: 'Richard Marrero',
          original_name: 'Richard Marrero',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dkyrndpFfzJolEmvVKHb6lwQeGC.jpg',
          credit_id: '5c48ddfd0e0a26494fcd8001',
          department: 'Crew',
          job: 'Stunt Driver',
        },
        {
          adult: false,
          gender: 0,
          id: 1815939,
          known_for_department: 'Visual Effects',
          name: 'Jan Reichmann',
          original_name: 'Jan Reichmann',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e5f0c3a368704800c79c',
          department: 'Visual Effects',
          job: 'VFX Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1824513,
          known_for_department: 'Visual Effects',
          name: 'Aaron Colman-Hayes',
          original_name: 'Aaron Colman-Hayes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e0b2c3a368705500d4ca',
          department: 'Visual Effects',
          job: '3D Modeller',
        },
        {
          adult: false,
          gender: 0,
          id: 1829977,
          known_for_department: 'Visual Effects',
          name: 'Steph Lynn Robinson',
          original_name: 'Steph Lynn Robinson',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/n9vHOr54XygWhSpZsqVq1qMBAVB.jpg',
          credit_id: '5a16e54fc3a368705500d9ca',
          department: 'Visual Effects',
          job: 'Stereoscopic Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1842740,
          known_for_department: 'Costume & Make-Up',
          name: 'Joseph Negrete',
          original_name: 'Joseph Negrete',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59582cf7c3a3682750011074',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1842741,
          known_for_department: 'Costume & Make-Up',
          name: 'Seidah Nichols',
          original_name: 'Seidah Nichols',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59582d019251410bfa013b1e',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1842743,
          known_for_department: 'Costume & Make-Up',
          name: 'Enrique Vega',
          original_name: 'Enrique Vega',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59582d6f9251410cbc012acc',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1851867,
          known_for_department: 'Diễn viên',
          name: 'Charles Barden',
          original_name: 'Charles Barden',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c48d542c3a368663485c874',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1851886,
          known_for_department: 'Crew',
          name: 'Niko Dalman',
          original_name: 'Niko Dalman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c48dad092514154484f2522',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1853442,
          known_for_department: 'Crew',
          name: 'Cody Banta',
          original_name: 'Cody Banta',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5c48d527c3a368576a88b0f3',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1860862,
          known_for_department: 'Lighting',
          name: 'Adam Harrison',
          original_name: 'Adam Harrison',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a158a5192514178c501162f',
          department: 'Lighting',
          job: 'Rigging Gaffer',
        },
        {
          adult: false,
          gender: 1,
          id: 1869061,
          known_for_department: 'Crew',
          name: 'Sarah Reagin',
          original_name: 'Sarah Reagin',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/btDWbkVeDo2qmk71Iab33aTN9q5.jpg',
          credit_id: '5c48d757c3a3684777898991',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1893166,
          known_for_department: 'Visual Effects',
          name: 'Andy Yamada',
          original_name: 'Andy Yamada',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e574925141539d00d4d4',
          department: 'Visual Effects',
          job: 'Stereoscopic Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1900164,
          known_for_department: 'Diễn viên',
          name: 'Marc Canonizado',
          original_name: 'Marc Canonizado',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/37zMatkJimn5EeWmfgYq6Dd87Wc.jpg',
          credit_id: '5c48d6239251410e245493d2',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 1,
          id: 1915275,
          known_for_department: 'Visual Effects',
          name: 'Megan Flood',
          original_name: 'Megan Flood',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e7da0e0a2612e800d037',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1927991,
          known_for_department: 'Costume & Make-Up',
          name: 'Ian Churchill',
          original_name: 'Ian Churchill',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a15857192514178c2011769',
          department: 'Costume & Make-Up',
          job: 'Ager/Dyer',
        },
        {
          adult: false,
          gender: 0,
          id: 1927992,
          known_for_department: 'Costume & Make-Up',
          name: 'Deb Downing',
          original_name: 'Deb Downing',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a15859c92514178bc011746',
          department: 'Costume & Make-Up',
          job: 'Costume Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1927993,
          known_for_department: 'Costume & Make-Up',
          name: 'Lisa Halperin',
          original_name: 'Lisa Halperin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a15869fc3a368071a011806',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1927995,
          known_for_department: 'Costume & Make-Up',
          name: 'Lawrence Tarzy',
          original_name: 'Lawrence Tarzy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a158712c3a368072301124c',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1928000,
          known_for_department: 'Lighting',
          name: 'Kevin Jackson',
          original_name: 'Kevin Jackson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a158983c3a3680733011adb',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1928001,
          known_for_department: 'Lighting',
          name: "Berrian 'Scarecrow' Hobby IV",
          original_name: "Berrian 'Scarecrow' Hobby IV",
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1589c1c3a368073e012b5d',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1928002,
          known_for_department: 'Lighting',
          name: 'Joseph Kendrick',
          original_name: 'Joseph Kendrick',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a1589d092514178b6011922',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1928005,
          known_for_department: 'Camera',
          name: 'Pyare Fortunato',
          original_name: 'Pyare Fortunato',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a158a6e92514178cb01152e',
          department: 'Camera',
          job: 'Steadicam Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1928010,
          known_for_department: 'Art',
          name: 'Bianca Siu Davies',
          original_name: 'Bianca Siu Davies',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a158c72c3a3680733011fb4',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1928012,
          known_for_department: 'Art',
          name: 'Rodney Fuentebella',
          original_name: 'Rodney Fuentebella',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ewvenMc2XY3UGXImeJZQuF4O51I.jpg',
          credit_id: '5a158d2192514178bf011b54',
          department: 'Art',
          job: 'Conceptual Illustrator',
        },
        {
          adult: false,
          gender: 0,
          id: 1928015,
          known_for_department: 'Art',
          name: 'Justin Trudeau',
          original_name: 'Justin Trudeau',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a158dcdc3a368071a01235f',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1928580,
          known_for_department: 'Visual Effects',
          name: 'Tim Ranck',
          original_name: 'Tim Ranck',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e10a92514153a300ce7e',
          department: 'Visual Effects',
          job: 'Animation Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1928583,
          known_for_department: 'Crew',
          name: 'Joosten Kuypers',
          original_name: 'Joosten Kuypers',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e1fd92514153a000d198',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1928584,
          known_for_department: 'Crew',
          name: 'Chris Smallfield',
          original_name: 'Chris Smallfield',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e20e0e0a2612e500c9cc',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1928585,
          known_for_department: 'Crew',
          name: 'Justin Johnson',
          original_name: 'Justin Johnson',
          popularity: 1.019,
          profile_path: null,
          credit_id: '5a16e2cbc3a368705b00bf7c',
          department: 'Crew',
          job: 'Digital Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1928587,
          known_for_department: 'Visual Effects',
          name: 'Chris Waegner',
          original_name: 'Chris Waegner',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e2f192514153a000d294',
          department: 'Crew',
          job: 'Digital Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1928588,
          known_for_department: 'Visual Effects',
          name: 'Kevin Culhane',
          original_name: 'Kevin Culhane',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e3370e0a2612dd00c8f6',
          department: 'Visual Effects',
          job: 'Lead Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 1928591,
          known_for_department: 'Visual Effects',
          name: 'Lisa Wang',
          original_name: 'Lisa Wang',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e38d92514153b200c7e1',
          department: 'Visual Effects',
          job: 'Lead Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 1928592,
          known_for_department: 'Visual Effects',
          name: 'Arda Uysal',
          original_name: 'Arda Uysal',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e3bcc3a368705500d808',
          department: 'Visual Effects',
          job: 'Lead Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 1928594,
          known_for_department: 'Visual Effects',
          name: 'Patrick Haskew',
          original_name: 'Patrick Haskew',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e4910e0a2612e800cc75',
          department: 'Visual Effects',
          job: 'Pre-Visualization Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1928595,
          known_for_department: 'Visual Effects',
          name: 'Javier Lopez-Duprey',
          original_name: 'Javier Lopez-Duprey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e4a392514153a600c5ef',
          department: 'Visual Effects',
          job: 'Pre-Visualization Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1928597,
          known_for_department: 'Crew',
          name: 'Xinling Chen',
          original_name: 'Xinling Chen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e4d892514153af00c82b',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1928598,
          known_for_department: 'Crew',
          name: 'Scott Englert',
          original_name: 'Scott Englert',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e4ea0e0a2612df00cfee',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1928599,
          known_for_department: 'Crew',
          name: 'Mariatta Wijaya',
          original_name: 'Mariatta Wijaya',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e5110e0a2612d900ce11',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1928600,
          known_for_department: 'Crew',
          name: 'Valerie Bernard',
          original_name: 'Valerie Bernard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e52192514153a300d2c1',
          department: 'Crew',
          job: 'Software Engineer',
        },
        {
          adult: false,
          gender: 0,
          id: 1928601,
          known_for_department: 'Crew',
          name: 'Francisco Ramirez',
          original_name: 'Francisco Ramirez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e68892514153af00ca3d',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1928604,
          known_for_department: 'Visual Effects',
          name: 'Eric Kimelton',
          original_name: 'Eric Kimelton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e6f192514153a600c898',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1928605,
          known_for_department: 'Visual Effects',
          name: 'Lou Pecora',
          original_name: 'Lou Pecora',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e774c3a368704600cc2d',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1928606,
          known_for_department: 'Visual Effects',
          name: 'Dan Bethell',
          original_name: 'Dan Bethell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e80292514153b200ccc2',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1928608,
          known_for_department: 'Visual Effects',
          name: 'Scott Seungpil Jung',
          original_name: 'Scott Seungpil Jung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e87f92514153a900cf1b',
          department: 'Visual Effects',
          job: 'Visual Effects Technical Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1928609,
          known_for_department: 'Visual Effects',
          name: 'Kevin Kitchel',
          original_name: 'Kevin Kitchel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e8940e0a2612dd00ceee',
          department: 'Visual Effects',
          job: 'Visual Effects Technical Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1928610,
          known_for_department: 'Visual Effects',
          name: 'Viktor Lundqvist',
          original_name: 'Viktor Lundqvist',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a16e8a70e0a2612e500d111',
          department: 'Visual Effects',
          job: 'Visual Effects Technical Director',
        },
        {
          adult: false,
          gender: 1,
          id: 2224819,
          known_for_department: 'Crew',
          name: 'Nitasha Bhambree',
          original_name: 'Nitasha Bhambree',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c48d56d0e0a26495dcd5070',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 2224820,
          known_for_department: 'Crew',
          name: 'Sebastiano Cartier',
          original_name: 'Sebastiano Cartier',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c48d6409251410e245493fd',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 1,
          id: 2224824,
          known_for_department: 'Crew',
          name: 'Elizabeth Classen',
          original_name: 'Elizabeth Classen',
          popularity: 0.828,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ka2HyR2xKrcO3bFba90OSTDgRg1.jpg',
          credit_id: '5c48d7049251415e3453871c',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 2224825,
          known_for_department: 'Crew',
          name: 'Tye Claybrook Jr.',
          original_name: 'Tye Claybrook Jr.',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5c48d7240e0a264965cd73f6',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 2224833,
          known_for_department: 'Crew',
          name: 'David Elson',
          original_name: 'David Elson',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8KM7BfZXgVqaAWjXqPS6hEdWWQI.jpg',
          credit_id: '5c48db940e0a260419ca20f0',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 1,
          id: 2224834,
          known_for_department: 'Crew',
          name: 'Katie Kramer',
          original_name: 'Katie Kramer',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yiwKToB0v8XxwG4mbYSs7sI87JT.jpg',
          credit_id: '5c48dc4f0e0a263ccdcd0137',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 2,
          id: 2224841,
          known_for_department: 'Crew',
          name: 'Amadei Weiland',
          original_name: 'Amadei Weiland',
          popularity: 0.617,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rTcefSlxINKaEzlO1GqF2O3wA5X.jpg',
          credit_id: '5c48e0290e0a26495dcd68f9',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 2,
          id: 2234460,
          known_for_department: 'Diễn viên',
          name: 'Harrison Osterfield',
          original_name: 'Harrison Osterfield',
          popularity: 1.799,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yX5auOS06AgMzOXEOs9f0eqiuNg.jpg',
          credit_id: '5e2e6f6a1685da0017e97074',
          department: 'Crew',
          job: "Actor's Assistant",
        },
        {
          adult: false,
          gender: 0,
          id: 2384271,
          known_for_department: 'Visual Effects',
          name: 'Davide Binello',
          original_name: 'Davide Binello',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d4ff08d079a970b9eae09bc',
          department: 'Visual Effects',
          job: 'Matte Painter',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'Gimly',
          author_details: {
            name: 'Gimly',
            username: 'Ruuz',
            avatar_path: '/xUObnJSvHrFPsIpoDmb1jiQZLq7.jpg',
            rating: 7.0,
          },
          content:
            "There's now officially (not at all officially, more like just-my-opinion-ally) twice as many good Spider-Man movies as there is bad ones. But _Homecoming_ is my favourite of the bunch. 2017 has been a great year for  the Superhero genre, and _Spider-Man: Homecoming_ does nothing to buck that trend. It's got everything a Spider-Man movie should have: Heart, humour, action, spectacle, a grounded school life, coming-of-age themes, and all this while firmly rooting itself in the Marvel Cinematic Universe -- without relying on the framework of the past to hold it up. _Spider-Man: Homecoming_ is spectacular, and it stands up both on its own, and as a part of the larger universe.\r\n\r\n_Final rating:★★★½ - I really liked it. Would strongly recommend you give it your time._",
          created_at: '2017-07-10T09:07:43.738Z',
          id: '596343df9251410b860f177c',
          updated_at: '2021-06-23T15:57:59.209Z',
          url: 'https://www.themoviedb.org/review/596343df9251410b860f177c',
        },
        {
          author: 'AJGibbs',
          author_details: {
            name: '',
            username: 'AJGibbs',
            avatar_path: null,
            rating: 4.0,
          },
          content:
            "Disappointing return for the webslinger. After the dramatic introduction in Civil War this film feels like an excercise in keeping the coffers full.\r\nUnlike the Toby Maguire films this incarnation feels flat. It never manages to really put our superhero in any real peril...it just goes through the motions and ticks boxes. Granted it is mostly enjoyable, but did we need it??\r\nNo.\r\n\r\nThe suit and inclusion of Iron Man takes away from what is great about Spiderman. The fact he has to juggle school, work, realationships is what kept him grounded...\r\nHe does not need Iron Man's suit or him flying in to save the day!!\r\n\r\nAlso, why does he not have a spidey-sense?!? He gets nailed left, right and centre!\r\n\r\n*  To conclude; disappointing, Yes, as Spiderman just became another member of Tony's team...when he should stand alone.",
          created_at: '2017-12-12T01:23:57.898Z',
          id: '5a2f2fad925141032c16f0e7',
          updated_at: '2021-06-23T15:58:03.360Z',
          url: 'https://www.themoviedb.org/review/5a2f2fad925141032c16f0e7',
        },
        {
          author: 'Per Gunnar Jonsson',
          author_details: {
            name: 'Per Gunnar Jonsson',
            username: 'Dark Jedi',
            avatar_path:
              '/https://secure.gravatar.com/avatar/cbabaea0fa98692d00130498d7ac5d7c.jpg',
            rating: 4.0,
          },
          content:
            "I guess I should not be too surprised given the Spider Man character we saw in the latest Captain America but I have to say that I was, well, hoping for something else, as in something better.\r\n\r\nIf the producer/writer intended to make a Spider Man movie for kids, and I mean kids, not young adults but kids, then this movie is hitting the spot. It is an excellent action/adventure movie for kids. Unfortunately I am not really in that viewer segment and for me this movie was pretty bad.\r\n\r\nThe movie is childish. There is no other way to describe it. My memory of spider man is a quite serious young man with a sharp and witty tongue. Not the fumbling and childish Spider Man in this movie. His best friend may be a good computer geek but otherwise he is dumb as a door nail and just tiring to watch. His, supposedly adult handler is a screw up who, surprise surprise, is hanging up the phone because he cannot be bothered to listen to kids.\r\n\r\nThe FX may be good as FX goes visually but it was also the typical, nonsensical Hollywood rubbish like boats that stays afloat forever despite being split in half etc. etc. The talking Spider Man suit appears to be programmed by the same guy who wrote the childish script.\r\n\r\nThe main bad guy pretty much has zero charisma and is nothing but a simple thief. Same goes for his buddies.\r\n\r\nThe SJW crap spread out here and there in the movie, especially in the Washington Monument scenes, was unwanted and just pissed me off.\r\n\r\nI am afraid that this movie missed its mark for me by a wide margin. I do not understand why it seems to be so bloody difficult for Hollywood to make a good Spider Man movie. I like Spider Man, the comics character that is, so I find the slew of substandard movies really disappointing.\r\n\r\nThe only reason it doesn't get less than two out of three stars from me is because, as a kids movie, it is not at all bad (except for the SJW crap). It wasn't what I was looking for though.",
          created_at: '2017-12-26T16:59:11.029Z',
          id: '5a427fdf0e0a2620e9056c3d',
          updated_at: '2021-06-23T15:58:03.598Z',
          url: 'https://www.themoviedb.org/review/5a427fdf0e0a2620e9056c3d',
        },
        {
          author: 'Reno',
          author_details: {
            name: 'Reno',
            username: 'Rangan',
            avatar_path: '/6ZpVUJzqXMzH35VprEtnX0sNI3.jpg',
            rating: 7.0,
          },
          content:
            "**Young & hungry to fight crimes!**\r\n\r\nNo doubt, Tobey Maguire Spider-man is the best. It was also the first modern superhero of the millennium. The visual effects and entertainment wise, the second live-action Spider-man was good too, but this one is so different. This is about a teenage superhero. Just a kid. Having possessed such superpower, how he manages it alongside his normal life was nicely told.\r\n\r\nThis story begins straight away, because the introduction was done in the previous Marvel film, which are part of Avengers universe. Peter Parker assisted by Tony Stark, is very keen to fight small crimes compared to what Avengers fighting for. He feels, he's held back by Iron Man, so he wanted to make independent decisions. At one stage he succeeds in that, but things get more severe. Fighting bad guys, and the other side of his life, a romance, how the remaining story turns out are revealed with a twist.\r\n\r\nTom Holland was good. The story was simple, more like one liner. But the visuals and each scene forged nicely. Having seen all the five previous Spider-man films, this was quite predictable. Particularly the characters and their connections. Seeing how it had ended, it is possible that the daughter of the villain could take-over her father's place. That would be very interesting, because of the linkage between the film characters.\r\n\r\nAfter seeing the first look, I was afraid that this young Spider-man might be overshadowed by Iron Man, but those parts really well done. Comparing it with the 15 years ago Spider-man, the technology has been the biggest change. That's why I still love Tobey Maguire film. Very simple and down to the earth without cell phones, computers. But the current superhero films are all alien oriented/connected theme, and of course digital technology a big leap. Hoping the next film too would impress us with the same intensity. So lets wait for summer 2019.\r\n\r\n_7/10_",
          created_at: '2018-02-04T13:42:39.750Z',
          id: '5a770dcfc3a36859ec04ad39',
          updated_at: '2021-06-23T15:58:04.715Z',
          url: 'https://www.themoviedb.org/review/5a770dcfc3a36859ec04ad39',
        },
        {
          author: 'A Fan of Many Things',
          author_details: {
            name: 'A Fan of Many Things',
            username: 'Pippiang',
            avatar_path: '/kRIm0w5CHvd8ifNSqgYOMvsoIL6.jpg',
            rating: 10.0,
          },
          content:
            "After the failure that was 'The Amazing Spider-man 2' Sony made a drastic decision in lending the character back to Marvel, and did it pay off? Absolutely!\r\n\r\nUnlike the Sam Raimi trilogy where Toby Maguire was a better Peter Parker than Spider-man and the Mark Webb duology where Andrew Garfield was a better Spider-man than a Peter, Tom Holland encapsulates both characters perfectly.\r\nOf course there were a negatives, especially in the second act which drops off a bit but the movies does such a wonderful job of recapturing our attention that you just can't help but forgive the movie for it!",
          created_at: '2018-06-10T17:41:09.145Z',
          id: '5b1d62b59251416614000cb5',
          updated_at: '2021-06-23T15:58:09.439Z',
          url: 'https://www.themoviedb.org/review/5b1d62b59251416614000cb5',
        },
        {
          author: 'skembry',
          author_details: {
            name: '',
            username: 'skembry',
            avatar_path:
              '/https://secure.gravatar.com/avatar/4ea62f6b572569c494a879bfe872d25c.jpg',
            rating: 10.0,
          },
          content: 'AMAZING!!',
          created_at: '2018-07-19T23:40:43.886Z',
          id: '5b51217b92514112ae005fe6',
          updated_at: '2021-06-23T15:58:10.666Z',
          url: 'https://www.themoviedb.org/review/5b51217b92514112ae005fe6',
        },
        {
          author: 'Andrew Gentry',
          author_details: {
            name: 'Andrew Gentry',
            username: 'AndrewGentry',
            avatar_path: '/vVGgWZe3bDdy0fsODYDtrL8J51b.jpg',
            rating: 9.0,
          },
          content:
            'My expectations were extremely low before this one Đã phát hành. Can\'t argue that the Amazing Spider-Man movies are very bad, yet there is always a room for a getting worse. But seriously, Homecoming has completely changed my experience from movies by Marvel x <a href="https://free-psn-codes.org/">Sony</a> Pictures. It was entertaining and moving. Furthermore, it\'s as good for re-watch as well, what is a completely new experience for me.',
          created_at: '2018-10-22T09:00:34.868Z',
          id: '5bcd91b20e0a26015b01dfd9',
          updated_at: '2021-06-23T15:58:13.831Z',
          url: 'https://www.themoviedb.org/review/5bcd91b20e0a26015b01dfd9',
        },
        {
          author: 'tmdb44006625',
          author_details: {
            name: '',
            username: 'tmdb44006625',
            avatar_path: null,
            rating: 5.0,
          },
          content:
            "Spider-Man: Homecoming can't even hold a candle next to Sam Raimi's first two Spider-Man films, not to mention Spider-Man: Into the Spiderverse. Homecoming is simply Marvel's integration of Spider-Man into the MCU. It works on that level. Tom Holland is a good Peter Parker; finally an actor that looks like a high school student! Marisa Tomei does a really cool, sexy Aunt May, which I never thought I'd ever see. Michael Keaton is excellent as Vulture, one of the more interesting villains in the MCU.\r\n\r\nThe relationship between Tony Stark and Peter Parker is good but should have been better. It's clear that they half-assed the development of these two characters. The high-tech Spidey suit is neat but gives off the sense that the movie is trying to be too much like Iron Man.",
          created_at: '2019-03-09T20:44:24.443Z',
          id: '5c8425a80e0a264301635857',
          updated_at: '2021-06-23T15:58:19.169Z',
          url: 'https://www.themoviedb.org/review/5c8425a80e0a264301635857',
        },
        {
          author: 'Myles',
          author_details: {
            name: 'Myles',
            username: 'mfrencken',
            avatar_path: '/3n6oS5nnHo5sU1DRNTbOr6JMjY7.jpg',
            rating: 8.0,
          },
          content:
            "I personally thought all hope was lost, there's no way ANOTHER Spider-Man reboot could be successful. Yet this movie is colourful, fun, and fitting movie for the MCU",
          created_at: '2019-04-07T04:10:32.288Z',
          id: '5ca97838c3a3683f5260a0c8',
          updated_at: '2021-06-23T15:58:20.051Z',
          url: 'https://www.themoviedb.org/review/5ca97838c3a3683f5260a0c8',
        },
        {
          author: 'r96sk',
          author_details: {
            name: '',
            username: 'r96sk',
            avatar_path:
              '/https://secure.gravatar.com/avatar/96c2e0e4ac98450f9e8e3c0a0a40aad8.jpg',
            rating: 8.0,
          },
          content:
            "A lot of fun!\r\n\r\n<em>'Spider-Man: Homecoming'</em> is entertaining, as I had expected in truth. The plot is possibly not as great as it could've been, but it is still one that is enjoyable to see. The effects are excellent, as is the humour.\r\n\r\nTom Holland is the star of this though. He kills it as the titular character, he adds a tremendous amount to the film. Michael Keaton plays his role well enough, while it's cool to see <em>'Iron Man'</em> duo Robert Downey Jr. and Jon Favreau involved.\r\n\r\nJacob Batalon is good, while it's noteworthy to have Zendaya and Donald Glover appear; even if they are underused/unimportant, at least for now for the former, I assume. I found the whole cast enjoyable, to be fair.\r\n\r\nThis narrowly misses the next rating up from me, but I still had a very pleasant time watching - and await the follow-up with much eagerness!",
          created_at: '2021-01-21T23:29:38.251Z',
          id: '600a0e62cf9ba3003f834452',
          updated_at: '2021-06-23T15:58:50.475Z',
          url: 'https://www.themoviedb.org/review/600a0e62cf9ba3003f834452',
        },
      ],
      total_pages: 1,
      total_results: 10,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/kMRdsjSHifqGZPfHdZIS8YfNMk0.jpg',
    belongs_to_collection: null,
    budget: 60000000,
    genres: [
      { id: 28, name: 'Phim Hành Động' },
      { id: 80, name: 'Phim Hình Sự' },
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 53, name: 'Phim Gây Cấn' },
    ],
    homepage: '',
    id: 949,
    imdb_id: 'tt0113277',
    original_language: 'en',
    original_title: 'Heat',
    overview:
      'Một chiếc xe bọc thép chở tiền bị đánh cắp giữa thành phố Los Angeles. Ba nhân viên bảo vệ trên xe bị bắn chết. tẩu thoát ngay trước một rừng cảnh sát, bọn cướp không đả động tới tiền mặt, chỉ mang theo một đống trái phiếu trị giá 1,6 triệu đô la của Malibu Equity Investment, một công ty sản xuất vũ khí. Một tay cớm sừng sỏ của sở cảnh sát Los Angeles lần theo dấu vết và nhận ra, anh phải đối đầu với 1 tổ chức xã hội đen nguy hiểm, được cầm đầu bởi 1 tên trùm cũng sừng sỏ không kém.',
    popularity: 31.39,
    poster_path:
      'https://image.tmdb.org/t/p/w342/5Hb8N5q9YdK1KpJbZLhesMTDINi.jpg',
    production_companies: [
      {
        id: 508,
        logo_path: '/7PzJdsLGlR7oW4J0J5Xcd0pHGRg.png',
        name: 'Regency Enterprises',
        origin_country: 'US',
      },
      { id: 675, logo_path: null, name: 'Forward Pass', origin_country: 'US' },
      {
        id: 174,
        logo_path: '/IuAlhI9eVC9Z8UQWOIDdWRKSEJ.png',
        name: 'Warner Bros. Pictures',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '1995-12-15',
    revenue: 187436818,
    runtime: 170,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
      { english_name: 'Spanish', iso_639_1: 'es', name: 'Español' },
    ],
    status: 'Đã phát hành',
    tagline: 'A Los Angeles crime saga.',
    title: 'Kỳ Phùng Địch Thủ',
    video: false,
    vote_average: 7.9,
    vote_count: 5200,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Heat - Original Theatrical Trailer',
          key: '14oNcFxiVaQ',
          published_at: '2014-07-09T00:02:53.000Z',
          site: 'YouTube',
          size: 360,
          type: 'Trailer',
          official: true,
          id: '5ad77e8dc3a36847e80128ee',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 1158,
          known_for_department: 'Diễn viên',
          name: 'Al Pacino',
          original_name: 'Al Pacino',
          popularity: 16.967,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fMDFeVf0pjopTJbyRSLFwNDm8Wr.jpg',
          cast_id: 25,
          character: 'Lt. Vincent Hanna',
          credit_id: '52fe4292c3a36847f80291f5',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 380,
          known_for_department: 'Diễn viên',
          name: 'Robert De Niro',
          original_name: 'Robert De Niro',
          popularity: 8.693,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cT8htcckIuyI1Lqwt1CvD02ynTh.jpg',
          cast_id: 26,
          character: 'Neil McCauley',
          credit_id: '52fe4292c3a36847f80291f9',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 5576,
          known_for_department: 'Diễn viên',
          name: 'Val Kilmer',
          original_name: 'Val Kilmer',
          popularity: 16.57,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uqX8JxI6bWs1I3BOAtzJJD0DDo6.jpg',
          cast_id: 27,
          character: 'Chris Shiherlis',
          credit_id: '52fe4292c3a36847f80291fd',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 3197,
          known_for_department: 'Diễn viên',
          name: 'Tom Sizemore',
          original_name: 'Tom Sizemore',
          popularity: 7.36,
          profile_path:
            'https://image.tmdb.org/t/p/w185/soINOuacuiThRb2LyPD4tTWve7C.jpg',
          cast_id: 29,
          character: 'Michael Cheritto',
          credit_id: '52fe4292c3a36847f8029205',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 6200,
          known_for_department: 'Diễn viên',
          name: 'Diane Venora',
          original_name: 'Diane Venora',
          popularity: 4.055,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8GLq0qdpLzNKjPRxBf3NQMEqafx.jpg',
          cast_id: 30,
          character: 'Justine Hanna',
          credit_id: '52fe4292c3a36847f8029209',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 15851,
          known_for_department: 'Diễn viên',
          name: 'Amy Brenneman',
          original_name: 'Amy Brenneman',
          popularity: 4.312,
          profile_path:
            'https://image.tmdb.org/t/p/w185/buQhbTkoNcAC12oNXo6RCIoVNQw.jpg',
          cast_id: 31,
          character: 'Eady',
          credit_id: '52fe4292c3a36847f802920d',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 15852,
          known_for_department: 'Diễn viên',
          name: 'Ashley Judd',
          original_name: 'Ashley Judd',
          popularity: 7.424,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dofk0Y9YnGfoakFOonxoyFD7LOC.jpg',
          cast_id: 32,
          character: 'Charlene Shiherlis',
          credit_id: '52fe4292c3a36847f8029211',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 34,
          known_for_department: 'Diễn viên',
          name: 'Mykelti Williamson',
          original_name: 'Mykelti Williamson',
          popularity: 4.465,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vR1PqusHy0n4gWr3887pEcxPU6.jpg',
          cast_id: 33,
          character: 'Sergeant Drucker',
          credit_id: '52fe4292c3a36847f8029215',
          order: 7,
        },
        {
          adult: false,
          gender: 1,
          id: 524,
          known_for_department: 'Diễn viên',
          name: 'Natalie Portman',
          original_name: 'Natalie Portman',
          popularity: 14.905,
          profile_path:
            'https://image.tmdb.org/t/p/w185/edPU5HxncLWa1YkgRPNkSd68ONG.jpg',
          cast_id: 38,
          character: 'Lauren Gustafson',
          credit_id: '52fe4292c3a36847f8029229',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 15854,
          known_for_department: 'Diễn viên',
          name: 'Ted Levine',
          original_name: 'Ted Levine',
          popularity: 9.9,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4oqD1t4IQ06ssIogBs2Wlk95GDb.jpg',
          cast_id: 35,
          character: 'Bosko',
          credit_id: '52fe4292c3a36847f802921d',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 119232,
          known_for_department: 'Diễn viên',
          name: 'Tom Noonan',
          original_name: 'Tom Noonan',
          popularity: 2.467,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vNGdfEAo6OVOHkGuwx7ioeomv55.jpg',
          cast_id: 39,
          character: 'Kelso',
          credit_id: '52fe4292c3a36847f802922d',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 34839,
          known_for_department: 'Diễn viên',
          name: 'Kevin Gage',
          original_name: 'Kevin Gage',
          popularity: 1.791,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nTaDLkN1RAhPGaM0AO1CFysnwUl.jpg',
          cast_id: 43,
          character: 'Waingro',
          credit_id: '52fe4292c3a36847f802923f',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 10127,
          known_for_department: 'Diễn viên',
          name: 'Jon Voight',
          original_name: 'Jon Voight',
          popularity: 6.023,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oxLsItDwLddXu8YYJCfkddYNejL.jpg',
          cast_id: 28,
          character: 'Nate',
          credit_id: '52fe4292c3a36847f8029201',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 31004,
          known_for_department: 'Diễn viên',
          name: 'Tone Loc',
          original_name: 'Tone Loc',
          popularity: 1.192,
          profile_path:
            'https://image.tmdb.org/t/p/w185/puDbq7YPq6Jg0nrSeK6t9MFIhFP.jpg',
          cast_id: 41,
          character: 'Richard Torena',
          credit_id: '52fe4292c3a36847f8029237',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 5587,
          known_for_department: 'Diễn viên',
          name: 'Hank Azaria',
          original_name: 'Hank Azaria',
          popularity: 6.486,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yFDw4b0jucuFWNnGcBPfpYUtn16.jpg',
          cast_id: 42,
          character: 'Alan Marciano',
          credit_id: '52fe4292c3a36847f802923b',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 15853,
          known_for_department: 'Diễn viên',
          name: 'Wes Studi',
          original_name: 'Wes Studi',
          popularity: 2.83,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hIi9rjpOR4az0oJfvlx0FnKSJLv.jpg',
          cast_id: 34,
          character: 'Detective Casals',
          credit_id: '52fe4292c3a36847f8029219',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 352,
          known_for_department: 'Diễn viên',
          name: 'Dennis Haysbert',
          original_name: 'Dennis Haysbert',
          popularity: 6.044,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lcnjaw2CFN6q9eaes1jTYrUB0rb.jpg',
          cast_id: 36,
          character: 'Donald Breedan',
          credit_id: '52fe4292c3a36847f8029221',
          order: 16,
        },
        {
          adult: false,
          gender: 2,
          id: 11160,
          known_for_department: 'Diễn viên',
          name: 'Danny Trejo',
          original_name: 'Danny Trejo',
          popularity: 9.835,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iSZbMYL2vuYtLY86da1TP1ScDTT.jpg',
          cast_id: 46,
          character: 'Trejo',
          credit_id: '52fe4292c3a36847f802924b',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 9290,
          known_for_department: 'Diễn viên',
          name: 'Henry Rollins',
          original_name: 'Henry Rollins',
          popularity: 5.371,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2E0cZdoJsdt1Lv4waG3s6fsfJeU.jpg',
          cast_id: 47,
          character: 'Hugh Benny',
          credit_id: '52fe4292c3a36847f802924f',
          order: 18,
        },
        {
          adult: false,
          gender: 2,
          id: 886,
          known_for_department: 'Diễn viên',
          name: 'William Fichtner',
          original_name: 'William Fichtner',
          popularity: 8.654,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wWtJOoaNAwPparpzMNuRBjvxwEf.jpg',
          cast_id: 37,
          character: 'Roger Van Zant',
          credit_id: '52fe4292c3a36847f8029225',
          order: 19,
        },
        {
          adult: false,
          gender: 1,
          id: 4158,
          known_for_department: 'Diễn viên',
          name: 'Susan Traylor',
          original_name: 'Susan Traylor',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mAQwOoUrf4Su4MOBPPn68q9JLPx.jpg',
          cast_id: 44,
          character: 'Elaine Cheritto',
          credit_id: '52fe4292c3a36847f8029243',
          order: 20,
        },
        {
          adult: false,
          gender: 2,
          id: 86602,
          known_for_department: 'Diễn viên',
          name: 'Jerry Trimble',
          original_name: 'Jerry Trimble',
          popularity: 1.025,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oDK7NCnz2z2BFV8YquEpj8PBwed.jpg',
          cast_id: 48,
          character: 'Schwartz',
          credit_id: '52fe4292c3a36847f8029253',
          order: 21,
        },
        {
          adult: false,
          gender: 2,
          id: 158452,
          known_for_department: 'Diễn viên',
          name: 'Ricky Harris',
          original_name: 'Ricky Harris',
          popularity: 0.828,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dqttJ39XEIdgGLxA9X7hQO3qDrZ.jpg',
          cast_id: 50,
          character: 'Albert Torena',
          credit_id: '52fe4292c3a36847f802925b',
          order: 22,
        },
        {
          adult: false,
          gender: 2,
          id: 12799,
          known_for_department: 'Diễn viên',
          name: 'Jeremy Piven',
          original_name: 'Jeremy Piven',
          popularity: 3.399,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dPCFGmNhrF3niEJMPIbC1fiIqyI.jpg',
          cast_id: 54,
          character: 'Dr. Bob',
          credit_id: '52fe4292c3a36847f802926b',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 3982,
          known_for_department: 'Diễn viên',
          name: 'Xander Berkeley',
          original_name: 'Xander Berkeley',
          popularity: 3.692,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oBoKGfngGGZmSVGFslphYjc23WO.jpg',
          cast_id: 55,
          character: 'Ralph',
          credit_id: '52fe4292c3a36847f802926f',
          order: 24,
        },
        {
          adult: false,
          gender: 1,
          id: 181343,
          known_for_department: 'Diễn viên',
          name: 'Begonya Plaza',
          original_name: 'Begonya Plaza',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lt7xH5ttmaJsZnc15FoSJnXTpnE.jpg',
          cast_id: 51,
          character: 'Anna Trejo',
          credit_id: '52fe4292c3a36847f802925f',
          order: 25,
        },
        {
          adult: false,
          gender: 2,
          id: 81687,
          known_for_department: 'Crew',
          name: 'Rick Avery',
          original_name: 'Rick Avery',
          popularity: 1.388,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7CiosKnycMKSi3UD2cXFJJNceAZ.jpg',
          cast_id: 56,
          character: 'Armoured Guard',
          credit_id: '52fe4292c3a36847f8029273',
          order: 26,
        },
        {
          adult: false,
          gender: 1,
          id: 91756,
          known_for_department: 'Diễn viên',
          name: 'Hazelle Goodman',
          original_name: 'Hazelle Goodman',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nY4Vdoa2Y4X9fFlDiPKTqHF24YR.jpg',
          cast_id: 52,
          character: "Hooker's Mother",
          credit_id: '52fe4292c3a36847f8029263',
          order: 27,
        },
        {
          adult: false,
          gender: 2,
          id: 160970,
          known_for_department: 'Diễn viên',
          name: 'Ray Buktenica',
          original_name: 'Ray Buktenica',
          popularity: 0.699,
          profile_path: null,
          cast_id: 53,
          character: 'Timmons',
          credit_id: '52fe4292c3a36847f8029267',
          order: 28,
        },
        {
          adult: false,
          gender: 2,
          id: 175600,
          known_for_department: 'Diễn viên',
          name: 'Max Daniels',
          original_name: 'Max Daniels',
          popularity: 0.6,
          profile_path: null,
          cast_id: 59,
          character: 'Shooter at Drive-in',
          credit_id: '52fe4292c3a36847f802927f',
          order: 29,
        },
        {
          adult: false,
          gender: 2,
          id: 12879,
          known_for_department: 'Crew',
          name: 'Vince Deadrick Jr.',
          original_name: 'Vince Deadrick Jr.',
          popularity: 1.38,
          profile_path: null,
          cast_id: 60,
          character: 'Driver at Drive-in',
          credit_id: '52fe4292c3a36847f8029283',
          order: 30,
        },
        {
          adult: false,
          gender: 2,
          id: 9258,
          known_for_department: 'Diễn viên',
          name: 'Steven Ford',
          original_name: 'Steven Ford',
          popularity: 1.294,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lszRdjY2fTVYcsQBbziRnc9X1Ar.jpg',
          cast_id: 96,
          character: 'Officer Bruce',
          credit_id: '56be773e9251417359005063',
          order: 31,
        },
        {
          adult: false,
          gender: 1,
          id: 167501,
          known_for_department: 'Diễn viên',
          name: 'Farrah Forke',
          original_name: 'Farrah Forke',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4DGZJEuVVXg19mrv9wzLFPEWaLh.jpg',
          cast_id: 97,
          character: 'Claudia',
          credit_id: '56be7769c3a36817f200506f',
          order: 32,
        },
        {
          adult: false,
          gender: 1,
          id: 95145,
          known_for_department: 'Diễn viên',
          name: 'Patricia Healy',
          original_name: 'Patricia Healy',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8s1IxSkuuLaEaPZiMaJO4mzKCMv.jpg',
          cast_id: 99,
          character: "Bosko's Date",
          credit_id: '56be794dc3a36818020054bd',
          order: 33,
        },
        {
          adult: false,
          gender: 2,
          id: 58535,
          known_for_department: 'Diễn viên',
          name: 'Paul Herman',
          original_name: 'Paul Herman',
          popularity: 1.156,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mMuxbsQgfWzTh3QPoJ1VSrRGRcg.jpg',
          cast_id: 100,
          character: 'Sergeant Heinz',
          credit_id: '56be79839251417347004f69',
          order: 34,
        },
        {
          adult: false,
          gender: 1,
          id: 161939,
          known_for_department: 'Diễn viên',
          name: 'Cindy Katz',
          original_name: 'Cindy Katz',
          popularity: 0.61,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2REv1EmoHzoJDNY9PlWnfOq5Ej4.jpg',
          cast_id: 101,
          character: 'Rachel',
          credit_id: '56be79cec3a36817f200511b',
          order: 35,
        },
        {
          adult: false,
          gender: 2,
          id: 6580,
          known_for_department: 'Diễn viên',
          name: 'Brian Libby',
          original_name: 'Brian Libby',
          popularity: 2.342,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3aJlXJDURrdMjrE654F6PwBw6KX.jpg',
          cast_id: 102,
          character: 'Captain Jackson',
          credit_id: '56be79fa9251417344004ea0',
          order: 36,
        },
        {
          adult: false,
          gender: 2,
          id: 95796,
          known_for_department: 'Diễn viên',
          name: 'Dan Martin',
          original_name: 'Dan Martin',
          popularity: 0.63,
          profile_path:
            'https://image.tmdb.org/t/p/w185/brRz4upQrDPULNuoBUG6LFVK6NO.jpg',
          cast_id: 104,
          character: 'Harry Dieter',
          credit_id: '56be7a8ac3a36817f200516d',
          order: 37,
        },
        {
          adult: false,
          gender: 0,
          id: 166543,
          known_for_department: 'Crew',
          name: 'Mario Roberts',
          original_name: 'Mario Roberts',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/smpxow6kyXsEYhqmiFqjlFHufsp.jpg',
          cast_id: 109,
          character: 'Bank Guard',
          credit_id: '56be7bafc3a36817ef005294',
          order: 38,
        },
        {
          adult: false,
          gender: 2,
          id: 43010,
          known_for_department: 'Diễn viên',
          name: 'Thomas Rosales Jr.',
          original_name: 'Thomas Rosales Jr.',
          popularity: 2.586,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ffDrcpKGvjPgpcjd0t9T6EtQ2hz.jpg',
          cast_id: 110,
          character: 'Armoured Truck Driver',
          credit_id: '56be7c61c3a36817ef0052cf',
          order: 39,
        },
        {
          adult: false,
          gender: 1,
          id: 37252,
          known_for_department: 'Diễn viên',
          name: 'Yvonne Zima',
          original_name: 'Yvonne Zima',
          popularity: 5.783,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7CbBGobt0fMDLgwJa1v5xcPrS2Z.jpg',
          cast_id: 112,
          character: 'Hostage Girl',
          credit_id: '56be7db1925141735600517b',
          order: 40,
        },
        {
          adult: false,
          gender: 0,
          id: 1457709,
          known_for_department: 'Diễn viên',
          name: 'Mick Gould',
          original_name: 'Mick Gould',
          popularity: 1.094,
          profile_path: null,
          cast_id: 116,
          character: '1st SIS Detective in the hallway (uncredited)',
          credit_id: '56be7ed4c3a36817f9005000',
          order: 41,
        },
        {
          adult: false,
          gender: 2,
          id: 4971,
          known_for_department: 'Diễn viên',
          name: 'Bud Cort',
          original_name: 'Bud Cort',
          popularity: 1.149,
          profile_path:
            'https://image.tmdb.org/t/p/w185/agiubl6msYlKM7DpghIYDw1pcBN.jpg',
          cast_id: 115,
          character: 'Solenko, Restaurant Manager (uncredited)',
          credit_id: '56be7e6e92514173590052b3',
          order: 42,
        },
        {
          adult: false,
          gender: 1,
          id: 941147,
          known_for_department: 'Diễn viên',
          name: 'Viviane Vives',
          original_name: 'Viviane Vives',
          popularity: 0.6,
          profile_path: null,
          cast_id: 123,
          character: 'Castilian Woman (uncredited)',
          credit_id: '56be80ed925141735900535e',
          order: 43,
        },
        {
          adult: false,
          gender: 1,
          id: 17358,
          known_for_department: 'Diễn viên',
          name: 'Kim Staunton',
          original_name: 'Kim Staunton',
          popularity: 0.6,
          profile_path: null,
          cast_id: 45,
          character: 'Lillian',
          credit_id: '52fe4292c3a36847f8029247',
          order: 44,
        },
        {
          adult: false,
          gender: 2,
          id: 4790,
          known_for_department: 'Diễn viên',
          name: 'Martin Ferrero',
          original_name: 'Martin Ferrero',
          popularity: 1.312,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eGDvOx9sABKXNpikwrVhQ20vWle.jpg',
          cast_id: 49,
          character: 'Construction Clerk',
          credit_id: '52fe4292c3a36847f8029257',
          order: 45,
        },
        {
          adult: false,
          gender: 0,
          id: 1090464,
          known_for_department: 'Diễn viên',
          name: 'Brad Baldridge',
          original_name: 'Brad Baldridge',
          popularity: 0.828,
          profile_path: null,
          cast_id: 57,
          character: "Children's Hospital Doctor",
          credit_id: '52fe4292c3a36847f8029277',
          order: 46,
        },
        {
          adult: false,
          gender: 0,
          id: 1090465,
          known_for_department: 'Diễn viên',
          name: 'Andrew Camuccio',
          original_name: 'Andrew Camuccio',
          popularity: 0.6,
          profile_path: null,
          cast_id: 58,
          character: 'Dominick',
          credit_id: '52fe4292c3a36847f802927b',
          order: 47,
        },
        {
          adult: false,
          gender: 2,
          id: 1576419,
          known_for_department: 'Diễn viên',
          name: 'Kenny Endoso',
          original_name: 'Kenny Endoso',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cVDyTG8I6hdfOQRrgn2oX2hyGRQ.jpg',
          cast_id: 94,
          character: 'Bartender',
          credit_id: '56be231dc3a3681806004214',
          order: 48,
        },
        {
          adult: false,
          gender: 1,
          id: 106714,
          known_for_department: 'Diễn viên',
          name: 'Kimberly Flynn',
          original_name: 'Kimberly Flynn',
          popularity: 0.608,
          profile_path:
            'https://image.tmdb.org/t/p/w185/keMGmT6xr0UypDMCxnVgNK5a5YQ.jpg',
          cast_id: 95,
          character: "Casals' Date",
          credit_id: '56be7708c3a36817f200504f',
          order: 49,
        },
        {
          adult: false,
          gender: 1,
          id: 116153,
          known_for_department: 'Diễn viên',
          name: 'Niki Haris',
          original_name: 'Niki Haris',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/igDPgIlLQfkr2IjVabkjt1v5cit.jpg',
          cast_id: 98,
          character: 'Marcia Drucker',
          credit_id: '56be77fcc3a36817ef005164',
          order: 50,
        },
        {
          adult: false,
          gender: 2,
          id: 237923,
          known_for_department: 'Crew',
          name: 'Bill McIntosh',
          original_name: 'Bill McIntosh',
          popularity: 0.6,
          profile_path: null,
          cast_id: 103,
          character: 'Armoured Guard',
          credit_id: '56be7a30c3a36817f2005154',
          order: 51,
        },
        {
          adult: false,
          gender: 2,
          id: 4047,
          known_for_department: 'Diễn viên',
          name: 'Rick Marzan',
          original_name: 'Rick Marzan',
          popularity: 1.097,
          profile_path: null,
          cast_id: 105,
          character: 'Basketball Player',
          credit_id: '56be7aabc3a36817f40053ec',
          order: 52,
        },
        {
          adult: false,
          gender: 2,
          id: 57347,
          known_for_department: 'Production',
          name: 'Terry Miller',
          original_name: 'Terry Miller',
          popularity: 0.6,
          profile_path: null,
          cast_id: 106,
          character: "Children's Hospital Nurse",
          credit_id: '56be7aec9251417344004ee2',
          order: 53,
        },
        {
          adult: false,
          gender: 0,
          id: 1576553,
          known_for_department: 'Crew',
          name: "Daniel O'Haco",
          original_name: "Daniel O'Haco",
          popularity: 0.6,
          profile_path: null,
          cast_id: 107,
          character: 'Detective',
          credit_id: '56be7b44c3a368180200556a',
          order: 54,
        },
        {
          adult: false,
          gender: 1,
          id: 218094,
          known_for_department: 'Diễn viên',
          name: 'Kai Soremekun',
          original_name: 'Kai Soremekun',
          popularity: 0.828,
          profile_path: null,
          cast_id: 111,
          character: 'Prostitute',
          credit_id: '56be7d28c3a368180200560d',
          order: 55,
        },
        {
          adult: false,
          gender: 0,
          id: 1491009,
          known_for_department: 'Sound',
          name: 'Peter Blackwell',
          original_name: 'Peter Blackwell',
          popularity: 0.6,
          profile_path: null,
          cast_id: 113,
          character: 'Bar Couple (uncredited)',
          credit_id: '56be7e1c9251411d27000305',
          order: 56,
        },
        {
          adult: false,
          gender: 0,
          id: 1137847,
          known_for_department: 'Diễn viên',
          name: 'Trevor Coppola',
          original_name: 'Trevor Coppola',
          popularity: 1.528,
          profile_path: null,
          cast_id: 114,
          character: 'Restaurant Patron (uncredited)',
          credit_id: '56be7e45c3a36817ef005374',
          order: 57,
        },
        {
          adult: false,
          gender: 1,
          id: 1504112,
          known_for_department: 'Diễn viên',
          name: 'Mary Kircher',
          original_name: 'Mary Kircher',
          popularity: 0.6,
          profile_path: null,
          cast_id: 118,
          character: 'Police Woman (uncredited)',
          credit_id: '56be7f699251417344005036',
          order: 58,
        },
        {
          adult: false,
          gender: 0,
          id: 1504568,
          known_for_department: 'Diễn viên',
          name: 'Darin Mangan',
          original_name: 'Darin Mangan',
          popularity: 0.6,
          profile_path: null,
          cast_id: 119,
          character: 'Grocery Store Employee (uncredited)',
          credit_id: '56be7fbd925141734d005299',
          order: 59,
        },
        {
          adult: false,
          gender: 2,
          id: 20625,
          known_for_department: 'Diễn viên',
          name: 'Robert Miranda',
          original_name: 'Robert Miranda',
          popularity: 1.114,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3g6BNl9tHuYnvQgkM0yVX0XZpil.jpg',
          cast_id: 120,
          character: 'Cusamano (uncredited)',
          credit_id: '56be8014c3a36817ef00540a',
          order: 60,
        },
        {
          adult: false,
          gender: 2,
          id: 1502517,
          known_for_department: 'Diễn viên',
          name: 'Manny Perry',
          original_name: 'Manny Perry',
          popularity: 1.38,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aCYOiEZ7LkqJUEce0PsPVx6GWo0.jpg',
          cast_id: 121,
          character: 'Grocery Store Cop (uncredited)',
          credit_id: '56be8053c3a36817f40055b3',
          order: 61,
        },
        {
          adult: false,
          gender: 1,
          id: 114625,
          known_for_department: 'Diễn viên',
          name: 'Iva Franks Singer',
          original_name: 'Iva Franks Singer',
          popularity: 1.388,
          profile_path:
            'https://image.tmdb.org/t/p/w185/e2qXaTrVKoF8fk2FRK6l3ABgPrq.jpg',
          cast_id: 122,
          character: 'Waitress (uncredited)',
          credit_id: '56be80a8925141734400508d',
          order: 62,
        },
        {
          adult: false,
          gender: 0,
          id: 1576562,
          known_for_department: 'Crew',
          name: 'Tim Werner',
          original_name: 'Tim Werner',
          popularity: 0.6,
          profile_path: null,
          cast_id: 124,
          character: 'Bank Guard (uncredited)',
          credit_id: '56be8132925141735900536f',
          order: 63,
        },
        {
          adult: false,
          gender: 0,
          id: 2648854,
          known_for_department: 'Diễn viên',
          name: 'Rainell Saunders',
          original_name: 'Rainell Saunders',
          popularity: 0.6,
          profile_path: null,
          cast_id: 148,
          character: '',
          credit_id: '5ec7ab090fb17f001c7aa8fd',
          order: 64,
        },
        {
          adult: false,
          gender: 0,
          id: 2648856,
          known_for_department: 'Diễn viên',
          name: 'Brian Camuccio',
          original_name: 'Brian Camuccio',
          popularity: 0.6,
          profile_path: null,
          cast_id: 149,
          character: '',
          credit_id: '5ec7ab488e2e0000201fcb82',
          order: 65,
        },
        {
          adult: false,
          gender: 1,
          id: 2648858,
          known_for_department: 'Diễn viên',
          name: 'Amanda Graves',
          original_name: 'Amanda Graves',
          popularity: 0.6,
          profile_path: null,
          cast_id: 150,
          character: 'Linda Cheritto',
          credit_id: '5ec7ab870fb17f001d7c517e',
          order: 66,
        },
        {
          adult: false,
          gender: 0,
          id: 2648859,
          known_for_department: 'Diễn viên',
          name: 'Emily Graves',
          original_name: 'Emily Graves',
          popularity: 0.98,
          profile_path: null,
          cast_id: 151,
          character: '',
          credit_id: '5ec7ac166c8492001f2a1216',
          order: 67,
        },
        {
          adult: false,
          gender: 0,
          id: 2648860,
          known_for_department: 'Diễn viên',
          name: 'Thomas Elfmont',
          original_name: 'Thomas Elfmont',
          popularity: 0.6,
          profile_path: null,
          cast_id: 152,
          character: '',
          credit_id: '5ec7ac83e24b930021d48c02',
          order: 68,
        },
        {
          adult: false,
          gender: 0,
          id: 2648863,
          known_for_department: 'Diễn viên',
          name: 'Ted Harvey',
          original_name: 'Ted Harvey',
          popularity: 0.6,
          profile_path: null,
          cast_id: 153,
          character: '',
          credit_id: '5ec7acc0d2147c0022ba2e14',
          order: 69,
        },
        {
          adult: false,
          gender: 0,
          id: 2648864,
          known_for_department: 'Diễn viên',
          name: 'Wendy L. Walsh',
          original_name: 'Wendy L. Walsh',
          popularity: 0.6,
          profile_path: null,
          cast_id: 154,
          character: '',
          credit_id: '5ec7ad179979d2002031c99f',
          order: 70,
        },
        {
          adult: false,
          gender: 0,
          id: 2648865,
          known_for_department: 'Diễn viên',
          name: 'Rey Verdugo',
          original_name: 'Rey Verdugo',
          popularity: 0.6,
          profile_path: null,
          cast_id: 155,
          character: '',
          credit_id: '5ec7ad52140bad001c17cbb5',
          order: 71,
        },
        {
          adult: false,
          gender: 0,
          id: 2648866,
          known_for_department: 'Diễn viên',
          name: 'Phillip Robinson',
          original_name: 'Phillip Robinson',
          popularity: 0.6,
          profile_path: null,
          cast_id: 156,
          character: '',
          credit_id: '5ec7ada6ae281100203b65f5',
          order: 72,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 376,
          known_for_department: 'Production',
          name: 'Arnon Milchan',
          original_name: 'Arnon Milchan',
          popularity: 0.625,
          profile_path:
            'https://image.tmdb.org/t/p/w185/b2hBExX4NnczNAnLuTBF4kmNhZm.jpg',
          credit_id: '56bf65e09251410bb0000d9f',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 638,
          known_for_department: 'Directing',
          name: 'Michael Mann',
          original_name: 'Michael Mann',
          popularity: 1.757,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1nRqwMyQuCkvNPAzDY5oOSfGZ6b.jpg',
          credit_id: '52fe4292c3a36847f8029173',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 638,
          known_for_department: 'Directing',
          name: 'Michael Mann',
          original_name: 'Michael Mann',
          popularity: 1.757,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1nRqwMyQuCkvNPAzDY5oOSfGZ6b.jpg',
          credit_id: '52fe4292c3a36847f802916d',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 638,
          known_for_department: 'Directing',
          name: 'Michael Mann',
          original_name: 'Michael Mann',
          popularity: 1.757,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1nRqwMyQuCkvNPAzDY5oOSfGZ6b.jpg',
          credit_id: '52fe4292c3a36847f802917f',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 639,
          known_for_department: 'Production',
          name: 'Pieter Jan Brugge',
          original_name: 'Pieter Jan Brugge',
          popularity: 0.685,
          profile_path: null,
          credit_id: '56bf6596c3a368180a009a90',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 15841,
          known_for_department: 'Editing',
          name: 'William Goldenberg',
          original_name: 'William Goldenberg',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eOgoea8HbZt2TfLn0tDNI1TepSN.jpg',
          credit_id: '52fe4292c3a36847f8029197',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 897,
          known_for_department: 'Production',
          name: 'Bonnie Timmermann',
          original_name: 'Bonnie Timmermann',
          popularity: 1.381,
          profile_path: null,
          credit_id: '52fe4292c3a36847f80291a9',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 1047,
          known_for_department: 'Editing',
          name: 'Tom Rolf',
          original_name: 'Tom Rolf',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4292c3a36847f80291a3',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1254,
          known_for_department: 'Production',
          name: 'Art Linson',
          original_name: 'Art Linson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4292c3a36847f8029179',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1305,
          known_for_department: 'Sound',
          name: 'Bill Abbott',
          original_name: 'Bill Abbott',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4292c3a36847f80291cd',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 13677,
          known_for_department: 'Art',
          name: 'Anne H. Ahrens',
          original_name: 'Anne H. Ahrens',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4292c3a36847f8029233',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 2,
          id: 5581,
          known_for_department: 'Sound',
          name: 'Elliot Goldenthal',
          original_name: 'Elliot Goldenthal',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9FOePwrekBTTuSSBmgVVeKKO8cR.jpg',
          credit_id: '52fe4292c3a36847f8029185',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 11411,
          known_for_department: 'Art',
          name: 'Neil Spisak',
          original_name: 'Neil Spisak',
          popularity: 1.4,
          profile_path: null,
          credit_id: '52fe4292c3a36847f80291af',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 1,
          id: 8527,
          known_for_department: 'Costume & Make-Up',
          name: 'Deborah Lynn Scott',
          original_name: 'Deborah Lynn Scott',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lYYxq6AxOMYqc934V80ez9Cmfwj.jpg',
          credit_id: '52fe4292c3a36847f80291bb',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 2,
          id: 8870,
          known_for_department: 'Costume & Make-Up',
          name: 'Leonard Engelman',
          original_name: 'Leonard Engelman',
          popularity: 0.766,
          profile_path: null,
          credit_id: '564717f19251413adb002c49',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 2,
          id: 16177,
          known_for_department: 'Sound',
          name: 'Ron Bartlett',
          original_name: 'Ron Bartlett',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/AmFG81joHLkvnh4Io20TdCCBk8P.jpg',
          credit_id: '566159a4c3a36875e0007279',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 14765,
          known_for_department: 'Sound',
          name: 'Per Hallberg',
          original_name: 'Per Hallberg',
          popularity: 0.691,
          profile_path: null,
          credit_id: '52fe4292c3a36847f80291d3',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 11099,
          known_for_department: 'Camera',
          name: 'Dante Spinotti',
          original_name: 'Dante Spinotti',
          popularity: 0.832,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7Ts0bNMarg8t5tUS0fKZthhvCYF.jpg',
          credit_id: '52fe4292c3a36847f802918b',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 15840,
          known_for_department: 'Editing',
          name: 'Pasquale Buba',
          original_name: 'Pasquale Buba',
          popularity: 0.706,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wp0LNgZLPMtWzIOrap0HPdolyDT.jpg',
          credit_id: '52fe4292c3a36847f8029191',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 15842,
          known_for_department: 'Editing',
          name: 'Dov Hoenig',
          original_name: 'Dov Hoenig',
          popularity: 0.838,
          profile_path: null,
          credit_id: '52fe4292c3a36847f802919d',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 15843,
          known_for_department: 'Art',
          name: 'Margie Stone McShirley',
          original_name: 'Margie Stone McShirley',
          popularity: 1.048,
          profile_path: null,
          credit_id: '52fe4292c3a36847f80291b5',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 15845,
          known_for_department: 'Costume & Make-Up',
          name: 'John Caglione Jr.',
          original_name: 'John Caglione Jr.',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5647183bc3a3682611002c24',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 15846,
          known_for_department: 'Costume & Make-Up',
          name: 'Vera Mitchell',
          original_name: 'Vera Mitchell',
          popularity: 0.694,
          profile_path: null,
          credit_id: '56471821c3a3682611002c1e',
          department: 'Costume & Make-Up',
          job: 'Key Hair Stylist',
        },
        {
          adult: false,
          gender: 0,
          id: 15847,
          known_for_department: 'Crew',
          name: 'Terry D. Frazee',
          original_name: 'Terry D. Frazee',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4292c3a36847f80291d9',
          department: 'Crew',
          job: 'Special Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 15848,
          known_for_department: 'Crew',
          name: 'Paul H. Haines Jr.',
          original_name: 'Paul H. Haines Jr.',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4292c3a36847f80291df',
          department: 'Crew',
          job: 'Special Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 15849,
          known_for_department: 'Visual Effects',
          name: 'Neil Krepela',
          original_name: 'Neil Krepela',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4292c3a36847f80291e5',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 13458,
          known_for_department: 'Crew',
          name: 'Joel Kramer',
          original_name: 'Joel Kramer',
          popularity: 0.649,
          profile_path:
            'https://image.tmdb.org/t/p/w185/76EDeGntW2vdvAG7r1TN5JmHDv8.jpg',
          credit_id: '52fe4292c3a36847f80291eb',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 15850,
          known_for_department: 'Diễn viên',
          name: 'Tony Brubaker',
          original_name: 'Tony Brubaker',
          popularity: 0.732,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pi2U3iRoMNc4zHvzWdXG8hqMQUn.jpg',
          credit_id: '52fe4292c3a36847f80291f1',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 14653,
          known_for_department: 'Costume & Make-Up',
          name: 'Ken Diaz',
          original_name: 'Ken Diaz',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5647184fc3a3682611002c2a',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 15178,
          known_for_department: 'Sound',
          name: 'Jimmy Webb',
          original_name: 'Jimmy Webb',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/18Jum4p1eAmZKyn7Z4qzcBSqdS6.jpg',
          credit_id: '587d05e1925141410100ffb1',
          department: 'Sound',
          job: 'Additional Soundtrack',
        },
        {
          adult: false,
          gender: 1,
          id: 16551,
          known_for_department: 'Costume & Make-Up',
          name: 'Ilona Herman',
          original_name: 'Ilona Herman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5647180a9251413adb002c52',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 2,
          id: 21118,
          known_for_department: 'Camera',
          name: 'J. Michael Muro',
          original_name: 'J. Michael Muro',
          popularity: 1.556,
          profile_path: null,
          credit_id: '564719a9c3a3682608002d95',
          department: 'Camera',
          job: 'Steadicam Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 4727,
          known_for_department: 'Art',
          name: 'Dianne Wager',
          original_name: 'Dianne Wager',
          popularity: 0.694,
          profile_path: null,
          credit_id: '564716fe9251413acc002d2a',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 2,
          id: 37317,
          known_for_department: 'Sound',
          name: 'Brian Eno',
          original_name: 'Brian Eno',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lLdYPTiwg5uvFFSY70TI3CCJYE4.jpg',
          credit_id: '60398d336a22270052363f69',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 0,
          id: 60592,
          known_for_department: 'Editing',
          name: 'Matthew Booth',
          original_name: 'Matthew Booth',
          popularity: 0.6,
          profile_path: null,
          credit_id: '566158b5c3a36875e2006961',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 75002,
          known_for_department: 'Sound',
          name: 'Budd Carr',
          original_name: 'Budd Carr',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56615839c3a36875f4006418',
          department: 'Sound',
          job: 'Music Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 142157,
          known_for_department: 'Crew',
          name: 'Doug Coleman',
          original_name: 'Doug Coleman',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/temeKPrQ9VosJXwb51O3EWxQ5yO.jpg',
          credit_id: '56e76b15c3a368408c000bf5',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 212137,
          known_for_department: 'Directing',
          name: 'Michael Waxman',
          original_name: 'Michael Waxman',
          popularity: 0.693,
          profile_path: null,
          credit_id: '56bf67ab92514170aa002b87',
          department: 'Directing',
          job: 'Assistant Director',
        },
        {
          adult: false,
          gender: 2,
          id: 548451,
          known_for_department: 'Visual Effects',
          name: 'Jeff Wells',
          original_name: 'Jeff Wells',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56e066a2c3a3687492004ab5',
          department: 'Crew',
          job: 'Digital Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 928502,
          known_for_department: 'Sound',
          name: 'Matthias Gohl',
          original_name: 'Matthias Gohl',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3LcqKXTCgKKplje0zg5E1BDjOaj.jpg',
          credit_id: '5ba765019251412ef4021f27',
          department: 'Sound',
          job: 'Music Score Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 944682,
          known_for_department: 'Production',
          name: 'Gusmano Cesaretti',
          original_name: 'Gusmano Cesaretti',
          popularity: 0.702,
          profile_path: null,
          credit_id: '56bf65ba92514170aa002b1c',
          department: 'Production',
          job: 'Associate Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1338976,
          known_for_department: 'Sound',
          name: 'Andy Nelson',
          original_name: 'Andy Nelson',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rsezSNhDdoKgM99MZYyUX8V35S0.jpg',
          credit_id: '566159f1c3a36875ed00613e',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 1347763,
          known_for_department: 'Camera',
          name: 'Chris Moseley',
          original_name: 'Chris Moseley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '564719f4c3a3682620002d82',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 2,
          id: 1368864,
          known_for_department: 'Sound',
          name: 'Chris Jenkins',
          original_name: 'Chris Jenkins',
          popularity: 1.198,
          profile_path: null,
          credit_id: '566159c9c3a36875e2006994',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 1391385,
          known_for_department: 'Editing',
          name: 'Duncan Burns',
          original_name: 'Duncan Burns',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad5e4140e0a2660bc01589d',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1392084,
          known_for_department: 'Sound',
          name: 'Larry Kemp',
          original_name: 'Larry Kemp',
          popularity: 0.6,
          profile_path: null,
          credit_id: '564719199251413ad5002d09',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1392142,
          known_for_department: 'Costume & Make-Up',
          name: 'Marsha Bozeman',
          original_name: 'Marsha Bozeman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56ddc252925141187c00009b',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 1,
          id: 1392901,
          known_for_department: 'Sound',
          name: 'Lauren Stephens',
          original_name: 'Lauren Stephens',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad5e42fc3a3680c0f015acf',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1401687,
          known_for_department: 'Sound',
          name: 'Anna Behlmer',
          original_name: 'Anna Behlmer',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kUsjqvtj653USV4FXxJmPiqJCW4.jpg',
          credit_id: '5661595f925141790c00648d',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1403479,
          known_for_department: 'Camera',
          name: 'Duane Manwiller',
          original_name: 'Duane Manwiller',
          popularity: 0.759,
          profile_path: null,
          credit_id: '564719dec3a368261a002d54',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1404308,
          known_for_department: 'Art',
          name: 'Anthony Lattanzio',
          original_name: 'Anthony Lattanzio',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56471718c3a3682605002c62',
          department: 'Art',
          job: 'Construction Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1405208,
          known_for_department: 'Editing',
          name: 'Thomas R. Bryant',
          original_name: 'Thomas R. Bryant',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56615906c3a36875ed006116',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1406826,
          known_for_department: 'Sound',
          name: 'Hector C. Gika',
          original_name: 'Hector C. Gika',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1yJ3xp1jj4Az44n6fdIw4F6lCz6.jpg',
          credit_id: '5ad5e3fc0e0a2660ad015bfd',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1406905,
          known_for_department: 'Sound',
          name: 'Michael Connell',
          original_name: 'Michael Connell',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5661581a925141790f0068fd',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1409831,
          known_for_department: 'Camera',
          name: 'Gary Jay',
          original_name: 'Gary Jay',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5647197fc3a3682608002d90',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 1412205,
          known_for_department: 'Camera',
          name: 'Frank Connor',
          original_name: 'Frank Connor',
          popularity: 0.6,
          profile_path: null,
          credit_id: '564719bfc3a3682620002d79',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 0,
          id: 1415635,
          known_for_department: 'Lighting',
          name: 'Frank Dorowsky',
          original_name: 'Frank Dorowsky',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56471a16c3a3682611002c82',
          department: 'Lighting',
          job: 'Rigging Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1424046,
          known_for_department: 'Production',
          name: 'Jane Brody',
          original_name: 'Jane Brody',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56bf68e39251417359008e89',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 1432026,
          known_for_department: 'Editing',
          name: 'Ray Boniker',
          original_name: 'Ray Boniker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '566159209251417918006451',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1433743,
          known_for_department: 'Sound',
          name: 'Vicki Hiatt',
          original_name: 'Vicki Hiatt',
          popularity: 0.6,
          profile_path: null,
          credit_id: '566158dfc3a36875e2006968',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1457709,
          known_for_department: 'Diễn viên',
          name: 'Mick Gould',
          original_name: 'Mick Gould',
          popularity: 1.094,
          profile_path: null,
          credit_id: '56be7f199251417347005171',
          department: 'Crew',
          job: 'Technical Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1478953,
          known_for_department: 'Directing',
          name: 'Cate Hardman',
          original_name: 'Cate Hardman',
          popularity: 1.4,
          profile_path: null,
          credit_id: '564717d0c3a3682620002d27',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1479277,
          known_for_department: 'Art',
          name: 'Oscar Mazzola',
          original_name: 'Oscar Mazzola',
          popularity: 0.6,
          profile_path: null,
          credit_id: '564716d9c3a368260c002d5a',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1494667,
          known_for_department: 'Production',
          name: 'Christopher Cronyn',
          original_name: 'Christopher Cronyn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56bf6743c3a3681806008963',
          department: 'Production',
          job: 'Unit Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1535949,
          known_for_department: 'Costume & Make-Up',
          name: 'David Le Vey',
          original_name: 'David Le Vey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '564717949251413e7f002a36',
          department: 'Costume & Make-Up',
          job: 'Assistant Costume Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1535950,
          known_for_department: 'Costume & Make-Up',
          name: 'Darryl M. Athons',
          original_name: 'Darryl M. Athons',
          popularity: 0.6,
          profile_path: null,
          credit_id: '564717adc3a3682611002c07',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1535951,
          known_for_department: 'Sound',
          name: 'Neal J. Anderson',
          original_name: 'Neal J. Anderson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad5e3e5c3a3680c12014b50',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1535952,
          known_for_department: 'Production',
          name: 'Alison E. McBryde',
          original_name: 'Alison E. McBryde',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56bf6812c3a36817fd0089a0',
          department: 'Production',
          job: 'Casting Associate',
        },
        {
          adult: false,
          gender: 0,
          id: 1538308,
          known_for_department: 'Editing',
          name: 'Mark S. Westmore',
          original_name: 'Mark S. Westmore',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad5e46f9251415dc6012e5d',
          department: 'Editing',
          job: 'Assistant Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1544638,
          known_for_department: 'Sound',
          name: 'Mark Smith',
          original_name: 'Mark Smith',
          popularity: 0.88,
          profile_path: null,
          credit_id: '56615a69925141791800649a',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1550830,
          known_for_department: 'Crew',
          name: 'Donald Frazee',
          original_name: 'Donald Frazee',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57190686c3a3680160004721',
          department: 'Crew',
          job: 'Special Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1576553,
          known_for_department: 'Crew',
          name: "Daniel O'Haco",
          original_name: "Daniel O'Haco",
          popularity: 0.6,
          profile_path: null,
          credit_id: '56be7b5cc3a36817f400542a',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1576562,
          known_for_department: 'Crew',
          name: 'Tim Werner',
          original_name: 'Tim Werner',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56be8150925141734d00530c',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1900639,
          known_for_department: 'Sound',
          name: 'Stephen McLaughlin',
          original_name: 'Stephen McLaughlin',
          popularity: 0.917,
          profile_path:
            'https://image.tmdb.org/t/p/w185/q7WO4q0OoJPmyN15NJAO8fh5q0p.jpg',
          credit_id: '5ba6451f9251412f0400b00b',
          department: 'Sound',
          job: 'Scoring Mixer',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'John Chard',
          author_details: {
            name: '',
            username: 'John Chard',
            avatar_path: '/utEXl2EDiXBK6f41wCLsvprvMg4.jpg',
            rating: 10.0,
          },
          content:
            "You don't live with me, you live among the remains of dead people.\r\n\r\nHeat is written and directed by Michael Mann. It stars Robert DeNiro, Al Pacino, Val Kilmer, Jon Voight, Tom Sizemore, Diane Venora, Ashley Judd, Amy Brennerman and Danny Trejo. Music is scored by Elliot Goldenthal and cinematography by Dante Spinoti.\r\n\r\nBig time thief Neil McCauley (DeNiro) is after one last major score before he retires, but hot on his tail is Vincent Hannah (Pacino), a cop equally and methodically as driven as he is himself.\r\n\r\nIn the build up to Heat's release, much was made of it being the first on screen pairing of DeNiro and Pacino. A mouthwatering prospect for sure, it proved to be worth the wait and unfolds as a lesson in restrained Diễn viên with two modern greats affording each other the respect that was due. What we didn't realise in the build up to the film's release, was that it would prove to be one of the greatest cops and robbers movies of all time, brought to us by an auteur director whose kink for realism and commitment to research stands him out from much of the modern directing pack.\r\n\r\nRarely does a film come together as one, where all the cogs of the engine are in tune, but Heat is one such picture. From cast performances to visual aesthetics, to screenplay and actual substance of story, Heat is as meticulous as it is thrilling. There are a myriad of characters brilliantly stitched together in one de-glamorised City of Angels, as plot develops, and each character and their crumbling relationships come under inspection, we are witnessing a coarse viewpoint of human nature, where people's lives are ended or defined by their choices. Everywhere you look, here, there are folk cracking under the strain of being exposed to high end crime, dreams, hopes and happiness are unlikely to be achieved, and this is on both sides of the law.\r\n\r\nFor Heat, Mann fuses the tonal and visual ticks of Manhunter with that of the adrenalin rushes from Last of the Mohicans, with the former gorgeously born out by Spinoti's pin sharp photography, the latter thrillingly realised by Mann's skill at action set pieces. Once again word of mouth about the key heist and shoot out in the film led to high expectation, and again there is no disappointment. L.A. becomes a battle ground, rapid gunfire punctures the air, cars swerve and crash, bodies fall, visually and aurally it drags you to the edge of your seat, an extended action sequence fit to sit with the best of them. The kicker as well is that because Mann has been so detailed in his characterisations, we care about what happens to all parties, we understand motives and means. Which in a film with such a huge support cast is quite an achievement.\r\n\r\nThere is enough in Heat to fill out a dozen other cops and robbers films, fans of neo-noir and crime films in general are spoilt supreme here. It's not rocket science really, put a group of great actors together, give them an intelligent script to work from and let them be guided by a director who will not sit still, and you get a great film. Heat, the ultimate predator and prey movie, where from beginning to end it refuses to be lazy or cop out, and energy and thought seeps from every frame. 10/10",
          created_at: '2015-03-24T03:18:14.113Z',
          id: '5510d7769251415c960007f3',
          updated_at: '2021-06-23T15:57:33.213Z',
          url: 'https://www.themoviedb.org/review/5510d7769251415c960007f3',
        },
        {
          author: 'Gimly',
          author_details: {
            name: 'Gimly',
            username: 'Ruuz',
            avatar_path: '/xUObnJSvHrFPsIpoDmb1jiQZLq7.jpg',
            rating: 8.0,
          },
          content:
            "Partly I'm disappointed in myself for taking so long to watch _Heat_ because it's such a massive influence on one of the best movies ever (_The Dark Knight_), and one my favourite video games ever (_Payday: The Heist_).\r\n\r\nMostly though, I'm disappointed in myself for taking so long to watch _Heat_ because I've denied myself for so long the privilege of having seen such a great fucking crime movie.\r\n\r\n_Final rating:★★★★ - An all round good movie with a little something extra._",
          created_at: '2017-06-04T03:28:09.311Z',
          id: '59337e49c3a3685a24014d42',
          updated_at: '2021-06-23T15:57:58.083Z',
          url: 'https://www.themoviedb.org/review/59337e49c3a3685a24014d42',
        },
      ],
      total_pages: 1,
      total_results: 2,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/sRfhl2ff0OdJT6QC68Bo9bAb5SY.jpg',
    belongs_to_collection: {
      id: 148065,
      name: 'Phim Điện Ảnh Doraemon',
      poster_path: '/4TLSP1KD1uAlp2q1rTrc6SFlktX.jpg',
      backdrop_path: '/rc6OFcSasL5YxBRPUQVwxmVF6h5.jpg',
    },
    budget: 0,
    genres: [{ id: 16, name: 'Phim Hoạt Hình' }],
    homepage: '',
    id: 134162,
    imdb_id: 'tt1147523',
    original_language: 'ja',
    original_title: 'ドラえもん のび太と雲の王国',
    overview:
      'Doraemon đã sử dụng những bảo bối của mình để cùng với Nobita tạo ra thế giới của riêng cậu trên bầu trời, một đám mây khổng lồ. Trong cuộc hành trình trên đám mây, cả nhóm nhận ra những người ngoài hành tinh đang tìm cách phá hủy nền văn minh loài người vì thiếu cam kết với môi trường. Doraemon và nhóm bạn phải tìm đồng minh và thuyết phục những người trên mây trên Trái đất rằng có những người chiến đấu vì thiên nhiên. Trong cuộc phiêu lưu của mình, gặp gỡ những người bạn tốt, trải qua vô số nguy hiểm, chạm trán với động vật thời tiền sử và cố gắng để bảo vệ hành tinh của chúng ta.',
    popularity: 52.118,
    poster_path:
      'https://image.tmdb.org/t/p/w342/ch12oEXzm5uXroWSQmp2fOwGYbV.jpg',
    production_companies: [],
    production_countries: [{ iso_3166_1: 'JP', name: 'Nhật Bản' }],
    release_date: '1992-03-07',
    revenue: 0,
    runtime: 90,
    spoken_languages: [],
    status: 'Đã phát hành',
    tagline: 'Nobita và vương quốc trên mây',
    title: 'Nobita và vương quốc trên mây',
    video: false,
    vote_average: 6.8,
    vote_count: 15,
    videos: { results: [] },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 1018898,
          known_for_department: 'Diễn viên',
          name: 'Michiko Nomura',
          original_name: 'Michiko Nomura',
          popularity: 1.616,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1rN19cFZgWdSEnVJApmVutSInY8.jpg',
          cast_id: 4,
          character: null,
          credit_id: '52fe4bc6c3a368484e198a55',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 1037843,
          known_for_department: 'Diễn viên',
          name: 'Kazuya Tatekabe',
          original_name: 'Kazuya Tatekabe',
          popularity: 1.028,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2fDKvJ7CorbtKjOc9x1C2LFu4o7.jpg',
          cast_id: 6,
          character: null,
          credit_id: '52fe4bc6c3a368484e198a5d',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 1238594,
          known_for_department: 'Diễn viên',
          name: 'Kaneta Kimotsuki',
          original_name: 'Kaneta Kimotsuki',
          popularity: 1.973,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gzNyG0KgQs4eMqVB4mD8XKGrb2N.jpg',
          cast_id: 7,
          character: 'Suneo Honegawa (voice)',
          credit_id: '56d0a9d79251413e6a006fe7',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 1018899,
          known_for_department: 'Diễn viên',
          name: 'Noriko Ohara',
          original_name: 'Noriko Ohara',
          popularity: 1.103,
          profile_path:
            'https://image.tmdb.org/t/p/w185/u5dvWzckBXvZw8Oexn5VN08vW7G.jpg',
          cast_id: 9,
          character: 'Nobita Nobi (voice)',
          credit_id: '56d1b66e925141746800171f',
          order: 7,
        },
        {
          adult: false,
          gender: 1,
          id: 1018900,
          known_for_department: 'Diễn viên',
          name: 'Nobuyo Oyama',
          original_name: 'Nobuyo Oyama',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/x2363EzijCCE3dpKcOHilX73MSI.jpg',
          cast_id: 10,
          character: 'Doraemon (voice)',
          credit_id: '56d262179251413402009287',
          order: 8,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 0,
          id: 1018897,
          known_for_department: 'Directing',
          name: 'Tsutomu Shibayama',
          original_name: 'Tsutomu Shibayama',
          popularity: 1.22,
          profile_path: null,
          credit_id: '52fe4bc6c3a368484e198a49',
          department: 'Directing',
          job: 'Director',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/uAzdAGerv6i1XVl4ACfpuoWtq21.jpg',
    belongs_to_collection: {
      id: 39199,
      name: '名探偵コナン',
      poster_path: '/bV6EHK0Q65hHKSoVDeACbc960jQ.jpg',
      backdrop_path: '/9bogrpii4e61SR6a9qLHow7I46U.jpg',
    },
    budget: 0,
    genres: [
      { id: 16, name: 'Phim Hoạt Hình' },
      { id: 53, name: 'Phim Gây Cấn' },
    ],
    homepage: 'https://www.tms-e.co.jp/global/alltitles/conan/087303.html',
    id: 28808,
    imdb_id: 'tt1067920',
    original_language: 'ja',
    original_title: '名探偵コナン 世紀末の魔術師',
    overview:
      'Imperial Easter Egg là món đồ nghệ thuật mà sa hoàng Nga đặt nghệ nhân Faberge tạo ra để làm quà tặng cho hoàng hậu nhân lễ phục sinh. Không chỉ Kid mà rất nhiều nhân vật tham gia vào vụ trộm này : Hoshi Seiran, nhà nghiên cứu vương triều Romanov; Ông Inui, nhà buôn đồ cổ; Ông Serger Ovchinikov - bí thư thứ nhất đại sứ quán Nga; Anh Sagawa Ryu – nhiếp ảnh gia tự do... Một cuộc họp khẩn do thanh tra Chaki chủ trì với sự góp mặt của các thanh tra cảnh sát cao cấp nhằm giải mã thư cảnh báo của siêu đạo chích Kid và ngăn chặn vụ trộm của hắn. Một lần nữa Hattori và Conan lại đụng độ cùng giải mã bí ẩn của Kid và báu vật có 1 không hai. Kid với những trò phù thủy của mình lại biến mất trong quá trình truy đuổi. Một kẻ bí ẩn đã ra tay? Kẻ đó là ai? Kid có thực sự chết? Lâu đài Yokusuka có vẻ như là nơi giả câu đố về báu vật. Mọi người đã cùng lên thuyền tới nơi đó? Những nguy hiểm nào đang chờ đợi họ?!',
    popularity: 8.485,
    poster_path:
      'https://image.tmdb.org/t/p/w342/foshgIzj7dPlDIis3KrHHvImdLU.jpg',
    production_companies: [
      {
        id: 882,
        logo_path: '/fRSWWjquvzcHjACbtF53utZFIll.png',
        name: 'Toho',
        origin_country: 'JP',
      },
    ],
    production_countries: [{ iso_3166_1: 'JP', name: 'Nhật Bản' }],
    release_date: '1999-04-17',
    revenue: 22951145,
    runtime: 100,
    spoken_languages: [
      { english_name: 'Nhật Bảnese', iso_639_1: 'ja', name: '日本語' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Thám Tử Lừng Danh Conan 3: Ảo Thuật Gia Cuối Cùng Của Thế Kỷ',
    video: false,
    vote_average: 7.1,
    vote_count: 106,
    videos: { results: [] },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 68470,
          known_for_department: 'Diễn viên',
          name: 'Minami Takayama',
          original_name: 'Minami Takayama',
          popularity: 3.181,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3a3NFRAQ1QMsQbiJ5NWif3R12Rq.jpg',
          cast_id: 3,
          character: 'Conan Edogawa (voice)',
          credit_id: '52fe45b4c3a368484e06a331',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 68472,
          known_for_department: 'Diễn viên',
          name: 'Kappei Yamaguchi',
          original_name: 'Kappei Yamaguchi',
          popularity: 7.19,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sbeWiK7FuUvPqF4yG6XR5CkPAqF.jpg',
          cast_id: 4,
          character: 'Shinichi Kudo (voice)',
          credit_id: '52fe45b4c3a368484e06a335',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 87582,
          known_for_department: 'Diễn viên',
          name: 'Wakana Yamazaki',
          original_name: 'Wakana Yamazaki',
          popularity: 1.831,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7BKB03wUE66hSUTUpUKBQ6djYsA.jpg',
          cast_id: 5,
          character: 'Ran Mori (voice)',
          credit_id: '52fe45b4c3a368484e06a339',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 54690,
          known_for_department: 'Diễn viên',
          name: 'Akira Kamiya',
          original_name: 'Akira Kamiya',
          popularity: 1.968,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mTNcabyfjrGixnxdF39w6ud315X.jpg',
          cast_id: 6,
          character: 'Kogoro Mori (voice)',
          credit_id: '52fe45b4c3a368484e06a33d',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 68472,
          known_for_department: 'Diễn viên',
          name: 'Kappei Yamaguchi',
          original_name: 'Kappei Yamaguchi',
          popularity: 7.19,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sbeWiK7FuUvPqF4yG6XR5CkPAqF.jpg',
          cast_id: 7,
          character: 'Kaitou Kid (voice)',
          credit_id: '52fe45b4c3a368484e06a341',
          order: 4,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 102033,
          known_for_department: 'Directing',
          name: 'Kenji Kodama',
          original_name: 'Kenji Kodama',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/egHkNYdpKLt9GMAaDSSZA1uDX6K.jpg',
          credit_id: '52fe45b4c3a368484e06a327',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 102036,
          known_for_department: 'Biên kịch',
          name: 'Kazunari Kouchi',
          original_name: 'Kazunari Kouchi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe45b4c3a368484e06a32d',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 101917,
          known_for_department: 'Biên kịch',
          name: 'Gōshō Aoyama',
          original_name: 'Gōshō Aoyama',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c1b43d50e0a265f62562198',
          department: 'Biên kịch',
          job: 'Original Story',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/1WFbwmw7B7DqtdAXmbYw2nIftvm.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 28, name: 'Phim Hành Động' },
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 35, name: 'Phim Hài' },
    ],
    homepage: '',
    id: 29014,
    imdb_id: 'tt0098155',
    original_language: 'cn',
    original_title: '群龍戲鳳',
    overview:
      'Bối cảnh bộ phim diễn ra vào những năm 30, kể về một nhóm những anh chàng lái xe xích lô thân thiết với nhau như anh em. Thông to béo, giỏi võ nghệ được mọi người tôn làm thủ lĩnh. Đường “Mạch Nha” điển trai, thích đọc tiểu thuyết lãng mạn nên hay mơ mộng. Cao thấp bé sớm lấy một cô vợ to béo và có 3 đứa con. Sơn tính tình thực dụng, không tin tình yêu, chỉ thích chơi gái. Một lần, nhóm xích lô và nhóm khuân vác họp tại quán ăn để tranh cãi vì chuyện giành khách. Thông đã thuyết phục được hai bên giảng hòa, nhưng đầu bếp vác dao đuổi mèo vô tình kích động một cuộc hồn chiến giữa hai phe…',
    popularity: 4.484,
    poster_path:
      'https://image.tmdb.org/t/p/w342/stUyBIRUo8rmQHb991ywjtra7iB.jpg',
    production_companies: [
      {
        id: 37065,
        logo_path: null,
        name: 'Bojon Films Company Ltd.',
        origin_country: '',
      },
    ],
    production_countries: [{ iso_3166_1: 'HK', name: 'Hồng Kông' }],
    release_date: '1989-02-24',
    revenue: 0,
    runtime: 95,
    spoken_languages: [
      { english_name: 'Cantonese', iso_639_1: 'cn', name: '广州话 / 廣州話' },
    ],
    status: 'Đã phát hành',
    tagline: 'Pedicab Driver (1989)',
    title: 'Quần Long Hí Phụng',
    video: false,
    vote_average: 6.7,
    vote_count: 23,
    videos: { results: [] },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 62410,
          known_for_department: 'Diễn viên',
          name: 'Sammo Hung',
          original_name: 'Sammo Hung',
          popularity: 4.128,
          profile_path:
            'https://image.tmdb.org/t/p/w185/AsB9uRDQWdIbFGnkICEl8I2gDWn.jpg',
          cast_id: 2,
          character: 'Lo Tung',
          credit_id: '52fe45c1c3a368484e06d13f',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 26785,
          known_for_department: 'Diễn viên',
          name: 'Nina Li Chi',
          original_name: 'Nina Li Chi',
          popularity: 3.987,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lL76hgrDqmtUZMtSW8AB2o7GD8f.jpg',
          cast_id: 3,
          character: 'Bing',
          credit_id: '52fe45c1c3a368484e06d143',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 1174635,
          known_for_department: 'Diễn viên',
          name: 'Sun Yueh',
          original_name: 'Sun Yueh',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6XDg8HRINPMIYNivtfeT2wiS5Oq.jpg',
          cast_id: 4,
          character: 'Fong the Baker',
          credit_id: '52fe45c1c3a368484e06d147',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 65992,
          known_for_department: 'Diễn viên',
          name: 'Max Mok Siu-Chung',
          original_name: 'Max Mok Siu-Chung',
          popularity: 1.661,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yTJvpKXrNHbvJPTzRtDDM2pIAfa.jpg',
          cast_id: 29,
          character: 'Malted Candy',
          credit_id: '53fcfcecc3a3684c7d000093',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 238973,
          known_for_department: 'Diễn viên',
          name: 'Lowell Lo',
          original_name: 'Lowell Lo',
          popularity: 1.128,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1PwtmDWX9csN0DexPivz2S9asba.jpg',
          cast_id: 7,
          character: 'San Cha Cake',
          credit_id: '52fe45c1c3a368484e06d153',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 83556,
          known_for_department: 'Diễn viên',
          name: 'Mang Hoi',
          original_name: 'Mang Hoi',
          popularity: 2.23,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bpWZuq1Vz3rCEHvF0Oi0Lg1kzfh.jpg',
          cast_id: 8,
          character: 'Rice Pudding',
          credit_id: '52fe45c1c3a368484e06d157',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 116906,
          known_for_department: 'Diễn viên',
          name: 'John Shum Kin-Fun',
          original_name: 'John Shum Kin-Fun',
          popularity: 2.25,
          profile_path:
            'https://image.tmdb.org/t/p/w185/m07HdRGg2tXS0onuFDYiuZjaa38.jpg',
          cast_id: 9,
          character: 'Master 5',
          credit_id: '52fe45c1c3a368484e06d15b',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 26775,
          known_for_department: 'Diễn viên',
          name: 'Liu Chia-Liang',
          original_name: 'Liu Chia-Liang',
          popularity: 2.391,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1cKWtvMp0onUAn4OfuclM1693gn.jpg',
          cast_id: 10,
          character: 'Casino boss',
          credit_id: '52fe45c1c3a368484e06d15f',
          order: 9,
        },
        {
          adult: false,
          gender: 0,
          id: 126852,
          known_for_department: 'Diễn viên',
          name: 'Maria Cordero',
          original_name: 'Maria Cordero',
          popularity: 0.6,
          profile_path: null,
          cast_id: 11,
          character: "Tung's Aunt",
          credit_id: '52fe45c1c3a368484e06d163',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 35452,
          known_for_department: 'Diễn viên',
          name: 'Corey Yuen',
          original_name: 'Corey Yuen',
          popularity: 4.717,
          profile_path:
            'https://image.tmdb.org/t/p/w185/d4doL1fc0TCcQqgFvkB8fRRpa1F.jpg',
          cast_id: 12,
          character: 'Coolie',
          credit_id: '52fe45c1c3a368484e06d167',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 239010,
          known_for_department: 'Diễn viên',
          name: 'Billy Lau',
          original_name: 'Billy Lau',
          popularity: 2.178,
          profile_path:
            'https://image.tmdb.org/t/p/w185/upXNfzzn7Qm1YXYZgIdHdFEpwKt.jpg',
          cast_id: 13,
          character: 'Coolie',
          credit_id: '52fe45c1c3a368484e06d16b',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 66122,
          known_for_department: 'Diễn viên',
          name: 'Alfred Cheung Kin-Ting',
          original_name: 'Alfred Cheung Kin-Ting',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/veaGtUTk9MSN2mlG7Ghw5tqVDBd.jpg',
          cast_id: 15,
          character: 'Jeweller',
          credit_id: '52fe45c1c3a368484e06d173',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 62423,
          known_for_department: 'Diễn viên',
          name: 'Lam Ching-Ying',
          original_name: 'Lam Ching-Ying',
          popularity: 2.834,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8gS55Yvd4XR9ntBGQiDN3vma712.jpg',
          cast_id: 16,
          character: 'Uncle Sheng',
          credit_id: '52fe45c1c3a368484e06d177',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 1173757,
          known_for_department: 'Diễn viên',
          name: 'Peter Chan Lung',
          original_name: 'Peter Chan Lung',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aho8hTXgcaRc7LenO82MSv6Nfiu.jpg',
          cast_id: 17,
          character: '',
          credit_id: '52fe45c1c3a368484e06d17b',
          order: 16,
        },
        {
          adult: false,
          gender: 0,
          id: 1193735,
          known_for_department: 'Diễn viên',
          name: 'Michelle Yip Suen',
          original_name: 'Michelle Yip Suen',
          popularity: 0.6,
          profile_path: null,
          cast_id: 18,
          character: 'Lan',
          credit_id: '52fe45c1c3a368484e06d17f',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 119460,
          known_for_department: 'Diễn viên',
          name: 'Paul Chung Fat',
          original_name: 'Paul Chung Fat',
          popularity: 2.052,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8dNh1Vw98Sur204iTSnsD6dtIb.jpg',
          cast_id: 19,
          character: "Master 5's thug",
          credit_id: '52fe45c1c3a368484e06d183',
          order: 18,
        },
        {
          adult: false,
          gender: 2,
          id: 239961,
          known_for_department: 'Diễn viên',
          name: 'Billy Chow Bei-Lei',
          original_name: 'Billy Chow Bei-Lei',
          popularity: 3.648,
          profile_path: null,
          cast_id: 20,
          character: "Master 5's leading thug",
          credit_id: '52fe45c1c3a368484e06d187',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 81081,
          known_for_department: 'Diễn viên',
          name: '吴振东',
          original_name: '吴振东',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pOF5i7KO4HJNwwgBfaOAdC69EYR.jpg',
          cast_id: 21,
          character: "Master 5's thug",
          credit_id: '52fe45c1c3a368484e06d18b',
          order: 20,
        },
        {
          adult: false,
          gender: 2,
          id: 62424,
          known_for_department: 'Diễn viên',
          name: 'Dick Wei',
          original_name: 'Dick Wei',
          popularity: 2.285,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pkllOdDN2CGukmyOv2XlzoMAQfC.jpg',
          cast_id: 22,
          character: 'Wei',
          credit_id: '52fe45c1c3a368484e06d18f',
          order: 21,
        },
        {
          adult: false,
          gender: 2,
          id: 26724,
          known_for_department: 'Diễn viên',
          name: 'Eric Tsang',
          original_name: 'Eric Tsang',
          popularity: 3.112,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vrPBadugqlMkfNIYzLZbP4sEF1j.jpg',
          cast_id: 23,
          character: 'Wok cook',
          credit_id: '52fe45c1c3a368484e06d193',
          order: 22,
        },
        {
          adult: false,
          gender: 2,
          id: 230781,
          known_for_department: 'Diễn viên',
          name: 'Eddie Edvardo Maher',
          original_name: 'Eddie Edvardo Maher',
          popularity: 0.6,
          profile_path: null,
          cast_id: 24,
          character: "Master 5's thug",
          credit_id: '52fe45c1c3a368484e06d197',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 119449,
          known_for_department: 'Diễn viên',
          name: 'Fung Ging-Man',
          original_name: 'Fung Ging-Man',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4DVkvBOaKo4a9z00f8kispO4tGu.jpg',
          cast_id: 25,
          character: 'Brothel Boss Uncle Fe',
          credit_id: '52fe45c1c3a368484e06d19b',
          order: 24,
        },
        {
          adult: false,
          gender: 0,
          id: 21902,
          known_for_department: 'Biên kịch',
          name: 'Manfred Wong',
          original_name: 'Manfred Wong',
          popularity: 1.064,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ZW0X62PWUkVG4UTrMDqmdt1NmA.jpg',
          cast_id: 30,
          character: 'Pork Bun man',
          credit_id: '548bdc69c3a3684ea1000b77',
          order: 25,
        },
        {
          adult: false,
          gender: 1,
          id: 579216,
          known_for_department: 'Diễn viên',
          name: 'Fennie Yuen',
          original_name: 'Fennie Yuen',
          popularity: 1.105,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1llk1BKK4qyLUWQprZKxqhpWzWA.jpg',
          cast_id: 32,
          character: 'Siu Chui',
          credit_id: '591fe860c3a36878fe03d0be',
          order: 26,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 62410,
          known_for_department: 'Diễn viên',
          name: 'Sammo Hung',
          original_name: 'Sammo Hung',
          popularity: 4.128,
          profile_path:
            'https://image.tmdb.org/t/p/w185/AsB9uRDQWdIbFGnkICEl8I2gDWn.jpg',
          credit_id: '52fe45c1c3a368484e06d13b',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 62410,
          known_for_department: 'Diễn viên',
          name: 'Sammo Hung',
          original_name: 'Sammo Hung',
          popularity: 4.128,
          profile_path:
            'https://image.tmdb.org/t/p/w185/AsB9uRDQWdIbFGnkICEl8I2gDWn.jpg',
          credit_id: '5dfd317dd1a893001986598e',
          department: 'Crew',
          job: 'Presenter',
        },
        {
          adult: false,
          gender: 2,
          id: 62412,
          known_for_department: 'Biên kịch',
          name: 'Barry Wong',
          original_name: 'Barry Wong',
          popularity: 1.742,
          profile_path: null,
          credit_id: '5742a4b8c3a3686c8c000e2c',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 83556,
          known_for_department: 'Diễn viên',
          name: 'Mang Hoi',
          original_name: 'Mang Hoi',
          popularity: 2.23,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bpWZuq1Vz3rCEHvF0Oi0Lg1kzfh.jpg',
          credit_id: '5dfd314c9824c80015de20e4',
          department: 'Directing',
          job: 'Action Director',
        },
        {
          adult: false,
          gender: 2,
          id: 238973,
          known_for_department: 'Diễn viên',
          name: 'Lowell Lo',
          original_name: 'Lowell Lo',
          popularity: 1.128,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1PwtmDWX9csN0DexPivz2S9asba.jpg',
          credit_id: '5dfd313e699fb7001806862f',
          department: 'Crew',
          job: 'Compositor',
        },
        {
          adult: false,
          gender: 2,
          id: 592316,
          known_for_department: 'Sound',
          name: 'Sherman Chow',
          original_name: 'Sherman Chow',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5dfd317265686e001590fdd4',
          department: 'Crew',
          job: 'Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 1043439,
          known_for_department: 'Biên kịch',
          name: 'Yuen Gai-Chi',
          original_name: 'Yuen Gai-Chi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe45c1c3a368484e06d1a1',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 1088190,
          known_for_department: 'Diễn viên',
          name: 'Brandy Yuen Jan-Yeung',
          original_name: 'Brandy Yuen Jan-Yeung',
          popularity: 1.38,
          profile_path:
            'https://image.tmdb.org/t/p/w185/c9tIXDpswVWNnvCqwubVclSZO3g.jpg',
          credit_id: '5dfd315526dac100145ea7fa',
          department: 'Directing',
          job: 'Action Director',
        },
        {
          adult: false,
          gender: 1,
          id: 1193736,
          known_for_department: 'Production',
          name: 'Jessica Chan Pooi-Wa',
          original_name: 'Jessica Chan Pooi-Wa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe45c1c3a368484e06d1ad',
          department: 'Production',
          job: 'Producer',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/yX1IsNlhVnqkSD6XBXnVNKOQ6WL.jpg',
    belongs_to_collection: null,
    budget: 100000000,
    genres: [
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 878, name: 'Phim Khoa Học Viễn Tưởng' },
      { id: 12, name: 'Phim Phiêu Lưu' },
    ],
    homepage: '',
    id: 644,
    imdb_id: 'tt0212720',
    original_language: 'en',
    original_title: 'A.I. Artificial Intelligence',
    overview:
      'Trong tương lai, con người tạo ra một thế hệ robot mới biết tư duy, hoạt động như con người, thậm chí có những tình cảm và cảm xúc y hệt con người. Ở một nơi khác, vợ chồng Monica và Henry Swinton đau khổ trong tuyệt vọng khi cậu con trai Martin đang lâm bệnh nặng. Không cam lòng nhìn vợ sầu thảm, Henry đặt sản xuất một robot trẻ em về bầu bạn với vợ với điều kiện, sẽ phải hoàn trả sản phẩm cho nhà sản xuất nếu không có nhu cầu sử dụng.  Robot có tên là David. Không ai phát hiện ra cậu không phải người thật bởi David là một người máy hoàn hảo. Nhưng bà Monica vẫn không thể coi cậu là con. Dần dần, bằng tình cảm thiết tha, ánh mắt buồn bã đến khắc khoải, David làm cho trái tim đau khổ của mẹ phải tan chảy…',
    popularity: 18.213,
    poster_path:
      'https://image.tmdb.org/t/p/w342/wnUAcUrMRGPPZUDroLeZhSjLkuu.jpg',
    production_companies: [
      {
        id: 56,
        logo_path: '/cEaxANEisCqeEoRvODv2dO1I0iI.png',
        name: 'Amblin Entertainment',
        origin_country: 'US',
      },
      {
        id: 385,
        logo_path: null,
        name: 'Stanley Kubrick Productions',
        origin_country: 'GB',
      },
      {
        id: 7,
        logo_path: '/vru2SssLX3FPhnKZGtYw00pVIS9.png',
        name: 'DreamWorks Pictures',
        origin_country: 'US',
      },
      {
        id: 174,
        logo_path: '/IuAlhI9eVC9Z8UQWOIDdWRKSEJ.png',
        name: 'Warner Bros. Pictures',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2001-06-29',
    revenue: 235926552,
    runtime: 146,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline:
      'David is 11 years old. He weighs 60 pounds. He is 4 feet, 6 inches tall. He has brown hair. His love is real. But he is not.',
    title: 'Trí Tuệ Nhân Tạo',
    video: false,
    vote_average: 7.0,
    vote_count: 4970,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'A.I. Artificial Intelligence International Trailer #1 (2001)',
          key: 'oBUAQGwzGk0',
          published_at: '2015-08-28T18:49:41.000Z',
          site: 'YouTube',
          size: 480,
          type: 'Trailer',
          official: false,
          id: '5936a11c9251416c1d00e060',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 9640,
          known_for_department: 'Diễn viên',
          name: 'Haley Joel Osment',
          original_name: 'Haley Joel Osment',
          popularity: 7.137,
          profile_path:
            'https://image.tmdb.org/t/p/w185/di2YAJkjOi5CJEx5xkGl4ynXXyB.jpg',
          cast_id: 18,
          character: 'David',
          credit_id: '52fe4263c3a36847f801a9cf',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 9642,
          known_for_department: 'Diễn viên',
          name: 'Jude Law',
          original_name: 'Jude Law',
          popularity: 7.996,
          profile_path:
            'https://image.tmdb.org/t/p/w185/A6Y0m7qEe04ZTHKyYDLbnyCHNzn.jpg',
          cast_id: 22,
          character: 'Gigolo Joe',
          credit_id: '52fe4263c3a36847f801a9df',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 1518,
          known_for_department: 'Diễn viên',
          name: "Frances O'Connor",
          original_name: "Frances O'Connor",
          popularity: 2.778,
          profile_path:
            'https://image.tmdb.org/t/p/w185/e8Mk7PNuOIc1BzNkXRzWhkY4kGa.jpg',
          cast_id: 19,
          character: 'Monica Swinton',
          credit_id: '52fe4263c3a36847f801a9d3',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 8213,
          known_for_department: 'Diễn viên',
          name: 'Sam Robards',
          original_name: 'Sam Robards',
          popularity: 1.533,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bUXMGjSmgFabbvlU2V6jhLmehhx.jpg',
          cast_id: 20,
          character: 'Henry Swinton',
          credit_id: '52fe4263c3a36847f801a9d7',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 9641,
          known_for_department: 'Diễn viên',
          name: 'Jake Thomas',
          original_name: 'Jake Thomas',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rM0IbCQcaCJe37YDu44uIhv6xJX.jpg',
          cast_id: 21,
          character: 'Martin Swinton',
          credit_id: '52fe4263c3a36847f801a9db',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 227,
          known_for_department: 'Diễn viên',
          name: 'William Hurt',
          original_name: 'William Hurt',
          popularity: 8.153,
          profile_path:
            'https://image.tmdb.org/t/p/w185/j3mjmuHLBW4XQSw53C8Sh0Lh3ZQ.jpg',
          cast_id: 23,
          character: 'Prof. Hobby',
          credit_id: '52fe4263c3a36847f801a9e3',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 2157,
          known_for_department: 'Diễn viên',
          name: 'Robin Williams',
          original_name: 'Robin Williams',
          popularity: 9.11,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iYdeP6K0qz44Wg2Nw9LPJGMBkQ5.jpg',
          cast_id: 24,
          character: 'Dr. Know (voice)',
          credit_id: '52fe4263c3a36847f801a9e7',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 2282,
          known_for_department: 'Diễn viên',
          name: 'Ben Kingsley',
          original_name: 'Ben Kingsley',
          popularity: 12.376,
          profile_path:
            'https://image.tmdb.org/t/p/w185/k3Dmu49B2akwDvgqy52MOxznI59.jpg',
          cast_id: 25,
          character: 'Specialist (voice)',
          credit_id: '52fe4263c3a36847f801a9eb',
          order: 7,
        },
        {
          adult: false,
          gender: 1,
          id: 5064,
          known_for_department: 'Diễn viên',
          name: 'Meryl Streep',
          original_name: 'Meryl Streep',
          popularity: 19.785,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xqL5IJxV0fDeD3OfkS3eWqwJoGV.jpg',
          cast_id: 26,
          character: 'Blue Mecha (voice)',
          credit_id: '52fe4263c3a36847f801a9ef',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 2632,
          known_for_department: 'Diễn viên',
          name: 'Chris Rock',
          original_name: 'Chris Rock',
          popularity: 5.713,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cqI8yQ00GNDV3PAAz5UeLj7vOX0.jpg',
          cast_id: 27,
          character: 'Comedian (voice)',
          credit_id: '52fe4263c3a36847f801a9f3',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 2131,
          known_for_department: 'Diễn viên',
          name: 'Ken Leung',
          original_name: 'Ken Leung',
          popularity: 5.91,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hpatUP6u74gkpDRmn9voNY9V43O.jpg',
          cast_id: 30,
          character: 'Syatyoo-Sama',
          credit_id: '52fe4263c3a36847f801aa03',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 9048,
          known_for_department: 'Diễn viên',
          name: 'Clark Gregg',
          original_name: 'Clark Gregg',
          popularity: 5.012,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zwyhwrxgpiufSPpjC9dxCy5kAB0.jpg',
          cast_id: 31,
          character: 'Supernerd',
          credit_id: '52fe4263c3a36847f801aa07',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 60633,
          known_for_department: 'Diễn viên',
          name: 'Kevin Sussman',
          original_name: 'Kevin Sussman',
          popularity: 5.083,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tLqrE9uz6GKoeoDC7LU7cE6oF2Q.jpg',
          cast_id: 32,
          character: 'Supernerd',
          credit_id: '52fe4263c3a36847f801aa0b',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 27030,
          known_for_department: 'Diễn viên',
          name: 'Tom Gallop',
          original_name: 'Tom Gallop',
          popularity: 2.111,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jqbrDxorFinlo6Ae39SL17AvKaf.jpg',
          cast_id: 33,
          character: 'Supernerd',
          credit_id: '52fe4263c3a36847f801aa0f',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 1004155,
          known_for_department: 'Diễn viên',
          name: 'Eugene Osment',
          original_name: 'Eugene Osment',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3y7IDD8EmpUudkKU5yQsFGXaGq3.jpg',
          cast_id: 34,
          character: 'Supernerd',
          credit_id: '52fe4263c3a36847f801aa13',
          order: 14,
        },
        {
          adult: false,
          gender: 1,
          id: 10691,
          known_for_department: 'Diễn viên',
          name: 'April Grace',
          original_name: 'April Grace',
          popularity: 2.122,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nV8nnymN0ClT3xppwhlAtUnjSxa.jpg',
          cast_id: 35,
          character: 'Female Colleague',
          credit_id: '52fe4263c3a36847f801aa17',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 35521,
          known_for_department: 'Diễn viên',
          name: 'Matt Winston',
          original_name: 'Matt Winston',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/et38vhCb9y8yGleMRNY2j4nDDyr.jpg',
          cast_id: 36,
          character: 'Executive',
          credit_id: '52fe4263c3a36847f801aa1b',
          order: 16,
        },
        {
          adult: false,
          gender: 1,
          id: 142736,
          known_for_department: 'Diễn viên',
          name: 'Sabrina Grdevich',
          original_name: 'Sabrina Grdevich',
          popularity: 2.222,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pcTeiiMSRUbgqQ60v0TuiDHvBze.jpg',
          cast_id: 37,
          character: 'Sheila',
          credit_id: '52fe4263c3a36847f801aa1f',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 167195,
          known_for_department: 'Diễn viên',
          name: 'Theo Greenly',
          original_name: 'Theo Greenly',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dc6CBtEtD5guZp6nCRnDaOz6u79.jpg',
          cast_id: 38,
          character: 'Todd',
          credit_id: '52fe4263c3a36847f801aa23',
          order: 18,
        },
        {
          adult: false,
          gender: 2,
          id: 91030,
          known_for_department: 'Diễn viên',
          name: 'Michael Mantell',
          original_name: 'Michael Mantell',
          popularity: 1.265,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wZ8XkAkpok05jQthvy0H8iGoXrz.jpg',
          cast_id: 41,
          character: 'Dr. Frazier at Cryogenic Institute',
          credit_id: '539974960e0a263e300018a7',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 15318,
          known_for_department: 'Crew',
          name: 'Keith Campbell',
          original_name: 'Keith Campbell',
          popularity: 0.662,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oPAqYzvsm2m3HtnxKTuzglgFxum.jpg',
          cast_id: 42,
          character: 'Roadworker',
          credit_id: '53b951560e0a2676c7009c2d',
          order: 20,
        },
        {
          adult: false,
          gender: 2,
          id: 1214402,
          known_for_department: 'Diễn viên',
          name: 'Brian Turk',
          original_name: 'Brian Turk',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lcLaFJe1Z6IVtEEx0foo3xQsJ6D.jpg',
          cast_id: 103,
          character: 'Backstage Bull',
          credit_id: '56e7a7c6c3a3684082001b89',
          order: 21,
        },
        {
          adult: false,
          gender: 2,
          id: 2039,
          known_for_department: 'Diễn viên',
          name: 'Brendan Gleeson',
          original_name: 'Brendan Gleeson',
          popularity: 8.712,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rMqHaHDwSvqH8d0NdSS2qrWldvS.jpg',
          cast_id: 161,
          character: 'Lord Johnson-Johnson',
          credit_id: '5886379f9251415abb001dd7',
          order: 22,
        },
        {
          adult: false,
          gender: 2,
          id: 2001832,
          known_for_department: 'Directing',
          name: 'Christopher Dye',
          original_name: 'Christopher Dye',
          popularity: 0.6,
          profile_path: null,
          cast_id: 185,
          character: 'Flesh Fair Participant',
          credit_id: '5aaf112292514116bd02c565',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 19545,
          known_for_department: 'Diễn viên',
          name: 'Jack Angel',
          original_name: 'Jack Angel',
          popularity: 2.179,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5MsVwIULYJotUSbDs61uSJff7ei.jpg',
          cast_id: 186,
          character: 'Teddy (voice)',
          credit_id: '5ab41ad60e0a265f30011357',
          order: 24,
        },
        {
          adult: false,
          gender: 2,
          id: 1209419,
          known_for_department: 'Crew',
          name: 'Tim Rigby',
          original_name: 'Tim Rigby',
          popularity: 2.014,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5ckhBJzA3MNxGPDSWytTKrdm26M.jpg',
          cast_id: 187,
          character: 'Yeoman',
          credit_id: '5acc6e469251410c03006e07',
          order: 25,
        },
        {
          adult: false,
          gender: 2,
          id: 15029,
          known_for_department: 'Diễn viên',
          name: 'Enrico Colantoni',
          original_name: 'Enrico Colantoni',
          popularity: 4.757,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yxxy8IrGRwnRPbLmgyfwF26Feve.jpg',
          cast_id: 188,
          character: 'The Murderer',
          credit_id: '5ae9d5efc3a3683bb200c01f',
          order: 26,
        },
        {
          adult: false,
          gender: 2,
          id: 5090,
          known_for_department: 'Diễn viên',
          name: 'Adrian Grenier',
          original_name: 'Adrian Grenier',
          popularity: 3.073,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2ILiQq6Sr8vfZqaL7JR5PIdiL6l.jpg',
          cast_id: 189,
          character: 'Teen in Van',
          credit_id: '5ae9d6100e0a26395d008c53',
          order: 27,
        },
        {
          adult: false,
          gender: 2,
          id: 19208,
          known_for_department: 'Diễn viên',
          name: 'Matt Malloy',
          original_name: 'Matt Malloy',
          popularity: 1.784,
          profile_path:
            'https://image.tmdb.org/t/p/w185/csNVv2jlw6QLoNCcifGnvT9hN2O.jpg',
          cast_id: 190,
          character: 'Robot Repairman',
          credit_id: '5ae9d62ac3a3683b8a00b106',
          order: 28,
        },
        {
          adult: false,
          gender: 2,
          id: 159261,
          known_for_department: 'Diễn viên',
          name: 'Brent Sexton',
          original_name: 'Brent Sexton',
          popularity: 2.335,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wjxWvYZZIWIKb7rQnJXRoXPRqwh.jpg',
          cast_id: 191,
          character: 'Russell',
          credit_id: '5ae9d63fc3a3683ba60076cd',
          order: 29,
        },
        {
          adult: false,
          gender: 2,
          id: 1729665,
          known_for_department: 'Diễn viên',
          name: 'Erik Bauersfeld',
          original_name: 'Erik Bauersfeld',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zJU29NfYKBhvSO1QHdsgpBLhK79.jpg',
          cast_id: 202,
          character: 'Gardener (Voice)',
          credit_id: '5c23aecd0e0a264dedf1a4be',
          order: 30,
        },
        {
          adult: false,
          gender: 2,
          id: 167651,
          known_for_department: 'Diễn viên',
          name: 'Michael Fishman',
          original_name: 'Michael Fishman',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8zPCl7uFbRu4TJTYOKZqGWSzfzJ.jpg',
          cast_id: 203,
          character: 'Teen in Van',
          credit_id: '5c23af0fc3a368700bf0539f',
          order: 31,
        },
        {
          adult: false,
          gender: 1,
          id: 134117,
          known_for_department: 'Diễn viên',
          name: 'Diane Fletcher',
          original_name: 'Diane Fletcher',
          popularity: 0.6,
          profile_path: null,
          cast_id: 204,
          character: 'Sentient Machine Security',
          credit_id: '5c23af3dc3a3681c34ef15d0',
          order: 32,
        },
        {
          adult: false,
          gender: 2,
          id: 150992,
          known_for_department: 'Diễn viên',
          name: 'Al Jourgensen',
          original_name: 'Al Jourgensen',
          popularity: 1.138,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sdYye6r8rEXC0HDbyaXGBJ05jpE.jpg',
          cast_id: 205,
          character: 'Flesh Fair Band Member',
          credit_id: '5c23af7d925141520dc2c8de',
          order: 33,
        },
        {
          adult: false,
          gender: 0,
          id: 150993,
          known_for_department: 'Diễn viên',
          name: 'Paul Barker',
          original_name: 'Paul Barker',
          popularity: 0.6,
          profile_path: null,
          cast_id: 206,
          character: 'Flesh Fair Band Member',
          credit_id: '5c23afad0e0a264ddef1ac84',
          order: 34,
        },
        {
          adult: false,
          gender: 0,
          id: 1568226,
          known_for_department: 'Diễn viên',
          name: 'Vito Carenzo',
          original_name: 'Vito Carenzo',
          popularity: 0.6,
          profile_path: null,
          cast_id: 207,
          character: 'Big Man',
          credit_id: '5c23afd10e0a264de1f19575',
          order: 35,
        },
        {
          adult: false,
          gender: 0,
          id: 2202223,
          known_for_department: 'Diễn viên',
          name: 'Adam Grossman',
          original_name: 'Adam Grossman',
          popularity: 0.6,
          profile_path: null,
          cast_id: 208,
          character: 'Flesh Fair Band Member',
          credit_id: '5c23afe90e0a264df2f1794d',
          order: 36,
        },
        {
          adult: false,
          gender: 1,
          id: 7241,
          known_for_department: 'Diễn viên',
          name: 'Rena Owen',
          original_name: 'Rena Owen',
          popularity: 3.271,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8s0ePZ1ifvE7NlvtLOAWNXLjdx4.jpg',
          cast_id: 209,
          character: 'Ticket Taker',
          credit_id: '5c23b008c3a368044aed76af',
          order: 37,
        },
        {
          adult: false,
          gender: 2,
          id: 20804,
          known_for_department: 'Diễn viên',
          name: 'Adam Alexi-Malle',
          original_name: 'Adam Alexi-Malle',
          popularity: 0.6,
          profile_path: null,
          cast_id: 210,
          character: 'Crowd Member',
          credit_id: '5c23b021c3a368700eeff345',
          order: 38,
        },
        {
          adult: false,
          gender: 2,
          id: 65141,
          known_for_department: 'Diễn viên',
          name: 'Laurence Mason',
          original_name: 'Laurence Mason',
          popularity: 2.268,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nzRcya54sfvopQEfImZyDXsZ4u.jpg',
          cast_id: 211,
          character: 'Tech Director',
          credit_id: '5c23b0450e0a264dd8f19fdc',
          order: 39,
        },
        {
          adult: false,
          gender: 1,
          id: 71128,
          known_for_department: 'Diễn viên',
          name: 'Ashley Scott',
          original_name: 'Ashley Scott',
          popularity: 6.91,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eKMcubmUjNHgAp5qBaEucPtOtZX.jpg',
          cast_id: 241,
          character: 'Gigolo Jane',
          credit_id: '5cbd1d5bc3a368776c870952',
          order: 40,
        },
        {
          adult: false,
          gender: 2,
          id: 2310115,
          known_for_department: 'Diễn viên',
          name: 'Ty Coon',
          original_name: 'Ty Coon',
          popularity: 0.6,
          profile_path: null,
          cast_id: 242,
          character: 'Flesh Fair Band Member',
          credit_id: '5cd6e6d10e0a262df2cc2a50',
          order: 41,
        },
        {
          adult: false,
          gender: 2,
          id: 2310118,
          known_for_department: 'Diễn viên',
          name: 'Duane Buford',
          original_name: 'Duane Buford',
          popularity: 0.6,
          profile_path: null,
          cast_id: 243,
          character: 'Flesh Fair Band Member',
          credit_id: '5cd6e72392514106eecebca6',
          order: 42,
        },
        {
          adult: false,
          gender: 2,
          id: 2310120,
          known_for_department: 'Diễn viên',
          name: 'Max Brody',
          original_name: 'Max Brody',
          popularity: 0.6,
          profile_path: null,
          cast_id: 244,
          character: 'Flesh Fair Band Member',
          credit_id: '5cd6e7510e0a262e03cc202c',
          order: 43,
        },
        {
          adult: false,
          gender: 2,
          id: 2310122,
          known_for_department: 'Diễn viên',
          name: 'Red King',
          original_name: 'Red King',
          popularity: 0.6,
          profile_path: null,
          cast_id: 245,
          character: 'Covert Information Retrieval',
          credit_id: '5cd6e789c3a36817d7c180be',
          order: 44,
        },
        {
          adult: false,
          gender: 2,
          id: 2310123,
          known_for_department: 'Diễn viên',
          name: 'Claude Gilbert',
          original_name: 'Claude Gilbert',
          popularity: 0.6,
          profile_path: null,
          cast_id: 246,
          character: 'Cybertronics - Room 93056',
          credit_id: '5cd6e7b80e0a262e03cc20a1',
          order: 45,
        },
        {
          adult: false,
          gender: 1,
          id: 2310125,
          known_for_department: 'Diễn viên',
          name: 'Kate Nei',
          original_name: 'Kate Nei',
          popularity: 0.6,
          profile_path: null,
          cast_id: 247,
          character: 'Toe Bell Ringing',
          credit_id: '5cd6e7e10e0a262e03cc2155',
          order: 46,
        },
        {
          adult: false,
          gender: 1,
          id: 2310126,
          known_for_department: 'Diễn viên',
          name: 'Laia Salla',
          original_name: 'Laia Salla',
          popularity: 0.828,
          profile_path: null,
          cast_id: 248,
          character: "Mr. Chan's Assistant",
          credit_id: '5cd6e814c3a36817c0c18d40',
          order: 47,
        },
        {
          adult: false,
          gender: 1,
          id: 2310128,
          known_for_department: 'Diễn viên',
          name: 'Jeanine Salla',
          original_name: 'Jeanine Salla',
          popularity: 0.6,
          profile_path: null,
          cast_id: 249,
          character: 'Sentient Machine Therapist',
          credit_id: '5cd6e8410e0a262e03cc2232',
          order: 48,
        },
        {
          adult: false,
          gender: 2,
          id: 1545795,
          known_for_department: 'Diễn viên',
          name: 'Mark Allan Staubach',
          original_name: 'Mark Allan Staubach',
          popularity: 0.6,
          profile_path: null,
          cast_id: 250,
          character: 'Teen in Van',
          credit_id: '5cd6e8889251417c3fce89a5',
          order: 49,
        },
        {
          adult: false,
          gender: 2,
          id: 34840,
          known_for_department: 'Diễn viên',
          name: 'Miguel Pérez',
          original_name: 'Miguel Pérez',
          popularity: 2.832,
          profile_path:
            'https://image.tmdb.org/t/p/w185/laGQcrfJ6bAHxLmdLjfCghmuRUH.jpg',
          cast_id: 251,
          character: 'Robot Repairman',
          credit_id: '5cd6e8fdc3a36817c0c18e56',
          order: 50,
        },
        {
          adult: false,
          gender: 2,
          id: 1188702,
          known_for_department: 'Diễn viên',
          name: 'Billy Scudder',
          original_name: 'Billy Scudder',
          popularity: 0.6,
          profile_path: null,
          cast_id: 252,
          character: 'Mechanic',
          credit_id: '5cd6e9d90e0a263080cbe073',
          order: 51,
        },
        {
          adult: false,
          gender: 2,
          id: 43895,
          known_for_department: 'Diễn viên',
          name: 'Bobby Harwell',
          original_name: 'Bobby Harwell',
          popularity: 0.6,
          profile_path: null,
          cast_id: 253,
          character: 'TV Face',
          credit_id: '5cd6ea1bc3a36817c0c18ffb',
          order: 52,
        },
        {
          adult: false,
          gender: 2,
          id: 1216179,
          known_for_department: 'Diễn viên',
          name: 'Wayne Wilderson',
          original_name: 'Wayne Wilderson',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wxGjX5fqMaw9pey8ysFZbetpKGD.jpg',
          cast_id: 254,
          character: 'Comedian',
          credit_id: '5cd6ea870e0a262e03cc2922',
          order: 53,
        },
        {
          adult: false,
          gender: 2,
          id: 1478951,
          known_for_department: 'Diễn viên',
          name: 'R. David Smith',
          original_name: 'R. David Smith',
          popularity: 0.6,
          profile_path: null,
          cast_id: 255,
          character: 'Welder',
          credit_id: '5cd6eae69251410703ceccd6',
          order: 54,
        },
        {
          adult: false,
          gender: 1,
          id: 1464310,
          known_for_department: 'Crew',
          name: 'Eliza Coleman',
          original_name: 'Eliza Coleman',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wb7sr5O0WVADFsOUiC8hzekhDmd.jpg',
          cast_id: 256,
          character: 'General Circuita',
          credit_id: '5cd6eb210e0a262e03cc2a4f',
          order: 55,
        },
        {
          adult: false,
          gender: 2,
          id: 155031,
          known_for_department: 'Diễn viên',
          name: 'Jim Jansen',
          original_name: 'Jim Jansen',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mMzX4hyysmZ5i8N0EGuwNq9tVfJ.jpg',
          cast_id: 257,
          character: 'Chef',
          credit_id: '5cd6eb61c3a36817cec17002',
          order: 56,
        },
        {
          adult: false,
          gender: 2,
          id: 1226519,
          known_for_department: 'Diễn viên',
          name: 'Tim Rhoze',
          original_name: 'Tim Rhoze',
          popularity: 1.22,
          profile_path: null,
          cast_id: 258,
          character: 'Laboratory Technician',
          credit_id: '5cd6eb8792514106faced99f',
          order: 57,
        },
        {
          adult: false,
          gender: 1,
          id: 27637,
          known_for_department: 'Diễn viên',
          name: 'Clara Bellar',
          original_name: 'Clara Bellar',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ahfyLH2B0sVMNTaSZ0zgrezJrOY.jpg',
          cast_id: 259,
          character: 'FemMecha Nanny',
          credit_id: '5cd6ebc90e0a262defcc2553',
          order: 58,
        },
        {
          adult: false,
          gender: 1,
          id: 2310136,
          known_for_department: 'Diễn viên',
          name: 'Kelly McCool',
          original_name: 'Kelly McCool',
          popularity: 0.6,
          profile_path: null,
          cast_id: 260,
          character: 'Kate the Holographic Girl',
          credit_id: '5cd6ec070e0a262df2cc3463',
          order: 59,
        },
        {
          adult: false,
          gender: 2,
          id: 9291,
          known_for_department: 'Diễn viên',
          name: 'Michael Shamus Wiles',
          original_name: 'Michael Shamus Wiles',
          popularity: 1.53,
          profile_path:
            'https://image.tmdb.org/t/p/w185/niY4gYqAUjmnU4KRiguxpsKliWA.jpg',
          cast_id: 261,
          character: 'Cop',
          credit_id: '5cd6ec33c3a36817c0c19314',
          order: 60,
        },
        {
          adult: false,
          gender: 2,
          id: 2310138,
          known_for_department: 'Diễn viên',
          name: 'Jason Sutter',
          original_name: 'Jason Sutter',
          popularity: 0.6,
          profile_path: null,
          cast_id: 262,
          character: 'Percussionist',
          credit_id: '5cd6ec5f9251417c3fce8ef4',
          order: 61,
        },
        {
          adult: false,
          gender: 2,
          id: 937337,
          known_for_department: 'Diễn viên',
          name: 'Ken Palmer',
          original_name: 'Ken Palmer',
          popularity: 0.6,
          profile_path: null,
          cast_id: 263,
          character: 'Percussionist',
          credit_id: '5cd6ec9d9251417c3fce9069',
          order: 62,
        },
        {
          adult: false,
          gender: 2,
          id: 1400337,
          known_for_department: 'Crew',
          name: 'Alan Scott',
          original_name: 'Alan Scott',
          popularity: 0.6,
          profile_path: null,
          cast_id: 264,
          character: 'Worker',
          credit_id: '5cd6edf99251410703ced373',
          order: 63,
        },
        {
          adult: false,
          gender: 1,
          id: 12539,
          known_for_department: 'Diễn viên',
          name: 'Lily Knight',
          original_name: 'Lily Knight',
          popularity: 1.768,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mc4RlYfBJt82tOq6IAK6zsFejFu.jpg',
          cast_id: 265,
          character: 'Voice in the Crowd (voice)',
          credit_id: '5cd6ef840e0a262df5cc37e8',
          order: 64,
        },
        {
          adult: false,
          gender: 1,
          id: 95517,
          known_for_department: 'Diễn viên',
          name: 'Justina Machado',
          original_name: 'Justina Machado',
          popularity: 4.465,
          profile_path:
            'https://image.tmdb.org/t/p/w185/j5FaJXoyhMHlqv1l6TBdt1CH1oO.jpg',
          cast_id: 266,
          character: 'Assistant',
          credit_id: '5cd6efb692514106f3cecc78',
          order: 65,
        },
        {
          adult: false,
          gender: 1,
          id: 1580,
          known_for_department: 'Diễn viên',
          name: 'Daveigh Chase',
          original_name: 'Daveigh Chase',
          popularity: 3.1,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3PVQPEc6nXNX2eoW2UbsfVikc7H.jpg',
          cast_id: 267,
          character: 'Child Singer (scenes deleted)',
          credit_id: '5cd6efef9251417c3fce93dd',
          order: 66,
        },
        {
          adult: false,
          gender: 1,
          id: 2208,
          known_for_department: 'Diễn viên',
          name: 'Kathryn Morris',
          original_name: 'Kathryn Morris',
          popularity: 7.402,
          profile_path:
            'https://image.tmdb.org/t/p/w185/k5m4ijRTc8Z0dqZvsXfuFISHJ4u.jpg',
          cast_id: 268,
          character: 'Teenage Honey',
          credit_id: '5cd6f02592514111decea250',
          order: 67,
        },
        {
          adult: false,
          gender: 1,
          id: 1446320,
          known_for_department: 'Diễn viên',
          name: 'Hunter King',
          original_name: 'Hunter King',
          popularity: 1.176,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lFACjapH3WvCrUSUlhEJZZxkbxA.jpg',
          cast_id: 269,
          character: 'Amanda',
          credit_id: '5cd6f0790e0a263080cbeca6',
          order: 68,
        },
        {
          adult: false,
          gender: 2,
          id: 81867,
          known_for_department: 'Diễn viên',
          name: 'Michael Berresse',
          original_name: 'Michael Berresse',
          popularity: 0.6,
          profile_path: null,
          cast_id: 270,
          character: 'Stage Manager',
          credit_id: '5cd6f15e9251417c3fce95ee',
          order: 69,
        },
        {
          adult: false,
          gender: 1,
          id: 47533,
          known_for_department: 'Diễn viên',
          name: 'Paula Malcomson',
          original_name: 'Paula Malcomson',
          popularity: 3.426,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9lJy6ze86ZfVcBcyBK9UZq8FJiC.jpg',
          cast_id: 271,
          character: 'Patricia in Mirrored Room',
          credit_id: '5cd6f1ba92514106f8cee73e',
          order: 70,
        },
        {
          adult: false,
          gender: 2,
          id: 42724,
          known_for_department: 'Diễn viên',
          name: 'John Prosky',
          original_name: 'John Prosky',
          popularity: 1.013,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zinfZ6InYtlnXnwl4UwKEITP1xf.jpg',
          cast_id: 272,
          character: 'Mr. Williamson, the Bellman',
          credit_id: '5cd6f21992514106eeced137',
          order: 71,
        },
        {
          adult: false,
          gender: 2,
          id: 1605123,
          known_for_department: 'Diễn viên',
          name: 'Curt Youngberg',
          original_name: 'Curt Youngberg',
          popularity: 0.694,
          profile_path: null,
          cast_id: 273,
          character: 'Kid',
          credit_id: '5cd6f25ac3a36875bcc1511b',
          order: 72,
        },
        {
          adult: false,
          gender: 2,
          id: 151228,
          known_for_department: 'Diễn viên',
          name: 'Andy Morrow',
          original_name: 'Andy Morrow',
          popularity: 0.98,
          profile_path: null,
          cast_id: 274,
          character: 'Kid',
          credit_id: '5cd6f29192514106f6cec95f',
          order: 73,
        },
        {
          adult: false,
          gender: 2,
          id: 2310148,
          known_for_department: 'Diễn viên',
          name: 'Dillon McEwin',
          original_name: 'Dillon McEwin',
          popularity: 0.6,
          profile_path: null,
          cast_id: 275,
          character: 'Kid',
          credit_id: '5cd6f2bd0e0a262defcc3122',
          order: 74,
        },
        {
          adult: false,
          gender: 2,
          id: 1226764,
          known_for_department: 'Diễn viên',
          name: 'Jeremy James Kissner',
          original_name: 'Jeremy James Kissner',
          popularity: 0.6,
          profile_path: null,
          cast_id: 276,
          character: 'Kid',
          credit_id: '5cd6f2e092514106f6cec9a6',
          order: 75,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 491,
          known_for_department: 'Sound',
          name: 'John Williams',
          original_name: 'John Williams',
          popularity: 1.155,
          profile_path:
            'https://image.tmdb.org/t/p/w185/KFyMqUWeiBdP9tJcZyGWOqnrgK.jpg',
          credit_id: '52fe4263c3a36847f801a995',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 1,
          id: 2952,
          known_for_department: 'Production',
          name: 'Avy Kaufman',
          original_name: 'Avy Kaufman',
          popularity: 1.4,
          profile_path: null,
          credit_id: '52fe4263c3a36847f801a9a7',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 1719,
          known_for_department: 'Production',
          name: 'Jennifer Alessi',
          original_name: 'Jennifer Alessi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c5625290e0a2601d6d0a9c0',
          department: 'Production',
          job: 'Extras Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 488,
          known_for_department: 'Directing',
          name: 'Steven Spielberg',
          original_name: 'Steven Spielberg',
          popularity: 10.468,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tZxcg19YQ3e8fJ0pOs7hjlnmmr6.jpg',
          credit_id: '52fe4263c3a36847f801a977',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 488,
          known_for_department: 'Directing',
          name: 'Steven Spielberg',
          original_name: 'Steven Spielberg',
          popularity: 10.468,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tZxcg19YQ3e8fJ0pOs7hjlnmmr6.jpg',
          credit_id: '52fe4263c3a36847f801a96b',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 488,
          known_for_department: 'Directing',
          name: 'Steven Spielberg',
          original_name: 'Steven Spielberg',
          popularity: 10.468,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tZxcg19YQ3e8fJ0pOs7hjlnmmr6.jpg',
          credit_id: '52fe4263c3a36847f801a98f',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 489,
          known_for_department: 'Production',
          name: 'Kathleen Kennedy',
          original_name: 'Kathleen Kennedy',
          popularity: 1.154,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ndgYlie0PHkyqEiEBGM8SqrPOkr.jpg',
          credit_id: '52fe4263c3a36847f801a9f9',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 492,
          known_for_department: 'Camera',
          name: 'Janusz Kamiński',
          original_name: 'Janusz Kamiński',
          popularity: 0.989,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5yURZbwMmhiXXlvDmRdz4V14Ufs.jpg',
          credit_id: '52fe4263c3a36847f801a99b',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 493,
          known_for_department: 'Editing',
          name: 'Michael Kahn',
          original_name: 'Michael Kahn',
          popularity: 0.691,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jb4Y9q1q91VRQJue0VXhU7VcXce.jpg',
          credit_id: '52fe4263c3a36847f801a9a1',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 496,
          known_for_department: 'Art',
          name: 'Rick Carter',
          original_name: 'Rick Carter',
          popularity: 1.094,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5QlzL72Du5zVs1E27pQ0OlFLImI.jpg',
          credit_id: '52fe4263c3a36847f801a9ad',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 1,
          id: 555,
          known_for_department: 'Art',
          name: 'Nancy Haigh',
          original_name: 'Nancy Haigh',
          popularity: 1.025,
          profile_path: null,
          credit_id: '52fe4263c3a36847f801a9c5',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 1,
          id: 2210,
          known_for_department: 'Production',
          name: 'Bonnie Curtis',
          original_name: 'Bonnie Curtis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4263c3a36847f801a97d',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 2212,
          known_for_department: 'Production',
          name: 'Walter F. Parkes',
          original_name: 'Walter F. Parkes',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cagg6PtTt2Zvqut8DBmlO6uncKk.jpg',
          credit_id: '52fe4263c3a36847f801a989',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 2216,
          known_for_department: 'Sound',
          name: 'Gary Rydstrom',
          original_name: 'Gary Rydstrom',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1DoKaxoJlz6hV9bai43e07GxGQf.jpg',
          credit_id: '5492fe2fc3a3683cfa0013c5',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 2216,
          known_for_department: 'Sound',
          name: 'Gary Rydstrom',
          original_name: 'Gary Rydstrom',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1DoKaxoJlz6hV9bai43e07GxGQf.jpg',
          credit_id: '5492fe03c3a3683cfa0013c0',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 2530,
          known_for_department: 'Costume & Make-Up',
          name: 'Bob Ringwood',
          original_name: 'Bob Ringwood',
          popularity: 0.828,
          profile_path: null,
          credit_id: '52fe4263c3a36847f801a9cb',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 2,
          id: 3993,
          known_for_department: 'Visual Effects',
          name: 'Dennis Muren',
          original_name: 'Dennis Muren',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aRTo2aBGIQisn1q9b8LwdL8IcR8.jpg',
          credit_id: '5493ed80c3a3686af1001036',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 7236,
          known_for_department: 'Art',
          name: 'Andrew Menzies',
          original_name: 'Andrew Menzies',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5492bdf4c3a3683cf8001443',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 2,
          id: 5016,
          known_for_department: 'Production',
          name: 'Jan Harlan',
          original_name: 'Jan Harlan',
          popularity: 0.75,
          profile_path: null,
          credit_id: '52fe4263c3a36847f801a983',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 5338,
          known_for_department: 'Sound',
          name: 'Kyrsten Mate',
          original_name: 'Kyrsten Mate',
          popularity: 0.611,
          profile_path: null,
          credit_id: '564f20509251414af5003a21',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 7764,
          known_for_department: 'Sound',
          name: 'Richard Hymns',
          original_name: 'Richard Hymns',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5492fee8c3a3683d00001985',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 8160,
          known_for_department: 'Sound',
          name: 'Dennie Thorpe',
          original_name: 'Dennie Thorpe',
          popularity: 1.166,
          profile_path: null,
          credit_id: '5b1ef1d60e0a264fa700fa8e',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 8163,
          known_for_department: 'Sound',
          name: 'Jana Vance',
          original_name: 'Jana Vance',
          popularity: 0.667,
          profile_path: null,
          credit_id: '5b1ef1b19251416628010087',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 8164,
          known_for_department: 'Sound',
          name: 'Tony Eckert',
          original_name: 'Tony Eckert',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1ef1f70e0a264fbb0108f6',
          department: 'Sound',
          job: 'Foley Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 8285,
          known_for_department: 'Art',
          name: 'Richard L. Johnson',
          original_name: 'Richard L. Johnson',
          popularity: 0.997,
          profile_path: null,
          credit_id: '52fe4263c3a36847f801a9b3',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 8679,
          known_for_department: 'Art',
          name: 'William James Teegarden',
          original_name: 'William James Teegarden',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4263c3a36847f801a9b9',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 9264,
          known_for_department: 'Directing',
          name: 'Sergio Mimica-Gezzan',
          original_name: 'Sergio Mimica-Gezzan',
          popularity: 1.044,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5JSARSBOHvxkelxw8X6j4sRivoe.jpg',
          credit_id: '594cffa2925141310c02426b',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 2,
          id: 9635,
          known_for_department: 'Biên kịch',
          name: 'Brian Aldiss',
          original_name: 'Brian Aldiss',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tkrHtRYb2TqBHedzlnzXXpa9PcI.jpg',
          credit_id: '57e2714792514123f500439f',
          department: 'Biên kịch',
          job: 'Short Story',
        },
        {
          adult: false,
          gender: 0,
          id: 9636,
          known_for_department: 'Biên kịch',
          name: 'Ian Watson',
          original_name: 'Ian Watson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57e2715d92514118f7004d4a',
          department: 'Biên kịch',
          job: 'Screenstory',
        },
        {
          adult: false,
          gender: 2,
          id: 9639,
          known_for_department: 'Art',
          name: 'Thomas Valentine',
          original_name: 'Thomas Valentine',
          popularity: 1.539,
          profile_path: null,
          credit_id: '52fe4263c3a36847f801a9bf',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 1,
          id: 15893,
          known_for_department: 'Sound',
          name: 'Teresa Eckton',
          original_name: 'Teresa Eckton',
          popularity: 1.106,
          profile_path: null,
          credit_id: '5492ff11c3a3683d0000198d',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 15017,
          known_for_department: 'Costume & Make-Up',
          name: 'Bill Corso',
          original_name: 'Bill Corso',
          popularity: 0.884,
          profile_path: null,
          credit_id: '56abf0949251417e11003c48',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 14350,
          known_for_department: 'Art',
          name: 'Richard F. Mays',
          original_name: 'Richard F. Mays',
          popularity: 0.84,
          profile_path: null,
          credit_id: '5492bee092514109210013ce',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 19863,
          known_for_department: 'Art',
          name: 'Patrick M. Sullivan',
          original_name: 'Patrick M. Sullivan',
          popularity: 1.094,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pISNlAYTGeADQWm2Jp0LBDMtjUX.jpg',
          credit_id: '5492be3f92514163fe000903',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 0,
          id: 20846,
          known_for_department: 'Editing',
          name: 'Richard Byard',
          original_name: 'Richard Byard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f44e5892514176c500249a',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 42265,
          known_for_department: 'Production',
          name: 'Peter M. Tobyansen',
          original_name: 'Peter M. Tobyansen',
          popularity: 0.62,
          profile_path: null,
          credit_id: '56f44f599251413cfb00013c',
          department: 'Production',
          job: 'Production Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 34526,
          known_for_department: 'Art',
          name: 'Fred Arbegast',
          original_name: 'Fred Arbegast',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5492bf5792514118f20013e1',
          department: 'Art',
          job: 'Sculptor',
        },
        {
          adult: false,
          gender: 0,
          id: 60109,
          known_for_department: 'Production',
          name: 'Beth Bowling',
          original_name: 'Beth Bowling',
          popularity: 0.984,
          profile_path: null,
          credit_id: '594d0699c3a36832ca023778',
          department: 'Production',
          job: 'Casting Assistant',
        },
        {
          adult: false,
          gender: 2,
          id: 60261,
          known_for_department: 'Crew',
          name: 'Stan Winston',
          original_name: 'Stan Winston',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/k1L7O1pIQ1fveNnKBcLNICL2cIm.jpg',
          credit_id: '594cff469251413127023391',
          department: 'Crew',
          job: 'Animatronics Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 66142,
          known_for_department: 'Sound',
          name: 'Kenneth Wannberg',
          original_name: 'Kenneth Wannberg',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eaJSJFP5pf9EElU58DyPh8QoiRT.jpg',
          credit_id: '56f44fe79251411a850035ca',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 75380,
          known_for_department: 'Sound',
          name: 'Robert Jackson',
          original_name: 'Robert Jackson',
          popularity: 0.652,
          profile_path: null,
          credit_id: '56f44facc3a3682fd2003823',
          department: 'Sound',
          job: 'Boom Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 83071,
          known_for_department: 'Directing',
          name: 'David H. Venghaus Jr.',
          original_name: 'David H. Venghaus Jr.',
          popularity: 0.6,
          profile_path: null,
          credit_id: '594cffd0925141310c024298',
          department: 'Directing',
          job: 'Second Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 91144,
          known_for_department: 'Sound',
          name: 'Shawn Murphy',
          original_name: 'Shawn Murphy',
          popularity: 1.96,
          profile_path: null,
          credit_id: '56f450189251410e64001258',
          department: 'Sound',
          job: 'Scoring Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 91146,
          known_for_department: 'Sound',
          name: 'John Neufeld',
          original_name: 'John Neufeld',
          popularity: 0.694,
          profile_path: null,
          credit_id: '56f45000925141769e00259e',
          department: 'Sound',
          job: 'Orchestrator',
        },
        {
          adult: false,
          gender: 2,
          id: 93258,
          known_for_department: 'Visual Effects',
          name: 'Michael Lantieri',
          original_name: 'Michael Lantieri',
          popularity: 0.694,
          profile_path: null,
          credit_id: '56f450999251411a8b003424',
          department: 'Visual Effects',
          job: 'Special Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 109994,
          known_for_department: 'Production',
          name: 'Gregory Alpert',
          original_name: 'Gregory Alpert',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5493efd6c3a3686af3000dc1',
          department: 'Production',
          job: 'Location Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 109245,
          known_for_department: 'Crew',
          name: 'John Wright Jr.',
          original_name: 'John Wright Jr.',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f44b8c9251411a97003677',
          department: 'Crew',
          job: 'Craft Service',
        },
        {
          adult: false,
          gender: 1,
          id: 128103,
          known_for_department: 'Production',
          name: 'Patricia Churchill',
          original_name: 'Patricia Churchill',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f44d9dc3a3682fcf0038e8',
          department: 'Production',
          job: 'Unit Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 138617,
          known_for_department: 'Sound',
          name: 'Jonathan Null',
          original_name: 'Jonathan Null',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5b1ef2090e0a264fbf01088a',
          department: 'Sound',
          job: 'Foley Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 142157,
          known_for_department: 'Crew',
          name: 'Doug Coleman',
          original_name: 'Doug Coleman',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/temeKPrQ9VosJXwb51O3EWxQ5yO.jpg',
          credit_id: '5493ee54c3a3686aed000f20',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 151007,
          known_for_department: 'Directing',
          name: 'Peter Ramsey',
          original_name: 'Peter Ramsey',
          popularity: 0.842,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9vCpMCgf5R0EQkWbylKTvtxzsB.jpg',
          credit_id: '5c5622abc3a3687199828f9d',
          department: 'Art',
          job: 'Storyboard Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 162532,
          known_for_department: 'Art',
          name: 'Steven Schwartz',
          original_name: 'Steven Schwartz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5492beb4c3a3683d000013e4',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 202711,
          known_for_department: 'Diễn viên',
          name: 'Bob Anderson',
          original_name: 'Bob Anderson',
          popularity: 0.728,
          profile_path:
            'https://image.tmdb.org/t/p/w185/67IDY3Jz1Oiu97DYokoQB46tL7x.jpg',
          credit_id: '594bcae1c3a36832ad01130c',
          department: 'Camera',
          job: 'Grip',
        },
        {
          adult: false,
          gender: 2,
          id: 210110,
          known_for_department: 'Directing',
          name: 'Chris Cunningham',
          original_name: 'Chris Cunningham',
          popularity: 0.606,
          profile_path: null,
          credit_id: '52fe4263c3a36847f801a9ff',
          department: 'Crew',
          job: 'Special Effects',
        },
        {
          adult: false,
          gender: 1,
          id: 406204,
          known_for_department: 'Costume & Make-Up',
          name: 'Ve Neill',
          original_name: 'Ve Neill',
          popularity: 1.027,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gNYwxuK5Z7Nr3tWtSWv0qAueUIs.jpg',
          credit_id: '594cfeafc3a36832ad022f57',
          department: 'Costume & Make-Up',
          job: 'Key Makeup Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 930028,
          known_for_department: 'Camera',
          name: 'Christopher Duskin',
          original_name: 'Christopher Duskin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c56244792514116fc571cfe',
          department: 'Camera',
          job: 'Second Assistant Camera',
        },
        {
          adult: false,
          gender: 1,
          id: 936669,
          known_for_department: 'Diễn viên',
          name: 'Latifa Ouaou',
          original_name: 'Latifa Ouaou',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tqH1mKrJoVGcMmlCQpw4vnjyLjE.jpg',
          credit_id: '5492be27925141091300138c',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 1,
          id: 963355,
          known_for_department: 'Art',
          name: 'Suzan Wexler',
          original_name: 'Suzan Wexler',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5492be57925141091800143b',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1095994,
          known_for_department: 'Sound',
          name: 'Ron Judkins',
          original_name: 'Ron Judkins',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f45045c3a3682fd800389c',
          department: 'Sound',
          job: 'Sound Mixer',
        },
        {
          adult: false,
          gender: 1,
          id: 1108501,
          known_for_department: 'Editing',
          name: 'Jennifer Leo Russ',
          original_name: 'Jennifer Leo Russ',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5493eda29251416e24000e81',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1171098,
          known_for_department: 'Art',
          name: 'Darrell L. Wight',
          original_name: 'Darrell L. Wight',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5492be8bc3a3683d0d001571',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1271735,
          known_for_department: 'Art',
          name: 'Harry E. Otto',
          original_name: 'Harry E. Otto',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5492be06c3a3683d0d00155d',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1319750,
          known_for_department: 'Art',
          name: 'Thomas Minton',
          original_name: 'Thomas Minton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5492beca92514109210013c6',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1321004,
          known_for_department: 'Costume & Make-Up',
          name: 'David Rawley',
          original_name: 'David Rawley',
          popularity: 0.98,
          profile_path: null,
          credit_id: '539973b10e0a263e41001852',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1325650,
          known_for_department: 'Art',
          name: 'Elizabeth Lapp',
          original_name: 'Elizabeth Lapp',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5492bde0c3a368606800092b',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1327842,
          known_for_department: 'Editing',
          name: 'Michael Trent',
          original_name: 'Michael Trent',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5823d75bc3a3684bfb001659',
          department: 'Editing',
          job: 'Assistant Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1338976,
          known_for_department: 'Sound',
          name: 'Andy Nelson',
          original_name: 'Andy Nelson',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rsezSNhDdoKgM99MZYyUX8V35S0.jpg',
          credit_id: '5492ffaac3a3683d0d001b79',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 1,
          id: 1339432,
          known_for_department: 'Crew',
          name: 'Erica Frauman',
          original_name: 'Erica Frauman',
          popularity: 1.614,
          profile_path: null,
          credit_id: '5492bd50c3a3683d0d00154c',
          department: 'Crew',
          job: 'Post Production Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1341850,
          known_for_department: 'Art',
          name: 'Pamela Klamer',
          original_name: 'Pamela Klamer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5492bfc1c3a3683cfe001692',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 1341865,
          known_for_department: 'Directing',
          name: 'Ana Maria Quintana',
          original_name: 'Ana Maria Quintana',
          popularity: 0.832,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qRZk7M0pZ9JmcXVGPYGtDPjmk6R.jpg',
          credit_id: '56f44e15925141769e002570',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1357070,
          known_for_department: 'Crew',
          name: 'Denny Caira',
          original_name: 'Denny Caira',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5493efb8c3a3686ae9000e03',
          department: 'Crew',
          job: 'Transportation Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1370953,
          known_for_department: 'Crew',
          name: 'J. Mark Donaldson',
          original_name: 'J. Mark Donaldson',
          popularity: 1.159,
          profile_path: null,
          credit_id: '5c5623c10e0a26494de0adac',
          department: 'Crew',
          job: 'Stunt Double',
        },
        {
          adult: false,
          gender: 0,
          id: 1376897,
          known_for_department: 'Art',
          name: 'John Villarino',
          original_name: 'John Villarino',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5492bffcc3a3683cf800147a',
          department: 'Art',
          job: 'Construction Coordinator',
        },
        {
          adult: false,
          gender: 1,
          id: 1376902,
          known_for_department: 'Sound',
          name: 'Gwendolyn Yates Whittle',
          original_name: 'Gwendolyn Yates Whittle',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5b1ef0b1c3a36808ac010597',
          department: 'Sound',
          job: 'ADR Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1378236,
          known_for_department: 'Visual Effects',
          name: 'Scott Farrar',
          original_name: 'Scott Farrar',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sWAog1QxHwk51Oe84tBKYW3rN75.jpg',
          credit_id: '5493ecdac3a3686ae9000db8',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1378726,
          known_for_department: 'Crew',
          name: 'Francie Brown',
          original_name: 'Francie Brown',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f44ba0925141769e00251f',
          department: 'Crew',
          job: 'Dialect Coach',
        },
        {
          adult: false,
          gender: 1,
          id: 1378825,
          known_for_department: 'Art',
          name: 'Dawn Brown',
          original_name: 'Dawn Brown',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5492bf1ac3a3683d000013ef',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1389139,
          known_for_department: 'Camera',
          name: 'David James',
          original_name: 'David James',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f44af09251411a8b003375',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 2,
          id: 1389534,
          known_for_department: 'Sound',
          name: 'Richard Quinn',
          original_name: 'Richard Quinn',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5b1ef09e925141662800fff6',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1389540,
          known_for_department: 'Lighting',
          name: 'David Devlin',
          original_name: 'David Devlin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '594d0631925141311f024649',
          department: 'Lighting',
          job: 'Chief Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 1390534,
          known_for_department: 'Visual Effects',
          name: 'Les Hunter',
          original_name: 'Les Hunter',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5493ee1c9251416e2b000ef9',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1392116,
          known_for_department: 'Art',
          name: 'Masako Masuda',
          original_name: 'Masako Masuda',
          popularity: 1.22,
          profile_path: null,
          credit_id: '5492bef2925141091e00146a',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1395463,
          known_for_department: 'Camera',
          name: 'Mitch Dubin',
          original_name: 'Mitch Dubin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5493eea79251416e1800103b',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 1398972,
          known_for_department: 'Camera',
          name: 'Pete Romano',
          original_name: 'Pete Romano',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5493eef5c3a3686aed000f40',
          department: 'Camera',
          job: 'Underwater Camera',
        },
        {
          adult: false,
          gender: 1,
          id: 1400065,
          known_for_department: 'Art',
          name: 'Patte Strong-Lord',
          original_name: 'Patte Strong-Lord',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5492bea0c3a3683d0700143f',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1400847,
          known_for_department: 'Costume & Make-Up',
          name: 'Candace Neal',
          original_name: 'Candace Neal',
          popularity: 0.98,
          profile_path: null,
          credit_id: '56f44b3892514176c5002447',
          department: 'Costume & Make-Up',
          job: 'Key Hair Stylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1400848,
          known_for_department: 'Art',
          name: 'Anya Rudnick',
          original_name: 'Anya Rudnick',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5492bd8c92514118f20013c0',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1400849,
          known_for_department: 'Art',
          name: 'Jerry Moss',
          original_name: 'Jerry Moss',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1ef0d4c3a368089f010289',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 1400852,
          known_for_department: 'Art',
          name: 'James Jones',
          original_name: 'James Jones',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5492bf8992514109130013af',
          department: 'Art',
          job: 'Sculptor',
        },
        {
          adult: false,
          gender: 0,
          id: 1400853,
          known_for_department: 'Art',
          name: 'Mike Villarino',
          original_name: 'Mike Villarino',
          popularity: 0.608,
          profile_path: null,
          credit_id: '5492c013c3a3683cfa001002',
          department: 'Art',
          job: 'Construction Foreman',
        },
        {
          adult: false,
          gender: 0,
          id: 1400854,
          known_for_department: 'Art',
          name: "Vincent D'Aquino",
          original_name: "Vincent D'Aquino",
          popularity: 0.6,
          profile_path: null,
          credit_id: '5492c04dc3a368606800096a',
          department: 'Art',
          job: 'Greensman',
        },
        {
          adult: false,
          gender: 0,
          id: 1400855,
          known_for_department: 'Art',
          name: 'Alex Sessing',
          original_name: 'Alex Sessing',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5492c06892514109210013f1',
          department: 'Art',
          job: 'Greensman',
        },
        {
          adult: false,
          gender: 0,
          id: 1400856,
          known_for_department: 'Art',
          name: 'Johnny Torres',
          original_name: 'Johnny Torres',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5492c07cc3a3683d00001412',
          department: 'Art',
          job: 'Greensman',
        },
        {
          adult: false,
          gender: 0,
          id: 1400857,
          known_for_department: 'Art',
          name: 'Jason Vanover',
          original_name: 'Jason Vanover',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5492c08e92514118f20013ff',
          department: 'Art',
          job: 'Greensman',
        },
        {
          adult: false,
          gender: 1,
          id: 1400905,
          known_for_department: 'Sound',
          name: 'Ewa Sztompke',
          original_name: 'Ewa Sztompke',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b1ef08792514166ab0126de',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1400906,
          known_for_department: 'Sound',
          name: 'Christopher Scarabosio',
          original_name: 'Christopher Scarabosio',
          popularity: 0.771,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9lOLuw52TKHXbzOzzlOsTYS3UEu.jpg',
          credit_id: '549300f7c3a3683d000019dc',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1401105,
          known_for_department: 'Crew',
          name: 'Michael Gleason',
          original_name: 'Michael Gleason',
          popularity: 0.708,
          profile_path: null,
          credit_id: '5493ed409251416e2b000ee5',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1401106,
          known_for_department: 'Visual Effects',
          name: 'Henry LaBounta',
          original_name: 'Henry LaBounta',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5493ed63c3a3686aed000efd',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1401107,
          known_for_department: 'Visual Effects',
          name: 'Ginger Theisen',
          original_name: 'Ginger Theisen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5493edd5c3a3686ae9000dc6',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1401108,
          known_for_department: 'Crew',
          name: 'David Nakabayashi',
          original_name: 'David Nakabayashi',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5493edf89251416e1800101c',
          department: 'Crew',
          job: 'Visual Effects Art Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1401109,
          known_for_department: 'Camera',
          name: 'Chris Haarhoff',
          original_name: 'Chris Haarhoff',
          popularity: 1.008,
          profile_path:
            'https://image.tmdb.org/t/p/w185/s8rWd96a0I2IPKOjESrHtaZyQ8U.jpg',
          credit_id: '5493ef559251411e5e000bde',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 1401109,
          known_for_department: 'Camera',
          name: 'Chris Haarhoff',
          original_name: 'Chris Haarhoff',
          popularity: 1.008,
          profile_path:
            'https://image.tmdb.org/t/p/w185/s8rWd96a0I2IPKOjESrHtaZyQ8U.jpg',
          credit_id: '5493eec49251416e22000e34',
          department: 'Camera',
          job: 'Steadicam Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 1401117,
          known_for_department: 'Crew',
          name: 'David Linck',
          original_name: 'David Linck',
          popularity: 1.082,
          profile_path: null,
          credit_id: '556a3359c3a36876bd001f5a',
          department: 'Production',
          job: 'Publicist',
        },
        {
          adult: false,
          gender: 0,
          id: 1401118,
          known_for_department: 'Crew',
          name: 'Francesca Jaynes',
          original_name: 'Francesca Jaynes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5493f0309251416e18001071',
          department: 'Crew',
          job: 'Choreographer',
        },
        {
          adult: false,
          gender: 2,
          id: 1405241,
          known_for_department: 'Camera',
          name: 'Adam Dale',
          original_name: 'Adam Dale',
          popularity: 0.6,
          profile_path: null,
          credit_id: '594bc85fc3a3683265012c24',
          department: 'Camera',
          job: 'Aerial Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 1414996,
          known_for_department: 'Art',
          name: 'Jack Blanchard',
          original_name: 'Jack Blanchard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '594bc803c3a368328b010003',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 1425320,
          known_for_department: 'Production',
          name: 'Tomáš Loewy',
          original_name: 'Tomáš Loewy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f44dc7c3a3682fe0003828',
          department: 'Crew',
          job: 'Video Assist Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 1426773,
          known_for_department: 'Visual Effects',
          name: 'Hal T. Hickel',
          original_name: 'Hal T. Hickel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f45071c3a3682fcf00392c',
          department: 'Visual Effects',
          job: 'Animation Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1429549,
          known_for_department: 'Editing',
          name: 'Dale E. Grahn',
          original_name: 'Dale E. Grahn',
          popularity: 1.635,
          profile_path: null,
          credit_id: '56f44e3ac3a3682fcf0038fa',
          department: 'Editing',
          job: 'Color Timer',
        },
        {
          adult: false,
          gender: 0,
          id: 1435586,
          known_for_department: 'Crew',
          name: 'Eric Bruneau',
          original_name: 'Eric Bruneau',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c5624f8c3a368302883e5e4',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1438398,
          known_for_department: 'Sound',
          name: 'Larry Schalit',
          original_name: 'Larry Schalit',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c56233392514135b04e7ee7',
          department: 'Sound',
          job: 'Assistant Dialogue Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1449172,
          known_for_department: 'Sound',
          name: 'Lindakay Brown',
          original_name: 'Lindakay Brown',
          popularity: 0.6,
          profile_path: null,
          credit_id: '594d06fec3a368328b020e4b',
          department: 'Sound',
          job: 'Foley Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1450333,
          known_for_department: 'Production',
          name: 'John Burton West',
          original_name: 'John Burton West',
          popularity: 0.98,
          profile_path: null,
          credit_id: '594d067b925141314b023b47',
          department: 'Production',
          job: 'Assistant Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1456474,
          known_for_department: 'Sound',
          name: 'Larry Singer',
          original_name: 'Larry Singer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '594d06d7c3a36832ca0237a8',
          department: 'Sound',
          job: 'ADR Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1463323,
          known_for_department: 'Art',
          name: 'Philip Keller',
          original_name: 'Philip Keller',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f450c89251411a97003702',
          department: 'Biên kịch',
          job: 'Storyboard',
        },
        {
          adult: false,
          gender: 0,
          id: 1531566,
          known_for_department: 'Crew',
          name: 'Jeff Khachadoorian',
          original_name: 'Jeff Khachadoorian',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f44b71c3a3682fdd003816',
          department: 'Crew',
          job: 'Carpenter',
        },
        {
          adult: false,
          gender: 0,
          id: 1533752,
          known_for_department: 'Editing',
          name: 'Begonia Colomar',
          original_name: 'Begonia Colomar',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c5624730e0a263ccde20879',
          department: 'Editing',
          job: 'Digital Color Timer',
        },
        {
          adult: false,
          gender: 0,
          id: 1550636,
          known_for_department: 'Costume & Make-Up',
          name: 'Karen Asano-Myers',
          original_name: 'Karen Asano-Myers',
          popularity: 0.608,
          profile_path: null,
          credit_id: '56f44b1ec3a3682fd80037ed',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 2,
          id: 1561360,
          known_for_department: 'Sound',
          name: 'Brian Chumney',
          original_name: 'Brian Chumney',
          popularity: 0.753,
          profile_path: null,
          credit_id: '56f450f29251411a9700370d',
          department: 'Editing',
          job: 'Editorial Services',
        },
        {
          adult: false,
          gender: 0,
          id: 1570740,
          known_for_department: 'Camera',
          name: 'Jim Kwiatkowski',
          original_name: 'Jim Kwiatkowski',
          popularity: 0.6,
          profile_path: null,
          credit_id: '594bcaa0c3a368329b012dfa',
          department: 'Camera',
          job: 'Key Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1573468,
          known_for_department: 'Visual Effects',
          name: 'Ken Dackermann',
          original_name: 'Ken Dackermann',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f450849251411a94003379',
          department: 'Visual Effects',
          job: 'Digital Compositors',
        },
        {
          adult: false,
          gender: 0,
          id: 1586079,
          known_for_department: 'Costume & Make-Up',
          name: 'Robert Chase',
          original_name: 'Robert Chase',
          popularity: 0.6,
          profile_path: null,
          credit_id: '594bcb4bc3a368329b012ea4',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1594967,
          known_for_department: 'Sound',
          name: 'Dean Drabin',
          original_name: 'Dean Drabin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c5622ebc3a368729087bae1',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1595459,
          known_for_department: 'Art',
          name: 'Kirk D. Hansen',
          original_name: 'Kirk D. Hansen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f449cec3a3682fdb0033b7',
          department: 'Art',
          job: 'Painter',
        },
        {
          adult: false,
          gender: 0,
          id: 1595460,
          known_for_department: 'Art',
          name: 'John Bell',
          original_name: 'John Bell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f44a1b9251413cfb0000af',
          department: 'Art',
          job: 'Production Illustrator',
        },
        {
          adult: false,
          gender: 0,
          id: 1595461,
          known_for_department: 'Art',
          name: 'Tony Leonardi',
          original_name: 'Tony Leonardi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f44a36c3a3682fd2003793',
          department: 'Art',
          job: 'Standby Painter',
        },
        {
          adult: false,
          gender: 0,
          id: 1595462,
          known_for_department: 'Camera',
          name: 'Mike Bienstock',
          original_name: 'Mike Bienstock',
          popularity: 1.008,
          profile_path: null,
          credit_id: '56f44a5d925141769e002503',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1595467,
          known_for_department: 'Crew',
          name: 'George Alden',
          original_name: 'George Alden',
          popularity: 1.38,
          profile_path: null,
          credit_id: '56f44bb3c3a3682fd8003807',
          department: 'Crew',
          job: 'Driver',
        },
        {
          adult: false,
          gender: 0,
          id: 1595468,
          known_for_department: 'Camera',
          name: "David O'Brien",
          original_name: "David O'Brien",
          popularity: 0.6,
          profile_path: null,
          credit_id: '594bc8cbc3a3683279011452',
          department: 'Camera',
          job: 'Camera Loader',
        },
        {
          adult: false,
          gender: 0,
          id: 1595469,
          known_for_department: 'Crew',
          name: 'Adam Christopher',
          original_name: 'Adam Christopher',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f44c92c3a3682fe600387e',
          department: 'Crew',
          job: 'Makeup Effects',
        },
        {
          adult: false,
          gender: 2,
          id: 1595470,
          known_for_department: 'Sound',
          name: 'Jurgen Scharpf',
          original_name: 'Jurgen Scharpf',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5ba176f5c3a3680c390085d3',
          department: 'Sound',
          job: 'Sound Mix Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 1595471,
          known_for_department: 'Crew',
          name: 'Mark Gillard',
          original_name: 'Mark Gillard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f44cdbc3a3682fcf0038c5',
          department: 'Crew',
          job: 'Post Production Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 1595472,
          known_for_department: 'Crew',
          name: 'René González',
          original_name: 'René González',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f44cf09251411a8500355f',
          department: 'Crew',
          job: 'Projection',
        },
        {
          adult: false,
          gender: 0,
          id: 1595473,
          known_for_department: 'Art',
          name: 'Brian Feola',
          original_name: 'Brian Feola',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f44d02c3a3682fd800382f',
          department: 'Crew',
          job: 'Propmaker',
        },
        {
          adult: false,
          gender: 2,
          id: 1595474,
          known_for_department: 'Visual Effects',
          name: 'Tom Martinek',
          original_name: 'Tom Martinek',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bIMrbDewD4n4tK2LISCVKeabzHG.jpg',
          credit_id: '56f44d269251413cfb0000fe',
          department: 'Crew',
          job: 'Sequence Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1595475,
          known_for_department: 'Crew',
          name: 'Scott Rorie',
          original_name: 'Scott Rorie',
          popularity: 1.128,
          profile_path: null,
          credit_id: '56f44d4bc3a3682fd800383f',
          department: 'Crew',
          job: 'Set Production Assistant',
        },
        {
          adult: false,
          gender: 2,
          id: 1595476,
          known_for_department: 'Crew',
          name: 'James Henderson',
          original_name: 'James Henderson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f44d60c3a3682fd20037d9',
          department: 'Crew',
          job: 'Stand In',
        },
        {
          adult: false,
          gender: 0,
          id: 1595477,
          known_for_department: 'Crew',
          name: 'Richard L. Blackwell',
          original_name: 'Richard L. Blackwell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f44d739251411a9400331c',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 1,
          id: 1595478,
          known_for_department: 'Crew',
          name: 'Dana Dru Evenson',
          original_name: 'Dana Dru Evenson',
          popularity: 0.94,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jPOA5LdCAEqUOIx9cmnmd7koLAW.jpg',
          credit_id: '56f44db49251411a8b0033cb',
          department: 'Crew',
          job: 'Utility Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1595479,
          known_for_department: 'Visual Effects',
          name: 'Jason Patnode',
          original_name: 'Jason Patnode',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f44e069251411a8500358a',
          department: 'Directing',
          job: 'Layout',
        },
        {
          adult: false,
          gender: 0,
          id: 1595482,
          known_for_department: 'Lighting',
          name: 'Scot Gaal',
          original_name: 'Scot Gaal',
          popularity: 0.98,
          profile_path: null,
          credit_id: '56f44e7e9251411a9400333d',
          department: 'Lighting',
          job: 'Best Boy Electric',
        },
        {
          adult: false,
          gender: 0,
          id: 1595483,
          known_for_department: 'Lighting',
          name: 'John Atkins',
          original_name: 'John Atkins',
          popularity: 0.694,
          profile_path: null,
          credit_id: '56f44eaa9251410e6400122f',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 1595484,
          known_for_department: 'Lighting',
          name: 'Glenn Corbett',
          original_name: 'Glenn Corbett',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f44ed79251411a9400334d',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 2,
          id: 1595485,
          known_for_department: 'Lighting',
          name: 'Marek Bojsza',
          original_name: 'Marek Bojsza',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f44eea9251411a850035ab',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 1595486,
          known_for_department: 'Lighting',
          name: 'David Gamerman',
          original_name: 'David Gamerman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f44efa9251411a94003358',
          department: 'Lighting',
          job: 'Rigging Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1595487,
          known_for_department: 'Lighting',
          name: 'Kevin Fahey',
          original_name: 'Kevin Fahey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f44f10c3a3682fe000385b',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1595488,
          known_for_department: 'Production',
          name: 'Laurie Charchut',
          original_name: 'Laurie Charchut',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f44f2fc3a3682fdd00388d',
          department: 'Production',
          job: 'Production Accountant',
        },
        {
          adult: false,
          gender: 1,
          id: 1595489,
          known_for_department: 'Production',
          name: 'Lisbeth Wynn-Owen',
          original_name: 'Lisbeth Wynn-Owen',
          popularity: 0.98,
          profile_path: null,
          credit_id: '56f44f47925141769e00258f',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1595491,
          known_for_department: 'Visual Effects',
          name: 'Duncan Blackman',
          original_name: 'Duncan Blackman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f4505ec3a3682fdb00347a',
          department: 'Visual Effects',
          job: '3D Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1595492,
          known_for_department: 'Visual Effects',
          name: 'Julie Creighton',
          original_name: 'Julie Creighton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56f450b392514176c50024c9',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1640918,
          known_for_department: 'Sound',
          name: "Frank 'Pepe' Merel",
          original_name: "Frank 'Pepe' Merel",
          popularity: 0.838,
          profile_path: null,
          credit_id: '5b1ef1e69251416618010dd9',
          department: 'Sound',
          job: 'Foley Recordist',
        },
        {
          adult: false,
          gender: 0,
          id: 1705810,
          known_for_department: 'Costume & Make-Up',
          name: 'Kathy Kane-Macgowan',
          original_name: 'Kathy Kane-Macgowan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '594bcb329251413115011e6b',
          department: 'Costume & Make-Up',
          job: 'Hair Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1733142,
          known_for_department: 'Editing',
          name: 'Gary Burritt',
          original_name: 'Gary Burritt',
          popularity: 0.704,
          profile_path: null,
          credit_id: '594d000dc3a36832790233cb',
          department: 'Editing',
          job: 'Negative Cutter',
        },
        {
          adult: false,
          gender: 2,
          id: 1741194,
          known_for_department: 'Sound',
          name: 'James Thatcher',
          original_name: 'James Thatcher',
          popularity: 0.6,
          profile_path: null,
          credit_id: '594d071b92514131150247e8',
          department: 'Sound',
          job: 'Musician',
        },
        {
          adult: false,
          gender: 2,
          id: 1757345,
          known_for_department: 'Art',
          name: 'Chris Baker',
          original_name: 'Chris Baker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c56226b0e0a26495ae26b4d',
          department: 'Art',
          job: 'Concept Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1776549,
          known_for_department: 'Art',
          name: 'Jimmy Zelinger',
          original_name: 'Jimmy Zelinger',
          popularity: 0.6,
          profile_path: null,
          credit_id: '594bc83cc3a3683265012c0e',
          department: 'Art',
          job: 'Title Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 1803767,
          known_for_department: 'Camera',
          name: 'Larissa Supplitt',
          original_name: 'Larissa Supplitt',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5c56240a92514135b04e8008',
          department: 'Camera',
          job: 'Additional Second Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1837365,
          known_for_department: 'Art',
          name: 'Mark W. Brown',
          original_name: 'Mark W. Brown',
          popularity: 1.094,
          profile_path: null,
          credit_id: '594bc7d7c3a368329b012b8e',
          department: 'Art',
          job: 'Assistant Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 1837424,
          known_for_department: 'Camera',
          name: 'Rick Kangrga',
          original_name: 'Rick Kangrga',
          popularity: 0.6,
          profile_path: null,
          credit_id: '594bc8e3925141310c011b12',
          department: 'Camera',
          job: 'Dolly Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1837822,
          known_for_department: 'Costume & Make-Up',
          name: 'Vicente Aguilar',
          original_name: 'Vicente Aguilar',
          popularity: 0.6,
          profile_path: null,
          credit_id: '594cff0b9251413111023b52',
          department: 'Costume & Make-Up',
          job: 'Tailor',
        },
        {
          adult: false,
          gender: 0,
          id: 1941584,
          known_for_department: 'Production',
          name: 'Cecilia Escobar',
          original_name: 'Cecilia Escobar',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c56255792514157df4eea8c',
          department: 'Production',
          job: 'Payroll Accountant',
        },
        {
          adult: false,
          gender: 0,
          id: 2080021,
          known_for_department: 'Art',
          name: 'Martin Charles',
          original_name: 'Martin Charles',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c5622909251410e24688a47',
          department: 'Art',
          job: 'Graphic Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2153812,
          known_for_department: 'Directing',
          name: 'Paul Byrne Prenderville',
          original_name: 'Paul Byrne Prenderville',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c5621ee0e0a26031bc74fdc',
          department: 'Directing',
          job: 'Additional Second Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2157039,
          known_for_department: 'Production',
          name: 'Sven E. Fahlgren',
          original_name: 'Sven E. Fahlgren',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c56248c0e0a2601d6d0a859',
          department: 'Production',
          job: 'Post Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2215654,
          known_for_department: 'Art',
          name: 'Niamh Murphy',
          original_name: 'Niamh Murphy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c5622d492514135b04e7e1a',
          department: 'Art',
          job: 'Textile Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2215661,
          known_for_department: 'Visual Effects',
          name: 'Lindsay MacGowan',
          original_name: 'Lindsay MacGowan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c5625119251410e1d4ea12b',
          department: 'Visual Effects',
          job: 'Effects Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 2233154,
          known_for_department: 'Production',
          name: 'Lisa Curtis',
          original_name: 'Lisa Curtis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c56257ec3a368302883e62d',
          department: 'Production',
          job: 'Production Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2233247,
          known_for_department: 'Costume & Make-Up',
          name: 'Ricardo Richard Alvarez',
          original_name: 'Ricardo Richard Alvarez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c5621d20e0a263ccde203c5',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2233248,
          known_for_department: 'Directing',
          name: 'Lisa Brookes',
          original_name: 'Lisa Brookes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c562205c3a36826a6832f3f',
          department: 'Directing',
          job: 'Second Second Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2233252,
          known_for_department: 'Sound',
          name: 'John Merton',
          original_name: 'John Merton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c56231cc3a3680b57861753',
          department: 'Sound',
          job: 'ADR Recordist',
        },
        {
          adult: false,
          gender: 0,
          id: 2233253,
          known_for_department: 'Sound',
          name: 'Susan McLean',
          original_name: 'Susan McLean',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c56234cc3a368302883e41b',
          department: 'Sound',
          job: 'Assistant Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2233254,
          known_for_department: 'Crew',
          name: 'Thomas Brown',
          original_name: 'Thomas Brown',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c56237fc3a36805e88344d9',
          department: 'Crew',
          job: 'Special Effects Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2233255,
          known_for_department: 'Visual Effects',
          name: 'Evan Cecil',
          original_name: 'Evan Cecil',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c562399c3a368302883e475',
          department: 'Visual Effects',
          job: 'Visual Effects Production Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2233258,
          known_for_department: 'Camera',
          name: 'Daniel Coscia',
          original_name: 'Daniel Coscia',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c5624309251410e1d4ea03d',
          department: 'Camera',
          job: 'Best Boy Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2233261,
          known_for_department: 'Production',
          name: 'Tim Spurry',
          original_name: 'Tim Spurry',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c5624a50e0a263ccde208aa',
          department: 'Production',
          job: 'Assistant Location Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 2233263,
          known_for_department: 'Production',
          name: 'Linden Johnson',
          original_name: 'Linden Johnson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c5624ca92514135b04e80f2',
          department: 'Production',
          job: 'Assistant Accountant',
        },
        {
          adult: false,
          gender: 0,
          id: 2233265,
          known_for_department: 'Lighting',
          name: 'Stanley L. Gonsales',
          original_name: 'Stanley L. Gonsales',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c5624dd0e0a2601d6d0a924',
          department: 'Lighting',
          job: 'Assistant Chief Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2233267,
          known_for_department: 'Crew',
          name: 'Jorge Pallares',
          original_name: 'Jorge Pallares',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c562540c3a368478c9f82d2',
          department: 'Crew',
          job: 'Intern',
        },
        {
          adult: false,
          gender: 0,
          id: 2233268,
          known_for_department: 'Production',
          name: 'Chas Dupuis',
          original_name: 'Chas Dupuis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c56256fc3a36805e8834714',
          department: 'Production',
          job: 'Production Assistant',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'Peter McGinn',
          author_details: {
            name: 'Peter McGinn',
            username: 'narrator56',
            avatar_path: '/tVbrLJzA2RwRlE7dJLJG54UsAkq.jpg',
            rating: 6.0,
          },
          content:
            'I bought this on DVD many years ago, convinced I had never seen it. I finally got around to watching it, and it wasn’t until I reached the robot demolition circus (words I bet I have never seen in the same sentence before) that I realized I had watched this movie before. That is a memorable sequence.\r\n\r\nIn many respects I thought the movie was well made: the special effects, the deep thinking behind the plot, and the Biên kịch was mostly good. It almost felt like it was covering too much ground, and I felt there were a few lapses. I will mention only one, and try not to give anything away. There is a pivotal scene where John Hurt’s character is with the AI child David. It took a lot of effort to get David there, so what does the guy do/ he leaves David alone and unchaperoned. And the end of the movie turns on that. Why would he wander off like that except to serve the plot?\r\n\r\nStill, the film, mirroring and projecting the story of Pinocchio into the future, was quite an achievement. I liked it, but not as much as a lot of other Spielberg efforts.',
          created_at: '2021-05-08T01:23:27.007Z',
          id: '6095e80f896b8f003c24bd2f',
          updated_at: '2021-06-23T15:58:55.498Z',
          url: 'https://www.themoviedb.org/review/6095e80f896b8f003c24bd2f',
        },
      ],
      total_pages: 1,
      total_results: 1,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/2LmpNG02E92t2830kWm4XlJJiQL.jpg',
    belongs_to_collection: null,
    budget: 100000000,
    genres: [
      { id: 10752, name: 'Phim Chiến Tranh' },
      { id: 36, name: 'Phim Lịch Sử' },
      { id: 28, name: 'Phim Hành Động' },
      { id: 18, name: 'Phim Chính Kịch' },
    ],
    homepage: 'https://midway.movie',
    id: 522162,
    imdb_id: 'tt6924650',
    original_language: 'en',
    original_title: 'Midway',
    overview:
      'Bộ phim xoay quanh trận đánh tại đảo Midway 6 tháng sau trận Trân Châu Cảng. Nhờ vào đội ngũ mã thám Hải quân Hoa Kỳ chỉ trong một ngày gần như xóa sổ hạm đội Hải quân Nhật qua đó xoay chuyển gần như hoàn toàn cục diện chiến tranh ở Thái Bình Dương.',
    popularity: 35.079,
    poster_path:
      'https://image.tmdb.org/t/p/w342/aLGdRhkAuZpoHhqEUWAA0wrWBHM.jpg',
    production_companies: [
      {
        id: 110799,
        logo_path: '/eHjtiQJjrGQTooEsBmPSYoUnNB.png',
        name: 'AGC Studios',
        origin_country: 'US',
      },
      {
        id: 347,
        logo_path: null,
        name: 'Centropolis Entertainment',
        origin_country: '',
      },
      {
        id: 105986,
        logo_path: null,
        name: 'Entertainment One',
        origin_country: '',
      },
      {
        id: 128493,
        logo_path: null,
        name: 'Starlight Culture Entertainment Group',
        origin_country: '',
      },
      {
        id: 114885,
        logo_path: null,
        name: 'Street Entertainment',
        origin_country: '',
      },
      {
        id: 1632,
        logo_path: '/cisLn1YAUuptXVBa0xjq7ST9cH0.png',
        name: 'Lionsgate',
        origin_country: 'US',
      },
    ],
    production_countries: [
      { iso_3166_1: 'CA', name: 'Canada' },
      { iso_3166_1: 'CN', name: 'Trung Quốc' },
      { iso_3166_1: 'US', name: 'Hoa Kì' },
    ],
    release_date: '2019-11-06',
    revenue: 125641396,
    runtime: 138,
    spoken_languages: [
      { english_name: 'Mandarin', iso_639_1: 'zh', name: '普通话' },
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
      { english_name: 'Nhật Bảnese', iso_639_1: 'ja', name: '日本語' },
    ],
    status: 'Đã phát hành',
    tagline: 'Một trận chiến thay đổi chiều hướng của cả cuộc chiến.',
    title: 'Trận Chiến Midway',
    video: false,
    vote_average: 7.1,
    vote_count: 1735,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Midway (2019 Movie) New Trailer – Ed Skrein, Mandy Moore, Nick Jonas, Woody Harrelson',
          key: 'l9laReRAYFk',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2019-09-12T15:21:04.000Z',
          id: '5da67472a24232001777bda8',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Midway (2019 Movie) Teaser Trailer — Ed Skrein, Patrick Wilson, Nick Jonas',
          key: 'Z_7eN5iloyk',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2019-06-27T14:00:06.000Z',
          id: '5da6746747721500185e8f06',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 1047649,
          known_for_department: 'Diễn viên',
          name: 'Ed Skrein',
          original_name: 'Ed Skrein',
          popularity: 6.303,
          profile_path:
            'https://image.tmdb.org/t/p/w185/c5PSRY9xbwJFCVCEeDIcx9SiJI1.jpg',
          cast_id: 8,
          character: "Lieutenant Richard 'Dick' Best",
          credit_id: '5b70599f925141406817739e',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 17178,
          known_for_department: 'Diễn viên',
          name: 'Patrick Wilson',
          original_name: 'Patrick Wilson',
          popularity: 9.059,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tc1ezEfIY8BhCy85svOUDtpBFPt.jpg',
          cast_id: 5,
          character: 'Rear Admiral Edwin T. Layton',
          credit_id: '5b7059740e0a267ee71882e0',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 57755,
          known_for_department: 'Diễn viên',
          name: 'Woody Harrelson',
          original_name: 'Woody Harrelson',
          popularity: 18.8,
          profile_path:
            'https://image.tmdb.org/t/p/w185/igxYDQBbTEdAqaJxaW6ffqswmUU.jpg',
          cast_id: 2,
          character: 'Admiral Chester W. Nimitz',
          credit_id: '5aeb53ad0e0a262b350071b9',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 114019,
          known_for_department: 'Diễn viên',
          name: 'Luke Evans',
          original_name: 'Luke Evans',
          popularity: 7.122,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qUkYJcrDc4M0LHNYASs30luFvw0.jpg',
          cast_id: 4,
          character: 'Commander Wade McClusky',
          credit_id: '5b3db88692514114aa005c08',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 16855,
          known_for_department: 'Diễn viên',
          name: 'Mandy Moore',
          original_name: 'Mandy Moore',
          popularity: 4.659,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1Z5yJ6FUsEtlVZzpyzOpfzvcpcm.jpg',
          cast_id: 3,
          character: 'Anne Best',
          credit_id: '5aeb53b4c3a3682df2004ec8',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 967781,
          known_for_department: 'Diễn viên',
          name: 'Luke Kleintank',
          original_name: 'Luke Kleintank',
          popularity: 3.795,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9iDyOwyeUyXNNjpqNwmXKwmwpTh.jpg',
          cast_id: 12,
          character: 'Lieutenant Clarence Earle Dickinson',
          credit_id: '5b705a20925141404f14a97c',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 6065,
          known_for_department: 'Diễn viên',
          name: 'Dennis Quaid',
          original_name: 'Dennis Quaid',
          popularity: 4.914,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9z8nfkqRgEBjsb3sXQ0jMopJJOE.jpg',
          cast_id: 9,
          character: "Vice Admiral William 'Bull' Halsey",
          credit_id: '5b7059d1c3a36818881744e1',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 6383,
          known_for_department: 'Diễn viên',
          name: 'Aaron Eckhart',
          original_name: 'Aaron Eckhart',
          popularity: 6.285,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5EFQvRHlpP1Iaw2e6vjOaBny6DV.jpg',
          cast_id: 6,
          character: 'Lieutenant Colonel Jimmy Doolittle',
          credit_id: '5b7059890e0a267ef6179dc2',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 1448516,
          known_for_department: 'Diễn viên',
          name: 'Keean Johnson',
          original_name: 'Keean Johnson',
          popularity: 3.48,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qYslz07HQUW1bAqdYSa3dUbnglb.jpg',
          cast_id: 11,
          character: 'Chief Aviation Radioman James Murray',
          credit_id: '5b705a13c3a36818861c1fe6',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 130565,
          known_for_department: 'Diễn viên',
          name: 'Nick Jonas',
          original_name: 'Nick Jonas',
          popularity: 2.774,
          profile_path:
            'https://image.tmdb.org/t/p/w185/o0BVIpLe8VnCkTuLsk5ObcQmRJr.jpg',
          cast_id: 7,
          character: 'Bruno Gaido',
          credit_id: '5b7059990e0a267ef6179dd3',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 80754,
          known_for_department: 'Diễn viên',
          name: 'Etsushi Toyokawa',
          original_name: 'Etsushi Toyokawa',
          popularity: 2.73,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9yUKBVACR2vsjl4a4sdo8UgGqDc.jpg',
          cast_id: 14,
          character: 'Admiral Isoroku Yamamoto',
          credit_id: '5b705a460e0a267ef818427f',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 13275,
          known_for_department: 'Diễn viên',
          name: 'Tadanobu Asano',
          original_name: 'Tadanobu Asano',
          popularity: 4.585,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wDw1z9Pk9dEzopzlZQ4X8wTbj1t.jpg',
          cast_id: 10,
          character: 'Rear Admiral Tamon Yamaguchi',
          credit_id: '5b705a070e0a267eeb18eaff',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 228721,
          known_for_department: 'Diễn viên',
          name: 'Darren Criss',
          original_name: 'Darren Criss',
          popularity: 3.407,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sE7dBeSXAhHKxnXyScvf8D4au4k.jpg',
          cast_id: 18,
          character: 'Commander Eugene Lindsey',
          credit_id: '5c442ca80e0a266d5ed2b94f',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 1855143,
          known_for_department: 'Diễn viên',
          name: 'Brandon Sklenar',
          original_name: 'Brandon Sklenar',
          popularity: 1.721,
          profile_path:
            'https://image.tmdb.org/t/p/w185/unM5wewbqrmE2cf6DSyyKLeA05I.jpg',
          cast_id: 269,
          character: "George 'Tex' Gay",
          credit_id: '5ee499a5a217c00020d03e5f',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 1300650,
          known_for_department: 'Diễn viên',
          name: 'Jake Manley',
          original_name: 'Jake Manley',
          popularity: 1.908,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rc5n3lDDv0NexXpVtRS0Tw9eCUa.jpg',
          cast_id: 267,
          character: 'Willie West',
          credit_id: '5e8ee3f415959f0019eb459e',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 2541,
          known_for_department: 'Diễn viên',
          name: 'Jun Kunimura',
          original_name: 'Jun Kunimura',
          popularity: 3.841,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ck1wrjyqBP322VBYkXmAq6Krw4w.jpg',
          cast_id: 13,
          character: 'Vice Admiral Chūichi Nagumo',
          credit_id: '5b705a2d92514168b60e74c4',
          order: 15,
        },
        {
          adult: false,
          gender: 0,
          id: 930327,
          known_for_department: 'Diễn viên',
          name: 'Nobuya Shimamoto',
          original_name: 'Nobuya Shimamoto',
          popularity: 1.28,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ocn3uQD9E01BTe3bQkeN9r0KE8M.jpg',
          cast_id: 37,
          character: 'Captain Tomeo Kaku',
          credit_id: '5d589b385cc11d00156002f2',
          order: 16,
        },
        {
          adult: false,
          gender: 2,
          id: 1218149,
          known_for_department: 'Diễn viên',
          name: 'Brennan Brown',
          original_name: 'Brennan Brown',
          popularity: 1.013,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ulP8XOTkF1EOfZGiyLXMrpkIZzo.jpg',
          cast_id: 40,
          character: 'Commander Joseph Rochefort',
          credit_id: '5dc989e199259c665e7bcf45',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 4177,
          known_for_department: 'Diễn viên',
          name: 'Jake Weber',
          original_name: 'Jake Weber',
          popularity: 4.781,
          profile_path:
            'https://image.tmdb.org/t/p/w185/z1RTh4qvyMFha8nKd5Uw1dKwkZz.jpg',
          cast_id: 38,
          character: 'Rear Admiral Raymond Spruance',
          credit_id: '5d589bba5cc11d001260055b',
          order: 18,
        },
        {
          adult: false,
          gender: 2,
          id: 23498,
          known_for_department: 'Diễn viên',
          name: 'Alexander Ludwig',
          original_name: 'Alexander Ludwig',
          popularity: 5.665,
          profile_path:
            'https://image.tmdb.org/t/p/w185/unP5YUgEdECL2gMLs0zCNya6is6.jpg',
          cast_id: 41,
          character: 'Lieutenant Roy Pearce',
          credit_id: '5e319b29ac8e6b0018bf586f',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 5892,
          known_for_department: 'Diễn viên',
          name: 'David Hewlett',
          original_name: 'David Hewlett',
          popularity: 1.834,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hUcYyssAPCqnZ4GjolhOWXHTWSa.jpg',
          cast_id: 270,
          character: 'Husband Kimmel',
          credit_id: '5ee49a2c97eab4001de20cfc',
          order: 20,
        },
        {
          adult: false,
          gender: 2,
          id: 6576,
          known_for_department: 'Diễn viên',
          name: 'Mark Rolston',
          original_name: 'Mark Rolston',
          popularity: 4.906,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hcrNRIptYMRXgkJ9k76BlQu6DQp.jpg',
          cast_id: 271,
          character: 'Ernest King',
          credit_id: '5ee49a360cb335001fbc1379',
          order: 21,
        },
        {
          adult: false,
          gender: 2,
          id: 216785,
          known_for_department: 'Diễn viên',
          name: 'Eric Davis',
          original_name: 'Eric Davis',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jcLaVXfXVeCIPnow8oNXQilUTRP.jpg',
          cast_id: 39,
          character: 'Captain Miles Browning',
          credit_id: '5d589bef761421001abfcab9',
          order: 22,
        },
        {
          adult: false,
          gender: 0,
          id: 1474171,
          known_for_department: 'Diễn viên',
          name: 'Kenny Leu',
          original_name: 'Kenny Leu',
          popularity: 0.622,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9e8mnD6SfsQAW536tpm5On8LXTP.jpg',
          cast_id: 272,
          character: 'Zhu Xuesan',
          credit_id: '5ee49a59cb71b8001fb3a1b1',
          order: 23,
        },
        {
          adult: false,
          gender: 1,
          id: 1616492,
          known_for_department: 'Diễn viên',
          name: 'Rachael Perrell Fosket',
          original_name: 'Rachael Perrell Fosket',
          popularity: 1.166,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5NDV4zLePU3euu5Cokbyh42MiXH.jpg',
          cast_id: 273,
          character: 'Dagne Layton',
          credit_id: '5ee49a65a217c00022d11ef7',
          order: 24,
        },
        {
          adult: false,
          gender: 2,
          id: 172994,
          known_for_department: 'Diễn viên',
          name: 'Peter Shinkoda',
          original_name: 'Peter Shinkoda',
          popularity: 0.828,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lCQl28poQr4bLwqZjhryGkV73jO.jpg',
          cast_id: 36,
          character: 'Cmdr. Minoru Genda',
          credit_id: '5d589aa75cc11d00115fff6b',
          order: 25,
        },
        {
          adult: false,
          gender: 2,
          id: 53198,
          known_for_department: 'Diễn viên',
          name: 'James Carpinello',
          original_name: 'James Carpinello',
          popularity: 2.06,
          profile_path:
            'https://image.tmdb.org/t/p/w185/18b4AHQ5P21I4tM7vN8jYvpJv6j.jpg',
          cast_id: 274,
          character: 'William Brockman',
          credit_id: '5ee49a9a0cb3350021bbe5e5',
          order: 26,
        },
        {
          adult: false,
          gender: 2,
          id: 550550,
          known_for_department: 'Diễn viên',
          name: 'Tim Beckmann',
          original_name: 'Tim Beckmann',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4u9cCTDSsgoKeX9eRKTppYGPW6D.jpg',
          cast_id: 275,
          character: 'Captain Rawlings',
          credit_id: '5ee49aa5a217c00022d11f33',
          order: 27,
        },
        {
          adult: false,
          gender: 0,
          id: 1440573,
          known_for_department: 'Diễn viên',
          name: 'Sarah Halford',
          original_name: 'Sarah Halford',
          popularity: 0.708,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aZTcd9OEvhv2CbXoiGLF94uyV0A.jpg',
          cast_id: 276,
          character: 'Marie Pearce',
          credit_id: '5ee49ab297eab40020e60d97',
          order: 28,
        },
        {
          adult: false,
          gender: 2,
          id: 1722430,
          known_for_department: 'Diễn viên',
          name: 'Cameron Brodeur',
          original_name: 'Cameron Brodeur',
          popularity: 1.999,
          profile_path:
            'https://image.tmdb.org/t/p/w185/htUezZbskoZ7nLrxT4CjM7BkLTU.jpg',
          cast_id: 277,
          character: 'Sully Brown',
          credit_id: '5ee49abd97eab40020e60db0',
          order: 29,
        },
        {
          adult: false,
          gender: 0,
          id: 2091617,
          known_for_department: 'Diễn viên',
          name: 'Hiromoto Ida',
          original_name: 'Hiromoto Ida',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lXs6jQfbFfPmA9fQTmkgzwRPXJ0.jpg',
          cast_id: 278,
          character: 'Prime Minister Tojo',
          credit_id: '5ee49ac80cb3350022bc4ac3',
          order: 30,
        },
        {
          adult: false,
          gender: 0,
          id: 2676883,
          known_for_department: 'Diễn viên',
          name: 'Hiroaki Shintani',
          original_name: 'Hiroaki Shintani',
          popularity: 0.6,
          profile_path: null,
          cast_id: 279,
          character: 'Emperor Hirohito',
          credit_id: '5ee49ad40cb3350022bc4af9',
          order: 31,
        },
        {
          adult: false,
          gender: 2,
          id: 1267379,
          known_for_department: 'Diễn viên',
          name: 'Russell Dennis Lewis',
          original_name: 'Russell Dennis Lewis',
          popularity: 0.606,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rqu1qPn26APEi02CJJJ2mEDHyks.jpg',
          cast_id: 19,
          character: 'Ensigh O’Flaherty',
          credit_id: '5cb7fc830e0a266ba4f06052',
          order: 32,
        },
        {
          adult: false,
          gender: 2,
          id: 148122,
          known_for_department: 'Diễn viên',
          name: 'Geoffrey Blake',
          original_name: 'Geoffrey Blake',
          popularity: 2.391,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uKdiO6QagiT0mZ7tf9Xrl8OZUKy.jpg',
          cast_id: 280,
          character: 'John Ford',
          credit_id: '5ee49b615b4fed0021652f95',
          order: 33,
        },
        {
          adult: false,
          gender: 2,
          id: 1593585,
          known_for_department: 'Diễn viên',
          name: 'Mikaël Conde',
          original_name: 'Mikaël Conde',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zjg10lLfFsKxi8MWVokUBtMxgWg.jpg',
          cast_id: 281,
          character: 'Bill Miller',
          credit_id: '5ee49b6fa217c0001fd0a442',
          order: 34,
        },
        {
          adult: false,
          gender: 0,
          id: 2676887,
          known_for_department: 'Diễn viên',
          name: 'Madison Roukema',
          original_name: 'Madison Roukema',
          popularity: 0.694,
          profile_path: null,
          cast_id: 282,
          character: 'Barbara Best',
          credit_id: '5ee49b7d97eab4001ee4c47a',
          order: 35,
        },
        {
          adult: false,
          gender: 0,
          id: 2676889,
          known_for_department: 'Diễn viên',
          name: 'Christie Brooke',
          original_name: 'Christie Brooke',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/AjBCAiqy4FhIaRJi4YDvQTayRJ6.jpg',
          cast_id: 283,
          character: 'Millicent McClusky',
          credit_id: '5ee49b895b4fed0021652ff1',
          order: 36,
        },
        {
          adult: false,
          gender: 0,
          id: 2676890,
          known_for_department: 'Diễn viên',
          name: 'Dustin Geiger',
          original_name: 'Dustin Geiger',
          popularity: 0.6,
          profile_path: null,
          cast_id: 284,
          character: 'Paul Crosley',
          credit_id: '5ee49b94cb71b8001cb3c7a9',
          order: 37,
        },
        {
          adult: false,
          gender: 2,
          id: 2308850,
          known_for_department: 'Diễn viên',
          name: 'Jason Lee Hoy',
          original_name: 'Jason Lee Hoy',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4HfI26yj5p55N5HvEtcgN5HtAwM.jpg',
          cast_id: 285,
          character: 'Pat Rooney',
          credit_id: '5ee49bf0cb71b8001cb3c81d',
          order: 38,
        },
        {
          adult: false,
          gender: 1,
          id: 53934,
          known_for_department: 'Diễn viên',
          name: 'Ellen Dubin',
          original_name: 'Ellen Dubin',
          popularity: 0.612,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6pskknCFA9ELimcXdR5LMJb1JJn.jpg',
          cast_id: 286,
          character: 'Admiral King Secretary',
          credit_id: '5ee49bfda217c00022d120d8',
          order: 39,
        },
        {
          adult: false,
          gender: 0,
          id: 2676891,
          known_for_department: 'Diễn viên',
          name: 'Jason New',
          original_name: 'Jason New',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/thJTgscIRvpSPNgReibrhk2PrBx.jpg',
          cast_id: 287,
          character: 'Marine Captain (Midway)',
          credit_id: '5ee49c160cb3350021bbe7c3',
          order: 40,
        },
        {
          adult: false,
          gender: 0,
          id: 2676892,
          known_for_department: 'Diễn viên',
          name: 'Dean Schaller',
          original_name: 'Dean Schaller',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hDdXa5OHfRdX2PDIOW6a1tPnX8R.jpg',
          cast_id: 288,
          character: 'Jack MacKenzie Jr.',
          credit_id: '5ee49c22cb71b8001db3bb1a',
          order: 41,
        },
        {
          adult: false,
          gender: 2,
          id: 208069,
          known_for_department: 'Diễn viên',
          name: 'Jacob Blair',
          original_name: 'Jacob Blair',
          popularity: 1.487,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rFL3qaFa6vlw6gLDNBEDrqMP6JS.jpg',
          cast_id: 289,
          character: 'Hank Potter',
          credit_id: '5ee49c3797eab4001fe38499',
          order: 42,
        },
        {
          adult: false,
          gender: 1,
          id: 2676896,
          known_for_department: 'Diễn viên',
          name: 'Kayo Yasuhara',
          original_name: 'Kayo Yasuhara',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3UIQovsveNzTKGpIDs87bmrm0O0.jpg',
          cast_id: 290,
          character: 'Geisha',
          credit_id: '5ee49d04cb71b8001fb3a387',
          order: 43,
        },
        {
          adult: false,
          gender: 0,
          id: 2676897,
          known_for_department: 'Diễn viên',
          name: 'Rudolph Wallstrom',
          original_name: 'Rudolph Wallstrom',
          popularity: 0.6,
          profile_path: null,
          cast_id: 291,
          character: 'Petty Officer (Pacific HQ)',
          credit_id: '5ee49d140cb335001fbc16e4',
          order: 44,
        },
        {
          adult: false,
          gender: 2,
          id: 140182,
          known_for_department: 'Diễn viên',
          name: 'Matthew MacCaull',
          original_name: 'Matthew MacCaull',
          popularity: 5.426,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aewHo2WLk00xLx6yPuS8BEFstbn.jpg',
          cast_id: 292,
          character: 'Staff Officer (Nimitz)',
          credit_id: '5ee49d2197eab40020e61523',
          order: 45,
        },
        {
          adult: false,
          gender: 0,
          id: 2676898,
          known_for_department: 'Diễn viên',
          name: 'Philip Fu-Kang Wang',
          original_name: 'Philip Fu-Kang Wang',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/x53o0QAHZeKMLJNe4sTBaD6Ro3X.jpg',
          cast_id: 293,
          character: 'Chinese Major',
          credit_id: '5ee49d32a217c00022d125b9',
          order: 46,
        },
        {
          adult: false,
          gender: 2,
          id: 1868401,
          known_for_department: 'Diễn viên',
          name: 'Johan Strombergsson-Denora',
          original_name: 'Johan Strombergsson-Denora',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5J7NJfeJ6kd3a5z4BaE756npHxB.jpg',
          cast_id: 294,
          character: 'Radioman #1 (Enterprise SC)',
          credit_id: '5ee49d43a217c00022d12607',
          order: 47,
        },
        {
          adult: false,
          gender: 0,
          id: 2676899,
          known_for_department: 'Diễn viên',
          name: 'Nico DeCastris',
          original_name: 'Nico DeCastris',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/p7D1xR79cl7mXTuqSCK7loL9T48.jpg',
          cast_id: 295,
          character: 'Radioman #2 (Enterprise SC)',
          credit_id: '5ee49d545b4fed0021653247',
          order: 48,
        },
        {
          adult: false,
          gender: 2,
          id: 1284645,
          known_for_department: 'Diễn viên',
          name: 'Alexandre Dubois',
          original_name: 'Alexandre Dubois',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qF25jUBLtvowFRdoBTosakwHUdd.jpg',
          cast_id: 296,
          character: 'Radar Officer (Enterprise)',
          credit_id: '5ee49d600cb3350022bc50b7',
          order: 49,
        },
        {
          adult: false,
          gender: 2,
          id: 1260716,
          known_for_department: 'Diễn viên',
          name: 'Tyler Elliot Burke',
          original_name: 'Tyler Elliot Burke',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7nQS7XoQhVzJ5qUNdTAC45weETK.jpg',
          cast_id: 297,
          character: 'Radar Officer (Enterprise)',
          credit_id: '5ee49d6a0cb3350022bc50d5',
          order: 50,
        },
        {
          adult: false,
          gender: 2,
          id: 1272480,
          known_for_department: 'Diễn viên',
          name: 'Raphael Grosz-Harvey',
          original_name: 'Raphael Grosz-Harvey',
          popularity: 0.838,
          profile_path:
            'https://image.tmdb.org/t/p/w185/h78FvoeeuTtX5K6DwcamB4kU27T.jpg',
          cast_id: 298,
          character: 'Lt. JG (Hospital)',
          credit_id: '5ee49d760cb3350021bbe8d7',
          order: 51,
        },
        {
          adult: false,
          gender: 0,
          id: 2213350,
          known_for_department: 'Diễn viên',
          name: 'Trevor Danielson',
          original_name: 'Trevor Danielson',
          popularity: 0.6,
          profile_path: null,
          cast_id: 299,
          character: 'Talker',
          credit_id: '5ee49d810cb335001fbc1742',
          order: 52,
        },
        {
          adult: false,
          gender: 0,
          id: 2676901,
          known_for_department: 'Diễn viên',
          name: 'Agostino Michael Cimino',
          original_name: 'Agostino Michael Cimino',
          popularity: 0.6,
          profile_path: null,
          cast_id: 300,
          character: 'Buzz Davis (Sonar Tech Nautilus)',
          credit_id: '5ee49d95a217c00022d126b2',
          order: 53,
        },
        {
          adult: false,
          gender: 0,
          id: 2525159,
          known_for_department: 'Diễn viên',
          name: 'Takeshi Kurokawa',
          original_name: 'Takeshi Kurokawa',
          popularity: 0.6,
          profile_path: null,
          cast_id: 301,
          character: 'Imperial Guardsman',
          credit_id: '5ee49da0cb71b8001fb3a407',
          order: 54,
        },
        {
          adult: false,
          gender: 0,
          id: 2676903,
          known_for_department: 'Diễn viên',
          name: 'Ryuta Kato',
          original_name: 'Ryuta Kato',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/su1AdAS2UXSbx0jfwMruL4z0my6.jpg',
          cast_id: 302,
          character: 'Nhật Bảnese Junior Officer (Yamat)',
          credit_id: '5ee49dac0cb3350022bc5115',
          order: 55,
        },
        {
          adult: false,
          gender: 2,
          id: 107489,
          known_for_department: 'Diễn viên',
          name: 'Garret Sato',
          original_name: 'Garret Sato',
          popularity: 0.828,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yEORvpqsasweaMIThCLBKqYjJ7E.jpg',
          cast_id: 303,
          character: 'Nhật Bảnese Officer (Prison)',
          credit_id: '5ee49db7a217c0001fd0a5fd',
          order: 56,
        },
        {
          adult: false,
          gender: 2,
          id: 1178295,
          known_for_department: 'Diễn viên',
          name: 'Neil Girvan',
          original_name: 'Neil Girvan',
          popularity: 1.013,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fOhrMtrfoaNHSQUFaehNMK1E4vE.jpg',
          cast_id: 304,
          character: 'Navy Yard Inspector',
          credit_id: '5ee49dc497eab4001de21248',
          order: 57,
        },
        {
          adult: false,
          gender: 2,
          id: 2170745,
          known_for_department: 'Diễn viên',
          name: 'Ellis Arch',
          original_name: 'Ellis Arch',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dwq90x3I968AN5i6uOSDnffIpSk.jpg',
          cast_id: 305,
          character: 'Lofton Henderson',
          credit_id: '5ee49dd05b4fed001f629307',
          order: 58,
        },
        {
          adult: false,
          gender: 2,
          id: 60906,
          known_for_department: 'Diễn viên',
          name: 'Robert Crooks',
          original_name: 'Robert Crooks',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nrGJWpytpp8zZzjZM0KdrzgwnhP.jpg',
          cast_id: 306,
          character: "McClusky's Radioman",
          credit_id: '5ee49ddf97eab4001fe38699',
          order: 59,
        },
        {
          adult: true,
          gender: 0,
          id: 1523478,
          known_for_department: 'Diễn viên',
          name: 'Sean Colby',
          original_name: 'Sean Colby',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sCcUDtbs2Fw2KexTY5GboxZ0wNt.jpg',
          cast_id: 307,
          character: "Gay's Radioman",
          credit_id: '5ee49dee97eab4001ee4c8aa',
          order: 60,
        },
        {
          adult: false,
          gender: 2,
          id: 1048580,
          known_for_department: 'Diễn viên',
          name: 'Kasey Ryne Mazak',
          original_name: 'Kasey Ryne Mazak',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pVC3OtRyUV6JPFwsoGtBkD4VNsJ.jpg',
          cast_id: 308,
          character: 'Signal Officer (Akagi)',
          credit_id: '5ee49dfca217c00020d0433e',
          order: 61,
        },
        {
          adult: false,
          gender: 2,
          id: 1677943,
          known_for_department: 'Diễn viên',
          name: 'Ryo Hayashida',
          original_name: 'Ryo Hayashida',
          popularity: 0.6,
          profile_path: null,
          cast_id: 309,
          character: 'Deck Officer (Akagi)',
          credit_id: '5ee49e070cb335001fbc179c',
          order: 62,
        },
        {
          adult: false,
          gender: 2,
          id: 1385061,
          known_for_department: 'Diễn viên',
          name: 'Michael Chapman',
          original_name: 'Michael Chapman',
          popularity: 1.62,
          profile_path: null,
          cast_id: 310,
          character: 'Helmsman (Nautilus)',
          credit_id: '5ee49e1a0cb3350022bc543c',
          order: 63,
        },
        {
          adult: false,
          gender: 0,
          id: 2676906,
          known_for_department: 'Diễn viên',
          name: 'Masahiro Tanikawa Masa Tani',
          original_name: 'Masahiro Tanikawa Masa Tani',
          popularity: 0.6,
          profile_path: null,
          cast_id: 311,
          character: 'Damage Control Officer',
          credit_id: '5ee49e2aa217c00022d128c5',
          order: 64,
        },
        {
          adult: false,
          gender: 0,
          id: 2676907,
          known_for_department: 'Diễn viên',
          name: 'Ryohei Arima',
          original_name: 'Ryohei Arima',
          popularity: 0.6,
          profile_path: null,
          cast_id: 312,
          character: 'Nhật Bảnese Lieutenant (Kaga)',
          credit_id: '5ee49e3697eab4001ee4c919',
          order: 65,
        },
        {
          adult: false,
          gender: 2,
          id: 60719,
          known_for_department: 'Diễn viên',
          name: 'Hiro Kanagawa',
          original_name: 'Hiro Kanagawa',
          popularity: 3.48,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dyWOPJmZTfy3r3R5eDY2d7yf8Ze.jpg',
          cast_id: 313,
          character: 'Makigumo Captain',
          credit_id: '5ee49e475b4fed0020636736',
          order: 66,
        },
        {
          adult: false,
          gender: 0,
          id: 2676909,
          known_for_department: 'Diễn viên',
          name: 'Ken Takikawa',
          original_name: 'Ken Takikawa',
          popularity: 0.6,
          profile_path: null,
          cast_id: 314,
          character: 'Makigumo Lieutenant',
          credit_id: '5ee49e51a217c00022d12919',
          order: 67,
        },
        {
          adult: false,
          gender: 2,
          id: 2242320,
          known_for_department: 'Diễn viên',
          name: 'Leonardo Boudreau',
          original_name: 'Leonardo Boudreau',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iqKLZzZqEFaAqPL2YGJeyrGIVPC.jpg',
          cast_id: 315,
          character: 'Passing Sailor',
          credit_id: '5ee49e60a217c00022d12981',
          order: 68,
        },
        {
          adult: false,
          gender: 2,
          id: 557002,
          known_for_department: 'Diễn viên',
          name: 'Tony Christopher',
          original_name: 'Tony Christopher',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mrbbQlg0RVA9GvjwZSEizmKytew.jpg',
          cast_id: 316,
          character: 'SBD Pilot (Enterprise)',
          credit_id: '5ee49e73a217c00021d00480',
          order: 69,
        },
        {
          adult: false,
          gender: 0,
          id: 2670693,
          known_for_department: 'Diễn viên',
          name: 'Yuta Takenaka',
          original_name: 'Yuta Takenaka',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/36kGGXODint5SGMHqXQQLAU8W63.jpg',
          cast_id: 317,
          character: 'Staff Officer (Yamato)',
          credit_id: '5ee49e7fcb71b8001eb3b41f',
          order: 70,
        },
        {
          adult: false,
          gender: 0,
          id: 2115840,
          known_for_department: 'Diễn viên',
          name: 'Tatsuya Shirato',
          original_name: 'Tatsuya Shirato',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uGCGXCc3nzReGvZ2c7v1tXErvUh.jpg',
          cast_id: 318,
          character: 'Flag Officer (Yamato)',
          credit_id: '5ee49e8acb71b8001cb3ccd9',
          order: 71,
        },
        {
          adult: false,
          gender: 2,
          id: 1890932,
          known_for_department: 'Crew',
          name: 'Tyler Hall',
          original_name: 'Tyler Hall',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lN0FFCcqLTAKMv9uyWYR2o1OPRl.jpg',
          cast_id: 319,
          character: "William 'Slim' Townsend",
          credit_id: '5ee49ec3cb71b8001cb3cd1c',
          order: 72,
        },
        {
          adult: false,
          gender: 0,
          id: 2676913,
          known_for_department: 'Diễn viên',
          name: 'Kyle Bougeno',
          original_name: 'Kyle Bougeno',
          popularity: 0.6,
          profile_path: null,
          cast_id: 320,
          character: 'Smoking Sailor',
          credit_id: '5ee49ecdcb71b8001db3bf64',
          order: 73,
        },
        {
          adult: false,
          gender: 2,
          id: 2507243,
          known_for_department: 'Diễn viên',
          name: 'David Dacosta',
          original_name: 'David Dacosta',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/d7X2ogV3lDha83vJ20BTok9gG8J.jpg',
          cast_id: 321,
          character: 'Breathless Ensign (Enterprise)',
          credit_id: '5ee49ed80cb3350021bbea1a',
          order: 74,
        },
        {
          adult: false,
          gender: 0,
          id: 2676914,
          known_for_department: 'Diễn viên',
          name: 'Kazuki Gonzalez-Adachi',
          original_name: 'Kazuki Gonzalez-Adachi',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/svmy5eWWIBDXKHFXlgSEqtMqtGa.jpg',
          cast_id: 322,
          character: 'Hiryu Helmsman',
          credit_id: '5ee49ee50cb335001fbc18b2',
          order: 75,
        },
        {
          adult: false,
          gender: 0,
          id: 2676916,
          known_for_department: 'Diễn viên',
          name: 'Reyn Halford',
          original_name: 'Reyn Halford',
          popularity: 0.6,
          profile_path: null,
          cast_id: 323,
          character: 'Torpedo Room Chief',
          credit_id: '5ee49eef0cb3350022bc5627',
          order: 76,
        },
        {
          adult: false,
          gender: 0,
          id: 2676917,
          known_for_department: 'Diễn viên',
          name: 'Toyoaki Ito Leung',
          original_name: 'Toyoaki Ito Leung',
          popularity: 0.6,
          profile_path: null,
          cast_id: 324,
          character: 'Nhật Bảnese Boy (10 YO)',
          credit_id: '5ee49efba217c00020d04478',
          order: 77,
        },
        {
          adult: false,
          gender: 0,
          id: 2676918,
          known_for_department: 'Diễn viên',
          name: 'Halta Nonen',
          original_name: 'Halta Nonen',
          popularity: 0.6,
          profile_path: null,
          cast_id: 325,
          character: 'Nhật Bảnese Boy #2 (6 YO)',
          credit_id: '5ee49f050cb3350021bbea64',
          order: 78,
        },
        {
          adult: false,
          gender: 2,
          id: 1849319,
          known_for_department: 'Diễn viên',
          name: 'Adrian Spencer',
          original_name: 'Adrian Spencer',
          popularity: 2.3,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ibDcS36iABXTNnbQUN10TLZ6EKT.jpg',
          cast_id: 326,
          character: 'Chief Medic (Enterprise)',
          credit_id: '5ee49f0fcb71b8001fb3a4f8',
          order: 79,
        },
        {
          adult: false,
          gender: 2,
          id: 2782684,
          known_for_department: 'Diễn viên',
          name: 'James Hicks',
          original_name: 'James Hicks',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/27Ovnj1L3vU7tA2IKjK9PFvNZuB.jpg',
          cast_id: 338,
          character: 'Edwin Kroeger',
          credit_id: '5f640cbb87f3f2003a83c709',
          order: 81,
        },
        {
          adult: false,
          gender: 2,
          id: 224144,
          known_for_department: 'Diễn viên',
          name: 'Sebastian Pigott',
          original_name: 'Sebastian Pigott',
          popularity: 2.329,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dFdv24Qa9j3WhJDxchn6s8jeepj.jpg',
          cast_id: 328,
          character: 'Petty Officer #2',
          credit_id: '5ee49f27cb71b8001cb3ce00',
          order: 82,
        },
        {
          adult: false,
          gender: 2,
          id: 2182319,
          known_for_department: 'Diễn viên',
          name: 'Simon Pelletier-Gilbert',
          original_name: 'Simon Pelletier-Gilbert',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/AmV9BXYWAMexDZDsYDc4ecmT4jJ.jpg',
          cast_id: 329,
          character: 'Yorktown Spotter',
          credit_id: '5ee49f315b4fed001f6294f7',
          order: 83,
        },
        {
          adult: false,
          gender: 0,
          id: 2676921,
          known_for_department: 'Diễn viên',
          name: 'Philippe Verville',
          original_name: 'Philippe Verville',
          popularity: 0.6,
          profile_path: null,
          cast_id: 330,
          character: "Doolittle's Bombardier",
          credit_id: '5ee49f3b0cb3350020bbccfc',
          order: 84,
        },
        {
          adult: false,
          gender: 0,
          id: 2676923,
          known_for_department: 'Diễn viên',
          name: 'Shigeru Yabuta',
          original_name: 'Shigeru Yabuta',
          popularity: 0.6,
          profile_path: null,
          cast_id: 331,
          character: 'Nhật Bảnese Duck Netting Officer',
          credit_id: '5ee49f490cb335001fbc18ef',
          order: 85,
        },
        {
          adult: false,
          gender: 0,
          id: 2676924,
          known_for_department: 'Diễn viên',
          name: 'Seunghwan Min',
          original_name: 'Seunghwan Min',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xMgZOJLLHG18zivnZtSOcJjNK53.jpg',
          cast_id: 332,
          character: 'Zero Pilots Squadron Leader',
          credit_id: '5ee49f540cb3350020bbcd17',
          order: 86,
        },
        {
          adult: false,
          gender: 0,
          id: 2676925,
          known_for_department: 'Diễn viên',
          name: 'Christopher Tapia',
          original_name: 'Christopher Tapia',
          popularity: 0.6,
          profile_path: null,
          cast_id: 333,
          character: 'Hiryu Pointer',
          credit_id: '5ee49f640cb3350021bbeaa9',
          order: 87,
        },
        {
          adult: false,
          gender: 0,
          id: 2676926,
          known_for_department: 'Diễn viên',
          name: 'Sangwon Jun',
          original_name: 'Sangwon Jun',
          popularity: 0.6,
          profile_path: null,
          cast_id: 334,
          character: 'Hiryu Talker',
          credit_id: '5ee49f6ecb71b8001db3c06c',
          order: 88,
        },
        {
          adult: false,
          gender: 0,
          id: 2676927,
          known_for_department: 'Diễn viên',
          name: 'Motoo Taira',
          original_name: 'Motoo Taira',
          popularity: 0.6,
          profile_path: null,
          cast_id: 335,
          character: 'Akagi Spotter',
          credit_id: '5ee49f780cb3350020bbcd37',
          order: 89,
        },
        {
          adult: false,
          gender: 0,
          id: 1249312,
          known_for_department: 'Diễn viên',
          name: 'Ana Maria Lombo',
          original_name: 'Ana Maria Lombo',
          popularity: 0.728,
          profile_path: null,
          cast_id: 336,
          character: 'Ballroom Singer',
          credit_id: '5ee49f85a217c00021d00551',
          order: 90,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 0,
          id: 7240,
          known_for_department: 'Sound',
          name: 'Cary Weitz',
          original_name: 'Cary Weitz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e67c373459ad600185cd45a',
          department: 'Sound',
          job: 'Boom Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 5430,
          known_for_department: 'Sound',
          name: 'Harald Kloser',
          original_name: 'Harald Kloser',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5d50b3eb0102c90011752ffb',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 5430,
          known_for_department: 'Sound',
          name: 'Harald Kloser',
          original_name: 'Harald Kloser',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5b715e8c0e0a267eeb1a4489',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 2,
          id: 6046,
          known_for_department: 'Directing',
          name: 'Roland Emmerich',
          original_name: 'Roland Emmerich',
          popularity: 2.954,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mN8x74uv9yQ7dJl8nh2q26mkY8v.jpg',
          credit_id: '5aeb5324c3a3682dd1003e79',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 6046,
          known_for_department: 'Directing',
          name: 'Roland Emmerich',
          original_name: 'Roland Emmerich',
          popularity: 2.954,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mN8x74uv9yQ7dJl8nh2q26mkY8v.jpg',
          credit_id: '5d50b3cecc277c0015f12425',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 6048,
          known_for_department: 'Production',
          name: 'Mark Gordon',
          original_name: 'Mark Gordon',
          popularity: 0.617,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lATsud5NyaXaKE5p8H1kEkUsbWN.jpg',
          credit_id: '5d50b3e0a2d2e90015860aac',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 6049,
          known_for_department: 'Sound',
          name: 'Thomas Wanker',
          original_name: 'Thomas Wanker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b715e76c3a368188818926c',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 0,
          id: 6207,
          known_for_department: 'Art',
          name: 'Doug Hardwick',
          original_name: 'Doug Hardwick',
          popularity: 0.706,
          profile_path: null,
          credit_id: '5e66633055c926001362da3e',
          department: 'Art',
          job: 'Construction Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 8704,
          known_for_department: 'Art',
          name: 'Isabelle Guay',
          original_name: 'Isabelle Guay',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6667b3151c5c001501b67d',
          department: 'Art',
          job: 'Supervising Art Director',
        },
        {
          adult: false,
          gender: 2,
          id: 10819,
          known_for_department: 'Art',
          name: 'Kirk M. Petruccelli',
          original_name: 'Kirk M. Petruccelli',
          popularity: 0.982,
          profile_path: null,
          credit_id: '5d15bb1c50f7ca0015151ce9',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 1,
          id: 17611,
          known_for_department: 'Production',
          name: 'Andrea Kenyon',
          original_name: 'Andrea Kenyon',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5d50b474cc277c0013f124b2',
          department: 'Production',
          job: 'Casting Director',
        },
        {
          adult: false,
          gender: 2,
          id: 42034,
          known_for_department: 'Sound',
          name: 'Greg P. Russell',
          original_name: 'Greg P. Russell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e67c5f755c926001962e716',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 18867,
          known_for_department: 'Art',
          name: 'Page Buckner',
          original_name: 'Page Buckner',
          popularity: 2.744,
          profile_path: null,
          credit_id: '5d50b48ea2d2e90014861b8d',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 19657,
          known_for_department: 'Production',
          name: 'Carsten H. W. Lorenz',
          original_name: 'Carsten H. W. Lorenz',
          popularity: 0.719,
          profile_path: null,
          credit_id: '5d50b4240102c90012753556',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 60711,
          known_for_department: 'Production',
          name: "Brent O'Connor",
          original_name: "Brent O'Connor",
          popularity: 1.094,
          profile_path: null,
          credit_id: '5d50b45d0102c90012753629',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 59055,
          known_for_department: 'Production',
          name: 'Caitlin McKenna-Wilkinson',
          original_name: 'Caitlin McKenna-Wilkinson',
          popularity: 1.804,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cPfk4htR9X7gUnr1jYsKs0Y5qBq.jpg',
          credit_id: '5e6a5c2855c9260015665b88',
          department: 'Production',
          job: 'ADR Voice Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 71067,
          known_for_department: 'Production',
          name: 'Yu Dong',
          original_name: 'Yu Dong',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d50b431cc277c0016f12063',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 74202,
          known_for_department: 'Sound',
          name: 'Michael Hoffman',
          original_name: 'Michael Hoffman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e67c58d151c5c001703c285',
          department: 'Sound',
          job: 'Sound Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 113894,
          known_for_department: 'Costume & Make-Up',
          name: 'Mario Davignon',
          original_name: 'Mario Davignon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d15bb3171ffdf5cf9872576',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 1,
          id: 107420,
          known_for_department: 'Art',
          name: 'Carolyn A. Loucks',
          original_name: 'Carolyn A. Loucks',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iy7lqjMdb3Qn6W0lLo0b6kcWZLz.jpg',
          credit_id: '5d50b4a6a2d2e90012860eb0',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 2,
          id: 207818,
          known_for_department: 'Crew',
          name: 'Patrick Kerton',
          original_name: 'Patrick Kerton',
          popularity: 1.128,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jj9uVCBSSUFvOi663jMbs7YJ3G3.jpg',
          credit_id: '5e69106855c926001564cbe3',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 222883,
          known_for_department: 'Editing',
          name: 'Ryan Stevens Harris',
          original_name: 'Ryan Stevens Harris',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a5f7a55c926001367cce3',
          department: 'Editing',
          job: 'Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 225904,
          known_for_department: 'Editing',
          name: 'Adam Wolfe',
          original_name: 'Adam Wolfe',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d15bb0618b751002d5d552b',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 229902,
          known_for_department: 'Visual Effects',
          name: 'Patricia Binga',
          original_name: 'Patricia Binga',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6907decabfe400110e79c0',
          department: 'Visual Effects',
          job: 'Lead Animator',
        },
        {
          adult: false,
          gender: 2,
          id: 588407,
          known_for_department: 'Diễn viên',
          name: 'Harlan Glenn',
          original_name: 'Harlan Glenn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a5a67459ad6001a60ce97',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1076764,
          known_for_department: 'Editing',
          name: "Paul O'Bryan",
          original_name: "Paul O'Bryan",
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a6020357c0000113eacc5',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1085032,
          known_for_department: 'Sound',
          name: 'Steve Neal',
          original_name: 'Steve Neal',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e67c4b8cee2f6001396d545',
          department: 'Sound',
          job: 'Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1095252,
          known_for_department: 'Production',
          name: 'Matt Jackson',
          original_name: 'Matt Jackson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d50b4049c055000174534b4',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1183805,
          known_for_department: 'Directing',
          name: 'Martin Doepner',
          original_name: 'Martin Doepner',
          popularity: 0.702,
          profile_path: null,
          credit_id: '5e6a5dde357c0000133f41c0',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1190108,
          known_for_department: 'Sound',
          name: 'Matt Hovland',
          original_name: 'Matt Hovland',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5e67c27ae38bd8001516060c',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1191811,
          known_for_department: 'Sound',
          name: 'Tom Marks',
          original_name: 'Tom Marks',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e67c5dd459ad600115c8a28',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1298897,
          known_for_department: 'Crew',
          name: 'Eric Rylander',
          original_name: 'Eric Rylander',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e67c0ea55c9260015630f58',
          department: 'Crew',
          job: 'Special Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1327907,
          known_for_department: 'Art',
          name: 'Jean-Pierre Paquet',
          original_name: 'Jean-Pierre Paquet',
          popularity: 0.728,
          profile_path: null,
          credit_id: '5d50b49dcc277c0013f124d1',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1355605,
          known_for_department: 'Production',
          name: 'Katie Doyle',
          original_name: 'Katie Doyle',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/quEEShWQuJA4oVgAY1CA9Rksrn5.jpg',
          credit_id: '5e6a5cc0cedac40013476170',
          department: 'Production',
          job: 'Casting Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1374355,
          known_for_department: 'Camera',
          name: 'Joseph Segura',
          original_name: 'Joseph Segura',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666b3d8d52c9001b3f2fab',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1378721,
          known_for_department: 'Costume & Make-Up',
          name: 'Marylou Lim',
          original_name: 'Marylou Lim',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a5822cedac40015479a91',
          department: 'Costume & Make-Up',
          job: 'Assistant Costume Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1378726,
          known_for_department: 'Crew',
          name: 'Francie Brown',
          original_name: 'Francie Brown',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a613c459ad600115f9174',
          department: 'Crew',
          job: 'Dialect Coach',
        },
        {
          adult: false,
          gender: 2,
          id: 1379517,
          known_for_department: 'Crew',
          name: 'Craig Hosking',
          original_name: 'Craig Hosking',
          popularity: 1.312,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fBAS5WsGgyASXHWve1g5cVI0KXP.jpg',
          credit_id: '5e6a60a5459ad600185fe229',
          department: 'Crew',
          job: 'Aerial Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1379999,
          known_for_department: 'Camera',
          name: 'Reiner Bajo',
          original_name: 'Reiner Bajo',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5e666e8755c926001961080b',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 0,
          id: 1388876,
          known_for_department: 'Visual Effects',
          name: 'Peter G. Travers',
          original_name: 'Peter G. Travers',
          popularity: 1.094,
          profile_path: null,
          credit_id: '5e690f2f357c0000133dde1e',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1392943,
          known_for_department: 'Lighting',
          name: 'Joshua Davis',
          original_name: 'Joshua Davis',
          popularity: 1.057,
          profile_path: null,
          credit_id: '5e666bf9151c5c001501bfff',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1393494,
          known_for_department: 'Camera',
          name: 'Dan Goyens',
          original_name: 'Dan Goyens',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666d41357c000011399f91',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 1,
          id: 1394740,
          known_for_department: 'Art',
          name: 'Helene Lamarre',
          original_name: 'Helene Lamarre',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e66618d151c5c001301b17a',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1395902,
          known_for_department: 'Camera',
          name: 'Robby Baumgartner',
          original_name: 'Robby Baumgartner',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b715df2c3a368189d17c329',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 1399321,
          known_for_department: 'Costume & Make-Up',
          name: 'Paul Corricelli',
          original_name: 'Paul Corricelli',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a5a152f3b1700143fbfb1',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1399888,
          known_for_department: 'Editing',
          name: 'Walter Volpatto',
          original_name: 'Walter Volpatto',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a600055c9260015666800',
          department: 'Editing',
          job: 'Digital Intermediate Colorist',
        },
        {
          adult: false,
          gender: 0,
          id: 1401965,
          known_for_department: 'Visual Effects',
          name: 'Bryan Grill',
          original_name: 'Bryan Grill',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5e690f66cabfe400150e89db',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1402034,
          known_for_department: 'Lighting',
          name: 'Eames Gagnon',
          original_name: 'Eames Gagnon',
          popularity: 0.84,
          profile_path: null,
          credit_id: '5e666be555c92600196104e6',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1403425,
          known_for_department: 'Costume & Make-Up',
          name: 'Mahealani Diego',
          original_name: 'Mahealani Diego',
          popularity: 0.652,
          profile_path: null,
          credit_id: '5e666fe5459ad600135bcd89',
          department: 'Costume & Make-Up',
          job: 'Assistant Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1403430,
          known_for_department: 'Art',
          name: 'Christine Youngstrom',
          original_name: 'Christine Youngstrom',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5e6661a08d52c900173f4ee1',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1403478,
          known_for_department: 'Camera',
          name: 'Don King',
          original_name: 'Don King',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666eae459ad6001a5b34fe',
          department: 'Camera',
          job: 'Underwater Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1403692,
          known_for_department: 'Costume & Make-Up',
          name: 'Emilie Gauthier',
          original_name: 'Emilie Gauthier',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6672858d52c900193f432b',
          department: 'Costume & Make-Up',
          job: 'Makeup Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1407028,
          known_for_department: 'Camera',
          name: 'Alan Markfield',
          original_name: 'Alan Markfield',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5e666e97357c00001139a2d6',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 0,
          id: 1408293,
          known_for_department: 'Costume & Make-Up',
          name: 'Linda D. Flowers',
          original_name: 'Linda D. Flowers',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e667183151c5c001301cdf7',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1416170,
          known_for_department: 'Visual Effects',
          name: 'Derek Spears',
          original_name: 'Derek Spears',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5e690c04151c5c0013053652',
          department: 'Visual Effects',
          job: 'VFX Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1419733,
          known_for_department: 'Crew',
          name: 'Puelo Deir',
          original_name: 'Puelo Deir',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a626c459ad600185fe501',
          department: 'Crew',
          job: 'Unit Publicist',
        },
        {
          adult: false,
          gender: 0,
          id: 1422400,
          known_for_department: 'Costume & Make-Up',
          name: 'Tom Macdonald',
          original_name: 'Tom Macdonald',
          popularity: 0.984,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1IUGgpG0aE5rLOopO0fkmzSRsXd.jpg',
          credit_id: '5e6a58bdcabfe400150fefcb',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1423544,
          known_for_department: 'Sound',
          name: 'Josh Bower',
          original_name: 'Josh Bower',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5e67c384151c5c0019030830',
          department: 'Sound',
          job: 'Boom Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1438616,
          known_for_department: 'Visual Effects',
          name: 'Phil Jones',
          original_name: 'Phil Jones',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690bc9459ad6001a5f5209',
          department: 'Visual Effects',
          job: 'VFX Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1439053,
          known_for_department: 'Crew',
          name: 'Dan Smiczek',
          original_name: 'Dan Smiczek',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6903d155c9260019649a27',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1445367,
          known_for_department: 'Sound',
          name: 'Patrick Christensen',
          original_name: 'Patrick Christensen',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5e67c20d357c0000193bdf79',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1445974,
          known_for_department: 'Production',
          name: 'Eriko Miyagawa',
          original_name: 'Eriko Miyagawa',
          popularity: 1.09,
          profile_path: null,
          credit_id: '5e6a5cae357c0000133f4083',
          department: 'Production',
          job: 'Casting Consultant',
        },
        {
          adult: false,
          gender: 0,
          id: 1458086,
          known_for_department: 'Costume & Make-Up',
          name: 'Laine Rykes',
          original_name: 'Laine Rykes',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5e6671cb357c00001939ed9a',
          department: 'Costume & Make-Up',
          job: 'Key Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1458141,
          known_for_department: 'Lighting',
          name: 'Don Tomich',
          original_name: 'Don Tomich',
          popularity: 1.214,
          profile_path: null,
          credit_id: '5e666dbc8d52c9001d3f453e',
          department: 'Lighting',
          job: 'Rigging Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1459924,
          known_for_department: 'Crew',
          name: 'Lukas Lepicovsky',
          original_name: 'Lukas Lepicovsky',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690445cabfe400150e7869',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1462038,
          known_for_department: 'Visual Effects',
          name: 'Greg Strasz',
          original_name: 'Greg Strasz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690f3f2f3b1700143e6155',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1463301,
          known_for_department: 'Crew',
          name: 'Alvin S. Cabrinha Jr.',
          original_name: 'Alvin S. Cabrinha Jr.',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6664c555c926001960f2bf',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 2,
          id: 1463383,
          known_for_department: 'Art',
          name: 'Christopher J. Wood',
          original_name: 'Christopher J. Wood',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e66673c151c5c0019010534',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 1463631,
          known_for_department: 'Visual Effects',
          name: 'Rene Toye',
          original_name: 'Rene Toye',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690b24459ad600185e75d2',
          department: 'Visual Effects',
          job: 'VFX Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1463695,
          known_for_department: 'Diễn viên',
          name: 'Stephen Bacquet',
          original_name: 'Stephen Bacquet',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666d1b8d52c9001b3f328a',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 2,
          id: 1463735,
          known_for_department: 'Lighting',
          name: 'Rick Harris',
          original_name: 'Rick Harris',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666c8d459ad600135bc68f',
          department: 'Lighting',
          job: 'Key Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1463770,
          known_for_department: 'Camera',
          name: 'Les T. Tomita',
          original_name: 'Les T. Tomita',
          popularity: 0.84,
          profile_path: null,
          credit_id: '5e666c70459ad600185af1b4',
          department: 'Camera',
          job: 'Key Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1463803,
          known_for_department: 'Costume & Make-Up',
          name: 'Cathie Valdovino',
          original_name: 'Cathie Valdovino',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a5a9e2f3b1700194067e9',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1484196,
          known_for_department: 'Visual Effects',
          name: 'Sebastian Butenberg',
          original_name: 'Sebastian Butenberg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690277151c5c00130521f7',
          department: 'Visual Effects',
          job: 'Animation Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1511582,
          known_for_department: 'Costume & Make-Up',
          name: 'Gina Scarnati',
          original_name: 'Gina Scarnati',
          popularity: 1.22,
          profile_path: null,
          credit_id: '5e6a5afdcedac40017478da9',
          department: 'Art',
          job: 'Textile Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1519867,
          known_for_department: 'Directing',
          name: 'Lorette Leblanc',
          original_name: 'Lorette Leblanc',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a5e7955c926001566663b',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1537771,
          known_for_department: 'Sound',
          name: 'Jan Bezouška',
          original_name: 'Jan Bezouška',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e67c509cee2f6001396d5d1',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1546958,
          known_for_department: 'Crew',
          name: 'Andrew Ryan Turner',
          original_name: 'Andrew Ryan Turner',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690de1459ad600135f66d1',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1548672,
          known_for_department: 'Camera',
          name: 'Rick Crum',
          original_name: 'Rick Crum',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666ad0151c5c0019010983',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 1557104,
          known_for_department: 'Art',
          name: 'Carolyne de Bellefeuille',
          original_name: 'Carolyne de Bellefeuille',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d50b496a2d2e90014861b9c',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 1570608,
          known_for_department: 'Costume & Make-Up',
          name: 'Marcelo Padovani',
          original_name: 'Marcelo Padovani',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666fb9151c5c00190111cd',
          department: 'Costume & Make-Up',
          job: 'Assistant Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1571045,
          known_for_department: 'Camera',
          name: 'Dany Racine',
          original_name: 'Dany Racine',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5e666b7f357c0000133a1013',
          department: 'Camera',
          job: 'First Assistant "A" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1571046,
          known_for_department: 'Costume & Make-Up',
          name: 'Félix Larivière',
          original_name: 'Félix Larivière',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e667038151c5c001501c542',
          department: 'Costume & Make-Up',
          job: 'Hair Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 1573716,
          known_for_department: 'Camera',
          name: 'Jeremy Brussell',
          original_name: 'Jeremy Brussell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e66693e55c926001960fddb',
          department: 'Camera',
          job: 'Best Boy Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1574648,
          known_for_department: 'Crew',
          name: 'Julie Garceau',
          original_name: 'Julie Garceau',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666a08357c0000133a0e15',
          department: 'Camera',
          job: 'Digital Imaging Technician',
        },
        {
          adult: false,
          gender: 2,
          id: 1587281,
          known_for_department: 'Biên kịch',
          name: 'Wes Tooke',
          original_name: 'Wes Tooke',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5aeb53340e0a262b27006942',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 0,
          id: 1590087,
          known_for_department: 'Camera',
          name: 'Soupharak Keoborakoth',
          original_name: 'Soupharak Keoborakoth',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666e4755c92600196107cc',
          department: 'Camera',
          job: 'Second Assistant "A" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1593425,
          known_for_department: 'Biên kịch',
          name: 'Pierre Daudelin',
          original_name: 'Pierre Daudelin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6668c7459ad600135bbf61',
          department: 'Lighting',
          job: 'Best Boy Electric',
        },
        {
          adult: false,
          gender: 1,
          id: 1594191,
          known_for_department: 'Costume & Make-Up',
          name: 'Pamela Goldammer',
          original_name: 'Pamela Goldammer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6670f6151c5c001301c499',
          department: 'Costume & Make-Up',
          job: 'First Assistant Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1599366,
          known_for_department: 'Biên kịch',
          name: 'Hale Mawae',
          original_name: 'Hale Mawae',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6666a7151c5c001501b41e',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 2,
          id: 1611194,
          known_for_department: 'Sound',
          name: 'Marcin Kasiński',
          original_name: 'Marcin Kasiński',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f2c7ed99c24fc0036a48b46',
          department: 'Sound',
          job: 'Foley Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1611781,
          known_for_department: 'Art',
          name: 'Martin Chalifoux',
          original_name: 'Martin Chalifoux',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6663598d52c9001d3f3d4a',
          department: 'Art',
          job: 'Construction Manager',
        },
        {
          adult: false,
          gender: 2,
          id: 1619981,
          known_for_department: 'Camera',
          name: 'Steven Cueva',
          original_name: 'Steven Cueva',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666b558d52c900173f65a1',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1621800,
          known_for_department: 'Editing',
          name: 'Shae Salmon',
          original_name: 'Shae Salmon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690b14151c5c001705add8',
          department: 'Visual Effects',
          job: 'VFX Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1627125,
          known_for_department: 'Crew',
          name: 'Dave Goetter',
          original_name: 'Dave Goetter',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e67c268459ad6001a5d600f',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1631607,
          known_for_department: 'Camera',
          name: 'Eric Aubin',
          original_name: 'Eric Aubin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666e5c357c00001139a266',
          department: 'Camera',
          job: 'Second Assistant "B" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1646230,
          known_for_department: 'Crew',
          name: 'Harry Lu',
          original_name: 'Harry Lu',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5e6a60e4cabfe400180fd27d',
          department: 'Crew',
          job: 'Armorer',
        },
        {
          adult: false,
          gender: 0,
          id: 1658456,
          known_for_department: 'Production',
          name: 'Alastair Burlingham',
          original_name: 'Alastair Burlingham',
          popularity: 2.398,
          profile_path: null,
          credit_id: '5d50b3f50102c900157538d6',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1661326,
          known_for_department: 'Production',
          name: 'Caitlin Well',
          original_name: 'Caitlin Well',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a5c7e459ad600185fdbc7',
          department: 'Production',
          job: 'Casting Associate',
        },
        {
          adult: false,
          gender: 0,
          id: 1675777,
          known_for_department: 'Visual Effects',
          name: 'Tefft Smith',
          original_name: 'Tefft Smith',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690aad459ad600185e74f6',
          department: 'Visual Effects',
          job: 'Pre-Visualization Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1709104,
          known_for_department: 'Art',
          name: 'David Shauger',
          original_name: 'David Shauger',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666345151c5c001900fe13',
          department: 'Art',
          job: 'Construction Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1715162,
          known_for_department: 'Sound',
          name: 'Peter Bawiec',
          original_name: 'Peter Bawiec',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e67c657459ad600115c8a8b',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1715162,
          known_for_department: 'Sound',
          name: 'Peter Bawiec',
          original_name: 'Peter Bawiec',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e67c610cee2f6001696d2f9',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1716003,
          known_for_department: 'Crew',
          name: 'Wouter van Herwerden',
          original_name: 'Wouter van Herwerden',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e67c2c6357c0000193be168',
          department: 'Sound',
          job: 'ADR Recordist',
        },
        {
          adult: false,
          gender: 0,
          id: 1725770,
          known_for_department: 'Visual Effects',
          name: 'Thomas Dane Wagener',
          original_name: 'Thomas Dane Wagener',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690d93cabfe400180e7566',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1725887,
          known_for_department: 'Sound',
          name: 'Louis Marion',
          original_name: 'Louis Marion',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e67c47a55c926001563145a',
          department: 'Sound',
          job: 'Production Sound Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1739791,
          known_for_department: 'Crew',
          name: 'Steven Spady',
          original_name: 'Steven Spady',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690df3459ad600135f671f',
          department: 'Crew',
          job: 'Visual Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1759809,
          known_for_department: 'Costume & Make-Up',
          name: 'Ralph Malani',
          original_name: 'Ralph Malani',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e667196151c5c001301ce12',
          department: 'Costume & Make-Up',
          job: 'Key Hair Stylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1789912,
          known_for_department: 'Art',
          name: 'Nicholas Rymond',
          original_name: 'Nicholas Rymond',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666472459ad600185ae2d9',
          department: 'Art',
          job: 'Leadman',
        },
        {
          adult: false,
          gender: 0,
          id: 1790350,
          known_for_department: 'Costume & Make-Up',
          name: 'Sabrine Canuel',
          original_name: 'Sabrine Canuel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a59fb2f3b1700143fbf89',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1790947,
          known_for_department: 'Crew',
          name: 'Laurent Taillefer',
          original_name: 'Laurent Taillefer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690f78459ad6001a5f56fd',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1795426,
          known_for_department: 'Lighting',
          name: 'Mike Gerzevitz',
          original_name: 'Mike Gerzevitz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666d76357c00001639667a',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 1803662,
          known_for_department: 'Diễn viên',
          name: 'Andrea Montana Knoll',
          original_name: 'Andrea Montana Knoll',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a61ebcabfe400111038bd',
          department: 'Production',
          job: 'Production Consultant',
        },
        {
          adult: false,
          gender: 0,
          id: 1803751,
          known_for_department: 'Sound',
          name: 'Jon Lawless',
          original_name: 'Jon Lawless',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e67c2a4151c5c001503cad9',
          department: 'Sound',
          job: 'ADR Recordist',
        },
        {
          adult: false,
          gender: 0,
          id: 1814557,
          known_for_department: 'Sound',
          name: 'Taylor Westerfield',
          original_name: 'Taylor Westerfield',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e67c39c55c926001364af4a',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1815918,
          known_for_department: 'Visual Effects',
          name: 'Babak Bina',
          original_name: 'Babak Bina',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6902002f3b1700113eab58',
          department: 'Visual Effects',
          job: '3D Generalist',
        },
        {
          adult: false,
          gender: 0,
          id: 1815919,
          known_for_department: 'Visual Effects',
          name: 'Daniel Perez',
          original_name: 'Daniel Perez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690216459ad600185e6393',
          department: 'Visual Effects',
          job: '3D Generalist',
        },
        {
          adult: false,
          gender: 0,
          id: 1823796,
          known_for_department: 'Camera',
          name: 'Alan Shultz',
          original_name: 'Alan Shultz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666a2f55c926001362ec33',
          department: 'Camera',
          job: 'Dolly Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1842149,
          known_for_department: 'Sound',
          name: 'Matt Yocum',
          original_name: 'Matt Yocum',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5e67c51ee38bd8001315f6c3',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1856174,
          known_for_department: 'Art',
          name: 'Vicki Pui',
          original_name: 'Vicki Pui',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6662f7459ad600135bb8e6',
          department: 'Art',
          job: 'Concept Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1883407,
          known_for_department: 'Diễn viên',
          name: 'Danny MAlin',
          original_name: 'Danny MAlin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a5d52357c0000193f804b',
          department: 'Production',
          job: 'Extras Casting',
        },
        {
          adult: false,
          gender: 1,
          id: 1890944,
          known_for_department: 'Camera',
          name: 'Marie-Julie Besse',
          original_name: 'Marie-Julie Besse',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666b6b151c5c001501bfbd',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1903911,
          known_for_department: 'Visual Effects',
          name: 'Aaron Reznick',
          original_name: 'Aaron Reznick',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690ea2459ad600135f6926',
          department: 'Visual Effects',
          job: 'Visual Effects Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1903916,
          known_for_department: 'Visual Effects',
          name: 'Tricia Kim',
          original_name: 'Tricia Kim',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e69096dcabfe400130e6883',
          department: 'Visual Effects',
          job: 'Matchmove Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1929030,
          known_for_department: 'Art',
          name: 'Radia Slaimi',
          original_name: 'Radia Slaimi',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5e6665d1357c00001139970e',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1930230,
          known_for_department: 'Visual Effects',
          name: 'Bill Wang',
          original_name: 'Bill Wang',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690edd459ad600185e7cfa',
          department: 'Visual Effects',
          job: 'Visual Effects Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1933914,
          known_for_department: 'Lighting',
          name: 'David Villeneuve',
          original_name: 'David Villeneuve',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666af0357c0000133a0f68',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 1938584,
          known_for_department: 'Crew',
          name: 'Nathalie Legault',
          original_name: 'Nathalie Legault',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666ff98d52c900173f6ef8',
          department: 'Costume & Make-Up',
          job: 'Assistant Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1940693,
          known_for_department: 'Visual Effects',
          name: 'Micah Gallagher',
          original_name: 'Micah Gallagher',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e69065f357c0000193db0a7',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1942271,
          known_for_department: 'Costume & Make-Up',
          name: 'Jen Martin',
          original_name: 'Jen Martin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a59a32f3b1700173fe319',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1967588,
          known_for_department: 'Costume & Make-Up',
          name: 'Jean Scarabin',
          original_name: 'Jean Scarabin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6670ac55c9260017612ab5',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1982003,
          known_for_department: 'Visual Effects',
          name: 'Greta Ruljevaite',
          original_name: 'Greta Ruljevaite',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5e690e69151c5c001705b159',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1993875,
          known_for_department: 'Directing',
          name: 'Bethan Mowat',
          original_name: 'Bethan Mowat',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a5df7459ad600185fddaa',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 1,
          id: 1997336,
          known_for_department: 'Production',
          name: 'Angela Laprete',
          original_name: 'Angela Laprete',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a620555c926001367cf22',
          department: 'Production',
          job: 'Production Consultant',
        },
        {
          adult: false,
          gender: 0,
          id: 1998206,
          known_for_department: 'Crew',
          name: 'Marc Roth',
          original_name: 'Marc Roth',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e69039f459ad600185e66a7',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1999492,
          known_for_department: 'Costume & Make-Up',
          name: 'Daniel McGraw',
          original_name: 'Daniel McGraw',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2OPwe3pOWjB7eVNAxkp0Mo6JcfP.jpg',
          credit_id: '5fa99c2894d8a80042e14031',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2000413,
          known_for_department: 'Visual Effects',
          name: 'Errol Stussi',
          original_name: 'Errol Stussi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690d83cabfe400180e751a',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2000427,
          known_for_department: 'Visual Effects',
          name: 'Nick Crew',
          original_name: 'Nick Crew',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5e690f51151c5c0013053f45',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 2010394,
          known_for_department: 'Visual Effects',
          name: 'Ilkka Uitto',
          original_name: 'Ilkka Uitto',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5e690b37151c5c001904b9b3',
          department: 'Visual Effects',
          job: 'VFX Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2010411,
          known_for_department: 'Visual Effects',
          name: 'Marshall Rainey',
          original_name: 'Marshall Rainey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690c64151c5c0015055d2a',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2010426,
          known_for_department: 'Crew',
          name: 'Timur Yesilfiliz',
          original_name: 'Timur Yesilfiliz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690b7755c926001764d830',
          department: 'Visual Effects',
          job: 'VFX Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2013355,
          known_for_department: 'Lighting',
          name: 'Prapanch Swamy',
          original_name: 'Prapanch Swamy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690418357c0000113d2968',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2020371,
          known_for_department: 'Art',
          name: 'Tom Curtis',
          original_name: 'Tom Curtis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6666488d52c900193f3385',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2020375,
          known_for_department: 'Art',
          name: 'Craig K. Lewis',
          original_name: 'Craig K. Lewis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666528151c5c0019010322',
          department: 'Art',
          job: 'Set Decoration Buyer',
        },
        {
          adult: false,
          gender: 0,
          id: 2029556,
          known_for_department: 'Diễn viên',
          name: 'Mandalyn Forbes',
          original_name: 'Mandalyn Forbes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690cfd151c5c0015055eb2',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2068402,
          known_for_department: 'Visual Effects',
          name: 'Rodgers Paul',
          original_name: 'Rodgers Paul',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6908b955c926001764d262',
          department: 'Visual Effects',
          job: 'Matte Painter',
        },
        {
          adult: false,
          gender: 0,
          id: 2069402,
          known_for_department: 'Costume & Make-Up',
          name: 'Josh Mar',
          original_name: 'Josh Mar',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a5966cabfe400180fca33',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2091376,
          known_for_department: 'Lighting',
          name: 'Allen Mozo',
          original_name: 'Allen Mozo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666d6155c92600196106d8',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2092046,
          known_for_department: 'Visual Effects',
          name: 'Michael Porterfield',
          original_name: 'Michael Porterfield',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6906702f3b1700173e61f1',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2092290,
          known_for_department: 'Visual Effects',
          name: 'Mariana Gorbea',
          original_name: 'Mariana Gorbea',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6909ea55c926001764d525',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 2093363,
          known_for_department: 'Sound',
          name: 'Michal Wilczewski',
          original_name: 'Michal Wilczewski',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e67c40e55c926001763371c',
          department: 'Sound',
          job: 'Foley Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2118455,
          known_for_department: 'Production',
          name: 'Karen Wood',
          original_name: 'Karen Wood',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a5c92cedac40015479e92',
          department: 'Production',
          job: 'Casting Associate',
        },
        {
          adult: false,
          gender: 2,
          id: 2119481,
          known_for_department: 'Sound',
          name: 'Jacek Wiśniewski',
          original_name: 'Jacek Wiśniewski',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e67c3e4151c5c001703c0b1',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2124101,
          known_for_department: 'Visual Effects',
          name: 'Philip Nussbaumer',
          original_name: 'Philip Nussbaumer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690bae459ad6001a5f51ef',
          department: 'Visual Effects',
          job: 'VFX Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2145209,
          known_for_department: 'Visual Effects',
          name: 'Florian Franke',
          original_name: 'Florian Franke',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6905392f3b1700173e5eba',
          department: 'Visual Effects',
          job: 'Compositing Lead',
        },
        {
          adult: false,
          gender: 0,
          id: 2150661,
          known_for_department: 'Visual Effects',
          name: 'Rodions Jepejevs',
          original_name: 'Rodions Jepejevs',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e69054b2f3b1700173e5ec3',
          department: 'Visual Effects',
          job: 'Compositing Lead',
        },
        {
          adult: false,
          gender: 0,
          id: 2202749,
          known_for_department: 'Crew',
          name: 'Mark Spindler',
          original_name: 'Mark Spindler',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e69064e55c926001764cf17',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2211397,
          known_for_department: 'Visual Effects',
          name: 'Eun Young Kim',
          original_name: 'Eun Young Kim',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690903459ad600115e3701',
          department: 'Visual Effects',
          job: 'Matte Painter',
        },
        {
          adult: false,
          gender: 0,
          id: 2220725,
          known_for_department: 'Art',
          name: 'Catherine Lam',
          original_name: 'Catherine Lam',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e66653f55c926001362e1df',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2230126,
          known_for_department: 'Crew',
          name: 'Stephane Boisvert',
          original_name: 'Stephane Boisvert',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666c0d357c0000133a1131',
          department: 'Crew',
          job: 'Generator Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 2236499,
          known_for_department: 'Camera',
          name: 'David Dinel',
          original_name: 'David Dinel',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5e666c5c357c00001939e28a',
          department: 'Camera',
          job: 'Key Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2252964,
          known_for_department: 'Crew',
          name: 'Rebecca Gausnell',
          original_name: 'Rebecca Gausnell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a6155357c0000133f459d',
          department: 'Crew',
          job: 'Dialect Coach',
        },
        {
          adult: false,
          gender: 0,
          id: 2278934,
          known_for_department: 'Crew',
          name: 'Thomas Weckenmann',
          original_name: 'Thomas Weckenmann',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690b6655c926001764d817',
          department: 'Visual Effects',
          job: 'VFX Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2285867,
          known_for_department: 'Visual Effects',
          name: 'Tricia Mulgrew',
          original_name: 'Tricia Mulgrew',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690e5b459ad6001a5f5558',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2348741,
          known_for_department: 'Costume & Make-Up',
          name: 'Jean-Manuel Medina',
          original_name: 'Jean-Manuel Medina',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5e667143459ad6001a5b3b9a',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 2356331,
          known_for_department: 'Art',
          name: 'Gaby Miègeville-Little',
          original_name: 'Gaby Miègeville-Little',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6665ae8d52c900193f32b1',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2366716,
          known_for_department: 'Diễn viên',
          name: 'Mónica Caballero',
          original_name: 'Mónica Caballero',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666d2b357c000016396501',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 2,
          id: 2389963,
          known_for_department: 'Art',
          name: 'Simon Théberge',
          original_name: 'Simon Théberge',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6665e7357c000016395b9a',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2413641,
          known_for_department: 'Sound',
          name: 'Filip Stefanowski',
          original_name: 'Filip Stefanowski',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e67c424357c0000113b9bfa',
          department: 'Sound',
          job: 'Foley Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 2431753,
          known_for_department: 'Art',
          name: 'Pierre Antoine Rousse',
          original_name: 'Pierre Antoine Rousse',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e66672955c926001362e77c',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 2,
          id: 2470452,
          known_for_department: 'Production',
          name: 'Miguel Palos',
          original_name: 'Miguel Palos',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fc7cb9555c1f4003f5fa897',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2476634,
          known_for_department: 'Lighting',
          name: 'John M.H. Lee',
          original_name: 'John M.H. Lee',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666d51357c00001939e3c2',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2477309,
          known_for_department: 'Costume & Make-Up',
          name: 'Aaron Ellis',
          original_name: 'Aaron Ellis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a5910357c0000163e634b',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2495183,
          known_for_department: 'Costume & Make-Up',
          name: 'Arthur B Wilson III',
          original_name: 'Arthur B Wilson III',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e66715655c926001362f55e',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 2504443,
          known_for_department: 'Costume & Make-Up',
          name: 'Catherine Lahaye',
          original_name: 'Catherine Lahaye',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e667201459ad600135bd458',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2504842,
          known_for_department: 'Camera',
          name: 'Gary Pachany',
          original_name: 'Gary Pachany',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666b908d52c900173f65dc',
          department: 'Camera',
          job: 'First Assistant "B" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2551858,
          known_for_department: 'Art',
          name: 'Chris Lewis',
          original_name: 'Chris Lewis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e66655f8d52c900173f586c',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2555201,
          known_for_department: 'Sound',
          name: 'Nicolas Dallaire',
          original_name: 'Nicolas Dallaire',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e67c291151c5c00190305ab',
          department: 'Sound',
          job: 'ADR Recordist',
        },
        {
          adult: false,
          gender: 0,
          id: 2558864,
          known_for_department: 'Costume & Make-Up',
          name: 'Jeong-Hwa Fonkalsrud',
          original_name: 'Jeong-Hwa Fonkalsrud',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e667272459ad6001a5b3f03',
          department: 'Costume & Make-Up',
          job: 'Makeup Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 2559398,
          known_for_department: 'Visual Effects',
          name: 'Magnus Skagerlund',
          original_name: 'Magnus Skagerlund',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690a522f3b1700113eb83c',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 2561209,
          known_for_department: 'Art',
          name: 'Justin Neenan',
          original_name: 'Justin Neenan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6665c055c926001362e43f',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2561211,
          known_for_department: 'Art',
          name: 'Cedric Levesque',
          original_name: 'Cedric Levesque',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e66665855c926001960f509',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2561212,
          known_for_department: 'Art',
          name: 'Maxime Privé',
          original_name: 'Maxime Privé',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6666bb459ad600135bbcbb',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2561214,
          known_for_department: 'Art',
          name: 'Nicolas Privé',
          original_name: 'Nicolas Privé',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6667148d52c9001d3f3f15',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2561215,
          known_for_department: 'Art',
          name: 'Johannes Muecke',
          original_name: 'Johannes Muecke',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6901a8459ad600185e62bc',
          department: 'Art',
          job: 'Title Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2561215,
          known_for_department: 'Art',
          name: 'Johannes Muecke',
          original_name: 'Johannes Muecke',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e66679a357c000016395df4',
          department: 'Art',
          job: 'Storyboard Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2561220,
          known_for_department: 'Lighting',
          name: 'Joshua Atkin',
          original_name: 'Joshua Atkin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e66690b151c5c001501bb21',
          department: 'Lighting',
          job: 'Best Boy Electric',
        },
        {
          adult: false,
          gender: 0,
          id: 2561221,
          known_for_department: 'Camera',
          name: 'Tuiaana Scanlan',
          original_name: 'Tuiaana Scanlan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e66692455c926001960fda8',
          department: 'Camera',
          job: 'Best Boy Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2561224,
          known_for_department: 'Camera',
          name: 'Reid Murphy',
          original_name: 'Reid Murphy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6669b9151c5c001901079d',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 2561227,
          known_for_department: 'Camera',
          name: 'Jeroen Hendriks',
          original_name: 'Jeroen Hendriks',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666a1955c9260019610165',
          department: 'Camera',
          job: 'Digital Imaging Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2561231,
          known_for_department: 'Camera',
          name: 'Michael Keola Jones',
          original_name: 'Michael Keola Jones',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666a4c459ad600185af032',
          department: 'Camera',
          job: 'Dolly Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2561232,
          known_for_department: 'Lighting',
          name: 'Aaron McMullen',
          original_name: 'Aaron McMullen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666ae0459ad6001a5b2ce7',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 2561237,
          known_for_department: 'Crew',
          name: 'Todd Schatz',
          original_name: 'Todd Schatz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666c1d151c5c0019010c46',
          department: 'Crew',
          job: 'Generator Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 2561239,
          known_for_department: 'Lighting',
          name: 'James Takahashi',
          original_name: 'James Takahashi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666dd3459ad6001a5b339e',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2561240,
          known_for_department: 'Lighting',
          name: 'Curtis Wingerter',
          original_name: 'Curtis Wingerter',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666de3151c5c001301bdbd',
          department: 'Lighting',
          job: 'Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2561258,
          known_for_department: 'Costume & Make-Up',
          name: 'Liliane Saad',
          original_name: 'Liliane Saad',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e666fd0151c5c001301c168',
          department: 'Costume & Make-Up',
          job: 'Assistant Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 2561259,
          known_for_department: 'Costume & Make-Up',
          name: 'Eli Girard',
          original_name: 'Eli Girard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6670858d52c9001d3f48b5',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 2561261,
          known_for_department: 'Costume & Make-Up',
          name: 'Sheldon Yamauchi',
          original_name: 'Sheldon Yamauchi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6670958d52c900173f7099',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 2561265,
          known_for_department: 'Costume & Make-Up',
          name: 'Paula Hong',
          original_name: 'Paula Hong',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e66713255c92600156102ae',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 2561274,
          known_for_department: 'Costume & Make-Up',
          name: 'Christine Carrière',
          original_name: 'Christine Carrière',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e66726255c926001362f7d6',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2562227,
          known_for_department: 'Sound',
          name: 'Natalia Lubowiecka',
          original_name: 'Natalia Lubowiecka',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e67c3f6e38bd80015160874',
          department: 'Sound',
          job: 'Foley Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2563025,
          known_for_department: 'Visual Effects',
          name: 'Joshua Hakim',
          original_name: 'Joshua Hakim',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6901ee55c926001564baf7',
          department: 'Visual Effects',
          job: '3D Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2563034,
          known_for_department: 'Visual Effects',
          name: 'Steve Seongik Hong',
          original_name: 'Steve Seongik Hong',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e69030dcabfe400110e74a9',
          department: 'Visual Effects',
          job: 'Animation Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2563035,
          known_for_department: 'Visual Effects',
          name: 'Johannes Wolz',
          original_name: 'Johannes Wolz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e69032355c9260013666b91',
          department: 'Visual Effects',
          job: 'Animation Technical Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2563039,
          known_for_department: 'Crew',
          name: 'Evgeny Berbasov',
          original_name: 'Evgeny Berbasov',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6903b0459ad600185e66e3',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2563040,
          known_for_department: 'Crew',
          name: 'Jason Hannen-Williams',
          original_name: 'Jason Hannen-Williams',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6903bf2f3b1700113eaf59',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2563044,
          known_for_department: 'Crew',
          name: 'Ryo Sakaguchi',
          original_name: 'Ryo Sakaguchi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6904332f3b1700143e56b9',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2563045,
          known_for_department: 'Crew',
          name: 'Matthew Novak',
          original_name: 'Matthew Novak',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6904c1cabfe400150e79a4',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2563051,
          known_for_department: 'Visual Effects',
          name: 'Jean-Philippe Tristant',
          original_name: 'Jean-Philippe Tristant',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e69055c55c9260019649c46',
          department: 'Visual Effects',
          job: 'Compositing Lead',
        },
        {
          adult: false,
          gender: 0,
          id: 2563053,
          known_for_department: 'Visual Effects',
          name: 'Enrique Sandoval Castro',
          original_name: 'Enrique Sandoval Castro',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5e690593357c0000113d30a2',
          department: 'Visual Effects',
          job: 'Compositing Lead',
        },
        {
          adult: false,
          gender: 0,
          id: 2563054,
          known_for_department: 'Visual Effects',
          name: 'Danielle Norgate',
          original_name: 'Danielle Norgate',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6905a455c926001564bdc7',
          department: 'Visual Effects',
          job: 'Compositing Lead',
        },
        {
          adult: false,
          gender: 0,
          id: 2563055,
          known_for_department: 'Visual Effects',
          name: 'Henrique Reginato',
          original_name: 'Henrique Reginato',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6905b5151c5c001705a880',
          department: 'Visual Effects',
          job: 'Compositing Lead',
        },
        {
          adult: false,
          gender: 0,
          id: 2563057,
          known_for_department: 'Visual Effects',
          name: 'Phil Prates',
          original_name: 'Phil Prates',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6905ef459ad600135f599b',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2563059,
          known_for_department: 'Visual Effects',
          name: 'Egbert Reichel',
          original_name: 'Egbert Reichel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6905fe55c926001764cedd',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2563061,
          known_for_department: 'Visual Effects',
          name: 'Michael J. Viera',
          original_name: 'Michael J. Viera',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690681357c0000193db0e6',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2563066,
          known_for_department: 'Visual Effects',
          name: 'Ning Yan',
          original_name: 'Ning Yan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6907b02f3b1700113eb44e',
          department: 'Visual Effects',
          job: 'Lead Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 2563069,
          known_for_department: 'Visual Effects',
          name: 'Philipp Winterstein',
          original_name: 'Philipp Winterstein',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6907f02f3b1700173e649c',
          department: 'Visual Effects',
          job: 'Lead Animator',
        },
        {
          adult: false,
          gender: 0,
          id: 2563073,
          known_for_department: 'Visual Effects',
          name: 'Dasom Song',
          original_name: 'Dasom Song',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6908cdcabfe400110e7a92',
          department: 'Visual Effects',
          job: 'Matte Painter',
        },
        {
          adult: false,
          gender: 0,
          id: 2563074,
          known_for_department: 'Visual Effects',
          name: 'Peter Braeley',
          original_name: 'Peter Braeley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6908ddcabfe400110e7adf',
          department: 'Visual Effects',
          job: 'Matte Painter',
        },
        {
          adult: false,
          gender: 0,
          id: 2563076,
          known_for_department: 'Visual Effects',
          name: 'Chengwei Zheng',
          original_name: 'Chengwei Zheng',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6908ee151c5c001904b482',
          department: 'Visual Effects',
          job: 'Matte Painter',
        },
        {
          adult: false,
          gender: 0,
          id: 2563077,
          known_for_department: 'Visual Effects',
          name: 'Mujia Liao',
          original_name: 'Mujia Liao',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690914151c5c001904b518',
          department: 'Visual Effects',
          job: 'Matte Painter',
        },
        {
          adult: false,
          gender: 0,
          id: 2563079,
          known_for_department: 'Visual Effects',
          name: 'Kevin Mains',
          original_name: 'Kevin Mains',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6909b8459ad6001a5f4f1e',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 2563080,
          known_for_department: 'Visual Effects',
          name: 'Zaki Saati',
          original_name: 'Zaki Saati',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6909ca2f3b1700173e696a',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 2563081,
          known_for_department: 'Visual Effects',
          name: 'Dylan Dunford',
          original_name: 'Dylan Dunford',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6909da151c5c001904b78f',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 2563082,
          known_for_department: 'Visual Effects',
          name: 'Benjamin Lepine',
          original_name: 'Benjamin Lepine',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690a342f3b1700193ec696',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 2563083,
          known_for_department: 'Visual Effects',
          name: 'Ron Schrems',
          original_name: 'Ron Schrems',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690a42cabfe400150e81dc',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 2563086,
          known_for_department: 'Visual Effects',
          name: 'Laura Carnegie',
          original_name: 'Laura Carnegie',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690b00151c5c00130533eb',
          department: 'Visual Effects',
          job: 'VFX Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2563090,
          known_for_department: 'Visual Effects',
          name: 'Adam Figielski',
          original_name: 'Adam Figielski',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690b9c459ad600185e7661',
          department: 'Visual Effects',
          job: 'VFX Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2563093,
          known_for_department: 'Visual Effects',
          name: 'Selah Chung',
          original_name: 'Selah Chung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690c54459ad600185e775b',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2563095,
          known_for_department: 'Visual Effects',
          name: 'Natsai Todd',
          original_name: 'Natsai Todd',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690c74cabfe400110e815c',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2563096,
          known_for_department: 'Visual Effects',
          name: 'Aditya Menon',
          original_name: 'Aditya Menon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690c87cabfe400110e8179',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2563097,
          known_for_department: 'Visual Effects',
          name: 'Kin Yiu',
          original_name: 'Kin Yiu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690c9b2f3b1700193ecb55',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2563100,
          known_for_department: 'Visual Effects',
          name: 'Gray Xi',
          original_name: 'Gray Xi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690d33459ad600135f634e',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2563101,
          known_for_department: 'Visual Effects',
          name: 'Sophia Zhang',
          original_name: 'Sophia Zhang',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690d44459ad600185e79aa',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2563103,
          known_for_department: 'Visual Effects',
          name: 'Michael Armstrong',
          original_name: 'Michael Armstrong',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690d61cabfe400130e6bb1',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2563104,
          known_for_department: 'Visual Effects',
          name: 'Thelma Rangel',
          original_name: 'Thelma Rangel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690d70459ad600135f642e',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2563105,
          known_for_department: 'Visual Effects',
          name: 'Sofronie Dun',
          original_name: 'Sofronie Dun',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690e7b55c926001764dd69',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2563106,
          known_for_department: 'Visual Effects',
          name: 'Iva Modrah',
          original_name: 'Iva Modrah',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690e8ccabfe400180e79c6',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2563110,
          known_for_department: 'Visual Effects',
          name: 'Troy Moore',
          original_name: 'Troy Moore',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e690fbbcabfe400150e8a30',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2564194,
          known_for_department: 'Costume & Make-Up',
          name: 'Sara Eva Gonzalez',
          original_name: 'Sara Eva Gonzalez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a586655c9260015665554',
          department: 'Costume & Make-Up',
          job: 'Costume Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2564200,
          known_for_department: 'Production',
          name: 'Daryl Baboulis-Gyscek',
          original_name: 'Daryl Baboulis-Gyscek',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a5c6ccedac40017478e6e',
          department: 'Production',
          job: 'Casting Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2564203,
          known_for_department: 'Production',
          name: 'Johanna Bautista',
          original_name: 'Johanna Bautista',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a5d31357c0000193f8012',
          department: 'Production',
          job: 'Extras Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 2564204,
          known_for_department: 'Production',
          name: 'Dustin Snodgrass',
          original_name: 'Dustin Snodgrass',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a5d6855c9260017666084',
          department: 'Production',
          job: 'Extras Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 2564205,
          known_for_department: 'Production',
          name: 'Marie Medina',
          original_name: 'Marie Medina',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a5d942f3b170011403220',
          department: 'Production',
          job: 'Extras Casting Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2564206,
          known_for_department: 'Directing',
          name: 'Pauline Beraud',
          original_name: 'Pauline Beraud',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a5e5b459ad600115f8e33',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2564209,
          known_for_department: 'Editing',
          name: 'Trevor White',
          original_name: 'Trevor White',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a5fda55c926001367cd53',
          department: 'Editing',
          job: 'Colorist',
        },
        {
          adult: false,
          gender: 0,
          id: 2564210,
          known_for_department: 'Crew',
          name: 'Rob Scratch Mitchell',
          original_name: 'Rob Scratch Mitchell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a6091357c0000193f86b5',
          department: 'Crew',
          job: 'Aerial Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2564211,
          known_for_department: 'Production',
          name: 'Marie-Helene Roy',
          original_name: 'Marie-Helene Roy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a621fcabfe400180fd36d',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2564212,
          known_for_department: 'Production',
          name: 'Natacha Williams',
          original_name: 'Natacha Williams',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e6a6257357c0000163e6993',
          department: 'Production',
          job: 'Travel Coordinator',
        },
        {
          adult: false,
          gender: 1,
          id: 2607303,
          known_for_department: 'Directing',
          name: 'Carolina Jiménez',
          original_name: 'Carolina Jiménez',
          popularity: 1.214,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3GiT1cIGLb5XpuQmydHHscGcHFb.jpg',
          credit_id: '5eb834820cb3350020cff284',
          department: 'Directing',
          job: 'Layout',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'msbreviews',
          author_details: {
            name: '',
            username: 'msbreviews',
            avatar_path:
              '/https://secure.gravatar.com/avatar/992eef352126a53d7e141bf9e8707576.jpg',
            rating: 5.0,
          },
          content:
            "If you enjoy reading my Spoiler-Free reviews, please follow my blog :)\r\n\r\nWith all due respect to Roland Emmerich and to his fantastic Independence Day, his movies never quite reach their potential, ending up in constant disappointments. It doesn't matter if he has excellent casts or amazing VFX teams, his films' screenplays are almost always stuffed with narrative issues. Midway is simply another installment in his saga of letdowns. Without knowing the director, anyone who looks at this movie will feel instantly captivated. From the unbelievably talented cast to the impressive visuals, it has two attention-grabber ingredients, which can result in a remarkable film… only if the two pillars of any cinematic production are decent enough: story and characters.\r\n\r\nThese are the main issue with Emmerich's movies. His characters are not compelling or intriguing enough, and his screenplays lack creativity and excitement (whether these are written by him or someone else). When I noticed that Midway had such an acclaimed cast and that it was about the Battle of Midway, I immediately got excited. War epics are a genre that I sincerely appreciate. However, when I checked who was \"running the show\", I instantly lowered my expectations. Honestly, it's exactly what I expected it to be: visually gripping, but emotionally hollow.\r\n\r\nI don't want to understate it. The CGI work in this film is jaw-dropping. The actual war is riveting with astonishing aerial sequences and powerful sound design. Even at a regular screening with the usual 7.1 Dolby surround speakers, the floor was rumbling with the explosions and the planes. This is why I think audiences will definitely enjoy this movie. Maybe not a vast majority, but surely most people will leave their theaters feeling it was good entertainment. It has a long runtime, and it's hard to get through the exposition-heavy story, but in the end, I bet the general public will appreciate the war action enough to give the whole thing a thumbs up.\r\n\r\nNevertheless, it's still a very superficial flick. While it's very respectful to everyone who fought in the war (including the Nhật Bảnese) and to the historic event on itself, it lacks emotional attachment to its characters. Dunkirk was praised by both critics and audiences all around the world, but its main criticism connects to what I just wrote. Christopher Nolan's film also didn't have any compelling characters. However, there's a big difference between these two movies. Both their marketing and their ultimate goal are distinct. Dunkirk was all about showing the actual war. It never marketed itself as a character-study or that it would even have a significant focus on some of the heroes that fought there. Nolan repeated several times: it's about the war and the war only.\r\n\r\nIt's genuinely one of the best, if not the best, *pure* war film I've ever seen. When it comes to depicting the claustrophobic, unbreathable, restless, bloody, loud event that a devastating war is, Dunkirk is so realistic it can even become uncomfortable with just sitting in your chair (at least, I did in IMAX). On the other hand, Midway's marketing was about paying homage to \"people who fought in the Battle of Midway\". Hence the stellar cast compared to Nolan's just competent actors (with obvious exceptions like Mark Rylance or Tom Hardy). It spends most of its screentime trying to develop the actual people that helped win that battle, not with the action itself. Therefore, these characters need engaging scripts and emotionally resonant arcs.\r\n\r\nWes Tooke delivers a screenplay packed with so much exposition that a lot of it looks clearly unrealistic. Characters discuss specific topics that don't make any sense of being in a conversation at a particular time and place. Throughout the runtime, there are dialogue sequences with the sole purpose of explicitly telling the audience what we need to know to understand the story, which ends up turning the narrative confusing, convoluted, and lacking faster pacing. It's tough to get through the non-action periods, and I can't even imagine how dull it would be without such an impeccable cast. Ed Skrein remarkably portrays Dick Best, the only character who's genuinely compelling and carries a complete, well-developed arc.\r\n\r\nUnfortunately, I didn't feel invested in any other character. Only the best movies of every year can have a numerous and talented cast while giving each and every actor an exciting role. Midway has too many characters for the story it wants to tell. In addition to this, it has to stretch its runtime because you can't get Woody Harrelson or Dennis Quaid playing secondary roles and not giving them more than just a couple of lines. As time goes by, Emmerich's storytelling structure gets needlessly more and more complicated to follow. It's yet another film added to the \"wasted potential\" list…\r\n\r\nPotential due to how truly magnificent the action sequences can be. It's undeniable that these are entertaining, gripping, and exciting. The dive bombers' scenes are packed with so much tension that I was getting more and more frustrated every time they missed their target, and a bomb went into the sea. I wanted them to succeed so bad, and this feeling can only be triggered by something extraordinary. Midway's war is as close to epic as it could be, but as with every other cinematic production, if its story and its characters are not up to par with the action, there are no outstanding VFX that can save a lousy screenplay.\r\n\r\nAll in all, Midway is a respectful homage to the people who fought in the Battle of Midway, but it fails to deliver an engaging story with compelling characters. With more characters that what it needed, the runtime is stretched beyond its limit due to the numerous acclaimed actors who would never be in a movie if they didn't have more than a couple of lines. Roland Emmerich has to thank his VFX team for presenting the closest war action we could ever get of the famous battle. Truly epic visuals with tense and riveting aerial sequences, plus a powerful sound design, get your teeth biting the nails. Unfortunately, except for Ed Skrein's character, I didn't feel invested enough to appreciate the non-action moments due to the confusing, convoluted, and exposition-heavy narrative. It's a shame that a visually impressive film possesses such an emotionally dull story. However, I still recommend it for anyone who enjoys war epics and \"based on a true story\" adaptations.\r\n\r\nPS: it doesn’t hurt to research a bit about the Battle of Midway. I didn’t and I’m sort of regretting that now. Don’t make the same mistake. Going in with basic knowledge of what, how, and why it happened will only help you enjoy this movie more.\r\n\r\nRating: C+",
          created_at: '2019-11-08T17:18:24.954Z',
          id: '5dc5a360ab1bc70013ff7b68',
          updated_at: '2021-06-23T15:58:28.852Z',
          url: 'https://www.themoviedb.org/review/5dc5a360ab1bc70013ff7b68',
        },
        {
          author: 'Wuchak',
          author_details: {
            name: '',
            username: 'Wuchak',
            avatar_path: '/4KVM1VkqmXLOuwj1jjaSdxbvBDk.jpg',
            rating: 8.0,
          },
          content:
            '***Just the facts, Jack***\r\n\r\nIntelligence officer Edwin Layton (Patrick Wilson) warns that a Nhật Bảnese attack is imminent, but his advice is disregarded and the Nhật Bảnese use their carrier fleet to attack Pearl Harbor on December 7, 1941. Admiral Chester Nimitz (Woody Harrelson) swiftly assumes command of the heavily weakened US Pacific Fleet. After the Doolittle air raid on Tokyo & Honshu 4.5 months later, \tevents lead up to the Battle of Midway on June 4–7, 1942. Ed Skrein plays cocky pilot Dick Best while Dennis Quaid is on hand as carrier commander William "Bull" Halsey. \r\n\r\n"Midway" (2019) tackles the Battle of Midway and events leading up to it without throwing in a dramatic fictional story, like the love triangle of “Pearl Harbor” (2001). While I loved “Pearl Harbor” and proudly stand by it, “Midway” chooses to stick to the facts and is thrilling from beginning to end. The main cast members are all real-life figures and there’s a tribute to each at the close.  \r\n\r\nThis is superior to the 1976 movie because Roland Emmerich had the CGI technology to pull off the battle scenes which take place in & above the Pacific Ocean near the atoll of Midway, which is located a little over a thousand miles west of Hawaii. The flick successfully takes the viewer right into the midst of the fight on the water, in the air and under the water. It’s exciting, horrific and revelatory.   \r\n\r\nThe film runs almost 2 hours and 18 minutes.\r\n\r\nGRADE: A-',
          created_at: '2019-11-24T05:47:02.414Z',
          id: '5dda195628723c0014593266',
          updated_at: '2021-06-23T15:58:29.301Z',
          url: 'https://www.themoviedb.org/review/5dda195628723c0014593266',
        },
        {
          author: 'SWITCH.',
          author_details: {
            name: 'SWITCH.',
            username: 'maketheSWITCH',
            avatar_path: '/klZ9hebmc8biG1RC4WmzNFnciJN.jpg',
            rating: 3.0,
          },
          content:
            "War stories are only worth retelling in film if you're doing something new and interesting with the genre. Otherwise, it's just a retread of 'Pearl Harbour' or 'Fury' or any of the dozen other thematically-empty, explosion-happy extravaganzas from the last ten years. There's a compelling, nuanced, and affecting film to be made about Midway. This is not that film.\r\n- Jake Watt\r\n\r\nRead Jake's full article...\r\nhttps://www.maketheswitch.com.au/article/review-midway-sound-and-fury-signifying-nothing",
          created_at: '2020-01-30T05:29:57.522Z',
          id: '5e3269d5c56d2d0018521ffa',
          updated_at: '2021-06-23T15:58:33.600Z',
          url: 'https://www.themoviedb.org/review/5e3269d5c56d2d0018521ffa',
        },
        {
          author: 'JPV852',
          author_details: {
            name: '',
            username: 'JPV852',
            avatar_path: '/xNLOqXXVJf9m7WngUMLIMFsjKgh.jpg',
            rating: 8.0,
          },
          content:
            "Admittedly I have a love for anything involving World War II and although the dialogue was a bit spotty and some of the visual effects were okay at best, I still found this to be a pretty good war movie and nice performances all around. Probably doesn't rank all that high compared to others about Midway and Pearl Harbor, yet still found it to be worth checking out. **3.75/5**",
          created_at: '2020-02-26T19:33:11.410Z',
          id: '5e56c7f735811d00135d3dab',
          updated_at: '2021-06-23T15:58:34.475Z',
          url: 'https://www.themoviedb.org/review/5e56c7f735811d00135d3dab',
        },
        {
          author: 'SierraKiloBravo',
          author_details: {
            name: '',
            username: 'SierraKiloBravo',
            avatar_path:
              '/https://secure.gravatar.com/avatar/ee92332df4b8ec59eacb9f64cb419668.jpg',
            rating: 4.0,
          },
          content:
            "Click here for a video version of this review: youtu.be/2Mr6XRF4GR4\r\n\r\n_Midway_ is an ambitous film that sets out to follow the United States entry into World War Two, from the attack on Pearl Harbour through to the Battle of Midway. To tell this story it focuses on two main characters who are also based on real life people. There's Ed Skrein playing Dick Best, a pilot on the USS Enterprise, and Patrick Wilson playing intelligence officer Edwin Layton.\r\n\r\nAs you might imagine jamming seven months of war into just over two hours is a big task, and while they did manage to pull this off, the result is a movie that feels rushed, where we can't get to know all the many characters, and which probably requires a pretty strong knowledge of this time period in history to understand all the things that are rapidly being thrown on screen.\r\n\r\nI actually had a lot of trouble telling who was who in many of the scenes involving the pilots. Apart from Ed Skrein and Luke Evans the rest of the pilots and rear gunners are such a copy / paste of each other and they come and go so fast on screen that you have zero time to have any kind of emotional connection to them, even though the movie tries to make you feel for them. For a lead actor, Skrein is very wooden and uninspiring, and I don't think has shoulders big enough to carry his part of the film.\r\n\r\nThen, as if the 10,000 mile an hour story is not bad enough, this movie relies very heavily on visual effects. Apart from close-ups, everything you see that involves a ship or a plane is entirely CGI and it is woefully bad 99% of the time. I've used the Playstation analogy a lot, and this is another example. I feel like if they had cut back the story to not cover so many fights and battles, there would have been a lot less visual effect shots. And with less shots to create and render, perhaps those remaining would have come out looking more realistic. As it is, it really takes you out of the movie - the planes move like they are weightless and defy the laws of physics, the explosions look they were made in AfterEffects, and each scene on a ship has that horrible green screen glow about it.\r\n\r\nIn summary I think this movie suffers from trying to do too much all at once. This came off feeling more like a trilogy of movies about Pearl Harbour, The Doolittle Raid, and The Battle of Midway had been edited down to one single movie. The end result is a rushed film that is hard to follow, whose characters are difficult to connect with, and whose visual effects are video game level at best. This will not go down in history as a great war film.",
          created_at: '2020-04-25T00:41:29.987Z',
          id: '5ea38739af432400259ff3dc',
          updated_at: '2021-06-23T15:58:37.418Z',
          url: 'https://www.themoviedb.org/review/5ea38739af432400259ff3dc',
        },
        {
          author: 'Per Gunnar Jonsson',
          author_details: {
            name: 'Per Gunnar Jonsson',
            username: 'Dark Jedi',
            avatar_path:
              '/https://secure.gravatar.com/avatar/cbabaea0fa98692d00130498d7ac5d7c.jpg',
            rating: null,
          },
          content:
            'This movie was a bit of a positive surprise. I was actually prepared to not like it that much but Hollywood actually made a decent war movie without pushing their usual left wing political propaganda and woke SJW bullshit.\r\n\r\nIt’s really a good movie in pretty much all aspects.\r\n\r\nFirst, I liked that it covers quite a bit more than “just” Midway. It actually starts before the attack on Pearl Harbor. Then it covers the attack on Perl Harbor and also the famous Dolittle raid on Tokay to finally end up with the battle of Midway. All of it is more or less historically accurate. We also get to see a fair amount of the history from the viewpoint of the Nhật Bảnese. Whether that bit of the story is actually entirely accurate I guess no one will ever know of course.\r\n\r\nI also liked that they took the effort to get all Nhật Bảnese actors (or Nhật Bảnese looking at least) playing the Nhật Bảnese side and that they spoke Nhật Bảnese all the time. That’s the kind of thing that gives the right atmosphere for those parts of the movie.\r\n\r\nThe Diễn viên was overall good on both sides. I quite liked Woody Harrelson as Nimitz. Ed Skrein was probably the actor I felt made the most mediocre performance but that might just be me.\r\n\r\nOf course there can be no war movie without things going boom and this movie didn’t disappoint on that. It has plenty of action, lots of flight scenes and lots of thing being blown up and it was overall well made. The effects when large ships got torpedoed, bombed or when their munitions exploded was quite realistic. You could see the ships shuddering and the effect on the water around it.\r\n\r\nIf I should complain about something it was that the movie is too short. Given the large time period it covers there is so much material that it could easily have been longer. It almost felt a bit rushed. There could have been much more suspense around the battle of Midway itself and the part of how they got Yorktown operational, and hid the fact from the Nhật Bảnese, in time for the battle was altogether left out for example.\r\n\r\nThe movie was 2 hours 18 minutes long which is respectable but not that long by today’s standards. All three of the extended Lord of the Rings movies was three and a half hours long and this one could easily have been as long.',
          created_at: '2021-02-14T10:19:13.669Z',
          id: '6028f9213a48c500410d73ed',
          updated_at: '2021-06-23T15:58:51.704Z',
          url: 'https://www.themoviedb.org/review/6028f9213a48c500410d73ed',
        },
      ],
      total_pages: 1,
      total_results: 6,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/zvWFvOiWGSK3SetE6U8qtRl2AUs.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 36, name: 'Phim Lịch Sử' },
    ],
    homepage: '',
    id: 638032,
    imdb_id: 'tt10670442',
    original_language: 'zh',
    original_title: '夺冠',
    overview:
      'Bước Nhảy Vọt nói về sau 12 năm, đội tuyển bóng chuyền nữ Trung Quốc mới lại lọt vào trận chung kết Olympic. Những thăng trầm của đội tuyển bóng chuyền nữ Trung Quốc trong hơn 3 thập kỷ đã dần trôi đi.',
    popularity: 2.539,
    poster_path:
      'https://image.tmdb.org/t/p/w342/grRJYKcYjLMJ2lulnGmu0Qjquf1.jpg',
    production_companies: [],
    production_countries: [
      { iso_3166_1: 'CN', name: 'Trung Quốc' },
      { iso_3166_1: 'HK', name: 'Hồng Kông' },
    ],
    release_date: '2020-09-25',
    revenue: 0,
    runtime: 135,
    spoken_languages: [
      { english_name: 'Mandarin', iso_639_1: 'zh', name: '普通话' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Bước Nhảy Vọt',
    video: false,
    vote_average: 6.3,
    vote_count: 12,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Leap [TRAILER 05 - ENG SUB] Trung Quốc 2020 | Sports Drama | Gong Li | 夺冠',
          key: 'biqUKRDapvU',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: false,
          published_at: '2021-01-17T22:34:44.000Z',
          id: '6004d94830f79c003f0c428c',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 643,
          known_for_department: 'Diễn viên',
          name: 'Gong Li',
          original_name: 'Gong Li',
          popularity: 9.871,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uP3Fs3QUsGBxhNqGFWMnN1Z2l8z.jpg',
          cast_id: 1,
          character: 'Lang Ping',
          credit_id: '5d9d6c7fa6e2d200354f9865',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 128026,
          known_for_department: 'Diễn viên',
          name: 'Huang Bo',
          original_name: 'Huang Bo',
          popularity: 1.703,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zOzz4woq7dfcll9AR1yGiQbjY4.jpg',
          cast_id: 4,
          character: 'Chen Zhonghe',
          credit_id: '5dfb816265686e00158e3319',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 1086844,
          known_for_department: 'Diễn viên',
          name: 'Wu Gang',
          original_name: 'Wu Gang',
          popularity: 2.503,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2b7T8VVbGM6p2SUdg5vf4K9pxTC.jpg',
          cast_id: 5,
          character: 'Yuan Weimin',
          credit_id: '5dfb81ab5ed9620016e4ded8',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 1897274,
          known_for_department: 'Diễn viên',
          name: 'Peng Yuchang',
          original_name: 'Peng Yuchang',
          popularity: 2.734,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eeU2VRMJQIeX6Z4dvbVndmDlCVt.jpg',
          cast_id: 6,
          character: 'Chen Zhonghe (young)',
          credit_id: '5dfb81b4d1a8930019833026',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 2873063,
          known_for_department: 'Diễn viên',
          name: 'Lydia Bai',
          original_name: 'Lydia Bai',
          popularity: 0.6,
          profile_path: null,
          cast_id: 9,
          character: 'Lang Ping (young)',
          credit_id: '5fc1f39dd2f5b50041d61d15',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 1384277,
          known_for_department: 'Diễn viên',
          name: 'Li Xian',
          original_name: 'Li Xian',
          popularity: 1.371,
          profile_path: null,
          cast_id: 10,
          character: 'Director of the General Administration of Sport',
          credit_id: '5fc1f4202bcf67003fbf2737',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 1614347,
          known_for_department: 'Diễn viên',
          name: 'Xing Jiadong',
          original_name: 'Xing Jiadong',
          popularity: 1.4,
          profile_path: null,
          cast_id: 12,
          character: 'Li Xuegang',
          credit_id: '5fcf2201680be8003d1f27c0',
          order: 8,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 12455,
          known_for_department: 'Sound',
          name: 'Shigeru Umebayashi',
          original_name: 'Shigeru Umebayashi',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/h73YChptaEO6rbvGpPY2KlqxG8N.jpg',
          credit_id: '5e246ae9397df000169dfda7',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 56739,
          known_for_department: 'Directing',
          name: 'Peter Chan',
          original_name: 'Peter Chan',
          popularity: 1.331,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pITuexUp4J9SP9lcJ4Fa78hyPza.jpg',
          credit_id: '5d9d6cc4477215001d0324e7',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 57619,
          known_for_department: 'Production',
          name: 'Zhao Hai-Cheng',
          original_name: 'Zhao Hai-Cheng',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bmgYE21XNipFSASp2LRmYboOOcg.jpg',
          credit_id: '614244212bcf6700426ce9bb',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 586425,
          known_for_department: 'Camera',
          name: 'Jing-Pin Yu',
          original_name: 'Jing-Pin Yu',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/r64fBNeLEvjH5MXVYLJkePLLgfk.jpg',
          credit_id: '614250859f0e19002b075f20',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 1749479,
          known_for_department: 'Camera',
          name: 'Zhao Xiaoshi',
          original_name: 'Zhao Xiaoshi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e246b1dcf4b8b0012f65ae4',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 2106919,
          known_for_department: 'Biên kịch',
          name: 'Zhang Ji',
          original_name: 'Zhang Ji',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5d9d6dfea5046e0036833495',
          department: 'Biên kịch',
          job: 'Writer',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/riIO9hvZll4UEmVm5qsWM6fq4zZ.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [{ id: 27, name: 'Phim Kinh Dị' }],
    homepage: '',
    id: 39843,
    imdb_id: 'tt0111037',
    original_language: 'cn',
    original_title: '弱殺',
    overview:
      'Một tên giết người tâm thần có vấn đề với màu đỏ và đặc biệt với phụ nữ. Khi gặp phụ nữ trong bộ đồ màu đỏ, hắn trở nên điên loạn và cực kì nguy hiểm. Ngày nọ, hắn tấn công và xâm hai một cô gái làm công tác xã hội ở trại chăm sóc người bị thiểu năng. Cô gái may mắn thoát chết, lên kế hoạch trả thù kẻ gây ra vết thương lòng cho mình và loại trừ một mối nguy cho cả xã hội vì với cảnh sát, cô không thể chờ đến khi họ vào cuộc được.',
    popularity: 3.268,
    poster_path:
      'https://image.tmdb.org/t/p/w342/jTp27XNpfixSad5WjwCtOpLKTLl.jpg',
    production_companies: [],
    production_countries: [{ iso_3166_1: 'HK', name: 'Hồng Kông' }],
    release_date: '1994-10-20',
    revenue: 0,
    runtime: 97,
    spoken_languages: [
      { english_name: 'Cantonese', iso_639_1: 'cn', name: '广州话 / 廣州話' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Huyết Dụ Sát Nhân',
    video: false,
    vote_average: 7.3,
    vote_count: 10,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: '弱杀 Red to Kill 1994 DVDRip HALFCD 2Audios CHT edit110',
          key: 'jA7oim1Lewg',
          site: 'YouTube',
          size: 480,
          type: 'Trailer',
          official: false,
          published_at: '2020-02-05T11:18:48.000Z',
          id: '5e96767030f79c0012d7dd95',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 548052,
          known_for_department: 'Diễn viên',
          name: 'Lily Chung Suk-Wai',
          original_name: 'Lily Chung Suk-Wai',
          popularity: 3.142,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aXq9i924gUsurXwvltMbr5Wr0E4.jpg',
          cast_id: 3,
          character: 'Ming-Ming Yuk Kong',
          credit_id: '52fe47359251416c9106d987',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 230778,
          known_for_department: 'Diễn viên',
          name: 'Money Lo',
          original_name: 'Money Lo',
          popularity: 0.6,
          profile_path: null,
          cast_id: 4,
          character: 'Ka Lok Cheung',
          credit_id: '52fe47359251416c9106d98b',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 227806,
          known_for_department: 'Diễn viên',
          name: 'Ben Ng',
          original_name: 'Ben Ng',
          popularity: 3.058,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jKHeeOK0ay8cvhasjQgkAYU3ZAa.jpg',
          cast_id: 5,
          character: 'Chi Wai Chan',
          credit_id: '52fe47359251416c9106d98f',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 1195450,
          known_for_department: 'Diễn viên',
          name: 'Baat Leung-Gam',
          original_name: 'Baat Leung-Gam',
          popularity: 1.4,
          profile_path: null,
          cast_id: 6,
          character: '',
          credit_id: '5ce0f72e9251412ce1bad7b2',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 1629227,
          known_for_department: 'Diễn viên',
          name: 'Hui Sze-Man',
          original_name: 'Hui Sze-Man',
          popularity: 0.6,
          profile_path: null,
          cast_id: 7,
          character: '',
          credit_id: '603a684ccb5c8e004b22abe3',
          order: 4,
        },
        {
          adult: true,
          gender: 0,
          id: 552202,
          known_for_department: 'Diễn viên',
          name: 'Bobby Yip',
          original_name: 'Bobby Yip',
          popularity: 0.6,
          profile_path: null,
          cast_id: 8,
          character: 'Ugly Mental Patient',
          credit_id: '603a68ac43494f5076ad99bb',
          order: 5,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 0,
          id: 1063349,
          known_for_department: 'Directing',
          name: 'Billy Tang',
          original_name: 'Billy Tang',
          popularity: 1.314,
          profile_path: null,
          credit_id: '52fe47359251416c9106d97d',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1157306,
          known_for_department: 'Biên kịch',
          name: 'Wong Ho-Wa',
          original_name: 'Wong Ho-Wa',
          popularity: 1.176,
          profile_path: null,
          credit_id: '52fe47359251416c9106d983',
          department: 'Biên kịch',
          job: 'Writer',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/fryB9DApUwB0zEdlZtDH1RefHuD.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 16, name: 'Phim Hoạt Hình' },
      { id: 14, name: 'Phim Giả Tượng' },
    ],
    homepage: '',
    id: 518604,
    imdb_id: 'tt7403574',
    original_language: 'ru',
    original_title: 'Принцесса и дракон',
    overview:
      'Vào sinh nhật lần thứ 7 của mình, Công chúa Barbara khám phá ra một cuốn sách ma thuật đưa cô đến Wonderland, một nơi đầy mê hoặc với những con rồng và những sinh vật kỳ diệu.',
    popularity: 4.428,
    poster_path:
      'https://image.tmdb.org/t/p/w342/jB2gQVdsnCctEDp11EfgtjJhSW7.jpg',
    production_companies: [
      {
        id: 103418,
        logo_path: null,
        name: 'Licensing Brands',
        origin_country: 'RU',
      },
      {
        id: 7036,
        logo_path: '/javbyY0ZCvlFJtly3tpZqf2NwLX.png',
        name: 'CJ Entertainment',
        origin_country: 'KR',
      },
    ],
    production_countries: [{ iso_3166_1: 'RU', name: 'Russia' }],
    release_date: '2018-08-23',
    revenue: 0,
    runtime: 75,
    spoken_languages: [
      { english_name: 'Russian', iso_639_1: 'ru', name: 'Pусский' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Công Chúa Luyện Rồng',
    video: false,
    vote_average: 7.3,
    vote_count: 16,
    videos: { results: [] },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 2046420,
          known_for_department: 'Diễn viên',
          name: 'Irina Kireeva',
          original_name: 'Irina Kireeva',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7ohjYfffIa6lbBrFb5KjFCElnnN.jpg',
          cast_id: 5,
          character: 'Queen',
          credit_id: '5b9687fbc3a3685688031b7b',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 813884,
          known_for_department: 'Diễn viên',
          name: 'Ani Lorak',
          original_name: 'Ani Lorak',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7q69DMh3ZSTXHyg29OPxZEZ9L7s.jpg',
          cast_id: 7,
          character: 'Princess Barbara',
          credit_id: '5b96882d9251414330036dd1',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 1881951,
          known_for_department: 'Diễn viên',
          name: 'Sergey Smirnov',
          original_name: 'Sergey Smirnov',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qeUAuj0bUXHRPMuBcBi0Mmwgfl0.jpg',
          cast_id: 8,
          character: 'Dragosha',
          credit_id: '5b968854c3a368567603422e',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 1754218,
          known_for_department: 'Diễn viên',
          name: 'Diomid Vinogradov',
          original_name: 'Diomid Vinogradov',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4VXryQlIAvpsXwUm2VTqsQI4ouJ.jpg',
          cast_id: 9,
          character: 'King',
          credit_id: '5b96886ac3a368568103f2ed',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 2125631,
          known_for_department: 'Diễn viên',
          name: 'Konstantin Kozhevnikov',
          original_name: 'Konstantin Kozhevnikov',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rJ1kykRzR2MusB63QUi1zgzlRPz.jpg',
          cast_id: 6,
          character: 'Balthasar',
          credit_id: '5b9688140e0a261973035d6e',
          order: 4,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 238618,
          known_for_department: 'Production',
          name: 'Roman Borisevich',
          original_name: 'Roman Borisevich',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hE23Ry7anuIqg1MQgnAphUHrOLU.jpg',
          credit_id: '5ad50531c3a3680bff005c46',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1265147,
          known_for_department: 'Biên kịch',
          name: 'Vasiliy Rovenskiy',
          original_name: 'Vasiliy Rovenskiy',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tzHUJ2ElcNkvrG8auKtCElzc7r0.jpg',
          credit_id: '5ad5050cc3a3680c050062cb',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 1265147,
          known_for_department: 'Biên kịch',
          name: 'Vasiliy Rovenskiy',
          original_name: 'Vasiliy Rovenskiy',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tzHUJ2ElcNkvrG8auKtCElzc7r0.jpg',
          credit_id: '5ad50516c3a3680c050062d9',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 2023972,
          known_for_department: 'Production',
          name: 'Maxim Rogalsky',
          original_name: 'Maxim Rogalsky',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad505280e0a2660bf0064df',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2023980,
          known_for_department: 'Directing',
          name: 'Marina Nefedova',
          original_name: 'Marina Nefedova',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ad50500c3a3680c09006805',
          department: 'Directing',
          job: 'Director',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/qqsMWcJCnl11IllBLvEWmleRbEQ.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 80, name: 'Phim Hình Sự' },
    ],
    homepage: 'http://www.mymovies.it/gomorra/',
    id: 8882,
    imdb_id: 'tt0929425',
    original_language: 'it',
    original_title: 'Gomorra',
    overview:
      'Một thủ quỹ thiện tâm nhưng bị buộc phải làm việc cho một tổ chức tội phạm để rồi phải chịu sự nguyền rủa của láng giềng; một cậu bé chưa qua tuổi thành niên nhưng đã muốn trở thành tay chân của tội phạm đến nỗi bán đứng cả người thân; một thợ may bậc cao vì thiếu tiền nên phải lén lút truyền nghề cho đối thủ cạnh tranh với xưởng may nơi mình làm việc; một cử nhân mới ra trường phải chứng kiến công việc của mình đang đẩy người dân vào bước đường cùng; và câu chuyện về 2 thanh niên khao khát có được sự tôn trọng trong thế giới tội phạm. Năm câu chuyện hoàn toàn độc lập nhưng đã giúp khán giả hình dung được bộ mặt thật của mafia Italia thời hiện đại.',
    popularity: 10.884,
    poster_path:
      'https://image.tmdb.org/t/p/w342/t1W5qvdIyimeltRjTaT4Z8KWZ0l.jpg',
    production_companies: [
      {
        id: 2441,
        logo_path: '/7Vutdea75apwXkRyfQ4Ne6j0KcN.png',
        name: 'Fandango',
        origin_country: 'IT',
      },
      {
        id: 18973,
        logo_path: '/lM081nCPhuKIPc2lJWstsQAlIaJ.png',
        name: '01 Distribution',
        origin_country: 'IT',
      },
      {
        id: 1583,
        logo_path: '/gKP4egMJOi5rksdnplfPV1wa0sd.png',
        name: 'RAI',
        origin_country: 'IT',
      },
    ],
    production_countries: [{ iso_3166_1: 'IT', name: 'Italy' }],
    release_date: '2008-01-01',
    revenue: 0,
    runtime: 135,
    spoken_languages: [
      { english_name: 'Italian', iso_639_1: 'it', name: 'Italiano' },
      { english_name: 'Mandarin', iso_639_1: 'zh', name: '普通话' },
      { english_name: 'French', iso_639_1: 'fr', name: 'Français' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Giữa Muôn Trùng Tội Ác',
    video: false,
    vote_average: 6.9,
    vote_count: 948,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Gomorrah (2008) official trailer [1080p HD]',
          key: 'QmwUVwsAEGE',
          published_at: '2009-02-04T06:06:38.000Z',
          site: 'YouTube',
          size: 720,
          type: 'Trailer',
          official: false,
          id: '533ec664c3a3685448001456',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'gomorrah trailer 640x360',
          key: 'MN7-tepnIfY',
          published_at: '2009-01-05T15:33:36.000Z',
          site: 'YouTube',
          size: 360,
          type: 'Trailer',
          official: false,
          id: '533ec664c3a3685448001455',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 72782,
          known_for_department: 'Diễn viên',
          name: 'Toni Servillo',
          original_name: 'Toni Servillo',
          popularity: 1.451,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fimZhhBC5fRJ0opQqdDuELfVcBs.jpg',
          cast_id: 18,
          character: 'Franco',
          credit_id: '52fe44c4c3a36847f80a8dad',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 72779,
          known_for_department: 'Diễn viên',
          name: 'Gianfelice Imparato',
          original_name: 'Gianfelice Imparato',
          popularity: 0.828,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pUacKAYqx1zImabM69RhY9DUqLj.jpg',
          cast_id: 15,
          character: 'Don Ciro',
          credit_id: '52fe44c4c3a36847f80a8da1',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 72780,
          known_for_department: 'Diễn viên',
          name: 'Maria Nazionale',
          original_name: 'Maria Nazionale',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/x9SHHntTIvwn16ISnxH3DVFSFkz.jpg',
          cast_id: 16,
          character: 'Maria',
          credit_id: '52fe44c4c3a36847f80a8da5',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 72785,
          known_for_department: 'Diễn viên',
          name: 'Salvatore Cantalupo',
          original_name: 'Salvatore Cantalupo',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lcYF2lNmqxIYNa6ZTFaXODLrid3.jpg',
          cast_id: 21,
          character: 'Pasquale',
          credit_id: '52fe44c4c3a36847f80a8db9',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 72786,
          known_for_department: 'Diễn viên',
          name: 'Gigio Morra',
          original_name: 'Gigio Morra',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/n4osWBIcJVgs7KyoaFZPxaBJfYD.jpg',
          cast_id: 22,
          character: 'Iavarone',
          credit_id: '52fe44c4c3a36847f80a8dbd',
          order: 4,
        },
        {
          adult: false,
          gender: 0,
          id: 72788,
          known_for_department: 'Diễn viên',
          name: 'Marco Macor',
          original_name: 'Marco Macor',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iq1sagZjNVaEI0swnVIsbhqQluf.jpg',
          cast_id: 24,
          character: 'Marco',
          credit_id: '52fe44c4c3a36847f80a8dc5',
          order: 5,
        },
        {
          adult: false,
          gender: 0,
          id: 72775,
          known_for_department: 'Diễn viên',
          name: 'Salvatore Abruzzese',
          original_name: 'Salvatore Abruzzese',
          popularity: 0.6,
          profile_path: null,
          cast_id: 11,
          character: 'Toto',
          credit_id: '52fe44c4c3a36847f80a8d91',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 72789,
          known_for_department: 'Diễn viên',
          name: 'Ciro Petrone',
          original_name: 'Ciro Petrone',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oRYd6Iodd2zY0XB2Sa4O0YbBe4U.jpg',
          cast_id: 25,
          character: 'Ciro',
          credit_id: '52fe44c4c3a36847f80a8dc9',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 72777,
          known_for_department: 'Diễn viên',
          name: 'Salvatore Ruocco',
          original_name: 'Salvatore Ruocco',
          popularity: 1.242,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yYwUkA3BxAuCu7M84YNay9NLa4h.jpg',
          cast_id: 13,
          character: 'Boxer',
          credit_id: '52fe44c4c3a36847f80a8d99',
          order: 8,
        },
        {
          adult: false,
          gender: 0,
          id: 72783,
          known_for_department: 'Diễn viên',
          name: 'Carmine Paternoster',
          original_name: 'Carmine Paternoster',
          popularity: 1.532,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jMg3Y5wHLbPQBnC58P1Tjl5aKMW.jpg',
          cast_id: 19,
          character: 'Roberto',
          credit_id: '52fe44c4c3a36847f80a8db1',
          order: 9,
        },
        {
          adult: false,
          gender: 0,
          id: 1882931,
          known_for_department: 'Diễn viên',
          name: 'Gaetano Altamura',
          original_name: 'Gaetano Altamura',
          popularity: 0.6,
          profile_path: null,
          cast_id: 29,
          character: 'Gaetano',
          credit_id: '59afbedec3a36824430111f3',
          order: 10,
        },
        {
          adult: false,
          gender: 0,
          id: 1882932,
          known_for_department: 'Diễn viên',
          name: 'Italo Renda',
          original_name: 'Italo Renda',
          popularity: 0.6,
          profile_path: null,
          cast_id: 30,
          character: 'Italo',
          credit_id: '59afbee6c3a3682cc8069029',
          order: 11,
        },
        {
          adult: false,
          gender: 0,
          id: 72776,
          known_for_department: 'Diễn viên',
          name: 'Simone Sacchettino',
          original_name: 'Simone Sacchettino',
          popularity: 0.6,
          profile_path: null,
          cast_id: 12,
          character: 'Simone',
          credit_id: '52fe44c4c3a36847f80a8d95',
          order: 12,
        },
        {
          adult: false,
          gender: 0,
          id: 72778,
          known_for_department: 'Diễn viên',
          name: 'Vincenzo Fabricino',
          original_name: 'Vincenzo Fabricino',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bWl4mPIY1xU882QTi8HWRoKZNFA.jpg',
          cast_id: 14,
          character: 'Pitbull',
          credit_id: '52fe44c4c3a36847f80a8d9d',
          order: 13,
        },
        {
          adult: false,
          gender: 0,
          id: 72781,
          known_for_department: 'Diễn viên',
          name: 'Salvatore Striano',
          original_name: 'Salvatore Striano',
          popularity: 1.226,
          profile_path: null,
          cast_id: 17,
          character: 'Scissionista',
          credit_id: '52fe44c4c3a36847f80a8da9',
          order: 14,
        },
        {
          adult: false,
          gender: 0,
          id: 1882933,
          known_for_department: 'Diễn viên',
          name: 'Vincenzo Bombolo',
          original_name: 'Vincenzo Bombolo',
          popularity: 0.6,
          profile_path: null,
          cast_id: 31,
          character: 'Pitbull',
          credit_id: '59afbf1ac3a3682cc806907f',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 72784,
          known_for_department: 'Diễn viên',
          name: 'Alfonso Santagata',
          original_name: 'Alfonso Santagata',
          popularity: 0.6,
          profile_path: null,
          cast_id: 20,
          character: 'Dante Serini',
          credit_id: '52fe44c4c3a36847f80a8db5',
          order: 16,
        },
        {
          adult: false,
          gender: 0,
          id: 72787,
          known_for_department: 'Diễn viên',
          name: 'Ronghua Zhang',
          original_name: 'Ronghua Zhang',
          popularity: 0.6,
          profile_path: null,
          cast_id: 23,
          character: 'Xian',
          credit_id: '52fe44c4c3a36847f80a8dc1',
          order: 17,
        },
        {
          adult: false,
          gender: 0,
          id: 72790,
          known_for_department: 'Diễn viên',
          name: 'Giovanni Venosa',
          original_name: 'Giovanni Venosa',
          popularity: 0.6,
          profile_path: null,
          cast_id: 26,
          character: 'Giovanni',
          credit_id: '52fe44c4c3a36847f80a8dcd',
          order: 18,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 1032,
          known_for_department: 'Directing',
          name: 'Martin Scorsese',
          original_name: 'Martin Scorsese',
          popularity: 7.059,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ixaF5f1lWhWy7aKr21KpX2SiI7S.jpg',
          credit_id: '5ba5798c0e0a262f990006c0',
          department: 'Crew',
          job: 'Presenter',
        },
        {
          adult: false,
          gender: 2,
          id: 63973,
          known_for_department: 'Directing',
          name: 'Matteo Garrone',
          original_name: 'Matteo Garrone',
          popularity: 0.932,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4QfjC6ELaFP2f3Ixo3JWEpcznr.jpg',
          credit_id: '52fe44c4c3a36847f80a8d75',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 63973,
          known_for_department: 'Directing',
          name: 'Matteo Garrone',
          original_name: 'Matteo Garrone',
          popularity: 0.932,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4QfjC6ELaFP2f3Ixo3JWEpcznr.jpg',
          credit_id: '52fe44c4c3a36847f80a8d57',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 72766,
          known_for_department: 'Biên kịch',
          name: 'Roberto Saviano',
          original_name: 'Roberto Saviano',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iwNkvWovNRKxHNYR8RxlUskQutH.jpg',
          credit_id: '58d06926c3a368679b000b1a',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 72766,
          known_for_department: 'Biên kịch',
          name: 'Roberto Saviano',
          original_name: 'Roberto Saviano',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iwNkvWovNRKxHNYR8RxlUskQutH.jpg',
          credit_id: '52fe44c4c3a36847f80a8d5d',
          department: 'Biên kịch',
          job: 'Novel',
        },
        {
          adult: false,
          gender: 0,
          id: 72767,
          known_for_department: 'Biên kịch',
          name: 'Maurizio Braucci',
          original_name: 'Maurizio Braucci',
          popularity: 0.63,
          profile_path: null,
          credit_id: '52fe44c4c3a36847f80a8d63',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 72768,
          known_for_department: 'Biên kịch',
          name: 'Ugo Chiti',
          original_name: 'Ugo Chiti',
          popularity: 0.743,
          profile_path: null,
          credit_id: '52fe44c4c3a36847f80a8d69',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 72769,
          known_for_department: 'Biên kịch',
          name: 'Gianni Di Gregorio',
          original_name: 'Gianni Di Gregorio',
          popularity: 1.255,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1wlZqqnaAsvjKTXP8GBcFwew1cZ.jpg',
          credit_id: '52fe44c4c3a36847f80a8d6f',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 72772,
          known_for_department: 'Camera',
          name: 'Marco Onorato',
          original_name: 'Marco Onorato',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe44c4c3a36847f80a8d81',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 72773,
          known_for_department: 'Editing',
          name: 'Marco Spoletini',
          original_name: 'Marco Spoletini',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe44c4c3a36847f80a8d87',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 72774,
          known_for_department: 'Diễn viên',
          name: 'Alessandra Cardini',
          original_name: 'Alessandra Cardini',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xIQRiJjZHFaSNYpiLjiWkhorDZT.jpg',
          credit_id: '52fe44c4c3a36847f80a8d8d',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 2,
          id: 72051,
          known_for_department: 'Production',
          name: 'Domenico Procacci',
          original_name: 'Domenico Procacci',
          popularity: 1.116,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zZYhgBDgVc39Jmjz11vajaWW06b.jpg',
          credit_id: '52fe44c4c3a36847f80a8dd3',
          department: 'Production',
          job: 'Producer',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/IRN1JuNwr1VKp88Dscgja2uR8H.jpg',
    belongs_to_collection: null,
    budget: 80000000,
    genres: [
      { id: 10752, name: 'Phim Chiến Tranh' },
      { id: 36, name: 'Phim Lịch Sử' },
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 28, name: 'Phim Hành Động' },
    ],
    homepage: 'https://cmc-pictures.com/the-eight-hundred/',
    id: 508935,
    imdb_id: 'tt7294150',
    original_language: 'zh',
    original_title: '八佰',
    overview:
      'Vào năm 1937, một nhóm lính Trung Quốc và quân nhân kéo quân đã bố trí bốn ngày bảo vệ khu phức hợp kho hàng ở Thượng Hải khi quân Nhật đang áp đảo Trung Quốc.',
    popularity: 10.13,
    poster_path:
      'https://image.tmdb.org/t/p/w342/lujHQzMhzRbmSqtmrO0q0S2bR6c.jpg',
    production_companies: [
      {
        id: 112270,
        logo_path: null,
        name: 'Beijing Diqi Yinxiang Entertainment',
        origin_country: '',
      },
      {
        id: 3393,
        logo_path: null,
        name: 'Huayi Brothers Pictures',
        origin_country: 'CN',
      },
    ],
    production_countries: [{ iso_3166_1: 'CN', name: 'Trung Quốc' }],
    release_date: '2020-08-14',
    revenue: 460919368,
    runtime: 147,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
      { english_name: 'Nhật Bảnese', iso_639_1: 'ja', name: '日本語' },
      { english_name: 'Mandarin', iso_639_1: 'zh', name: '普通话' },
    ],
    status: 'Đã phát hành',
    tagline: 'Bát Bách',
    title: 'Bát Bách',
    video: false,
    vote_average: 7.2,
    vote_count: 129,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Eight Hundred (Official 2021 English Trailer)',
          key: 'wdaf_D1KeMY',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: false,
          published_at: '2021-02-23T21:30:06.000Z',
          id: '6036d33671458f003dbd8028',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Eight Hundred Trailer #1 (2020) | Movieclips Trailers',
          key: 'kbikn8Q148c',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: false,
          published_at: '2020-08-21T23:30:02.000Z',
          id: '5f9b116339b6c300372de421',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 565378,
          known_for_department: 'Diễn viên',
          name: 'Wang Qian-Yuan',
          original_name: 'Wang Qian-Yuan',
          popularity: 2.529,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sSrS42hvZb2H8UVpCyXYr6v64hY.jpg',
          cast_id: 15,
          character: 'Yang Guai',
          credit_id: '5f4928212da84600334563c1',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 146098,
          known_for_department: 'Diễn viên',
          name: 'Zhang Yi',
          original_name: 'Zhang Yi',
          popularity: 5.508,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wh2ljaHbXvjSdp8WnJn5O3bLLwq.jpg',
          cast_id: 1,
          character: 'Xiao Hubei',
          credit_id: '5c11edeb0e0a26327b7aec39',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 1338063,
          known_for_department: 'Diễn viên',
          name: 'Huang Zhizhong',
          original_name: 'Huang Zhizhong',
          popularity: 3.935,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nqApESG1sTNtGjzcoMFIjF8ZeZ0.jpg',
          cast_id: 6,
          character: 'Lao Hulu',
          credit_id: '5cfddc00c3a36801a71df9bc',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 15170,
          known_for_department: 'Diễn viên',
          name: 'Jiang Wu',
          original_name: 'Jiang Wu',
          popularity: 2.524,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2eUlOQ4JlGUMMAPNHgxZ4uO4ONA.jpg',
          cast_id: 5,
          character: 'Lao Tie',
          credit_id: '5cfddbe90e0a2671c7c9cbf4',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 1355667,
          known_for_department: 'Diễn viên',
          name: 'Oho Ou',
          original_name: 'Oho Ou',
          popularity: 2.588,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uWvtZqSq4CMpAtLVD0BjTixpscz.jpg',
          cast_id: 21,
          character: 'Duan Wu',
          credit_id: '5fa0c2b2db952d003641c2f1',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 1110539,
          known_for_department: 'Diễn viên',
          name: 'Du Chun',
          original_name: 'Du Chun',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/12uAAvcRdWXmyJes9p2CNjv5HCD.jpg',
          cast_id: 22,
          character: 'Lieutenant Colonel Xie Jinyuan',
          credit_id: '5fa0c2f7e24e3a00389cbafb',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 1397014,
          known_for_department: 'Diễn viên',
          name: 'Vision Wei',
          original_name: 'Vision Wei',
          popularity: 2.14,
          profile_path:
            'https://image.tmdb.org/t/p/w185/Y8hZq6zG39i1fByGYZwUnBTN4g.jpg',
          cast_id: 7,
          character: 'Zhu Shengzhong',
          credit_id: '5cfddc0f0e0a267e51c9c3d4',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 1539646,
          known_for_department: 'Diễn viên',
          name: 'Tang Yixin',
          original_name: 'Tang Yixin',
          popularity: 3.766,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sQzDVRmdyUOQFIJapee1NQuYOAk.jpg',
          cast_id: 8,
          character: 'Yang Huimin',
          credit_id: '5cfddc1b0e0a261f29c9bd3b',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 1724347,
          known_for_department: 'Diễn viên',
          name: 'Li Jiuxiao',
          original_name: 'Li Jiuxiao',
          popularity: 1.385,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wBaTXTKFCavDhHleVBZ1F35DWfS.jpg',
          cast_id: 23,
          character: 'Dao Zi',
          credit_id: '5fa0c311db952d003941d12f',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 130984,
          known_for_department: 'Diễn viên',
          name: 'Jerry Lee',
          original_name: 'Jerry Lee',
          popularity: 1.26,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9EM6fLaIccpGcsjXh7ozBqz54Hu.jpg',
          cast_id: 9,
          character: 'Qi Jiaming, the Shandong Soldier',
          credit_id: '5cfddc25c3a368019a1df6f0',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 130866,
          known_for_department: 'Diễn viên',
          name: 'Liang Jing',
          original_name: 'Liang Jing',
          popularity: 1.724,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6EHpFtHSp6m7ExrEJJf04oMsmr3.jpg',
          cast_id: 24,
          character: "Professor's wife",
          credit_id: '5fa0c328ecaef50037b6002a',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 958556,
          known_for_department: 'Diễn viên',
          name: 'Hou Yong',
          original_name: 'Hou Yong',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/au1omdWnecVCQsRV8FCVbHMBhVA.jpg',
          cast_id: 25,
          character: 'Professor',
          credit_id: '5fa0c33fa3491100365fe551',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 1172611,
          known_for_department: 'Diễn viên',
          name: 'Xin Baiqing',
          original_name: 'Xin Baiqing',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8CShRVzlOGfE0CETTGhvBe95MNV.jpg',
          cast_id: 27,
          character: 'Fang Xingwen',
          credit_id: '5fa0c4153e6f2b00380da622',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 1539663,
          known_for_department: 'Diễn viên',
          name: 'Yu Haoming',
          original_name: 'Yu Haoming',
          popularity: 1.702,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hDq6SM6bojCkR7PJF6vdJXurmF9.jpg',
          cast_id: 3,
          character: 'Shangguan Zhibiao',
          credit_id: '5c11ee08c3a3682424e6fffa',
          order: 13,
        },
        {
          adult: false,
          gender: 1,
          id: 482101,
          known_for_department: 'Diễn viên',
          name: 'Yao Chen',
          original_name: 'Yao Chen',
          popularity: 2.739,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xBdGgptr7CopKOCFf2umQ5LT1ra.jpg',
          cast_id: 2,
          character: 'He Xiangning',
          credit_id: '5c11edfbc3a3682437e6ffa9',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 1279598,
          known_for_department: 'Diễn viên',
          name: 'Ryan Zheng Kai',
          original_name: 'Ryan Zheng Kai',
          popularity: 2.923,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jWB0e7UzTzuvnEfWya9eQ046jva.jpg',
          cast_id: 12,
          character: 'Chen Shusheng',
          credit_id: '5cfddc679251415cd7b84c85',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 1387956,
          known_for_department: 'Diễn viên',
          name: 'Yu Ailei',
          original_name: 'Yu Ailei',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cFJuAVGSzgJVV6E3FsOytDh1WAq.jpg',
          cast_id: 10,
          character: 'Luoyang Chan',
          credit_id: '5cfddc339251416f8ebe68bb',
          order: 16,
        },
        {
          adult: false,
          gender: 2,
          id: 109434,
          known_for_department: 'Diễn viên',
          name: 'Huang Xiaoming',
          original_name: 'Huang Xiaoming',
          popularity: 2.329,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eIC3tenhlbFtaGnFXhta7e25avQ.jpg',
          cast_id: 13,
          character: 'Messenger',
          credit_id: '5cfddc73c3a36813021e0772',
          order: 17,
        },
        {
          adult: false,
          gender: 1,
          id: 1827884,
          known_for_department: 'Diễn viên',
          name: 'Augusta Xu-Holland',
          original_name: 'Augusta Xu-Holland',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9cIW0X2D6pgsS1FI61eJlemI7q5.jpg',
          cast_id: 4,
          character: 'Eva',
          credit_id: '5c11ee170e0a2632677aec09',
          order: 18,
        },
        {
          adult: false,
          gender: 0,
          id: 1063128,
          known_for_department: 'Diễn viên',
          name: 'Ethan Juan',
          original_name: 'Ethan Juan',
          popularity: 4.783,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vDiFcca1TYcFssxjU9efGjIAWN4.jpg',
          cast_id: 11,
          character: 'Yao',
          credit_id: '5cfddc4e0e0a261f29c9bd69',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 554932,
          known_for_department: 'Diễn viên',
          name: 'Song Yang',
          original_name: 'Song Yang',
          popularity: 0.975,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hqC8QMRWM5Tpne8jiSvXghVgeyb.jpg',
          cast_id: 26,
          character: 'Zhang Boting',
          credit_id: '5fa0c371db952d003741d30a',
          order: 20,
        },
        {
          adult: false,
          gender: 1,
          id: 593163,
          known_for_department: 'Diễn viên',
          name: 'Liu Xiaoqing',
          original_name: 'Liu Xiaoqing',
          popularity: 2.615,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tEv7SQ2zTVf2pA3LY9af1XomKMI.jpg',
          cast_id: 28,
          character: 'Sister Rong',
          credit_id: '5fae31c57a97ab003dcd58de',
          order: 21,
        },
        {
          adult: false,
          gender: 1,
          id: 3112884,
          known_for_department: 'Diễn viên',
          name: 'Huang Miyi',
          original_name: 'Huang Miyi',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eG1rNlEtQtvqBQfp0Jk7WJq3L6E.jpg',
          cast_id: 113,
          character: 'Hudie',
          credit_id: '6147a81222df2e00656c05f1',
          order: 22,
        },
        {
          adult: false,
          gender: 0,
          id: 3307708,
          known_for_department: 'Diễn viên',
          name: 'Pang Guochang',
          original_name: 'Pang Guochang',
          popularity: 0.98,
          profile_path: null,
          cast_id: 114,
          character: 'Zhou Tianyu',
          credit_id: '618fa67fcca7de0043568ee7',
          order: 23,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 2593,
          known_for_department: 'Sound',
          name: 'Rupert Gregson-Williams',
          original_name: 'Rupert Gregson-Williams',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6qr9v5tsFrZtAA8EUfO1XQtUHhB.jpg',
          credit_id: '6058c436a294f0003cb060be',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 92017,
          known_for_department: 'Camera',
          name: 'Cao Yu',
          original_name: 'Cao Yu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8431c402842000371aa9cf',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 131301,
          known_for_department: 'Directing',
          name: 'Guan Hu',
          original_name: 'Guan Hu',
          popularity: 0.744,
          profile_path: null,
          credit_id: '5a9ad5880e0a2606490227fe',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 131301,
          known_for_department: 'Directing',
          name: 'Guan Hu',
          original_name: 'Guan Hu',
          popularity: 0.744,
          profile_path: null,
          credit_id: '5cfddcaa92514142cab8536f',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 0,
          id: 1368868,
          known_for_department: 'Visual Effects',
          name: 'Ilona Blyth',
          original_name: 'Ilona Blyth',
          popularity: 0.652,
          profile_path: null,
          credit_id: '6058c9d0eec4f3003e8ac8ef',
          department: 'Visual Effects',
          job: 'Visual Effects Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1384373,
          known_for_department: 'Visual Effects',
          name: 'Tim Crosbie',
          original_name: 'Tim Crosbie',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058ca1047c9fb006abd0752',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1463609,
          known_for_department: 'Crew',
          name: 'Andrew Savchenko',
          original_name: 'Andrew Savchenko',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c59cab1bc7003da8ecc2',
          department: 'Crew',
          job: 'Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 1463629,
          known_for_department: 'Diễn viên',
          name: 'Lachlan Tolley',
          original_name: 'Lachlan Tolley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c56422931a006a2a2b4a',
          department: 'Crew',
          job: 'Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 1469116,
          known_for_department: 'Sound',
          name: 'Miguel Calvo',
          original_name: 'Miguel Calvo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058cad36e3deb0028d977c5',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1539293,
          known_for_department: 'Visual Effects',
          name: 'Jason Troughton',
          original_name: 'Jason Troughton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058ca666e3deb0054ea243a',
          department: 'Visual Effects',
          job: 'Special Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1644254,
          known_for_department: 'Visual Effects',
          name: 'Emily Pead',
          original_name: 'Emily Pead',
          popularity: 1.4,
          profile_path: null,
          credit_id: '6058c9e122931a00286475f1',
          department: 'Visual Effects',
          job: 'Visual Effects Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1718279,
          known_for_department: 'Production',
          name: 'Arwen Munro',
          original_name: 'Arwen Munro',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c997af2da80055a45271',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1738651,
          known_for_department: 'Crew',
          name: 'Roy Malhi',
          original_name: 'Roy Malhi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c3c7a294f000699e8ca3',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1739319,
          known_for_department: 'Crew',
          name: 'Julian Hutchens',
          original_name: 'Julian Hutchens',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c3d9b39e350028f495f2',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1739794,
          known_for_department: 'Visual Effects',
          name: 'Linda Luong',
          original_name: 'Linda Luong',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c9a822931a006a2a3260',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1789138,
          known_for_department: 'Sound',
          name: 'Roberto H.G.',
          original_name: 'Roberto H.G.',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058cae9ab1bc70054537efd',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1826909,
          known_for_department: 'Crew',
          name: 'Andrew Kawczynski',
          original_name: 'Andrew Kawczynski',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c44ca6c10400289a2c4b',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 1848101,
          known_for_department: 'Visual Effects',
          name: 'Rodrigo Dorsch',
          original_name: 'Rodrigo Dorsch',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c4eab39e3500544b0bd1',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1876066,
          known_for_department: 'Sound',
          name: 'Steve Miller',
          original_name: 'Steve Miller',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058cd0e0792e1006b3218e1',
          department: 'Sound',
          job: 'Supervising Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1876066,
          known_for_department: 'Sound',
          name: 'Steve Miller',
          original_name: 'Steve Miller',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058ccd46e3deb006ba7c37f',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1918481,
          known_for_department: 'Visual Effects',
          name: 'Naveen Kumar',
          original_name: 'Naveen Kumar',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c96a47c9fb0053bf51c3',
          department: 'Visual Effects',
          job: 'VFX Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1942714,
          known_for_department: 'Visual Effects',
          name: 'Simon Pynn',
          original_name: 'Simon Pynn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c6c6fd4f800074bc8aad',
          department: 'Visual Effects',
          job: 'Matchmove Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2002558,
          known_for_department: 'Sound',
          name: 'Fu Kang',
          original_name: 'Fu Kang',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058ccf901e4d1003dee4d7c',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2002558,
          known_for_department: 'Sound',
          name: 'Fu Kang',
          original_name: 'Fu Kang',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058cb21eec4f30029feac14',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 2011399,
          known_for_department: 'Visual Effects',
          name: 'Joe Tsung-Yu Wu',
          original_name: 'Joe Tsung-Yu Wu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c8404557a000681a6b91',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2026189,
          known_for_department: 'Editing',
          name: 'Tu Yiran',
          original_name: 'Tu Yiran',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8431aa02842000371aa9c2',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2059550,
          known_for_department: 'Visual Effects',
          name: 'Daniel Rauchwerger',
          original_name: 'Daniel Rauchwerger',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058ca42ab1bc7006b7f5ab5',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2110167,
          known_for_department: 'Crew',
          name: 'Dustin Cumming',
          original_name: 'Dustin Cumming',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c5526bdec3003dace012',
          department: 'Crew',
          job: 'Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 2141422,
          known_for_department: 'Crew',
          name: 'Kamal Kumar Tiwari',
          original_name: 'Kamal Kumar Tiwari',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c52fa6c10400543633b8',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2149211,
          known_for_department: 'Visual Effects',
          name: 'Louis Laflamme-Fillion',
          original_name: 'Louis Laflamme-Fillion',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058ca215c071b003d5240dc',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2156209,
          known_for_department: 'Visual Effects',
          name: 'Alistair Darby',
          original_name: 'Alistair Darby',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c3860792e10028f03088',
          department: 'Visual Effects',
          job: 'CG Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2161831,
          known_for_department: 'Visual Effects',
          name: 'Ryan Basa',
          original_name: 'Ryan Basa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c542fd4f800074bc88b1',
          department: 'Crew',
          job: 'Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 2161839,
          known_for_department: 'Visual Effects',
          name: 'Rebecca Bogert',
          original_name: 'Rebecca Bogert',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c8a04557a000280c5368',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2161873,
          known_for_department: 'Lighting',
          name: 'Shawn McCarten',
          original_name: 'Shawn McCarten',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c6b322931a002864709d',
          department: 'Visual Effects',
          job: 'VFX Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2161882,
          known_for_department: 'Visual Effects',
          name: 'Abby Nath',
          original_name: 'Abby Nath',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c7f90792e100542bef85',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2161901,
          known_for_department: 'Visual Effects',
          name: 'David Schulz',
          original_name: 'David Schulz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c8b2a294f000283a0ead',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2161930,
          known_for_department: 'Sound',
          name: 'Victor Kong',
          original_name: 'Victor Kong',
          popularity: 0.828,
          profile_path: null,
          credit_id: '6058cd9522931a0054ec85cd',
          department: 'Sound',
          job: 'Music Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2161936,
          known_for_department: 'Sound',
          name: 'Fei Yu',
          original_name: 'Fei Yu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058cde1fd4f800074bc952b',
          department: 'Sound',
          job: 'Music Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2163289,
          known_for_department: 'Visual Effects',
          name: 'Oniel Fernandes',
          original_name: 'Oniel Fernandes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c4bc47c9fb0053bf4922',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2262016,
          known_for_department: 'Visual Effects',
          name: 'Imran Ahmed Raichuri',
          original_name: 'Imran Ahmed Raichuri',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c809b39e3500544b10e4',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2262025,
          known_for_department: 'Visual Effects',
          name: 'Ankur Singh',
          original_name: 'Ankur Singh',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c716fd4f80003e0875de',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 2272545,
          known_for_department: 'Production',
          name: 'Wenjiu Zhu',
          original_name: 'Wenjiu Zhu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c2baaf2da8003ee048b7',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2285851,
          known_for_department: 'Crew',
          name: 'Jason Bowers',
          original_name: 'Jason Bowers',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c4d5a294f000283a08ae',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2321586,
          known_for_department: 'Visual Effects',
          name: 'Shashank Jadhav',
          original_name: 'Shashank Jadhav',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c5dd6bdec3005489f563',
          department: 'Visual Effects',
          job: 'Digital Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 2437765,
          known_for_department: 'Sound',
          name: 'Pablo Áset',
          original_name: 'Pablo Áset',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058cafc4557a0003dd70eb8',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2515695,
          known_for_department: 'Directing',
          name: 'Siyang Zhang',
          original_name: 'Siyang Zhang',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c280ab1bc700287cf365',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2520911,
          known_for_department: 'Visual Effects',
          name: 'Syamil Aiman Mazlan',
          original_name: 'Syamil Aiman Mazlan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c7eb4557a0003dd7097d',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2701356,
          known_for_department: 'Visual Effects',
          name: 'Craig Saxby',
          original_name: 'Craig Saxby',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c90d22931a006a2a3177',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 2758186,
          known_for_department: 'Biên kịch',
          name: 'Ge Rui',
          original_name: 'Ge Rui',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f49294945819900343e1093',
          department: 'Biên kịch',
          job: "Writers' Production",
        },
        {
          adult: false,
          gender: 0,
          id: 2812484,
          known_for_department: 'Editing',
          name: 'He Yongyi',
          original_name: 'He Yongyi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8431b325b9550035291e13',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2835604,
          known_for_department: 'Art',
          name: 'Mu Lin',
          original_name: 'Mu Lin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f9b14449a9f9a0036552b39',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 0,
          id: 2835604,
          known_for_department: 'Art',
          name: 'Mu Lin',
          original_name: 'Mu Lin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c163b39e3500544b0667',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 0,
          id: 2842246,
          known_for_department: 'Visual Effects',
          name: 'Anupam Pal',
          original_name: 'Anupam Pal',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c61601e4d1005364ebe4',
          department: 'Visual Effects',
          job: 'Digital Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 2885490,
          known_for_department: 'Visual Effects',
          name: 'Dean Richichi',
          original_name: 'Dean Richichi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c62ba294f000699e9004',
          department: 'Visual Effects',
          job: 'Digital Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 2896821,
          known_for_department: 'Crew',
          name: 'Will Hackett',
          original_name: 'Will Hackett',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c5756e3deb0054ea1cca',
          department: 'Crew',
          job: 'Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 2926846,
          known_for_department: 'Visual Effects',
          name: 'Kulbhushan Kale',
          original_name: 'Kulbhushan Kale',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c5f10792e100542bec0c',
          department: 'Visual Effects',
          job: 'Digital Compositor',
        },
        {
          adult: false,
          gender: 1,
          id: 2976485,
          known_for_department: 'Visual Effects',
          name: 'Samantha Abda',
          original_name: 'Samantha Abda',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c942b39e35003dd82b46',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2993736,
          known_for_department: 'Visual Effects',
          name: 'Andrew Shanks',
          original_name: 'Andrew Shanks',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c6416e3deb0028d97174',
          department: 'Visual Effects',
          job: 'Digital Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 3020481,
          known_for_department: 'Costume & Make-Up',
          name: 'Zhou Li',
          original_name: 'Zhou Li',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c12a5c071b00546d0457',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 0,
          id: 3020485,
          known_for_department: 'Costume & Make-Up',
          name: 'Ye Tian',
          original_name: 'Ye Tian',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c19feec4f3006b9a6c26',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 0,
          id: 3020487,
          known_for_department: 'Costume & Make-Up',
          name: 'Hong Yang',
          original_name: 'Hong Yang',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c1be6e3deb006ba7b340',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 3020493,
          known_for_department: 'Production',
          name: 'Yingxue Zeng',
          original_name: 'Yingxue Zeng',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c22f6e3deb006ba7b3c4',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 3020495,
          known_for_department: 'Production',
          name: 'Yu Liang',
          original_name: 'Yu Liang',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c2565c071b00546d0677',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 3020505,
          known_for_department: 'Production',
          name: 'Qiongfang Liu',
          original_name: 'Qiongfang Liu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c2966bdec3005489f04a',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 3020510,
          known_for_department: 'Lighting',
          name: 'Zhigong Sun',
          original_name: 'Zhigong Sun',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c30a6bdec30075b58a1b',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 3020521,
          known_for_department: 'Crew',
          name: 'Mani Bhushan Kumar',
          original_name: 'Mani Bhushan Kumar',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c3a10792e1003d639676',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 3020523,
          known_for_department: 'Crew',
          name: 'Stefano Cieri',
          original_name: 'Stefano Cieri',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c3b2ab1bc700545373a4',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 3020549,
          known_for_department: 'Crew',
          name: 'Josh Hulands',
          original_name: 'Josh Hulands',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c588a6c1040054363485',
          department: 'Crew',
          job: 'Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 3020556,
          known_for_department: 'Visual Effects',
          name: 'Yulong Liu',
          original_name: 'Yulong Liu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c604fd4f800054267bf6',
          department: 'Visual Effects',
          job: 'Digital Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 3020561,
          known_for_department: 'Visual Effects',
          name: 'Shwet Suman Sharma',
          original_name: 'Shwet Suman Sharma',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c6584557a0003dd706ba',
          department: 'Visual Effects',
          job: 'Digital Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 3020565,
          known_for_department: 'Visual Effects',
          name: 'Chew Teng Lim',
          original_name: 'Chew Teng Lim',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c6a26e3deb0054ea1e3a',
          department: 'Visual Effects',
          job: 'VFX Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 3020568,
          known_for_department: 'Visual Effects',
          name: 'Vishal Sharma',
          original_name: 'Vishal Sharma',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c757ab1bc7003da8ef2f',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 3020569,
          known_for_department: 'Visual Effects',
          name: 'Nikhil Kamboj',
          original_name: 'Nikhil Kamboj',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c7676e3deb0028d972dd',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 3020570,
          known_for_department: 'Visual Effects',
          name: 'Prashant Bavariya',
          original_name: 'Prashant Bavariya',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c7776bdec3002848b266',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 3020573,
          known_for_department: 'Visual Effects',
          name: 'Demián Astur',
          original_name: 'Demián Astur',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c7beaf2da80055a45028',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 3020575,
          known_for_department: 'Visual Effects',
          name: 'Vanathi Jayalakshmi',
          original_name: 'Vanathi Jayalakshmi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c7cdb39e350028f49ae3',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 3020577,
          known_for_department: 'Visual Effects',
          name: 'Sowmithri Sai Koutha',
          original_name: 'Sowmithri Sai Koutha',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c7db0792e1003d639ccc',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 3020581,
          known_for_department: 'Visual Effects',
          name: 'Luke Rawcliffe',
          original_name: 'Luke Rawcliffe',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c8196e3deb003de3d7d5',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 3020584,
          known_for_department: 'Visual Effects',
          name: 'Daniel Steart',
          original_name: 'Daniel Steart',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c830af2da80029f60c3b',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 3020587,
          known_for_department: 'Visual Effects',
          name: 'Indreep Raha',
          original_name: 'Indreep Raha',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c8806bdec3005489f9d1',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 3020589,
          known_for_department: 'Visual Effects',
          name: 'Deepak Suresh',
          original_name: 'Deepak Suresh',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c88fa6c1040075523a6a',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 3020592,
          known_for_department: 'Visual Effects',
          name: 'Aimee McKinney',
          original_name: 'Aimee McKinney',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c8fda294f000699e951b',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 3020593,
          known_for_department: 'Visual Effects',
          name: 'Nova Zheng',
          original_name: 'Nova Zheng',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c91e47c9fb0028029cef',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 3020595,
          known_for_department: 'Visual Effects',
          name: 'Martin Kemble',
          original_name: 'Martin Kemble',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c931b39e35006ab55e40',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 3020596,
          known_for_department: 'Visual Effects',
          name: 'Gaurav Gawas',
          original_name: 'Gaurav Gawas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c95822931a0028647544',
          department: 'Visual Effects',
          job: 'VFX Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 3020597,
          known_for_department: 'Visual Effects',
          name: 'Lolly Sawant',
          original_name: 'Lolly Sawant',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c97cb39e35006ab55e9f',
          department: 'Visual Effects',
          job: 'VFX Lighting Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 3020598,
          known_for_department: 'Visual Effects',
          name: 'Mark Koval',
          original_name: 'Mark Koval',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058c9bfb39e350028f49d60',
          department: 'Visual Effects',
          job: 'Visual Effects Production Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 3020605,
          known_for_department: 'Visual Effects',
          name: 'Wu Yanran',
          original_name: 'Wu Yanran',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058ca32a294f000699e969a',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 3020610,
          known_for_department: 'Sound',
          name: 'Ai Long Tan',
          original_name: 'Ai Long Tan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058cab622931a0028647719',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 3020642,
          known_for_department: 'Directing',
          name: 'Xiaojie Fu',
          original_name: 'Xiaojie Fu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6058cd77ab1bc7005453833d',
          department: 'Directing',
          job: 'Action Director',
        },
        {
          adult: false,
          gender: 0,
          id: 3237678,
          known_for_department: 'Visual Effects',
          name: 'Michael Furniss',
          original_name: 'Michael Furniss',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6144283d85da120020b771b1',
          department: 'Visual Effects',
          job: 'Visual Effects',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/fgffluhvdOv79SkYaKrfRA0xkf4.jpg',
    belongs_to_collection: null,
    budget: 12000000,
    genres: [{ id: 18, name: 'Phim Chính Kịch' }],
    homepage: 'http://lionmovie.com/',
    id: 334543,
    imdb_id: 'tt3741834',
    original_language: 'en',
    original_title: 'Lion',
    overview:
      'Như rất nhiều đứa trẻ sinh ra ở vùng nông thôn rộng lớn và nghèo khó của Ấn Độ vào thập niên 1980, Saroo (Sunny Pawar) chưa bao giờ có cơ hội tận hưởng cảm giác no đủ khi mẹ cậu phải một mình gánh vác ba đứa con nheo nhóc bằng nghề khuân vác trong các mỏ đá ở ngoại vi thành phố Khandwa. Bỗng dưng bị số phận đưa đẩy tới một thành phố xa lạ, nơi người dân thậm chí còn chẳng sử dụng thứ ngôn ngữ ở quê nhà, Saroo một mình đối mặt với muôn vàn khó khăn: từ những cơn đói triền miên, đến nỗi nhớ mẹ, nhớ anh trai da diết, và cả hiểm họa thường trực từ những kẻ lòng lang dạ thú muốn lạm dụng lũ trẻ ngây thơ như cậu. Dù vẫn tồn tại những tấm lòng nhân hậu muốn giúp đỡ Saroo tìm về với gia đình, nhưng tất cả những gì cậu có thể mô tả cho họ chỉ là Guddu - tên người anh trai, và “Ginestley” - tên ngôi làng nghèo quê hương nhưng chẳng thể tìm thấy ở bất cứ đâu trên tấm bản đồ Ấn Độ.',
    popularity: 22.661,
    poster_path:
      'https://image.tmdb.org/t/p/w342/kCELJH1tCmaRLqvwIgKDb09aEaw.jpg',
    production_companies: [
      {
        id: 308,
        logo_path: '/e8F3mQM7DkJ5SfYYDp8FYzPBOGX.png',
        name: 'The Weinstein Company',
        origin_country: 'US',
      },
      {
        id: 7217,
        logo_path: '/vFbexaF70wSMUHRA6Fy6UcuA1ju.png',
        name: 'See-Saw Films',
        origin_country: 'GB',
      },
      {
        id: 7584,
        logo_path: '/eGkfvvyf4fJTvBUR1xt1669IPA3.png',
        name: 'Screen Australia',
        origin_country: 'AU',
      },
      {
        id: 13786,
        logo_path: '/1SZVpHLNMlYGshAXZK8FIIWQyu1.png',
        name: 'Aquarius Films',
        origin_country: 'AU',
      },
      {
        id: 50501,
        logo_path: '/ySFGl5qxxurlkvvXBPGTD1uQ2Zy.png',
        name: 'Sunstar Entertainment',
        origin_country: 'AU',
      },
    ],
    production_countries: [
      { iso_3166_1: 'AU', name: 'Australia' },
      { iso_3166_1: 'GB', name: 'United Kingdom' },
      { iso_3166_1: 'US', name: 'Hoa Kì' },
    ],
    release_date: '2016-01-20',
    revenue: 140312928,
    runtime: 118,
    spoken_languages: [
      { english_name: 'Bengali', iso_639_1: 'bn', name: 'বাংলা' },
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
      { english_name: 'Hindi', iso_639_1: 'hi', name: 'हिन्दी' },
    ],
    status: 'Đã phát hành',
    tagline: 'Cuộc tìm kiếm bắt đầu.',
    title: 'Tìm Mẹ',
    video: false,
    vote_average: 8.1,
    vote_count: 5539,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'LION Q&A with Nicole Kidman and Dev Patel at AFI FEST 2016',
          key: 'nsvbQ-b2btE',
          published_at: '2016-11-13T20:02:23.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Featurette',
          official: false,
          id: '582a11729251417b2903b798',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'A roaring success: Nicole Kidman and Dev Patel introduce Lion at the London film festival',
          key: 'kBsIbpwF7_k',
          published_at: '2016-10-13T14:55:58.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Featurette',
          official: false,
          id: '5800017bc3a3683d7b000364',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Lion Official Trailer',
          key: 'xNstK5rbzcw',
          published_at: '2016-08-26T01:19:39.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '5bbed407c3a3682b36009dd0',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 76788,
          known_for_department: 'Diễn viên',
          name: 'Dev Patel',
          original_name: 'Dev Patel',
          popularity: 8.83,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jt08kAMlC7s9MJ8PupHBUjY0Ruc.jpg',
          cast_id: 4,
          character: 'Saroo Brierley',
          credit_id: '5521bd6ac3a368333a001d2d',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 108916,
          known_for_department: 'Diễn viên',
          name: 'Rooney Mara',
          original_name: 'Rooney Mara',
          popularity: 8.531,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zT6UyHFHEQ9RcKykplWCycKBnoS.jpg',
          cast_id: 7,
          character: 'Lucy',
          credit_id: '55530902c3a3686343000ea0',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 1371,
          known_for_department: 'Diễn viên',
          name: 'David Wenham',
          original_name: 'David Wenham',
          popularity: 12.114,
          profile_path:
            'https://image.tmdb.org/t/p/w185/F7CWSqUE75HtrcdqIQ7UMZ9aTX.jpg',
          cast_id: 8,
          character: 'John Brierley',
          credit_id: '568a67a292514169d0015b57',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 2227,
          known_for_department: 'Diễn viên',
          name: 'Nicole Kidman',
          original_name: 'Nicole Kidman',
          popularity: 10.568,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dlcNtb7y0Be1pOWdsogowLEsOta.jpg',
          cast_id: 3,
          character: 'Sue Brierley',
          credit_id: '5521bd5bc3a3684dd400462b',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 1750435,
          known_for_department: 'Diễn viên',
          name: 'Abhishek Bharate',
          original_name: 'Abhishek Bharate',
          popularity: 1.012,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fHZ4oMfj8Q9bewvDUqAq1xxFUao.jpg',
          cast_id: 73,
          character: 'Guddu',
          credit_id: '5896596092514129c800bcec',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 1285715,
          known_for_department: 'Diễn viên',
          name: 'Divian Ladwa',
          original_name: 'Divian Ladwa',
          popularity: 0.765,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fSiX3vqxNBbjNXgykSgKqFDHffj.jpg',
          cast_id: 87,
          character: 'Mantosh Brierley',
          credit_id: '5a0ae2779251413118018ea2',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 1296866,
          known_for_department: 'Diễn viên',
          name: 'Priyanka Bose',
          original_name: 'Priyanka Bose',
          popularity: 2.094,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2sISoCre8JbMZgx8ZWjLF02X4FN.jpg',
          cast_id: 14,
          character: 'Kamla Munshi',
          credit_id: '5710aef9c3a36860a80042f0',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 150220,
          known_for_department: 'Diễn viên',
          name: 'Deepti Naval',
          original_name: 'Deepti Naval',
          popularity: 1.205,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nUMAIUxjrnxHEOgAudLbst2IIqZ.jpg',
          cast_id: 16,
          character: 'Saroj Sood',
          credit_id: '5710aefac3a36831e1002e34',
          order: 7,
        },
        {
          adult: false,
          gender: 1,
          id: 87297,
          known_for_department: 'Diễn viên',
          name: 'Tannishtha Chatterjee',
          original_name: 'Tannishtha Chatterjee',
          popularity: 0.709,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sMHI5SS5CSvDLzqwfnGn4XG0oGc.jpg',
          cast_id: 6,
          character: 'Noor',
          credit_id: '5521bd7a9251415c7f004004',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 85047,
          known_for_department: 'Diễn viên',
          name: 'Nawazuddin Siddiqui',
          original_name: 'Nawazuddin Siddiqui',
          popularity: 1.015,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9eeCApyd3fTrLVeKSVs6ZEVLi4l.jpg',
          cast_id: 5,
          character: 'Rama',
          credit_id: '5521bd739251415c8200403e',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 1717046,
          known_for_department: 'Diễn viên',
          name: 'Sunny Pawar',
          original_name: 'Sunny Pawar',
          popularity: 0.714,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ht2vbePlFUVyriEK9UgvwUdUevC.jpg',
          cast_id: 31,
          character: 'Young Saroo Brierley',
          credit_id: '58408a0ec3a36832d6001e05',
          order: 10,
        },
        {
          adult: false,
          gender: 0,
          id: 1750436,
          known_for_department: 'Diễn viên',
          name: 'Keshav Jadhav',
          original_name: 'Keshav Jadhav',
          popularity: 0.6,
          profile_path: null,
          cast_id: 74,
          character: 'Young Mantosh',
          credit_id: '589659a3c3a3680898010188',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 1371541,
          known_for_department: 'Diễn viên',
          name: 'Benjamin Rigby',
          original_name: 'Benjamin Rigby',
          popularity: 0.876,
          profile_path:
            'https://image.tmdb.org/t/p/w185/le5qTKDolOJBZ5mWjnx5QwNbCPA.jpg',
          cast_id: 10,
          character: 'Waiter',
          credit_id: '5710aef8c3a3684ff10046b6',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 1671080,
          known_for_department: 'Diễn viên',
          name: 'Riddhi Sen',
          original_name: 'Riddhi Sen',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sNZbvQPNwqYQiZJEA8sMzLspkBs.jpg',
          cast_id: 75,
          character: 'Cafe Man',
          credit_id: '589659c19251412e1400f4ef',
          order: 13,
        },
        {
          adult: false,
          gender: 0,
          id: 1750440,
          known_for_department: 'Diễn viên',
          name: 'Rita Boy',
          original_name: 'Rita Boy',
          popularity: 0.6,
          profile_path: null,
          cast_id: 76,
          character: 'Amita',
          credit_id: '589659e8c3a36822e000b9b3',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 1496153,
          known_for_department: 'Diễn viên',
          name: 'Arka Das',
          original_name: 'Arka Das',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hbmlfI4zeChzGMskEcO3kpjfa31.jpg',
          cast_id: 19,
          character: 'Sami',
          credit_id: '5710aefbc3a368412200316e',
          order: 15,
        },
        {
          adult: false,
          gender: 1,
          id: 1606096,
          known_for_department: 'Diễn viên',
          name: 'Emilie Cocquerel',
          original_name: 'Emilie Cocquerel',
          popularity: 3.567,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kRH5xfWrpEygbKIRjntsu8Lh6jQ.jpg',
          cast_id: 15,
          character: 'Annika',
          credit_id: '5710aef99251416a56003b92',
          order: 16,
        },
        {
          adult: false,
          gender: 2,
          id: 1094512,
          known_for_department: 'Diễn viên',
          name: 'Sachin Joab',
          original_name: 'Sachin Joab',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/szO3mSQcnpek4x9ghEUSSB5bxQj.jpg',
          cast_id: 20,
          character: 'Bharat',
          credit_id: '5710aefbc3a36853700063d3',
          order: 17,
        },
        {
          adult: false,
          gender: 0,
          id: 1204264,
          known_for_department: 'Diễn viên',
          name: 'Menik Gooneratne',
          original_name: 'Menik Gooneratne',
          popularity: 1.548,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zsYbBv8ZMsvvH2OXglLWA3NVx9S.jpg',
          cast_id: 12,
          character: 'Swarmina',
          credit_id: '5710aef8c3a3685373005b03',
          order: 18,
        },
        {
          adult: false,
          gender: 0,
          id: 1515827,
          known_for_department: 'Diễn viên',
          name: 'Anna Samson',
          original_name: 'Anna Samson',
          popularity: 1.473,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zGBscoNaSSpBuWGfW1XKJzvgg70.jpg',
          cast_id: 13,
          character: 'Cute Bar Maid',
          credit_id: '5710aef9c3a36860a80042ee',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 110425,
          known_for_department: 'Diễn viên',
          name: 'Eamon Farren',
          original_name: 'Eamon Farren',
          popularity: 11.973,
          profile_path:
            'https://image.tmdb.org/t/p/w185/80VSnsS2HRVeJR62QtSwrHvtzjx.jpg',
          cast_id: 11,
          character: 'Luke',
          credit_id: '5710aef89251416d95002eae',
          order: 20,
        },
        {
          adult: false,
          gender: 0,
          id: 1371536,
          known_for_department: 'Diễn viên',
          name: 'Tegan Crowley',
          original_name: 'Tegan Crowley',
          popularity: 0.6,
          profile_path: null,
          cast_id: 18,
          character: 'Workmate #1',
          credit_id: '5710aefac3a368537800605d',
          order: 21,
        },
        {
          adult: false,
          gender: 1,
          id: 1381668,
          known_for_department: 'Diễn viên',
          name: 'Belinda Misevski',
          original_name: 'Belinda Misevski',
          popularity: 0.6,
          profile_path: null,
          cast_id: 21,
          character: "Lucy's Friend",
          credit_id: '5710aefbc3a3684122003170',
          order: 22,
        },
        {
          adult: false,
          gender: 0,
          id: 1606097,
          known_for_department: 'Diễn viên',
          name: 'Lucy Moir',
          original_name: 'Lucy Moir',
          popularity: 0.6,
          profile_path: null,
          cast_id: 22,
          character: "Lucy's Friend",
          credit_id: '5710aefb925141763e000f94',
          order: 23,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 1307,
          known_for_department: 'Production',
          name: 'Bob Weinstein',
          original_name: 'Bob Weinstein',
          popularity: 2.01,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lCLIlmY3oZN9n0YgrH3i0oZygPU.jpg',
          credit_id: '58b0fe19c3a368076c0039d2',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 59839,
          known_for_department: 'Production',
          name: 'Harvey Weinstein',
          original_name: 'Harvey Weinstein',
          popularity: 1.844,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ylC5G8B151xdRGNX30odj0HALIi.jpg',
          credit_id: '58b0fe28c3a368075a0034dc',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 15330,
          known_for_department: 'Costume & Make-Up',
          name: 'Paul Pattison',
          original_name: 'Paul Pattison',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5873a8a6c3a368175600c4ae',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 2,
          id: 21390,
          known_for_department: 'Production',
          name: 'David Glasser',
          original_name: 'David Glasser',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58b0fdf09251415b2d003b9f',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 37268,
          known_for_department: 'Biên kịch',
          name: 'Luke Davies',
          original_name: 'Luke Davies',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5521bd41c3a368333a001d2a',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 0,
          id: 37270,
          known_for_department: 'Production',
          name: 'Emile Sherman',
          original_name: 'Emile Sherman',
          popularity: 0.829,
          profile_path: null,
          credit_id: '57733c02c3a3686a5e001d7e',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 37276,
          known_for_department: 'Production',
          name: 'Iain Canning',
          original_name: 'Iain Canning',
          popularity: 0.694,
          profile_path: null,
          credit_id: '57733be89251415acd001ac9',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 37277,
          known_for_department: 'Production',
          name: 'Libby Sharpe',
          original_name: 'Libby Sharpe',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58b0fdac9251415b480039b5',
          department: 'Production',
          job: 'Line Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 61630,
          known_for_department: 'Editing',
          name: 'Alexandre de Franceschi',
          original_name: 'Alexandre de Franceschi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57733c2c92514153f4001c54',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 67113,
          known_for_department: 'Camera',
          name: 'Greig Fraser',
          original_name: 'Greig Fraser',
          popularity: 2.95,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cwj0aValmr7TGQ2OOQk5CAy1PWf.jpg',
          credit_id: '587397029251410e7100aa6e',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 75151,
          known_for_department: 'Sound',
          name: 'Glenn Newnham',
          original_name: 'Glenn Newnham',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5873a7b89251410e7300be6b',
          department: 'Editing',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 75477,
          known_for_department: 'Production',
          name: 'Pravesh Sahni',
          original_name: 'Pravesh Sahni',
          popularity: 1.104,
          profile_path:
            'https://image.tmdb.org/t/p/w185/isPTEleOIhqHNbtCpsvOCLAYU5R.jpg',
          credit_id: '58b0fda19251415b25003a8a',
          department: 'Production',
          job: 'Line Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 80680,
          known_for_department: 'Art',
          name: 'Chris Kennedy',
          original_name: 'Chris Kennedy',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5873986c9251410e6d00afb7',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 0,
          id: 137220,
          known_for_department: 'Production',
          name: 'Angie Fielder',
          original_name: 'Angie Fielder',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57733bf4c3a36869ae001dd0',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 147855,
          known_for_department: 'Editing',
          name: 'Simon Alberry',
          original_name: 'Simon Alberry',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5873a9359251410e7100bc0e',
          department: 'Editing',
          job: 'Digital Intermediate',
        },
        {
          adult: false,
          gender: 0,
          id: 214356,
          known_for_department: 'Production',
          name: 'Andrew Fraser',
          original_name: 'Andrew Fraser',
          popularity: 0.98,
          profile_path: null,
          credit_id: '58b0fde29251415b21003f8b',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 233130,
          known_for_department: 'Sound',
          name: "Dustin O'Halloran",
          original_name: "Dustin O'Halloran",
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jUoREoQoh69lfHJ2zSGteV1JobP.jpg',
          credit_id: '5f135a8078570e0032569ebe',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 0,
          id: 1001794,
          known_for_department: 'Camera',
          name: 'Daniel Levin',
          original_name: 'Daniel Levin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58b0fdff9251415b25003aea',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1023809,
          known_for_department: 'Sound',
          name: 'Volker Bertelmann',
          original_name: 'Volker Bertelmann',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6iZPE8RAh3twac8yHYPWRpWWPZ9.jpg',
          credit_id: '5d0ead66c3a36828e61fdc2e',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 1173102,
          known_for_department: 'Directing',
          name: 'Garth Davis',
          original_name: 'Garth Davis',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lqxIIqqe7T64Oj6I9mofH2irDfd.jpg',
          credit_id: '5521bd2e9251417096001a63',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 1,
          id: 1191326,
          known_for_department: 'Art',
          name: 'Nicki Gardiner',
          original_name: 'Nicki Gardiner',
          popularity: 0.6,
          profile_path: null,
          credit_id: '587398c29251410e7700a9c4',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 1196121,
          known_for_department: 'Costume & Make-Up',
          name: 'Cappi Ireland',
          original_name: 'Cappi Ireland',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5873991b9251410e6d00b04f',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 1,
          id: 1198829,
          known_for_department: 'Production',
          name: 'Kirsty McGregor',
          original_name: 'Kirsty McGregor',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57733c38c3a3686ad90018f9',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 1308567,
          known_for_department: 'Crew',
          name: 'Warwick Field',
          original_name: 'Warwick Field',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58739aaa9251410e7300b219',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1311620,
          known_for_department: 'Costume & Make-Up',
          name: 'Larry Van Duynhoven',
          original_name: 'Larry Van Duynhoven',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5873a913c3a368174600af04',
          department: 'Costume & Make-Up',
          job: 'Prosthetic Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1336767,
          known_for_department: 'Art',
          name: 'Erica Brien',
          original_name: 'Erica Brien',
          popularity: 0.6,
          profile_path: null,
          credit_id: '587399339251410e7100ac78',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1395454,
          known_for_department: 'Visual Effects',
          name: 'Ineke Majoor',
          original_name: 'Ineke Majoor',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5873a74fc3a368175e00a3cc',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1402740,
          known_for_department: 'Sound',
          name: 'Adam Connelly',
          original_name: 'Adam Connelly',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5873a7de9251410e6d00bedb',
          department: 'Sound',
          job: 'Foley',
        },
        {
          adult: false,
          gender: 0,
          id: 1410551,
          known_for_department: 'Sound',
          name: 'Robert Mackenzie',
          original_name: 'Robert Mackenzie',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5873a841c3a368174c00d09b',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1419234,
          known_for_department: 'Editing',
          name: 'James Ashton',
          original_name: 'James Ashton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5873a8799251410e6d00bf6f',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1431513,
          known_for_department: 'Visual Effects',
          name: 'Julian Dimsey',
          original_name: 'Julian Dimsey',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5873a7219251410e7300bdce',
          department: 'Visual Effects',
          job: 'VFX Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1450272,
          known_for_department: 'Biên kịch',
          name: 'Saroo Brierley',
          original_name: 'Saroo Brierley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '588cc299c3a3681c0b000d9c',
          department: 'Biên kịch',
          job: 'Book',
        },
        {
          adult: false,
          gender: 0,
          id: 1452994,
          known_for_department: 'Visual Effects',
          name: 'Guillaume Roux',
          original_name: 'Guillaume Roux',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5873a6e69251410e6b00b587',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1505079,
          known_for_department: 'Sound',
          name: 'Alex Francis',
          original_name: 'Alex Francis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5873a80fc3a368175600c42c',
          department: 'Sound',
          job: 'Foley',
        },
        {
          adult: false,
          gender: 0,
          id: 1505086,
          known_for_department: 'Sound',
          name: 'Jemma Burns',
          original_name: 'Jemma Burns',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58739a1cc3a3681731009b73',
          department: 'Sound',
          job: 'Music Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1516456,
          known_for_department: 'Production',
          name: 'Maribeth Fox',
          original_name: 'Maribeth Fox',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58739a6e9251410e6200b117',
          department: 'Production',
          job: 'Casting Associate',
        },
        {
          adult: false,
          gender: 0,
          id: 1555186,
          known_for_department: 'Costume & Make-Up',
          name: 'Riyaz Ali Merchant',
          original_name: 'Riyaz Ali Merchant',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58739a3cc3a368174c00c323',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1555211,
          known_for_department: 'Costume & Make-Up',
          name: 'Kamlesh U. Shinde',
          original_name: 'Kamlesh U. Shinde',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5873a8d0c3a368176800de11',
          department: 'Costume & Make-Up',
          job: 'Key Makeup Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 1569342,
          known_for_department: 'Camera',
          name: 'Andrew AJ Johnson',
          original_name: 'Andrew AJ Johnson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58739aecc3a3681731009c21',
          department: 'Camera',
          job: 'Steadicam Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1578021,
          known_for_department: 'Sound',
          name: 'Andrew Ramage',
          original_name: 'Andrew Ramage',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5873a7a09251410e6800bb85',
          department: 'Crew',
          job: 'Sound Recordist',
        },
        {
          adult: false,
          gender: 0,
          id: 1644252,
          known_for_department: 'Camera',
          name: 'Peter Beeh',
          original_name: 'Peter Beeh',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58739b0e9251410e7700abca',
          department: 'Camera',
          job: 'Aerial Camera (suggest in addition to Helicopter Camera)',
        },
        {
          adult: false,
          gender: 0,
          id: 1660308,
          known_for_department: 'Visual Effects',
          name: 'Sid Jayakar',
          original_name: 'Sid Jayakar',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5873a7639251410e6b00b5e9',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1689963,
          known_for_department: 'Sound',
          name: 'Tim Ryan',
          original_name: 'Tim Ryan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '587399e8c3a368174100ac5c',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1708703,
          known_for_department: 'Costume & Make-Up',
          name: 'Luize Joyce Margaret',
          original_name: 'Luize Joyce Margaret',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5873a8bf9251410e7700b7ae',
          department: 'Costume & Make-Up',
          job: 'Key Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1717739,
          known_for_department: 'Crew',
          name: 'Avi Goodman',
          original_name: 'Avi Goodman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5873a6fc9251410e7300bdad',
          department: 'Crew',
          job: 'CG Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1729046,
          known_for_department: 'Visual Effects',
          name: 'Rebecca Vujanovic',
          original_name: 'Rebecca Vujanovic',
          popularity: 0.629,
          profile_path: null,
          credit_id: '5873a737c3a368175600c369',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1735820,
          known_for_department: 'Production',
          name: 'Tess Joseph',
          original_name: 'Tess Joseph',
          popularity: 0.6,
          profile_path: null,
          credit_id: '587397269251410e6d00ae23',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 1735822,
          known_for_department: 'Art',
          name: 'Seema Kashyap',
          original_name: 'Seema Kashyap',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58739908c3a3681731009a73',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 1735825,
          known_for_department: 'Directing',
          name: 'Guy Strachan',
          original_name: 'Guy Strachan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5873995cc3a368175e009872',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1735827,
          known_for_department: 'Sound',
          name: 'Francesco Le Metre',
          original_name: 'Francesco Le Metre',
          popularity: 0.6,
          profile_path: null,
          credit_id: '587399fe9251410e7100ade1',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1735830,
          known_for_department: 'Costume & Make-Up',
          name: 'Barbara Pinn',
          original_name: 'Barbara Pinn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58739a53c3a368174600a20e',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1735832,
          known_for_department: 'Lighting',
          name: 'Ramesh Sadrani',
          original_name: 'Ramesh Sadrani',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58739b58c3a368176800d037',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1735833,
          known_for_department: 'Camera',
          name: 'Sunny Wilding',
          original_name: 'Sunny Wilding',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58739b7ec3a368176800d066',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1735855,
          known_for_department: 'Visual Effects',
          name: 'Timothy Jeffs',
          original_name: 'Timothy Jeffs',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5873a6cc9251410e6d00be07',
          department: 'Visual Effects',
          job: 'Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1735857,
          known_for_department: 'Costume & Make-Up',
          name: 'Kirsten Veysey',
          original_name: 'Kirsten Veysey',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5873a8e59251410e6200bf49',
          department: 'Costume & Make-Up',
          job: 'Key Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1735859,
          known_for_department: 'Editing',
          name: 'Maria Papoutsis',
          original_name: 'Maria Papoutsis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5873a94ec3a368176800de95',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1764991,
          known_for_department: 'Production',
          name: 'Karen Sproul',
          original_name: 'Karen Sproul',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58b0fdc1c3a3680701003dd7',
          department: 'Production',
          job: 'Associate Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1764992,
          known_for_department: 'Production',
          name: 'Simone Nicholson',
          original_name: 'Simone Nicholson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58b0fdcec3a3680732003ef4',
          department: 'Production',
          job: 'Associate Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1764993,
          known_for_department: 'Production',
          name: 'Shahen Mekertichian',
          original_name: 'Shahen Mekertichian',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58b0fe0c9251415b31003a4f',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2033405,
          known_for_department: 'Camera',
          name: 'Stephen Oh',
          original_name: 'Stephen Oh',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ae793029251410d3400ed91',
          department: 'Camera',
          job: 'Aerial Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2887235,
          known_for_department: 'Camera',
          name: 'Ryley Brown',
          original_name: 'Ryley Brown',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fd04c6468929c003bc478ae',
          department: 'Camera',
          job: 'Camera Operator',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'djgri',
          author_details: {
            name: '',
            username: 'djgri',
            avatar_path: null,
            rating: 4.0,
          },
          content:
            'An interesting true story. Film starts well and ends well. In the middle, there is a rapid acceleration from being a boy to being a man that misses out on a lot of an explanation as to how he ended up being the person he was. Quite boring in the middle of the film, which is a shame since the young actor was excellent.',
          created_at: '2017-05-01T08:05:05.214Z',
          id: '5906ec31c3a3684ab402d3dc',
          updated_at: '2021-06-23T15:57:56.830Z',
          url: 'https://www.themoviedb.org/review/5906ec31c3a3684ab402d3dc',
        },
        {
          author: 'Reno',
          author_details: {
            name: 'Reno',
            username: 'Rangan',
            avatar_path: '/6ZpVUJzqXMzH35VprEtnX0sNI3.jpg',
            rating: 9.0,
          },
          content:
            "**Lost in India, found in Australia!**\r\n\r\nBased on the book 'A Long Way Home' that tells the story of a young Indian boy who lost his brother in a railway station in the night and the next morning he woke up thousands kilometers away from home. Not knowing the language or the address and the names of his family, he struggled from various threats in the society. After that he got adopted from an Australian family and the rest of the film revolved on his true identity. Haunted by his past, how he rediscovered his originality was emotionally told.\r\n\r\nVery impressive film. The families should not miss it. Even though it is a must see by all ages. I am not a big fan of Dev's performances, even in his debut film 'Slumdog Millionaire'. After that success, he had survived in the film industry doing decent roles, for like a decade. But it was 'The Man Who Knew Infinity' that changed his career. For the first time I liked him very much in that, and again he was pretty impressive in this. The second best performance in his career. Though his part comes only after the half way mark. Yet in that one hour, he did great, particularly in the sentiments.\r\n\r\nI was wondering why it was called 'Lion'. And I got answered only just before the end credit. So you should be patient to learn why, if you are yet to see it. It was not until the 90s the India began to see a real change. This story takes place in the mid 80s, only the opening half and those parts were raw and cruel, especially in the eyes of an 8 year old boy. That kid was so good. Just like Jacom Tremblay, a year before who impressed us with his performance from the film 'Room'.\r\n\r\nIt was a feature film debut for the director and he was wonderful in this attempt. The film splits into two, the first half was about lost and the following half is about finding the road back to the home. Less dialogues, but well written in those necessary parts. The music was good. Only negative was the film was out of depth. Yeah, all the events were like fast forward. If they had focused on details, the narration would have reached at least 3 hours. Especially I wanted the Australian mother's perspective on how she went through to raise those kids.\r\n\r\nNow I'm waiting for the 2020. I mean 2008 was SDM, 2012 was LoP and 2016 was this one. The 4 years later, surely there will be another India related western film would come. Despite this film nominated for the 6 Oscars, it had won nothing. That's very sad. Overall, I strongly suggest it. One of the best films of the Year.\r\n\r\n_9/10_",
          created_at: '2017-06-26T23:40:02.176Z',
          id: '59519b529251412ac7014299',
          updated_at: '2021-06-23T15:57:58.808Z',
          url: 'https://www.themoviedb.org/review/59519b529251412ac7014299',
        },
      ],
      total_pages: 1,
      total_results: 2,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/4GV7v37r43vPkRNowLIFrpWAb20.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 27, name: 'Phim Kinh Dị' },
      { id: 14, name: 'Phim Giả Tượng' },
      { id: 10749, name: 'Phim Lãng Mạn' },
    ],
    homepage: '',
    id: 516850,
    imdb_id: 'tt7162390',
    original_language: 'ru',
    original_title: 'Русалка. Озеро мертвых',
    overview:
      'Truyền thuyết kể rằng, nếu bạn bơi tại hồ tử thần vào ban đêm, Mỹ nhân ngư sẽ xuất hiện… Từ nhiều năm trước, một cô gái trẻ không may bị chết đuối và trở thành Tiên cá hắc ám dưới Hồ Tử Thần. Ả ta sa vào lưới tình với Roman và muốn giữ chàng cho riêng mình mãi mãi. Để vĩnh viễn chiếm đoạt Roman, ả âm mưu dìm hôn thê Marina của chàng xuống đáy hồ. Điều gì sẽ xảy ra? Liệu Marina có cứu được chính mình cùng với Roman?”',
    popularity: 12.242,
    poster_path:
      'https://image.tmdb.org/t/p/w342/9s1dZT7G95zL3JZ3K34VHZi6oa5.jpg',
    production_companies: [
      { id: 103137, logo_path: null, name: 'QS Films', origin_country: 'RU' },
      { id: 107811, logo_path: null, name: 'STGCinema', origin_country: '' },
      {
        id: 3419,
        logo_path: '/byrxE2pJD9JLyBCIzyK0pYVanyG.png',
        name: 'Central Partnership',
        origin_country: 'RU',
      },
    ],
    production_countries: [{ iso_3166_1: 'RU', name: 'Russia' }],
    release_date: '2018-07-12',
    revenue: 0,
    runtime: 90,
    spoken_languages: [
      { english_name: 'Russian', iso_639_1: 'ru', name: 'Pусский' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Mỹ Nhân Ngư: Hồ Tử Thần',
    video: false,
    vote_average: 6.3,
    vote_count: 251,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Clip: Pretty Smile',
          key: 'IjztgvDJC7E',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: true,
          published_at: '2019-02-04T17:00:02.000Z',
          id: '61485dbe6097500043901748',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Clip: Vivid Dream',
          key: 'AClBVUtCiSA',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: true,
          published_at: '2019-02-04T17:00:01.000Z',
          id: '61485e6570309f002af743e6',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Official Trailer',
          key: 'koBvnxSBqk4',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2019-01-14T16:46:06.000Z',
          id: '61485e3c168935008f0d7b69',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 1853565,
          known_for_department: 'Diễn viên',
          name: 'Victoria Agalakova',
          original_name: 'Victoria Agalakova',
          popularity: 5.733,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4iIKyph4fUKGdCuNRzXw5y4HA1H.jpg',
          cast_id: 15,
          character: 'Marina',
          credit_id: '5ac9e1620e0a264974056c3d',
          order: 0,
        },
        {
          adult: false,
          gender: 0,
          id: 1783718,
          known_for_department: 'Diễn viên',
          name: 'Efim Petrunin',
          original_name: 'Efim Petrunin',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jWBMkvcS7UZXt6Hpyl7TKmAx7Oe.jpg',
          cast_id: 16,
          character: 'Roma Kitaev',
          credit_id: '5ac9e1a592514162ae0553ff',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 1850402,
          known_for_department: 'Diễn viên',
          name: 'Nikita Elenev',
          original_name: 'Nikita Elenev',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/62LDDOsAqrAl6PYJvboyyBcZozA.jpg',
          cast_id: 17,
          character: 'Ilya',
          credit_id: '5ac9e1c2c3a36834de0518e8',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 2018536,
          known_for_department: 'Diễn viên',
          name: 'Sesil Plezhe',
          original_name: 'Sesil Plezhe',
          popularity: 0.6,
          profile_path: null,
          cast_id: 18,
          character: 'Olga',
          credit_id: '5ac9e24b92514162b105229c',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 2018540,
          known_for_department: 'Diễn viên',
          name: 'Sofya Shidlovskaya',
          original_name: 'Sofya Shidlovskaya',
          popularity: 1.15,
          profile_path:
            'https://image.tmdb.org/t/p/w185/t7n0y5pS5JLvsQfb7OEF9mNc0de.jpg',
          cast_id: 20,
          character: 'Lisa Grigorieva',
          credit_id: '5ac9e38c92514162ae0555d0',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 1034698,
          known_for_department: 'Diễn viên',
          name: 'Igor Khripunov',
          original_name: 'Igor Khripunov',
          popularity: 2.653,
          profile_path:
            'https://image.tmdb.org/t/p/w185/k9Nw2mZlLAtbZOJdTmnbX4Vj8hK.jpg',
          cast_id: 19,
          character: '',
          credit_id: '5ac9e34e0e0a264965059b2f',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 2018542,
          known_for_department: 'Diễn viên',
          name: 'Dariya Yartseva',
          original_name: 'Dariya Yartseva',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/v5BMoIwYv0P4u7nKKP6jOYJnFVt.jpg',
          cast_id: 21,
          character: 'Bride',
          credit_id: '5ac9e40e0e0a264977058ebb',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 2018544,
          known_for_department: 'Diễn viên',
          name: 'Dmitry Yartsev',
          original_name: 'Dmitry Yartsev',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hQI3x73J24HC48nQ1BRvAKXuXV3.jpg',
          cast_id: 22,
          character: "Bride's Father",
          credit_id: '5ac9e4c092514162b705059f',
          order: 7,
        },
        {
          adult: false,
          gender: 1,
          id: 2018545,
          known_for_department: 'Diễn viên',
          name: 'Alla Artamonova',
          original_name: 'Alla Artamonova',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/taQ7pgQT6etn4waIZELYhYZ5DYj.jpg',
          cast_id: 23,
          character: 'Victim',
          credit_id: '5ac9e54a92514162ae0557a1',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 2018546,
          known_for_department: 'Diễn viên',
          name: 'Emil Sales',
          original_name: 'Emil Sales',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/g8O3gLD6lDibkEZMa2Wqm3hCgzR.jpg',
          cast_id: 24,
          character: 'Groom Mermaid',
          credit_id: '5ac9e5c292514162b7050672',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 2018547,
          known_for_department: 'Diễn viên',
          name: 'Nadezhda Igoshina',
          original_name: 'Nadezhda Igoshina',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/raBVV8xwnlZgfPQUDNkOOjKZsc3.jpg',
          cast_id: 25,
          character: 'Mother',
          credit_id: '5ac9e6480e0a26497a05903d',
          order: 10,
        },
      ],
      crew: [
        {
          adult: true,
          gender: 2,
          id: 118328,
          known_for_department: 'Production',
          name: 'Alexandr Bondarev',
          original_name: 'Alexandr Bondarev',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dkMkZ1RuPBPqQvNe5Kwg90dFxHc.jpg',
          credit_id: '5ac9df9ec3a36834d0053856',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1008387,
          known_for_department: 'Directing',
          name: 'Dzhanik Fayziev',
          original_name: 'Dzhanik Fayziev',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eTTdWtZkhcl6YVrmYoAl8UtrkUy.jpg',
          credit_id: '5ac9de9492514162b4054552',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1311031,
          known_for_department: 'Biên kịch',
          name: 'Svyatoslav Podgaevsky',
          original_name: 'Svyatoslav Podgaevsky',
          popularity: 1.015,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lFJyhIp5960Urn1MmJ7eW8G7p4k.jpg',
          credit_id: '5ac9d7fc0e0a26496e058c5a',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 1311031,
          known_for_department: 'Biên kịch',
          name: 'Svyatoslav Podgaevsky',
          original_name: 'Svyatoslav Podgaevsky',
          popularity: 1.015,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lFJyhIp5960Urn1MmJ7eW8G7p4k.jpg',
          credit_id: '5ac9d7e092514162b4053e5a',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1311031,
          known_for_department: 'Biên kịch',
          name: 'Svyatoslav Podgaevsky',
          original_name: 'Svyatoslav Podgaevsky',
          popularity: 1.015,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lFJyhIp5960Urn1MmJ7eW8G7p4k.jpg',
          credit_id: '5ac9d7ef0e0a2649770581b8',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1620055,
          known_for_department: 'Biên kịch',
          name: 'Ivan Kapitonov',
          original_name: 'Ivan Kapitonov',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lCYMLsICNFaEtMIeW1acSc57IWL.jpg',
          credit_id: '5ac9dcf392514162ab05642c',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 1620055,
          known_for_department: 'Biên kịch',
          name: 'Ivan Kapitonov',
          original_name: 'Ivan Kapitonov',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lCYMLsICNFaEtMIeW1acSc57IWL.jpg',
          credit_id: '5ac9e066c3a36834e805b41d',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1876333,
          known_for_department: 'Costume & Make-Up',
          name: 'Svetlana Gribanova',
          original_name: 'Svetlana Gribanova',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1luJO4xwNlmN5aridCYD3mRFRpM.jpg',
          credit_id: '5ac9d977c3a36834d705dbcf',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 2,
          id: 2018515,
          known_for_department: 'Editing',
          name: 'Anton Komrakov',
          original_name: 'Anton Komrakov',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jMjd636F8jMtmz8CKUyphgTdERT.jpg',
          credit_id: '5ac9d90f0e0a26496e058d7b',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 2018517,
          known_for_department: 'Art',
          name: 'Alexandra Fatina',
          original_name: 'Alexandra Fatina',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ac9d9fe92514162a804c6b1',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 2,
          id: 2018518,
          known_for_department: 'Camera',
          name: 'Anton Zenkovich',
          original_name: 'Anton Zenkovich',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wQCOwe1BIEnXi5xtcozC3PlzWC3.jpg',
          credit_id: '5c3c2eeac3a36821623c6f39',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 1,
          id: 2018519,
          known_for_department: 'Biên kịch',
          name: 'Nataliya Dubovaya',
          original_name: 'Nataliya Dubovaya',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/blruyjHTEGtlEs2UkUmpeHjegEk.jpg',
          credit_id: '5ac9dc7492514162a2053dab',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 2018526,
          known_for_department: 'Production',
          name: 'Rafael Minasbekyan',
          original_name: 'Rafael Minasbekyan',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tz6Sq014INkqS5EX87jx0HmOZV3.jpg',
          credit_id: '5ac9deb90e0a2649650595f2',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 2018532,
          known_for_department: 'Production',
          name: 'Stanislav Grachev',
          original_name: 'Stanislav Grachev',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pSA2CB0bSz0doACn7ZDZ52sneSU.jpg',
          credit_id: '5ac9e07bc3a3687a4f01f4d2',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 2018535,
          known_for_department: 'Production',
          name: 'Maxim Kovalevich',
          original_name: 'Maxim Kovalevich',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ac9e0fb0e0a2649650598d9',
          department: 'Production',
          job: 'Executive Producer',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/apTOVNAkOg5O8jN9G8tfYgZf1HG.jpg',
    belongs_to_collection: null,
    budget: 44000000,
    genres: [
      { id: 28, name: 'Phim Hành Động' },
      { id: 12, name: 'Phim Phiêu Lưu' },
      { id: 10749, name: 'Phim Lãng Mạn' },
      { id: 878, name: 'Phim Khoa Học Viễn Tưởng' },
      { id: 53, name: 'Phim Gây Cấn' },
    ],
    homepage: 'http://thehostthefilm.com/',
    id: 72710,
    imdb_id: 'tt1517260',
    original_language: 'en',
    original_title: 'The Host',
    overview:
      'Phim được chuyển thể từ tiểu thuyết cùng tên của nhà văn Stephenie Meyer – tác giả loạt truyện kinh dị lãng mạn nổi tiếngTwilight. Bộ phim kể về câu chuyện tình yêu của đôi bạn trẻ Melanie Stryder và Jared trong bối cảnh Trái Đất bị xâm chiếm bởi những người ngoài hành tinh có khả năng chiếm giữ cơ thể con người, biến họ thành những vật chủ. Melanie, một trong những người sống sót cuối cùng, bị một trong những linh hồn ký sinh đó xâm chiếm cơ thể của Melanie Stryder. Nhưng thay vì thực hiện nhiệm vụ của giống loài là chiếm giữ Trái Đất, "Lữ Hành" trở nên gắn kết với vật chủ của mình và bắt đầu giải cứu những con người còn tự do...',
    popularity: 28.441,
    poster_path:
      'https://image.tmdb.org/t/p/w342/ok2sl6rGITZ0W94DeRU4VkB2ssW.jpg',
    production_companies: [
      {
        id: 10427,
        logo_path: '/3u5sNgPRbba0ND3SUMXPTT7On9h.png',
        name: 'Open Road Films',
        origin_country: 'US',
      },
      {
        id: 8073,
        logo_path: null,
        name: 'Nick Wechsler Productions',
        origin_country: 'US',
      },
      { id: 12075, logo_path: null, name: 'Silver Reel', origin_country: 'CH' },
      {
        id: 13649,
        logo_path: null,
        name: 'Chockstone Pictures',
        origin_country: '',
      },
      {
        id: 33,
        logo_path: '/8lvHyhjr8oUKOOy2dKXoALWKdp0.png',
        name: 'Universal Pictures',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2013-03-22',
    revenue: 63327201,
    runtime: 125,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'You will be one of us',
    title: 'Vật Chủ',
    video: false,
    vote_average: 6.3,
    vote_count: 3490,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Host Official Trailer #2 (2013) - Saoirse Ronan Movie HD',
          key: 'SRKjf8b4f2E',
          site: 'YouTube',
          size: 720,
          type: 'Trailer',
          published_at: '2012-11-13T17:08:35.000Z',
          official: false,
          id: '5c6360e39251412fc4fd7776',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 36592,
          known_for_department: 'Diễn viên',
          name: 'Saoirse Ronan',
          original_name: 'Saoirse Ronan',
          popularity: 7.346,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9buDPdqKN9vbnQLLkHEinDtMrCG.jpg',
          cast_id: 52,
          character: 'Melanie Stryder / Wanda',
          credit_id: '52fe487bc3a368484e0fa99d',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 9824,
          known_for_department: 'Diễn viên',
          name: 'Diane Kruger',
          original_name: 'Diane Kruger',
          popularity: 6.591,
          profile_path:
            'https://image.tmdb.org/t/p/w185/A7S3Lku5Ebgds3VwfFutrFt2kiv.jpg',
          cast_id: 11,
          character: 'The Seeker / Lacey',
          credit_id: '52fe487bc3a368484e0fa8eb',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 232396,
          known_for_department: 'Diễn viên',
          name: 'Max Irons',
          original_name: 'Max Irons',
          popularity: 3.733,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8TRKWEEQr6GreyrAQ8AWZo4jWjS.jpg',
          cast_id: 15,
          character: 'Jared Howe',
          credit_id: '52fe487bc3a368484e0fa8fb',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 105727,
          known_for_department: 'Diễn viên',
          name: 'Jake Abel',
          original_name: 'Jake Abel',
          popularity: 4.578,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qPFAG3wNIUYO7HHZ3HHn6Kdr1PM.jpg',
          cast_id: 12,
          character: "Ian O'Shea",
          credit_id: '52fe487bc3a368484e0fa8ef',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 227,
          known_for_department: 'Diễn viên',
          name: 'William Hurt',
          original_name: 'William Hurt',
          popularity: 8.153,
          profile_path:
            'https://image.tmdb.org/t/p/w185/j3mjmuHLBW4XQSw53C8Sh0Lh3ZQ.jpg',
          cast_id: 13,
          character: 'Jeb Stryder',
          credit_id: '52fe487bc3a368484e0fa8f3',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 3713,
          known_for_department: 'Diễn viên',
          name: 'Frances Fisher',
          original_name: 'Frances Fisher',
          popularity: 6.427,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tsyGcoXGRNM8KGLpLG3OuxAyxx2.jpg',
          cast_id: 14,
          character: 'Maggie Stryder',
          credit_id: '52fe487bc3a368484e0fa8f7',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 77334,
          known_for_department: 'Diễn viên',
          name: 'Chandler Canterbury',
          original_name: 'Chandler Canterbury',
          popularity: 4.1,
          profile_path:
            'https://image.tmdb.org/t/p/w185/flfh9tLEiERwZFQPlcShejI1TS8.jpg',
          cast_id: 16,
          character: 'Jamie Stryder',
          credit_id: '52fe487bc3a368484e0fa8ff',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 467645,
          known_for_department: 'Diễn viên',
          name: 'Boyd Holbrook',
          original_name: 'Boyd Holbrook',
          popularity: 5.059,
          profile_path:
            'https://image.tmdb.org/t/p/w185/531YOKa2usleWCA55t6Db4MZhT3.jpg',
          cast_id: 17,
          character: "Kyle O'Shea",
          credit_id: '52fe487bc3a368484e0fa903',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 936403,
          known_for_department: 'Diễn viên',
          name: 'Stephen Rider',
          original_name: 'Stephen Rider',
          popularity: 1.078,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jMrQPv21ayJwf48neXKKWsjqcDu.jpg',
          cast_id: 20,
          character: 'Seeker Reed',
          credit_id: '52fe487bc3a368484e0fa913',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 558466,
          known_for_department: 'Diễn viên',
          name: 'Alex Russell',
          original_name: 'Alex Russell',
          popularity: 1.562,
          profile_path:
            'https://image.tmdb.org/t/p/w185/o1Z5Fo1wzKBGrzOsfxDq9vPbnq0.jpg',
          cast_id: 50,
          character: 'Seeker Burns',
          credit_id: '52fe487bc3a368484e0fa995',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 35198,
          known_for_department: 'Diễn viên',
          name: 'Rachel Roberts',
          original_name: 'Rachel Roberts',
          popularity: 2.177,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hESAMcshJW552D4DF41GTQ6xhUZ.jpg',
          cast_id: 27,
          character: 'Soul Fleur',
          credit_id: '52fe487bc3a368484e0fa939',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 129868,
          known_for_department: 'Diễn viên',
          name: 'J.D. Evermore',
          original_name: 'J.D. Evermore',
          popularity: 1.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bTLrDTIj9DNnYP8afZXPTo31CJA.jpg',
          cast_id: 37,
          character: 'Trevor Stryder',
          credit_id: '52fe487bc3a368484e0fa961',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 70456,
          known_for_department: 'Diễn viên',
          name: 'Emily Browning',
          original_name: 'Emily Browning',
          popularity: 8.02,
          profile_path:
            'https://image.tmdb.org/t/p/w185/silK3Pdugbf1YOtIdXev1eZxzvF.jpg',
          cast_id: 22,
          character: 'Wanda',
          credit_id: '52fe487bc3a368484e0fa91d',
          order: 12,
        },
        {
          adult: false,
          gender: 0,
          id: 1273231,
          known_for_department: 'Diễn viên',
          name: 'Shyaam Karra',
          original_name: 'Shyaam Karra',
          popularity: 0.6,
          profile_path: null,
          cast_id: 28,
          character: 'Soul Anshu',
          credit_id: '52fe487bc3a368484e0fa93d',
          order: 13,
        },
        {
          adult: false,
          gender: 0,
          id: 1273232,
          known_for_department: 'Diễn viên',
          name: 'Brent Wendell Williams',
          original_name: 'Brent Wendell Williams',
          popularity: 0.98,
          profile_path: null,
          cast_id: 29,
          character: 'Soul Winters',
          credit_id: '52fe487bc3a368484e0fa941',
          order: 14,
        },
        {
          adult: false,
          gender: 0,
          id: 1273233,
          known_for_department: 'Diễn viên',
          name: 'Jhil McEntyre',
          original_name: 'Jhil McEntyre',
          popularity: 0.98,
          profile_path: null,
          cast_id: 30,
          character: 'Soul Lake',
          credit_id: '52fe487bc3a368484e0fa945',
          order: 15,
        },
        {
          adult: false,
          gender: 0,
          id: 1273234,
          known_for_department: 'Diễn viên',
          name: 'Jalen Coleman',
          original_name: 'Jalen Coleman',
          popularity: 0.6,
          profile_path: null,
          cast_id: 31,
          character: 'Soul Nafisa',
          credit_id: '52fe487bc3a368484e0fa949',
          order: 16,
        },
        {
          adult: false,
          gender: 0,
          id: 1181296,
          known_for_department: 'Diễn viên',
          name: 'Jaylen Moore',
          original_name: 'Jaylen Moore',
          popularity: 1.675,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fFOu4NtqhxLaVoMi2xwRT6ofeaP.jpg',
          cast_id: 32,
          character: 'Seeker Song',
          credit_id: '52fe487bc3a368484e0fa94d',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 1273235,
          known_for_department: 'Diễn viên',
          name: 'Stephen Conroy',
          original_name: 'Stephen Conroy',
          popularity: 1.491,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ngy98NITtbHvVPxcmcTMkSz1Knf.jpg',
          cast_id: 33,
          character: 'Seeker Sands',
          credit_id: '52fe487bc3a368484e0fa951',
          order: 18,
        },
        {
          adult: false,
          gender: 0,
          id: 1273236,
          known_for_department: 'Diễn viên',
          name: 'Michael L. Parker',
          original_name: 'Michael L. Parker',
          popularity: 0.6,
          profile_path: null,
          cast_id: 34,
          character: 'Seeker Wolfe',
          credit_id: '52fe487bc3a368484e0fa955',
          order: 19,
        },
        {
          adult: false,
          gender: 0,
          id: 92058,
          known_for_department: 'Diễn viên',
          name: 'Phil Austin',
          original_name: 'Phil Austin',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rfgWK2zjC9qTNu9jXSqmFqXQl3a.jpg',
          cast_id: 35,
          character: 'Seeker Waverley',
          credit_id: '52fe487bc3a368484e0fa959',
          order: 20,
        },
        {
          adult: false,
          gender: 2,
          id: 16460,
          known_for_department: 'Diễn viên',
          name: 'Marcus Lyle Brown',
          original_name: 'Marcus Lyle Brown',
          popularity: 0.665,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zHsqlROpMRsvtW70bgbkSEqakCd.jpg',
          cast_id: 36,
          character: 'Healer Fords',
          credit_id: '52fe487bc3a368484e0fa95d',
          order: 21,
        },
        {
          adult: false,
          gender: 0,
          id: 1273237,
          known_for_department: 'Diễn viên',
          name: 'John Wilmot',
          original_name: 'John Wilmot',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dUGcM4T8SKFhHCEtCH1HOoj3fvm.jpg',
          cast_id: 38,
          character: 'Soul Raines',
          credit_id: '52fe487bc3a368484e0fa965',
          order: 22,
        },
        {
          adult: false,
          gender: 0,
          id: 1273238,
          known_for_department: 'Diễn viên',
          name: 'Evan Cleaver',
          original_name: 'Evan Cleaver',
          popularity: 0.6,
          profile_path: null,
          cast_id: 39,
          character: 'Seeker Pavo',
          credit_id: '52fe487bc3a368484e0fa969',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 1273239,
          known_for_department: 'Diễn viên',
          name: 'Mustafa Harris',
          original_name: 'Mustafa Harris',
          popularity: 0.828,
          profile_path: null,
          cast_id: 40,
          character: 'Brandt',
          credit_id: '52fe487bc3a368484e0fa96d',
          order: 24,
        },
        {
          adult: false,
          gender: 2,
          id: 42317,
          known_for_department: 'Diễn viên',
          name: 'Scott Lawrence',
          original_name: 'Scott Lawrence',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8lwnmlHN6QPK75NwfufsIFZZhmB.jpg',
          cast_id: 41,
          character: 'Doc',
          credit_id: '52fe487bc3a368484e0fa971',
          order: 25,
        },
        {
          adult: false,
          gender: 0,
          id: 176491,
          known_for_department: 'Diễn viên',
          name: 'Shawn Carter Peterson',
          original_name: 'Shawn Carter Peterson',
          popularity: 0.993,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4sh2N9glH4MhpjmejarrAvjvvSK.jpg',
          cast_id: 42,
          character: 'Wes',
          credit_id: '52fe487bc3a368484e0fa975',
          order: 26,
        },
        {
          adult: false,
          gender: 1,
          id: 1123886,
          known_for_department: 'Diễn viên',
          name: 'Raeden Greer',
          original_name: 'Raeden Greer',
          popularity: 2.493,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kqUWRAsN5lzfVMlTE9SbFB2Bw20.jpg',
          cast_id: 43,
          character: 'Lily',
          credit_id: '52fe487bc3a368484e0fa979',
          order: 27,
        },
        {
          adult: false,
          gender: 2,
          id: 1112417,
          known_for_department: 'Diễn viên',
          name: 'Tatanka Means',
          original_name: 'Tatanka Means',
          popularity: 1.052,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vf5h5mlGRrQI5DGCRD1hM01MHah.jpg',
          cast_id: 44,
          character: 'Seeker Hawke',
          credit_id: '52fe487bc3a368484e0fa97d',
          order: 28,
        },
        {
          adult: false,
          gender: 0,
          id: 79211,
          known_for_department: 'Diễn viên',
          name: 'David House',
          original_name: 'David House',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/t67HnLsCMecFLMdhtJQbkiQiyXq.jpg',
          cast_id: 46,
          character: 'Seeker Summers',
          credit_id: '52fe487bc3a368484e0fa985',
          order: 29,
        },
        {
          adult: false,
          gender: 0,
          id: 1273240,
          known_for_department: 'Diễn viên',
          name: 'Ruby Lou Smith',
          original_name: 'Ruby Lou Smith',
          popularity: 0.6,
          profile_path: null,
          cast_id: 47,
          character: 'Soul Pearle',
          credit_id: '52fe487bc3a368484e0fa989',
          order: 30,
        },
        {
          adult: false,
          gender: 1,
          id: 946356,
          known_for_department: 'Diễn viên',
          name: 'Andrea Frankle',
          original_name: 'Andrea Frankle',
          popularity: 1.102,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ielAUOMSHkwrdamqqsThdErTSjZ.jpg',
          cast_id: 48,
          character: 'Healer Skye',
          credit_id: '52fe487bc3a368484e0fa98d',
          order: 31,
        },
        {
          adult: false,
          gender: 2,
          id: 1049735,
          known_for_department: 'Diễn viên',
          name: 'Yohance Myles',
          original_name: 'Yohance Myles',
          popularity: 0.744,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nfSaENqW1RbjlSg8gGhlNjwlqau.jpg',
          cast_id: 49,
          character: 'Seeker Nova',
          credit_id: '52fe487bc3a368484e0fa991',
          order: 32,
        },
        {
          adult: false,
          gender: 2,
          id: 71913,
          known_for_department: 'Diễn viên',
          name: 'Bokeem Woodbine',
          original_name: 'Bokeem Woodbine',
          popularity: 12.041,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pnPyA5pJn94zUzuLWTNkGBNZxza.jpg',
          cast_id: 51,
          character: 'Nate',
          credit_id: '52fe487bc3a368484e0fa999',
          order: 33,
        },
        {
          adult: false,
          gender: 1,
          id: 1369033,
          known_for_department: 'Diễn viên',
          name: 'Stacey Carino',
          original_name: 'Stacey Carino',
          popularity: 0.6,
          profile_path: null,
          cast_id: 56,
          character: 'Seeker Dawn',
          credit_id: '56a12cdcc3a36858e500fde3',
          order: 34,
        },
        {
          adult: false,
          gender: 2,
          id: 1566669,
          known_for_department: 'Crew',
          name: 'Erik Schultz',
          original_name: 'Erik Schultz',
          popularity: 0.611,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2fEndqcsasY10F9Z8wOkrdt438Y.jpg',
          cast_id: 57,
          character: 'Seeker Zephyr',
          credit_id: '56a12dc0c3a3683413005c66',
          order: 35,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 3498,
          known_for_department: 'Production',
          name: 'Bill Johnson',
          original_name: 'Bill Johnson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe487bc3a368484e0fa919',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 6044,
          known_for_department: 'Production',
          name: 'Mindy Marin',
          original_name: 'Mindy Marin',
          popularity: 0.828,
          profile_path: null,
          credit_id: '52fe487bc3a368484e0fa923',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 6468,
          known_for_department: 'Production',
          name: 'Nick Wechsler',
          original_name: 'Nick Wechsler',
          popularity: 0.681,
          profile_path: null,
          credit_id: '52fe487bc3a368484e0fa8e7',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 8685,
          known_for_department: 'Biên kịch',
          name: 'Andrew Niccol',
          original_name: 'Andrew Niccol',
          popularity: 2.206,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jTNhskoCvZsLqZwk5CFIrMpCftx.jpg',
          credit_id: '52fe487bc3a368484e0fa90f',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 8685,
          known_for_department: 'Biên kịch',
          name: 'Andrew Niccol',
          original_name: 'Andrew Niccol',
          popularity: 2.206,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jTNhskoCvZsLqZwk5CFIrMpCftx.jpg',
          credit_id: '52fe487bc3a368484e0fa8bd',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 8576,
          known_for_department: 'Sound',
          name: 'Antonio Pinto',
          original_name: 'Antonio Pinto',
          popularity: 4.281,
          profile_path:
            'https://image.tmdb.org/t/p/w185/my56LyiV6z4RftHnjUpDvz1UfYJ.jpg',
          credit_id: '52fe487bc3a368484e0fa935',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 2,
          id: 13000,
          known_for_department: 'Camera',
          name: 'Roberto Schaefer',
          original_name: 'Roberto Schaefer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '58c9c82bc3a36841b6000136',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 20567,
          known_for_department: 'Production',
          name: 'Marc Butan',
          original_name: 'Marc Butan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe487bc3a368484e0fa8c9',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 56856,
          known_for_department: 'Biên kịch',
          name: 'Stephenie Meyer',
          original_name: 'Stephenie Meyer',
          popularity: 2.391,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tOcgB1W13MwlEVNF6rFQosqb3fD.jpg',
          credit_id: '52fe487bc3a368484e0fa8cf',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 56856,
          known_for_department: 'Biên kịch',
          name: 'Stephenie Meyer',
          original_name: 'Stephenie Meyer',
          popularity: 2.391,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tOcgB1W13MwlEVNF6rFQosqb3fD.jpg',
          credit_id: '52fe487bc3a368484e0fa909',
          department: 'Biên kịch',
          job: 'Novel',
        },
        {
          adult: false,
          gender: 2,
          id: 62238,
          known_for_department: 'Production',
          name: 'Jim Seibel',
          original_name: 'Jim Seibel',
          popularity: 1.094,
          profile_path: null,
          credit_id: '52fe487bc3a368484e0fa8e1',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 71556,
          known_for_department: 'Production',
          name: 'Ray Angelic',
          original_name: 'Ray Angelic',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe487bc3a368484e0fa8c3',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 406204,
          known_for_department: 'Costume & Make-Up',
          name: 'Ve Neill',
          original_name: 'Ve Neill',
          popularity: 1.027,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gNYwxuK5Z7Nr3tWtSWv0qAueUIs.jpg',
          credit_id: '52fe487bc3a368484e0fa9a3',
          department: 'Costume & Make-Up',
          job: 'Makeup Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 566958,
          known_for_department: 'Production',
          name: 'Paula Mae Schwartz',
          original_name: 'Paula Mae Schwartz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe487bc3a368484e0fa8d5',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 566962,
          known_for_department: 'Production',
          name: 'Steve Schwartz',
          original_name: 'Steve Schwartz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe487bc3a368484e0fa8db',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 963843,
          known_for_department: 'Art',
          name: 'Priscilla Elliott',
          original_name: 'Priscilla Elliott',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5526d4e79251417165002568',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 1119658,
          known_for_department: 'Editing',
          name: 'Harold Parker',
          original_name: 'Harold Parker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '553fd52bc3a3683c74000066',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 1,
          id: 1193620,
          known_for_department: 'Costume & Make-Up',
          name: 'Erin Benach',
          original_name: 'Erin Benach',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe487bc3a368484e0fa929',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1304298,
          known_for_department: 'Costume & Make-Up',
          name: 'Melanie Deforrest',
          original_name: 'Melanie Deforrest',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5723e6d1c3a3681347000f47',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/gqbTNLpn200fnCyg07LgdwoalOj.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [{ id: 18, name: 'Phim Chính Kịch' }],
    homepage: '',
    id: 547341,
    imdb_id: null,
    original_language: 'vi',
    original_title: 'Khi Vắng Bà',
    overview:
      'Phỏng theo truyện ngắn "Bến tàu trong thành phố" của nhà thơ Xuân Quỳnh',
    popularity: 0.6,
    poster_path:
      'https://image.tmdb.org/t/p/w342/6ZOV3HbFKZHgyF5U6Va8Q2kpHKr.jpg',
    production_companies: [
      {
        id: 7753,
        logo_path: null,
        name: 'Hang Phim Truyen',
        origin_country: '',
      },
    ],
    production_countries: [{ iso_3166_1: 'VN', name: 'Vietnam' }],
    release_date: '1985-01-01',
    revenue: 0,
    runtime: 63,
    spoken_languages: [
      { english_name: 'Vietnamese', iso_639_1: 'vi', name: 'Tiếng Việt' },
    ],
    status: 'Đã phát hành',
    tagline: 'Khi Vắng Bà',
    title: 'Khi Vắng Bà',
    video: false,
    vote_average: 0.0,
    vote_count: 0,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Khi Bà Vắng Nhà Full | Phim Thiếu Nhi Việt Nam Hay',
          key: '_QkwaczQldA',
          published_at: '2016-06-23T02:03:29.000Z',
          site: 'YouTube',
          size: 360,
          type: 'Featurette',
          official: false,
          id: '5b9538c10e0a2619780213e0',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 0,
          id: 2124802,
          known_for_department: 'Diễn viên',
          name: 'Lê Tuấn Long',
          original_name: 'Lê Tuấn Long',
          popularity: 0.6,
          profile_path: null,
          cast_id: 6,
          character: 'Minh (The Boy)',
          credit_id: '5b9537b20e0a26197b020ffa',
          order: 1,
        },
        {
          adult: false,
          gender: 0,
          id: 2124803,
          known_for_department: 'Diễn viên',
          name: 'Năm Hương',
          original_name: 'Năm Hương',
          popularity: 0.6,
          profile_path: null,
          cast_id: 7,
          character: 'The Grandmother',
          credit_id: '5b9537df0e0a2619820210bf',
          order: 2,
        },
        {
          adult: false,
          gender: 0,
          id: 2124805,
          known_for_department: 'Diễn viên',
          name: 'Hoàng Long',
          original_name: 'Hoàng Long',
          popularity: 0.6,
          profile_path: null,
          cast_id: 8,
          character: 'The Father',
          credit_id: '5b9537f8925141432401c2c1',
          order: 3,
        },
        {
          adult: false,
          gender: 0,
          id: 2124806,
          known_for_department: 'Diễn viên',
          name: 'Thanh Hiền',
          original_name: 'Thanh Hiền',
          popularity: 0.6,
          profile_path: null,
          cast_id: 9,
          character: 'The Mother',
          credit_id: '5b9538050e0a26197b021083',
          order: 4,
        },
        {
          adult: false,
          gender: 0,
          id: 2124807,
          known_for_department: 'Diễn viên',
          name: 'Lê Vi',
          original_name: 'Lê Vi',
          popularity: 0.6,
          profile_path: null,
          cast_id: 10,
          character: 'The Teacher',
          credit_id: '5b95381e0e0a261975021bb9',
          order: 5,
        },
        {
          adult: false,
          gender: 0,
          id: 2124808,
          known_for_department: 'Diễn viên',
          name: 'Đinh Văn Thắng',
          original_name: 'Đinh Văn Thắng',
          popularity: 0.6,
          profile_path: null,
          cast_id: 11,
          character: 'Lộc',
          credit_id: '5b95382ec3a368568a01d200',
          order: 6,
        },
        {
          adult: false,
          gender: 0,
          id: 2124809,
          known_for_department: 'Diễn viên',
          name: 'Khánh Vinh',
          original_name: 'Khánh Vinh',
          popularity: 0.6,
          profile_path: null,
          cast_id: 12,
          character: 'Phong',
          credit_id: '5b95383ec3a368567601f162',
          order: 7,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 0,
          id: 2124793,
          known_for_department: 'Biên kịch',
          name: 'Vũ Lê Mai',
          original_name: 'Vũ Lê Mai',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b953662c3a3685681025547',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 0,
          id: 2124795,
          known_for_department: 'Directing',
          name: 'Nguyễn Anh Thái',
          original_name: 'Nguyễn Anh Thái',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b953670925141432b01e0a5',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2124797,
          known_for_department: 'Crew',
          name: 'Phạm Ngọc Lan',
          original_name: 'Phạm Ngọc Lan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b95368ac3a368567f022e12',
          department: 'Crew',
          job: 'Cinematography',
        },
        {
          adult: false,
          gender: 0,
          id: 2124798,
          known_for_department: 'Sound',
          name: 'Hoàng Vân',
          original_name: 'Hoàng Vân',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9536acc3a368568102559f',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 0,
          id: 2124800,
          known_for_department: 'Sound',
          name: 'Mai Thế Hồng',
          original_name: 'Mai Thế Hồng',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5b9536cec3a3685685022c25',
          department: 'Sound',
          job: 'Sound',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/uSi5OqbdD4bo6fIO8nd0SENAzIY.jpg',
    belongs_to_collection: null,
    budget: 10000000,
    genres: [{ id: 18, name: 'Phim Chính Kịch' }],
    homepage: 'http://www.weareallprecious.com/',
    id: 25793,
    imdb_id: 'tt0929632',
    original_language: 'en',
    original_title: 'Precious',
    overview:
      'Là một bộ phim độc lập gây được tiếng vang lớn tại Liên hoan phim Sundance 2009, Precious (Vươn lên) được chuyển thể từ cuốn tiểu thuyết Push của Sapphire. Phim là câu chuyện kể về Precious - một cô gái da đen bị chính cha đẻ của mình lạm dụng tình dục và mang thai đứa con thứ hai của ông ta. Cô còn bị mẹ đẻ của mình ngược đãi, bị mọi người xa lánh vì ngoại hình quá khổ và học vấn thấp kém. Cuộc sống đầy tăm tối và nghiệt ngã, nhưng Precious chưa bao giờ thôi hy vọng vào một tương lai tươi sáng. Chính nghị lực tuyệt vời đã giúp cô gái trẻ vượt qua mọi khó khăn của cuộc sống...',
    popularity: 11.401,
    poster_path:
      'https://image.tmdb.org/t/p/w342/ic1d46g6GIIuCjUoNCuHHeSWQvY.jpg',
    production_companies: [
      {
        id: 4424,
        logo_path: null,
        name: 'Smokewood Entertainment Group',
        origin_country: '',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2009-11-06',
    revenue: 47536959,
    runtime: 110,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
      { english_name: 'Italian', iso_639_1: 'it', name: 'Italiano' },
    ],
    status: 'Đã phát hành',
    tagline: 'We are all precious',
    title: 'Vươn Lên',
    video: false,
    vote_average: 7.4,
    vote_count: 1293,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Precious (2009) - Official Trailer',
          key: 'urFY3jp759c',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2009-05-20T23:12:01.000Z',
          id: '5cc30d1b9251412ba1f7645a',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 109560,
          known_for_department: 'Diễn viên',
          name: 'Gabourey Sidibe',
          original_name: 'Gabourey Sidibe',
          popularity: 1.777,
          profile_path:
            'https://image.tmdb.org/t/p/w185/d0p0MGqM1GrrnBw4b3V9uM6HCl2.jpg',
          cast_id: 1,
          character: 'Precious',
          credit_id: '52fe44dec3a368484e03b7b5',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 60561,
          known_for_department: 'Diễn viên',
          name: "Mo'Nique",
          original_name: "Mo'Nique",
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zEuWWR8opYwdBBOzjrUtxorJzLf.jpg',
          cast_id: 2,
          character: 'Mary',
          credit_id: '52fe44dec3a368484e03b7b9',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 52851,
          known_for_department: 'Diễn viên',
          name: 'Paula Patton',
          original_name: 'Paula Patton',
          popularity: 8.456,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9sLIo0nCh4UEi3dHQCAwrFh0r4j.jpg',
          cast_id: 4,
          character: 'Ms. Rain',
          credit_id: '52fe44dec3a368484e03b7c3',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 66586,
          known_for_department: 'Diễn viên',
          name: 'Mariah Carey',
          original_name: 'Mariah Carey',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wSiQWbkMplbO5wnXYhwQ1g7jyG0.jpg',
          cast_id: 5,
          character: 'Mrs. Weiss',
          credit_id: '52fe44dec3a368484e03b7c7',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 77069,
          known_for_department: 'Diễn viên',
          name: 'Lenny Kravitz',
          original_name: 'Lenny Kravitz',
          popularity: 3.966,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pIoGuEUax5aeH3PKuaYK9wKEeoj.jpg',
          cast_id: 6,
          character: 'Nurse John',
          credit_id: '52fe44dec3a368484e03b7cb',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 109561,
          known_for_department: 'Diễn viên',
          name: 'Sherri Shepherd',
          original_name: 'Sherri Shepherd',
          popularity: 1.456,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uDhUIZadyHec8AUi5zDQ8ilMpn9.jpg',
          cast_id: 7,
          character: 'Cornrows',
          credit_id: '52fe44dec3a368484e03b7cf',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 109562,
          known_for_department: 'Diễn viên',
          name: 'Stephanie Andujar',
          original_name: 'Stephanie Andujar',
          popularity: 0.828,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dNmZm9arYHJdiTbFsL6O6Rx7xHT.jpg',
          cast_id: 8,
          character: 'Rita',
          credit_id: '52fe44dec3a368484e03b7d3',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 109563,
          known_for_department: 'Diễn viên',
          name: 'Chyna Layne',
          original_name: 'Chyna Layne',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uGLBdZxAFfED9RE5gdJcHO3muY.jpg',
          cast_id: 9,
          character: 'Rhonda',
          credit_id: '52fe44dec3a368484e03b7d7',
          order: 7,
        },
        {
          adult: false,
          gender: 1,
          id: 109564,
          known_for_department: 'Diễn viên',
          name: 'Amina Robinson',
          original_name: 'Amina Robinson',
          popularity: 0.6,
          profile_path: null,
          cast_id: 10,
          character: 'Jermaine',
          credit_id: '52fe44dec3a368484e03b7db',
          order: 8,
        },
        {
          adult: false,
          gender: 1,
          id: 109565,
          known_for_department: 'Diễn viên',
          name: 'Xosha Roquemore',
          original_name: 'Xosha Roquemore',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/g0CEVYlW5IPqBmouiIOJD7OdC1Y.jpg',
          cast_id: 11,
          character: 'Joann',
          credit_id: '52fe44dec3a368484e03b7df',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 109566,
          known_for_department: 'Diễn viên',
          name: 'Angelic Zambrana',
          original_name: 'Angelic Zambrana',
          popularity: 1.015,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uW4axkgPdYVn2VFoV4HkyMG6WR3.jpg',
          cast_id: 12,
          character: 'Consuelo',
          credit_id: '52fe44dec3a368484e03b7e3',
          order: 10,
        },
        {
          adult: false,
          gender: 0,
          id: 109567,
          known_for_department: 'Diễn viên',
          name: 'Aunt Dot',
          original_name: 'Aunt Dot',
          popularity: 0.6,
          profile_path: null,
          cast_id: 13,
          character: 'Tootsie',
          credit_id: '52fe44dec3a368484e03b7e7',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 109568,
          known_for_department: 'Diễn viên',
          name: 'Nealla Gordon',
          original_name: 'Nealla Gordon',
          popularity: 0.618,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3TpK3kxculu7qUpCkw1UMlqqeqR.jpg',
          cast_id: 14,
          character: 'Mrs. Lichtenstien',
          credit_id: '52fe44dec3a368484e03b7eb',
          order: 12,
        },
        {
          adult: false,
          gender: 0,
          id: 109569,
          known_for_department: 'Diễn viên',
          name: 'Grace Hightower',
          original_name: 'Grace Hightower',
          popularity: 0.6,
          profile_path: null,
          cast_id: 15,
          character: 'Social Worker',
          credit_id: '52fe44dec3a368484e03b7ef',
          order: 13,
        },
        {
          adult: false,
          gender: 0,
          id: 109570,
          known_for_department: 'Diễn viên',
          name: 'Barret Helms',
          original_name: 'Barret Helms',
          popularity: 0.6,
          profile_path: null,
          cast_id: 16,
          character: 'Tom Cruise (as Barret Isaiah Mindell)',
          credit_id: '52fe44dec3a368484e03b7f3',
          order: 14,
        },
        {
          adult: false,
          gender: 1,
          id: 65397,
          known_for_department: 'Diễn viên',
          name: 'Kimberly Russell',
          original_name: 'Kimberly Russell',
          popularity: 0.695,
          profile_path:
            'https://image.tmdb.org/t/p/w185/shdU4xS8mYlS8N6KFGaT07aYVXc.jpg',
          cast_id: 17,
          character: 'Katherine',
          credit_id: '52fe44dec3a368484e03b7f7',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 32029,
          known_for_department: 'Diễn viên',
          name: 'Bill Sage',
          original_name: 'Bill Sage',
          popularity: 1.909,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2uQv1NMnGrqqhBMKTm5RBCKh7UV.jpg',
          cast_id: 18,
          character: 'Mr. Wicher',
          credit_id: '52fe44dec3a368484e03b7fb',
          order: 16,
        },
        {
          adult: false,
          gender: 0,
          id: 109571,
          known_for_department: 'Diễn viên',
          name: 'Susan Taylor',
          original_name: 'Susan Taylor',
          popularity: 0.6,
          profile_path: null,
          cast_id: 19,
          character: 'Fairy Godmother',
          credit_id: '52fe44dec3a368484e03b7ff',
          order: 17,
        },
        {
          adult: false,
          gender: 0,
          id: 109572,
          known_for_department: 'Diễn viên',
          name: 'Kendall Toombs',
          original_name: 'Kendall Toombs',
          popularity: 0.6,
          profile_path: null,
          cast_id: 20,
          character: 'Abdul, New Born',
          credit_id: '52fe44dec3a368484e03b803',
          order: 18,
        },
        {
          adult: false,
          gender: 0,
          id: 109573,
          known_for_department: 'Diễn viên',
          name: 'Alexander Toombs',
          original_name: 'Alexander Toombs',
          popularity: 0.6,
          profile_path: null,
          cast_id: 21,
          character: 'Abdul, New Born',
          credit_id: '52fe44dec3a368484e03b807',
          order: 19,
        },
        {
          adult: false,
          gender: 0,
          id: 109574,
          known_for_department: 'Diễn viên',
          name: 'Cory Davis',
          original_name: 'Cory Davis',
          popularity: 0.6,
          profile_path: null,
          cast_id: 22,
          character: 'Abdul, 9 Months',
          credit_id: '52fe44dec3a368484e03b80b',
          order: 20,
        },
        {
          adult: false,
          gender: 0,
          id: 109575,
          known_for_department: 'Diễn viên',
          name: 'Rochelle McNaughton',
          original_name: 'Rochelle McNaughton',
          popularity: 0.6,
          profile_path: null,
          cast_id: 23,
          character: 'AIDS Clerk',
          credit_id: '52fe44dec3a368484e03b80f',
          order: 21,
        },
        {
          adult: false,
          gender: 1,
          id: 187847,
          known_for_department: 'Sound',
          name: 'Abigail Savage',
          original_name: 'Abigail Savage',
          popularity: 1.815,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hpsHu1ddCIhoHTgMPl2TKyH0KoF.jpg',
          cast_id: 33,
          character: 'Bunny',
          credit_id: '5c6f6417c3a3685a31d3fc67',
          order: 22,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 8846,
          known_for_department: 'Camera',
          name: 'Andrew Dunn',
          original_name: 'Andrew Dunn',
          popularity: 2.086,
          profile_path: null,
          credit_id: '5ada87d30e0a26143c001504',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 20019,
          known_for_department: 'Directing',
          name: 'Lee Daniels',
          original_name: 'Lee Daniels',
          popularity: 0.7,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6boIrLokvene1qlhvb4wiKB5Ikd.jpg',
          credit_id: '52fe44dec3a368484e03b7bf',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 20019,
          known_for_department: 'Directing',
          name: 'Lee Daniels',
          original_name: 'Lee Daniels',
          popularity: 0.7,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6boIrLokvene1qlhvb4wiKB5Ikd.jpg',
          credit_id: '5ada87adc3a36862c0001316',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 60546,
          known_for_department: 'Production',
          name: 'Lisa Cortés',
          original_name: 'Lisa Cortés',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f1dc1b44bfa540037f2d073',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 60557,
          known_for_department: 'Sound',
          name: 'Mario Grigorov',
          original_name: 'Mario Grigorov',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ada87c90e0a261430001478',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 0,
          id: 68392,
          known_for_department: 'Editing',
          name: 'Joe Klotz',
          original_name: 'Joe Klotz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ada87dcc3a36803fa000922',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 96127,
          known_for_department: 'Costume & Make-Up',
          name: 'Marina Draghici',
          original_name: 'Marina Draghici',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ada87e89251410ac50013a1',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 1,
          id: 966188,
          known_for_department: 'Production',
          name: 'Sarah Siegel-Magness',
          original_name: 'Sarah Siegel-Magness',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5ada87c00e0a261430001469',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1059118,
          known_for_department: 'Biên kịch',
          name: 'Geoffrey Fletcher',
          original_name: 'Geoffrey Fletcher',
          popularity: 0.982,
          profile_path: null,
          credit_id: '52fe44dec3a368484e03b815',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 0,
          id: 1545917,
          known_for_department: 'Production',
          name: 'Gary Magness',
          original_name: 'Gary Magness',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5ada87b6c3a36862bd00130a',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1842583,
          known_for_department: 'Biên kịch',
          name: 'Sapphire',
          original_name: 'Sapphire',
          popularity: 0.608,
          profile_path: null,
          credit_id: '5958046e9251410a59010cd9',
          department: 'Biên kịch',
          job: 'Novel',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'ViciousSnowflake',
          author_details: {
            name: '',
            username: 'ViciousSnowflake',
            avatar_path: null,
            rating: 7.0,
          },
          content:
            'This is kind of a rough movie to watch. A very victimized and bullied teen tries to get through life. It ends on a fairly positive note but damn. Incest babies is just a weird, skin crawling topic for me so that is always going to be rough to go through.',
          created_at: '2020-04-09T01:38:48.682Z',
          id: '5e8e7ca8d35dea0013723049',
          updated_at: '2021-06-23T15:58:36.658Z',
          url: 'https://www.themoviedb.org/review/5e8e7ca8d35dea0013723049',
        },
      ],
      total_pages: 1,
      total_results: 1,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/tTyodXuRkgOTGgye7H3p0dG231d.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 35, name: 'Phim Hài' },
      { id: 27, name: 'Phim Kinh Dị' },
    ],
    homepage: 'https://kendy.men',
    id: 485314,
    imdb_id: 'tt5926858',
    original_language: 'vi',
    original_title: 'Bệnh Viện Ma',
    overview:
      'Phim xoay quanh câu chuyện của chàng sinh viên y khoa vừa tốt nghiệp tên Thành (Trấn Thành đóng) đến làm việc tại bệnh viện An Tâm – nơi có những lời đồn ma ám. Liên tiếp chứng kiến những sự kiện ly kỳ, Thành quyết định truy tìm sự thật đang ẩn giấu với sự giúp đỡ nhiệt tình của y tá Hằng (Hari Won)…',
    popularity: 0.84,
    poster_path:
      'https://image.tmdb.org/t/p/w342/dNgUuSrFYNFjP4tMKrCEBvzSBrt.jpg',
    production_companies: [],
    production_countries: [{ iso_3166_1: 'VN', name: 'Vietnam' }],
    release_date: '2016-03-04',
    revenue: 0,
    runtime: 90,
    spoken_languages: [
      { english_name: 'Vietnamese', iso_639_1: 'vi', name: 'Tiếng Việt' },
    ],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Bệnh Viện Ma',
    video: false,
    vote_average: 9.3,
    vote_count: 1,
    videos: { results: [] },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 1594385,
          known_for_department: 'Diễn viên',
          name: 'Trấn Thành',
          original_name: 'Trấn Thành',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/okO8FXm2IeydZnEHjffS34XrRus.jpg',
          cast_id: 0,
          character: 'Thành',
          credit_id: '59ff2a2892514146e803c738',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 1594388,
          known_for_department: 'Diễn viên',
          name: 'Hari Won',
          original_name: 'Hari Won',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/A17FhdIjdqYdL9weo97w5D04wDK.jpg',
          cast_id: 1,
          character: 'Hằng',
          credit_id: '59ff2a46c3a368687e038647',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 1917977,
          known_for_department: 'Diễn viên',
          name: 'Tiến Luật',
          original_name: 'Tiến Luật',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oF3y6nJ4R9EmzHfynPcQ58BN6Gr.jpg',
          cast_id: 2,
          character: 'Lễ Tân',
          credit_id: '59ff2a70c3a36868a7038835',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 1841829,
          known_for_department: 'Diễn viên',
          name: 'Thu Trang',
          original_name: 'Thu Trang',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oSpHBUKu9vNcmQTJD9w936jJD7R.jpg',
          cast_id: 3,
          character: 'Y Tá',
          credit_id: '59ff2a80c3a3686893042d3b',
          order: 4,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 0,
          id: 1918038,
          known_for_department: 'Directing',
          name: 'Võ Thanh Hòa',
          original_name: 'Võ Thanh Hòa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '59ff2aab92514146d4040ee1',
          department: 'Directing',
          job: 'Director',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/s7gVnkGiczRRJxwmzXR6OfDCOua.jpg',
    belongs_to_collection: {
      id: 436982,
      name: '殺破狼（系列）',
      poster_path: '/8QdfsRWlYu9QipxMIseOS9YwXTG.jpg',
      backdrop_path: '/rrnYd9vVu5bbbCWSLXhMit2vF0B.jpg',
    },
    budget: 0,
    genres: [
      { id: 80, name: 'Phim Hình Sự' },
      { id: 28, name: 'Phim Hành Động' },
      { id: 18, name: 'Phim Chính Kịch' },
    ],
    homepage: '',
    id: 452558,
    imdb_id: 'tt7245176',
    original_language: 'cn',
    original_title: '殺破狼·貪狼',
    overview:
      'Phim Sát Phá Lang 3 có tên gọi Paradox (Tham lang) ra mắt tại Trung Quốc vào ngày 17/8 vừa qua. Nội dung phim xoay quanh câu chuyện truy tìm và trả thù kẻ bắt cóc con của Lee (Cổ Thiên Lạc). Trong quá trình sang Thái Lan tìm kiếm con gái mình, Lee còn phát hiện ra bí mật liên quan đến ứng cử viên thị trưởng của Bangkok.',
    popularity: 11.479,
    poster_path:
      'https://image.tmdb.org/t/p/w342/txSeSIjuV9rQWtqGUdGdjVa0F27.jpg',
    production_companies: [
      {
        id: 113740,
        logo_path: null,
        name: 'Aether Film Production',
        origin_country: '',
      },
      {
        id: 69484,
        logo_path: '/2xtmvbEse87LM7OJXVksv7DToZx.png',
        name: 'Alibaba Pictures Group',
        origin_country: 'CN',
      },
      {
        id: 30148,
        logo_path: '/zerhOenUD6CkH8SMgZUhrDkOs4w.png',
        name: 'Bona Film Group',
        origin_country: 'CN',
      },
      {
        id: 30238,
        logo_path: null,
        name: 'Bravos Pictures',
        origin_country: '',
      },
      {
        id: 107790,
        logo_path: null,
        name: 'Flagship Entertainment Group',
        origin_country: 'CN',
      },
      {
        id: 113741,
        logo_path: null,
        name: 'Huoerguosi Bona Culture and Media',
        origin_country: '',
      },
      {
        id: 113742,
        logo_path: null,
        name: 'Rock Partner Film',
        origin_country: '',
      },
      {
        id: 113743,
        logo_path: null,
        name: 'Shanghai PMF Media',
        origin_country: '',
      },
      {
        id: 5686,
        logo_path: null,
        name: 'Sil-Metropole Organisation',
        origin_country: '',
      },
      {
        id: 113744,
        logo_path: null,
        name: 'Sun Entertainment Film Group',
        origin_country: 'HK',
      },
      { id: 113745, logo_path: null, name: 'Wish Films', origin_country: '' },
      {
        id: 113746,
        logo_path: '/eiq9XYn7yL5x5hXe4bGQmlFBMRr.png',
        name: 'YL Entertainment & Sport',
        origin_country: 'CN',
      },
    ],
    production_countries: [{ iso_3166_1: 'HK', name: 'Hồng Kông' }],
    release_date: '2017-08-25',
    revenue: 0,
    runtime: 101,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
      { english_name: 'Cantonese', iso_639_1: 'cn', name: '广州话 / 廣州話' },
      { english_name: 'Thai', iso_639_1: 'th', name: 'ภาษาไทย' },
    ],
    status: 'Đã phát hành',
    tagline: 'SPL III: Paradox',
    title: 'Sát Phá Lang 3: Tham Lang',
    video: false,
    vote_average: 6.5,
    vote_count: 114,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'PARADOX (2018) Official Trailer | Tony Jaa Martial Arts',
          key: 'raF9-6wFXIg',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2018-04-10T13:40:05.000Z',
          id: '5e22136ea24c500013d12f17',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 78875,
          known_for_department: 'Diễn viên',
          name: 'Louis Koo',
          original_name: 'Louis Koo',
          popularity: 5.462,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yQuDBTzm7xWlJICNvl20OmcJP80.jpg',
          cast_id: 0,
          character: 'Lee Chung-Chi',
          credit_id: '58f48ee19251413d6e0224fb',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 1800792,
          known_for_department: 'Diễn viên',
          name: 'Wu Yue',
          original_name: 'Wu Yue',
          popularity: 3.454,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hRePA3mh9mfAqX7SJ4rGxrNrxT7.jpg',
          cast_id: 3,
          character: 'Chui Kit',
          credit_id: '58fa33eac3a3687c8600bea3',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 83820,
          known_for_department: 'Diễn viên',
          name: 'Gordon Lam',
          original_name: 'Gordon Lam',
          popularity: 3.173,
          profile_path:
            'https://image.tmdb.org/t/p/w185/61gQoVwgpd4qzovOaZjzJpdm47K.jpg',
          cast_id: 7,
          character: 'Cheng Hon-Sau',
          credit_id: '59a6e26092514158080001aa',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 1957064,
          known_for_department: 'Diễn viên',
          name: 'Chris Collins',
          original_name: 'Chris Collins',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/joxLBbrhQDmF63G2icEQef1g3pd.jpg',
          cast_id: 14,
          character: 'Sacha',
          credit_id: '5a557444c3a3685ee60190cd',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 57207,
          known_for_department: 'Diễn viên',
          name: 'Tony Jaa',
          original_name: 'Tony Jaa',
          popularity: 6.182,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cs5NAQxyfAkUpWBZaLCbqE5LsMj.jpg',
          cast_id: 15,
          character: 'Tak',
          credit_id: '5a5574500e0a2607ce01b24d',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 1450374,
          known_for_department: 'Diễn viên',
          name: 'Jacky Cai',
          original_name: 'Jacky Cai',
          popularity: 6.39,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bMl4iCaaoFDVb7JVPWjTVWKqGev.jpg',
          cast_id: 16,
          character: 'Sui Man',
          credit_id: '5a557460c3a3685ecd01b086',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 70690,
          known_for_department: 'Diễn viên',
          name: 'Ken Lo',
          original_name: 'Ken Lo',
          popularity: 1.688,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aecWmrSbnZTTnBJ8vgyNAaphOLp.jpg',
          cast_id: 17,
          character: 'Ban',
          credit_id: '5a557493c3a3685ec7019a87',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 1879409,
          known_for_department: 'Diễn viên',
          name: 'Hanna Chan',
          original_name: 'Hanna Chan',
          popularity: 1.646,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2YnnhzrciSjNSjPXf2KbKv3fPyu.jpg',
          cast_id: 19,
          character: 'Lee Wing-Chi',
          credit_id: '5a5574ab9251417a9a01996c',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 1102621,
          known_for_department: 'Diễn viên',
          name: 'Vithaya Pansringarm',
          original_name: 'Vithaya Pansringarm',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/d27LoRSKh6WBYSQo6MNPNFfB0BQ.jpg',
          cast_id: 20,
          character: 'Commissioner Chai',
          credit_id: '5a5574ba9251417a9a019974',
          order: 8,
        },
        {
          adult: false,
          gender: 0,
          id: 566091,
          known_for_department: 'Diễn viên',
          name: 'Sompob Benjathikul',
          original_name: 'Sompob Benjathikul',
          popularity: 1.094,
          profile_path: null,
          cast_id: 21,
          character: 'Mayor Azis',
          credit_id: '5a5574c60e0a2607d701b5c6',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 96012,
          known_for_department: 'Diễn viên',
          name: 'Siraphan Wattanajinda',
          original_name: 'Siraphan Wattanajinda',
          popularity: 1.614,
          profile_path:
            'https://image.tmdb.org/t/p/w185/TZEeuVDazyqNBQMncS8VZ02RqB.jpg',
          cast_id: 22,
          character: 'Soei',
          credit_id: '5a5574d20e0a2607d101b6f9',
          order: 10,
        },
        {
          adult: false,
          gender: 1,
          id: 1957065,
          known_for_department: 'Diễn viên',
          name: 'Iris Lam',
          original_name: 'Iris Lam',
          popularity: 0.6,
          profile_path: null,
          cast_id: 23,
          character: 'Jenny',
          credit_id: '5a5574dfc3a3685ebf019c43',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 1178885,
          known_for_department: 'Diễn viên',
          name: 'Michelle Saram',
          original_name: 'Michelle Saram',
          popularity: 0.6,
          profile_path: null,
          cast_id: 24,
          character: "Lee Chung-Chi's wife",
          credit_id: '5ac30579925141271202c9cf',
          order: 12,
        },
        {
          adult: false,
          gender: 0,
          id: 1191262,
          known_for_department: 'Diễn viên',
          name: 'Puchong Sartnok',
          original_name: 'Puchong Sartnok',
          popularity: 0.6,
          profile_path: null,
          cast_id: 66,
          character: '',
          credit_id: '5f45ff6f2da8460033398651',
          order: 13,
        },
        {
          adult: false,
          gender: 0,
          id: 1673825,
          known_for_department: 'Diễn viên',
          name: 'Maethi Thapthimthong',
          original_name: 'Maethi Thapthimthong',
          popularity: 0.6,
          profile_path: null,
          cast_id: 67,
          character: '',
          credit_id: '5f45ff7afdc4fa0036bc2ed7',
          order: 14,
        },
        {
          adult: false,
          gender: 0,
          id: 1660591,
          known_for_department: 'Diễn viên',
          name: 'Jirapat Phanngoen',
          original_name: 'Jirapat Phanngoen',
          popularity: 0.6,
          profile_path: null,
          cast_id: 68,
          character: '',
          credit_id: '5f45ff866743fa0034ed7421',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 1163445,
          known_for_department: 'Diễn viên',
          name: 'Charlie Ruedpokanon',
          original_name: 'Charlie Ruedpokanon',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rzZ5WGsuXmnb1tIoPTPQvOJuArn.jpg',
          cast_id: 69,
          character: '',
          credit_id: '5f45ffb441429100365b46b1',
          order: 16,
        },
        {
          adult: false,
          gender: 0,
          id: 1673828,
          known_for_department: 'Diễn viên',
          name: 'Yothin Udomsanti',
          original_name: 'Yothin Udomsanti',
          popularity: 0.6,
          profile_path: null,
          cast_id: 70,
          character: '',
          credit_id: '5f45ffc199d5c30034be032a',
          order: 17,
        },
        {
          adult: false,
          gender: 0,
          id: 1622009,
          known_for_department: 'Diễn viên',
          name: 'Zhang Gui-Bo',
          original_name: 'Zhang Gui-Bo',
          popularity: 0.828,
          profile_path: null,
          cast_id: 71,
          character: '',
          credit_id: '5f45ffe1fdc4fa0037b64ce2',
          order: 18,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 21903,
          known_for_department: 'Sound',
          name: 'Kwong Wing Chan',
          original_name: 'Kwong Wing Chan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f4602e50d11f20033b77f97',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 62410,
          known_for_department: 'Diễn viên',
          name: 'Sammo Hung',
          original_name: 'Sammo Hung',
          popularity: 4.128,
          profile_path:
            'https://image.tmdb.org/t/p/w185/AsB9uRDQWdIbFGnkICEl8I2gDWn.jpg',
          credit_id: '5d00c89bc3a368445b237a1b',
          department: 'Directing',
          job: 'Action Director',
        },
        {
          adult: false,
          gender: 2,
          id: 63571,
          known_for_department: 'Directing',
          name: 'Wilson Yip',
          original_name: 'Wilson Yip',
          popularity: 1.43,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tDAr3QsLT4vTqHotRM0kChtVKDk.jpg',
          credit_id: '58f492b89251413d6e02288b',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 67260,
          known_for_department: 'Sound',
          name: 'Ken Chan',
          original_name: 'Ken Chan',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5f4601dcfdc4fa0036bc3388',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 93991,
          known_for_department: 'Directing',
          name: 'Soi Cheang',
          original_name: 'Soi Cheang',
          popularity: 0.972,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5PKTT0o0Sbkuo2m2I9iooOALYug.jpg',
          credit_id: '5c45e6e1c3a3684e9682c346',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 140488,
          known_for_department: 'Camera',
          name: 'Kenny Tse',
          original_name: 'Kenny Tse',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45e7940e0a26494dc74e1f',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 237191,
          known_for_department: 'Biên kịch',
          name: 'Lai-yin Leung',
          original_name: 'Lai-yin Leung',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5f4600d04142910037562ee4',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 1024029,
          known_for_department: 'Production',
          name: 'Paco Wong Pak-Go',
          original_name: 'Paco Wong Pak-Go',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45e728c3a3684777835d91',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1456025,
          known_for_department: 'Editing',
          name: 'Wong Hoi',
          original_name: 'Wong Hoi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45e7b8c3a36847828370f5',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1879401,
          known_for_department: 'Biên kịch',
          name: 'Nick Cheuk',
          original_name: 'Nick Cheuk',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f46011871f0950035840de5',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 0,
          id: 2223114,
          known_for_department: 'Art',
          name: 'Kwok-Keung Mak',
          original_name: 'Kwok-Keung Mak',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45e7d20e0a26495ac7611f',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 0,
          id: 2223117,
          known_for_department: 'Art',
          name: 'Sai Hung Chow',
          original_name: 'Sai Hung Chow',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45e7f09251410e0a4e968a',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 2223120,
          known_for_department: 'Costume & Make-Up',
          name: 'Kar Yan Yip',
          original_name: 'Kar Yan Yip',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45e8530e0a264962c76fe1',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 0,
          id: 2223123,
          known_for_department: 'Directing',
          name: 'Tai Lau',
          original_name: 'Tai Lau',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45e93e0e0a264965c77310',
          department: 'Directing',
          job: 'Continuity',
        },
        {
          adult: false,
          gender: 0,
          id: 2223125,
          known_for_department: 'Crew',
          name: 'Andrii Palekha',
          original_name: 'Andrii Palekha',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45ea660e0a263ccdc6dd76',
          department: 'Crew',
          job: 'Pilot',
        },
        {
          adult: false,
          gender: 0,
          id: 2223127,
          known_for_department: 'Camera',
          name: 'Yau Hong Chan',
          original_name: 'Yau Hong Chan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45eabdc3a368478283778e',
          department: 'Camera',
          job: 'Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2223128,
          known_for_department: 'Camera',
          name: 'Chun Wa Cheuk',
          original_name: 'Chun Wa Cheuk',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45ead50e0a264965c777a2',
          department: 'Camera',
          job: 'Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2223129,
          known_for_department: 'Camera',
          name: 'Chiu Lap Poon',
          original_name: 'Chiu Lap Poon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45eae9c3a3684e9682cb9d',
          department: 'Camera',
          job: 'Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2223130,
          known_for_department: 'Camera',
          name: 'Wai Yin Tse',
          original_name: 'Wai Yin Tse',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45eafb0e0a26495dc772e8',
          department: 'Camera',
          job: 'Assistant Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2223131,
          known_for_department: 'Camera',
          name: 'Thitinun Lerdkijsakul',
          original_name: 'Thitinun Lerdkijsakul',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45eb0f0e0a26495dc77316',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 2223132,
          known_for_department: 'Camera',
          name: 'Hei Kwan Chan',
          original_name: 'Hei Kwan Chan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45eb260e0a26496bc7740e',
          department: 'Camera',
          job: 'Dolly Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2223134,
          known_for_department: 'Camera',
          name: 'Shing Chung Wong',
          original_name: 'Shing Chung Wong',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45eb3c0e0a264962c77549',
          department: 'Camera',
          job: 'Focus Puller',
        },
        {
          adult: false,
          gender: 0,
          id: 2223137,
          known_for_department: 'Camera',
          name: 'Kei Lick Kwok',
          original_name: 'Kei Lick Kwok',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45eb4e0e0a26494dc75971',
          department: 'Camera',
          job: 'Focus Puller',
        },
        {
          adult: false,
          gender: 0,
          id: 2223138,
          known_for_department: 'Lighting',
          name: 'Hoi Yan Chan',
          original_name: 'Hoi Yan Chan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45eb6f9251410e0a4e9cf6',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 2223139,
          known_for_department: 'Camera',
          name: 'Samuel Fu',
          original_name: 'Samuel Fu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45eb889251410e0a4e9d26',
          department: 'Camera',
          job: 'Second Unit Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 2223142,
          known_for_department: 'Camera',
          name: 'Ka-Fung Lai',
          original_name: 'Ka-Fung Lai',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45eb99c3a368477a838516',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 0,
          id: 2223154,
          known_for_department: 'Art',
          name: 'Gloria Hoi-Ki Cheung',
          original_name: 'Gloria Hoi-Ki Cheung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45ec2fc3a368478c8369c7',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2223155,
          known_for_department: 'Art',
          name: 'Pui-Sze Fok',
          original_name: 'Pui-Sze Fok',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45ec42c3a3684777836d52',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2223157,
          known_for_department: 'Art',
          name: 'Tim-Yi Yuen',
          original_name: 'Tim-Yi Yuen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45ec530e0a26496bc776a6',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2223159,
          known_for_department: 'Art',
          name: 'Nattavut Buranakij',
          original_name: 'Nattavut Buranakij',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45ec6d9251415e344e0fd1',
          department: 'Art',
          job: 'Assistant Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 2223161,
          known_for_department: 'Art',
          name: 'Chi-Sang Lam',
          original_name: 'Chi-Sang Lam',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45ec83c3a3684793835728',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 2223167,
          known_for_department: 'Costume & Make-Up',
          name: 'Shuen Cheung',
          original_name: 'Shuen Cheung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45ed599251410e244ecca2',
          department: 'Costume & Make-Up',
          job: 'Assistant Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 2223168,
          known_for_department: 'Costume & Make-Up',
          name: 'Ziwei Hu',
          original_name: 'Ziwei Hu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45ed71c3a368478c836e20',
          department: 'Costume & Make-Up',
          job: 'Assistant Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 2223169,
          known_for_department: 'Costume & Make-Up',
          name: 'Jiahe Zheng',
          original_name: 'Jiahe Zheng',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45eda0c3a368478c836eb2',
          department: 'Costume & Make-Up',
          job: 'Assistant Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2223170,
          known_for_department: 'Costume & Make-Up',
          name: 'Xin Zhou',
          original_name: 'Xin Zhou',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45edb80e0a263ccdc6e848',
          department: 'Costume & Make-Up',
          job: 'Assistant Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2223171,
          known_for_department: 'Costume & Make-Up',
          name: 'Ka-Keung Tam',
          original_name: 'Ka-Keung Tam',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45edca9251410e0a4ea470',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 2223172,
          known_for_department: 'Costume & Make-Up',
          name: 'Sui Keung Tse',
          original_name: 'Sui Keung Tse',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45eddb0e0a26494dc75ef7',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 2223173,
          known_for_department: 'Costume & Make-Up',
          name: 'Lai-Yee Man',
          original_name: 'Lai-Yee Man',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45ee250e0a263ccdc6e973',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2223174,
          known_for_department: 'Costume & Make-Up',
          name: 'Sau-Hon Chan',
          original_name: 'Sau-Hon Chan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45ee37c3a3684782838226',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2223175,
          known_for_department: 'Costume & Make-Up',
          name: 'Ching Man Chan',
          original_name: 'Ching Man Chan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45ee91c3a3684777837391',
          department: 'Costume & Make-Up',
          job: 'Assistant Costume Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2223176,
          known_for_department: 'Costume & Make-Up',
          name: 'Sin Sze Tsang',
          original_name: 'Sin Sze Tsang',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45eeae0e0a26496bc77e10',
          department: 'Costume & Make-Up',
          job: 'Assistant Costume Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2223177,
          known_for_department: 'Costume & Make-Up',
          name: 'Audrey Yeung',
          original_name: 'Audrey Yeung',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45eec6c3a368478c8370cb',
          department: 'Costume & Make-Up',
          job: 'Assistant Costume Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2223178,
          known_for_department: 'Costume & Make-Up',
          name: 'Kit Ling Chan',
          original_name: 'Kit Ling Chan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c45eee19251410e144ea6e8',
          department: 'Costume & Make-Up',
          job: 'Wardrobe Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2544786,
          known_for_department: 'Production',
          name: 'Eddie Wong',
          original_name: 'Eddie Wong',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e4ea00e9b861600166a4a92',
          department: 'Production',
          job: 'Production Manager',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/cDFtxTxEtE3ljadfQ5SwtRTi8Iw.jpg',
    belongs_to_collection: null,
    budget: 90000000,
    genres: [
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 53, name: 'Phim Gây Cấn' },
      { id: 80, name: 'Phim Hình Sự' },
    ],
    homepage: 'http://thedeparted.com',
    id: 1422,
    imdb_id: 'tt0407887',
    original_language: 'en',
    original_title: 'The Departed',
    overview:
      'The Departed (Điệp Vụ Boston) là bộ phim được dựng lại từ siêu phẩm Vô Gian Đạo (Infernal Affairs) của Hồng Kông. Nội dung phim xoay quanh hai con người có hai lai lịch hoàn toàn khác nhau nhưng lại đi chung một con đường: làm nội gián. Billy Costigan (Leonardo DiCaprio), một cảnh sát chìm được cài vào băng nhóm tội phạm do Frank Costello (Jack Nicholson) cầm đầu. Cùng lúc này, nhân viên cảnh sát Colin Sullivan (Matt Damon) lại là một tay tội phạm được đưa vào nội bộ cảnh sát nhằm cung cấp tin tức cho Frank. Cả hai bước vào cuộc rượt đuổi với nhiệm vụ khai thác thông tin mật của mỗi bên, đồng thời phải che giấu thân phận thật sự của mình...',
    popularity: 28.536,
    poster_path:
      'https://image.tmdb.org/t/p/w342/kWWAt2FMRbqLFFy8o5R4Zr8cMAb.jpg',
    production_companies: [
      {
        id: 829,
        logo_path: '/mzpAmEQ5P1gFvdRoNyCk9q8ngiv.png',
        name: 'Vertigo Entertainment',
        origin_country: 'US',
      },
      {
        id: 5552,
        logo_path: '/wdtjT9x5OG7nLusPctACI3i7Im2.png',
        name: 'Media Asia Films',
        origin_country: 'HK',
      },
      {
        id: 7380,
        logo_path: null,
        name: 'Initial Entertainment Group (IEG)',
        origin_country: '',
      },
      {
        id: 174,
        logo_path: '/IuAlhI9eVC9Z8UQWOIDdWRKSEJ.png',
        name: 'Warner Bros. Pictures',
        origin_country: 'US',
      },
      {
        id: 81,
        logo_path: '/8wOfUhA7vwU2gbPjQy7Vv3EiF0o.png',
        name: 'Plan B Entertainment',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2006-10-05',
    revenue: 291465000,
    runtime: 151,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
      { english_name: 'Cantonese', iso_639_1: 'cn', name: '广州话 / 廣州話' },
    ],
    status: 'Đã phát hành',
    tagline: 'The Departed',
    title: 'Điệp Vụ Boston',
    video: false,
    vote_average: 8.2,
    vote_count: 11877,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Departed (2005) Official Trailer - Matt Damon, Jack Nicholson Movie HD',
          key: 'iojhqm0JTW4',
          published_at: '2014-05-16T06:54:53.000Z',
          site: 'YouTube',
          size: 720,
          type: 'Trailer',
          official: false,
          id: '5ad45915925141296c010b5c',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 514,
          known_for_department: 'Diễn viên',
          name: 'Jack Nicholson',
          original_name: 'Jack Nicholson',
          popularity: 9.802,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6h12pZsgj3WWjMtykUgfLkLEBWz.jpg',
          cast_id: 6,
          character: "Francis 'Frank' Costello",
          credit_id: '52fe42f5c3a36847f802fed9',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 6193,
          known_for_department: 'Diễn viên',
          name: 'Leonardo DiCaprio',
          original_name: 'Leonardo DiCaprio',
          popularity: 27.887,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wo2hJpn04vbtmh0B9utCFdsQhxM.jpg',
          cast_id: 2,
          character: 'William "Billy" Costigan, Jr.',
          credit_id: '52fe42f5c3a36847f802fecf',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 1892,
          known_for_department: 'Diễn viên',
          name: 'Matt Damon',
          original_name: 'Matt Damon',
          popularity: 17.383,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lL1bN9lszEqcUDD73560cc64wO2.jpg',
          cast_id: 25,
          character: 'Staff Sgt. Colin Sullivan',
          credit_id: '52fe42f5c3a36847f802ff1f',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 13240,
          known_for_department: 'Diễn viên',
          name: 'Mark Wahlberg',
          original_name: 'Mark Wahlberg',
          popularity: 19.719,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bTEFpaWd7A6AZVWOqKKBWzKEUe8.jpg',
          cast_id: 7,
          character: 'Staff Sgt. Sean Dignam',
          credit_id: '52fe42f5c3a36847f802fedd',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 21657,
          known_for_department: 'Diễn viên',
          name: 'Vera Farmiga',
          original_name: 'Vera Farmiga',
          popularity: 13.837,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5Vs7huBmTKftwlsc2BPAntyaQYj.jpg',
          cast_id: 23,
          character: 'Dr. Madolyn Madden',
          credit_id: '52fe42f5c3a36847f802ff17',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 8349,
          known_for_department: 'Diễn viên',
          name: 'Martin Sheen',
          original_name: 'Martin Sheen',
          popularity: 5.82,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eANpr603scA1jfR6aOh42YqSke7.jpg',
          cast_id: 26,
          character: 'Capt. Oliver Charles Queenan',
          credit_id: '52fe42f5c3a36847f802ff23',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 5538,
          known_for_department: 'Diễn viên',
          name: 'Ray Winstone',
          original_name: 'Ray Winstone',
          popularity: 3.568,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eSRgAC98u5hQroeZzDeRf60XE21.jpg',
          cast_id: 10,
          character: 'Arnold "Frenchy" French',
          credit_id: '52fe42f5c3a36847f802fee7',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 18471,
          known_for_department: 'Diễn viên',
          name: 'Anthony Anderson',
          original_name: 'Anthony Anderson',
          popularity: 3.102,
          profile_path:
            'https://image.tmdb.org/t/p/w185/reO1OjwFdtXmiO4LMDaBj6eatzK.jpg',
          cast_id: 11,
          character: 'Trooper Brown',
          credit_id: '52fe42f5c3a36847f802feeb',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 7447,
          known_for_department: 'Diễn viên',
          name: 'Alec Baldwin',
          original_name: 'Alec Baldwin',
          popularity: 11.078,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hzKy7x574eeUS3wt1R3yvWBRpeR.jpg',
          cast_id: 12,
          character: 'Capt. George Ellerby',
          credit_id: '52fe42f5c3a36847f802feef',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 18472,
          known_for_department: 'Diễn viên',
          name: 'Kevin Corrigan',
          original_name: 'Kevin Corrigan',
          popularity: 2.926,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qu2P3gjPneAOTZpSjH6m6hSOxrD.jpg',
          cast_id: 13,
          character: 'Cousin Sean',
          credit_id: '52fe42f5c3a36847f802fef3',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 18473,
          known_for_department: 'Diễn viên',
          name: 'James Badge Dale',
          original_name: 'James Badge Dale',
          popularity: 5.833,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xODHrgxKPNWYATKgZWQJLNhImlZ.jpg',
          cast_id: 14,
          character: 'Barrigan',
          credit_id: '52fe42f5c3a36847f802fef7',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 2482,
          known_for_department: 'Diễn viên',
          name: "David O'Hara",
          original_name: "David O'Hara",
          popularity: 7.671,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iWL0enoe5Ehyj8JvmJFCtbjXuRN.jpg',
          cast_id: 24,
          character: 'Fitzy',
          credit_id: '52fe42f5c3a36847f802ff1b',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 4733,
          known_for_department: 'Diễn viên',
          name: 'Robert Wahlberg',
          original_name: 'Robert Wahlberg',
          popularity: 4.404,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yi8JZEy30rkBFJwd5WYfDj0QHpx.jpg',
          cast_id: 16,
          character: 'Lazio',
          credit_id: '52fe42f5c3a36847f802fefb',
          order: 12,
        },
        {
          adult: false,
          gender: 1,
          id: 18475,
          known_for_department: 'Diễn viên',
          name: 'Kristen Dalton',
          original_name: 'Kristen Dalton',
          popularity: 1.06,
          profile_path:
            'https://image.tmdb.org/t/p/w185/b6j5SfCHCvLULJeLJVTK4aleUBX.jpg',
          cast_id: 17,
          character: 'Gwen',
          credit_id: '52fe42f5c3a36847f802feff',
          order: 13,
        },
        {
          adult: false,
          gender: 0,
          id: 18476,
          known_for_department: 'Diễn viên',
          name: 'Thomas B. Duffy',
          original_name: 'Thomas B. Duffy',
          popularity: 0.6,
          profile_path: null,
          cast_id: 18,
          character: 'Govenor',
          credit_id: '52fe42f5c3a36847f802ff03',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 18477,
          known_for_department: 'Diễn viên',
          name: 'Richard Hughes',
          original_name: 'Richard Hughes',
          popularity: 0.6,
          profile_path: null,
          cast_id: 19,
          character: 'Uncle Edward',
          credit_id: '52fe42f5c3a36847f802ff07',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 17194,
          known_for_department: 'Diễn viên',
          name: 'Chance Kelly',
          original_name: 'Chance Kelly',
          popularity: 3.396,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hRfBFx2E8pEGNx6GEHTBHSy3dJv.jpg',
          cast_id: 34,
          character: 'Exam Instructor',
          credit_id: '52fe42f5c3a36847f802ff51',
          order: 16,
        },
        {
          adult: false,
          gender: 2,
          id: 1182724,
          known_for_department: 'Diễn viên',
          name: 'Larry Mitchell',
          original_name: 'Larry Mitchell',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9jP4wAs0Pgzj51R3JCcItnX1QVO.jpg',
          cast_id: 81,
          character: 'Younger Priest',
          credit_id: '55055f01c3a3680581000f2c',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 6576,
          known_for_department: 'Diễn viên',
          name: 'Mark Rolston',
          original_name: 'Mark Rolston',
          popularity: 4.906,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hcrNRIptYMRXgkJ9k76BlQu6DQp.jpg',
          cast_id: 82,
          character: 'Delahunt',
          credit_id: '55e783bac3a3682c5f00021d',
          order: 18,
        },
        {
          adult: false,
          gender: 2,
          id: 63296,
          known_for_department: 'Diễn viên',
          name: 'J. C. MacKenzie',
          original_name: 'J. C. MacKenzie',
          popularity: 2.248,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aAy2hzMku50aM2lUYg7yNQYdpMW.jpg',
          cast_id: 83,
          character: 'Realtor',
          credit_id: '55e783eec3a3682c6200022c',
          order: 19,
        },
        {
          adult: false,
          gender: 0,
          id: 951993,
          known_for_department: 'Diễn viên',
          name: 'Mary Klug',
          original_name: 'Mary Klug',
          popularity: 0.6,
          profile_path: null,
          cast_id: 84,
          character: "Billy's Aunt",
          credit_id: '55e7841d9251413e320001d7',
          order: 20,
        },
        {
          adult: false,
          gender: 2,
          id: 1203261,
          known_for_department: 'Diễn viên',
          name: "Robert 'Toshi' Kar Yuen Chan",
          original_name: "Robert 'Toshi' Kar Yuen Chan",
          popularity: 0.6,
          profile_path: null,
          cast_id: 85,
          character: 'Triad Boss',
          credit_id: '55e78451c3a3682c5f000228',
          order: 21,
        },
        {
          adult: false,
          gender: 1,
          id: 2191244,
          known_for_department: 'Diễn viên',
          name: 'Peg Holzemer',
          original_name: 'Peg Holzemer',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9g7PtEDqkPSu9K9VC8pEaf73EZQ.jpg',
          cast_id: 153,
          character: 'Mrs. Kennefick',
          credit_id: '5c0c1b1b92514147aa07a82f',
          order: 22,
        },
        {
          adult: false,
          gender: 0,
          id: 185705,
          known_for_department: 'Diễn viên',
          name: 'Gurdeep Singh',
          original_name: 'Gurdeep Singh',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9Qq7d88WPyab4zXG9qwlpy9L9iH.jpg',
          cast_id: 86,
          character: 'Pakistani Proprietor',
          credit_id: '55e7847c9251413e3e00021d',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 1184209,
          known_for_department: 'Diễn viên',
          name: 'Armen Garo',
          original_name: 'Armen Garo',
          popularity: 3.177,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yRtRh0SwHxy7LtU82l1oqctiOAl.jpg',
          cast_id: 87,
          character: 'Providence Gangster #1',
          credit_id: '55e784b69251413e3a000208',
          order: 24,
        },
        {
          adult: false,
          gender: 2,
          id: 206398,
          known_for_department: 'Crew',
          name: 'John Cenatiempo',
          original_name: 'John Cenatiempo',
          popularity: 2.276,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6cEyUFyS5Tw2LGY0HkjpMjMZDmG.jpg',
          cast_id: 88,
          character: 'Providence Gangster #2',
          credit_id: '55e784cbc3a3682c640001f4',
          order: 25,
        },
        {
          adult: false,
          gender: 2,
          id: 1434599,
          known_for_department: 'Crew',
          name: 'Brian Smyj',
          original_name: 'Brian Smyj',
          popularity: 1.176,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zpVyJRhBQQZ3bc2COTOtv5iUmv6.jpg',
          cast_id: 90,
          character: 'Man Glassed in Bar',
          credit_id: '55e785749251413e2f000236',
          order: 26,
        },
        {
          adult: false,
          gender: 0,
          id: 77025,
          known_for_department: 'Diễn viên',
          name: 'William Severs',
          original_name: 'William Severs',
          popularity: 0.6,
          profile_path: null,
          cast_id: 91,
          character: 'Older Priest',
          credit_id: '55e785a4c3a3682c6b000233',
          order: 27,
        },
        {
          adult: false,
          gender: 2,
          id: 155535,
          known_for_department: 'Crew',
          name: 'Douglas Crosby',
          original_name: 'Douglas Crosby',
          popularity: 0.6,
          profile_path: null,
          cast_id: 92,
          character: 'Man Killed by French',
          credit_id: '55e785fcc3a3682c64000218',
          order: 28,
        },
        {
          adult: false,
          gender: 1,
          id: 19488,
          known_for_department: 'Diễn viên',
          name: 'Dorothy Lyman',
          original_name: 'Dorothy Lyman',
          popularity: 2.708,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fXBwBgxKyOIwha47Csx5AEAVSEe.jpg',
          cast_id: 93,
          character: 'Woman at Bar #1',
          credit_id: '55e786109251413e3e00023d',
          order: 29,
        },
        {
          adult: false,
          gender: 1,
          id: 77100,
          known_for_department: 'Diễn viên',
          name: 'Audrie Neenan',
          original_name: 'Audrie Neenan',
          popularity: 0.888,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xteimBrBfdXPjcLNiAmehwuOou6.jpg',
          cast_id: 94,
          character: 'Woman at Bar #2',
          credit_id: '55e786269251413e32000203',
          order: 30,
        },
        {
          adult: false,
          gender: 2,
          id: 82754,
          known_for_department: 'Diễn viên',
          name: 'Conor Donovan',
          original_name: 'Conor Donovan',
          popularity: 1.094,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qvrPwtXBZnaqm5IokFQAtlEVgTv.jpg',
          cast_id: 95,
          character: 'Young Colin',
          credit_id: '55e786569251413e3a000236',
          order: 31,
        },
        {
          adult: false,
          gender: 0,
          id: 51666,
          known_for_department: 'Production',
          name: 'Patrick Coppola',
          original_name: 'Patrick Coppola',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5sqQGaWmUAXj1gQIS5a7lN3fj1n.jpg',
          cast_id: 96,
          character: 'Bookie Harassed by French',
          credit_id: '55e786adc3a3682c7000023c',
          order: 32,
        },
        {
          adult: false,
          gender: 2,
          id: 122260,
          known_for_department: 'Crew',
          name: "Mick O'Rourke",
          original_name: "Mick O'Rourke",
          popularity: 1.225,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ocIfNeYVLBZt10tc3OIpZEodvUH.jpg',
          cast_id: 97,
          character: 'Jimmy Bags',
          credit_id: '55e786c8c3a3682c70000244',
          order: 33,
        },
        {
          adult: false,
          gender: 1,
          id: 177898,
          known_for_department: 'Diễn viên',
          name: 'Nellie Sciutto',
          original_name: 'Nellie Sciutto',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ncYzjwMzadea4vOZ72MXJSk7Wcm.jpg',
          cast_id: 130,
          character: "Queenan's Secretary",
          credit_id: '56c6777c9251412451004744',
          order: 34,
        },
        {
          adult: false,
          gender: 2,
          id: 1428152,
          known_for_department: 'Diễn viên',
          name: 'Henry Yuk',
          original_name: 'Henry Yuk',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vqsJWpXDeHdhlAORYzLDUnnRc9B.jpg',
          cast_id: 99,
          character: 'Chinese Government Man',
          credit_id: '55e7873f9251413e38000247',
          order: 35,
        },
        {
          adult: false,
          gender: 2,
          id: 1000883,
          known_for_department: 'Diễn viên',
          name: 'John Rue',
          original_name: 'John Rue',
          popularity: 2.519,
          profile_path:
            'https://image.tmdb.org/t/p/w185/q3VG3GR4OFZjdj8Se7JUZ79pXEy.jpg',
          cast_id: 100,
          character: 'Luncheonette Proprietor',
          credit_id: '55e78796c3a3682c5f00027d',
          order: 36,
        },
        {
          adult: false,
          gender: 2,
          id: 7531,
          known_for_department: 'Production',
          name: 'Joseph P. Reidy',
          original_name: 'Joseph P. Reidy',
          popularity: 0.624,
          profile_path: null,
          cast_id: 101,
          character: 'Priest with Young Colin',
          credit_id: '55e787d29251413e38000251',
          order: 37,
        },
        {
          adult: false,
          gender: 2,
          id: 93752,
          known_for_department: 'Diễn viên',
          name: 'John Farrer',
          original_name: 'John Farrer',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aNSWpZyyyZNQCISCLKoHqtpNKyU.jpg',
          cast_id: 102,
          character: "Priest at Billy's Funeral",
          credit_id: '55e787ec9251413e2f000265',
          order: 38,
        },
        {
          adult: false,
          gender: 2,
          id: 1218180,
          known_for_department: 'Diễn viên',
          name: 'Billy Smith',
          original_name: 'Billy Smith',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uzFxV2l3ODxfknHhIAgvLf0ihH6.jpg',
          cast_id: 89,
          character: 'Detective #1 Tailing Queenan',
          credit_id: '55e78526c3a3682c5f000232',
          order: 39,
        },
        {
          adult: false,
          gender: 2,
          id: 10138,
          known_for_department: 'Diễn viên',
          name: 'Brian Haley',
          original_name: 'Brian Haley',
          popularity: 3.17,
          profile_path:
            'https://image.tmdb.org/t/p/w185/KoD3GS7jOHRpJjCVJt4XM9Dh30.jpg',
          cast_id: 103,
          character: 'Detective #2 Tailing Queenan',
          credit_id: '55e78831c3a3682c5d0002ec',
          order: 40,
        },
        {
          adult: false,
          gender: 2,
          id: 2257,
          known_for_department: 'Diễn viên',
          name: 'Terry Serpico',
          original_name: 'Terry Serpico',
          popularity: 4.169,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nxku2blYCPYtEmAkKlUFJ4YUWsa.jpg',
          cast_id: 104,
          character: 'Detective #3 Tailing Queenan',
          credit_id: '55e788529251413e41000268',
          order: 41,
        },
        {
          adult: false,
          gender: 2,
          id: 170240,
          known_for_department: 'Diễn viên',
          name: 'Jay Giannone',
          original_name: 'Jay Giannone',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fMRNeyjoHNtYwSBytga8m3ReMUs.jpg',
          cast_id: 105,
          character: 'Detective #4 Tailing Queenan',
          credit_id: '55e788679251413e4100026b',
          order: 42,
        },
        {
          adult: false,
          gender: 2,
          id: 187812,
          known_for_department: 'Diễn viên',
          name: 'David Conley',
          original_name: 'David Conley',
          popularity: 0.6,
          profile_path: null,
          cast_id: 106,
          character: 'Gang Member with Mr. French',
          credit_id: '55e789109251413e3500026c',
          order: 43,
        },
        {
          adult: false,
          gender: 1,
          id: 2191249,
          known_for_department: 'Diễn viên',
          name: 'Tracey Paleo',
          original_name: 'Tracey Paleo',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rrXfiYxrpWr8ayHM5VSsBptTXbh.jpg',
          cast_id: 157,
          character: 'Darlene the Secretary',
          credit_id: '5c0c1f09c3a368251c085524',
          order: 44,
        },
        {
          adult: false,
          gender: 1,
          id: 1455497,
          known_for_department: 'Crew',
          name: 'Jill Brown',
          original_name: 'Jill Brown',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/le9ZbpgwR5CiA1w2skyvP1701.jpg',
          cast_id: 107,
          character: 'Executed Woman',
          credit_id: '55e78945c3a3682c7000027a',
          order: 45,
        },
        {
          adult: false,
          gender: 2,
          id: 58333,
          known_for_department: 'Diễn viên',
          name: 'Tom Kemp',
          original_name: 'Tom Kemp',
          popularity: 2.995,
          profile_path:
            'https://image.tmdb.org/t/p/w185/naKmj05P3TM3GWNoS3DoYoD49XU.jpg',
          cast_id: 108,
          character: 'Billy Costigan, Sr. (credit only)',
          credit_id: '55e789779251413e41000285',
          order: 46,
        },
        {
          adult: false,
          gender: 2,
          id: 2191245,
          known_for_department: 'Diễn viên',
          name: 'Kevin P. McCarthy',
          original_name: 'Kevin P. McCarthy',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lA1BLiEhA3lbdxaVpa3GlgxuLNO.jpg',
          cast_id: 155,
          character: "Detective #1 - Colin's Unit",
          credit_id: '5c0c1d3e0e0a2638af08cd34',
          order: 47,
        },
        {
          adult: false,
          gender: 2,
          id: 1861185,
          known_for_department: 'Diễn viên',
          name: 'Chris Fischer',
          original_name: 'Chris Fischer',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5N4tzbuLPC8KsDmAjClSXnXsOlD.jpg',
          cast_id: 156,
          character: "Detective #2 - Colin's Unit",
          credit_id: '5c0c1d61c3a3682528087aad',
          order: 48,
        },
        {
          adult: false,
          gender: 2,
          id: 1939442,
          known_for_department: 'Diễn viên',
          name: 'Joseph Riccobene',
          original_name: 'Joseph Riccobene',
          popularity: 1.052,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fWKFMNkFXkuQSx7Z7y02EAPfPnN.jpg',
          cast_id: 150,
          character: 'Kneecapped Bankrobber',
          credit_id: '5a2f09ba925141032c16cfa5',
          order: 49,
        },
        {
          adult: false,
          gender: 2,
          id: 1083451,
          known_for_department: 'Diễn viên',
          name: 'Johnny Cicco',
          original_name: 'Johnny Cicco',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ooEiY9wZcT8tXKR1KmBtDnRqDwk.jpg',
          cast_id: 109,
          character: 'Crack Addict',
          credit_id: '55e789df9251413e3e0002ac',
          order: 50,
        },
        {
          adult: false,
          gender: 2,
          id: 1610941,
          known_for_department: 'Diễn viên',
          name: 'Lyman Chen',
          original_name: 'Lyman Chen',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3aDbxJeem9JHHoSPXHIHsg8kWKJ.jpg',
          cast_id: 154,
          character: 'Translator',
          credit_id: '5c0c1d050e0a2638af08cc44',
          order: 51,
        },
        {
          adult: false,
          gender: 2,
          id: 42290,
          known_for_department: 'Diễn viên',
          name: 'Shay Duffin',
          original_name: 'Shay Duffin',
          popularity: 0.996,
          profile_path:
            'https://image.tmdb.org/t/p/w185/A9oSkVp1v2MB2eR2ORziTi1m52b.jpg',
          cast_id: 110,
          character: 'Bartender at Brasserie',
          credit_id: '55e78a109251413e4100029c',
          order: 52,
        },
        {
          adult: false,
          gender: 2,
          id: 1711562,
          known_for_department: 'Diễn viên',
          name: 'David Fischer',
          original_name: 'David Fischer',
          popularity: 0.6,
          profile_path: null,
          cast_id: 149,
          character: 'Executed Man',
          credit_id: '5831d690c3a3685b9a028001',
          order: 53,
        },
        {
          adult: false,
          gender: 1,
          id: 45648,
          known_for_department: 'Production',
          name: 'Emma Tillinger Koskoff',
          original_name: 'Emma Tillinger Koskoff',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bsKUYo9DyNYj4xB10182k7CZOQD.jpg',
          cast_id: 112,
          character: 'Woman with Dog',
          credit_id: '55e78aaa9251413e3e0002bd',
          order: 54,
        },
        {
          adult: false,
          gender: 2,
          id: 1116907,
          known_for_department: 'Diễn viên',
          name: "Craig 'Radioman' Castaldo",
          original_name: "Craig 'Radioman' Castaldo",
          popularity: 0.6,
          profile_path: null,
          cast_id: 113,
          character: 'Crack House Denizen',
          credit_id: '55e78adac3a3682c64000292',
          order: 55,
        },
        {
          adult: false,
          gender: 1,
          id: 1674603,
          known_for_department: 'Diễn viên',
          name: 'Francesca Scorsese',
          original_name: 'Francesca Scorsese',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gldqz0GTn3dEmL8JJ9bQ09c6LfD.jpg',
          cast_id: 152,
          character: 'Little Girl at Airport',
          credit_id: '5c0c18140e0a2638d30896b4',
          order: 56,
        },
        {
          adult: false,
          gender: 0,
          id: 1616719,
          known_for_department: 'Diễn viên',
          name: 'Dennis Lynch',
          original_name: 'Dennis Lynch',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aK5ZDRQ9fZbeUORvAcCveW80S03.jpg',
          cast_id: 158,
          character: "Costello's Crew #1",
          credit_id: '5c0c212a925141479207ff2e',
          order: 57,
        },
        {
          adult: false,
          gender: 0,
          id: 1947524,
          known_for_department: 'Diễn viên',
          name: 'Michael Byron',
          original_name: 'Michael Byron',
          popularity: 0.639,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pYbzQ23TY3lLadXInOi7l790v2A.jpg',
          cast_id: 159,
          character: "Costello's Crew #2",
          credit_id: '5c0c213dc3a368252a089d55',
          order: 58,
        },
        {
          adult: false,
          gender: 2,
          id: 1011669,
          known_for_department: 'Diễn viên',
          name: 'Takumi Bando',
          original_name: 'Takumi Bando',
          popularity: 0.6,
          profile_path: null,
          cast_id: 115,
          character: 'Triad (uncredited)',
          credit_id: '55e78b349251413e350002a9',
          order: 59,
        },
        {
          adult: false,
          gender: 0,
          id: 1221663,
          known_for_department: 'Diễn viên',
          name: 'Eric Bruno Borgman',
          original_name: 'Eric Bruno Borgman',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sdtcwesWN1IF6KXgZyOUSuJ8NVM.jpg',
          cast_id: 116,
          character: 'Reporter (uncredited)',
          credit_id: '55e78b619251413e3a0002be',
          order: 60,
        },
        {
          adult: false,
          gender: 2,
          id: 1422337,
          known_for_department: 'Diễn viên',
          name: 'Brendan Burke',
          original_name: 'Brendan Burke',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/caUA0KNcjFVxq8DAfEiAWgybOF6.jpg',
          cast_id: 118,
          character: 'Irish Thug (uncredited)',
          credit_id: '55e78c0fc3a3682c6200030a',
          order: 62,
        },
        {
          adult: false,
          gender: 0,
          id: 204711,
          known_for_department: 'Diễn viên',
          name: 'Chris Chinn',
          original_name: 'Chris Chinn',
          popularity: 0.6,
          profile_path: null,
          cast_id: 119,
          character: 'Gang Member (uncredited)',
          credit_id: '55e78c3d9251413e3a0002d6',
          order: 63,
        },
        {
          adult: false,
          gender: 2,
          id: 1371552,
          known_for_department: 'Diễn viên',
          name: 'Jeffrey Corazzini',
          original_name: 'Jeffrey Corazzini',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vpFHpdt9YYoi9wVtV4kSzAUyF5g.jpg',
          cast_id: 120,
          character: 'Crime Scene Unit (uncredited)',
          credit_id: '55e78c969251413e3e000305',
          order: 64,
        },
        {
          adult: false,
          gender: 2,
          id: 1198454,
          known_for_department: 'Diễn viên',
          name: 'Jim Ford',
          original_name: 'Jim Ford',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nSLODHZocKl8v2EgwBp7dOLpebz.jpg',
          cast_id: 121,
          character: 'Cadet (uncredited)',
          credit_id: '55e78d78c3a3682c5d00039f',
          order: 65,
        },
        {
          adult: false,
          gender: 0,
          id: 1277520,
          known_for_department: 'Diễn viên',
          name: 'Trudi Goodman',
          original_name: 'Trudi Goodman',
          popularity: 0.6,
          profile_path: null,
          cast_id: 122,
          character: 'Woman Office Worker (uncredited)',
          credit_id: '55e78da8c3a3682c6700030c',
          order: 66,
        },
        {
          adult: false,
          gender: 0,
          id: 580695,
          known_for_department: 'Diễn viên',
          name: 'Steve Lord',
          original_name: 'Steve Lord',
          popularity: 0.6,
          profile_path: null,
          cast_id: 123,
          character: 'Academy Pistol Coach (uncredited)',
          credit_id: '55e78e3a9251413e4100032c',
          order: 67,
        },
        {
          adult: false,
          gender: 0,
          id: 1385443,
          known_for_department: 'Diễn viên',
          name: 'Jack McCullough',
          original_name: 'Jack McCullough',
          popularity: 0.6,
          profile_path: null,
          cast_id: 124,
          character: 'EMT (uncredited)',
          credit_id: '55e78eaf9251413e3500032e',
          order: 68,
        },
        {
          adult: false,
          gender: 0,
          id: 205231,
          known_for_department: 'Diễn viên',
          name: 'Osmani Rodriguez',
          original_name: 'Osmani Rodriguez',
          popularity: 0.838,
          profile_path: null,
          cast_id: 125,
          character: 'Reporter (uncredited)',
          credit_id: '55e78f109251413e4100037d',
          order: 69,
        },
        {
          adult: false,
          gender: 0,
          id: 1297402,
          known_for_department: 'Diễn viên',
          name: 'Lawrence Cameron Steele',
          original_name: 'Lawrence Cameron Steele',
          popularity: 0.613,
          profile_path:
            'https://image.tmdb.org/t/p/w185/g4Lhuit9epkBYMnY9cf2KnCcuGz.jpg',
          cast_id: 126,
          character: 'Academy Firearms Instructor (uncredited)',
          credit_id: '55e78f409251413e4100038e',
          order: 70,
        },
        {
          adult: false,
          gender: 0,
          id: 1366927,
          known_for_department: 'Diễn viên',
          name: 'Conor Timmis',
          original_name: 'Conor Timmis',
          popularity: 0.6,
          profile_path: null,
          cast_id: 128,
          character: 'Rugby Fan (uncredited)',
          credit_id: '55e78f7b9251413e3e0003c2',
          order: 71,
        },
        {
          adult: false,
          gender: 2,
          id: 1360008,
          known_for_department: 'Diễn viên',
          name: 'Joseph Oliveira',
          original_name: 'Joseph Oliveira',
          popularity: 1.091,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hrVn7CVgShz3UaLLnzMxSIRnKCa.jpg',
          cast_id: 129,
          character: 'Officer (uncredited)',
          credit_id: '55e78fccc3a3682c760003ab',
          order: 72,
        },
        {
          adult: false,
          gender: 2,
          id: 1519595,
          known_for_department: 'Diễn viên',
          name: 'Adam Masnyk',
          original_name: 'Adam Masnyk',
          popularity: 0.6,
          profile_path: null,
          cast_id: 133,
          character: 'Southie Teen / Soccer Player (uncredited)',
          credit_id: '56e1bf1dc3a3680a100031d9',
          order: 73,
        },
        {
          adult: false,
          gender: 2,
          id: 928638,
          known_for_department: 'Diễn viên',
          name: 'John Franchi',
          original_name: 'John Franchi',
          popularity: 0.6,
          profile_path: null,
          cast_id: 142,
          character: 'Pedestrian (uncredited)',
          credit_id: '5798e82392514101e1002013',
          order: 74,
        },
        {
          adult: false,
          gender: 0,
          id: 1507846,
          known_for_department: 'Diễn viên',
          name: 'Paul McGillicuddy',
          original_name: 'Paul McGillicuddy',
          popularity: 0.98,
          profile_path: null,
          cast_id: 147,
          character: 'Subway Passenger (uncredited)',
          credit_id: '57d89107c3a3685490001f8a',
          order: 75,
        },
        {
          adult: false,
          gender: 2,
          id: 583838,
          known_for_department: 'Diễn viên',
          name: 'Kim Carrell',
          original_name: 'Kim Carrell',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4Tnkb2xmAl95oG2J9KTaaRs4cNV.jpg',
          cast_id: 164,
          character: 'MA State Police Detective',
          credit_id: '5e1e28fb511d090014819861',
          order: 76,
        },
        {
          adult: false,
          gender: 2,
          id: 1781349,
          known_for_department: 'Diễn viên',
          name: 'Robert Myers',
          original_name: 'Robert Myers',
          popularity: 0.702,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eEsh5ySBVDMFMF2smWvXyYRXoqZ.jpg',
          cast_id: 165,
          character: 'Cadet Parent (uncredited)',
          credit_id: '5e8b5924ffd44d00131b056e',
          order: 77,
        },
        {
          adult: true,
          gender: 1,
          id: 99688,
          known_for_department: 'Diễn viên',
          name: 'Rebecca Love',
          original_name: 'Rebecca Love',
          popularity: 2.744,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vuW2UPh980GQSGcxxLZLdAoURwM.jpg',
          cast_id: 166,
          character: 'Adult Film Actress (uncredited)',
          credit_id: '5f025f32d70594003709aa2b',
          order: 78,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 117,
          known_for_department: 'Sound',
          name: 'Howard Shore',
          original_name: 'Howard Shore',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nJ606tXnL8vDVHi7qavrV292ljt.jpg',
          credit_id: '5f443a2c41aac400370fc09f',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 287,
          known_for_department: 'Diễn viên',
          name: 'Brad Pitt',
          original_name: 'Brad Pitt',
          popularity: 19.876,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hfkzP7YstXRsj2IM1a8lLz8bvst.jpg',
          credit_id: '52fe42f5c3a36847f802ff41',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1032,
          known_for_department: 'Directing',
          name: 'Martin Scorsese',
          original_name: 'Martin Scorsese',
          popularity: 7.059,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ixaF5f1lWhWy7aKr21KpX2SiI7S.jpg',
          credit_id: '52fe42f5c3a36847f802fecb',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1298,
          known_for_department: 'Production',
          name: 'Brad Grey',
          original_name: 'Brad Grey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe42f5c3a36847f802ff3b',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1638,
          known_for_department: 'Sound',
          name: 'Eugene Gearty',
          original_name: 'Eugene Gearty',
          popularity: 0.631,
          profile_path: null,
          credit_id: '54d1e7f09251411b65002046',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1638,
          known_for_department: 'Sound',
          name: 'Eugene Gearty',
          original_name: 'Eugene Gearty',
          popularity: 0.631,
          profile_path: null,
          credit_id: '54d1e7cf925141579e001c7d',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 2242,
          known_for_department: 'Production',
          name: 'Ellen Lewis',
          original_name: 'Ellen Lewis',
          popularity: 0.74,
          profile_path: null,
          credit_id: '52fe42f5c3a36847f802ff13',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 1,
          id: 3661,
          known_for_department: 'Editing',
          name: 'Thelma Schoonmaker',
          original_name: 'Thelma Schoonmaker',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nmFrA92JuDOvGAyd6yxnRdiYVMF.jpg',
          credit_id: '52fe42f5c3a36847f802ff0d',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 3769,
          known_for_department: 'Camera',
          name: 'Michael Ballhaus',
          original_name: 'Michael Ballhaus',
          popularity: 0.652,
          profile_path: null,
          credit_id: '52fe42f5c3a36847f802fee3',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 0,
          id: 5333,
          known_for_department: 'Costume & Make-Up',
          name: 'Christine Beveridge',
          original_name: 'Christine Beveridge',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1e5ebc3a3687388001fad',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 6191,
          known_for_department: 'Art',
          name: 'Leslie E. Rollins',
          original_name: 'Leslie E. Rollins',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1e4e1925141579e001c2c',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 2,
          id: 6942,
          known_for_department: 'Crew',
          name: 'Eric Weinstein',
          original_name: 'Eric Weinstein',
          popularity: 1.546,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yPYIjSrc1SLiVHAsBaB5RAOhINh.jpg',
          credit_id: '579793c8925141068a0048c7',
          department: 'Crew',
          job: "Actor's Assistant",
        },
        {
          adult: false,
          gender: 2,
          id: 7531,
          known_for_department: 'Production',
          name: 'Joseph P. Reidy',
          original_name: 'Joseph P. Reidy',
          popularity: 0.624,
          profile_path: null,
          credit_id: '56cb4d1e92514156cd000106',
          department: 'Directing',
          job: 'Assistant Director',
        },
        {
          adult: false,
          gender: 1,
          id: 9027,
          known_for_department: 'Costume & Make-Up',
          name: 'Sandy Powell',
          original_name: 'Sandy Powell',
          popularity: 0.828,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3pK4SuBmOVghdktSREkSBkFFnG.jpg',
          credit_id: '52fe42f5c3a36847f802ff4d',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 1,
          id: 9178,
          known_for_department: 'Art',
          name: 'Kristi Zea',
          original_name: 'Kristi Zea',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eXkeXScvvcfiuVplqCy8ljLY4vs.jpg',
          credit_id: '54d1e4b19251411b5700201d',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 0,
          id: 13050,
          known_for_department: 'Crew',
          name: 'Tim Monich',
          original_name: 'Tim Monich',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1ea2e9251411b5c001e4e',
          department: 'Crew',
          job: 'Dialect Coach',
        },
        {
          adult: false,
          gender: 0,
          id: 15528,
          known_for_department: 'Crew',
          name: 'Steven Kirshoff',
          original_name: 'Steven Kirshoff',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1e85e9251411b69002152',
          department: 'Crew',
          job: 'Special Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 15845,
          known_for_department: 'Costume & Make-Up',
          name: 'John Caglione Jr.',
          original_name: 'John Caglione Jr.',
          popularity: 0.98,
          profile_path: null,
          credit_id: '54d1e61cc3a3687600001d85',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 16729,
          known_for_department: 'Production',
          name: 'Graham King',
          original_name: 'Graham King',
          popularity: 0.606,
          profile_path: null,
          credit_id: '52fe42f5c3a36847f802ff47',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 34510,
          known_for_department: 'Biên kịch',
          name: 'William Monahan',
          original_name: 'William Monahan',
          popularity: 0.923,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eqpsbq6zBEnT8b8ayDYUvubJbCQ.jpg',
          credit_id: '52fe42f5c3a36847f802ff29',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 21035,
          known_for_department: 'Production',
          name: 'Doug Davison',
          original_name: 'Doug Davison',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57754b31c3a3686ce6000611',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 21036,
          known_for_department: 'Production',
          name: 'Roy Lee',
          original_name: 'Roy Lee',
          popularity: 1.38,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fMY0MiVyrGaK44ejqWzT2txcRVI.jpg',
          credit_id: '57754e75c3a368475f001290',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 23226,
          known_for_department: 'Production',
          name: 'G. Mac Brown',
          original_name: 'G. Mac Brown',
          popularity: 0.6,
          profile_path: null,
          credit_id: '575706939251414ec0000268',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 35630,
          known_for_department: 'Lighting',
          name: 'Timothy Healy',
          original_name: 'Timothy Healy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57c467579251416b610052fd',
          department: 'Lighting',
          job: 'Electrician',
        },
        {
          adult: false,
          gender: 2,
          id: 60190,
          known_for_department: 'Crew',
          name: 'Paul A. Levin',
          original_name: 'Paul A. Levin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57c85bb0925141628100054c',
          department: 'Crew',
          job: 'Post Production Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 66718,
          known_for_department: 'Directing',
          name: 'Alan Mak',
          original_name: 'Alan Mak',
          popularity: 1.163,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gwv64jcZAWiDNT5P9x0YCiUmSAO.jpg',
          credit_id: '52fe42f5c3a36847f802ff2f',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 66719,
          known_for_department: 'Biên kịch',
          name: 'Felix Chong Man-Keung',
          original_name: 'Felix Chong Man-Keung',
          popularity: 1.21,
          profile_path:
            'https://image.tmdb.org/t/p/w185/AwiN7Um3loYamJ4F413fNelveoT.jpg',
          credit_id: '52fe42f5c3a36847f802ff35',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 92373,
          known_for_department: 'Sound',
          name: 'Kam Chan',
          original_name: 'Kam Chan',
          popularity: 0.982,
          profile_path: null,
          credit_id: '5f443a6b6eecee00355a1dc0',
          department: 'Sound',
          job: 'Foley Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 92376,
          known_for_department: 'Sound',
          name: 'Marko Costanzo',
          original_name: 'Marko Costanzo',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5f443a41511d090036b3ce4f',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 1,
          id: 92386,
          known_for_department: 'Sound',
          name: 'Marissa Littlefield',
          original_name: 'Marissa Littlefield',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f443a0f511d090037b4d4d2',
          department: 'Sound',
          job: 'ADR Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 91072,
          known_for_department: 'Production',
          name: 'Carla Raij',
          original_name: 'Carla Raij',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1ea4ac3a3687600001e09',
          department: 'Production',
          job: 'Location Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 117206,
          known_for_department: 'Costume & Make-Up',
          name: 'Kay Georgiou',
          original_name: 'Kay Georgiou',
          popularity: 1.166,
          profile_path: null,
          credit_id: '54d1e57b9251411b5f001e6e',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 2,
          id: 162522,
          known_for_department: 'Crew',
          name: 'Blaise Corrigan',
          original_name: 'Blaise Corrigan',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ycsMR3gck2D8jJT6QEtzyrjUmC6.jpg',
          credit_id: '5f025fd3dd258900399d079a',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 186721,
          known_for_department: 'Visual Effects',
          name: 'Ron Ames',
          original_name: 'Ron Ames',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1e884c3a3687388001ffb',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 388770,
          known_for_department: 'Sound',
          name: 'Jeffrey Stern',
          original_name: 'Jeffrey Stern',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f4439f141aac400360fb400',
          department: 'Sound',
          job: 'ADR Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 995189,
          known_for_department: 'Camera',
          name: 'Thomas Lappin',
          original_name: 'Thomas Lappin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1e8d6c3a3687600001de7',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1073780,
          known_for_department: 'Visual Effects',
          name: 'David Ebner',
          original_name: 'David Ebner',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5711162cc3a36831e1003ca1',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1074163,
          known_for_department: 'Crew',
          name: 'G. A. Aguilar',
          original_name: 'G. A. Aguilar',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qhnZkskvONZXKmijtOzTG0uP5kS.jpg',
          credit_id: '54d1e8b5c3a3687600001de1',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1190771,
          known_for_department: 'Crew',
          name: 'George B. Colucci Jr.',
          original_name: 'George B. Colucci Jr.',
          popularity: 0.84,
          profile_path: null,
          credit_id: '5f025fba7caa470038dfb8fc',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 1,
          id: 1193637,
          known_for_department: 'Art',
          name: 'Susan Perlman',
          original_name: 'Susan Perlman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57530d97c3a3684b96000703',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 2,
          id: 1270921,
          known_for_department: 'Crew',
          name: 'Peewee Piemonte',
          original_name: 'Peewee Piemonte',
          popularity: 0.621,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9qeo6ppYpOc0aYIseTESagK1kth.jpg',
          credit_id: '5f02604a7caa470035e1de05',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1315700,
          known_for_department: 'Costume & Make-Up',
          name: 'Donald Mowat',
          original_name: 'Donald Mowat',
          popularity: 0.673,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ikdaVXZvwu9wdgbtJWbeokb0fVL.jpg',
          credit_id: '54d1e609c3a3687600001d81',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1317645,
          known_for_department: 'Art',
          name: 'Teresa Carriker-Thayer',
          original_name: 'Teresa Carriker-Thayer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1e4cec3a3687351001cf2',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 1328380,
          known_for_department: 'Costume & Make-Up',
          name: 'David Davenport',
          original_name: 'David Davenport',
          popularity: 0.98,
          profile_path: null,
          credit_id: '54d1e95bc3a368307d0024f8',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1332210,
          known_for_department: 'Costume & Make-Up',
          name: 'Michael Germain',
          original_name: 'Michael Germain',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1e5c0c3a3687600001d76',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 1333223,
          known_for_department: 'Sound',
          name: 'Philip Stockton',
          original_name: 'Philip Stockton',
          popularity: 1.008,
          profile_path: null,
          credit_id: '54d1e7bac3a368308200203b',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1333223,
          known_for_department: 'Sound',
          name: 'Philip Stockton',
          original_name: 'Philip Stockton',
          popularity: 1.008,
          profile_path: null,
          credit_id: '5e1b7e3ce194b00016b63aef',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1338670,
          known_for_department: 'Costume & Make-Up',
          name: 'Joy Zapata',
          original_name: 'Joy Zapata',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1e5a59251411b5700203f',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 2,
          id: 1380443,
          known_for_department: 'Sound',
          name: 'Jac Rubenstein',
          original_name: 'Jac Rubenstein',
          popularity: 0.614,
          profile_path: null,
          credit_id: '5e1b7e4c3520e8001535fb57',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1386920,
          known_for_department: 'Camera',
          name: 'Andrew Cooper',
          original_name: 'Andrew Cooper',
          popularity: 1.38,
          profile_path: null,
          credit_id: '54d1e919c3a368308200206b',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 0,
          id: 1391591,
          known_for_department: 'Camera',
          name: 'Bruce MacCallum',
          original_name: 'Bruce MacCallum',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1e8eac3a368306f002074',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 1400072,
          known_for_department: 'Sound',
          name: 'Tom Fleischman',
          original_name: 'Tom Fleischman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1e823c3a3687351001d38',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 1400081,
          known_for_department: 'Camera',
          name: 'Andrew Rowlands',
          original_name: 'Andrew Rowlands',
          popularity: 1.008,
          profile_path: null,
          credit_id: '54d1e8ff925141579e001ca0',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 1,
          id: 1402015,
          known_for_department: 'Costume & Make-Up',
          name: 'Kathryn Blondell',
          original_name: 'Kathryn Blondell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1e54dc3a368306f001fe1',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 2,
          id: 1402031,
          known_for_department: 'Visual Effects',
          name: 'Robert Legato',
          original_name: 'Robert Legato',
          popularity: 1.38,
          profile_path: null,
          credit_id: '54d1e89fc3a368308200205e',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1402037,
          known_for_department: 'Sound',
          name: 'Jennifer Dunnington',
          original_name: 'Jennifer Dunnington',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1e9d9925141579e001caf',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1402039,
          known_for_department: 'Directing',
          name: 'Martha Pinson',
          original_name: 'Martha Pinson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1ea16c3a368306f00208b',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1402040,
          known_for_department: 'Crew',
          name: 'Larry Kaplan',
          original_name: 'Larry Kaplan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1ea829251411b5c001e55',
          department: 'Crew',
          job: 'Unit Publicist',
        },
        {
          adult: false,
          gender: 0,
          id: 1406596,
          known_for_department: 'Art',
          name: 'Marion Kolsby',
          original_name: 'Marion Kolsby',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1e688925141579e001c51',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1406898,
          known_for_department: 'Sound',
          name: 'Allan Zaleski',
          original_name: 'Allan Zaleski',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/u1SkYb0bUayr4YaXfB4KpC88CI0.jpg',
          credit_id: '54d1e8039251411b69002144',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1407009,
          known_for_department: 'Costume & Make-Up',
          name: 'Johnny Villanueva',
          original_name: 'Johnny Villanueva',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1e5919251411b59001fc8',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 1407205,
          known_for_department: 'Editing',
          name: 'Devin Sterling',
          original_name: 'Devin Sterling',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1e9939251411b6900216f',
          department: 'Editing',
          job: 'Digital Intermediate',
        },
        {
          adult: false,
          gender: 2,
          id: 1414994,
          known_for_department: 'Art',
          name: 'Robert Griffon Jr.',
          original_name: 'Robert Griffon Jr.',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5e1b7dd20e29a20017f6456a',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 1419095,
          known_for_department: 'Art',
          name: 'Theodore Suchecki',
          original_name: 'Theodore Suchecki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1e73fc3a3687388001fd1',
          department: 'Art',
          job: 'Construction Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1422795,
          known_for_department: 'Costume & Make-Up',
          name: 'Sian Grigg',
          original_name: 'Sian Grigg',
          popularity: 1.62,
          profile_path: null,
          credit_id: '54d1e5d39251411b69002102',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1422796,
          known_for_department: 'Art',
          name: 'Erik Knight',
          original_name: 'Erik Knight',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1e6729251411b6500201c',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1422797,
          known_for_department: 'Art',
          name: 'Robert Thayer',
          original_name: 'Robert Thayer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1e6e39251411b59001ff8',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1422798,
          known_for_department: 'Costume & Make-Up',
          name: 'Thomas Stokes',
          original_name: 'Thomas Stokes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1e9739251411b6500206a',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1422799,
          known_for_department: 'Sound',
          name: 'Tass Filipos',
          original_name: 'Tass Filipos',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1e9bfc3a3687600001df9',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1422800,
          known_for_department: 'Crew',
          name: 'Robert Martini',
          original_name: 'Robert Martini',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54d1e9f8c3a36830800024ae',
          department: 'Crew',
          job: 'Transportation Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1457637,
          known_for_department: 'Crew',
          name: "William 'Billy Jack' Jakielaszek",
          original_name: "William 'Billy Jack' Jakielaszek",
          popularity: 0.6,
          profile_path: null,
          credit_id: '57d893b892514168de001dbc',
          department: 'Crew',
          job: 'Special Effects',
        },
        {
          adult: false,
          gender: 1,
          id: 1553887,
          known_for_department: 'Sound',
          name: 'Jamie Baker',
          original_name: 'Jamie Baker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f443a5899d5c30034b8a377',
          department: 'Sound',
          job: 'Foley Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1554926,
          known_for_department: 'Crew',
          name: 'Shawnna Thibodeau',
          original_name: 'Shawnna Thibodeau',
          popularity: 0.656,
          profile_path: null,
          credit_id: '5f026094d0b4340036685a50',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1555017,
          known_for_department: 'Crew',
          name: 'Brian Ricci',
          original_name: 'Brian Ricci',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5796b3bd9251417dca002732',
          department: 'Crew',
          job: 'Special Effects',
        },
        {
          adult: false,
          gender: 2,
          id: 1647723,
          known_for_department: 'Diễn viên',
          name: 'Michael Arthur',
          original_name: 'Michael Arthur',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/f3xG2p3rPU8wIkFUCUZMGwjdqjN.jpg',
          credit_id: '57d88f1992514168de001c58',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 1,
          id: 1648167,
          known_for_department: 'Crew',
          name: 'Janet Paparazzo',
          original_name: 'Janet Paparazzo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f02600f8ec4ab00334035e7',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 1,
          id: 1996017,
          known_for_department: 'Crew',
          name: 'Lisa Shaftel',
          original_name: 'Lisa Shaftel',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5aa54f53925141278d02216d',
          department: 'Crew',
          job: 'Scenic Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2021433,
          known_for_department: 'Diễn viên',
          name: 'Joseph Zamparelli',
          original_name: 'Joseph Zamparelli',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f0260aad70594003709ab81',
          department: 'Crew',
          job: 'Stunt Driver',
        },
        {
          adult: false,
          gender: 1,
          id: 2103599,
          known_for_department: 'Crew',
          name: 'Jodi Michelle Pynn',
          original_name: 'Jodi Michelle Pynn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f02607f41aac40036925b36',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 2506559,
          known_for_department: 'Art',
          name: 'Joseph S. Alfieri',
          original_name: 'Joseph S. Alfieri',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e19632a6f43ec0016620a84',
          department: 'Art',
          job: 'Construction Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2703164,
          known_for_department: 'Crew',
          name: 'Lauren Hayward',
          original_name: 'Lauren Hayward',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f025feed70594003709ab40',
          department: 'Crew',
          job: 'Stunts',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'talisencrw',
          author_details: {
            name: '',
            username: 'talisencrw',
            avatar_path:
              '/https://secure.gravatar.com/avatar/cbcc9350415274a3c68399bd37ca3ebc.jpg',
            rating: 10.0,
          },
          content:
            "I decided to celebrate the Summer Solstice by watching 'The Departed'. Don't ask me why. I had previously loved the Hồng Kông-made 'Infernal Affairs' trilogy on which this is based. Usually I hate when international masterpieces get remade, but this was a sterling exception. This was controversial when it took in a cartload of Oscars, particularly finally a directorial nod for Scorsese, but don't be misled--it's easily one of his finest works.\r\n\r\nThis is my Golden Rule on both remakes in general, but especially American remakes of international (particularly foreign-language) great films. When in doubt, check the label:\r\n\r\n1. Director? (check)\r\n2. Cast? (check)\r\n3. Script? (check)\r\n\r\n'The proof is in the pudding!'",
          created_at: '2016-07-21T23:08:30.635Z',
          id: '579155ee9251415aab002740',
          updated_at: '2021-06-23T15:57:49.489Z',
          url: 'https://www.themoviedb.org/review/579155ee9251415aab002740',
        },
        {
          author: 'John Chard',
          author_details: {
            name: '',
            username: 'John Chard',
            avatar_path: '/utEXl2EDiXBK6f41wCLsvprvMg4.jpg',
            rating: 8.0,
          },
          content:
            "The only one that can do what I do is me. Lot of people had to die for me to be me. You wanna be me? \r\n\r\nThe Departed is directed by Martin Scorsese and written by William Monahan, Alan Mak and Felix Chong. It stars Jack Nicholson, Matt Damon, Leonardo DiCaprio, Mark Wahlberg, Martin Sheen, Ray Winstone, Vera Farmiga, Anthony Anderson, Mark Rolston and Alec Baldwin. Music is by Howard Shore and cinematography by Michael Ballhaus.\r\n\r\nAn Irish gang in South Boston becomes aware there is a rat in their midst, whilst the police force has a mole to contend with - with each one trying to out each other before the other does...\r\n\r\nMartin Scorsese remakes Hồng Kông thriller Infernal Affairs (2002) for the English speaking world, and promptly bagged his first Best Director Oscar in the process. It's a thrilling picture packed with suspense and edginess, a psychological gangster picture driven by two men leading double lives that is leading them to the abyss. When the violence comes it erupts in thunderous strokes, all while the narrative pulses with paranoia. There are some irksome contrivances, but with a uniformly strong set of turns from the cast, great musical accompaniments, and a director returning to gangster form, The Departed is a sure fire winner. 8.5/10",
          created_at: '2020-04-25T12:05:28.320Z',
          id: '5ea427886d1bb2001fa38c93',
          updated_at: '2021-06-23T15:58:37.429Z',
          url: 'https://www.themoviedb.org/review/5ea427886d1bb2001fa38c93',
        },
      ],
      total_pages: 1,
      total_results: 2,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/wRDyTXw5j0RN9M03xZlHYkoNLCI.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 16, name: 'Phim Hoạt Hình' },
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 14, name: 'Phim Giả Tượng' },
      { id: 10749, name: 'Phim Lãng Mạn' },
    ],
    homepage: 'https://gkidstickets.com/us/weathering-with-you/',
    id: 568160,
    imdb_id: 'tt9426210',
    original_language: 'ja',
    original_title: '天気の子',
    overview:
      'Xoay quanh cuộc sống của cậu thiếu niên Morishima Hodaka, ở độ tuổi “trẻ trâu” 16 mùa bánh trưng, sau khi đã quá chán cuộc sống tại vùng đảo xa nên cậu có ý định lên thành phố Tokyo để tìm kiếm thử thách của riêng mình. Thế nhưng, mọi việc dần trở nên không giống như cậu mong tưởng, cuộc sống trở nên túng thiếu giữa thành thị đắt đỏ để rồi cậu co mình lại cùn nỗi cô đơn nhớ nhà. Để có tiền trang trải, Hodaka viết bài cho một tờ tạp chí chuyên tin tức về những hiện tượng lạ thường.  Nhưng đúng lúc mới đi làm thì trời cứ mưa mãi khiến cuộc sống xung quanh trở nên ảm đạm và càng não nề. Và rồi như một định mệnh ông trời sắp đặt, trong một con hẻm của thành phố đông đúc và bận rộn, Hodaka gặp một cô gái trẻ tên Hina Amano, một cô gái có khả năng kỳ lạ có thể làm ánh sáng trên bầu trời bừng sáng thông qua những lời nguyện cầu đặc biệt.',
    popularity: 155.665,
    poster_path:
      'https://image.tmdb.org/t/p/w342/3agCPmRZg0G9nS2Go0uzftE9gmr.jpg',
    production_companies: [
      {
        id: 3756,
        logo_path: '/t38uPdbKmyBB8brKKeTFWIwojRz.png',
        name: 'CoMix Wave Films',
        origin_country: 'JP',
      },
      {
        id: 128616,
        logo_path: '/cjmwexOzetWZa8QKy447NMrM6MG.png',
        name: 'STORY',
        origin_country: 'JP',
      },
      {
        id: 882,
        logo_path: '/fRSWWjquvzcHjACbtF53utZFIll.png',
        name: 'Toho',
        origin_country: 'JP',
      },
      {
        id: 2073,
        logo_path: '/6KxDcBObqIPRgns95Vdo6sjRtXQ.png',
        name: 'Kadokawa',
        origin_country: 'JP',
      },
      { id: 128617, logo_path: null, name: 'voque ting', origin_country: 'JP' },
      {
        id: 8157,
        logo_path: '/yHOC2PPmj6j2zzRqwdufCZauFxI.png',
        name: 'East Nhật Bản Marketing & Communications',
        origin_country: 'JP',
      },
      {
        id: 104184,
        logo_path: null,
        name: 'Lawson Entertainment',
        origin_country: 'JP',
      },
      {
        id: 150372,
        logo_path: null,
        name: 'Sound Team・Don Juan',
        origin_country: 'JP',
      },
      {
        id: 145448,
        logo_path: null,
        name: '"Weathering With You" Film Partners',
        origin_country: 'JP',
      },
    ],
    production_countries: [{ iso_3166_1: 'JP', name: 'Nhật Bản' }],
    release_date: '2019-06-19',
    revenue: 186965409,
    runtime: 112,
    spoken_languages: [
      { english_name: 'Nhật Bảnese', iso_639_1: 'ja', name: '日本語' },
    ],
    status: 'Đã phát hành',
    tagline: 'Tớ cần cậu hơn bất cứ trời xanh nào!',
    title: 'Đứa Con Của Thời Tiết',
    video: false,
    vote_average: 8.2,
    vote_count: 1279,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'WEATHERING WITH YOU Trailer (2020) - English Dub',
          key: 'LrMVYx2RG6w',
          site: 'YouTube',
          size: 360,
          type: 'Trailer',
          official: false,
          published_at: '2020-01-08T16:50:49.000Z',
          id: '5f7032b7d55e4d00378813f3',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'WEATHERING WITH YOU Trailer (2020) English Dub',
          key: '9TN44ZBVo-A',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: false,
          published_at: '2020-01-07T09:03:56.000Z',
          id: '5f0bcb5d5e12000037e8afa5',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Weathering With You (2020) - Official Trailer | English Dub',
          key: 'Rdh82jbHoIw',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: false,
          published_at: '2020-01-06T20:26:02.000Z',
          id: '5e1406a5d8af670016c0a471',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'English Subtitled Trailer. Weathering With You [Official GKIDS]',
          key: 'Q6iK6DjV_iE',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2019-07-23T14:04:24.000Z',
          id: '5d68dd0213af5f7d25bc5edb',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 2194388,
          known_for_department: 'Diễn viên',
          name: 'Kotaro Daigo',
          original_name: 'Kotaro Daigo',
          popularity: 0.618,
          profile_path:
            'https://image.tmdb.org/t/p/w185/13cjAKPYGh4FDh7ctwxDfQRhpKg.jpg',
          cast_id: 3,
          character: 'Hodaka Morishima (voice)',
          credit_id: '5c122039925141352bb98950',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 2109360,
          known_for_department: 'Diễn viên',
          name: 'Nana Mori',
          original_name: 'Nana Mori',
          popularity: 2.185,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kmvxKEhUeolX4frX2ws4NnfIdf3.jpg',
          cast_id: 4,
          character: 'Hina Amano (voice)',
          credit_id: '5c1220620e0a2632797b1fcd',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 1255487,
          known_for_department: 'Diễn viên',
          name: 'Tsubasa Honda',
          original_name: 'Tsubasa Honda',
          popularity: 4.73,
          profile_path:
            'https://image.tmdb.org/t/p/w185/A18nsMcxi7qlCYV7R5BJsToDQKf.jpg',
          cast_id: 14,
          character: 'Natsumi Suga (voice)',
          credit_id: '5d1a6a7aaf95900021cd3f66',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 2352340,
          known_for_department: 'Diễn viên',
          name: 'Sakura Kiryu',
          original_name: 'Sakura Kiryu',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jS96RwYZLaPPhlvxKzJmb8ItURN.jpg',
          cast_id: 10,
          character: 'Nagisa Amano (voice)',
          credit_id: '5d1a6a34ca4f6752bfd6ecb9',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 85939,
          known_for_department: 'Diễn viên',
          name: 'Sei Hiraizumi',
          original_name: 'Sei Hiraizumi',
          popularity: 1.214,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4zrn7ltgOCvjyk9CWrhmsS7yrlc.jpg',
          cast_id: 11,
          character: 'Yasui (voice)',
          credit_id: '5d1a6a468a84d27f56cca27e',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 149894,
          known_for_department: 'Diễn viên',
          name: 'Yuki Kaji',
          original_name: 'Yuki Kaji',
          popularity: 6.588,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8wKdPV11IwowfwoqGqMMNt9hmp6.jpg',
          cast_id: 12,
          character: 'Takai (voice)',
          credit_id: '5d1a6a5f30aa314923c561e9',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 533325,
          known_for_department: 'Diễn viên',
          name: 'Chieko Baisho',
          original_name: 'Chieko Baisho',
          popularity: 2.804,
          profile_path:
            'https://image.tmdb.org/t/p/w185/h4RXDxmSOhjlJsb1BY20RXZ9bSR.jpg',
          cast_id: 15,
          character: 'Fumi Tachibana (voice)',
          credit_id: '5db84aae0792e10013463b6e',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 46364,
          known_for_department: 'Diễn viên',
          name: 'Shun Oguri',
          original_name: 'Shun Oguri',
          popularity: 5.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4tfrhvqp3IGHPATor0lYE9X9UD3.jpg',
          cast_id: 13,
          character: 'Keisuke Suga (voice)',
          credit_id: '5d1a6a6b8a84d27f35ccb20f',
          order: 7,
        },
        {
          adult: false,
          gender: 1,
          id: 613,
          known_for_department: 'Diễn viên',
          name: 'Sumi Shimamoto',
          original_name: 'Sumi Shimamoto',
          popularity: 1.894,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bBA5xY4wrOUIpGnY6QPPQ9vNJB1.jpg',
          cast_id: 20,
          character: 'Mamiya (voice)',
          credit_id: '5db84ec60f2fbd001473c6ad',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 114299,
          known_for_department: 'Diễn viên',
          name: 'Ryohei Kimura',
          original_name: 'Ryohei Kimura',
          popularity: 2.428,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ghw7P67LKTNIsc6g6hAixsRSIWR.jpg',
          cast_id: 22,
          character: 'Kimura (voice)',
          credit_id: '5db84f2c3faba0001439b9aa',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 119143,
          known_for_department: 'Diễn viên',
          name: 'Kana Hanazawa',
          original_name: 'Kana Hanazawa',
          popularity: 6.429,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5bK9ttcRydQBWmyZp7gXDmJYOPF.jpg',
          cast_id: 16,
          character: 'Kana (voice)',
          credit_id: '5db84b7d0f2fbd0011742e09',
          order: 10,
        },
        {
          adult: false,
          gender: 1,
          id: 992869,
          known_for_department: 'Diễn viên',
          name: 'Ayane Sakura',
          original_name: 'Ayane Sakura',
          popularity: 4.168,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6IxCswQIxI8AlKezwOfk9eS9eGC.jpg',
          cast_id: 17,
          character: 'Ayane (voice)',
          credit_id: '5db84b8b3faba0001439b57b',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 1972402,
          known_for_department: 'Diễn viên',
          name: 'Kana Ichinose',
          original_name: 'Kana Ichinose',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3MmHWf5pa1i4s64T2mI6npc26TY.jpg',
          cast_id: 21,
          character: 'Sasaki (voice)',
          credit_id: '5db84f030792e100134642f3',
          order: 12,
        },
        {
          adult: false,
          gender: 1,
          id: 90496,
          known_for_department: 'Diễn viên',
          name: 'Masako Nozawa',
          original_name: 'Masako Nozawa',
          popularity: 3.94,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jxbXdejmPoiKnNoQz7Dkb80qC26.jpg',
          cast_id: 23,
          character: 'Fortuneteller (voice)',
          credit_id: '5dbaaf52dbf1440011519555',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 1213848,
          known_for_department: 'Diễn viên',
          name: 'Hidekatsu Shibata',
          original_name: 'Hidekatsu Shibata',
          popularity: 1.214,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hnKQe1GpuLAZY8pDnJc6eXIQzfv.jpg',
          cast_id: 24,
          character: 'Shinto priest (voice)',
          credit_id: '5dbaaf9112970c001838374b',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 225730,
          known_for_department: 'Diễn viên',
          name: 'Ryunosuke Kamiki',
          original_name: 'Ryunosuke Kamiki',
          popularity: 5.277,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6MwcfIUraHuKOmwjT4gX8BBB2T6.jpg',
          cast_id: 19,
          character: 'Taki Tachibana (voice)',
          credit_id: '5db84c8ea1d3320017e7cf59',
          order: 15,
        },
        {
          adult: false,
          gender: 1,
          id: 1369100,
          known_for_department: 'Diễn viên',
          name: 'Mone Kamishiraishi',
          original_name: 'Mone Kamishiraishi',
          popularity: 5.436,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cPydoy2sSqFDsbXeBPmzQGPmq0R.jpg',
          cast_id: 18,
          character: 'Mitsuha Miyamizu (voice)',
          credit_id: '5db84c64a1d3320014e7808b',
          order: 16,
        },
        {
          adult: false,
          gender: 2,
          id: 1668610,
          known_for_department: 'Diễn viên',
          name: 'Ryo Narita',
          original_name: 'Ryo Narita',
          popularity: 1.132,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nuDFEGyuL4b1u5JUNee7WmJfgp3.jpg',
          cast_id: 26,
          character: 'Katsuhiko Teshigawara (voice)',
          credit_id: '5dbab0b6dbf14400115198b5',
          order: 17,
        },
        {
          adult: false,
          gender: 1,
          id: 936275,
          known_for_department: 'Diễn viên',
          name: 'Aoi Yuki',
          original_name: 'Aoi Yuki',
          popularity: 8.375,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4kHNZSUIux52UU2BD3H6b5c5ymZ.jpg',
          cast_id: 27,
          character: 'Sayaka Natori (voice)',
          credit_id: '5dbab0e4d2c0c100181b990d',
          order: 18,
        },
        {
          adult: false,
          gender: 1,
          id: 1344919,
          known_for_department: 'Diễn viên',
          name: 'Kanon Tani',
          original_name: 'Kanon Tani',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xY3JBxs6blBe2AvyS678bcs76Vc.jpg',
          cast_id: 25,
          character: 'Yotsuha Miyamizu (voice)',
          credit_id: '5dbab05112970c0015382385',
          order: 19,
        },
        {
          adult: false,
          gender: 1,
          id: 2463606,
          known_for_department: 'Diễn viên',
          name: 'Yuki Ominami',
          original_name: 'Yuki Ominami',
          popularity: 2.268,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ehJmhf5FeeXTJvOV8SfQuxdzWvS.jpg',
          cast_id: 47,
          character: '(voice)',
          credit_id: '605e41c6f3e0df003db7d598',
          order: 20,
        },
        {
          adult: false,
          gender: 2,
          id: 2995659,
          known_for_department: 'Diễn viên',
          name: 'Shinjirō Gōda',
          original_name: 'Shinjirō Gōda',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xjnDnzVw6BRBcZDSuvRx0lfYCQY.jpg',
          cast_id: 206,
          character: '(voice)',
          credit_id: '618abfd4b076e500664627b7',
          order: 21,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 52215,
          known_for_department: 'Art',
          name: 'Hiroshi Katou',
          original_name: 'Hiroshi Katou',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hm3AcelBSqF8VrHGfJrOHwq2cHq.jpg',
          credit_id: '60f09d21706e56002ee299c5',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 74091,
          known_for_department: 'Directing',
          name: 'Makoto Shinkai',
          original_name: 'Makoto Shinkai',
          popularity: 3.514,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mSCk6PmAR99bCsKJYlMx94vq5qe.jpg',
          credit_id: '5fa3cb7c6e3deb004042c8f6',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 74091,
          known_for_department: 'Directing',
          name: 'Makoto Shinkai',
          original_name: 'Makoto Shinkai',
          popularity: 3.514,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mSCk6PmAR99bCsKJYlMx94vq5qe.jpg',
          credit_id: '60a8e50d85702e004062a47a',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 74091,
          known_for_department: 'Directing',
          name: 'Makoto Shinkai',
          original_name: 'Makoto Shinkai',
          popularity: 3.514,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mSCk6PmAR99bCsKJYlMx94vq5qe.jpg',
          credit_id: '616e9719e004a6005f0d0b65',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 74091,
          known_for_department: 'Directing',
          name: 'Makoto Shinkai',
          original_name: 'Makoto Shinkai',
          popularity: 3.514,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mSCk6PmAR99bCsKJYlMx94vq5qe.jpg',
          credit_id: '5fa3ca2821621d003ef16f02',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 74091,
          known_for_department: 'Directing',
          name: 'Makoto Shinkai',
          original_name: 'Makoto Shinkai',
          popularity: 3.514,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mSCk6PmAR99bCsKJYlMx94vq5qe.jpg',
          credit_id: '611f96db2e06970073576f91',
          department: 'Art',
          job: 'Storyboard Artist',
        },
        {
          adult: false,
          gender: 1,
          id: 144665,
          known_for_department: 'Sound',
          name: 'Eiko Morikawa',
          original_name: 'Eiko Morikawa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8e6de8dbc330041a33895',
          department: 'Sound',
          job: 'Sound Effects',
        },
        {
          adult: false,
          gender: 2,
          id: 237364,
          known_for_department: 'Production',
          name: 'Genki Kawamura',
          original_name: 'Genki Kawamura',
          popularity: 1.38,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lYiWJdjiib6b6uhiPfX9eU0bOGX.jpg',
          credit_id: '5c1a1b32c3a3683451d00b71',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1009730,
          known_for_department: 'Art',
          name: 'Nizou Yamamoto',
          original_name: 'Nizou Yamamoto',
          popularity: 0.766,
          profile_path: null,
          credit_id: '60a8ef700398ab00578d7f00',
          department: 'Art',
          job: 'Painter',
        },
        {
          adult: false,
          gender: 2,
          id: 1029281,
          known_for_department: 'Production',
          name: 'Minami Ichikawa',
          original_name: 'Minami Ichikawa',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hbLwY27J83U0FFTPqYvfFXpBRco.jpg',
          credit_id: '616e96e1cddbbc002c1f2264',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1031975,
          known_for_department: 'Visual Effects',
          name: 'Kenichi Tsuchiya',
          original_name: 'Kenichi Tsuchiya',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8ef2c85702e00580bba01',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 1116326,
          known_for_department: 'Production',
          name: 'Noritaka Kawaguchi',
          original_name: 'Noritaka Kawaguchi',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/c05kckuUvGjv6xx6pI7bPpjydvk.jpg',
          credit_id: '616e96ef53866e0068157f9b',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1315688,
          known_for_department: 'Art',
          name: 'Yuji Kaneko',
          original_name: 'Yuji Kaneko',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09d0668b1ea0046e553ff',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1316537,
          known_for_department: 'Art',
          name: 'Hiroshi Gouroku',
          original_name: 'Hiroshi Gouroku',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60b6a412dfaae90040692815',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1325228,
          known_for_department: 'Directing',
          name: 'Susumu Mitsunaka',
          original_name: 'Susumu Mitsunaka',
          popularity: 0.84,
          profile_path: null,
          credit_id: '60a8f4e285b105002a9d8a82',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 1456610,
          known_for_department: 'Visual Effects',
          name: 'Shunsuke Hirota',
          original_name: 'Shunsuke Hirota',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f0d59a64c100296702c8',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1456620,
          known_for_department: 'Visual Effects',
          name: 'Kazuyoshi Onoda',
          original_name: 'Kazuyoshi Onoda',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f3640398ab0029b3eb28',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 1456630,
          known_for_department: 'Visual Effects',
          name: 'Masafumi Yokota',
          original_name: 'Masafumi Yokota',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f45fc6006d002a72e701',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 1456773,
          known_for_department: 'Visual Effects',
          name: 'Tsutomu Awata',
          original_name: 'Tsutomu Awata',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f0fa85702e00580bbbbb',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 1462260,
          known_for_department: 'Diễn viên',
          name: 'Yojiro Noda',
          original_name: 'Yojiro Noda',
          popularity: 1.995,
          profile_path:
            'https://image.tmdb.org/t/p/w185/a7A6y9fMdSyiMPli7WuvPNZlGvb.jpg',
          credit_id: '607c6b359f37b00057a89d01',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 1462260,
          known_for_department: 'Diễn viên',
          name: 'Yojiro Noda',
          original_name: 'Yojiro Noda',
          popularity: 1.995,
          profile_path:
            'https://image.tmdb.org/t/p/w185/a7A6y9fMdSyiMPli7WuvPNZlGvb.jpg',
          credit_id: '5dc5c16aa14e1000105a51e4',
          department: 'Sound',
          job: 'Songs',
        },
        {
          adult: false,
          gender: 2,
          id: 1462260,
          known_for_department: 'Diễn viên',
          name: 'Yojiro Noda',
          original_name: 'Yojiro Noda',
          popularity: 1.995,
          profile_path:
            'https://image.tmdb.org/t/p/w185/a7A6y9fMdSyiMPli7WuvPNZlGvb.jpg',
          credit_id: '619cec13af58cb00444ba342',
          department: 'Sound',
          job: 'Theme Song Performance',
        },
        {
          adult: false,
          gender: 2,
          id: 1466002,
          known_for_department: 'Visual Effects',
          name: 'Shuichi Kaneko',
          original_name: 'Shuichi Kaneko',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f4e6c6006d0041376e24',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 1473665,
          known_for_department: 'Art',
          name: 'Osamu Masuyama',
          original_name: 'Osamu Masuyama',
          popularity: 0.698,
          profile_path: null,
          credit_id: '60f09d25706e5600741698e8',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1481733,
          known_for_department: 'Visual Effects',
          name: 'Taisuke Iwasaki',
          original_name: 'Taisuke Iwasaki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f0f00398ab0029b3e99d',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 1509659,
          known_for_department: 'Diễn viên',
          name: 'Toko Miura',
          original_name: 'Toko Miura',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kaFqvlsnJ7dtW6mvCuvRsirSS4U.jpg',
          credit_id: '619cebf9ea7b0e006351d95c',
          department: 'Sound',
          job: 'Theme Song Performance',
        },
        {
          adult: false,
          gender: 1,
          id: 1512044,
          known_for_department: 'Visual Effects',
          name: 'Touko Yatabe',
          original_name: 'Touko Yatabe',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f86a9a64c10029670ac3',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 1512105,
          known_for_department: 'Sound',
          name: 'Haru Yamada',
          original_name: 'Haru Yamada',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7arIZylFga4mHhZ407EMa3oXLOo.jpg',
          credit_id: '60a8e6d4d8cc4a0057422fc7',
          department: 'Sound',
          job: 'Sound Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1520822,
          known_for_department: 'Art',
          name: 'Yasuomi Kishi',
          original_name: 'Yasuomi Kishi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '612d1bc0b84cdd008638e522',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1559388,
          known_for_department: 'Art',
          name: 'Hiroshi Takiguchi',
          original_name: 'Hiroshi Takiguchi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c126cb70e0a2632797b4a2b',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 1590940,
          known_for_department: 'Art',
          name: 'Yohei Takamatsu',
          original_name: 'Yohei Takamatsu',
          popularity: 0.622,
          profile_path: null,
          credit_id: '60f09d33f3e0df005cf74bd5',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 1602468,
          known_for_department: 'Visual Effects',
          name: 'Minoru Ohashi',
          original_name: 'Minoru Ohashi',
          popularity: 1.38,
          profile_path: null,
          credit_id: '5fa3cb933a340b0041bc7cb5',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 1608130,
          known_for_department: 'Camera',
          name: 'Yuki Kawashita',
          original_name: 'Yuki Kawashita',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61814f880752880028769f2e',
          department: 'Visual Effects',
          job: 'Compositing Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 1632180,
          known_for_department: 'Visual Effects',
          name: 'Tatsuya Miki',
          original_name: 'Tatsuya Miki',
          popularity: 0.608,
          profile_path: null,
          credit_id: '60a8f5ecd8cc4a0057423a21',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 1661044,
          known_for_department: 'Visual Effects',
          name: 'Chiyoko Ueno',
          original_name: 'Chiyoko Ueno',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f0ca501cf200593110a1',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 1728057,
          known_for_department: 'Visual Effects',
          name: 'Nobuyuki Takeuchi',
          original_name: 'Nobuyuki Takeuchi',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/d7O7ZwWkmqPFKz32k39S8bw9bzA.jpg',
          credit_id: '60a8f4728dbc33007a419b4e',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 1749022,
          known_for_department: 'Production',
          name: 'Yoshihiro Furusawa',
          original_name: 'Yoshihiro Furusawa',
          popularity: 1.102,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8cVWxK1hw3YEqzjpE8cxI1gR8W4.jpg',
          credit_id: '60a8e7b385b10500797ed4a2',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1777159,
          known_for_department: 'Crew',
          name: 'Chiemi Irisa',
          original_name: 'Chiemi Irisa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8ef95d8cc4a00400e66d5',
          department: 'Crew',
          job: 'Special Effects',
        },
        {
          adult: false,
          gender: 1,
          id: 1778888,
          known_for_department: 'Visual Effects',
          name: 'Sayuri Yoshida',
          original_name: 'Sayuri Yoshida',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61a633d40486380045b84f01',
          department: 'Art',
          job: 'Painter',
        },
        {
          adult: false,
          gender: 2,
          id: 1782847,
          known_for_department: 'Visual Effects',
          name: 'Masayoshi Tanaka',
          original_name: 'Masayoshi Tanaka',
          popularity: 1.644,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eZMM15xElpDWnhrEdqqjuxT8wbn.jpg',
          credit_id: '5c126c819251413532b9b4cb',
          department: 'Visual Effects',
          job: 'Character Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1801212,
          known_for_department: 'Visual Effects',
          name: 'Takao Maki',
          original_name: 'Takao Maki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f51dd8cc4a00400e6c2c',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 1842747,
          known_for_department: 'Visual Effects',
          name: 'Shuichi Kitayama',
          original_name: 'Shuichi Kitayama',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f4317f2d4a007dfdc96f',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 1845058,
          known_for_department: 'Visual Effects',
          name: 'Hiroko Yaguchi',
          original_name: 'Hiroko Yaguchi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f4f4c6006d002a72e775',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 1847885,
          known_for_department: 'Visual Effects',
          name: 'Takashi Tomioka',
          original_name: 'Takashi Tomioka',
          popularity: 0.608,
          profile_path: null,
          credit_id: '60a8f47c66e469007b3d29f3',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 1848290,
          known_for_department: 'Visual Effects',
          name: 'Tatsuya Oka',
          original_name: 'Tatsuya Oka',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f5f17f4f210070fa904b',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 1893353,
          known_for_department: 'Visual Effects',
          name: 'Keiichiro Matsui',
          original_name: 'Keiichiro Matsui',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f5e1c6006d0059086135',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 1895789,
          known_for_department: 'Art',
          name: 'Akiko Majima',
          original_name: 'Akiko Majima',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09c7bcb75d1005d8d952f',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1895793,
          known_for_department: 'Art',
          name: 'Tasuku Watanabe',
          original_name: 'Tasuku Watanabe',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60b699f3dd926a00294908a7',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1895793,
          known_for_department: 'Art',
          name: 'Tasuku Watanabe',
          original_name: 'Tasuku Watanabe',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60b69a53c740d900424e3d70',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 1895799,
          known_for_department: 'Visual Effects',
          name: 'Yoko Miki',
          original_name: 'Yoko Miki',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/b3OwVn1iQhDPM3wsbOUjzqwksKP.jpg',
          credit_id: '60a8ef517f2d4a004418ce4a',
          department: 'Visual Effects',
          job: 'Color Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 1895799,
          known_for_department: 'Visual Effects',
          name: 'Yoko Miki',
          original_name: 'Yoko Miki',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/b3OwVn1iQhDPM3wsbOUjzqwksKP.jpg',
          credit_id: '60a8ea82501cf20026d3cd40',
          department: 'Directing',
          job: 'Assistant Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1895800,
          known_for_department: 'Sound',
          name: 'Yoichiro Kanesada',
          original_name: 'Yoichiro Kanesada',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f097c6006d0041376aec',
          department: 'Sound',
          job: 'Music Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1918524,
          known_for_department: 'Visual Effects',
          name: 'Hisayuki Tabata',
          original_name: 'Hisayuki Tabata',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f43c9a64c1006e269bd5',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 1968516,
          known_for_department: 'Art',
          name: 'Atsushi Satomi',
          original_name: 'Atsushi Satomi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09d3d87e63e00744336c2',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 1970418,
          known_for_department: 'Visual Effects',
          name: 'Maho Takagi',
          original_name: 'Maho Takagi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f1c066e469002cf17b34',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 2023280,
          known_for_department: 'Art',
          name: 'Takumi Tanji',
          original_name: 'Takumi Tanji',
          popularity: 1.38,
          profile_path: null,
          credit_id: '60f09c773396b900464fb51d',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 2032142,
          known_for_department: 'Visual Effects',
          name: 'Shigeru Kimishima',
          original_name: 'Shigeru Kimishima',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f25e7f2d4a004418d1e4',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2032169,
          known_for_department: 'Art',
          name: 'Satoko Nakamura',
          original_name: 'Satoko Nakamura',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09d360f21c6008027095e',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2032242,
          known_for_department: 'Visual Effects',
          name: 'Hirofumi Masuda',
          original_name: 'Hirofumi Masuda',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f1e90398ab0077c7aa15',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2032265,
          known_for_department: 'Visual Effects',
          name: 'Kazuko Shibata',
          original_name: 'Kazuko Shibata',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f54385702e002918c2d8',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2032278,
          known_for_department: 'Visual Effects',
          name: 'Takayo Nishimura',
          original_name: 'Takayo Nishimura',
          popularity: 0.98,
          profile_path: null,
          credit_id: '60a8ebb58dbc330041a33ca5',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 2037587,
          known_for_department: 'Sound',
          name: 'Yuki Hayashi',
          original_name: 'Yuki Hayashi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6126642ad70594004552a0d6',
          department: 'Sound',
          job: 'Sound Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 2040392,
          known_for_department: 'Sound',
          name: 'Takahisa Ishino',
          original_name: 'Takahisa Ishino',
          popularity: 0.6,
          profile_path: null,
          credit_id: '612664340257640092eb3f74',
          department: 'Sound',
          job: 'Sound Effects',
        },
        {
          adult: false,
          gender: 2,
          id: 2040407,
          known_for_department: 'Visual Effects',
          name: 'Naoki Kobayashi',
          original_name: 'Naoki Kobayashi',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5fc8921bdcf875003f3e5796',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2044662,
          known_for_department: 'Art',
          name: 'Hisako Saitou',
          original_name: 'Hisako Saitou',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60b6277aabf8e2004214fadf',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 2044744,
          known_for_department: 'Visual Effects',
          name: 'Yuko Matsui',
          original_name: 'Yuko Matsui',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f9549a64c1006e26a097',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 1,
          id: 2044744,
          known_for_department: 'Visual Effects',
          name: 'Yuko Matsui',
          original_name: 'Yuko Matsui',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f0c585702e002918bf19',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2044744,
          known_for_department: 'Visual Effects',
          name: 'Yuko Matsui',
          original_name: 'Yuko Matsui',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8fa11c6006d004137721a',
          department: 'Art',
          job: 'Art Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2044763,
          known_for_department: 'Visual Effects',
          name: 'Tomoyo Nishida',
          original_name: 'Tomoyo Nishida',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f5e785702e00580bc00d',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 2135167,
          known_for_department: 'Directing',
          name: 'Kenji Imura',
          original_name: 'Kenji Imura',
          popularity: 1.09,
          profile_path: null,
          credit_id: '60a8ea590398ab0029b3e4e7',
          department: 'Directing',
          job: 'Second Unit Director',
        },
        {
          adult: false,
          gender: 2,
          id: 2135201,
          known_for_department: 'Art',
          name: 'Yoshikazu Fukutome',
          original_name: 'Yoshikazu Fukutome',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09d2f5aba32005e4ce216',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 2135315,
          known_for_department: 'Visual Effects',
          name: 'Yoshie Hayashi',
          original_name: 'Yoshie Hayashi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f3dc0398ab00578d82a2',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2159511,
          known_for_department: 'Art',
          name: 'Hisako Akagi',
          original_name: 'Hisako Akagi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09cffcf1afd002a494fef',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 2159515,
          known_for_department: 'Visual Effects',
          name: 'Akira Honma',
          original_name: 'Akira Honma',
          popularity: 0.98,
          profile_path: null,
          credit_id: '60a8f918501cf20040105561',
          department: 'Art',
          job: 'Art Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 2159516,
          known_for_department: 'Art',
          name: 'Yumi Ishii',
          original_name: 'Yumi Ishii',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09d390f21c6002ac42007',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2159654,
          known_for_department: 'Art',
          name: 'Toshie Honda',
          original_name: 'Toshie Honda',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09ca774645700465fa8d0',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 2159673,
          known_for_department: 'Visual Effects',
          name: 'Atsushi Tamura',
          original_name: 'Atsushi Tamura',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5c126c699251413543b9b0dd',
          department: 'Visual Effects',
          job: 'Animation Director',
        },
        {
          adult: false,
          gender: 2,
          id: 2159673,
          known_for_department: 'Visual Effects',
          name: 'Atsushi Tamura',
          original_name: 'Atsushi Tamura',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8e7c366e469002cf174f2',
          department: 'Visual Effects',
          job: 'Character Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 2159798,
          known_for_department: 'Art',
          name: 'Mizuka Ueda',
          original_name: 'Mizuka Ueda',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60b6a3f17cffda004068f21d',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 2160299,
          known_for_department: 'Art',
          name: 'Shinsuke Kinoshita',
          original_name: 'Shinsuke Kinoshita',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09d28ab1bc70047bd0508',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 2160401,
          known_for_department: 'Art',
          name: 'Yu Tajima',
          original_name: 'Yu Tajima',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61847c82e7414600438b61cf',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2160464,
          known_for_department: 'Art',
          name: 'Yuna Murooka',
          original_name: 'Yuna Murooka',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60b69a10c740d900424e3cf4',
          department: 'Art',
          job: 'Assistant Art Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2160464,
          known_for_department: 'Art',
          name: 'Yuna Murooka',
          original_name: 'Yuna Murooka',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60b69a2da055ef0057fd4a83',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 2160465,
          known_for_department: 'Art',
          name: 'Minako Shimada',
          original_name: 'Minako Shimada',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09c6d87e63e005d5cf6f0',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2160486,
          known_for_department: 'Visual Effects',
          name: 'Jumi Lee',
          original_name: 'Jumi Lee',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8fa06d8cc4a0029d1f98e',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 0,
          id: 2160486,
          known_for_department: 'Visual Effects',
          name: 'Jumi Lee',
          original_name: 'Jumi Lee',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8fa02501cf200593118ae',
          department: 'Art',
          job: 'Art Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2160514,
          known_for_department: 'Art',
          name: 'Toshihiko Goto',
          original_name: 'Toshihiko Goto',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09c99a579f90074634026',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2160520,
          known_for_department: 'Art',
          name: 'Akira Hirosawa',
          original_name: 'Akira Hirosawa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09c7468b1ea00808c4643',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2160533,
          known_for_department: 'Art',
          name: 'Kaori Izumiya',
          original_name: 'Kaori Izumiya',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09c82706e560074169787',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 2160536,
          known_for_department: 'Art',
          name: 'Sachiko Kadono',
          original_name: 'Sachiko Kadono',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09ce2cb75d1007ea3ffe4',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 2160547,
          known_for_department: 'Visual Effects',
          name: 'Misato Kishino',
          original_name: 'Misato Kishino',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f660501cf20059311521',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 2160549,
          known_for_department: 'Art',
          name: 'Mariko Kohara',
          original_name: 'Mariko Kohara',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09c8b706e56007416978c',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2160556,
          known_for_department: 'Art',
          name: 'Masae Kurosawa',
          original_name: 'Masae Kurosawa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09cf1706e560045c6be65',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 2160565,
          known_for_department: 'Visual Effects',
          name: 'Yuka Matsumura',
          original_name: 'Yuka Matsumura',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f63a9a64c10058c5135f',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2160566,
          known_for_department: 'Visual Effects',
          name: 'Emi Matsunaga',
          original_name: 'Emi Matsunaga',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f1a20398ab00578d80ce',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 2160571,
          known_for_department: 'Visual Effects',
          name: 'Ryosuke Mizuno',
          original_name: 'Ryosuke Mizuno',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f1f8c6006d00704ab848',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 2160576,
          known_for_department: 'Art',
          name: 'Kenta Nakajima',
          original_name: 'Kenta Nakajima',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09c93ab1bc7002a4997be',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 2160577,
          known_for_department: 'Art',
          name: 'Eriko Nakamura',
          original_name: 'Eriko Nakamura',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09c8fcf1afd002a494ef3',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2160582,
          known_for_department: 'Art',
          name: 'Mirai Saito',
          original_name: 'Mirai Saito',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09ca187e63e004600f68a',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2160612,
          known_for_department: 'Visual Effects',
          name: 'Asahi Takeuchi',
          original_name: 'Asahi Takeuchi',
          popularity: 0.98,
          profile_path: null,
          credit_id: '60a8f45a85b10500593ca684',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 2160616,
          known_for_department: 'Art',
          name: 'Kaoru Takino',
          original_name: 'Kaoru Takino',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09c7fcb75d1005d8d9532',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2160627,
          known_for_department: 'Art',
          name: 'Yuho Tomozawa',
          original_name: 'Yuho Tomozawa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09c5b68b1ea0046e55301',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 2160630,
          known_for_department: 'Art',
          name: 'Leonardo Ken Usami',
          original_name: 'Leonardo Ken Usami',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60b6a207a055ef0057fd5283',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2160635,
          known_for_department: 'Visual Effects',
          name: 'Sanae Yamamoto',
          original_name: 'Sanae Yamamoto',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8e4ee7f2d4a005bb2cbc2',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 2160647,
          known_for_department: 'Sound',
          name: 'Sayoko Narukawa',
          original_name: 'Sayoko Narukawa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8eff385b105002a9d882a',
          department: 'Sound',
          job: 'Music Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 2211079,
          known_for_department: 'Visual Effects',
          name: 'Hidetsugu Ito',
          original_name: 'Hidetsugu Ito',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8eb6b501cf20059310c75',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 2211079,
          known_for_department: 'Visual Effects',
          name: 'Hidetsugu Ito',
          original_name: 'Hidetsugu Ito',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f90b66e4690043cc59aa',
          department: 'Art',
          job: 'Art Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 2263057,
          known_for_department: 'Visual Effects',
          name: 'Yuriko Ishii',
          original_name: 'Yuriko Ishii',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fa3cb8371ffdf0042d71c01',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2292375,
          known_for_department: 'Art',
          name: 'Minami Kasuga',
          original_name: 'Minami Kasuga',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09cb9e55937002a506210',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 2397288,
          known_for_department: 'Art',
          name: 'Hirofumi Sakagami',
          original_name: 'Hirofumi Sakagami',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09d13746457002fd1cf6a',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 2419817,
          known_for_department: 'Production',
          name: 'Wakana Okamura',
          original_name: 'Wakana Okamura',
          popularity: 0.6,
          profile_path: null,
          credit_id: '616e96696d4c97009200a907',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 2475019,
          known_for_department: 'Visual Effects',
          name: 'Keita Nagahara',
          original_name: 'Keita Nagahara',
          popularity: 0.98,
          profile_path: null,
          credit_id: '6041219296670e0028f3762a',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 2498259,
          known_for_department: 'Visual Effects',
          name: 'Yuuga Tokuno',
          original_name: 'Yuuga Tokuno',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f2008dbc33005996e29b',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 2498259,
          known_for_department: 'Visual Effects',
          name: 'Yuuga Tokuno',
          original_name: 'Yuuga Tokuno',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8ea379a64c10058c50a4a',
          department: 'Directing',
          job: 'Second Unit Director',
        },
        {
          adult: false,
          gender: 2,
          id: 2594173,
          known_for_department: 'Art',
          name: 'Daiki Kuribayashi',
          original_name: 'Daiki Kuribayashi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09cc3cb75d1005d8d959c',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2777787,
          known_for_department: 'Visual Effects',
          name: 'Zhu Xiaoyue',
          original_name: 'Zhu Xiaoyue',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f8e88dbc330041a34964',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 2790226,
          known_for_department: 'Visual Effects',
          name: 'Saeko Ozawa',
          original_name: 'Saeko Ozawa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f455d8cc4a0029d1f534',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 2797511,
          known_for_department: 'Visual Effects',
          name: 'Yuki Hayashi',
          original_name: 'Yuki Hayashi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f4768dbc33005996e474',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 2797750,
          known_for_department: 'Art',
          name: 'Kim Jeong-ryeon',
          original_name: 'Kim Jeong-ryeon',
          popularity: 0.98,
          profile_path: null,
          credit_id: '60f09cf7ab1bc7005e3b43ea',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 2870829,
          known_for_department: 'Visual Effects',
          name: 'Rena Ono',
          original_name: 'Rena Ono',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fbfa7759c97bd003fa29cca',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 2882935,
          known_for_department: 'Visual Effects',
          name: 'Mamoru Otake',
          original_name: 'Mamoru Otake',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f5f8501cf20078c6042f',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 2896255,
          known_for_department: 'Art',
          name: 'Yuki Funagakure',
          original_name: 'Yuki Funagakure',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09c9dcb75d1007ea3ff57',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2961592,
          known_for_department: 'Visual Effects',
          name: 'Hiroo Nagano',
          original_name: 'Hiroo Nagano',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f8ee501cf20026d3d975',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 2992883,
          known_for_department: 'Visual Effects',
          name: 'Kazumasa Ishikawa',
          original_name: 'Kazumasa Ishikawa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f8b78dbc330041a34947',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 3025738,
          known_for_department: 'Visual Effects',
          name: 'Luke Asuka Okamoto',
          original_name: 'Luke Asuka Okamoto',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6s55OeCg6iZYWqsV3ryJw2thUrF.jpg',
          credit_id: '605ddcb6435011003d060016',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 3028245,
          known_for_department: 'Art',
          name: 'Shingo Kanai',
          original_name: 'Shingo Kanai',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09cbdf3e0df002ce9d077',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 3036073,
          known_for_department: 'Visual Effects',
          name: 'Kouta Mori',
          original_name: 'Kouta Mori',
          popularity: 0.6,
          profile_path: null,
          credit_id: '606890721e9225002b60224c',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 3070799,
          known_for_department: 'Art',
          name: 'Kinichi Okubo',
          original_name: 'Kinichi Okubo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09d2ccf1afd005efcee13',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 3076266,
          known_for_department: 'Visual Effects',
          name: 'Masahiro Sato',
          original_name: 'Masahiro Sato',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f1ef9a64c1002967036b',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 3077210,
          known_for_department: 'Visual Effects',
          name: 'Tatsuya Sakurai',
          original_name: 'Tatsuya Sakurai',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608fa743a199a6002985e2bf',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 3077264,
          known_for_department: 'Visual Effects',
          name: 'Kazuki Chiba',
          original_name: 'Kazuki Chiba',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f7e285702e006eef9325',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 3099273,
          known_for_department: 'Crew',
          name: 'Masayoshi Sugai',
          original_name: 'Masayoshi Sugai',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f0229a64c10058c50e55',
          department: 'Crew',
          job: 'Mixing Engineer',
        },
        {
          adult: false,
          gender: 2,
          id: 3099276,
          known_for_department: 'Visual Effects',
          name: 'Shigehito Tsuji',
          original_name: 'Shigehito Tsuji',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f2168dbc3300282bbfec',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 3099290,
          known_for_department: 'Visual Effects',
          name: 'Ryouichi Kaida',
          original_name: 'Ryouichi Kaida',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f5889a64c10040bbc18e',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 3099291,
          known_for_department: 'Visual Effects',
          name: 'Yoshiyuki Saotome',
          original_name: 'Yoshiyuki Saotome',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f5bed8cc4a007792469b',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 3099294,
          known_for_department: 'Visual Effects',
          name: 'Hiroko Yasutome',
          original_name: 'Hiroko Yasutome',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f6867f4f21002a8fdf0e',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 3099295,
          known_for_department: 'Visual Effects',
          name: 'Ai Nakanishi',
          original_name: 'Ai Nakanishi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f6a8d8cc4a0057423b06',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 3099304,
          known_for_department: 'Visual Effects',
          name: 'Yukari Kaku',
          original_name: 'Yukari Kaku',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f7c8d8cc4a0057423c28',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 0,
          id: 3099310,
          known_for_department: 'Visual Effects',
          name: 'Masaki Hiraoka',
          original_name: 'Masaki Hiraoka',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f80266e4690043cc5889',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 3099313,
          known_for_department: 'Visual Effects',
          name: 'Tomoe Kikuchi',
          original_name: 'Tomoe Kikuchi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f81dd8cc4a0057423c7a',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 1,
          id: 3099317,
          known_for_department: 'Visual Effects',
          name: 'Chie Tanaka',
          original_name: 'Chie Tanaka',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f89566e469002cf18138',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 3099318,
          known_for_department: 'Visual Effects',
          name: 'Takahiro Yamakita',
          original_name: 'Takahiro Yamakita',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60a8f8c79a64c10058c515dd',
          department: 'Visual Effects',
          job: 'Key Animation',
        },
        {
          adult: false,
          gender: 2,
          id: 3110680,
          known_for_department: 'Art',
          name: 'Hiroshi Nakamura',
          original_name: 'Hiroshi Nakamura',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60b6239ec740d90079daf134',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3110691,
          known_for_department: 'Art',
          name: 'Taketo Gonpei',
          original_name: 'Taketo Gonpei',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60b6255adfaae90040687f94',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3110694,
          known_for_department: 'Art',
          name: 'Nerimasa Yamamoto',
          original_name: 'Nerimasa Yamamoto',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09cdfa579f9002f0ef142',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3110707,
          known_for_department: 'Art',
          name: 'Jun Osano',
          original_name: 'Jun Osano',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60b62a6b899da2002b24458b',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3111111,
          known_for_department: 'Art',
          name: 'Kazuki Niwa',
          original_name: 'Kazuki Niwa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60b69a9aefd3c20059bedf27',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3111131,
          known_for_department: 'Art',
          name: 'Tram Anh Nguyen',
          original_name: 'Tram Anh Nguyen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60b69e616dea3a005896e681',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3111133,
          known_for_department: 'Art',
          name: 'Nguyen Ngoc Thanh',
          original_name: 'Nguyen Ngoc Thanh',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60b69e6f899da2004247e1d5',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3111142,
          known_for_department: 'Art',
          name: 'Phan Diem Trang',
          original_name: 'Phan Diem Trang',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60b69f38efd3c20041e0276b',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3111150,
          known_for_department: 'Art',
          name: 'Tran Hoang Bao Vy',
          original_name: 'Tran Hoang Bao Vy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60b69f286905fb00295fe18a',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3111151,
          known_for_department: 'Art',
          name: 'Attachai Boonsamai',
          original_name: 'Attachai Boonsamai',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60b69fb9a06645002a56951f',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3111159,
          known_for_department: 'Art',
          name: 'Rungrat Khankaew',
          original_name: 'Rungrat Khankaew',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60b6a0afefd3c20059bee61b',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3111163,
          known_for_department: 'Art',
          name: 'Mineaki Sugata',
          original_name: 'Mineaki Sugata',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60b6a1115c56340040699e83',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3113750,
          known_for_department: 'Art',
          name: 'Tomoya Asami',
          original_name: 'Tomoya Asami',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09d0dab1bc7002a49986b',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3159137,
          known_for_department: 'Art',
          name: 'Bicester Singa',
          original_name: 'Bicester Singa',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09bc8706e56005d5e0bb4',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3159140,
          known_for_department: 'Art',
          name: 'Chie Akitake',
          original_name: 'Chie Akitake',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09cbca579f9002f0ef0d6',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3159142,
          known_for_department: 'Art',
          name: 'Nguyen Quoc',
          original_name: 'Nguyen Quoc',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f09cde5aba32005e4ce12d',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3167195,
          known_for_department: 'Art',
          name: 'Ngoc Tho',
          original_name: 'Ngoc Tho',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f92d5e07e28100467a8a05',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3167197,
          known_for_department: 'Art',
          name: 'Thu Yen',
          original_name: 'Thu Yen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60f92d4cf056d5005e70859f',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 2,
          id: 3179914,
          known_for_department: 'Art',
          name: 'Chihiro Okawa',
          original_name: 'Chihiro Okawa',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6KRsGiOWCpOVfl08IWrHUwPGmUN.jpg',
          credit_id: '610424094284ea210e464e3f',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 3209929,
          known_for_department: 'Art',
          name: 'Miyoshi Makiya',
          original_name: 'Miyoshi Makiya',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6123fbd9b458b80073acb11c',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 3212165,
          known_for_department: 'Sound',
          name: 'Kurumi Tamura',
          original_name: 'Kurumi Tamura',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6126644b8741c4008a49724c',
          department: 'Sound',
          job: 'Sound Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 3212166,
          known_for_department: 'Sound',
          name: 'Rio Sato',
          original_name: 'Rio Sato',
          popularity: 0.6,
          profile_path: null,
          credit_id: '612664764e67420044bf107e',
          department: 'Sound',
          job: 'Sound Effects',
        },
        {
          adult: false,
          gender: 1,
          id: 3212168,
          known_for_department: 'Sound',
          name: 'Airi Kobayashi',
          original_name: 'Airi Kobayashi',
          popularity: 0.6,
          profile_path: null,
          credit_id: '612664997eb5f200684443fd',
          department: 'Sound',
          job: 'Sound Effects',
        },
        {
          adult: false,
          gender: 1,
          id: 3217409,
          known_for_department: 'Art',
          name: 'Maiko Ikeda',
          original_name: 'Maiko Ikeda',
          popularity: 0.6,
          profile_path: null,
          credit_id: '612d54b0223e200045776b5c',
          department: 'Art',
          job: 'Background Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 3276309,
          known_for_department: 'Production',
          name: 'Kinue Itou',
          original_name: 'Kinue Itou',
          popularity: 0.6,
          profile_path: null,
          credit_id: '616e968190dde00066848713',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 3276312,
          known_for_department: 'Production',
          name: 'Kazuki Sunami',
          original_name: 'Kazuki Sunami',
          popularity: 0.6,
          profile_path: null,
          credit_id: '616e97cfbf09d1008f20c96f',
          department: 'Production',
          job: 'Associate Producer',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'sykobanana',
          author_details: {
            name: '',
            username: 'sykobanana',
            avatar_path: '/j2KpvD880J95lqf3ct4u1MmWZhE.jpg',
            rating: 9.0,
          },
          content:
            'Starting off as a slow burn, I started questioning how this anime got so much talk on the net.  But the pace lets you get to know and relate to the characters before the final act where things really spring forth.  And I was sucked in (enjoyably) for the ride, holding my breath as I honestly did not know how it was going to end.  \r\n\r\nBeautiful, gorgeous, etherial at times, there just arent enough words in the English language to describe appropriately just how stunning this is...nor how seamlessly the traditional and 3D animation blend together.  \r\n\r\nThe voice cast of both languages are great and the soundtrack and score are both great.  \r\n\r\nAfter The Garden of Words and Your Name, Makoto Shinkai is proving to be a master of his craft in the same vein as Miyazaki.  A classic.',
          created_at: '2021-07-05T10:14:29.378Z',
          id: '60e2db85caa5080060ed7027',
          updated_at: '2021-07-05T10:14:29.378Z',
          url: 'https://www.themoviedb.org/review/60e2db85caa5080060ed7027',
        },
      ],
      total_pages: 1,
      total_results: 1,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/2g4cXP5ozwmHlETU6BADv01xVGj.jpg',
    belongs_to_collection: null,
    budget: 28000000,
    genres: [
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 53, name: 'Phim Gây Cấn' },
    ],
    homepage: '',
    id: 162903,
    imdb_id: 'tt1837703',
    original_language: 'en',
    original_title: 'The Fifth Estate',
    overview:
      'Mối quan hệ giữa Daniel Domscheit-Berg ( Daniel Brühl ) và Julian Assange ( Benedict Cumberbatch ) khi mô phỏng lại những ngày đầu của WikiLeaks với đỉnh điểm là việc tiết lộ hàng loạt những thông tin chấn động lịch sử gây tranh cãi.',
    popularity: 9.779,
    poster_path:
      'https://image.tmdb.org/t/p/w342/1dzLHy1AN8hgppJp1LDzMI4fbHY.jpg',
    production_companies: [
      {
        id: 6735,
        logo_path: '/pAQW38WU8ychBvYU2aGPTEbynEN.png',
        name: 'Participant',
        origin_country: 'US',
      },
      {
        id: 7294,
        logo_path: '/kK4PRgceWp9KNrycD8xx8seWxYU.png',
        name: 'Reliance Entertainment',
        origin_country: 'IN',
      },
      {
        id: 9195,
        logo_path: '/ou5BUbtulr6tIt699q6xJiEQTR9.png',
        name: 'Touchstone Pictures',
        origin_country: 'US',
      },
      {
        id: 10039,
        logo_path: '/b8w4LldQolMKiLZw4FQJBcXSDGI.png',
        name: 'Anonymous Content',
        origin_country: 'US',
      },
      {
        id: 7,
        logo_path: '/vru2SssLX3FPhnKZGtYw00pVIS9.png',
        name: 'DreamWorks Pictures',
        origin_country: 'US',
      },
    ],
    production_countries: [
      { iso_3166_1: 'IN', name: 'India' },
      { iso_3166_1: 'BE', name: 'Belgium' },
      { iso_3166_1: 'US', name: 'Hoa Kì' },
    ],
    release_date: '2013-10-11',
    revenue: 8555008,
    runtime: 128,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: "You can't expose the world's secrets without exposing yourself",
    title: 'Quyền Lực Thứ Năm',
    video: false,
    vote_average: 6.0,
    vote_count: 795,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'THE FIFTH ESTATE Official Trailer',
          key: 'ZT1wb8_tcYU',
          published_at: '2013-07-17T04:00:04.000Z',
          site: 'YouTube',
          size: 720,
          type: 'Trailer',
          official: false,
          id: '533ec6ffc3a3685448009edd',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 71580,
          known_for_department: 'Diễn viên',
          name: 'Benedict Cumberbatch',
          original_name: 'Benedict Cumberbatch',
          popularity: 34.514,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fBEucxECxGLKVHBznO0qHtCGiMO.jpg',
          cast_id: 1,
          character: 'Julian Assange',
          credit_id: '52fe4c60c3a36847f822b10b',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 3872,
          known_for_department: 'Diễn viên',
          name: 'Daniel Brühl',
          original_name: 'Daniel Brühl',
          popularity: 4.127,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3YlmTfiy5qZXkrdKGjaM1uMjGKP.jpg',
          cast_id: 3,
          character: 'Daniel Domscheit-Berg',
          credit_id: '52fe4c60c3a36847f822b113',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 53650,
          known_for_department: 'Diễn viên',
          name: 'Anthony Mackie',
          original_name: 'Anthony Mackie',
          popularity: 7.002,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kfTwOYr3iUucmYz8kPjhYy07G2Z.jpg',
          cast_id: 24,
          character: 'Sam Coulson',
          credit_id: '5580f82a92514144aa000efd',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 11207,
          known_for_department: 'Diễn viên',
          name: 'David Thewlis',
          original_name: 'David Thewlis',
          popularity: 8.7,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sNuYyT8ocLlQr3TdAW9CoKVbCU8.jpg',
          cast_id: 13,
          character: 'Nick Davies',
          credit_id: '52fe4c60c3a36847f822b141',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 227454,
          known_for_department: 'Diễn viên',
          name: 'Alicia Vikander',
          original_name: 'Alicia Vikander',
          popularity: 10.464,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9pmHTbXeRxUF51jJKthmHI49u9z.jpg',
          cast_id: 4,
          character: 'Anke Domscheit-Berg',
          credit_id: '52fe4c60c3a36847f822b117',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 221018,
          known_for_department: 'Diễn viên',
          name: 'Dan Stevens',
          original_name: 'Dan Stevens',
          popularity: 12.371,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fFsgginZKH527o38ZfdDxuzx7Ew.jpg',
          cast_id: 2,
          character: 'Ian Katz',
          credit_id: '52fe4c60c3a36847f822b10f',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 2283,
          known_for_department: 'Diễn viên',
          name: 'Stanley Tucci',
          original_name: 'Stanley Tucci',
          popularity: 12.244,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7wPPKi7djQfNc9NLVJvhBmoZ26U.jpg',
          cast_id: 11,
          character: 'James Boswell',
          credit_id: '52fe4c60c3a36847f822b139',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 350,
          known_for_department: 'Diễn viên',
          name: 'Laura Linney',
          original_name: 'Laura Linney',
          popularity: 5.493,
          profile_path:
            'https://image.tmdb.org/t/p/w185/h6i3fZoFuKxDZ4u29wZnjJ2r5Tq.jpg',
          cast_id: 12,
          character: 'Sarah Shaw',
          credit_id: '52fe4c60c3a36847f822b13d',
          order: 7,
        },
        {
          adult: false,
          gender: 1,
          id: 23229,
          known_for_department: 'Diễn viên',
          name: 'Carice van Houten',
          original_name: 'Carice van Houten',
          popularity: 5.878,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wcyc5upHVhIF9cl1DrWgjlmKWSX.jpg',
          cast_id: 5,
          character: 'Birgitta Jonsdottir',
          credit_id: '52fe4c60c3a36847f822b11b',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 12982,
          known_for_department: 'Diễn viên',
          name: 'Peter Capaldi',
          original_name: 'Peter Capaldi',
          popularity: 2.181,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wcsd1tMVFjgplfZlTUfb7fiD2zP.jpg',
          cast_id: 6,
          character: 'Alan Rusbridger',
          credit_id: '52fe4c60c3a36847f822b11f',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 677,
          known_for_department: 'Diễn viên',
          name: 'Moritz Bleibtreu',
          original_name: 'Moritz Bleibtreu',
          popularity: 2.325,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uWAtkeIRE4I1EnkWw44Qhhi1Tx0.jpg',
          cast_id: 20,
          character: 'Marcus',
          credit_id: '52fe4c60c3a36847f822b163',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 4796,
          known_for_department: 'Diễn viên',
          name: 'Alexander Beyer',
          original_name: 'Alexander Beyer',
          popularity: 1.729,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xuD0crcNa6gViFShvFCsY1ZOgLW.jpg',
          cast_id: 21,
          character: 'Marcel Rosenbach',
          credit_id: '52fe4c60c3a36847f822b167',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 221985,
          known_for_department: 'Diễn viên',
          name: 'Jamie Blackley',
          original_name: 'Jamie Blackley',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3Ru1099xez4YEnsEMCmtpTqK9JI.jpg',
          cast_id: 7,
          character: 'Ziggy',
          credit_id: '52fe4c60c3a36847f822b123',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 62892,
          known_for_department: 'Diễn viên',
          name: 'Anatole Taubman',
          original_name: 'Anatole Taubman',
          popularity: 2.276,
          profile_path:
            'https://image.tmdb.org/t/p/w185/A7B7POXpFyNg7C36fGxVc4EiR2W.jpg',
          cast_id: 23,
          character: 'Holger Stark',
          credit_id: '5580f7d2c3a3681651000e18',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 8445,
          known_for_department: 'Diễn viên',
          name: 'Michael Culkin',
          original_name: 'Michael Culkin',
          popularity: 0.696,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eUTAyHEEKE3ZVVqKuEiPG8APU14.jpg',
          cast_id: 30,
          character: 'Ralph Zilke',
          credit_id: '58bdf854c3a368668604aa87',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 2957,
          known_for_department: 'Diễn viên',
          name: 'Alexander Siddig',
          original_name: 'Alexander Siddig',
          popularity: 5.621,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fpriiMtXCqG74iALsr9uK8iyDbp.jpg',
          cast_id: 34,
          character: 'Dr. Tarek Haliseh',
          credit_id: '58bdf898c3a368663004d902',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 1643968,
          known_for_department: 'Diễn viên',
          name: 'Michael Kranz',
          original_name: 'Michael Kranz',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9WioDLqhY0eUG96ytxXkNuH8nej.jpg',
          cast_id: 29,
          character: 'Otto',
          credit_id: '58bdf8359251416084055423',
          order: 16,
        },
        {
          adult: false,
          gender: 2,
          id: 36010,
          known_for_department: 'Diễn viên',
          name: 'Axel Milberg',
          original_name: 'Axel Milberg',
          popularity: 2.554,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eK1Kkda8rOZMgo5BYBUVeYenOwj.jpg',
          cast_id: 31,
          character: 'Hans',
          credit_id: '58bdf85ec3a3680df8006a65',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 1212897,
          known_for_department: 'Diễn viên',
          name: 'Philip Bretherton',
          original_name: 'Philip Bretherton',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bmAjtjAzCtqDT8yprjNV4Jr50q7.jpg',
          cast_id: 28,
          character: 'Bill Keller',
          credit_id: '58bdf82bc3a3680db1006b9b',
          order: 18,
        },
        {
          adult: false,
          gender: 0,
          id: 1771323,
          known_for_department: 'Diễn viên',
          name: 'Joseph Kinyua Muriuki',
          original_name: 'Joseph Kinyua Muriuki',
          popularity: 0.6,
          profile_path: null,
          cast_id: 32,
          character: 'John Paul Oulu',
          credit_id: '58bdf86fc3a368668f04792f',
          order: 19,
        },
        {
          adult: false,
          gender: 0,
          id: 1771324,
          known_for_department: 'Diễn viên',
          name: 'Peter King Nzioki',
          original_name: 'Peter King Nzioki',
          popularity: 0.6,
          profile_path: null,
          cast_id: 33,
          character: 'Oscar Kamau Kingara',
          credit_id: '58bdf87c925141126a036b73',
          order: 20,
        },
        {
          adult: false,
          gender: 1,
          id: 82807,
          known_for_department: 'Diễn viên',
          name: 'Lydia Leonard',
          original_name: 'Lydia Leonard',
          popularity: 4.411,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wG4IodO3kkROpHDa2JTepfuYAzc.jpg',
          cast_id: 35,
          character: 'Alex Lang',
          credit_id: '58bdf8a39251413435006adf',
          order: 21,
        },
        {
          adult: false,
          gender: 0,
          id: 1771325,
          known_for_department: 'Diễn viên',
          name: 'Amir Boutrous',
          original_name: 'Amir Boutrous',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rtIdTRX7Pn7JY073FZN99DrWiu.jpg',
          cast_id: 36,
          character: 'Mutassim Al-Gaddafi',
          credit_id: '58bdf8b8c3a3680d680064d9',
          order: 22,
        },
        {
          adult: false,
          gender: 1,
          id: 1198815,
          known_for_department: 'Diễn viên',
          name: 'Mimi Ferrer',
          original_name: 'Mimi Ferrer',
          popularity: 0.6,
          profile_path: null,
          cast_id: 37,
          character: 'Shida Haliseh',
          credit_id: '58bdf8c59251416084055482',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 1113789,
          known_for_department: 'Diễn viên',
          name: 'Gudmundur Thorvaldsson',
          original_name: 'Gudmundur Thorvaldsson',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bb0WgMKxnH0XuP8jgPIOw4QDZNN.jpg',
          cast_id: 26,
          character: 'WikiLeaks Staffer #1',
          credit_id: '58bdf6fac3a3680db1006b15',
          order: 24,
        },
        {
          adult: false,
          gender: 1,
          id: 586286,
          known_for_department: 'Diễn viên',
          name: 'Hera Hilmar',
          original_name: 'Hera Hilmar',
          popularity: 11.436,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hUgQJYayUWt3zON9COn0f7RVJxF.jpg',
          cast_id: 27,
          character: 'Wikileaks Staffer #2',
          credit_id: '58bdf709c3a3680db1006b1a',
          order: 25,
        },
        {
          adult: false,
          gender: 2,
          id: 29697,
          known_for_department: 'Diễn viên',
          name: 'Nigel Whitmey',
          original_name: 'Nigel Whitmey',
          popularity: 0.759,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gWAesPayT4moGtSmWCKBmad9Hl2.jpg',
          cast_id: 38,
          character: 'General Thomason',
          credit_id: '5a27501692514103390f76e7',
          order: 26,
        },
        {
          adult: false,
          gender: 1,
          id: 38809,
          known_for_department: 'Diễn viên',
          name: 'Camilla Rutherford',
          original_name: 'Camilla Rutherford',
          popularity: 1.414,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rVoFC3VLv5JWsBN0mlyTLrF1Zg5.jpg',
          cast_id: 39,
          character: 'Guardian Lawyer',
          credit_id: '5a27502a92514103260ff106',
          order: 27,
        },
        {
          adult: false,
          gender: 2,
          id: 1088,
          known_for_department: 'Diễn viên',
          name: 'Ludger Pistor',
          original_name: 'Ludger Pistor',
          popularity: 1.619,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pixOQw3AM7XhOR6fjSoP6L3ml0g.jpg',
          cast_id: 40,
          character: 'Supervisor',
          credit_id: '5d764b3e12970c000f9bb719',
          order: 28,
        },
        {
          adult: false,
          gender: 0,
          id: 3043559,
          known_for_department: 'Diễn viên',
          name: 'Ben Rook',
          original_name: 'Ben Rook',
          popularity: 0.6,
          profile_path: null,
          cast_id: 60,
          character: 'Julian Assange jeune',
          credit_id: '606f0a93befd91006eea2df6',
          order: 29,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 322,
          known_for_department: 'Production',
          name: 'Steve Golin',
          original_name: 'Steve Golin',
          popularity: 1.385,
          profile_path: null,
          credit_id: '52fe4c60c3a36847f822b12f',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1225,
          known_for_department: 'Sound',
          name: 'Carter Burwell',
          original_name: 'Carter Burwell',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5f24e8972ac49900365f3264',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 2071,
          known_for_department: 'Art',
          name: 'Mark Tildesley',
          original_name: 'Mark Tildesley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f24e8b76f31af00359c89ea',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 2,
          id: 10684,
          known_for_department: 'Production',
          name: 'Jonathan King',
          original_name: 'Jonathan King',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/v9jHbrlUXxxz5BazZaaWpAIQCSU.jpg',
          credit_id: '5f24e94b869e75003658a1b7',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 15557,
          known_for_department: 'Directing',
          name: 'Bill Condon',
          original_name: 'Bill Condon',
          popularity: 2.331,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zgqg8ZS1JN2WJq141dbgTwtPbyx.jpg',
          credit_id: '52fe4c60c3a36847f822b129',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 15559,
          known_for_department: 'Camera',
          name: 'Tobias A. Schliessler',
          original_name: 'Tobias A. Schliessler',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5f24e8c16f31af00359c89f4',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 1,
          id: 15560,
          known_for_department: 'Editing',
          name: 'Virginia Katz',
          original_name: 'Virginia Katz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f24e8abdfaae90034a0b319',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 19971,
          known_for_department: 'Costume & Make-Up',
          name: 'Shay Cunliffe',
          original_name: 'Shay Cunliffe',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f24e8a2168ea30037b6db30',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 1,
          id: 19773,
          known_for_department: 'Art',
          name: 'Véronique Melery',
          original_name: 'Véronique Melery',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f24e9ce6f31af00359c8d38',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 1,
          id: 23424,
          known_for_department: 'Production',
          name: 'Lucy Bevan',
          original_name: 'Lucy Bevan',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5f24e96c2ac49900365f3aca',
          department: 'Production',
          job: 'Casting Director',
        },
        {
          adult: false,
          gender: 2,
          id: 26193,
          known_for_department: 'Art',
          name: 'Denis Schnegg',
          original_name: 'Denis Schnegg',
          popularity: 0.767,
          profile_path: null,
          credit_id: '5f24e9de498ef90039af2d8a',
          department: 'Art',
          job: 'Supervising Art Director',
        },
        {
          adult: false,
          gender: 0,
          id: 31519,
          known_for_department: 'Production',
          name: 'Jeff Skoll',
          original_name: 'Jeff Skoll',
          popularity: 0.764,
          profile_path: null,
          credit_id: '5f24e922f0647c0033255077',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 41331,
          known_for_department: 'Production',
          name: 'Michael Sugar',
          original_name: 'Michael Sugar',
          popularity: 1.4,
          profile_path: null,
          credit_id: '52fe4c60c3a36847f822b135',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 90593,
          known_for_department: 'Production',
          name: 'Paul Green',
          original_name: 'Paul Green',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f24e9116f31af00379a7e9b',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 150883,
          known_for_department: 'Biên kịch',
          name: 'Daniel Domscheidt-Berg',
          original_name: 'Daniel Domscheidt-Berg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f24e7e92ac499003560a71c',
          department: 'Biên kịch',
          job: 'Book',
        },
        {
          adult: false,
          gender: 2,
          id: 1105636,
          known_for_department: 'Production',
          name: 'Richard Sharkey',
          original_name: 'Richard Sharkey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4c60c3a36847f822b15f',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1172246,
          known_for_department: 'Biên kịch',
          name: 'Luke Harding',
          original_name: 'Luke Harding',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f24e85b168ea30036b59d82',
          department: 'Biên kịch',
          job: 'Book',
        },
        {
          adult: false,
          gender: 0,
          id: 1172247,
          known_for_department: 'Biên kịch',
          name: 'David Leigh',
          original_name: 'David Leigh',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f24e84d2ac49900345e5a64',
          department: 'Biên kịch',
          job: 'Book',
        },
        {
          adult: false,
          gender: 2,
          id: 1219529,
          known_for_department: 'Biên kịch',
          name: 'Josh Singer',
          original_name: 'Josh Singer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '566c2a31c3a36833b600828d',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 0,
          id: 1394001,
          known_for_department: 'Art',
          name: 'Katrina Mackay',
          original_name: 'Katrina Mackay',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5f24eaa3869e75003658ab05',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 1,
          id: 1428470,
          known_for_department: 'Costume & Make-Up',
          name: 'Christine Blundell',
          original_name: 'Christine Blundell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f24eb04f0647c0035248c18',
          department: 'Costume & Make-Up',
          job: 'Hair Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 1428470,
          known_for_department: 'Costume & Make-Up',
          name: 'Christine Blundell',
          original_name: 'Christine Blundell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f24eafa498ef90039af304a',
          department: 'Costume & Make-Up',
          job: 'Makeup Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2025728,
          known_for_department: 'Art',
          name: 'Toon Marien',
          original_name: 'Toon Marien',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f24ea7edfaae90034a0b6ca',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 2728219,
          known_for_department: 'Art',
          name: 'Emmanuelle Lelong',
          original_name: 'Emmanuelle Lelong',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f24ea8a2ac49900365f3e12',
          department: 'Art',
          job: 'Art Direction',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'Fixyf',
          author_details: {
            name: '',
            username: 'Fixyf',
            avatar_path: null,
            rating: null,
          },
          content:
            'Oh, I wonder how soon they will make a film about our time and everything that happens with data security now? It’s just a nightmare, my guy insisted that I delete Telegram and download Utopia p2p, because Telegrams are often tried to be hacked. But Cumberbatch is handsome',
          created_at: '2020-02-11T11:09:37.832Z',
          id: '5e428b7141465c0014cf1624',
          updated_at: '2021-06-23T15:58:33.896Z',
          url: 'https://www.themoviedb.org/review/5e428b7141465c0014cf1624',
        },
      ],
      total_pages: 1,
      total_results: 1,
    },
  },
  {
    adult: false,
    backdrop_path: null,
    belongs_to_collection: null,
    budget: 0,
    genres: [{ id: 28, name: 'Phim Hành Động' }],
    homepage: '',
    id: 719515,
    imdb_id: 'tt12719414',
    original_language: 'vi',
    original_title: 'Đỉnh Mù Sương',
    overview:
      'Sau cái chết đầy bất ngờ của vợ, Phi - một võ sỹ tự do quyết định trở về Việt Nam để đòi món nợ máu. Tại bản Mù Sương, anh không chỉ đối mặt với Ba Râu cùng mối thù giết vợ mà còn phát hiện hàng loạt những bí mật kinh hoàng. Ba Râu cũng chính là nỗi khiếp sợ bấy lâu nay của người dân nơi này. Số phận một lần nữa đặt Phi vào giữa lằn ranh lựa chọn: báo thù Ba Râu hay bảo vệ người dân bản Mù Sương? Và liệu Phi sẽ tìm ra được thuốc giải cho liều thuốc độc mang tên "hận thù" đang tồn tại trong chính bản thân mình?',
    popularity: 0.662,
    poster_path:
      'https://image.tmdb.org/t/p/w342/qMCO3txxxatCtAhOnzeqLcw4fI8.jpg',
    production_companies: [],
    production_countries: [],
    release_date: '2020-07-17',
    revenue: 0,
    runtime: 87,
    spoken_languages: [
      { english_name: 'Vietnamese', iso_639_1: 'vi', name: 'Tiếng Việt' },
    ],
    status: 'Đã phát hành',
    tagline: 'Có thù, báo thù, lại gây thù',
    title: 'Đỉnh Mù Sương',
    video: false,
    vote_average: 2.0,
    vote_count: 1,
    videos: { results: [] },
    credits: {
      cast: [
        {
          adult: false,
          gender: 0,
          id: 2902850,
          known_for_department: 'Diễn viên',
          name: 'Peter Pham',
          original_name: 'Peter Pham',
          popularity: 0.6,
          profile_path: null,
          cast_id: 5,
          character: 'Phi',
          credit_id: '5fe043a3bbe1dd00411fb7e0',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 1595454,
          known_for_department: 'Diễn viên',
          name: 'Kim Long Thach',
          original_name: 'Kim Long Thach',
          popularity: 0.6,
          profile_path: null,
          cast_id: 6,
          character: '',
          credit_id: '5fe044c9fb3f6100416a7bd9',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 2040630,
          known_for_department: 'Diễn viên',
          name: 'Công Ninh',
          original_name: 'Công Ninh',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7WOtGqFX6xHEsjENBExERgUePQ9.jpg',
          cast_id: 1,
          character: '',
          credit_id: '5ef77bc8e93e950033b74d5d',
          order: 2,
        },
        {
          adult: false,
          gender: 0,
          id: 2902851,
          known_for_department: 'Diễn viên',
          name: 'Pham Huy Thuc',
          original_name: 'Pham Huy Thuc',
          popularity: 0.6,
          profile_path: null,
          cast_id: 7,
          character: '',
          credit_id: '5fe044e5f706de003c8235b7',
          order: 3,
        },
        {
          adult: false,
          gender: 0,
          id: 2902853,
          known_for_department: 'Diễn viên',
          name: 'Truc May',
          original_name: 'Truc May',
          popularity: 0.6,
          profile_path: null,
          cast_id: 8,
          character: '',
          credit_id: '5fe044f9a0b690003fa3ec68',
          order: 4,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 0,
          id: 2902847,
          known_for_department: 'Directing',
          name: 'Phan Anh',
          original_name: 'Phan Anh',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe04374d70594003c2e0f5b',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2902848,
          known_for_department: 'Directing',
          name: 'Ken Dinh',
          original_name: 'Ken Dinh',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe04387eb0932003f539c23',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2902849,
          known_for_department: 'Production',
          name: 'Tran Ho Truc Duy',
          original_name: 'Tran Ho Truc Duy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5fe04393e263bb0041bdac1d',
          department: 'Production',
          job: 'Producer',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/i20UUgyMyaLNLDqJ1MKMZdNMcn7.jpg',
    belongs_to_collection: {
      id: 595390,
      name: 'ตีสาม รวมชุด',
      poster_path: '/aPTnshlFWomrzVjtRgZdikSW4X6.jpg',
      backdrop_path: null,
    },
    budget: 0,
    genres: [{ id: 27, name: 'Phim Kinh Dị' }],
    homepage: '',
    id: 178875,
    imdb_id: 'tt2563548',
    original_language: 'th',
    original_title: 'ตีสาม 3D',
    overview:
      'tác phẩm kinh dị 3D mới nhất của xưởng phim Five Star Production là tuyển tập 3 phim kinh dị ngắn với ma, quỷ và những linh hồn báo thù. Phim là tổ hợp ba câu chuyện rùng rợn khác nhau xảy ra với người bảo vệ nhà tang lễ, cô gái làm tóc giả và hai nhân viên văn phòng vào cùng một thời điểm là 3 giờ sáng được lồng ghép vào nhau. 3AM được chỉ đạo bởi 3 đạo diễn nổi tiếng và có sự tham gia của hàng loạt diễn viên hàng đầu Thái Lan.',
    popularity: 3.131,
    poster_path:
      'https://image.tmdb.org/t/p/w342/aPTnshlFWomrzVjtRgZdikSW4X6.jpg',
    production_companies: [
      {
        id: 1241,
        logo_path: '/m0pcwdXt4FgzaBtoSMfXoNucgoz.png',
        name: 'Five Star Production',
        origin_country: 'TH',
      },
    ],
    production_countries: [{ iso_3166_1: 'TH', name: 'Thailand' }],
    release_date: '2012-11-21',
    revenue: 0,
    runtime: 96,
    spoken_languages: [
      { english_name: 'Thai', iso_639_1: 'th', name: 'ภาษาไทย' },
    ],
    status: 'Đã phát hành',
    tagline: 'The scariest hour of the night',
    title: '3 Giờ Sáng',
    video: false,
    vote_average: 5.0,
    vote_count: 20,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: '3AM Trailer with eng sub (Official HD)',
          key: 'HZb3gUHGpnw',
          published_at: '2012-10-25T11:30:11.000Z',
          site: 'YouTube',
          size: 720,
          type: 'Trailer',
          official: true,
          id: '533ec706c3a368544800a42d',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 112727,
          known_for_department: 'Diễn viên',
          name: 'Apinya Sakuljaroensuk',
          original_name: 'Apinya Sakuljaroensuk',
          popularity: 2.185,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zvrljG4X28c0fPrlowxPcNqhOA3.jpg',
          cast_id: 1,
          character: 'Mint',
          credit_id: '52fe4d9dc3a36847f826aa01',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 83158,
          known_for_department: 'Diễn viên',
          name: 'Focus Jirakul',
          original_name: 'Focus Jirakul',
          popularity: 1.286,
          profile_path: null,
          cast_id: 2,
          character: 'May',
          credit_id: '52fe4d9dc3a36847f826aa05',
          order: 1,
        },
        {
          adult: false,
          gender: 0,
          id: 74747,
          known_for_department: 'Diễn viên',
          name: 'Shahkrit Yamnarm',
          original_name: 'Shahkrit Yamnarm',
          popularity: 0.636,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6C4rrk2D7flkprMCw5GO2hw9MSB.jpg',
          cast_id: 3,
          character: 'Karan',
          credit_id: '52fe4d9dc3a36847f826aa09',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 115496,
          known_for_department: 'Diễn viên',
          name: 'Ray MacDonald',
          original_name: 'Ray MacDonald',
          popularity: 0.6,
          profile_path: null,
          cast_id: 4,
          character: 'Tee',
          credit_id: '52fe4d9dc3a36847f826aa0d',
          order: 3,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 0,
          id: 571683,
          known_for_department: 'Directing',
          name: 'Patchanon Thammajira',
          original_name: 'Patchanon Thammajira',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4d9dc3a36847f826aa1f',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1027748,
          known_for_department: 'Directing',
          name: 'Isara Nadee',
          original_name: 'Isara Nadee',
          popularity: 0.98,
          profile_path: null,
          credit_id: '52fe4d9dc3a36847f826aa13',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1082616,
          known_for_department: 'Directing',
          name: 'Kirati Nakintanon',
          original_name: 'Kirati Nakintanon',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dfTSAxzVD5uALmhkim3eSC17Ez0.jpg',
          credit_id: '52fe4d9dc3a36847f826aa19',
          department: 'Directing',
          job: 'Director',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/z2B0NsdGL5XLsI2IRLJEATUMh5t.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [],
    homepage: '',
    id: 550203,
    imdb_id: null,
    original_language: 'vi',
    original_title: 'Đích Tôn Độc Đắc',
    overview:
      'Đích Tôn Độc Đắc là một câu chuyện xoay quanh ước mơ sẽ được nhìn thấy đứa chắt đích tôn, người sẽ thừa hưởng sản nghiệp của gia đình của ông Hữu Phát. Nhưng ước mơ đó của ông dường như vẫn còn quá xa vời khi cháu nội Hữu Phước chưa thể cầu hôn được Phương Thúy- người bạn gái lâu năm của anh.',
    popularity: 0.6,
    poster_path:
      'https://image.tmdb.org/t/p/w342/1Hteo6NzJ0iNYl2JIc9A9o5FZv5.jpg',
    production_companies: [],
    production_countries: [],
    release_date: '2018-10-16',
    revenue: 0,
    runtime: 90,
    spoken_languages: [],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Đích Tôn Độc Đắc',
    video: false,
    vote_average: 0.0,
    vote_count: 0,
    videos: { results: [] },
    credits: { cast: [], crew: [] },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/Adr9KGNyh5MVIELvACznDq2H64y.jpg',
    belongs_to_collection: null,
    budget: 60000000,
    genres: [
      { id: 28, name: 'Phim Hành Động' },
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 53, name: 'Phim Gây Cấn' },
    ],
    homepage: '',
    id: 137094,
    imdb_id: 'tt1205537',
    original_language: 'en',
    original_title: 'Jack Ryan: Shadow Recruit',
    overview:
      'Trong Jack Ryan: Đặc vụ bóng đêm, sau khi chứng kiến qua màn hình cảnh toà tháp đôi New York bị tấn công khủng bố, chàng thanh niên Jack Ryan (Chris Pine) đã "xếp bút nghiên" và tình nguyện ra chiến trường. Trong một lần hành quân, Jack bị thương và phải giải ngũ, mọi chuyện tưởng như chấm dứt thì anh được sĩ quan tình báo CIA Thomas Harper (Kevin Costner) tuyển dụng vào một nhóm tinh nhuệ. Anh được gửi trả lại trường học và đi làm chuyên viên phân tích tài chính ở phố Wall với mục đích theo dõi các khoản tiền của bọn khủng bố.\r Sau 10 năm làm việc, tình cờ Jack phát hiện ra một âm mưu khủng khiếp nhắm vào thị trường tài chính Mỹ. Anh lên đường sang Nga để kiểm chứng lại giả thuyết của mình. Tuy nhiên, khi đến Nga, Jack Ryan lập tức bị cuốn vào một cuộc chiến đã khiến cho anh không chỉ từ một nhân viên bàn giấy trở thành đặc vụ hành động mà còn ảnh hưởng cả đến người tình xinh đẹp Cathy Muller (Keira Knightley) của mình.',
    popularity: 34.04,
    poster_path:
      'https://image.tmdb.org/t/p/w342/m7HcLUodrD4lM4s0Hui1tzO2pjO.jpg',
    production_companies: [
      {
        id: 435,
        logo_path: '/AjzK0s2w1GtLfR4hqCjVSYi0Sr8.png',
        name: 'Di Bonaventura Pictures',
        origin_country: 'US',
      },
      { id: 9341, logo_path: null, name: 'Etalon-Film', origin_country: 'RU' },
      {
        id: 4,
        logo_path: '/fycMZt242LVjagMByZOLUGbCvv3.png',
        name: 'Paramount',
        origin_country: 'US',
      },
      {
        id: 2767,
        logo_path: null,
        name: 'Mace Neufeld Productions',
        origin_country: 'US',
      },
      {
        id: 11250,
        logo_path: null,
        name: 'Buckaroo Entertainment',
        origin_country: '',
      },
      {
        id: 82819,
        logo_path: '/5Z8WWr0Lf1tInVWwJsxPP0uMz9a.png',
        name: 'Skydance Media',
        origin_country: 'US',
      },
      {
        id: 7036,
        logo_path: '/javbyY0ZCvlFJtly3tpZqf2NwLX.png',
        name: 'CJ Entertainment',
        origin_country: 'KR',
      },
    ],
    production_countries: [
      { iso_3166_1: 'RU', name: 'Russia' },
      { iso_3166_1: 'US', name: 'Hoa Kì' },
    ],
    release_date: '2014-01-15',
    revenue: 135511030,
    runtime: 105,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
      { english_name: 'Russian', iso_639_1: 'ru', name: 'Pусский' },
    ],
    status: 'Đã phát hành',
    tagline: 'Trust no one.',
    title: 'Đặc Vụ Bóng Đêm',
    video: false,
    vote_average: 6.1,
    vote_count: 2333,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Jack Ryan: Shadow Recruit - Official Trailer',
          key: 'S8EaxDvZt4w',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2013-10-04T19:12:22.000Z',
          id: '5c910d2d9251410feaa60aa6',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 62064,
          known_for_department: 'Diễn viên',
          name: 'Chris Pine',
          original_name: 'Chris Pine',
          popularity: 8.355,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vSe6sIsdtcoqBhuWRXynahFg8Vf.jpg',
          cast_id: 14,
          character: 'Jack Ryan',
          credit_id: '52fe4c26c3a368484e1a9deb',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 116,
          known_for_department: 'Diễn viên',
          name: 'Keira Knightley',
          original_name: 'Keira Knightley',
          popularity: 13.848,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8OpsaapXmwpLQqHvN5iwoIElERY.jpg',
          cast_id: 13,
          character: 'Cathy Muller',
          credit_id: '52fe4c26c3a368484e1a9de7',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 1269,
          known_for_department: 'Diễn viên',
          name: 'Kevin Costner',
          original_name: 'Kevin Costner',
          popularity: 18.097,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bykmxJHLfbFM3NT05RZXhx8YTzF.jpg',
          cast_id: 15,
          character: 'William Harper',
          credit_id: '52fe4c26c3a368484e1a9def',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 11181,
          known_for_department: 'Diễn viên',
          name: 'Kenneth Branagh',
          original_name: 'Kenneth Branagh',
          popularity: 6.834,
          profile_path:
            'https://image.tmdb.org/t/p/w185/AbCqqFxNi5w3nDUFdQt0DGMFh5H.jpg',
          cast_id: 23,
          character: 'Viktor Cherevin',
          credit_id: '52fe4c26c3a368484e1a9e0f',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 12766,
          known_for_department: 'Diễn viên',
          name: 'Lenn Kudrjawizki',
          original_name: 'Lenn Kudrjawizki',
          popularity: 1.541,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hH26APWthsuBSlX9VeOMcM2olel.jpg',
          cast_id: 19,
          character: 'Constantin',
          credit_id: '52fe4c26c3a368484e1a9dff',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 10132,
          known_for_department: 'Diễn viên',
          name: 'Colm Feore',
          original_name: 'Colm Feore',
          popularity: 3.553,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oOxcf1qB1IvVZrBEE1PdrfMiyBK.jpg',
          cast_id: 28,
          character: 'Rob Behringer',
          credit_id: '52fe4c26c3a368484e1a9e1f',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 97576,
          known_for_department: 'Diễn viên',
          name: 'Gemma Chan',
          original_name: 'Gemma Chan',
          popularity: 16.139,
          profile_path:
            'https://image.tmdb.org/t/p/w185/stTKj4iNauhqlVmZ6XAsFsvcMCY.jpg',
          cast_id: 17,
          character: 'Amy Chan',
          credit_id: '52fe4c26c3a368484e1a9df7',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 1196960,
          known_for_department: 'Diễn viên',
          name: 'Alec Utgoff',
          original_name: 'Alec Utgoff',
          popularity: 1.886,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zYtPKsXbeUg8kR2UqADdgKDfvJ1.jpg',
          cast_id: 61,
          character: 'Aleksandr Borovsky',
          credit_id: '58cbcfc89251415e6f0122f1',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 21193,
          known_for_department: 'Diễn viên',
          name: 'Peter Andersson',
          original_name: 'Peter Andersson',
          popularity: 2.116,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5VDByR9Px3uiLcDknCdYVhjQVOb.jpg',
          cast_id: 29,
          character: 'Dimitri Lemkov',
          credit_id: '52fe4c26c3a368484e1a9e23',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 43547,
          known_for_department: 'Diễn viên',
          name: 'Nonso Anozie',
          original_name: 'Nonso Anozie',
          popularity: 5.252,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vA7PTx27mVSuvvcDh0KOHc3LmHk.jpg',
          cast_id: 16,
          character: 'Embee',
          credit_id: '52fe4c26c3a368484e1a9df3',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 1202317,
          known_for_department: 'Diễn viên',
          name: 'Aleksandar Aleksiev',
          original_name: 'Aleksandar Aleksiev',
          popularity: 4.35,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bvpfp7CFvEw6KwxAzCCHKfkSsoF.jpg',
          cast_id: 27,
          character: "Cherevin's Bodyguard",
          credit_id: '52fe4c26c3a368484e1a9e1b',
          order: 10,
        },
        {
          adult: false,
          gender: 1,
          id: 1106755,
          known_for_department: 'Diễn viên',
          name: 'Deborah Rosan',
          original_name: 'Deborah Rosan',
          popularity: 0.6,
          profile_path: null,
          cast_id: 18,
          character: 'Customer',
          credit_id: '52fe4c26c3a368484e1a9dfb',
          order: 11,
        },
        {
          adult: false,
          gender: 0,
          id: 1106757,
          known_for_department: 'Diễn viên',
          name: 'Price Lindsey',
          original_name: 'Price Lindsey',
          popularity: 0.6,
          profile_path: null,
          cast_id: 20,
          character: 'Waiter',
          credit_id: '52fe4c26c3a368484e1a9e03',
          order: 12,
        },
        {
          adult: false,
          gender: 0,
          id: 1106759,
          known_for_department: 'Diễn viên',
          name: 'Celine Jedidi',
          original_name: 'Celine Jedidi',
          popularity: 0.6,
          profile_path: null,
          cast_id: 21,
          character: 'Restaurant Diner',
          credit_id: '52fe4c26c3a368484e1a9e07',
          order: 13,
        },
        {
          adult: false,
          gender: 0,
          id: 1106760,
          known_for_department: 'Diễn viên',
          name: 'Ricky Rajpal',
          original_name: 'Ricky Rajpal',
          popularity: 0.6,
          profile_path: null,
          cast_id: 22,
          character: 'VIP Business Man',
          credit_id: '52fe4c26c3a368484e1a9e0b',
          order: 14,
        },
        {
          adult: false,
          gender: 1,
          id: 79124,
          known_for_department: 'Diễn viên',
          name: 'Karen David',
          original_name: 'Karen David',
          popularity: 2.583,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mVEkM2LFiB2cmMHDYFFTE7wkHtY.jpg',
          cast_id: 24,
          character: 'FBI Lead Agent',
          credit_id: '52fe4c26c3a368484e1a9e13',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 19839,
          known_for_department: 'Diễn viên',
          name: 'David Paymer',
          original_name: 'David Paymer',
          popularity: 4.718,
          profile_path:
            'https://image.tmdb.org/t/p/w185/owoOdDFgXpls1OFKwmQ104Nkl5.jpg',
          cast_id: 30,
          character: 'Dixon Lewis',
          credit_id: '52fe4c26c3a368484e1a9e27',
          order: 16,
        },
        {
          adult: false,
          gender: 2,
          id: 54014,
          known_for_department: 'Diễn viên',
          name: 'David Hayman',
          original_name: 'David Hayman',
          popularity: 7.938,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gTwOhUXKzdHn4CEO4VEPyJHleb1.jpg',
          cast_id: 31,
          character: 'Sergey Dostal',
          credit_id: '52fe4c26c3a368484e1a9e2b',
          order: 17,
        },
        {
          adult: false,
          gender: 0,
          id: 1327764,
          known_for_department: 'Diễn viên',
          name: 'Amy J. Kim',
          original_name: 'Amy J. Kim',
          popularity: 0.6,
          profile_path: null,
          cast_id: 49,
          character: 'UN Announcer',
          credit_id: '5390313e0e0a262986001f68',
          order: 18,
        },
        {
          adult: false,
          gender: 2,
          id: 1327765,
          known_for_department: 'Diễn viên',
          name: 'Bogdan Kominowski',
          original_name: 'Bogdan Kominowski',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rr7GN56aOVdcetBbXHVwcXhfhZt.jpg',
          cast_id: 50,
          character: 'Mr. Borovsky',
          credit_id: '53903192c3a3680d750013ed',
          order: 19,
        },
        {
          adult: false,
          gender: 0,
          id: 1085742,
          known_for_department: 'Diễn viên',
          name: 'Maggie Daniels',
          original_name: 'Maggie Daniels',
          popularity: 0.6,
          profile_path: null,
          cast_id: 51,
          character: 'Mrs. Borovsky',
          credit_id: '53903254c3a3680d5e001443',
          order: 20,
        },
        {
          adult: false,
          gender: 0,
          id: 1129795,
          known_for_department: 'Diễn viên',
          name: 'Annika Pergament',
          original_name: 'Annika Pergament',
          popularity: 0.729,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2TdAzItn9V4GCgQ22seOirPZp6a.jpg',
          cast_id: 54,
          character: 'Mary',
          credit_id: '561e173692514142cc0019ef',
          order: 21,
        },
        {
          adult: false,
          gender: 0,
          id: 1225974,
          known_for_department: 'Diễn viên',
          name: 'Seth Ayott',
          original_name: 'Seth Ayott',
          popularity: 0.98,
          profile_path: null,
          cast_id: 62,
          character: 'Teddy Hefferman',
          credit_id: '58cbd0ccc3a368289100ff42',
          order: 22,
        },
        {
          adult: false,
          gender: 2,
          id: 1052209,
          known_for_department: 'Diễn viên',
          name: 'Andrew Byron',
          original_name: 'Andrew Byron',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6p5LO85IeXqir68HvnFWDCc6Dwj.jpg',
          cast_id: 63,
          character: "Cherevin's Bodyguard",
          credit_id: '58cbd0d99251415e690125a0',
          order: 23,
        },
        {
          adult: false,
          gender: 2,
          id: 97436,
          known_for_department: 'Diễn viên',
          name: 'Derek Lea',
          original_name: 'Derek Lea',
          popularity: 1.402,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fcI8XMeweX1PyGfoalemET40QAM.jpg',
          cast_id: 64,
          character: "Cherevin's Bodyguard",
          credit_id: '58cbd0e69251415e440127b9',
          order: 24,
        },
        {
          adult: false,
          gender: 0,
          id: 1778221,
          known_for_department: 'Diễn viên',
          name: 'Andy Butcher',
          original_name: 'Andy Butcher',
          popularity: 0.6,
          profile_path: null,
          cast_id: 65,
          character: "Cherevin's Guest Driver",
          credit_id: '58cbd0f19251415e570115fb',
          order: 25,
        },
        {
          adult: false,
          gender: 2,
          id: 1480047,
          known_for_department: 'Diễn viên',
          name: 'Pat Kiernan',
          original_name: 'Pat Kiernan',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/c8QASMhNim0bXySxaxRrkkzvKQ7.jpg',
          cast_id: 66,
          character: 'Anchor',
          credit_id: '58cbd1179251415e690125e9',
          order: 26,
        },
        {
          adult: false,
          gender: 0,
          id: 122556,
          known_for_department: 'Diễn viên',
          name: 'Ian Bonar',
          original_name: 'Ian Bonar',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/n77hqqUOLvUU4li9VuXxs2NeejJ.jpg',
          cast_id: 67,
          character: 'Student',
          credit_id: '58d9d7e3925141144900089f',
          order: 27,
        },
        {
          adult: false,
          gender: 1,
          id: 2118851,
          known_for_department: 'Diễn viên',
          name: 'Elena Velikanova',
          original_name: 'Elena Velikanova',
          popularity: 0.694,
          profile_path: null,
          cast_id: 68,
          character: 'Катя',
          credit_id: '5b8938650e0a2679a8011831',
          order: 28,
        },
        {
          adult: false,
          gender: 0,
          id: 1669418,
          known_for_department: 'Crew',
          name: 'Lloyd Bass',
          original_name: 'Lloyd Bass',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lHfGTQk2kzVBpaDmuY5wABySMeG.jpg',
          cast_id: 69,
          character: "Harper's Driver / Exfil Operator",
          credit_id: '5c7d8769c3a36843ed18d2f9',
          order: 29,
        },
        {
          adult: false,
          gender: 2,
          id: 1188241,
          known_for_department: 'Diễn viên',
          name: 'Santino Fontana',
          original_name: 'Santino Fontana',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5wo0D9drLtLwdyZyDqNZRejgzoM.jpg',
          cast_id: 70,
          character: 'Running Banker',
          credit_id: '5eaa3715426ae8001f4a86f3',
          order: 30,
        },
        {
          adult: false,
          gender: 2,
          id: 79952,
          known_for_department: 'Diễn viên',
          name: 'Mikhail Baryshnikov',
          original_name: 'Mikhail Baryshnikov',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/phF0evzvCvJhCrj4wUXd6Pnke9g.jpg',
          cast_id: 71,
          character: 'Minister Sorokin (Uncredited)',
          credit_id: '6190474dd75bd6006440afcf',
          order: 31,
        },
        {
          adult: false,
          gender: 2,
          id: 78047,
          known_for_department: 'Diễn viên',
          name: 'Matt Rippy',
          original_name: 'Matt Rippy',
          popularity: 1.022,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nJhQoU3YaGcdd9xFbdXGjO1ciMN.jpg',
          cast_id: 72,
          character: 'FBI Lead Agent Simmons - Dearborn',
          credit_id: '6190479966a7c3002182303f',
          order: 32,
        },
        {
          adult: false,
          gender: 0,
          id: 8660,
          known_for_department: 'Diễn viên',
          name: 'Kieron Jecchinis',
          original_name: 'Kieron Jecchinis',
          popularity: 0.98,
          profile_path: null,
          cast_id: 73,
          character: 'Walter Reed Doctor',
          credit_id: '619047d846e75f0060921d13',
          order: 33,
        },
        {
          adult: false,
          gender: 2,
          id: 122344,
          known_for_department: 'Diễn viên',
          name: 'William Meredith',
          original_name: 'William Meredith',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vLiHlMF7IPZ0bNQzN0MV8RKw992.jpg',
          cast_id: 74,
          character: 'Auto Plant Guard',
          credit_id: '6190480bcb6db5008d67e253',
          order: 34,
        },
        {
          adult: false,
          gender: 0,
          id: 2532404,
          known_for_department: 'Diễn viên',
          name: 'Leonard Redlich',
          original_name: 'Leonard Redlich',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1j5zwRrVPIlJgrus74qM85MfsPA.jpg',
          cast_id: 75,
          character: "Cherevin's Doctor",
          credit_id: '6190486da5d8490065a0fbfe',
          order: 35,
        },
        {
          adult: false,
          gender: 2,
          id: 1252814,
          known_for_department: 'Diễn viên',
          name: 'Angus Wright',
          original_name: 'Angus Wright',
          popularity: 1.557,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sjpzYOulNc0CyxGTj7H39DN6uge.jpg',
          cast_id: 76,
          character: 'Tall Man',
          credit_id: '619048b0e93e950062741471',
          order: 36,
        },
        {
          adult: false,
          gender: 2,
          id: 1935735,
          known_for_department: null,
          name: 'Jefferson King',
          original_name: 'Jefferson King',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gZe6PR2Y3qWuZJD47cdPPDWRPaR.jpg',
          cast_id: 77,
          character: 'Student (uncredited)',
          credit_id: '61c115f9dd47e1001ce9877f',
          order: 37,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 1,
          id: 1113,
          known_for_department: 'Production',
          name: 'Lucinda Syson',
          original_name: 'Lucinda Syson',
          popularity: 0.84,
          profile_path: null,
          credit_id: '53902dad0e0a2643fc0007a5',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 508,
          known_for_department: 'Biên kịch',
          name: 'David Koepp',
          original_name: 'David Koepp',
          popularity: 3.953,
          profile_path:
            'https://image.tmdb.org/t/p/w185/srPSV5EyQomUn65ZLD45h2b0AA5.jpg',
          credit_id: '52fe4c26c3a368484e1a9db3',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 1,
          id: 3965,
          known_for_department: 'Production',
          name: 'Deborah Aquila',
          original_name: 'Deborah Aquila',
          popularity: 1.546,
          profile_path: null,
          credit_id: '53902d840e0a26297f001e29',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 4611,
          known_for_department: 'Production',
          name: 'Mace Neufeld',
          original_name: 'Mace Neufeld',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4c26c3a368484e1a9ddd',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 10952,
          known_for_department: 'Production',
          name: 'Lorenzo Di Bonaventura',
          original_name: 'Lorenzo Di Bonaventura',
          popularity: 1.38,
          profile_path: null,
          credit_id: '52fe4c26c3a368484e1a9dc5',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 9152,
          known_for_department: 'Sound',
          name: 'Patrick Doyle',
          original_name: 'Patrick Doyle',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zffHei02Xba8eH8KjdQf1irOTYQ.jpg',
          credit_id: '53902de40e0a262986001f1f',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 2,
          id: 11181,
          known_for_department: 'Diễn viên',
          name: 'Kenneth Branagh',
          original_name: 'Kenneth Branagh',
          popularity: 6.834,
          profile_path:
            'https://image.tmdb.org/t/p/w185/AbCqqFxNi5w3nDUFdQt0DGMFh5H.jpg',
          credit_id: '52fe4c25c3a368484e1a9da1',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 65614,
          known_for_department: 'Production',
          name: 'David Barron',
          original_name: 'David Barron',
          popularity: 0.98,
          profile_path: null,
          credit_id: '53902cc80e0a262986001f06',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 24309,
          known_for_department: 'Production',
          name: 'Mark Vahradian',
          original_name: 'Mark Vahradian',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/soKYRPi4hYTnVABGkAGCRGnU87J.jpg',
          credit_id: '53902cef0e0a262979001df6',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 24217,
          known_for_department: 'Camera',
          name: 'Haris Zambarloukos',
          original_name: 'Haris Zambarloukos',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/buBq3MDhGydmOBQvodoNA5lk0PE.jpg',
          credit_id: '570bcfe3c3a36802b90001f9',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 28636,
          known_for_department: 'Art',
          name: 'Andrew Laws',
          original_name: 'Andrew Laws',
          popularity: 0.989,
          profile_path: null,
          credit_id: '53902e0c0e0a262976001ded',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 1,
          id: 29018,
          known_for_department: 'Production',
          name: 'Dana Goldberg',
          original_name: 'Dana Goldberg',
          popularity: 1.4,
          profile_path: null,
          credit_id: '52fe4c26c3a368484e1a9dd1',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 29609,
          known_for_department: 'Art',
          name: 'Stuart Kearns',
          original_name: 'Stuart Kearns',
          popularity: 0.6,
          profile_path: null,
          credit_id: '570bcfd4c3a36802b90001f2',
          department: 'Art',
          job: 'Supervising Art Director',
        },
        {
          adult: false,
          gender: 2,
          id: 38568,
          known_for_department: 'Biên kịch',
          name: 'Tom Clancy',
          original_name: 'Tom Clancy',
          popularity: 1.01,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dDnkblF2qwBGLC04aIdYgc6Bv6b.jpg',
          credit_id: '52fe4c25c3a368484e1a9da7',
          department: 'Biên kịch',
          job: 'Characters',
        },
        {
          adult: false,
          gender: 1,
          id: 53527,
          known_for_department: 'Costume & Make-Up',
          name: 'Jill Taylor',
          original_name: 'Jill Taylor',
          popularity: 0.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mf6epKzcLHODbLpljU8wbdQ0vUU.jpg',
          credit_id: '53902f02c3a3680d750013d5',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 1,
          id: 53680,
          known_for_department: 'Production',
          name: 'Elaine Grainger',
          original_name: 'Elaine Grainger',
          popularity: 0.98,
          profile_path: null,
          credit_id: '53902d9a0e0a2643fc0007a2',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 972623,
          known_for_department: 'Art',
          name: 'Dean Clegg',
          original_name: 'Dean Clegg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '53902e310e0a262979001e08',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 979698,
          known_for_department: 'Art',
          name: 'Neal Callow',
          original_name: 'Neal Callow',
          popularity: 0.6,
          profile_path: null,
          credit_id: '53902e1e0e0a26297f001e35',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 1,
          id: 1034748,
          known_for_department: 'Production',
          name: 'Tricia Wood',
          original_name: 'Tricia Wood',
          popularity: 1.273,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hSYw8hshMtY06XzuX2ZAuYluO03.jpg',
          credit_id: '53902dbf0e0a26297f001e2e',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 1106745,
          known_for_department: 'Biên kịch',
          name: 'Adam Cozad',
          original_name: 'Adam Cozad',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4c25c3a368484e1a9dad',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 0,
          id: 1106750,
          known_for_department: 'Production',
          name: 'Alexander Dostal',
          original_name: 'Alexander Dostal',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4c26c3a368484e1a9dcb',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1106751,
          known_for_department: 'Production',
          name: 'Tommy Harper',
          original_name: 'Tommy Harper',
          popularity: 1.132,
          profile_path: null,
          credit_id: '52fe4c26c3a368484e1a9dd7',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1106752,
          known_for_department: 'Production',
          name: 'David Ready',
          original_name: 'David Ready',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4c26c3a368484e1a9de3',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1319120,
          known_for_department: 'Costume & Make-Up',
          name: 'Charlotte Finlay',
          original_name: 'Charlotte Finlay',
          popularity: 0.6,
          profile_path: null,
          credit_id: '53902f59c3a3680d4e001487',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1327762,
          known_for_department: 'Art',
          name: 'Judy Farr',
          original_name: 'Judy Farr',
          popularity: 0.6,
          profile_path: null,
          credit_id: '53902e880e0a262986001f27',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 0,
          id: 1327763,
          known_for_department: 'Production',
          name: 'Alena Garetovskaya',
          original_name: 'Alena Garetovskaya',
          popularity: 0.6,
          profile_path: null,
          credit_id: '53902f33c3a3680d6e001375',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 1,
          id: 1402039,
          known_for_department: 'Directing',
          name: 'Martha Pinson',
          original_name: 'Martha Pinson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '570bd0359251413c940001f7',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1408825,
          known_for_department: 'Camera',
          name: 'Larry D. Horricks',
          original_name: 'Larry D. Horricks',
          popularity: 0.6,
          profile_path: null,
          credit_id: '570bd04ec3a36802a3000231',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 1,
          id: 1427849,
          known_for_department: 'Directing',
          name: 'Zoe Morgan',
          original_name: 'Zoe Morgan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '570bd02ac3a36802b0000211',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1428727,
          known_for_department: 'Sound',
          name: 'Patrick Jonsson',
          original_name: 'Patrick Jonsson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '54e51a8c92514109f9000441',
          department: 'Sound',
          job: 'Other',
        },
        {
          adult: false,
          gender: 0,
          id: 1583827,
          known_for_department: 'Visual Effects',
          name: 'Matt Johnson',
          original_name: 'Matt Johnson',
          popularity: 0.98,
          profile_path: null,
          credit_id: '57ebe6539251410c5b00645c',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/uWVkEo9PWHu9algZsiLPi6sRU64.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 36, name: 'Phim Lịch Sử' },
      { id: 18, name: 'Phim Chính Kịch' },
    ],
    homepage: 'https://www.disneyplus.com/movies/hamilton/3uPmBHWlO6HJ',
    id: 556574,
    imdb_id: 'tt8503618',
    original_language: 'en',
    original_title: 'Hamilton',
    overview:
      'Alexander Hamilton, một đứa trẻ mồ côi, đến New York để làm việc cho George Washington. Sau Cách mạng Hoa Kỳ, ông trở thành Bộ trưởng Tài chính đầu tiên của Hoa Kỳ.',
    popularity: 11.874,
    poster_path:
      'https://image.tmdb.org/t/p/w342/h1B7tW0t399VDjAcWJh8m87469b.jpg',
    production_companies: [
      {
        id: 89394,
        logo_path: '/m1Hku3PhgdsQiPO8uVe7szyrxAb.png',
        name: 'RadicalMedia',
        origin_country: 'US',
      },
      {
        id: 122645,
        logo_path: null,
        name: '5000 Broadway Productions',
        origin_country: 'US',
      },
      {
        id: 150839,
        logo_path: null,
        name: 'Nevis Productions',
        origin_country: '',
      },
      {
        id: 122647,
        logo_path: null,
        name: 'Old 320 Sycamore',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2020-07-03',
    revenue: 0,
    runtime: 160,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline:
      'Five Founding Fathers, Three Sisters - Over A Decade, in One Night',
    title: 'Anh Hùng Hamilton',
    video: false,
    vote_average: 8.4,
    vote_count: 868,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: '"Satisfied" Clip | Hamilton | Disney+',
          key: 'asfLNbrSPv4',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: true,
          published_at: '2020-06-29T23:51:45.000Z',
          id: '5efbcc10e93e950032bab038',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Hamilton | Streaming Exclusively July 3 | Disney+',
          key: '5EI40a-Fc1k',
          site: 'YouTube',
          size: 1080,
          type: 'Teaser',
          official: true,
          published_at: '2020-06-28T16:00:11.000Z',
          id: '5ef8c3b7be7f350035a0c5e1',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: '"The Room Where It Happens" Clip | Hamilton | Disney+',
          key: 'BQjGGrKRL8o',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: true,
          published_at: '2020-06-27T16:01:27.000Z',
          id: '5ef99d7fcffeed003604a55f',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: '"Alexander Hamilton" Clip | Hamilton | Disney+',
          key: 'hrGwCJQoeVo',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: true,
          published_at: '2020-06-24T16:39:17.000Z',
          id: '5ef99d8d13af5f003758538a',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Hamilton | Official Trailer | Disney+',
          key: 'DSCKfXpAGHc',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2020-06-22T02:30:34.000Z',
          id: '5ef0c495957e6d00367aff6b',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 1179651,
          known_for_department: 'Diễn viên',
          name: 'Lin-Manuel Miranda',
          original_name: 'Lin-Manuel Miranda',
          popularity: 2.607,
          profile_path:
            'https://image.tmdb.org/t/p/w185/r0wFwPa041pZ1QM66yJWuQXCkqx.jpg',
          cast_id: 0,
          character: 'Alexander Hamilton',
          credit_id: '5bd21f3c0e0a26171f003f27',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 1254614,
          known_for_department: 'Diễn viên',
          name: 'Leslie Odom Jr.',
          original_name: 'Leslie Odom Jr.',
          popularity: 1.327,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pDA11JMNAGQGJo7nRpZHp7pdp9N.jpg',
          cast_id: 23,
          character: 'Aaron Burr',
          credit_id: '5ee2adfd90dde0001fa81810',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 87932,
          known_for_department: 'Diễn viên',
          name: 'Renée Elise Goldsberry',
          original_name: 'Renée Elise Goldsberry',
          popularity: 2.065,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bNHksD4bZxWhNUIW5mwLgPWc30G.jpg',
          cast_id: 22,
          character: 'Angelica Schuyler',
          credit_id: '5ee2ade0f36a32001d94bdce',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 1631814,
          known_for_department: 'Diễn viên',
          name: 'Phillipa Soo',
          original_name: 'Phillipa Soo',
          popularity: 1.558,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1oKShCBjS2wxeAFqPuO2XSrpa5w.jpg',
          cast_id: 25,
          character: 'Eliza Hamilton',
          credit_id: '5ee2ae60197de4001f8f2211',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 1652371,
          known_for_department: 'Diễn viên',
          name: 'Daveed Diggs',
          original_name: 'Daveed Diggs',
          popularity: 5.452,
          profile_path:
            'https://image.tmdb.org/t/p/w185/v4VmQP0iFFW7SU2ouE2Qhu27Hgy.jpg',
          cast_id: 5,
          character: 'Marquis de Lafayette / Thomas Jefferson',
          credit_id: '5bd21ff392514144c9003776',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 1307751,
          known_for_department: 'Diễn viên',
          name: 'Christopher Jackson',
          original_name: 'Christopher Jackson',
          popularity: 0.933,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tPzdVCV8LsWvgVm0EYonuuzgt0H.jpg',
          cast_id: 12,
          character: 'George Washington',
          credit_id: '5db8dfe93faba000193b4f3f',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 1291890,
          known_for_department: 'Diễn viên',
          name: 'Jasmine Cephas Jones',
          original_name: 'Jasmine Cephas Jones',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lT0BC4xmluVmjo3yIGxTqHPqa9p.jpg',
          cast_id: 19,
          character: 'Peggy Schuyler / Maria Reynolds',
          credit_id: '5ee2ad42f36a32001d94bcef',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 1419065,
          known_for_department: 'Diễn viên',
          name: 'Okieriete Onaodowan',
          original_name: 'Okieriete Onaodowan',
          popularity: 2.702,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kxPzTxYuPInFY08o0H3KZahf7lX.jpg',
          cast_id: 21,
          character: 'Hercules Mulligan / James Madison',
          credit_id: '5ee2adc85b4fed001e61238d',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 1560244,
          known_for_department: 'Diễn viên',
          name: 'Anthony Ramos',
          original_name: 'Anthony Ramos',
          popularity: 5.807,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ityTHqIXFT3laID4j4ptlnc84zq.jpg',
          cast_id: 20,
          character: 'John Laurens / Philip Hamilton',
          credit_id: '5ee2ad6090dde00021ab52f5',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 221611,
          known_for_department: 'Diễn viên',
          name: 'Jonathan Groff',
          original_name: 'Jonathan Groff',
          popularity: 10.924,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3kmnYKAzSc3Lp7iK5pcj97Hx9Cm.jpg',
          cast_id: 24,
          character: 'King George III',
          credit_id: '5ee2ae2d97eab4001de06c94',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 2598207,
          known_for_department: 'Diễn viên',
          name: 'Carleigh Bettiol',
          original_name: 'Carleigh Bettiol',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gqVaxCYwvcujXd7BHFg7jsqzOO1.jpg',
          cast_id: 26,
          character: 'Ensemble',
          credit_id: '5efe0c025437f500398e4816',
          order: 10,
        },
        {
          adult: false,
          gender: 1,
          id: 1437491,
          known_for_department: 'Diễn viên',
          name: 'Ariana DeBose',
          original_name: 'Ariana DeBose',
          popularity: 1.118,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zTSeaRHiDPNZsxSVwyOgNSldL2h.jpg',
          cast_id: 27,
          character: 'Ensemble',
          credit_id: '5efe0c11a76ac50035fdb0fa',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 2699155,
          known_for_department: 'Diễn viên',
          name: 'Hope Easterbrook',
          original_name: 'Hope Easterbrook',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/auj0YAYvrerRDU10azCDyIp4tm7.jpg',
          cast_id: 28,
          character: 'Ensemble',
          credit_id: '5efe0c28a76ac50034fdddce',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 2478755,
          known_for_department: 'Diễn viên',
          name: 'Sydney James Harcourt',
          original_name: 'Sydney James Harcourt',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tKNptUzgklRMk5ZI1E1yHRCCzvG.jpg',
          cast_id: 29,
          character: 'Phillip Schuyler / James Reynolds / Doctor/ Ensemble',
          credit_id: '5efe0c64a284eb003691c9bd',
          order: 13,
        },
        {
          adult: false,
          gender: 1,
          id: 1974492,
          known_for_department: 'Diễn viên',
          name: 'Sasha Hutchings',
          original_name: 'Sasha Hutchings',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/f8rrBfBcXOuTD8iYDqoWDv9KzBw.jpg',
          cast_id: 30,
          character: 'Ensemble',
          credit_id: '5efe0c7ea284eb00389ae6ee',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 2028051,
          known_for_department: 'Diễn viên',
          name: 'Thayne Jasperson',
          original_name: 'Thayne Jasperson',
          popularity: 0.608,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sYEs8g8tfrhxfiEO60jKnMBSCJL.jpg',
          cast_id: 31,
          character: 'Samuel Seabury / Ensemble',
          credit_id: '5efe0c9ea76ac50035fdb17c',
          order: 15,
        },
        {
          adult: false,
          gender: 1,
          id: 2699157,
          known_for_department: 'Diễn viên',
          name: 'Elizabeth Judd',
          original_name: 'Elizabeth Judd',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/z4tRPVFiizy7ZpdDsMLQzDPOZ4K.jpg',
          cast_id: 32,
          character: 'Ensemble',
          credit_id: '5efe0cb7be7f350033ac8308',
          order: 16,
        },
        {
          adult: false,
          gender: 2,
          id: 1437486,
          known_for_department: 'Diễn viên',
          name: 'Jon Rua',
          original_name: 'Jon Rua',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4BNnQUaiHUYggtxMDsRFiM5JYZj.jpg',
          cast_id: 33,
          character: 'Charles Lee / Ensemble',
          credit_id: '5efe0ccaf031740036546691',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 2699159,
          known_for_department: 'Diễn viên',
          name: 'Austin Smith',
          original_name: 'Austin Smith',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/am5idTErXWa2dInMlIAWX3DuZuv.jpg',
          cast_id: 34,
          character: 'Ensemble',
          credit_id: '5efe0cf0be7f350034a3a226',
          order: 18,
        },
        {
          adult: false,
          gender: 2,
          id: 1587180,
          known_for_department: 'Diễn viên',
          name: 'Seth Stewart',
          original_name: 'Seth Stewart',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qgoRIi2jvHhOlRzQAcqjPM7DDQq.jpg',
          cast_id: 35,
          character: 'Ensemble',
          credit_id: '5efe0d09a284eb00389ae776',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 1026889,
          known_for_department: 'Diễn viên',
          name: 'Ephraim Sykes',
          original_name: 'Ephraim Sykes',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/o7ep0QI2rLiGJOhXJ4Gs6GzjwUi.jpg',
          cast_id: 36,
          character: 'George Eacker / Ensemble',
          credit_id: '5efe0d2f5437f500378fe261',
          order: 20,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 6117,
          known_for_department: 'Camera',
          name: 'Declan Quinn',
          original_name: 'Declan Quinn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f0cd51570309f00371e33f0',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 19316,
          known_for_department: 'Production',
          name: 'Jeffrey Seller',
          original_name: 'Jeffrey Seller',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/A39b1gGekptoXlud6BYZRpva4r6.jpg',
          credit_id: '5effd7e7a76ac5003601fd5b',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 58855,
          known_for_department: 'Production',
          name: 'Bernard Telsey',
          original_name: 'Bernard Telsey',
          popularity: 1.22,
          profile_path: null,
          credit_id: '5f0cd549efe37c0035c5ec43',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 40142,
          known_for_department: 'Sound',
          name: 'Robert Fernandez',
          original_name: 'Robert Fernandez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba9e45b4fed0041e321db',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 69241,
          known_for_department: 'Production',
          name: 'Jon Kamen',
          original_name: 'Jon Kamen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f949df03ff2df0050af3df3',
          department: 'Production',
          job: 'Co-Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 111406,
          known_for_department: 'Production',
          name: 'Justin Wilkes',
          original_name: 'Justin Wilkes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f949dcf6e0d720040ffae76',
          department: 'Production',
          job: 'Co-Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1070088,
          known_for_department: 'Sound',
          name: 'Tony Volante',
          original_name: 'Tony Volante',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba7db43250f00572a73fc',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 1179651,
          known_for_department: 'Diễn viên',
          name: 'Lin-Manuel Miranda',
          original_name: 'Lin-Manuel Miranda',
          popularity: 2.607,
          profile_path:
            'https://image.tmdb.org/t/p/w185/r0wFwPa041pZ1QM66yJWuQXCkqx.jpg',
          credit_id: '5effd7d7a284eb0036931d90',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1179651,
          known_for_department: 'Diễn viên',
          name: 'Lin-Manuel Miranda',
          original_name: 'Lin-Manuel Miranda',
          popularity: 2.607,
          profile_path:
            'https://image.tmdb.org/t/p/w185/r0wFwPa041pZ1QM66yJWuQXCkqx.jpg',
          credit_id: '6115b05a006b010072e4f509',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 2,
          id: 1179651,
          known_for_department: 'Diễn viên',
          name: 'Lin-Manuel Miranda',
          original_name: 'Lin-Manuel Miranda',
          popularity: 2.607,
          profile_path:
            'https://image.tmdb.org/t/p/w185/r0wFwPa041pZ1QM66yJWuQXCkqx.jpg',
          credit_id: '608ba3cb66469a005a3a9fe1',
          department: 'Biên kịch',
          job: 'Musical',
        },
        {
          adult: false,
          gender: 0,
          id: 1219633,
          known_for_department: 'Production',
          name: 'Dave Sirulnick',
          original_name: 'Dave Sirulnick',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5f949e03435abd005f761b8c',
          department: 'Production',
          job: 'Co-Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1337463,
          known_for_department: 'Sound',
          name: 'Dave Paterson',
          original_name: 'Dave Paterson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba9cd66469a00428d8647',
          department: 'Sound',
          job: 'Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1391591,
          known_for_department: 'Camera',
          name: 'Bruce MacCallum',
          original_name: 'Bruce MacCallum',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba8e867e0f7006fb4a5c9',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 1407021,
          known_for_department: 'Camera',
          name: 'Maceo Bishop',
          original_name: 'Maceo Bishop',
          popularity: 1.38,
          profile_path: null,
          credit_id: '608ba92b77c01f0079385929',
          department: 'Camera',
          job: 'Steadicam Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 1408359,
          known_for_department: 'Camera',
          name: 'David Knox',
          original_name: 'David Knox',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba8d208354700402f6045',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 1437483,
          known_for_department: 'Crew',
          name: 'Alex Lacamoire',
          original_name: 'Alex Lacamoire',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/m5KqXrSm8BeW1nilP6Fc5iO8NLa.jpg',
          credit_id: '608ba43367e0f7006fb4a205',
          department: 'Sound',
          job: 'Orchestrator',
        },
        {
          adult: false,
          gender: 2,
          id: 1437483,
          known_for_department: 'Crew',
          name: 'Alex Lacamoire',
          original_name: 'Alex Lacamoire',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/m5KqXrSm8BeW1nilP6Fc5iO8NLa.jpg',
          credit_id: '608ba42c81a7fc003f28fa46',
          department: 'Sound',
          job: 'Music Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1437483,
          known_for_department: 'Crew',
          name: 'Alex Lacamoire',
          original_name: 'Alex Lacamoire',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/m5KqXrSm8BeW1nilP6Fc5iO8NLa.jpg',
          credit_id: '608ba7cf43250f00572a73f9',
          department: 'Sound',
          job: 'Conductor',
        },
        {
          adult: false,
          gender: 2,
          id: 1437483,
          known_for_department: 'Crew',
          name: 'Alex Lacamoire',
          original_name: 'Alex Lacamoire',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/m5KqXrSm8BeW1nilP6Fc5iO8NLa.jpg',
          credit_id: '5e3978de4ca676001755e3eb',
          department: 'Sound',
          job: 'Music Arranger',
        },
        {
          adult: false,
          gender: 2,
          id: 1437496,
          known_for_department: 'Crew',
          name: 'Andy Blankenbuehler',
          original_name: 'Andy Blankenbuehler',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/pX7E4RaBFi7FnzHMZznQaFrOS3S.jpg',
          credit_id: '5e397906d1a893001ad02ad3',
          department: 'Crew',
          job: 'Choreographer',
        },
        {
          adult: false,
          gender: 0,
          id: 1441781,
          known_for_department: 'Sound',
          name: 'Jay Vicari',
          original_name: 'Jay Vicari',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba96066469a00716efb7c',
          department: 'Sound',
          job: 'Sound Engineer',
        },
        {
          adult: false,
          gender: 2,
          id: 1485823,
          known_for_department: 'Production',
          name: 'Thomas Kail',
          original_name: 'Thomas Kail',
          popularity: 1.7,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fe568wCZjaM7ZmSMcraYe3XN3tt.jpg',
          credit_id: '5e3978784ca676001755e35a',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1485823,
          known_for_department: 'Production',
          name: 'Thomas Kail',
          original_name: 'Thomas Kail',
          popularity: 1.7,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fe568wCZjaM7ZmSMcraYe3XN3tt.jpg',
          credit_id: '5effd7c95437f500398fa93a',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1485823,
          known_for_department: 'Production',
          name: 'Thomas Kail',
          original_name: 'Thomas Kail',
          popularity: 1.7,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fe568wCZjaM7ZmSMcraYe3XN3tt.jpg',
          credit_id: '608ba41208354700402f5ccc',
          department: 'Directing',
          job: 'Stage Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1496409,
          known_for_department: 'Sound',
          name: 'Daniel Timmons',
          original_name: 'Daniel Timmons',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba9871d1bf4003ff55dee',
          department: 'Sound',
          job: 'Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1509382,
          known_for_department: 'Camera',
          name: 'Jack Donnelly',
          original_name: 'Jack Donnelly',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba8b68c40f70057e81a44',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1586730,
          known_for_department: 'Production',
          name: 'Chris Rouchard',
          original_name: 'Chris Rouchard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba64bf8aee8002903f69f',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1587182,
          known_for_department: 'Production',
          name: 'Jill Furman',
          original_name: 'Jill Furman',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9t4QLwcRllHSM0mCOd7BEtrk0Kf.jpg',
          credit_id: '5effd819a284eb0036931dbb',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1587185,
          known_for_department: 'Editing',
          name: 'Jonah Moran',
          original_name: 'Jonah Moran',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f0cd531d5dbc20036e39f5b',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1590582,
          known_for_department: 'Art',
          name: 'Charles Christopher Rubino',
          original_name: 'Charles Christopher Rubino',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608baaa220af770029255c61',
          department: 'Art',
          job: 'Title Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1616167,
          known_for_department: 'Art',
          name: 'David Korins',
          original_name: 'David Korins',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba58df8aee800578e0497',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1704679,
          known_for_department: 'Costume & Make-Up',
          name: 'Paul Tazewell',
          original_name: 'Paul Tazewell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f0cd564eec5b50033d22a34',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 2,
          id: 1712264,
          known_for_department: 'Lighting',
          name: 'Howell Binkley',
          original_name: 'Howell Binkley',
          popularity: 0.98,
          profile_path: null,
          credit_id: '608ba5dc8c40f7003f35ae59',
          department: 'Lighting',
          job: 'Lighting Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1712265,
          known_for_department: 'Diễn viên',
          name: 'Nevin Steinberg',
          original_name: 'Nevin Steinberg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba5f1764841002bb954f4',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1712265,
          known_for_department: 'Diễn viên',
          name: 'Nevin Steinberg',
          original_name: 'Nevin Steinberg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba9fe81a7fc00776b4c53',
          department: 'Sound',
          job: 'Sound Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1785775,
          known_for_department: 'Costume & Make-Up',
          name: 'Charles G. LaPointe',
          original_name: 'Charles G. LaPointe',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba61407e28100592fa5b1',
          department: 'Costume & Make-Up',
          job: 'Hair Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1785775,
          known_for_department: 'Costume & Make-Up',
          name: 'Charles G. LaPointe',
          original_name: 'Charles G. LaPointe',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba61b66469a005a3aa153',
          department: 'Costume & Make-Up',
          job: 'Wig Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1996016,
          known_for_department: 'Editing',
          name: 'Chris MacKenzie',
          original_name: 'Chris MacKenzie',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608baaf671ffdf007774cb09',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2084398,
          known_for_department: 'Visual Effects',
          name: 'Ross Vincent',
          original_name: 'Ross Vincent',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608baacda6e2d2002ab5e6fd',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 2208144,
          known_for_department: 'Biên kịch',
          name: 'Ron Chernow',
          original_name: 'Ron Chernow',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9y5PAjeq1V7f4ctGoCn5dIOBZud.jpg',
          credit_id: '5fa9e6cb41465c003fc3f34a',
          department: 'Biên kịch',
          job: 'Novel',
        },
        {
          adult: false,
          gender: 0,
          id: 2225983,
          known_for_department: 'Camera',
          name: 'Bill Winters',
          original_name: 'Bill Winters',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba91d07e28100414a15b6',
          department: 'Camera',
          job: 'Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 2354691,
          known_for_department: 'Directing',
          name: 'Robin Mishkin Abrams',
          original_name: 'Robin Mishkin Abrams',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba6d5a6e2d2006f2b1c72',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2624437,
          known_for_department: 'Directing',
          name: 'Tom Gaito',
          original_name: 'Tom Gaito',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba6c477c01f003fa694ea',
          department: 'Directing',
          job: 'Second Assistant Director',
        },
        {
          adult: false,
          gender: 2,
          id: 2700857,
          known_for_department: 'Production',
          name: 'Sander Jacobs',
          original_name: 'Sander Jacobs',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dpF2WwbzXxQliU6KcXU9AymnN96.jpg',
          credit_id: '5effd82f5437f5003791cad5',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 2711292,
          known_for_department: 'Production',
          name: 'Bethany Knox',
          original_name: 'Bethany Knox',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f0cd53f81c7be0032fa6600',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 3073102,
          known_for_department: 'Production',
          name: 'David Backus',
          original_name: 'David Backus',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba68f20af770029255935',
          department: 'Production',
          job: 'Unit Production Manager',
        },
        {
          adult: false,
          gender: 1,
          id: 3073103,
          known_for_department: 'Production',
          name: 'Nan Marie Sandle',
          original_name: 'Nan Marie Sandle',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba7bf5b4fed0041e32014',
          department: 'Production',
          job: 'Production Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 3073104,
          known_for_department: 'Costume & Make-Up',
          name: 'Fred Waggoner',
          original_name: 'Fred Waggoner',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba826ac41610040c8db29',
          department: 'Costume & Make-Up',
          job: 'Hair Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 3073106,
          known_for_department: 'Costume & Make-Up',
          name: 'Shannon Williams',
          original_name: 'Shannon Williams',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba8538c40f7003f35b092',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 3073107,
          known_for_department: 'Costume & Make-Up',
          name: 'Nicky Saunders',
          original_name: 'Nicky Saunders',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba85df8aee8006d070a44',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 3073109,
          known_for_department: 'Camera',
          name: 'Pat Capone',
          original_name: 'Pat Capone',
          popularity: 0.6,
          profile_path: null,
          credit_id: '608ba88807e28100781ac4c5',
          department: 'Camera',
          job: 'Camera Operator',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'sykobanana',
          author_details: {
            name: '',
            username: 'sykobanana',
            avatar_path: '/j2KpvD880J95lqf3ct4u1MmWZhE.jpg',
            rating: 4.0,
          },
          content:
            "A Disappointment\r\n\r\nThis is a musical not made for people outside of the USA.  I had to watch the thing again and wiki Hamilton to try to figure out who was who except for some of the bigger names.  \r\n\r\nGoing by the poster, this is was meant to be some attempted rise to fame of Harry Potter in Hollywood.  \r\nThe casting was varied, which is great generally, but not representative of history (noone looked like what they should have).  \r\nHistorical themes seemed to be swapped around and added in for convenience-sake.   \r\nSome performances were good, Soo, Groff and Diggs, whilst others (MIranda - who was better in Mary Poppins Returns) just felt flat and tired.  \r\nIt felt like 6 or so cameras were placed and then just recorded.  \r\nAnd the choreography was distrDiễn viên at times, not complimentary.  \r\nAnd character development - the only one who shows any is Soo's character.  \r\n\r\nThis might be a great musical, but it is not a great movie (despite what people are reviewing it as).  It is hard to follow as a citizen of the world who does not know US political history details nor its players.  Its cinematography, casting and set pieces felt lazy (this could have been turned into grand cinema). \r\nAnd it was overly long...people might expect this type of thing to go for hours on West End to get their money's worth, but 2hrs 40 is overkill in this medium.  \r\n\r\nThe hype behind this made me think this was brilliant.  I was majorly disappointed.",
          created_at: '2020-07-06T08:25:14.869Z',
          id: '5f02dfea8ec4ab0035409479',
          updated_at: '2021-06-23T15:58:40.165Z',
          url: 'https://www.themoviedb.org/review/5f02dfea8ec4ab0035409479',
        },
        {
          author: 'Peter McGinn',
          author_details: {
            name: 'Peter McGinn',
            username: 'narrator56',
            avatar_path: '/tVbrLJzA2RwRlE7dJLJG54UsAkq.jpg',
            rating: 7.0,
          },
          content:
            'I suppose this movie was behind the eight ball from the very start in a way. On the one hand, there was such a tremendous hype for it as a play, it built the expectation of being blown away, and on the other hand, it being presented in its live theater version made it lose some of the visual impact of seeing it in person. We expect a greater production value on the screen.\r\n\r\nThe story is great, and should be required viewing for children at a certain age. I confess, I wasn’t enthralled by it as a musical. I guess I am too used to musicals that have regular dialogue broken up by songs rather than continuous sung dialogue. If there had been dialogue surroundIng eight or ten lovely songs like Helpless, I would have given it top marks. It is still an impressive production.\r\n\r\nI feel I have to comment on the diverse cast. I am white and had no problem with the cast choices. I would have cried foul if they had presented an all white cast as some seem to think was required. I had an acquaintance complain, “What if they cast a white actor as Martin Luther King? And all I can do is flip it upside down. There are only a half-dozen people of color in our history books for every hundred Caucasians, and if it reaches the point where whites stop whining when people of color play those roles, I am convinced that people of color will be totally fine with whites playing the roles of people of color. But we aren’t there yet, are we?',
          created_at: '2020-08-06T01:47:21.173Z',
          id: '5f2b61292d8ef30036e325d3',
          updated_at: '2021-06-23T15:58:42.106Z',
          url: 'https://www.themoviedb.org/review/5f2b61292d8ef30036e325d3',
        },
        {
          author: 'CaptNemo',
          author_details: {
            name: '',
            username: 'CaptNemo',
            avatar_path:
              '/https://secure.gravatar.com/avatar/e4f2df6b36ce014959a30664fd257006.jpg',
            rating: null,
          },
          content:
            'This is not a Movie. It is a television program. It is a filmed stage play that is being broadcast on television. These things do not add up to this being a film, not even a TV-movie.',
          created_at: '2021-04-04T15:27:41.366Z',
          id: '6069daed1cc4ff0078838e4d',
          updated_at: '2021-06-23T15:58:53.933Z',
          url: 'https://www.themoviedb.org/review/6069daed1cc4ff0078838e4d',
        },
      ],
      total_pages: 1,
      total_results: 3,
    },
  },
  {
    adult: false,
    backdrop_path: null,
    belongs_to_collection: null,
    budget: 0,
    genres: [{ id: 27, name: 'Phim Kinh Dị' }],
    homepage: '',
    id: 682201,
    imdb_id: null,
    original_language: 'vi',
    original_title: 'Vô Diện Sát Nhân',
    overview: 'Vô Diện Sát Nhân',
    popularity: 1.235,
    poster_path:
      'https://image.tmdb.org/t/p/w342/AnW8LJeu59oeDfQdxG6sfMWaRBW.jpg',
    production_companies: [],
    production_countries: [],
    release_date: '2020-04-17',
    revenue: 0,
    runtime: 0,
    spoken_languages: [],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Vô Diện Sát Nhân',
    video: false,
    vote_average: 0.0,
    vote_count: 0,
    videos: { results: [] },
    credits: {
      cast: [
        {
          adult: false,
          gender: 1,
          id: 2040628,
          known_for_department: 'Diễn viên',
          name: 'Phương Anh Đào',
          original_name: 'Phương Anh Đào',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gnbYK8XXL87WHzFmDtLUUmf7Kpm.jpg',
          cast_id: 1,
          character: 'Phương Anh',
          credit_id: '5e67cd29cee2f6001596bf99',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 2335254,
          known_for_department: 'Diễn viên',
          name: 'Quách Ngọc Tuyên',
          original_name: 'Quách Ngọc Tuyên',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8busSWanG35Sxv0srk5LOmdotLw.jpg',
          cast_id: 2,
          character: '',
          credit_id: '5e67cd38e38bd800151613cd',
          order: 2,
        },
        {
          adult: false,
          gender: 0,
          id: 2041124,
          known_for_department: 'Diễn viên',
          name: 'Hiếu Nguyễn',
          original_name: 'Hiếu Nguyễn',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1D7H8LB9sg52KXhqN4jSZbnerDE.jpg',
          cast_id: 3,
          character: '',
          credit_id: '5e67cd4655c9260015632887',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 1861442,
          known_for_department: 'Diễn viên',
          name: 'Oanh Kiều',
          original_name: 'Oanh Kiều',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uZosshNpQqC9gDYmjEfwOQuR5KF.jpg',
          cast_id: 4,
          character: '',
          credit_id: '5e67cd55357c0000133c2ef6',
          order: 4,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 0,
          id: 2562257,
          known_for_department: 'Directing',
          name: 'Đinh Công Hiếu',
          original_name: 'Đinh Công Hiếu',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5e67cd6e459ad600135de85c',
          department: 'Directing',
          job: 'Director',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/eTfik9sRZTcaWIMJGVhmUqrbL0Q.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [
      { id: 16, name: 'Phim Hoạt Hình' },
      { id: 878, name: 'Phim Khoa Học Viễn Tưởng' },
      { id: 28, name: 'Phim Hành Động' },
    ],
    homepage: 'http://www.kingsglaivefinalfantasyxv-movie.com',
    id: 390734,
    imdb_id: 'tt5595168',
    original_language: 'ja',
    original_title: 'キングスグレイブ ファイナルファンタジーXV',
    overview:
      'Kingsglaive diễn ra trong song song với những sự kiện trong Final Fantasy XV, tập trung vào các sự kiện xung quanh vua Regis Lucis Caelum CXIII, cha của nhân vật chính Noctis. Cốt truyện kể về các Kingsglaive, đội vệ binh tinh nhuệ của vua Regis, được thừa hưởng sức mạnh ma thuật từ vị vua nhầm bảo vệ vương quốc Lucis và Thánh Thạch khỏi sự xâm lăng của Đế quốc Niflheim.  Phải đối mặt với liên tục với những cuộc xung đột, vua Regis chấp nhận một hiệp định đình chiến với Niflheim. Một phần của các hiệp ước hòa bình yêu cầu Hoàng tử Noctis phải kết hôn với công chúa Lunafreya Nox Fleuret của thành bang Tenebrae. Hiệp ước hòa bình hóa ra là một cái bẫy để Niflheim xâm lược vương quốc. Nyx Ulric, vệ binh tinh nhuệ nhất Kingsglavie cùng với vua Regis và Lunafreya phải tham gia vào cuộc chiến vì vận mênh của Lucis.',
    popularity: 45.581,
    poster_path:
      'https://image.tmdb.org/t/p/w342/fjJc8LlPsb0ZuC0wCwslVy8yNae.jpg',
    production_companies: [
      {
        id: 142655,
        logo_path: null,
        name: 'Square Visual Works Co. Ltd.',
        origin_country: '',
      },
      {
        id: 75080,
        logo_path: null,
        name: 'Digic Pictures',
        origin_country: '',
      },
      {
        id: 142992,
        logo_path: null,
        name: 'Pixoloid Studios',
        origin_country: '',
      },
      {
        id: 10038,
        logo_path: '/nCueXKwYIEXrZ5ofqSJBO1YcmRr.png',
        name: 'Square Enix',
        origin_country: 'JP',
      },
      { id: 4164, logo_path: null, name: 'Square USA', origin_country: '' },
      {
        id: 110539,
        logo_path: null,
        name: 'The Monk Studios',
        origin_country: '',
      },
      {
        id: 94458,
        logo_path: null,
        name: 'Toneplus Animation Studios',
        origin_country: '',
      },
    ],
    production_countries: [
      { iso_3166_1: 'JP', name: 'Nhật Bản' },
      { iso_3166_1: 'US', name: 'Hoa Kì' },
    ],
    release_date: '2016-07-09',
    revenue: 269980,
    runtime: 115,
    spoken_languages: [
      { english_name: 'Nhật Bảnese', iso_639_1: 'ja', name: '日本語' },
    ],
    status: 'Đã phát hành',
    tagline: 'The Final Fantasy XV saga starts here.',
    title: 'Final Fantasy XV: Đội Vệ Binh Tinh Nhuệ',
    video: false,
    vote_average: 6.8,
    vote_count: 526,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'KINGSGLAIVE FFXV ファン感謝特別ムービー',
          key: 'AlHR0QztA9Q',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: false,
          published_at: '2017-01-01T02:59:40.000Z',
          id: '5d4b73bb00213400132690a8',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Kingsglaive Final Fantasy XV - Official Trailer',
          key: 'htnkOpknGok',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: false,
          published_at: '2016-07-24T04:30:00.000Z',
          id: '5caa19090e0a264c71f4a345',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'KINGSGLAIVE FINAL FANTASY XV- Official E3 Trailer',
          key: 'nGl_2gYrfM0',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2016-06-14T04:19:09.000Z',
          id: '618158f8c7c22400939196eb',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'KINGSGLAIVE FINAL FANTASY XV - Official Teaser Trailer (2016)',
          key: 'iP8EgMUVmwk',
          published_at: '2016-03-31T03:30:43.000Z',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          id: '56fd1cb3c3a36848280028d9',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 1084911,
          known_for_department: 'Diễn viên',
          name: 'Go Ayano',
          original_name: 'Go Ayano',
          popularity: 4.618,
          profile_path:
            'https://image.tmdb.org/t/p/w185/Ap5IuncBMYnABsvkEtsdoM92VTh.jpg',
          cast_id: 11,
          character: 'Nyx Ulric (voice)',
          credit_id: '577efa63c3a3686a09004276',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 230660,
          known_for_department: 'Diễn viên',
          name: 'Shiori Kutsuna',
          original_name: 'Shiori Kutsuna',
          popularity: 5.158,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5EdMbcRIemzLszjEr36Ic0Obmdb.jpg',
          cast_id: 13,
          character: 'Lunafrena Nox Fleuret (voice)',
          credit_id: '577efadec3a368307c000d13',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 89835,
          known_for_department: 'Diễn viên',
          name: 'Ayumi Fujimura',
          original_name: 'Ayumi Fujimura',
          popularity: 1.379,
          profile_path: null,
          cast_id: 19,
          character: 'Crowe Altius (voice)',
          credit_id: '580bc4c4c3a3682413005532',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 9708,
          known_for_department: 'Diễn viên',
          name: 'Keiji Fujiwara',
          original_name: 'Keiji Fujiwara',
          popularity: 2.082,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hbfBiFiEvD8u3vikl6hUNLKF7Lv.jpg',
          cast_id: 20,
          character: 'Ardyn Izunia (voice)',
          credit_id: '580bc4d2925141717600540c',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 20664,
          known_for_department: 'Diễn viên',
          name: 'Koichi Yamadera',
          original_name: 'Koichi Yamadera',
          popularity: 3.389,
          profile_path:
            'https://image.tmdb.org/t/p/w185/biov5jENp2XYfehkcdnRvi796Wi.jpg',
          cast_id: 21,
          character: 'Drautos (voice)',
          credit_id: '580bc4dfc3a368258f004fcc',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 223309,
          known_for_department: 'Diễn viên',
          name: 'Shozo Iizuka',
          original_name: 'Shozo Iizuka',
          popularity: 1.417,
          profile_path:
            'https://image.tmdb.org/t/p/w185/msqe5A1q5YUUND0RhzB9dw1AEAO.jpg',
          cast_id: 23,
          character: 'Iedolas Aldercapt (voice)',
          credit_id: '580bc501c3a368260d0053f1',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 90567,
          known_for_department: 'Diễn viên',
          name: 'Tomokazu Seki',
          original_name: 'Tomokazu Seki',
          popularity: 3.138,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4N6i4cgtbeUj5AJd8kiBZ2BxxEJ.jpg',
          cast_id: 24,
          character: 'Luche Lazarus (voice)',
          credit_id: '580bc50f925141701a0058cc',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 1221114,
          known_for_department: 'Diễn viên',
          name: 'Yuichi Nakamura',
          original_name: 'Yuichi Nakamura',
          popularity: 4.678,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wb8behVKjBHX9XXrEydvNINCYwH.jpg',
          cast_id: 25,
          character: 'Ravus Nox Fleuret (voice)',
          credit_id: '580bc546925141712c005509',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 112278,
          known_for_department: 'Diễn viên',
          name: 'Wataru Takagi',
          original_name: 'Wataru Takagi',
          popularity: 1.826,
          profile_path:
            'https://image.tmdb.org/t/p/w185/amccLvyTl5JP7T9F05BojgQedNw.jpg',
          cast_id: 28,
          character: 'Pelna Khara (voice)',
          credit_id: '580bc575c3a368249d004716',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 20661,
          known_for_department: 'Diễn viên',
          name: 'Tsutomu Isobe',
          original_name: 'Tsutomu Isobe',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qP5vQMIbLNvSsSFkEMLZRVt4ZW5.jpg',
          cast_id: 14,
          character: 'Regis Lucis Caelum (voice)',
          credit_id: '577efb13c3a36830fb000cf0',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 1276791,
          known_for_department: 'Diễn viên',
          name: 'Mitsuaki Kanuka',
          original_name: 'Mitsuaki Kanuka',
          popularity: 1.38,
          profile_path: null,
          cast_id: 22,
          character: 'Libertus Ostium (voice)',
          credit_id: '580bc4eec3a36823df0051fc',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 1563028,
          known_for_department: 'Diễn viên',
          name: 'Fuminori Komatsu',
          original_name: 'Fuminori Komatsu',
          popularity: 0.834,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zI2Wh6fiEkWfWREGDcyAsXsDhBc.jpg',
          cast_id: 27,
          character: 'Tredd Furia (voice)',
          credit_id: '580bc55f925141712c005512',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 122481,
          known_for_department: 'Diễn viên',
          name: 'Banjo Ginga',
          original_name: 'Banjo Ginga',
          popularity: 2.702,
          profile_path:
            'https://image.tmdb.org/t/p/w185/akhAAMAjgZw13Lrz8LQqsfm9ez2.jpg',
          cast_id: 29,
          character: 'Clarus Amacitia (voice)',
          credit_id: '59eb6a659251415544013483',
          order: 12,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 0,
          id: 9661,
          known_for_department: 'Directing',
          name: 'Takeshi Nozue',
          original_name: 'Takeshi Nozue',
          popularity: 0.6,
          profile_path: null,
          credit_id: '56fd1a259251415fa3002309',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 235290,
          known_for_department: 'Biên kịch',
          name: 'Takashi Hasegawa',
          original_name: 'Takashi Hasegawa',
          popularity: 0.98,
          profile_path: null,
          credit_id: '57024823c3a3685686002792',
          department: 'Biên kịch',
          job: 'Writer',
        },
        {
          adult: false,
          gender: 2,
          id: 1003243,
          known_for_department: 'Sound',
          name: 'John R. Graham',
          original_name: 'John R. Graham',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5756958a9251416e2d002364',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 0,
          id: 1412917,
          known_for_department: 'Visual Effects',
          name: 'Daniel Perez Ferreira',
          original_name: 'Daniel Perez Ferreira',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5f8b17f50792e100362dc872',
          department: 'Visual Effects',
          job: 'Visual Effects Technical Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1460616,
          known_for_department: 'Visual Effects',
          name: 'Devin Stoutley',
          original_name: 'Devin Stoutley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8b26d6d05a030037db4e09',
          department: 'Visual Effects',
          job: 'Modeling',
        },
        {
          adult: false,
          gender: 0,
          id: 1696361,
          known_for_department: 'Production',
          name: 'Hajime Tabata',
          original_name: 'Hajime Tabata',
          popularity: 0.6,
          profile_path: null,
          credit_id: '580653e8c3a3684d4e007ff8',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1696364,
          known_for_department: 'Production',
          name: 'Rui Kawada',
          original_name: 'Rui Kawada',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5806540d9251415bbe00862b',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 2818813,
          known_for_department: 'Visual Effects',
          name: 'Shaila Tobin',
          original_name: 'Shaila Tobin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f8b283ceb79c200370c9d5b',
          department: 'Visual Effects',
          job: 'Animation',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/uwivrZ7vIeP0HNkE5gKavzhZNpG.jpg',
    belongs_to_collection: {
      id: 228446,
      name: 'Insidious Collection',
      poster_path: '/w1213HKk1XKSwHiBgjkWghn9biC.jpg',
      backdrop_path: '/5FrPZHgbbmTIq0oxpwSGqu5HyXC.jpg',
    },
    budget: 5000000,
    genres: [
      { id: 27, name: 'Phim Kinh Dị' },
      { id: 53, name: 'Phim Gây Cấn' },
    ],
    homepage: 'http://www.insidiousch2.com/',
    id: 91586,
    imdb_id: 'tt2226417',
    original_language: 'en',
    original_title: 'Insidious: Chapter 2',
    overview:
      'Năm 1986, Lorraine Lambert mời nhà tâm linh Elise đến nhà mình để giúp tìm con ma đang đeo bám cậu con trai Josh của bà. Elise nhận định Josh có khả năng đặc biệt mà người thường không có, đó là kết nối linh hồn mình với thế giới của người chết. Hai người quyết định xóa ký ức của Josh để anh thôi không "du hành" vào thế giới đen tối này nữa.  Hai mươi lăm năm trôi qua, Josh khi này đã có vợ là Renai cùng hai con. Đây là lúc truyện phim tiếp nối phần 1. Những tưởng đã thoát khỏi ma quỷ từ lần trước nhưng những hiện tượng lạ vẫn diễn ra trong nhà Lambert.',
    popularity: 52.607,
    poster_path:
      'https://image.tmdb.org/t/p/w342/chnxUtTmTRZh5FE7Ha4aUOZ9ahs.jpg',
    production_companies: [
      {
        id: 7263,
        logo_path: '/auaadhBBcvvTDtmW2iJzOrEjfgO.png',
        name: 'FilmDistrict',
        origin_country: 'US',
      },
      {
        id: 34,
        logo_path: '/GagSvqWlyPdkFHMfQ3pNq6ix9P.png',
        name: 'Sony Pictures',
        origin_country: 'US',
      },
      {
        id: 3172,
        logo_path: '/kDedjRZwO8uyFhuHamomOhN6fzG.png',
        name: 'Blumhouse Productions',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2013-09-12',
    revenue: 161000000,
    runtime: 105,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'Insidious: Chapter 2',
    title: 'Qủy Quyệt 2',
    video: false,
    vote_average: 6.7,
    vote_count: 3260,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Insidious: Chapter 2 Official Trailer #1 (2013) - Patrick Wilson Movie HD',
          key: 'fBbi4NeebAk',
          published_at: '2013-06-05T16:37:41.000Z',
          site: 'YouTube',
          size: 720,
          type: 'Trailer',
          official: false,
          id: '533ec6d6c3a3685448007e08',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 17178,
          known_for_department: 'Diễn viên',
          name: 'Patrick Wilson',
          original_name: 'Patrick Wilson',
          popularity: 9.059,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tc1ezEfIY8BhCy85svOUDtpBFPt.jpg',
          cast_id: 3,
          character: 'Josh Lambert',
          credit_id: '52fe48dc9251416c750b5935',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 9827,
          known_for_department: 'Diễn viên',
          name: 'Rose Byrne',
          original_name: 'Rose Byrne',
          popularity: 14.756,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4oQWCLK7gd6RNKF0WJipJo7TyFP.jpg',
          cast_id: 2,
          character: 'Renai Lambert',
          credit_id: '52fe48dc9251416c750b5931',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 17181,
          known_for_department: 'Diễn viên',
          name: 'Ty Simpkins',
          original_name: 'Ty Simpkins',
          popularity: 4.124,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8FyJcMFmPdCSfz2Zc5ZcAKrIorj.jpg',
          cast_id: 5,
          character: 'Dalton Lambert',
          credit_id: '52fe48dc9251416c750b593d',
          order: 2,
        },
        {
          adult: false,
          gender: 1,
          id: 7401,
          known_for_department: 'Diễn viên',
          name: 'Lin Shaye',
          original_name: 'Lin Shaye',
          popularity: 5.072,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aL87Za52elH81zMiXQn5C7AXAeg.jpg',
          cast_id: 4,
          character: 'Elise Rainier',
          credit_id: '52fe48dc9251416c750b5939',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 10767,
          known_for_department: 'Diễn viên',
          name: 'Barbara Hershey',
          original_name: 'Barbara Hershey',
          popularity: 5.475,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6swwfge3HlvyBVRSNwroFtMcgNB.jpg',
          cast_id: 7,
          character: 'Lorraine Lambert',
          credit_id: '52fe48dc9251416c750b5947',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 80619,
          known_for_department: 'Diễn viên',
          name: 'Steve Coulter',
          original_name: 'Steve Coulter',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5bK6a5Cfy5DxVoNpzt4nbhUUW85.jpg',
          cast_id: 8,
          character: 'Carl',
          credit_id: '52fe48dc9251416c750b594b',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 2128,
          known_for_department: 'Diễn viên',
          name: 'Leigh Whannell',
          original_name: 'Leigh Whannell',
          popularity: 3.049,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wvoTbsROOHfCqJ3Voe9zpal429L.jpg',
          cast_id: 9,
          character: 'Specs',
          credit_id: '52fe48dc9251416c750b594f',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 59117,
          known_for_department: 'Diễn viên',
          name: 'Angus Sampson',
          original_name: 'Angus Sampson',
          popularity: 4.558,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8EX6ul2zyVUg91oDvI3RpYS5szV.jpg',
          cast_id: 10,
          character: 'Tucker',
          credit_id: '52fe48dc9251416c750b5953',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 208524,
          known_for_department: 'Diễn viên',
          name: 'Andrew Astor',
          original_name: 'Andrew Astor',
          popularity: 1.29,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hrmqe7NZgr1bvlItyhITX0w8J10.jpg',
          cast_id: 11,
          character: 'Foster Lambert',
          credit_id: '52fe48dc9251416c750b5957',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 58739,
          known_for_department: 'Diễn viên',
          name: 'Hank Harris',
          original_name: 'Hank Harris',
          popularity: 0.631,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eSen8ub5SAnzqSel1brB7Ju76aa.jpg',
          cast_id: 12,
          character: 'Young Carl',
          credit_id: '52fe48dc9251416c750b595b',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 78804,
          known_for_department: 'Diễn viên',
          name: 'Jocelin Donahue',
          original_name: 'Jocelin Donahue',
          popularity: 3.77,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jJGpkFqdZYQnTuUMOQcvNNEt75X.jpg',
          cast_id: 13,
          character: 'Young Lorraine Lambert',
          credit_id: '52fe48dc9251416c750b595f',
          order: 10,
        },
        {
          adult: false,
          gender: 1,
          id: 1153842,
          known_for_department: 'Diễn viên',
          name: 'Lindsay Seim',
          original_name: 'Lindsay Seim',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1dNluYFkeZTQBDCZ3NkjqGKxjrk.jpg',
          cast_id: 14,
          character: 'Young Elise Rainier',
          credit_id: '52fe48dc9251416c750b5963',
          order: 11,
        },
        {
          adult: false,
          gender: 1,
          id: 154839,
          known_for_department: 'Diễn viên',
          name: 'Danielle Bisutti',
          original_name: 'Danielle Bisutti',
          popularity: 3.66,
          profile_path:
            'https://image.tmdb.org/t/p/w185/f5EKWWRPmQF3aDWBUHIBsVt96Yp.jpg',
          cast_id: 15,
          character: "Parker Crane's Mother",
          credit_id: '52fe48dc9251416c750b5967',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 1223444,
          known_for_department: 'Diễn viên',
          name: 'Tyler Griffin',
          original_name: 'Tyler Griffin',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/x88AQFcW2NIEiiMF1lmRzozeVSD.jpg',
          cast_id: 16,
          character: 'Young Parker Crane',
          credit_id: '52fe48dc9251416c750b596b',
          order: 13,
        },
        {
          adult: false,
          gender: 2,
          id: 206505,
          known_for_department: 'Diễn viên',
          name: 'Garrett Ryan',
          original_name: 'Garrett Ryan',
          popularity: 1.473,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sad0CJT5ERc8k6gBcyjhIeBxl5n.jpg',
          cast_id: 17,
          character: 'Young Josh Lambert',
          credit_id: '52fe48dc9251416c750b596f',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 62851,
          known_for_department: 'Diễn viên',
          name: 'Tom Fitzpatrick',
          original_name: 'Tom Fitzpatrick',
          popularity: 0.707,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7OUqO0jvZfm5tSEWT6Cscooqsdp.jpg',
          cast_id: 37,
          character: 'Bride in Black / Old Parker Crane',
          credit_id: '554fa967c3a3682254004832',
          order: 15,
        },
        {
          adult: false,
          gender: 1,
          id: 181329,
          known_for_department: 'Diễn viên',
          name: 'Priscilla Garita',
          original_name: 'Priscilla Garita',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9GscT4W431S2IOJPiDVO9hC1tNu.jpg',
          cast_id: 38,
          character: 'Natalie',
          credit_id: '57f100859251416d31002fc0',
          order: 16,
        },
        {
          adult: false,
          gender: 2,
          id: 87118,
          known_for_department: 'Diễn viên',
          name: 'Michael Beach',
          original_name: 'Michael Beach',
          popularity: 4.323,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7gCBCpK2OSzuUWk5iTZds9NjqkF.jpg',
          cast_id: 39,
          character: 'Detective Sendal',
          credit_id: '593dc7fac3a3680f670252e5',
          order: 17,
        },
        {
          adult: false,
          gender: 2,
          id: 139631,
          known_for_department: 'Diễn viên',
          name: 'J. LaRose',
          original_name: 'J. LaRose',
          popularity: 0.766,
          profile_path:
            'https://image.tmdb.org/t/p/w185/eZHglMF2O4KtXZAQtlQ4Vf2taTW.jpg',
          cast_id: 40,
          character: 'Long Haired Fiend',
          credit_id: '593dc812c3a3680f42024bbe',
          order: 18,
        },
        {
          adult: false,
          gender: 1,
          id: 568240,
          known_for_department: 'Diễn viên',
          name: 'Brooke Peoples',
          original_name: 'Brooke Peoples',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4nl1nJel9I93MpuGnBqdJydXUAV.jpg',
          cast_id: 41,
          character: 'Neighbor Jessica',
          credit_id: '593dc829c3a3680f140227e0',
          order: 19,
        },
        {
          adult: false,
          gender: 1,
          id: 1478382,
          known_for_department: 'Diễn viên',
          name: 'Edwina Findley Dickerson',
          original_name: 'Edwina Findley Dickerson',
          popularity: 2.625,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jRXh0twORpmf1nHhMrc8uMVvFHZ.jpg',
          cast_id: 42,
          character: 'Hillary',
          credit_id: '593dccb892514105b7023f59',
          order: 20,
        },
        {
          adult: false,
          gender: 1,
          id: 1570330,
          known_for_department: 'Diễn viên',
          name: 'Stephanie Pearson',
          original_name: 'Stephanie Pearson',
          popularity: 1.375,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cmMC3OBOpsTsDj1UW4jERAhZG9a.jpg',
          cast_id: 43,
          character: 'Dark Haired Woman',
          credit_id: '593dcce0c3a36828b200e150',
          order: 21,
        },
        {
          adult: false,
          gender: 2,
          id: 1448173,
          known_for_department: 'Diễn viên',
          name: 'Jorge-Luis Pallo',
          original_name: 'Jorge-Luis Pallo',
          popularity: 1.593,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9cw97jnvm7SvnCTNBWZHXt4clfu.jpg',
          cast_id: 44,
          character: 'Brian',
          credit_id: '593dccf2c3a36828b200e16a',
          order: 22,
        },
        {
          adult: false,
          gender: 1,
          id: 974169,
          known_for_department: 'Diễn viên',
          name: 'Jenna Ortega',
          original_name: 'Jenna Ortega',
          popularity: 6.478,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aQZ68fE7gkofkC99zHrqsZSqski.jpg',
          cast_id: 45,
          character: 'Annie',
          credit_id: '593dcd2dc3a3680f6702572f',
          order: 23,
        },
        {
          adult: false,
          gender: 0,
          id: 1608562,
          known_for_department: 'Diễn viên',
          name: 'Dannay Rodriguez',
          original_name: 'Dannay Rodriguez',
          popularity: 0.964,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yBspbI2rQUvFhuimlZNm4vWwKEk.jpg',
          cast_id: 46,
          character: 'Allison',
          credit_id: '593dcd439251410587024758',
          order: 24,
        },
        {
          adult: false,
          gender: 0,
          id: 1023732,
          known_for_department: 'Diễn viên',
          name: 'Sienna Farall',
          original_name: 'Sienna Farall',
          popularity: 1.025,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zjANCvuphArVaEkQE3rAuVVYe6n.jpg',
          cast_id: 47,
          character: 'Coma Ward Nurse',
          credit_id: '593dcdadc3a3680f42025058',
          order: 25,
        },
        {
          adult: false,
          gender: 2,
          id: 1832086,
          known_for_department: 'Diễn viên',
          name: 'Jack Walsh',
          original_name: 'Jack Walsh',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3zQboyL6xA1U6MIOGdaUhLTZjbi.jpg',
          cast_id: 48,
          character: 'Old Man in the Further',
          credit_id: '593dcee2c3a3680f87024fc2',
          order: 26,
        },
        {
          adult: false,
          gender: 0,
          id: 1832087,
          known_for_department: 'Diễn viên',
          name: 'Brynn Bowie',
          original_name: 'Brynn Bowie',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aHxINuziBUkfCsFZxKFbIzvpejW.jpg',
          cast_id: 49,
          character: 'Kali Lambert',
          credit_id: '593dd298c3a3680f87025277',
          order: 27,
        },
        {
          adult: false,
          gender: 0,
          id: 1832088,
          known_for_department: 'Diễn viên',
          name: 'Madison Bowie',
          original_name: 'Madison Bowie',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jUAEOuwjiDR6HGhjh9lcHa2T6u6.jpg',
          cast_id: 50,
          character: 'Kali Lambert',
          credit_id: '593dd2cdc3a3680f67025be1',
          order: 28,
        },
        {
          adult: false,
          gender: 0,
          id: 1832089,
          known_for_department: 'Diễn viên',
          name: 'Dylan Quigg',
          original_name: 'Dylan Quigg',
          popularity: 1.62,
          profile_path:
            'https://image.tmdb.org/t/p/w185/i2fVzNkgF1pkKYGLYmOwfb1JVAn.jpg',
          cast_id: 51,
          character: 'Ghoul (uncredited)',
          credit_id: '593dd368925141058f025bf5',
          order: 29,
        },
        {
          adult: false,
          gender: 0,
          id: 145556,
          known_for_department: 'Diễn viên',
          name: 'Kimberly Ables Jindra',
          original_name: 'Kimberly Ables Jindra',
          popularity: 1.114,
          profile_path:
            'https://image.tmdb.org/t/p/w185/et3I0JUM8qzj8LnMDRcZdbBEJ5U.jpg',
          cast_id: 52,
          character: 'Bride (uncredited)',
          credit_id: '593dd3ddc3a3680f33021020',
          order: 30,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 2127,
          known_for_department: 'Directing',
          name: 'James Wan',
          original_name: 'James Wan',
          popularity: 3.445,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5Jtcdbv80koVk0cSZJ0bhqREfaT.jpg',
          credit_id: '52fe48dc9251416c750b592d',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 2127,
          known_for_department: 'Directing',
          name: 'James Wan',
          original_name: 'James Wan',
          popularity: 3.445,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5Jtcdbv80koVk0cSZJ0bhqREfaT.jpg',
          credit_id: '52fe48dc9251416c750b59a5',
          department: 'Biên kịch',
          job: 'Story',
        },
        {
          adult: false,
          gender: 2,
          id: 2128,
          known_for_department: 'Diễn viên',
          name: 'Leigh Whannell',
          original_name: 'Leigh Whannell',
          popularity: 3.049,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wvoTbsROOHfCqJ3Voe9zpal429L.jpg',
          credit_id: '52fe48dc9251416c750b5943',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 2128,
          known_for_department: 'Diễn viên',
          name: 'Leigh Whannell',
          original_name: 'Leigh Whannell',
          popularity: 3.049,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wvoTbsROOHfCqJ3Voe9zpal429L.jpg',
          credit_id: '52fe48dc9251416c750b59b1',
          department: 'Biên kịch',
          job: 'Characters',
        },
        {
          adult: false,
          gender: 2,
          id: 2128,
          known_for_department: 'Diễn viên',
          name: 'Leigh Whannell',
          original_name: 'Leigh Whannell',
          popularity: 3.049,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wvoTbsROOHfCqJ3Voe9zpal429L.jpg',
          credit_id: '52fe48dc9251416c750b59ab',
          department: 'Biên kịch',
          job: 'Story',
        },
        {
          adult: false,
          gender: 1,
          id: 9545,
          known_for_department: 'Production',
          name: 'Anne McCarthy',
          original_name: 'Anne McCarthy',
          popularity: 0.866,
          profile_path: null,
          credit_id: '52fe48dc9251416c750b59d5',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 26714,
          known_for_department: 'Camera',
          name: 'John R. Leonetti',
          original_name: 'John R. Leonetti',
          popularity: 0.753,
          profile_path:
            'https://image.tmdb.org/t/p/w185/uksq1bamaA4MfpBPaP4Vv8BvLpu.jpg',
          credit_id: '52fe48dc9251416c750b59bd',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 13458,
          known_for_department: 'Crew',
          name: 'Joel Kramer',
          original_name: 'Joel Kramer',
          popularity: 0.649,
          profile_path:
            'https://image.tmdb.org/t/p/w185/76EDeGntW2vdvAG7r1TN5JmHDv8.jpg',
          credit_id: '60e1a30e83ee67005ddea54e',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 1,
          id: 21323,
          known_for_department: 'Art',
          name: 'Lori Mazuer',
          original_name: 'Lori Mazuer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a52783ee67005ddea6b1',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 2,
          id: 113043,
          known_for_department: 'Sound',
          name: 'Scott Curtis',
          original_name: 'Scott Curtis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1b5b5fbe36f002d54cfa3',
          department: 'Sound',
          job: 'Foley Mixer',
        },
        {
          adult: false,
          gender: 1,
          id: 113045,
          known_for_department: 'Sound',
          name: 'Dawn Lunsford',
          original_name: 'Dawn Lunsford',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gaGtvXaFT7hZzGc12KsYp91etlh.jpg',
          credit_id: '60e1b592071650007e4527b6',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 1,
          id: 113090,
          known_for_department: 'Sound',
          name: 'Alicia Stevenson',
          original_name: 'Alicia Stevenson',
          popularity: 3.534,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kgYtaWN4VSFh2B0jkHa1GMBOcNU.jpg',
          credit_id: '60e1b55dfbe36f00465b7b24',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 62813,
          known_for_department: 'Editing',
          name: 'Kirk M. Morri',
          original_name: 'Kirk M. Morri',
          popularity: 0.608,
          profile_path: null,
          credit_id: '52fe48dc9251416c750b59c3',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 62775,
          known_for_department: 'Production',
          name: 'Peter Schlessel',
          original_name: 'Peter Schlessel',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/b2z1mYePuy6gGA8AxopcGNKydwK.jpg',
          credit_id: '52fe48dc9251416c750b5999',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 73417,
          known_for_department: 'Sound',
          name: 'Joseph Bishara',
          original_name: 'Joseph Bishara',
          popularity: 2.454,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jkFmkZcd16cEX2yGFNNAsNJyN5U.jpg',
          credit_id: '52fe48dc9251416c750b59b7',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 84348,
          known_for_department: 'Production',
          name: 'Jason Blum',
          original_name: 'Jason Blum',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9tm1oUdA6HOUaaS4bwWI2ihmBVt.jpg',
          credit_id: '60ddb3cfd0b434002aaf3d2e',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 90591,
          known_for_department: 'Production',
          name: 'Oren Peli',
          original_name: 'Oren Peli',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1GQMVWW2G7CpR3kSZMe348CZoQh.jpg',
          credit_id: '52fe48dc9251416c750b597b',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 106933,
          known_for_department: 'Diễn viên',
          name: 'Sophia M. Crawford',
          original_name: 'Sophia M. Crawford',
          popularity: 0.853,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6AwEQ2rV2an1oLE3o3k3eVcGz2L.jpg',
          credit_id: '60e1a41127ff99002accc395',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 1,
          id: 169743,
          known_for_department: 'Art',
          name: 'Jennifer Spence',
          original_name: 'Jennifer Spence',
          popularity: 0.828,
          profile_path: null,
          credit_id: '52fe48dc9251416c750b59c9',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 0,
          id: 549521,
          known_for_department: 'Visual Effects',
          name: 'Juan Carlos Vargas',
          original_name: 'Juan Carlos Vargas',
          popularity: 0.694,
          profile_path: null,
          credit_id: '60e1ba341e9225005df97b86',
          department: 'Visual Effects',
          job: 'CG Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 991706,
          known_for_department: 'Production',
          name: 'Charles Layton',
          original_name: 'Charles Layton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe48dc9251416c750b5993',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 995456,
          known_for_department: 'Production',
          name: 'Steven Schneider',
          original_name: 'Steven Schneider',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe48dc9251416c750b599f',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 999763,
          known_for_department: 'Production',
          name: 'Brian Kavanaugh-Jones',
          original_name: 'Brian Kavanaugh-Jones',
          popularity: 0.611,
          profile_path: null,
          credit_id: '52fe48dc9251416c750b598d',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1030966,
          known_for_department: 'Production',
          name: 'Jeanette Volturno',
          original_name: 'Jeanette Volturno',
          popularity: 0.732,
          profile_path: null,
          credit_id: '52fe48dc9251416c750b5981',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1038313,
          known_for_department: 'Art',
          name: 'Thomas Spence',
          original_name: 'Thomas Spence',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1abf72588230074088839',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 1059590,
          known_for_department: 'Camera',
          name: 'Matt Kennedy',
          original_name: 'Matt Kennedy',
          popularity: 0.828,
          profile_path: null,
          credit_id: '60e1b37b27ff990074d92b05',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 2,
          id: 1125685,
          known_for_department: 'Production',
          name: 'Rick Osako',
          original_name: 'Rick Osako',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a1f1a3b5e6004585fef8',
          department: 'Production',
          job: 'Unit Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1178366,
          known_for_department: 'Art',
          name: 'Jason Garner',
          original_name: 'Jason Garner',
          popularity: 0.98,
          profile_path: null,
          credit_id: '52fe48dc9251416c750b59cf',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 1,
          id: 1183915,
          known_for_department: 'Costume & Make-Up',
          name: 'Kristin M. Burke',
          original_name: 'Kristin M. Burke',
          popularity: 0.6,
          profile_path: null,
          credit_id: '531d800b92514177ab006a7b',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 0,
          id: 1276601,
          known_for_department: 'Production',
          name: 'Lia Buman',
          original_name: 'Lia Buman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe48dc9251416c750b5987',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1276602,
          known_for_department: 'Production',
          name: 'Kellie Roy',
          original_name: 'Kellie Roy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe48dc9251416c750b59db',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 1309884,
          known_for_department: 'Sound',
          name: 'Joe Dzuban',
          original_name: 'Joe Dzuban',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1b5d5a3b5e6007438081c',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1309884,
          known_for_department: 'Sound',
          name: 'Joe Dzuban',
          original_name: 'Joe Dzuban',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1b5e1caa5080060eb1ad8',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1309885,
          known_for_department: 'Sound',
          name: 'Justin Dzuban',
          original_name: 'Justin Dzuban',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1b62e880551005d3f1487',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1317667,
          known_for_department: 'Costume & Make-Up',
          name: 'Eleanor Sabaduquia',
          original_name: 'Eleanor Sabaduquia',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1af4aa3b5e6002911c0af',
          department: 'Costume & Make-Up',
          job: 'Makeup Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 1319040,
          known_for_department: 'Production',
          name: 'Couper Samuelson',
          original_name: 'Couper Samuelson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a2a8fbe36f00465b6893',
          department: 'Production',
          job: 'Associate Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1335432,
          known_for_department: 'Sound',
          name: 'Cole Bluma',
          original_name: 'Cole Bluma',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a92a880551005d3f048d',
          department: 'Sound',
          job: 'Boom Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1338150,
          known_for_department: 'Sound',
          name: 'Charles German',
          original_name: 'Charles German',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a95727ff99002accca35',
          department: 'Sound',
          job: 'Utility Sound',
        },
        {
          adult: false,
          gender: 2,
          id: 1338158,
          known_for_department: 'Crew',
          name: 'John Yarbrough',
          original_name: 'John Yarbrough',
          popularity: 0.605,
          profile_path: null,
          credit_id: '60e1b4e8105611005f9d20ad',
          department: 'Crew',
          job: 'Transportation Captain',
        },
        {
          adult: false,
          gender: 1,
          id: 1344842,
          known_for_department: 'Directing',
          name: 'Renetta G. Amador',
          original_name: 'Renetta G. Amador',
          popularity: 0.828,
          profile_path: null,
          credit_id: '60e1a8a8fbe36f005eea52f4',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1358563,
          known_for_department: 'Crew',
          name: "Tree O'Toole",
          original_name: "Tree O'Toole",
          popularity: 1.214,
          profile_path: null,
          credit_id: '60e1a34a4ca67600750184e4',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 1,
          id: 1364121,
          known_for_department: 'Crew',
          name: 'Emily Brobst',
          original_name: 'Emily Brobst',
          popularity: 1.836,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vc9Y7bM9PnXvt5D5BuozJvP5Gzd.jpg',
          credit_id: '60e1a4492588230074088023',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1374767,
          known_for_department: 'Costume & Make-Up',
          name: 'Jennifer Tyre',
          original_name: 'Jennifer Tyre',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1aee1caa508002efc0626',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1378250,
          known_for_department: 'Crew',
          name: 'Rhona Gordon',
          original_name: 'Rhona Gordon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1b22d071650007e452284',
          department: 'Crew',
          job: 'Studio Teacher',
        },
        {
          adult: false,
          gender: 0,
          id: 1393390,
          known_for_department: 'Visual Effects',
          name: 'Ray McIntyre Jr.',
          original_name: 'Ray McIntyre Jr.',
          popularity: 0.969,
          profile_path: null,
          credit_id: '5d6bf531549dda24447eab63',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1395465,
          known_for_department: 'Crew',
          name: 'Josie Batorski',
          original_name: 'Josie Batorski',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1b2844ca676007501953a',
          department: 'Crew',
          job: 'Studio Teacher',
        },
        {
          adult: false,
          gender: 1,
          id: 1400877,
          known_for_department: 'Costume & Make-Up',
          name: 'Janet Ingram',
          original_name: 'Janet Ingram',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1ae85a3b5e6002911c010',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1401857,
          known_for_department: 'Production',
          name: 'Phillip Dawe',
          original_name: 'Phillip Dawe',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a2ce9979d2007f4e7650',
          department: 'Production',
          job: 'Associate Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1403508,
          known_for_department: 'Crew',
          name: 'James G. Brill',
          original_name: 'James G. Brill',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1b4c5caa5080048e56fe7',
          department: 'Crew',
          job: 'Transportation Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1404311,
          known_for_department: 'Art',
          name: 'Charli Palazzo',
          original_name: 'Charli Palazzo',
          popularity: 0.98,
          profile_path: null,
          credit_id: '60e1adfafbe36f005eea584d',
          department: 'Art',
          job: 'Paint Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1406389,
          known_for_department: 'Sound',
          name: 'Bruce Tanis',
          original_name: 'Bruce Tanis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1b6a783ee670074bc12ea',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1409283,
          known_for_department: 'Crew',
          name: 'Alex L. Worman',
          original_name: 'Alex L. Worman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1b33b1e9225005df972c8',
          department: 'Crew',
          job: 'Unit Publicist',
        },
        {
          adult: false,
          gender: 2,
          id: 1410152,
          known_for_department: 'Sound',
          name: 'Nathan Hankins',
          original_name: 'Nathan Hankins',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1b6ea9979d2007f4e8c9d',
          department: 'Sound',
          job: 'Assistant Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1412767,
          known_for_department: 'Costume & Make-Up',
          name: "Yesim 'Shimmy' Osman",
          original_name: "Yesim 'Shimmy' Osman",
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1afa227ff99005df745e2',
          department: 'Costume & Make-Up',
          job: 'Hair Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 1413120,
          known_for_department: 'Camera',
          name: 'Mark La Bonge',
          original_name: 'Mark La Bonge',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a5b51e922500462888a2',
          department: 'Camera',
          job: 'Steadicam Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1413120,
          known_for_department: 'Camera',
          name: 'Mark La Bonge',
          original_name: 'Mark La Bonge',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a6001e9225005df9614a',
          department: 'Camera',
          job: '"B" Camera Operator',
        },
        {
          adult: false,
          gender: 1,
          id: 1417867,
          known_for_department: 'Production',
          name: 'Laura Altmann',
          original_name: 'Laura Altmann',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a485071650002d67142c',
          department: 'Production',
          job: 'Production Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1417875,
          known_for_department: 'Crew',
          name: 'Mark Gullesserian',
          original_name: 'Mark Gullesserian',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1acb8a3b5e6005d89bc4a',
          department: 'Crew',
          job: 'Special Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1417887,
          known_for_department: 'Production',
          name: 'Justin Carville',
          original_name: 'Justin Carville',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1b1b9071650002d671f91',
          department: 'Production',
          job: 'Production Accountant',
        },
        {
          adult: false,
          gender: 0,
          id: 1417888,
          known_for_department: 'Production',
          name: 'Kandice Billingsley',
          original_name: 'Kandice Billingsley',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1ace5258823004723321c',
          department: 'Production',
          job: 'Location Manager',
        },
        {
          adult: false,
          gender: 2,
          id: 1421252,
          known_for_department: 'Lighting',
          name: 'Tim Marshall',
          original_name: 'Tim Marshall',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a981caa5080060eb0be9',
          department: 'Lighting',
          job: 'Chief Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 1425764,
          known_for_department: 'Crew',
          name: 'David Combs',
          original_name: 'David Combs',
          popularity: 0.694,
          profile_path: null,
          credit_id: '60e1b2f8a3b5e6005d89c2d6',
          department: 'Crew',
          job: 'Studio Teacher',
        },
        {
          adult: false,
          gender: 1,
          id: 1430989,
          known_for_department: 'Costume & Make-Up',
          name: 'Liz Mendoza',
          original_name: 'Liz Mendoza',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1af739979d20046a02c00',
          department: 'Costume & Make-Up',
          job: 'Key Makeup Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 1445583,
          known_for_department: 'Crew',
          name: 'Adam Hart',
          original_name: 'Adam Hart',
          popularity: 0.728,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lVQreqn2sL33TgPlqY12YymQ3e8.jpg',
          credit_id: '60e1a3efa3b5e6005d89b2d0',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1452334,
          known_for_department: 'Art',
          name: 'Scott Nifong',
          original_name: 'Scott Nifong',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1ac18caa5080060eb0f20',
          department: 'Art',
          job: 'Assistant Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 1478662,
          known_for_department: 'Production',
          name: 'Bailey Conway',
          original_name: 'Bailey Conway',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a2eb258823002d859247',
          department: 'Production',
          job: 'Associate Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1495875,
          known_for_department: 'Editing',
          name: 'Regan Copeland',
          original_name: 'Regan Copeland',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1bb0610561100761bbd72',
          department: 'Editing',
          job: 'Digital Intermediate Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1517894,
          known_for_department: 'Diễn viên',
          name: 'Scott Leva',
          original_name: 'Scott Leva',
          popularity: 0.828,
          profile_path:
            'https://image.tmdb.org/t/p/w185/VSRX2k8pYXTHmnEOvosUFtY4Zh.jpg',
          credit_id: '60e1a45c258823007408802d',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1525059,
          known_for_department: 'Diễn viên',
          name: 'Stephen Bralver',
          original_name: 'Stephen Bralver',
          popularity: 1.094,
          profile_path:
            'https://image.tmdb.org/t/p/w185/v434dHQbLOTOFp50yUNPgkob5vn.jpg',
          credit_id: '60e1a32d880551005d3efe8c',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 1,
          id: 1535393,
          known_for_department: 'Diễn viên',
          name: 'Dorenda Moore',
          original_name: 'Dorenda Moore',
          popularity: 0.84,
          profile_path: null,
          credit_id: '60e1a3b54ca676005e10bc2e',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1545436,
          known_for_department: 'Editing',
          name: 'Dennis Alaniz',
          original_name: 'Dennis Alaniz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1afeb1056110047f2a508',
          department: 'Editing',
          job: 'Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1548075,
          known_for_department: 'Art',
          name: 'Jennifer Stoefen',
          original_name: 'Jennifer Stoefen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1ae5f83ee670027be8475',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1552347,
          known_for_department: 'Diễn viên',
          name: 'Joel Michael Kramer',
          original_name: 'Joel Michael Kramer',
          popularity: 1.012,
          profile_path:
            'https://image.tmdb.org/t/p/w185/h4Jwmi9NzcAZAEYp9yIUC5JQDWU.jpg',
          credit_id: '60e1a3de10561100761ba058',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1568318,
          known_for_department: 'Diễn viên',
          name: 'Linda Ljoka',
          original_name: 'Linda Ljoka',
          popularity: 1.216,
          profile_path: null,
          credit_id: '60e1b82e4ca676002dde8eb1',
          department: 'Sound',
          job: 'Loop Group Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1591168,
          known_for_department: 'Production',
          name: 'Morgan Robbins',
          original_name: 'Morgan Robbins',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1b157071650007e452120',
          department: 'Production',
          job: 'Casting Associate',
        },
        {
          adult: false,
          gender: 0,
          id: 1603334,
          known_for_department: 'Sound',
          name: 'Buck Robinson',
          original_name: 'Buck Robinson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a9089979d2005d4569a1',
          department: 'Sound',
          job: 'Production Sound Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1627721,
          known_for_department: 'Editing',
          name: 'Susan Alexander',
          original_name: 'Susan Alexander',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1bb9227ff990074d937be',
          department: 'Editing',
          job: 'Digital Intermediate Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 1647187,
          known_for_department: 'Diễn viên',
          name: 'Tammie Baird',
          original_name: 'Tammie Baird',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a429258823005d7b4588',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1647714,
          known_for_department: 'Camera',
          name: 'Alan Cohen',
          original_name: 'Alan Cohen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a7391056110047f29a7f',
          department: 'Camera',
          job: 'First Assistant "B" Camera',
        },
        {
          adult: false,
          gender: 2,
          id: 1647993,
          known_for_department: 'Directing',
          name: 'Albert Cho',
          original_name: 'Albert Cho',
          popularity: 1.214,
          profile_path: null,
          credit_id: '60e1a218caa5080048e558e1',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1667250,
          known_for_department: 'Camera',
          name: 'Andrew Degnan',
          original_name: 'Andrew Degnan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a7d69979d200294c38e8',
          department: 'Camera',
          job: 'First Assistant "B" Camera',
        },
        {
          adult: false,
          gender: 2,
          id: 1737654,
          known_for_department: 'Sound',
          name: 'Judah Getz',
          original_name: 'Judah Getz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1b538caa5080060eb1a02',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1739784,
          known_for_department: 'Lighting',
          name: 'Wayne Marshall',
          original_name: 'Wayne Marshall',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a9a41056110047f29d3f',
          department: 'Lighting',
          job: 'Best Boy Electric',
        },
        {
          adult: false,
          gender: 0,
          id: 1741180,
          known_for_department: 'Camera',
          name: 'Colin Edwards',
          original_name: 'Colin Edwards',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1ab064ca67600461d9ab7',
          department: 'Camera',
          job: 'Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1747999,
          known_for_department: 'Costume & Make-Up',
          name: 'Julia Gombert',
          original_name: 'Julia Gombert',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1af28880551005d3f0b3f',
          department: 'Costume & Make-Up',
          job: 'Ager/Dyer',
        },
        {
          adult: false,
          gender: 1,
          id: 1759274,
          known_for_department: 'Production',
          name: 'Jessica Hall',
          original_name: 'Jessica Hall',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a279258823002d8591fe',
          department: 'Production',
          job: 'Associate Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1761066,
          known_for_department: 'Lighting',
          name: 'Renzo Bartolotta',
          original_name: 'Renzo Bartolotta',
          popularity: 0.694,
          profile_path: null,
          credit_id: '60e1a9ec071650005d9e4684',
          department: 'Lighting',
          job: 'Rigging Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1773847,
          known_for_department: 'Visual Effects',
          name: 'J. Thomas Wilson',
          original_name: 'J. Thomas Wilson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1b9871e9225002cc51212',
          department: 'Visual Effects',
          job: 'Compositing Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1775182,
          known_for_department: 'Crew',
          name: 'Darrin Rolls',
          original_name: 'Darrin Rolls',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1ada1caa5080060eb108f',
          department: 'Art',
          job: 'Construction Foreman',
        },
        {
          adult: false,
          gender: 0,
          id: 1817641,
          known_for_department: 'Editing',
          name: 'Mark Griffith',
          original_name: 'Mark Griffith',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1ba9c83ee670046f24315',
          department: 'Editing',
          job: 'Digital Intermediate Colorist',
        },
        {
          adult: false,
          gender: 0,
          id: 1831356,
          known_for_department: 'Crew',
          name: 'Niccole Osborn',
          original_name: 'Niccole Osborn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1b01a4ca676005e10c9d1',
          department: 'Production',
          job: 'Post Production Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1836446,
          known_for_department: 'Production',
          name: 'Tony Roman',
          original_name: 'Tony Roman',
          popularity: 0.694,
          profile_path: null,
          credit_id: '60e1a4fe25882300740880ac',
          department: 'Crew',
          job: 'Post Production Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1837370,
          known_for_department: 'Camera',
          name: 'Bryan Antin',
          original_name: 'Bryan Antin',
          popularity: 1.008,
          profile_path: null,
          credit_id: '60e1ab75071650005d9e4862',
          department: 'Camera',
          job: 'Grip',
        },
        {
          adult: false,
          gender: 2,
          id: 1953617,
          known_for_department: 'Camera',
          name: 'Darrell B. Sheldon',
          original_name: 'Darrell B. Sheldon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a5414ca676002dde7760',
          department: 'Camera',
          job: '"A" Camera Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 1955824,
          known_for_department: 'Editing',
          name: 'Bob Fredrickson',
          original_name: 'Bob Fredrickson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1bad6071650007e4531bc',
          department: 'Editing',
          job: 'Digital Intermediate Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 2005006,
          known_for_department: 'Camera',
          name: 'Dan Reilly',
          original_name: 'Dan Reilly',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1aa091e9225002cc4fdf4',
          department: 'Camera',
          job: 'Key Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2005009,
          known_for_department: 'Lighting',
          name: 'Quinton Reilly',
          original_name: 'Quinton Reilly',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1aa3c9979d2005d456ae8',
          department: 'Camera',
          job: 'Best Boy Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2038967,
          known_for_department: 'Sound',
          name: 'Frank Sharp',
          original_name: 'Frank Sharp',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xTPNnbTJInpn9lRKzO1thpDroOD.jpg',
          credit_id: '60e1b7df1e9225005df97822',
          department: 'Sound',
          job: 'Loop Group Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2047454,
          known_for_department: 'Camera',
          name: 'Doug Price',
          original_name: 'Doug Price',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a873a3b5e6007437f7fc',
          department: 'Camera',
          job: 'Second Assistant "B" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2062540,
          known_for_department: 'Visual Effects',
          name: 'Patrick Trahan',
          original_name: 'Patrick Trahan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1b967a3b5e60074380dc5',
          department: 'Visual Effects',
          job: 'Compositing Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2072599,
          known_for_department: 'Camera',
          name: 'Justin Watson',
          original_name: 'Justin Watson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a6b683ee670046f229a2',
          department: 'Camera',
          job: 'Second Assistant "A" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2072599,
          known_for_department: 'Camera',
          name: 'Justin Watson',
          original_name: 'Justin Watson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a8268805510074dc3029',
          department: 'Camera',
          job: 'Second Assistant "B" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2155347,
          known_for_department: 'Visual Effects',
          name: 'Jordan Alphonso',
          original_name: 'Jordan Alphonso',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1b9451e9225005df979bf',
          department: 'Visual Effects',
          job: 'Compositing Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2155813,
          known_for_department: 'Camera',
          name: 'Kevin Huver',
          original_name: 'Kevin Huver',
          popularity: 0.98,
          profile_path: null,
          credit_id: '60e1a6a01e9225007ed36071',
          department: 'Camera',
          job: 'Second Assistant "A" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2173649,
          known_for_department: 'Camera',
          name: 'Scott Ronnow',
          original_name: 'Scott Ronnow',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a6259979d20046a02019',
          department: 'Camera',
          job: 'First Assistant "A" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2195119,
          known_for_department: 'Costume & Make-Up',
          name: 'Emily Dominguez',
          original_name: 'Emily Dominguez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1aea5fbe36f005eea5937',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2227259,
          known_for_department: 'Camera',
          name: 'Chuck Whelan',
          original_name: 'Chuck Whelan',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a65f1e9225004628894d',
          department: 'Camera',
          job: 'First Assistant "A" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2249016,
          known_for_department: 'Production',
          name: 'Christina Beaumont',
          original_name: 'Christina Beaumont',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1ad1b27ff99004708ecba',
          department: 'Production',
          job: 'Assistant Location Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 2254685,
          known_for_department: 'Directing',
          name: 'Jeff Bilger',
          original_name: 'Jeff Bilger',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5f45aa8c4142910038574629',
          department: 'Directing',
          job: 'Second Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2264741,
          known_for_department: 'Camera',
          name: 'Dennis Skog',
          original_name: 'Dennis Skog',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1aa7efbe36f007407aada',
          department: 'Camera',
          job: 'Dolly Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2281509,
          known_for_department: 'Visual Effects',
          name: 'David Ridlen',
          original_name: 'David Ridlen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1ba64071650007e4530e8',
          department: 'Visual Effects',
          job: 'CG Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2613640,
          known_for_department: 'Directing',
          name: 'Nathan Kimball',
          original_name: 'Nathan Kimball',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1b1919979d200294c454c',
          department: 'Directing',
          job: 'Second Second Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2636850,
          known_for_department: 'Production',
          name: 'Chris Ruiz',
          original_name: 'Chris Ruiz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a8ea071650004616af0c',
          department: 'Production',
          job: 'Production Secretary',
        },
        {
          adult: false,
          gender: 0,
          id: 2674487,
          known_for_department: 'Visual Effects',
          name: 'Daniel Briney',
          original_name: 'Daniel Briney',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1b9c81056110047f2b292',
          department: 'Visual Effects',
          job: 'Compositing Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 2702984,
          known_for_department: 'Visual Effects',
          name: 'Thomas Mathai',
          original_name: 'Thomas Mathai',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1b913071650007e452e0b',
          department: 'Visual Effects',
          job: 'Visual Effects Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2726964,
          known_for_department: 'Camera',
          name: 'Ryan Houghton',
          original_name: 'Ryan Houghton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1abd2a3b5e6002911bd13',
          department: 'Camera',
          job: 'Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2726970,
          known_for_department: 'Camera',
          name: 'Scott Floren',
          original_name: 'Scott Floren',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1abbb071650002d6719ac',
          department: 'Camera',
          job: 'Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2726978,
          known_for_department: 'Camera',
          name: 'Martin Gillette',
          original_name: 'Martin Gillette',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1ab408805510074dc33a6',
          department: 'Camera',
          job: 'Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2919216,
          known_for_department: 'Art',
          name: 'Jeremy Stecker',
          original_name: 'Jeremy Stecker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1ac89071650004616b2d6',
          department: 'Crew',
          job: 'Propmaker',
        },
        {
          adult: false,
          gender: 1,
          id: 3120601,
          known_for_department: 'Production',
          name: 'Karen M. Fuchs',
          original_name: 'Karen M. Fuchs',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1b1eefbe36f005eea5d49',
          department: 'Production',
          job: 'First Assistant Accountant',
        },
        {
          adult: false,
          gender: 1,
          id: 3120605,
          known_for_department: 'Production',
          name: 'Mandy Yaeger',
          original_name: 'Mandy Yaeger',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60e1a8c9fbe36f007407a927',
          department: 'Production',
          job: 'Production Coordinator',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'Gimly',
          author_details: {
            name: 'Gimly',
            username: 'Ruuz',
            avatar_path: '/xUObnJSvHrFPsIpoDmb1jiQZLq7.jpg',
            rating: 5.0,
          },
          content:
            'A decent enough movie I suppose, and an interesting sequel, but pales in comparison to the first.\r\n\r\n_Final rating:★★½ - Had a lot that appealed to me, didn’t quite work as a whole._',
          created_at: '2017-02-06T06:08:26.342Z',
          id: '589812da9251417a7c0051e9',
          updated_at: '2021-06-23T15:57:53.254Z',
          url: 'https://www.themoviedb.org/review/589812da9251417a7c0051e9',
        },
      ],
      total_pages: 1,
      total_results: 1,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/94zFmmvcY83vHdLKci3dOIVhnc8.jpg',
    belongs_to_collection: null,
    budget: 0,
    genres: [{ id: 35, name: 'Phim Hài' }],
    homepage: '',
    id: 269242,
    imdb_id: 'tt3307774',
    original_language: 'en',
    original_title: 'Alpha House',
    overview:
      'Bộ phim kể về 2 chàng trai vui tính, hồn nhiên được gia nhập một CLB sinh viên lớn và có rất nhiều điều thú vị. Ở đây các cậu tha hồ tiệc tùng và vui chơi với những cô gái nóng bỏng.',
    popularity: 6.214,
    poster_path:
      'https://image.tmdb.org/t/p/w342/s00AwtusVVG8lpA3fquKaE63NWW.jpg',
    production_companies: [
      { id: 40745, logo_path: null, name: 'Broken Films', origin_country: '' },
      {
        id: 1311,
        logo_path: '/ic2bTizdzRLDVzAvN7MXdUg3WQV.png',
        name: 'The Asylum',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2014-03-11',
    revenue: 0,
    runtime: 1,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'The wildest frat house is going... Co-Ed!',
    title: 'Ngôi nhà sung sướng',
    video: false,
    vote_average: 4.4,
    vote_count: 53,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: '"Alpha House" Feature Film Trailer (from The Asylum)',
          key: '5dHIVO0mcz8',
          published_at: '2014-02-24T23:47:26.000Z',
          site: 'YouTube',
          size: 720,
          type: 'Trailer',
          official: false,
          id: '536e9fbc0e0a2647cb010bb4',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 0,
          id: 1843902,
          known_for_department: 'Diễn viên',
          name: 'Julien Ari',
          original_name: 'Julien Ari',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5xvOg5uinnthNyU6EUFWCng8UsW.jpg',
          cast_id: 30,
          character: 'Cameron',
          credit_id: '61746e518ddc340044b5a1b6',
          order: 0,
        },
        {
          adult: false,
          gender: 1,
          id: 1318329,
          known_for_department: 'Diễn viên',
          name: 'Heather Paige Cohn',
          original_name: 'Heather Paige Cohn',
          popularity: 1.286,
          profile_path:
            'https://image.tmdb.org/t/p/w185/62Hn3VwUGHBDkaOGTWd3Kffo1Rq.jpg',
          cast_id: 4,
          character: 'Kelly Kramer',
          credit_id: '536e9ee3c3a368124100d8f8',
          order: 1,
        },
        {
          adult: false,
          gender: 1,
          id: 80732,
          known_for_department: 'Diễn viên',
          name: "Jean Louise O'Sullivan",
          original_name: "Jean Louise O'Sullivan",
          popularity: 1.619,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1l6YxXt4CLP3hhnZOBLB40qXHzD.jpg',
          cast_id: 6,
          character: 'Melanie Parker',
          credit_id: '536ea1160e0a2647c80111d6',
          order: 2,
        },
        {
          adult: false,
          gender: 0,
          id: 117672,
          known_for_department: 'Diễn viên',
          name: "Chris O'Brien",
          original_name: "Chris O'Brien",
          popularity: 0.6,
          profile_path: null,
          cast_id: 5,
          character: 'Zack',
          credit_id: '536e9ef5c3a368122600d133',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 43961,
          known_for_department: 'Diễn viên',
          name: 'D.C. Douglas',
          original_name: 'D.C. Douglas',
          popularity: 1.486,
          profile_path:
            'https://image.tmdb.org/t/p/w185/suXu7UYETw3LINlZjedvpxbwtnD.jpg',
          cast_id: 15,
          character: 'Dean Marshall',
          credit_id: '57d2fcbfc3a36820030002cb',
          order: 4,
        },
        {
          adult: false,
          gender: 1,
          id: 1319600,
          known_for_department: 'Diễn viên',
          name: 'Sam Aotaki',
          original_name: 'Sam Aotaki',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hiyuoZ53e0YrZBXa47teytRCYiN.jpg',
          cast_id: 8,
          character: 'Natalie',
          credit_id: '55cc32da925141764b001db4',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 1386925,
          known_for_department: 'Diễn viên',
          name: 'Anna Beletzki',
          original_name: 'Anna Beletzki',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mFdRtZ9UByZO98ALLVVsiiOFnvb.jpg',
          cast_id: 9,
          character: 'Misty',
          credit_id: '55cc32eec3a3685708001e04',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 1395209,
          known_for_department: 'Diễn viên',
          name: 'Eli Bildner',
          original_name: 'Eli Bildner',
          popularity: 1.277,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7v8lEz0bwtICOoeqxmZKawl5axS.jpg',
          cast_id: 10,
          character: 'Stuart',
          credit_id: '55cc32fc925141764f001ddf',
          order: 7,
        },
        {
          adult: false,
          gender: 1,
          id: 1377616,
          known_for_department: 'Diễn viên',
          name: 'Audrey Ellis Fox',
          original_name: 'Audrey Ellis Fox',
          popularity: 1.286,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gPdAaGRqtJGKvjwt88NRlxtcoJn.jpg',
          cast_id: 17,
          character: 'Emily',
          credit_id: '5a791a70c3a368225501f0ce',
          order: 8,
        },
        {
          adult: false,
          gender: 0,
          id: 2890045,
          known_for_department: 'Diễn viên',
          name: 'Jacquie Cardinale',
          original_name: 'Jacquie Cardinale',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/Ade11CrqEgoKR4WlrpPdeJsYZaM.jpg',
          cast_id: 19,
          character: 'Renee',
          credit_id: '5fd3d6109e4586003dba4ccc',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 1181339,
          known_for_department: 'Diễn viên',
          name: 'Melvin Gregg',
          original_name: 'Melvin Gregg',
          popularity: 1.135,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tIeYOezPPBpUmVuzYO7idcWPuUz.jpg',
          cast_id: 14,
          character: 'Kyle',
          credit_id: '55cc333cc3a3685701001f10',
          order: 10,
        },
        {
          adult: false,
          gender: 0,
          id: 1525857,
          known_for_department: 'Diễn viên',
          name: 'Nina Kate',
          original_name: 'Nina Kate',
          popularity: 0.6,
          profile_path: null,
          cast_id: 31,
          character: 'Allison',
          credit_id: '61746ece0d5d85004377f81c',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 592340,
          known_for_department: 'Diễn viên',
          name: 'Jon Kondelik',
          original_name: 'Jon Kondelik',
          popularity: 0.6,
          profile_path: null,
          cast_id: 32,
          character: 'Edgar',
          credit_id: '61746ed51f3e6000449617c9',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 1590297,
          known_for_department: 'Diễn viên',
          name: 'A.J. Rivera',
          original_name: 'A.J. Rivera',
          popularity: 1.178,
          profile_path: null,
          cast_id: 33,
          character: 'Marty',
          credit_id: '61746edeb6c2640090c877bc',
          order: 13,
        },
        {
          adult: false,
          gender: 1,
          id: 1072882,
          known_for_department: 'Diễn viên',
          name: 'Mindy Robinson',
          original_name: 'Mindy Robinson',
          popularity: 2.033,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wRStB9kFS531TAtjP3UoR8ODd9S.jpg',
          cast_id: 34,
          character: 'Abby',
          credit_id: '61746ee5b6c2640090c877c7',
          order: 14,
        },
        {
          adult: false,
          gender: 0,
          id: 2509548,
          known_for_department: 'Diễn viên',
          name: 'Grace Roubidoux',
          original_name: 'Grace Roubidoux',
          popularity: 0.6,
          profile_path: null,
          cast_id: 35,
          character: 'Katie',
          credit_id: '61746eee8ddc34002d476869',
          order: 15,
        },
        {
          adult: false,
          gender: 1,
          id: 1496350,
          known_for_department: 'Diễn viên',
          name: 'Janna VanHeertum',
          original_name: 'Janna VanHeertum',
          popularity: 0.608,
          profile_path:
            'https://image.tmdb.org/t/p/w185/u2nyxsbcf36wkWk7O4QqDj1d5qP.jpg',
          cast_id: 12,
          character: 'Jessica',
          credit_id: '55cc3320c3a3685708001e0e',
          order: 16,
        },
        {
          adult: false,
          gender: 2,
          id: 2648891,
          known_for_department: 'Diễn viên',
          name: 'Taylor Zakhar Perez',
          original_name: 'Taylor Zakhar Perez',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/a3sVwrVoMlYuDHRPUZmxrFFqHqM.jpg',
          cast_id: 36,
          character: 'Trent',
          credit_id: '61746ef50d5d85004377f875',
          order: 17,
        },
        {
          adult: false,
          gender: 0,
          id: 1808223,
          known_for_department: 'Diễn viên',
          name: 'Brent A. McCoy',
          original_name: 'Brent A. McCoy',
          popularity: 0.6,
          profile_path: null,
          cast_id: 37,
          character: 'Dean Bungalon',
          credit_id: '61746eff65e0a2006275aaac',
          order: 18,
        },
        {
          adult: false,
          gender: 0,
          id: 2692498,
          known_for_department: 'Diễn viên',
          name: 'David Brite',
          original_name: 'David Brite',
          popularity: 0.6,
          profile_path: null,
          cast_id: 38,
          character: 'Last Virgin Mary Suit',
          credit_id: '61746f9bfd7aa400435deb41',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 1506829,
          known_for_department: 'Diễn viên',
          name: 'Baker Chase Powell',
          original_name: 'Baker Chase Powell',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sEqFcESUZqeWIkMfmeBSq8kQZvj.jpg',
          cast_id: 39,
          character: 'Super Hippie',
          credit_id: '61746fae3f48330029690207',
          order: 20,
        },
        {
          adult: false,
          gender: 2,
          id: 1684648,
          known_for_department: 'Diễn viên',
          name: 'Justin Cornwell',
          original_name: 'Justin Cornwell',
          popularity: 0.629,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xFmMBP5qtAiLDpbrziXOYdAkK7.jpg',
          cast_id: 40,
          character: 'DJ Furry',
          credit_id: '61746fb9f85958004349fe3f',
          order: 21,
        },
        {
          adult: false,
          gender: 0,
          id: 2641198,
          known_for_department: 'Diễn viên',
          name: 'Glen Hill',
          original_name: 'Glen Hill',
          popularity: 0.6,
          profile_path: null,
          cast_id: 41,
          character: 'Dean Elias',
          credit_id: '61746fc7b3316b0044aa13b2',
          order: 22,
        },
        {
          adult: false,
          gender: 2,
          id: 1288778,
          known_for_department: 'Diễn viên',
          name: 'Michael Lewis Hudson',
          original_name: 'Michael Lewis Hudson',
          popularity: 0.6,
          profile_path: null,
          cast_id: 42,
          character: 'Dude',
          credit_id: '61746fd0a217c00043435e77',
          order: 23,
        },
        {
          adult: false,
          gender: 1,
          id: 1471377,
          known_for_department: 'Diễn viên',
          name: 'Vanessa Sheri',
          original_name: 'Vanessa Sheri',
          popularity: 0.6,
          profile_path: null,
          cast_id: 43,
          character: 'Boob Pong Hero',
          credit_id: '61746fe5176a940042bc3bb7',
          order: 24,
        },
        {
          adult: false,
          gender: 1,
          id: 1153680,
          known_for_department: 'Diễn viên',
          name: 'Jessica Sonneborn',
          original_name: 'Jessica Sonneborn',
          popularity: 0.968,
          profile_path:
            'https://image.tmdb.org/t/p/w185/8oSoBowoQZrtNeihHKJZDGgkmsB.jpg',
          cast_id: 44,
          character: 'Stephanie',
          credit_id: '61746feecadb6b00439759d5',
          order: 25,
        },
        {
          adult: false,
          gender: 1,
          id: 2649112,
          known_for_department: 'Diễn viên',
          name: 'Erica Allseitz',
          original_name: 'Erica Allseitz',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cpVGlcdIesTrpdZauE3x8ILrOj8.jpg',
          cast_id: 45,
          character: 'Background',
          credit_id: '61746ffffd7aa4006614e63e',
          order: 26,
        },
        {
          adult: false,
          gender: 1,
          id: 1503678,
          known_for_department: 'Diễn viên',
          name: 'Destiny Soria',
          original_name: 'Destiny Soria',
          popularity: 1.094,
          profile_path: null,
          cast_id: 18,
          character: 'Background',
          credit_id: '5f5d7ef7bdc34c0039ed5ed7',
          order: 27,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 30053,
          known_for_department: 'Production',
          name: 'David Michael Latt',
          original_name: 'David Michael Latt',
          popularity: 1.224,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cBkmGgFkGFFyyE6aWDYovvaHL0g.jpg',
          credit_id: '61746ddd172d7f0092510c63',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 128763,
          known_for_department: 'Sound',
          name: 'Chris Ridenhour',
          original_name: 'Chris Ridenhour',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7tDpp0CuTMr6EV03oCDZvJW4s9b.jpg',
          credit_id: '61746def65e0a2006275a848',
          department: 'Sound',
          job: 'Music',
        },
        {
          adult: false,
          gender: 2,
          id: 236844,
          known_for_department: 'Production',
          name: 'David Rimawi',
          original_name: 'David Rimawi',
          popularity: 0.98,
          profile_path: null,
          credit_id: '61746de7172d7f006737a49a',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1072870,
          known_for_department: 'Editing',
          name: 'Bobby K. Richardson',
          original_name: 'Bobby K. Richardson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61746dff172d7f006737a4c8',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1192110,
          known_for_department: 'Camera',
          name: 'Laura Beth Love',
          original_name: 'Laura Beth Love',
          popularity: 0.98,
          profile_path: null,
          credit_id: '61746df6cadb6b0043975533',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 1318326,
          known_for_department: 'Biên kịch',
          name: 'Jacob Cooney',
          original_name: 'Jacob Cooney',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4hEMgTX1BBXXNPGNFga8xY3e7MS.jpg',
          credit_id: '536e9e18c3a368122000d584',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 1318326,
          known_for_department: 'Biên kịch',
          name: 'Jacob Cooney',
          original_name: 'Jacob Cooney',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4hEMgTX1BBXXNPGNFga8xY3e7MS.jpg',
          credit_id: '536e9df7c3a368124100d8e0',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1318327,
          known_for_department: 'Biên kịch',
          name: 'Brandon Trenz',
          original_name: 'Brandon Trenz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '536e9e36c3a368124100d8e7',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 0,
          id: 1332522,
          known_for_department: 'Art',
          name: 'F. Joseph Burns',
          original_name: 'F. Joseph Burns',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61746e08b3316b006578b555',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 1,
          id: 1452241,
          known_for_department: 'Costume & Make-Up',
          name: 'Mariah Kraft',
          original_name: 'Mariah Kraft',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61746e26a217c00062532470',
          department: 'Costume & Make-Up',
          job: 'Makeup Department Head',
        },
        {
          adult: false,
          gender: 0,
          id: 1573368,
          known_for_department: 'Costume & Make-Up',
          name: 'Elizabeth Magallanes',
          original_name: 'Elizabeth Magallanes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61746e1ecadb6b002a1f0751',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 0,
          id: 3281818,
          known_for_department: 'Art',
          name: 'Becky Hughes',
          original_name: 'Becky Hughes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61746e10e72fe8002b50cd91',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 0,
          id: 3281818,
          known_for_department: 'Art',
          name: 'Becky Hughes',
          original_name: 'Becky Hughes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '61746e15894ed6002337ccea',
          department: 'Art',
          job: 'Art Direction',
        },
      ],
    },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/vfuzELmhBjBTswXj2Vqxnu5ge4g.jpg',
    belongs_to_collection: null,
    budget: 30000000,
    genres: [
      { id: 53, name: 'Phim Gây Cấn' },
      { id: 80, name: 'Phim Hình Sự' },
      { id: 18, name: 'Phim Chính Kịch' },
    ],
    homepage: 'https://www.thelittlethingsmovie.com',
    id: 602269,
    imdb_id: 'tt10016180',
    original_language: 'en',
    original_title: 'The Little Things',
    overview:
      'Phó cảnh sát trưởng Joe "Deke" Deacon gia nhập lực lượng với Sgt. Jim Baxter để tìm kiếm kẻ giết người hàng loạt đang khủng bố Los Angeles. Khi họ theo dõi thủ phạm, Baxter không biết rằng cuộc điều tra đang tìm kiếm những dư âm về quá khứ của Deke, khám phá ra những bí mật đáng lo ngại có thể đe dọa nhiều hơn vụ án của anh ta.',
    popularity: 98.654,
    poster_path:
      'https://image.tmdb.org/t/p/w342/tLO1aD1ghdtVMT32z2sRmzgYKYd.jpg',
    production_companies: [
      {
        id: 174,
        logo_path: '/IuAlhI9eVC9Z8UQWOIDdWRKSEJ.png',
        name: 'Warner Bros. Pictures',
        origin_country: 'US',
      },
      {
        id: 2605,
        logo_path: null,
        name: 'Gran Via Productions',
        origin_country: 'US',
      },
    ],
    production_countries: [{ iso_3166_1: 'US', name: 'Hoa Kì' }],
    release_date: '2021-01-28',
    revenue: 29844012,
    runtime: 128,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
    ],
    status: 'Đã phát hành',
    tagline: 'Some things never let us go.',
    title: 'Manh Mối Nhỏ Nhặt',
    video: false,
    vote_average: 6.4,
    vote_count: 1376,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Little Things - 10 Minute Preview - Warner Bros. UK',
          key: 'aPDh6vip6yw',
          site: 'YouTube',
          size: 1080,
          type: 'Clip',
          official: true,
          published_at: '2021-03-11T17:52:31.000Z',
          id: '615f94b43e2ec8002d712176',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Denzel Washington, Rami Malek & Jared Leto Give An Exclusive Look Into The Little Things | HBO Max',
          key: 'aZ5dSyfbSRY',
          site: 'YouTube',
          size: 1080,
          type: 'Behind the Scenes',
          official: true,
          published_at: '2021-01-26T22:12:31.000Z',
          id: '6010a390ccde040041260fa4',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'The Little Things | Official Trailer | HBO Max',
          key: 'a45Xj7tfm8E',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2021-01-11T19:00:05.000Z',
          id: '5ffccf1c1c0435003fc0408c',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'THE LITTLE THINGS – Official Trailer',
          key: '1HZAnkxdYuA',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: true,
          published_at: '2020-12-22T14:00:00.000Z',
          id: '5fe201f169eb9000419a72db',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 5292,
          known_for_department: 'Diễn viên',
          name: 'Denzel Washington',
          original_name: 'Denzel Washington',
          popularity: 11.414,
          profile_path:
            'https://image.tmdb.org/t/p/w185/cEU2Vrdo83izpGmOvbVAOz5jCof.jpg',
          cast_id: 2,
          character: 'Joe "Deke" Deacon',
          credit_id: '5cda1d430e0a265585cd29b3',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 17838,
          known_for_department: 'Diễn viên',
          name: 'Rami Malek',
          original_name: 'Rami Malek',
          popularity: 10.159,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2OuFzCbMibXGouG79tG1U4BLPbe.jpg',
          cast_id: 1,
          character: 'Jim Baxter',
          credit_id: '5cda1d35c3a3683c67c43bfc',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 7499,
          known_for_department: 'Diễn viên',
          name: 'Jared Leto',
          original_name: 'Jared Leto',
          popularity: 13.603,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ca3x0OfIKbJppZh8S1Alx3GfUZO.jpg',
          cast_id: 7,
          character: 'Albert Sparma',
          credit_id: '5d4357b6d8cc4a00133618de',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 4445,
          known_for_department: 'Diễn viên',
          name: 'Chris Bauer',
          original_name: 'Chris Bauer',
          popularity: 2.272,
          profile_path:
            'https://image.tmdb.org/t/p/w185/1AjdNxbVmy6azlOxIfnCX5OruEA.jpg',
          cast_id: 25,
          character: 'Detective Sal Rizoli',
          credit_id: '5e757cfc2f3b1700174f14c6',
          order: 3,
        },
        {
          adult: false,
          gender: 1,
          id: 61084,
          known_for_department: 'Diễn viên',
          name: 'Michael Hyatt',
          original_name: 'Michael Hyatt',
          popularity: 1.724,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zXJ1mV2NlZuWYgTj8eTuUFhCgp5.jpg',
          cast_id: 28,
          character: 'Flo Dunigan',
          credit_id: '5e757d492f3b1700174f152f',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 11067,
          known_for_department: 'Diễn viên',
          name: 'Terry Kinney',
          original_name: 'Terry Kinney',
          popularity: 2.947,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5y2rzFRQxRktRobRSKdgsJ1ygsg.jpg',
          cast_id: 27,
          character: 'LASD Captain Carl Farris',
          credit_id: '5e757d34a055ef00182b7bc0',
          order: 5,
        },
        {
          adult: false,
          gender: 1,
          id: 118752,
          known_for_department: 'Diễn viên',
          name: 'Natalie Morales',
          original_name: 'Natalie Morales',
          popularity: 3.214,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gDMgBz8Kc1E2A8f1t4fMVoiYcpB.jpg',
          cast_id: 8,
          character: 'Detective Jamie Estrada',
          credit_id: '5d8427c06cf3d5023c25d360',
          order: 6,
        },
        {
          adult: false,
          gender: 1,
          id: 1685356,
          known_for_department: 'Diễn viên',
          name: 'Isabel Arraiza',
          original_name: 'Isabel Arraiza',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7y91M7Bcneff9d8KC8tQCoLoOJQ.jpg',
          cast_id: 31,
          character: 'Ana Baxter',
          credit_id: '5e757d9b2f3b1700174f161b',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 76973,
          known_for_department: 'Diễn viên',
          name: 'Joris Jarsky',
          original_name: 'Joris Jarsky',
          popularity: 1.515,
          profile_path:
            'https://image.tmdb.org/t/p/w185/snXBT36DDvxDhRyym44Zs55eKUf.jpg',
          cast_id: 9,
          character: 'Detective Sergeant Rogers',
          credit_id: '5d8d4cde172d7f00275186c5',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 12797,
          known_for_department: 'Diễn viên',
          name: 'Glenn Morshower',
          original_name: 'Glenn Morshower',
          popularity: 3.903,
          profile_path:
            'https://image.tmdb.org/t/p/w185/SjgNUSLoBAVossDI4QkNtDxYDZ.jpg',
          cast_id: 53,
          character: 'Captain Henry Davis',
          credit_id: '60141fd7cb802800410d4a83',
          order: 9,
        },
        {
          adult: false,
          gender: 1,
          id: 95039,
          known_for_department: 'Diễn viên',
          name: 'Sofia Vassilieva',
          original_name: 'Sofia Vassilieva',
          popularity: 5.352,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ryZqVhzjKfUBYuPMKXvZ1KF4tmU.jpg',
          cast_id: 11,
          character: 'Tina Salvatore',
          credit_id: '5d8d4d2c172d7f00275186f0',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 18259,
          known_for_department: 'Diễn viên',
          name: 'Jason James Richter',
          original_name: 'Jason James Richter',
          popularity: 2.272,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fY4fYZOQZKlAtRxys2zxZ884EZq.jpg',
          cast_id: 24,
          character: 'Detective Dennis Williams',
          credit_id: '5e757ce4b1f68d0019e33489',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 1382755,
          known_for_department: 'Diễn viên',
          name: 'John Harlan Kim',
          original_name: 'John Harlan Kim',
          popularity: 1.38,
          profile_path:
            'https://image.tmdb.org/t/p/w185/syCWEzV2zFYdYV6Kk4ebTgjGWFK.jpg',
          cast_id: 20,
          character: 'Officer Henderson',
          credit_id: '5dbd2b947d2bc10013334490',
          order: 12,
        },
        {
          adult: false,
          gender: 2,
          id: 76513,
          known_for_department: 'Diễn viên',
          name: 'Fred Koehler',
          original_name: 'Fred Koehler',
          popularity: 2.337,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mtaIu7XH5wtKydxUyIdN0zLjtdR.jpg',
          cast_id: 54,
          character: 'Stan Peters',
          credit_id: '60141fead266a2003f0c7eee',
          order: 13,
        },
        {
          adult: false,
          gender: 1,
          id: 44185,
          known_for_department: 'Diễn viên',
          name: 'Judith Scott',
          original_name: 'Judith Scott',
          popularity: 4.007,
          profile_path:
            'https://image.tmdb.org/t/p/w185/h1oDVb4GuihdB1hgrr8Zqm9kagm.jpg',
          cast_id: 55,
          character: 'Marsha',
          credit_id: '60141ff4b5bc21003b9aaf1c',
          order: 14,
        },
        {
          adult: false,
          gender: 1,
          id: 1476037,
          known_for_department: 'Diễn viên',
          name: 'Maya Kazan',
          original_name: 'Maya Kazan',
          popularity: 2.762,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lkymEg4965qpGx493tZDpvuhxqm.jpg',
          cast_id: 56,
          character: 'Ronda Rathbun',
          credit_id: '601420005ad76b00407153fb',
          order: 15,
        },
        {
          adult: false,
          gender: 1,
          id: 1083134,
          known_for_department: 'Diễn viên',
          name: 'Tiffany Gonzáles',
          original_name: 'Tiffany Gonzáles',
          popularity: 0.6,
          profile_path: null,
          cast_id: 57,
          character: 'Julie Brock',
          credit_id: '6014200c1b70ae003e5e4b00',
          order: 16,
        },
        {
          adult: false,
          gender: 1,
          id: 2969742,
          known_for_department: 'Diễn viên',
          name: 'Anna McKitrick',
          original_name: 'Anna McKitrick',
          popularity: 0.6,
          profile_path: null,
          cast_id: 80,
          character: 'Mary Roberts',
          credit_id: '60214ed9ea37e000413eec1c',
          order: 17,
        },
        {
          adult: false,
          gender: 0,
          id: 2419390,
          known_for_department: 'Diễn viên',
          name: 'Sheila Houlahan',
          original_name: 'Sheila Houlahan',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qfha9EdzFt70bw5hFJe344gMggQ.jpg',
          cast_id: 10,
          character: 'Paige Callahan',
          credit_id: '5d8d4d1b8289a00029ca6e5e',
          order: 18,
        },
        {
          adult: false,
          gender: 0,
          id: 2792754,
          known_for_department: 'Diễn viên',
          name: 'Ebony N Mayo',
          original_name: 'Ebony N Mayo',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aPM4bVFqGH0mZ73juSLYgXyi9aT.jpg',
          cast_id: 52,
          character: 'Tamara Ewing',
          credit_id: '5ffddad741a561003c0621ee',
          order: 19,
        },
        {
          adult: false,
          gender: 0,
          id: 2191493,
          known_for_department: 'Diễn viên',
          name: 'Matt Morrison',
          original_name: 'Matt Morrison',
          popularity: 0.6,
          profile_path: null,
          cast_id: 58,
          character: 'Guy Jogger',
          credit_id: '60142023cb802800410d4b1e',
          order: 20,
        },
        {
          adult: false,
          gender: 1,
          id: 1688100,
          known_for_department: 'Diễn viên',
          name: 'Olivia Washington',
          original_name: 'Olivia Washington',
          popularity: 2.397,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jKiyIYnjolaIwJpIClDyITZMjxr.jpg',
          cast_id: 59,
          character: 'Amy Anders',
          credit_id: '6014202e99d5c3003f5a977b',
          order: 21,
        },
        {
          adult: false,
          gender: 2,
          id: 1141368,
          known_for_department: 'Diễn viên',
          name: 'Kiff VandenHeuvel',
          original_name: 'Kiff VandenHeuvel',
          popularity: 2.247,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5vf1cIWjqH3xgbHWPhyIIEKDgdN.jpg',
          cast_id: 60,
          character: 'Tow Truck Driver',
          credit_id: '60142038cb8028003e0a2989',
          order: 22,
        },
        {
          adult: false,
          gender: 2,
          id: 101300,
          known_for_department: 'Diễn viên',
          name: 'J. Downing',
          original_name: 'J. Downing',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ghd3tPWcCRD5oAgPfiy1AtQCUmN.jpg',
          cast_id: 37,
          character: 'Flanders',
          credit_id: '5e757e5bb7d3520018770817',
          order: 23,
        },
        {
          adult: false,
          gender: 0,
          id: 1198428,
          known_for_department: 'Diễn viên',
          name: 'Sean Spann',
          original_name: 'Sean Spann',
          popularity: 1.199,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rQhqXLH4raZRRZtYsZiTEDpiXtI.jpg',
          cast_id: 46,
          character: 'Ghoul Squad',
          credit_id: '5e757f41a055ef00162b4e3a',
          order: 24,
        },
        {
          adult: false,
          gender: 1,
          id: 2969743,
          known_for_department: 'Diễn viên',
          name: 'Sophia Castro',
          original_name: 'Sophia Castro',
          popularity: 0.6,
          profile_path: null,
          cast_id: 81,
          character: 'Jennifer Baxter',
          credit_id: '60214f38d6c30000416707ee',
          order: 25,
        },
        {
          adult: false,
          gender: 1,
          id: 2969745,
          known_for_department: 'Diễn viên',
          name: 'Calliah Sophie Estrada',
          original_name: 'Calliah Sophie Estrada',
          popularity: 0.6,
          profile_path: null,
          cast_id: 82,
          character: 'Chloe Baxter',
          credit_id: '60214f439979d20040e23827',
          order: 26,
        },
        {
          adult: false,
          gender: 2,
          id: 1852817,
          known_for_department: 'Diễn viên',
          name: 'Thomas Crawford',
          original_name: 'Thomas Crawford',
          popularity: 1.289,
          profile_path:
            'https://image.tmdb.org/t/p/w185/evWOfbaQXyDsKELTVoqB29BsGdZ.jpg',
          cast_id: 35,
          character: 'Burns',
          credit_id: '5e757e19357c0000164dfcd2',
          order: 27,
        },
        {
          adult: false,
          gender: 2,
          id: 1520065,
          known_for_department: 'Diễn viên',
          name: 'Eric Satterberg',
          original_name: 'Eric Satterberg',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7OFDbpmL0E4qmBWWOrgnD0FYtZ8.jpg',
          cast_id: 42,
          character: 'LASD Tech #1',
          credit_id: '5e757edea055ef00142bb16d',
          order: 28,
        },
        {
          adult: false,
          gender: 0,
          id: 1429891,
          known_for_department: 'Diễn viên',
          name: 'Ian Gary',
          original_name: 'Ian Gary',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/rnMCVokfzD0i2md4Z5mKrMwxpFp.jpg',
          cast_id: 61,
          character: 'LASD Tech #2',
          credit_id: '60142166bf0f63003e0ba2b7',
          order: 29,
        },
        {
          adult: false,
          gender: 1,
          id: 155520,
          known_for_department: 'Diễn viên',
          name: 'Linara Washington',
          original_name: 'Linara Washington',
          popularity: 1.049,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6M1WgrRrpq6QK9TyKaQkONH37f4.jpg',
          cast_id: 62,
          character: 'Waitress',
          credit_id: '601421715ad76b004170fe73',
          order: 30,
        },
        {
          adult: false,
          gender: 2,
          id: 1056194,
          known_for_department: 'Diễn viên',
          name: 'Jeff Corbett',
          original_name: 'Jeff Corbett',
          popularity: 1.55,
          profile_path:
            'https://image.tmdb.org/t/p/w185/90BXqe89kTCrLNeFxXv99cecP5v.jpg',
          cast_id: 32,
          character: 'Bill Rathbun',
          credit_id: '5e757dc0a055ef00122b9f70',
          order: 31,
        },
        {
          adult: false,
          gender: 1,
          id: 154993,
          known_for_department: 'Diễn viên',
          name: 'Stephanie Erb',
          original_name: 'Stephanie Erb',
          popularity: 2.534,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3eTrorUzs0BCqOy0dnAMUjFaERb.jpg',
          cast_id: 26,
          character: 'Phyllis Rathbun',
          credit_id: '5e757d11b7d3520018770509',
          order: 32,
        },
        {
          adult: false,
          gender: 1,
          id: 2941461,
          known_for_department: 'Diễn viên',
          name: 'Samantha Cormier',
          original_name: 'Samantha Cormier',
          popularity: 0.652,
          profile_path:
            'https://image.tmdb.org/t/p/w185/mkklBzfS3ZT9LkN9fnjvDTORQK4.jpg',
          cast_id: 63,
          character: 'Teenage Girl',
          credit_id: '6014217fbe2d49003ffdb2a7',
          order: 33,
        },
        {
          adult: false,
          gender: 2,
          id: 154549,
          known_for_department: 'Diễn viên',
          name: 'Smalls',
          original_name: 'Smalls',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yauCJY20k4tOreEPh0ROGH2kvhh.jpg',
          cast_id: 64,
          character: 'Truck Driver',
          credit_id: '60142188c8a2d4003df467d8',
          order: 34,
        },
        {
          adult: false,
          gender: 1,
          id: 23975,
          known_for_department: 'Diễn viên',
          name: 'Lee Garlington',
          original_name: 'Lee Garlington',
          popularity: 4.806,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tbXeeXUl9py2pCeMHchZAxd56Ua.jpg',
          cast_id: 65,
          character: 'Landlady',
          credit_id: '60142192cb8028003e0a2ac4',
          order: 35,
        },
        {
          adult: false,
          gender: 2,
          id: 1613744,
          known_for_department: 'Diễn viên',
          name: 'Dimiter D. Marinov',
          original_name: 'Dimiter D. Marinov',
          popularity: 0.828,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lZwHZ27xqsPsuswcxyx6uWSh5VP.jpg',
          cast_id: 30,
          character: 'St. Agnes Hotel Manager',
          credit_id: '5e757d90a055ef00122b9f31',
          order: 36,
        },
        {
          adult: false,
          gender: 1,
          id: 168881,
          known_for_department: 'Diễn viên',
          name: 'Julia Vera',
          original_name: 'Julia Vera',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lmB2sxRlUi2I8krf3XpPOVbfp0K.jpg',
          cast_id: 66,
          character: 'ABC Appliance Owner',
          credit_id: '601421b30816c700418561ba',
          order: 37,
        },
        {
          adult: false,
          gender: 2,
          id: 146906,
          known_for_department: 'Diễn viên',
          name: 'Jack Topalian',
          original_name: 'Jack Topalian',
          popularity: 1.165,
          profile_path:
            'https://image.tmdb.org/t/p/w185/4MBcynysA0OLX263lq3N0qGpXjO.jpg',
          cast_id: 41,
          character: 'AAA Appliance Owner',
          credit_id: '5e757ebab7d3520011778e6b',
          order: 38,
        },
        {
          adult: false,
          gender: 2,
          id: 95356,
          known_for_department: 'Diễn viên',
          name: 'Charlie Saxton',
          original_name: 'Charlie Saxton',
          popularity: 1.326,
          profile_path:
            'https://image.tmdb.org/t/p/w185/owVq4RaxeXxkGYTHCdIiKy676bz.jpg',
          cast_id: 67,
          character: 'Felix',
          credit_id: '601421c43e09f3003e3f620a',
          order: 39,
        },
        {
          adult: false,
          gender: 2,
          id: 2969746,
          known_for_department: 'Diễn viên',
          name: 'Justin Barnhill',
          original_name: 'Justin Barnhill',
          popularity: 0.6,
          profile_path: null,
          cast_id: 83,
          character: 'Grunge Kid',
          credit_id: '60214fd25690b50040223535',
          order: 40,
        },
        {
          adult: false,
          gender: 2,
          id: 202691,
          known_for_department: 'Diễn viên',
          name: 'Emil Beheshti',
          original_name: 'Emil Beheshti',
          popularity: 1.008,
          profile_path:
            'https://image.tmdb.org/t/p/w185/o7QAbl9AFkJzXHbEA9m40pQLVo1.jpg',
          cast_id: 68,
          character: 'Lab Coat Tech',
          credit_id: '601421d7ea84c7003ec0e181',
          order: 41,
        },
        {
          adult: false,
          gender: 2,
          id: 154689,
          known_for_department: 'Diễn viên',
          name: 'Bradley James',
          original_name: 'Bradley James',
          popularity: 3.639,
          profile_path:
            'https://image.tmdb.org/t/p/w185/djYjl9kE2VPSO3qLnC8Jo3aD8d2.jpg',
          cast_id: 45,
          character: 'LAPD #1',
          credit_id: '5e757f2e357c0000194d54d0',
          order: 42,
        },
        {
          adult: false,
          gender: 2,
          id: 2636777,
          known_for_department: 'Diễn viên',
          name: 'Ben Kliewer',
          original_name: 'Ben Kliewer',
          popularity: 0.6,
          profile_path: null,
          cast_id: 69,
          character: 'LAPD #2',
          credit_id: '601421e0d266a2003d0d1385',
          order: 43,
        },
        {
          adult: false,
          gender: 0,
          id: 1377030,
          known_for_department: 'Diễn viên',
          name: 'Hank Northrop',
          original_name: 'Hank Northrop',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jfoUFc59Z1qGT3ctEPJwPINBDqv.jpg',
          cast_id: 40,
          character: 'LAPD #3',
          credit_id: '5e757ea9357c0000134e4253',
          order: 44,
        },
        {
          adult: false,
          gender: 2,
          id: 1667612,
          known_for_department: 'Diễn viên',
          name: 'Bob Golub',
          original_name: 'Bob Golub',
          popularity: 1.38,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kMDOr4FYAa5ss12CyxIyuxipynE.jpg',
          cast_id: 43,
          character: 'Bum',
          credit_id: '5e757f03b7d3520011778f52',
          order: 45,
        },
        {
          adult: false,
          gender: 0,
          id: 1848624,
          known_for_department: 'Diễn viên',
          name: 'Ben Sanders',
          original_name: 'Ben Sanders',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9UJWwXWBOgXDpg9qm5b4QH1xqZi.jpg',
          cast_id: 33,
          character: 'Delinquent Kid',
          credit_id: '5e757ddcb1f68d0012e24395',
          order: 46,
        },
        {
          adult: false,
          gender: 2,
          id: 106965,
          known_for_department: 'Diễn viên',
          name: 'Adam J. Harrington',
          original_name: 'Adam J. Harrington',
          popularity: 1.176,
          profile_path:
            'https://image.tmdb.org/t/p/w185/9oaeu0UVSfg87rJ38fw3JfO3ZTL.jpg',
          cast_id: 51,
          character: 'Greg Alberts',
          credit_id: '5ffddad747c9fb003f7a6b7a',
          order: 47,
        },
        {
          adult: false,
          gender: 2,
          id: 2969747,
          known_for_department: 'Diễn viên',
          name: 'Neil Garcia',
          original_name: 'Neil Garcia',
          popularity: 0.6,
          profile_path: null,
          cast_id: 84,
          character: "Pike's Bartender",
          credit_id: '60215030ccde040040f306e2',
          order: 48,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 153,
          known_for_department: 'Sound',
          name: 'Thomas Newman',
          original_name: 'Thomas Newman',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/j8rIiOSdBjtDL5vji8m5BtChZou.jpg',
          credit_id: '5fe2671870309f00407de6f1',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 1,
          id: 2215,
          known_for_department: 'Production',
          name: 'Denise Chamian',
          original_name: 'Denise Chamian',
          popularity: 0.694,
          profile_path: null,
          credit_id: '601ae3057314a1003ef8900d',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 892,
          known_for_department: 'Camera',
          name: 'John Schwartzman',
          original_name: 'John Schwartzman',
          popularity: 1.826,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tP37xmTuc1RXSGdTxnPxanpwIvd.jpg',
          credit_id: '5fe0f2565545ca003edf94df',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 5162,
          known_for_department: 'Production',
          name: 'Mark Johnson',
          original_name: 'Mark Johnson',
          popularity: 2.276,
          profile_path:
            'https://image.tmdb.org/t/p/w185/gLuXkOQjqB81aHMGJ2OtYzEpHQu.jpg',
          credit_id: '5cda21050e0a2666decc3a9a',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 7855,
          known_for_department: 'Art',
          name: 'Michael Corenblith',
          original_name: 'Michael Corenblith',
          popularity: 0.652,
          profile_path: null,
          credit_id: '5da0e52dc5c1ef0018f1e7bc',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 2,
          id: 8411,
          known_for_department: 'Costume & Make-Up',
          name: 'Daniel Orlandi',
          original_name: 'Daniel Orlandi',
          popularity: 0.981,
          profile_path: null,
          credit_id: '5da0e54fea7b0e0013bc5855',
          department: 'Costume & Make-Up',
          job: 'Costume Design',
        },
        {
          adult: false,
          gender: 0,
          id: 9440,
          known_for_department: 'Sound',
          name: 'Christopher Moriana',
          original_name: 'Christopher Moriana',
          popularity: 0.6,
          profile_path: null,
          credit_id: '609956fd05a533003b295ef1',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 12533,
          known_for_department: 'Sound',
          name: 'José Antonio García',
          original_name: 'José Antonio García',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215b7f87a27a00417a137a',
          department: 'Sound',
          job: 'Sound Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 12587,
          known_for_department: 'Sound',
          name: 'Jonathan Fuh',
          original_name: 'Jonathan Fuh',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215b8a5690b5003e2358b3',
          department: 'Sound',
          job: 'Boom Operator',
        },
        {
          adult: false,
          gender: 2,
          id: 15526,
          known_for_department: 'Costume & Make-Up',
          name: 'Larry M. Cherry',
          original_name: 'Larry M. Cherry',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215b72fd6300003e732d9b',
          department: 'Costume & Make-Up',
          job: 'Hairstylist',
        },
        {
          adult: false,
          gender: 0,
          id: 42032,
          known_for_department: 'Camera',
          name: 'Ian Fox',
          original_name: 'Ian Fox',
          popularity: 0.828,
          profile_path: null,
          credit_id: '602153f0c2b9df003f9dbb3a',
          department: 'Camera',
          job: '"A" Camera Operator',
        },
        {
          adult: false,
          gender: 1,
          id: 38022,
          known_for_department: 'Art',
          name: 'Lauren E. Polizzi',
          original_name: 'Lauren E. Polizzi',
          popularity: 0.98,
          profile_path: null,
          credit_id: '601ae32b66a0d3003f7ca754',
          department: 'Art',
          job: 'Supervising Art Director',
        },
        {
          adult: false,
          gender: 2,
          id: 54040,
          known_for_department: 'Directing',
          name: 'John Lee Hancock',
          original_name: 'John Lee Hancock',
          popularity: 4.292,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ytGKxuC1sFUmd68jUwDA37Jn0LG.jpg',
          credit_id: '5fe0f4a6b6c264003deff239',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 54040,
          known_for_department: 'Directing',
          name: 'John Lee Hancock',
          original_name: 'John Lee Hancock',
          popularity: 4.292,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ytGKxuC1sFUmd68jUwDA37Jn0LG.jpg',
          credit_id: '5cda1d599251412f6bd20ff9',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 54040,
          known_for_department: 'Directing',
          name: 'John Lee Hancock',
          original_name: 'John Lee Hancock',
          popularity: 4.292,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ytGKxuC1sFUmd68jUwDA37Jn0LG.jpg',
          credit_id: '5cda1d6c0e0a267e73cacaf4',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 56932,
          known_for_department: 'Production',
          name: 'Kevin McCormick',
          original_name: 'Kevin McCormick',
          popularity: 0.656,
          profile_path: null,
          credit_id: '5fe0f4108cfcc7003eeb19ee',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 65849,
          known_for_department: 'Editing',
          name: 'Robert Frazen',
          original_name: 'Robert Frazen',
          popularity: 0.972,
          profile_path: null,
          credit_id: '5da0e50aea7b0e0013bc580c',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 62723,
          known_for_department: 'Editing',
          name: 'Stefan Sonnenfeld',
          original_name: 'Stefan Sonnenfeld',
          popularity: 0.645,
          profile_path: null,
          credit_id: '609962d84e6742003e960af9',
          department: 'Editing',
          job: 'Digital Intermediate Colorist',
        },
        {
          adult: false,
          gender: 2,
          id: 75636,
          known_for_department: 'Crew',
          name: 'Jalil Jay Lynch',
          original_name: 'Jalil Jay Lynch',
          popularity: 0.67,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lpU7fTd5MTv4nXcmmr1WdPcKnVN.jpg',
          credit_id: '602151bdc2b9df003d9e1e87',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 76328,
          known_for_department: 'Diễn viên',
          name: 'Anders Jansson',
          original_name: 'Anders Jansson',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/akxYNYSb0NutPWTohD04x5HghwC.jpg',
          credit_id: '60215ac29979d2003ee18eab',
          department: 'Costume & Make-Up',
          job: 'Costume Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 112609,
          known_for_department: 'Sound',
          name: 'David E. Fluhr',
          original_name: 'David E. Fluhr',
          popularity: 1.396,
          profile_path: null,
          credit_id: '609957c9b87aec003ca09d49',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 42824,
          known_for_department: 'Diễn viên',
          name: 'Carl Ciarfalio',
          original_name: 'Carl Ciarfalio',
          popularity: 2.197,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yADROfK7uJkmd8p3GyjxH8WZqRL.jpg',
          credit_id: '602151a1458199003da73b1f',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 114409,
          known_for_department: 'Production',
          name: 'Mike Drake',
          original_name: 'Mike Drake',
          popularity: 0.98,
          profile_path: null,
          credit_id: '5da0e4b8c5c1ef0018f1e5ae',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 200402,
          known_for_department: 'Crew',
          name: 'Tim Trella',
          original_name: 'Tim Trella',
          popularity: 1.22,
          profile_path: null,
          credit_id: '6021512795c0af00404fa327',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 1,
          id: 948223,
          known_for_department: 'Art',
          name: 'Susan Benjamin',
          original_name: 'Susan Benjamin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5da0e53dfd4a960019533a1d',
          department: 'Art',
          job: 'Set Decoration',
        },
        {
          adult: false,
          gender: 1,
          id: 1027021,
          known_for_department: 'Directing',
          name: 'Stephanie Tull',
          original_name: 'Stephanie Tull',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60214e7ca80673004041c85b',
          department: 'Directing',
          job: 'Second Assistant Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1046463,
          known_for_department: 'Diễn viên',
          name: 'Dennis Fitzgerald',
          original_name: 'Dennis Fitzgerald',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zL8Bh0plys2Dpe13oTlKbedORQO.jpg',
          credit_id: '602151afdd2589003fb7ee2f',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1209419,
          known_for_department: 'Crew',
          name: 'Tim Rigby',
          original_name: 'Tim Rigby',
          popularity: 2.014,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5ckhBJzA3MNxGPDSWytTKrdm26M.jpg',
          credit_id: '602151cc263462003df93c54',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1315700,
          known_for_department: 'Costume & Make-Up',
          name: 'Donald Mowat',
          original_name: 'Donald Mowat',
          popularity: 0.673,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ikdaVXZvwu9wdgbtJWbeokb0fVL.jpg',
          credit_id: '5de7b41d11386c001655ba71',
          department: 'Costume & Make-Up',
          job: 'Makeup Department Head',
        },
        {
          adult: false,
          gender: 2,
          id: 1315700,
          known_for_department: 'Costume & Make-Up',
          name: 'Donald Mowat',
          original_name: 'Donald Mowat',
          popularity: 0.673,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ikdaVXZvwu9wdgbtJWbeokb0fVL.jpg',
          credit_id: '5de7b4487646fd0015991742',
          department: 'Costume & Make-Up',
          job: 'Makeup Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1324884,
          known_for_department: 'Costume & Make-Up',
          name: 'Frank Perry Rose',
          original_name: 'Frank Perry Rose',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215a29ea37e000403f0046',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 1,
          id: 1339432,
          known_for_department: 'Crew',
          name: 'Erica Frauman',
          original_name: 'Erica Frauman',
          popularity: 1.614,
          profile_path: null,
          credit_id: '6021558aa22d3e003db6c5cf',
          department: 'Crew',
          job: 'Post Production Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1339435,
          known_for_department: 'Art',
          name: 'Lorrie Campbell',
          original_name: 'Lorrie Campbell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602153d20e597b003ea4792b',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1341398,
          known_for_department: 'Art',
          name: 'Stephanie Higgins Frey',
          original_name: 'Stephanie Higgins Frey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602153e8a22d3e003eb70c5c',
          department: 'Art',
          job: 'Art Department Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 1347144,
          known_for_department: 'Crew',
          name: 'Greg Fitzpatrick',
          original_name: 'Greg Fitzpatrick',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6021520287a27a003e791fa7',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1350426,
          known_for_department: 'Visual Effects',
          name: 'Gabriel Sánchez',
          original_name: 'Gabriel Sánchez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '609959cb028f14003e42d26c',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1378068,
          known_for_department: 'Costume & Make-Up',
          name: 'Carl Fullerton',
          original_name: 'Carl Fullerton',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215b159979d2003fe2f56c',
          department: 'Costume & Make-Up',
          job: 'Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1378721,
          known_for_department: 'Costume & Make-Up',
          name: 'Marylou Lim',
          original_name: 'Marylou Lim',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215a68dd2589003db6fc5d',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 2,
          id: 1393445,
          known_for_department: 'Visual Effects',
          name: 'Tim LeDoux',
          original_name: 'Tim LeDoux',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/hrhSUcTOvNiPMhjVhLzQnKxFFIm.jpg',
          credit_id: '609959b5af58cb003eb1cb8a',
          department: 'Visual Effects',
          job: 'Visual Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1393446,
          known_for_department: 'Visual Effects',
          name: 'Jason Sanford',
          original_name: 'Jason Sanford',
          popularity: 1.4,
          profile_path: null,
          credit_id: '609959a1da10f0003c34055b',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1397809,
          known_for_department: 'Art',
          name: 'Don Miloyevich',
          original_name: 'Don Miloyevich',
          popularity: 0.98,
          profile_path: null,
          credit_id: '6021581ffd6300003f73270d',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 2,
          id: 1397822,
          known_for_department: 'Sound',
          name: 'Jon Johnson',
          original_name: 'Jon Johnson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '609957f941eee1003bd91d4a',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1397823,
          known_for_department: 'Sound',
          name: 'Alyson Dee Moore',
          original_name: 'Alyson Dee Moore',
          popularity: 1.381,
          profile_path: null,
          credit_id: '609956ea41eee1003bd91baf',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 1,
          id: 1403421,
          known_for_department: 'Directing',
          name: 'Dawn Gilliam',
          original_name: 'Dawn Gilliam',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6021556fccde040041f30fa9',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1403438,
          known_for_department: 'Sound',
          name: 'Darren King',
          original_name: 'Darren King',
          popularity: 1.094,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yiK8MMwsOiahv1uH8rzzn5v44K8.jpg',
          credit_id: '60995699283ed9003d6ee9b2',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1403438,
          known_for_department: 'Sound',
          name: 'Darren King',
          original_name: 'Darren King',
          popularity: 1.094,
          profile_path:
            'https://image.tmdb.org/t/p/w185/yiK8MMwsOiahv1uH8rzzn5v44K8.jpg',
          credit_id: '6099568cd2b209003c79259b',
          department: 'Sound',
          job: 'ADR Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1403439,
          known_for_department: 'Sound',
          name: 'Gregory King',
          original_name: 'Gregory King',
          popularity: 0.739,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tmyEC5zNGoPyfzNzsyBGor6Bn4P.jpg',
          credit_id: '609957deda10f0003d33fe7e',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1403440,
          known_for_department: 'Sound',
          name: 'Yann Delpuech',
          original_name: 'Yann Delpuech',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6099576b41eee1003dd8bdbe',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1403440,
          known_for_department: 'Sound',
          name: 'Yann Delpuech',
          original_name: 'Yann Delpuech',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6099577c028f14003e42ceb2',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1403488,
          known_for_department: 'Editing',
          name: 'Erik Rogers',
          original_name: 'Erik Rogers',
          popularity: 0.6,
          profile_path: null,
          credit_id: '609962f4a3d027003d41393b',
          department: 'Editing',
          job: 'Digital Intermediate Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 1415337,
          known_for_department: 'Costume & Make-Up',
          name: 'Mark Nieman',
          original_name: 'Mark Nieman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '601ae368470ead003e73fa41',
          department: 'Costume & Make-Up',
          job: 'Special Effects Makeup Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 1416671,
          known_for_department: 'Editing',
          name: 'Chris Jackson',
          original_name: 'Chris Jackson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602155b5ea37e0003e3ef761',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1425829,
          known_for_department: 'Camera',
          name: 'Jody Miller',
          original_name: 'Jody Miller',
          popularity: 0.732,
          profile_path: null,
          credit_id: '6021548f9979d2003fe2e795',
          department: 'Camera',
          job: 'Steadicam Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1425829,
          known_for_department: 'Camera',
          name: 'Jody Miller',
          original_name: 'Jody Miller',
          popularity: 0.732,
          profile_path: null,
          credit_id: '60215485263462003bf898f9',
          department: 'Camera',
          job: '"B" Camera Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1428841,
          known_for_department: 'Costume & Make-Up',
          name: 'Myron Baker',
          original_name: 'Myron Baker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215a5da80673003e4171f2',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 2,
          id: 1428908,
          known_for_department: 'Costume & Make-Up',
          name: 'Michael White',
          original_name: 'Michael White',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5da0e59246aed400112fb5f9',
          department: 'Costume & Make-Up',
          job: 'Hair Department Head',
        },
        {
          adult: false,
          gender: 1,
          id: 1450292,
          known_for_department: 'Production',
          name: 'Leigh Shanta',
          original_name: 'Leigh Shanta',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60214e535690b5003e233e3a',
          department: 'Production',
          job: 'Unit Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 1463296,
          known_for_department: 'Art',
          name: 'Samantha Avila',
          original_name: 'Samantha Avila',
          popularity: 1.048,
          profile_path: null,
          credit_id: '601ae31c1108a8003dc10786',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 1,
          id: 1463658,
          known_for_department: 'Crew',
          name: 'Hannah Betts',
          original_name: 'Hannah Betts',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6021513860b58d0040d97aef',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1482837,
          known_for_department: 'Sound',
          name: 'Christopher Alba',
          original_name: 'Christopher Alba',
          popularity: 0.6,
          profile_path: null,
          credit_id: '609956ad97eab4003bd18bba',
          department: 'Sound',
          job: 'Assistant Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1488386,
          known_for_department: 'Diễn viên',
          name: 'Dustin Courtney',
          original_name: 'Dustin Courtney',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602151da458199003fa89cfa',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1502517,
          known_for_department: 'Diễn viên',
          name: 'Manny Perry',
          original_name: 'Manny Perry',
          popularity: 1.38,
          profile_path:
            'https://image.tmdb.org/t/p/w185/aCYOiEZ7LkqJUEce0PsPVx6GWo0.jpg',
          credit_id: '6021516660b58d003fd8cf2d',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1519868,
          known_for_department: 'Directing',
          name: 'Donald Sparks',
          original_name: 'Donald Sparks',
          popularity: 0.6,
          profile_path: null,
          credit_id: '601ae2f081a7fc0040ff1e15',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 1519868,
          known_for_department: 'Directing',
          name: 'Donald Sparks',
          original_name: 'Donald Sparks',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60214e66d6c300003f65931e',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 1530712,
          known_for_department: 'Visual Effects',
          name: 'Mark Hawker',
          original_name: 'Mark Hawker',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995a25a3d027003b420e4d',
          department: 'Visual Effects',
          job: 'Special Effects Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1536391,
          known_for_department: 'Production',
          name: 'Jeremy Fischer',
          original_name: 'Jeremy Fischer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215694263462003ef91696',
          department: 'Production',
          job: 'Assistant Accountant',
        },
        {
          adult: false,
          gender: 0,
          id: 1537474,
          known_for_department: 'Lighting',
          name: 'Todd Heater',
          original_name: 'Todd Heater',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995c94af58cb003cb332d2',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1537474,
          known_for_department: 'Lighting',
          name: 'Todd Heater',
          original_name: 'Todd Heater',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215ba69979d20040e24fb4',
          department: 'Lighting',
          job: 'Chief Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 1542688,
          known_for_department: 'Crew',
          name: 'Eddie L. Watkins',
          original_name: 'Eddie L. Watkins',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6021516d5690b5004022376b',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1548262,
          known_for_department: 'Camera',
          name: 'Nicola Goode',
          original_name: 'Nicola Goode',
          popularity: 0.84,
          profile_path: null,
          credit_id: '6021555195c0af003e5002f4',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 2,
          id: 1548454,
          known_for_department: 'Art',
          name: 'Stuart Rankine',
          original_name: 'Stuart Rankine',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215905dd2589003fb7fc1f',
          department: 'Art',
          job: 'Props',
        },
        {
          adult: false,
          gender: 2,
          id: 1550064,
          known_for_department: 'Costume & Make-Up',
          name: 'Edward T. Hanley',
          original_name: 'Edward T. Hanley',
          popularity: 1.528,
          profile_path: null,
          credit_id: '602159950e597b003ea482b1',
          department: 'Costume & Make-Up',
          job: 'Costume Supervisor',
        },
        {
          adult: false,
          gender: 1,
          id: 1550819,
          known_for_department: 'Production',
          name: 'Lori Berlanga',
          original_name: 'Lori Berlanga',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xEmmDTLngXlCfSDBjNpOlWYbqw2.jpg',
          credit_id: '602155f9a22d3e003eb71124',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 1551520,
          known_for_department: 'Costume & Make-Up',
          name: 'Demetricus Holloway',
          original_name: 'Demetricus Holloway',
          popularity: 0.98,
          profile_path: null,
          credit_id: '602159a46dc5070040bf678c',
          department: 'Costume & Make-Up',
          job: 'Key Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 1562408,
          known_for_department: 'Directing',
          name: 'Andrés Moret Urdampilleta',
          original_name: 'Andrés Moret Urdampilleta',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6021563787a27a00417a06fe',
          department: 'Production',
          job: 'Production Secretary',
        },
        {
          adult: false,
          gender: 0,
          id: 1565107,
          known_for_department: 'Sound',
          name: 'Dan Gamache',
          original_name: 'Dan Gamache',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995791efd3c2003c962dee',
          department: 'Sound',
          job: 'Sound Effects Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1583045,
          known_for_department: 'Diễn viên',
          name: 'Mehdi Merali',
          original_name: 'Mehdi Merali',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602152205690b50040223817',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1585177,
          known_for_department: 'Crew',
          name: 'Michael Herron',
          original_name: 'Michael Herron',
          popularity: 0.98,
          profile_path: null,
          credit_id: '60995e2d96522000423e5437',
          department: 'Crew',
          job: 'Video Assist Operator',
        },
        {
          adult: false,
          gender: 1,
          id: 1592516,
          known_for_department: 'Diễn viên',
          name: 'Angela Meryl',
          original_name: 'Angela Meryl',
          popularity: 0.609,
          profile_path:
            'https://image.tmdb.org/t/p/w185/40dm2Bl3h8G2BgpWLIaTxlLCJaj.jpg',
          credit_id: '6021515fc2b9df003d9e1c77',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1634422,
          known_for_department: 'Art',
          name: 'Geoffrey Mandel',
          original_name: 'Geoffrey Mandel',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602152d7458199003ea821bd',
          department: 'Art',
          job: 'Graphic Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1634438,
          known_for_department: 'Crew',
          name: 'Allan Padelford',
          original_name: 'Allan Padelford',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215230a80673004141436c',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1656647,
          known_for_department: 'Diễn viên',
          name: 'Janelle Beaudry',
          original_name: 'Janelle Beaudry',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602151d260b58d003eda0285',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1711885,
          known_for_department: 'Diễn viên',
          name: 'Sabrina LeBrun',
          original_name: 'Sabrina LeBrun',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215212ccde04003ff30b22',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 1,
          id: 1743025,
          known_for_department: 'Diễn viên',
          name: 'Colby Lemmo',
          original_name: 'Colby Lemmo',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lpKZXhsGcn1RHEYT27jBFbJmGfn.jpg',
          credit_id: '60215158263462003bf892c0',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1748848,
          known_for_department: 'Costume & Make-Up',
          name: 'Michael Budge',
          original_name: 'Michael Budge',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602153dcea37e0003f3ef775',
          department: 'Art',
          job: 'Set Designer',
        },
        {
          adult: false,
          gender: 1,
          id: 1752588,
          known_for_department: 'Production',
          name: 'Sarah Gray',
          original_name: 'Sarah Gray',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215662a22d3e003cb7282c',
          department: 'Production',
          job: 'First Assistant Accountant',
        },
        {
          adult: false,
          gender: 0,
          id: 1755689,
          known_for_department: 'Costume & Make-Up',
          name: 'Jack Taggart',
          original_name: 'Jack Taggart',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/oztXS3hIIzZ6hZCrp6HZAClniYY.jpg',
          credit_id: '60215a9b87a27a003e792ec7',
          department: 'Costume & Make-Up',
          job: 'Ager/Dyer',
        },
        {
          adult: false,
          gender: 0,
          id: 1758241,
          known_for_department: 'Crew',
          name: 'Bill Leaman',
          original_name: 'Bill Leaman',
          popularity: 1.564,
          profile_path:
            'https://image.tmdb.org/t/p/w185/wpq02sSTNgdhbK4FXt8YLkEZJPa.jpg',
          credit_id: '602151b5ea37e0003e3ef06e',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1760561,
          known_for_department: 'Crew',
          name: 'Steven Blizzard',
          original_name: 'Steven Blizzard',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995c5441eee1003dd8c47f',
          department: 'Crew',
          job: 'Drone Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 1760567,
          known_for_department: 'Camera',
          name: 'Brad Rea',
          original_name: 'Brad Rea',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995bdbaf58cb003db2a2fa',
          department: 'Camera',
          job: 'Dolly Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1760568,
          known_for_department: 'Camera',
          name: 'Michael Wahl',
          original_name: 'Michael Wahl',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995bf5af58cb003db2a32d',
          department: 'Camera',
          job: 'Dolly Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1760573,
          known_for_department: 'Sound',
          name: 'Darrin Mann',
          original_name: 'Darrin Mann',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995716006eee003b1d217c',
          department: 'Sound',
          job: 'Foley Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 1768957,
          known_for_department: 'Art',
          name: 'Alan Munro',
          original_name: 'Alan Munro',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60996077d2b209003c79311b',
          department: 'Art',
          job: 'Title Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1781877,
          known_for_department: 'Camera',
          name: 'Milan Janicin',
          original_name: 'Milan Janicin',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602154afea37e000403ef7e4',
          department: 'Camera',
          job: 'Second Assistant "B" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 1789765,
          known_for_department: 'Art',
          name: 'Rio Noel Zumwalt',
          original_name: 'Rio Noel Zumwalt',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995e4997eab4003bd198fd',
          department: 'Crew',
          job: 'Loader',
        },
        {
          adult: false,
          gender: 0,
          id: 1789765,
          known_for_department: 'Art',
          name: 'Rio Noel Zumwalt',
          original_name: 'Rio Noel Zumwalt',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215514a22d3e003cb72230',
          department: 'Camera',
          job: 'Camera Loader',
        },
        {
          adult: false,
          gender: 1,
          id: 1792884,
          known_for_department: 'Crew',
          name: 'LaFaye Baker',
          original_name: 'LaFaye Baker',
          popularity: 0.98,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iCDZL7AawTc2gpm0XRbdK3DPRU5.jpg',
          credit_id: '6021512fa80673004141421b',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1792891,
          known_for_department: 'Lighting',
          name: 'Doug Ednie',
          original_name: 'Doug Ednie',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995b853520e8003d00ea1a',
          department: 'Lighting',
          job: 'Best Boy Electric',
        },
        {
          adult: false,
          gender: 0,
          id: 1792891,
          known_for_department: 'Lighting',
          name: 'Doug Ednie',
          original_name: 'Doug Ednie',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215bb0a22d3e003eb71eaa',
          department: 'Lighting',
          job: 'Assistant Chief Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 1815346,
          known_for_department: 'Costume & Make-Up',
          name: 'Ruth Haney',
          original_name: 'Ruth Haney',
          popularity: 0.6,
          profile_path: null,
          credit_id: '601ae359bc8657003fbc8dd8',
          department: 'Costume & Make-Up',
          job: 'Key Makeup Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 1837345,
          known_for_department: 'Art',
          name: 'Christopher Hansen',
          original_name: 'Christopher Hansen',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215911458199003ca7b109',
          department: 'Art',
          job: 'Props',
        },
        {
          adult: false,
          gender: 0,
          id: 1844322,
          known_for_department: 'Production',
          name: 'Gail Marks',
          original_name: 'Gail Marks',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6021564cc2b9df003f9dbff6',
          department: 'Production',
          job: 'Production Accountant',
        },
        {
          adult: false,
          gender: 2,
          id: 1848844,
          known_for_department: 'Camera',
          name: 'Todd Schlopy',
          original_name: 'Todd Schlopy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6021546c263462003bf898be',
          department: 'Camera',
          job: 'First Assistant "A" Camera',
        },
        {
          adult: false,
          gender: 2,
          id: 1868738,
          known_for_department: 'Camera',
          name: 'Gabe Camacho',
          original_name: 'Gabe Camacho',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995ca672a2c9003e33b477',
          department: 'Camera',
          job: 'Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 1924395,
          known_for_department: 'Visual Effects',
          name: 'Matthew Morrissey',
          original_name: 'Matthew Morrissey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995b1c168ea3003b15a51d',
          department: 'Visual Effects',
          job: '24 Frame Playback',
        },
        {
          adult: false,
          gender: 1,
          id: 1937893,
          known_for_department: 'Sound',
          name: 'Jessie Anne Spence',
          original_name: 'Jessie Anne Spence',
          popularity: 0.84,
          profile_path:
            'https://image.tmdb.org/t/p/w185/6av3fwyPvIoLhLpHDyTv5zbhs23.jpg',
          credit_id: '609956d6a3d027003b42081b',
          department: 'Sound',
          job: 'Dialogue Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1944697,
          known_for_department: 'Art',
          name: 'Jenn McLaren',
          original_name: 'Jenn McLaren',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602157fa87a27a003e792a2f',
          department: 'Art',
          job: 'Set Decoration Buyer',
        },
        {
          adult: false,
          gender: 1,
          id: 1976089,
          known_for_department: 'Crew',
          name: 'Linda Jewell',
          original_name: 'Linda Jewell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6021515160b58d003fd8cf19',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 1997382,
          known_for_department: 'Camera',
          name: 'Dan Godar',
          original_name: 'Dan Godar',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995b4897eab4003bd192b6',
          department: 'Camera',
          job: 'Aerial Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2002654,
          known_for_department: 'Art',
          name: 'Joel Prihoda',
          original_name: 'Joel Prihoda',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6021575887a27a00417a0a68',
          department: 'Art',
          job: 'Leadman',
        },
        {
          adult: false,
          gender: 0,
          id: 2009125,
          known_for_department: 'Art',
          name: 'Rafael Somarriba',
          original_name: 'Rafael Somarriba',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602158399979d2003ee18c26',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2026582,
          known_for_department: 'Art',
          name: 'Albert Valdez',
          original_name: 'Albert Valdez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6021582b0e597b003ea47f60',
          department: 'Art',
          job: 'Assistant Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 2050107,
          known_for_department: 'Sound',
          name: 'Dave Wilson',
          original_name: 'Dave Wilson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995676da10f0003b33fb0c',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 2059837,
          known_for_department: 'Crew',
          name: 'Ross Scharphorn',
          original_name: 'Ross Scharphorn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6021523760b58d0040d97c16',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 2066275,
          known_for_department: 'Lighting',
          name: 'Michael E. Pacheco',
          original_name: 'Michael E. Pacheco',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995ce53520e8003e00ec1b',
          department: 'Lighting',
          job: 'Key Rigging Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2069682,
          known_for_department: 'Art',
          name: 'Chris Langevin',
          original_name: 'Chris Langevin',
          popularity: 1.38,
          profile_path: null,
          credit_id: '6021598460b58d003fd8dd18',
          department: 'Art',
          job: 'Props',
        },
        {
          adult: false,
          gender: 0,
          id: 2072153,
          known_for_department: 'Costume & Make-Up',
          name: 'Nancy Malone',
          original_name: 'Nancy Malone',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995ec6d2b209003c792f10',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2073453,
          known_for_department: 'Camera',
          name: 'Alex Cruz',
          original_name: 'Alex Cruz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995cccaf58cb003db2a475',
          department: 'Camera',
          job: 'Key Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2080017,
          known_for_department: 'Directing',
          name: 'Alejandro Mora',
          original_name: 'Alejandro Mora',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6099639c3520e8003d00f61d',
          department: 'Directing',
          job: 'Second Second Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 2080021,
          known_for_department: 'Art',
          name: 'Martin Charles',
          original_name: 'Martin Charles',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602152c460b58d003eda04ff',
          department: 'Art',
          job: 'Graphic Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 2091401,
          known_for_department: 'Camera',
          name: 'Thomas D. Lairson Jr.',
          original_name: 'Thomas D. Lairson Jr.',
          popularity: 1.38,
          profile_path: null,
          credit_id: '60215477ccde040041f30e4c',
          department: 'Camera',
          job: 'Second Assistant "A" Camera',
        },
        {
          adult: false,
          gender: 1,
          id: 2097578,
          known_for_department: 'Costume & Make-Up',
          name: 'Merdyce McClaran',
          original_name: 'Merdyce McClaran',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602158e6ea37e0003e3efe2e',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2124174,
          known_for_department: 'Lighting',
          name: 'Michael D. Anderson',
          original_name: 'Michael D. Anderson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995d39aede59003d1fff5e',
          department: 'Lighting',
          job: 'Rigging Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 2142360,
          known_for_department: 'Visual Effects',
          name: 'Min Young Kim',
          original_name: 'Min Young Kim',
          popularity: 1.094,
          profile_path: null,
          credit_id: '6099591f3520e8003f00df07',
          department: 'Crew',
          job: 'Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 2156316,
          known_for_department: 'Art',
          name: 'Xavier Corby',
          original_name: 'Xavier Corby',
          popularity: 0.694,
          profile_path: null,
          credit_id: '602158b46dc5070040bf65bc',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2196077,
          known_for_department: 'Diễn viên',
          name: 'Gregory Carlton Battle',
          original_name: 'Gregory Carlton Battle',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215175ea37e000403ef4b7',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 2200397,
          known_for_department: 'Costume & Make-Up',
          name: 'Michael Ward',
          original_name: 'Michael Ward',
          popularity: 0.6,
          profile_path: null,
          credit_id: '601ae37acf62cd003f04441e',
          department: 'Costume & Make-Up',
          job: 'Key Hair Stylist',
        },
        {
          adult: false,
          gender: 0,
          id: 2219102,
          known_for_department: 'Production',
          name: 'Rick Roesch',
          original_name: 'Rick Roesch',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6021566f0e597b003fa46825',
          department: 'Production',
          job: 'Payroll Accountant',
        },
        {
          adult: false,
          gender: 0,
          id: 2254039,
          known_for_department: 'Lighting',
          name: 'Joe Love',
          original_name: 'Joe Love',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995a513520e8004000ecc6',
          department: 'Crew',
          job: 'Special Effects Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2256935,
          known_for_department: 'Crew',
          name: 'Chris Denison',
          original_name: 'Chris Denison',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602151a7ea37e000413eef6b',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 2383992,
          known_for_department: 'Production',
          name: 'Ales Ordelt',
          original_name: 'Ales Ordelt',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602151c5ccde040041f30916',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 2441052,
          known_for_department: 'Crew',
          name: 'Julius Denem',
          original_name: 'Julius Denem',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6021513f5690b50040223740',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 2460005,
          known_for_department: 'Diễn viên',
          name: 'Robert Powell',
          original_name: 'Robert Powell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6021511dccde04003ef30781',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2594282,
          known_for_department: 'Directing',
          name: 'Jason Inman',
          original_name: 'Jason Inman',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6099637b8ee49c003e7510d5',
          department: 'Directing',
          job: 'Second Unit First Assistant Director',
        },
        {
          adult: false,
          gender: 2,
          id: 2636803,
          known_for_department: 'Crew',
          name: 'Travis Fienhage',
          original_name: 'Travis Fienhage',
          popularity: 0.694,
          profile_path: null,
          credit_id: '602151489979d20040e23a7c',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 0,
          id: 2638024,
          known_for_department: 'Sound',
          name: 'Sheraton Toyota',
          original_name: 'Sheraton Toyota',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6099580caf58cb003cb32e94',
          department: 'Sound',
          job: 'Utility Sound',
        },
        {
          adult: false,
          gender: 0,
          id: 2780586,
          known_for_department: 'Camera',
          name: 'Steve Freebairn',
          original_name: 'Steve Freebairn',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602154c5ccde040041f30ecb',
          department: 'Camera',
          job: 'Digital Imaging Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2844685,
          known_for_department: 'Camera',
          name: 'Andrae Crawford',
          original_name: 'Andrae Crawford',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602154a15690b5003e234b1f',
          department: 'Camera',
          job: 'First Assistant "B" Camera',
        },
        {
          adult: false,
          gender: 0,
          id: 2912490,
          known_for_department: 'Visual Effects',
          name: 'Nicholas Daniels',
          original_name: 'Nicholas Daniels',
          popularity: 0.6,
          profile_path: null,
          credit_id: '609958e2b87aec003b9f8256',
          department: 'Visual Effects',
          job: 'Compositing Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2969765,
          known_for_department: 'Camera',
          name: 'Kai Borson-Paine',
          original_name: 'Kai Borson-Paine',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602154e860b58d003eda089b',
          department: 'Camera',
          job: 'Digital Imaging Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2969768,
          known_for_department: 'Editing',
          name: 'Gaby Zamora',
          original_name: 'Gaby Zamora',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602155dca80673003e416bf8',
          department: 'Editing',
          job: 'Assistant Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 2969769,
          known_for_department: 'Production',
          name: 'Jessica DeLuca',
          original_name: 'Jessica DeLuca',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6021561560b58d003eda0bba',
          department: 'Production',
          job: 'Assistant Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2969771,
          known_for_department: 'Production',
          name: 'Carlos Healy',
          original_name: 'Carlos Healy',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602156a39979d2003de1eb0c',
          department: 'Production',
          job: 'Assistant Accountant',
        },
        {
          adult: false,
          gender: 0,
          id: 2969772,
          known_for_department: 'Production',
          name: 'Alexandra Rubisz',
          original_name: 'Alexandra Rubisz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602156dcdd25890040b86d32',
          department: 'Production',
          job: 'Assistant Accountant',
        },
        {
          adult: false,
          gender: 0,
          id: 2969773,
          known_for_department: 'Production',
          name: 'Eric Behnke',
          original_name: 'Eric Behnke',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602156ffdd2589003fb7f787',
          department: 'Production',
          job: 'Assistant Accountant',
        },
        {
          adult: false,
          gender: 0,
          id: 2969776,
          known_for_department: 'Production',
          name: 'Austin Lewis',
          original_name: 'Austin Lewis',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215728263462003ef917a4',
          department: 'Production',
          job: 'Assistant Accountant',
        },
        {
          adult: false,
          gender: 1,
          id: 2969777,
          known_for_department: 'Art',
          name: 'Emma Verdugo',
          original_name: 'Emma Verdugo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602157dd0e597b003fa46bd9',
          department: 'Art',
          job: 'Set Decoration Buyer',
        },
        {
          adult: false,
          gender: 0,
          id: 2969779,
          known_for_department: 'Art',
          name: 'Benjamin Robertson',
          original_name: 'Benjamin Robertson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215862d6c3000041671cbb',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2969781,
          known_for_department: 'Art',
          name: 'Bernardo Osorio',
          original_name: 'Bernardo Osorio',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6021589460b58d003fd8dc44',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 2969784,
          known_for_department: 'Art',
          name: 'Brant Boling',
          original_name: 'Brant Boling',
          popularity: 0.6,
          profile_path: null,
          credit_id: '602158ceea37e0003f3f0179',
          department: 'Art',
          job: 'Set Dresser',
        },
        {
          adult: false,
          gender: 1,
          id: 2969787,
          known_for_department: 'Costume & Make-Up',
          name: 'Caroline Skubik',
          original_name: 'Caroline Skubik',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215a080e597b003ca44c15',
          department: 'Costume & Make-Up',
          job: 'Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2969788,
          known_for_department: 'Costume & Make-Up',
          name: 'Artemio Carpio',
          original_name: 'Artemio Carpio',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215a80dd2589003db6fca1',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 0,
          id: 2969792,
          known_for_department: 'Costume & Make-Up',
          name: 'Richard Gartrell',
          original_name: 'Richard Gartrell',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215aeb87a27a003e792f6d',
          department: 'Costume & Make-Up',
          job: 'Costume Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2969798,
          known_for_department: 'Lighting',
          name: 'Danny Carrillo',
          original_name: 'Danny Carrillo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215be587a27a00407a8e32',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2969799,
          known_for_department: 'Lighting',
          name: 'Richard Arana',
          original_name: 'Richard Arana',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215c29c2b9df00409edafe',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2969800,
          known_for_department: 'Lighting',
          name: 'Eric Kramer',
          original_name: 'Eric Kramer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215c56fd6300003e733002',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2969801,
          known_for_department: 'Lighting',
          name: 'Scotty Frazer',
          original_name: 'Scotty Frazer',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215c709979d20040e251ba',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2969803,
          known_for_department: 'Lighting',
          name: 'Devin Hayes',
          original_name: 'Devin Hayes',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60215cb90e597b003da446f9',
          department: 'Lighting',
          job: 'Lighting Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 3059026,
          known_for_department: 'Visual Effects',
          name: 'Jason Evanko',
          original_name: 'Jason Evanko',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995962aede59003d1ffb89',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 3085910,
          known_for_department: 'Sound',
          name: 'Jonathan Gomez',
          original_name: 'Jonathan Gomez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6099565eaede59003e2004e9',
          department: 'Sound',
          job: 'ADR Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 3085923,
          known_for_department: 'Crew',
          name: 'Daniel Dupre',
          original_name: 'Daniel Dupre',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995901efd3c2003b95f996',
          department: 'Crew',
          job: 'Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 3085924,
          known_for_department: 'Crew',
          name: 'Kyle Merola',
          original_name: 'Kyle Merola',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6099593db87aec003e9ff41b',
          department: 'Crew',
          job: 'Compositor',
        },
        {
          adult: false,
          gender: 0,
          id: 3085925,
          known_for_department: 'Visual Effects',
          name: 'Cathy Shaw',
          original_name: 'Cathy Shaw',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995975a3d027003a41aedc',
          department: 'Visual Effects',
          job: 'VFX Artist',
        },
        {
          adult: false,
          gender: 0,
          id: 3085927,
          known_for_department: 'Visual Effects',
          name: 'Andrew Kalicki',
          original_name: 'Andrew Kalicki',
          popularity: 0.6,
          profile_path: null,
          credit_id: '6099598f05a533003b296397',
          department: 'Visual Effects',
          job: 'Visual Effects Producer',
        },
        {
          adult: false,
          gender: 0,
          id: 3085935,
          known_for_department: 'Camera',
          name: 'Michael D. Gonzalez',
          original_name: 'Michael D. Gonzalez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995b97d2b209003d79b001',
          department: 'Camera',
          job: 'Best Boy Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 3085938,
          known_for_department: 'Camera',
          name: 'Christopher J. Schuster',
          original_name: 'Christopher J. Schuster',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995c37746457003f5b80da',
          department: 'Camera',
          job: 'Drone Cinematographer',
        },
        {
          adult: false,
          gender: 0,
          id: 3085939,
          known_for_department: 'Camera',
          name: 'Zynnia Cabrera',
          original_name: 'Zynnia Cabrera',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995c66006eee003b1d2938',
          department: 'Camera',
          job: 'Drone Pilot',
        },
        {
          adult: false,
          gender: 0,
          id: 3085940,
          known_for_department: 'Camera',
          name: 'Edwin Rios',
          original_name: 'Edwin Rios',
          popularity: 0.6,
          profile_path: null,
          credit_id: '60995cb572a2c9003c337c19',
          department: 'Camera',
          job: 'Grip',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'garethmb',
          author_details: {
            name: '',
            username: 'garethmb',
            avatar_path:
              '/https://secure.gravatar.com/avatar/3593437cbd05cebe0a4ee753965a8ad1.jpg',
            rating: null,
          },
          content:
            'Academy Award Winners Denzel Washington, Jared Leto, and Remi Malik star in the new thriller “The Little Things” and combine to make very gripping and memorable performances.\r\n\r\nThe script was reportedly written over thirty years ago by John Lee Hancock who has gone on to write, direct, and produce multiple films of note in the decades since he first created the screenplay.\r\nThe film is set in 1990 and involves a cop named Joe Deacon (Denzel Washington), who travels from his small California town to Los Angeles to get information on a suspect.\r\n\r\nJoe has a history in L.A as he used to be a homicide detective for the department which combined with his meltdown while obsessing over a murder case has caused him more than a bit of notoriety.\r\n\r\nJim Baxter (Remi Malik) is the hotshot new Detective who has been leading the investigation into a string of unsolved murders. Joe accompanies Jim to a new crime scene and notes some similarities with his unsolved case.  Joe takes some personal days and begins to do some legwork on the case and reports his findings to Jim which causes Joe to remember aspects of what drove him to his marital, health, and career issues as he is unable and unwilling to let the case drop.\r\n\r\nWhen a prime suspect no longer fits into the picture; suspicions fall on a crime enthusiast named Albert (Jared Leto) who seems to check all the boxes but is also taking delight in winding up Joe which causes Jim to question if he is a viable suspect or just an oddball who gets off on crimes and winding up the cops but does not actually commit any offenses.\r\n\r\nAs the delicate dance unfolds between the characters the fact that this is an era before Cell Phones, DNA tests, GPS, and elaborate computer networks helps underscore the plight of the officers. If the film was set in a modern setting much of the suspense and uncertainty of the story and characters would be moot thanks to technology. \r\n\r\nAs the game of cat and mouse unfolds between the characters Jim learns how a person can become obsessed with a case and Joe attempts to mentor him from the success and failures of his life which includes some gray areas.\r\nAside from the strong performances and engaging story what makes “The Little Things” work is that it is a film that does not take the Hollywood fallbacks of extended gunfights, car chases, and over the top action scenes. What it does show is real and flawed characters that are doing what they think are right and does not attempt to wrap things up nice and tidy.\r\n\r\nThe film uses the element of doubt to not only drive the story but the actions of the characters which underscores that an element of uncertainty exists in some investigations and in with the resources available to police at the time; things are not always certain.\r\n\r\nThe film will appear in cinemas and HBO Max and is a compelling and well-crafted thriller that is not to be missed.\r\n\r\n4.5 stars out of 5',
          created_at: '2021-01-26T19:43:51.708Z',
          id: '601070f70816c700417eac18',
          updated_at: '2021-06-23T15:58:50.637Z',
          url: 'https://www.themoviedb.org/review/601070f70816c700417eac18',
        },
        {
          author: 'JPV852',
          author_details: {
            name: '',
            username: 'JPV852',
            avatar_path: '/xNLOqXXVJf9m7WngUMLIMFsjKgh.jpg',
            rating: null,
          },
          content:
            "Okay movie made watchable thanks to Washington, Malek and to some extent Leto. Is a bit slow so does take a bit of patience to get to the end, but it's worth checking out. In addition, this is a movie that deserves the straight-to-streaming treatment and not pay to see in theaters. **3.0/5**",
          created_at: '2021-01-30T22:03:01.665Z',
          id: '6015d7951511aa0041540b4c',
          updated_at: '2021-06-23T15:58:50.894Z',
          url: 'https://www.themoviedb.org/review/6015d7951511aa0041540b4c',
        },
        {
          author: 'SWITCH.',
          author_details: {
            name: 'SWITCH.',
            username: 'maketheSWITCH',
            avatar_path: '/klZ9hebmc8biG1RC4WmzNFnciJN.jpg',
            rating: 4.0,
          },
          content:
            "'The Little Things' is a diversion - not the worst way to kill two hours, and definitely a movie with some people in it. It's a shame there isn't more to recommend about it.\r\n- Jake Watt\r\n\r\nRead Jake's full article...\r\nhttps://www.maketheswitch.com.au/article/review-the-little-things-three-oscar-winners-one-so-so-mystery",
          created_at: '2021-02-07T05:52:08.588Z',
          id: '601f80080e597b003ea1b4cb',
          updated_at: '2021-06-23T15:58:51.316Z',
          url: 'https://www.themoviedb.org/review/601f80080e597b003ea1b4cb',
        },
        {
          author: 'Louisa Moore - Screen Zealots',
          author_details: {
            name: 'Louisa Moore - Screen Zealots',
            username: 'screenzealots',
            avatar_path:
              '/https://secure.gravatar.com/avatar/70d4177132896d293b72f4c595521141.jpg',
            rating: null,
          },
          content:
            '“The Little Things” is such a by-the-book police procedural drama that the film doesn’t stand out much. It could be just another season of “True Detective,” or could run together in your memory with dozens of similar crime movies from the last 30 years. The story is familiar, but the ridiculous amount of talent from the Oscar winning cast helps to slightly elevate this routine material.\r\n\r\nVeteran sheriff Joe Deacon (Denzel Washington) teams up with police Sergeant Jim Baxter (Rami Malek) to search for a serial killer who’s murdering women in the Los Angeles area. With the body count rising, the men begin to focus on a suspect named Albert (Jared Leto), a disturbing and unbalanced man who enjoys toying with the cops. The men go to great lengths to uncover the guilty party, but the investigation brings up a dark history that uncovers some of Deacon’s long-buried secrets.\r\n\r\nIn terms of psychological crime thrillers, there’s nothing new here. The plot is uncomplicated and direct, and even the surprise reveal isn’t unexpected. Washington is the ideal casting choice as Deacon. He’s a reliable old timer, and there aren’t many actors like him who are working today. He plays well against Malik’s understated brooding, and both are no match for Leto. He’s great at creating crazed psychopath characters, selling the role as an unhinged killer right down to the most intimidating physical mannerisms. The cast is the film’s strongest point.\r\n\r\nDirector John Lee Hancock makes the awful choice to score scenes with 60’s rock and roll, which is almost as off-putting as the distrDiễn viên, choppy editing. There are depictions of crime scenes that are gruesome and distressing, giving the film an unsettling vibe. The overall atmosphere is unpleasant, and the film ultimately feels pointless.\r\n\r\n“The Little Things” isn’t a total dud by any means, but it’s not one of the best examples of the genre. The screenplay (by Hancock) is written for those who enjoy disciplined crime dramas, and it should satisfy fans who aren’t expecting too much.\r\n\r\nBy: Louisa Moore',
          created_at: '2021-03-09T04:25:55.309Z',
          id: '6046f8d370b44400459c4d41',
          updated_at: '2021-06-23T15:58:52.798Z',
          url: 'https://www.themoviedb.org/review/6046f8d370b44400459c4d41',
        },
        {
          author: 'lipjam',
          author_details: {
            name: '',
            username: 'lipjam',
            avatar_path:
              '/https://secure.gravatar.com/avatar/a7f5dbe85dda9297b402c772e3409d08.jpg',
            rating: 4.0,
          },
          content:
            'Good actors. Ok pacing. Storyline somewhat disjointed and unbelieveable at times. Poor ending.',
          created_at: '2021-04-04T14:38:54.552Z',
          id: '6069cf7ed3d3870059c7180e',
          updated_at: '2021-06-23T15:58:53.929Z',
          url: 'https://www.themoviedb.org/review/6069cf7ed3d3870059c7180e',
        },
        {
          author: 'msbreviews',
          author_details: {
            name: '',
            username: 'msbreviews',
            avatar_path:
              '/https://secure.gravatar.com/avatar/992eef352126a53d7e141bf9e8707576.jpg',
            rating: 3.0,
          },
          content:
            "Boasting some of the worst editing of the last couple of years, John Lee Hancock (The Highwaymen) delivers a Se7en's copycat narrative that lacks the overall interest and impact of the classic film. Despite good performances from the (type)cast, the supposedly mysterious, suspenseful story surrounding a serial killer is just another variation of the same formula people have seen hundreds of times.\r\n\r\nCharacters, relationships, and plot points are far from compelling, making the whole movie feel extremely forced and somewhat predictable. With no surprise factor and zero innovative developments, the overextended runtime simply becomes heavier and heavier...\r\n\r\nAn utter waste of remarkable actors.\r\n\r\nRating: D",
          created_at: '2021-10-12T16:13:40.179Z',
          id: '6165b4343a99370043eb094e',
          updated_at: '2021-10-12T16:13:40.179Z',
          url: 'https://www.themoviedb.org/review/6165b4343a99370043eb094e',
        },
      ],
      total_pages: 1,
      total_results: 6,
    },
  },
  {
    adult: false,
    backdrop_path:
      'https://image.tmdb.org/t/p/original/8LdElajDZ56XA5Y8UiIbW624x14.jpg',
    belongs_to_collection: null,
    budget: 6000000,
    genres: [
      { id: 18, name: 'Phim Chính Kịch' },
      { id: 10752, name: 'Phim Chiến Tranh' },
      { id: 28, name: 'Phim Hành Động' },
    ],
    homepage: '',
    id: 792,
    imdb_id: 'tt0091763',
    original_language: 'en',
    original_title: 'Platoon',
    overview:
      'Trung Đội mang lại cái nhìn rõ ràng hơn về cuộc chiến tranh phi nghĩa của đế quốc Mỹ tại Việt Nam. Phim khắc họa sâu sắc sự khủng hoảng cùng cực, bệ rạc của những tên lính xâm lược.Tân binh Chris Taylor (Charlie Sheen) là lính tình nguyện được điều động sang Việt Nam năm 1967, anh được bổ sung vào trung đội Bravo 6 thuộc Sư đoàn Bộ binh 25 Mỹ, vốn đã bị tiêu hao nặng sau những trận càn liên miên ở biên giới Việt Nam - Campuchia. Bravo 6 dưới quyền chỉ huy của trung úy Wolfe trẻ tuổi và chưa có kinh nghiệm trận mạc. Những cựu binh của trung đội là trung sĩ Barnes (Tom Berenger) và trung sĩ Elias (Willem Dafoe) luôn đối chọi nhau và lấn lướt quyền của trung đội trưởng.Trong một cuộc hành quân càn quét, Bravo 6 đã tràn vào ngôi làng tình nghi có ...',
    popularity: 21.688,
    poster_path:
      'https://image.tmdb.org/t/p/w342/m3mmFkPQKvPZq5exmh0bDuXlD9T.jpg',
    production_companies: [
      {
        id: 469,
        logo_path: null,
        name: 'Hemdale Film Corporation',
        origin_country: '',
      },
      { id: 104411, logo_path: null, name: 'Cinema 86', origin_country: '' },
      { id: 4764, logo_path: null, name: 'Cinema 84', origin_country: '' },
    ],
    production_countries: [
      { iso_3166_1: 'US', name: 'Hoa Kì' },
      { iso_3166_1: 'GB', name: 'United Kingdom' },
    ],
    release_date: '1986-12-19',
    revenue: 138530565,
    runtime: 120,
    spoken_languages: [
      { english_name: 'English', iso_639_1: 'en', name: 'English' },
      { english_name: 'Vietnamese', iso_639_1: 'vi', name: 'Tiếng Việt' },
    ],
    status: 'Đã phát hành',
    tagline: 'The first casualty of war is innocence.',
    title: 'Trung Đội',
    video: false,
    vote_average: 7.7,
    vote_count: 3382,
    videos: {
      results: [
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Platoon ≣ 1986 ≣ Trailer',
          key: 'Dbt7ewqYvRA',
          site: 'YouTube',
          size: 1080,
          type: 'Trailer',
          official: false,
          published_at: '2017-08-21T09:14:15.000Z',
          id: '5cd971c8c3a3681befc0395d',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Martin Sheen on PLATOON',
          key: 'PSLx-_swp9Y',
          published_at: '2011-12-21T00:46:14.000Z',
          site: 'YouTube',
          size: 480,
          type: 'Featurette',
          official: false,
          id: '533ec656c3a36854480005d8',
        },
        {
          iso_639_1: 'en',
          iso_3166_1: 'US',
          name: 'Platoon - Trailer - (1986) - HQ',
          key: 'pPi8EQzJ2Bg',
          published_at: '2008-12-25T18:36:00.000Z',
          site: 'YouTube',
          size: 480,
          type: 'Trailer',
          official: false,
          id: '533ec656c3a36854480005d7',
        },
      ],
    },
    credits: {
      cast: [
        {
          adult: false,
          gender: 2,
          id: 6952,
          known_for_department: 'Diễn viên',
          name: 'Charlie Sheen',
          original_name: 'Charlie Sheen',
          popularity: 3.926,
          profile_path:
            'https://image.tmdb.org/t/p/w185/npEqnIw321opMKuu3lsFNKNKQdX.jpg',
          cast_id: 93,
          character: 'Chris',
          credit_id: '5a7a203f925141776002c169',
          order: 0,
        },
        {
          adult: false,
          gender: 2,
          id: 5293,
          known_for_department: 'Diễn viên',
          name: 'Willem Dafoe',
          original_name: 'Willem Dafoe',
          popularity: 31.692,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ui8e4sgZAwMPi3hzEO53jyBJF9B.jpg',
          cast_id: 80,
          character: 'Sgt. Elias',
          credit_id: '5a7a1483c3a3682251029cb6',
          order: 1,
        },
        {
          adult: false,
          gender: 2,
          id: 85,
          known_for_department: 'Diễn viên',
          name: 'Johnny Depp',
          original_name: 'Johnny Depp',
          popularity: 21.175,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ilPBHd3r3ahlipNQtjr4E3G04jJ.jpg',
          cast_id: 88,
          character: 'Lerner',
          credit_id: '5a7a1575c3a368225502f80e',
          order: 2,
        },
        {
          adult: false,
          gender: 2,
          id: 2178,
          known_for_department: 'Diễn viên',
          name: 'Forest Whitaker',
          original_name: 'Forest Whitaker',
          popularity: 5.193,
          profile_path:
            'https://image.tmdb.org/t/p/w185/fugyEeN6sisuYi07HSoxdVHm0CZ.jpg',
          cast_id: 81,
          character: 'Big Harold',
          credit_id: '5a7a14990e0a26598502e38f',
          order: 3,
        },
        {
          adult: false,
          gender: 2,
          id: 13022,
          known_for_department: 'Diễn viên',
          name: 'Tom Berenger',
          original_name: 'Tom Berenger',
          popularity: 10.398,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zLxzAdAfu7y02yEx29JSLDgXJZ4.jpg',
          cast_id: 36,
          character: 'Staff Sergeant Bob Barnes',
          credit_id: '52fe4277c3a36847f8020d47',
          order: 4,
        },
        {
          adult: false,
          gender: 2,
          id: 65827,
          known_for_department: 'Diễn viên',
          name: 'Keith David',
          original_name: 'Keith David',
          popularity: 5.562,
          profile_path:
            'https://image.tmdb.org/t/p/w185/jJLJuR7FNHYL1fB5igjj7IXzOel.jpg',
          cast_id: 23,
          character: 'King',
          credit_id: '52fe4277c3a36847f8020d37',
          order: 5,
        },
        {
          adult: false,
          gender: 2,
          id: 11886,
          known_for_department: 'Diễn viên',
          name: 'Francesco Quinn',
          original_name: 'Francesco Quinn',
          popularity: 2.659,
          profile_path:
            'https://image.tmdb.org/t/p/w185/5afSAq8iusKG5i9SDSgZV9xHJuM.jpg',
          cast_id: 82,
          character: 'Rhah',
          credit_id: '5a7a14b39251417754028f3d',
          order: 6,
        },
        {
          adult: false,
          gender: 2,
          id: 6863,
          known_for_department: 'Diễn viên',
          name: 'Kevin Dillon',
          original_name: 'Kevin Dillon',
          popularity: 2.106,
          profile_path:
            'https://image.tmdb.org/t/p/w185/tIadFMFzA6LcXaAaVpJmrd7waXQ.jpg',
          cast_id: 83,
          character: 'Bunny',
          credit_id: '5a7a14d3c3a368225502f746',
          order: 7,
        },
        {
          adult: false,
          gender: 2,
          id: 11885,
          known_for_department: 'Diễn viên',
          name: 'John C. McGinley',
          original_name: 'John C. McGinley',
          popularity: 6.539,
          profile_path:
            'https://image.tmdb.org/t/p/w185/a9Oc7STg83syQh3X22u2TroAifk.jpg',
          cast_id: 84,
          character: "Sgt. O'Neill",
          credit_id: '5a7a15049251417754028f94',
          order: 8,
        },
        {
          adult: false,
          gender: 2,
          id: 11888,
          known_for_department: 'Diễn viên',
          name: 'Reggie Johnson',
          original_name: 'Reggie Johnson',
          popularity: 1.4,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kWn0MOxzU4Ag4XQPRKEElimnzrm.jpg',
          cast_id: 85,
          character: 'Junior',
          credit_id: '5a7a1523c3a3682261027d6e',
          order: 9,
        },
        {
          adult: false,
          gender: 2,
          id: 11889,
          known_for_department: 'Diễn viên',
          name: 'Mark Moses',
          original_name: 'Mark Moses',
          popularity: 2.403,
          profile_path:
            'https://image.tmdb.org/t/p/w185/c4C6xZoBx3ATQ8yzdiWX8p6LdKq.jpg',
          cast_id: 86,
          character: 'Lt. Wolfe',
          credit_id: '5a7a153c0e0a26599102e0bd',
          order: 10,
        },
        {
          adult: false,
          gender: 2,
          id: 11894,
          known_for_department: 'Diễn viên',
          name: 'Corey Glover',
          original_name: 'Corey Glover',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bGYIzsvavAq15SNKaVajwJwmZuA.jpg',
          cast_id: 87,
          character: 'Francis',
          credit_id: '5a7a15590e0a26598802dfb7',
          order: 11,
        },
        {
          adult: false,
          gender: 2,
          id: 11890,
          known_for_department: 'Diễn viên',
          name: 'Chris Pedersen',
          original_name: 'Chris Pedersen',
          popularity: 1.694,
          profile_path:
            'https://image.tmdb.org/t/p/w185/qf1P6TXDEqEA2eHsoGrcHa8Spkr.jpg',
          cast_id: 89,
          character: 'Crawford',
          credit_id: '5a7a1592925141775c028d1c',
          order: 12,
        },
        {
          adult: false,
          gender: 0,
          id: 11895,
          known_for_department: 'Diễn viên',
          name: 'Bob Orwig',
          original_name: 'Bob Orwig',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/liBVBj77ueAq9vpVhTvjEmFhKR.jpg',
          cast_id: 90,
          character: 'Gardner',
          credit_id: '5a7a18e2c3a368227302d061',
          order: 13,
        },
        {
          adult: false,
          gender: 0,
          id: 1447263,
          known_for_department: 'Diễn viên',
          name: 'Corkey Ford',
          original_name: 'Corkey Ford',
          popularity: 0.6,
          profile_path: null,
          cast_id: 91,
          character: 'Manny',
          credit_id: '5a7a1ff5c3a368227302d6a9',
          order: 14,
        },
        {
          adult: false,
          gender: 2,
          id: 4042,
          known_for_department: 'Diễn viên',
          name: 'David Neidorf',
          original_name: 'David Neidorf',
          popularity: 1.175,
          profile_path:
            'https://image.tmdb.org/t/p/w185/dhnYvp7cd939ITQWaFOqrOh9ZG3.jpg',
          cast_id: 92,
          character: 'Tex',
          credit_id: '5a7a20180e0a26599402db85',
          order: 15,
        },
        {
          adult: false,
          gender: 2,
          id: 6396,
          known_for_department: 'Diễn viên',
          name: 'Richard Edson',
          original_name: 'Richard Edson',
          popularity: 2.912,
          profile_path:
            'https://image.tmdb.org/t/p/w185/vuuU7beZrawR6VZB3a2QhDVtkjg.jpg',
          cast_id: 94,
          character: 'Sal',
          credit_id: '5a7a20619251417766028f81',
          order: 16,
        },
        {
          adult: false,
          gender: 2,
          id: 19384,
          known_for_department: 'Diễn viên',
          name: 'Tony Todd',
          original_name: 'Tony Todd',
          popularity: 4.304,
          profile_path:
            'https://image.tmdb.org/t/p/w185/iFISUOjo3ICCQuLwaDUeuGeYKnW.jpg',
          cast_id: 95,
          character: 'Warren',
          credit_id: '5a7a208892514177630280f7',
          order: 17,
        },
        {
          adult: false,
          gender: 0,
          id: 11896,
          known_for_department: 'Diễn viên',
          name: 'Kevin Eshelman',
          original_name: 'Kevin Eshelman',
          popularity: 1.217,
          profile_path:
            'https://image.tmdb.org/t/p/w185/sC1033WwAS22eGqX8vvvWXvPtlZ.jpg',
          cast_id: 96,
          character: 'Morehouse',
          credit_id: '5a7a20afc3a368227b030bea',
          order: 18,
        },
        {
          adult: false,
          gender: 2,
          id: 11897,
          known_for_department: 'Diễn viên',
          name: 'James Terry McIlvain',
          original_name: 'James Terry McIlvain',
          popularity: 0.665,
          profile_path:
            'https://image.tmdb.org/t/p/w185/s4PtKoC0YQuI7BEHDmOIF4n6wtA.jpg',
          cast_id: 97,
          character: 'Ace',
          credit_id: '5a7a20e8925141776302813c',
          order: 19,
        },
        {
          adult: false,
          gender: 2,
          id: 11893,
          known_for_department: 'Diễn viên',
          name: 'J. Adam Glover',
          original_name: 'J. Adam Glover',
          popularity: 1.96,
          profile_path:
            'https://image.tmdb.org/t/p/w185/3g41FBOlsY1g8h59eo0T4LScFbL.jpg',
          cast_id: 98,
          character: 'Sanderson',
          credit_id: '5a7a2108925141776902bdbb',
          order: 20,
        },
        {
          adult: false,
          gender: 2,
          id: 11891,
          known_for_department: 'Diễn viên',
          name: 'Ivan Kane',
          original_name: 'Ivan Kane',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/ps90jjqtgWo00c1MYOfelhlBwGV.jpg',
          cast_id: 99,
          character: 'Tony',
          credit_id: '5a7a2117925141775702b8c8',
          order: 21,
        },
        {
          adult: false,
          gender: 2,
          id: 11892,
          known_for_department: 'Diễn viên',
          name: 'Paul Sanchez',
          original_name: 'Paul Sanchez',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/kMeHRtJGgS1RrThOecSy4wcy3uV.jpg',
          cast_id: 100,
          character: 'Doc',
          credit_id: '5a7a2178925141775902a591',
          order: 22,
        },
        {
          adult: false,
          gender: 2,
          id: 3211,
          known_for_department: 'Diễn viên',
          name: 'Dale Dye',
          original_name: 'Dale Dye',
          popularity: 1.331,
          profile_path:
            'https://image.tmdb.org/t/p/w185/bkMcK2hvB1wRJT1YFgNTl7ivlF2.jpg',
          cast_id: 101,
          character: 'Captain Harris',
          credit_id: '5a7a21ad925141776902be50',
          order: 23,
        },
        {
          adult: false,
          gender: 0,
          id: 1973823,
          known_for_department: 'Diễn viên',
          name: 'Peter Hicks',
          original_name: 'Peter Hicks',
          popularity: 1.4,
          profile_path: null,
          cast_id: 102,
          character: 'Parker',
          credit_id: '5a7a21da0e0a26598802eba0',
          order: 24,
        },
        {
          adult: false,
          gender: 0,
          id: 1973824,
          known_for_department: 'Diễn viên',
          name: 'Basile Achara',
          original_name: 'Basile Achara',
          popularity: 0.6,
          profile_path: null,
          cast_id: 103,
          character: 'Flash',
          credit_id: '5a7a21edc3a36822610287c2',
          order: 25,
        },
        {
          adult: false,
          gender: 0,
          id: 1973825,
          known_for_department: 'Diễn viên',
          name: 'Steve Barredo',
          original_name: 'Steve Barredo',
          popularity: 0.6,
          profile_path: null,
          cast_id: 104,
          character: 'Fu Sheng',
          credit_id: '5a7a2203c3a368227b030d15',
          order: 26,
        },
        {
          adult: false,
          gender: 0,
          id: 1921431,
          known_for_department: 'Diễn viên',
          name: 'Chris Castillejo',
          original_name: 'Chris Castillejo',
          popularity: 0.6,
          profile_path: null,
          cast_id: 105,
          character: 'Rodriguez',
          credit_id: '5a7a222c9251417766029106',
          order: 27,
        },
        {
          adult: false,
          gender: 0,
          id: 1973826,
          known_for_department: 'Diễn viên',
          name: 'Andrew B. Clark',
          original_name: 'Andrew B. Clark',
          popularity: 0.6,
          profile_path: null,
          cast_id: 106,
          character: 'Tubbs',
          credit_id: '5a7a22dd0e0a26598502f178',
          order: 28,
        },
        {
          adult: false,
          gender: 0,
          id: 1973827,
          known_for_department: 'Diễn viên',
          name: 'Bernardo Manalili',
          original_name: 'Bernardo Manalili',
          popularity: 0.6,
          profile_path: null,
          cast_id: 107,
          character: 'Village Chief',
          credit_id: '5a7a231cc3a368226502d6b2',
          order: 29,
        },
        {
          adult: false,
          gender: 0,
          id: 1973829,
          known_for_department: 'Diễn viên',
          name: 'Than Rogers',
          original_name: 'Than Rogers',
          popularity: 0.6,
          profile_path: null,
          cast_id: 108,
          character: "Village Chief's Wife",
          credit_id: '5a7a2364c3a368225b028b7e',
          order: 30,
        },
        {
          adult: false,
          gender: 0,
          id: 1973830,
          known_for_department: 'Diễn viên',
          name: 'Li Thi Van',
          original_name: 'Li Thi Van',
          popularity: 0.6,
          profile_path: null,
          cast_id: 109,
          character: "Village Chief's Daughter",
          credit_id: '5a7a23cdc3a368224e029fb3',
          order: 31,
        },
        {
          adult: false,
          gender: 0,
          id: 1973833,
          known_for_department: 'Diễn viên',
          name: 'Clarisa Ortacio',
          original_name: 'Clarisa Ortacio',
          popularity: 0.6,
          profile_path: null,
          cast_id: 110,
          character: 'Old Woman',
          credit_id: '5a7a23fb9251417754029bf5',
          order: 32,
        },
        {
          adult: false,
          gender: 0,
          id: 1973837,
          known_for_department: 'Diễn viên',
          name: 'Romy Sevilla',
          original_name: 'Romy Sevilla',
          popularity: 0.6,
          profile_path: null,
          cast_id: 111,
          character: 'One-Legged Man',
          credit_id: '5a7a24cb925141775902a851',
          order: 33,
        },
        {
          adult: false,
          gender: 0,
          id: 1973835,
          known_for_department: 'Diễn viên',
          name: 'Matthew Westfall',
          original_name: 'Matthew Westfall',
          popularity: 0.6,
          profile_path: null,
          cast_id: 112,
          character: 'Terrified Soldier',
          credit_id: '5a7a25240e0a26597f02f38c',
          order: 34,
        },
        {
          adult: false,
          gender: 2,
          id: 107323,
          known_for_department: 'Diễn viên',
          name: 'Nick Nicholson',
          original_name: 'Nick Nicholson',
          popularity: 0.694,
          profile_path: null,
          cast_id: 113,
          character: 'Mechanized Soldier #1',
          credit_id: '5a7a2555c3a368227302dbcd',
          order: 35,
        },
        {
          adult: false,
          gender: 2,
          id: 11881,
          known_for_department: 'Production',
          name: 'Warren McLean',
          original_name: 'Warren McLean',
          popularity: 0.6,
          profile_path: null,
          cast_id: 114,
          character: 'Mechanized Soldier #2',
          credit_id: '5a7a25790e0a26598202f4ec',
          order: 36,
        },
        {
          adult: false,
          gender: 0,
          id: 1973848,
          known_for_department: 'Diễn viên',
          name: 'Li Mai Thao',
          original_name: 'Li Mai Thao',
          popularity: 0.6,
          profile_path: null,
          cast_id: 115,
          character: 'Rape Victim',
          credit_id: '5a7a25bd0e0a26599402e171',
          order: 37,
        },
        {
          adult: false,
          gender: 0,
          id: 1973849,
          known_for_department: 'Diễn viên',
          name: 'Ron Barracks',
          original_name: 'Ron Barracks',
          popularity: 0.6,
          profile_path: null,
          cast_id: 116,
          character: 'Medic',
          credit_id: '5a7a25d80e0a26598b02f462',
          order: 38,
        },
        {
          adult: false,
          gender: 2,
          id: 135538,
          known_for_department: 'Directing',
          name: 'H. Gordon Boos',
          original_name: 'H. Gordon Boos',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nx1F9IBmEKnvZxaWg9cfi3cXEg1.jpg',
          cast_id: 117,
          character: 'Soldier with Mohawk Haircut (uncredited)',
          credit_id: '5a7a26a1925141776002c73b',
          order: 39,
        },
        {
          adult: false,
          gender: 2,
          id: 1434559,
          known_for_department: 'Crew',
          name: "Robert 'Rock' Galotti",
          original_name: "Robert 'Rock' Galotti",
          popularity: 0.6,
          profile_path: null,
          cast_id: 118,
          character: 'Huffmeister (uncredited)',
          credit_id: '5a7a26e60e0a26599402e268',
          order: 40,
        },
        {
          adult: false,
          gender: 2,
          id: 1152,
          known_for_department: 'Directing',
          name: 'Oliver Stone',
          original_name: 'Oliver Stone',
          popularity: 3.616,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nPFtjueZHmU56boVKXEvAoQOTWf.jpg',
          cast_id: 119,
          character: 'Alpha Company Major in Bunker (uncredited)',
          credit_id: '5a7a274fc3a3682261028cb3',
          order: 41,
        },
        {
          adult: false,
          gender: 0,
          id: 1457986,
          known_for_department: 'Diễn viên',
          name: 'Brad Cassini',
          original_name: 'Brad Cassini',
          popularity: 0.6,
          profile_path: null,
          cast_id: 120,
          character: 'Soldier (uncredited)',
          credit_id: '5a7a27ab92514177630286bb',
          order: 42,
        },
        {
          adult: false,
          gender: 0,
          id: 1973866,
          known_for_department: 'Diễn viên',
          name: 'Mark Ebenhoch',
          original_name: 'Mark Ebenhoch',
          popularity: 0.6,
          profile_path: null,
          cast_id: 121,
          character: 'Ebenhoch (uncredited)',
          credit_id: '5a7a34fd925141776002d310',
          order: 43,
        },
      ],
      crew: [
        {
          adult: false,
          gender: 2,
          id: 149,
          known_for_department: 'Camera',
          name: 'Robert Richardson',
          original_name: 'Robert Richardson',
          popularity: 3.135,
          profile_path:
            'https://image.tmdb.org/t/p/w185/lmJy31oZtN5l2VAGpkrt3xEXsxL.jpg',
          credit_id: '52fe4277c3a36847f8020cf3',
          department: 'Camera',
          job: 'Director of Photography',
        },
        {
          adult: false,
          gender: 2,
          id: 1152,
          known_for_department: 'Directing',
          name: 'Oliver Stone',
          original_name: 'Oliver Stone',
          popularity: 3.616,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nPFtjueZHmU56boVKXEvAoQOTWf.jpg',
          credit_id: '52fe4277c3a36847f8020ccf',
          department: 'Biên kịch',
          job: 'Screenplay',
        },
        {
          adult: false,
          gender: 2,
          id: 1152,
          known_for_department: 'Directing',
          name: 'Oliver Stone',
          original_name: 'Oliver Stone',
          popularity: 3.616,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nPFtjueZHmU56boVKXEvAoQOTWf.jpg',
          credit_id: '52fe4277c3a36847f8020cc9',
          department: 'Directing',
          job: 'Director',
        },
        {
          adult: false,
          gender: 2,
          id: 2621,
          known_for_department: 'Production',
          name: 'A. Kitman Ho',
          original_name: 'A. Kitman Ho',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af379c09251417878002ae7',
          department: 'Production',
          job: 'Co-Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 2720,
          known_for_department: 'Production',
          name: 'Derek Gibson',
          original_name: 'Derek Gibson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4277c3a36847f8020ce1',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 2721,
          known_for_department: 'Production',
          name: 'John Daly',
          original_name: 'John Daly',
          popularity: 1.38,
          profile_path: null,
          credit_id: '52fe4277c3a36847f8020ce7',
          department: 'Production',
          job: 'Executive Producer',
        },
        {
          adult: false,
          gender: 2,
          id: 3103,
          known_for_department: 'Sound',
          name: 'Charles Grenzbach',
          original_name: 'Charles Grenzbach',
          popularity: 0.84,
          profile_path: null,
          credit_id: '5a9aa8eb0e0a2605f201dd80',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 2,
          id: 3535,
          known_for_department: 'Sound',
          name: 'Georges Delerue',
          original_name: 'Georges Delerue',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xKRsHzgZicN1KCUmnl4M09TVCxE.jpg',
          credit_id: '52fe4277c3a36847f8020ced',
          department: 'Sound',
          job: 'Original Music Composer',
        },
        {
          adult: false,
          gender: 2,
          id: 3535,
          known_for_department: 'Sound',
          name: 'Georges Delerue',
          original_name: 'Georges Delerue',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/xKRsHzgZicN1KCUmnl4M09TVCxE.jpg',
          credit_id: '5cf301d90e0a261e1bcd0517',
          department: 'Sound',
          job: 'Conductor',
        },
        {
          adult: false,
          gender: 0,
          id: 4714,
          known_for_department: 'Sound',
          name: 'Greg Dillon',
          original_name: 'Greg Dillon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aa8dd925141289601d0a7',
          department: 'Sound',
          job: 'Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 5709,
          known_for_department: 'Art',
          name: 'Bruno Rubeo',
          original_name: 'Bruno Rubeo',
          popularity: 0.98,
          profile_path: null,
          credit_id: '52fe4277c3a36847f8020d11',
          department: 'Art',
          job: 'Production Design',
        },
        {
          adult: false,
          gender: 2,
          id: 6051,
          known_for_department: 'Editing',
          name: 'David Brenner',
          original_name: 'David Brenner',
          popularity: 0.728,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zGKJ7WXooRVqLgK7geLpsUq8McA.jpg',
          credit_id: '5af37ceb0e0a263971002e58',
          department: 'Editing',
          job: 'First Assistant Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 8971,
          known_for_department: 'Production',
          name: 'Pat Golden',
          original_name: 'Pat Golden',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4277c3a36847f8020cff',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 10764,
          known_for_department: 'Production',
          name: 'Arnold Kopelson',
          original_name: 'Arnold Kopelson',
          popularity: 0.98,
          profile_path: null,
          credit_id: '52fe4277c3a36847f8020cd5',
          department: 'Production',
          job: 'Producer',
        },
        {
          adult: false,
          gender: 1,
          id: 11880,
          known_for_department: 'Editing',
          name: 'Claire Simpson',
          original_name: 'Claire Simpson',
          popularity: 1.614,
          profile_path:
            'https://image.tmdb.org/t/p/w185/l67tVrqKyvVnPeU0nfCgK3SzQnE.jpg',
          credit_id: '52fe4277c3a36847f8020cf9',
          department: 'Editing',
          job: 'Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 11881,
          known_for_department: 'Production',
          name: 'Warren McLean',
          original_name: 'Warren McLean',
          popularity: 0.6,
          profile_path: null,
          credit_id: '52fe4277c3a36847f8020d05',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 2,
          id: 11882,
          known_for_department: 'Production',
          name: 'Bob Morones',
          original_name: 'Bob Morones',
          popularity: 0.98,
          profile_path: null,
          credit_id: '52fe4277c3a36847f8020d0b',
          department: 'Production',
          job: 'Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 11883,
          known_for_department: 'Art',
          name: 'Rodell Cruz',
          original_name: 'Rodell Cruz',
          popularity: 1.048,
          profile_path: null,
          credit_id: '52fe4277c3a36847f8020d17',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 2,
          id: 12114,
          known_for_department: 'Directing',
          name: 'Michael Cimino',
          original_name: 'Michael Cimino',
          popularity: 1.22,
          profile_path:
            'https://image.tmdb.org/t/p/w185/7LyJWnmesjNnmpLDtWcYXVnkfkW.jpg',
          credit_id: '5709376bc3a3687de30002f1',
          department: 'Crew',
          job: 'Thanks',
        },
        {
          adult: false,
          gender: 1,
          id: 21517,
          known_for_department: 'Production',
          name: 'Mary Colquhoun',
          original_name: 'Mary Colquhoun',
          popularity: 1.4,
          profile_path: null,
          credit_id: '5709379dc3a3681d3a00377d',
          department: 'Crew',
          job: 'Thanks',
        },
        {
          adult: false,
          gender: 2,
          id: 24681,
          known_for_department: 'Sound',
          name: 'Simon Kaye',
          original_name: 'Simon Kaye',
          popularity: 0.6,
          profile_path: null,
          credit_id: '579640f0c3a3683ce4000804',
          department: 'Sound',
          job: 'Sound Mixer',
        },
        {
          adult: false,
          gender: 1,
          id: 47892,
          known_for_department: 'Costume & Make-Up',
          name: 'Kathryn Morrison',
          original_name: 'Kathryn Morrison',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5709384cc3a36810b400019a',
          department: 'Costume & Make-Up',
          job: 'Set Costumer',
        },
        {
          adult: false,
          gender: 2,
          id: 51701,
          known_for_department: 'Editing',
          name: 'Tom Finan',
          original_name: 'Tom Finan',
          popularity: 0.656,
          profile_path: null,
          credit_id: '5cf3019d925141247cbc1d52',
          department: 'Editing',
          job: 'Associate Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 53645,
          known_for_department: 'Editing',
          name: 'Julie Monroe',
          original_name: 'Julie Monroe',
          popularity: 0.6,
          profile_path: null,
          credit_id: '57093880c3a3687de3000321',
          department: 'Editing',
          job: 'Assistant Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 71833,
          known_for_department: 'Art',
          name: 'Sherman Williams',
          original_name: 'Sherman Williams',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5709330b92514155f30000f5',
          department: 'Art',
          job: 'Art Direction',
        },
        {
          adult: false,
          gender: 0,
          id: 74817,
          known_for_department: 'Production',
          name: 'Graham Henderson',
          original_name: 'Graham Henderson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5709347592514155f300012e',
          department: 'Production',
          job: 'Executive In Charge Of Production',
        },
        {
          adult: false,
          gender: 2,
          id: 75002,
          known_for_department: 'Sound',
          name: 'Budd Carr',
          original_name: 'Budd Carr',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5648c6069251413acf0080ff',
          department: 'Sound',
          job: 'Music Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 86332,
          known_for_department: 'Production',
          name: 'Gerry Toomey',
          original_name: 'Gerry Toomey',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5709361f9251414a560002ad',
          department: 'Directing',
          job: 'Assistant Director',
        },
        {
          adult: false,
          gender: 1,
          id: 91312,
          known_for_department: 'Sound',
          name: 'Vanessa Theme Ament',
          original_name: 'Vanessa Theme Ament',
          popularity: 1.166,
          profile_path: null,
          credit_id: '5af37df7c3a3682165001fad',
          department: 'Sound',
          job: 'Foley Artist',
        },
        {
          adult: false,
          gender: 2,
          id: 107323,
          known_for_department: 'Diễn viên',
          name: 'Nick Nicholson',
          original_name: 'Nick Nicholson',
          popularity: 0.694,
          profile_path: null,
          credit_id: '5cf30268c3a36861781de968',
          department: 'Production',
          job: 'Production Assistant',
        },
        {
          adult: false,
          gender: 2,
          id: 135538,
          known_for_department: 'Directing',
          name: 'H. Gordon Boos',
          original_name: 'H. Gordon Boos',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/nx1F9IBmEKnvZxaWg9cfi3cXEg1.jpg',
          credit_id: '5af37cb10e0a263943002c36',
          department: 'Directing',
          job: 'First Assistant Director',
        },
        {
          adult: false,
          gender: 0,
          id: 136424,
          known_for_department: 'Crew',
          name: 'Gil Arceo',
          original_name: 'Gil Arceo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5709369dc3a368775700032f',
          department: 'Crew',
          job: 'Stunt Coordinator',
        },
        {
          adult: false,
          gender: 2,
          id: 202100,
          known_for_department: 'Biên kịch',
          name: 'Tim Minear',
          original_name: 'Tim Minear',
          popularity: 1.139,
          profile_path:
            'https://image.tmdb.org/t/p/w185/zOnOJmM0sShVbLgW2jB0j0r6D6U.jpg',
          credit_id: '5737a55cc3a3686f04000cd8',
          department: 'Directing',
          job: 'Assistant Director',
        },
        {
          adult: false,
          gender: 1,
          id: 230436,
          known_for_department: 'Production',
          name: 'Barbara Harris',
          original_name: 'Barbara Harris',
          popularity: 1.426,
          profile_path:
            'https://image.tmdb.org/t/p/w185/d1BGeZT2b81Wa9gCOPdrXGWUtmR.jpg',
          credit_id: '5cc4ce39c3a36827d584760f',
          department: 'Production',
          job: 'ADR Voice Casting',
        },
        {
          adult: false,
          gender: 0,
          id: 589973,
          known_for_department: 'Camera',
          name: 'Chris Lombardi',
          original_name: 'Chris Lombardi',
          popularity: 0.982,
          profile_path: null,
          credit_id: '5af37a79925141790f002478',
          department: 'Camera',
          job: 'First Assistant Camera',
        },
        {
          adult: false,
          gender: 2,
          id: 1053716,
          known_for_department: 'Sound',
          name: 'Richard Stone',
          original_name: 'Richard Stone',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf301f89251411882bc09bd',
          department: 'Sound',
          job: 'Supervising Music Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1202157,
          known_for_department: 'Diễn viên',
          name: 'Dwight Gaston',
          original_name: 'Dwight Gaston',
          popularity: 0.694,
          profile_path: null,
          credit_id: '60c00400eb79c20040b308af',
          department: 'Art',
          job: 'Assistant Set Dresser',
        },
        {
          adult: false,
          gender: 0,
          id: 1304735,
          known_for_department: 'Directing',
          name: 'Pepito Diaz',
          original_name: 'Pepito Diaz',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf2ff14c3a36861781de271',
          department: 'Directing',
          job: 'Second Assistant Director',
        },
        {
          adult: false,
          gender: 2,
          id: 1314343,
          known_for_department: 'Editing',
          name: 'David Campling',
          original_name: 'David Campling',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aa8c1c3a3680c0801d682',
          department: 'Sound',
          job: 'Sound Editor',
        },
        {
          adult: false,
          gender: 1,
          id: 1324995,
          known_for_department: 'Costume & Make-Up',
          name: 'Cecille Baun',
          original_name: 'Cecille Baun',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5709334cc3a3681d24003a2f',
          department: 'Costume & Make-Up',
          job: 'Prosthetic Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1340086,
          known_for_department: 'Production',
          name: 'Jonathan Sheinberg',
          original_name: 'Jonathan Sheinberg',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf302230e0a264876cdb685',
          department: 'Production',
          job: 'Head of Production',
        },
        {
          adult: false,
          gender: 0,
          id: 1342639,
          known_for_department: 'Sound',
          name: 'James J. Klinger',
          original_name: 'James J. Klinger',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aa928925141285101d556',
          department: 'Sound',
          job: 'Sound Editor',
        },
        {
          adult: false,
          gender: 0,
          id: 1345106,
          known_for_department: 'Diễn viên',
          name: 'Alex Cabodil',
          original_name: 'Alex Cabodil',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af37c7c9251417878002c4c',
          department: 'Crew',
          job: 'Stunts',
        },
        {
          adult: false,
          gender: 2,
          id: 1349631,
          known_for_department: 'Diễn viên',
          name: "Jerry O'Hara",
          original_name: "Jerry O'Hara",
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af37d60925141787c002da3',
          department: 'Production',
          job: 'Location Manager',
        },
        {
          adult: false,
          gender: 2,
          id: 1378199,
          known_for_department: 'Sound',
          name: 'Gordon Daniel',
          original_name: 'Gordon Daniel',
          popularity: 0.6,
          profile_path:
            'https://image.tmdb.org/t/p/w185/2M1HP8CEUQ2g9NvlulkfWXFkz5V.jpg',
          credit_id: '5648c6579251413ae1007bee',
          department: 'Sound',
          job: 'Supervising Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1429245,
          known_for_department: 'Visual Effects',
          name: 'Yves De Bono',
          original_name: 'Yves De Bono',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af37e550e0a26395e002ae0',
          department: 'Visual Effects',
          job: 'Special Effects Supervisor',
        },
        {
          adult: false,
          gender: 2,
          id: 1431628,
          known_for_department: 'Sound',
          name: 'Richard D. Rogers',
          original_name: 'Richard D. Rogers',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aa940c3a3680b990230eb',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 1,
          id: 1434225,
          known_for_department: 'Directing',
          name: 'Susan Malerstein',
          original_name: 'Susan Malerstein',
          popularity: 0.972,
          profile_path: null,
          credit_id: '5648c5e0c3a368260c0080ef',
          department: 'Directing',
          job: 'Script Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1515941,
          known_for_department: 'Production',
          name: 'John Kerr',
          original_name: 'John Kerr',
          popularity: 0.828,
          profile_path: null,
          credit_id: '5cf30237c3a36861781de8d1',
          department: 'Production',
          job: 'Key Production Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 1536637,
          known_for_department: 'Camera',
          name: 'Ricky Francisco',
          original_name: 'Ricky Francisco',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5648c6249251413ae1007bd8',
          department: 'Camera',
          job: 'Still Photographer',
        },
        {
          adult: false,
          gender: 0,
          id: 1536638,
          known_for_department: 'Production',
          name: 'Ooty Moorehead',
          original_name: 'Ooty Moorehead',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5648c63dc3a3682620008344',
          department: 'Production',
          job: 'Production Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 1603300,
          known_for_department: 'Costume & Make-Up',
          name: 'Gordon J. Smith',
          original_name: 'Gordon J. Smith',
          popularity: 0.98,
          profile_path: null,
          credit_id: '570933c4c3a36877570002a2',
          department: 'Crew',
          job: 'Makeup Effects',
        },
        {
          adult: false,
          gender: 0,
          id: 1640698,
          known_for_department: 'Sound',
          name: 'Anthony Palk',
          original_name: 'Anthony Palk',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aa91792514127ea01d9de',
          department: 'Sound',
          job: 'Sound Editor',
        },
        {
          adult: false,
          gender: 2,
          id: 1648134,
          known_for_department: 'Art',
          name: 'Dan Perri',
          original_name: 'Dan Perri',
          popularity: 0.766,
          profile_path: null,
          credit_id: '5c151b2692514132ba0ab7dd',
          department: 'Art',
          job: 'Title Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1697617,
          known_for_department: 'Production',
          name: 'Andy Birmingham',
          original_name: 'Andy Birmingham',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af37d74c3a36821410035f5',
          department: 'Production',
          job: 'Production Accountant',
        },
        {
          adult: false,
          gender: 2,
          id: 1710243,
          known_for_department: 'Sound',
          name: 'John Wilkinson',
          original_name: 'John Wilkinson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aa94f0e0a26064901faef',
          department: 'Sound',
          job: 'Sound Re-Recording Mixer',
        },
        {
          adult: false,
          gender: 1,
          id: 1736218,
          known_for_department: 'Editing',
          name: 'Mary Nelson-Duerrstein',
          original_name: 'Mary Nelson-Duerrstein',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf301bcc3a3685c081de7db',
          department: 'Editing',
          job: 'Negative Cutter',
        },
        {
          adult: false,
          gender: 0,
          id: 1743157,
          known_for_department: 'Production',
          name: 'Dianne E. Collins',
          original_name: 'Dianne E. Collins',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af37dbe92514178e6001b23',
          department: 'Production',
          job: 'Publicist',
        },
        {
          adult: false,
          gender: 0,
          id: 1792769,
          known_for_department: 'Sound',
          name: 'Steve Bartlett',
          original_name: 'Steve Bartlett',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aa96f0e0a2605d501f0a7',
          department: 'Sound',
          job: 'Sound Designer',
        },
        {
          adult: false,
          gender: 0,
          id: 1827973,
          known_for_department: 'Editing',
          name: 'Ron Wengler',
          original_name: 'Ron Wengler',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af37ccf92514179fc002698',
          department: 'Editing',
          job: 'Color Timer',
        },
        {
          adult: false,
          gender: 2,
          id: 1969161,
          known_for_department: 'Camera',
          name: 'James Finnerty',
          original_name: 'James Finnerty',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af37a9592514178cc0019df',
          department: 'Camera',
          job: 'Grip',
        },
        {
          adult: false,
          gender: 2,
          id: 1978806,
          known_for_department: 'Lighting',
          name: 'James Fitzpatrick',
          original_name: 'James Fitzpatrick',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af37d270e0a26396e002d4d',
          department: 'Lighting',
          job: 'Gaffer',
        },
        {
          adult: false,
          gender: 0,
          id: 1989405,
          known_for_department: 'Sound',
          name: 'Taffy Haines',
          original_name: 'Taffy Haines',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5a9aa8f50e0a26061101fc1b',
          department: 'Sound',
          job: 'Sound Mixer',
        },
        {
          adult: false,
          gender: 0,
          id: 2039633,
          known_for_department: 'Art',
          name: 'David Delina',
          original_name: 'David Delina',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af37a56c3a3682154002e6f',
          department: 'Art',
          job: 'Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 2039636,
          known_for_department: 'Crew',
          name: 'Venancio Goltiano',
          original_name: 'Venancio Goltiano',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af37ad8c3a3682168002fbf',
          department: 'Crew',
          job: 'Cableman',
        },
        {
          adult: false,
          gender: 0,
          id: 2039637,
          known_for_department: 'Crew',
          name: 'Bobby Buensalida',
          original_name: 'Bobby Buensalida',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af37aefc3a3682168002fdb',
          department: 'Crew',
          job: 'Craft Service',
        },
        {
          adult: false,
          gender: 0,
          id: 2039638,
          known_for_department: 'Crew',
          name: 'David Lowe',
          original_name: 'David Lowe',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af37b11c3a36821570037a2',
          department: 'Crew',
          job: 'Legal Services',
        },
        {
          adult: false,
          gender: 0,
          id: 2039639,
          known_for_department: 'Crew',
          name: 'Frank Fleming',
          original_name: 'Frank Fleming',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af37b25c3a3682159002e43',
          department: 'Crew',
          job: 'Loader',
        },
        {
          adult: false,
          gender: 0,
          id: 2039641,
          known_for_department: 'Crew',
          name: 'Orlando Nui',
          original_name: 'Orlando Nui',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af37c670e0a263964002ab9',
          department: 'Crew',
          job: 'Security',
        },
        {
          adult: false,
          gender: 0,
          id: 2039642,
          known_for_department: 'Crew',
          name: 'Primo Guina',
          original_name: 'Primo Guina',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af37c97c3a3682148003d70',
          department: 'Crew',
          job: 'Transportation Captain',
        },
        {
          adult: false,
          gender: 0,
          id: 2039644,
          known_for_department: 'Lighting',
          name: 'Celebrando Raymundo',
          original_name: 'Celebrando Raymundo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af37d12925141790f002593',
          department: 'Lighting',
          job: 'Best Boy Electric',
        },
        {
          adult: false,
          gender: 0,
          id: 2039648,
          known_for_department: 'Production',
          name: 'Angelica De Leon',
          original_name: 'Angelica De Leon',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af37d8a0e0a26396e002d82',
          department: 'Production',
          job: 'Production Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2039649,
          known_for_department: 'Production',
          name: 'Joe Constantino',
          original_name: 'Joe Constantino',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af37d9dc3a3682160002eb2',
          department: 'Production',
          job: 'Production Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 2039651,
          known_for_department: 'Production',
          name: 'Cenón González',
          original_name: 'Cenón González',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af37dd492514178fd001ccd',
          department: 'Production',
          job: 'Unit Manager',
        },
        {
          adult: false,
          gender: 0,
          id: 2039653,
          known_for_department: 'Sound',
          name: 'Donald Santos',
          original_name: 'Donald Santos',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5af37de80e0a263971002ecf',
          department: 'Sound',
          job: 'Boom Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 2141649,
          known_for_department: 'Crew',
          name: 'Dale A. Dye',
          original_name: 'Dale A. Dye',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf302ae9251410ecfb8552a',
          department: 'Crew',
          job: 'Technical Advisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2327396,
          known_for_department: 'Costume & Make-Up',
          name: 'Jim Elyea',
          original_name: 'Jim Elyea',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf2fef60e0a2670bdcda5a6',
          department: 'Costume & Make-Up',
          job: 'Additional Wardrobe Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2327397,
          known_for_department: 'Costume & Make-Up',
          name: 'Maria Cecina',
          original_name: 'Maria Cecina',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf2ff01c3a3685f111de4c6',
          department: 'Costume & Make-Up',
          job: 'Tailor',
        },
        {
          adult: false,
          gender: 0,
          id: 2327398,
          known_for_department: 'Art',
          name: 'Romulo Bernales',
          original_name: 'Romulo Bernales',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf2ff22c3a368735b23d0c9',
          department: 'Art',
          job: 'Assistant Property Master',
        },
        {
          adult: false,
          gender: 0,
          id: 2327400,
          known_for_department: 'Crew',
          name: 'Rudy Candaza',
          original_name: 'Rudy Candaza',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf2ff449251411cdbbbd7f1',
          department: 'Crew',
          job: 'Special Effects Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2327401,
          known_for_department: 'Crew',
          name: 'Andrew Wilson',
          original_name: 'Andrew Wilson',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf2ffc80e0a2670bdcda720',
          department: 'Crew',
          job: 'Special Effects Technician',
        },
        {
          adult: false,
          gender: 0,
          id: 2327402,
          known_for_department: 'Lighting',
          name: 'Ernesto Enríquez',
          original_name: 'Ernesto Enríquez',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf3003ec3a3685c081de585',
          department: 'Lighting',
          job: 'Assistant Electrician',
        },
        {
          adult: false,
          gender: 0,
          id: 2327403,
          known_for_department: 'Camera',
          name: 'Rufo Ballos Balicas',
          original_name: 'Rufo Ballos Balicas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf3004d9251413921bb77f3',
          department: 'Camera',
          job: 'Best Boy Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2327404,
          known_for_department: 'Camera',
          name: 'Victor Cecogo',
          original_name: 'Victor Cecogo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf3005b9251413921bb780d',
          department: 'Camera',
          job: 'Clapper Loader',
        },
        {
          adult: false,
          gender: 0,
          id: 2327405,
          known_for_department: 'Camera',
          name: 'Rene Balicas',
          original_name: 'Rene Balicas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf300650e0a2670bdcda96d',
          department: 'Camera',
          job: 'Dolly Grip',
        },
        {
          adult: false,
          gender: 0,
          id: 2327406,
          known_for_department: 'Costume & Make-Up',
          name: 'Mike Ambrosio',
          original_name: 'Mike Ambrosio',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf3006fc3a3684bf0220c30',
          department: 'Costume & Make-Up',
          job: 'Wardrobe Assistant',
        },
        {
          adult: false,
          gender: 0,
          id: 2327407,
          known_for_department: 'Costume & Make-Up',
          name: 'Wynn Arenas',
          original_name: 'Wynn Arenas',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf3017e92514138ccbb79d5',
          department: 'Costume & Make-Up',
          job: 'Wardrobe Supervisor',
        },
        {
          adult: false,
          gender: 0,
          id: 2327410,
          known_for_department: 'Sound',
          name: 'Joanne Weiss',
          original_name: 'Joanne Weiss',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf301e50e0a2679d3cdc0c4',
          department: 'Sound',
          job: 'Music Coordinator',
        },
        {
          adult: false,
          gender: 0,
          id: 2327412,
          known_for_department: 'Production',
          name: 'Yvonne Eastmond',
          original_name: 'Yvonne Eastmond',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf3020c0e0a264876cdb667',
          department: 'Production',
          job: 'Assistant Accountant',
        },
        {
          adult: false,
          gender: 0,
          id: 2327413,
          known_for_department: 'Crew',
          name: 'Charlie Rebolledo',
          original_name: 'Charlie Rebolledo',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf302180e0a2679d3cdc130',
          department: 'Crew',
          job: 'Generator Operator',
        },
        {
          adult: false,
          gender: 0,
          id: 2327418,
          known_for_department: 'Production',
          name: 'Pierre David',
          original_name: 'Pierre David',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf3027a9251410ecfb854af',
          department: 'Production',
          job: 'Production Executive',
        },
        {
          adult: false,
          gender: 0,
          id: 2327419,
          known_for_department: 'Production',
          name: 'Anne G. Garcia',
          original_name: 'Anne G. Garcia',
          popularity: 0.6,
          profile_path: null,
          credit_id: '5cf3028f92514138ccbb7c52',
          department: 'Production',
          job: 'Production Secretary',
        },
      ],
    },
    reviews: {
      page: 1,
      results: [
        {
          author: 'tricksy',
          author_details: {
            name: '',
            username: 'tricksy',
            avatar_path: null,
            rating: null,
          },
          content:
            'Platoon is a must see. The film that put Stone on the map, Platoon is considered by Vietnam Vets as the most realistic. But in keeping the maxim of giving credit where credit is due, much of the success of Platoon belongs to military adviser Captain Dale Dye, who has been linked to pretty much every great war movie in the last twenty years. Much accolades to Tom Berenger as well, whose performance as Sgt. Barnes is the tour de force of his career. With a great script, great performances, and awesome cinematography, Platoon is a surefire classic.',
          created_at: '2015-06-10T04:35:54.064Z',
          id: '5577beaac3a3684308000a9c',
          updated_at: '2021-06-23T15:57:35.072Z',
          url: 'https://www.themoviedb.org/review/5577beaac3a3684308000a9c',
        },
      ],
      total_pages: 1,
      total_results: 1,
    },
  },
  {
    adult: false,
    backdrop_path: null,
    belongs_to_collection: null,
    budget: 0,
    genres: [],
    homepage: '',
    id: 677293,
    imdb_id: null,
    original_language: 'vi',
    original_title: 'Chuyện Ở Quê Tôi (Tập 01)',
    overview:
      'Hiệp Mỹ An năm 1981, tại địa phương xảy ra việc sát nhập điền đất vào “tập đoàn” sau đó chia lại cho nông dân canh tác. Miếng đất 4 công nhà ông Tư Thương có ngôi mộ vợ ông cũng bị sát nhập chia lại cho người khác làm lúa. Nhiều lần phản đối không được lắng nghe, Tư Thương và “tập đoàn trưởng” Hai Mạnh xảy đến xô xát. Tư Thương lỡ tay ngộ sát Hai Mạnh… Nỗi oan ức theo ông đằng đẵng 30 năm trời.',
    popularity: 0.6,
    poster_path:
      'https://image.tmdb.org/t/p/w342/4m14aCxLtE7WkpZz1qOYOh09jgf.jpg',
    production_companies: [],
    production_countries: [],
    release_date: '',
    revenue: 0,
    runtime: 0,
    spoken_languages: [],
    status: 'Đã phát hành',
    tagline: '',
    title: 'Chuyện Ở Quê Tôi (Tập 01)',
    video: false,
    vote_average: 0.0,
    vote_count: 0,
    videos: { results: [] },
    credits: { cast: [], crew: [] },
    reviews: { page: 1, results: [], total_pages: 0, total_results: 0 },
  },
];
